// This file is generated by scripts/generate-tool-demo-page-catalog.js.
// Do not edit by hand; update the tool specs and regenerate.

const generatedToolDemoPageDefinitions = [
	{
		"toolType": "dbtSkillsDiaryCard",
		"slug": "dbt-skills-diary-card",
		"title": "DBT Skills Diary Card for Weekly Client Monitoring | Qwoach",
		"metaDescription": "Explore a DBT Skills Diary Card for daily urges, emotions, target behaviors, medication/substance context, skills practice, and therapist review.",
		"h1": "DBT Skills Diary Card",
		"intro": "The DBT Skills Diary Card is a weekly self-monitoring tool for DBT therapists and clients. It helps therapists review daily urges, emotions, target behaviors, medication or substance context, skills practice, and completion patterns before setting session priorities.",
		"demoTitle": "Explore the weekly card",
		"demoPrompt": "Interested in using DBT Skills Diary Card with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0001-f-001-dbt-001-r001-dbt-skills-diary-card.md",
		"specId": "0001-f-001-dbt-001-r001-dbt-skills-diary-card",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Session preparation"
			],
			"topic": [
				"Emotion regulation",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use during comprehensive or skills-informed DBT when weekly behavior, urge, emotion, skill-use, and medication/substance information will support session review."
			},
			{
				"title": "What It Captures",
				"body": "The card captures daily reported ratings, target behavior occurrences, skills practiced, relevant medication/substance context, notes where enabled, and completion status."
			},
			{
				"title": "Longitudinal Review",
				"body": "Completed weeks remain available for comparison over time, with configuration differences visible when targets or context fields change."
			}
		],
		"faqItems": [
			{
				"question": "Does the DBT Skills Diary Card generate session priorities?",
				"answer": "No. It organizes reported diary-card data so the therapist can identify likely priorities or chain-analysis targets."
			},
			{
				"question": "Can clients leave days incomplete?",
				"answer": "Yes. Missing or partial days remain visible instead of forcing fabricated answers."
			},
			{
				"question": "What can I configure?",
				"answer": "You can configure target behaviors, relevant medication/substance fields, and whether optional notes or session-entry ratings are included."
			},
			{
				"question": "Are sample demo responses saved as client data?",
				"answer": "No. Sample entries and fictional review notes are for public exploration only and are not saved as real client data."
			}
		]
	},
	{
		"toolType": "dbtSubstanceUseDiaryCard",
		"slug": "dbt-substance-use-diary-card",
		"title": "NIDA Diary Card for DBT Substance-Use Monitoring | Qwoach",
		"metaDescription": "Explore a NIDA DBT diary-card preset for daily substance-use, medication, risk-behavior, urge, emotion, reinforcement, and skills review.",
		"h1": "NIDA Diary Card",
		"intro": "The NIDA Diary Card is a DBT diary-card preset for therapists working with substance-use, medication or pharmacotherapy adherence, HIV-risk behavior, and related target behaviors. It helps practitioners review day-by-day substance, medication, risk, urge, emotion, reinforcement, and skills-use information in one weekly card.",
		"demoTitle": "Explore the NIDA card",
		"demoPrompt": "Interested in using NIDA Diary Card with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0002-f-001-dbt-001-r002-nida-diary-card.md",
		"specId": "0002-f-001-dbt-001-r002-nida-diary-card",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Session preparation"
			],
			"topic": [
				"Substance use",
				"Medication adherence",
				"Self-harm"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use when DBT targets include substance use, medication or pharmacotherapy adherence, HIV-risk behavior, self-harm, lying, or related risk behavior."
			},
			{
				"title": "Blank Versus None",
				"body": "The card distinguishes unanswered fields from reported zero or none so review does not confuse missing data with no occurrence."
			},
			{
				"title": "History",
				"body": "Prior NIDA cards can be compared where fields are comparable, and field changes are visible in history."
			}
		],
		"faqItems": [
			{
				"question": "Is the NIDA Diary Card a medication manager?",
				"answer": "No. It records medication and pharmacotherapy context for DBT review but does not provide medication guidance."
			},
			{
				"question": "Can the demo include substance-use examples without real client data?",
				"answer": "Yes. The public demo uses fictional, non-identifying entries only."
			},
			{
				"question": "What happens if a client leaves a field blank?",
				"answer": "Blank fields remain visible as missing rather than being treated as zero or none."
			},
			{
				"question": "Does the tool decide risk level or treatment actions?",
				"answer": "No. It organizes diary-card data for practitioner review and does not generate clinical conclusions."
			}
		]
	},
	{
		"toolType": "caresSkillsDiaryCard",
		"slug": "cares-skills-diary-card",
		"title": "CARES Skills Diary Card for Weekly DBT Review | Qwoach",
		"metaDescription": "Explore a CARES Skills Diary Card for weekly DBT monitoring of targets, skills use, homework, goal progress, change belief, and skills focus.",
		"h1": "CARES Skills Diary Card",
		"intro": "The CARES Skills Diary Card is a concise weekly DBT diary-card preset for DBT practitioners and clients. It helps practitioners review target behaviors, urges, emotions, substance or medication context, skills practice, homework follow-through, goal progress, belief in ability to change, and next-week skills focus.",
		"demoTitle": "Explore the CARES card",
		"demoPrompt": "Interested in using CARES Skills Diary Card with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0003-f-001-dbt-001-r003-cares-skills-diary-card.md",
		"specId": "0003-f-001-dbt-001-r003-cares-skills-diary-card",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Skills use",
				"Homework",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use when weekly DBT review should include behavior monitoring, skills practice, homework follow-through, goal movement, confidence in change, and next skills focus."
			},
			{
				"title": "What It Adds",
				"body": "Compared with a general diary-card flow, this preset adds CARES-specific engagement fields for homework, goals, change belief, and skills focus."
			}
		],
		"faqItems": [
			{
				"question": "Is CARES Skills Diary Card a general goal tracker?",
				"answer": "No. It is a DBT weekly diary-card preset with CARES-specific homework, goal, change-belief, and skills-focus fields."
			},
			{
				"question": "Can weeks with no homework be represented?",
				"answer": "Yes. Weeks without homework should be distinguishable from missing homework data."
			},
			{
				"question": "Does the tool score motivation or readiness?",
				"answer": "No. It records belief in ability to change where supported but does not infer motivation or readiness."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and supported setup are saved; fictional weekly entries are not saved as real client records."
			}
		]
	},
	{
		"toolType": "dbtChainAnalysisWorksheet",
		"slug": "dbt-chain-analysis-worksheet",
		"title": "DBT Chain Analysis Worksheet Demo | Qwoach",
		"metaDescription": "Explore a DBT chain analysis worksheet for mapping one problem behavior through prompting event, vulnerabilities, links, consequences, and repair.",
		"h1": "General Worksheet 2: Chain Analysis of Problem Behavior",
		"intro": "General Worksheet 2: Chain Analysis of Problem Behavior is a DBT worksheet for practitioners and clients. It helps them reconstruct one target problem behavior by mapping the prompting event, vulnerability factors, ordered links, consequences, replacement behaviors, prevention plans, and repair actions.",
		"demoTitle": "Build a sample chain",
		"demoPrompt": "Interested in using General Worksheet 2: Chain Analysis of Problem Behavior with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0004-f-001-dbt-002-r001-general-worksheet-2-chain-analysis-of-problem-behavior.md",
		"specId": "0004-f-001-dbt-002-r001-general-worksheet-2-chain-analysis-of-problem-behavior",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Problem behavior",
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One Behavior at a Time",
				"body": "The worksheet is anchored to one concrete target behavior. If multiple behaviors appear in the same incident, the workflow should prompt selection of one behavior first."
			},
			{
				"title": "Partial Chains",
				"body": "Uncertain or missing links can remain unresolved. The result preserves completed sections without forcing unsupported detail."
			},
			{
				"title": "Natural Continuation",
				"body": "A completed chain can lead into solution analysis, replacement behavior planning, prevention, repair, or future diary-card monitoring."
			}
		],
		"faqItems": [
			{
				"question": "Does this worksheet choose DBT skills for the client?",
				"answer": "No. It organizes the chain and attached alternatives, but it does not automatically select skills or make treatment recommendations."
			},
			{
				"question": "Can the chain be incomplete?",
				"answer": "Yes. Partial chains remain visible with unresolved sections for later work."
			},
			{
				"question": "Can links be reordered?",
				"answer": "Yes. The product supports ordered link creation and reordering so the sequence can be clarified during discussion."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The fixed Chain Analysis worksheet tool is saved as-is; sample demo content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "dbtSolutionAnalysis",
		"slug": "dbt-solution-analysis",
		"title": "DBT Solution Analysis for Chain-Linked Planning | Qwoach",
		"metaDescription": "Explore DBT Solution Analysis for linking behavior-chain points to alternatives, prevention steps, environmental changes, practice, and repair actions.",
		"h1": "DBT Solution Analysis",
		"intro": "DBT Solution Analysis is a post-chain intervention-planning tool for DBT practitioners and clients. It helps them connect specific chain points to skillful alternatives, prevention steps, environmental changes, rehearsal or practice commitments, and repair actions.",
		"demoTitle": "Map sample solutions",
		"demoPrompt": "Interested in using DBT Solution Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0005-f-001-dbt-003-r001-dbt-solution-analysis.md",
		"specId": "0005-f-001-dbt-003-r001-dbt-solution-analysis",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Problem behavior",
				"Behavior change",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Depends on Chain Context",
				"body": "The tool is designed to follow or accompany chain analysis. If no completed chain exists, chain elements may be entered manually and marked as unresolved source context."
			},
			{
				"title": "Specificity",
				"body": "A solution entry must connect to a chain point, consequence, or harm area so the plan remains tied to the behavior pathway."
			},
			{
				"title": "Partial Plans",
				"body": "Unresolved intervention points can remain open for later work instead of forcing premature agreement."
			}
		],
		"faqItems": [
			{
				"question": "Does DBT Solution Analysis generate DBT skills?",
				"answer": "No. It records practitioner-client agreed solutions and does not generate skills or prescribe actions."
			},
			{
				"question": "Can it be used without a completed chain analysis?",
				"answer": "Yes, chain elements may be entered manually, but the source chain should be marked unresolved."
			},
			{
				"question": "What counts as a solution entry?",
				"answer": "A solution entry can be a prevention step, skillful alternative, environmental or contingency change, rehearsal/practice commitment, or repair action tied to a chain point."
			},
			{
				"question": "Is sample planning content saved?",
				"answer": "No. The fixed tool is saved, while fictional chain and solution entries are discarded."
			}
		]
	},
	{
		"toolType": "missingLinksAnalysis",
		"slug": "missing-links-analysis",
		"title": "DBT Missing-Links Analysis Worksheet Demo | Qwoach",
		"metaDescription": "Explore Missing-Links Analysis, a DBT worksheet for finding what blocked an expected effective behavior and planning a fitting correction.",
		"h1": "Missing-Links Analysis",
		"intro": "Missing-Links Analysis is a DBT behavior analysis worksheet for practitioners and clients. It helps identify why an expected, agreed, hoped-for, or needed effective behavior did not occur and connects the identified barrier to a future problem-solving plan.",
		"demoTitle": "Try the branch path",
		"demoPrompt": "Interested in using Missing-Links Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0006-f-001-dbt-004-r001-missing-links-analysis.md",
		"specId": "0006-f-001-dbt-004-r001-missing-links-analysis",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Problem solving"
			],
			"topic": [
				"Behavior analysis",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use when the target is an expected effective behavior that did not happen, not an ineffective behavior that occurred."
			},
			{
				"title": "Unknown Answers",
				"body": "If the client cannot answer a branch question, the analysis can pause without fabricating a barrier."
			},
			{
				"title": "Other Obstacles",
				"body": "When a barrier does not fit listed categories, the result should preserve the reported obstacle as other problem-solving rather than forcing a category."
			}
		],
		"faqItems": [
			{
				"question": "Is Missing-Links Analysis the same as Chain Analysis?",
				"answer": "No. Missing-Links Analysis is for an expected effective behavior that did not occur; chain analysis is for a problem behavior that occurred."
			},
			{
				"question": "Does the tool decide the corrective step?",
				"answer": "No. It organizes the branch path and barrier area, while the practitioner and client record the corrective plan."
			},
			{
				"question": "Can the analysis stay partial?",
				"answer": "Yes. Partial work preserves the branch path and unresolved question."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The fixed tool is saved as-is; fictional branch answers and sample plans are not saved as client data."
			}
		]
	},
	{
		"toolType": "linehanRiskAssessmentAndManagementProtocolLramp",
		"slug": "linehan-risk-assessment-and-management-protocol-lramp",
		"title": "LRAMP Suicide and Self-Injury Risk Protocol Demo | Qwoach",
		"metaDescription": "Explore LRAMP, a practitioner-only DBT protocol for documenting suicide/self-injury risk factors, protective factors, actions, disposition, and reevaluation.",
		"h1": "Linehan Risk Assessment and Management Protocol (LRAMP)",
		"intro": "The Linehan Risk Assessment and Management Protocol (LRAMP) is a practitioner-only DBT protocol for clinicians. It helps document suicide and self-injury risk formulation, acute risk factors, protective factors, management actions, disposition, clinical rationale, and reevaluation timing.",
		"demoTitle": "Review a sample protocol",
		"demoPrompt": "Interested in using Linehan Risk Assessment and Management Protocol (LRAMP) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0007-f-001-dbt-005-r001-linehan-risk-assessment-and-management-protocol-lramp.md",
		"specId": "0007-f-001-dbt-005-r001-linehan-risk-assessment-and-management-protocol-lramp",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Risk review",
				"Clinical documentation"
			],
			"topic": [
				"Suicide risk",
				"Self-harm"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "LRAMP has no separate client-facing product experience. Client information may be elicited during care, but the tool surface is clinician documentation."
			},
			{
				"title": "Completeness Without Automation",
				"body": "The system can show incomplete sections and unresolved reevaluation timing, but practitioner judgment controls formulation, actions, disposition, and timing."
			},
			{
				"title": "Follow-Up Clarity",
				"body": "Completed records remain available for reassessment. Later updates should preserve the prior documented state as follow-up or reevaluation entries."
			}
		],
		"faqItems": [
			{
				"question": "Does LRAMP assign suicide risk level automatically?",
				"answer": "No. LRAMP supports practitioner documentation and does not compute or assign risk levels unless entered by the clinician using supported fields."
			},
			{
				"question": "Is there a client-facing version of this tool?",
				"answer": "No. LRAMP is practitioner-only; the client may provide information during assessment, but the product workflow is clinician-completed."
			},
			{
				"question": "Can incomplete information be recorded?",
				"answer": "Yes. Unknown or not assessed information should be documented as such rather than inferred."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed LRAMP tool is saved as-is; fictional risk details and sample documentation are not saved as real client data."
			}
		]
	},
	{
		"toolType": "imminentRiskAndActionPlanBrtcImminentSuicideRiskAndTreatmentActionsNote",
		"slug": "imminent-risk-and-action-plan-brtc-imminent-suicide-risk-and-treatment-actions-note",
		"title": "Imminent Suicide Risk and Treatment Actions Note Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only imminent-risk action note for documenting suicide/self-injury risk concerns, actions, emergency decisions, and reevaluation timing.",
		"h1": "Imminent Risk and Action Plan / BRTC Imminent Suicide Risk and Treatment Actions Note",
		"intro": "The Imminent Risk and Action Plan is a practitioner-only DBT treatment-actions note for clinicians. It helps document current or increased suicide/self-injury risk concern, risk and protective factors, treatment actions, emergency interventions considered or taken, consultation, follow-up responsibility, and reevaluation timing.",
		"demoTitle": "Review a sample action note",
		"demoPrompt": "Interested in using Imminent Risk and Action Plan / BRTC Imminent Suicide Risk and Treatment Actions Note with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0008-f-001-dbt-006-r001-imminent-risk-and-action-plan-brtc-imminent-suicide-risk-and-treatment-actions-note.md",
		"specId": "0008-f-001-dbt-006-r001-imminent-risk-and-action-plan-brtc-imminent-suicide-risk-and-treatment-actions-note",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Risk review",
				"Clinical documentation"
			],
			"topic": [
				"Suicide risk",
				"Self-harm",
				"Crisis response"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Rapid Partial Completion",
				"body": "The note should allow rapid capture when time-sensitive action occurs before full documentation, while keeping unresolved sections visible."
			},
			{
				"title": "Reevaluation Visibility",
				"body": "Follow-up responsibility and reevaluation timing are central completion elements and should remain prominent until entered."
			},
			{
				"title": "Historical Clarity",
				"body": "Later information should be handled as follow-up or reevaluation documentation so the original note state remains clear."
			}
		],
		"faqItems": [
			{
				"question": "Does this note determine imminent suicide risk?",
				"answer": "No. It documents practitioner-entered concern, actions, decisions, and reevaluation timing; it does not automate risk determination."
			},
			{
				"question": "Is this the same as LRAMP?",
				"answer": "No. This is a practitioner-only imminent-risk treatment-actions note; LRAMP is a broader risk assessment and management protocol."
			},
			{
				"question": "Can emergency action be documented before every section is complete?",
				"answer": "Yes. The workflow should support rapid partial completion while showing unresolved sections."
			},
			{
				"question": "What is saved after demo exploration?",
				"answer": "The fixed tool is saved as-is; fictional risk concerns and sample note data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "lifetimeSuicideAttemptSelfInjuryCountLSasi",
		"slug": "lifetime-suicide-attempt-self-injury-count-l-sasi",
		"title": "L-SASI Lifetime Suicide and Self-Injury Count Demo | Qwoach",
		"metaDescription": "Explore L-SASI, a practitioner-administered interview for lifetime self-injury and suicide-attempt counts, methods, dates, treatment, and lethality.",
		"h1": "Lifetime - Suicide Attempt Self-Injury Count (L-SASI)",
		"intro": "The Lifetime - Suicide Attempt Self-Injury Count (L-SASI) is a practitioner-administered assessment interview and scoring tool. It helps practitioners document lifetime nonsuicidal self-injury, suicide attempts, ambivalent attempts, methods, dates, medical treatment levels, and lethality information for assessment, formulation, treatment planning, or research measurement.",
		"demoTitle": "Explore the interview workflow",
		"demoPrompt": "Interested in using Lifetime - Suicide Attempt Self-Injury Count (L-SASI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0009-f-001-dbt-007-r001-lifetime-suicide-attempt-self-injury-count-l-sasi.md",
		"specId": "0009-f-001-dbt-007-r001-lifetime-suicide-attempt-self-injury-count-l-sasi",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Suicide risk",
				"Self-harm",
				"Clinical history"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Led Administration",
				"body": "L-SASI is administered by the practitioner, who records and codes client-reported lifetime history."
			},
			{
				"title": "Scoring Status",
				"body": "Scores should show when totals are unavailable or provisional because required data is missing or unknown."
			},
			{
				"title": "Not a Current-Risk Protocol",
				"body": "L-SASI documents lifetime history and scoring outputs; it does not generate current safety disposition."
			}
		],
		"faqItems": [
			{
				"question": "Is L-SASI completed by the client alone?",
				"answer": "No. L-SASI is practitioner-administered; the client supplies interview responses while the practitioner records and codes them."
			},
			{
				"question": "Does L-SASI produce current suicide-risk decisions?",
				"answer": "No. It produces lifetime history counts and related scoring outputs, not current-risk disposition or treatment recommendations."
			},
			{
				"question": "Can approximate dates be represented?",
				"answer": "Yes. The UX should support date-accuracy coding and avoid forcing unsupported precision where the instrument allows it."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed L-SASI tool is saved as-is; fictional history, sample coding, and demo scores are not saved as real client data."
			}
		]
	},
	{
		"toolType": "dbtWaysOfCopingChecklistDbtWccl",
		"slug": "dbt-ways-of-coping-checklist-dbt-wccl",
		"title": "DBT-WCCL Coping Checklist Demo | Qwoach",
		"metaDescription": "Explore DBT-WCCL, a 59-item self-report checklist scored for DBT skills use and dysfunctional coping across a recent time period.",
		"h1": "DBT-Ways of Coping Checklist (DBT-WCCL)",
		"intro": "The DBT-Ways of Coping Checklist (DBT-WCCL) is a client self-report DBT coping assessment with practitioner scoring. It helps DBT practitioners or researchers assess recent DBT skills use and dysfunctional coping patterns using a fixed 59-item checklist with 0-3 frequency ratings.",
		"demoTitle": "Try sample ratings",
		"demoPrompt": "Interested in using DBT-Ways of Coping Checklist (DBT-WCCL) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0010-f-001-dbt-008-r001-dbt-ways-of-coping-checklist-dbt-wccl.md",
		"specId": "0010-f-001-dbt-008-r001-dbt-ways-of-coping-checklist-dbt-wccl",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Coping",
				"Skills use",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Assessment",
				"body": "DBT-WCCL uses a fixed 59-item checklist, 0-3 ratings, and defined scoring. It is not a questionnaire builder."
			},
			{
				"title": "Repeated Monitoring",
				"body": "When administered repeatedly, results can show comparable score trajectories with administration date and time period visible."
			},
			{
				"title": "Missing Data",
				"body": "Missing item responses remain visible and should be handled according to scoring rules rather than imputed without support."
			}
		],
		"faqItems": [
			{
				"question": "Can I customize DBT-WCCL items?",
				"answer": "No. The item set, response scale, and scoring structure are fixed for this assessment."
			},
			{
				"question": "Does DBT-WCCL diagnose a client?",
				"answer": "No. It scores reported coping patterns and does not generate diagnosis or treatment conclusions."
			},
			{
				"question": "Can scores be compared over time?",
				"answer": "Yes. Repeated administrations can show comparable score trajectories when the administration context supports comparison."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The fixed DBT-WCCL tool is saved as-is; fictional responses, scores, and demo history are not saved as real client data."
			}
		]
	},
	{
		"toolType": "demographicDataScaleDds",
		"slug": "demographic-data-scale-dds",
		"title": "Demographic Data Scale (DDS) Demo for DBT Intake | Qwoach",
		"metaDescription": "Preview the DDS, a DBT intake questionnaire for structured demographic, family, socioeconomic, education, occupation, and background context.",
		"h1": "Demographic Data Scale (DDS)",
		"intro": "The Demographic Data Scale (DDS) is a DBT assessment and intake self-report questionnaire for clinicians, assessors, and DBT programs. It helps practitioners collect standardized demographic, family, socioeconomic, educational, occupational, religious, birthplace, caregiver, child, and family-location context from a client.",
		"demoTitle": "Preview the DDS as a practitioner, try a sample client completion, then review the structured result.",
		"demoPrompt": "Interested in using Demographic Data Scale (DDS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0011-f-001-dbt-009-r001-demographic-data-scale-dds.md",
		"specId": "0011-f-001-dbt-009-r001-demographic-data-scale-dds",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Demographics"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the DDS when broad demographic and background context is needed during DBT intake, assessment, or research characterization."
			},
			{
				"title": "What It Captures",
				"body": "The questionnaire captures client-reported demographic, family, socioeconomic, educational, occupational, religious, birthplace, caregiver, child, and family-location information through coded and narrative fields."
			},
			{
				"title": "Limits",
				"body": "The DDS does not score responses, interpret demographics, produce clinical conclusions, or recommend treatment."
			}
		],
		"faqItems": [
			{
				"question": "Is the DDS scored?",
				"answer": "No. The DDS produces a completed structured demographic/context questionnaire, not a score or clinical interpretation."
			},
			{
				"question": "Can I change the DDS fields in the demo?",
				"answer": "No. The DDS is presented as a fixed full questionnaire configuration, not a generic form builder."
			},
			{
				"question": "Does sample demo data become client data after saving?",
				"answer": "No. Saving preserves the tool and practitioner setup, but fictional sample responses do not carry over as real client records."
			},
			{
				"question": "What does the practitioner review after completion?",
				"answer": "The practitioner reviews grouped DDS responses, coded and free-text content, completion status, and missing fields."
			}
		]
	},
	{
		"toolType": "demographicDataScheduleShortVersionDds",
		"slug": "demographic-data-schedule-short-version-dds",
		"title": "Short DDS Demo for Brief DBT Demographic Assessment | Qwoach",
		"metaDescription": "Preview the Short DDS, a brief demographic schedule for DBT screening, intake, baseline description, and research sample characterization.",
		"h1": "Demographic Data Schedule - Short Version (DDS)",
		"intro": "The Demographic Data Schedule - Short Version (DDS) is a brief DBT-related demographic self-report schedule for practitioners and research assessors. It helps collect essential client or participant variables for screening, intake, baseline description, or sample characterization without administering the full DDS.",
		"demoTitle": "Preview the short assignment, complete sample fields, and review the compact profile.",
		"demoPrompt": "Interested in using Demographic Data Schedule - Short Version (DDS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0012-f-001-dbt-009-r002-demographic-data-schedule-short-version-dds.md",
		"specId": "0012-f-001-dbt-009-r002-demographic-data-schedule-short-version-dds",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Demographics"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Short Version Boundary",
				"body": "The Short DDS is for concise demographic characterization. It should not be presented as covering the full DDS background domains."
			},
			{
				"title": "Useful Review State",
				"body": "The review emphasizes whether essential variables are complete enough for the brief workflow and shows missing or unknown responses clearly."
			},
			{
				"title": "Limits",
				"body": "The tool does not infer demographic meaning, score responses, or add unsupported fields."
			}
		],
		"faqItems": [
			{
				"question": "Is the Short DDS the same as the full DDS?",
				"answer": "No. The Short DDS is a reduced demographic schedule and should not be treated as complete full-DDS data."
			},
			{
				"question": "What variables are shown in the demo?",
				"answer": "The demo shows essential variables supported by the specification, including age, sex, ethnicity/race, marital status, income, education, and occupation."
			},
			{
				"question": "Can I switch from the Short DDS to the full DDS after saving?",
				"answer": "Switching to the full DDS should create a new assignment or extension; the short form should not be silently treated as a full DDS completion."
			},
			{
				"question": "Does saving preserve sample responses?",
				"answer": "No. Saving preserves the tool and practitioner setup, not fictional sample responses."
			}
		]
	},
	{
		"toolType": "wiseMind",
		"slug": "wise-mind",
		"title": "Wise Mind DBT Worksheet Demo | Qwoach",
		"metaDescription": "Preview Wise Mind, a DBT mindfulness practice record for emotion mind, reasonable mind, Wise Mind response, effectiveness, and review.",
		"h1": "Wise Mind",
		"intro": "Wise Mind is a DBT mindfulness practice/reflection tool for DBT practitioners and clients. It helps a client identify emotional input, factual reasoning, Wise Mind practice, perceived effectiveness, and a wise action or response for a specific situation.",
		"demoTitle": "Try the worksheet with a fictional situation, then review the completed Wise Mind record.",
		"demoPrompt": "Interested in using Wise Mind with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0013-f-001-dbt-010-r001-wise-mind.md",
		"specId": "0013-f-001-dbt-010-r001-wise-mind",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Skills use",
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use Wise Mind for decisions, urges, conflicts, coping situations, communication, or relationship moments where emotion-only or reason-only responding feels insufficient."
			},
			{
				"title": "Result Boundary",
				"body": "The result is a reported practice record. The system does not decide whether the response is correct, wise, or clinically indicated."
			},
			{
				"title": "Repeat Use",
				"body": "Dated Wise Mind records can support review of repeated practice by situation and rating, without turning the rating into a score or outcome interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does Wise Mind generate the client's wise action?",
				"answer": "No. The client records the Wise Mind response or action; the system organizes it for review."
			},
			{
				"question": "Can Wise Mind be completed during session?",
				"answer": "Yes. The tool supports assigned completion or completion together in session."
			},
			{
				"question": "Is the effectiveness rating interpreted by the system?",
				"answer": "No. The rating is self-reported and displayed for practitioner review without automated clinical meaning."
			},
			{
				"question": "What saves after the demo?",
				"answer": "The Wise Mind tool and practitioner setup save; fictional sample reflections and situations do not become client records."
			}
		]
	},
	{
		"toolType": "observe",
		"slug": "observe",
		"title": "Observe DBT Mindfulness Practice Demo | Qwoach",
		"metaDescription": "Preview Observe, a DBT mindfulness practice record for noticing present-moment sensations, thoughts, emotions, urges, and events before reacting.",
		"h1": "Observe",
		"intro": "Observe is a DBT mindfulness practice tool for DBT practitioners and clients. It helps a client notice sensations, thoughts, emotions, urges, and external events as present-moment experience before reacting automatically.",
		"demoTitle": "Try a short Observe practice record and review what the practitioner sees.",
		"demoPrompt": "Interested in using Observe with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0014-f-001-dbt-011-r001-observe.md",
		"specId": "0014-f-001-dbt-011-r001-observe",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Lightweight Practice",
				"body": "Observe records should stay brief because the skill is noticing, not lengthy analysis."
			},
			{
				"title": "Practitioner Role",
				"body": "The practitioner reviews reported noticing, attention drift, and reaction patterns and may add separate coaching notes."
			},
			{
				"title": "Limits",
				"body": "Observe does not label, judge, interpret, or score the client's experience."
			}
		],
		"faqItems": [
			{
				"question": "Is Observe the same as Describe?",
				"answer": "No. Observe focuses on noticing experience before reacting; Describe focuses on putting factual words on observed experience."
			},
			{
				"question": "Does the tool score mindfulness?",
				"answer": "No. It shows completion and organized reported observations only."
			},
			{
				"question": "Can Observe be used in session?",
				"answer": "Yes. It supports completion together in session or assignment between sessions."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The Observe tool and reusable setup are saved; fictional sample practice entries are not saved as client data."
			}
		]
	},
	{
		"toolType": "describe",
		"slug": "describe",
		"title": "Describe DBT Mindfulness Practice Demo | Qwoach",
		"metaDescription": "Preview Describe, a DBT mindfulness practice for factual labeling of observed experience without judgments, assumptions, or conclusions.",
		"h1": "Describe",
		"intro": "Describe is a DBT mindfulness practice tool for DBT practitioners and clients. It helps a client put factual words to observed internal or external experience without adding judgments, assumptions, motives, or conclusions.",
		"demoTitle": "Try a sample Describe entry and review how the wording appears to the practitioner.",
		"demoPrompt": "Interested in using Describe with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0015-f-001-dbt-012-r001-describe.md",
		"specId": "0015-f-001-dbt-012-r001-describe",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Helps",
				"body": "Describe is useful when a client blends facts with judgments, motives, assumptions, or conclusions and needs practice stating what was directly observed."
			},
			{
				"title": "Review Focus",
				"body": "The practitioner reviews the client's wording and coaches factual labeling while keeping practitioner interpretation separate."
			},
			{
				"title": "Limits",
				"body": "The tool does not determine whether a statement is true, diagnose patterns, or provide cognitive restructuring content."
			}
		],
		"faqItems": [
			{
				"question": "Does Describe automatically correct the client's wording?",
				"answer": "No. The tool preserves attempts and revisions for practitioner review rather than auto-correcting meaning."
			},
			{
				"question": "Can the client revise a description?",
				"answer": "Yes. The product can show original wording and revised factual wording when revision is used."
			},
			{
				"question": "Is this a thought record?",
				"answer": "No. Describe is a DBT mindfulness skill for factual labeling of observed experience, not cognitive restructuring."
			},
			{
				"question": "Does saving include demo examples?",
				"answer": "No. Saving includes the tool and setup, not fictional sample wording or demo situations."
			}
		]
	},
	{
		"toolType": "ideasForPracticingDescribing",
		"slug": "ideas-for-practicing-describing",
		"title": "Ideas for Practicing Describing DBT Demo | Qwoach",
		"metaDescription": "Preview a DBT Describe practice preset with selectable exercises, checklist completion, factual descriptions, and practitioner review.",
		"h1": "Ideas for Practicing Describing",
		"intro": "Ideas for Practicing Describing is a DBT mindfulness Describe practice preset for DBT practitioners and clients. It helps practitioners assign fixed Describe exercises and helps clients record attempted items and brief factual descriptions across multiple types of observed experience.",
		"demoTitle": "Choose sample exercises, complete the checklist as a client, and review the submitted practice record.",
		"demoPrompt": "Interested in using Ideas for Practicing Describing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0016-f-001-dbt-012-r002-ideas-for-practicing-describing.md",
		"specId": "0016-f-001-dbt-012-r002-ideas-for-practicing-describing",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Skills use",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Exercise Preset Boundary",
				"body": "The practice menu is fixed to supported Describe exercises and categories. The tool does not invent new exercises."
			},
			{
				"title": "Repeat Use",
				"body": "Dated assignments can show which categories have been practiced over time without producing a mastery score."
			},
			{
				"title": "Practitioner Review",
				"body": "Review focuses on attempted items, client wording, skipped items, and where further Describe practice may be useful."
			}
		],
		"faqItems": [
			{
				"question": "Can I create my own exercise categories in this tool?",
				"answer": "No. The tool uses a fixed Describe-specific preset once source wording and categories are validated."
			},
			{
				"question": "Does the result score the client's Describe skill?",
				"answer": "No. It shows completion, category coverage, and client descriptions for practitioner review."
			},
			{
				"question": "Can clients mark an assigned item as not attempted?",
				"answer": "Yes. Unattempted or skipped items remain visible in review instead of being coerced into completion."
			},
			{
				"question": "What saves from the demo?",
				"answer": "The practice preset, selected exercises, assignment mode, and setup save; fictional checklist responses do not."
			}
		]
	},
	{
		"toolType": "nonjudgmentally",
		"slug": "nonjudgmentally",
		"title": "Nonjudgmentally DBT Practice Demo | Qwoach",
		"metaDescription": "Preview Nonjudgmentally, a DBT mindfulness practice for identifying judgments, writing factual replacements, and reviewing counts or entries.",
		"h1": "Nonjudgmentally",
		"intro": "Nonjudgmentally is a DBT mindfulness practice tool for DBT practitioners and clients. It helps clients identify judgmental thoughts or statements, write factual nonjudgmental replacements, record counts or repeated practice entries, and notice changes after practice.",
		"demoTitle": "Choose a practice format, enter a fictional judgment and replacement, and review the practitioner result.",
		"demoPrompt": "Interested in using Nonjudgmentally with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0017-f-001-dbt-014-r001-nonjudgmentally.md",
		"specId": "0017-f-001-dbt-014-r001-nonjudgmentally",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Between-session monitoring"
			],
			"topic": [
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practice Formats",
				"body": "The tool can be set up as a single example, checklist, or calendar-style repeated practice record when those formats fit the assignment."
			},
			{
				"title": "Review Focus",
				"body": "Review highlights judgments, replacement factual descriptions, counts or frequency, and reported changes so the practitioner can coach more accurate awareness."
			},
			{
				"title": "Limits",
				"body": "The tool does not morally evaluate judgments, score skill use, or provide automated clinical interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does Nonjudgmentally write the replacement statement for the client?",
				"answer": "No. The client writes replacement factual descriptions; the practitioner may coach separately."
			},
			{
				"question": "Can the tool track repeated practice?",
				"answer": "Yes. It can support checklist or calendar-style repeated entries with counts or frequency when that practice format is selected."
			},
			{
				"question": "Are counts treated as scores?",
				"answer": "No. Counts are descriptive reported data and do not produce a mastery score or clinical interpretation."
			},
			{
				"question": "What does saving preserve?",
				"answer": "Saving preserves the tool, selected practice format, completion mode, and setup, but not fictional demo entries."
			}
		]
	},
	{
		"toolType": "oneMindfully",
		"slug": "one-mindfully",
		"title": "One-Mindfully DBT Practice Demo | Qwoach",
		"metaDescription": "Preview One-Mindfully, a DBT mindfulness practice for one present-moment focus, distraction, return to attention, and perceived effect.",
		"h1": "One-Mindfully",
		"intro": "One-Mindfully is a DBT mindfulness practice tool for DBT practitioners and clients. It helps clients focus on one present-moment activity or experience, notice distraction, return attention, and record the perceived effect of practice.",
		"demoTitle": "Try a sample single-focus practice entry and review the practitioner view.",
		"demoPrompt": "Interested in using One-Mindfully with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0018-f-001-dbt-015-r001-one-mindfully.md",
		"specId": "0018-f-001-dbt-015-r001-one-mindfully",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Designed To Stay Lightweight",
				"body": "Entries remain concise because the practice is attentional, not narrative-heavy."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated dated entries can support coaching about contexts where single-task attention is easier or harder, without creating a mastery score."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide productivity analytics, objective attention measurement, or clinical inference."
			}
		],
		"faqItems": [
			{
				"question": "Is One-Mindfully a focus timer?",
				"answer": "No. One-Mindfully is a DBT mindfulness practice record, not a productivity timer."
			},
			{
				"question": "Can clients record repeated practice?",
				"answer": "Yes. Optional repeated-practice mode can capture multiple dated entries."
			},
			{
				"question": "Does the tool measure attention?",
				"answer": "No. It records the client's reported focus, distraction, return, and perceived effect."
			},
			{
				"question": "What saves after the demo?",
				"answer": "The tool and selected setup save; fictional practice entries do not become real client data."
			}
		]
	},
	{
		"toolType": "effectively",
		"slug": "effectively",
		"title": "Effectively DBT Skill Worksheet Demo | Qwoach",
		"metaDescription": "Preview Effectively, a DBT mindfulness practice for clarifying goals, facts, actions, and barriers in charged or judgment-heavy situations.",
		"h1": "Effectively",
		"intro": "Effectively is a DBT mindfulness practice tool for DBT practitioners and clients. It helps clients clarify the goal, appraise the facts, notice judgments, emotions, or urges that may interfere, select the action most likely to work, and identify barriers.",
		"demoTitle": "Try a fictional situation and review the completed Effectively action plan.",
		"demoPrompt": "Interested in using Effectively with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0019-f-001-dbt-016-r001-effectively.md",
		"specId": "0019-f-001-dbt-016-r001-effectively",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Skills use",
				"Goals",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use Effectively when judgments, fairness arguments, emotions, or urges may pull the client away from the goal in the actual situation."
			},
			{
				"title": "What It Produces",
				"body": "The useful state is a goal-linked action plan with facts and barriers visible for coaching."
			},
			{
				"title": "Limits",
				"body": "The tool does not recommend, rank, or validate actions as clinically correct. Practitioner review remains separate."
			}
		],
		"faqItems": [
			{
				"question": "Does Effectively tell the client what to do?",
				"answer": "No. The client selects the action; the system structures the reflection for practitioner review."
			},
			{
				"question": "Can candidate actions be included?",
				"answer": "Yes. Candidate actions can be included as an optional field before selected action."
			},
			{
				"question": "Is Effectively a DEAR MAN script?",
				"answer": "No. Effectively is a goal/facts/what-works reflection and does not generate interpersonal scripts."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The Effectively tool and selected setup save; fictional sample action plans do not become client records."
			}
		]
	},
	{
		"toolType": "clarifyingPrioritiesInInterpersonalSituations",
		"slug": "clarifying-priorities-in-interpersonal-situations",
		"title": "DBT Interpersonal Priorities Worksheet Demo | Qwoach",
		"metaDescription": "Preview a DBT interpersonal worksheet for ranking objective, relationship, and self-respect priorities for one target situation.",
		"h1": "Clarifying Priorities in Interpersonal Situations",
		"intro": "Clarifying Priorities in Interpersonal Situations is a DBT interpersonal effectiveness worksheet for DBT practitioners and clients. It helps a client define one interpersonal situation, state objective, relationship, and self-respect outcomes, and rank which priority should lead.",
		"demoTitle": "Try a fictional interpersonal scenario, rank the three priorities, and review the ordered formulation.",
		"demoPrompt": "Interested in using Clarifying Priorities in Interpersonal Situations with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0020-f-001-dbt-017-r001-clarifying-priorities-in-interpersonal-situations.md",
		"specId": "0020-f-001-dbt-017-r001-clarifying-priorities-in-interpersonal-situations",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Session preparation",
				"Intervention planning"
			],
			"topic": [
				"Skills use",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Three Priority Domains",
				"body": "The worksheet keeps objective effectiveness, relationship effectiveness, and self-respect effectiveness distinct and requires a unique ranking."
			},
			{
				"title": "Preparation For Later Skills",
				"body": "The result can guide later practitioner-led interpersonal strategy or scripting, but the worksheet itself does not create DEAR MAN, GIVE, or FAST content."
			},
			{
				"title": "History Value",
				"body": "Dated records are useful because priorities can differ across situations or relationships."
			}
		],
		"faqItems": [
			{
				"question": "Can two priorities tie for first?",
				"answer": "No. The worksheet requires a unique 1/2/3 ranking so the leading priority is clear."
			},
			{
				"question": "Does the tool generate DEAR MAN, GIVE, or FAST scripts?",
				"answer": "No. It prepares for later strategy selection or scripting but does not generate scripts."
			},
			{
				"question": "Can one worksheet cover multiple situations?",
				"answer": "No. The product should require one target interpersonal situation per worksheet record."
			},
			{
				"question": "What saves after account creation?",
				"answer": "The worksheet tool and practitioner setup save; fictional demo situations and rankings do not become real client data."
			}
		]
	},
	{
		"toolType": "dearMan",
		"slug": "dear-man",
		"title": "DEAR MAN DBT Script Planning Tool | Qwoach",
		"metaDescription": "Explore a DEAR MAN planning tool for DBT practitioners helping clients prepare requests, refusals, or boundary conversations.",
		"h1": "DEAR MAN Script Planning Tool",
		"intro": "DEAR MAN is a DBT interpersonal effectiveness planning tool for practitioners helping clients prepare a concrete request, refusal, or boundary-setting conversation. It helps organize the client's own situation into facts, feelings, ask or limit, reinforcement, focus, confidence, and negotiation points.",
		"demoTitle": "Explore a sample DEAR MAN plan",
		"demoPrompt": "Interested in using DEAR MAN with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0021-f-001-dbt-018-r001-dear-man.md",
		"specId": "0021-f-001-dbt-018-r001-dear-man",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use this when the main task is objective effectiveness: asking for something, saying no, or setting a boundary in a specific conversation."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not score relationship quality, diagnose the interaction, judge who is right, or predict whether the conversation will succeed."
			}
		],
		"faqItems": [
			{
				"question": "Can the practitioner change the DEAR MAN sequence?",
				"answer": "No. The DEAR MAN sequence is fixed; changing it would change the product."
			},
			{
				"question": "Can this be used for a refusal as well as a request?",
				"answer": "Yes. The plan supports a request, refusal, or boundary-setting conversation when the client has a clear objective."
			},
			{
				"question": "What happens if the client does not know their objective?",
				"answer": "The plan stays in preparation state and shows the objective as a coaching need."
			},
			{
				"question": "Does the demo require real client information?",
				"answer": "No. The public demo uses fictional, non-identifying sample content and does not require sensitive client details."
			}
		]
	},
	{
		"toolType": "giveGuidelinesForRelationshipEffectivenessKeepingTheRelationship",
		"slug": "give-guidelines-for-relationship-effectiveness-keeping-the-relationship",
		"title": "GIVE DBT Relationship Effectiveness Tool | Qwoach",
		"metaDescription": "Explore a GIVE planning checklist for DBT practitioners helping clients prepare respectful, validating interpersonal behavior.",
		"h1": "GIVE Relationship Effectiveness Planning Tool",
		"intro": "GIVE is a DBT interpersonal effectiveness tool for practitioners helping clients prepare behavior and wording that protects or improves a relationship during an interaction. It helps organize planned Gentle, Interested, Validating, and Easy-manner responses for review and rehearsal.",
		"demoTitle": "Explore a sample GIVE plan",
		"demoPrompt": "Interested in using GIVE with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0022-f-001-dbt-019-r001-give-guidelines-for-relationship-effectiveness-keeping-the-relationship.md",
		"specId": "0022-f-001-dbt-019-r001-give-guidelines-for-relationship-effectiveness-keeping-the-relationship",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use GIVE when preserving or improving the relationship is a priority in the interaction."
			},
			{
				"title": "Relevant Limitation",
				"body": "If the client's main need is objective effectiveness rather than relationship preservation, a sibling interpersonal effectiveness tool may fit better."
			}
		],
		"faqItems": [
			{
				"question": "Is GIVE a relationship assessment?",
				"answer": "No. GIVE is a relationship-effectiveness planning checklist, not a relationship diagnosis or score."
			},
			{
				"question": "Can the client leave some GIVE sections blank?",
				"answer": "Yes. Unused sections can remain blank, but the review shows them as incomplete."
			},
			{
				"question": "Does validation mean agreement in this tool?",
				"answer": "No. The tool supports naming what can be validated without requiring the client to give up their own position."
			}
		]
	},
	{
		"toolType": "guidelinesForSelfRespectEffectivenessKeepingRespectForYourselfFast",
		"slug": "guidelines-for-self-respect-effectiveness-keeping-respect-for-yourself-fast",
		"title": "FAST DBT Self-Respect Planning Tool | Qwoach",
		"metaDescription": "Explore a FAST planning checklist for DBT practitioners helping clients prepare fair, values-consistent, truthful responses.",
		"h1": "FAST Self-Respect Effectiveness Planning Tool",
		"intro": "FAST is a DBT interpersonal effectiveness tool for practitioners helping clients prepare for situations where values, fairness, apology boundaries, and truthfulness matter. It helps organize a self-respecting stance using Fair, no Apologies, Stick to values, and Truthful sections.",
		"demoTitle": "Explore a sample FAST plan",
		"demoPrompt": "Interested in using Guidelines for Self-Respect Effectiveness: Keeping Respect for Yourself (FAST) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0023-f-001-dbt-020-r001-guidelines-for-self-respect-effectiveness-keeping-respect-for-yourself-fast.md",
		"specId": "0023-f-001-dbt-020-r001-guidelines-for-self-respect-effectiveness-keeping-respect-for-yourself-fast",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Skills use",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use FAST when preserving self-respect is central to the interaction, especially around values, truthfulness, fairness, and apology boundaries."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not decide whether the client is right or wrong and does not score self-respect."
			}
		],
		"faqItems": [
			{
				"question": "Can FAST include a planned apology?",
				"answer": "Yes. If an apology is appropriate, the tool can include it while distinguishing it from unnecessary apology."
			},
			{
				"question": "Is FAST a values inventory?",
				"answer": "No. FAST captures values relevant to one interpersonal situation; it does not add a values taxonomy or score."
			},
			{
				"question": "What if the client cannot name their values?",
				"answer": "The plan remains incomplete and shows that as a coaching need rather than inventing values."
			}
		]
	},
	{
		"toolType": "validation",
		"slug": "validation",
		"title": "DBT Validation Practice Tool | Qwoach",
		"metaDescription": "Explore a DBT Validation tool for practitioners teaching clients to identify what is valid without equating validation with agreement.",
		"h1": "Validation Teaching and Example Tool",
		"intro": "Validation is a DBT interpersonal effectiveness tool for practitioners teaching clients how to acknowledge another person's emotions, thoughts, or behavior without necessarily agreeing. It helps the client identify what is valid, draft a validating statement, and notice invalidating responses to avoid.",
		"demoTitle": "Explore a sample validation example",
		"demoPrompt": "Interested in using Validation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0024-f-001-dbt-021-r001-validation.md",
		"specId": "0024-f-001-dbt-021-r001-validation",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use this when the client needs to practice acknowledging what is valid in another person's response while keeping their own position."
			},
			{
				"title": "Relevant Limitation",
				"body": "The tool does not rate the other person, decide who is correct, or claim that validation will solve the problem."
			}
		],
		"faqItems": [
			{
				"question": "Does validation mean agreement?",
				"answer": "No. The tool explicitly separates validation from agreement or approval."
			},
			{
				"question": "Can this be used only for psychoeducation?",
				"answer": "Yes. If only teaching is needed, the example fields can remain unused."
			},
			{
				"question": "What if the client cannot find anything valid?",
				"answer": "The result shows that as a coaching need for practitioner review."
			}
		]
	},
	{
		"toolType": "validatingOthers",
		"slug": "validating-others",
		"title": "DBT Validating Others Worksheet Tool | Qwoach",
		"metaDescription": "Explore a DBT Validating Others tool for reviewing real validation attempts, exact statements, outcomes, feelings, and next steps.",
		"h1": "Validating Others Practice Review Tool",
		"intro": "Validating Others is a DBT interpersonal effectiveness practice tool for practitioners reviewing a client's opportunity to validate another person. It helps capture the situation, validation behaviors used, exact invalidating and validating statements, outcome, feelings, and one change to try next time.",
		"demoTitle": "Explore a sample practice record",
		"demoPrompt": "Interested in using Validating Others with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0025-f-001-dbt-021-r002-validating-others.md",
		"specId": "0025-f-001-dbt-021-r002-validating-others",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Progress review",
				"Skill practice"
			],
			"topic": [
				"Skills use",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use this after a real opportunity to validate, including times when the client noticed they did not validate."
			},
			{
				"title": "History And Comparison",
				"body": "Repeated records remain individually dated or situated so the practitioner can review practice examples over time without merging them into a broad relationship record."
			}
		],
		"faqItems": [
			{
				"question": "Can the client complete it if they did not validate?",
				"answer": "Yes. The record can capture that the opportunity occurred and that validation did not happen."
			},
			{
				"question": "What if the client cannot remember exact wording?",
				"answer": "The record can mark statements as approximate rather than forcing certainty."
			},
			{
				"question": "Does the tool score whether validation worked?",
				"answer": "No. It records reported outcome and coaching targets without success or failure scoring."
			}
		]
	},
	{
		"toolType": "selfValidationAndSelfRespect",
		"slug": "self-validation-and-self-respect",
		"title": "DBT Self-Validation Practice Tool | Qwoach",
		"metaDescription": "Explore a DBT self-validation record for reviewing invalidating events, self-talk, strategies used, outcomes, and self-respect next steps.",
		"h1": "Self-Validation and Self-Respect Practice Tool",
		"intro": "Self-Validation and Self-Respect is a DBT practice tool for practitioners helping clients review an invalidating event, identify self-invalidating and self-validating statements, note strategies used, and choose a self-respect-preserving next step.",
		"demoTitle": "Explore a sample self-validation record",
		"demoPrompt": "Interested in using Self-Validation and Self-Respect with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0026-f-001-dbt-021-r003-self-validation-and-self-respect.md",
		"specId": "0026-f-001-dbt-021-r003-self-validation-and-self-respect",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Progress review",
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use this after invalidation, disappointment, or failed interpersonal effectiveness attempts when the client needs structured self-validation."
			},
			{
				"title": "Relevant Limitation",
				"body": "The tool is not a crisis tool, mood tracker, or broad self-esteem program; it records one invalidating experience and a self-respect-linked next step."
			}
		],
		"faqItems": [
			{
				"question": "Can the record stay partial?",
				"answer": "Yes. Incomplete event details or missing self-validating statements remain visible for practitioner review."
			},
			{
				"question": "Does the tool interpret severe distress?",
				"answer": "No. It records the client's report and allows practitioner review without making unsupported clinical interpretations."
			},
			{
				"question": "Can repeated records be compared?",
				"answer": "Yes. Repeated records can show patterns in self-talk and strategies without system interpretation."
			}
		]
	},
	{
		"toolType": "emotionRegulationHandout5ModelForDescribingEmotions",
		"slug": "emotion-regulation-handout-5-model-for-describing-emotions",
		"title": "DBT Model for Describing Emotions Tool | Qwoach",
		"metaDescription": "Explore a DBT emotion episode mapping tool for practitioners reviewing triggers, interpretations, body responses, urges, actions, and aftereffects.",
		"h1": "Model for Describing Emotions Flow Map Tool",
		"intro": "The Model for Describing Emotions is a DBT emotion regulation tool for practitioners helping clients understand a specific emotional episode. It helps map vulnerabilities, prompting event, interpretations, biological changes, body sensations, action urges, expressions or actions, secondary emotions, aftereffects, and the emotion name so possible intervention points are visible.",
		"demoTitle": "Explore a sample emotion map",
		"demoPrompt": "Interested in using Emotion Regulation Handout 5: Model for Describing Emotions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0027-f-001-dbt-022-r001-emotion-regulation-handout-5-model-for-describing-emotions.md",
		"specId": "0027-f-001-dbt-022-r001-emotion-regulation-handout-5-model-for-describing-emotions",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use this after a confusing, intense, or hard-to-regulate emotional episode when the practitioner and client need to understand the sequence."
			},
			{
				"title": "History And Partial Maps",
				"body": "Partial maps remain useful but visibly incomplete. Completed maps are preserved as separate episodes for later review."
			},
			{
				"title": "Relevant Limitation",
				"body": "The tool does not automatically interpret the episode, rank interventions, or decide treatment."
			}
		],
		"faqItems": [
			{
				"question": "Can the emotion name be uncertain?",
				"answer": "Yes. The tool allows tentative emotion labeling rather than forcing certainty."
			},
			{
				"question": "Can multiple emotions be mapped?",
				"answer": "The tool keeps one primary episode map and can note secondary emotions instead of becoming a generic multi-emotion tracker."
			},
			{
				"question": "Does the system choose the intervention?",
				"answer": "No. Practitioner or client marking can show possible intervention points, but the system does not prescribe or rank interventions."
			}
		]
	},
	{
		"toolType": "pleaseSkill",
		"slug": "please-skill",
		"title": "DBT PLEASE Skill Tracker | Qwoach",
		"metaDescription": "Explore a DBT PLEASE tracker for reviewing illness care, eating, substances, sleep, exercise, helpfulness, barriers, and targets.",
		"h1": "PLEASE Skill Tracking Tool",
		"intro": "The PLEASE skill tool is a DBT emotion regulation tracker for practitioners and clients reviewing physical illness care, balanced eating, avoiding mood-altering substances, balanced sleep, and exercise. It helps identify self-care gaps, helpfulness, barriers, and concrete follow-up targets for reducing emotional vulnerability.",
		"demoTitle": "Explore a sample PLEASE week",
		"demoPrompt": "Interested in using PLEASE skill with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0028-f-001-dbt-023-r001-please-skill.md",
		"specId": "0028-f-001-dbt-023-r001-please-skill",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Emotion regulation",
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use this when reviewing whether body-care patterns may be increasing emotional vulnerability."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated weeks support longitudinal comparison of targets and helpfulness while preserving missed days and not-applicable notes as entered."
			},
			{
				"title": "Relevant Limitation",
				"body": "The tool records self-report for DBT emotion-regulation review; it is not medical management, a nutrition program, a sleep clinic workflow, or an exercise tracker."
			}
		],
		"faqItems": [
			{
				"question": "Can missed days stay blank?",
				"answer": "Yes. Missed days remain blank rather than being inferred."
			},
			{
				"question": "Can a domain be marked not applicable?",
				"answer": "Yes. A domain can be marked not applicable for a day with a note."
			},
			{
				"question": "Does PLEASE give medical advice?",
				"answer": "No. The tool records client self-report and supports practitioner review without giving medical advice."
			},
			{
				"question": "What configuration is saved?",
				"answer": "The tool itself and the selected tracking period setup are saved; fictional demo entries are not saved as client data."
			}
		]
	},
	{
		"toolType": "abcPleaseSkills",
		"slug": "abc-please-skills",
		"title": "DBT ABC PLEASE Planning Tool | Qwoach",
		"metaDescription": "Explore an ABC PLEASE planning tool for DBT practitioners building preventive emotion-regulation targets with clients.",
		"h1": "ABC PLEASE Skills Planning Tool",
		"intro": "ABC PLEASE Skills is a DBT emotion regulation planning tool for practitioners helping clients reduce future emotional vulnerability. It helps organize Accumulate positive emotions, Build mastery, Cope ahead, and PLEASE body-care targets into a reviewable plan for between-session practice.",
		"demoTitle": "Explore a sample ABC PLEASE plan",
		"demoPrompt": "Interested in using ABC PLEASE Skills with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0029-f-001-dbt-024-r001-abc-please-skills.md",
		"specId": "0029-f-001-dbt-024-r001-abc-please-skills",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Emotion regulation",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use this when the clinical task is prevention: building positive experiences, mastery, preparation, and body-care targets before future distress spikes."
			},
			{
				"title": "Partial Plans",
				"body": "If only some areas are planned, the result remains partial and shows missing skill areas for follow-up."
			},
			{
				"title": "Relevant Limitation",
				"body": "The tool does not score vulnerability, recommend interventions automatically, or function as a crisis plan."
			}
		],
		"faqItems": [
			{
				"question": "Can the review period be configured?",
				"answer": "Yes. The target review period can be selected to match the assignment timing."
			},
			{
				"question": "Does changing the period change ABC PLEASE?",
				"answer": "No. It changes due dates and layout, not the meaning of the ABC PLEASE sections."
			},
			{
				"question": "Can a plan be saved if some sections are incomplete?",
				"answer": "Yes. Partial plans show missing areas and can still be reviewed."
			},
			{
				"question": "Does this replace a separate PLEASE tracker?",
				"answer": "No. This tool captures PLEASE targets within ABC PLEASE planning; whether it links to a separate PLEASE tracker requires product validation."
			}
		]
	},
	{
		"toolType": "pleasantEventsDiary",
		"slug": "pleasant-events-diary",
		"title": "DBT Pleasant Events Diary Tool | Qwoach",
		"metaDescription": "Explore a DBT Pleasant Events Diary for tracking planned and actual activities, mindfulness, worry, and pleasantness day by day.",
		"h1": "Pleasant Events Diary Tool",
		"intro": "Pleasant Events Diary is a DBT emotion regulation tool for practitioners helping clients intentionally increase short-term positive experiences. It helps track planned pleasant events, actual completed events, mindfulness ratings, worry interference ratings, and pleasantness ratings for review and next planning.",
		"demoTitle": "Explore a sample diary week",
		"demoPrompt": "Interested in using Pleasant Events Diary with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0030-f-001-dbt-024-r002-pleasant-events-diary.md",
		"specId": "0030-f-001-dbt-024-r002-pleasant-events-diary",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Emotion regulation",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use this for short-term Accumulate Positive Emotions practice when the practitioner wants daily planned-versus-actual tracking."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated diaries create a longitudinal practice history while keeping each diary period separate."
			},
			{
				"title": "Relevant Limitation",
				"body": "The diary is not a generic habit tracker, mood diary, or full behavioral activation program, and it does not make clinical outcome claims from ratings."
			}
		],
		"faqItems": [
			{
				"question": "Can unplanned pleasant events be recorded?",
				"answer": "Yes. Planned events that did not happen are preserved, and unplanned pleasant events can be entered as actual activity."
			},
			{
				"question": "What happens to missed days?",
				"answer": "Missed days remain blank and visible in review."
			},
			{
				"question": "Can the rating scale display change?",
				"answer": "Yes, if supported by implementation, the display can change while the rating meanings stay stable."
			},
			{
				"question": "Are ratings interpreted as mood improvement?",
				"answer": "No. Ratings are descriptive and are used to guide future planning, not to infer clinical improvement."
			}
		]
	},
	{
		"toolType": "puttingAbcSkillsTogetherDayByDay",
		"slug": "putting-abc-skills-together-day-by-day",
		"title": "Putting ABC Skills Together Day by Day DBT Tracker | Qwoach",
		"metaDescription": "Demo a weekly DBT ABC tracker for planned vs. actual Accumulate Positive Emotions, Build Mastery, Cope-Ahead, and daily mood ratings.",
		"h1": "Putting ABC Skills Together Day by Day",
		"intro": "Putting ABC Skills Together Day by Day is a DBT emotion-regulation practice tracker for practitioners who assign Accumulate Positive Emotions, Build Mastery, and Cope-Ahead work. It helps the practitioner compare planned and actual daily skill use alongside start- and end-of-day negative mood ratings.",
		"demoTitle": "Open the sample weekly tracker",
		"demoPrompt": "Interested in using Putting ABC Skills Together Day by Day with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0031-f-001-dbt-024-r003-putting-abc-skills-together-day-by-day.md",
		"specId": "0031-f-001-dbt-024-r003-putting-abc-skills-together-day-by-day",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Skill practice"
			],
			"topic": [
				"Emotion regulation",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for between-session or week-level ABC practice when planned preventive emotion-regulation actions need to be compared with what the client actually did."
			},
			{
				"title": "What It Captures",
				"body": "The tracker captures time blocks, planned ABC actions, actual completed actions, and start/end negative mood ratings. It does not capture diagnoses, risk scores, or automated clinical interpretations."
			},
			{
				"title": "History",
				"body": "Completed weeks remain available for longitudinal comparison, with prior entries preserving the structure used when they were completed."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score ABC skill use?",
				"answer": "No. It shows planned versus actual practice and mood-rating changes descriptively; the practitioner interprets the pattern."
			},
			{
				"question": "Can a client submit a partially completed week?",
				"answer": "Yes. Partial days remain reviewable, and missing planned, actual, or mood-rating fields are marked as missing rather than treated as zero."
			},
			{
				"question": "Can the practitioner change the time blocks?",
				"answer": "Yes, if local practice requires it. Changing time-block labels changes row labels only and should remain visible in history if labels change midweek."
			},
			{
				"question": "Are sample demo responses saved as client records?",
				"answer": "No. Demo entries are temporary and do not become real owned client data when the practitioner saves the tool."
			}
		]
	},
	{
		"toolType": "checkTheFacts",
		"slug": "check-the-facts",
		"title": "Check the Facts DBT Worksheet Demo | Qwoach",
		"metaDescription": "Demo a DBT Check the Facts worksheet for separating facts from interpretations and reviewing emotion intensity and fit with the situation.",
		"h1": "Check the Facts",
		"intro": "Check the Facts is a DBT emotion-regulation appraisal worksheet for practitioners and clients reviewing one intense emotional reaction. It helps separate observable facts from interpretations, consider alternative explanations, and make the emotion and intensity fit review clinically clear.",
		"demoTitle": "Try a sample appraisal",
		"demoPrompt": "Interested in using Check the Facts with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0032-f-001-dbt-025-r001-check-the-facts.md",
		"specId": "0032-f-001-dbt-025-r001-check-the-facts",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when an emotion and its intensity need to be examined against observable facts before deciding whether validation, problem solving, opposite action, or another response fits."
			},
			{
				"title": "What It Does Not Do",
				"body": "The worksheet does not make truth judgments, generate alternatives, apply diagnostic labels, or automatically select the next clinical strategy."
			}
		],
		"faqItems": [
			{
				"question": "Does Check the Facts decide whether an emotion is justified?",
				"answer": "No. The tool organizes the appraisal; the practitioner interprets whether the emotion and intensity fit the facts."
			},
			{
				"question": "Can it handle more than one emotion?",
				"answer": "Multiple emotions should be handled as separate worksheets or clearly separated entries so the fit review does not become confused."
			},
			{
				"question": "What happens if the client cannot name an alternative interpretation?",
				"answer": "The alternatives section remains incomplete or marked none entered; the system does not invent alternatives."
			},
			{
				"question": "Is there anything to configure before saving?",
				"answer": "No substantive settings are required, but saving still adds the fixed Check the Facts tool to the practitioner's account."
			}
		]
	},
	{
		"toolType": "oppositeAction",
		"slug": "opposite-action",
		"title": "Opposite Action DBT Worksheet Demo | Qwoach",
		"metaDescription": "Demo a DBT Opposite Action worksheet for linking emotion, action urge, opposite behavior, implementation, and aftereffect review.",
		"h1": "Opposite Action",
		"intro": "Opposite Action is a DBT behavioral experiment worksheet for practitioners and clients working with a painful emotion and an ineffective action urge. It helps identify the emotion, check fit or effectiveness, plan a specific opposite behavior, and review what happened after trying it.",
		"demoTitle": "Build a sample opposite-action record",
		"demoPrompt": "Interested in using Opposite Action with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0033-f-001-dbt-026-r001-opposite-action.md",
		"specId": "0033-f-001-dbt-026-r001-opposite-action",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Planned and Completed States",
				"body": "A record can remain planned if the client has not tried the action yet. Outcome fields can be reviewed later after practice."
			},
			{
				"title": "Limits",
				"body": "The product does not generate opposite actions, judge whether a behavior was correct, or automate the next clinical decision."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend the opposite action?",
				"answer": "No. The client and practitioner enter the opposite behavior; the system does not generate substantive actions."
			},
			{
				"question": "Can an experiment stay pending?",
				"answer": "Yes. If the client has not tried the action, the record remains in a planned state with outcome fields pending."
			},
			{
				"question": "What if before or after intensity is missing?",
				"answer": "The aftereffect narrative can still be reviewed, but rating change is unavailable."
			},
			{
				"question": "Is Opposite Action configurable?",
				"answer": "No core settings are required. Saving adds the fixed Opposite Action tool to the practitioner's account."
			}
		]
	},
	{
		"toolType": "problemSolvingToChangeEmotions",
		"slug": "problem-solving-to-change-emotions",
		"title": "Problem Solving to Change Emotions DBT Demo | Qwoach",
		"metaDescription": "Demo a 7-step DBT problem-solving worksheet for defining a changeable problem, setting a goal, choosing an action, and reviewing outcome.",
		"h1": "Problem Solving to Change Emotions",
		"intro": "Problem Solving to Change Emotions is a DBT problem-solving worksheet for practitioners working with a client whose painful emotion fits the facts and whose situation may be changed. It helps define the problem, set a goal, consider options, choose an action, and review whether the action worked.",
		"demoTitle": "Try the 7-step worksheet",
		"demoPrompt": "Interested in using Problem Solving to Change Emotions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0034-f-001-dbt-027-r001-problem-solving-to-change-emotions.md",
		"specId": "0034-f-001-dbt-027-r001-problem-solving-to-change-emotions",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Problem solving",
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation",
				"Goals",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Fits",
				"body": "Use this worksheet when the painful emotion fits the facts and the situation can potentially be changed."
			},
			{
				"title": "Pending Actions",
				"body": "The action and outcome sections can remain pending until the client has tried the selected solution."
			},
			{
				"title": "Limits",
				"body": "The tool does not become a task manager, solution optimizer, or source of automated clinical advice."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool choose the best solution?",
				"answer": "No. It organizes options and the selected action; the practitioner and client choose and interpret the solution."
			},
			{
				"question": "What if the problem is not changeable?",
				"answer": "The worksheet can be marked not appropriate or stopped without forcing completion."
			},
			{
				"question": "Can the action be reviewed later?",
				"answer": "Yes. A worksheet can remain pending until the client records action taken and outcome."
			},
			{
				"question": "Are sample options saved when I save the tool?",
				"answer": "No. Saving preserves the fixed tool, not fictional demo options or temporary client content."
			}
		]
	},
	{
		"toolType": "mindfulnessOfCurrentEmotions",
		"slug": "mindfulness-of-current-emotions",
		"title": "Mindfulness of Current Emotions DBT Demo | Qwoach",
		"metaDescription": "Demo a DBT practice worksheet for observing current emotion, body sensations, urges, allowing practice, and practitioner review.",
		"h1": "Mindfulness of Current Emotions",
		"intro": "Mindfulness of Current Emotions is a DBT mindfulness practice worksheet for practitioners helping clients notice and tolerate a current emotion. It helps the client name the emotion, observe body sensations and urges, practice allowing the emotion, and record the experience for practitioner review.",
		"demoTitle": "Open the practice demo",
		"demoPrompt": "Interested in using Mindfulness of Current Emotions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0035-f-001-dbt-028-r001-mindfulness-of-current-emotions.md",
		"specId": "0035-f-001-dbt-028-r001-mindfulness-of-current-emotions",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Emotion regulation",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Low-Burden Practice",
				"body": "The client experience should minimize typing during active practice and allow brief entries afterward."
			},
			{
				"title": "Partial Records",
				"body": "If the client cannot identify sensations or urges, those fields can be left unknown or none without forcing content."
			},
			{
				"title": "Limits",
				"body": "The tool does not interpret the meaning of the emotion, score mindfulness, or make safety determinations."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include a mindfulness score?",
				"answer": "No. It records practice completion and observations; it does not score mindfulness skill."
			},
			{
				"question": "Can a client skip sensations or urges if they cannot identify them?",
				"answer": "Yes. Those fields can be marked unknown or none rather than forcing content."
			},
			{
				"question": "Does the demo require real emotional material?",
				"answer": "No. The public demo uses fictional sample content and should not require sensitive or identifying information."
			},
			{
				"question": "Is the tool configurable?",
				"answer": "No substantive settings are required. Saving adds the fixed Mindfulness of Current Emotions tool to the practitioner's account."
			}
		]
	},
	{
		"toolType": "theWaveSkillMindfulnessOfCurrentEmotions",
		"slug": "the-wave-skill-mindfulness-of-current-emotions",
		"title": "The Wave Skill DBT STEPS-A Demo | Qwoach",
		"metaDescription": "Demo a youth DBT Wave Skill practice for emotion, trigger, intensity change, sensations, urges, and acceptance-step checklist review.",
		"h1": "The Wave Skill—Mindfulness of Current Emotions",
		"intro": "The Wave Skill—Mindfulness of Current Emotions is an adolescent/school DBT practice preset for practitioners and instructors teaching students to experience difficult emotions. It helps students name the emotion, track before-and-after intensity, notice sensations and urges, and identify which wave-skill steps they used.",
		"demoTitle": "Preview the student practice sheet",
		"demoPrompt": "Interested in using The Wave Skill—Mindfulness of Current Emotions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0036-f-001-dbt-028-r002-the-wave-skill-mindfulness-of-current-emotions.md",
		"specId": "0036-f-001-dbt-028-r002-the-wave-skill-mindfulness-of-current-emotions",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Between-session monitoring"
			],
			"topic": [
				"Emotion regulation",
				"Coping"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Youth-Friendly Use",
				"body": "The practice sheet should keep writing burden low and use simple checklist interaction for the steps used."
			},
			{
				"title": "Individual or Group Context",
				"body": "The assignment context can be individual or classroom/youth group; the fields and result remain the same."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide grades, discipline conclusions, diagnoses, or automated safety determinations."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as the adult Mindfulness of Current Emotions worksheet?",
				"answer": "No. This page represents the adolescent/school Wave Skill preset with student homework structure and intensity tracking."
			},
			{
				"question": "Does changing assignment context change the worksheet fields?",
				"answer": "No. It changes distribution and review framing, not the student response fields."
			},
			{
				"question": "What if no wave-skill steps are checked?",
				"answer": "The result shows none selected; it does not infer that the student did or did not practice."
			},
			{
				"question": "Are sample student entries saved?",
				"answer": "No. Saving preserves the tool and assignment context, not fictional student demo data."
			}
		]
	},
	{
		"toolType": "tipSkills",
		"slug": "tip-skills",
		"title": "TIP Skills DBT Practice Demo | Qwoach",
		"metaDescription": "Demo a DBT TIP Skills plan and practice record for selected components, before/after arousal ratings, notes, and practitioner review.",
		"h1": "TIP Skills",
		"intro": "TIP Skills is a DBT distress-tolerance plan and practice record for practitioners helping clients reduce physiological arousal during crisis or intense distress. It helps select body-based TIP components, capture before-and-after arousal or distress ratings, and review whether safer next coping became possible.",
		"demoTitle": "Try a sample TIP practice",
		"demoPrompt": "Interested in using TIP Skills with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0037-f-001-dbt-029-r001-tip-skills.md",
		"specId": "0037-f-001-dbt-029-r001-tip-skills",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Crisis response",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Low-Burden Crisis Entry",
				"body": "The client flow should stay brief: select skill, rate before, rate after, and note what happened."
			},
			{
				"title": "Component Availability",
				"body": "Practitioners can limit available components based on what has been agreed as appropriate; the product does not explain contraindications or make medical decisions."
			},
			{
				"title": "History",
				"body": "Repeated practice records can show descriptively which components were used and what rating changes were reported."
			}
		],
		"faqItems": [
			{
				"question": "Does TIP Skills provide medical clearance?",
				"answer": "No. The practitioner controls component availability; the product does not provide medical advice or clearance."
			},
			{
				"question": "Can a client record TIP use after the crisis?",
				"answer": "Yes. If crisis use is too urgent for full entry, retrospective recording is supported."
			},
			{
				"question": "What happens if the after-rating is missing?",
				"answer": "The practice record remains incomplete for outcome; notes can still be reviewed."
			},
			{
				"question": "Does the tool decide the client is safe?",
				"answer": "No. It shows reported ratings, selected components, and observations; safety decisions remain outside the automated tool."
			}
		]
	},
	{
		"toolType": "distractWithWiseMindAccepts",
		"slug": "distract-with-wise-mind-accepts",
		"title": "Distract with Wise Mind ACCEPTS DBT Demo | Qwoach",
		"metaDescription": "Demo a DBT ACCEPTS worksheet for personalized crisis-survival distraction options, practice records, and descriptive effectiveness review.",
		"h1": "Distract with Wise Mind ACCEPTS",
		"intro": "Distract with Wise Mind ACCEPTS is a DBT distress-tolerance worksheet for practitioners helping clients survive intense distress that cannot be solved immediately. It helps clients personalize distraction options across the ACCEPTS categories and review which options helped reduce distress or urges.",
		"demoTitle": "Explore the ACCEPTS plan",
		"demoPrompt": "Interested in using Distract with Wise Mind ACCEPTS with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0038-f-001-dbt-030-r001-distract-with-wise-mind-accepts.md",
		"specId": "0038-f-001-dbt-030-r001-distract-with-wise-mind-accepts",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Crisis response",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "The Seven Categories",
				"body": "The plan is organized by Activities, Contributing, Comparisons, different Emotions, Pushing away, other Thoughts, and other Sensations."
			},
			{
				"title": "Practice Review",
				"body": "Practice records can accumulate over time to show which options were tried and what the client reported about effectiveness."
			},
			{
				"title": "Limits",
				"body": "The product stays within ACCEPTS and does not merge adjacent DBT distress-tolerance tools or generate clinical recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate ACCEPTS options?",
				"answer": "No. Options are client-entered or practitioner-supported; the system does not generate coping recommendations."
			},
			{
				"question": "Can a category stay blank?",
				"answer": "Yes. If no realistic option exists for a category, it can remain blank or be revised later."
			},
			{
				"question": "Do ratings have to be entered?",
				"answer": "No. If ratings are missing, reflections and tried/not tried status remain reviewable."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected configuration are saved; fictional crisis examples and sample practice records are not saved as real client data."
			}
		]
	},
	{
		"toolType": "improveTheMoment",
		"slug": "improve-the-moment",
		"title": "IMPROVE the Moment DBT Worksheet Demo | Qwoach",
		"metaDescription": "Demo a DBT IMPROVE worksheet for personalized distress-tolerance strategies, optional before/after ratings, reflections, and review.",
		"h1": "IMPROVE the Moment",
		"intro": "IMPROVE the Moment is a DBT distress-tolerance worksheet for practitioners helping clients endure a distressing situation that cannot be solved immediately. It helps clients personalize strategies across the IMPROVE categories and record ratings or reflections about which strategies helped.",
		"demoTitle": "Explore the IMPROVE worksheet",
		"demoPrompt": "Interested in using IMPROVE the Moment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0039-f-001-dbt-031-r001-improve-the-moment.md",
		"specId": "0039-f-001-dbt-031-r001-improve-the-moment",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Crisis response",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the distressing situation cannot be solved immediately and the goal is to make the moment more tolerable."
			},
			{
				"title": "Optional Ratings",
				"body": "Before/after distress ratings may be used when included, but reflections remain reviewable without ratings."
			},
			{
				"title": "Limits",
				"body": "The tool does not merge ACCEPTS, Self-Soothing, or other DBT tools into the same configuration."
			}
		],
		"faqItems": [
			{
				"question": "Are all IMPROVE categories required?",
				"answer": "No. A category can remain blank if it does not fit the client, and the worksheet can still be reviewed."
			},
			{
				"question": "Does the tool rank strategies by effectiveness?",
				"answer": "No. It shows reported ratings or reflections descriptively; the practitioner interprets usefulness."
			},
			{
				"question": "Are before and after ratings required?",
				"answer": "No. Ratings are optional in this configuration; reflections remain reviewable if ratings are absent."
			},
			{
				"question": "What is saved when there are no settings?",
				"answer": "The fixed IMPROVE the Moment tool itself is saved; sample demo content is not saved as client data."
			}
		]
	},
	{
		"toolType": "selfSoothing",
		"slug": "self-soothing",
		"title": "Self-Soothing DBT Worksheet Demo | Qwoach",
		"metaDescription": "Demo a DBT Self-Soothing worksheet for sensory coping options by sense, practice notes, optional effectiveness ratings, and review.",
		"h1": "Self-Soothing",
		"intro": "Self-Soothing is a DBT distress-tolerance worksheet for practitioners helping clients lower distress through sensory comfort. It helps clients list soothing options by sense, practice them during distress, and report which strategies were realistic and helpful.",
		"demoTitle": "Explore the sensory coping plan",
		"demoPrompt": "Interested in using Self-Soothing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0040-f-001-dbt-032-r001-self-soothing.md",
		"specId": "0040-f-001-dbt-032-r001-self-soothing",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Crisis response",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Senses as Structure",
				"body": "The worksheet is organized by sensory categories, commonly vision, hearing, smell, taste, and touch."
			},
			{
				"title": "Blank Categories",
				"body": "Not every sense needs an option; blank senses remain visible for review and future refinement."
			},
			{
				"title": "Practice History",
				"body": "Repeated practice records can be linked to the same sensory repertoire so the practitioner can review reported helpfulness over time."
			}
		],
		"faqItems": [
			{
				"question": "Does every sense need a strategy?",
				"answer": "No. Relevant senses may vary by client, and blank categories are allowed."
			},
			{
				"question": "Does the tool recommend sensory strategies?",
				"answer": "No. Strategies are client-entered and reviewed by the practitioner."
			},
			{
				"question": "What if a sensory option makes distress worse?",
				"answer": "The record should preserve that reported information for practitioner review rather than hide or reinterpret it."
			},
			{
				"question": "Is anything saved if there are no settings?",
				"answer": "Yes. Saving adds the fixed Self-Soothing tool to the practitioner's account; fictional demo content is not saved as client data."
			}
		]
	},
	{
		"toolType": "selfSootheWithSixSenses",
		"slug": "self-soothe-with-six-senses",
		"title": "Self-Soothe with Six Senses DBT-A Demo | Qwoach",
		"metaDescription": "Explore a DBT-A self-soothe practice for teens that builds a six-sense coping plan and records practice effects for clinician review.",
		"h1": "Self-Soothe with Six Senses for adolescent DBT practice",
		"intro": "Self-Soothe with Six Senses is a teen-oriented DBT-A distress-tolerance tool for clinicians teaching adolescents how to use sensory coping actions during stressful situations. It helps the teen identify stressful contexts, choose soothing actions across six sensory channels, and report whether practice helped with feelings, urges, or conflict.",
		"demoTitle": "Explore the teen practice and review a sample result.",
		"demoPrompt": "Interested in using Self-Soothe with Six Senses with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0041-f-001-dbt-032-r002-self-soothe-with-six-senses.md",
		"specId": "0041-f-001-dbt-032-r002-self-soothe-with-six-senses",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Skills use",
				"Emotion regulation"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "This tool is used when a teen needs concrete sensory options for tolerating distress between sessions."
			},
			{
				"title": "What It Captures",
				"body": "It captures stressful contexts, self-soothing actions by sensory channel, practice attempts, perceived helpfulness, and barriers."
			},
			{
				"title": "History",
				"body": "Prior coping-plan versions and practice entries remain available so the practitioner can compare fit and use over time."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool score coping ability?",
				"answer": "No. It provides descriptive summaries of the teen's coping plan and practice reports, but it does not score coping ability or draw clinical conclusions."
			},
			{
				"question": "Can the teen complete a plan before practicing it in a real stressful situation?",
				"answer": "Yes. The practitioner can use a plan-only first pass and request practice follow-up later."
			},
			{
				"question": "What happens if not all six senses have entries?",
				"answer": "Missing sensory channels are shown as missing, not treated as failure."
			},
			{
				"question": "Does sample demo content become client data when saved?",
				"answer": "No. Saving preserves the tool and reusable practitioner settings, not fictional demo responses."
			}
		]
	},
	{
		"toolType": "dbtProsAndConsProsAndConsOfActingOnCrisisUrges",
		"slug": "dbt-pros-and-cons-pros-and-cons-of-acting-on-crisis-urges",
		"title": "DBT Pros and Cons Crisis Urge Demo | Qwoach",
		"metaDescription": "Explore a DBT Pros and Cons worksheet for crisis urges with acting and resisting quadrants, consequence timing, and practitioner review.",
		"h1": "DBT Pros and Cons for crisis urges",
		"intro": "DBT Pros and Cons is a distress-tolerance worksheet for DBT practitioners and clients working with a specific crisis urge or impulsive behavior. It helps the client list pros and cons of acting on the urge versus resisting it and distinguish short-term relief from longer-term costs or benefits.",
		"demoTitle": "Try the four-quadrant grid with sample content.",
		"demoPrompt": "Interested in using DBT Pros and Cons / Pros and Cons of Acting on Crisis Urges with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0042-f-001-dbt-033-r001-dbt-pros-and-cons-pros-and-cons-of-acting-on-crisis-urges.md",
		"specId": "0042-f-001-dbt-033-r001-dbt-pros-and-cons-pros-and-cons-of-acting-on-crisis-urges",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Crisis response",
				"Behavior change",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before, during, or in session around a specific crisis urge or impulsive behavior."
			},
			{
				"title": "What It Captures",
				"body": "It captures the target urge, pros and cons of acting, pros and cons of resisting, and short-term or long-term consequence markers."
			},
			{
				"title": "Limits",
				"body": "The tool does not choose for the client, score risk, or generate advice about what the client must do."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool make a recommendation?",
				"answer": "No. It organizes the client's own consequences and reasons but does not generate an automated recommendation."
			},
			{
				"question": "Can the grid be reused for recurring urges?",
				"answer": "Yes. Prior grids can remain available with the original date and target urge for historical clarity."
			},
			{
				"question": "What if only one quadrant is filled?",
				"answer": "The result shows the imbalance as incomplete instead of interpreting the client's motivation."
			}
		]
	},
	{
		"toolType": "dbtRadicalAcceptance",
		"slug": "dbt-radical-acceptance",
		"title": "DBT Radical Acceptance Worksheet Demo | Qwoach",
		"metaDescription": "Explore a DBT Radical Acceptance practice that captures the painful reality, rejection patterns, acceptance response, ratings, and barriers.",
		"h1": "DBT Radical Acceptance practice for clinician review",
		"intro": "DBT Radical Acceptance is a distress-tolerance practice for DBT practitioners and clients facing painful facts, losses, limitations, or circumstances that cannot immediately be changed. It helps the client name the reality, identify rejecting-reality patterns, practice acceptance, and record barriers or distress and acceptance ratings.",
		"demoTitle": "Explore the acceptance reflection and sample review.",
		"demoPrompt": "Interested in using DBT Radical Acceptance with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0043-f-001-dbt-034-r001-dbt-radical-acceptance.md",
		"specId": "0043-f-001-dbt-034-r001-dbt-radical-acceptance",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "It is used when a client is suffering more because they are fighting facts or circumstances that cannot immediately be changed."
			},
			{
				"title": "What It Captures",
				"body": "It captures the painful reality, rejection patterns, acceptance practices, optional ratings, barriers, and reminders."
			},
			{
				"title": "Limits",
				"body": "The tool does not decide what a client should accept, treat acceptance as approval, or generate clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does Radical Acceptance mean approval?",
				"answer": "No. The tool explicitly keeps acceptance separate from liking, approving, or giving up."
			},
			{
				"question": "Are ratings required?",
				"answer": "No. The practitioner can include distress ratings, acceptance ratings, both, or neither."
			},
			{
				"question": "What if ratings worsen?",
				"answer": "The report preserves the client's ratings without interpreting the practice as a failure."
			}
		]
	},
	{
		"toolType": "turningTheMind",
		"slug": "turning-the-mind",
		"title": "Turning the Mind DBT Skill Demo | Qwoach",
		"metaDescription": "Explore a DBT Turning the Mind exercise for naming nonacceptance cues, choosing acceptance, and creating a repeatable recommitment plan.",
		"h1": "Turning the Mind DBT recommitment exercise",
		"intro": "Turning the Mind is a DBT distress-tolerance exercise for practitioners and clients working with repeated nonacceptance, resistance, or willfulness toward a painful reality. It helps the client name the reality, recognize cues that the mind has turned toward rejection, state an acceptance choice, and create a recommitment plan.",
		"demoTitle": "Build a sample recommitment card.",
		"demoPrompt": "Interested in using Turning the Mind with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0044-f-001-dbt-035-r001-turning-the-mind.md",
		"specId": "0044-f-001-dbt-035-r001-turning-the-mind",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "It is used when a client notices recurring resistance, rejection, or willfulness toward a painful reality."
			},
			{
				"title": "What It Captures",
				"body": "It captures nonacceptance cues, the acceptance choice, and a practical recommitment strategy."
			},
			{
				"title": "Limits",
				"body": "The tool does not require ratings, infer readiness, or generate automated advice."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as Radical Acceptance?",
				"answer": "No. This tool focuses on repeatedly recommitting to acceptance when the mind turns back toward rejection."
			},
			{
				"question": "Can it be completed with the practitioner?",
				"answer": "Yes. The completion context can be collaborative or assigned for independent reflection."
			},
			{
				"question": "What if the client can identify cues but cannot choose acceptance yet?",
				"answer": "The result preserves that incomplete state for follow-up review."
			}
		]
	},
	{
		"toolType": "dbtDistressToleranceHandout13Willingness",
		"slug": "dbt-distress-tolerance-handout-13-willingness",
		"title": "DBT Willingness Skill Demo | Qwoach",
		"metaDescription": "Explore a DBT Willingness practice that captures willful cues, willing stance, and realistic responses for practitioner review.",
		"h1": "DBT Willingness practice for willfulness and effective action",
		"intro": "DBT Distress Tolerance Handout 13: Willingness is a DBT skill practice for practitioners and clients working with resistance, forcing, avoidance, or giving up. It helps the client identify willful thoughts, actions, or body cues, name what willingness would look like, and choose a response that fits present reality.",
		"demoTitle": "Try the willingness contrast exercise.",
		"demoPrompt": "Interested in using DBT Distress Tolerance Handout 13: Willingness with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0045-f-001-dbt-036-r001-dbt-distress-tolerance-handout-13-willingness.md",
		"specId": "0045-f-001-dbt-036-r001-dbt-distress-tolerance-handout-13-willingness",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Coping",
				"Behavior change",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "It is used when resistance, control, avoidance, or giving up is blocking effective action."
			},
			{
				"title": "What It Captures",
				"body": "It captures a current situation, willful thoughts, actions, or body cues, a willing stance, and chosen response."
			},
			{
				"title": "Limits",
				"body": "The tool does not create a willfulness score or interpret the chosen response clinically."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool score willfulness?",
				"answer": "No. It keeps willful cues and willing responses descriptive and reviewable."
			},
			{
				"question": "Can body cues be skipped?",
				"answer": "Yes. Thoughts or actions can be used if body cues are not present."
			},
			{
				"question": "What if the client cannot identify willingness?",
				"answer": "That section remains incomplete for practitioner review instead of being automatically corrected."
			}
		]
	},
	{
		"toolType": "mindfulnessOfCurrentThoughts",
		"slug": "mindfulness-of-current-thoughts",
		"title": "Mindfulness of Current Thoughts Demo | Qwoach",
		"metaDescription": "Explore a DBT mindfulness practice for observing current thoughts as thoughts, without suppression, truth analysis, or automatic interpretation.",
		"h1": "Mindfulness of Current Thoughts DBT practice",
		"intro": "Mindfulness of Current Thoughts is a DBT mindfulness practice for practitioners and clients working with looping thoughts or thoughts that feel like facts, threats, or commands. It helps the client identify current thoughts, label them as thoughts, practice an observing or distancing stance, and reflect on whether the thoughts felt less controlling.",
		"demoTitle": "Try the thought-observation practice.",
		"demoPrompt": "Interested in using Mindfulness of Current Thoughts with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0046-f-001-dbt-037-r001-mindfulness-of-current-thoughts.md",
		"specId": "0046-f-001-dbt-037-r001-mindfulness-of-current-thoughts",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Mindfulness",
				"Coping",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "It is used when thoughts are looping, distressing, or being treated as facts, threats, or commands."
			},
			{
				"title": "What It Captures",
				"body": "It captures current thoughts, thought labels, the observing method used, non-suppression reflection, and perceived effect."
			},
			{
				"title": "Limits",
				"body": "The tool does not evaluate whether thoughts are true, assign distortion categories, or generate clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool challenge thoughts?",
				"answer": "No. It supports observing and labeling thoughts, not evaluating their truth or restructuring them."
			},
			{
				"question": "What if the client tried to suppress the thoughts?",
				"answer": "The report preserves suppression as barrier information for practitioner review."
			},
			{
				"question": "Is distress reduction required?",
				"answer": "No. If no change occurs, the practice is not marked as failed."
			}
		]
	},
	{
		"toolType": "guilfordDigitalForDbt",
		"slug": "guilford-digital-for-dbt",
		"title": "Guilford Digital for DBT Demo | Qwoach",
		"metaDescription": "Explore customizable DBT diary cards with client device completion, assigned materials, longitudinal charts, and clinician review analytics.",
		"h1": "Guilford Digital for DBT diary-card and analytics demo",
		"intro": "Guilford Digital for DBT is a digital DBT diary-card and analytics platform for clinicians monitoring target behaviors, emotions, urges, skills use, and change between sessions. It helps clinicians tailor diary cards to treatment priorities, assign materials, and review longitudinal charts and visual analytics.",
		"demoTitle": "Configure a sample diary card and view analytics.",
		"demoPrompt": "Interested in using Guilford Digital for DBT with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0047-f-001-dbt-038-r001-guilford-digital-for-dbt.md",
		"specId": "0047-f-001-dbt-038-r001-guilford-digital-for-dbt",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Skills use",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "It is used for ongoing between-session DBT monitoring across days, weeks, and months."
			},
			{
				"title": "What It Captures",
				"body": "It captures clinician-selected targets, emotions, urges, skills, optional thoughts, assigned-material completion, and diary-card entries."
			},
			{
				"title": "Comparability",
				"body": "When configuration changes, historical data retains the field set active at the time so old and new entries remain interpretable."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic mood tracker?",
				"answer": "No. It is represented as a DBT diary-card platform configured around treatment-priority targets, emotions, urges, and skills."
			},
			{
				"question": "What happens when entries are missing?",
				"answer": "Missing entries are shown as gaps rather than filled in by the system."
			},
			{
				"question": "Are analytics clinical conclusions?",
				"answer": "No. Analytics are descriptive views based on submitted diary-card data."
			}
		]
	},
	{
		"toolType": "dbrief",
		"slug": "dbrief",
		"title": "Dbrief DBT Diary Card Demo | Qwoach",
		"metaDescription": "Explore Dbrief DBT diary cards with plan-of-care fields, text, form, phone, or photo check-ins, trends, flags, and review views.",
		"h1": "Dbrief multi-channel DBT diary-card demo",
		"intro": "Dbrief is a digital DBT diary-card system for therapists and clinics whose patients may not use one fixed check-in method consistently. It helps practitioners configure plan-of-care diary-card fields, accept check-ins by text, form, phone, or paper-card photo, and review session-ready trends, flags, tables, calendars, and traditional diary-card views.",
		"demoTitle": "Configure channels and review sample diary-card data.",
		"demoPrompt": "Interested in using Dbrief with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0048-f-001-dbt-038-r002-dbrief.md",
		"specId": "0048-f-001-dbt-038-r002-dbrief",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Problem behavior",
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "It is used when patients need more than one way to submit diary-card information between sessions."
			},
			{
				"title": "What It Captures",
				"body": "It captures configured metrics, emotions, behaviors, and check-ins submitted through enabled channels."
			},
			{
				"title": "Ambiguity Handling",
				"body": "Unreadable or unclear phone and photo submissions are marked for clarification rather than silently transformed."
			}
		],
		"faqItems": [
			{
				"question": "Does Dbrief replace DBT diary-card structure with messaging?",
				"answer": "No. Multi-channel capture serves structured DBT diary-card review."
			},
			{
				"question": "What if a photo or phone check-in is unclear?",
				"answer": "It is marked for clarification instead of being silently converted."
			},
			{
				"question": "Can different channels create different levels of detail?",
				"answer": "Yes. Coverage differences should remain visible in review."
			}
		]
	},
	{
		"toolType": "weeklyThoughtsFeelings",
		"slug": "weekly-thoughts-feelings",
		"title": "Weekly Thoughts & Feelings Demo | Qwoach",
		"metaDescription": "Explore therapist-linked DBT diary cards with tracking options, charts, alerts, safety-plan views, engagement, and PDF reports.",
		"h1": "Weekly Thoughts & Feelings therapist-linked DBT diary-card demo",
		"intro": "Weekly Thoughts & Feelings is a therapist-linked digital DBT diary-card app for DBT therapists and patients. It helps patients log emotions, urges, behaviors, sleep, medications, notes, skills, and safety-plan information, while the linked therapist reviews charts, alerts, engagement indicators, safety-plan views, and PDF reports.",
		"demoTitle": "Explore the linked patient and therapist views.",
		"demoPrompt": "Interested in using Weekly Thoughts & Feelings with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0049-f-001-dbt-038-r003-weekly-thoughts-feelings.md",
		"specId": "0049-f-001-dbt-038-r003-weekly-thoughts-feelings",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Risk review"
			],
			"topic": [
				"Outcome monitoring",
				"Suicide risk",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "It is used between sessions so DBT-relevant logging can inform the next session."
			},
			{
				"title": "What It Captures",
				"body": "It captures configured emotions, urges, behaviors, sleep, medications, notes, skills used, and safety-plan content."
			},
			{
				"title": "Engagement",
				"body": "Logging consistency remains visible so the therapist can judge how much weight to place on the displayed pattern."
			}
		],
		"faqItems": [
			{
				"question": "Does the therapist see data without linking?",
				"answer": "No. Data remains patient-only until the therapist link is established."
			},
			{
				"question": "Are alerts clinical determinations?",
				"answer": "No. Alerts are surfaced for review without making unsupported clinical conclusions."
			},
			{
				"question": "Can reports be generated?",
				"answer": "Yes. The product supports session or progress PDF reports based on existing tracked data."
			}
		]
	},
	{
		"toolType": "guilfordDigitalForDbtCompleteInteractiveSkillsLibrary",
		"slug": "guilford-digital-for-dbt-complete-interactive-skills-library",
		"title": "Guilford Digital DBT Skills Library Demo | Qwoach",
		"metaDescription": "Explore a DBT skills assignment library with searchable materials, individual or group assignment, interactive completion, and progress review.",
		"h1": "Guilford Digital for DBT Complete Interactive Skills Library demo",
		"intro": "Guilford Digital for DBT Complete Interactive Skills Library is a practitioner DBT skills assignment library for clinicians teaching skills to clients or groups. It helps clinicians select treatment-relevant DBT handouts, worksheets, videos, or interactive exercises, assign them digitally, and review engagement, responses, and progress information.",
		"demoTitle": "Search sample skills and assign a demo activity.",
		"demoPrompt": "Interested in using Guilford Digital for DBT Complete Interactive Skills Library with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0050-f-001-dbt-039-r001-guilford-digital-for-dbt-complete-interactive-skills-library.md",
		"specId": "0050-f-001-dbt-039-r001-guilford-digital-for-dbt-complete-interactive-skills-library",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Skills use",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "It is used when a clinician wants clients or groups to continue DBT skills learning and practice outside the session."
			},
			{
				"title": "What It Captures",
				"body": "It captures selected skill material, assignment target, completion, engagement, interactive responses, and progress indicators."
			},
			{
				"title": "Partial Progress",
				"body": "Assigned but unopened, in-progress, completed, and historical assignments remain visible for continuity."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic worksheet builder?",
				"answer": "No. It represents a curated DBT skills library assignment workflow."
			},
			{
				"question": "Can assignments go to a group?",
				"answer": "Yes. Assignment target can be individual or group, with individual statuses visible inside group progress."
			},
			{
				"question": "Does the tool score DBT skill mastery?",
				"answer": "No. It tracks engagement, completion, responses, and descriptive progress without automated mastery scoring."
			}
		]
	},
	{
		"toolType": "guilfordDigitalEnhancedResourcesForDbtSkillsTrainingHandoutsAndWorksheets",
		"slug": "guilford-digital-enhanced-resources-for-dbt-skills-training-handouts-and-worksheets",
		"title": "DBT Skills Fillable PDF Resource Library Demo | Qwoach",
		"metaDescription": "Explore a DBT skills fillable PDF library for locating, sharing, downloading, printing, and reviewing returned DBT handouts and worksheets.",
		"h1": "DBT Skills Training Handouts and Worksheets Fillable PDF Library",
		"intro": "Guilford Digital Enhanced Resources for DBT Skills Training Handouts and Worksheets is a DBT skills handout and worksheet resource library for DBT practitioners. It helps practitioners locate official DBT materials by title or module, share or print fillable PDFs for client practice, and review returned completed materials through their chosen workflow.",
		"demoTitle": "Search the sample library, choose a DBT module or title, and preview the digital or print workflow.",
		"demoPrompt": "Interested in using Guilford Digital Enhanced Resources for DBT Skills Training Handouts and Worksheets with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0051-f-001-dbt-039-r002-guilford-digital-enhanced-resources-for-dbt-skills-training-handouts-and-worksheets.md",
		"specId": "0051-f-001-dbt-039-r002-guilford-digital-enhanced-resources-for-dbt-skills-training-handouts-and-worksheets",
		"tags": {
			"framework": [
				"DBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Skills use",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when DBT skills practice needs to be aligned with a specific handout, worksheet, or module being taught."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures resource selection, sharing or printing workflow, and returned completed materials if managed within the product. It does not collect new clinical ratings or generate DBT skill scores."
			},
			{
				"title": "Limitations",
				"body": "The tool organizes and displays existing fillable PDF materials and returned responses. It does not create new worksheet content, score skill use, or interpret client responses."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create new DBT worksheets?",
				"answer": "No. It helps locate, share, download, print, and review existing DBT handouts and worksheets in fillable PDF form."
			},
			{
				"question": "Can clients complete the materials digitally?",
				"answer": "Yes. The supported workflow includes fillable PDFs where the source PDF supports digital completion, with printing available as a fallback."
			},
			{
				"question": "Does the product score completed DBT worksheets?",
				"answer": "No. Review is limited to the returned completed PDF or printed worksheet content without automated scoring or clinical interpretation."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The saved account item includes the tool itself and your selected reusable setup, such as resource scope and digital or print workflow. Demo client content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "yaleBrownObsessiveCompulsiveScaleSecondEditionYBocsIi",
		"slug": "yale-brown-obsessive-compulsive-scale-second-edition-y-bocs-ii",
		"title": "Y-BOCS II Adult OCD Assessment Demo | Qwoach",
		"metaDescription": "Explore a clinician-administered Y-BOCS II demo for adult OCD symptom checklist, 0-5 severity ratings, scoring, and follow-up comparison.",
		"h1": "Yale-Brown Obsessive-Compulsive Scale Second Edition Demo",
		"intro": "Yale-Brown Obsessive-Compulsive Scale Second Edition (Y-BOCS II) is a clinician-administered adult OCD symptom and severity assessment. It helps clinicians characterize obsession and compulsion symptoms, rate severity on the supported 0-5 items, and compare baseline or follow-up score information over time.",
		"demoTitle": "Start a sample clinician administration and review the scored assessment summary.",
		"demoPrompt": "Interested in using Yale-Brown Obsessive-Compulsive Scale Second Edition (Y-BOCS II) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0052-f-002-ocd-001-r001-yale-brown-obsessive-compulsive-scale-second-edition-y-bocs-ii.md",
		"specId": "0052-f-002-ocd-001-r001-yale-brown-obsessive-compulsive-scale-second-edition-y-bocs-ii",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for adult OCD baseline assessment, reassessment, or treatment-outcome review when clinician-rated symptom and severity information is needed."
			},
			{
				"title": "Result Boundaries",
				"body": "The result is scored assessment information for clinician review. It does not diagnose OCD, generate treatment recommendations, or add unsupported interpretation."
			},
			{
				"title": "Repeat Use",
				"body": "Follow-up administrations can be compared descriptively by date and score when they use the same instrument version."
			}
		],
		"faqItems": [
			{
				"question": "Is the Y-BOCS II completed by the client alone?",
				"answer": "No. This configuration is clinician-administered. The adult client provides information during the assessment, and the clinician records ratings."
			},
			{
				"question": "Does the tool diagnose OCD?",
				"answer": "No. It provides clinician-rated symptom and severity information that can inform diagnostic consideration and treatment planning."
			},
			{
				"question": "What happens if an item is missing?",
				"answer": "Missing required ratings are flagged, and unsupported total-score interpretation is prevented when scoring requirements are not met."
			},
			{
				"question": "Can I compare results over time?",
				"answer": "Yes. The review view can compare Y-BOCS II administrations descriptively by date and score for the same client and instrument."
			}
		]
	},
	{
		"toolType": "yBocsIiSrYaleBrownObsessiveCompulsiveScaleIiSelfReport",
		"slug": "y-bocs-ii-sr-yale-brown-obsessive-compulsive-scale-ii-self-report",
		"title": "Y-BOCS-II-SR Self-Report OCD Demo | Qwoach",
		"metaDescription": "Explore Y-BOCS-II-SR for adult OCD self-report completion, clinician review, scoring, missing-item status, and comparison over time.",
		"h1": "Y-BOCS-II Self-Report for Adult OCD Clinical Review",
		"intro": "Y-BOCS-II-SR / Yale-Brown Obsessive Compulsive Scale-II Self-Report is an adult OCD self-report symptom and severity assessment for clinician review. It helps clinicians gather patient-reported OCD symptom breadth and severity information before or between clinical encounters and compare it with prior assessment data.",
		"demoTitle": "Send a sample self-report, complete the patient view, and review the clinician summary.",
		"demoPrompt": "Interested in using Y-BOCS-II-SR / Yale-Brown Obsessive Compulsive Scale-II Self-Report with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0053-f-002-ocd-001-r002-y-bocs-ii-sr-yale-brown-obsessive-compulsive-scale-ii-self-report.md",
		"specId": "0053-f-002-ocd-001-r002-y-bocs-ii-sr-yale-brown-obsessive-compulsive-scale-ii-self-report",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Between-session monitoring"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before intake, before a session, between encounters, or for measurement-based follow-up when adult patient self-report can inform clinical review."
			},
			{
				"title": "Practitioner And Patient Roles",
				"body": "The patient completes the self-report. The clinician reviews the submitted information as decision-support and integrates it with other assessment data."
			},
			{
				"title": "Comparison Behavior",
				"body": "Prior self-report results and clinician-rated Y-BOCS II data can be displayed descriptively when available. The product does not resolve discrepancies automatically."
			}
		],
		"faqItems": [
			{
				"question": "Is this a clinician-administered assessment?",
				"answer": "No. This configuration is patient-completed self-report for clinician review."
			},
			{
				"question": "Does the Y-BOCS-II-SR diagnose OCD?",
				"answer": "No. It provides patient-reported clinical decision-support information and does not present results as a standalone diagnosis."
			},
			{
				"question": "Can incomplete forms be submitted?",
				"answer": "Yes, if the practitioner allows partial submission. Missing items are flagged and unsupported score calculations are withheld."
			},
			{
				"question": "Can results be compared with clinician-rated Y-BOCS II data?",
				"answer": "Yes. When both records exist, comparison can be shown descriptively without merging the instruments or interpreting discrepancies."
			}
		]
	},
	{
		"toolType": "obsessiveCompulsiveInventoryRevisedOciR",
		"slug": "obsessive-compulsive-inventory-revised-oci-r",
		"title": "OCI-R Adult OCD Self-Report Demo | Qwoach",
		"metaDescription": "Explore the OCI-R demo for adult OCD self-report ratings, total score, six subscale scores, missingness, and outcome monitoring review.",
		"h1": "Obsessive-Compulsive Inventory-Revised Demo",
		"intro": "Obsessive-Compulsive Inventory-Revised (OCI-R) is a brief adult self-report OCD symptom severity and symptom-dimension measure. It helps clinicians and researchers collect 18 past-month distress or bother ratings and review a total score plus six dimensional subscale scores.",
		"demoTitle": "Assign the sample OCI-R, complete fictional ratings, and review the score summary.",
		"demoPrompt": "Interested in using Obsessive-Compulsive Inventory-Revised (OCI-R) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0054-f-002-ocd-003-r001-obsessive-compulsive-inventory-revised-oci-r.md",
		"specId": "0054-f-002-ocd-003-r001-obsessive-compulsive-inventory-revised-oci-r",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures 18 adult self-report ratings of recent OCD-related distress or bother and scores them into total and six symptom-dimension subscales."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated OCI-R administrations can be compared descriptively for outcome monitoring when they use the same measure."
			},
			{
				"title": "Limitations",
				"body": "The tool does not diagnose OCD, create unsupported severity categories, or generate treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "How many items are in the OCI-R?",
				"answer": "The OCI-R has 18 self-report items rated on a 0-4 scale for recent distress or bother."
			},
			{
				"question": "What scores does the OCI-R produce?",
				"answer": "It produces a total score and six 3-item subscale scores: washing, checking, ordering, obsessing, hoarding, and neutralizing."
			},
			{
				"question": "Can the OCI-R be used for children?",
				"answer": "No. This configuration is the adult OCI-R. Pediatric use should route to an appropriate child OCD measure."
			},
			{
				"question": "Does the demo save sample responses?",
				"answer": "No. Saving preserves the tool and reusable configuration, not fictional ratings or sample score history."
			}
		]
	},
	{
		"toolType": "obsessiveCompulsiveInventoryChildVersionOciCv",
		"slug": "obsessive-compulsive-inventory-child-version-oci-cv",
		"title": "OCI-CV Child OCD Self-Report Demo | Qwoach",
		"metaDescription": "Explore the OCI-CV demo for youth OCD self-report ratings, total score, six domain scores, missingness, and clinician review.",
		"h1": "Obsessive Compulsive Inventory-Child Version Demo",
		"intro": "Obsessive Compulsive Inventory-Child Version (OCI-CV) is a child and adolescent self-report pediatric OCD symptom inventory. It helps practitioners and researchers collect 21 youth frequency ratings and review an overall pediatric OCD severity estimate plus six symptom-dimension scores.",
		"demoTitle": "Preview the youth form, enter sample ratings, and review the scored OCI-CV summary.",
		"demoPrompt": "Interested in using Obsessive Compulsive Inventory-Child Version (OCI-CV) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0055-f-002-ocd-003-r002-obsessive-compulsive-inventory-child-version-oci-cv.md",
		"specId": "0055-f-002-ocd-003-r002-obsessive-compulsive-inventory-child-version-oci-cv",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when youth self-report across pediatric OCD domains is needed for assessment or monitoring."
			},
			{
				"title": "Roles",
				"body": "The youth completes the self-report. The practitioner reviews scores and integrates the youth-reported profile with caregiver input and clinical assessment."
			},
			{
				"title": "Limitations",
				"body": "The tool does not diagnose OCD, replace caregiver or clinician assessment, or generate treatment plans."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the OCI-CV?",
				"answer": "The child or adolescent completes the self-report, and the practitioner reviews the scored result."
			},
			{
				"question": "How is the OCI-CV rated?",
				"answer": "It uses 21 youth self-report items rated on a 0-2 frequency scale."
			},
			{
				"question": "Does the OCI-CV replace caregiver input?",
				"answer": "No. It provides youth-reported information that the practitioner can integrate with caregiver input and clinical assessment."
			},
			{
				"question": "Can repeated OCI-CV results be compared?",
				"answer": "Yes. Repeated OCI-CV administrations can be compared descriptively when version and scoring are compatible."
			}
		]
	},
	{
		"toolType": "5ItemObsessiveCompulsiveInventoryChildVersionOciCv5",
		"slug": "5-item-obsessive-compulsive-inventory-child-version-oci-cv-5",
		"title": "OCI-CV-5 Pediatric OCD Screening Demo | Qwoach",
		"metaDescription": "Explore the OCI-CV-5 pediatric OCD screener with five youth ratings, 0-10 total score, cutoff indication, and clinician review.",
		"h1": "5-Item OCI-CV Child OCD Screener Demo",
		"intro": "5-Item Obsessive-Compulsive Inventory-Child Version (OCI-CV-5) is an ultra-brief pediatric OCD self-report screener. It helps practitioners and screening workflows collect five youth frequency ratings, sum a 0-10 score, and see whether the recommended cutoff indicates further diagnostic assessment.",
		"demoTitle": "Complete the sample five-item screen and review the cutoff result.",
		"demoPrompt": "Interested in using 5-Item Obsessive-Compulsive Inventory-Child Version (OCI-CV-5) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0056-f-002-ocd-003-r003-5-item-obsessive-compulsive-inventory-child-version-oci-cv-5.md",
		"specId": "0056-f-002-ocd-003-r003-5-item-obsessive-compulsive-inventory-child-version-oci-cv-5",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"OCD"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a pediatric pathway needs a fast likely-OCD screen before deciding whether fuller diagnostic assessment is warranted."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures five youth frequency ratings and produces a summed screening score with cutoff status."
			},
			{
				"title": "Limitations",
				"body": "The tool is not a diagnosis, full OCD inventory, severity profile, or treatment planner."
			}
		],
		"faqItems": [
			{
				"question": "How many questions are in the OCI-CV-5?",
				"answer": "There are five youth self-report frequency-rated items."
			},
			{
				"question": "What does a positive screen mean?",
				"answer": "A positive screen means the cutoff indication recommends further diagnostic assessment; it is not a diagnosis."
			},
			{
				"question": "Can an incomplete screen be interpreted?",
				"answer": "No complete cutoff result is shown when required item ratings are missing unless official scoring rules support it."
			},
			{
				"question": "Is this the full OCI-CV?",
				"answer": "No. This is the five-item pediatric screening version, not the full OCI-CV assessment."
			}
		]
	},
	{
		"toolType": "obsessiveCompulsiveInventory4Oci4",
		"slug": "obsessive-compulsive-inventory-4-oci-4",
		"title": "OCI-4 Adult OCD Screening Demo | Qwoach",
		"metaDescription": "Explore the OCI-4 adult OCD screener with four 0-4 ratings, summed score, cutoff indication, incomplete-screen handling, and review.",
		"h1": "Obsessive-Compulsive Inventory-4 Adult OCD Screener",
		"intro": "Obsessive-Compulsive Inventory-4 (OCI-4) is an ultra-brief adult OCD self-report screener. It helps practitioners and screening workflows collect four past-month distress or bother ratings, sum a screening score, and see whether cutoff guidance indicates fuller diagnostic assessment.",
		"demoTitle": "Complete the sample four-item screen and review the cutoff result.",
		"demoPrompt": "Interested in using Obsessive-Compulsive Inventory-4 (OCI-4) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0057-f-002-ocd-004-r001-obsessive-compulsive-inventory-4-oci-4.md",
		"specId": "0057-f-002-ocd-004-r001-obsessive-compulsive-inventory-4-oci-4",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"OCD"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for rapid adult OCD screening when a fuller diagnostic assessment is not practical as the first step."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures four adult self-ratings of recent distress or bother and produces a summed cutoff-based screening result."
			},
			{
				"title": "Limitations",
				"body": "The tool does not diagnose OCD, create symptom-dimension profiles, or generate treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "How many items are in the OCI-4?",
				"answer": "The OCI-4 has four adult self-report items rated from 0 to 4."
			},
			{
				"question": "Does a positive OCI-4 screen diagnose OCD?",
				"answer": "No. A positive screen indicates likely need for fuller diagnostic assessment or referral."
			},
			{
				"question": "Can a non-positive screen rule out OCD?",
				"answer": "No. A non-positive result is a screening result and should not replace practitioner judgment when clinical concern remains."
			},
			{
				"question": "What is saved when I save the screener?",
				"answer": "The tool itself and reusable routing or partial-submission setup are saved. Fictional demo responses are not saved as client data."
			}
		]
	},
	{
		"toolType": "fiveItemObsessiveCompulsiveInventoryChildVersionOciCv5",
		"slug": "five-item-obsessive-compulsive-inventory-child-version-oci-cv-5",
		"title": "Five Item OCI-CV-5 Youth OCD Demo | Qwoach",
		"metaDescription": "Explore the Five Item OCI-CV-5 youth OCD screener with five frequency ratings, 0-10 score, threshold indication, and pathway review.",
		"h1": "Five Item Obsessive-Compulsive Inventory - Child Version Demo",
		"intro": "Five Item Obsessive-Compulsive Inventory - Child Version (OCI-CV-5) is an ultra-brief child and adolescent OCD self-report screener. It helps clinicians, health systems, school-linked mental health providers, and OCD specialists collect five youth frequency ratings and see whether the score exceeds the recommended threshold for further OCD assessment.",
		"demoTitle": "Choose a review pathway, complete the youth screen, and review the threshold result.",
		"demoPrompt": "Interested in using Five Item Obsessive-Compulsive Inventory - Child Version (OCI-CV-5) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0058-f-002-ocd-005-r001-five-item-obsessive-compulsive-inventory-child-version-oci-cv-5.md",
		"specId": "0058-f-002-ocd-005-r001-five-item-obsessive-compulsive-inventory-child-version-oci-cv-5",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"OCD"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it in clinical, health system, school-linked, or OCD-specialty pathways when a very brief youth screen is needed before fuller evaluation."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures five youth frequency ratings for representative pediatric OCD symptoms and produces a threshold-based further-assessment indication."
			},
			{
				"title": "Limitations",
				"body": "The tool does not diagnose OCD, collect caregiver report, provide a full symptom profile, or generate treatment targets."
			}
		],
		"faqItems": [
			{
				"question": "What response choices does the youth see?",
				"answer": "The youth sees five frequency choices using never, sometimes, and always, corresponding to 0-2 scoring."
			},
			{
				"question": "What does the score range mean?",
				"answer": "The five item ratings are summed to a total score from 0 to 10, then compared with the supported threshold."
			},
			{
				"question": "Does exceeding the threshold mean the youth has OCD?",
				"answer": "No. Exceeding the threshold indicates that further diagnostic assessment is recommended."
			},
			{
				"question": "Can this replace a full OCD evaluation?",
				"answer": "No. It is a brief screen used to decide whether fuller assessment or referral is needed."
			}
		]
	},
	{
		"toolType": "ocChartObsessionAndCompulsionLogOcl",
		"slug": "oc-chart-obsession-and-compulsion-log-ocl",
		"title": "OC Chart Obsession Compulsion Log Demo | Qwoach",
		"metaDescription": "Explore an OC Chart demo for logging obsession-compulsion episodes with time, obsession, compulsion, duration, and clinician review for ERP planning.",
		"h1": "Obsession and Compulsion Log for ERP Preparation",
		"intro": "OC Chart / Obsession and Compulsion Log (OCL) is an OCD symptom sampling and self-monitoring log for ERP preparation. It helps clinicians assign a short sampling window so patients can record recent obsession-compulsion episodes with time, linked ritual response, and duration for clinician review.",
		"demoTitle": "Set a sample window, add fictional log rows, and review the chronological OCL table.",
		"demoPrompt": "Interested in using OC Chart / Obsession and Compulsion Log (OCL) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0059-f-002-ocd-006-r001-oc-chart-obsession-and-compulsion-log-ocl.md",
		"specId": "0059-f-002-ocd-006-r001-oc-chart-obsession-and-compulsion-log-ocl",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before or during ERP planning when real recent examples are needed to clarify obsessions, compulsions, and ritual burden."
			},
			{
				"title": "What It Captures",
				"body": "The log captures time, obsession, compulsion, and duration for each episode row."
			},
			{
				"title": "Limitations",
				"body": "The tool does not score severity, diagnose OCD, add unsupported fields, categorize symptoms automatically, or generate an ERP hierarchy."
			}
		],
		"faqItems": [
			{
				"question": "Does the OCL need to capture every episode?",
				"answer": "No. The product is designed for a clinically useful sample during an assigned window, not necessarily exhaustive long-term frequency measurement."
			},
			{
				"question": "What fields are included in each row?",
				"answer": "Each row includes time, obsession, compulsion, and duration."
			},
			{
				"question": "Can a partial log be reviewed?",
				"answer": "Yes. Partial logs can be submitted if allowed and are flagged so the clinician can decide whether the sample is sufficient."
			},
			{
				"question": "Does the tool create ERP targets automatically?",
				"answer": "No. The clinician uses the logged examples clinically; the product does not generate ERP targets or case formulation."
			}
		]
	},
	{
		"toolType": "familyAccommodationScaleForObsessiveCompulsiveDisorderInterviewerRatedVersionFasIr",
		"slug": "family-accommodation-scale-for-obsessive-compulsive-disorder-interviewer-rated-version-fas-ir",
		"title": "FAS-IR OCD Family Accommodation Demo | Qwoach",
		"metaDescription": "Explore the FAS-IR demo for clinician-administered family accommodation interview, 0-4 ratings, total score, and monitoring review.",
		"h1": "Family Accommodation Scale for OCD Interviewer-Rated Demo",
		"intro": "Family Accommodation Scale for Obsessive-Compulsive Disorder - Interviewer-Rated Version (FAS-IR) is a clinician-administered semi-structured family accommodation interview for adult OCD. It helps clinicians interview a family member or significant other, rate accommodation behaviors on 0-4 scales, calculate a total accommodation score, and monitor change over time.",
		"demoTitle": "Start a sample FAS-IR interview, rate accommodation items, and review the score profile.",
		"demoPrompt": "Interested in using Family Accommodation Scale for Obsessive-Compulsive Disorder - Interviewer-Rated Version (FAS-IR) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0060-f-002-ocd-007-r001-family-accommodation-scale-for-obsessive-compulsive-disorder-interviewer-rated-version-fas-ir.md",
		"specId": "0060-f-002-ocd-007-r001-family-accommodation-scale-for-obsessive-compulsive-disorder-interviewer-rated-version-fas-ir",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Family accommodation"
			],
			"population": [
				"Adults",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during adult OCD assessment, treatment planning, or monitoring when family accommodation behaviors need structured clinician rating."
			},
			{
				"title": "Roles",
				"body": "The clinician administers the interview and rates items. The family member or significant other provides report. The adult OCD patient is not the primary respondent for this configuration."
			},
			{
				"title": "Repeat Use",
				"body": "Baseline and follow-up FAS-IR administrations can be compared descriptively, with respondent relationship visible so comparisons are not overread."
			},
			{
				"title": "Limitations",
				"body": "The tool does not diagnose OCD, score patient OCD severity, infer blame, generate family therapy instructions, or create an ERP plan automatically."
			}
		],
		"faqItems": [
			{
				"question": "Who is interviewed in the FAS-IR?",
				"answer": "A family member or significant other is interviewed by the clinician about the adult OCD patient's symptoms and accommodation behaviors."
			},
			{
				"question": "Is FAS-IR a self-report form?",
				"answer": "No. This configuration is interviewer-rated and clinician-administered."
			},
			{
				"question": "What scores does the tool show?",
				"answer": "It shows item-level accommodation ratings and a total family-accommodation score when scoring requirements are met."
			},
			{
				"question": "Can multiple family members be included?",
				"answer": "Yes, but separate respondent records should be stored unless the instrument materials define another approach."
			},
			{
				"question": "Does the tool assign blame to family members?",
				"answer": "No. It records accommodation behaviors for clinical assessment and monitoring without moral judgment or causality claims."
			}
		]
	},
	{
		"toolType": "familyAccommodationScaleForObsessiveCompulsiveDisorderSelfRatedVersionFasSr",
		"slug": "family-accommodation-scale-for-obsessive-compulsive-disorder-self-rated-version-fas-sr",
		"title": "FAS-SR OCD Family Accommodation Self-Report | Qwoach",
		"metaDescription": "Explore the FAS-SR demo for OCD care: send a family-member self-report, review accommodation item responses, total score, and history.",
		"h1": "Family Accommodation Scale for OCD - Self-Rated Version",
		"intro": "The FAS-SR is a self-report questionnaire for relatives or significant others in OCD cases. Clinicians and researchers use it to quantify accommodation behaviors and review item-level patterns with a summed total severity score.",
		"demoTitle": "Explore the demo assignment and review a sample completed result.",
		"demoPrompt": "Interested in using Family Accommodation Scale for Obsessive-Compulsive Disorder - Self-Rated Version (FAS-SR) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0061-f-002-ocd-007-r002-family-accommodation-scale-for-obsessive-compulsive-disorder-self-rated-version-fas-sr.md",
		"specId": "0061-f-002-ocd-007-r002-family-accommodation-scale-for-obsessive-compulsive-disorder-self-rated-version-fas-sr",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Family accommodation"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "FAS-SR is used when a practitioner or researcher wants a family-member self-report of accommodation in an OCD case with less administration burden than a clinician interview."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the relative's own report of accommodation behaviors and preserves both item-level responses and the total accommodation severity score."
			},
			{
				"title": "Repeat Use",
				"body": "Completed results are stored as dated assessment points so the same respondent type can be compared over time when prior FAS-SR results exist."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate diagnostic conclusions, unsupported subscales, treatment recommendations, family conflict judgments, or clinician-rated FAS-IR data."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the FAS-SR?",
				"answer": "A relative or significant other completes the FAS-SR as a self-report about their own accommodation behaviors related to the person with OCD."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews completion status, item responses, total FAS-SR score, respondent relation, date, and longitudinal comparison when prior completed results exist."
			},
			{
				"question": "Can the practitioner change the scoring?",
				"answer": "No. Scoring, item content, response options, and interpretation settings are not practitioner-configurable."
			},
			{
				"question": "Are partial responses scored?",
				"answer": "No. Partial responses can be saved as incomplete, but a final total score is not shown until required scored items are complete."
			}
		]
	},
	{
		"toolType": "familyAccommodationScaleForObsessiveCompulsiveDisorderPatientVersionFasPv",
		"slug": "family-accommodation-scale-for-obsessive-compulsive-disorder-patient-version-fas-pv",
		"title": "FAS-PV Patient-Reported Family Accommodation | Qwoach",
		"metaDescription": "Explore FAS-PV for OCD care: collect a patient report of relatives' accommodation behaviors and review total score, item or factor profile.",
		"h1": "Family Accommodation Scale for OCD - Patient Version",
		"intro": "The FAS-PV is a patient-report questionnaire for adult OCD care. Practitioners use it when relatives are unavailable or when the patient's perspective is needed to describe relatives' accommodation behaviors and severity.",
		"demoTitle": "Explore the patient assignment and review a sample FAS-PV result.",
		"demoPrompt": "Interested in using Family Accommodation Scale for Obsessive-Compulsive Disorder - Patient Version (FAS-PV) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0062-f-002-ocd-007-r003-family-accommodation-scale-for-obsessive-compulsive-disorder-patient-version-fas-pv.md",
		"specId": "0062-f-002-ocd-007-r003-family-accommodation-scale-for-obsessive-compulsive-disorder-patient-version-fas-pv",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Family accommodation"
			],
			"population": [
				"Adults",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use FAS-PV when adult OCD patients present without relatives or when the patient's view of relatives' accommodation is clinically useful."
			},
			{
				"title": "Perspective Handling",
				"body": "The result remains clearly patient-reported. If family-member data exist, the product can show perspective comparison without merging the reports into a single truth."
			},
			{
				"title": "Repeat Use",
				"body": "Completed FAS-PV results persist as dated assessment points for monitoring over time."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not independently verify relative behavior, judge relatives' motives, generate family diagnoses, or create treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the FAS-PV?",
				"answer": "The adult OCD patient completes the FAS-PV by rating relatives' or significant others' accommodation behaviors."
			},
			{
				"question": "Can it be used when relatives are unavailable?",
				"answer": "Yes. The tool is designed for patient report, so relatives do not need to complete the measure."
			},
			{
				"question": "Can patient and family reports be compared?",
				"answer": "Yes, when other informant measures are available, the review can show separate perspective comparison without merging the reports."
			},
			{
				"question": "Are partial questionnaires scored?",
				"answer": "No. Partial FAS-PV responses remain incomplete and are not treated as final scored results."
			}
		]
	},
	{
		"toolType": "familyAccommodationScaleParentReportFasPr",
		"slug": "family-accommodation-scale-parent-report-fas-pr",
		"title": "FAS-PR Pediatric OCD Parent Report Demo | Qwoach",
		"metaDescription": "Explore FAS-PR for pediatric OCD: send a parent accommodation questionnaire and review total score, supported subscales, and item profile.",
		"h1": "Family Accommodation Scale - Parent Report",
		"intro": "FAS-PR is a parent-report questionnaire for pediatric OCD care and research. Practitioners use it to quantify how a parent accommodates a child's rituals and avoidance and to review total and supported subscale patterns.",
		"demoTitle": "Explore the parent assignment and sample FAS-PR review.",
		"demoPrompt": "Interested in using Family Accommodation Scale - Parent Report (FAS-PR) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0063-f-002-ocd-007-r004-family-accommodation-scale-parent-report-fas-pr.md",
		"specId": "0063-f-002-ocd-007-r004-family-accommodation-scale-parent-report-fas-pr",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Family accommodation"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "FAS-PR is used during pediatric OCD intake, research assessment, treatment planning, or monitoring when parent accommodation is clinically relevant."
			},
			{
				"title": "Multiple Caregivers",
				"body": "Caregiver results remain separate unless validated scoring rules define combining them."
			},
			{
				"title": "Version Context",
				"body": "If 12- and 13-item variants are supported, each administration keeps its item-version context so historical comparisons are not silently distorted."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide child diagnosis conclusions, unsupported thresholds, parent-blame language, or invented clinical recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the FAS-PR?",
				"answer": "A parent or caregiver completes the FAS-PR by rating their accommodation of the child's OCD-related rituals and avoidance."
			},
			{
				"question": "What scores are shown?",
				"answer": "The review shows a total score and supported subscale scores, with item responses and caregiver attribution."
			},
			{
				"question": "Can multiple caregivers complete it?",
				"answer": "Yes, multiple caregiver results can be collected, but they remain separate unless validated scoring rules specify combining them."
			},
			{
				"question": "Can partial responses be reviewed as final?",
				"answer": "No. Partial records show incomplete status and are not final scored results."
			}
		]
	},
	{
		"toolType": "ocdFamilyFunctioningOffScale",
		"slug": "ocd-family-functioning-off-scale",
		"title": "OFF Scale OCD Family Functioning Demo | Qwoach",
		"metaDescription": "Explore the OFF Scale demo for OCD care: assign patient or relative versions, review family-functioning scores, domains, and perspectives.",
		"h1": "OCD Family Functioning (OFF) Scale",
		"intro": "The OCD Family Functioning Scale is a self-report assessment for OCD patients and relatives. Practitioners and researchers use it to quantify family-functioning impairment, review affected domains, and compare perspectives when multiple respondents participate.",
		"demoTitle": "Choose respondent versions and review a sample OFF Scale profile.",
		"demoPrompt": "Interested in using OCD Family Functioning (OFF) Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0064-f-002-ocd-009-r001-ocd-family-functioning-off-scale.md",
		"specId": "0064-f-002-ocd-009-r001-ocd-family-functioning-off-scale",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Patient And Relative Versions",
				"body": "The OFF Scale supports patient and relative perspectives. Each completed perspective remains distinct in review."
			},
			{
				"title": "What It Measures",
				"body": "The scale assesses OCD-related family-functioning impairment across routines, roles, emotional impact, symptom-specific impairment, and functional domains supported by the scale."
			},
			{
				"title": "Single-Perspective Use",
				"body": "If only one respondent completes the scale, the result remains valid as a single-perspective result and comparison is marked unavailable."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create a family diagnosis, rank one perspective as true, invent domains, or generate intervention prescriptions."
			}
		],
		"faqItems": [
			{
				"question": "Can the OFF Scale be assigned to both patient and relative?",
				"answer": "Yes. The practitioner can assign patient and relative versions and compare completed perspectives side by side."
			},
			{
				"question": "What happens if only one person completes it?",
				"answer": "A single-perspective result is shown with clear respondent labeling, and comparison remains unavailable until another perspective is complete."
			},
			{
				"question": "Does the tool merge family perspectives?",
				"answer": "No. Patient and relative reports remain separate unless validated scale scoring defines a merged score."
			},
			{
				"question": "Are part-specific scoring rules configurable?",
				"answer": "No. The tool applies the defined scoring mechanics for each OFF Scale part; scoring is not a practitioner setting."
			}
		]
	},
	{
		"toolType": "obsessiveCompulsiveDisorderOcdFormulation",
		"slug": "obsessive-compulsive-disorder-ocd-formulation",
		"title": "OCD Formulation Worksheet Demo for CBT and ERP | Qwoach",
		"metaDescription": "Explore a collaborative OCD formulation demo: map intrusive thoughts, appraisals, emotions, and compulsive responses into a maintenance model.",
		"h1": "Obsessive Compulsive Disorder (OCD) Formulation",
		"intro": "Obsessive Compulsive Disorder (OCD) Formulation is a collaborative worksheet for therapists and clients in OCD-focused CBT or ERP. It helps them build a visual maintenance model linking intrusive thoughts or obsessions, meanings, emotions, and compulsive or safety behaviors.",
		"demoTitle": "Open the demo formulation and add sample client examples.",
		"demoPrompt": "Interested in using Obsessive Compulsive Disorder (OCD) Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0065-f-002-ocd-011-r001-obsessive-compulsive-disorder-ocd-formulation.md",
		"specId": "0065-f-002-ocd-011-r001-obsessive-compulsive-disorder-ocd-formulation",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the formulation early in OCD-focused CBT or ERP and revisit it as treatment reveals new information."
			},
			{
				"title": "What It Produces",
				"body": "The output is a visual shared maintenance model linking obsessions or intrusive thoughts, appraisals, emotions, and compulsive or safety behaviors."
			},
			{
				"title": "Revision Over Time",
				"body": "Partial formulations can be saved in progress, and dated updates preserve how the shared understanding changes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not produce severity scores, diagnostic conclusions, risk determinations, automated intervention prescriptions, or generic formulation fields beyond the supported structure."
			}
		],
		"faqItems": [
			{
				"question": "Is this a scored OCD measure?",
				"answer": "No. The OCD Formulation tool produces a visual maintenance model, not a score."
			},
			{
				"question": "Who completes it?",
				"answer": "The therapist and client complete it collaboratively, usually early in OCD-focused CBT or ERP."
			},
			{
				"question": "Can the formulation be incomplete?",
				"answer": "Yes. A partial formulation can be saved in progress, with missing core areas visible rather than auto-filled."
			},
			{
				"question": "Does it generate ERP targets?",
				"answer": "No. It can help the therapist choose interventions, but it does not automatically generate ERP targets or treatment steps."
			}
		]
	},
	{
		"toolType": "ocd5AreasFormulationBlank",
		"slug": "ocd-5-areas-formulation-blank",
		"title": "OCD 5 Areas Formulation Worksheet Demo | Qwoach",
		"metaDescription": "Explore a youth OCD 5 Areas Formulation demo: map situations, thoughts, emotions, body sensations, and behaviors into a CBT cycle.",
		"h1": "OCD 5 Areas Formulation (Blank)",
		"intro": "OCD 5 Areas Formulation (Blank) is a collaborative worksheet for practitioners and young people with OCD. It helps organize situations, thoughts, emotions, physical sensations, and behaviors or compulsions into a recognizable CBT maintenance pattern.",
		"demoTitle": "Open the blank demo worksheet and add sample youth-friendly entries.",
		"demoPrompt": "Interested in using OCD 5 Areas Formulation (Blank) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0066-f-002-ocd-011-r002-ocd-5-areas-formulation-blank.md",
		"specId": "0066-f-002-ocd-011-r002-ocd-5-areas-formulation-blank",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Behavior analysis"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it in early sessions with a young person when OCD experiences need to be organized into a clear CBT pattern."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures the young person's own situations, thoughts or obsessions, emotions, body sensations, and behaviors or compulsions."
			},
			{
				"title": "Updating The Formulation",
				"body": "Incomplete work can remain in progress, and later dated updates can show how the formulation changes over time."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not score symptoms, generate diagnoses, create treatment steps, or become a generic worksheet builder."
			}
		],
		"faqItems": [
			{
				"question": "Is this tool designed for young people?",
				"answer": "Yes. It is a youth-oriented OCD formulation worksheet intended to make the CBT cycle accessible for a young person."
			},
			{
				"question": "Does it include scoring?",
				"answer": "No. The tool creates a visual formulation and does not produce a score or severity threshold."
			},
			{
				"question": "Can sections be left blank?",
				"answer": "Yes. Blank or tentative areas can remain visibly incomplete rather than being filled automatically."
			},
			{
				"question": "Can caregivers contribute?",
				"answer": "Caregiver input can be labeled separately if captured, but the primary formulation remains the young person's OCD cycle."
			}
		]
	},
	{
		"toolType": "erpForOcdCaseFormulation",
		"slug": "erp-for-ocd-case-formulation",
		"title": "ERP for OCD Case Formulation Demo | Qwoach",
		"metaDescription": "Explore an ERP case formulation demo: organize obsessions, compulsions or secondary avoidance, primary avoidance, and goals before exposure planning.",
		"h1": "ERP for OCD Case Formulation",
		"intro": "ERP for OCD Case Formulation is a collaborative form for ERP practitioners and clients. It helps organize obsessions, compulsions or secondary avoidance, primary avoidance, and goals or objectives into a structured formulation for ERP planning.",
		"demoTitle": "Open the demo form and complete sample ERP formulation sections.",
		"demoPrompt": "Interested in using ERP for OCD Case Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0067-f-002-ocd-011-r003-erp-for-ocd-case-formulation.md",
		"specId": "0067-f-002-ocd-011-r003-erp-for-ocd-case-formulation",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Behavior analysis",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during ERP assessment and formulation, before building an exposure hierarchy or response-prevention plan."
			},
			{
				"title": "What It Organizes",
				"body": "The form organizes obsessions, compulsions or secondary avoidance, primary avoidance, and goals/objectives."
			},
			{
				"title": "Draft State",
				"body": "Incomplete formulations can remain drafts with unresolved sections clearly visible."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create exposure rankings, SUDS trajectories, treatment schedules, diagnosis, or automated ERP tasks."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as an exposure hierarchy?",
				"answer": "No. This is a formulation form used before exposure hierarchy construction."
			},
			{
				"question": "Can goals be left open?",
				"answer": "Yes. Goals or objectives can remain unresolved until treatment planning advances."
			},
			{
				"question": "Does the tool classify unclear avoidance automatically?",
				"answer": "No. Unclear avoidance can remain tentative or unresolved; the system does not classify it automatically."
			},
			{
				"question": "Who completes the form?",
				"answer": "The practitioner completes it collaboratively with the client during ERP assessment and formulation."
			}
		]
	},
	{
		"toolType": "exposureHierarchy",
		"slug": "exposure-hierarchy",
		"title": "OCD ERP Exposure Hierarchy Demo | Qwoach",
		"metaDescription": "Explore an Exposure Hierarchy demo for ERP: add feared targets, rate SUDS or difficulty, order a ladder, and note response prevention.",
		"h1": "Exposure Hierarchy",
		"intro": "Exposure Hierarchy is a collaborative planning tool for therapists and clients in OCD ERP. It helps list feared situations, thoughts, images, objects, or stimuli, rate anticipated distress or difficulty, and order targets into a graduated exposure sequence.",
		"demoTitle": "Add sample targets and build a demo hierarchy.",
		"demoPrompt": "Interested in using Exposure Hierarchy with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0068-f-002-ocd-012-r001-exposure-hierarchy.md",
		"specId": "0068-f-002-ocd-012-r001-exposure-hierarchy",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the hierarchy after assessment and before selecting ERP practice targets."
			},
			{
				"title": "Manual Ordering",
				"body": "The practitioner can override numeric sort because sequencing may reflect readiness, context, or treatment planning, not rating alone."
			},
			{
				"title": "Draft And Final States",
				"body": "Unrated targets can be saved in draft, but the hierarchy cannot be marked ready until required ratings are present."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate exposure ideas, infer readiness automatically, track SUDS during practice, or score treatment outcome."
			}
		],
		"faqItems": [
			{
				"question": "What information does each exposure target need?",
				"answer": "Each ready target needs at least a description and a valid distress or difficulty rating; response-prevention notes can be added when needed."
			},
			{
				"question": "Can the therapist reorder items manually?",
				"answer": "Yes. The therapist can manually order items so clinical sequencing remains explicit alongside ratings."
			},
			{
				"question": "Can unrated targets be saved?",
				"answer": "Yes. Unrated targets can remain in draft but are not included in a finalized ranked sequence."
			},
			{
				"question": "Does the hierarchy generate exposure tasks?",
				"answer": "No. The tool organizes client-specific targets entered by the therapist and client; it does not invent exposure content."
			}
		]
	},
	{
		"toolType": "subjectiveUnitsOfDistressScaleSuds",
		"slug": "subjective-units-of-distress-scale-suds",
		"title": "SUDS Rating Demo for ERP and Exposure Therapy | Qwoach",
		"metaDescription": "Explore a SUDS demo for ERP: capture current distress ratings, link them to an exposure, and review trajectory, peak, and change.",
		"h1": "Subjective Units of Distress Scale (SUDS)",
		"intro": "Subjective Units of Distress Scale (SUDS) is a single-item rating tool for clients in exposure therapy or ERP. Practitioners use it to capture current subjective anxiety or distress before, during, or after exposure practice and review change over time.",
		"demoTitle": "Start a demo exposure and enter sample SUDS ratings.",
		"demoPrompt": "Interested in using Subjective Units of Distress Scale (SUDS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0069-f-002-ocd-013-r001-subjective-units-of-distress-scale-suds.md",
		"specId": "0069-f-002-ocd-013-r001-subjective-units-of-distress-scale-suds",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "SUDS is used before, during, or after exposure practice to capture current subjective anxiety or distress."
			},
			{
				"title": "Repeated Ratings",
				"body": "A single rating can stand alone as momentary data; repeated ratings create the trajectory needed for exposure review."
			},
			{
				"title": "Multiple Exposures",
				"body": "Separate exposures in one session should have separate SUDS series linked to their own contexts."
			},
			{
				"title": "Important Limits",
				"body": "SUDS is not an objective anxiety measure, diagnostic score, exposure hierarchy, or automatic treatment outcome interpretation."
			}
		],
		"faqItems": [
			{
				"question": "What does a SUDS rating represent?",
				"answer": "A SUDS rating represents the client's current subjective distress or anxiety at that moment."
			},
			{
				"question": "Can one exposure have multiple SUDS ratings?",
				"answer": "Yes. Repeated ratings form a trajectory across the exposure exercise."
			},
			{
				"question": "What happens if a rating is missed?",
				"answer": "A missed rating remains a gap; the system does not interpolate a value."
			},
			{
				"question": "Does SUDS decide whether exposure worked?",
				"answer": "No. The tool shows reported ratings and descriptive changes but does not conclude that exposure succeeded or failed."
			}
		]
	},
	{
		"toolType": "inhibitoryLearningExposureWorksheet",
		"slug": "inhibitory-learning-exposure-worksheet",
		"title": "Inhibitory Learning Exposure Worksheet Demo | Qwoach",
		"metaDescription": "Explore an inhibitory learning exposure demo: record feared predictions, exposure conditions, actual outcome, discrepancy, and learning.",
		"h1": "Inhibitory Learning Exposure Worksheet",
		"intro": "The Inhibitory Learning Exposure Worksheet is a two-phase worksheet for exposure therapy or ERP. Practitioners and clients use it to specify a feared outcome before exposure, compare it with what actually happened, and record the learning takeaway.",
		"demoTitle": "Start a demo prediction and outcome review.",
		"demoPrompt": "Interested in using Inhibitory Learning Exposure Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0070-f-002-ocd-014-r001-inhibitory-learning-exposure-worksheet.md",
		"specId": "0070-f-002-ocd-014-r001-inhibitory-learning-exposure-worksheet",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when exposure practice is framed as testing a feared prediction and consolidating learning from the prediction-outcome gap."
			},
			{
				"title": "Two-Phase Structure",
				"body": "Pre-exposure fields are completed before practice; post-exposure fields are completed after practice."
			},
			{
				"title": "Incomplete Exposure",
				"body": "If the exposure is not completed, the pre-exposure plan remains incomplete and the tool does not request outcome conclusions."
			},
			{
				"title": "Important Limits",
				"body": "The worksheet does not rank exposures, track SUDS, generate feared outcomes, infer therapeutic success, or create learning statements automatically."
			}
		],
		"faqItems": [
			{
				"question": "What is the main output of the worksheet?",
				"answer": "The main output is a prediction-versus-outcome exposure record with a learning statement."
			},
			{
				"question": "Can the post-exposure section be completed first?",
				"answer": "No. The worksheet requires the pre-exposure prediction structure before outcome review."
			},
			{
				"question": "What happens if safety behaviors were used?",
				"answer": "Safety behaviors are recorded descriptively for practitioner review; the system does not automatically classify the exposure as invalid."
			},
			{
				"question": "Does the worksheet create the next exposure?",
				"answer": "No. It can inform future exposure design, but it does not generate or rank new exposure tasks."
			}
		]
	},
	{
		"toolType": "expectancyExposureWorksheet",
		"slug": "expectancy-exposure-worksheet",
		"title": "Expectancy Exposure Worksheet for OCD ERP | Qwoach",
		"metaDescription": "Assign OCD ERP homework that records feared expectations, likelihood, actual exposure outcomes, tolerance notes, and learning for review.",
		"h1": "Expectancy Exposure Worksheet",
		"intro": "The Expectancy Exposure Worksheet is an OCD ERP homework worksheet for clinicians assigning exposure with response prevention. It helps the practitioner and client record the feared consequence, the client's 0-100 likelihood estimate, the actual outcome, and the learning statement for later review.",
		"demoTitle": "Explore a sample worksheet assignment",
		"demoPrompt": "Interested in using Expectancy Exposure Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0071-f-002-ocd-014-r002-expectancy-exposure-worksheet.md",
		"specId": "0071-f-002-ocd-014-r002-expectancy-exposure-worksheet",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it around a specific OCD ERP homework assignment when the practitioner wants the client's feared outcome prediction recorded before exposure and the actual outcome recorded afterward."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not prescribe exposures, diagnose OCD, score severity, or label the discrepancy with clinical meaning. Practitioner review remains separate from the worksheet result."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general exposure log?",
				"answer": "No. It is an expectancy comparison worksheet for OCD ERP homework, centered on predicted feared consequence, likelihood, actual outcome, and learning."
			},
			{
				"question": "Can the likelihood scale be changed?",
				"answer": "No. The worksheet uses a fixed 0-100 likelihood rating because that is part of the supported mechanic."
			},
			{
				"question": "What happens if the client only completes the pre-exposure section?",
				"answer": "The worksheet remains a prediction record. It should not imply that an expectancy comparison has occurred until post-exposure outcome and learning are entered."
			},
			{
				"question": "Does the result interpret whether the client's OCD appraisal was false?",
				"answer": "No. The result shows the reported prediction and outcome side by side; interpretation belongs to practitioner review."
			}
		]
	},
	{
		"toolType": "yaleBrownObsessiveCompulsiveScaleSymptomChecklistYBocsSc",
		"slug": "yale-brown-obsessive-compulsive-scale-symptom-checklist-y-bocs-sc",
		"title": "Y-BOCS-SC Symptom Checklist for OCD Planning | Qwoach",
		"metaDescription": "Review current and past OCD symptom endorsements with a patient and select target symptoms for Y-BOCS severity rating or ERP planning.",
		"h1": "Yale-Brown Obsessive Compulsive Scale Symptom Checklist",
		"intro": "The Y-BOCS-SC is a clinician-reviewed OCD symptom checklist for practitioners assessing OCD or planning ERP. It helps the clinician and patient identify current and past obsessions and compulsions, clarify endorsements, and select target symptoms for treatment focus or severity rating.",
		"demoTitle": "Explore the checklist review",
		"demoPrompt": "Interested in using Yale-Brown Obsessive Compulsive Scale Symptom Checklist (Y-BOCS-SC) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0072-f-002-ocd-015-r001-yale-brown-obsessive-compulsive-scale-symptom-checklist-y-bocs-sc.md",
		"specId": "0072-f-002-ocd-015-r001-yale-brown-obsessive-compulsive-scale-symptom-checklist-y-bocs-sc",
		"tags": {
			"framework": [],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"OCD"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Patient Roles",
				"body": "The patient provides symptom endorsements. The practitioner controls clinical review, clarification, and final target-symptom selection."
			},
			{
				"title": "Result Boundaries",
				"body": "The checklist supports target selection and severity-rating preparation, but it does not diagnose OCD, generate treatment recommendations, or add unsupported severity scores inside the checklist itself."
			}
		],
		"faqItems": [
			{
				"question": "Is the Y-BOCS-SC a diagnosis by itself?",
				"answer": "No. The checklist organizes current and past OCD symptom endorsements for clinician review and target selection; it does not diagnose OCD by itself."
			},
			{
				"question": "Can targets be selected from symptoms the patient did not endorse?",
				"answer": "Not by default. Target selection should come from endorsed symptoms unless the practitioner intentionally adds and confirms clarification during review."
			},
			{
				"question": "Does the checklist include severity scoring?",
				"answer": "No unsupported severity score is added inside the checklist. The selected targets can support Y-BOCS severity rating or treatment focus decisions."
			},
			{
				"question": "Can historical checklists be compared?",
				"answer": "Yes, historical inventories can be compared descriptively for changes in endorsements or selected targets when the same checklist structure is used."
			}
		]
	},
	{
		"toolType": "floridaObsessiveCompulsiveInventoryFoci",
		"slug": "florida-obsessive-compulsive-inventory-foci",
		"title": "FOCI OCD Symptom and Severity Measure | Qwoach",
		"metaDescription": "Send a brief OCD self-report measure with a symptom checklist and severity scale for intake, screening, assessment, or monitoring.",
		"h1": "Florida Obsessive-Compulsive Inventory",
		"intro": "The Florida Obsessive-Compulsive Inventory is a brief OCD self-report measure for clinicians using intake, screening, assessment, or monitoring workflows. It helps the practitioner see which common obsessions and compulsions are endorsed and how the client rates overall severity.",
		"demoTitle": "Try the two-part measure",
		"demoPrompt": "Interested in using Florida Obsessive-Compulsive Inventory (FOCI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0073-f-002-ocd-015-r002-florida-obsessive-compulsive-inventory-foci.md",
		"specId": "0073-f-002-ocd-015-r002-florida-obsessive-compulsive-inventory-foci",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Repeated Use",
				"body": "When FOCI is repeated with the same measure structure, the product can show descriptive changes in endorsed symptoms and scores across administrations."
			},
			{
				"title": "Measure Boundaries",
				"body": "FOCI does not diagnose OCD, generate an ERP hierarchy, or add unsupported severity labels. Results require practitioner review."
			}
		],
		"faqItems": [
			{
				"question": "Can I customize the FOCI items?",
				"answer": "No. The checklist and severity items are fixed because changing them would make the result less comparable and no longer represent the same measure."
			},
			{
				"question": "When are scores shown?",
				"answer": "Scores are shown only when required checklist and severity responses are complete. Missing responses keep the administration incomplete."
			},
			{
				"question": "Can this be used for monitoring?",
				"answer": "Yes. Repeated administrations can be compared descriptively when they use the same measure structure."
			},
			{
				"question": "Does FOCI create treatment targets automatically?",
				"answer": "No. It identifies endorsed symptom areas and severity responses; the practitioner decides assessment focus or treatment priorities."
			}
		]
	},
	{
		"toolType": "ocChart",
		"slug": "oc-chart",
		"title": "OC Chart for OCD Obsession and Compulsion Samples | Qwoach",
		"metaDescription": "Collect daily-life examples of obsessions and compulsions during a short observation period for ERP case review or early planning.",
		"h1": "OC Chart",
		"intro": "The OC Chart is an OCD self-monitoring log for ERP practitioners preparing case review or early treatment planning. It helps the practitioner gather a brief sample of the client's daily-life obsessions and compulsions without treating the entries as a frequency estimate.",
		"demoTitle": "Explore a sample observation chart",
		"demoPrompt": "Interested in using OC Chart with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0074-f-002-ocd-015-r003-oc-chart.md",
		"specId": "0074-f-002-ocd-015-r003-oc-chart",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Intervention planning"
			],
			"topic": [
				"OCD"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Sampling, Not Frequency",
				"body": "The chart is designed to collect examples. A small number of entries should not be presented as low symptom frequency, and many entries should not be converted into a severity score."
			},
			{
				"title": "Use In Planning",
				"body": "The practitioner reviews entries to identify possible response-prevention targets and clarify how symptoms appear in daily life."
			}
		],
		"faqItems": [
			{
				"question": "Does the OC Chart estimate symptom frequency?",
				"answer": "No. The OC Chart collects an illustrative sample of obsessions and compulsions, not a frequency estimate."
			},
			{
				"question": "What does each entry need?",
				"answer": "Each entry should contain enough content to distinguish an obsession example from a compulsion example when both are known."
			},
			{
				"question": "Can incomplete entries be saved?",
				"answer": "Yes. Incomplete entries can be preserved, and the chart should show whether it is still in progress."
			},
			{
				"question": "Does the chart rank ERP targets?",
				"answer": "No. The chart provides examples for practitioner review; it does not automatically rank targets or create an exposure hierarchy."
			}
		]
	},
	{
		"toolType": "behavioralAvoidanceTestForObsessiveCompulsiveDisorder",
		"slug": "behavioral-avoidance-test-for-obsessive-compulsive-disorder",
		"title": "Behavioral Avoidance Test for OCD Assessment | Qwoach",
		"metaDescription": "Create individualized OCD behavioral tasks, record graded step completion, avoidance, rituals, and SUDS, and compare pre/post assessments.",
		"h1": "Behavioral Avoidance Test for Obsessive Compulsive Disorder",
		"intro": "The Behavioral Avoidance Test for Obsessive Compulsive Disorder is a practitioner-guided behavioral assessment for OCD clinicians. It helps the practitioner define OCD-relevant situations, record graded step completion, avoidance, rituals, and SUDS, and compare behavioral data across assessment points.",
		"demoTitle": "Build a sample BAT record",
		"demoPrompt": "Interested in using Behavioral Avoidance Test for Obsessive Compulsive Disorder with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0075-f-002-ocd-016-r001-behavioral-avoidance-test-for-obsessive-compulsive-disorder.md",
		"specId": "0075-f-002-ocd-016-r001-behavioral-avoidance-test-for-obsessive-compulsive-disorder",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Comparable Repeats",
				"body": "Pre/post comparison is meaningful when the same task and step structure is repeated. Revised tasks should be shown as revised rather than silently compared as identical."
			},
			{
				"title": "Behavioral Data Boundaries",
				"body": "The BAT records task behavior and ratings. It does not choose clinically appropriate situations, diagnose, or infer progress beyond the recorded data."
			}
		],
		"faqItems": [
			{
				"question": "Is this a questionnaire?",
				"answer": "No. It is a behavioral approach test using individualized OCD-relevant tasks and graded steps."
			},
			{
				"question": "Can task steps change between baseline and follow-up?",
				"answer": "Yes, but comparisons should distinguish same-task repeats from revised tasks so the result remains interpretable."
			},
			{
				"question": "Are missing ratings inferred?",
				"answer": "No. Missing avoidance, ritual, or SUDS ratings remain missing rather than being filled automatically."
			},
			{
				"question": "Does the BAT choose exposure targets?",
				"answer": "No. The practitioner and client define tasks; the system records and summarizes the behavioral data."
			}
		]
	},
	{
		"toolType": "safetyBehaviorAssessmentForm",
		"slug": "safety-behavior-assessment-form",
		"title": "Safety Behavior Assessment Form for Exposure Planning | Qwoach",
		"metaDescription": "Identify client safety behavior patterns with frequency ratings, total score, and supported domain scores for assessment, planning, or monitoring.",
		"h1": "Safety Behavior Assessment Form",
		"intro": "The Safety Behavior Assessment Form is a self-report measure for practitioners working with anxiety-related avoidance and exposure planning. It helps the practitioner see how often a client reports safety behaviors overall and across supported domains such as vigilance, health, and social safety behaviors.",
		"demoTitle": "Explore the safety behavior profile",
		"demoPrompt": "Interested in using Safety Behavior Assessment Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0076-f-002-ocd-016-r002-safety-behavior-assessment-form.md",
		"specId": "0076-f-002-ocd-016-r002-safety-behavior-assessment-form",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Safety behaviors"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Safety Behavior Focus",
				"body": "The form identifies threat-reducing or avoidance-maintaining responses across anxiety-related situations. It should not be presented as an OCD-specific compulsion inventory unless interpreted separately by the practitioner."
			},
			{
				"title": "Monitoring",
				"body": "Repeated administrations can show descriptive change when the same form structure and scoring are used."
			}
		],
		"faqItems": [
			{
				"question": "Is this form OCD-specific?",
				"answer": "No. The form is safety-behavior focused across anxiety-related situations and should not be redefined as an OCD-specific compulsion inventory."
			},
			{
				"question": "Can the domains be customized?",
				"answer": "No. Items, domains, and scoring should remain fixed unless supported by the represented form source."
			},
			{
				"question": "Are scores shown if an item is skipped?",
				"answer": "No. Final total and domain scores should not be calculated until required responses are complete."
			},
			{
				"question": "Does the form recommend which safety behaviors to drop?",
				"answer": "No. It shows reported patterns; the practitioner decides which behaviors matter for exposure work."
			}
		]
	},
	{
		"toolType": "avoidanceHierarchy",
		"slug": "avoidance-hierarchy",
		"title": "Avoidance Hierarchy Worksheet for ERP Planning | Qwoach",
		"metaDescription": "Create a ranked exposure ladder by listing avoided situations, rating anticipated distress, and ordering items from least to most challenging.",
		"h1": "Avoidance Hierarchy",
		"intro": "The Avoidance Hierarchy is a CBT/ERP worksheet for practitioners planning graded exposure with a client. It helps the practitioner and client list feared or avoided places, situations, or stimuli, rate anticipated distress, and order items from least to most challenging.",
		"demoTitle": "Build a sample hierarchy",
		"demoPrompt": "Interested in using Avoidance Hierarchy with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0077-f-002-ocd-016-r003-avoidance-hierarchy.md",
		"specId": "0077-f-002-ocd-016-r003-avoidance-hierarchy",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"OCD"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Ordering And Clinical Review",
				"body": "The system can sort by rating, but the practitioner can confirm sequence collaboratively when clinical sequencing differs from numeric order."
			},
			{
				"title": "What It Does Not Track",
				"body": "The hierarchy does not record exposure completion, actual distress during exposure, response-prevention adherence, or treatment progress."
			}
		],
		"faqItems": [
			{
				"question": "Is this an exposure log?",
				"answer": "No. It is a planning worksheet for ranking avoided situations before exposure work."
			},
			{
				"question": "Can items have the same rating?",
				"answer": "Yes. Ties can remain visible, and the practitioner can confirm the sequence collaboratively."
			},
			{
				"question": "What happens to items without ratings?",
				"answer": "Items without ratings remain draft or unranked until a distress rating is added."
			},
			{
				"question": "Does the hierarchy generate exposure instructions?",
				"answer": "No. It organizes avoided situations into a ladder; the practitioner decides how to use it in treatment."
			}
		]
	},
	{
		"toolType": "therapistExposureRecordingForm",
		"slug": "therapist-exposure-recording-form",
		"title": "Therapist Exposure Recording Form for In-Session ERP | Qwoach",
		"metaDescription": "Record an in-session OCD ERP exposure with target, response-prevention expectations, repeated SUDS, comments, difficulties, and learning.",
		"h1": "Therapist Exposure Recording Form",
		"intro": "The Therapist Exposure Recording Form is a practitioner-only in-session OCD EX/RP record. It helps clinicians document the exposure target, response-prevention expectations, repeated SUDS ratings, comments, difficulties, and post-exposure learning during a clinician-guided exposure.",
		"demoTitle": "Start a sample exposure record",
		"demoPrompt": "Interested in using Therapist Exposure Recording Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0078-f-002-ocd-017-r001-therapist-exposure-recording-form.md",
		"specId": "0078-f-002-ocd-017-r001-therapist-exposure-recording-form",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"OCD"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Operation",
				"body": "The practitioner controls the record during the session. The client contributes subjective SUDS and behavioral participation but does not manage the scoring or note interface."
			},
			{
				"title": "Trajectory Boundaries",
				"body": "The form can show start, end, minimum, maximum, and interval SUDS descriptively where ratings support it, but it does not interpret habituation, learning strength, or the next clinical step."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client form for this tool?",
				"answer": "No. The primary product experience is practitioner-only during in-session ERP."
			},
			{
				"question": "Can SUDS be entered manually?",
				"answer": "Yes. Manual entry is supported when fixed intervals are not practical during a live exposure."
			},
			{
				"question": "What happens if an interval is missed?",
				"answer": "A missed interval appears as a gap rather than being interpolated."
			},
			{
				"question": "Does the form decide the next ERP step?",
				"answer": "No. It records the exposure and learning; the practitioner decides what to adjust next."
			}
		]
	},
	{
		"toolType": "exposureHomeworkRecordingForm",
		"slug": "exposure-homework-recording-form",
		"title": "Exposure Homework Recording Form for OCD ERP | Qwoach",
		"metaDescription": "Assign real-world OCD ERP homework and review practice dates, SUDS ratings, time spent, comments, and difficulties between sessions.",
		"h1": "Exposure Homework Recording Form",
		"intro": "The Exposure Homework Recording Form is a client homework log for OCD clinicians assigning real-world EX/RP practice. It helps the practitioner review practice dates, SUDS ratings over time, time spent, comments, and difficulties from between-session exposure work.",
		"demoTitle": "Explore a sample homework log",
		"demoPrompt": "Interested in using Exposure Homework Recording Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0079-f-002-ocd-017-r002-exposure-homework-recording-form.md",
		"specId": "0079-f-002-ocd-017-r002-exposure-homework-recording-form",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One Assigned Situation Per Log",
				"body": "Each assigned exposure situation should remain its own log unless the represented form explicitly combines multiple exposures."
			},
			{
				"title": "Partial And Missed Practice",
				"body": "Incomplete entries are preserved and shown separately from missed practices. Missing SUDS ratings create gaps rather than derived distress change."
			}
		],
		"faqItems": [
			{
				"question": "Does this form build an exposure hierarchy?",
				"answer": "No. It logs assigned exposure homework after the exposure situation has been chosen."
			},
			{
				"question": "Can the client save a partial practice entry?",
				"answer": "Yes. Partial entries can be saved and later resumed, with missing fields visible for review."
			},
			{
				"question": "Does the form score adherence?",
				"answer": "No. It shows completion, ratings, time spent, and difficulties without adding an unsupported adherence grade."
			},
			{
				"question": "What if the assignment changes midweek?",
				"answer": "A changed assignment should create a new homework log or a clearly marked revision so dates and ratings remain interpretable."
			}
		]
	},
	{
		"toolType": "exposureWithResponsePreventionPracticeForm",
		"slug": "exposure-with-response-prevention-practice-form",
		"title": "Pediatric OCD ERP Practice Form | Qwoach",
		"metaDescription": "Coordinate youth OCD ERP practice with exposure target, response prevention, participation, difficulties, and caregiver-relevant follow-through.",
		"h1": "Exposure With Response Prevention Practice Form",
		"intro": "The Exposure With Response Prevention Practice Form is a pediatric OCD ERP worksheet for practitioners working with young people and caregivers. It helps document the exposure target, response-prevention practice, youth participation, difficulties, and caregiver-relevant follow-through for the next graded ERP step.",
		"demoTitle": "Explore a sample youth ERP practice form",
		"demoPrompt": "Interested in using Exposure With Response Prevention Practice Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0080-f-002-ocd-017-r003-exposure-with-response-prevention-practice-form.md",
		"specId": "0080-f-002-ocd-017-r003-exposure-with-response-prevention-practice-form",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"OCD"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "Youth And Caregiver Roles",
				"body": "The young person contributes participation and experience information. The caregiver can view or contribute follow-through information when relevant, without taking over the therapy task."
			},
			{
				"title": "Scope Boundaries",
				"body": "The form documents pediatric ERP practice. It does not add unsupported child-specific prompts, scoring, caregiver interventions, or treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is this an adult ERP homework log?",
				"answer": "No. It is a pediatric OCD ERP practice form designed for youth practice with clinician and caregiver-relevant review."
			},
			{
				"question": "Is caregiver input always required?",
				"answer": "No. Caregiver-relevant follow-through is included when relevant to the practice context; otherwise it remains absent rather than inferred."
			},
			{
				"question": "Does the form create the next exposure step automatically?",
				"answer": "No. It organizes practice information so the practitioner can decide the next graded ERP step."
			},
			{
				"question": "Can the practice context change?",
				"answer": "Yes. Practice context can be in-session or home practice, and it affects who contributes information and how the result is reviewed."
			}
		]
	},
	{
		"toolType": "imaginalExposureScriptWorksheet",
		"slug": "imaginal-exposure-script-worksheet",
		"title": "Imaginal Exposure Script Worksheet for OCD ERP | Qwoach",
		"metaDescription": "Create a first-person feared-outcome script for OCD ERP when in vivo exposure is not practical, with use mode and ritual-prevention rules.",
		"h1": "Imaginal Exposure Script Worksheet",
		"intro": "The Imaginal Exposure Script Worksheet is a collaborative OCD ERP tool for practitioners and clients. It helps create a vivid first-person feared-outcome scenario for repeated imaginal exposure when the feared consequence, thought, image, or catastrophe cannot be practiced through in vivo exposure.",
		"demoTitle": "Open the sample worksheet and preview how the script, use mode, ritual-prevention rules, and readiness status appear before saving.",
		"demoPrompt": "Interested in using Imaginal Exposure Script Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0081-f-002-ocd-018-r001-imaginal-exposure-script-worksheet.md",
		"specId": "0081-f-002-ocd-018-r001-imaginal-exposure-script-worksheet",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"OCD",
				"Safety behaviors"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during OCD ERP when the feared consequence, thought, image, or catastrophe needs imaginal exposure rather than in vivo exposure."
			},
			{
				"title": "What It Produces",
				"body": "The central artifact is a written and/or recorded imaginal exposure script with target, use mode, ritual-prevention rules, and ready/draft status."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create a hierarchy, score symptoms, interpret fear content, predict treatment response, or track homework beyond minimal practice-use handoff details."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create an exposure hierarchy?",
				"answer": "No. It creates and supports use of one imaginal exposure script for a specific feared outcome."
			},
			{
				"question": "Can the client edit the script?",
				"answer": "Yes, if collaborative live edit is selected. The practitioner can also use practitioner-mediated editing."
			},
			{
				"question": "What makes a script ready?",
				"answer": "A script can be marked ready when the target feared outcome, script body, and response-prevention rules are present."
			},
			{
				"question": "Does the tool interpret the client’s fear content?",
				"answer": "No. It separates entered content from practitioner interpretation and does not generate clinical meanings."
			}
		]
	},
	{
		"toolType": "mayOrMayNotMomnStatements",
		"slug": "may-or-may-not-momn-statements",
		"title": "May or May Not Statements for OCD ERP | Qwoach",
		"metaDescription": "Create concise “may or may not” ERP statements for OCD uncertainty, with response-prevention rules for rumination and reassurance.",
		"h1": "May or May Not (MOMN) Statements",
		"intro": "May or May Not (MOMN) Statements is an OCD ERP scripting tool for practitioners working with clients triggered by intrusive thoughts and mental rituals. It helps the client use a brief uncertainty-facing response that keeps the feared possibility open without moving into reassurance, checking, rumination, or other compulsions.",
		"demoTitle": "Draft a sample MOMN statement, preview the client card, and see what is saved for use in practice.",
		"demoPrompt": "Interested in using May or May Not (MOMN) Statements with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0082-f-002-ocd-018-r002-may-or-may-not-momn-statements.md",
		"specId": "0082-f-002-ocd-018-r002-may-or-may-not-momn-statements",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Safety behaviors"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for OCD uncertainty triggers where the aim is to remain exposed to uncertainty without resolving the fear through reassurance, checking, rumination, or other rituals."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the target uncertainty, the MOMN phrase or phrases, response-prevention rules, and optional notes about use."
			},
			{
				"title": "Important Limits",
				"body": "It does not provide reassurance answers, probability estimates, fear interpretations, or broader imaginal exposure narratives."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool answer whether the feared outcome is likely?",
				"answer": "No. It keeps the uncertainty open and does not provide probability estimates or reassurance."
			},
			{
				"question": "Can it be used outside planned ERP practice?",
				"answer": "Yes. The supported use contexts are planned ERP, trigger-time use, or both."
			},
			{
				"question": "Can the client change the assigned statement later?",
				"answer": "The client may suggest wording before approval, but the practitioner controls the ready statement so the exposure meaning is not changed without review."
			},
			{
				"question": "What if the phrase becomes rumination?",
				"answer": "The practitioner can review use and revise the wording or response-prevention instructions."
			}
		]
	},
	{
		"toolType": "responsePreventionPlan",
		"slug": "response-prevention-plan",
		"title": "Response Prevention Plan for OCD ERP | Qwoach",
		"metaDescription": "Create explicit OCD ERP response-prevention rules for prohibited rituals, allowed responses, timing, and adherence review.",
		"h1": "Response Prevention Plan",
		"intro": "The Response Prevention Plan is an OCD ERP planning tool for practitioners and clients. It helps specify which compulsions, avoidance patterns, reassurance seeking, or safety behaviors will be blocked during and after exposure, and which non-compulsive responses or delay rules are allowed instead.",
		"demoTitle": "Build a sample rule plan, preview the client view, and review what would be saved.",
		"demoPrompt": "Interested in using Response Prevention Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0083-f-002-ocd-019-r001-response-prevention-plan.md",
		"specId": "0083-f-002-ocd-019-r001-response-prevention-plan",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Safety behaviors",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it while setting up ERP assignments or exposure categories where rituals, avoidance, reassurance, or safety behaviors must be blocked."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures exposure context, prohibited behaviors, allowed alternatives or delay rules, timing, and adherence review points."
			},
			{
				"title": "Important Limits",
				"body": "The tool is not an exposure hierarchy, symptom tracker, or clinical outcome measure. It does not decide whether a behavior is clinically appropriate."
			}
		],
		"faqItems": [
			{
				"question": "Can a plan be valid without an allowed alternative response?",
				"answer": "Yes. A plan can be valid when refraining itself is the agreed behavior, as long as the plan explicitly indicates that no alternative is specified."
			},
			{
				"question": "Does the system judge whether an allowed response is reassurance?",
				"answer": "No. The practitioner reviews and revises allowed responses; the system does not infer clinical appropriateness."
			},
			{
				"question": "Can rules apply after exposure as well as during exposure?",
				"answer": "Yes. The plan can clarify rules for during exposure, after exposure, or phase-specific use."
			},
			{
				"question": "What happens if a new covert ritual is identified later?",
				"answer": "The practitioner can add rules while preserving prior plan context for review."
			}
		]
	},
	{
		"toolType": "patientRulesForRitualPrevention",
		"slug": "patient-rules-for-ritual-prevention",
		"title": "Patient Rules for Ritual Prevention | Qwoach",
		"metaDescription": "Prepare a patient-facing OCD EX/RP ritual-prevention rule handout with practitioner-provided rules, ritual focus, and optional review acknowledgement.",
		"h1": "Patient Rules for Ritual Prevention",
		"intro": "Patient Rules for Ritual Prevention is an OCD EX/RP handout tool for practitioners. It helps present practitioner-provided behavioral expectations for refraining from rituals during self-exposure and homework practice, especially when the patient needs consistent rules for washing, checking, or another specified ritual focus.",
		"demoTitle": "Prepare a sample rule handout, preview the patient view, and see what gets saved.",
		"demoPrompt": "Interested in using Patient Rules for Ritual Prevention with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0084-f-002-ocd-019-r002-patient-rules-for-ritual-prevention.md",
		"specId": "0084-f-002-ocd-019-r002-patient-rules-for-ritual-prevention",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Safety behaviors",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Patient Roles",
				"body": "The practitioner creates or selects the rule content. The patient views the handout, acknowledges review if enabled, and follows the rules during practice."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures practitioner-provided ritual-prevention rules, ritual focus, context, optional permitted ordinary behavior, and optional acknowledgement."
			},
			{
				"title": "Important Limits",
				"body": "The system does not invent rule content, create exposure assignments, measure adherence longitudinally, or interpret reported practice."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool auto-fill ritual-prevention rules?",
				"answer": "No. The practitioner provides the rule content; the system does not generate substantive rules."
			},
			{
				"question": "Can it focus on rituals other than washing or checking?",
				"answer": "Yes. The supported ritual focus options are washing, checking, or a practitioner-specified other focus."
			},
			{
				"question": "Is acknowledgement required?",
				"answer": "No. Review acknowledgement can be turned on or off."
			},
			{
				"question": "Can the patient edit the rules?",
				"answer": "No. The patient views and acknowledges the rules; edits are practitioner-mediated."
			}
		]
	},
	{
		"toolType": "exposureHomeworkRecordingForm2",
		"slug": "exposure-homework-recording-form-2",
		"title": "Exposure Homework Recording Form for OCD ERP | Qwoach",
		"metaDescription": "Send an OCD ERP homework log for in vivo exposure attempts, SUDS ratings, timing, comments, difficulties, and practitioner review.",
		"h1": "Exposure Homework Recording Form",
		"intro": "The Exposure Homework Recording Form is an OCD ERP homework log for practitioners assigning between-session in vivo exposure practice. It helps capture the assigned exposure situation, practice attempts, SUDS ratings, timing when used, and comments or difficulties so the practitioner can review adherence, distress pattern, and barriers.",
		"demoTitle": "Configure a sample homework form, add fictional practice entries, and inspect the review view.",
		"demoPrompt": "Interested in using Exposure Homework Recording Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0085-f-002-ocd-020-r001-exposure-homework-recording-form.md",
		"specId": "0085-f-002-ocd-020-r001-exposure-homework-recording-form",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Homework",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for between-session in vivo exposure homework when the practitioner needs evidence of completion, distress response, and barriers."
			},
			{
				"title": "What It Captures",
				"body": "The form captures assigned exposure situation, attempts or dates, SUDS ratings, timing if configured, and comments or difficulties."
			},
			{
				"title": "Important Limits",
				"body": "It does not create an exposure hierarchy, make treatment recommendations, or interpret distress changes."
			}
		],
		"faqItems": [
			{
				"question": "Does this form show whether exposure was successful?",
				"answer": "No. It records reported practice data and descriptive summaries; the practitioner interprets the record."
			},
			{
				"question": "Can entries be partial?",
				"answer": "Yes. Partial entries are preserved and shown as incomplete when required fields are missing."
			},
			{
				"question": "What if the client practices a different exposure?",
				"answer": "The entry can be recorded and visibly distinguished from the assigned target based on the reported label."
			},
			{
				"question": "Can timing be turned off?",
				"answer": "Yes. Time capture is configurable when timing is not needed for the assignment."
			}
		]
	},
	{
		"toolType": "imaginalExposureHomeworkRecordingForm",
		"slug": "imaginal-exposure-homework-recording-form",
		"title": "Imaginal Exposure Homework Recording Form for OCD ERP | Qwoach",
		"metaDescription": "Track OCD imaginal exposure homework episodes with assignment, time spent, pre/peak/post SUDS, comments, and difficulties for review.",
		"h1": "Imaginal Exposure Homework Recording Form",
		"intro": "The Imaginal Exposure Homework Recording Form is an OCD ERP homework log for practitioners assigning between-session imaginal exposure. It helps capture the assigned script or scenario, time spent, pre, peak, and post SUDS ratings, and comments or difficulties so the practitioner can review completion, dose, distress response, and barriers.",
		"demoTitle": "Configure a sample imaginal homework log, add fictional practice episodes, and view the review summary.",
		"demoPrompt": "Interested in using Imaginal Exposure Homework Recording Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0086-f-002-ocd-020-r002-imaginal-exposure-homework-recording-form.md",
		"specId": "0086-f-002-ocd-020-r002-imaginal-exposure-homework-recording-form",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Homework",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for between-session imaginal exposure homework, commonly paired with a script or scenario."
			},
			{
				"title": "What It Captures",
				"body": "The log captures exercise practiced, date, time spent, pre/peak/post SUDS where configured, and comments or difficulties."
			},
			{
				"title": "Important Limits",
				"body": "It does not create the script, interpret the meaning of memories or images, or claim improvement from rating changes."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as an imaginal exposure script worksheet?",
				"answer": "No. This tool records homework practice after a script or scenario has been assigned."
			},
			{
				"question": "Are pre, peak, and post SUDS always required?",
				"answer": "They can be required or partially optional, depending on the practitioner setting."
			},
			{
				"question": "What if the script changes?",
				"answer": "Entries should remain tied to the version or assignment practiced so historical review is clear."
			},
			{
				"question": "Does the tool interpret distress patterns?",
				"answer": "No. It displays descriptive patterns from entered values without clinical interpretation."
			}
		]
	},
	{
		"toolType": "exposureHomeworkRecordingForm3",
		"slug": "exposure-homework-recording-form-3",
		"title": "Exposure Homework Recording Form for ERP Review | Qwoach",
		"metaDescription": "Record in vivo ERP homework attempts with dose, distress ratings, time spent, ritual-prevention adherence, and notes for session review.",
		"h1": "Exposure Homework Recording Form",
		"intro": "The Exposure Homework Recording Form is an OCD ERP homework record for practitioners assigning between-session in vivo exposure. It helps make the client’s exposure dose, distress change, homework completion, and ritual-prevention adherence visible for session review.",
		"demoTitle": "Set up a sample assignment, enter fictional practice attempts, and inspect the review-ready record.",
		"demoPrompt": "Interested in using Exposure Homework Recording Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0087-f-002-ocd-021-r001-exposure-homework-recording-form.md",
		"specId": "0087-f-002-ocd-021-r001-exposure-homework-recording-form",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Homework",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after assigning between-session in vivo exposure and response-prevention homework."
			},
			{
				"title": "What It Captures",
				"body": "The form captures exposure attempts, amount and timing of practice, distress ratings, ritual-prevention adherence, completion information, and notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool records homework evidence. It does not create an exposure hierarchy, judge whether ERP is working, or provide treatment advice."
			}
		],
		"faqItems": [
			{
				"question": "Can the practitioner set a target dose?",
				"answer": "Yes. The supported dose expectation can be none, a target number of attempts, or target time."
			},
			{
				"question": "Can adherence be optional?",
				"answer": "Yes. Ritual-prevention adherence can be required or optional, although optional entries may leave coaching needs unclear."
			},
			{
				"question": "What if there are no entries?",
				"answer": "The review shows a no-entry state that supports discussion of noncompletion or barriers without scoring."
			},
			{
				"question": "Does the tool decide the next ERP step?",
				"answer": "No. It organizes reported practice evidence so the practitioner can decide the next step."
			}
		]
	},
	{
		"toolType": "imaginalExposureHomeworkRecordingForm2",
		"slug": "imaginal-exposure-homework-recording-form-2",
		"title": "Imaginal Exposure Homework Recording Form | Qwoach",
		"metaDescription": "Log repeated OCD imaginal exposure practice tied to a script or scenario, with response ratings, completion information, and notes for review.",
		"h1": "Imaginal Exposure Homework Recording Form",
		"intro": "The Imaginal Exposure Homework Recording Form is an OCD ERP homework log for practitioners assigning script-based or scenario-based imaginal exposure. It helps make repeated practice episodes, response ratings, completion information, and homework notes visible so the practitioner can adjust imaginal exposure content, practice dose, and ritual-prevention instructions.",
		"demoTitle": "Try a sample script-based assignment, record fictional episodes, and inspect the review view.",
		"demoPrompt": "Interested in using Imaginal Exposure Homework Recording Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0088-f-002-ocd-021-r002-imaginal-exposure-homework-recording-form.md",
		"specId": "0088-f-002-ocd-021-r002-imaginal-exposure-homework-recording-form",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Homework",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for assigned imaginal exposure homework involving a script, feared consequence, intrusive thought, or scenario."
			},
			{
				"title": "What It Captures",
				"body": "The log captures assignment identity, repeated practice episodes, response ratings, completion information, and notes."
			},
			{
				"title": "Important Limits",
				"body": "It does not construct the imaginal script, track in vivo exposure homework, interpret intrusive thoughts, or make treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool write the imaginal script?",
				"answer": "No. It records practice for an assigned script or scenario."
			},
			{
				"question": "Can response rating fields be flexible?",
				"answer": "Yes. The response rating requirement controls which distress or response fields are enabled."
			},
			{
				"question": "What if the client practices a different script?",
				"answer": "The record captures what the client reports and distinguishes it from the assignment."
			},
			{
				"question": "Does the tool judge whether distress should rise or fall?",
				"answer": "No. It displays descriptive response patterns without judging what they mean."
			}
		]
	},
	{
		"toolType": "erpPracticeRecord",
		"slug": "erp-practice-record",
		"title": "ERP Practice Record for OCD ERP | Qwoach",
		"metaDescription": "Record completed ERP practice attempts with exposure description, SUDS, urge to ritualise, end anxiety, ritual prevention, and learning notes.",
		"h1": "ERP Practice Record",
		"intro": "The ERP Practice Record is an OCD ERP practice-session log for practitioners whose clients are completing exposures between sessions or during structured homework. It helps record which exposures occurred, peak anxiety or SUDS, urge to ritualise, end anxiety, whether the ritual was prevented, and what the client learned.",
		"demoTitle": "Complete a fictional practice entry, then inspect how the practitioner review summarizes it.",
		"demoPrompt": "Interested in using ERP Practice Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0089-f-002-ocd-021-r003-erp-practice-record.md",
		"specId": "0089-f-002-ocd-021-r003-erp-practice-record",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Homework",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after ERP practice attempts so the next review can address what happened during exposure and response prevention."
			},
			{
				"title": "What It Captures",
				"body": "Each entry captures exposure description, peak anxiety/SUDS, urge to ritualise, end anxiety, ritual-prevention status, and learning notes."
			},
			{
				"title": "Important Limits",
				"body": "It does not create homework assignments, interpret learning quality, label practice as success or failure, or prescribe next steps."
			}
		],
		"faqItems": [
			{
				"question": "Is the entry completed before or after exposure?",
				"answer": "After exposure. Each entry represents a completed ERP practice attempt."
			},
			{
				"question": "Is ritual-prevention status required?",
				"answer": "It is required by default because it is central to ERP review."
			},
			{
				"question": "Can the record be used without a prefilled assignment?",
				"answer": "Yes. Assignment context can be linked to a specific exposure or left as client-described practice."
			},
			{
				"question": "Does the tool evaluate whether the client’s learning is correct?",
				"answer": "No. It records the learning note for practitioner review without judging it."
			}
		]
	},
	{
		"toolType": "selfMonitoringForm",
		"slug": "self-monitoring-form",
		"title": "Self-Monitoring Form for OCD EX/RP | Qwoach",
		"metaDescription": "Record OCD episodes by trigger, distress or urge intensity, ritual description, and minutes spent ritualizing for EX/RP planning.",
		"h1": "Self-Monitoring Form",
		"intro": "The Self-Monitoring Form is an OCD EX/RP monitoring tool for practitioners planning or reviewing ERP. It helps clients record recurring OCD episodes by triggering situation, activity, or thought; distress or urge intensity; overt or mental ritual; and minutes spent ritualizing so the practitioner can select precise ERP and response-prevention targets.",
		"demoTitle": "Set a sample monitoring window, enter fictional episode rows, and review the descriptive summary.",
		"demoPrompt": "Interested in using Self-Monitoring Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0090-f-002-ocd-022-r001-self-monitoring-form.md",
		"specId": "0090-f-002-ocd-022-r001-self-monitoring-form",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Assessment"
			],
			"topic": [
				"OCD",
				"Problem behavior",
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during EX/RP planning or homework review when detailed trigger, distress or urge, ritual, and time-cost data are needed."
			},
			{
				"title": "What It Captures",
				"body": "The form captures time or episode, triggering situation/activity/thought, distress or urge rating, overt or mental ritual description, and minutes spent ritualizing."
			},
			{
				"title": "Important Limits",
				"body": "It is not a diagnostic assessment, exposure homework log, exposure hierarchy, or treatment recommendation tool."
			}
		],
		"faqItems": [
			{
				"question": "Can the client record mental rituals?",
				"answer": "Yes. The ritual field supports overt or mental ritual descriptions."
			},
			{
				"question": "What if the client cannot identify a trigger?",
				"answer": "The row can record unknown or unclear rather than forcing the client to invent a trigger."
			},
			{
				"question": "Does the tool rank ERP targets automatically?",
				"answer": "No. It can sort or display entered intensity and time values, but the practitioner selects targets."
			},
			{
				"question": "Can monitoring periods be compared later?",
				"answer": "Historical monitoring periods remain distinct so change can be reviewed without mixing periods."
			}
		]
	},
	{
		"toolType": "obsessionsAndCompulsionsLog",
		"slug": "obsessions-and-compulsions-log",
		"title": "Obsessions and Compulsions Log for ERP | Qwoach",
		"metaDescription": "Explore an OCD/ERP log for recording intrusive thoughts, compulsions, distress, and duration as linked episode data for clinical review.",
		"h1": "Obsessions and Compulsions Log for OCD/ERP Review",
		"intro": "Obsessions and Compulsions Log is a ready-to-send OCD/ERP treatment log for clinicians who need clients to record intrusive thoughts, compulsive responses, duration or frequency, distress, and related episode details. It helps practitioners review actual obsession-compulsion loops and choose response-prevention targets that match the client’s reported pattern.",
		"demoTitle": "Explore the log with sample entries",
		"demoPrompt": "Interested in using Obsessions and Compulsions Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0091-f-002-ocd-022-r002-obsessions-and-compulsions-log.md",
		"specId": "0091-f-002-ocd-022-r002-obsessions-and-compulsions-log",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Safety behaviors"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the log before or during ERP treatment when the practitioner needs current data about the client’s obsession-compulsion cycles."
			},
			{
				"title": "What It Captures",
				"body": "The log captures obsessional thoughts or intrusive thoughts, compulsive responses, duration or frequency when used, distress or episode details when requested, notes, and completion status."
			},
			{
				"title": "Limits",
				"body": "The tool does not assign clinical meaning, generate an exposure hierarchy, diagnose OCD, calculate standardized severity, or create treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is this an OCD severity scale?",
				"answer": "No. It is an episode-level obsession and compulsion recording log, not a standardized severity assessment."
			},
			{
				"question": "Can clients save partial entries?",
				"answer": "Yes. Partial entries can be saved and resumed, and entries missing either obsession or compulsion are marked incomplete."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews linked obsessional content, compulsive responses, duration or frequency where present, distress or episode details, notes, and descriptive patterns."
			},
			{
				"question": "Does the system choose response-prevention targets automatically?",
				"answer": "No. The system organizes reported data descriptively; the practitioner chooses targets."
			}
		]
	},
	{
		"toolType": "erpForAdultsWorksheet",
		"slug": "erp-for-adults-worksheet",
		"title": "ERP for Adults Worksheet Demo | Qwoach",
		"metaDescription": "Explore an adult ERP worksheet for mapping compulsions, planning response prevention, and reviewing trigger, urge, response, and obstacles.",
		"h1": "ERP for Adults Worksheet with Compulsion Diary",
		"intro": "ERP for adults worksheet is a ready-to-complete-together adult ERP planning and review worksheet for clinicians and clients. It helps practitioners map compulsions, define ERP steps, tie response-prevention expectations to the exercise, and review trigger, OCD urge, response, completion, and obstacles.",
		"demoTitle": "Open the worksheet demo",
		"demoPrompt": "Interested in using ERP for adults worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0092-f-002-ocd-022-r003-erp-for-adults-worksheet.md",
		"specId": "0092-f-002-ocd-022-r003-erp-for-adults-worksheet",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Homework",
				"Safety behaviors"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Practitioner and Client Roles",
				"body": "The practitioner and client jointly create the plan; the client later contributes diary and review information; the practitioner controls clinical interpretation and the next assignment."
			},
			{
				"title": "Partial States",
				"body": "A worksheet may be planned before diary entries exist. Planned-but-not-reviewed and reviewed exercises are shown distinctly."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic homework tracker?",
				"answer": "No. It is an adult ERP planning and review worksheet with a compulsion diary component."
			},
			{
				"question": "Can the worksheet be used before the client has completed homework?",
				"answer": "Yes. Planning can be complete before diary entries exist, and the review section can remain empty until practice occurs."
			},
			{
				"question": "Does the system rate adherence automatically?",
				"answer": "No. It provides descriptive completion and obstacle information based on entered data."
			}
		]
	},
	{
		"toolType": "exposureTrackingLog",
		"slug": "exposure-tracking-log",
		"title": "Exposure Tracking Log for ERP | Qwoach",
		"metaDescription": "Explore an exposure therapy log for recording situations, SUDS ratings, duration, safety behaviors, and notes for practitioner review.",
		"h1": "Exposure Tracking Log for SUDS and Exposure Review",
		"intro": "Exposure Tracking Log is a ready-to-send exposure therapy and ERP log for clinicians whose clients record exposure situation, safety behaviors, exercise duration, SUDS ratings, and notes. It helps practitioners review distress change during exposure practice and compare descriptive patterns across exercises.",
		"demoTitle": "Try a sample exposure log",
		"demoPrompt": "Interested in using Exposure Tracking Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0093-f-002-ocd-023-r001-exposure-tracking-log.md",
		"specId": "0093-f-002-ocd-023-r001-exposure-tracking-log",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Safety behaviors",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The log captures exposure situation, exercise duration, repeated SUDS ratings, safety behavior information, notes, and completion status."
			},
			{
				"title": "History and Comparison",
				"body": "Repeated logs can be compared descriptively when rating scale, capture pattern, and exposure context are consistent."
			},
			{
				"title": "Limits",
				"body": "The tool does not infer habituation, assign clinical meaning, generate an exposure hierarchy, or make treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does this create an exposure hierarchy?",
				"answer": "No. It tracks distress and context during exposure practice; it is not an exposure hierarchy tool."
			},
			{
				"question": "What happens if a rating is missed?",
				"answer": "Missed ratings remain missing and are not interpolated."
			},
			{
				"question": "Can it be used for homework and in-session exposure?",
				"answer": "Yes. The log supports exposure tracking in homework or in-session contexts when repeated ratings and exposure details are recorded."
			}
		]
	},
	{
		"toolType": "therapistExposureRecordingForm2",
		"slug": "therapist-exposure-recording-form-2",
		"title": "Therapist Exposure Recording Form | Qwoach",
		"metaDescription": "Explore a practitioner-only ERP form for recording in-session exposure context, repeated SUDS ratings, comments, and process notes.",
		"h1": "Therapist Exposure Recording Form for In-Session ERP",
		"intro": "Therapist Exposure Recording Form is a practitioner-only in-session EX/RP exposure form for therapists who need to document the exposure practiced, repeated SUDS ratings, and clinical notes. It helps the practitioner see within-session distress trajectory, engagement, and response-prevention information for review and future exposure planning.",
		"demoTitle": "Start a sample therapist record",
		"demoPrompt": "Interested in using Therapist Exposure Recording Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0094-f-002-ocd-023-r002-therapist-exposure-recording-form.md",
		"specId": "0094-f-002-ocd-023-r002-therapist-exposure-recording-form",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Safety behaviors",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The therapist controls the record. The client supplies ratings and participates in the exposure but does not operate the form."
			},
			{
				"title": "Active and Completed States",
				"body": "The form can be incomplete during exposure. Completed records persist for later comparison with context visible."
			},
			{
				"title": "Limits",
				"body": "The system does not generate clinical interpretation, outcome classification, severity scores, or therapist judgments."
			}
		],
		"faqItems": [
			{
				"question": "Does the client complete this form?",
				"answer": "No. This is a practitioner-only form; the client provides distress ratings during the session while the therapist records them."
			},
			{
				"question": "Can multiple exposures be recorded in one session?",
				"answer": "Multiple exposures require separate records or clearly separated segments."
			},
			{
				"question": "What happens if the exposure stops early?",
				"answer": "The record shows the actual available ratings and notes without filling in missing points."
			}
		]
	},
	{
		"toolType": "exposureHomeworkRecordingForm4",
		"slug": "exposure-homework-recording-form-4",
		"title": "Exposure Homework Recording Form | Qwoach",
		"metaDescription": "Explore an ERP homework form for recording assigned exposure attempts, dates, repeated SUDS ratings, comments, and difficulties.",
		"h1": "Exposure Homework Recording Form for Between-Session ERP",
		"intro": "Exposure Homework Recording Form is a ready-to-send between-session ERP homework form for practitioners whose clients record assigned exposure practice and repeated SUDS ratings outside the therapy office. It helps clinicians review homework adherence, distress change during practice, and reported difficulties.",
		"demoTitle": "Try the homework form",
		"demoPrompt": "Interested in using Exposure Homework Recording Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0095-f-002-ocd-023-r003-exposure-homework-recording-form.md",
		"specId": "0095-f-002-ocd-023-r003-exposure-homework-recording-form",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Homework",
				"Safety behaviors",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "No Attempts State",
				"body": "If no attempts are completed, the review state can show missing practice or nonadherence without inventing ratings."
			},
			{
				"title": "Multiple Attempts",
				"body": "Each attempt remains tied to its assigned exposure context so different tasks are not merged into one trend."
			}
		],
		"faqItems": [
			{
				"question": "Is this for between-session use?",
				"answer": "Yes. It is for assigned exposure practice outside the therapy office between sessions."
			},
			{
				"question": "Can the client record more than one attempt?",
				"answer": "Yes. The form supports multiple homework attempts for the assigned exposure."
			},
			{
				"question": "Does no completed homework break the review?",
				"answer": "No. No attempts completed is a valid review state showing missing practice or nonadherence."
			}
		]
	},
	{
		"toolType": "exposurePracticeForm",
		"slug": "exposure-practice-form",
		"title": "Exposure Practice Form Demo | Qwoach",
		"metaDescription": "Explore a CBT exposure worksheet for planning a feared-stimulus task, comparing prediction with outcome, and reviewing learning.",
		"h1": "Exposure Practice Form for Prediction-Outcome Review",
		"intro": "Exposure Practice Form is a ready-to-complete-together CBT exposure worksheet for therapists and clients planning and reviewing exposure to a feared stimulus. It helps practitioners compare feared expectations with what actually happened, record emotional response, and identify implications for future exposure practice.",
		"demoTitle": "Explore the practice form",
		"demoPrompt": "Interested in using Exposure Practice Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0096-f-002-ocd-024-r001-exposure-practice-form.md",
		"specId": "0096-f-002-ocd-024-r001-exposure-practice-form",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the form before, during, and after a planned exposure when prediction-outcome comparison and post-exposure learning are central."
			},
			{
				"title": "Partial Work",
				"body": "Before-exposure sections can exist before outcome sections. Partial work resumes at the correct stage."
			},
			{
				"title": "Limits",
				"body": "The tool does not score learning, infer belief change, diagnose, or generate an exposure hierarchy."
			}
		],
		"faqItems": [
			{
				"question": "Is this only a SUDS log?",
				"answer": "No. Distress or emotional response can be recorded, but the central feature is comparing prediction with actual outcome and learning."
			},
			{
				"question": "Can it be completed with the client?",
				"answer": "Yes. The form can be completed together in session or assigned for client completion."
			},
			{
				"question": "Does it generate the next exposure?",
				"answer": "No. It records next-step implications as reported or reviewed; the practitioner plans the next exposure."
			}
		]
	},
	{
		"toolType": "myExpectancyExposureForm",
		"slug": "my-expectancy-exposure-form",
		"title": "My Expectancy Exposure Form | Qwoach",
		"metaDescription": "Explore a four-part expectancy exposure worksheet for recording task, feared prediction, actual outcome, and learning.",
		"h1": "My Expectancy Exposure Form for CBT Exposure Review",
		"intro": "My Expectancy Exposure Form is a ready-to-send expectancy-violation exposure worksheet for CBT practitioners and workbook-guided clients. It helps the practitioner capture a four-part record: exposure task, feared prediction or expected bad outcome, actual events during exposure, and what the client learned.",
		"demoTitle": "Try the four-part form",
		"demoPrompt": "Interested in using My Expectancy Exposure Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0097-f-002-ocd-024-r002-my-expectancy-exposure-form.md",
		"specId": "0097-f-002-ocd-024-r002-my-expectancy-exposure-form",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Four-Part Structure",
				"body": "The form consists of exposure task, feared prediction or expected bad outcome, what actually happened, and what was learned."
			},
			{
				"title": "Limits",
				"body": "The tool does not collect distress ratings unless separately supplied, add hierarchy data, score the response, or generate clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool require configuration?",
				"answer": "No. The worksheet is fixed; saving still saves the tool itself as-is."
			},
			{
				"question": "Can a form be saved if the outcome is missing?",
				"answer": "Yes. It can be saved as partial, but the expectancy comparison remains incomplete without an actual outcome."
			},
			{
				"question": "Does the system decide whether the exposure worked?",
				"answer": "No. It displays the reported prediction, outcome, and learning for practitioner review."
			}
		]
	},
	{
		"toolType": "exposureExerciseWorksheet",
		"slug": "exposure-exercise-worksheet",
		"title": "Exposure Exercise Worksheet | Qwoach",
		"metaDescription": "Explore an ACT-informed ERP worksheet for OCD exposure planning, response prevention, values, expected outcome, and learning review.",
		"h1": "ACT-Informed ERP Exposure Exercise Worksheet",
		"intro": "Exposure Exercise Worksheet is a ready-to-send ACT-informed ERP worksheet for practitioners supporting OCD exposure preparation and review. It helps connect an exposure plan to response prevention, values, core fear, expected outcome, actual outcome, and learning about uncertainty or discomfort.",
		"demoTitle": "Explore the exposure worksheet",
		"demoPrompt": "Interested in using Exposure Exercise Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0098-f-002-ocd-024-r003-exposure-exercise-worksheet.md",
		"specId": "0098-f-002-ocd-024-r003-exposure-exercise-worksheet",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"OCD",
				"Values",
				"Safety behaviors"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Two-Phase Use",
				"body": "Preparation can be saved before the exposure is performed. Post-exposure review completes the outcome comparison and learning section."
			},
			{
				"title": "What It Connects",
				"body": "The worksheet connects OCD trigger exposure to response prevention, values, core fear, expected outcome, actual outcome, and learning about uncertainty or discomfort."
			},
			{
				"title": "Limits",
				"body": "The tool does not generate values interpretation, clinical conclusions, exposure scripts, scores, or a success label."
			}
		],
		"faqItems": [
			{
				"question": "Is the script required?",
				"answer": "No. Script inclusion is a setting for the specific exposure."
			},
			{
				"question": "Can preparation be saved before the exposure happens?",
				"answer": "Yes. Preparation-only worksheets remain active until post-exposure review is completed."
			},
			{
				"question": "Does the system interpret the client’s values?",
				"answer": "No. Values links remain client-reported or practitioner-entered text."
			}
		]
	},
	{
		"toolType": "patientExRpAdherenceScalePeas",
		"slug": "patient-ex-rp-adherence-scale-peas",
		"title": "PEAS ERP Adherence Scale | Qwoach",
		"metaDescription": "Explore clinician-rated PEAS for ERP: three 1-7 adherence items, averaged score, session context, notes, and trend review.",
		"h1": "Patient EX/RP Adherence Scale (PEAS) for ERP Homework Review",
		"intro": "Patient EX/RP Adherence Scale (PEAS) is a ready-to-complete-together clinician-rated ERP adherence scale for practitioners reviewing between-session exposure and response-prevention homework. It helps clinicians rate exposure quantity, exposure quality, and resistance to ritualizing on three anchored 1-7 items and view an averaged adherence score over time.",
		"demoTitle": "Rate a sample PEAS session",
		"demoPrompt": "Interested in using Patient EX/RP Adherence Scale (PEAS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0099-f-002-ocd-025-r001-patient-ex-rp-adherence-scale-peas.md",
		"specId": "0099-f-002-ocd-025-r001-patient-ex-rp-adherence-scale-peas",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Homework",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Domains",
				"body": "PEAS covers percentage of assigned exposures attempted, quality of attempted exposures, and percentage of urges to ritualize resisted."
			},
			{
				"title": "Longitudinal Review",
				"body": "Scores remain tied to session/date and homework period so item and total trends can be reviewed over time."
			},
			{
				"title": "Limits",
				"body": "The tool does not add adherence subscales, infer severity, predict outcomes, or create ratings without clinician judgment."
			}
		],
		"faqItems": [
			{
				"question": "Who completes PEAS?",
				"answer": "The practitioner completes PEAS ratings using homework evidence, logs, client report, and clinical judgment."
			},
			{
				"question": "How many items are included?",
				"answer": "PEAS includes exactly three clinician-rated 1-7 adherence items."
			},
			{
				"question": "What happens if one item is missing?",
				"answer": "The scale is visibly incomplete and does not produce a complete average unless a defined missing-item rule exists."
			},
			{
				"question": "Is PEAS an OCD severity scale?",
				"answer": "No. PEAS rates ERP homework adherence, not broader OCD severity."
			}
		]
	},
	{
		"toolType": "patientExRpAdherenceScalePatientPeasP",
		"slug": "patient-ex-rp-adherence-scale-patient-peas-p",
		"title": "PEAS-P Patient ERP Adherence | Qwoach",
		"metaDescription": "Explore PEAS-P, a patient-rated ERP adherence scale with three 1-7 items for exposure quantity, quality, and response prevention.",
		"h1": "PEAS-P Patient-Rated ERP Adherence Scale",
		"intro": "Patient EX/RP Adherence Scale-Patient (PEAS-P) is a ready-to-send patient-rated adaptation of PEAS for practitioners and teams in concentrated ERP treatment contexts. It helps collect three 1-7 self-ratings for exposure practice attempted, quality of exposure practice, and success with response prevention during a defined treatment period.",
		"demoTitle": "Try a sample PEAS-P rating",
		"demoPrompt": "Interested in using Patient EX/RP Adherence Scale-Patient (PEAS-P) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0100-f-002-ocd-025-r002-patient-ex-rp-adherence-scale-patient-peas-p.md",
		"specId": "0100-f-002-ocd-025-r002-patient-ex-rp-adherence-scale-patient-peas-p",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Patient-Rated Instrument",
				"body": "PEAS-P is completed by the patient. Clinician-rated PEAS remains a separate instrument."
			},
			{
				"title": "Treatment-Period Context",
				"body": "Each response is anchored to the defined treatment day or recent practice period so repeated scores can be compared descriptively."
			},
			{
				"title": "Limits",
				"body": "The tool does not classify risk, infer severity, predict outcomes, or add questionnaire content beyond the three adherence domains."
			}
		],
		"faqItems": [
			{
				"question": "Who completes PEAS-P?",
				"answer": "The patient completes PEAS-P as a self-rated adherence measure for the defined treatment period."
			},
			{
				"question": "Is PEAS-P the same as clinician-rated PEAS?",
				"answer": "No. PEAS-P is patient-rated; clinician-rated PEAS is a separate instrument."
			},
			{
				"question": "What does the total score mean in the product?",
				"answer": "The total score summarizes the three patient-rated adherence items descriptively; the product does not add risk or severity interpretation."
			},
			{
				"question": "What happens if the patient skips an item?",
				"answer": "The response remains partial, and total score handling must be clear before a total is shown."
			}
		]
	},
	{
		"toolType": "familyAccommodationScaleForObsessiveCompulsiveDisorderInterviewerRatedVersionFasIr2",
		"slug": "family-accommodation-scale-for-obsessive-compulsive-disorder-interviewer-rated-version-fas-ir-2",
		"title": "FAS-IR OCD Family Accommodation Interview Demo | Qwoach",
		"metaDescription": "Explore FAS-IR for OCD clinicians: interview a family member, rate accommodation behaviors, review item scores and total severity.",
		"h1": "Family Accommodation Scale for OCD, Interviewer-Rated Version Demo",
		"intro": "FAS-IR is a clinician-administered OCD family accommodation assessment for OCD clinicians and researchers. It helps practitioners interview a relative, rate specific accommodation behaviors, and review a total family accommodation severity score for treatment planning or monitoring.",
		"demoTitle": "Start a sample FAS-IR interview",
		"demoPrompt": "Interested in using Family Accommodation Scale for Obsessive-Compulsive Disorder, Interviewer-Rated Version (FAS-IR) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0101-f-002-ocd-026-r001-family-accommodation-scale-for-obsessive-compulsive-disorder-interviewer-rated-version-fas-ir.md",
		"specId": "0101-f-002-ocd-026-r001-family-accommodation-scale-for-obsessive-compulsive-disorder-interviewer-rated-version-fas-ir",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Family accommodation",
				"Outcome monitoring"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "FAS-IR is used when family-member accommodation needs to be assessed through a clinician interview rather than a self-report form."
			},
			{
				"title": "What It Captures",
				"body": "It captures family-member report as optional examples, practitioner-entered item ratings, completion status, total severity score when valid, and prior administrations for comparison."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate diagnosis, treatment recommendations, invented subscales, family-blame labels, or conclusions beyond reported behaviors, descriptive ratings, and supported scoring."
			}
		],
		"faqItems": [
			{
				"question": "Is FAS-IR completed by the family member independently?",
				"answer": "No. FAS-IR is interviewer-rated, so the clinician interviews the family member and records the formal ratings."
			},
			{
				"question": "What does the result show?",
				"answer": "The result shows rated accommodation items, completion status, total family accommodation severity score when valid, assessment date/window, and comparison with prior administrations when available."
			},
			{
				"question": "Can the demo be explored without real case information?",
				"answer": "Yes. The demo uses fictional case and relative placeholders, and sample responses are not saved as real client data."
			},
			{
				"question": "Can item wording or scoring be configured?",
				"answer": "No. Item content, response anchors, scoring, and total-score behavior are fixed parts of the represented instrument once implemented."
			}
		]
	},
	{
		"toolType": "familyAccommodationScaleForObsessiveCompulsiveDisorderSelfRatedVersionFasSr2",
		"slug": "family-accommodation-scale-for-obsessive-compulsive-disorder-self-rated-version-fas-sr-2",
		"title": "FAS-SR OCD Family Accommodation Self-Report Demo | Qwoach",
		"metaDescription": "Explore FAS-SR for OCD care: send a family accommodation self-report, capture item responses, and review total accommodation score.",
		"h1": "Family Accommodation Scale for OCD, Self-Rated Version Demo",
		"intro": "FAS-SR is a relative-completed OCD family accommodation self-report scale for OCD practitioners. It helps practitioners collect accommodation item responses and an overall accommodation score without conducting the full interviewer-rated assessment.",
		"demoTitle": "Preview a sample FAS-SR assignment",
		"demoPrompt": "Interested in using Family Accommodation Scale for Obsessive-Compulsive Disorder, Self-Rated Version (FAS-SR) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0102-f-002-ocd-026-r002-family-accommodation-scale-for-obsessive-compulsive-disorder-self-rated-version-fas-sr.md",
		"specId": "0102-f-002-ocd-026-r002-family-accommodation-scale-for-obsessive-compulsive-disorder-self-rated-version-fas-sr",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Family accommodation",
				"Outcome monitoring"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "FAS-SR is used when relatives can report their own accommodation behaviors and the practitioner wants a lower-burden alternative to a clinician interview."
			},
			{
				"title": "Practitioner And Family Roles",
				"body": "The practitioner creates and reviews the assignment. The family member completes the ratings directly and submits them for practitioner review."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide diagnosis, family intervention plans, causal explanations, or invented item categories."
			}
		],
		"faqItems": [
			{
				"question": "Who completes FAS-SR?",
				"answer": "A family member completes FAS-SR as a self-report questionnaire about accommodation behaviors."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews item responses, total accommodation score when valid, missing-response status, respondent role, date/window, and prior comparison when available."
			},
			{
				"question": "Does the family member need to interpret the score?",
				"answer": "No. The family member completes the responses; substantive interpretation is reserved for practitioner review or discussion."
			},
			{
				"question": "Can multiple relatives complete one combined form?",
				"answer": "No. Multiple relatives should complete separate administrations rather than merged responses."
			}
		]
	},
	{
		"toolType": "familyAccommodationScaleForObsessiveCompulsiveDisorderPatientVersionFasPv2",
		"slug": "family-accommodation-scale-for-obsessive-compulsive-disorder-patient-version-fas-pv-2",
		"title": "FAS-PV OCD Patient-Reported Accommodation Demo | Qwoach",
		"metaDescription": "Explore FAS-PV for OCD practice: collect patient-reported perceived family accommodation and review item responses and supported scores.",
		"h1": "Family Accommodation Scale for OCD, Patient Version Demo",
		"intro": "FAS-PV is a patient-reported OCD family accommodation questionnaire for OCD practitioners. It helps practitioners assess perceived family accommodation when relatives are unavailable or when the patient's perspective is specifically needed.",
		"demoTitle": "Preview a sample FAS-PV assignment",
		"demoPrompt": "Interested in using Family Accommodation Scale for Obsessive-Compulsive Disorder, Patient Version (FAS-PV) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0103-f-002-ocd-026-r003-family-accommodation-scale-for-obsessive-compulsive-disorder-patient-version-fas-pv.md",
		"specId": "0103-f-002-ocd-026-r003-family-accommodation-scale-for-obsessive-compulsive-disorder-patient-version-fas-pv",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Family accommodation",
				"Outcome monitoring"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "FAS-PV is used when relatives are unavailable or when the patient's perspective on family accommodation is the specific information needed."
			},
			{
				"title": "How Results Are Labeled",
				"body": "Results are labeled as patient-reported perceived accommodation so practitioner review does not treat them as verified collateral report."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not verify relatives' behavior, generate treatment recommendations, diagnose, or add unsupported subscales."
			}
		],
		"faqItems": [
			{
				"question": "Who completes FAS-PV?",
				"answer": "The patient completes FAS-PV to report perceived family accommodation behaviors."
			},
			{
				"question": "Is FAS-PV a replacement for interviewing relatives?",
				"answer": "No. It captures the patient's perspective and does not independently verify relatives' behavior."
			},
			{
				"question": "What can be configured?",
				"answer": "The practitioner can configure assessment window and administration mode; item content, response scale, perspective, and scoring are fixed."
			},
			{
				"question": "What happens if the patient cannot identify a relevant accommodation context?",
				"answer": "The administration can be marked limited-use rather than forcing invented responses."
			}
		]
	},
	{
		"toolType": "behavioralContractingForFamilyAccommodationInOcd",
		"slug": "behavioral-contracting-for-family-accommodation-in-ocd",
		"title": "OCD Family Accommodation Behavioral Contract Demo | Qwoach",
		"metaDescription": "Explore a practitioner-guided OCD family accommodation contract with target situations, replacement responses, barriers, review dates, and revisions.",
		"h1": "Behavioral Contracting for Family Accommodation in OCD Demo",
		"intro": "Behavioral Contracting for Family Accommodation in OCD is a practitioner-guided planning tool for OCD clinicians. It helps the person with OCD and family members agree how specific accommodating responses will change in a predictable, ERP-aligned way.",
		"demoTitle": "Build a sample accommodation contract",
		"demoPrompt": "Interested in using Behavioral Contracting for Family Accommodation in OCD with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0104-f-002-ocd-027-r001-behavioral-contracting-for-family-accommodation-in-ocd.md",
		"specId": "0104-f-002-ocd-027-r001-behavioral-contracting-for-family-accommodation-in-ocd",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Family accommodation",
				"Behavior change"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when OCD treatment has identified family accommodation and the family needs a predictable, negotiated plan for changing responses."
			},
			{
				"title": "Practitioner, Client, And Family Roles",
				"body": "The practitioner facilitates. The client and family contribute situations, fears, and agreements. The practitioner controls clinical revision and follow-up review."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create generic household rules, automated treatment directives, symptom scores, or unsupported interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Is this a rating scale?",
				"answer": "No. It is a negotiated behavioral contract for changing family accommodation responses."
			},
			{
				"question": "Can a contract be active without family agreement?",
				"answer": "No. Without agreement, the target remains a draft rather than an active contract item."
			},
			{
				"question": "What is saved in the demo?",
				"answer": "The tool and supported reusable setup can be saved; fictional target examples and sample family content are not saved as real client data."
			},
			{
				"question": "Can plans be revised over treatment?",
				"answer": "Yes. Revisions are preserved so changes in targets or responses remain visible over treatment."
			}
		]
	},
	{
		"toolType": "spaceAccommodationReductionPlan",
		"slug": "space-accommodation-reduction-plan",
		"title": "SPACE Accommodation Reduction Plan Demo | Qwoach",
		"metaDescription": "Explore a parent-only SPACE accommodation reduction plan with target behaviors, supportive communication, expected reactions, and follow-up review.",
		"h1": "SPACE Accommodation Reduction Plan for Parents Demo",
		"intro": "The SPACE Accommodation Reduction Plan is a practitioner-guided parent-only planning tool for clinicians working with parents of children or adolescents with OCD or anxiety. It helps parents reduce selected accommodations while preparing supportive communication and anticipating implementation barriers.",
		"demoTitle": "Create a sample parent plan",
		"demoPrompt": "Interested in using SPACE Accommodation Reduction Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0105-f-002-ocd-027-r002-space-accommodation-reduction-plan.md",
		"specId": "0105-f-002-ocd-027-r002-space-accommodation-reduction-plan",
		"tags": {
			"framework": [
				"SPACE"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Family accommodation",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when parent behavior change is the treatment pathway for reducing child reliance on reassurance or other accommodation."
			},
			{
				"title": "Parent Role",
				"body": "Parents provide accommodation patterns, select targets with the practitioner, prepare supportive communication, implement the change, and report back at follow-up."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not require child self-report, create child assignments, generate SPACE scripts, or represent the full SPACE protocol."
			}
		],
		"faqItems": [
			{
				"question": "Does the child need to use this tool?",
				"answer": "No. This is a parent-only planning tool; child participation is not required for setup, completion, or review."
			},
			{
				"question": "What makes a plan ready for implementation?",
				"answer": "A plan is ready when the target accommodation, parent behavior change, supportive communication, anticipated reactions or barriers, and review timing are sufficiently entered."
			},
			{
				"question": "Can multiple targets be planned at once?",
				"answer": "Multiple targets can be tracked separately to avoid cognitive overload."
			},
			{
				"question": "Does the product generate SPACE scripts?",
				"answer": "No. Supportive communication is entered by the practitioner and parents; the product does not invent scripts."
			}
		]
	},
	{
		"toolType": "briefFamilyInterventionBfiToReduceAccommodationInOcd",
		"slug": "brief-family-intervention-bfi-to-reduce-accommodation-in-ocd",
		"title": "Brief Family Intervention OCD Accommodation Demo | Qwoach",
		"metaDescription": "Explore BFI for adult OCD ERP: identify family accommodation, plan alternatives, rehearse reactions, and review follow-up barriers.",
		"h1": "Brief Family Intervention to Reduce Accommodation in OCD Demo",
		"intro": "Brief Family Intervention to Reduce Accommodation in OCD is a clinician-delivered adjunctive protocol for adult OCD ERP. It helps clinicians and family members identify accommodation, choose feasible non-accommodating responses, rehearse likely reactions, and review implementation barriers.",
		"demoTitle": "Start a sample BFI plan",
		"demoPrompt": "Interested in using Brief Family Intervention (BFI) to Reduce Accommodation in OCD with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0106-f-002-ocd-027-r003-brief-family-intervention-bfi-to-reduce-accommodation-in-ocd.md",
		"specId": "0106-f-002-ocd-027-r003-brief-family-intervention-bfi-to-reduce-accommodation-in-ocd",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Family accommodation",
				"Behavior change"
			],
			"population": [
				"Adults",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "BFI is used with family members of adults entering individual OCD ERP when accommodation may reinforce rituals, avoidance, or reassurance seeking."
			},
			{
				"title": "What It Tracks",
				"body": "It tracks accommodation targets, alternative responses, expected reactions, rehearsal status, session or follow-up state, and troubleshooting notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate ERP decisions, invent handout content, score symptoms, or expand into a full family therapy program."
			}
		],
		"faqItems": [
			{
				"question": "Is BFI a self-service family tool?",
				"answer": "No. BFI is clinician-delivered, with the family member participating in structured planning and practice."
			},
			{
				"question": "What does the result answer?",
				"answer": "It answers whether the family member has feasible, practiced alternatives to accommodation that can support the patient's ERP."
			},
			{
				"question": "What if no accommodating family member is involved?",
				"answer": "The tool is not applicable when there is no accommodating family member to participate."
			},
			{
				"question": "Can follow-up remain pending?",
				"answer": "Yes. Missed or not-yet-completed follow-up remains visible as pending rather than treated as reviewed."
			}
		]
	},
	{
		"toolType": "behavioralContractingForFamilyAccommodationInOcd2",
		"slug": "behavioral-contracting-for-family-accommodation-in-ocd-2",
		"title": "OCD Reassurance Accommodation Contract Demo | Qwoach",
		"metaDescription": "Explore an OCD response-prevention contract for family reassurance and accommodation targets, agreed responses, gradual steps, and review.",
		"h1": "Behavioral Contracting for OCD Reassurance and Family Accommodation",
		"intro": "Behavioral Contracting for Family Accommodation in OCD is a collaborative response-prevention contract for OCD practitioners, clients, and family members. It helps them agree how relatives will respond to reassurance requests and other OCD demands in a planned, revisable way.",
		"demoTitle": "Create a sample reassurance contract",
		"demoPrompt": "Interested in using Behavioral Contracting for Family Accommodation in OCD with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0107-f-002-ocd-028-r001-behavioral-contracting-for-family-accommodation-in-ocd.md",
		"specId": "0107-f-002-ocd-028-r001-behavioral-contracting-for-family-accommodation-in-ocd",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Family accommodation",
				"Behavior change"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when ERP requires family members to reduce reassurance or other accommodation without abrupt, unclear, or one-sided withdrawal."
			},
			{
				"title": "What It Captures",
				"body": "It captures target requests, old responses, new agreed responses, gradual steps, feared consequences or barriers, status, review dates, and revisions."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create generic coping plans, family motivation judgments, symptom scores, or invented ERP rules."
			}
		],
		"faqItems": [
			{
				"question": "Is this only for reassurance seeking?",
				"answer": "No. It can cover reassurance requests and other family accommodation demands in OCD ERP context."
			},
			{
				"question": "Can abrupt withdrawal concerns be represented?",
				"answer": "Yes. The contract can include gradual withdrawal steps where immediate change is not workable."
			},
			{
				"question": "What makes a target active?",
				"answer": "A target becomes active when there is agreement on the situation covered, the replacement response, and the current step or status."
			},
			{
				"question": "Does the tool write scripts for the family?",
				"answer": "No. The practitioner, client, and family enter the agreed responses; the tool does not invent scripts."
			}
		]
	},
	{
		"toolType": "spaceSupportiveParentingForAnxiousChildhoodEmotionsAccommodationReductionPlan",
		"slug": "space-supportive-parenting-for-anxious-childhood-emotions-accommodation-reduction-plan",
		"title": "SPACE Reassurance Accommodation Plan Demo | Qwoach",
		"metaDescription": "Explore a SPACE parent-only plan for reducing reassurance and accommodation with supportive language, implementation steps, and follow-up review.",
		"h1": "SPACE Supportive Accommodation Reduction Plan Demo",
		"intro": "The SPACE accommodation reduction plan is a practitioner-guided parent-only tool for clinicians working with parents of children or adolescents with OCD or anxiety. It helps parents reduce repeated reassurance and other accommodations while preparing supportive responses and concrete implementation steps.",
		"demoTitle": "Build a sample SPACE plan",
		"demoPrompt": "Interested in using SPACE - Supportive Parenting for Anxious Childhood Emotions accommodation reduction plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0108-f-002-ocd-028-r002-space-supportive-parenting-for-anxious-childhood-emotions-accommodation-reduction-plan.md",
		"specId": "0108-f-002-ocd-028-r002-space-supportive-parenting-for-anxious-childhood-emotions-accommodation-reduction-plan",
		"tags": {
			"framework": [
				"SPACE"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Family accommodation",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when parent-only treatment focuses on reducing repeated reassurance or other accommodations for a child or adolescent with OCD or anxiety."
			},
			{
				"title": "What Parents See",
				"body": "Parents see the active target, supportive response, concrete steps, expected reactions, and troubleshooting notes needed for between-session use."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create child exposure plans, require child self-report, generate SPACE scripts, or make automated judgments about parenting quality."
			}
		],
		"faqItems": [
			{
				"question": "Is there a child-facing workflow?",
				"answer": "No. The child may receive parent communication, but the product is used by the practitioner and parents."
			},
			{
				"question": "What must be entered before a plan is ready?",
				"answer": "A ready plan needs a target accommodation, supportive response, implementation steps, and review structure."
			},
			{
				"question": "Can parents disagree on the target?",
				"answer": "Yes. If parents disagree, the plan remains draft until the target is resolved."
			},
			{
				"question": "Does the tool cover the full SPACE protocol?",
				"answer": "No. It covers the accommodation reduction plan configuration only."
			}
		]
	},
	{
		"toolType": "familyAccommodationReductionPlan",
		"slug": "family-accommodation-reduction-plan",
		"title": "OCD Family Accommodation Reduction Plan Demo | Qwoach",
		"metaDescription": "Explore an OCD family accommodation worksheet with current accommodations, reduction ladder, replacement responses, scripts, and escalation handling.",
		"h1": "Family Accommodation Reduction Plan Demo",
		"intro": "The Family Accommodation Reduction Plan is a worksheet-based OCD planning tool for therapists, clients, and supporters. It helps them map reassurance and other accommodations, order easier-to-harder reduction steps, and agree on compassionate supporter responses for between-session use.",
		"demoTitle": "Complete a sample worksheet",
		"demoPrompt": "Interested in using Family Accommodation Reduction Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0109-f-002-ocd-028-r003-family-accommodation-reduction-plan.md",
		"specId": "0109-f-002-ocd-028-r003-family-accommodation-reduction-plan",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Family accommodation",
				"Behavior change"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when family-supported response prevention needs to become a concrete between-session plan rather than a general discussion."
			},
			{
				"title": "What It Captures",
				"body": "It captures accommodation rows, frequency, OCD fear or ritual links, reduction ladder order, replacement responses, compassionate scripts, start dates, escalation handling, and optional follow-up notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not add unsupported ratings, clinical conclusions, generic family rules, or therapeutic prompts beyond the worksheet structure."
			}
		],
		"faqItems": [
			{
				"question": "Is this a symptom tracker?",
				"answer": "No. It is a worksheet-based accommodation map and graded reduction plan."
			},
			{
				"question": "Why use easier-to-harder steps?",
				"answer": "The worksheet represents graded reduction so accommodation withdrawal is not treated as all-or-nothing."
			},
			{
				"question": "What blocks ready status?",
				"answer": "Missing replacement responses or escalation handling can keep a planned implementation step incomplete."
			},
			{
				"question": "Can adherence notes be added later?",
				"answer": "Yes. Adherence and escalation notes can be collected later as optional follow-up information."
			}
		]
	},
	{
		"toolType": "therapyBlueprintForObsessiveCompulsiveDisorderOcd",
		"slug": "therapy-blueprint-for-obsessive-compulsive-disorder-ocd",
		"title": "Therapy Blueprint For OCD Demo | Qwoach",
		"metaDescription": "Explore an OCD therapy blueprint for relapse prevention with maintaining patterns, therapy learning, skills, goals, warning signs, and setback responses.",
		"h1": "Therapy Blueprint For Obsessive Compulsive Disorder Demo",
		"intro": "Therapy Blueprint For Obsessive Compulsive Disorder is an OCD-specific relapse-prevention and therapy summary worksheet for practitioners and clients. It helps them consolidate OCD maintaining patterns, therapy learning, skills, goals, warning signs, and setback responses as active treatment ends.",
		"demoTitle": "Complete a sample blueprint",
		"demoPrompt": "Interested in using Therapy Blueprint For Obsessive Compulsive Disorder (OCD) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0110-f-002-ocd-029-r001-therapy-blueprint-for-obsessive-compulsive-disorder-ocd.md",
		"specId": "0110-f-002-ocd-029-r001-therapy-blueprint-for-obsessive-compulsive-disorder-ocd",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Goals",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it near the end of OCD therapy or during maintenance planning when the client needs a usable summary for life after regular sessions."
			},
			{
				"title": "What It Captures",
				"body": "It captures OCD maintaining patterns, therapy learning, skills, goals, warning signs, setback responses, follow-up needs, review status, and revisions."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide new diagnosis, relapse prediction, symptom scoring, or therapeutic exercises beyond the supported blueprint structure."
			}
		],
		"faqItems": [
			{
				"question": "When should the blueprint be completed?",
				"answer": "It is completed near the end of OCD therapy when practitioner and client are consolidating learning and preparing for setbacks."
			},
			{
				"question": "Can the client complete sections before review?",
				"answer": "Yes. Client prefill can remain draft until practitioner review when the workflow requires collaborative completion."
			},
			{
				"question": "What does finalizing the blueprint mean?",
				"answer": "Finalizing marks the blueprint as the post-treatment summary while preserving the ability to record later revisions without erasing the original version."
			},
			{
				"question": "Does the tool predict relapse risk?",
				"answer": "No. It does not calculate relapse risk or generate automated clinical interpretation."
			}
		]
	},
	{
		"toolType": "ocdRelapsePreventionPlan",
		"slug": "ocd-relapse-prevention-plan",
		"title": "OCD Relapse Prevention Plan for ERP Maintenance | Qwoach",
		"metaDescription": "Create an OCD flare-response plan for ERP discharge with warning signs, triggers, first-48-hour steps, supports, and booster criteria.",
		"h1": "OCD Relapse Prevention Plan",
		"intro": "OCD Relapse Prevention Plan is a discharge-oriented OCD/ERP worksheet for therapists and other OCD practitioners. It helps a client identify early warning signs, likely flare triggers, previously effective ERP tools, support steps, and criteria for re-engaging care.",
		"demoTitle": "Preview the worksheet, try a sample client response, then review the plan.",
		"demoPrompt": "Interested in using OCD Relapse Prevention Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0111-f-002-ocd-029-r002-ocd-relapse-prevention-plan.md",
		"specId": "0111-f-002-ocd-029-r002-ocd-relapse-prevention-plan",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"OCD",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use near discharge, ERP completion, medication changes, or other identified high-risk periods when a client needs a concrete plan for early symptom return."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures stable OCD themes, costly compulsions, early warning signs, likely triggers, previously effective ERP tools, support contacts, first-48-hours actions, and booster-session criteria."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not assess OCD severity, diagnose relapse, prescribe new ERP exercises, infer risk, or generate clinical instructions that were not entered by the practitioner or client."
			}
		],
		"faqItems": [
			{
				"question": "Is this a symptom tracker?",
				"answer": "No. It is a relapse-prevention and flare-response plan for OCD/ERP maintenance, not a broad symptom tracker."
			},
			{
				"question": "Can the demo be used without entering real client information?",
				"answer": "Yes. The public demo should use fictional or placeholder content only, and sample responses are not saved as real client data."
			},
			{
				"question": "What can the practitioner configure?",
				"answer": "The practitioner can configure an assignment note and optional review timing. The worksheet domains are fixed."
			},
			{
				"question": "Does the result predict whether the client is relapsing?",
				"answer": "No. The result organizes reported warning signs, triggers, response steps, supports, and thresholds without predicting relapse or rating severity."
			}
		]
	},
	{
		"toolType": "relapsePreventionProgramForTreatmentOfObsessiveCompulsiveDisorder",
		"slug": "relapse-prevention-program-for-treatment-of-obsessive-compulsive-disorder",
		"title": "Four-Session OCD Relapse Prevention Program | Qwoach",
		"metaDescription": "Run a post-ERP OCD relapse-prevention program with four practitioner-led sessions, risk planning, coping skills, supports, and setback responses.",
		"h1": "Relapse Prevention Program for Treatment of Obsessive-Compulsive Disorder",
		"intro": "Relapse Prevention Program for Treatment of Obsessive-Compulsive Disorder is a practitioner-delivered post-ERP protocol for OCD clinicians. It helps prepare clients to recognize risk situations and respond to anxiety, ritual urges, stressors, and setbacks with self-exposure, coping strategies, goals, lifestyle planning, social support, and setback responses.",
		"demoTitle": "Explore the four-session program record and sample maintenance strategy.",
		"demoPrompt": "Interested in using Relapse Prevention Program for Treatment of Obsessive-Compulsive Disorder with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0112-f-002-ocd-029-r003-relapse-prevention-program-for-treatment-of-obsessive-compulsive-disorder.md",
		"specId": "0112-f-002-ocd-029-r003-relapse-prevention-program-for-treatment-of-obsessive-compulsive-disorder",
		"tags": {
			"framework": [
				"ERP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"OCD",
				"Relapse prevention",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Led Use",
				"body": "This is a live-session program. Client participation is part of practitioner-guided post-ERP maintenance, not a standalone client workbook."
			},
			{
				"title": "What It Tracks",
				"body": "The record tracks session completion, covered domains, client-reported risks and responses, optional preparation, practitioner notes, and the final maintenance strategy."
			},
			{
				"title": "Important Limits",
				"body": "The system does not invent session scripts, clinical thresholds, new practice steps, relapse probability, or individual efficacy predictions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a single worksheet?",
				"answer": "No. It is a four-session practitioner-delivered post-ERP relapse-prevention program."
			},
			{
				"question": "Can the client complete the full protocol alone?",
				"answer": "No. The primary experience is live-session participation guided by the practitioner; any client-facing entry is limited to assigned preparation."
			},
			{
				"question": "What settings can be saved?",
				"answer": "Session schedule or order, optional session notes, and optional between-session client entry can be saved with the program tool."
			},
			{
				"question": "Does the program generate clinical readiness scores?",
				"answer": "No. It tracks completion and organizes reported risks, skills, goals, supports, and setback plans; practitioner interpretation remains separate."
			}
		]
	},
	{
		"toolType": "youngSchemaQuestionnaireLongForm3rdEditionYsqL3",
		"slug": "young-schema-questionnaire-long-form-3rd-edition-ysq-l3",
		"title": "YSQ-L3 Schema Assessment Demo | Qwoach",
		"metaDescription": "Preview YSQ-L3 administration, 1-6 client ratings, completion validation, scoring, schema profile review, and same-version comparison.",
		"h1": "Young Schema Questionnaire - Long Form, 3rd Edition (YSQ-L3)",
		"intro": "Young Schema Questionnaire - Long Form, 3rd Edition (YSQ-L3) is a long-form schema therapy assessment for schema therapists and clinicians. It helps clients complete 1-6 self-report ratings so the practitioner can review a scored profile across 18 early maladaptive schemas for assessment, case conceptualization, target selection, and baseline comparison.",
		"demoTitle": "Preview the assignment, client rating flow, and scored schema profile.",
		"demoPrompt": "Interested in using Young Schema Questionnaire - Long Form, 3rd Edition (YSQ-L3) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0113-f-003-sch-001-r001-young-schema-questionnaire-long-form-3rd-edition-ysq-l3.md",
		"specId": "0113-f-003-sch-001-r001-young-schema-questionnaire-long-form-3rd-edition-ysq-l3",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Long-Form Use",
				"body": "YSQ-L3 is suited to detailed schema assessment and formulation when broad 18-schema coverage is needed."
			},
			{
				"title": "Review Boundaries",
				"body": "The system calculates supported scores and displays descriptive profile information. Practitioner interpretation, formulation, and target selection remain separate."
			},
			{
				"title": "Comparison Over Time",
				"body": "Prior YSQ-L3 administrations can be compared only when the same instrument version and scoring configuration are preserved."
			}
		],
		"faqItems": [
			{
				"question": "Is YSQ-L3 configurable?",
				"answer": "No. The instrument domains, items, response scale, and scoring are fixed; the practitioner can add context, timing, and comparison display settings."
			},
			{
				"question": "Can incomplete responses be scored?",
				"answer": "Incomplete responses must block or clearly qualify scoring according to supported scoring rules."
			},
			{
				"question": "Does the tool select treatment targets automatically?",
				"answer": "No. It presents a scored schema profile; the practitioner selects or prioritizes targets using clinical judgment."
			},
			{
				"question": "Can the public demo show a result without real client data?",
				"answer": "Yes. The demo can use fictional sample ratings and must not save them as real client assessment data."
			}
		]
	},
	{
		"toolType": "youngSchemaQuestionnaireShortForm3rdEditionYsqS3",
		"slug": "young-schema-questionnaire-short-form-3rd-edition-ysq-s3",
		"title": "YSQ-S3 Short Schema Assessment Demo | Qwoach",
		"metaDescription": "Preview YSQ-S3 short-form schema assessment with 1-6 ratings, completion checks, scoring, condensed profile, and repeated assessment comparison.",
		"h1": "Young Schema Questionnaire - Short Form, 3rd Edition (YSQ-S3)",
		"intro": "Young Schema Questionnaire - Short Form, 3rd Edition (YSQ-S3) is a short-form schema therapy assessment for practitioners and researchers. It helps clients rate selected schema statements on a 1-6 scale so the practitioner can review a condensed profile of probable early maladaptive schema elevations.",
		"demoTitle": "Try the short-form rating flow and review a sample condensed profile.",
		"demoPrompt": "Interested in using Young Schema Questionnaire - Short Form, 3rd Edition (YSQ-S3) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0114-f-003-sch-001-r002-young-schema-questionnaire-short-form-3rd-edition-ysq-s3.md",
		"specId": "0114-f-003-sch-001-r002-young-schema-questionnaire-short-form-3rd-edition-ysq-s3",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Why Short Form",
				"body": "YSQ-S3 is designed for lower-burden schema screening and repeated assessment when the long-form process is not needed."
			},
			{
				"title": "Result Boundaries",
				"body": "The result is a condensed scored profile of probable elevations. It does not diagnose, automatically choose treatment targets, or provide invented interpretation categories."
			},
			{
				"title": "Repeated Assessment",
				"body": "Comparison over time is valid only for same-version YSQ-S3 administrations scored consistently."
			}
		],
		"faqItems": [
			{
				"question": "Is YSQ-S3 the same as YSQ-L3?",
				"answer": "No. YSQ-S3 is the short-form configuration and should be presented as a condensed assessment, not as a substitute for full long-form detail."
			},
			{
				"question": "What does the practitioner configure?",
				"answer": "The practitioner configures intended administration context, due/review timing, and optional longitudinal comparison display."
			},
			{
				"question": "Does the client see schema interpretations automatically?",
				"answer": "No. Client result visibility occurs through the practitioner workflow; automatic interpretation is not part of core completion."
			},
			{
				"question": "What happens to demo responses after saving?",
				"answer": "Demo responses are discarded by default and do not become real client assessment data."
			}
		]
	},
	{
		"toolType": "youngSchemaQuestionnaireRevisedYsqR",
		"slug": "young-schema-questionnaire-revised-ysq-r",
		"title": "YSQ-R Revised Schema Assessment Demo | Qwoach",
		"metaDescription": "Preview YSQ-R administration for revised schema domains, scored profiles, summary tables, printable charts, and optional score tracking.",
		"h1": "Young Schema Questionnaire - Revised (YSQ-R)",
		"intro": "Young Schema Questionnaire - Revised (YSQ-R) is a revised schema assessment for suitably trained clinicians and researchers. It helps clients complete a fixed 116-item questionnaire so the practitioner can review scores, summary tables, schema profile charts, and comparable tracking records across 20 revised early maladaptive schema domains.",
		"demoTitle": "Preview YSQ-R setup, client completion, and profile review.",
		"demoPrompt": "Interested in using Young Schema Questionnaire - Revised (YSQ-R) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0115-f-003-sch-001-r003-young-schema-questionnaire-revised-ysq-r.md",
		"specId": "0115-f-003-sch-001-r003-young-schema-questionnaire-revised-ysq-r",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Revised Assessment",
				"body": "YSQ-R should be used as its own revised-domain instrument and not mixed with YSQ-L3 or YSQ-S3 scoring or interpretation."
			},
			{
				"title": "Tracking",
				"body": "Tracking compares only same-configuration YSQ-R records scored by the same supported method."
			},
			{
				"title": "Review Limits",
				"body": "The system scores, charts, and compares results descriptively. Diagnosis, treatment targeting, and interpretation remain with the practitioner or researcher."
			}
		],
		"faqItems": [
			{
				"question": "How is YSQ-R different from YSQ-L3 or YSQ-S3?",
				"answer": "YSQ-R is a revised schema-domain assessment and should not be treated as interchangeable with legacy YSQ versions."
			},
			{
				"question": "What outputs does the review show?",
				"answer": "The review shows schema scores, a summary table, a profile chart, completion state, printable chart option, and tracking records when enabled."
			},
			{
				"question": "Can the system make treatment recommendations from YSQ-R scores?",
				"answer": "No. The system presents supported scoring and descriptive profiles only; practitioner or researcher interpretation remains separate."
			},
			{
				"question": "Does saving keep demo scores?",
				"answer": "No. Saving keeps the tool and selected setup, not fictional demo responses or sample score records."
			}
		]
	},
	{
		"toolType": "schemaModeInventorySmi11ShortSmi",
		"slug": "schema-mode-inventory-smi-1-1-short-smi",
		"title": "SMI-1.1 Schema Mode Inventory Demo | Qwoach",
		"metaDescription": "Preview adult SMI schema-mode assessment with frequency ratings, 14-mode subscale scoring, profile review, and monitoring comparison.",
		"h1": "Schema Mode Inventory (SMI-1.1 / short SMI)",
		"intro": "Schema Mode Inventory (SMI-1.1 / short SMI) is an adult schema-mode assessment for schema therapists. It helps clients rate mode-related statements on a frequency scale so the practitioner can review subscale scores across 14 schema modes for formulation, treatment planning, intervention selection, and monitoring.",
		"demoTitle": "Preview the adult SMI rating flow and mode profile.",
		"demoPrompt": "Interested in using Schema Mode Inventory (SMI-1.1 / short SMI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0116-f-003-sch-002-r001-schema-mode-inventory-smi-1-1-short-smi.md",
		"specId": "0116-f-003-sch-002-r001-schema-mode-inventory-smi-1-1-short-smi",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Adult Configuration",
				"body": "This tool is the adult SMI-1.1 / short SMI configuration and should not be used as an adolescent or eating-disorder-specific adaptation."
			},
			{
				"title": "What It Measures",
				"body": "The profile distinguishes relative mode presence across multiple schema modes rather than producing a single global distress score."
			},
			{
				"title": "Monitoring",
				"body": "Monitoring comparison requires the same SMI configuration and scoring method."
			}
		],
		"faqItems": [
			{
				"question": "Does SMI produce a diagnosis?",
				"answer": "No. SMI produces subscale scores and a relative mode profile, not a diagnosis."
			},
			{
				"question": "Can the practitioner change the mode set?",
				"answer": "No. The 14-mode structure, items, response scale, and scoring are fixed for the adult SMI configuration."
			},
			{
				"question": "Can results be compared over time?",
				"answer": "Yes, when repeated administrations use the same SMI version and scoring method."
			},
			{
				"question": "Are demo ratings saved after account creation?",
				"answer": "No. Demo ratings and sample profiles are not saved as real client data."
			}
		]
	},
	{
		"toolType": "schemaModeInventoryForAdolescentsSmiA",
		"slug": "schema-mode-inventory-for-adolescents-smi-a",
		"title": "SMI-A Adolescent Schema Mode Assessment Demo | Qwoach",
		"metaDescription": "Preview SMI-A for adolescent schema-mode assessment with Likert ratings, youth mode profile review, completion checks, and monitoring comparison.",
		"h1": "Schema Mode Inventory for Adolescents (SMI-A)",
		"intro": "Schema Mode Inventory for Adolescents (SMI-A) is an age-adapted schema mode assessment for schema therapists and researchers working with youth. It helps adolescents complete Likert ratings so the practitioner can review stronger and weaker schema mode patterns for formulation or treatment monitoring.",
		"demoTitle": "Preview the adolescent rating flow and mode profile.",
		"demoPrompt": "Interested in using Schema Mode Inventory for Adolescents (SMI-A) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0117-f-003-sch-002-r002-schema-mode-inventory-for-adolescents-smi-a.md",
		"specId": "0117-f-003-sch-002-r002-schema-mode-inventory-for-adolescents-smi-a",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Adolescent-Specific Use",
				"body": "SMI-A is an adolescent adaptation and should not be replaced with adult SMI content or interpreted as interchangeable with adult SMI results."
			},
			{
				"title": "What It Produces",
				"body": "The result is a scored youth schema mode profile showing stronger and weaker mode patterns, not a diagnosis or automatic treatment plan."
			},
			{
				"title": "Monitoring",
				"body": "Mode change can be monitored only with comparable same-version SMI-A administrations."
			}
		],
		"faqItems": [
			{
				"question": "Is SMI-A the adult SMI shown to adolescents?",
				"answer": "No. SMI-A is the adolescent adaptation and should be clearly labeled as such."
			},
			{
				"question": "Can the tool add extra youth reflection prompts?",
				"answer": "No. The demo should not add unsupported reflection prompts or psychoeducation beyond the specified inventory experience."
			},
			{
				"question": "Does SMI-A produce treatment recommendations?",
				"answer": "No. It produces scored profile information; practitioner formulation and treatment decisions remain separate."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The SMI-A tool and selected practitioner settings are saved. Fictional adolescent responses and sample profiles are not saved as real data."
			}
		]
	},
	{
		"toolType": "schemaModeInventoryForEatingDisordersShortFormSmiEdSfEnSmiEdSf",
		"slug": "schema-mode-inventory-for-eating-disorders-short-form-smi-ed-sf-en-smi-ed-sf",
		"title": "SMI-ED-SF Eating Disorder Schema Mode Demo | Qwoach",
		"metaDescription": "Preview SMI-ED-SF for eating-disorder schema-mode assessment with Likert ratings, 16-mode scoring, ED-specific profile, and monitoring.",
		"h1": "Schema Mode Inventory for Eating Disorders - Short Form (SMI-ED-SF / EN-SMI-ED-SF)",
		"intro": "Schema Mode Inventory for Eating Disorders - Short Form (SMI-ED-SF / EN-SMI-ED-SF) is a condition-specific schema mode inventory for clinicians and researchers working with eating disorder symptoms or diagnosis. It helps clients complete Likert ratings so the practitioner can review a 16-mode profile that includes general and eating-disorder-specific schema modes.",
		"demoTitle": "Preview the ED-specific rating flow and 16-mode profile.",
		"demoPrompt": "Interested in using Schema Mode Inventory for Eating Disorders - Short Form (SMI-ED-SF / EN-SMI-ED-SF) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0118-f-003-sch-002-r003-schema-mode-inventory-for-eating-disorders-short-form-smi-ed-sf-en-smi-ed-sf.md",
		"specId": "0118-f-003-sch-002-r003-schema-mode-inventory-for-eating-disorders-short-form-smi-ed-sf-en-smi-ed-sf",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Eating disorders",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Condition-Specific Use",
				"body": "This configuration is for eating-disorder-relevant schema mode assessment and should not be used as a generic SMI by default."
			},
			{
				"title": "What It Does Not Capture",
				"body": "The tool does not collect eating behavior logs, weight data, treatment adherence, or eating disorder severity scores outside the inventory."
			},
			{
				"title": "Monitoring",
				"body": "Progress monitoring uses only comparable same-configuration SMI-ED-SF / EN-SMI-ED-SF administrations."
			}
		],
		"faqItems": [
			{
				"question": "Is this an eating disorder severity measure?",
				"answer": "No. It is a schema mode inventory for eating-disorder-relevant formulation and monitoring, not an ED severity scale."
			},
			{
				"question": "What modes are included?",
				"answer": "The tool assesses 16 schema modes, including ED-specific modes such as Eating Disorder Overcontroller and Helpless Surrenderer, where supported by the instrument."
			},
			{
				"question": "Can general SMI results be merged with this profile?",
				"answer": "No. General SMI results should not be merged with ED-specific profiles for direct comparison."
			},
			{
				"question": "Does the public demo collect eating behavior or weight data?",
				"answer": "No. The demo should use fictional inventory ratings only and avoid collecting extra ED data."
			}
		]
	},
	{
		"toolType": "youngParentingInventoryYpi",
		"slug": "young-parenting-inventory-ypi",
		"title": "Young Parenting Inventory Schema-Origin Demo | Qwoach",
		"metaDescription": "Preview YPI caregiver-separated retrospective ratings, substitute caregiver labels, 1-6 scale completion, and schema-origin profile review.",
		"h1": "Young Parenting Inventory (YPI)",
		"intro": "Young Parenting Inventory (YPI) is a retrospective parenting-pattern inventory for schema therapists. It helps clients rate remembered parenting behaviors for mother, father, or substitute caregivers on a 1-6 scale so the practitioner can review caregiver-specific schema-origin patterns alongside active schema assessment.",
		"demoTitle": "Preview caregiver setup, client ratings, and origin profile review.",
		"demoPrompt": "Interested in using Young Parenting Inventory (YPI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0119-f-003-sch-003-r001-young-parenting-inventory-ypi.md",
		"specId": "0119-f-003-sch-003-r001-young-parenting-inventory-ypi",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Clinical history"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Caregiver-Specific Ratings",
				"body": "YPI separates ratings by mother, father, or substitute caregivers so the practitioner can compare patterns where applicable."
			},
			{
				"title": "Formulation Use",
				"body": "The profile supports schema-origin formulation when reviewed alongside active schema assessment; it does not prove historical facts or generate causal conclusions."
			},
			{
				"title": "Handling Non-Applicable Caregivers",
				"body": "Absent or unknown caregivers should be represented without forcing invalid ratings, and labels should persist in the result."
			}
		],
		"faqItems": [
			{
				"question": "Does YPI prove what happened in childhood?",
				"answer": "No. YPI records retrospective client ratings and organizes them for clinical formulation; it does not verify events or judge caregivers."
			},
			{
				"question": "Can substitute caregivers be included?",
				"answer": "Yes. The practitioner can configure substitute caregiver labels when they are relevant to the client's childhood context."
			},
			{
				"question": "Does the tool create treatment steps automatically?",
				"answer": "No. It presents caregiver-specific ratings and supported schema-origin patterns; treatment planning remains practitioner-led."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The YPI tool and caregiver/configuration settings are saved. Fictional caregiver ratings and sample history do not become real client data."
			}
		]
	},
	{
		"toolType": "youngParentingInventoryRevised2YpiR2",
		"slug": "young-parenting-inventory-revised-2-ypi-r2",
		"title": "YPI-R2 Revised Parenting Pattern Assessment Demo | Qwoach",
		"metaDescription": "Preview YPI-R2 father and mother retrospective rating forms, validated subscale scoring, profile comparison, and schema-context review.",
		"h1": "Young Parenting Inventory-Revised 2 (YPI-R2)",
		"intro": "Young Parenting Inventory-Revised 2 (YPI-R2) is a revised validated retrospective parenting-pattern measure for schema therapy practitioners and researchers. It helps clients rate father and mother parenting behaviors so the practitioner or researcher can review empirically structured subscale profiles for schema-related formulation or analysis.",
		"demoTitle": "Preview form setup, client ratings, and father/mother profile review.",
		"demoPrompt": "Interested in using Young Parenting Inventory-Revised 2 (YPI-R2) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0120-f-003-sch-003-r002-young-parenting-inventory-revised-2-ypi-r2.md",
		"specId": "0120-f-003-sch-003-r002-young-parenting-inventory-revised-2-ypi-r2",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Clinical history"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Validated Revised Structure",
				"body": "YPI-R2 uses separate father and mother forms and empirically reduced subscales, rather than the original YPI's informal mapping structure."
			},
			{
				"title": "Comparison Context",
				"body": "When schema measures or clinical outcomes are available, the review may place profiles side by side for examination without generating unsupported conclusions."
			},
			{
				"title": "Non-Applicable Forms",
				"body": "If a father or mother form does not apply, practitioner handling is required so scoring comparability is not distorted by guessed ratings."
			}
		],
		"faqItems": [
			{
				"question": "Is YPI-R2 the same as the original YPI?",
				"answer": "No. YPI-R2 is a revised validated measure with separate father and mother forms and empirically reduced subscale scoring."
			},
			{
				"question": "Can father and mother scores be collapsed into one profile?",
				"answer": "No. Father and mother profiles must remain separate because their scoring structures may differ."
			},
			{
				"question": "Does YPI-R2 explain what caused a client's schemas?",
				"answer": "No. It provides validated subscale patterns for perceived parenting constructs; causal interpretation remains with the practitioner or researcher."
			},
			{
				"question": "What carries over when saving?",
				"answer": "The YPI-R2 tool and selected administration settings carry over. Fictional demo ratings and sample profiles do not become real client data."
			}
		]
	},
	{
		"toolType": "youngParentingInventoryRevised3YpiR3",
		"slug": "young-parenting-inventory-revised-3-ypi-r3",
		"title": "YPI-R3 Schema Therapy Assessment Demo | Qwoach",
		"metaDescription": "Explore the YPI-R3 workflow for caregiver-separated retrospective parenting ratings and ten-subscale schema therapy profile review.",
		"h1": "Young Parenting Inventory-Revised 3 for Schema Therapy Assessment",
		"intro": "Young Parenting Inventory-Revised 3 is a ready-to-send schema therapy assessment questionnaire for practitioners and researchers. It helps organize a client's 1-6 ratings of remembered caregiver behavior into a caregiver-separated ten-subscale parenting-pattern profile.",
		"demoTitle": "Explore the YPI-R3 demo",
		"demoPrompt": "Interested in using Young Parenting Inventory-Revised 3 (YPI-R3) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0121-f-003-sch-003-r003-young-parenting-inventory-revised-3-ypi-r3.md",
		"specId": "0121-f-003-sch-003-r003-young-parenting-inventory-revised-3-ypi-r3",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Clinical history"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "YPI-R3 is used during schema therapy assessment or research when remembered caregiver behavior needs to be represented across specific parenting dimensions rather than summarized as a single childhood-history impression."
			},
			{
				"title": "What It Does Not Conclude",
				"body": "The result does not diagnose the client, prove historical facts, or automatically identify schema origins. It organizes the client's reported ratings into the supported YPI-R3 profile for practitioner interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo require real client history?",
				"answer": "No. The public demo uses fictional responses and placeholder caregiver labels so practitioners can explore the workflow without entering sensitive client information."
			},
			{
				"question": "Can substitute caregivers be included?",
				"answer": "Yes. The tool supports mother, father, or substitute parental figures, with substitute caregivers kept distinct from mother and father labels."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The YPI-R3 tool and selected caregiver setup are saved. Demo responses and fictional profile values are not saved as real client data."
			}
		]
	},
	{
		"toolType": "youngRyghAvoidanceInventoryYrai",
		"slug": "young-rygh-avoidance-inventory-yrai",
		"title": "YRAI Schema Avoidance Inventory Demo | Qwoach",
		"metaDescription": "Explore the YRAI workflow for client 1-6 ratings, high-rated avoidance item review, and schema therapy formulation support.",
		"h1": "Young-Rygh Avoidance Inventory for Schema Avoidance Review",
		"intro": "Young-Rygh Avoidance Inventory is a ready-to-send schema therapy self-report inventory for practitioners. It helps identify high-rated avoidance-related behaviors so the practitioner can discuss how a client may avoid schema-related emotions, memories, or triggers.",
		"demoTitle": "Open the YRAI demo",
		"demoPrompt": "Interested in using Young-Rygh Avoidance Inventory (YRAI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0122-f-003-sch-004-r001-young-rygh-avoidance-inventory-yrai.md",
		"specId": "0122-f-003-sch-004-r001-young-rygh-avoidance-inventory-yrai",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Clinical Use",
				"body": "YRAI supports discussion of concrete avoidant behaviors that may block emotional processing in schema therapy. The practitioner connects results to schemas, emotions, memories, or triggering situations through clinical formulation."
			},
			{
				"title": "Result Boundaries",
				"body": "The review does not explain why the client avoids, assign avoided schemas, diagnose the client, or conclude that low elevated-item counts mean avoidance is absent."
			}
		],
		"faqItems": [
			{
				"question": "Does YRAI have configurable settings?",
				"answer": "No. The YRAI is saved as a fixed assessment tool, even though there are no tool-specific settings to preserve."
			},
			{
				"question": "What does the review emphasize?",
				"answer": "The review emphasizes high-rated avoidance items and supported grouping or total information where defined."
			},
			{
				"question": "Are demo responses saved?",
				"answer": "No. Demo responses are fictional and are discarded when the practitioner saves the tool."
			}
		]
	},
	{
		"toolType": "youngCompensationInventoryYci",
		"slug": "young-compensation-inventory-yci",
		"title": "YCI Schema Overcompensation Demo | Qwoach",
		"metaDescription": "Explore the YCI workflow for client ratings, high-scoring compensatory behavior review, and schema therapy formulation support.",
		"h1": "Young Compensation Inventory for Schema Overcompensation Review",
		"intro": "Young Compensation Inventory is a ready-to-send schema therapy self-report questionnaire for practitioners. It helps identify high-scoring compensatory behaviors so overcompensation patterns can be discussed in case conceptualization and treatment planning.",
		"demoTitle": "Explore the YCI demo",
		"demoPrompt": "Interested in using Young Compensation Inventory (YCI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0123-f-003-sch-005-r001-young-compensation-inventory-yci.md",
		"specId": "0123-f-003-sch-005-r001-young-compensation-inventory-yci",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Helps",
				"body": "YCI helps when the practitioner needs to distinguish schema overcompensation from general assertiveness or unrelated behavior and identify compensatory behaviors specific enough for therapeutic discussion."
			},
			{
				"title": "Review Limits",
				"body": "The review remains descriptive. It does not diagnose the client, classify assertiveness as pathology, or generate schema links without practitioner interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Is YCI configurable?",
				"answer": "No. The YCI is a fixed assessment tool, and saving adds that fixed tool to the practitioner's account."
			},
			{
				"question": "What does the result show?",
				"answer": "The result shows high-scoring compensatory behaviors, item-level ratings, and supported profile outputs where defined."
			},
			{
				"question": "Does the tool generate treatment priorities?",
				"answer": "No. Treatment priorities remain practitioner-led and are not generated automatically by the tool."
			}
		]
	},
	{
		"toolType": "turkishYoungCompensationInventory",
		"slug": "turkish-young-compensation-inventory",
		"title": "Turkish YCI Schema Therapy Demo | Qwoach",
		"metaDescription": "Explore the Turkish YCI workflow for Turkish-language ratings, supported overcompensation profile review, and schema therapy assessment.",
		"h1": "Turkish Young Compensation Inventory for Schema Overcompensation Assessment",
		"intro": "Turkish Young Compensation Inventory is a Turkish-language schema therapy self-report questionnaire for practitioners and researchers. It helps assess schema-driven overcompensation patterns using the Turkish validated YCI configuration and supported score or factor information.",
		"demoTitle": "Explore the Turkish YCI demo",
		"demoPrompt": "Interested in using Turkish Young Compensation Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0124-f-003-sch-005-r002-turkish-young-compensation-inventory.md",
		"specId": "0124-f-003-sch-005-r002-turkish-young-compensation-inventory",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Language-Specific Use",
				"body": "The Turkish YCI is used as its own validated configuration. The demo should not present it as an automatic translation of the English YCI."
			},
			{
				"title": "Comparison Boundaries",
				"body": "English and Turkish YCI administrations should be treated as separate language-specific records unless validated comparability is supplied."
			}
		],
		"faqItems": [
			{
				"question": "Is this the English YCI translated on screen?",
				"answer": "No. The page presents the Turkish YCI as a distinct Turkish-language validated configuration."
			},
			{
				"question": "Can the demo mix English and Turkish responses?",
				"answer": "No. Mixed-language administration is outside the supported configuration unless a supported bilingual procedure is supplied."
			},
			{
				"question": "What is saved?",
				"answer": "The Turkish YCI tool configuration is saved. Fictional demo responses and sample review data are not saved as real data."
			}
		]
	},
	{
		"toolType": "schemaTherapyCaseConceptualizationForm",
		"slug": "schema-therapy-case-conceptualization-form",
		"title": "Schema Therapy Case Form Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only schema therapy case conceptualization form for organizing schemas, modes, triggers, goals, and treatment planning.",
		"h1": "Schema Therapy Case Conceptualization Form for Individual Cases",
		"intro": "Schema Therapy Case Conceptualization Form is a practitioner-only structured formulation tool for schema therapists. It helps organize presenting problems, history, unmet needs, schemas, modes, coping responses, triggers, therapy relationship observations, goals, and treatment planning into a coherent individual case formulation.",
		"demoTitle": "Explore the formulation form",
		"demoPrompt": "Interested in using Schema Therapy Case Conceptualization Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0125-f-003-sch-006-r001-schema-therapy-case-conceptualization-form.md",
		"specId": "0125-f-003-sch-006-r001-schema-therapy-case-conceptualization-form",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning",
				"Clinical documentation"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Workflow",
				"body": "The form is completed by the practitioner. Client information may inform entries through therapy or assessment, but the client does not complete the form as a product interaction."
			},
			{
				"title": "Drafts and Versions",
				"body": "Partial formulations are expected during assessment. The product should preserve submitted or reviewed versions when supervision or certification review requires a stable state."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate schemas or modes?",
				"answer": "No. The practitioner enters and interprets schemas, modes, origins, goals, and interventions."
			},
			{
				"question": "Is there a client form to complete?",
				"answer": "No. This is a practitioner-only formulation form, although a practitioner may share a review version outside the core entry workflow."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed form is saved. Fictional draft content and sample client details are not saved as real client data."
			}
		]
	},
	{
		"toolType": "schemaTherapyCaseConceptualizationFormChildAndAdolescentsStccfCa",
		"slug": "schema-therapy-case-conceptualization-form-child-and-adolescents-stccf-ca",
		"title": "STCCF-CA Schema Therapy Demo | Qwoach",
		"metaDescription": "Explore the STCCF-CA practitioner form for child and adolescent schema therapy formulation, family context, and treatment planning.",
		"h1": "Schema Therapy Case Conceptualization Form for Child and Adolescent Cases",
		"intro": "Schema Therapy Case Conceptualization Form - Child and Adolescents is a practitioner-only formulation form for child and adolescent schema therapy. It helps organize the young client's presentation, developmental context, family factors, schema and mode assessment, needs, and treatment plan for clinical, supervision, or ST-CA review use.",
		"demoTitle": "Explore the STCCF-CA demo",
		"demoPrompt": "Interested in using Schema Therapy Case Conceptualization Form - Child and Adolescents (STCCF-CA) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0126-f-003-sch-006-r002-schema-therapy-case-conceptualization-form-child-and-adolescents-stccf-ca.md",
		"specId": "0126-f-003-sch-006-r002-schema-therapy-case-conceptualization-form-child-and-adolescents-stccf-ca",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning",
				"Clinical documentation"
			],
			"topic": [
				"Goals"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Why This Is Separate From the Adult Form",
				"body": "STCCF-CA is designed for child and adolescent schema therapy formulation, where developmental and family context must be represented rather than substituted with adult-form assumptions."
			},
			{
				"title": "Associated Review Context",
				"body": "The associated ST-CCRS-CA rating scale is separate review context and is not part of the form completion workflow unless added as a separate tool."
			}
		],
		"faqItems": [
			{
				"question": "Do young clients or caregivers complete this form?",
				"answer": "No. The STCCF-CA is practitioner-only; young clients or caregivers may inform the formulation through therapy or assessment outside the product."
			},
			{
				"question": "Can this replace the adult case conceptualization form?",
				"answer": "No. STCCF-CA is the child/adolescent configuration and should not be mixed with adult-form fields unless those fields are part of the child/adolescent form."
			},
			{
				"question": "What is saved?",
				"answer": "The fixed STCCF-CA form is saved. Fictional demo case content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "schemaTherapyModeMap",
		"slug": "schema-therapy-mode-map",
		"title": "Schema Therapy Mode Map Demo | Qwoach",
		"metaDescription": "Explore a collaborative schema therapy mode map canvas for visualizing modes, triggers, needs, relationships, and treatment-focus notes.",
		"h1": "Schema Therapy Mode Map for Collaborative Formulation",
		"intro": "Schema Therapy Mode Map is a collaborative visual formulation tool for schema therapists and clients. It helps make active child, coping, critic or parent, and healthy modes visible, along with triggers, feelings, needs, self-talk, functions, relationships, and treatment-focus annotations.",
		"demoTitle": "Build a sample mode map",
		"demoPrompt": "Interested in using Schema Therapy Mode Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0127-f-003-sch-007-r001-schema-therapy-mode-map.md",
		"specId": "0127-f-003-sch-007-r001-schema-therapy-mode-map",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Collaborative Use",
				"body": "Mode maps are built with the client where appropriate. The practitioner facilitates formulation, while the client contributes lived examples, recognition, corrections, and language that fits their experience."
			},
			{
				"title": "Version History",
				"body": "Maps can evolve as assessment and treatment progress. Prior versions should be preserved when meaning or layout changes substantially."
			},
			{
				"title": "Not a Questionnaire",
				"body": "The tool does not calculate mode scores or convert mode mapping into standardized assessment. It is a visual formulation artifact."
			}
		],
		"faqItems": [
			{
				"question": "Can clients edit the map?",
				"answer": "Yes, if the practitioner enables collaborative in-session editing or suggested edits. Practitioner-controlled sharing remains part of the workflow."
			},
			{
				"question": "Does the map score schema modes?",
				"answer": "No. The map organizes practitioner and client-entered formulation content visually and does not produce standardized mode scores."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool and selected map setup are saved. Fictional mode nodes and sample case content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "schemaTherapyDiary",
		"slug": "schema-therapy-diary",
		"title": "Schema Therapy Diary Demo | Qwoach",
		"metaDescription": "Explore a schema therapy diary for between-session trigger episodes, schema or mode reactions, appraisal, and healthier response review.",
		"h1": "Schema Therapy Diary for Between-Session Activation Episodes",
		"intro": "Schema Therapy Diary is a ready-to-send between-session structured diary for schema therapists and clients. It helps clients record one schema or mode activation episode at a time, including the trigger, emotions, thoughts, behaviors, schema or mode, appraisal, and healthier response.",
		"demoTitle": "Try a sample diary entry",
		"demoPrompt": "Interested in using Schema Therapy Diary with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0128-f-003-sch-008-r001-schema-therapy-diary.md",
		"specId": "0128-f-003-sch-008-r001-schema-therapy-diary",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Skill practice"
			],
			"topic": [
				"Skills use",
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One Episode Per Entry",
				"body": "The diary is structured around a specific activation episode. Keeping one event per entry preserves the link between trigger, reaction, schema or mode, appraisal, and healthier response."
			},
			{
				"title": "Drafts Under Distress",
				"body": "Clients can save partial entries when completing the diary during distress or interruption. Drafts remain marked as incomplete until submitted or reviewed."
			},
			{
				"title": "Pattern Review",
				"body": "Repeated triggers, schema or mode labels, coping reactions, or difficulty generating healthy responses can be summarized descriptively across entries."
			}
		],
		"faqItems": [
			{
				"question": "Does the client need clinician-level formulation skill?",
				"answer": "No. The diary uses structured prompts so the client can organize an episode without needing to formulate like a clinician."
			},
			{
				"question": "Can an entry be saved unfinished?",
				"answer": "Yes. Draft saving is supported because between-session entries may be interrupted or completed under distress."
			},
			{
				"question": "Does the tool identify schemas automatically?",
				"answer": "No. The client may select or enter known labels, and the practitioner interprets the content clinically."
			}
		]
	},
	{
		"toolType": "schemaFlashcards",
		"slug": "schema-flashcards",
		"title": "Schema Flashcards Demo | Qwoach",
		"metaDescription": "Explore schema therapy flashcards for co-creating concise trigger-specific Healthy Adult responses clients can use between sessions.",
		"h1": "Schema Flashcards for Between-Session Healthy Responses",
		"intro": "Schema Flashcards are personalized portable coping cards for schema therapists and clients. They help co-create a short, believable message that names a trigger or schema response and provides a healthier perspective, reality test, evidence, or alternative behavior for use outside sessions.",
		"demoTitle": "Create a sample flashcard",
		"demoPrompt": "Interested in using Schema Flashcards with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0129-f-003-sch-009-r001-schema-flashcards.md",
		"specId": "0129-f-003-sch-009-r001-schema-flashcards",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Short Enough for Activation",
				"body": "The flashcard should be concise enough to read under distress. Longer formulation details can support creation but should not crowd the final card."
			},
			{
				"title": "Active and Retired Cards",
				"body": "Current cards should be easy for the client to find. Superseded cards can be retired without deleting history."
			},
			{
				"title": "Collaborative Wording",
				"body": "The card is authored with practitioner and client input so the message is specific, believable, and clinically grounded."
			}
		],
		"faqItems": [
			{
				"question": "Are Schema Flashcards generic affirmations?",
				"answer": "No. They are personalized schema therapy cards tied to a client's trigger, schema or mode, coping reaction, and healthier response."
			},
			{
				"question": "Can the client suggest changes?",
				"answer": "Yes, if enabled. Client suggestions support later practitioner review and do not replace practitioner-led finalization."
			},
			{
				"question": "What is saved?",
				"answer": "The tool and selected flashcard setup are saved. Fictional demo card content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "audioFlashcards",
		"slug": "audio-flashcards",
		"title": "Audio Flashcards Schema Therapy Demo | Qwoach",
		"metaDescription": "Explore audio schema flashcards for recording personalized Healthy Adult messages clients can replay during triggering moments.",
		"h1": "Audio Flashcards for Schema Therapy Between-Session Support",
		"intro": "Audio Flashcards are recorded voice-message adaptations of schema flashcards for schema therapists and clients. They help turn a personalized trigger-specific Healthy Adult message into audio that the client can replay during schema activation when written prompts are not enough.",
		"demoTitle": "Preview an audio flashcard workflow",
		"demoPrompt": "Interested in using Audio Flashcards with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0130-f-003-sch-009-r002-audio-flashcards.md",
		"specId": "0130-f-003-sch-009-r002-audio-flashcards",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Voice Source",
				"body": "The recording may use the therapist's voice or the client's Healthy Adult voice, depending on the intended clinical use and therapy phase."
			},
			{
				"title": "Quick Playback",
				"body": "The client playback view should be easy to open during activation and should not require completing forms while distressed."
			},
			{
				"title": "Current and Retired Recordings",
				"body": "Active recordings are presented for quick use. Outdated recordings can be retired without deleting history."
			}
		],
		"faqItems": [
			{
				"question": "Are Audio Flashcards session recordings?",
				"answer": "No. Audio Flashcards are short personalized schema flashcard messages, not full session recordings or a general voice-note archive."
			},
			{
				"question": "Can the client record the message?",
				"answer": "Yes. The supported voice source can be therapist voice or the client's Healthy Adult voice."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool and selected audio flashcard setup are saved. Sample audio and fictional scripts are not saved as real client data."
			}
		]
	},
	{
		"toolType": "imageryRescriptingImrs",
		"slug": "imagery-rescripting-imrs",
		"title": "Imagery Rescripting ImRs Session Support Demo | Qwoach",
		"metaDescription": "Explore an ImRs session support tool for schema therapists to document target images, unmet needs, in-image intervention, and review notes.",
		"h1": "Imagery Rescripting (ImRs) session support",
		"intro": "Imagery Rescripting (ImRs) is a live-session schema therapy support tool for therapists working with memories, nightmares, aversive images, fantasies, or future projections that maintain current distress. It helps the practitioner organize the target, unmet needs, in-image intervention, reported shifts, and links to current schema or mode work.",
		"demoTitle": "Explore a sample ImRs session record",
		"demoPrompt": "Interested in using Imagery Rescripting (ImRs) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0131-f-003-sch-010-r001-imagery-rescripting-imrs.md",
		"specId": "0131-f-003-sch-010-r001-imagery-rescripting-imrs",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Clinical documentation",
				"Skill practice"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Live-session boundaries",
				"body": "ImRs is represented as therapist-guided in-session work. The page should not present it as an autonomous client exercise or a score-based assessment."
			},
			{
				"title": "Incomplete sessions",
				"body": "Attempted, paused, or interrupted work can be saved descriptively. If rescripting does not occur, the review must not imply unmet needs were addressed."
			},
			{
				"title": "History use",
				"body": "Prior ImRs records may be shown by target and date for continuity, without comparing them as standardized outcomes."
			}
		],
		"faqItems": [
			{
				"question": "Is this a self-guided imagery exercise for clients?",
				"answer": "No. The tool supports therapist-guided live-session Imagery Rescripting and documentation; the client does not complete a separate product flow."
			},
			{
				"question": "Does the tool score whether ImRs worked?",
				"answer": "No. It provides a descriptive review of phases reached, unmet needs addressed, reported shifts, and practitioner-entered links."
			},
			{
				"question": "Can I use a client-facing view?",
				"answer": "Yes, optionally. The client-facing view should show only simple framing or phase labels selected by the practitioner."
			},
			{
				"question": "What happens if the exercise stops early?",
				"answer": "The record can remain partial and show the phase reached, obstacle notes, and unresolved items without marking the work complete."
			}
		]
	},
	{
		"toolType": "modeDialoguesChairwork",
		"slug": "mode-dialogues-chairwork",
		"title": "Mode Dialogues Chairwork Demo for Schema Therapy | Qwoach",
		"metaDescription": "Explore a schema therapy chairwork support tool for mapping modes to chairs, capturing dialogue notes, and reviewing Healthy Adult responses.",
		"h1": "Mode Dialogues / Chairwork session support",
		"intro": "Mode Dialogues / Chairwork is a live-session schema therapy support tool for therapists guiding clients through embodied dialogue between modes or parts. It helps the practitioner assign modes to chairs, track active positions, capture brief notes, and review mode needs, beliefs, and Healthy Adult responses.",
		"demoTitle": "Build a sample chair map",
		"demoPrompt": "Interested in using Mode Dialogues / Chairwork with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0132-f-003-sch-011-r001-mode-dialogues-chairwork.md",
		"specId": "0132-f-003-sch-011-r001-mode-dialogues-chairwork",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Clinical documentation",
				"Skill practice"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Spatial work stays central",
				"body": "The demo should keep chairs and movement visible as the organizing structure rather than converting the exercise into a flat form."
			},
			{
				"title": "Flexible mode labels",
				"body": "The tool does not require a fixed mode taxonomy. Practitioners can label chairs for the modes or parts relevant to the session."
			},
			{
				"title": "Partial dialogue records",
				"body": "If the session stops early or integration does not emerge, the review shows what was captured so far without implying completion."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool diagnose modes automatically?",
				"answer": "No. Mode labels and interpretations are practitioner-entered; the system only organizes the chair map and sequence."
			},
			{
				"question": "Can chair labels change during a session?",
				"answer": "Yes. Earlier notes retain the label used at the time, and later notes use the updated label."
			},
			{
				"question": "Is there a client worksheet?",
				"answer": "No. The client participates through live movement and speech; a shared view can show only the chair map."
			},
			{
				"question": "What if the client cannot move physically?",
				"answer": "The record can still support symbolic position switching while preserving the chair map."
			}
		]
	},
	{
		"toolType": "instructionsForPuttingTheModeMapOnChairsWorkingWithCriticModes",
		"slug": "instructions-for-putting-the-mode-map-on-chairs-working-with-critic-modes",
		"title": "Critic-Mode Chairwork Preset Demo | Qwoach",
		"metaDescription": "Explore a schema therapy critic-mode chairwork preset for mapping critic messages, child needs, Healthy Adult responses, and take-home notes.",
		"h1": "Instructions for Putting the Mode Map on Chairs working with Critic Modes",
		"intro": "Instructions for Putting the Mode Map on Chairs working with Critic Modes is a live-session schema therapy chairwork preset for therapists working with Inner Critic or Punitive Parent voices. It helps the practitioner map critic, child, observer, and Healthy Adult positions, capture critic messages and vulnerable needs, and review the practiced response and take-home principle.",
		"demoTitle": "Explore the critic-mode preset",
		"demoPrompt": "Interested in using Instructions for Putting the Mode Map on Chairs working with Critic Modes with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0133-f-003-sch-011-r002-instructions-for-putting-the-mode-map-on-chairs-working-with-critic-modes.md",
		"specId": "0133-f-003-sch-011-r002-instructions-for-putting-the-mode-map-on-chairs-working-with-critic-modes",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Clinical documentation",
				"Skill practice"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Preset scope",
				"body": "The tool is specifically for critic-mode chairwork. It should not expand into a general chairwork builder."
			},
			{
				"title": "Take-home response",
				"body": "A take-home principle can be recorded only when formed in the session and reviewed by the practitioner."
			},
			{
				"title": "Incomplete work",
				"body": "If critic externalization, vulnerable needs, or a take-home principle are unresolved, the review shows them as open rather than creating content."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write Healthy Adult responses for the client?",
				"answer": "No. Healthy Adult responses are client- or practitioner-entered from the session; the tool does not generate them."
			},
			{
				"question": "Can multiple critic messages be captured?",
				"answer": "Yes. Multiple messages can be entered under the critic position."
			},
			{
				"question": "Is the observer chair required?",
				"answer": "No. The observer position can be turned on or off in the preset settings."
			},
			{
				"question": "What if the critic voice cannot be externalized safely?",
				"answer": "The record can document the obstacle and stop state without marking the challenge complete."
			}
		]
	},
	{
		"toolType": "instructionsForModeDialoguesWithExternalizingClients",
		"slug": "instructions-for-mode-dialogues-with-externalizing-clients",
		"title": "Externalizing-Client Chairwork Preset Demo | Qwoach",
		"metaDescription": "Explore a schema therapy chairwork preset for externalizing coping modes, observer stance, other-person perspective, vulnerable needs, and balanced response.",
		"h1": "Instructions for mode dialogues with externalizing clients",
		"intro": "Instructions for mode dialogues with externalizing clients is a live-session schema therapy chairwork preset for therapists working with an externalizing or dominant coping mode. It helps the practitioner map coping-mode, observer, other-person, vulnerable or angry child, and balanced-response positions while documenting impact, underlying needs, and revised response attempts.",
		"demoTitle": "Explore the externalizing-client preset",
		"demoPrompt": "Interested in using Instructions for mode dialogues with externalizing clients with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0134-f-003-sch-011-r003-instructions-for-mode-dialogues-with-externalizing-clients.md",
		"specId": "0134-f-003-sch-011-r003-instructions-for-mode-dialogues-with-externalizing-clients",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Clinical documentation",
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Neutral language",
				"body": "The shared view should describe positions without shaming the client or labeling the person as the problem."
			},
			{
				"title": "Rupture or pause states",
				"body": "If engagement drops, the record can show a paused or rupture state and preserve notes without implying the process was completed."
			},
			{
				"title": "Unresolved vulnerability",
				"body": "If vulnerable needs do not emerge, that field remains unresolved and no balanced response is created automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool assign blame for the conflict or behavior?",
				"answer": "No. It maps positions and responses descriptively and does not assign blame or score the client."
			},
			{
				"question": "Can I use only some of the chairs?",
				"answer": "Yes. The practitioner selects which perspective chairs are active for the session."
			},
			{
				"question": "What if the client cannot take the other person's perspective?",
				"answer": "The result records that limitation descriptively without treating it as a scored failure."
			},
			{
				"question": "Is this self-guided for clients?",
				"answer": "No. It is a therapist-guided live-session chairwork preset."
			}
		]
	},
	{
		"toolType": "historicalRolePlay",
		"slug": "historical-role-play",
		"title": "Historical Role Play Schema Therapy Demo | Qwoach",
		"metaDescription": "Explore a schema therapy Historical Role Play support tool for role setup, active-role notes, role reversal, changed meaning, and treatment links.",
		"h1": "Historical Role Play session support",
		"intro": "Historical Role Play is a live-session schema therapy support tool for therapists replaying a childhood or formative interpersonal memory linked to current schemas, modes, meanings, or coping patterns. It helps the practitioner set roles, mark active-role switches, capture emotions and needs, and review new perspective and changed meaning.",
		"demoTitle": "Explore a sample role-play record",
		"demoPrompt": "Interested in using Historical Role Play with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0135-f-003-sch-012-r001-historical-role-play.md",
		"specId": "0135-f-003-sch-012-r001-historical-role-play",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Clinical documentation",
				"Skill practice"
			],
			"topic": [
				"Clinical history"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Role reversal is optional",
				"body": "If role reversal is not clinically used, the result should not require other-perspective material."
			},
			{
				"title": "No memory verification",
				"body": "The tool records client report, enactment notes, and practitioner interpretation separately. It does not determine whether a memory is true."
			},
			{
				"title": "Interrupted work",
				"body": "If the client cannot access the memory or the session stops early, the record remains partial."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic role-play generator?",
				"answer": "No. It supports therapist-guided Historical Role Play for formative interactions linked to schema therapy work."
			},
			{
				"question": "Does the tool decide responsibility or blame?",
				"answer": "No. It records role attributions and perspective shifts entered during processing without scoring responsibility."
			},
			{
				"question": "Can additional roles be added?",
				"answer": "Yes. Additional key figures can be added without changing the tool identity."
			},
			{
				"question": "What if no new perspective emerges?",
				"answer": "The review records unresolved processing rather than fabricating a changed meaning."
			}
		]
	},
	{
		"toolType": "empathicConfrontation",
		"slug": "empathic-confrontation",
		"title": "Empathic Confrontation Support Note Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only schema therapy note for documenting validation, confrontation, client response, and healthier direction after live intervention.",
		"h1": "Empathic Confrontation practitioner support note",
		"intro": "Empathic Confrontation is a live schema therapy practitioner stance for therapists challenging schema-driven coping patterns without shame. This support note helps the practitioner document the target pattern, developmental validation, current cost or limit, client response, and healthier behavior or Healthy Adult direction after or around the live intervention.",
		"demoTitle": "Open a sample support note",
		"demoPrompt": "Interested in using Empathic Confrontation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0136-f-003-sch-013-r001-empathic-confrontation.md",
		"specId": "0136-f-003-sch-013-r001-empathic-confrontation",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Clinical documentation"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-only scope",
				"body": "The product is a support and documentation note. It is not a client worksheet, script generator, or automated recommendation engine."
			},
			{
				"title": "Incomplete notes",
				"body": "If only validation or only confrontation is documented, the review can show the paired intervention as incomplete."
			}
		],
		"faqItems": [
			{
				"question": "Is Empathic Confrontation delivered by the product?",
				"answer": "No. The therapist delivers the live intervention; the product only supports preparation and documentation."
			},
			{
				"question": "Does the tool generate wording for confrontation?",
				"answer": "No. Exact wording remains practitioner-authored."
			},
			{
				"question": "Are there configurable settings?",
				"answer": "No. The fixed support note is saved as-is."
			},
			{
				"question": "Can I document rupture or disengagement?",
				"answer": "Yes. The client response field can capture disengagement, rupture concern, or follow-up needs."
			}
		]
	},
	{
		"toolType": "limitedReparenting",
		"slug": "limited-reparenting",
		"title": "Limited Reparenting Continuity Note Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only schema therapy note for documenting need or mode, bounded response, boundary frame, client response, and follow-up.",
		"h1": "Limited Reparenting practitioner continuity note",
		"intro": "Limited Reparenting is a live schema therapy relational stance for therapists responding to unmet needs and activated modes within a professional frame. This practitioner continuity note helps document the salient need or mode, bounded response, boundary considerations, observed client response, and follow-up for ongoing schema work.",
		"demoTitle": "Open a sample continuity note",
		"demoPrompt": "Interested in using Limited Reparenting with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0137-f-003-sch-014-r001-limited-reparenting.md",
		"specId": "0137-f-003-sch-014-r001-limited-reparenting",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Clinical documentation"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Continuity aid only",
				"body": "The tool supports brief practitioner documentation. It does not perform Limited Reparenting or prescribe relational decisions."
			},
			{
				"title": "Response tags",
				"body": "Care, validation, guidance, confrontation, and limits may be used as optional descriptive tags, not as a required sequence."
			},
			{
				"title": "Boundary clarity",
				"body": "Boundary concerns can be recorded as practitioner notes; the tool does not determine whether a boundary decision is correct."
			}
		],
		"faqItems": [
			{
				"question": "Is Limited Reparenting a client-facing tool here?",
				"answer": "No. The client experiences the therapist's live relational stance; the product is practitioner-only documentation."
			},
			{
				"question": "Does the tool generate reparenting scripts?",
				"answer": "No. It does not generate scripts or prescribe relational responses."
			},
			{
				"question": "Are there configurable settings?",
				"answer": "No. The fixed continuity note is saved as-is."
			},
			{
				"question": "Can I record that mode change was not observed?",
				"answer": "Yes. The note can document that mode change was not observed without implying progress occurred."
			}
		]
	},
	{
		"toolType": "behavioralPatternBreakingWorksheet",
		"slug": "behavioral-pattern-breaking-worksheet",
		"title": "Behavioral Pattern Breaking Worksheet Demo | Qwoach",
		"metaDescription": "Explore a schema therapy worksheet for planned behavior change, expected versus actual distress, Healthy Adult responses, mode observations, and review.",
		"h1": "Behavioral Pattern Breaking worksheet",
		"intro": "The Behavioral Pattern Breaking worksheet is a schema therapy homework and review tool for practitioners and clients working on real-world behavior change. It helps the practitioner assign a schema-linked task, lets the client record expected and actual distress, and supports review of Healthy Adult responses, modes observed, and next steps.",
		"demoTitle": "Try the worksheet demo",
		"demoPrompt": "Interested in using Behavioral Pattern Breaking worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0138-f-003-sch-015-r001-behavioral-pattern-breaking-worksheet.md",
		"specId": "0138-f-003-sch-015-r001-behavioral-pattern-breaking-worksheet",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Coping",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Before and after task moments",
				"body": "The worksheet is designed for partial save: planning may be complete before the real-world attempt, and review may happen later."
			},
			{
				"title": "Repeated attempts",
				"body": "Each attempt is preserved as its own record so graded practice can be reviewed without creating a standardized outcome scale."
			},
			{
				"title": "Unresolved fields",
				"body": "If the client cannot identify modes or a Healthy Adult response, those fields remain unresolved and do not block recording the attempt."
			}
		],
		"faqItems": [
			{
				"question": "Is this a habit tracker?",
				"answer": "No. It is a schema therapy worksheet for comparing prediction and experience in a planned behavior-change task."
			},
			{
				"question": "Does the tool decide whether the attempt succeeded?",
				"answer": "No. It shows the comparison and notes; practitioner and client interpret the learning."
			},
			{
				"question": "Can clients complete it between sessions?",
				"answer": "Yes. In assigned mode, clients can save pre-task planning and return later for post-task completion."
			},
			{
				"question": "What happens if the client does not attempt the task?",
				"answer": "The record remains planned or unattempted and can be revised or carried forward."
			}
		]
	},
	{
		"toolType": "modeClashCardModeClashCards",
		"slug": "mode-clash-card-mode-clash-cards",
		"title": "Mode Clash Card Schema Couples Therapy Demo | Qwoach",
		"metaDescription": "Explore a schema couples therapy Mode Clash Card for mapping partner triggers, modes, coping responses, unmet needs, cycle, and alternatives.",
		"h1": "Mode Clash Card for schema couples therapy",
		"intro": "Mode Clash Card / Mode Clash Cards is a schema couples therapy formulation tool for practitioners working with recurring couple conflicts. It helps the practitioner and partners map each partner's triggers, modes or schemas, coping responses, unmet needs, the reciprocal clash cycle, and alternative responses that could interrupt the pattern.",
		"demoTitle": "Explore a sample Mode Clash Card",
		"demoPrompt": "Interested in using Mode Clash Card / Mode Clash Cards with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0139-f-003-sch-016-r001-mode-clash-card-mode-clash-cards.md",
		"specId": "0139-f-003-sch-016-r001-mode-clash-card-mode-clash-cards",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Coping"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Neutral dyadic formulation",
				"body": "The card should represent both partners equally and locate the pattern in the interactional cycle rather than assigning fault."
			},
			{
				"title": "Disagreement and uncertainty",
				"body": "If partners disagree about the sequence, the tool can hold multiple versions or uncertainty notes."
			},
			{
				"title": "History of cards",
				"body": "Updated cards can be reviewed over time as formulations, not as standardized outcome measurements."
			}
		],
		"faqItems": [
			{
				"question": "Does the Mode Clash Card decide who is at fault?",
				"answer": "No. It maps the reciprocal cycle and avoids partner fault assignments."
			},
			{
				"question": "Can one partner's side be incomplete?",
				"answer": "Yes. The card can mark a side as unresolved or practitioner/client-reported rather than confirmed."
			},
			{
				"question": "Can partners use the card together?",
				"answer": "Yes. Partners can contribute in session under practitioner facilitation and view the shared formulation when the practitioner shares it."
			},
			{
				"question": "Is this a generic conflict log?",
				"answer": "No. It is a schema couples therapy dyadic mode-cycle formulation tool."
			}
		]
	},
	{
		"toolType": "needsVsWantsToolNeedsVersusWantsDiscernmentTool",
		"slug": "needs-vs-wants-tool-needs-versus-wants-discernment-tool",
		"title": "Needs vs. Wants Schema Therapy Tool Demo | Qwoach",
		"metaDescription": "Explore a schema therapy Needs vs. Wants tool for mapping wants, demands, or positions to underlying needs and need-based language.",
		"h1": "Needs vs. Wants discernment tool",
		"intro": "The Needs vs. Wants Tool is a schema therapy and schema couples therapy comparison tool for practitioners working with individuals or couples stuck in demands, conclusions, or negotiating positions. It helps clients distinguish immediate wants from underlying emotional needs and express those needs in language that can guide a more flexible therapeutic conversation.",
		"demoTitle": "Try a needs-versus-wants map",
		"demoPrompt": "Interested in using Needs vs. Wants Tool / Needs Versus Wants discernment tool with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0140-f-003-sch-017-r001-needs-vs-wants-tool-needs-versus-wants-discernment-tool.md",
		"specId": "0140-f-003-sch-017-r001-needs-vs-wants-tool-needs-versus-wants-discernment-tool",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Individual and couple use",
				"body": "The same discernment mechanic supports internal gridlock for individuals and side-by-side entries for couples."
			},
			{
				"title": "Uncertainty support",
				"body": "A want can remain unresolved when the underlying need is not yet clear. The tool should not force a conclusion."
			},
			{
				"title": "Speaker attribution",
				"body": "Needs remain attributed to the client, partner, or practitioner note rather than being treated as system-discovered facts."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool infer hidden needs automatically?",
				"answer": "No. Needs are entered by clients, partners, or the practitioner and remain attributed to their source."
			},
			{
				"question": "Can it be used with couples?",
				"answer": "Yes. Couple layout gives each partner separate space while preserving the same wants-versus-needs comparison."
			},
			{
				"question": "What if a want cannot be linked to a need yet?",
				"answer": "The need can remain unresolved with an uncertainty note."
			},
			{
				"question": "Is this a negotiation tool?",
				"answer": "No. It supports need-versus-want discernment for therapeutic conversation and does not score or manage negotiation outcomes."
			}
		]
	},
	{
		"toolType": "modeCycleClashCards",
		"slug": "mode-cycle-clash-cards",
		"title": "Mode Cycle Clash-cards Demo for Schema Couples Therapy | Qwoach",
		"metaDescription": "Explore a schema couples therapy tool for mapping recurring partner mode cycles, visible reactions, hidden needs, and maintaining loops.",
		"h1": "Mode Cycle Clash-cards for schema couples therapy",
		"intro": "Mode Cycle Clash-cards is a schema couples therapy formulation tool for schema couples therapists. It helps practitioners and partners map a recurring dyadic mode cycle, including each partner's triggers, activated modes, visible coping reactions, hidden needs or emotions, and maintaining responses.",
		"demoTitle": "Open the sample cycle card and try the practitioner, partner, and review views.",
		"demoPrompt": "Interested in using Mode Cycle Clash-cards with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0141-f-003-sch-018-r001-mode-cycle-clash-cards.md",
		"specId": "0141-f-003-sch-018-r001-mode-cycle-clash-cards",
		"tags": {
			"framework": [
				"Schema therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during schema couples therapy when the clinical task is to externalize a repeated reciprocal mode cycle and help partners recognize the loop as shared therapy material."
			},
			{
				"title": "What It Captures",
				"body": "The card captures partner triggers, modes or unresolved mode labels, visible reactions, hidden needs or emotions, interpretations or responses, and maintaining effects on the other partner."
			},
			{
				"title": "Relevant Limits",
				"body": "The result is descriptive organization of the reported and practitioner-entered material. It does not score relationship health, infer mode categories, assign blame, or generate intervention steps."
			}
		],
		"faqItems": [
			{
				"question": "Is this a couples assessment?",
				"answer": "No. Mode Cycle Clash-cards is a schema couples therapy formulation tool for mapping a reciprocal mode cycle, not a stand-alone assessment or relationship score."
			},
			{
				"question": "Can partners complete it without the therapist?",
				"answer": "The client-facing view supports collaborative completion, but the tool is not intended as a stand-alone partner assessment. The practitioner controls the formulation frame and final therapy-facing card."
			},
			{
				"question": "What happens if only one partner's side is complete?",
				"answer": "The card remains partial. The review view marks missing partner sections or loop links and does not present the record as a complete dyadic formulation."
			},
			{
				"question": "Does the system choose mode labels?",
				"answer": "No. Mode labels are entered or confirmed by the practitioner and partners. The product may allow unresolved labels but does not infer mode categories."
			}
		]
	},
	{
		"toolType": "7ColumnThoughtRecord",
		"slug": "7-column-thought-record",
		"title": "7-Column Thought Record Demo for CBT Practitioners | Qwoach",
		"metaDescription": "Explore a CBT thought record for testing automatic thoughts with evidence, balanced appraisal, and before-after mood ratings.",
		"h1": "7-Column Thought Record for CBT cognitive restructuring",
		"intro": "The 7-Column Thought Record is a CBT cognitive restructuring worksheet for CBT practitioners and clients. It helps a client examine a specific distressing situation, compare evidence for and against an automatic thought, create a balanced appraisal, and re-rate mood intensity.",
		"demoTitle": "Try the sample worksheet and review the before-after mood comparison.",
		"demoPrompt": "Interested in using 7-Column Thought Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0142-f-004-cbt-001-r001-7-column-thought-record.md",
		"specId": "0142-f-004-cbt-001-r001-7-column-thought-record",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The record captures a specific situation, mood with intensity, automatic thought, evidence for and against, an alternative balanced thought, and a mood re-rating."
			},
			{
				"title": "Review Limits",
				"body": "The result compares reported mood ratings and shows completion state. It does not label cognitive distortions, judge whether a thought is true, or produce clinical conclusions."
			},
			{
				"title": "Repeat Use",
				"body": "Each completed record remains tied to one distressing situation. History can support later review of multiple records while leaving interpretation to the practitioner."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate a balanced thought for the client?",
				"answer": "No. The client writes the balanced thought. The product structures the worksheet and shows missing fields and rating changes."
			},
			{
				"question": "Can a client save a partial record?",
				"answer": "Yes. Partial records can be saved and resumed, with missing columns shown until the record is complete."
			},
			{
				"question": "Does this include cognitive distortion labels?",
				"answer": "No. Cognitive distortion categories are deliberately not part of this exact tool unless configured outside it as a different thought-record variant."
			},
			{
				"question": "What does the result show?",
				"answer": "The result shows the full seven-column record, the evidence comparison, the alternative appraisal, and the before-after mood rating comparison."
			}
		]
	},
	{
		"toolType": "dysfunctionalThoughtRecord",
		"slug": "dysfunctional-thought-record",
		"title": "Dysfunctional Thought Record Demo for CBT | Qwoach",
		"metaDescription": "Explore a CBT worksheet for recording dysfunctional thoughts, identifying cognitive bias or error, and reviewing balanced alternatives and outcomes.",
		"h1": "Dysfunctional Thought Record for CBT cognitive restructuring",
		"intro": "The Dysfunctional Thought Record is a CBT cognitive restructuring worksheet for CBT practitioners and clients. It helps clients link a dysfunctional automatic thought to a concrete situation and emotion, identify a cognitive bias or error, write a balanced alternative, and record the emotional or behavioral outcome.",
		"demoTitle": "Configure the bias/error field and try the sample client worksheet.",
		"demoPrompt": "Interested in using Dysfunctional Thought Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0143-f-004-cbt-001-r002-dysfunctional-thought-record.md",
		"specId": "0143-f-004-cbt-001-r002-dysfunctional-thought-record",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What Makes It Different",
				"body": "This record centers cognitive bias or error identification. It is not the same as a seven-column evidence worksheet."
			},
			{
				"title": "History And Patterns",
				"body": "When consistent labels are used, prior records can be scanned or grouped by repeated bias/error labels as descriptive history. Treatment meaning remains practitioner interpreted."
			},
			{
				"title": "Relevant Limits",
				"body": "The product does not assign bias labels automatically, define unsupported taxonomies, generate replacement thoughts, or infer pathology."
			}
		],
		"faqItems": [
			{
				"question": "Does the product provide a list of cognitive biases?",
				"answer": "Only if the practitioner provides one. If no list is configured, the bias/error field remains free text or unresolved."
			},
			{
				"question": "Can the system choose the cognitive bias for the client?",
				"answer": "No. The system does not assign bias labels automatically. The client or practitioner enters or selects the label."
			},
			{
				"question": "What if the outcome is not known yet?",
				"answer": "The record can remain pending outcome until the client can report the emotional or behavioral outcome."
			},
			{
				"question": "Can repeated bias labels be reviewed over time?",
				"answer": "Yes. Repeated labels can be grouped descriptively when consistent labels are available, without clinical interpretation by the system."
			}
		]
	},
	{
		"toolType": "cciThoughtDiary3",
		"slug": "cci-thought-diary-3",
		"title": "CCI Thought Diary 3 Demo for CBT Depression Work | Qwoach",
		"metaDescription": "Explore a CBT depression thought diary using the ABCDE sequence to connect situation, beliefs, consequences, disputation, and balanced thought.",
		"h1": "CCI Thought Diary 3 for ABCDE balanced-thought practice",
		"intro": "CCI Thought Diary 3 is a CBT depression thought diary for practitioners and clients using the complete ABCDE sequence. It helps the client record an activating situation, beliefs or automatic thoughts, emotional consequences, disputation or evidence work, and a balanced end-result thought.",
		"demoTitle": "Try the ABCDE sample entry and review the balanced-thought summary.",
		"demoPrompt": "Interested in using CCI Thought Diary 3 with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0144-f-004-cbt-001-r003-cci-thought-diary-3.md",
		"specId": "0144-f-004-cbt-001-r003-cci-thought-diary-3",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after earlier thought monitoring when the client is ready to challenge an unhelpful thought through the complete ABCDE sequence."
			},
			{
				"title": "What It Produces",
				"body": "The result is an ABCDE summary with the balanced end-result thought highlighted as the endpoint."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not score depression, classify distortions, generate balanced thoughts, or transform into earlier thought diary versions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general thought record?",
				"answer": "No. CCI Thought Diary 3 is specifically the complete ABCDE balanced-thought diary, not a generic CBT thought record."
			},
			{
				"question": "Does the tool generate examples or reassurance phrases?",
				"answer": "No. It does not provide substantive examples or reassurance phrases unless supplied by the practitioner or supported source content."
			},
			{
				"question": "What happens if disputation is blank?",
				"answer": "The diary remains incomplete or flagged for practitioner support. A balanced thought is not treated as fully supported without disputation or evidence work."
			},
			{
				"question": "Can clients resume later?",
				"answer": "Yes. Partial entries can be saved and resumed at the next missing ABCDE stage."
			}
		]
	},
	{
		"toolType": "behavioralExperimentBehaviouralExperimentMonitoring",
		"slug": "behavioral-experiment-behavioural-experiment-monitoring",
		"title": "Behavioral Experiment Demo for CBT Practitioners | Qwoach",
		"metaDescription": "Explore a CBT behavioral experiment tool for planning a real-world test, comparing prediction with outcome, ratings, and learning.",
		"h1": "Behavioral Experiment Monitoring for CBT prediction testing",
		"intro": "Behavioral Experiment / Behavioural Experiment Monitoring is a CBT prediction-testing tool for CBT practitioners and clients. It helps them plan a real-world test of a belief, feared outcome, avoidance pattern, or safety behavior, record what happened, compare prediction with outcome, reassess distress or belief, and summarize learning.",
		"demoTitle": "Build a sample experiment, enter the outcome, and review the comparison.",
		"demoPrompt": "Interested in using Behavioral Experiment / Behavioural Experiment Monitoring with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0145-f-004-cbt-002-r001-behavioral-experiment-behavioural-experiment-monitoring.md",
		"specId": "0145-f-004-cbt-002-r001-behavioral-experiment-behavioural-experiment-monitoring",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Behavior change",
				"Safety behaviors"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Partial States",
				"body": "The tool supports planned but not attempted, attempted with outcome incomplete, and completed experiment states because behavioral experiments occur in real life."
			},
			{
				"title": "What It Compares",
				"body": "The review compares the original prediction with the actual outcome and shows before-after distress or belief ratings according to the configured rating focus."
			},
			{
				"title": "Relevant Limits",
				"body": "The product does not generate experiment plans, infer belief validity, label success or failure clinically, or add exposure hierarchy functionality."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create behavioral experiment ideas?",
				"answer": "No. The practitioner and client design the experiment. The product structures the plan, outcome, ratings, and learning."
			},
			{
				"question": "Can an experiment stay pending?",
				"answer": "Yes. A planned experiment can remain pending until the client carries out the real-world test and records outcome fields."
			},
			{
				"question": "What rating options are supported?",
				"answer": "The practitioner can configure distress rating, belief-strength rating, or both as the rating focus."
			},
			{
				"question": "Does the result say whether the belief was disproven?",
				"answer": "No. The result shows prediction, outcome, rating changes, and learning descriptively. Clinical interpretation remains practitioner-led."
			}
		]
	},
	{
		"toolType": "weeklyActivitySchedule",
		"slug": "weekly-activity-schedule",
		"title": "Weekly Activity Schedule Demo for Behavioral Activation | Qwoach",
		"metaDescription": "Explore a CBT behavioral activation schedule for planning activities by day and time across a structured seven-day week.",
		"h1": "Weekly Activity Schedule for CBT behavioral activation",
		"intro": "Weekly Activity Schedule is a CBT and behavioral activation planning tool for practitioners and clients. It helps a depressed or low-activity client create a realistic seven-day timetable of planned activities that supports routine and can later be reviewed against follow-through.",
		"demoTitle": "Open the sample week, add activities, and review the schedule.",
		"demoPrompt": "Interested in using Weekly Activity Schedule with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0146-f-004-cbt-003-r001-weekly-activity-schedule.md",
		"specId": "0146-f-004-cbt-003-r001-weekly-activity-schedule",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Planning, Not Monitoring",
				"body": "This tool is for planned activities. It does not collect mastery, pleasure, mood, or symptom ratings unless another tool is used."
			},
			{
				"title": "Review Use",
				"body": "The planned week can be reviewed later against actual follow-through if follow-through notes are captured, while the core product remains an activity schedule."
			},
			{
				"title": "Mobile Experience",
				"body": "A day-by-day view supports small screens while preserving the seven-day timetable for review."
			}
		],
		"faqItems": [
			{
				"question": "Is this a calendar app?",
				"answer": "No. It is a therapy-oriented weekly activity planning grid, not a general calendar system."
			},
			{
				"question": "Are empty slots errors?",
				"answer": "No. Empty slots are allowed. The product can show empty time descriptively, but adequacy is practitioner interpreted."
			},
			{
				"question": "Does it collect mood or mastery ratings?",
				"answer": "No. Weekly Activity Schedule does not collect ratings; those belong to activity monitoring tools unless separately enabled through another product."
			},
			{
				"question": "What is saved if there are no activities in the demo?",
				"answer": "The tool itself is still saved, along with any selected time-slot configuration. Demo activities are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "activityMonitoringWeeklyForm",
		"slug": "activity-monitoring-weekly-form",
		"title": "Activity Monitoring Weekly Form Demo for CBT | Qwoach",
		"metaDescription": "Explore a CBT activity monitoring form for recording actual weekly activities with mastery, pleasure, accomplishment, or mood ratings.",
		"h1": "Activity Monitoring Weekly Form for CBT behavioral activation",
		"intro": "Activity Monitoring Weekly Form is a CBT and behavioral activation monitoring tool for CBT practitioners and clients. It helps clients record what they actually did during the week and mark activities with supported ratings such as mastery, pleasure, accomplishment, or mood so practitioner and client can review behavior-mood patterns.",
		"demoTitle": "Choose rating dimensions, add sample activities, and view the weekly pattern summary.",
		"demoPrompt": "Interested in using Activity Monitoring Weekly Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0147-f-004-cbt-003-r002-activity-monitoring-weekly-form.md",
		"specId": "0147-f-004-cbt-003-r002-activity-monitoring-weekly-form",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Monitoring, Not Scheduling",
				"body": "The form records actual activities after or during the day. It is not for planning activities ahead of time."
			},
			{
				"title": "Supported Ratings",
				"body": "The practitioner chooses from supported dimensions: mastery/pleasure, accomplishment, mood, or a supported combination."
			},
			{
				"title": "Review Limits",
				"body": "Summaries are descriptive. The product does not infer causality, diagnose depression severity, classify avoidance, or generate behavioral activation targets automatically."
			}
		],
		"faqItems": [
			{
				"question": "Can clients leave time slots blank?",
				"answer": "Yes. Not every slot must be filled. Coverage indicators show how much of the week was captured for review."
			},
			{
				"question": "What happens if an activity has no rating?",
				"answer": "The activity remains visible, but missing ratings are excluded from rating summaries where needed."
			},
			{
				"question": "Can rating dimensions change?",
				"answer": "Yes, but changes should be marked in history because weeks using different rating sets are less directly comparable."
			},
			{
				"question": "Does the tool decide which activities are avoidant or reinforcing?",
				"answer": "No. It shows reported activities and ratings descriptively. Practitioner and client interpret the pattern."
			}
		]
	},
	{
		"toolType": "weeklyGoalsRecord",
		"slug": "weekly-goals-record",
		"title": "Weekly Goals Record Demo for CBT Homework Tracking | Qwoach",
		"metaDescription": "Explore a CBT weekly goals record for tracking homework tasks, daily completion, done status, and fixed 0-4 impact ratings.",
		"h1": "Weekly Goals Record for CBT homework review",
		"intro": "Weekly Goals Record is a CBT homework tracking worksheet for CBT practitioners and clients. It helps practitioners review agreed between-session tasks, intended frequency, Monday-Sunday completion marks, done status, and client-rated 0-4 impact so future homework can be adjusted based on follow-through and usefulness.",
		"demoTitle": "Add sample CBT tasks, mark the week, and review adherence and impact.",
		"demoPrompt": "Interested in using Weekly Goals Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0148-f-004-cbt-004-r001-weekly-goals-record.md",
		"specId": "0148-f-004-cbt-004-r001-weekly-goals-record",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Homework",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Impact Scale",
				"body": "The impact rating is fixed from 0 to 4 and should not be exposed as a configurable setting."
			},
			{
				"title": "Blank Versus Not Done",
				"body": "Blank daily marks are preserved as missing entries. They are not assumed to mean completion or noncompletion."
			},
			{
				"title": "Review Limits",
				"body": "The tool summarizes adherence and reported impact but does not infer clinical progress, generate homework tasks, or recommend treatment changes."
			}
		],
		"faqItems": [
			{
				"question": "Can the practitioner use custom homework tasks?",
				"answer": "Yes. The task list source can be practitioner-entered tasks, predefined local CBT homework categories, or a combination."
			},
			{
				"question": "Can the 0-4 impact scale be changed?",
				"answer": "No. The 0-4 impact scale is fixed by the tool configuration."
			},
			{
				"question": "What happens if a client skips a day?",
				"answer": "The day remains blank unless marked. The product does not assume completion or noncompletion from a blank."
			},
			{
				"question": "Does the tool recommend next week's homework?",
				"answer": "No. It provides adherence and impact information for practitioner-led review and adjustment."
			}
		]
	},
	{
		"toolType": "cciProblemSolvingWorksheet",
		"slug": "cci-problem-solving-worksheet",
		"title": "CCI Problem Solving Worksheet Demo for CBT | Qwoach",
		"metaDescription": "Explore a CBT problem-solving worksheet for defining a problem, comparing solutions, choosing action steps, and reviewing outcomes.",
		"h1": "CCI Problem Solving Worksheet for CBT action planning",
		"intro": "CCI Problem Solving Worksheet is a CBT problem-solving worksheet for CBT practitioners and clients. It helps them define a current psychosocial or practical problem, generate possible solutions, evaluate pros and cons or likely consequences, choose a solution, plan implementation, and review the outcome.",
		"demoTitle": "Work through a sample problem and review the selected action plan.",
		"demoPrompt": "Interested in using CCI Problem Solving Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0149-f-004-cbt-005-r001-cci-problem-solving-worksheet.md",
		"specId": "0149-f-004-cbt-005-r001-cci-problem-solving-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Problem solving",
				"Intervention planning"
			],
			"topic": [
				"Coping",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Plan And Review Lifecycle",
				"body": "The plan phase can be complete while outcome review remains pending until the client has tried the action steps."
			},
			{
				"title": "One Problem At A Time",
				"body": "Each record should focus on one current practical or psychosocial problem. A new problem should use a separate worksheet."
			},
			{
				"title": "Relevant Limits",
				"body": "The product does not generate solutions, score options, provide domain advice, or infer clinical outcomes."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool choose the best solution?",
				"answer": "No. The client and practitioner choose the solution. The product structures options, evaluations, and action planning."
			},
			{
				"question": "Can outcome review happen later?",
				"answer": "Yes. Outcome review can remain pending until after the action steps have been tried."
			},
			{
				"question": "What if only one solution is generated?",
				"answer": "The comparison step remains incomplete unless the practitioner marks that as sufficient. The standard flow asks for multiple possible solutions before selection."
			},
			{
				"question": "Can vague problems be entered?",
				"answer": "A vague problem can be saved as partial, but the product should prompt for a more specific actionable statement before the plan is complete."
			}
		]
	},
	{
		"toolType": "problemSolvingPracticalWorries",
		"slug": "problem-solving-practical-worries",
		"title": "Problem Solving Practical Worries Demo for CBT | Qwoach",
		"metaDescription": "Explore a youth CBT worksheet for turning actionable practical worries into solution options, realistic evaluation, and feasible next steps.",
		"h1": "Problem Solving Practical Worries for youth CBT",
		"intro": "Problem Solving Practical Worries is a CBT worksheet preset for practitioners and young people working on worry or anxiety. It helps them distinguish an actionable practical worry from stuck rumination, generate possible solutions, evaluate options for realism and usefulness, and choose feasible next steps.",
		"demoTitle": "Try the practical-worry flow with fictional sample content.",
		"demoPrompt": "Interested in using Problem Solving Practical Worries with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0150-f-004-cbt-005-r002-problem-solving-practical-worries.md",
		"specId": "0150-f-004-cbt-005-r002-problem-solving-practical-worries",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Problem solving",
				"Intervention planning"
			],
			"topic": [
				"Coping"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Fits",
				"body": "Use it only when the worry includes a practical problem that can be acted on. If it is not actionable, the worksheet should be marked as not a fit and returned to practitioner guidance."
			},
			{
				"title": "Youth-Friendly Collaboration",
				"body": "The flow should stay short, simple, and one step at a time because the supported use is collaborative CBT work with young people."
			},
			{
				"title": "Relevant Limits",
				"body": "The product does not diagnose anxiety, score worry severity, determine rumination automatically, generate solutions, or add unsupported coping content."
			}
		],
		"faqItems": [
			{
				"question": "Is this for all worries?",
				"answer": "No. It is for practical worries that can be acted on. Non-actionable worries should be marked as not a fit for this tool."
			},
			{
				"question": "Does the tool generate solutions for the young person?",
				"answer": "No. Solutions are generated collaboratively by the practitioner and young person."
			},
			{
				"question": "Can unrealistic options stay on the plan?",
				"answer": "Yes. Unrealistic options can remain visible as evaluated options rather than being deleted."
			},
			{
				"question": "Is parent or guardian information required?",
				"answer": "No. Parent or guardian data is not part of the worksheet unless surrounding care context separately requires it."
			}
		]
	},
	{
		"toolType": "7StepProblemSolvingTechnique",
		"slug": "7-step-problem-solving-technique",
		"title": "7 Step Problem-Solving Technique for CBT-Informed Practice | Qwoach",
		"metaDescription": "Explore a CBT-informed seven-step worksheet that helps clients turn practical anxiety or worry problems into action plans and review reflections.",
		"h1": "7 Step Problem-Solving Technique",
		"intro": "The 7 Step Problem-Solving Technique is a CBT-informed guided worksheet for practitioners supporting clients with practical anxiety or worry problems. It helps the client define the problem, compare possible solutions, choose a workable approach, specify actions, and review what happened.",
		"demoTitle": "Start with sample worry and action-plan entries, then switch to the client worksheet or review summary.",
		"demoPrompt": "Interested in using 7 Step Problem-Solving Technique with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0151-f-004-cbt-005-r003-7-step-problem-solving-technique.md",
		"specId": "0151-f-004-cbt-005-r003-7-step-problem-solving-technique",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Problem solving",
				"Intervention planning"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Fits",
				"body": "Use it for practical, actionable worry or anxiety problems. It is not intended for non-actionable worry, symptom severity assessment, diagnosis, or automated recommendations."
			},
			{
				"title": "Review Use",
				"body": "A completed worksheet can be reviewed in session. Original action-plan entries should remain understandable when later reflections or adjustments are added."
			}
		],
		"faqItems": [
			{
				"question": "Is this a scoring tool?",
				"answer": "No. The tool creates a structured worksheet and action plan; it does not score anxiety, diagnose, or judge plan quality."
			},
			{
				"question": "Can a client complete it outside session?",
				"answer": "Yes. The product supports ready-to-send completion as well as in-session co-completion."
			},
			{
				"question": "What makes a worksheet review-ready?",
				"answer": "A review-ready worksheet includes a problem statement, possible solutions, a chosen workable solution, and at least one action with timing or a responsible person where applicable."
			},
			{
				"question": "Does the demo save sample client content?",
				"answer": "No. Demo entries are fictional exploration data and are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "cciGradedTasksAndGradedExposureWorksheet",
		"slug": "cci-graded-tasks-and-graded-exposure-worksheet",
		"title": "Graded Tasks and Graded Exposure Worksheet Demo | Qwoach",
		"metaDescription": "Explore a CBT ladder worksheet for breaking a difficult goal or avoided activity into ordered steps with optional 0-100 ratings.",
		"h1": "CCI Graded Tasks and Graded Exposure Worksheet",
		"intro": "The CCI Graded Tasks and Graded Exposure Worksheet is a CBT planning tool for practitioners and clients working with a difficult goal or avoided activity. It helps them define the goal, add smaller ordered steps, and optionally use 0-100 distress or difficulty ratings to calibrate the ladder.",
		"demoTitle": "Try the sample ladder, change the use type, and view the hierarchy as a client or practitioner.",
		"demoPrompt": "Interested in using CCI Graded Tasks and Graded Exposure Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0152-f-004-cbt-006-r001-cci-graded-tasks-and-graded-exposure-worksheet.md",
		"specId": "0152-f-004-cbt-006-r001-cci-graded-tasks-and-graded-exposure-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Ratings Are Optional",
				"body": "When ratings are on, each rung accepts a 0-100 distress or difficulty rating. When ratings are off, the plan relies on manual order."
			},
			{
				"title": "Review Over Time",
				"body": "The ladder can be revisited as the client works through steps. Historical order and ratings should remain understandable when rungs are changed after attempts."
			}
		],
		"faqItems": [
			{
				"question": "Can this be used for both graded tasks and graded exposure?",
				"answer": "Yes. The same ladder structure can be framed as graded task completion or graded exposure planning."
			},
			{
				"question": "Are 0-100 ratings required?",
				"answer": "No. Ratings are optional; practitioners can turn them on or off for the worksheet."
			},
			{
				"question": "Does the tool decide which step is clinically appropriate?",
				"answer": "No. The system displays order and ratings, but the practitioner and client determine clinical fit."
			},
			{
				"question": "What is required for a review-ready ladder?",
				"answer": "A review-ready ladder needs a goal and at least one ordered step; ratings must be within 0-100 when ratings are enabled."
			}
		]
	},
	{
		"toolType": "exposureHierarchy2",
		"slug": "exposure-hierarchy-2",
		"title": "Exposure Hierarchy Worksheet Demo for CBT Practitioners | Qwoach",
		"metaDescription": "Explore a CBT exposure hierarchy tool for ranking feared or avoided situations with SUDS ratings and safety-behavior notes.",
		"h1": "Exposure Hierarchy",
		"intro": "Exposure Hierarchy is a CBT exposure planning worksheet for therapists and CBT practitioners working with avoidance-oriented anxiety, OCD, panic, social anxiety, or phobias. It helps the client and practitioner list feared or avoided situations, add SUDS ratings, note avoidance or safety behaviors, and organize items into a lower-to-higher distress roadmap.",
		"demoTitle": "Build a sample fear ladder, sort by SUDS as a cue, and review the final manual order.",
		"demoPrompt": "Interested in using Exposure Hierarchy with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0153-f-004-cbt-006-r002-exposure-hierarchy.md",
		"specId": "0153-f-004-cbt-006-r002-exposure-hierarchy",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Safety behaviors"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Manual Order With SUDS Visible",
				"body": "SUDS ratings guide the hierarchy, but the final order can be manually adjusted because clinical sequencing may depend on more than numeric distress."
			},
			{
				"title": "Safety-Behavior Notes",
				"body": "Safety-behavior notes are reported planning information. A blank field is acceptable and should not be treated as proof that no safety behavior exists."
			},
			{
				"title": "History During Review",
				"body": "After exposure work begins, changed ratings or order should preserve prior values so progress and revisions remain understandable."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create exposure tasks for the practitioner?",
				"answer": "No. It organizes practitioner/client-entered feared or avoided situations; it does not generate exposure prescriptions."
			},
			{
				"question": "What scale is used for ratings?",
				"answer": "SUDS ratings are used for each item, and ratings must be within the supported scale range defined by the product implementation."
			},
			{
				"question": "Can items with the same SUDS rating stay in the hierarchy?",
				"answer": "Yes. Items with identical ratings are allowed, and the practitioner can manually order them."
			},
			{
				"question": "Is one item enough to complete the hierarchy?",
				"answer": "No. A one-item hierarchy can be saved as a draft, but a usable progression requires at least two actionable items."
			}
		]
	},
	{
		"toolType": "gradedTaskAssignment",
		"slug": "graded-task-assignment",
		"title": "Graded Task Assignment Worksheet for CBT Practice | Qwoach",
		"metaDescription": "Explore a CBT graded task worksheet that helps clients break a large non-fear-based goal into smaller achievable steps.",
		"h1": "Graded Task Assignment",
		"intro": "Graded Task Assignment is a CBT worksheet for practitioners helping clients who feel overwhelmed, stuck, depressed, avoidant, or unable to start a large non-fear-based goal. It helps the client name the goal, break it into smaller concrete steps, choose an achievable first step, and adjust step size over time.",
		"demoTitle": "Try a sample goal, add step cards, and view the next-step result.",
		"demoPrompt": "Interested in using Graded Task Assignment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0154-f-004-cbt-006-r003-graded-task-assignment.md",
		"specId": "0154-f-004-cbt-006-r003-graded-task-assignment",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Not an Exposure Hierarchy",
				"body": "This tool is for non-fear-based goals. If the target is feared stimuli or exposure work, use an exposure hierarchy instead."
			},
			{
				"title": "Starting Before the Whole Ladder Is Perfect",
				"body": "A plan can be action-ready when the first step is clear, even if later steps remain provisional."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool use SUDS ratings?",
				"answer": "No. SUDS ratings are not part of this tool; difficulty and readiness remain practitioner-guided judgments or notes."
			},
			{
				"question": "Can a client start with only one clear step?",
				"answer": "Yes. A clear first step can be action-ready even while later steps are still rough."
			},
			{
				"question": "What makes the plan incomplete?",
				"answer": "A plan with only the final goal and no smaller step is incomplete because the mechanic requires graded decomposition."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The fixed Graded Task Assignment tool itself is saved as-is, even though there are no substantive settings."
			}
		]
	},
	{
		"toolType": "adjustingNegativeCoreBeliefs",
		"slug": "adjusting-negative-core-beliefs",
		"title": "Adjusting Negative Core Beliefs Worksheet Demo | Qwoach",
		"metaDescription": "Explore a CBT worksheet for evaluating an old negative core belief, forming a balanced belief, and planning behavior experiments.",
		"h1": "Adjusting Negative Core Beliefs",
		"intro": "Adjusting Negative Core Beliefs is a CBT worksheet for practitioners and clients working on low self-esteem or entrenched negative self-beliefs. It helps them state one old negative core belief, record conviction and emotions, examine evidence and alternative interpretations, form a balanced belief, and plan behaviors or experiments to gather new evidence.",
		"demoTitle": "Explore a fictional worksheet, compare old and balanced belief fields, and review the planned experiment summary.",
		"demoPrompt": "Interested in using Adjusting Negative Core Beliefs with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0155-f-004-cbt-007-r001-adjusting-negative-core-beliefs.md",
		"specId": "0155-f-004-cbt-007-r001-adjusting-negative-core-beliefs",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Cognitive restructuring",
				"Core beliefs"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Use After Belief Identification",
				"body": "The worksheet assumes one target core belief has already been identified. If no specific belief is available, the worksheet should remain incomplete."
			},
			{
				"title": "Reported Ratings Only",
				"body": "Conviction ratings are displayed as client-reported data. The system compares displayed values but does not conclude that belief change has occurred."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate balanced beliefs?",
				"answer": "No. The practitioner and client enter the balanced belief; the system does not generate beliefs."
			},
			{
				"question": "Can one worksheet cover multiple beliefs?",
				"answer": "No. One worksheet targets one old core belief. Multiple beliefs should use separate worksheets."
			},
			{
				"question": "Are planned behaviors or experiments required?",
				"answer": "Yes. A worksheet can be drafted without them, but planned behaviors or experiments are part of the supported success criteria."
			},
			{
				"question": "What if the rating scale wording is not validated?",
				"answer": "The product should not invent exact scale labels or anchors; it should use validated wording or mark the scale wording as unresolved."
			}
		]
	},
	{
		"toolType": "coreBeliefs",
		"slug": "core-beliefs",
		"title": "Core Beliefs Identification Worksheet Demo | Qwoach",
		"metaDescription": "Explore a CBT worksheet that helps clients identify negative core belief themes linked to mood, anxiety, or relationship patterns.",
		"h1": "Core Beliefs",
		"intro": "Core Beliefs is a CBT worksheet for therapists and practitioners helping clients understand and identify negative core beliefs linked to mood, anxiety, or relationship patterns. It introduces core-belief functioning, separates examples from client-entered beliefs, and supports later belief-level CBT work.",
		"demoTitle": "Review the identification flow, add tentative fictional beliefs, and view the formulation summary.",
		"demoPrompt": "Interested in using Core Beliefs with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0156-f-004-cbt-007-r002-core-beliefs.md",
		"specId": "0156-f-004-cbt-007-r002-core-beliefs",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Core beliefs"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Identification Only",
				"body": "This tool identifies negative core beliefs. It does not evaluate evidence, form balanced beliefs, rate conviction, or plan experiments."
			},
			{
				"title": "Emotionally Charged Material",
				"body": "The experience supports pause and resume and is intended for in-session or closely supported work when sensitive material emerges."
			}
		],
		"faqItems": [
			{
				"question": "Does this worksheet restructure beliefs?",
				"answer": "No. It identifies negative core beliefs and prepares for later belief-level work."
			},
			{
				"question": "Can the client mark a belief as uncertain?",
				"answer": "Yes. Tentative marking is supported so exploratory material does not have to be treated as final."
			},
			{
				"question": "What happens if the client enters a situation-specific thought?",
				"answer": "The tool can prompt for whether a broader belief is underneath, but it should not rewrite the entry automatically."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The fixed Core Beliefs tool itself is saved as-is; demo reflections are not saved as real client data."
			}
		]
	},
	{
		"toolType": "coreBeliefsExaminingTheEvidence",
		"slug": "core-beliefs-examining-the-evidence",
		"title": "Core Beliefs Evidence Worksheet Demo | Qwoach",
		"metaDescription": "Explore a CBT worksheet for reviewing evidence for and against one identified core belief, including discounted contradictory evidence.",
		"h1": "Core Beliefs: Examining the Evidence",
		"intro": "Core Beliefs: Examining the Evidence is a CBT worksheet for therapists and practitioners working with a client who has already identified a core belief. It helps the client list evidence supporting the belief, evidence against it, and contradictory evidence they may have ignored, rejected, or discounted.",
		"demoTitle": "Try the sample evidence table and view how the result keeps evidence categories separate.",
		"demoPrompt": "Interested in using Core Beliefs: Examining the Evidence with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0157-f-004-cbt-007-r003-core-beliefs-examining-the-evidence.md",
		"specId": "0157-f-004-cbt-007-r003-core-beliefs-examining-the-evidence",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Cognitive restructuring",
				"Core beliefs"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Requires a Target Belief",
				"body": "This worksheet starts after a core belief has been identified. Without a target belief, the tool should route back to identification work or remain a draft."
			},
			{
				"title": "No Automated Conclusion",
				"body": "The result keeps evidence categories visible but does not determine the belief's validity or score the evidence."
			}
		],
		"faqItems": [
			{
				"question": "Can this tool identify core beliefs?",
				"answer": "No. It requires a core belief that has already been identified."
			},
			{
				"question": "Can one worksheet examine multiple beliefs?",
				"answer": "No. One worksheet examines one target core belief; multiple beliefs should use separate worksheets."
			},
			{
				"question": "Is confirming evidence alone enough?",
				"answer": "No. A worksheet with only confirming evidence remains incomplete for this Job because non-confirming or discounted contradictory evidence is required."
			},
			{
				"question": "Does the system generate contradictory evidence?",
				"answer": "No. The client and practitioner provide the evidence; the system only organizes it."
			}
		]
	},
	{
		"toolType": "cciEarlyWarningSignsWorksheetCbtForPsychoticSymptoms",
		"slug": "cci-early-warning-signs-worksheet-cbt-for-psychotic-symptoms",
		"title": "Early Warning Signs Worksheet for Psychotic Symptoms | Qwoach",
		"metaDescription": "Explore a clinician-guided worksheet for identifying personal early warning signs and stressors for psychotic relapse-prevention planning.",
		"h1": "CCI Early Warning Signs Worksheet (CBT for Psychotic Symptoms)",
		"intro": "CCI Early Warning Signs Worksheet for CBT for Psychotic Symptoms is a clinician-guided worksheet for clients with psychotic symptoms or risk of psychotic relapse. It helps clinician and client identify personal signs of becoming unwell across behavior, thoughts, feelings, relationships or social functioning, significant-other observations, and life stressors.",
		"demoTitle": "Explore the fixed domain map with fictional warning signs and review the profile summary.",
		"demoPrompt": "Interested in using CCI Early Warning Signs Worksheet (CBT for Psychotic Symptoms) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0158-f-004-cbt-008-r001-cci-early-warning-signs-worksheet-cbt-for-psychotic-symptoms.md",
		"specId": "0158-f-004-cbt-008-r001-cci-early-warning-signs-worksheet-cbt-for-psychotic-symptoms",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Psychosis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Profile, Not Prediction",
				"body": "The tool creates a warning-sign profile. It does not predict relapse, assign risk level, or prescribe a response."
			},
			{
				"title": "Reported Outside Observations",
				"body": "Significant-other observations are recorded as reported information unless a separate third-party workflow exists."
			},
			{
				"title": "Handoff to Prevention Planning",
				"body": "The profile can be linked to a separate self-management or relapse-prevention plan without merging the tools."
			}
		],
		"faqItems": [
			{
				"question": "Can some domains be blank?",
				"answer": "Yes. Domains can be blank or explicitly marked no sign identified; entries should not be forced."
			},
			{
				"question": "Does this tool calculate relapse risk?",
				"answer": "No. It organizes personalized signs and stressors but does not calculate risk or make triage decisions."
			},
			{
				"question": "Can the worksheet be paused?",
				"answer": "Yes. Partial profiles should persist because recalling warning signs may require time or input from others."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The fixed worksheet itself is saved as-is; demo profile content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "cciEarlyWarningSignsWorksheetKeepingYourBalanceBipolarDisorder",
		"slug": "cci-early-warning-signs-worksheet-keeping-your-balance-bipolar-disorder",
		"title": "Bipolar Early Warning Signs Worksheet Demo | Qwoach",
		"metaDescription": "Explore a four-quadrant worksheet for identifying personal mild and moderate depression and mood elevation warning signs.",
		"h1": "CCI Early Warning Signs Worksheet (Keeping Your Balance / Bipolar Disorder)",
		"intro": "CCI Early Warning Signs Worksheet for Keeping Your Balance / Bipolar Disorder is a relapse-prevention worksheet for clinicians, doctors, mental health professionals, and clients monitoring bipolar relapse risk. It helps the client record personal signs of mild depression, moderate depression, mild mood elevation, and moderate mood elevation.",
		"demoTitle": "Explore the four-quadrant profile with fictional signs and review what would be discussed with a practitioner.",
		"demoPrompt": "Interested in using CCI Early Warning Signs Worksheet (Keeping Your Balance / Bipolar Disorder) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0159-f-004-cbt-008-r002-cci-early-warning-signs-worksheet-keeping-your-balance-bipolar-disorder.md",
		"specId": "0159-f-004-cbt-008-r002-cci-early-warning-signs-worksheet-keeping-your-balance-bipolar-disorder",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Between-session monitoring",
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Bipolar disorder"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Four Fixed Quadrants",
				"body": "The worksheet distinguishes depression from mood elevation and mild from moderate changes. The structure should not be reconfigured."
			},
			{
				"title": "Unknown Is Allowed",
				"body": "A quadrant can be marked unknown or no signs identified so clients are not pressured to invent signs."
			},
			{
				"title": "Action Plan Handoff",
				"body": "The warning-sign profile can inform a separate action plan, but the action plan itself is not part of this worksheet."
			}
		],
		"faqItems": [
			{
				"question": "Does this worksheet track current mood?",
				"answer": "No. It captures personal warning signs; it does not classify current mood or track symptoms over time."
			},
			{
				"question": "Can a quadrant be blank?",
				"answer": "Yes. A quadrant can be explicitly marked unknown or no signs identified."
			},
			{
				"question": "Can the worksheet use the client's own wording?",
				"answer": "Yes. Client language is allowed while preserving the fixed elevated-mood and depressive quadrants."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The fixed four-quadrant worksheet itself is saved as-is; sample demo signs are not saved as real client data."
			}
		]
	},
	{
		"toolType": "cciSelfManagementPlan",
		"slug": "cci-self-management-plan",
		"title": "CCI Self-Management Plan for Bipolar Maintenance Planning | Qwoach",
		"metaDescription": "Explore a bipolar maintenance plan for warning signs, prevention actions, coping strategies, balanced thoughts, and support options.",
		"h1": "CCI Self-Management Plan",
		"intro": "CCI Self-Management Plan is a CBT-oriented maintenance planning tool for practitioners working with clients preparing to manage future bipolar relapse-risk signs. It helps the client record warning signs, prevention actions, likely problem situations, responses to family or friend feedback, helpful strategies, balanced thoughts, and support contacts.",
		"demoTitle": "Explore the sample maintenance plan, complete required sections, and review the quick-reference result.",
		"demoPrompt": "Interested in using CCI Self-Management Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0160-f-004-cbt-009-r001-cci-self-management-plan.md",
		"specId": "0160-f-004-cbt-009-r001-cci-self-management-plan",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Coping",
				"Bipolar disorder"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Maintenance Consolidation",
				"body": "The plan is intended to consolidate strategies already learned or identified. If those strategies are not available yet, the plan should remain not ready rather than invent content."
			},
			{
				"title": "Support Options Are Entered, Not Contacted",
				"body": "Support contacts or help-seeking options are listed as client-entered plan content. The tool does not contact anyone or send alerts."
			},
			{
				"title": "Reviewed Versions",
				"body": "After review, later updates should create a clearly revised plan while preserving the previous reviewed version."
			}
		],
		"faqItems": [
			{
				"question": "Is this a daily mood tracker?",
				"answer": "No. It is a maintenance-plan consolidator, not a continuous tracker or assessment."
			},
			{
				"question": "Does the tool decide when escalation is needed?",
				"answer": "No. It records support options but does not rank urgency, determine escalation, or automate triage."
			},
			{
				"question": "What sections are required for completion?",
				"answer": "A complete plan includes warning signs, prevention actions, coping or helpful strategies, balanced thoughts, and support options."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The fixed Self-Management Plan tool itself is saved as-is; demo entries and fictional support contacts are not saved as real client data."
			}
		]
	},
	{
		"toolType": "aimsCenterMyRelapsePreventionPlan",
		"slug": "aims-center-my-relapse-prevention-plan",
		"title": "AIMS Center My Relapse Prevention Plan Demo | Qwoach",
		"metaDescription": "Explore a Collaborative Care relapse-prevention plan with warning signs, PHQ-9/GAD-7 thresholds, maintenance actions, and escalation contacts.",
		"h1": "AIMS Center My Relapse Prevention Plan",
		"intro": "AIMS Center My Relapse Prevention Plan is a Collaborative Care relapse-prevention and self-management planning tool for Behavioral Health Care Managers and care teams. It helps the practitioner and patient create a concrete post-care arrangement for warning signs, helpful actions, PHQ-9/GAD-7 monitoring thresholds, review timing, medication maintenance where relevant, and care-team escalation contacts.",
		"demoTitle": "Explore the plan with sample patient details",
		"demoPrompt": "Interested in using AIMS Center My Relapse Prevention Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0161-f-004-cbt-009-r002-aims-center-my-relapse-prevention-plan.md",
		"specId": "0161-f-004-cbt-009-r002-aims-center-my-relapse-prevention-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Medication adherence",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it in the months before completing Collaborative Care or behavioral health treatment, when the team wants continuity safeguards for symptom worsening and re-engagement."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures storage and sharing details, review timing, warning signs, helpful actions, PHQ-9/GAD-7 threshold instructions, medication maintenance where relevant, and care-team escalation contacts."
			},
			{
				"title": "Limits of the Result",
				"body": "The tool organizes a plan and compares responses to practitioner-entered thresholds. It does not diagnose relapse, predict risk, or interpret PHQ-9/GAD-7 scores beyond the supplied thresholds."
			}
		],
		"faqItems": [
			{
				"question": "Is this a questionnaire or a relapse-prevention plan?",
				"answer": "It is a relapse-prevention plan. PHQ-9 and GAD-7 responses support monitoring thresholds, but the primary result is a shared self-management and escalation plan."
			},
			{
				"question": "Who completes the plan?",
				"answer": "The patient completes it with a Behavioral Health Care Manager or care team member near the end of care."
			},
			{
				"question": "Can the medication section be skipped?",
				"answer": "Yes. Medication section applicability is a supported setting, so medication maintenance details can be required or marked not applicable."
			},
			{
				"question": "Does the demo require real patient information?",
				"answer": "No. The public demo uses fictional and placeholder content, and sample case data is not saved as real client data."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The tool itself and supported practitioner setup are saved, including selected settings, thresholds, contacts, review cadence, and sharing/location setup."
			}
		]
	},
	{
		"toolType": "cbtHubKeepingWellPlan",
		"slug": "cbt-hub-keeping-well-plan",
		"title": "CBT Hub Keeping Well Plan Demo for Therapists | Qwoach",
		"metaDescription": "Explore a youth CBT keeping-well plan for therapy endings, with learned CBT skills, signs of difficulty, and coping or support steps.",
		"h1": "CBT Hub Keeping Well Plan",
		"intro": "CBT Hub Keeping Well Plan is a youth-focused CBT transition-out-of-therapy worksheet for therapists. It helps a young person record the CBT techniques they learned, signs that things are becoming difficult, and coping or support steps to use after regular therapy ends.",
		"demoTitle": "Explore the sample keeping-well plan",
		"demoPrompt": "Interested in using CBT Hub Keeping Well Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0162-f-004-cbt-009-r003-cbt-hub-keeping-well-plan.md",
		"specId": "0162-f-004-cbt-009-r003-cbt-hub-keeping-well-plan",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Skills use",
				"Coping"
			],
			"population": [
				"Adolescents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it as regular CBT sessions are ending, when a young person needs a clear reminder of what to keep using outside therapy."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures learned CBT techniques, signs that difficulties are returning, and coping or support steps."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool is not a safety plan, assessment, scoring tool, or generic wellbeing app. It does not add unsupported prompts beyond the supported keeping-well categories."
			}
		],
		"faqItems": [
			{
				"question": "Is this tool for young people leaving CBT?",
				"answer": "Yes. It is a youth-focused CBT keeping-well plan for transition out of therapy."
			},
			{
				"question": "Can the young person complete it independently?",
				"answer": "Yes. Completion mode can be sent for independent completion or completed together in session."
			},
			{
				"question": "Does the tool score readiness or symptoms?",
				"answer": "No. It organizes the young person's CBT skills, signs of difficulty, and coping or support steps without scoring or clinical interpretation."
			},
			{
				"question": "What happens to demo entries when I save?",
				"answer": "Demo entries are not saved as real client data. Only the tool and selected practitioner setup are saved."
			}
		]
	},
	{
		"toolType": "decisionalBalanceWorksheetDbw",
		"slug": "decisional-balance-worksheet-dbw",
		"title": "Decisional Balance Worksheet Demo for Practitioners | Qwoach",
		"metaDescription": "Explore a four-quadrant decisional balance worksheet for behavior-change ambivalence, with pros and cons of changing and not changing.",
		"h1": "Decisional Balance Worksheet (DBW)",
		"intro": "Decisional Balance Worksheet (DBW) is a behavior-change and motivational interviewing worksheet for practitioners working with a patient or client who is considering change but remains ambivalent. It helps the practitioner and client organize reasons for not changing, reasons against not changing, reasons for changing, reasons against changing, and optional readiness information.",
		"demoTitle": "Try the four-quadrant worksheet",
		"demoPrompt": "Interested in using Decisional Balance Worksheet (DBW) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0163-f-004-cbt-010-r001-decisional-balance-worksheet-dbw.md",
		"specId": "0163-f-004-cbt-010-r001-decisional-balance-worksheet-dbw",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the client is considering a behavior change but remains ambivalent or not yet committed."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures the target behavior, reasons connected to not changing and changing, perceived barriers or costs, strengths or motivations, and optional readiness."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not score the decision, predict success, diagnose, or generate a behavior-change plan."
			}
		],
		"faqItems": [
			{
				"question": "Does DBW tell the client what choice to make?",
				"answer": "No. It organizes ambivalence in a balanced matrix and leaves interpretation and next steps to the practitioner-client conversation."
			},
			{
				"question": "Is readiness required?",
				"answer": "No. Readiness is optional and can be included or omitted by the practitioner."
			},
			{
				"question": "Can blank quadrants be left blank?",
				"answer": "Yes. Blank quadrants remain visible without implying failure, although the practitioner may use them as discussion points."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The DBW tool itself and selected configuration are saved. Sample client entries and demo readiness values are not saved as real client data."
			}
		]
	},
	{
		"toolType": "theChangeProcessBalanceSheet",
		"slug": "the-change-process-balance-sheet",
		"title": "Change Process Balance Sheet Demo for CBT Practitioners | Qwoach",
		"metaDescription": "Explore a psychosis-focused CBT balance sheet for current problem costs, positive aspects, benefits of changing, and costs of changing.",
		"h1": "The Change Process Balance Sheet",
		"intro": "The Change Process Balance Sheet is a CBT for psychotic symptoms worksheet for practitioners working with a patient whose motivation for therapy or symptom-related change is uncertain or fluctuating. It helps the therapist and patient define the current problem and record negative consequences of the current problem, positive aspects of the current problem, personal benefits expected from changing, and personal.",
		"demoTitle": "Explore the four-part balance sheet",
		"demoPrompt": "Interested in using The Change Process Balance Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0164-f-004-cbt-010-r002-the-change-process-balance-sheet.md",
		"specId": "0164-f-004-cbt-010-r002-the-change-process-balance-sheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Psychosis",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when motivation for therapy or symptom-related change is uncertain or fluctuating during CBT engagement."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures the current problem, negative consequences, positive aspects or perceived gains, personal benefits of changing, and personal costs or fears of changing."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not interpret psychotic symptoms, score motivation, infer insight, or generate change targets automatically."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as a generic pros-and-cons worksheet?",
				"answer": "No. It preserves the specific four-prompt Change Process Balance Sheet structure for CBT engagement around a current problem."
			},
			{
				"question": "Can it be revisited later?",
				"answer": "Yes. First completion versus revisit is a supported setting, and prior entries can be shown when revisiting motivation."
			},
			{
				"question": "Does the tool score motivation?",
				"answer": "No. It organizes patient-reported motivational material without scoring or clinical conclusions."
			},
			{
				"question": "Does sample demo content carry into my account?",
				"answer": "No. Saving keeps the tool and supported setup, not the fictional demo formulation."
			}
		]
	},
	{
		"toolType": "smartRecoveryCostBenefitAnalysisCba",
		"slug": "smart-recovery-cost-benefit-analysis-cba",
		"title": "SMART Recovery CBA Demo for Recovery Facilitators | Qwoach",
		"metaDescription": "Explore a recovery-focused CBA worksheet for benefits and costs of doing or not doing a behavior, with short-term and long-term labels.",
		"h1": "SMART Recovery Cost-Benefit Analysis (CBA)",
		"intro": "SMART Recovery Cost-Benefit Analysis (CBA) is a recovery-focused decision worksheet for practitioners and recovery facilitators supporting someone whose motivation about an addictive or concerning behavior feels mixed or unstable. It helps the participant name a specific behavior, list benefits and costs of doing it and not doing it, label entries short-term or long-term, and review the tradeoff pattern.",
		"demoTitle": "Try the CBA with sample entries",
		"demoPrompt": "Interested in using SMART Recovery Cost-Benefit Analysis (CBA) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0165-f-004-cbt-010-r003-smart-recovery-cost-benefit-analysis-cba.md",
		"specId": "0165-f-004-cbt-010-r003-smart-recovery-cost-benefit-analysis-cba",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when motivation about an addictive or concerning behavior feels mixed or unstable and the participant wants to examine tradeoffs."
			},
			{
				"title": "What It Captures",
				"body": "The CBA captures the target behavior, benefits and costs of doing it, benefits and costs of not doing it, and whether each entry is short-term or long-term."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not diagnose addiction severity, rank values, calculate a decision score, or produce recovery advice."
			}
		],
		"faqItems": [
			{
				"question": "Does the CBA recommend whether to stop a behavior?",
				"answer": "No. It organizes tradeoffs and time horizons so the participant and facilitator can review them together."
			},
			{
				"question": "Are short-term and long-term labels required?",
				"answer": "Entries can be labeled short-term or long-term, and missing labels are shown for review rather than interpreted automatically."
			},
			{
				"question": "Can one participant complete CBAs for multiple behaviors?",
				"answer": "Yes. Separate substances, activities, or behaviors should use separate CBAs so tradeoffs are not merged."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The CBA tool itself and selected setup are saved. Fictional sample behavior and demo entries are not saved as real client data."
			}
		]
	},
	{
		"toolType": "stressVulnerabilityWorksheet",
		"slug": "stress-vulnerability-worksheet",
		"title": "Stress-Vulnerability Worksheet Demo for CBT Practitioners | Qwoach",
		"metaDescription": "Explore a psychosis-focused CBT stress-vulnerability formulation worksheet for vulnerabilities, stressors, risk factors, and protective factors.",
		"h1": "Stress-Vulnerability Worksheet",
		"intro": "Stress-Vulnerability Worksheet is a CCI CBT for Psychotic Symptoms formulation worksheet for practitioners and clients. It helps connect symptoms or episodes with vulnerability factors, current or historical stressors, risk factors, and protective factors so the formulation can inform coping, support, and treatment planning.",
		"demoTitle": "Explore the formulation worksheet",
		"demoPrompt": "Interested in using Stress-Vulnerability Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0166-f-004-cbt-011-r001-stress-vulnerability-worksheet.md",
		"specId": "0166-f-004-cbt-011-r001-stress-vulnerability-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Psychosis",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during psychoeducation or formulation when the practitioner and client need a shared explanation connecting episodes or symptoms with stress, vulnerability, risk, and protection."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures vulnerability factors, stressors, risk factors, protective factors, client examples, coping resources, supports, and strengths."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not produce a relapse-risk score, diagnostic conclusion, causal inference, or medication instruction."
			}
		],
		"faqItems": [
			{
				"question": "Is this a symptom checklist?",
				"answer": "No. It is a formulation map that organizes vulnerabilities, stressors, risk factors, and protective factors."
			},
			{
				"question": "Can the demo show a diagram?",
				"answer": "Yes. Representation style can be diagram-first or worksheet-list-first while preserving the same formulation content."
			},
			{
				"question": "Does the system decide what caused symptoms?",
				"answer": "No. The system organizes reported and practitioner-entered material but does not infer causality."
			},
			{
				"question": "What gets saved?",
				"answer": "The tool itself and selected setup are saved. Fictional demo examples are not saved as real client data."
			}
		]
	},
	{
		"toolType": "stressVulnerabilityWorksheetBipolarDisorder",
		"slug": "stress-vulnerability-worksheet-bipolar-disorder",
		"title": "Bipolar Stress Vulnerability Worksheet Demo | Qwoach",
		"metaDescription": "Explore a bipolar stress-vulnerability formulation worksheet for episodes, stressors, risk factors, coping resources, and protective routines.",
		"h1": "Stress Vulnerability Worksheet - Bipolar Disorder",
		"intro": "Stress Vulnerability Worksheet - Bipolar Disorder is a CCI bipolar disorder clinician worksheet for clinicians and clients. It helps apply the stress-vulnerability model to bipolar relapse risk by organizing bipolar symptoms or episodes, stressors, vulnerability factors, risk factors, coping resources, and protective routines.",
		"demoTitle": "Explore the bipolar formulation worksheet",
		"demoPrompt": "Interested in using Stress Vulnerability Worksheet - Bipolar Disorder with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0167-f-004-cbt-011-r002-stress-vulnerability-worksheet-bipolar-disorder.md",
		"specId": "0167-f-004-cbt-011-r002-stress-vulnerability-worksheet-bipolar-disorder",
		"tags": {
			"framework": [],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Bipolar disorder",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it in bipolar psychoeducation or relapse-prevention formulation when stress, vulnerability, and protective routines need to be connected."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures bipolar symptoms or episode examples, stressors, vulnerability factors, risk factors, coping resources, and protective routines."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool is not daily mood monitoring, relapse prediction, medication guidance, diagnostic interpretation, or a broad bipolar management app."
			}
		],
		"faqItems": [
			{
				"question": "Is this a bipolar mood tracker?",
				"answer": "No. It is a formulation worksheet for stress, vulnerability, risk, coping resources, and protective routines."
			},
			{
				"question": "Can the formulation focus on one episode?",
				"answer": "Yes. Formulation focus can be a specific episode, current prevention, or general bipolar management."
			},
			{
				"question": "Does the tool predict relapse risk?",
				"answer": "No. It organizes formulation material and does not produce relapse prediction or clinical scores."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The fixed tool and selected setup are saved. Fictional bipolar examples and sample entries are not saved as real client data."
			}
		]
	},
	{
		"toolType": "stressVulnerabilityBufferModelWorksheet",
		"slug": "stress-vulnerability-buffer-model-worksheet",
		"title": "Stress-Vulnerability-Buffer Worksheet Demo | Qwoach",
		"metaDescription": "Explore a recovery-focused psychosis formulation worksheet for vulnerabilities, stressors, buffers, and differing participant perspectives.",
		"h1": "Stress-Vulnerability-Buffer Model Worksheet",
		"intro": "Stress-Vulnerability-Buffer Model worksheet is a recovery-focused psychosis formulation worksheet for clinicians, service users, and when appropriate family or significant others. It helps participants organize vulnerabilities, stressors, buffers, illness or wellness perceptions, and recovery strategies so recovery-focused intervention targets can be discussed.",
		"demoTitle": "Explore the shared formulation",
		"demoPrompt": "Interested in using Stress-Vulnerability-Buffer Model worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0168-f-004-cbt-011-r003-stress-vulnerability-buffer-model-worksheet.md",
		"specId": "0168-f-004-cbt-011-r003-stress-vulnerability-buffer-model-worksheet",
		"tags": {
			"framework": [],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Psychosis",
				"Relapse prevention"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a recovery-focused psychosis formulation should include the service user and, when appropriate, family or significant others."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures vulnerabilities, stressors, buffers, illness and wellness perceptions, supports, lifestyle factors, recovery strategies, and participant perspectives where used."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not automate consensus, rank perspectives, predict risk, or function as a family therapy platform."
			}
		],
		"faqItems": [
			{
				"question": "Are family or significant others required?",
				"answer": "No. Supporter inclusion is optional and should be used only when appropriate for the session."
			},
			{
				"question": "What are buffers in this tool?",
				"answer": "Buffers are protective, salutogenic, and recovery-supporting factors captured as active resources, not just the absence of risk."
			},
			{
				"question": "Does the tool resolve disagreements between participants?",
				"answer": "No. It displays differing perceptions as formulation material without forcing consensus."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The fixed tool and selected setup are saved. Fictional participant entries and sample perspectives are not saved as real client data."
			}
		]
	},
	{
		"toolType": "cciMoodMonitoringWorksheet",
		"slug": "cci-mood-monitoring-worksheet",
		"title": "CCI Mood Monitoring Worksheet Demo for Clinicians | Qwoach",
		"metaDescription": "Explore a seven-day bipolar mood graph with -5 to +5 mood ratings, sleep hours, context notes, and monitor/intervene threshold markers.",
		"h1": "CCI Mood Monitoring Worksheet",
		"intro": "CCI Mood Monitoring Worksheet is a bipolar disorder mood-monitoring worksheet for clinicians and clients. It helps track daily mood polarity from -5 depressed to +5 manic, hours slept, circumstances around high or low moods, and threshold labels for monitoring or intervention across a seven-day period.",
		"demoTitle": "Explore the weekly mood graph",
		"demoPrompt": "Interested in using CCI Mood Monitoring Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0169-f-004-cbt-012-r001-cci-mood-monitoring-worksheet.md",
		"specId": "0169-f-004-cbt-012-r001-cci-mood-monitoring-worksheet",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Bipolar disorder",
				"Outcome monitoring",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it between sessions when bipolar mood polarity, sleep, and context need to be reviewed for relapse prevention or CBT-oriented treatment."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures daily date, mood rating from -5 to +5, hours slept, and circumstances around high or low moods for seven days."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool graphically organizes reported mood data and threshold markers. It does not diagnose, predict relapse, recommend medication, or interpret mood beyond reported ratings and practitioner-defined thresholds."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic mood diary?",
				"answer": "No. It is a fixed seven-day bipolar mood graph with a -5 depressed to +5 manic scale, sleep hours, circumstances notes, and threshold labels."
			},
			{
				"question": "Can partial weeks be reviewed?",
				"answer": "Yes. Partial weeks are reviewable, with missed days visibly blank or incomplete."
			},
			{
				"question": "What happens if thresholds change later?",
				"answer": "Threshold labels used at completion persist with that dated weekly sheet so historical weeks remain understandable."
			},
			{
				"question": "Does the public demo save sample mood data?",
				"answer": "No. Saving keeps the tool and practitioner setup, not fictional ratings, sleep hours, or context notes."
			}
		]
	},
	{
		"toolType": "cbtMoodMonitoringHomeworkSheet",
		"slug": "cbt-mood-monitoring-homework-sheet",
		"title": "CBT+ Mood Monitoring Homework Sheet Demo | Qwoach",
		"metaDescription": "Explore a CBT depression homework sheet for weekly high and low mood ratings from 0 to 10 and events or activities linked to each day.",
		"h1": "CBT+ Mood Monitoring Homework Sheet",
		"intro": "CBT+ Mood Monitoring Homework Sheet is a CBT for Depression client handout for CBT practitioners and clients. It helps the client record daily high mood and low mood ratings from 0 to 10, along with events or activities connected to those ratings, so the week can be reviewed in the next session.",
		"demoTitle": "Explore the weekly homework sheet",
		"demoPrompt": "Interested in using CBT+ Mood Monitoring Homework Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0170-f-004-cbt-012-r002-cbt-mood-monitoring-homework-sheet.md",
		"specId": "0170-f-004-cbt-012-r002-cbt-mood-monitoring-homework-sheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Depression",
				"Outcome monitoring",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it as between-session CBT homework for depression when the practitioner wants daily mood highs and lows linked to events or activities."
			},
			{
				"title": "What It Captures",
				"body": "The sheet captures each day's high mood rating, low mood rating, and related event or activity notes."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not diagnose depression, score severity, recommend treatment, or infer intervention targets automatically."
			}
		],
		"faqItems": [
			{
				"question": "Is this a continuous mood tracking app?",
				"answer": "No. It is a weekly CBT homework sheet with one row per day for high mood, low mood, and event/activity context."
			},
			{
				"question": "What rating scale does it use?",
				"answer": "It uses 0 to 10 ratings for daily high mood and daily low mood."
			},
			{
				"question": "Can incomplete weeks be reviewed?",
				"answer": "Yes. Partial weeks can be reviewed, and missing ratings or context notes remain visible."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The fixed tool and selected practitioner setup are saved. Fictional ratings and sample event notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "mindOverMoodMeasuringAndTrackingMyMoodsWorksheet151",
		"slug": "mind-over-mood-measuring-and-tracking-my-moods-worksheet-15-1",
		"title": "Mind Over Mood Mood Tracking Worksheet Demo | Qwoach",
		"metaDescription": "Explore a CBT mood-monitoring worksheet for tracking one target mood weekly by frequency, strength, and duration over time.",
		"h1": "Mind Over Mood Measuring and Tracking My Moods Worksheet 15.1",
		"intro": "Mind Over Mood Measuring and Tracking My Moods Worksheet 15.1 is a CBT mood-monitoring worksheet for therapists and clients. It helps them track one selected mood or positive emotion each week by rating frequency, strength, and duration separately.",
		"demoTitle": "Choose a sample target mood and view the weekly rating worksheet.",
		"demoPrompt": "Interested in using Mind Over Mood Measuring and Tracking My Moods Worksheet 15.1 with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0171-f-004-cbt-012-r003-mind-over-mood-measuring-and-tracking-my-moods-worksheet-15-1.md",
		"specId": "0171-f-004-cbt-012-r003-mind-over-mood-measuring-and-tracking-my-moods-worksheet-15-1",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Emotion regulation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this worksheet when the treatment focus calls for monitoring one mood or positive emotion across repeated weeks."
			},
			{
				"title": "What It Captures",
				"body": "It captures weekly frequency, strength, and duration ratings for the selected mood. It does not capture causes, thought content, diagnoses, medication details, or risk status."
			},
			{
				"title": "Repeat Use",
				"body": "The worksheet is most comparable when the same target mood is repeated across weeks. Gaps and incomplete weeks should remain visible."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create a mood score?",
				"answer": "No. It keeps frequency, strength, and duration separate because the supplied product behavior does not support a composite mood score."
			},
			{
				"question": "Can it track a positive emotion?",
				"answer": "Yes. The same weekly rating structure can track a selected mood or positive emotion."
			},
			{
				"question": "What happens if one rating is missing?",
				"answer": "The week remains partial and is not treated as equivalent to a completed week."
			},
			{
				"question": "Is the demo asking for real client information?",
				"answer": "No. Public exploration uses fictional sample data and placeholder entries only."
			}
		]
	},
	{
		"toolType": "cciSymptomMonitoringWorksheet",
		"slug": "cci-symptom-monitoring-worksheet",
		"title": "CCI Symptom Monitoring Worksheet Demo | Qwoach",
		"metaDescription": "Explore a seven-day bipolar symptom-monitoring worksheet for daily depressive and manic symptom interference and circumstances.",
		"h1": "CCI Symptom Monitoring Worksheet",
		"intro": "The CCI Symptom Monitoring Worksheet is a CBT-oriented bipolar symptom-monitoring worksheet for clinicians and clients. It helps them record daily depressive and manic symptom interference and the circumstances in which symptoms occurred across a seven-day week.",
		"demoTitle": "Open a sample week and try the symptom grid.",
		"demoPrompt": "Interested in using CCI Symptom Monitoring Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0172-f-004-cbt-013-r001-cci-symptom-monitoring-worksheet.md",
		"specId": "0172-f-004-cbt-013-r001-cci-symptom-monitoring-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Intervention planning"
			],
			"topic": [
				"Bipolar disorder",
				"Relapse prevention",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Symptom Rows",
				"body": "The symptom rows remain fixed to preserve the worksheet identity and support week-to-week comparison."
			},
			{
				"title": "Blank And Missing Days",
				"body": "A blank day may mean no symptom interference or an incomplete day. The demo should show that distinction where the product can capture it."
			},
			{
				"title": "Review Boundary",
				"body": "The review shows reported patterns and circumstances. It does not provide an episode diagnosis, relapse alert, or treatment recommendation."
			}
		],
		"faqItems": [
			{
				"question": "Can I add new symptom rows?",
				"answer": "No. The bipolar symptom rows are fixed for this worksheet identity; extra information can only be captured through the circumstances field if appropriate."
			},
			{
				"question": "Does a blank day mean no symptoms?",
				"answer": "Not always. The interface should distinguish an intentionally completed blank day from an unvisited day when possible."
			},
			{
				"question": "Does the result identify relapse?",
				"answer": "No. The result organizes reported symptom interference and circumstances for clinician-client review."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and worksheet setup are saved. Fictional tick marks, notes, and sample client data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "psychologyToolsSymptomTracker",
		"slug": "psychology-tools-symptom-tracker",
		"title": "Psychology Tools Symptom Tracker Demo | Qwoach",
		"metaDescription": "Explore a one-month CBT symptom tracker with client-selected symptom rows and daily absence, mild presence, or severe presence markings.",
		"h1": "Psychology Tools Symptom Tracker",
		"intro": "Psychology Tools Symptom Tracker is a generic CBT symptom self-monitoring tracker for therapists and clients. It helps them monitor client-selected symptoms over a month using daily marks for absence, mild presence, or severe presence.",
		"demoTitle": "Add sample symptoms and try the monthly grid.",
		"demoPrompt": "Interested in using Psychology Tools Symptom Tracker with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0173-f-004-cbt-013-r002-psychology-tools-symptom-tracker.md",
		"specId": "0173-f-004-cbt-013-r002-psychology-tools-symptom-tracker",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Custom Symptom Rows",
				"body": "Rows should reflect symptoms relevant to the client and treatment focus. Changing rows across months limits direct comparison."
			},
			{
				"title": "Cell States",
				"body": "Each completed cell supports absence, mild presence, or severe presence. Missing data remains distinct from absence."
			},
			{
				"title": "Review Boundary",
				"body": "The tracker organizes and summarizes reported cell markings; it does not create standardized scores, clinical thresholds, diagnosis, or treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can the practitioner choose the symptoms?",
				"answer": "Yes. Symptom rows are configurable so the tracker reflects the client's treatment focus."
			},
			{
				"question": "Is absence the same as a missing day?",
				"answer": "No. Absence is a reported cell state, while missing means the day or cell has not been completed."
			},
			{
				"question": "Does the tracker score symptoms?",
				"answer": "No. It displays reported daily states and descriptive summaries only."
			},
			{
				"question": "What is saved when I use the demo?",
				"answer": "The tracker, symptom-row configuration, and date setup are saved. Fictional daily markings are not saved as client data."
			}
		]
	},
	{
		"toolType": "psychologyToolsPanicSymptomTracker",
		"slug": "psychology-tools-panic-symptom-tracker",
		"title": "Panic Symptom Tracker Demo | Qwoach",
		"metaDescription": "Explore a panic-specific monthly tracker for daily panic symptom occurrence, severity, preset rows, and optional client-specific symptoms.",
		"h1": "Psychology Tools Panic Symptom Tracker",
		"intro": "Psychology Tools Panic Symptom Tracker is a panic-specific CBT symptom-monitoring tracker for clinicians and clients. It helps them monitor panic symptom occurrence and severity over a one-month period, including optional client-specific panic symptoms.",
		"demoTitle": "Open the panic symptom grid and add a sample symptom.",
		"demoPrompt": "Interested in using Psychology Tools Panic Symptom Tracker with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0174-f-004-cbt-013-r003-psychology-tools-panic-symptom-tracker.md",
		"specId": "0174-f-004-cbt-013-r003-psychology-tools-panic-symptom-tracker",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Preset And Added Rows",
				"body": "Preset panic symptom rows define the tracker identity. Added rows are limited to client-specific panic symptoms."
			},
			{
				"title": "Missing Versus No Symptoms",
				"body": "No entries for a day remain incomplete unless the client explicitly records no symptoms where the interface supports that distinction."
			},
			{
				"title": "Review Boundary",
				"body": "The tracker shows daily occurrence and severity patterns. It does not diagnose panic disorder, infer causes, or generate treatment steps."
			}
		],
		"faqItems": [
			{
				"question": "Can I customize the preset panic symptom rows?",
				"answer": "No. Preset common panic symptom rows are part of the panic-specific tracker identity."
			},
			{
				"question": "Can I add symptoms that are specific to one client?",
				"answer": "Yes. The clinician may add client-specific panic symptom rows where needed."
			},
			{
				"question": "Does the tracker count panic attacks?",
				"answer": "No. It shows symptom occurrence and severity unless attack counts are directly supported by entered data, which this product specification does not define."
			},
			{
				"question": "What is saved from public exploration?",
				"answer": "The tool, date setup, and added client-specific panic symptom rows are saved. Fictional daily entries are not saved as client data."
			}
		]
	},
	{
		"toolType": "weeklyActivitySchedule2",
		"slug": "weekly-activity-schedule-2",
		"title": "Weekly Activity Schedule Demo | Qwoach",
		"metaDescription": "Explore a CBT behavioral activation weekly schedule for placing planned activities into specific days and time blocks for later review.",
		"h1": "Weekly Activity Schedule",
		"intro": "Weekly Activity Schedule is a CBT behavioral activation scheduling worksheet for practitioners and clients. It helps them place planned activities into specific daily time blocks across one week so the client has a concrete activation structure to use and review.",
		"demoTitle": "Set a sample week and fill the activity grid.",
		"demoPrompt": "Interested in using Weekly Activity Schedule with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0175-f-004-cbt-014-r001-weekly-activity-schedule.md",
		"specId": "0175-f-004-cbt-014-r001-weekly-activity-schedule",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Depression"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when behavioral activation work needs a concrete weekly plan rather than general intentions."
			},
			{
				"title": "Planning And Review",
				"body": "Planning entries and later follow-through observations are distinct. The schedule can be reviewed later if completion information is captured."
			},
			{
				"title": "Empty Blocks",
				"body": "Empty blocks are acceptable and visible. The goal is a usable activation structure, not a fully occupied calendar."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general calendar?",
				"answer": "No. It is a one-week behavioral activation schedule for planned activities tied to days and time blocks."
			},
			{
				"question": "Do all time blocks need activities?",
				"answer": "No. Empty blocks are allowed; the plan only needs to be concrete enough to guide activation and later review."
			},
			{
				"question": "Does the tool recommend activities?",
				"answer": "No. The practitioner and client choose activities; the tool organizes them into a weekly grid."
			},
			{
				"question": "Are demo activities saved as client data?",
				"answer": "No. The tool and setup can be saved, but fictional demo activities and review notes do not become real client data."
			}
		]
	},
	{
		"toolType": "myBehaviouralAntidepressants",
		"slug": "my-behavioural-antidepressants",
		"title": "My Behavioural Antidepressants Demo | Qwoach",
		"metaDescription": "Explore a behavioral activation worksheet for identifying personally useful activities across life domains before scheduling or review.",
		"h1": "My Behavioural Antidepressants",
		"intro": "My Behavioural Antidepressants is a CBT behavioral activation activity-identification worksheet for practitioners and depressed clients. It helps them identify personally useful pleasant, achievement, self-care, exercise, relationship, health, and other activities before or during activation planning.",
		"demoTitle": "Add sample activities across life domains.",
		"demoPrompt": "Interested in using My Behavioural Antidepressants with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0176-f-004-cbt-014-r002-my-behavioural-antidepressants.md",
		"specId": "0176-f-004-cbt-014-r002-my-behavioural-antidepressants",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Depression"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before or during behavioral activation planning when the client needs concrete activity options to try."
			},
			{
				"title": "Candidate Versus Helpful",
				"body": "The menu can distinguish activities that are candidates from activities the client later reports as helpful, where follow-up use is supported."
			},
			{
				"title": "Not A Scheduler",
				"body": "The worksheet creates an activity menu. Scheduling happens in a separate activity schedule or planning diary."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool schedule the activities?",
				"answer": "No. It creates a personalized menu of activity options that can feed a separate schedule or planning diary."
			},
			{
				"question": "Do all domains need to be filled?",
				"answer": "No. Domains can remain empty when they are not relevant to the client."
			},
			{
				"question": "Does it score or rank activities?",
				"answer": "No. It can group activities and show candidate or shown-benefit status, but it does not score or rank them."
			},
			{
				"question": "What gets saved?",
				"answer": "The tool and reusable setup are saved. Fictional activity ideas entered in the public demo are not saved as real client data."
			}
		]
	},
	{
		"toolType": "behavioralActivationActivityPlanningDiary",
		"slug": "behavioral-activation-activity-planning-diary",
		"title": "Behavioral Activation Activity Planning Diary Demo | Qwoach",
		"metaDescription": "Explore a seven-day behavioral activation diary for planning meaningful activities, details, obstacles, and later outcome review.",
		"h1": "Behavioral Activation Activity Planning Diary",
		"intro": "Behavioral Activation Activity Planning Diary is a behavioral activation planning and review worksheet for mental health professionals and clients. It helps them plan meaningful activities for the coming week, add implementation details and anticipated obstacles, and record later outcome observations for review.",
		"demoTitle": "Plan a sample week in the diary.",
		"demoPrompt": "Interested in using Behavioral Activation Activity Planning Diary with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0177-f-004-cbt-014-r003-behavioral-activation-activity-planning-diary.md",
		"specId": "0177-f-004-cbt-014-r003-behavioral-activation-activity-planning-diary",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Depression"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Planning And Review",
				"body": "The diary links activity planning with later outcome observations while keeping those states separate."
			},
			{
				"title": "Empty Slots",
				"body": "Empty day-part slots are acceptable. The goal is meaningful and realistic planning, not filling every slot."
			},
			{
				"title": "Barriers",
				"body": "Anticipated obstacles are captured before the client attempts activities, then outcomes can be reviewed afterward."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as a weekly calendar?",
				"answer": "No. It is a behavioral activation diary that includes planned activities, implementation details, anticipated obstacles, and later outcome observations."
			},
			{
				"question": "Does every morning, afternoon, and evening slot need an activity?",
				"answer": "No. Empty slots are allowed and should not be treated as errors."
			},
			{
				"question": "Does the tool rate mood improvement?",
				"answer": "No. It does not add unsupported mood-effect scores or activity ratings."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The diary tool and setup are saved. Fictional activities, barriers, and outcome observations are not saved as real client data."
			}
		]
	},
	{
		"toolType": "makingTheConnectionMakingTheThoughtFeelingConnection",
		"slug": "making-the-connection-making-the-thought-feeling-connection",
		"title": "Making the Thought-Feeling Connection Demo | Qwoach",
		"metaDescription": "Explore a CBT psychoeducation worksheet for helping clients connect self-statements, appraisals, and feelings in early formulation.",
		"h1": "Making the Connection / Making the Thought-Feeling Connection",
		"intro": "Making the Connection / Making the Thought-Feeling Connection is a CBT psychoeducation worksheet for practitioners and clients. It helps clients distinguish situations, self-statements or appraisals, and feelings so they can prepare for later thought monitoring, cognitive restructuring, or formulation work.",
		"demoTitle": "Try the thought-feeling mapping exercise.",
		"demoPrompt": "Interested in using Making the Connection / Making the Thought-Feeling Connection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0178-f-004-cbt-015-r001-making-the-connection-making-the-thought-feeling-connection.md",
		"specId": "0178-f-004-cbt-015-r001-making-the-connection-making-the-thought-feeling-connection",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Assessment"
			],
			"topic": [
				"Cognitive restructuring",
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during CBT psychoeducation or early formulation before thought monitoring, cognitive restructuring, or formulation work."
			},
			{
				"title": "What It Shows",
				"body": "The review shows whether the client can connect self-statements and feelings while keeping situation, thought, and feeling roles distinct."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not score responses, label distortions, restructure thoughts, or produce clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Are there practitioner settings?",
				"answer": "No. This is a fixed worksheet experience; saving still saves the tool itself as-is."
			},
			{
				"question": "Does the worksheet grade client answers?",
				"answer": "No. It organizes responses and completion status for practitioner discussion."
			},
			{
				"question": "Can it replace a thought record?",
				"answer": "No. It is an early teaching worksheet for the thought-feeling connection, not a full thought record or restructuring tool."
			},
			{
				"question": "What if exact source prompts are unavailable?",
				"answer": "The product can show the interaction structure, but exact substantive worksheet content remains unresolved and should not be invented."
			}
		]
	},
	{
		"toolType": "copingResourcesInventoryCri",
		"slug": "coping-resources-inventory-cri",
		"title": "Coping Resources Inventory CRI Demo | Qwoach",
		"metaDescription": "Explore a standardized 60-item coping-resource assessment concept with five domain scores for planning contexts when scoring rules are available.",
		"h1": "Coping Resources Inventory (CRI)",
		"intro": "Coping Resources Inventory (CRI) is a standardized self-report coping-resource assessment for counselors and practitioners. It helps assess a client's cognitive, social, emotional, spiritual or philosophical, and physical coping resources for planning or evaluation contexts when source-defined administration and scoring materials are available.",
		"demoTitle": "View the standardized administration and result structure.",
		"demoPrompt": "Interested in using Coping Resources Inventory (CRI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0179-f-004-cbt-016-r001-coping-resources-inventory-cri.md",
		"specId": "0179-f-004-cbt-016-r001-coping-resources-inventory-cri",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Score Integrity",
				"body": "Items, response options, scoring rules, and report formats must follow source-defined instrument materials. The product must not modify them."
			},
			{
				"title": "Five Domains",
				"body": "The supported domains are cognitive, social, emotional, spiritual/philosophical, and physical coping resources."
			},
			{
				"title": "Partial Administrations",
				"body": "Partial responses can be resumed, but final scoring is blocked or handled only according to source-defined rules."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo show real CRI items?",
				"answer": "Only if source-defined item materials are available. The public demo should not invent item text or response options."
			},
			{
				"question": "Does the tool create custom coping scores?",
				"answer": "No. Scores and reports must follow the CRI's source-defined scoring and interpretation rules."
			},
			{
				"question": "Can it support group reports?",
				"answer": "Yes, where the instrument supports group reporting and the report rules are available."
			},
			{
				"question": "What is saved if scoring rules are unavailable?",
				"answer": "The CRI tool and selected administration/report context are saved; fictional responses and placeholder scores are not saved as client data."
			}
		]
	},
	{
		"toolType": "goalsOfTherapy",
		"slug": "goals-of-therapy",
		"title": "Goals of Therapy Worksheet Demo | Qwoach",
		"metaDescription": "Explore a CBT goals worksheet for writing personal therapy goals and marking baseline achievement ratings on 0-100 scales.",
		"h1": "Goals of Therapy",
		"intro": "Goals of Therapy is a CBT therapy-goal setting worksheet for therapists and clients. It helps them establish specific, personal therapy targets and rate current progress toward each goal on a 0-100 scale.",
		"demoTitle": "Add a sample goal and set its baseline rating.",
		"demoPrompt": "Interested in using Goals of Therapy with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0180-f-004-cbt-017-r001-goals-of-therapy.md",
		"specId": "0180-f-004-cbt-017-r001-goals-of-therapy",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Baseline Ratings",
				"body": "Each written goal has its own 0-100 current achievement baseline so later review can refer back to the original rating."
			},
			{
				"title": "Goal Changes",
				"body": "If goal wording changes after baseline, the review should show that the target changed rather than treating ratings as automatically comparable."
			},
			{
				"title": "Review Boundary",
				"body": "The tool captures goals and ratings. It does not create treatment tasks, categories, diagnoses, or clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Does each goal need a rating?",
				"answer": "Yes. A goal without a baseline rating is incomplete because the worksheet links each goal to its own 0-100 achievement scale."
			},
			{
				"question": "Can goals be revised during discussion?",
				"answer": "Yes. Goals can be refined during setup, and later changes should be marked so comparison remains clear."
			},
			{
				"question": "Does the tool generate a treatment plan?",
				"answer": "No. It captures client-defined goals and baseline ratings for therapist-client planning and review."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and setup are saved. Fictional goal text and demo ratings are not saved as real client data."
			}
		]
	},
	{
		"toolType": "clientExpectationsQuestionnaireExpectationsQuestionnaire",
		"slug": "client-expectations-questionnaire-expectations-questionnaire",
		"title": "Client Expectations Questionnaire for CBT Engagement | Qwoach",
		"metaDescription": "Explore a CBT expectations questionnaire for therapists clarifying client expectations about therapy, change, benefits, and outcomes.",
		"h1": "Client Expectations Questionnaire for Early CBT Engagement",
		"intro": "The Client Expectations Questionnaire is a brief early CBT assessment and engagement worksheet for therapists working with clients experiencing psychotic symptoms. It helps the therapist make expectations about therapy, personal benefit, change, and outcomes explicit so they can be discussed collaboratively.",
		"demoTitle": "Explore the questionnaire flow",
		"demoPrompt": "Interested in using Client Expectations Questionnaire / Expectations Questionnaire with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0181-f-004-cbt-018-r001-client-expectations-questionnaire-expectations-questionnaire.md",
		"specId": "0181-f-004-cbt-018-r001-client-expectations-questionnaire-expectations-questionnaire",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use during early CBT assessment and engagement when therapy or outcome expectations should be made explicit before treatment proceeds."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not diagnose hopelessness, predict outcomes, recommend treatment steps, or decide whether an expectation is clinically realistic."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the questionnaire?",
				"answer": "The client completes the expectation ratings, either in session with the therapist or between sessions."
			},
			{
				"question": "Does the tool score motivation or prognosis?",
				"answer": "No. It organizes reported expectations into a brief profile and does not produce a motivation score, prognosis, diagnosis, or treatment recommendation."
			},
			{
				"question": "Can the therapist add interpretation?",
				"answer": "Yes. Practitioner notes can be added separately from client-reported ratings and system-derived summaries."
			}
		]
	},
	{
		"toolType": "theChangeProcessBalanceSheet2",
		"slug": "the-change-process-balance-sheet-2",
		"title": "Change Process Balance Sheet CBT Worksheet | Qwoach",
		"metaDescription": "Explore a CBT change balance worksheet for clarifying client ambivalence about staying the same versus changing a current problem.",
		"h1": "Change Process Balance Sheet for CBT Motivation Work",
		"intro": "The Change Process Balance Sheet is a CBT engagement and motivation worksheet for practitioners working with clients who feel ambivalent about psychological treatment or changing a current problem. It helps the practitioner and client organize costs and benefits of the current problem and of change in one shared view.",
		"demoTitle": "Try the balance sheet",
		"demoPrompt": "Interested in using The Change Process Balance Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0182-f-004-cbt-019-r001-the-change-process-balance-sheet.md",
		"specId": "0182-f-004-cbt-019-r001-the-change-process-balance-sheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The worksheet captures client-generated costs and benefits for both maintaining the current problem and changing it."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not calculate readiness, diagnose motivation, rank values, or recommend treatment steps automatically."
			}
		],
		"faqItems": [
			{
				"question": "Can the worksheet be reviewed if a quadrant is empty?",
				"answer": "Yes. Empty quadrants remain visible and are treated as discussion areas, not as evidence that no costs or benefits exist."
			},
			{
				"question": "Can one worksheet cover multiple change targets?",
				"answer": "No. Separate change targets should use separate balance sheets to avoid mixing different decisions."
			},
			{
				"question": "Does the tool score decisional balance?",
				"answer": "No. It provides an organized four-quadrant view and does not calculate a readiness or decisional balance score."
			}
		]
	},
	{
		"toolType": "changeProcessBalanceSheet",
		"slug": "change-process-balance-sheet",
		"title": "Eating Disorder Change Process Balance Sheet | Qwoach",
		"metaDescription": "Explore a CBT-ED change balance worksheet for organizing recovery ambivalence, eating-disorder positives, harms, barriers, and benefits.",
		"h1": "Change Process Balance Sheet for Eating-Disorder Recovery Ambivalence",
		"intro": "The Change Process Balance Sheet is a CBT-ED motivational worksheet for practitioners and guided self-help providers working with clients who feel ambivalent about giving up eating-disorder behaviors. It helps organize perceived positives and harms of the eating disorder alongside anticipated recovery challenges and personally meaningful recovery benefits.",
		"demoTitle": "Explore the recovery balance sheet",
		"demoPrompt": "Interested in using Change Process Balance Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0183-f-004-cbt-019-r002-change-process-balance-sheet.md",
		"specId": "0183-f-004-cbt-019-r002-change-process-balance-sheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Eating disorders",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The worksheet captures perceived positives and negative consequences of the eating disorder, anticipated recovery challenges, expected life improvements, and reflection where supported."
			},
			{
				"title": "What It Avoids",
				"body": "It does not collect weight, BMI, dietary logs, medical risk markers, diagnostic criteria, or generated recovery steps."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general eating-disorder assessment?",
				"answer": "No. It is a recovery ambivalence worksheet, not a diagnostic assessment, risk screen, meal plan, or recovery plan."
			},
			{
				"question": "Can a client list only positives of the eating disorder?",
				"answer": "Yes. The worksheet preserves the client's reflections without forcing balance or inventing recovery benefits."
			},
			{
				"question": "Does the tool classify recovery readiness?",
				"answer": "No. It organizes reflections and does not create a readiness classification or score."
			}
		]
	},
	{
		"toolType": "changeProcessBalanceSheetWorksheet",
		"slug": "change-process-balance-sheet-worksheet",
		"title": "Perfectionism Change Process Balance Sheet | Qwoach",
		"metaDescription": "Explore a CBT perfectionism worksheet for weighing unrelenting standards, loosening standards, readiness, and an initial goal area.",
		"h1": "Change Process Balance Sheet for Perfectionism",
		"intro": "The Change Process Balance Sheet - worksheet is a perfectionism-focused CBT decisional balance and readiness worksheet for practitioners. It helps the client compare the rewards and harms of unrelenting standards with feared costs and expected benefits of loosening standards, then clarify readiness for an initial change goal.",
		"demoTitle": "Try the perfectionism balance sheet",
		"demoPrompt": "Interested in using Change Process Balance Sheet - worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0184-f-004-cbt-019-r003-change-process-balance-sheet-worksheet.md",
		"specId": "0184-f-004-cbt-019-r003-change-process-balance-sheet-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Perfectionism"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use when deciding whether a client is ready to move from perfectionism appraisal into initial goal setting and behavior-change work."
			},
			{
				"title": "What It Does Not Do",
				"body": "The worksheet does not measure perfectionism severity, classify readiness, generate practice steps, or function as a full treatment module."
			}
		],
		"faqItems": [
			{
				"question": "Does the worksheet score readiness for change?",
				"answer": "No. It records readiness-related responses where supplied but does not calculate a readiness level or score."
			},
			{
				"question": "Can one worksheet cover several perfectionism patterns?",
				"answer": "No. Separate patterns should use separate worksheets when needed so the appraisal stays clear."
			},
			{
				"question": "What happens if readiness is unclear?",
				"answer": "Readiness is marked as unresolved rather than interpreted as not ready."
			}
		]
	},
	{
		"toolType": "childrenSYaleBrownObsessiveCompulsiveScaleCyBocs",
		"slug": "children-s-yale-brown-obsessive-compulsive-scale-cy-bocs",
		"title": "CY-BOCS Pediatric OCD Assessment Demo | Qwoach",
		"metaDescription": "Explore clinician-rated CY-BOCS workflow for pediatric OCD symptom checklist review, obsession score, compulsion score, and total score.",
		"h1": "Children's Yale-Brown Obsessive Compulsive Scale (CY-BOCS)",
		"intro": "The Children's Yale-Brown Obsessive Compulsive Scale (CY-BOCS) is a clinician-rated pediatric OCD assessment and monitoring instrument for clinicians assessing children or adolescents with suspected or diagnosed OCD. It helps produce a standardized symptom profile with obsession severity, compulsion severity, and total severity scores.",
		"demoTitle": "Explore the clinician workflow",
		"demoPrompt": "Interested in using Children's Yale-Brown Obsessive Compulsive Scale (CY-BOCS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0185-f-002-ocd-002-r001-children-s-yale-brown-obsessive-compulsive-scale-cy-bocs.md",
		"specId": "0185-f-002-ocd-002-r001-children-s-yale-brown-obsessive-compulsive-scale-cy-bocs",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Clinician-Rated Use",
				"body": "Child and parent information supports the interview, but the clinician enters the standardized ratings and controls finalization."
			},
			{
				"title": "Monitoring Over Time",
				"body": "Prior administrations can be opened for comparison when repeated, with version and date preserved."
			},
			{
				"title": "What It Does Not Generate",
				"body": "The tool does not automatically diagnose OCD, recommend treatment, create ERP steps, or add unsupported severity bands."
			}
		],
		"faqItems": [
			{
				"question": "Is CY-BOCS completed by the child alone?",
				"answer": "No. This configuration is clinician-rated; child and parent information informs the clinician's ratings."
			},
			{
				"question": "What scores are shown?",
				"answer": "The result shows obsession severity, compulsion severity, and total severity scores when required ratings are complete."
			},
			{
				"question": "Can CY-BOCS be used for follow-up monitoring?",
				"answer": "Yes. Follow-up administrations can be compared with prior CY-BOCS results while preserving version identity."
			}
		]
	},
	{
		"toolType": "childrenSYaleBrownObsessiveCompulsiveScaleSecondEditionCyBocsIi",
		"slug": "children-s-yale-brown-obsessive-compulsive-scale-second-edition-cy-bocs-ii",
		"title": "CY-BOCS-II Pediatric OCD Assessment | Qwoach",
		"metaDescription": "Explore clinician-rated CY-BOCS-II workflow for updated pediatric OCD symptom profiling, expanded ratings, and follow-up score comparison.",
		"h1": "Children's Yale-Brown Obsessive-Compulsive Scale Second Edition (CY-BOCS-II)",
		"intro": "The Children's Yale-Brown Obsessive-Compulsive Scale Second Edition (CY-BOCS-II) is a revised clinician-rated pediatric OCD severity assessment for clinicians working with children or adolescents. It helps measure updated symptom profile information and produces obsession, compulsion, and total severity scores using expanded rating scales.",
		"demoTitle": "Explore CY-BOCS-II",
		"demoPrompt": "Interested in using Children's Yale-Brown Obsessive-Compulsive Scale Second Edition (CY-BOCS-II) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0186-f-002-ocd-002-r002-children-s-yale-brown-obsessive-compulsive-scale-second-edition-cy-bocs-ii.md",
		"specId": "0186-f-002-ocd-002-r002-children-s-yale-brown-obsessive-compulsive-scale-second-edition-cy-bocs-ii",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Distinct Version",
				"body": "CY-BOCS-II is kept distinct from original CY-BOCS and adult Y-BOCS-II so historical comparisons remain clearly labeled."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not generate automated diagnosis, treatment instructions, ERP hierarchy items, medication decisions, or unsupported severity labels."
			}
		],
		"faqItems": [
			{
				"question": "Is CY-BOCS-II the same as CY-BOCS?",
				"answer": "No. CY-BOCS-II is a distinct revised configuration with updated checklist content and expanded rating scales."
			},
			{
				"question": "Who creates the scores?",
				"answer": "The clinician enters ratings, and the system calculates supported obsession, compulsion, and total scores."
			},
			{
				"question": "Can youth or parents complete it independently?",
				"answer": "No. Youth and parent information supports clinician administration, but they do not independently produce the clinician-rated scores."
			}
		]
	},
	{
		"toolType": "childObsessiveCompulsiveImpactScaleRevisedCoisR",
		"slug": "child-obsessive-compulsive-impact-scale-revised-cois-r",
		"title": "COIS-R Pediatric OCD Impairment Demo | Qwoach",
		"metaDescription": "Explore COIS-R for youth and parent ratings of OCD-related functional impairment across daily life domains and treatment follow-up.",
		"h1": "Child Obsessive-Compulsive Impact Scale-Revised (COIS-R)",
		"intro": "The Child Obsessive-Compulsive Impact Scale-Revised (COIS-R) is a pediatric OCD-specific functional impairment questionnaire for practitioners assessing or monitoring children and adolescents. It helps collect youth and/or parent ratings and organize impairment by daily life domains.",
		"demoTitle": "Explore COIS-R forms",
		"demoPrompt": "Interested in using Child Obsessive-Compulsive Impact Scale-Revised (COIS-R) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0187-f-002-ocd-008-r001-child-obsessive-compulsive-impact-scale-revised-cois-r.md",
		"specId": "0187-f-002-ocd-008-r001-child-obsessive-compulsive-impact-scale-revised-cois-r",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Reporter-Specific Forms",
				"body": "Youth and parent forms remain separate so each perspective is labeled and interpretable."
			},
			{
				"title": "Functional Domains",
				"body": "The tool focuses on OCD-related interference in daily functioning domains, not OCD symptom severity."
			},
			{
				"title": "Comparison Over Time",
				"body": "Repeated results can be compared when form identity and reporter type support meaningful comparison."
			}
		],
		"faqItems": [
			{
				"question": "Can I use only the parent form?",
				"answer": "Yes. The practitioner can select parent, youth, or both forms."
			},
			{
				"question": "What if youth and parent ratings disagree?",
				"answer": "The result shows differences descriptively without resolving or explaining them automatically."
			},
			{
				"question": "Is COIS-R a symptom severity scale?",
				"answer": "No. COIS-R focuses on OCD-specific functional impairment, not symptom severity scoring."
			}
		]
	},
	{
		"toolType": "childrenSFloridaObsessiveCompulsiveInventoryCFoci",
		"slug": "children-s-florida-obsessive-compulsive-inventory-c-foci",
		"title": "C-FOCI Pediatric OCD Measure Demo | Qwoach",
		"metaDescription": "Explore C-FOCI youth self-report for pediatric OCD symptom presence, severity ratings, screening, assessment, and progress monitoring.",
		"h1": "Children's Florida Obsessive Compulsive Inventory (C-FOCI)",
		"intro": "The Children's Florida Obsessive Compulsive Inventory (C-FOCI) is a brief pediatric OCD self-report assessment and monitoring measure for clinicians, OCD specialty trainers, researchers, and pediatric mental health practitioners. It helps collect a youth-reported profile of endorsed obsessions and compulsions with severity information.",
		"demoTitle": "Explore C-FOCI",
		"demoPrompt": "Interested in using Children's Florida Obsessive Compulsive Inventory (C-FOCI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0188-f-002-ocd-010-r001-children-s-florida-obsessive-compulsive-inventory-c-foci.md",
		"specId": "0188-f-002-ocd-010-r001-children-s-florida-obsessive-compulsive-inventory-c-foci",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"OCD",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Brief Youth Report",
				"body": "The measure is completed from the youth's perspective and combines symptom endorsement with severity ratings."
			},
			{
				"title": "What It Does Not Replace",
				"body": "C-FOCI is not a clinician-rated CY-BOCS substitute, diagnostic decision engine, ERP planner, or general anxiety screen."
			}
		],
		"faqItems": [
			{
				"question": "Who completes C-FOCI?",
				"answer": "The youth completes the C-FOCI self-report responses."
			},
			{
				"question": "Can it be used repeatedly?",
				"answer": "Yes. Repeated C-FOCI administrations can support monitoring when comparable forms and scoring rules are used."
			},
			{
				"question": "Does C-FOCI diagnose OCD?",
				"answer": "No. It provides symptom presence and severity information for practitioner review and does not generate an automated diagnosis."
			}
		]
	},
	{
		"toolType": "valuesCardSort",
		"slug": "values-card-sort",
		"title": "Values Card Sort ACT Demo | Qwoach",
		"metaDescription": "Explore an ACT Values Card Sort that helps practitioners and clients create a prioritized values profile for therapy focus or goals.",
		"h1": "Values Card Sort for ACT Values Clarification",
		"intro": "Values Card Sort is an ACT values clarification exercise for practitioners helping clients clarify what matters when values feel diffuse or hard to prioritize. It helps the client sort value cards into priority groupings so practitioner and client can use shared values language for therapy focus or goal selection.",
		"demoTitle": "Sort sample cards",
		"demoPrompt": "Interested in using Values Card Sort with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0189-f-005-act-001-r001-values-card-sort.md",
		"specId": "0189-f-005-act-001-r001-values-card-sort",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Why Sorting Matters",
				"body": "The exercise uses comparison and prioritization rather than isolated ratings, helping values become more explicit and discussable."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not define correct values, infer values from behavior, assign scores, or generate therapeutic interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Does every card need to be high priority?",
				"answer": "No. The tool is designed to distinguish more important values from lower-priority or less relevant values."
			},
			{
				"question": "Can the client revise the sort?",
				"answer": "Yes. The client can revise placements during active sorting and discussion before the profile is finalized."
			},
			{
				"question": "Does the result include a values score?",
				"answer": "No. The result is a prioritized profile, not a numerical score or normative ranking."
			}
		]
	},
	{
		"toolType": "valuesBullseye",
		"slug": "values-bullseye",
		"title": "Values Bullseye ACT Demo | Qwoach",
		"metaDescription": "Explore an ACT Values Bullseye for mapping values/action alignment by life domain and choosing a focused next values-based action.",
		"h1": "Values Bullseye for ACT Values and Action Alignment",
		"intro": "Values Bullseye is an ACT values/action alignment exercise for practitioners helping clients examine current behavior across life domains. It helps create a domain-by-domain bullseye profile so practitioner and client can identify visible gaps and choose a focused next values-based action when supported.",
		"demoTitle": "Map sample domains",
		"demoPrompt": "Interested in using Values Bullseye with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0190-f-005-act-002-r001-values-bullseye.md",
		"specId": "0190-f-005-act-002-r001-values-bullseye",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Domain-Based View",
				"body": "The bullseye keeps life domains distinct so alignment can be discussed by area rather than as a single global judgment."
			},
			{
				"title": "Repeat Use",
				"body": "Historical comparison is meaningful when the same domain set is reused and differences are clearly labeled."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not define values for the client, rate goal quality, judge adherence, or generate practice steps beyond the supplied exercise."
			}
		],
		"faqItems": [
			{
				"question": "What does the bullseye show?",
				"answer": "It shows client-reported closeness to values-consistent action by life domain."
			},
			{
				"question": "Can it track change over time?",
				"answer": "Yes. It can compare repeated bullseyes when the domain sets are comparable."
			},
			{
				"question": "What if the client does not choose a next step?",
				"answer": "The alignment profile is preserved and the next action is marked unresolved."
			}
		]
	},
	{
		"toolType": "actMatrix",
		"slug": "act-matrix",
		"title": "ACT Matrix Demo for ACT Practitioners | Qwoach",
		"metaDescription": "Explore an ACT Matrix for shared formulation of values, avoidance, internal experiences, and approach behaviors in practitioner-guided ACT work.",
		"h1": "ACT Matrix",
		"intro": "ACT Matrix is a practitioner-guided functional mapping tool for ACT practitioners and clients. It helps them create a compact shared map of internal experiences, avoidance or control responses, valued directions, and approach behaviors so ACT work can stay oriented around values-directed behavior.",
		"demoTitle": "Explore the sample matrix",
		"demoPrompt": "Interested in using ACT Matrix with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0191-f-005-act-003-r001-act-matrix.md",
		"specId": "0191-f-005-act-003-r001-act-matrix",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Values",
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during ACT work when the practitioner and client need a shared formulation of internal experiences, avoidance patterns, valued directions, and approach behaviors."
			},
			{
				"title": "What It Captures",
				"body": "The map captures concise entries and their placement in the ACT Matrix. It keeps client-reported content, practitioner observations, and system organization distinct."
			},
			{
				"title": "Limits",
				"body": "The tool does not score the client, diagnose, interpret values, or automatically decide which ACT process should be used next."
			}
		],
		"faqItems": [
			{
				"question": "Is ACT Matrix a questionnaire?",
				"answer": "No. ACT Matrix is a shared functional map, not a questionnaire or scoring tool."
			},
			{
				"question": "Can the client complete it alone?",
				"answer": "The supported experience is practitioner-guided collaborative completion. The client contributes examples and wording while the practitioner facilitates the map."
			},
			{
				"question": "What is saved after the public demo?",
				"answer": "The ACT Matrix tool itself and reusable practitioner setup are saved. Fictional demo entries and temporary sample maps are not saved as real client data."
			}
		]
	},
	{
		"toolType": "defusionTechniquesDeck",
		"slug": "defusion-techniques-deck",
		"title": "Defusion Techniques Deck for ACT Practice | Qwoach",
		"metaDescription": "Explore an ACT defusion techniques deck for selecting a practice card, capturing client reflection, and reviewing reported effect.",
		"h1": "Defusion Techniques Deck",
		"intro": "Defusion Techniques Deck is an ACT technique selection and practice-support tool for practitioners and clients. It helps a practitioner choose one or more defusion techniques so a client can notice difficult thoughts as thoughts rather than literal commands or truths.",
		"demoTitle": "Try a sample practice card",
		"demoPrompt": "Interested in using Defusion Techniques Deck with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0192-f-005-act-004-r001-defusion-techniques-deck.md",
		"specId": "0192-f-005-act-004-r001-defusion-techniques-deck",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Cognitive restructuring",
				"Values",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when difficult thoughts are functioning as commands or truths and the practitioner wants the client to try a defusion approach."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures selected technique, target thought or thought pattern, practice reflection, practitioner observation, and descriptive practice status."
			},
			{
				"title": "Limits",
				"body": "The tool does not interpret the truth or meaning of thoughts, score defusion, or recommend a clinically best technique."
			}
		],
		"faqItems": [
			{
				"question": "Does the deck choose the best defusion technique automatically?",
				"answer": "No. The practitioner chooses the technique and uses client experience and clinical judgment to decide what to repeat or adapt."
			},
			{
				"question": "Can a card be used outside session?",
				"answer": "Yes. The supported practice modes are live session practice and sent practice."
			},
			{
				"question": "What happens if the client reports no distance from the thought?",
				"answer": "The result records that descriptively. It does not mark the attempt as a clinical failure or generate an interpretation."
			}
		]
	},
	{
		"toolType": "valuesChecklist",
		"slug": "values-checklist",
		"title": "Values Checklist for ACT Values Clarification | Qwoach",
		"metaDescription": "Explore a ready-to-send ACT Values Checklist that helps clients identify personally meaningful values for practitioner review.",
		"h1": "Values Checklist",
		"intro": "Values Checklist is a ready-to-send ACT values clarification tool for practitioners and clients. It helps clients identify personally meaningful life directions and produces a concise values profile the practitioner can review in therapy planning.",
		"demoTitle": "Explore a sample checklist",
		"demoPrompt": "Interested in using Values Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0193-f-005-act-005-r001-values-checklist.md",
		"specId": "0193-f-005-act-005-r001-values-checklist",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client needs scaffolding to name personally meaningful values."
			},
			{
				"title": "What It Captures",
				"body": "The checklist captures endorsed values, optional client clarification, and practitioner review notes."
			},
			{
				"title": "Limits",
				"body": "The tool does not score values, rank them normatively, judge whether answers are authentic, or automatically create therapy goals."
			}
		],
		"faqItems": [
			{
				"question": "Does Values Checklist score the client's values?",
				"answer": "No. It produces a values profile, not a score."
			},
			{
				"question": "Can the client select many values?",
				"answer": "Yes. The profile can show all selected values for practitioner and client discussion without forcing unsupported prioritization."
			},
			{
				"question": "What if none of the values fit?",
				"answer": "The tool can show an incomplete or no-fit state for review instead of forcing a selection."
			}
		]
	},
	{
		"toolType": "committedActionPlan",
		"slug": "committed-action-plan",
		"title": "Committed Action Plan for ACT Practitioners | Qwoach",
		"metaDescription": "Explore an ACT Committed Action Plan for linking values to specific actions and reviewing follow-through without scoring adherence.",
		"h1": "Committed Action Plan",
		"intro": "Committed Action Plan is an ACT values-linked action planning and follow-through tool for practitioners and clients. It helps clients define values-consistent action intentions and gives practitioners reviewable information about whether actions happened and what barriers appeared.",
		"demoTitle": "Build a sample action plan",
		"demoPrompt": "Interested in using Committed Action Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0194-f-005-act-006-r001-committed-action-plan.md",
		"specId": "0194-f-005-act-006-r001-committed-action-plan",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Values",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after values have been identified and the next task is to define a concrete values-consistent action."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures linked value, planned action, follow-through status, barriers or issues, client reflection, and practitioner notes."
			},
			{
				"title": "Limits",
				"body": "The tool does not score adherence, create goals automatically, or prioritize symptom reduction over valued living."
			}
		],
		"faqItems": [
			{
				"question": "Is this a task manager?",
				"answer": "No. It is an ACT committed action tool that links actions to identified values and reviews follow-through descriptively."
			},
			{
				"question": "Does every action need a value?",
				"answer": "Yes. A planned action is incomplete for this ACT review unless it is linked to an identified value."
			},
			{
				"question": "What if the client does not follow through?",
				"answer": "The tool records that descriptively and captures barriers or issues for review without failure scoring."
			}
		]
	},
	{
		"toolType": "creativeHopelessnessWorkabilityReview",
		"slug": "creative-hopelessness-workability-review",
		"title": "Workability Review Tool for ACT Practitioners | Qwoach",
		"metaDescription": "Explore an ACT Workability Review for mapping avoidance strategies, short-term payoffs, longer-term costs, and valued-living reflections.",
		"h1": "Creative Hopelessness / Workability Review",
		"intro": "Creative Hopelessness / Workability Review is a practitioner-guided ACT formulation tool for practitioners and clients. It helps them examine control or avoidance strategies, short-term payoffs, longer-term costs, and workability in relation to valued living.",
		"demoTitle": "Explore a sample workability review",
		"demoPrompt": "Interested in using Creative Hopelessness / Workability Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0195-f-005-act-007-r001-creative-hopelessness-workability-review.md",
		"specId": "0195-f-005-act-007-r001-creative-hopelessness-workability-review",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when avoidance or control strategies need to be examined collaboratively for their workability over time."
			},
			{
				"title": "What It Captures",
				"body": "The review captures strategies, short-term payoffs, longer-term costs, valued-living relation, optional alternative response notes, and separate practitioner observations."
			},
			{
				"title": "Limits",
				"body": "The tool does not score workability, decide whether a strategy is valid, or generate alternatives automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide whether a strategy is workable?",
				"answer": "No. It organizes reported information so the practitioner and client can examine workability collaboratively."
			},
			{
				"question": "Can a review be saved if no alternative response is identified?",
				"answer": "Yes. The formulation can still be useful when strategies, payoffs, costs, and valued-living relation are clear."
			},
			{
				"question": "Is this completed by the client alone?",
				"answer": "No. The supported experience is collaborative, practitioner-guided completion during ACT work."
			}
		]
	},
	{
		"toolType": "experientialAvoidanceMap",
		"slug": "experiential-avoidance-map",
		"title": "Experiential Avoidance Map for ACT Formulation | Qwoach",
		"metaDescription": "Explore an ACT Experiential Avoidance Map linking private experiences, avoidance responses, and consequences for valued behavior.",
		"h1": "Experiential Avoidance Map",
		"intro": "Experiential Avoidance Map is a practitioner-guided ACT functional formulation tool for practitioners and clients. It helps map unwanted thoughts, emotions, sensations, memories, or urges, the avoidance or escape responses linked to them, and their effects on valued behavior.",
		"demoTitle": "Explore a sample avoidance map",
		"demoPrompt": "Interested in using Experiential Avoidance Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0196-f-005-act-008-r001-experiential-avoidance-map.md",
		"specId": "0196-f-005-act-008-r001-experiential-avoidance-map",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when avoidance or escape responses appear to restrict valued behavior and need to be mapped functionally."
			},
			{
				"title": "What It Captures",
				"body": "The map captures triggering private experiences, avoidance or escape responses, valued-life consequences, and descriptive links among them."
			},
			{
				"title": "Limits",
				"body": "The tool does not score experiential avoidance, diagnose, or automatically recommend acceptance, defusion, or committed-action work."
			}
		],
		"faqItems": [
			{
				"question": "Does the map diagnose experiential avoidance?",
				"answer": "No. It organizes reported patterns for practitioner interpretation outside the system."
			},
			{
				"question": "Can one response link to several private experiences?",
				"answer": "Yes. The tool supports one-to-many and many-to-one links."
			},
			{
				"question": "What happens if part of the pattern is unknown?",
				"answer": "Unknown triggers or consequences can remain unresolved and be reviewed later."
			}
		]
	},
	{
		"toolType": "tinCanMonsterExercise",
		"slug": "tin-can-monster-exercise",
		"title": "Tin Can Monster ACT Exercise Demo | Qwoach",
		"metaDescription": "Explore the Tin Can Monster ACT exercise for guided willingness practice across sensations, emotions, urges, thoughts, and memories.",
		"h1": "Tin Can Monster Exercise",
		"intro": "Tin Can Monster Exercise is a guided ACT willingness and acceptance exercise for practitioners and clients. It helps clients practice contacting uncomfortable sensations, emotions, urges, thoughts, or memories from an observing stance without needing the discomfort to disappear first.",
		"demoTitle": "Try the sample practice flow",
		"demoPrompt": "Interested in using Tin Can Monster Exercise with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0197-f-005-act-009-r001-tin-can-monster-exercise.md",
		"specId": "0197-f-005-act-009-r001-tin-can-monster-exercise",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Mindfulness",
				"Values",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client is avoiding or struggling with unwanted internal content and the practitioner wants to practice willingness."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures practice mode, selected domains, completion state, brief client reflection, practitioner observation, and values-consistent action link when present."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide scores, exposure-dose metrics, domain prioritization, or unsupported script language."
			}
		],
		"faqItems": [
			{
				"question": "Does Tin Can Monster produce a score?",
				"answer": "No. It produces a descriptive practice summary and reflections, not a formal score."
			},
			{
				"question": "Can the client stop early?",
				"answer": "Yes. The practice can be paused or stopped, and the partial state is preserved as stopped or incomplete rather than failed."
			},
			{
				"question": "Can practitioners select domains?",
				"answer": "Yes. Domain inclusion can be selected among the supported domains when the exercise is not run in full."
			}
		]
	},
	{
		"toolType": "acceptancePhysicalExercise",
		"slug": "acceptance-physical-exercise",
		"title": "Acceptance Physical Exercise for ACT Sessions | Qwoach",
		"metaDescription": "Explore an ACT live exercise that uses client-generated cards to compare fighting, distraction, and open willingness responses.",
		"h1": "Acceptance Physical Exercise",
		"intro": "Acceptance Physical Exercise is a live ACT experiential exercise for practitioners and clients. It helps clients identify unwanted internal experiences on cards and experientially compare fighting them away, distracting from them, and allowing them while staying open and present.",
		"demoTitle": "Walk through the sample phases",
		"demoPrompt": "Interested in using Acceptance Physical Exercise with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0198-f-005-act-009-r002-acceptance-physical-exercise.md",
		"specId": "0198-f-005-act-009-r002-acceptance-physical-exercise",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Mindfulness",
				"Values",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during live ACT sessions when the practitioner wants the client to experience different responses to unwanted private experiences."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures target struggle, card content, fixed phase completion, debrief reflections, and practitioner observations."
			},
			{
				"title": "Limits",
				"body": "The tool does not invent scripts, cautions, processing questions, clinical interpretations, or scores."
			}
		],
		"faqItems": [
			{
				"question": "Can the response stances be changed?",
				"answer": "No. Fighting, distraction, and allowing are fixed phases of this exercise."
			},
			{
				"question": "Is the number of cards a setting?",
				"answer": "No. The number of cards is session content generated from the client's material, not a reusable configuration setting."
			},
			{
				"question": "What if the exercise stops early?",
				"answer": "Completed phases are preserved, and the practitioner can debrief what occurred."
			}
		]
	},
	{
		"toolType": "passengersOnTheBusActingOutThePassengersOnTheBusExercise",
		"slug": "passengers-on-the-bus-acting-out-the-passengers-on-the-bus-exercise",
		"title": "Passengers on the Bus ACT Exercise Demo | Qwoach",
		"metaDescription": "Explore an ACT metaphor exercise that maps valued direction, internal barriers as passengers, rehearsal notes, and an action step.",
		"h1": "Passengers on the Bus / ACTing Out the Passengers on the Bus Exercise",
		"intro": "Passengers on the Bus / ACTing Out the Passengers on the Bus Exercise is an ACT metaphor-based experiential tool for practitioners, clients, and groups. It helps clients identify a valued direction, name difficult internal experiences as passengers, and practice continuing toward values while those passengers remain present.",
		"demoTitle": "Explore the bus metaphor map",
		"demoPrompt": "Interested in using Passengers on the Bus / ACTing Out the Passengers on the Bus Exercise with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0199-f-005-act-009-r003-passengers-on-the-bus-acting-out-the-passengers-on-the-bus-exercise.md",
		"specId": "0199-f-005-act-009-r003-passengers-on-the-bus-acting-out-the-passengers-on-the-bus-exercise",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Values",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when difficult internal experiences are being treated as reasons that valued action cannot begin."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures exercise mode, valued direction, passenger barriers, rehearsal observations, debrief reflections, and values-linked action step."
			},
			{
				"title": "Group Use",
				"body": "In group role-play, participant-specific material should remain distinct enough for debrief without forcing comparison between participants."
			},
			{
				"title": "Limits",
				"body": "The tool does not invent scripts or prompt sheets, rank values, score willingness, or interpret the clinical meaning of passengers."
			}
		],
		"faqItems": [
			{
				"question": "Can this be used with groups?",
				"answer": "Yes. Group role-play is a supported exercise mode, with participant-specific content kept distinct for review."
			},
			{
				"question": "Does the tool decide what the passengers mean?",
				"answer": "No. Passengers are client-reported internal barriers, and interpretation remains practitioner-led outside the system."
			},
			{
				"question": "What if no action step is named?",
				"answer": "The metaphor map can be preserved as partial, with the action step marked unresolved."
			}
		]
	},
	{
		"toolType": "droppingAnchor",
		"slug": "dropping-anchor",
		"title": "Dropping Anchor ACT Grounding Practice Demo | Qwoach",
		"metaDescription": "Explore Dropping Anchor, an ACT grounding practice for reconnecting attention with body, surroundings, and current action.",
		"h1": "Dropping Anchor",
		"intro": "Dropping Anchor is an ACT grounding, mindfulness, and present-moment practice for practitioners and clients. It helps clients regain contact with body, surroundings, and current action during stress, anxiety, emotional overwhelm, or disconnection from the here-and-now.",
		"demoTitle": "Preview the practice flow",
		"demoPrompt": "Interested in using Dropping Anchor with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0200-f-005-act-010-r001-dropping-anchor.md",
		"specId": "0200-f-005-act-010-r001-dropping-anchor",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Mindfulness",
				"Coping",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during stress, anxiety, emotional overwhelm, or disconnection when the practitioner wants to support present-moment contact."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures mode, practice state, optional reflection, practitioner observation when live, and descriptive practice history."
			},
			{
				"title": "Limits",
				"body": "The tool does not score regulation, infer clinical state, require a positive effect, or include exact scripts unless supplied."
			}
		],
		"faqItems": [
			{
				"question": "Does Dropping Anchor produce a score?",
				"answer": "No. Dropping Anchor has no scored output."
			},
			{
				"question": "Can a client stop early?",
				"answer": "Yes. A stopped practice is recorded as stopped, not failed, and the client can restart quickly."
			},
			{
				"question": "Is reflection required?",
				"answer": "No. Reflection is optional, and completion does not depend on reporting a positive effect."
			}
		]
	},
	{
		"toolType": "noticeFiveThings",
		"slug": "notice-five-things",
		"title": "Notice Five Things ACT Exercise | Qwoach",
		"metaDescription": "Explore Notice Five Things, an ACT present-moment exercise for helping clients notice seeing, hearing, and body-contact sensations.",
		"h1": "Notice Five Things",
		"intro": "Notice Five Things is an ACT present-moment mindfulness exercise for therapists, counselors, educators, and coaches. It helps a client reorient from being caught up in thoughts and feelings toward current visual, auditory, and body-contact sensations.",
		"demoTitle": "Try the guided practice with sample, non-identifying content, then review what a practitioner would see after completion.",
		"demoPrompt": "Interested in using Notice Five Things with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0201-f-005-act-010-r002-notice-five-things.md",
		"specId": "0201-f-005-act-010-r002-notice-five-things",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Mindfulness",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for in-session centering, group practice, homework, or between-session coping practice when a client is caught up in thoughts and feelings."
			},
			{
				"title": "Important Limitation",
				"body": "This tool is not a scored assessment, symptom scale, mood tracker, or generic grounding-technique selector."
			}
		],
		"faqItems": [
			{
				"question": "Does Notice Five Things produce a score?",
				"answer": "No. It produces completion and sequence information only, plus optional reflection or practitioner observation."
			},
			{
				"question": "Can a client continue without typing answers?",
				"answer": "Yes. The exercise is experiential, so blank responses are valid when text capture is available."
			},
			{
				"question": "What can the practitioner configure?",
				"answer": "The practitioner can configure delivery mode: live guidance, assigned individual practice, or group use."
			},
			{
				"question": "Is this the same as a generic 5-4-3-2-1 grounding tool?",
				"answer": "No. This tool is the specific ACT see, hear, and bodily-contact noticing practice described in the product specification."
			}
		]
	},
	{
		"toolType": "mindfulnessOfTheHand",
		"slug": "mindfulness-of-the-hand",
		"title": "Mindfulness of The Hand ACT Exercise | Qwoach",
		"metaDescription": "Explore Mindfulness of The Hand, an ACT exercise for practicing direct sensory noticing and noticing mind comments as comments.",
		"h1": "Mindfulness of The Hand",
		"intro": "Mindfulness of The Hand is an ACT object-focused mindfulness exercise for therapists, trainers, and educators. It helps a client attend to observable details of one hand while noticing judgments, predictions, and distractions as mind comments.",
		"demoTitle": "Explore the guided hand-observation flow with sample reflections, then review the descriptive practice summary.",
		"demoPrompt": "Interested in using Mindfulness of The Hand with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0202-f-005-act-010-r003-mindfulness-of-the-hand.md",
		"specId": "0202-f-005-act-010-r003-mindfulness-of-the-hand",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Mindfulness",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool can capture optional direct sensory observations, optional mind comments, completion state, and practitioner observations."
			},
			{
				"title": "Important Limitation",
				"body": "The tool does not score mindfulness, infer fusion or defusion, substitute another object, or create a general meditation library."
			}
		],
		"faqItems": [
			{
				"question": "Does the client have to type during the exercise?",
				"answer": "No. Typing is optional because the core task is attention practice."
			},
			{
				"question": "Can the practitioner change the object from the hand to something else?",
				"answer": "No. The hand is the fixed attention anchor for this tool."
			},
			{
				"question": "What does the review show?",
				"answer": "The review shows completion state and any optional reflections, separating observed details from mind comments when both are entered."
			}
		]
	},
	{
		"toolType": "observerExercise",
		"slug": "observer-exercise",
		"title": "Observer Exercise for ACT Self-as-Context | Qwoach",
		"metaDescription": "Explore the Observer Exercise, an ACT self-as-context practice for noticing changing experiences and an observing perspective.",
		"h1": "Observer Exercise",
		"intro": "Observer Exercise is an ACT self-as-context exercise for therapists, clinical psychologists, counselors, and ACT-informed coaches. It helps a client notice sensations, memories, roles, thoughts, emotions, or self-labels as changing experiences while orienting to the perspective from which they are noticed.",
		"demoTitle": "Configure a sample guided exercise, move through selected domains, and review the qualitative observer-perspective summary.",
		"demoPrompt": "Interested in using Observer Exercise with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0203-f-005-act-011-r001-observer-exercise.md",
		"specId": "0203-f-005-act-011-r001-observer-exercise",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Self-as-context"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Partial Use",
				"body": "Partial exercises are meaningful because a client may explore some domains but not others. The review shows the last reached domain rather than marking failure."
			},
			{
				"title": "Clinical Boundary",
				"body": "The product does not diagnose, score self-as-context, infer observer-self attainment, or automate conclusions about fusion."
			}
		],
		"faqItems": [
			{
				"question": "Can the practitioner choose which domains to include?",
				"answer": "Yes. The practitioner can include or omit supported domains while preserving the exercise identity."
			},
			{
				"question": "What happens if the client cannot describe an observing perspective?",
				"answer": "The result records that descriptively; it does not mark failure or generate an interpretation."
			},
			{
				"question": "Can this be assigned outside session?",
				"answer": "Yes. The supported delivery modes include assigned practice, though live guidance may provide more immediate support."
			}
		]
	},
	{
		"toolType": "chessboardMetaphor",
		"slug": "chessboard-metaphor",
		"title": "Chessboard Metaphor ACT Exercise | Qwoach",
		"metaDescription": "Explore the ACT Chessboard Metaphor for mapping conflicting inner experiences as pieces and shifting to a board-level perspective.",
		"h1": "Chessboard Metaphor",
		"intro": "Chessboard Metaphor is an ACT self-as-context exercise for therapists, counselors, psychologists, trainers, and ACT-informed practitioners. It helps a client represent conflicting thoughts, feelings, cravings, or self-evaluations as pieces on a board and consider a broader observing perspective.",
		"demoTitle": "Build a sample board with fictional internal-experience labels, then review the map and board-level reflection.",
		"demoPrompt": "Interested in using Chessboard Metaphor with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0204-f-005-act-011-r002-chessboard-metaphor.md",
		"specId": "0204-f-005-act-011-r002-chessboard-metaphor",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Self-as-context"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures client-reported internal-experience labels, optional grouping into opposing sides, board-level reflection, and practitioner observations."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not choose a winning side, evaluate truth, score the client, or provide strategic advice."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool solve the conflict?",
				"answer": "No. It maps the conflict and supports a shift to board-level perspective without deciding which side should win."
			},
			{
				"question": "Can the tool be used without a visual board?",
				"answer": "Yes. The supported enactment modes include a text-only map and live physical enactment support."
			},
			{
				"question": "What if the client names only one side?",
				"answer": "The map can remain incomplete and show one side without forcing opposition."
			}
		]
	},
	{
		"toolType": "pickAnIdentityExercise",
		"slug": "pick-an-identity-exercise",
		"title": "Pick an Identity ACT Exercise | Qwoach",
		"metaDescription": "Explore Pick an Identity, an ACT exercise for helping clients notice self-descriptions as content held flexibly, not fixed identity.",
		"h1": "Pick an Identity Exercise",
		"intro": "Pick an Identity Exercise is an ACT experiential exercise for therapists, counselors, psychologists, and ACT trainers. It helps a client temporarily hold identity descriptions and notice self-labels as psychological content rather than fixed truth.",
		"demoTitle": "Enter fictional practitioner-supplied identity statements, preview one-at-a-time display, and review the qualitative reaction log.",
		"demoPrompt": "Interested in using Pick an Identity Exercise with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0205-f-005-act-011-r003-pick-an-identity-exercise.md",
		"specId": "0205-f-005-act-011-r003-pick-an-identity-exercise",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Self-as-context"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Required Setup",
				"body": "The exercise requires practitioner-entered statements or source-provided statements when available. Without statements, the exercise cannot be fully configured."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not generate labels, infer identity traits, score identity flexibility, or create a reusable personality profile."
			}
		],
		"faqItems": [
			{
				"question": "Does the product generate identity labels?",
				"answer": "No. Identity statements must be practitioner-entered or source-provided when available."
			},
			{
				"question": "Is this a personality test?",
				"answer": "No. It is a live experiential exercise for noticing self-descriptions as holdable content."
			},
			{
				"question": "What if a statement feels harmful or too evocative?",
				"answer": "The practitioner can skip or stop the exercise and preserve notes without treating the response as failure."
			}
		]
	},
	{
		"toolType": "choicePoint",
		"slug": "choice-point",
		"title": "Choice Point ACT Map | Qwoach",
		"metaDescription": "Explore Choice Point, an ACT-derived map for choice moments, hooks, away moves, toward moves, and workable alternatives.",
		"h1": "Choice Point",
		"intro": "Choice Point is an ACT-derived action-pattern map for practitioners. It helps clarify a client's recurring choice moments, triggers or hooks, away moves, toward moves, and workable alternatives so intervention can focus on value-consistent behavior in difficult moments.",
		"demoTitle": "Create a sample map with fictional examples, inspect unmapped areas, and see how the result supports review.",
		"demoPrompt": "Interested in using Choice Point with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0206-f-005-act-012-r001-choice-point.md",
		"specId": "0206-f-005-act-012-r001-choice-point",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Repeat Use",
				"body": "History is useful because repeated maps can show recurring hooks, away moves, and emerging toward alternatives while preserving context differences."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not score the client, rank values, predict behavior, or decide which action is clinically correct."
			}
		],
		"faqItems": [
			{
				"question": "What is saved in a Choice Point result?",
				"answer": "The result saves the action-pattern map: choice moments, hooks or triggers, away moves, toward moves, workable alternatives, authorship, and practitioner notes where entered."
			},
			{
				"question": "Can the map be incomplete?",
				"answer": "Yes. Partial maps are allowed and can show missing alternatives or unresolved areas."
			},
			{
				"question": "Does the tool decide what counts as a toward move?",
				"answer": "No. Client examples are reported, structure is descriptive, and clinical meaning remains practitioner interpreted."
			}
		]
	},
	{
		"toolType": "acceptanceVsControlAgenda",
		"slug": "acceptance-vs-control-agenda",
		"title": "Acceptance vs Control Agenda ACT Tool | Qwoach",
		"metaDescription": "Explore an ACT formulation tool for mapping control or avoidance strategies, their costs, and acceptance-oriented alternatives.",
		"h1": "Acceptance vs Control Agenda",
		"intro": "Acceptance vs Control Agenda is an ACT process formulation tool for practitioners. It helps distinguish a client's attempts to control, avoid, or eliminate unwanted inner experiences from more open, accepting responses that can be considered in treatment.",
		"demoTitle": "Build a fictional contrast map, leave unresolved areas where needed, and review the formulation view.",
		"demoPrompt": "Interested in using Acceptance vs Control Agenda with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0207-f-005-act-013-r001-acceptance-vs-control-agenda.md",
		"specId": "0207-f-005-act-013-r001-acceptance-vs-control-agenda",
		"tags": {
			"framework": [
				"ACT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Partial Formulations",
				"body": "Costs or alternatives may be unclear at first. The tool can preserve unresolved sections for later review."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not generate alternatives, score workability, or decide that a strategy is unworkable."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool tell the client what they should accept?",
				"answer": "No. Acceptance-oriented alternatives are entered by the practitioner or client and remain part of clinical formulation."
			},
			{
				"question": "Can a control strategy be recorded as helpful?",
				"answer": "Yes. The perceived function can be recorded, along with any costs or limits when they are clear."
			},
			{
				"question": "Is this a symptom tracker?",
				"answer": "No. It is a contrastive ACT process formulation, not a symptom tracker or score-based measure."
			}
		]
	},
	{
		"toolType": "threeCirclesEmotionRegulationSystemsMap",
		"slug": "three-circles-emotion-regulation-systems-map",
		"title": "CFT Three Circles Map | Qwoach",
		"metaDescription": "Explore a CFT Three Circles map for organizing client examples across threat, drive, and soothing regulation systems.",
		"h1": "Three Circles / Emotion Regulation Systems Map",
		"intro": "Three Circles / Emotion Regulation Systems Map is a Compassion Focused Therapy formulation tool for compassion-focused practitioners. It helps organize client examples across threat, drive, and soothing systems so regulation patterns and soothing capacity can be discussed clinically.",
		"demoTitle": "Place fictional examples into the three systems, add sample practitioner notes, and review the profile.",
		"demoPrompt": "Interested in using Three Circles / Emotion Regulation Systems Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0208-f-006-cft-001-r001-three-circles-emotion-regulation-systems-map.md",
		"specId": "0208-f-006-cft-001-r001-three-circles-emotion-regulation-systems-map",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "History and Comparison",
				"body": "History can show changes in examples and soothing-capacity notes over time, using descriptive snapshots rather than scores."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not implement scale scoring, normative categories, physiological measures, or automated intervention recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Are threat, drive, and soothing configurable?",
				"answer": "No. The three systems are fixed as threat, drive, and soothing."
			},
			{
				"question": "Does the tool produce a score?",
				"answer": "No. It produces a personalized map and descriptive indicators, not a score or normative classification."
			},
			{
				"question": "What if the client has no soothing examples?",
				"answer": "The soothing area can remain sparse or unresolved instead of forcing content."
			}
		]
	},
	{
		"toolType": "cftCaseFormulation",
		"slug": "cft-case-formulation",
		"title": "CFT Case Formulation Tool | Qwoach",
		"metaDescription": "Explore a practitioner-only CFT case formulation workspace for linking difficulties, maintaining processes, and compassion-focused targets.",
		"h1": "CFT Case Formulation",
		"intro": "CFT Case Formulation is a practitioner-only structured clinical formulation tool for CFT practitioners. It helps organize a client's difficulties, relevant developmental, emotional, cognitive, and behavioral patterns, maintaining processes, and compassion-focused treatment targets.",
		"demoTitle": "Explore a sample practitioner-only formulation workspace and review how links and unresolved areas appear.",
		"demoPrompt": "Interested in using CFT Case Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0209-f-006-cft-002-r001-cft-case-formulation.md",
		"specId": "0209-f-006-cft-002-r001-cft-case-formulation",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The product specification does not require a client-facing flow. The practitioner creates, edits, links, and revises the formulation."
			},
			{
				"title": "Version History",
				"body": "Formulation history is important because a working formulation can change substantially over treatment and prior versions should remain distinguishable."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not a full EHR, diagnosis generator, risk assessment, treatment-plan generator, or generic formulation builder."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client-facing version of this tool?",
				"answer": "No. The supplied product specification defines this as practitioner-only."
			},
			{
				"question": "Does the tool generate treatment targets?",
				"answer": "No. Treatment targets are practitioner-entered; the system only organizes and links content."
			},
			{
				"question": "What happens if a section is incomplete?",
				"answer": "The formulation can remain in draft with unresolved sections and visible link gaps."
			}
		]
	},
	{
		"toolType": "functionalAnalysisOfSelfCriticism",
		"slug": "functional-analysis-of-self-criticism",
		"title": "CFT Self-Criticism Functional Analysis | Qwoach",
		"metaDescription": "Explore a CFT functional map for self-criticism, triggers, protective intentions, consequences, needs, and compassionate alternatives.",
		"h1": "Functional Analysis of Self-Criticism",
		"intro": "Functional Analysis of Self-Criticism is a CFT functional map for practitioners. It helps clarify triggers, protective intentions, emotional and behavioral consequences, costs, underlying needs, and compassionate alternatives for self-criticism or shame.",
		"demoTitle": "Create a fictional episode or pattern map, mark uncertain fields unresolved, and review the functional chain.",
		"demoPrompt": "Interested in using Functional Analysis of Self-Criticism with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0210-f-006-cft-003-r001-functional-analysis-of-self-criticism.md",
		"specId": "0210-f-006-cft-003-r001-functional-analysis-of-self-criticism",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Self-criticism",
				"Shame"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Single Episode or Pattern",
				"body": "A single episode map supports concrete learning from one event. A recurring pattern map emphasizes common triggers and functions across examples."
			},
			{
				"title": "Shame-Sensitive Use",
				"body": "Self-critical content may be omitted or held in practitioner-only notes when needed. The tool allows uncertainty and partial answers."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not generate affirmations, diagnose, score self-criticism, evaluate thought truth, or automatically interpret clinical meaning."
			}
		],
		"faqItems": [
			{
				"question": "Can the map be saved if the protective function is unclear?",
				"answer": "Yes. The function or protective logic can be marked unresolved and revisited later."
			},
			{
				"question": "Does the tool generate compassionate alternatives?",
				"answer": "No. Compassionate alternatives are entered by the practitioner or client and should be linked to the same underlying needs."
			},
			{
				"question": "Can the client skip entering self-critical content?",
				"answer": "Yes. Distressing content can be omitted or noted by the practitioner as appropriate."
			},
			{
				"question": "Is this a CBT thought record?",
				"answer": "No. It is a CFT functional map focused on self-criticism, shame, protective intentions, consequences, needs, and compassionate alternatives."
			}
		]
	},
	{
		"toolType": "fearsOfCompassionScaleFearsOfCompassionScalesFcs",
		"slug": "fears-of-compassion-scale-fears-of-compassion-scales-fcs",
		"title": "Fears of Compassion Scale demo | Qwoach",
		"metaDescription": "Explore a CFT questionnaire that profiles fears, blocks, and resistances across compassion for others, from others, and toward self.",
		"h1": "Fears of Compassion Scale",
		"intro": "The Fears of Compassion Scale is a client-completed CFT questionnaire for practitioners assessing barriers to compassion. CFT practitioners, clinical psychologists, counsellors, researchers, and psychology services use it to identify fear or resistance patterns across compassion for others, compassion from others, and compassion toward self.",
		"demoTitle": "Explore the questionnaire",
		"demoPrompt": "Interested in using Fears of Compassion Scale / Fears of Compassion Scales (FCS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0211-f-006-cft-004-r001-fears-of-compassion-scale-fears-of-compassion-scales-fcs.md",
		"specId": "0211-f-006-cft-004-r001-fears-of-compassion-scale-fears-of-compassion-scales-fcs",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the FCS when a practitioner wants to understand barriers to compassion before or during compassion-focused formulation and treatment planning."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures client ratings of statements about compassion for others, compassion from others, and compassion toward self, then shows item-level and supported flow-level patterns."
			},
			{
				"title": "Important Limits",
				"body": "The tool organizes self-report responses descriptively. It does not explain why a fear exists, assign unsupported severity labels, diagnose the client, or generate treatment instructions."
			}
		],
		"faqItems": [
			{
				"question": "What does the Fears of Compassion Scale measure?",
				"answer": "It measures self-reported fears, blocks, and resistances to compassion across compassion for others, compassion from others, and compassion toward self."
			},
			{
				"question": "Who completes the questionnaire?",
				"answer": "The client completes the item ratings, and the practitioner reviews the grouped responses and any source-supported profile or score."
			},
			{
				"question": "Does the tool interpret the client's results clinically?",
				"answer": "No. The tool shows reported ratings and descriptive patterns; practitioner interpretation remains separate."
			},
			{
				"question": "Can it be used repeatedly?",
				"answer": "Yes. Repeated administrations can be compared when the form version, response options, and scoring basis are preserved."
			}
		]
	},
	{
		"toolType": "soothingRhythmBreathing",
		"slug": "soothing-rhythm-breathing",
		"title": "Soothing Rhythm Breathing demo | Qwoach",
		"metaDescription": "Explore a live CFT breathing practice that helps clients slow and steady breathing before compassion-focused reflection or practice.",
		"h1": "Soothing Rhythm Breathing",
		"intro": "Soothing Rhythm Breathing is a live compassion-focused breathing practice for CFT practitioners. Practitioners use it to help a client slow and steady breathing, notice whether arousal settles, and prepare for compassion-focused reflection or practice.",
		"demoTitle": "Start the practice demo",
		"demoPrompt": "Interested in using Soothing Rhythm Breathing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0212-f-006-cft-005-r001-soothing-rhythm-breathing.md",
		"specId": "0212-f-006-cft-005-r001-soothing-rhythm-breathing",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Emotion regulation",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client is physiologically aroused or unsettled and the practitioner wants to support a steadier state before compassion-focused reflection or practice."
			},
			{
				"title": "What Is Tracked",
				"body": "Tracking is optional and minimal: duration, completion or interruption, selected guide, and brief reported or observed effect if captured."
			},
			{
				"title": "Limits",
				"body": "The tool does not require ratings, journaling, scoring, breath analysis, or diagnostic interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Is Soothing Rhythm Breathing an assessment?",
				"answer": "No. It is a live guided breathing practice, with optional minimal tracking only if the practitioner chooses to record it."
			},
			{
				"question": "Does the client need to complete a form?",
				"answer": "No. The client follows the breathing rhythm in session and may give brief feedback if tracking is used."
			},
			{
				"question": "What happens if the client becomes distressed?",
				"answer": "The practice can be paused or stopped immediately, and the practitioner returns to live support."
			},
			{
				"question": "What gets saved?",
				"answer": "The tool itself and selected supported delivery setup are saved; demo runs and sample feedback are not saved as client data."
			}
		]
	},
	{
		"toolType": "safePlaceImagery",
		"slug": "safe-place-imagery",
		"title": "Safe Place Imagery demo | Qwoach",
		"metaDescription": "Explore a live CFT imagery practice for helping clients access a safe-enough, grounding image before deeper compassion work.",
		"h1": "Safe Place Imagery",
		"intro": "Safe Place Imagery is a live CFT guided imagery practice for practitioners. Practitioners use it to help a client access an imagery-based state associated with safeness, steadiness, comfort, or grounding before deeper compassion-focused work.",
		"demoTitle": "Open the imagery demo",
		"demoPrompt": "Interested in using Safe Place Imagery with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0213-f-006-cft-006-r001-safe-place-imagery.md",
		"specId": "0213-f-006-cft-006-r001-safe-place-imagery",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Emotion regulation",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client Control",
				"body": "The client controls what imagery content they disclose. A useful summary can be brief and focused on recall cues rather than a detailed narrative."
			},
			{
				"title": "When Imagery Is Not Usable",
				"body": "If the image increases distress, feels unavailable, or no safe-enough place emerges, the result can record barriers without forcing completion."
			}
		],
		"faqItems": [
			{
				"question": "Does the client have to describe the safe place in detail?",
				"answer": "No. Description is optional and should include only what the client chooses to share."
			},
			{
				"question": "Does the tool interpret the image?",
				"answer": "No. The tool records reported imagery, cues, barriers, and observations without symbolic interpretation."
			},
			{
				"question": "Can a prior image be reused?",
				"answer": "Yes. A saved summary can help practitioner and client return to a previously useful image, while preserving that the client may later report it no longer feels safe."
			}
		]
	},
	{
		"toolType": "idealCompassionateOtherImagery",
		"slug": "ideal-compassionate-other-imagery",
		"title": "Ideal Compassionate Other demo | Qwoach",
		"metaDescription": "Explore a CFT imagery practice for helping clients experience care, wisdom, strength, and nonjudgment from an imagined presence.",
		"h1": "Ideal Compassionate Other Imagery",
		"intro": "Ideal Compassionate Other Imagery is a live CFT guided imagery practice for practitioners. Practitioners use it to help a client imagine being related to by an ideally compassionate presence with care, wisdom, strength, and nonjudgment.",
		"demoTitle": "Explore the imagery practice",
		"demoPrompt": "Interested in using Ideal Compassionate Other Imagery with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0214-f-006-cft-007-r001-ideal-compassionate-other-imagery.md",
		"specId": "0214-f-006-cft-007-r001-ideal-compassionate-other-imagery",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The optional summary captures compassionate qualities, felt experience, and barriers to receiving compassion when the client chooses to share them."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not require visual details, assign standardized ratings, diagnose attachment patterns, or interpret the imagined presence."
			}
		],
		"faqItems": [
			{
				"question": "Is this a character design tool?",
				"answer": "No. It is a guided relational imagery practice focused on the felt experience of receiving compassion."
			},
			{
				"question": "Does the client have to share image details?",
				"answer": "No. The client controls what qualities or imagery content they disclose."
			},
			{
				"question": "What if receiving compassion feels uncomfortable?",
				"answer": "The practice can be stopped or scaled back, and barriers can be recorded descriptively for practitioner follow-up."
			}
		]
	},
	{
		"toolType": "compassionateImage",
		"slug": "compassionate-image",
		"title": "Compassionate Image demo | Qwoach",
		"metaDescription": "Explore a CFT practice for developing a personally meaningful compassionate image with attributes, recall cues, and barriers.",
		"h1": "Compassionate Image",
		"intro": "Compassionate Image is a live CFT practice for practitioners helping clients develop a personally meaningful internal compassionate resource. Practitioners use it to support an image with attributes of care, wisdom, strength, and acceptance that may help the client work with distress or self-criticism.",
		"demoTitle": "Explore the image practice",
		"demoPrompt": "Interested in using Compassionate Image with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0215-f-006-cft-008-r001-compassionate-image.md",
		"specId": "0215-f-006-cft-008-r001-compassionate-image",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Self-criticism",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Nonvisual Images",
				"body": "The client is not forced to create a detailed visual picture. A felt sense or other clinically accepted form can be described if useful."
			},
			{
				"title": "Change Over Time",
				"body": "If the image changes, prior summaries should remain available rather than silently overwriting earlier meaning."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create an image for the client?",
				"answer": "No. The client develops and describes their own compassionate image or felt resource; the tool does not generate artwork."
			},
			{
				"question": "What is saved in a real session?",
				"answer": "A concise summary can save client-reported attributes, recall cues, emotional effect, barriers, and practitioner observations."
			},
			{
				"question": "Can the image be incomplete?",
				"answer": "Yes. Incomplete resource development can be recorded, including barriers or areas to revisit."
			}
		]
	},
	{
		"toolType": "compassionateSelf",
		"slug": "compassionate-self",
		"title": "Compassionate Self demo | Qwoach",
		"metaDescription": "Explore a CFT practice for helping clients access compassion, courage, wisdom, and warmth when facing distress or self-criticism.",
		"h1": "Compassionate Self",
		"intro": "Compassionate Self is a live CFT experiential practice for practitioners. Practitioners use it to help a client access compassion, courage, wisdom, and warmth, then apply that self-state to distress or self-criticism when appropriate.",
		"demoTitle": "Explore the practice",
		"demoPrompt": "Interested in using Compassionate Self with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0216-f-006-cft-009-r001-compassionate-self.md",
		"specId": "0216-f-006-cft-009-r001-compassionate-self",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Self-criticism",
				"Shame",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client Disclosure",
				"body": "The client controls what difficulty and internal experience they disclose. Application can be deferred when it feels overwhelming."
			},
			{
				"title": "What Review Supports",
				"body": "Review helps the practitioner revisit qualities, shifts, and barriers over time without turning the practice into a scored measure."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write compassionate responses for the client?",
				"answer": "No. It supports guided practice and descriptive capture; it does not generate responses or advice."
			},
			{
				"question": "Can the client skip applying the state to a difficulty?",
				"answer": "Yes. Application can be deferred if it feels too activating or clinically inappropriate."
			},
			{
				"question": "Does the tool score the compassionate self-state?",
				"answer": "No. It records descriptive qualities, shifts, application, and barriers when captured."
			}
		]
	},
	{
		"toolType": "compassionateLetterWriting",
		"slug": "compassionate-letter-writing",
		"title": "Compassionate Letter Writing demo | Qwoach",
		"metaDescription": "Explore a CFT writing practice where clients draft and choose whether to share a compassionate response to shame or self-criticism.",
		"h1": "Compassionate Letter Writing",
		"intro": "Compassionate Letter Writing is a CFT writing practice for practitioners and clients. Practitioners use it when a client needs to articulate a compassionate response to shame, self-criticism, or distress that can be reflected on and shared when the client chooses.",
		"demoTitle": "Try the writing demo",
		"demoPrompt": "Interested in using Compassionate Letter Writing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0217-f-006-cft-010-r001-compassionate-letter-writing.md",
		"specId": "0217-f-006-cft-010-r001-compassionate-letter-writing",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Self-criticism",
				"Shame",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client Sharing Control",
				"body": "The client can draft privately and share only when they choose. Output exists for practitioner review when the client shares it."
			},
			{
				"title": "Review Boundaries",
				"body": "Practitioner notes are separate from the client's words, and the tool does not judge, rewrite, or score the letter."
			}
		],
		"faqItems": [
			{
				"question": "Does the practitioner see every draft?",
				"answer": "No. The practitioner sees the letter when the client chooses to share it."
			},
			{
				"question": "Does the tool rewrite the letter to sound more compassionate?",
				"answer": "No. The client's own writing is the artifact; the tool does not substitute generated content."
			},
			{
				"question": "Can a letter be saved without being shared?",
				"answer": "Yes. A client can pause and resume a private draft, depending on the real assignment workflow."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews the shared letter, optional context, sharing status, and separate practitioner notes."
			}
		]
	},
	{
		"toolType": "chairWorkMultiSelfDialogue",
		"slug": "chair-work-multi-self-dialogue",
		"title": "CFT Chair Work demo | Qwoach",
		"metaDescription": "Explore a live CFT chair-work note for capturing self-positions, beliefs, needs, compassionate responses, and observed shifts.",
		"h1": "Chair Work / Multi-Self Dialogue",
		"intro": "Chair Work / Multi-Self Dialogue is a live CFT experiential practice for practitioners. Practitioners use it to help clients express, differentiate, and relate compassionately to conflicting self-positions, self-critical voices, unmet needs, or shame-based positions.",
		"demoTitle": "Open the live note demo",
		"demoPrompt": "Interested in using Chair Work / Multi-Self Dialogue with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0218-f-006-cft-011-r001-chair-work-multi-self-dialogue.md",
		"specId": "0218-f-006-cft-011-r001-chair-work-multi-self-dialogue",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Self-criticism",
				"Shame"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Flexible Positions",
				"body": "Position labels are descriptive and editable. The tool does not impose a fixed taxonomy of parts."
			},
			{
				"title": "Live Work First",
				"body": "The note supports facilitation but does not replace clinical pacing, movement, dialogue, or practitioner judgment."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client questionnaire?",
				"answer": "No. It is primarily a practitioner-facing live-session note for chair work or multi-self dialogue."
			},
			{
				"question": "Does the tool require a fixed list of parts?",
				"answer": "No. Positions and voices are flexible and descriptive."
			},
			{
				"question": "Does it score integration?",
				"answer": "No. It records descriptive observations and does not produce integration scores or automated interpretations."
			},
			{
				"question": "Can notes be completed after the session?",
				"answer": "Yes. The product supports quick live capture or later completion when that fits the session."
			}
		]
	},
	{
		"toolType": "compassionateVoiceTonePractice",
		"slug": "compassionate-voice-tone-practice",
		"title": "Compassionate Voice Tone demo | Qwoach",
		"metaDescription": "Explore a live CFT practice for helping clients recognize and shift from harsh tone toward warmth, steadiness, and compassion.",
		"h1": "Compassionate Voice Tone Practice",
		"intro": "Compassionate Voice Tone Practice is a live CFT experiential practice for practitioners and clients. Practitioners use it when a client's self-talk or interpersonal expression is harsh, threatening, or emotionally unsafe and the client needs to recognize and shift toward a more compassionate tone.",
		"demoTitle": "Open the live practice",
		"demoPrompt": "Interested in using Compassionate Voice Tone Practice with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0219-f-006-cft-012-r001-compassionate-voice-tone-practice.md",
		"specId": "0219-f-006-cft-012-r001-compassionate-voice-tone-practice",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Self-criticism",
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "No Audio Analysis",
				"body": "The tool does not record audio by default, analyze vocal features, or score tone."
			},
			{
				"title": "No Required Output",
				"body": "The practice is complete as a live experiential exercise. A brief practitioner note is optional."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool record the client's voice?",
				"answer": "No. Audio recording is not part of the default product behavior."
			},
			{
				"question": "Does it score voice tone?",
				"answer": "No. The tool does not analyze or score voice tone."
			},
			{
				"question": "Is there a client form?",
				"answer": "No. This is a live practice, not a client-completed form."
			},
			{
				"question": "What gets saved if there are no settings?",
				"answer": "The fixed Compassionate Voice Tone Practice tool itself is saved as-is."
			}
		]
	},
	{
		"toolType": "compassionatePostureEmbodiment",
		"slug": "compassionate-posture-embodiment",
		"title": "Compassionate Posture demo | Qwoach",
		"metaDescription": "Explore a live CFT embodiment practice for helping clients notice and shift bodily cues toward steadiness and compassionate presence.",
		"h1": "Compassionate Posture / Embodiment",
		"intro": "Compassionate Posture / Embodiment is a live CFT experiential practice for practitioners and clients. Practitioners use it to help a client notice and shift bodily stance toward steadiness, openness, courage, and compassionate presence.",
		"demoTitle": "Open the embodiment practice",
		"demoPrompt": "Interested in using Compassionate Posture / Embodiment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0220-f-006-cft-013-r001-compassionate-posture-embodiment.md",
		"specId": "0220-f-006-cft-013-r001-compassionate-posture-embodiment",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Emotion regulation",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "No Biometric Capture",
				"body": "The tool does not require photos, video, biometric data, posture scoring, or movement analysis."
			},
			{
				"title": "Optional Notes Only",
				"body": "Because the product has no required structured output, notes are optional and descriptive when the practitioner chooses to record them."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool assess posture?",
				"answer": "No. It supports live embodiment practice and does not score, correct, or analyze posture."
			},
			{
				"question": "Does the client need to submit anything?",
				"answer": "No. The client participates live and may give feedback, but no client submission is required."
			},
			{
				"question": "Can the practice be stopped?",
				"answer": "Yes. The practitioner or client can pause, adjust, or stop if the posture or movement feels uncomfortable."
			},
			{
				"question": "What gets saved if there are no configurable settings?",
				"answer": "The fixed Compassionate Posture / Embodiment tool itself is saved as-is."
			}
		]
	},
	{
		"toolType": "threeFlowsOfCompassionMap",
		"slug": "three-flows-of-compassion-map",
		"title": "Three Flows of Compassion Map for CFT Formulation | Qwoach",
		"metaDescription": "Explore a CFT process map for comparing giving compassion, receiving compassion, and self-compassion before saving it to your account.",
		"h1": "Three Flows of Compassion Map",
		"intro": "The Three Flows of Compassion Map is a CFT formulation aid for practitioners. It helps compare giving compassion, receiving compassion, and directing compassion toward self so the practitioner can identify available, blocked, feared, underdeveloped, or imbalanced compassion processes.",
		"demoTitle": "Explore the sample map",
		"demoPrompt": "Interested in using Three Flows of Compassion Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0221-f-006-cft-014-r001-three-flows-of-compassion-map.md",
		"specId": "0221-f-006-cft-014-r001-three-flows-of-compassion-map",
		"tags": {
			"framework": [
				"Compassion Focused Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during CFT formulation when compassion processes need to be compared across giving, receiving, and self-directed compassion."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not score compassion, diagnose the client, generate CFT prompts, or prescribe interventions. It organizes practitioner-entered material into a process profile."
			},
			{
				"title": "Repeat Review",
				"body": "Profiles can remain partial and be updated later. Changes are compared descriptively because the tool has no standardized scale."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score compassion?",
				"answer": "No. The tool produces a descriptive compassion process profile, not a score."
			},
			{
				"question": "Can the client complete it independently?",
				"answer": "No independent client worksheet is required. The map can be completed by the practitioner or together with the client during a session."
			},
			{
				"question": "Can I change the three compassion flows?",
				"answer": "No. Giving compassion, receiving compassion, and self-compassion are fixed parts of the tool."
			},
			{
				"question": "What happens if one flow is unclear?",
				"answer": "Unclear flows can be left unresolved and shown as incomplete in the profile."
			}
		]
	},
	{
		"toolType": "emdrHistoryTakingTimeline",
		"slug": "emdr-history-taking-timeline",
		"title": "EMDR History-Taking Timeline for Target Candidates | Qwoach",
		"metaDescription": "Explore a practitioner-only EMDR timeline for organizing history, candidate target memories, and recurring themes before saving it.",
		"h1": "EMDR History-Taking / Timeline",
		"intro": "The EMDR History-Taking / Timeline is a practitioner-only EMDR planning aid. It helps practitioners organize relevant client history chronologically so candidate target memories, events, recurring themes, and patterns are clear before initial target selection.",
		"demoTitle": "Explore the sample timeline",
		"demoPrompt": "Interested in using EMDR History-Taking / Timeline with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0222-f-007-emd-001-r001-emdr-history-taking-timeline.md",
		"specId": "0222-f-007-emd-001-r001-emdr-history-taking-timeline",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Session preparation"
			],
			"topic": [
				"Clinical history",
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Flexible Timing",
				"body": "Entries can use exact dates, approximate ages, life periods, sequence position, or unknown timing so the timeline does not force false precision."
			},
			{
				"title": "Practitioner Control",
				"body": "Candidate targets and themes are marked by the practitioner. The system organizes the material but does not select targets."
			},
			{
				"title": "Incomplete History",
				"body": "An incomplete timeline can remain useful as a working history and can be updated as more information emerges."
			}
		],
		"faqItems": [
			{
				"question": "Does the timeline automatically choose EMDR targets?",
				"answer": "No. The practitioner marks candidate targets; the system organizes chronology and themes descriptively."
			},
			{
				"question": "Does the client complete the timeline?",
				"answer": "No. This is a practitioner-only tool, though the client may provide history in session."
			},
			{
				"question": "Can I enter approximate dates?",
				"answer": "Yes. The tool supports approximate ages, life periods, sequence position, and unknown timing."
			},
			{
				"question": "Is the timeline a full EMDR protocol?",
				"answer": "No. It supports history organization and target-candidate identification only."
			}
		]
	},
	{
		"toolType": "aipCaseConceptualization",
		"slug": "aip-case-conceptualization",
		"title": "AIP Case Conceptualization for EMDR Practitioners | Qwoach",
		"metaDescription": "Explore a practitioner-only AIP conceptualization workspace for linking memory networks, symptoms, triggers, and adaptive aims.",
		"h1": "AIP Case Conceptualization",
		"intro": "AIP Case Conceptualization is a practitioner-only EMDR formulation aid. It helps practitioners organize relevant memory networks, linked experiences, current symptoms, triggers, and adaptive therapeutic aims into a treatment conceptualization based on practitioner-confirmed links.",
		"demoTitle": "Explore the sample conceptualization",
		"demoPrompt": "Interested in using AIP Case Conceptualization with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0223-f-007-emd-002-r001-aip-case-conceptualization.md",
		"specId": "0223-f-007-emd-002-r001-aip-case-conceptualization",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Defined Links",
				"body": "The practitioner creates and confirms conceptual links. The system organizes and displays them but does not infer clinical meaning."
			},
			{
				"title": "Provisional Formulation",
				"body": "Items can remain unresolved, unlinked, or uncertain so the conceptualization can reflect incomplete clinical understanding."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not generate causal claims, diagnosis, scoring, reprocessing outcomes, or prescriptive treatment steps."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool infer why symptoms are happening?",
				"answer": "No. The practitioner defines the conceptual links; the system only organizes and displays them."
			},
			{
				"question": "Can the conceptualization be incomplete?",
				"answer": "Yes. Unlinked, uncertain, and provisional elements are supported."
			},
			{
				"question": "Is this a client worksheet?",
				"answer": "No. It is a practitioner-only EMDR formulation aid."
			},
			{
				"question": "Does it run EMDR reprocessing?",
				"answer": "No. It supports AIP case conceptualization for planning and review only."
			}
		]
	},
	{
		"toolType": "threeProngedTreatmentPlan",
		"slug": "three-pronged-treatment-plan",
		"title": "Three-Pronged EMDR Treatment Plan Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only EMDR roadmap for organizing past targets, present activators, and future adaptive responses.",
		"h1": "Three-Pronged Treatment Plan",
		"intro": "The Three-Pronged Treatment Plan is a practitioner-only EMDR planning aid. It helps practitioners organize targets across past experiences, present activators, and future adaptive responses so the treatment roadmap reflects the presenting problem and goals.",
		"demoTitle": "Explore the sample roadmap",
		"demoPrompt": "Interested in using Three-Pronged Treatment Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0224-f-007-emd-003-r001-three-pronged-treatment-plan.md",
		"specId": "0224-f-007-emd-003-r001-three-pronged-treatment-plan",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Prongs",
				"body": "Past experiences, present activators, and future adaptive responses remain the organizing frame."
			},
			{
				"title": "Coverage Gaps",
				"body": "Empty, unresolved, or not-currently-relevant prongs stay visible so the practitioner can decide whether the roadmap is clinically sufficient."
			},
			{
				"title": "Practitioner Order",
				"body": "The practitioner marks what to address first and what remains for later. The system does not rank targets automatically."
			}
		],
		"faqItems": [
			{
				"question": "Can I rename or remove the three prongs?",
				"answer": "No. Past, present, and future are fixed parts of the tool."
			},
			{
				"question": "Does the tool decide target order?",
				"answer": "No. The practitioner marks first and later targets."
			},
			{
				"question": "What if a prong is not relevant right now?",
				"answer": "The practitioner can mark it as not currently relevant or unresolved instead of forcing an entry."
			},
			{
				"question": "Is this a full EMDR treatment platform?",
				"answer": "No. It creates a target roadmap only."
			}
		]
	},
	{
		"toolType": "targetSequencePlan",
		"slug": "target-sequence-plan",
		"title": "EMDR Target Sequence Plan Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only EMDR sequencing aid for ordering targets, marking the first target, and tracking unresolved material.",
		"h1": "Target Sequence Plan",
		"intro": "Target Sequence Plan is a practitioner-only EMDR planning aid. It helps practitioners order trauma-related targets or memory networks according to clinical relevance, readiness, stability, and known target relationships while keeping the first target and unresolved material clear.",
		"demoTitle": "Explore the sample sequence",
		"demoPrompt": "Interested in using Target Sequence Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0225-f-007-emd-004-r001-target-sequence-plan.md",
		"specId": "0225-f-007-emd-004-r001-target-sequence-plan",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "First Target Clarity",
				"body": "The review view makes the first target explicit while preserving the rest of the sequence."
			},
			{
				"title": "Unresolved Targets",
				"body": "Targets can remain unordered, deferred, or unresolved without forcing false precision."
			},
			{
				"title": "No Auto-Ranking",
				"body": "The system preserves practitioner order and rationale but does not calculate readiness or priority."
			}
		],
		"faqItems": [
			{
				"question": "Does the system rank targets automatically?",
				"answer": "No. Target order is entered and revised by the practitioner."
			},
			{
				"question": "Can targets remain unordered?",
				"answer": "Yes. The tool supports a holding area for unordered, deferred, or unresolved targets."
			},
			{
				"question": "Does this tool determine readiness?",
				"answer": "No. Readiness and stability considerations can be noted by the practitioner, but the system does not make readiness decisions."
			},
			{
				"question": "Can I revise the sequence later?",
				"answer": "Yes. The current sequence can be revised while unresolved material remains visible."
			}
		]
	},
	{
		"toolType": "emdrFocusedGenogram",
		"slug": "emdr-focused-genogram",
		"title": "EMDR-Focused Genogram for Relational Trauma Mapping | Qwoach",
		"metaDescription": "Explore an EMDR-focused relational trauma map for significant relationships, family-linked patterns, and potential target themes.",
		"h1": "EMDR-Focused Genogram",
		"intro": "The EMDR-Focused Genogram is a ready-to-complete-together relational trauma mapping aid for practitioners. It helps map significant relationships, family-system patterns, and potential intergenerational or family-linked target material relevant to EMDR formulation and target selection.",
		"demoTitle": "Explore the sample map",
		"demoPrompt": "Interested in using EMDR-Focused Genogram with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0226-f-007-emd-005-r001-emdr-focused-genogram.md",
		"specId": "0226-f-007-emd-005-r001-emdr-focused-genogram",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Relational Focus",
				"body": "The map includes significant family or non-family relationships when they are relevant to relational trauma and target material."
			},
			{
				"title": "Incomplete Information",
				"body": "Unknown, unresolved, sensitive, or intentionally omitted relationships can remain minimal or unresolved."
			},
			{
				"title": "Interpretation Boundary",
				"body": "The tool can show patterns entered by the practitioner but does not automatically interpret family causality."
			}
		],
		"faqItems": [
			{
				"question": "Is this a genealogy tool?",
				"answer": "No. It is an EMDR-focused relational trauma map, not a complete family tree builder."
			},
			{
				"question": "Can non-family relationships be included?",
				"answer": "Yes. Non-family significant relationships can be included when relevant to relational trauma or target material."
			},
			{
				"question": "Does the tool interpret intergenerational patterns automatically?",
				"answer": "No. It displays entered patterns and practitioner relevance markers without automatic causality claims."
			},
			{
				"question": "Can the client help build the map?",
				"answer": "Yes. The tool is designed for collaborative session use when appropriate, with practitioner control of the clinical artifact."
			}
		]
	},
	{
		"toolType": "readinessStabilizationScreen",
		"slug": "readiness-stabilization-screen",
		"title": "EMDR Readiness and Stabilization Screen Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only EMDR readiness screen for documenting stabilization capacity, risks, gaps, and pacing decisions.",
		"h1": "Readiness / Stabilization Screen",
		"intro": "The Readiness / Stabilization Screen is a practitioner-only EMDR decision aid. It helps practitioners organize stabilization capacity, client-reported coping information, risks or gaps, and a practitioner-entered decision to proceed, pause, or adjust pacing before reprocessing.",
		"demoTitle": "Explore the sample screen",
		"demoPrompt": "Interested in using Readiness / Stabilization Screen with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0227-f-007-emd-006-r001-readiness-stabilization-screen.md",
		"specId": "0227-f-007-emd-006-r001-readiness-stabilization-screen",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Risk review"
			],
			"topic": [
				"Trauma",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Entered Decision",
				"body": "Proceed, pause, or adjust pacing is selected by the practitioner. The system does not determine readiness."
			},
			{
				"title": "Draft Protection",
				"body": "Incomplete screens remain draft and should not appear as final proceed, pause, or adjust decisions."
			},
			{
				"title": "Historical Review",
				"body": "Past readiness decisions can be reviewed descriptively for continuity, not as standardized score changes."
			}
		],
		"faqItems": [
			{
				"question": "Does this screen clear a client for reprocessing?",
				"answer": "No. The practitioner enters the pacing decision; the system does not provide automated clearance."
			},
			{
				"question": "Are there readiness scores?",
				"answer": "No. The tool does not calculate scores or automated risk levels."
			},
			{
				"question": "What decisions are supported?",
				"answer": "The supported decisions are proceed, pause, or adjust pacing."
			},
			{
				"question": "Can a screen remain incomplete?",
				"answer": "Yes. Incomplete information remains draft and should not appear as a completed decision."
			}
		]
	},
	{
		"toolType": "safeCalmPlace",
		"slug": "safe-calm-place",
		"title": "Safe / Calm Place Support for EMDR Sessions | Qwoach",
		"metaDescription": "Explore a live-session EMDR resource support tool for documenting calming resource access, observed effect, and dependability.",
		"h1": "Safe / Calm Place",
		"intro": "Safe / Calm Place is a live-session EMDR stabilization support tool for practitioners and clients in session. It helps the practitioner guide resource access and document whether the client can identify a calming or safe-feeling internal resource, show or report increased steadiness, and use it dependably during later trauma work.",
		"demoTitle": "Explore the resource card",
		"demoPrompt": "Interested in using Safe / Calm Place with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0228-f-007-emd-007-r001-safe-calm-place.md",
		"specId": "0228-f-007-emd-007-r001-safe-calm-place",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Live-Session Boundary",
				"body": "The tool is designed for practitioner-guided session use, not unsupervised client self-completion."
			},
			{
				"title": "Dependability Judgment",
				"body": "The practitioner documents whether the resource is accessible, not yet dependable, unresolved, or usable for later trauma work."
			},
			{
				"title": "No Script or Score",
				"body": "The tool does not provide exact prompts, ratings, arousal interpretation, or guarantees about safety or effectiveness."
			}
		],
		"faqItems": [
			{
				"question": "Is this a self-guided relaxation exercise?",
				"answer": "No. Safe / Calm Place is a practitioner-guided live-session support tool."
			},
			{
				"question": "Does the tool include exact prompts?",
				"answer": "No. Exact prompt content is not defined and should not be invented in the product."
			},
			{
				"question": "Does the client need to give a numeric rating?",
				"answer": "No. The tool does not require numeric ratings."
			},
			{
				"question": "What is saved after a session?",
				"answer": "When documented, a compact resource card can record the resource, observed or reported effect, and practitioner dependability judgment."
			}
		]
	},
	{
		"toolType": "resourceDevelopmentAndInstallationRdi",
		"slug": "resource-development-and-installation-rdi",
		"title": "Resource Development and Installation for EMDR Sessions | Qwoach",
		"metaDescription": "Explore a live-session EMDR RDI support tool for documenting adaptive resources, felt connection, usefulness, and readiness.",
		"h1": "Resource Development and Installation (RDI)",
		"intro": "Resource Development and Installation (RDI) is a live-session EMDR resource-building support tool for practitioners and clients in session. It helps identify adaptive resources, document emotional or somatic connection, and record the practitioner’s judgment about whether the resource base is sufficient for the next phase of treatment.",
		"demoTitle": "Explore the sample inventory",
		"demoPrompt": "Interested in using Resource Development and Installation (RDI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0229-f-007-emd-008-r001-resource-development-and-installation-rdi.md",
		"specId": "0229-f-007-emd-008-r001-resource-development-and-installation-rdi",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Resource Inventory",
				"body": "The tool tracks multiple resources without forcing unsupported categories."
			},
			{
				"title": "Practitioner Sufficiency Judgment",
				"body": "Overall readiness for the next phase is determined by the practitioner, not calculated by the system."
			},
			{
				"title": "Unresolved or Insufficient Resources",
				"body": "Resources can be marked emerging, insufficient, unresolved, or no longer useful as clinical understanding changes."
			}
		],
		"faqItems": [
			{
				"question": "Does RDI include exact installation steps in this product?",
				"answer": "No. Exact RDI prompts, installation procedures, and stimulation instructions are not defined in the supplied product behavior."
			},
			{
				"question": "Does the tool rate resource strength?",
				"answer": "No. It does not use numeric ratings or automated readiness scores."
			},
			{
				"question": "Can multiple resources be documented?",
				"answer": "Yes. The tool supports multiple resources without forcing categories."
			},
			{
				"question": "Is this a coping-skills library?",
				"answer": "No. It documents client-specific adaptive resources identified during practitioner-guided live-session work."
			}
		]
	},
	{
		"toolType": "containerExercise",
		"slug": "container-exercise",
		"title": "Container Exercise Support for EMDR Sessions | Qwoach",
		"metaDescription": "Explore a live-session EMDR containment support tool with optional minimal notes on stability, tolerability, and re-access understanding.",
		"h1": "Container Exercise",
		"intro": "Container Exercise is a live-session EMDR containment support tool for practitioners and clients in session. It helps the practitioner guide temporary mental containment of active or unresolved distressing material and, only if useful, document whether the client regained present orientation, tolerable distress, and understanding of how to re-access containment.",
		"demoTitle": "Explore the optional status note",
		"demoPrompt": "Interested in using Container Exercise with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0230-f-007-emd-009-r001-container-exercise.md",
		"specId": "0230-f-007-emd-009-r001-container-exercise",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Optional Documentation",
				"body": "The supplied product behavior allows no structured output unless the practitioner chooses to document what was discussed."
			},
			{
				"title": "Temporary Containment",
				"body": "The result is temporary containment and present-focused stability, not processing, interpretation, or exposure work."
			},
			{
				"title": "Unresolved States",
				"body": "If containment is interrupted or not sufficient, the note should remain unresolved or not sufficient rather than completed."
			}
		],
		"faqItems": [
			{
				"question": "Does the Container Exercise require a structured output?",
				"answer": "No. The tool can be used live without creating a structured artifact."
			},
			{
				"question": "Does it include a script?",
				"answer": "No. Exact prompts and imagery instructions are not defined in the product behavior."
			},
			{
				"question": "Does it ask for distress ratings?",
				"answer": "No. Numeric distress ratings are not part of this tool."
			},
			{
				"question": "Can a practitioner save the tool even if there are no settings?",
				"answer": "Yes. Saving adds the fixed Container Exercise tool itself to the practitioner’s account."
			}
		]
	},
	{
		"toolType": "targetAssessmentForm",
		"slug": "target-assessment-form",
		"title": "Target Assessment Form for EMDR | Qwoach",
		"metaDescription": "Capture one EMDR target baseline with image, NC, PC, VOC, emotions, SUD, and body location for later review and comparison.",
		"h1": "Target Assessment Form",
		"intro": "Target Assessment Form is a structured EMDR assessment-phase baseline tool for EMDR practitioners. It helps capture one target's image, negative cognition, positive cognition, validity of cognition, emotions, subjective disturbance, and body location so the target has a clear reference for later reprocessing and comparison.",
		"demoTitle": "Explore a sample target baseline",
		"demoPrompt": "Interested in using Target Assessment Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0231-f-007-emd-010-r001-target-assessment-form.md",
		"specId": "0231-f-007-emd-010-r001-target-assessment-form",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a target is specific enough to anchor assessment and the practitioner needs baseline cognitive, emotional, distress, and somatic markers before or during target work."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures target image, negative cognition, positive cognition, VOC, emotions, SUD, and body location or sensation. It does not collect diagnosis, causal explanation, treatment recommendations, or unsupported symptom severity."
			},
			{
				"title": "Partial Baselines",
				"body": "Partial entries remain visible as partial. Missing elements are shown as missing baseline components rather than clinical findings."
			}
		],
		"faqItems": [
			{
				"question": "Can the component set be changed?",
				"answer": "No. The component set is fixed for this tool: image, NC, PC, VOC, emotions, SUD, and body location or sensation."
			},
			{
				"question": "Does the tool interpret the target?",
				"answer": "No. It organizes reported baseline information and completeness status; clinical interpretation remains practitioner work."
			},
			{
				"question": "Can a practitioner save a partial baseline?",
				"answer": "Yes. Partial completion can be saved and returned to, with missing baseline elements still visible."
			},
			{
				"question": "Does demo content become client data?",
				"answer": "No. Fictional demo target content and sample ratings are not carried into the account as real owned client data."
			}
		]
	},
	{
		"toolType": "negativeCognitionNcIdentification",
		"slug": "negative-cognition-nc-identification",
		"title": "EMDR Negative Cognition Identification | Qwoach",
		"metaDescription": "Identify and record the negative self-referential belief linked to a specific EMDR target during assessment.",
		"h1": "Negative Cognition Identification",
		"intro": "Negative Cognition Identification is a bounded EMDR assessment component for EMDR practitioners. It helps record the maladaptive self-referential belief activated by a specific trauma target so the practitioner can keep target meaning clear during assessment and reprocessing.",
		"demoTitle": "Try a sample NC capture",
		"demoPrompt": "Interested in using Negative Cognition (NC) Identification with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0232-f-007-emd-011-r001-negative-cognition-nc-identification.md",
		"specId": "0232-f-007-emd-011-r001-negative-cognition-nc-identification",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Trauma",
				"Core beliefs"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Narrow Scope",
				"body": "This tool captures the negative cognition only. Positive cognition, VOC, scoring, diagnosis, and treatment interpretation belong outside this component unless handled by separate tools."
			},
			{
				"title": "Revision History",
				"body": "If the working NC changes later, prior wording should remain distinguishable when it affects comparison or documentation."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool suggest negative cognitions?",
				"answer": "No. The tool records practitioner- and client-supplied wording and does not supply substantive NC content."
			},
			{
				"question": "Can the NC be blank?",
				"answer": "A blank NC remains incomplete and cannot be marked as the working completed NC."
			},
			{
				"question": "Is this a full target assessment?",
				"answer": "No. It is a focused component for identifying the negative cognition linked to a target."
			}
		]
	},
	{
		"toolType": "positiveCognitionPcIdentification",
		"slug": "positive-cognition-pc-identification",
		"title": "EMDR Positive Cognition Identification | Qwoach",
		"metaDescription": "Record the desired positive self-referential belief linked to a specific EMDR target for later credibility evaluation.",
		"h1": "Positive Cognition Identification",
		"intro": "Positive Cognition Identification is a specific EMDR assessment component for EMDR practitioners. It helps record the desired adaptive self-referential belief associated with a trauma target so the belief can be used in later target work and credibility evaluation.",
		"demoTitle": "Try a sample PC capture",
		"demoPrompt": "Interested in using Positive Cognition (PC) Identification with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0233-f-007-emd-012-r001-positive-cognition-pc-identification.md",
		"specId": "0233-f-007-emd-012-r001-positive-cognition-pc-identification",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Trauma",
				"Core beliefs"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Relationship To VOC",
				"body": "This tool identifies the PC. Credibility measurement belongs to VOC when that separate measure is used."
			},
			{
				"title": "Working Wording",
				"body": "Multiple candidate PCs can remain candidates until the practitioner marks one as the working PC for the target."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score how true the PC feels?",
				"answer": "No. VOC scoring is separate unless another tool captures it."
			},
			{
				"question": "Can the PC be recorded before the NC?",
				"answer": "Yes. PC without NC is allowed, but the absence of NC should remain visible if contrast is expected in the workflow."
			},
			{
				"question": "Does the tool generate adaptive beliefs?",
				"answer": "No. It records wording supplied through practitioner and client collaboration."
			}
		]
	},
	{
		"toolType": "validityOfCognitionVocScale",
		"slug": "validity-of-cognition-voc-scale",
		"title": "EMDR VOC Scale Rating Tool | Qwoach",
		"metaDescription": "Record repeated VOC ratings tied to the same EMDR target and positive cognition, with history and descriptive change display.",
		"h1": "Validity of Cognition (VOC) Scale",
		"intro": "Validity of Cognition Scale is a repeatable EMDR treatment-process measure for EMDR practitioners. It helps record how true a desired adaptive belief feels to the client in relation to a specific target and positive cognition, so ratings can be compared over time.",
		"demoTitle": "Explore sample VOC ratings",
		"demoPrompt": "Interested in using Validity of Cognition (VOC) Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0234-f-007-emd-013-r001-validity-of-cognition-voc-scale.md",
		"specId": "0234-f-007-emd-013-r001-validity-of-cognition-voc-scale",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Comparability",
				"body": "VOC ratings are comparable only when they reference the same target and PC wording. If the PC changes, the history should be marked as distinct or annotated."
			},
			{
				"title": "Descriptive Output",
				"body": "The tool displays rating history and change. It does not declare resolution or provide automated treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can VOC be recorded without a positive cognition?",
				"answer": "A rating without a PC lacks its required belief anchor and should be incomplete or non-comparable."
			},
			{
				"question": "Does the tool decide whether the target is resolved?",
				"answer": "No. It shows reported ratings and descriptive changes; practitioner interpretation remains separate."
			},
			{
				"question": "Can the VOC scale be customized?",
				"answer": "No. The supported scale remains fixed because changing it would affect comparability."
			}
		]
	},
	{
		"toolType": "subjectiveUnitsOfDisturbanceSudScale",
		"slug": "subjective-units-of-disturbance-sud-scale",
		"title": "EMDR SUD Scale Tracking Tool | Qwoach",
		"metaDescription": "Record repeated SUD ratings anchored to a specific EMDR target and review the target's descriptive disturbance trajectory.",
		"h1": "Subjective Units of Disturbance (SUD) Scale",
		"intro": "Subjective Units of Disturbance Scale is a repeatable EMDR process measure for EMDR practitioners. It helps record the client's current subjective disturbance in relation to a specific trauma target so changes can be compared during reprocessing.",
		"demoTitle": "Explore sample SUD tracking",
		"demoPrompt": "Interested in using Subjective Units of Disturbance (SUD) Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0235-f-007-emd-014-r001-subjective-units-of-disturbance-sud-scale.md",
		"specId": "0235-f-007-emd-014-r001-subjective-units-of-disturbance-sud-scale",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Target Anchoring",
				"body": "Every comparable SUD rating belongs to a specific target. Ratings without a target anchor are non-comparable."
			},
			{
				"title": "Repeated Use",
				"body": "The tool is designed for repeated entries across sets or sessions while preserving a chronological disturbance history."
			}
		],
		"faqItems": [
			{
				"question": "Does the SUD tool make clinical recommendations?",
				"answer": "No. It records and compares reported ratings; decisions about pacing, continuation, or closure remain practitioner decisions."
			},
			{
				"question": "Can ratings from different targets be combined?",
				"answer": "No. Multiple targets require separate SUD histories."
			},
			{
				"question": "What happens with an out-of-range rating?",
				"answer": "Out-of-range ratings are invalid and should not be saved as valid SUD entries."
			}
		]
	},
	{
		"toolType": "bodySensationBodyLocationAssessment",
		"slug": "body-sensation-body-location-assessment",
		"title": "EMDR Body Location Assessment | Qwoach",
		"metaDescription": "Record the body location and somatic quality linked to one EMDR target for baseline reference and later checking.",
		"h1": "Body Sensation / Body Location Assessment",
		"intro": "Body Sensation / Body Location Assessment is a bounded EMDR target-assessment component for EMDR practitioners. It helps record where and how target-related activation is felt physically so the somatic component can be included in the target baseline and checked later.",
		"demoTitle": "Explore a sample somatic assessment",
		"demoPrompt": "Interested in using Body Sensation / Body Location Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0236-f-007-emd-015-r001-body-sensation-body-location-assessment.md",
		"specId": "0236-f-007-emd-015-r001-body-sensation-body-location-assessment",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures body location and sensation quality as reported in relation to one target. Multiple locations can be captured if reported."
			},
			{
				"title": "Limits",
				"body": "The tool does not infer medical meaning, categorize sensations beyond supplied content, or require a body map not supported by the product specification."
			}
		],
		"faqItems": [
			{
				"question": "Is this a medical symptom tracker?",
				"answer": "No. It records target-related body location and sensation for EMDR assessment, not general medical symptoms."
			},
			{
				"question": "Can a client report no sensation?",
				"answer": "Yes. No sensation, vague sensation, or general discomfort should be recordable without forcing interpretation."
			},
			{
				"question": "Is a body map required?",
				"answer": "No. A plain location field is sufficient; a body-location selector may exist only if it remains descriptive."
			}
		]
	},
	{
		"toolType": "desensitizationTracking",
		"slug": "desensitization-tracking",
		"title": "EMDR Desensitization Tracking Tool | Qwoach",
		"metaDescription": "Track EMDR reprocessing trajectory for one target with SUD changes, stuck points, feeder memories, and interventions in sequence.",
		"h1": "Desensitization Tracking",
		"intro": "Desensitization Tracking is a practitioner-only EMDR reprocessing trajectory tool for EMDR practitioners. It helps organize distress changes, stuck points, feeder memories, and interventions used across sets or sessions for one trauma target.",
		"demoTitle": "Explore a sample reprocessing timeline",
		"demoPrompt": "Interested in using Desensitization Tracking with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0237-f-007-emd-016-r001-desensitization-tracking.md",
		"specId": "0237-f-007-emd-016-r001-desensitization-tracking",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "This configuration has no direct client entry surface. The practitioner records session information and reviews the timeline."
			},
			{
				"title": "Feeder Memories",
				"body": "If a feeder memory becomes a separate target, it should be explicitly linked or transitioned rather than silently merged into the original target."
			},
			{
				"title": "Historical Sequence",
				"body": "Edits after later sessions should preserve chronology and avoid rewriting the historical sequence."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend interventions?",
				"answer": "No. It records interventions and trajectory events descriptively; practitioner judgment determines next steps."
			},
			{
				"question": "Is a missing SUD value invalid?",
				"answer": "No. Missing SUD reduces trajectory completeness but does not invalidate other notes."
			},
			{
				"question": "Can this be used across sessions?",
				"answer": "Yes. The trajectory can continue across sessions for the same target."
			}
		]
	},
	{
		"toolType": "cognitiveInterweave",
		"slug": "cognitive-interweave",
		"title": "EMDR Cognitive Interweave Record | Qwoach",
		"metaDescription": "Document EMDR processing blockages, cognitive interweaves used, observed shifts, and continuation status in live-session notes.",
		"h1": "Cognitive Interweave",
		"intro": "Cognitive Interweave is a live-session EMDR intervention support record for EMDR practitioners. It helps document the blockage or loop, the interweave used, the observed shift, and whether processing resumed, without producing a standardized worksheet or automated recommendation.",
		"demoTitle": "Explore a sample interweave entry",
		"demoPrompt": "Interested in using Cognitive Interweave with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0238-f-007-emd-017-r001-cognitive-interweave.md",
		"specId": "0238-f-007-emd-017-r001-cognitive-interweave",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Clinical documentation"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "No Standardized Output",
				"body": "The tool produces a descriptive note, not a score, worksheet, or standardized result."
			},
			{
				"title": "Live Use",
				"body": "The tool should not slow intervention. It can be used during the moment or retrospectively after the session with timing uncertainty noted."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool provide cognitive interweave scripts?",
				"answer": "No. It does not provide substantive prompts, scripts, or automated intervention suggestions."
			},
			{
				"question": "Is there a client-facing version?",
				"answer": "No. This configuration is practitioner-only and live-session based."
			},
			{
				"question": "Does no observed shift mean failure?",
				"answer": "No. If no shift is observed, the continuation status is recorded descriptively without failure scoring."
			}
		]
	},
	{
		"toolType": "bodyScan",
		"slug": "body-scan",
		"title": "EMDR Body Scan Tool | Qwoach",
		"metaDescription": "Record whether an EMDR target's body response is clear or still activated, with residual sensation details when present.",
		"h1": "Body Scan",
		"intro": "Body Scan is a live-session EMDR resolution-check tool for EMDR practitioners. It helps record whether residual somatic activation remains for a specific trauma target and captures any residual sensations clearly enough to guide further practitioner review.",
		"demoTitle": "Try a sample body scan check",
		"demoPrompt": "Interested in using Body Scan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0239-f-007-emd-018-r001-body-scan.md",
		"specId": "0239-f-007-emd-018-r001-body-scan",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Clear Or Still Activated",
				"body": "The result is a target-linked status with residual sensations when present. Ambiguous sensations should be recorded as unclear rather than forced into clear status."
			},
			{
				"title": "Relationship To Somatic Baseline",
				"body": "When prior body location or sensation exists, the review may show descriptive comparison, but no medical or clinical interpretation is generated."
			}
		],
		"faqItems": [
			{
				"question": "Does Body Scan decide that treatment is complete?",
				"answer": "No. It records clear or still-activated body response; the practitioner decides what the result means clinically."
			},
			{
				"question": "Can multiple residual sensations be recorded?",
				"answer": "Yes. Multiple residual sensations should be allowed when reported."
			},
			{
				"question": "Is a body map required?",
				"answer": "No. Exact body-map use is unresolved; status and residual sensation capture are the required mechanics."
			}
		]
	},
	{
		"toolType": "closureIncompleteTargetPlan",
		"slug": "closure-incomplete-target-plan",
		"title": "EMDR Closure and Incomplete Target Plan | Qwoach",
		"metaDescription": "Document EMDR end-of-session target status, stabilization direction, and continuation notes for incomplete target work.",
		"h1": "Closure / Incomplete Target Plan",
		"intro": "Closure / Incomplete Target Plan is a practitioner-only EMDR end-of-session tool for EMDR practitioners. It helps document whether the current target is complete or incomplete and records practitioner-provided stabilization and continuity direction between sessions.",
		"demoTitle": "Explore a sample closure plan",
		"demoPrompt": "Interested in using Closure / Incomplete Target Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0240-f-007-emd-019-r001-closure-incomplete-target-plan.md",
		"specId": "0240-f-007-emd-019-r001-closure-incomplete-target-plan",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Clinical documentation",
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Complete Versus Incomplete",
				"body": "Complete target status should not require unresolved-material fields. Incomplete status should keep stabilization direction and continuation notes easy to find."
			},
			{
				"title": "Continuity",
				"body": "Historical closure records should remain visible if status changes after later review, so the session-end sequence is preserved."
			},
			{
				"title": "Limits",
				"body": "The tool records practitioner-provided stabilization direction but does not generate safety steps, risk determinations, or treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create stabilization steps?",
				"answer": "No. Stabilization content is practitioner-provided and the tool does not generate clinical steps."
			},
			{
				"question": "Is this client-facing?",
				"answer": "No. This configuration is practitioner-only, although closure may be discussed with the client during session."
			},
			{
				"question": "What if the target is incomplete?",
				"answer": "Incomplete status should preserve stabilization direction and next-session or between-session direction for unresolved material."
			}
		]
	},
	{
		"toolType": "reevaluationForm",
		"slug": "reevaluation-form",
		"title": "Reevaluation Form for EMDR Target Review | Qwoach",
		"metaDescription": "Review a previously processed EMDR target, compare earlier and current status, and record residual material and next-step notes.",
		"h1": "Reevaluation Form for EMDR Target Review",
		"intro": "The Reevaluation Form is a practitioner-only EMDR tool for clinicians continuing work after prior target processing. It helps the practitioner compare earlier target status with current reported or observed status, note residual distress or unresolved material, and record next-step direction.",
		"demoTitle": "Open the sample target review",
		"demoPrompt": "Interested in using Reevaluation Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0241-f-007-emd-020-r001-reevaluation-form.md",
		"specId": "0241-f-007-emd-020-r001-reevaluation-form",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after prior EMDR target processing when the practitioner needs to check how the target is holding up before continuing, revisiting, adjusting focus, or moving to another target."
			},
			{
				"title": "History Matters",
				"body": "Reevaluation entries remain tied to the selected target in chronological order so later reviews can distinguish current status from earlier entries."
			},
			{
				"title": "Important Boundary",
				"body": "The tool organizes entered information. It does not infer clinical resolution, treatment success, readiness to proceed, or EMDR protocol content."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client assignment?",
				"answer": "No. The Reevaluation Form is practitioner-only. Client responses may be elicited in session and entered by the practitioner, but no standalone client completion flow is specified."
			},
			{
				"question": "Does the tool decide whether EMDR processing is complete?",
				"answer": "No. The tool shows earlier and current status and any recorded residual material; the practitioner makes clinical interpretation and next-step decisions."
			},
			{
				"question": "Can a partial reevaluation be saved?",
				"answer": "Yes. A partial reevaluation can be saved as incomplete so unfinished capture is not presented as a completed longitudinal outcome."
			},
			{
				"question": "Can multiple reevaluations be compared?",
				"answer": "Yes. Prior reevaluations for the same target remain visible in chronological order for comparison."
			}
		]
	},
	{
		"toolType": "presentTriggerWorksheet",
		"slug": "present-trigger-worksheet",
		"title": "Present Trigger Worksheet for EMDR | Qwoach",
		"metaDescription": "Capture one current triggering situation, associated cues, and client responses as present-trigger target data for EMDR preparation.",
		"h1": "Present Trigger Worksheet for Current EMDR Triggers",
		"intro": "The Present Trigger Worksheet is an EMDR worksheet for practitioners and clients to complete together. It helps define one current triggering situation, capture associated cues and responses, and prepare present-trigger target data for later EMDR work.",
		"demoTitle": "Try the sample trigger worksheet",
		"demoPrompt": "Interested in using Present Trigger Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0242-f-007-emd-021-r001-present-trigger-worksheet.md",
		"specId": "0242-f-007-emd-021-r001-present-trigger-worksheet",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One Trigger at a Time",
				"body": "If multiple triggers appear in one description, the worksheet should keep them separate rather than combining them into one ambiguous entry."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures a current triggering situation, associated cues or responses, and practitioner notes about whether the information is usable for EMDR targeting."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not infer earlier memories, generate target priority, or provide unsupported worksheet scripts."
			}
		],
		"faqItems": [
			{
				"question": "Can clients complete this alone?",
				"answer": "No standalone independent client job is specified. The supported experience is collaborative or practitioner-guided completion."
			},
			{
				"question": "Does the worksheet identify root memories?",
				"answer": "No. It captures present-trigger target data and does not infer earlier memories or clinical meaning."
			},
			{
				"question": "What happens if the trigger is too broad?",
				"answer": "The worksheet remains incomplete or marked as needing clarification instead of forcing a completed target record."
			},
			{
				"question": "Can one worksheet include several triggers?",
				"answer": "No. Separate triggering situations should be captured as separate worksheet instances."
			}
		]
	},
	{
		"toolType": "futureTemplate",
		"slug": "future-template",
		"title": "Future Template for EMDR Planning | Qwoach",
		"metaDescription": "Define one future situation, adaptive response, and barriers or supports to help connect EMDR treatment focus to future functioning.",
		"h1": "Future Template for EMDR Future Preparation",
		"intro": "Future Template is a collaborative EMDR tool for practitioners and clients. It helps define a future situation or goal, state the desired adaptive response, and record barriers or supports relevant to treatment planning.",
		"demoTitle": "Build a sample future template",
		"demoPrompt": "Interested in using Future Template with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0243-f-007-emd-022-r001-future-template.md",
		"specId": "0243-f-007-emd-022-r001-future-template",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One Future Situation",
				"body": "Each template focuses on one future situation or goal so the adaptive response and barriers remain interpretable."
			},
			{
				"title": "What It Produces",
				"body": "The result is a structured summary of the future situation, intended adaptive response, and barriers or supports relevant to treatment planning."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not invent scripts, score adaptive capacity, or predict whether the client will succeed in the future situation."
			}
		],
		"faqItems": [
			{
				"question": "Is Future Template a goal tracker?",
				"answer": "No. It is an EMDR future-preparation tool for mapping a future situation to an adaptive response, not a generic goal tracker."
			},
			{
				"question": "Can barriers be unknown?",
				"answer": "Yes. Barriers or supports can be marked not identified yet, while the template shows that planning detail is incomplete."
			},
			{
				"question": "Can one template include multiple future situations?",
				"answer": "No. Multiple future situations should be handled as separate templates."
			},
			{
				"question": "Does the tool tell the practitioner the client is ready?",
				"answer": "No. Practitioner review remains separate; the system does not infer readiness or future success."
			}
		]
	},
	{
		"toolType": "floatbackTechnique",
		"slug": "floatback-technique",
		"title": "Floatback Technique EMDR Record | Qwoach",
		"metaDescription": "Record present activation, a candidate earlier memory, and practitioner notes from a live EMDR Floatback Technique session.",
		"h1": "Floatback Technique Live-Session Record",
		"intro": "Floatback Technique is a live-session-only EMDR support tool for practitioners. It helps record the current symptom, belief, or emotional response, the candidate earlier memory that emerges, and practitioner notes about whether the link is clinically workable.",
		"demoTitle": "Open a sample live-session record",
		"demoPrompt": "Interested in using Floatback Technique with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0244-f-007-emd-023-r001-floatback-technique.md",
		"specId": "0244-f-007-emd-023-r001-floatback-technique",
		"tags": {
			"framework": [
				"EMDR"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Live-Session Only",
				"body": "The tool is for practitioner-led live use and should not be presented as an independent client self-administration flow."
			},
			{
				"title": "Inconclusive Is Supported",
				"body": "If no candidate memory emerges or the connection is unclear, the record can remain inconclusive rather than being forced into a target."
			},
			{
				"title": "Important Boundary",
				"body": "The tool records and organizes the link. It does not interpret memories, infer causality, or decide treatment targets."
			}
		],
		"faqItems": [
			{
				"question": "Can this be sent to a client to complete alone?",
				"answer": "No. The supported use is live-session-only and practitioner-led."
			},
			{
				"question": "Does the tool discover earlier memories automatically?",
				"answer": "No. It records a candidate memory if one emerges during live clinical work; it does not generate memories."
			},
			{
				"question": "What if no earlier memory emerges?",
				"answer": "The practitioner can save an inconclusive record or discard it, depending on clinical choice."
			},
			{
				"question": "Can multiple candidate memories be recorded?",
				"answer": "Yes, if multiple candidates emerge they must be clearly distinguished and not automatically prioritized."
			}
		]
	},
	{
		"toolType": "readinessRuler",
		"slug": "readiness-ruler",
		"title": "Readiness Ruler MI Worksheet | Qwoach",
		"metaDescription": "Send a short Readiness Ruler to capture a client’s readiness rating, reasons for the rating, and same-focus comparison over time.",
		"h1": "Readiness Ruler for Behavior Change Conversations",
		"intro": "Readiness Ruler is a ready-to-send Motivational Interviewing worksheet for practitioners. It helps capture a client’s current readiness rating for one possible behavior change and the client’s own reasons for that rating so the practitioner can tailor the next conversation.",
		"demoTitle": "Set a sample change focus",
		"demoPrompt": "Interested in using Readiness Ruler with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0245-f-008-mi-001-r001-readiness-ruler.md",
		"specId": "0245-f-008-mi-001-r001-readiness-ruler",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The ruler captures one readiness value and the client’s reasons for that value. A number without reasons is incomplete for the practitioner’s job."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated entries can be compared only when they use the same change focus. Different changes should use separate ruler instances."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not interpret the client as motivated or unmotivated and does not prescribe the next MI step."
			}
		],
		"faqItems": [
			{
				"question": "What is saved with the ruler?",
				"answer": "The tool itself is saved, and an intentionally configured change focus can be preserved. Sample responses are not saved as real client data."
			},
			{
				"question": "Can a client submit only a number?",
				"answer": "A rating alone is incomplete because the practitioner needs the client’s reasons for that rating."
			},
			{
				"question": "Can I compare readiness over time?",
				"answer": "Yes. Comparison is supported for repeated entries tied to the same change focus."
			},
			{
				"question": "Does the tool decide the MI strategy?",
				"answer": "No. The practitioner uses the rating and reasons to decide how to tailor the conversation."
			}
		]
	},
	{
		"toolType": "importanceRuler",
		"slug": "importance-ruler",
		"title": "Importance Ruler MI Worksheet | Qwoach",
		"metaDescription": "Capture how important one change is to a client, the personal reasons behind it, and same-focus importance changes over time.",
		"h1": "Importance Ruler for Client Change Talk",
		"intro": "Importance Ruler is a ready-to-send Motivational Interviewing worksheet for practitioners. It helps measure how personally important a possible change is to a client and captures the reasons, values, or change talk connected to that importance.",
		"demoTitle": "Configure a sample importance ruler",
		"demoPrompt": "Interested in using Importance Ruler with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0246-f-008-mi-002-r001-importance-ruler.md",
		"specId": "0246-f-008-mi-002-r001-importance-ruler",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Importance Only",
				"body": "This ruler stays focused on how much the change matters. Confidence and readiness should be captured with their separate tools."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures an importance rating and the client’s own change talk or personal reasons connected to that rating."
			},
			{
				"title": "Important Boundary",
				"body": "The system does not judge whether importance is enough, infer values beyond the client’s words, or recommend intervention steps."
			}
		],
		"faqItems": [
			{
				"question": "How is this different from the Readiness Ruler?",
				"answer": "The Importance Ruler measures how much the change matters; it does not measure readiness or confidence."
			},
			{
				"question": "Is change talk required?",
				"answer": "Yes. A rating without personal reasons, values, or change talk is incomplete for this tool’s purpose."
			},
			{
				"question": "Can importance be tracked over time?",
				"answer": "Yes. Repeated entries can be compared when they use the same ruler type and change focus."
			},
			{
				"question": "What if the client writes about confidence instead?",
				"answer": "The text is preserved for practitioner review; the system does not recode it automatically."
			}
		]
	},
	{
		"toolType": "confidenceRuler",
		"slug": "confidence-ruler",
		"title": "Confidence Ruler MI Worksheet | Qwoach",
		"metaDescription": "Capture a client’s confidence rating for one change, plus barriers and supports shaping that confidence, with same-focus comparison.",
		"h1": "Confidence Ruler for Barriers and Supports",
		"intro": "Confidence Ruler is a ready-to-send Motivational Interviewing worksheet for practitioners. It helps measure a client’s confidence for one identified change and captures barriers, strengths, supports, or conditions shaping that confidence.",
		"demoTitle": "Configure a sample confidence ruler",
		"demoPrompt": "Interested in using Confidence Ruler with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0247-f-008-mi-003-r001-confidence-ruler.md",
		"specId": "0247-f-008-mi-003-r001-confidence-ruler",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Confidence Only",
				"body": "This ruler stays focused on perceived ability to carry out a change. Importance and readiness belong in separate ruler tools."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures a confidence value, barriers reducing confidence, and supports or conditions that could increase confidence."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not create a change plan, generate advice, or choose an intervention."
			}
		],
		"faqItems": [
			{
				"question": "What makes a Confidence Ruler complete?",
				"answer": "A complete result includes a confidence rating and both barrier and resource/support areas acknowledged or filled."
			},
			{
				"question": "Can this replace a Change Plan Worksheet?",
				"answer": "No. It measures confidence and captures barriers/resources; it does not create action steps or a plan."
			},
			{
				"question": "Can confidence be compared over time?",
				"answer": "Yes. Entries can be compared when they use the same confidence ruler type and the same change focus."
			},
			{
				"question": "What if the client writes importance reasons in the barrier field?",
				"answer": "The response is preserved for practitioner review; the system does not automatically reinterpret it."
			}
		]
	},
	{
		"toolType": "decisionalBalanceWorksheet",
		"slug": "decisional-balance-worksheet",
		"title": "Decisional Balance Worksheet MI | Qwoach",
		"metaDescription": "Map client ambivalence in four areas: reasons for and against change, and reasons for and against staying the same.",
		"h1": "Decisional Balance Worksheet for Ambivalence",
		"intro": "Decisional Balance Worksheet is a collaborative Motivational Interviewing worksheet for practitioners and clients. It helps structure reasons for and against change and for and against staying the same, so the practitioner can guide the next conversation without deciding for the client.",
		"demoTitle": "Build a sample ambivalence map",
		"demoPrompt": "Interested in using Decisional Balance Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0248-f-008-mi-004-r001-decisional-balance-worksheet.md",
		"specId": "0248-f-008-mi-004-r001-decisional-balance-worksheet",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Skill practice"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Four-Area Map",
				"body": "The worksheet represents reasons for change, reasons against change, reasons for staying the same, and reasons against staying the same."
			},
			{
				"title": "Client Language",
				"body": "Client wording remains distinct from practitioner notes so the map reflects the client’s own priorities rather than practitioner assumptions."
			},
			{
				"title": "Important Boundary",
				"body": "The tool maps ambivalence. It does not choose a side, calculate a winner, or convert the map into an action plan."
			}
		],
		"faqItems": [
			{
				"question": "Does the worksheet decide what the client should do?",
				"answer": "No. It maps ambivalence and does not calculate or recommend a decision."
			},
			{
				"question": "Do all four areas need the same number of entries?",
				"answer": "No. Equal counts are not required, but missing perspectives should remain visible for practitioner judgment."
			},
			{
				"question": "Can salience be captured?",
				"answer": "Yes, only as neutral client-indicated weight or ordering when supported; the system does not infer salience from text alone."
			},
			{
				"question": "Can this be used for multiple behavior changes at once?",
				"answer": "No. Each behavior change focus should use a separate worksheet."
			}
		]
	},
	{
		"toolType": "changePlanWorksheet",
		"slug": "change-plan-worksheet",
		"title": "Change Plan Worksheet MI | Qwoach",
		"metaDescription": "Create a concrete behavior change plan with desired change, next steps, anticipated barriers, and client-owned reasons or commitment.",
		"h1": "Change Plan Worksheet for Concrete Next Steps",
		"intro": "Change Plan Worksheet is a collaborative Motivational Interviewing worksheet for practitioners and clients. It helps define a specific change, concrete next steps, likely barriers, and the client’s own reasons or commitment so the plan stays grounded in the client’s context.",
		"demoTitle": "Create a sample change plan",
		"demoPrompt": "Interested in using Change Plan Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0249-f-008-mi-005-r001-change-plan-worksheet.md",
		"specId": "0249-f-008-mi-005-r001-change-plan-worksheet",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Problem solving"
			],
			"topic": [
				"Behavior change",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The worksheet captures desired change, concrete next steps, anticipated barriers, and the client’s own reasons or commitment."
			},
			{
				"title": "Draft Versus Complete",
				"body": "A plan remains draft when the desired change is vague, steps are missing, or barriers have not been considered or explicitly marked not identified yet."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not create reminders, track task completion, score feasibility, or predict follow-through."
			}
		],
		"faqItems": [
			{
				"question": "Is this a task manager?",
				"answer": "No. The Change Plan Worksheet structures a client-owned plan; reminders, due dates, task tracking, and adherence scoring are not part of the tool."
			},
			{
				"question": "What makes the plan complete?",
				"answer": "A complete plan needs a specific desired change, at least one concrete next step, barrier consideration, and client-owned reasons or commitment."
			},
			{
				"question": "Can plans be revised later?",
				"answer": "Yes. Plans can be revisited with prior versions or history preserved so follow-up remains clear."
			},
			{
				"question": "What if the plan reflects external pressure?",
				"answer": "The practitioner can note the concern separately; the system does not judge authenticity automatically."
			}
		]
	},
	{
		"toolType": "personalValuesCardSort",
		"slug": "personal-values-card-sort",
		"title": "Personal Values Card Sort MI | Qwoach",
		"metaDescription": "Sort values cards by importance to create a client-prioritized values profile for MI change, decision, or treatment conversations.",
		"h1": "Personal Values Card Sort for Client Priorities",
		"intro": "Personal Values Card Sort is a collaborative Motivational Interviewing card-sorting tool for practitioners and clients. It helps identify and prioritize the client’s personal values so change conversations can connect to the client’s own meaning, choices, or treatment direction.",
		"demoTitle": "Review the card-sort setup",
		"demoPrompt": "Interested in using Personal Values Card Sort with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0250-f-008-mi-006-r001-personal-values-card-sort.md",
		"specId": "0250-f-008-mi-006-r001-personal-values-card-sort",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Skill practice"
			],
			"topic": [
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Card Sort, Not Questionnaire",
				"body": "The interaction should preserve sorting and prioritization of cards rather than becoming a linear form."
			},
			{
				"title": "Client Prioritization",
				"body": "The final profile reflects the client’s choices. Practitioner notes about treatment or change relevance are stored separately."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not invent values cards, generate personality conclusions, or prescribe what the client should choose."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo invent sample values cards?",
				"answer": "No. Specific card content is unresolved unless sourced, so the demo must not invent card labels or categories."
			},
			{
				"question": "What does the practitioner save?",
				"answer": "The practitioner saves the Personal Values Card Sort tool itself, plus supported setup such as selected sourced card set and optional current focus when available."
			},
			{
				"question": "Is this a personality assessment?",
				"answer": "No. It produces a client-prioritized values profile and does not interpret personality or moral meaning."
			},
			{
				"question": "Can values profiles be repeated over time?",
				"answer": "Yes. Completed profiles can persist for later reference, and repeated sorts are most comparable when the same card set is used."
			}
		]
	},
	{
		"toolType": "valuesSortSheets",
		"slug": "values-sort-sheets",
		"title": "Values Sort Sheets Demo for MI Practitioners | Qwoach",
		"metaDescription": "Explore Values Sort Sheets, an MI values-clarification tool that helps practitioners and clients create a usable values profile.",
		"h1": "Values Sort Sheets for Motivational Interviewing",
		"intro": "Values Sort Sheets are a motivational interviewing values-clarification tool for practitioners working with clients in change conversations or treatment planning. The tool helps the practitioner and client sort and prioritize values so the resulting profile can inform discussion of change options.",
		"demoTitle": "Try the sample values sort, then review the values profile.",
		"demoPrompt": "Interested in using Values Sort Sheets with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0251-f-008-mi-007-r001-values-sort-sheets.md",
		"specId": "0251-f-008-mi-007-r001-values-sort-sheets",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When to use it",
				"body": "Use it when values need to be clarified enough to inform a motivational interviewing conversation or treatment-planning decision."
			},
			{
				"title": "What it does not do",
				"body": "It does not assign value meanings, calculate scores, make diagnostic conclusions, or recommend treatment steps."
			},
			{
				"title": "Incomplete sorts",
				"body": "A partially completed sort can be reviewed as incomplete, but it should not be treated as a final values profile."
			}
		],
		"faqItems": [
			{
				"question": "Is this a values assessment?",
				"answer": "No. Values Sort Sheets create a descriptive values profile from the client's sorting choices; they do not score values or interpret personality."
			},
			{
				"question": "Can a client complete it during a session?",
				"answer": "Yes. The represented configuration is ready to complete together, with the practitioner and client using the sort collaboratively."
			},
			{
				"question": "What is saved if I add this to my account?",
				"answer": "The tool itself and any selected source-defined configuration are saved. Demo responses and fictional sample content are not saved as real client data."
			},
			{
				"question": "Can profiles from different sort formats be compared?",
				"answer": "Not necessarily. Profiles from different source-defined formats may use different items or structures and may not be directly comparable."
			}
		]
	},
	{
		"toolType": "whatIWantForTreatmentQuestionnaire",
		"slug": "what-i-want-for-treatment-questionnaire",
		"title": "What I Want for Treatment Questionnaire Demo | Qwoach",
		"metaDescription": "Explore an MI treatment-preference questionnaire that helps practitioners capture client goals, priorities, and preferred ways of working.",
		"h1": "What I Want for Treatment Questionnaire",
		"intro": "What I Want for Treatment Questionnaire is a motivational interviewing treatment-preference questionnaire for practitioners working with clients entering or shaping treatment. It helps capture explicit client preferences about treatment goals, priorities, and desired ways of working together.",
		"demoTitle": "Preview the send setup and sample preference summary.",
		"demoPrompt": "Interested in using What I Want for Treatment Questionnaire with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0252-f-008-mi-008-r001-what-i-want-for-treatment-questionnaire.md",
		"specId": "0252-f-008-mi-008-r001-what-i-want-for-treatment-questionnaire",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it at treatment entry or when treatment is being shaped and the practitioner needs client-stated preferences."
			},
			{
				"title": "What it captures",
				"body": "It captures explicit preferences about treatment goals, priorities, and desired ways of working together, according to the source-defined questionnaire."
			},
			{
				"title": "Relevant limits",
				"body": "It is not a general intake form, satisfaction survey, clinical assessment, or treatment recommendation engine."
			}
		],
		"faqItems": [
			{
				"question": "Does this questionnaire create a treatment plan?",
				"answer": "No. It captures client preference information that can inform a treatment-planning conversation; it does not generate a treatment plan."
			},
			{
				"question": "Can clients skip questions?",
				"answer": "Only where the source-defined questionnaire permits skipping. Skipped or unanswered areas are shown in the result rather than filled in."
			},
			{
				"question": "What happens to incomplete responses?",
				"answer": "Incomplete responses can be saved and reviewed as incomplete preference data, not as a final treatment-planning result."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The questionnaire tool and selected supported setup are saved. Demo responses and fictional case information do not become client records."
			}
		]
	},
	{
		"toolType": "readinessRuler2",
		"slug": "readiness-ruler-2",
		"title": "Readiness Ruler Demo for MI Sessions | Qwoach",
		"metaDescription": "Try a Readiness Ruler demo for MI: capture importance and confidence ratings with client change-talk statements linked to each ruler.",
		"h1": "Readiness Ruler for Motivational Interviewing",
		"intro": "Readiness Ruler is a motivational interviewing conversation aid for practitioners working with clients considering personal behavior change. It helps the practitioner record 0-to-10 importance and confidence ratings and capture the client-generated language that explains those ratings.",
		"demoTitle": "Try a sample ruler conversation and review the result.",
		"demoPrompt": "Interested in using Readiness Ruler with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0253-f-008-mi-009-r001-readiness-ruler.md",
		"specId": "0253-f-008-mi-009-r001-readiness-ruler",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What it captures",
				"body": "It captures the target behavior, 0-to-10 importance and confidence ratings, and client explanations linked to each rating."
			},
			{
				"title": "Repeated use",
				"body": "Prior ratings can be shown as historical context only when the same target behavior and ruler dimension are repeated."
			},
			{
				"title": "Important limitation",
				"body": "The tool does not calculate readiness categories, clinical conclusions, or prescribed next steps."
			}
		],
		"faqItems": [
			{
				"question": "Is the Readiness Ruler a score?",
				"answer": "No. It records importance and confidence ratings, but the MI-relevant result includes the client's own explanations for those ratings."
			},
			{
				"question": "What if the client does not choose a number?",
				"answer": "The tool can record no rating and capture the client's explanation without forcing a score."
			},
			{
				"question": "Can I compare ratings over time?",
				"answer": "Yes, when the same target behavior and same ruler dimension are repeated. Different change focuses should be kept separate."
			},
			{
				"question": "What happens if I enter a rating without follow-up language?",
				"answer": "The result is marked incomplete for MI use because the client explanation is part of the tool's core mechanic."
			}
		]
	},
	{
		"toolType": "darnCatChangeTalkQuestions",
		"slug": "darn-cat-change-talk-questions",
		"title": "DARN-CAT Change Talk Questions Demo | Qwoach",
		"metaDescription": "Explore a DARN-CAT prompt framework for MI practitioners to evoke and capture client change talk tied to a target behavior.",
		"h1": "DARN-CAT Change Talk Questions for MI",
		"intro": "DARN-CAT Change Talk Questions is a motivational interviewing practitioner prompt framework for clinicians and counselors in the evoking phase. It helps the practitioner choose category-targeted open questions and capture client statements about a specific target behavior.",
		"demoTitle": "Choose a category and capture a sample change-talk note.",
		"demoPrompt": "Interested in using DARN-CAT Change Talk Questions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0254-f-008-mi-009-r002-darn-cat-change-talk-questions.md",
		"specId": "0254-f-008-mi-009-r002-darn-cat-change-talk-questions",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner and client roles",
				"body": "The practitioner chooses the category and asks the open question. The client provides the response in their own words."
			},
			{
				"title": "What it captures",
				"body": "It captures target behavior, selected category, question used where captured, and client statement."
			},
			{
				"title": "Relevant limitation",
				"body": "It does not classify motivation strength, calculate readiness, or turn client responses into scores."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client worksheet?",
				"answer": "No. It is a practitioner prompt framework for live MI conversation, not a self-guided client worksheet."
			},
			{
				"question": "Does the tool automatically identify DARN-CAT language?",
				"answer": "No. The practitioner selects the category being used; the tool organizes captured statements descriptively."
			},
			{
				"question": "Can I capture sustain talk or ambivalence?",
				"answer": "Yes. Capture it as conversation content without forcing it into a DARN-CAT category."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The prompt framework and reusable source-supported setup are saved. Fictional demo notes and sample client statements are not saved as real client data."
			}
		]
	},
	{
		"toolType": "oarsConversationGuide",
		"slug": "oars-conversation-guide",
		"title": "OARS Conversation Guide Demo | Qwoach",
		"metaDescription": "Preview a practitioner-only OARS reference for MI conversations: open questions, affirmations, reflections, and summaries.",
		"h1": "OARS Conversation Guide for Motivational Interviewing",
		"intro": "OARS Conversation Guide is a practitioner-only motivational interviewing reference for clinicians and counselors using open questions, affirmations, reflections, and summaries. It helps the practitioner orient the next conversational move without collecting client data or producing a structured result.",
		"demoTitle": "Preview the fixed OARS reference.",
		"demoPrompt": "Interested in using OARS Conversation Guide with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0255-f-008-mi-010-r001-oars-conversation-guide.md",
		"specId": "0255-f-008-mi-010-r001-oars-conversation-guide",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it before or during an MI conversation when the practitioner wants a quick reminder of OARS interaction options."
			},
			{
				"title": "What it does not create",
				"body": "It does not create a worksheet, assessment, score, transcript code, session note, or client-facing task."
			},
			{
				"title": "Fixed tool behavior",
				"body": "Because there are no configurable settings, saving adds the fixed guide itself to the practitioner's account."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool produce a client result?",
				"answer": "No. OARS Conversation Guide has no intrinsic structured output or client submission."
			},
			{
				"question": "Is there a client view?",
				"answer": "No. This configuration is practitioner-only."
			},
			{
				"question": "Can it score MI skill?",
				"answer": "No. Scoring or coding practitioner behavior would require a distinct fidelity or coding tool."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The fixed OARS Conversation Guide itself is saved as-is to the practitioner's account."
			}
		]
	},
	{
		"toolType": "fourProcessesMap",
		"slug": "four-processes-map",
		"title": "Four Processes Map Demo for MI Practitioners | Qwoach",
		"metaDescription": "Explore a Four Processes Map for MI that helps practitioners orient conversations around engagement, focus, evocation, or planning.",
		"h1": "Four Processes Map for Motivational Interviewing",
		"intro": "Four Processes Map is a motivational interviewing process-orientation aid for practitioners working in MI conversations. It helps locate the current conversation within engagement, focus, evocation, or planning so the practitioner can choose a fitting next move.",
		"demoTitle": "Mark a sample process and review the map state.",
		"demoPrompt": "Interested in using Four Processes Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0256-f-008-mi-011-r001-four-processes-map.md",
		"specId": "0256-f-008-mi-011-r001-four-processes-map",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning",
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it before, during, or after a session to orient the conversation around engagement, focus, evocation, or planning."
			},
			{
				"title": "Shared or private use",
				"body": "The map can be practitioner-only or shared live with a client as an orientation aid when appropriate."
			},
			{
				"title": "Relevant limitation",
				"body": "Movement across the map should not be treated as outcome improvement or a required linear path."
			}
		],
		"faqItems": [
			{
				"question": "Does the Four Processes Map decide the stage automatically?",
				"answer": "No. The practitioner selects or leaves unmarked the current process; the tool does not classify sessions automatically."
			},
			{
				"question": "Can more than one process be active?",
				"answer": "Yes. The demo should allow a primary marker plus a note instead of forcing false certainty."
			},
			{
				"question": "Is this a treatment plan?",
				"answer": "No. It is a process-orientation aid, not a session planner or intervention algorithm."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The map tool itself and any selected supported display variant are saved. Demo markers and notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "miti421",
		"slug": "miti-4-2-1",
		"title": "MITI 4.2.1 Demo for MI Fidelity Review | Qwoach",
		"metaDescription": "Explore MITI 4.2.1 as a practitioner-only MI fidelity coding tool for structured clinician-performance data and review.",
		"h1": "MITI 4.2.1 Fidelity Coding Tool",
		"intro": "MITI 4.2.1 is a practitioner-only Motivational Interviewing Treatment Integrity coding tool for supervisors, trainers, fidelity reviewers, and practitioners. It helps produce structured clinician-performance data about MI competence and adherence for review and improvement work.",
		"demoTitle": "Preview a sample coding record and performance summary.",
		"demoPrompt": "Interested in using MITI 4.2.1 with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0257-f-008-mi-012-r001-miti-4-2-1.md",
		"specId": "0257-f-008-mi-012-r001-miti-4-2-1",
		"tags": {
			"framework": [
				"Motivational interviewing"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-only use",
				"body": "MITI 4.2.1 is for clinician-performance coding and fidelity review. It is not a client-facing assessment."
			},
			{
				"title": "Draft and finalized states",
				"body": "Incomplete coding should remain clearly marked as draft and should not be included in finalized comparisons unless explicitly reviewed as draft."
			},
			{
				"title": "Comparison behavior",
				"body": "Historical comparison is supported only when source-defined coding rules and version behavior allow meaningful comparison."
			}
		],
		"faqItems": [
			{
				"question": "Is MITI 4.2.1 a client assessment?",
				"answer": "No. MITI 4.2.1 produces structured clinician-performance data, not client assessment data."
			},
			{
				"question": "Can the demo calculate final scores without all required fields?",
				"answer": "No. Final derived scores should not be calculated when required source-defined coding fields are missing."
			},
			{
				"question": "Can multiple coders code the same session?",
				"answer": "Yes, coder-specific records should remain distinct unless a source-defined reconciliation process is supplied."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The MITI 4.2.1 tool itself and selected supported setup are saved. Demo coding records and fictional session data are not saved as real records."
			}
		]
	},
	{
		"toolType": "miracleQuestion",
		"slug": "miracle-question",
		"title": "Miracle Question Demo for SFBT Practitioners | Qwoach",
		"metaDescription": "Explore a Miracle Question session aid that helps SFBT practitioners capture a client's concrete preferred-future description.",
		"h1": "Miracle Question for Solution-Focused Brief Therapy",
		"intro": "Miracle Question is a Solution-Focused Brief Therapy live-session intervention for practitioners working with clients who are focused on a problem. It helps elicit and preserve a detailed client-generated description of what life would look like if the problem were sufficiently resolved.",
		"demoTitle": "Try a sample live-session note and review the preferred-future description.",
		"demoPrompt": "Interested in using Miracle Question with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0258-f-009-sfbt-001-r001-miracle-question.md",
		"specId": "0258-f-009-sfbt-001-r001-miracle-question",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it when a client is focused on a problem and the practitioner wants to elicit a concrete preferred future."
			},
			{
				"title": "What it captures",
				"body": "It captures client language, observable signs of change, experience-near details, and signs others might notice."
			},
			{
				"title": "Relevant limitation",
				"body": "It is a live-session intervention aid and does not require assignment, scoring, or standardized goal fields."
			}
		],
		"faqItems": [
			{
				"question": "Is the Miracle Question a worksheet?",
				"answer": "No. In this configuration it is a live-session intervention aid with lightweight note capture."
			},
			{
				"question": "Does it produce a score?",
				"answer": "No. The result is a narrative preferred-future description, not a numeric score."
			},
			{
				"question": "What if the client's answer is abstract?",
				"answer": "Capture what was said and, where source-supported, prompt for more concrete details without forcing completion."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The Miracle Question tool itself is saved. Demo notes and fictional sample content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "miracleQuestionScale",
		"slug": "miracle-question-scale",
		"title": "Miracle Question Scale Demo | Qwoach",
		"metaDescription": "Explore an SFBT Miracle Question Scale that tracks a client's current rating toward their own preferred future over time.",
		"h1": "Miracle Question Scale for SFBT",
		"intro": "Miracle Question Scale is a Solution-Focused Brief Therapy scaling tool for practitioners working with clients who have described a preferred future. It helps capture a client-rated measure of current progress toward that preferred future, with explanation that can be revisited over time.",
		"demoTitle": "Try a sample anchored rating and review the trend.",
		"demoPrompt": "Interested in using Miracle Question Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0259-f-009-sfbt-002-r001-miracle-question-scale.md",
		"specId": "0259-f-009-sfbt-002-r001-miracle-question-scale",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Anchor requirement",
				"body": "The scale must be tied to a preferred-future description; unanchored ratings should not be treated as Miracle Question Scale results."
			},
			{
				"title": "Repeat use",
				"body": "Only ratings using the same preferred-future anchor should be trended together."
			},
			{
				"title": "What it captures",
				"body": "It captures the rating, the client's explanation, and what would mark a small upward movement when discussed."
			}
		],
		"faqItems": [
			{
				"question": "Can I use this scale without a Miracle Question preferred future?",
				"answer": "No. The scale must be anchored to a preferred-future description to have shared meaning."
			},
			{
				"question": "Are ratings comparable over time?",
				"answer": "Yes, when they use the same preferred-future anchor. A materially changed anchor should start a new series."
			},
			{
				"question": "Does the scale prove clinical progress?",
				"answer": "No. It shows the client's reported rating and explanation over time, not an unsupported clinical outcome conclusion."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The tool and selected reusable setup are saved. Demo ratings, fictional anchors, and sample explanations are not saved as real client data."
			}
		]
	},
	{
		"toolType": "generalScalingQuestion",
		"slug": "general-scaling-question",
		"title": "General Scaling Question Demo for SFBT | Qwoach",
		"metaDescription": "Explore an SFBT scaling question tool that captures repeatable client ratings and explanations for a defined dimension.",
		"h1": "General Scaling Question for SFBT",
		"intro": "General Scaling Question is a Solution-Focused Brief Therapy assessment device for practitioners working across sessions. It helps capture a client's current numeric rating and qualitative explanation for a clearly defined concern, goal, confidence, or progress dimension.",
		"demoTitle": "Define a sample dimension and try a rating.",
		"demoPrompt": "Interested in using General Scaling Question with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0260-f-009-sfbt-003-r001-general-scaling-question.md",
		"specId": "0260-f-009-sfbt-003-r001-general-scaling-question",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it when a concern, goal, confidence area, or progress area needs a repeatable rating across sessions."
			},
			{
				"title": "Why dimension wording matters",
				"body": "The dimension defines the meaning of the number. Materially different wording should start a separate series."
			},
			{
				"title": "Incomplete entries",
				"body": "A rating without explanation can be stored, but it should be marked incomplete for qualitative review."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic survey builder?",
				"answer": "No. Configurability is limited to defining the dimension being scaled while preserving the SFBT scaling mechanic."
			},
			{
				"question": "Can I compare ratings across different dimensions?",
				"answer": "No. Entries should be compared only when they use the same stable dimension and anchor meaning."
			},
			{
				"question": "What if the client cannot choose a number?",
				"answer": "Capture the discussion without forcing a rating."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The tool itself and intentionally configured dimension/anchor wording are saved. Demo ratings and sample explanations are not saved as real client data."
			}
		]
	},
	{
		"toolType": "confidenceScale",
		"slug": "confidence-scale",
		"title": "Confidence Scale Demo for SFBT Practitioners | Qwoach",
		"metaDescription": "Try a Confidence Scale demo for SFBT practice: capture a client confidence score, related supports, and dated comparison over time.",
		"h1": "Confidence Scale for solution-focused work",
		"intro": "Confidence Scale is a solution-focused scaling tool for practitioners. It helps a practitioner and client capture the client's current confidence about a next step and identify the resources, supports, conditions, or prior successes that could make that step feel achievable.",
		"demoTitle": "Try the demo with sample next-step context",
		"demoPrompt": "Interested in using Confidence Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0261-f-009-sfbt-004-r001-confidence-scale.md",
		"specId": "0261-f-009-sfbt-004-r001-confidence-scale",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the conversation turns to a next step and the practitioner needs to understand how able the client feels to attempt it."
			},
			{
				"title": "What It Captures",
				"body": "It captures a scale value plus client-reported supports, resources, conditions, or prior successes related to confidence."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not diagnose confidence, create readiness categories, prescribe action thresholds, or predict follow-through."
			}
		],
		"faqItems": [
			{
				"question": "Does the Confidence Scale recommend the next step?",
				"answer": "No. It organizes the client's confidence score and reported supports so the practitioner can align discussion with the client's perceived ability."
			},
			{
				"question": "Is supporting text required?",
				"answer": "A scale value is required for completion. Supporting detail may be prompted and can be flagged as missing, but the exact requirement needs validation."
			},
			{
				"question": "Can the tool compare entries over time?",
				"answer": "Yes. Completed dated entries can be shown with prior confidence entries when available, with context labels to avoid false comparison."
			}
		]
	},
	{
		"toolType": "willingnessMotivationScale",
		"slug": "willingness-motivation-scale",
		"title": "Willingness / Motivation Scale Demo | Qwoach",
		"metaDescription": "Try an SFBT motivation scale demo that captures current willingness, supporting factors, limiting factors, and dated review history.",
		"h1": "Willingness / Motivation Scale for SFBT practice",
		"intro": "Willingness / Motivation Scale is a solution-focused scaling tool for practitioners. It helps a practitioner and client express the client's current motivation for a desired change and identify factors that support or limit willingness.",
		"demoTitle": "Try the sample motivation scale",
		"demoPrompt": "Interested in using Willingness / Motivation Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0262-f-009-sfbt-005-r001-willingness-motivation-scale.md",
		"specId": "0262-f-009-sfbt-005-r001-willingness-motivation-scale",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures one motivation score plus client-reported factors that support or limit willingness."
			},
			{
				"title": "How Review Works",
				"body": "Review keeps reported factors separate from descriptive score movement and practitioner interpretation."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not assign readiness stages, predict adherence, or infer factors the client did not report."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool diagnose readiness for change?",
				"answer": "No. It captures motivation as a client-reported scale value and lists reported factors without assigning a readiness stage."
			},
			{
				"question": "Can a score be submitted without factor detail?",
				"answer": "Yes. A score is valid for completion, while missing factor detail can be shown as missing context in review."
			},
			{
				"question": "Can the practitioner compare motivation over time?",
				"answer": "Yes. Dated motivation entries can be compared descriptively when they relate to the appropriate desired-change context."
			}
		]
	},
	{
		"toolType": "exceptionFindingQuestions",
		"slug": "exception-finding-questions",
		"title": "Exception-Finding Questions Demo | Qwoach",
		"metaDescription": "Try a live-session SFBT exception-finding demo that captures exceptions, conditions, actions, interactions, and future relevance.",
		"h1": "Exception-Finding Questions for live SFBT sessions",
		"intro": "Exception-Finding Questions is a live-session-only SFBT tool for practitioners. It helps a practitioner and client identify times when a dominant problem was absent, less intense, or handled better, and capture the conditions, actions, or interactions connected to those moments.",
		"demoTitle": "Map a sample exception",
		"demoPrompt": "Interested in using Exception-Finding Questions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0263-f-009-sfbt-006-r001-exception-finding-questions.md",
		"specId": "0263-f-009-sfbt-006-r001-exception-finding-questions",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Live Session Role",
				"body": "This tool is designed for practitioner-led conversation. It should not be assigned as an independent client form."
			},
			{
				"title": "What It Captures",
				"body": "It captures exception moments and the conditions, actions, or interactions associated with them."
			},
			{
				"title": "Important Limits",
				"body": "It does not score symptoms, explain causes, or prescribe future steps."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client questionnaire?",
				"answer": "No. It is a live conversational scaffold with structured practitioner note capture."
			},
			{
				"question": "Can more than one exception be captured?",
				"answer": "Yes. Multiple exceptions should be captured separately so their conditions and actions remain clear."
			},
			{
				"question": "What happens if no exception is identified?",
				"answer": "The result remains incomplete and should show unresolved exception identification rather than inventing one."
			}
		]
	},
	{
		"toolType": "pastSuccessSolutionBehaviorInventory",
		"slug": "past-success-solution-behavior-inventory",
		"title": "Past Success Inventory Demo for SFBT | Qwoach",
		"metaDescription": "Try an SFBT inventory demo for collecting past successes, solution behaviors, resources, conditions, and relevance to current work.",
		"h1": "Past Success / Solution Behavior Inventory",
		"intro": "Past Success / Solution Behavior Inventory is an SFBT tool for practitioners. It helps a practitioner collect reusable examples of a client's past successful behaviors, resources, and conditions connected to the current concern or preferred future.",
		"demoTitle": "Create a sample solution inventory",
		"demoPrompt": "Interested in using Past Success / Solution Behavior Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0264-f-009-sfbt-007-r001-past-success-solution-behavior-inventory.md",
		"specId": "0264-f-009-sfbt-007-r001-past-success-solution-behavior-inventory",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the practitioner wants to identify past successful behaviors and resources relevant to the current preferred future."
			},
			{
				"title": "Repeat Use",
				"body": "The inventory can persist as a reference and can be added to later without overwriting prior entries."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not rank successes, infer traits, score strengths, or prescribe practice steps."
			}
		],
		"faqItems": [
			{
				"question": "Does the inventory score a client's strengths?",
				"answer": "No. It captures client-reported examples and organizes them descriptively without scores or trait labels."
			},
			{
				"question": "Can the client complete this between sessions?",
				"answer": "Yes. The supported configuration is ready to send, and live completion can be used when the platform workflow supports it."
			},
			{
				"question": "What counts as a complete inventory?",
				"answer": "At least one usable past success connected to the current concern or preferred future is needed; exact minimum entry requirements require validation."
			}
		]
	},
	{
		"toolType": "copingQuestion",
		"slug": "coping-question",
		"title": "Coping Question Demo for SFBT Practitioners | Qwoach",
		"metaDescription": "Try a live SFBT Coping Question demo that captures client actions, supports, and resources separately from difficulty context.",
		"h1": "Coping Question for live SFBT sessions",
		"intro": "Coping Question is a live-session-only SFBT intervention for practitioners. It helps a practitioner identify how a client has been managing, persisting, or drawing on actions, supports, and resources during difficulty.",
		"demoTitle": "Try the live capture demo",
		"demoPrompt": "Interested in using Coping Question with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0265-f-009-sfbt-008-r001-coping-question.md",
		"specId": "0265-f-009-sfbt-008-r001-coping-question",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Live Session Role",
				"body": "The tool supports practitioner-led conversation and note capture; it should not be turned into an asynchronous client form."
			},
			{
				"title": "What It Captures",
				"body": "It captures client-reported coping actions, supports, resources, persistence strategies, and relevant strengths when discussed."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not assess severity, make risk conclusions, score coping, or generate advice."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client form for Coping Question?",
				"answer": "No. The client participates verbally in a live session; the practitioner controls any capture surface."
			},
			{
				"question": "What happens if no coping resource is identified?",
				"answer": "The result remains incomplete because problem description alone does not satisfy the tool."
			},
			{
				"question": "Does the tool create survivable next steps?",
				"answer": "No. It can record survivable next steps or strengths if discussed, but it does not generate steps."
			}
		]
	},
	{
		"toolType": "bestHopesQuestion",
		"slug": "best-hopes-question",
		"title": "Best Hopes Question Demo | Qwoach",
		"metaDescription": "Try a live SFBT Best Hopes Question demo for capturing a client-defined desired outcome in the client's own words.",
		"h1": "Best Hopes Question for SFBT session orientation",
		"intro": "Best Hopes Question is a live-session-only SFBT opening intervention for practitioners. It helps the practitioner capture the client's desired outcome in the client's own terms so the session and later solution-building stay oriented around the client's preferred direction.",
		"demoTitle": "Capture a sample desired outcome",
		"demoPrompt": "Interested in using Best Hopes Question with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0266-f-009-sfbt-009-r001-best-hopes-question.md",
		"specId": "0266-f-009-sfbt-009-r001-best-hopes-question",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support",
				"Session preparation"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at the opening of work or when therapy needs a refreshed client-defined direction."
			},
			{
				"title": "What It Captures",
				"body": "It captures the client's desired outcome and optional clarifying notes needed to orient the conversation."
			},
			{
				"title": "Important Limits",
				"body": "It does not create treatment objectives, score goals, or replace client language with practitioner-authored goals."
			}
		],
		"faqItems": [
			{
				"question": "Is this a goal-setting worksheet?",
				"answer": "No. It is a live opening intervention for capturing the client's desired outcome, not a generic goal-setting module."
			},
			{
				"question": "What if the client only says what they want to avoid?",
				"answer": "The entry can be marked as needing clarification; the product should not automatically rewrite it."
			},
			{
				"question": "Can multiple desired outcomes be captured?",
				"answer": "Yes. Multiple desired outcomes can be captured separately if they emerge."
			}
		]
	},
	{
		"toolType": "preferredFutureDescription",
		"slug": "preferred-future-description",
		"title": "Preferred Future Description Demo | Qwoach",
		"metaDescription": "Try an SFBT preferred-future demo that captures observable behaviors, interactions, and daily-life signs of hoped-for change.",
		"h1": "Preferred Future Description for solution-focused practice",
		"intro": "Preferred Future Description is an SFBT tool for practitioners and clients. It helps them translate a hoped-for change into concrete behaviors, interactions, and signs the client or others could notice in everyday life.",
		"demoTitle": "Describe a sample preferred future",
		"demoPrompt": "Interested in using Preferred Future Description with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0267-f-009-sfbt-010-r001-preferred-future-description.md",
		"specId": "0267-f-009-sfbt-010-r001-preferred-future-description",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures observable behaviors, interactions, and signs in daily life that describe the client's preferred future."
			},
			{
				"title": "How It Supports Review",
				"body": "Completed descriptions persist as references for later progress review and can be refined over time while preserving history."
			},
			{
				"title": "Important Limits",
				"body": "It does not prescribe next steps, score goals, create treatment plans, or add unsupported dimensions."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create a treatment plan?",
				"answer": "No. It creates a client-described preferred-future picture, not treatment objectives or action steps."
			},
			{
				"question": "What is required for completion?",
				"answer": "At least one concrete observable sign is required; abstract hopes can be saved as partial and refined."
			},
			{
				"question": "Can signs others might notice be included?",
				"answer": "Yes. Signs others could notice can be captured when discussed, but they should not be invented or required without validation."
			}
		]
	},
	{
		"toolType": "betweenSessionObservationTask",
		"slug": "between-session-observation-task",
		"title": "Between-Session Observation Task Demo | Qwoach",
		"metaDescription": "Try a sendable SFBT observation task that captures useful real-world moments, context, conditions, and what works between sessions.",
		"h1": "Between-Session Observation Task for SFBT",
		"intro": "Between-Session Observation Task is a sendable SFBT tool for practitioners and clients. It helps the client record useful real-world moments, contexts, and conditions between sessions so the practitioner can review live evidence of emerging solutions.",
		"demoTitle": "Send a sample observation task",
		"demoPrompt": "Interested in using Between-Session Observation Task with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0268-f-009-sfbt-011-r001-between-session-observation-task.md",
		"specId": "0268-f-009-sfbt-011-r001-between-session-observation-task",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures noticed moments, context, conditions, and the connection to preferred future, exceptions, useful differences, or what works."
			},
			{
				"title": "Repeat Use",
				"body": "The task can be repeated between sessions with the same or a refined observation focus."
			},
			{
				"title": "Important Limits",
				"body": "It is not a diary, habit tracker, reminder system, score, or prescriptive homework planner."
			}
		],
		"faqItems": [
			{
				"question": "What setting can the practitioner change?",
				"answer": "The practitioner can change the observation focus, such as noticing preferred-future signs, exceptions, useful differences, or what works."
			},
			{
				"question": "Can the client submit an empty task?",
				"answer": "No. Submission requires at least one observation; empty tasks can remain open."
			},
			{
				"question": "Does the tool decide what strategy works?",
				"answer": "No. It organizes reported observations and conditions without concluding that a strategy works."
			}
		]
	},
	{
		"toolType": "progressFromLastSessionReview",
		"slug": "progress-from-last-session-review",
		"title": "Progress-from-Last-Session Review Demo | Qwoach",
		"metaDescription": "Try an SFBT follow-up review demo that captures concrete positive change, contributors, prevented worsening, and prior-session comparison.",
		"h1": "Progress-from-Last-Session Review for SFBT follow-up",
		"intro": "Progress-from-Last-Session Review is a solution-focused follow-up tool for practitioners. It helps a practitioner and client capture concrete positive change, useful differences, and what contributed since the last contact.",
		"demoTitle": "Review a sample follow-up session",
		"demoPrompt": "Interested in using Progress-from-Last-Session Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0269-f-009-sfbt-012-r001-progress-from-last-session-review.md",
		"specId": "0269-f-009-sfbt-012-r001-progress-from-last-session-review",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Progress review",
				"In-session support"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at the beginning of a follow-up session to capture what has changed since the last contact."
			},
			{
				"title": "What It Compares",
				"body": "It can compare the current review against the last session, a prior goal, or a preferred-future description when available."
			},
			{
				"title": "Important Limits",
				"body": "It is not a general outcome measure, symptom tracker, score, or automated treatment adjustment."
			}
		],
		"faqItems": [
			{
				"question": "What is the configurable setting?",
				"answer": "The configurable setting is the comparison reference: last session, selected prior goal, or preferred-future description when available."
			},
			{
				"question": "What if no improvement is identified?",
				"answer": "No improvement can be captured explicitly rather than forced into a positive-change entry."
			},
			{
				"question": "Does the tool include a scale?",
				"answer": "Not by default. Whether a scale belongs in this configuration is unresolved and should not be assumed."
			}
		]
	},
	{
		"toolType": "complimentResourceFeedback",
		"slug": "compliment-resource-feedback",
		"title": "Compliment / Resource Feedback Demo | Qwoach",
		"metaDescription": "Try a live SFBT resource feedback demo for noting specific client behavior, effort, resource, and connection to change.",
		"h1": "Compliment / Resource Feedback for live SFBT sessions",
		"intro": "Compliment / Resource Feedback is a live-session-only SFBT intervention for practitioners. It helps a practitioner prepare or record feedback that reflects a specific client behavior, effort, quality, or resource connected to the client's current change effort.",
		"demoTitle": "Draft a sample resource feedback note",
		"demoPrompt": "Interested in using Compliment / Resource Feedback with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0270-f-009-sfbt-013-r001-compliment-resource-feedback.md",
		"specId": "0270-f-009-sfbt-013-r001-compliment-resource-feedback",
		"tags": {
			"framework": [
				"Solution-Focused Brief Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "No Client Assignment",
				"body": "The tool does not create a form, submission, worksheet, or structured client output."
			},
			{
				"title": "What It Captures",
				"body": "It may capture practitioner-authored feedback anchored in a specific behavior, effort, resource, and change-effort connection."
			},
			{
				"title": "Important Limits",
				"body": "The product must not fabricate compliments, score strengths, assess traits, or treat repeated notes as a longitudinal measure."
			}
		],
		"faqItems": [
			{
				"question": "Does the client complete anything?",
				"answer": "No. There is no structured client output or client assignment for this tool."
			},
			{
				"question": "Does the product generate compliments?",
				"answer": "No. The practitioner authors the feedback in session; the product should not generate substantive praise content."
			},
			{
				"question": "Can client disagreement be recorded?",
				"answer": "Yes. If the client corrects or disagrees with the feedback, the practitioner may record that clarification separately."
			}
		]
	},
	{
		"toolType": "uclaChildAdolescentPtsdReactionIndexForDsm5",
		"slug": "ucla-child-adolescent-ptsd-reaction-index-for-dsm-5",
		"title": "UCLA PTSD Reaction Index DSM-5 Demo | Qwoach",
		"metaDescription": "Explore a practitioner demo of the UCLA PTSD Reaction Index for DSM-5 for youth trauma history, PTSD symptoms, distress, impairment, and monitoring.",
		"h1": "UCLA Child/Adolescent PTSD Reaction Index for DSM-5",
		"intro": "The UCLA Child/Adolescent PTSD Reaction Index for DSM-5 is a practitioner-facing assessment for child trauma clinicians and TF-CBT therapists. It helps practitioners document trauma exposure, quantify DSM-5 PTSD symptoms, include distress and impairment, review supported diagnostic indicators, and compare repeated administrations over treatment.",
		"demoTitle": "Start with a sample administration",
		"demoPrompt": "Interested in using UCLA Child/Adolescent PTSD Reaction Index for DSM-5 with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0271-f-010-tfcbt-001-r001-ucla-child-adolescent-ptsd-reaction-index-for-dsm-5.md",
		"specId": "0271-f-010-tfcbt-001-r001-ucla-child-adolescent-ptsd-reaction-index-for-dsm-5",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use at intake, treatment planning, or repeated progress monitoring when a trauma-exposed school-age child or adolescent needs structured PTSD assessment in TF-CBT or related care."
			},
			{
				"title": "What It Separates",
				"body": "The review keeps reported trauma and symptom responses, system-derived scoring and cutoff indicators, and practitioner interpretation visually distinct."
			},
			{
				"title": "Repeated Use",
				"body": "History is organized by administration date and respondent/version so baseline and later results can be compared while preserving score context."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general trauma assessment builder?",
				"answer": "No. This demo represents the UCLA Child/Adolescent PTSD Reaction Index for DSM-5 only, with its supported administration, scoring, review, and comparison workflow."
			},
			{
				"question": "Can a child or caregiver complete it directly?",
				"answer": "Yes, when a supported self-report or caregiver version is used. The practitioner still reviews the responses, scores, and interpretation."
			},
			{
				"question": "Does the tool generate treatment recommendations?",
				"answer": "No. It shows supported assessment results, score information, cutoff or diagnostic indicators, and comparison states; treatment planning remains practitioner-controlled."
			},
			{
				"question": "What happens to sample demo responses when I save?",
				"answer": "Sample responses are not saved as real client data. Saving keeps the assessment tool and selected reusable setup only."
			}
		]
	},
	{
		"toolType": "childPtsdSymptomScaleForDsm5Cpss5",
		"slug": "child-ptsd-symptom-scale-for-dsm-5-cpss-5",
		"title": "CPSS-5 PTSD Assessment Demo | Qwoach",
		"metaDescription": "Explore CPSS-5 for youth PTSD severity, symptom clusters, impairment scoring, likely diagnostic status, and treatment-change comparison.",
		"h1": "Child PTSD Symptom Scale for DSM-5 (CPSS-5)",
		"intro": "The Child PTSD Symptom Scale for DSM-5 is a practitioner-facing PTSD measure for TF-CBT providers and child trauma programs working with youth ages 8-18. It helps practitioners quantify PTSD symptom severity, review symptom-cluster and impairment scores, evaluate supported likely diagnostic status, and compare results across care.",
		"demoTitle": "Open the sample CPSS-5 workflow",
		"demoPrompt": "Interested in using Child PTSD Symptom Scale for DSM-5 (CPSS-5) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0272-f-010-tfcbt-001-r002-child-ptsd-symptom-scale-for-dsm-5-cpss-5.md",
		"specId": "0272-f-010-tfcbt-001-r002-child-ptsd-symptom-scale-for-dsm-5-cpss-5",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Supported Use",
				"body": "CPSS-5 is for youth ages 8-18 in TF-CBT or child trauma program contexts where PTSD symptom severity, impairment, and treatment change need structured review."
			},
			{
				"title": "Comparison Context",
				"body": "Historical results retain administration date and format so comparisons can account for whether interview or self-report formats differ."
			}
		],
		"faqItems": [
			{
				"question": "What age range does this demo represent?",
				"answer": "It represents CPSS-5 use with youth ages 8-18, matching the product specification."
			},
			{
				"question": "Does CPSS-5 include impairment?",
				"answer": "Yes. The tool includes functional impairment ratings and an impairment score alongside PTSD symptom scoring."
			},
			{
				"question": "Can incomplete responses be scored as complete?",
				"answer": "No. Required symptom and impairment sections must be complete before the demo presents a complete score profile unless supported scoring rules allow otherwise."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The CPSS-5 tool and selected reusable setup are saved. Fictional sample responses and results are not saved as real client data."
			}
		]
	},
	{
		"toolType": "traumaSymptomChecklistForChildrenTscc",
		"slug": "trauma-symptom-checklist-for-children-tscc",
		"title": "TSCC Trauma Symptom Checklist Demo | Qwoach",
		"metaDescription": "Explore a TSCC demo for child trauma symptom profiling, validity indicators, clinical scales, normed scores, percentiles, and profile graphs.",
		"h1": "Trauma Symptom Checklist for Children (TSCC)",
		"intro": "The Trauma Symptom Checklist for Children is a practitioner-facing child self-report checklist for clinicians and qualified assessment users evaluating trauma-exposed children ages 8-16. It helps practitioners review posttraumatic stress and related symptom domains, validity indicators, normed scores, percentiles, and profile information.",
		"demoTitle": "View the sample TSCC profile",
		"demoPrompt": "Interested in using Trauma Symptom Checklist for Children (TSCC) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0273-f-010-tfcbt-001-r003-trauma-symptom-checklist-for-children-tscc.md",
		"specId": "0273-f-010-tfcbt-001-r003-trauma-symptom-checklist-for-children-tscc",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Validity First",
				"body": "The review foregrounds validity indicators so practitioners can judge whether the child self-report profile is interpretable."
			},
			{
				"title": "Norm Context",
				"body": "Norm basis and form are retained with each result so historical review does not separate scores from their scoring context."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the TSCC?",
				"answer": "The child completes the self-report checklist; the practitioner controls administration setup, scoring review, and interpretation."
			},
			{
				"question": "Does the demo diagnose trauma-related disorders?",
				"answer": "No. The demo shows supported scale scores, validity indicators, normed outputs, percentiles, and profile information without generating unsupported diagnoses."
			},
			{
				"question": "Why are age or sex inputs shown?",
				"answer": "Norm-relevant inputs are shown because supported normed T scores and percentiles depend on the measure's required scoring basis."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The TSCC tool and selected setup are saved. Fictional responses, sample demographics, and sample profile outputs are not saved as real client data."
			}
		]
	},
	{
		"toolType": "assessmentFeedback",
		"slug": "assessment-feedback",
		"title": "TF-CBT Assessment Feedback Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT Assessment Feedback demo for discussing findings, connecting treatment rationale, and capturing child or caregiver questions.",
		"h1": "Assessment Feedback",
		"intro": "Assessment Feedback is a TF-CBT live-session configuration for practitioners who need to explain assessment findings to a child and caregiver. It helps the practitioner connect findings to the child's symptoms, strengths, needs, and treatment rationale while surfacing questions, concerns, and misunderstandings.",
		"demoTitle": "Open the sample feedback session",
		"demoPrompt": "Interested in using Assessment Feedback with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0274-f-010-tfcbt-002-r001-assessment-feedback.md",
		"specId": "0274-f-010-tfcbt-002-r001-assessment-feedback",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Live-Session Use",
				"body": "Assessment Feedback is used as a lightweight live-session guide, not as a questionnaire or automated assessment."
			},
			{
				"title": "Unresolved Questions",
				"body": "Questions, concerns, and misunderstandings remain visible as follow-up items instead of being automatically resolved by the system."
			}
		],
		"faqItems": [
			{
				"question": "Does Assessment Feedback create assessment findings?",
				"answer": "No. The practitioner selects or enters findings that already exist in the clinical workflow."
			},
			{
				"question": "Is there a separate client form?",
				"answer": "No. The supplied specification defines this as live-session-only, with child and caregiver participation occurring in conversation."
			},
			{
				"question": "Does the tool generate feedback scripts?",
				"answer": "No. Exact scripts and substantive prompts are unresolved; the tool organizes practitioner-provided feedback content and participant questions."
			}
		]
	},
	{
		"toolType": "traumaPsychoeducationWorksheet",
		"slug": "trauma-psychoeducation-worksheet",
		"title": "TF-CBT Trauma Psychoeducation Worksheet Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT psychoeducation worksheet demo for child or caregiver understanding, questions, reactions, and misconceptions about trauma responses.",
		"h1": "Trauma Psychoeducation Worksheet",
		"intro": "Trauma Psychoeducation Worksheet is a TF-CBT-ready worksheet for practitioners working with a child or caregiver early in treatment. It helps the practitioner provide selected psychoeducation material, collect understanding, questions, reactions, or misconceptions, and decide whether psychoeducation needs repetition, adjustment, or caregiver support.",
		"demoTitle": "Try the sample worksheet",
		"demoPrompt": "Interested in using Trauma Psychoeducation Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0275-f-010-tfcbt-003-r001-trauma-psychoeducation-worksheet.md",
		"specId": "0275-f-010-tfcbt-003-r001-trauma-psychoeducation-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Unresolved Worksheet Content",
				"body": "The product does not invent exact psychoeducation prompts or wording. Practitioners provide or select supported content before assigning the worksheet."
			},
			{
				"title": "Role-Labeled Responses",
				"body": "Child and caregiver responses remain separate so differences in understanding or questions are visible to the practitioner."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate psychoeducation content?",
				"answer": "No. The practitioner provides or selects the psychoeducation material used in the worksheet."
			},
			{
				"question": "Can both a child and caregiver complete it?",
				"answer": "Yes. Respondent choice supports child, caregiver, or both, with responses labeled by role."
			},
			{
				"question": "Are responses scored?",
				"answer": "No. Responses are organized for practitioner review but are not scored or automatically interpreted."
			}
		]
	},
	{
		"toolType": "parentingSkillsPlan",
		"slug": "parenting-skills-plan",
		"title": "TF-CBT Parenting Skills Plan Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT Parenting Skills Plan demo for linking child symptoms to caregiver responses and reviewing practice, adherence, and barriers.",
		"h1": "Parenting Skills Plan",
		"intro": "Parenting Skills Plan is a TF-CBT caregiver plan for practitioners working with caregivers. It helps the practitioner and caregiver define actionable caregiver responses matched to a child's trauma-related symptom or behavior patterns, then review practice, adherence, and barriers in later sessions.",
		"demoTitle": "Build a sample plan",
		"demoPrompt": "Interested in using Parenting Skills Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0276-f-010-tfcbt-004-r001-parenting-skills-plan.md",
		"specId": "0276-f-010-tfcbt-004-r001-parenting-skills-plan",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Trauma"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Actionable Links",
				"body": "A plan is considered actionable only when each active child symptom or behavior target has a linked caregiver response."
			},
			{
				"title": "Barrier Review",
				"body": "Barriers are captured as review information so the practitioner and caregiver can adjust the plan without system judgment."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool provide a parenting skill menu?",
				"answer": "No. Exact skill menus and prompts are unresolved; the practitioner supplies the plan content."
			},
			{
				"question": "Does it score caregiver adherence?",
				"answer": "No. It captures adherence and barriers for review without producing caregiver quality scores."
			},
			{
				"question": "Can the plan be revised?",
				"answer": "Yes. Revisions preserve prior targets and responses so later review has context."
			}
		]
	},
	{
		"toolType": "bellyBreathing",
		"slug": "belly-breathing",
		"title": "TF-CBT Belly Breathing Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT Belly Breathing demo for guided relaxation practice, practitioner observation, use situations, and optional home support.",
		"h1": "Belly Breathing",
		"intro": "Belly Breathing is a TF-CBT relaxation skill tool for practitioners teaching children slow, deep, belly-based breathing. It helps the child practice a body-calming skill and helps the practitioner observe technique, child use situations, perceived helpfulness, and whether home or caregiver support is needed.",
		"demoTitle": "Start the sample practice",
		"demoPrompt": "Interested in using Belly Breathing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0277-f-010-tfcbt-005-r001-belly-breathing.md",
		"specId": "0277-f-010-tfcbt-005-r001-belly-breathing",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"Between-session monitoring"
			],
			"topic": [
				"Coping",
				"Skills use"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Home Practice",
				"body": "Home practice is optional. When enabled, the result can include practice logs or caregiver observations without becoming a broad homework tracker."
			},
			{
				"title": "Helpfulness",
				"body": "Helpfulness is recorded from child report or practitioner observation. The system does not infer arousal reduction."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general breathing program?",
				"answer": "No. It is Belly Breathing within TF-CBT relaxation, focused on slow belly-based breathing practice."
			},
			{
				"question": "Can home practice be included?",
				"answer": "Yes, when live plus home practice mode is selected. Home practice is optional and lightweight."
			},
			{
				"question": "Does the tool measure arousal physiologically?",
				"answer": "No. It records practice, observation, child report, and practitioner notes, not physiological metrics."
			}
		]
	},
	{
		"toolType": "progressiveMuscleRelaxation",
		"slug": "progressive-muscle-relaxation",
		"title": "TF-CBT Progressive Muscle Relaxation Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT Progressive Muscle Relaxation demo for tense-and-release practice, adaptations, child reports, observations, and review.",
		"h1": "Progressive Muscle Relaxation",
		"intro": "Progressive Muscle Relaxation is a TF-CBT relaxation skill tool for practitioners teaching children or teens to recognize body tension and reduce it through a developmentally appropriate tense-and-release sequence. It helps practitioners guide practice, record adaptations, and review whether the strategy is feasible and calming.",
		"demoTitle": "Start the sample PMR sequence",
		"demoPrompt": "Interested in using Progressive Muscle Relaxation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0278-f-010-tfcbt-005-r002-progressive-muscle-relaxation.md",
		"specId": "0278-f-010-tfcbt-005-r002-progressive-muscle-relaxation",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Skills use"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Adaptation",
				"body": "The practitioner can shorten, skip, or adapt steps for age, attention, body awareness, or discomfort while preserving the tense-release mechanic."
			},
			{
				"title": "No Fixed Unsupported Script",
				"body": "The product does not hard-code scripts or muscle sequences unless they are supplied by the practitioner or supported source."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo require a fixed muscle sequence?",
				"answer": "No. The practitioner can use a supported sequence or enter an adaptation; unsupported scripts are not invented."
			},
			{
				"question": "What if a child cannot identify body sensations?",
				"answer": "The practitioner can mark the practice as needing adaptation and preserve notes without forcing completion."
			},
			{
				"question": "Does PMR produce a score?",
				"answer": "No. It records practice steps, reports, observations, adaptations, and barriers without scoring symptoms or relaxation."
			}
		]
	},
	{
		"toolType": "safePlaceImagery2",
		"slug": "safe-place-imagery-2",
		"title": "TF-CBT Safe Place Imagery Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT Safe Place Imagery demo for child-generated calming images, sensory details, rehearsal notes, and practice review.",
		"h1": "Safe Place Imagery",
		"intro": "Safe Place Imagery is a TF-CBT relaxation skill tool for practitioners helping a child create and rehearse an individualized calming image. It helps the child choose a safe, calm, or positive place, add sensory details, draw or describe it, and practice recalling it during fear, tension, or distress.",
		"demoTitle": "Create a sample safe place",
		"demoPrompt": "Interested in using Safe Place Imagery with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0279-f-010-tfcbt-005-r003-safe-place-imagery.md",
		"specId": "0279-f-010-tfcbt-005-r003-safe-place-imagery",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Skills use"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Child-Generated Content",
				"body": "The child creates the image or description. The system does not generate the safe place or interpret the child's drawing."
			},
			{
				"title": "Readiness",
				"body": "If an image does not feel safe, calm, or positive, it is marked not ready so the practitioner can revise or pause the exercise."
			}
		],
		"faqItems": [
			{
				"question": "Does the system create the safe place for the child?",
				"answer": "No. The child generates the safe-place content with practitioner guidance."
			},
			{
				"question": "Can the child draw instead of write?",
				"answer": "Yes, where drawing mode is supported. Verbal description, drawing, or both can be used based on the selected representation mode."
			},
			{
				"question": "Does the tool interpret artwork?",
				"answer": "No. It stores the child-created cue and practitioner observations without interpreting meaning."
			}
		]
	},
	{
		"toolType": "bellyBreathing2",
		"slug": "belly-breathing-2",
		"title": "Live TF-CBT Belly Breathing Demo | Qwoach",
		"metaDescription": "Explore a live-session Belly Breathing demo for TF-CBT practitioners teaching slow belly-based breathing and recording reinforcement decisions.",
		"h1": "Belly Breathing",
		"intro": "Belly Breathing is a live-session TF-CBT relaxation configuration for practitioners teaching a child slow belly-based breathing. It helps the practitioner observe belly movement or relaxed pacing, connect the skill to moments of tension, worry, or upset, and decide whether to reinforce the strategy between sessions.",
		"demoTitle": "Open the live practice demo",
		"demoPrompt": "Interested in using Belly Breathing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0280-f-010-tfcbt-006-r001-belly-breathing.md",
		"specId": "0280-f-010-tfcbt-006-r001-belly-breathing",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Coping",
				"Skills use"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Live-Session Focus",
				"body": "This configuration is intentionally compact. It supports live teaching and observation rather than a full homework program."
			},
			{
				"title": "Reinforcement Decision",
				"body": "The key continuation state is whether the practitioner decides to reinforce belly breathing between sessions or revisit it later."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as a full home practice tracker?",
				"answer": "No. This row is the live-session configuration; detailed home tracking is outside the smallest product unless separately enabled."
			},
			{
				"question": "Does the child complete a form?",
				"answer": "No. The child participates in live breathing practice while the practitioner records observation and judgment."
			},
			{
				"question": "What gets saved from the demo?",
				"answer": "The live Belly Breathing tool and reusable setup are saved. Fictional session observations and sample child responses are not saved as real client data."
			}
		]
	},
	{
		"toolType": "safePlaceImagery3",
		"slug": "safe-place-imagery-3",
		"title": "Safe Place Imagery Demo for TF-CBT Sessions | Qwoach",
		"metaDescription": "Explore a practitioner-led Safe Place Imagery tool for helping a child create and optionally record a calming mental refuge during TF-CBT work.",
		"h1": "Safe Place Imagery for Child Trauma-Focused Sessions",
		"intro": "Safe Place Imagery is a practitioner-led calming imagery tool for trauma-focused child therapy. Practitioners use it in live session to help a child identify a personalized safe or comforting mental image and optionally record the details for later supported reuse.",
		"demoTitle": "Open the demo workspace with sample, non-identifying imagery details.",
		"demoPrompt": "Interested in using Safe Place Imagery with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0281-f-010-tfcbt-007-r001-safe-place-imagery.md",
		"specId": "0281-f-010-tfcbt-007-r001-safe-place-imagery",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Trauma",
				"Emotion regulation",
				"Coping"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during practitioner-led trauma-focused work when a child needs a personalized calming image that can be revisited during or after distress."
			},
			{
				"title": "What It Captures",
				"body": "The tool can capture the image description, child-preferred sensory or comfort details, and avoidances if the child identifies unsafe or distress-linked associations."
			},
			{
				"title": "Limitations",
				"body": "The tool does not score distress, interpret imagery symbols, prescribe scripts, or determine whether an image is clinically safe beyond practitioner review."
			}
		],
		"faqItems": [
			{
				"question": "Can a child complete Safe Place Imagery independently?",
				"answer": "No. The specified experience is practitioner-led in live session, with shared viewing only when useful."
			},
			{
				"question": "Does the tool require recording the child's imagery?",
				"answer": "No. The practitioner can use it live without recording, or optionally record details for later supported reuse."
			},
			{
				"question": "What happens if the child cannot identify a safe image?",
				"answer": "The state remains incomplete. The tool does not force alternatives or mark the work as failed."
			},
			{
				"question": "Does the result include a score or interpretation?",
				"answer": "No. The result organizes recorded imagery details only and does not score, diagnose, or interpret symbolism."
			}
		]
	},
	{
		"toolType": "feelingsIdentification",
		"slug": "feelings-identification",
		"title": "Feelings Identification Demo for TF-CBT | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned Feelings Identification activity for helping children name emotions and connect feeling words to examples.",
		"h1": "Feelings Identification for Trauma-Focused Child Therapy",
		"intro": "Feelings Identification is an emotion identification activity for trauma-focused child therapy. Practitioners use it to help a child notice, name, and communicate emotional experiences so later coping and processing work can reflect the child's actual feeling vocabulary.",
		"demoTitle": "Try the activity with fictional feelings and example situations.",
		"demoPrompt": "Interested in using Feelings Identification with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0282-f-010-tfcbt-008-r001-feelings-identification.md",
		"specId": "0282-f-010-tfcbt-008-r001-feelings-identification",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The activity captures child-reported feeling words, optional situation or internal-experience links, and unclear or skipped emotions."
			},
			{
				"title": "Practitioner And Child Roles",
				"body": "The practitioner assigns or completes the activity and reviews the result. The child supplies emotion labels and examples in their own language."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not provide symptom severity ratings, diagnoses, mandated emotion categories, or unsupported emotion taxonomies."
			}
		],
		"faqItems": [
			{
				"question": "Can Feelings Identification be sent to a child?",
				"answer": "Yes. Completion mode may be ready-to-send or completed together, and both modes produce a recognition profile for practitioner review."
			},
			{
				"question": "Does the tool include a fixed emotion-word list?",
				"answer": "Not by default. Exact feeling vocabulary is unresolved, so the demo should use supported or practitioner-provided labels."
			},
			{
				"question": "What if a child skips feelings?",
				"answer": "Skipped or unclear feelings remain visible in the profile so the practitioner can decide whether to clarify them later."
			},
			{
				"question": "Does the tool measure mood over time?",
				"answer": "No. It identifies emotional vocabulary and recognition, not mood tracking or symptom severity."
			}
		]
	},
	{
		"toolType": "bodyFeelingsMap",
		"slug": "body-feelings-map",
		"title": "Body Feelings Map Demo for TF-CBT | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned Body Feelings Map for linking feelings to body locations and sensations with practitioner support.",
		"h1": "Body Feelings Map for Child Trauma-Focused Therapy",
		"intro": "Body Feelings Map is a practitioner-supported body-emotion mapping tool for children in trauma-focused treatment. Practitioners use it to help a child connect specific feelings with body locations and sensation words so early distress cues can be recognized for later coping work.",
		"demoTitle": "Create a sample body-emotion map with fictional associations.",
		"demoPrompt": "Interested in using Body Feelings Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0283-f-010-tfcbt-009-r001-body-feelings-map.md",
		"specId": "0283-f-010-tfcbt-009-r001-body-feelings-map",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The map captures reported feelings, body locations, sensation descriptions, and uncertainty or incomplete associations."
			},
			{
				"title": "Repeat Use",
				"body": "Saved maps can support descriptive review of added or changed associations across sessions without treating changes as clinical progress by default."
			},
			{
				"title": "Limitations",
				"body": "The tool does not diagnose medical symptoms, interpret body sensations, require comprehensive body coverage, or score distress."
			}
		],
		"faqItems": [
			{
				"question": "Is Body Feelings Map a medical symptom assessment?",
				"answer": "No. It records child-reported body-emotion associations and does not make medical or diagnostic interpretations."
			},
			{
				"question": "Can the activity be completed without a visual map?",
				"answer": "Yes. An accessible list mode can capture feeling, location, and sensation when visual marking is not appropriate."
			},
			{
				"question": "What happens if the child gives a sensation without a location?",
				"answer": "The tool keeps it as unmapped detail instead of discarding it or forcing a location."
			},
			{
				"question": "Does every feeling or body area need to be completed?",
				"answer": "No. Partial maps are supported, and the practitioner decides whether the information is useful."
			}
		]
	},
	{
		"toolType": "feelingsIntensityScale",
		"slug": "feelings-intensity-scale",
		"title": "Feelings Intensity Scale Demo for TF-CBT | Qwoach",
		"metaDescription": "Explore a 1-10 Feelings Intensity Scale for capturing repeatable child emotion ratings tied to specific feelings or situations.",
		"h1": "Feelings Intensity Scale for Trauma-Focused Child Therapy",
		"intro": "Feelings Intensity Scale is a repeatable 1-10 emotion-intensity rating tool for trauma-focused child therapy. Practitioners use it to help a child rate specific feelings or situations over time so descriptive changes in distress are visible for pacing coping, exposure, and trauma processing.",
		"demoTitle": "Enter sample 1-10 ratings and review the descriptive pattern.",
		"demoPrompt": "Interested in using Feelings Intensity Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0284-f-010-tfcbt-010-r001-feelings-intensity-scale.md",
		"specId": "0284-f-010-tfcbt-010-r001-feelings-intensity-scale",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Emotion regulation",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "Each completed entry captures a 1-10 rating, feeling label, and optional situation or moment, with date or session context when available."
			},
			{
				"title": "History And Comparison",
				"body": "Repeated entries can be grouped by feeling or situation to show descriptive change, highest and lowest ratings, and incomplete entries."
			},
			{
				"title": "Limitations",
				"body": "The tool does not create diagnosis, clinical thresholds, automated risk status, treatment recommendations, or readiness decisions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a symptom severity scale?",
				"answer": "No. It is a descriptive 1-10 emotion-intensity rating tool tied to specific feelings or situations."
			},
			{
				"question": "Can ratings be compared over time?",
				"answer": "Yes. Repeated ratings can be displayed together when the scale context and target are preserved."
			},
			{
				"question": "What if a child enters vague distress only?",
				"answer": "The entry is retained as incomplete or low-specificity rather than being converted into a completed rating."
			},
			{
				"question": "Does the tool tell the practitioner what action to take?",
				"answer": "No. It shows descriptive ratings and trends; practitioner interpretation and pacing decisions remain outside the system."
			}
		]
	},
	{
		"toolType": "feelingsSurvivalKit",
		"slug": "feelings-survival-kit",
		"title": "Feelings Survival Kit Demo for TF-CBT | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned Feelings Survival Kit for matching a child's difficult feelings with realistic coping options and contexts.",
		"h1": "Feelings Survival Kit for Trauma-Focused Child Therapy",
		"intro": "Feelings Survival Kit is an individualized coping toolkit for trauma-focused child therapy. Practitioners use it with a child to match difficult feelings with coping options and everyday contexts so the toolkit reflects the child's preferences and realistic situations.",
		"demoTitle": "Create a sample feeling-to-coping toolkit.",
		"demoPrompt": "Interested in using Feelings Survival Kit with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0285-f-010-tfcbt-011-r001-feelings-survival-kit.md",
		"specId": "0285-f-010-tfcbt-011-r001-feelings-survival-kit",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Coping",
				"Emotion regulation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a child needs concrete, individualized coping options for strong feelings during trauma recovery."
			},
			{
				"title": "Practitioner And Child Roles",
				"body": "The practitioner frames and reviews the toolkit. The child contributes difficult feelings, preferences, and feedback about what feels realistic."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not recommend, rank, or score coping strategies and does not function as a crisis plan."
			}
		],
		"faqItems": [
			{
				"question": "Can the toolkit be sent for child input?",
				"answer": "Yes. The completion mode may be ready-to-send, but sent entries require practitioner review before being treated as ready for therapeutic use."
			},
			{
				"question": "Does the tool provide a universal coping-skills list?",
				"answer": "No. Coping options must be supported by therapy, practitioner setup, or child preference; unsupported strategy catalogs are not part of the specification."
			},
			{
				"question": "What if a strategy is entered without a feeling?",
				"answer": "It remains as an unmatched option so the practitioner can review or match it later."
			},
			{
				"question": "Does the tool say which strategy will work best?",
				"answer": "No. It organizes feeling-to-coping matches and does not infer effectiveness or rank options."
			}
		]
	},
	{
		"toolType": "cognitiveTriangle",
		"slug": "cognitive-triangle",
		"title": "Cognitive Triangle Demo for TF-CBT | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned Cognitive Triangle for mapping thoughts, feelings, and behaviors in a specific child-relevant situation.",
		"h1": "Cognitive Triangle for Trauma-Focused Child Therapy",
		"intro": "Cognitive Triangle is a practitioner-supported formulation tool for trauma-focused child therapy. Practitioners use it with a child to separate what happened, what the child thought, what the child felt, and what the child did so cognitive coping work can start from the child's own example.",
		"demoTitle": "Build a sample triangle from a fictional situation.",
		"demoPrompt": "Interested in using Cognitive Triangle with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0286-f-010-tfcbt-012-r001-cognitive-triangle.md",
		"specId": "0286-f-010-tfcbt-012-r001-cognitive-triangle",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Cognitive restructuring",
				"Behavior change"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures a situation anchor and separate entries for thoughts, feelings, and behaviors."
			},
			{
				"title": "Practitioner And Child Roles",
				"body": "The practitioner guides the sorting and review. The child supplies examples and can see the categories as separate but connected."
			},
			{
				"title": "Limitations",
				"body": "The tool does not label cognitive distortions, judge correctness, generate alternative thoughts, or make clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Does Cognitive Triangle generate alternative thoughts?",
				"answer": "No. It organizes the situation, thoughts, feelings, and behaviors; any discussion of alternatives is practitioner-led."
			},
			{
				"question": "Is a specific situation required?",
				"answer": "Yes. The formulation must be grounded in a specific child-relevant situation."
			},
			{
				"question": "What if an entry is placed in the wrong category?",
				"answer": "It can be moved while preserving the child's original wording."
			},
			{
				"question": "Can a triangle be partial?",
				"answer": "Yes. Empty or unclear domains are shown as partial rather than forcing completion."
			}
		]
	},
	{
		"toolType": "thoughtProblemsCognitiveDistortionIdentification",
		"slug": "thought-problems-cognitive-distortion-identification",
		"title": "Thought Problems Identification Demo for TF-CBT | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned tool for capturing concrete distressing thoughts, optional supported categories, and clarification states.",
		"h1": "Thought Problems / Cognitive Distortion Identification",
		"intro": "Thought Problems / Cognitive Distortion Identification is a thought-pattern identification tool for trauma-focused child therapy. Practitioners use it to help a child record distressing thoughts, distinguish thoughts from feelings or events, and review recurring patterns for later cognitive coping work.",
		"demoTitle": "Try the demo with fictional thought entries.",
		"demoPrompt": "Interested in using Thought Problems / Cognitive Distortion Identification with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0287-f-010-tfcbt-013-r001-thought-problems-cognitive-distortion-identification.md",
		"specId": "0287-f-010-tfcbt-013-r001-thought-problems-cognitive-distortion-identification",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Cognitive restructuring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures child-reported thoughts, optional situations, supported assigned categories if used, and uncertainty or clarification status."
			},
			{
				"title": "Category Use",
				"body": "Categories are optional and must come from a supported source or practitioner setup; the system does not create a generic taxonomy."
			},
			{
				"title": "Limitations",
				"body": "The tool does not classify thoughts automatically, judge whether thoughts are true, generate alternative beliefs, or complete cognitive restructuring."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool automatically identify cognitive distortions?",
				"answer": "No. Categories are assigned only by the practitioner or user when a supported category set is available."
			},
			{
				"question": "Can uncertain entries be saved?",
				"answer": "Yes. Entries that may be feelings, events, or vague thoughts can be saved for practitioner clarification."
			},
			{
				"question": "Does the tool generate replacement thoughts?",
				"answer": "No. It identifies and organizes thoughts; evaluation and shifting occur in later practitioner-led cognitive coping work."
			},
			{
				"question": "What if no category set is available?",
				"answer": "The tool runs in no-category mode and groups entries by wording, recurrence, and clarification status only."
			}
		]
	},
	{
		"toolType": "traumaNarrative",
		"slug": "trauma-narrative",
		"title": "Trauma Narrative Demo for TF-CBT | Qwoach",
		"metaDescription": "Explore a practitioner-led Trauma Narrative workspace for organizing trauma account sections, thoughts, feelings, and meanings at a supported pace.",
		"h1": "Trauma Narrative Workspace for TF-CBT",
		"intro": "Trauma Narrative is a practitioner-led trauma narrative and processing tool for TF-CBT. Practitioners use it with a child who is ready to work directly with traumatic memories, organizing the account, sequence, thoughts, feelings, and meanings at a tolerable pace.",
		"demoTitle": "Explore a fictional, non-identifying narrative workspace.",
		"demoPrompt": "Interested in using Trauma Narrative with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0288-f-010-tfcbt-014-r001-trauma-narrative.md",
		"specId": "0288-f-010-tfcbt-014-r001-trauma-narrative",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Led Use",
				"body": "The tool is used together with the child in a structured therapeutic context, with practitioner pacing, containment, and review."
			},
			{
				"title": "Partial Progress",
				"body": "Incomplete and paused narratives are expected states and can be resumed without forcing traumatic details or completeness."
			},
			{
				"title": "Limitations",
				"body": "The tool does not generate trauma content, infer meanings, score readiness, require exhaustive detail, or operate as an unsupervised exposure workflow."
			}
		],
		"faqItems": [
			{
				"question": "Can Trauma Narrative be used as an unsupervised assignment?",
				"answer": "No. The specified use is practitioner-led co-completion in a structured therapeutic context."
			},
			{
				"question": "Does the tool write or complete narrative content?",
				"answer": "No. It organizes content provided by the child and practitioner; it does not generate memories, meanings, or conclusions."
			},
			{
				"question": "Are partial narratives allowed?",
				"answer": "Yes. Partial and paused states are expected and should remain clearly contained."
			},
			{
				"question": "What happens if narrative sections are reordered?",
				"answer": "The account can be reordered while preserving original wording and enough context for later review."
			}
		]
	},
	{
		"toolType": "traumaNarrativeFeelings110",
		"slug": "trauma-narrative-feelings-1-10",
		"title": "Trauma Narrative Feelings 1-10 Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned tool for linking 1-10 feelings ratings to trauma narrative sections, moments, or thoughts.",
		"h1": "Trauma Narrative Feelings 1-10",
		"intro": "Trauma Narrative Feelings 1-10 is a narrative-linked distress-rating tool for TF-CBT. Practitioners use it to attach repeatable 1-10 feelings ratings to specific trauma narrative sections, moments, or thoughts so pacing and focus can reflect the child's reported distress profile.",
		"demoTitle": "Rate fictional narrative anchors and view the distress profile.",
		"demoPrompt": "Interested in using Trauma Narrative Feelings 1-10 with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0289-f-010-tfcbt-015-r001-trauma-narrative-feelings-1-10.md",
		"specId": "0289-f-010-tfcbt-015-r001-trauma-narrative-feelings-1-10",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Emotion regulation",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures 1-10 feelings ratings linked to narrative sections, moments, or thoughts, with repeated ratings preserved as history."
			},
			{
				"title": "Partial Coverage",
				"body": "Not every narrative anchor needs to be rated. Unrated sections remain separate and are not interpreted as low distress."
			},
			{
				"title": "Limitations",
				"body": "The tool does not infer thresholds, readiness, risk, processing priorities, or required interventions from ratings."
			}
		],
		"faqItems": [
			{
				"question": "Can ratings be entered without a narrative anchor?",
				"answer": "No. A rating must be linked to a narrative section, moment, or thought to be complete."
			},
			{
				"question": "Does a high rating trigger an automated recommendation?",
				"answer": "No. The tool shows reported intensity descriptively and does not generate processing recommendations."
			},
			{
				"question": "Can the same anchor be rated more than once?",
				"answer": "Yes. Repeated ratings for the same anchor are shown as history rather than overwriting prior entries."
			},
			{
				"question": "Do unrated sections count as low distress?",
				"answer": "No. Unrated sections are shown as unrated and should not be interpreted as low distress."
			}
		]
	},
	{
		"toolType": "traumaThoughtsAndFeelingsProcessing",
		"slug": "trauma-thoughts-and-feelings-processing",
		"title": "Trauma Thoughts and Feelings Processing Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned workspace for linking trauma-related thoughts, feelings, memories, and meanings for practitioner review.",
		"h1": "Trauma Thoughts and Feelings Processing",
		"intro": "Trauma Thoughts and Feelings Processing is a practitioner-led cognitive processing workspace for TF-CBT. Practitioners use it with a child to make trauma-related thoughts, associated feelings, memory anchors, and emotional meanings explicit enough to guide cognitive processing.",
		"demoTitle": "Build a fictional linked processing map.",
		"demoPrompt": "Interested in using Trauma Thoughts and Feelings Processing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0290-f-010-tfcbt-016-r001-trauma-thoughts-and-feelings-processing.md",
		"specId": "0290-f-010-tfcbt-016-r001-trauma-thoughts-and-feelings-processing",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning",
				"In-session support"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The workspace captures trauma-material anchors, explicit thoughts, associated feelings, meanings, partial entries, revisions, and practitioner review markers."
			},
			{
				"title": "Practitioner And Child Roles",
				"body": "The practitioner frames, guides, and reviews the work. The child contributes thoughts, feelings, and meanings in their own words with support."
			},
			{
				"title": "Limitations",
				"body": "The tool does not generate adaptive beliefs, classify distortions, diagnose, score risk, or prescribe cognitive processing interventions."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate more adaptive interpretations?",
				"answer": "No. It organizes reported thoughts, feelings, memories, and meanings; developing interpretations remains practitioner-led."
			},
			{
				"question": "Can an entry be partial?",
				"answer": "Yes. A feeling without a thought or a thought without a clear anchor can be retained for review."
			},
			{
				"question": "Does the system identify distorted thinking automatically?",
				"answer": "No. Distress-maintaining or self-blaming meanings are recorded only when reported or practitioner-marked."
			},
			{
				"question": "Can this replace the Trauma Narrative tool?",
				"answer": "No. It is a cognitive processing configuration linked to trauma-related thoughts and feelings, not a standalone trauma narrative builder."
			}
		]
	},
	{
		"toolType": "inVivoMasteryTraumaReminderHierarchy",
		"slug": "in-vivo-mastery-trauma-reminder-hierarchy",
		"title": "In Vivo Mastery Trauma Reminder Hierarchy Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned hierarchy tool for safe trauma reminders, gradual exposure steps, and progress review across repeated encounters.",
		"h1": "In Vivo Mastery / Trauma Reminder Hierarchy",
		"intro": "In Vivo Mastery / Trauma Reminder Hierarchy is a TF-CBT-aligned exposure planning tool for trauma-focused practitioners working with children who avoid safe trauma reminders. It helps the practitioner organize specific avoided reminders, confirm safe-reminder links, order targets by difficulty, distress, or clinical order, and review progress over repeated encounters.",
		"demoTitle": "Explore the sample hierarchy",
		"demoPrompt": "Interested in using In Vivo Mastery / Trauma Reminder Hierarchy with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0291-f-010-tfcbt-017-r001-in-vivo-mastery-trauma-reminder-hierarchy.md",
		"specId": "0291-f-010-tfcbt-017-r001-in-vivo-mastery-trauma-reminder-hierarchy",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during trauma-focused treatment when safe trauma reminders are being avoided and the practitioner needs a gradual, clinically targeted path for exposure work."
			},
			{
				"title": "What It Tracks",
				"body": "The tool tracks targets, safe-reminder links, ordering basis, status, repeated progress entries, skipped or paused items, and practitioner notes."
			},
			{
				"title": "Important Boundary",
				"body": "The tool organizes practitioner-guided hierarchy work. It does not determine danger, diagnose symptoms, generate exposure targets, or prescribe universal exposure scripts."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general exposure builder?",
				"answer": "No. It is specifically for TF-CBT-aligned in-vivo mastery work with avoided safe trauma reminders."
			},
			{
				"question": "Does the tool decide whether a target is safe?",
				"answer": "No. The practitioner provides the clinical framing and confirms that a target is a safe reminder rather than actual danger."
			},
			{
				"question": "Can the hierarchy be changed after progress is recorded?",
				"answer": "Yes. Targets can be reordered, paused, or retired while preserving progress history attached to the target."
			},
			{
				"question": "Does the child need an account to participate?",
				"answer": "No separate client account model is required by the specification. The tool may support joint completion controlled by the practitioner."
			}
		]
	},
	{
		"toolType": "conjointTraumaNarrativeSharingPlan",
		"slug": "conjoint-trauma-narrative-sharing-plan",
		"title": "Conjoint Trauma Narrative Sharing Plan Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned planning tool for child readiness, caregiver questions, and focused preparation before conjoint trauma communication.",
		"h1": "Conjoint Trauma Narrative Sharing Plan",
		"intro": "Conjoint Trauma Narrative Sharing Plan is a TF-CBT-aligned planning tool for practitioners preparing a child-caregiver conjoint session involving trauma-related communication. It helps capture child readiness and concerns, caregiver questions or communication needs, and practitioner-confirmed discussion targets.",
		"demoTitle": "Review the sample preparation plan",
		"demoPrompt": "Interested in using Conjoint Trauma Narrative Sharing Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0292-f-010-tfcbt-018-r001-conjoint-trauma-narrative-sharing-plan.md",
		"specId": "0292-f-010-tfcbt-018-r001-conjoint-trauma-narrative-sharing-plan",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Session preparation",
				"In-session support"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Practitioner Control",
				"body": "The practitioner decides what is shared in the conjoint session and what remains preparation material."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures child readiness and concerns, caregiver questions or communication needs, planned discussion targets, unresolved concerns, and practitioner review status."
			},
			{
				"title": "Important Boundary",
				"body": "The tool prepares communication. It does not contain the trauma narrative itself or automatically decide whether the conjoint session should occur."
			}
		],
		"faqItems": [
			{
				"question": "Is this the trauma narrative?",
				"answer": "No. It is a preparation plan for trauma-related communication in a conjoint child-caregiver session."
			},
			{
				"question": "Does the tool decide readiness?",
				"answer": "No. It organizes readiness information and unresolved concerns for practitioner review."
			},
			{
				"question": "Can child and caregiver inputs stay separate?",
				"answer": "Yes. Child and caregiver inputs remain distinguishable, and neither view exposes the other's full input by default."
			},
			{
				"question": "Are there configurable settings?",
				"answer": "No. The tool has no substantive settings, but the fixed tool itself is still saved to the practitioner's account."
			}
		]
	},
	{
		"toolType": "personalSafetySkillsPlan",
		"slug": "personal-safety-skills-plan",
		"title": "Personal Safety Skills Plan Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned tool for child safety knowledge, concrete help-seeking actions, assertive communication, and practice review.",
		"h1": "Personal Safety Skills Plan",
		"intro": "Personal Safety Skills Plan is a TF-CBT-aligned planning tool for practitioners helping children strengthen personal safety knowledge and assertive communication after trauma. It helps organize relevant situations, safe actions or help-seeking steps, optional assertive communication items, and practice or review status.",
		"demoTitle": "Try the sample safety plan",
		"demoPrompt": "Interested in using Personal Safety Skills Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0293-f-010-tfcbt-019-r001-personal-safety-skills-plan.md",
		"specId": "0293-f-010-tfcbt-019-r001-personal-safety-skills-plan",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Trauma",
				"Skills use"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures relevant situations, safety knowledge, safe actions, help-seeking steps, optional assertive communication items, and practice or review status."
			},
			{
				"title": "Practitioner Review",
				"body": "The practitioner remains responsible for selecting content appropriate to the child and reviewing whether each item is concrete enough for practice."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not a general crisis plan, risk assessment, legal safety protocol, or predictor of future harm."
			}
		],
		"faqItems": [
			{
				"question": "Does every situation need an action?",
				"answer": "Yes. A complete item links a specific situation to at least one concrete safety action or help-seeking step."
			},
			{
				"question": "Is assertive communication required for every item?",
				"answer": "No. Assertive communication can be included where relevant and omitted without making the plan incomplete."
			},
			{
				"question": "Does the tool generate safety instructions?",
				"answer": "No. The practitioner and child enter the plan content; the system organizes it descriptively."
			},
			{
				"question": "Are there configurable settings?",
				"answer": "No. The tool has no substantive settings, but the fixed tool itself is still saved to the practitioner's account."
			}
		]
	},
	{
		"toolType": "circleOfSafety",
		"slug": "circle-of-safety",
		"title": "Circle of Safety Support Network Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned support-network map for naming trusted people, safety-related help types, and practitioner review status.",
		"h1": "Circle of Safety",
		"intro": "Circle of Safety is a TF-CBT-aligned support-network mapping tool for practitioners working with children who need to know who can provide protection, support, or help. It helps name specific trusted people, connect each person to kinds of help, and review appropriateness for safety-related needs.",
		"demoTitle": "Explore the sample support circle",
		"demoPrompt": "Interested in using Circle of Safety with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0294-f-010-tfcbt-020-r001-circle-of-safety.md",
		"specId": "0294-f-010-tfcbt-020-r001-circle-of-safety",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures specific support people, the kinds of safety-related help each person may provide, practitioner review status, unresolved concerns, and update history."
			},
			{
				"title": "Repeat Use",
				"body": "The network can be revisited as safety planning changes, with people added, removed, or marked unresolved."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not guarantee safety, import contact data, assign trust scores, or function as an emergency dispatch tool."
			}
		],
		"faqItems": [
			{
				"question": "Does the child need to add phone contacts?",
				"answer": "No. The tool avoids importing or managing unrelated contact information."
			},
			{
				"question": "Can vague entries be saved?",
				"answer": "Yes. Vague entries can remain draft or incomplete until clarified into specific support people where possible."
			},
			{
				"question": "Does the map guarantee that a person will provide safety?",
				"answer": "No. The result shows a support network and review status; it does not make safety guarantees."
			},
			{
				"question": "Are there configurable settings?",
				"answer": "No. The tool has no substantive settings, but the fixed tool itself is still saved to the practitioner's account."
			}
		]
	},
	{
		"toolType": "futureGoalsFabulousFuture",
		"slug": "future-goals-fabulous-future",
		"title": "Future Goals Fabulous Future Demo | Qwoach",
		"metaDescription": "Explore a TF-CBT-aligned future-orientation tool for capturing a child's own goals, priorities, strengths, and revisit history.",
		"h1": "Future Goals / Fabulous Future",
		"intro": "Future Goals / Fabulous Future is a TF-CBT-aligned future-orientation tool for practitioners helping children name personally meaningful future goals and developmental priorities. It helps preserve the child's own words, optional priorities, strengths or motivations, practitioner notes, and revisit history.",
		"demoTitle": "Explore the sample goals board",
		"demoPrompt": "Interested in using Future Goals / Fabulous Future with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0295-f-010-tfcbt-021-r001-future-goals-fabulous-future.md",
		"specId": "0295-f-010-tfcbt-021-r001-future-goals-fabulous-future",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when future orientation can support recovery, growth, strengths work, and discussion of life beyond trauma symptoms."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures goals in the child's own words, optional priority, practitioner notes, active or inactive status, and revisit history."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not a generic productivity system and does not score achievement, prognosis, or the clinical meaning of goals."
			}
		],
		"faqItems": [
			{
				"question": "Does the child need to create action plans?",
				"answer": "No. Detailed action plans are not required unless the practitioner separately adds them."
			},
			{
				"question": "Can vague hopes be saved?",
				"answer": "Yes. Vague hopes can remain drafts and be clarified later."
			},
			{
				"question": "Does the tool interpret what a goal means clinically?",
				"answer": "No. Clinical interpretation appears only if the practitioner records it."
			},
			{
				"question": "Are there configurable settings?",
				"answer": "No. The tool has no substantive settings, but the fixed tool itself is still saved to the practitioner's account."
			}
		]
	},
	{
		"toolType": "tfCbtBriefPracticeChecklist",
		"slug": "tf-cbt-brief-practice-checklist",
		"title": "TF-CBT Brief Practice Checklist Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only TF-CBT component tracking tool for session coverage, progression, omissions, delays, and planning notes.",
		"h1": "TF-CBT Brief Practice Checklist",
		"intro": "TF-CBT Brief Practice Checklist is a practitioner-only treatment-process and fidelity tracking tool for clinicians delivering trauma-focused cognitive behavioral treatment across multiple sessions. It helps record component coverage, timing, omissions, delays, and planning notes in a longitudinal session-by-component view.",
		"demoTitle": "Review the sample checklist grid",
		"demoPrompt": "Interested in using TF-CBT Brief Practice Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0296-f-010-tfcbt-022-r001-tf-cbt-brief-practice-checklist.md",
		"specId": "0296-f-010-tfcbt-022-r001-tf-cbt-brief-practice-checklist",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Progress review",
				"Session preparation"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The tool is for practitioner process tracking and has no separate client-facing experience."
			},
			{
				"title": "What It Tracks",
				"body": "The checklist tracks sessions, predefined components, component coverage, unknown entries, descriptive gaps, edits, and practitioner planning notes."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not a client worksheet, outcome measure, full psychotherapy note, or automatic treatment-quality judgment."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client worksheet?",
				"answer": "No. It is a practitioner-only treatment-process and fidelity tracking tool."
			},
			{
				"question": "Does a missing session mean no components were delivered?",
				"answer": "No. Missing entries remain unknown and are distinguished from components marked not delivered or not recorded."
			},
			{
				"question": "Can the component set change?",
				"answer": "Only through a supported checklist configuration. Existing records should preserve the prior configuration for historical comparability."
			},
			{
				"question": "Does the tool judge treatment quality?",
				"answer": "No. It descriptively summarizes component coverage and progression unless the practitioner adds interpretation."
			}
		]
	},
	{
		"toolType": "careerConstructionInterviewCci",
		"slug": "career-construction-interview-cci",
		"title": "Career Construction Interview CCI Demo | Qwoach",
		"metaDescription": "Explore a CCI narrative interview tool for career counseling responses, theme marking, source-linked formulation, and dialogue points.",
		"h1": "Career Construction Interview (CCI)",
		"intro": "Career Construction Interview (CCI) is a defined narrative interview configuration for career counselors helping clients make sense of career direction through personal life themes. It helps capture narrative responses, organize sections, mark recurring themes, link themes to source responses, and prepare counseling dialogue.",
		"demoTitle": "Explore the CCI interview",
		"demoPrompt": "Interested in using Career Construction Interview (CCI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0297-f-100-cci-001-r001-career-construction-interview-cci.md",
		"specId": "0297-f-100-cci-001-r001-career-construction-interview-cci",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Narrative First",
				"body": "The tool captures the client's stories and preferences before formulation, keeping client responses separate from practitioner interpretation."
			},
			{
				"title": "Theme Grounding",
				"body": "Themes can be linked to source responses so the counselor can show how formulation is grounded in client material."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not a career-interest inventory, scoring assessment, personality test, or automated occupational recommendation system."
			}
		],
		"faqItems": [
			{
				"question": "Does CCI produce scores?",
				"answer": "No. The CCI tool organizes narrative responses and practitioner-confirmed themes rather than psychometric scores."
			},
			{
				"question": "Can the interview be incomplete?",
				"answer": "Yes. Partial interviews remain usable as incomplete narrative records with unanswered sections clearly marked."
			},
			{
				"question": "Does the system automatically decide themes?",
				"answer": "No. It may organize descriptive material, but final formulation requires practitioner confirmation."
			},
			{
				"question": "Can the client complete it with the practitioner?",
				"answer": "Yes. The tool supports live completion together or practitioner entry from an interview."
			}
		]
	},
	{
		"toolType": "openingCareerConcern",
		"slug": "opening-career-concern",
		"title": "Opening Career Concern Demo | Qwoach",
		"metaDescription": "Explore a CCI-aligned tool for clarifying a client's presenting career concern, desired help, current focus, and revisitable purpose.",
		"h1": "Opening Career Concern",
		"intro": "Opening Career Concern is a CCI-aligned counseling-purpose capture tool for career counselors beginning work with a client. It helps record the presenting career issue or transition, the client's desired help, a shared concern statement, practitioner notes, and revision history.",
		"demoTitle": "Draft a sample opening concern",
		"demoPrompt": "Interested in using Opening Career Concern with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0298-f-100-cci-002-r001-opening-career-concern.md",
		"specId": "0298-f-100-cci-002-r001-opening-career-concern",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Session preparation",
				"In-session support"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Opening Focus Only",
				"body": "The tool focuses on why the client is seeking help now and what they want counseling to clarify."
			},
			{
				"title": "Revisitable Purpose",
				"body": "The current concern and prior revisions can be reviewed later to check whether counseling remains focused on the relevant career construction need."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not a full intake, career history, assessment battery, career theme formulation, or advice engine."
			}
		],
		"faqItems": [
			{
				"question": "Is this a full career intake?",
				"answer": "No. It captures the opening career concern and desired help, not a complete work history or assessment battery."
			},
			{
				"question": "Can a vague concern be saved?",
				"answer": "Yes. A vague concern can be saved as a draft but should not be marked clear until refined."
			},
			{
				"question": "What happens if the client has multiple concerns?",
				"answer": "The practitioner can distinguish the current focus from additional concerns."
			},
			{
				"question": "Are there configurable settings?",
				"answer": "No. The tool has no substantive settings, but the fixed tool itself is still saved to the practitioner's account."
			}
		]
	},
	{
		"toolType": "roleModelThemes",
		"slug": "role-model-themes",
		"title": "Role Model Themes Career Counseling Demo | Qwoach",
		"metaDescription": "Explore a CCI-aligned tool for role-model stories, valued qualities, self-concept themes, source links, and formulation notes.",
		"h1": "Role Model Themes",
		"intro": "Role Model Themes is a CCI-aligned narrative career tool for career counselors working with clients who are exploring identity and life direction through admired figures. It helps capture role-model stories, valued qualities, source-linked themes, and practitioner formulation notes.",
		"demoTitle": "Explore sample role-model themes",
		"demoPrompt": "Interested in using Role Model Themes with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0299-f-100-cci-003-r001-role-model-themes.md",
		"specId": "0299-f-100-cci-003-r001-role-model-themes",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures admired figures, role-model stories, valued qualities, practitioner-confirmed themes, source-to-theme links, and formulation notes."
			},
			{
				"title": "Theme Grounding",
				"body": "The interface keeps role-model descriptions separate from practitioner formulation so themes remain tied to client stories."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not a personality assessment, values inventory, celebrity-preference survey, or occupational matching test."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool rank role models?",
				"answer": "No. It captures narrative material and practitioner-confirmed themes, not ratings or rankings."
			},
			{
				"question": "Can a role-model entry be incomplete?",
				"answer": "Yes. Incomplete entries can remain draft, but theme review needs at least a figure or description plus a reason or story."
			},
			{
				"question": "Does the system assign identity themes?",
				"answer": "No. Themes require practitioner confirmation and should link back to client stories."
			},
			{
				"question": "Are there configurable settings?",
				"answer": "No substantive settings are required unless a selected CCI configuration defines a required count."
			}
		]
	},
	{
		"toolType": "preferredEnvironmentsMediaThemes",
		"slug": "preferred-environments-media-themes",
		"title": "Preferred Environments Media Themes Demo | Qwoach",
		"metaDescription": "Explore a CCI-aligned career tool for mapping media or content preferences to environment, interest, audience, and problem themes.",
		"h1": "Preferred Environments / Media Themes",
		"intro": "Preferred Environments / Media Themes is a CCI-aligned narrative career tool for career counselors helping clients clarify work settings and interests through media or content preferences. It helps capture examples, reasons for attraction, recurring interests or settings, practitioner-confirmed themes, and comparison notes for career contexts.",
		"demoTitle": "Explore sample preference themes",
		"demoPrompt": "Interested in using Preferred Environments / Media Themes with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0300-f-100-cci-004-r001-preferred-environments-media-themes.md",
		"specId": "0300-f-100-cci-004-r001-preferred-environments-media-themes",
		"tags": {
			"framework": [],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures preference examples, reasons for attraction, recurring interests or settings, practitioner-confirmed themes, source links, and career-context comparison notes."
			},
			{
				"title": "Surface Likes And Fit Themes",
				"body": "Surface preferences are preserved as source material, while practitioner-confirmed themes are linked to reasons and examples."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not import browsing history, recommend media, generate occupational matches, calculate fit scores, or make personality conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool track browsing history?",
				"answer": "No. It captures preferences the client chooses to share; it does not import browsing data."
			},
			{
				"question": "Is a preference enough without a reason?",
				"answer": "No. A preference without a reason remains incomplete for theme review."
			},
			{
				"question": "Does the tool recommend careers?",
				"answer": "No. It supports counseling dialogue and comparison notes, not automatic occupational recommendations."
			},
			{
				"question": "Are categories required?",
				"answer": "No. Predefined categories are unnecessary unless supplied by the selected CCI configuration."
			}
		]
	},
	{
		"toolType": "favoriteStoryScript",
		"slug": "favorite-story-script",
		"title": "Favorite Story / Script Career Construction Tool | Qwoach",
		"metaDescription": "Capture a client's favorite book or movie story, story meaning, and practitioner theme notes for career construction narrative work.",
		"h1": "Favorite Story / Script",
		"intro": "Favorite Story / Script is a career construction narrative elicitation tool for career counseling practitioners. It helps practitioners capture a client's favorite book or movie story, the client's own meaning, and practitioner notes about career-relevant roles, conflicts, resolutions, or themes.",
		"demoTitle": "Try the demo with sample story material, then review the separated reported and interpreted layers.",
		"demoPrompt": "Interested in using Favorite Story / Script with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0301-f-100-cci-005-r001-favorite-story-script.md",
		"specId": "0301-f-100-cci-005-r001-favorite-story-script",
		"tags": {
			"framework": [
				"Career construction"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What it captures",
				"body": "The tool captures one selected favorite story, the client's personally meaningful description, practitioner-noted story elements, and practitioner interpretation connected to career construction work."
			},
			{
				"title": "Important boundary",
				"body": "The tool does not provide media analysis, standardized scores, diagnostic conclusions, interest labels, or predefined story meanings."
			},
			{
				"title": "Incomplete entries",
				"body": "A story title without client meaning can remain as incomplete reported material until enough discussion supports interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool interpret the client's favorite story automatically?",
				"answer": "No. The system organizes reported story material, but the career-relevant theme is practitioner-entered or practitioner-confirmed."
			},
			{
				"question": "Can the client complete this outside the session?",
				"answer": "Possibly. The supported experience may be guided in-session or assigned as a simple response surface, but exact prompt wording is unresolved."
			},
			{
				"question": "What happens if the client cannot name a story?",
				"answer": "The entry remains absent or unresolved rather than forcing a substitute."
			}
		]
	},
	{
		"toolType": "lifeMotto",
		"slug": "life-motto",
		"title": "Life Motto Career Construction Tool | Qwoach",
		"metaDescription": "Capture a client's meaningful motto, explanation, and practitioner self-guidance theme notes for career construction counseling.",
		"h1": "Life Motto",
		"intro": "Life Motto is a career construction narrative elicitation tool for career counseling practitioners. It helps practitioners record a client's favorite saying, motto, or guiding phrase, the client's explanation of its meaning, and practitioner notes about the self-guidance theme relevant to career choices.",
		"demoTitle": "Explore the sample motto entry and review how the tool keeps client wording separate from practitioner interpretation.",
		"demoPrompt": "Interested in using Life Motto with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0302-f-100-cci-006-r001-life-motto.md",
		"specId": "0302-f-100-cci-006-r001-life-motto",
		"tags": {
			"framework": [
				"Career construction"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What it captures",
				"body": "The tool captures the motto itself, the client's explanation, practitioner theme notes, and a connection to the current career concern when supported by discussion."
			},
			{
				"title": "What it does not do",
				"body": "It does not classify motto types, score values, judge the quality of advice, or infer hidden meaning from the phrase."
			},
			{
				"title": "Multiple mottos",
				"body": "If a client offers multiple mottos, the practitioner should create separate entries or select a primary motto rather than blending meanings."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide what a motto means?",
				"answer": "No. The system organizes the phrase and explanation; the self-guidance theme is practitioner-entered or practitioner-confirmed."
			},
			{
				"question": "Can a generic slogan still be useful?",
				"answer": "Yes, if the client's explanation is personally meaningful. The explanation may carry the usable material."
			},
			{
				"question": "What if the client gives only a phrase with no explanation?",
				"answer": "The entry can remain incomplete because interpretation is not sufficiently supported."
			}
		]
	},
	{
		"toolType": "earliestRecollections",
		"slug": "earliest-recollections",
		"title": "Earliest Recollections Career Construction Tool | Qwoach",
		"metaDescription": "Capture early recollection narratives, reported details, and practitioner theme notes for career construction counseling work.",
		"h1": "Earliest Recollections",
		"intro": "Earliest Recollections is a career construction autobiographical narrative elicitation tool for career counseling practitioners. It helps practitioners capture early remembered experiences, organize reported details, and add practitioner theme notes about core concerns or recurring life themes relevant to career work.",
		"demoTitle": "Explore sample recollections and review how reported memory details stay separate from practitioner interpretation.",
		"demoPrompt": "Interested in using Earliest Recollections with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0303-f-100-cci-007-r001-earliest-recollections.md",
		"specId": "0303-f-100-cci-007-r001-earliest-recollections",
		"tags": {
			"framework": [
				"Career construction"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Career counseling",
				"Clinical history"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Partial recall is supported",
				"body": "The tool allows uncertain, sparse, or unfinished recollections to remain incomplete rather than forcing interpretation."
			},
			{
				"title": "Multiple recollections",
				"body": "When multiple recollections are captured, the review supports comparison without requiring a fixed number or forcing one theme."
			},
			{
				"title": "Boundary",
				"body": "The tool does not make diagnostic classifications, infer childhood facts, or perform automated psychological interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool require a specific number of recollections?",
				"answer": "No. The supplied specification does not define a required number, so the demo supports one or more recollections without forcing a fixed count."
			},
			{
				"question": "Can the system identify the client's core concerns automatically?",
				"answer": "No. The system may organize details, but theme synthesis is practitioner-authored."
			},
			{
				"question": "What if the client cannot recall early material?",
				"answer": "The tool should allow no entry or an unresolved entry rather than substituting unsupported content."
			}
		]
	},
	{
		"toolType": "careerThemeFormulation",
		"slug": "career-theme-formulation",
		"title": "Career Theme Formulation Tool for Career Construction | Qwoach",
		"metaDescription": "Synthesize career construction narrative sources into practitioner-authored career theme, core concern, vocational plot, and next-session basis.",
		"h1": "Career Theme Formulation",
		"intro": "Career Theme Formulation is a practitioner-only career construction synthesis tool for career counseling practitioners. It helps practitioners integrate gathered narrative sources into a formulation of the client's career theme, core concerns, vocational plot, and basis for the next counseling intervention.",
		"demoTitle": "Review sample narrative sources, draft a formulation, and inspect the evidence links before saving the tool.",
		"demoPrompt": "Interested in using Career Theme Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0304-f-100-cci-008-r001-career-theme-formulation.md",
		"specId": "0304-f-100-cci-008-r001-career-theme-formulation",
		"tags": {
			"framework": [
				"Career construction"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-only workspace",
				"body": "The tool is designed for practitioner synthesis. Client narrative material may feed it, but the formulation workspace is not a client questionnaire."
			},
			{
				"title": "Traceability",
				"body": "Each formulation element should remain connected to the narrative evidence that supports it, including selected client phrases where relevant."
			},
			{
				"title": "Draft states",
				"body": "A formulation can remain draft when source material is limited, conflicting, or not yet integrated into a central theme."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool generate the career theme for the practitioner?",
				"answer": "No. The tool organizes sources and trace links, but the interpretive formulation is practitioner-authored."
			},
			{
				"question": "Can it be used with only one source?",
				"answer": "Yes, but the result should indicate limited integration rather than implying cross-source synthesis."
			},
			{
				"question": "Is there a client-facing version?",
				"answer": "No. This product configuration is explicitly practitioner-only."
			}
		]
	},
	{
		"toolType": "lifePortraitNarrativeRetelling",
		"slug": "life-portrait-narrative-retelling",
		"title": "Life Portrait Narrative Retelling Tool | Qwoach",
		"metaDescription": "Create a co-constructed life-career narrative from prior story material with source links, career theme, and client fit review.",
		"h1": "Life Portrait / Narrative Retelling",
		"intro": "Life Portrait / Narrative Retelling is a career construction narrative synthesis tool for career counseling practitioners and clients working together. It helps practitioners use prior story material to draft a recognizable life-career narrative, highlight a career theme, and frame a possible next occupational chapter.",
		"demoTitle": "Select sample story sources, review the draft retelling, and try the client fit-check before saving.",
		"demoPrompt": "Interested in using Life Portrait / Narrative Retelling with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0305-f-100-cci-009-r001-life-portrait-narrative-retelling.md",
		"specId": "0305-f-100-cci-009-r001-life-portrait-narrative-retelling",
		"tags": {
			"framework": [
				"Career construction"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it after personal story material and, where available, a career theme formulation already exist."
			},
			{
				"title": "Client role",
				"body": "The client reviews the retelling for fit, corrects what does not match lived experience, and helps refine the possible next chapter."
			},
			{
				"title": "Draft and shared states",
				"body": "A retelling can remain draft until client recognition is sufficient to guide next-step discussion."
			},
			{
				"title": "Boundary",
				"body": "The tool does not fabricate biography, write generic motivational copy, score the client, or make unsupported career recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write a biography from scratch?",
				"answer": "No. It uses prior story material and source links to support a career construction retelling."
			},
			{
				"question": "What happens if the client does not recognize the retelling?",
				"answer": "The retelling remains draft and should be revised or returned to source material."
			},
			{
				"question": "What is configurable before saving?",
				"answer": "The practitioner can configure source inclusion, which changes the narrative scope and evidence base."
			}
		]
	},
	{
		"toolType": "futureCareerScenarioPlan",
		"slug": "future-career-scenario-plan",
		"title": "Future Career Scenario Plan for Career Construction | Qwoach",
		"metaDescription": "Turn clarified career narrative meaning into a future scenario, theme linkage, feasibility notes, and concrete exploration or action steps.",
		"h1": "Future Career Scenario Plan",
		"intro": "Future Career Scenario Plan is a career construction planning tool for practitioners and clients working together. It helps them link clarified career themes or concerns to a personally meaningful future occupational scenario, feasibility notes, and concrete exploration or action steps.",
		"demoTitle": "Use the sample theme to build a scenario, add next steps, and review the shared plan before saving.",
		"demoPrompt": "Interested in using Future Career Scenario Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0306-f-100-cci-010-r001-future-career-scenario-plan.md",
		"specId": "0306-f-100-cci-010-r001-future-career-scenario-plan",
		"tags": {
			"framework": [
				"Career construction"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Career counseling",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it after career narrative meaning has been clarified, not before there is a supported theme or concern to link the scenario to."
			},
			{
				"title": "What it captures",
				"body": "The plan captures source theme linkage, a future scenario, feasibility/context notes, concrete exploration or action steps, and coaching notes."
			},
			{
				"title": "Review over time",
				"body": "Historical plans remain useful for seeing how career movement evolved from narrative insight."
			},
			{
				"title": "Boundary",
				"body": "The tool does not rank occupations, predict labor market fit, or become a general task-management workflow."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool recommend the right career path?",
				"answer": "No. It helps practitioner and client document a scenario and steps that follow from clarified narrative meaning."
			},
			{
				"question": "What if the client cannot see how the scenario fits?",
				"answer": "The scenario should return to co-construction rather than being marked agreed."
			},
			{
				"question": "Can a plan be saved without completed steps?",
				"answer": "Yes. A draft scenario may exist without steps, and unclear feasibility should remain unresolved."
			}
		]
	},
	{
		"toolType": "baselineHrvRespirationAssessment",
		"slug": "baseline-hrv-respiration-assessment",
		"title": "Baseline HRV Respiration Assessment Tool | Qwoach",
		"metaDescription": "Measure and summarize resting HRV, heart rate, respiration pattern, signal quality, and comparison readiness before HRV biofeedback training.",
		"h1": "Baseline HRV / Respiration Assessment",
		"intro": "Baseline HRV / Respiration Assessment is a practitioner-only psychophysiological baseline assessment tool for HRV biofeedback practitioners. It helps practitioners measure and summarize a client's resting heart-rate variability, heart rate, and respiration pattern before setting training targets or comparing later sessions.",
		"demoTitle": "Review sample baseline data, switch measurement inputs, and inspect comparison readiness before saving.",
		"demoPrompt": "Interested in using Baseline HRV / Respiration Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0307-f-101-hrvb-001-r001-baseline-hrv-respiration-assessment.md",
		"specId": "0307-f-101-hrvb-001-r001-baseline-hrv-respiration-assessment",
		"tags": {
			"framework": [
				"HRV biofeedback"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Physiological self-regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Measurement inputs",
				"body": "The tool supports HR/HRV capture or import and respiration capture when available. Respiration is optional in the configuration because availability may vary."
			},
			{
				"title": "Reliability states",
				"body": "Poor signal, interruption, dropout, or unstable measurement should mark the baseline partial or not comparison-ready."
			},
			{
				"title": "Repeat assessment",
				"body": "Repeated baselines create new attempts rather than overwriting earlier records, so the current comparison reference remains traceable."
			},
			{
				"title": "Boundary",
				"body": "The tool does not diagnose health conditions, prescribe treatment, or collect broad medical history beyond training relevance."
			}
		],
		"faqItems": [
			{
				"question": "Does the baseline assessment diagnose physiological problems?",
				"answer": "No. It summarizes training-relevant baseline signals and comparison readiness without diagnostic conclusions."
			},
			{
				"question": "Is respiration required?",
				"answer": "No. The tool can support HR/HRV only, with respiration summarized when capture is available."
			},
			{
				"question": "What happens with poor signal quality?",
				"answer": "The baseline should be marked unreliable or partial rather than treated as comparison-ready."
			}
		]
	},
	{
		"toolType": "resonanceFrequencyAssessment",
		"slug": "resonance-frequency-assessment",
		"title": "Resonance Frequency Assessment for HRV Biofeedback | Qwoach",
		"metaDescription": "Compare physiological responses across breathing rates to select an individualized resonance breathing target for HRV biofeedback training.",
		"h1": "Resonance Frequency Assessment",
		"intro": "Resonance Frequency Assessment is a practitioner-only HRV biofeedback assessment tool. It helps practitioners guide paced-breathing trials at several candidate rates, compare physiological response data, note tolerability, and confirm an individualized resonance breathing rate for training.",
		"demoTitle": "Run through sample candidate rates, mark trial validity, and review the selected target evidence before saving.",
		"demoPrompt": "Interested in using Resonance Frequency Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0308-f-101-hrvb-002-r001-resonance-frequency-assessment.md",
		"specId": "0308-f-101-hrvb-002-r001-resonance-frequency-assessment",
		"tags": {
			"framework": [
				"HRV biofeedback"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Physiological self-regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What it compares",
				"body": "The tool compares physiological response summaries across several candidate breathing rates, with signal quality and tolerability visible for each trial."
			},
			{
				"title": "Trial validity",
				"body": "Poor-quality, interrupted, or intolerable trials can be marked invalid or repeated so they do not falsely support a target."
			},
			{
				"title": "Uncertainty",
				"body": "If nearby alternatives are similar, the result should show uncertainty or need for fine-tuning rather than overstating precision."
			},
			{
				"title": "Boundary",
				"body": "The tool does not run ongoing training sessions or provide a home-practice plan beyond carrying forward the selected target."
			}
		],
		"faqItems": [
			{
				"question": "Does the system select the resonance rate automatically?",
				"answer": "No. The system displays comparison evidence, and the practitioner confirms the selected target."
			},
			{
				"question": "What if not enough breathing rates are tested?",
				"answer": "The assessment remains incomplete because there is no defensible comparison basis."
			},
			{
				"question": "Can a client use this independently?",
				"answer": "No independent client experience is required; the client participates in practitioner-led paced trials."
			}
		]
	},
	{
		"toolType": "resonanceFrequencyProfile",
		"slug": "resonance-frequency-profile",
		"title": "Resonance Frequency Profile for HRV Biofeedback | Qwoach",
		"metaDescription": "Document the selected resonance breathing target with tested rate comparisons, practitioner rationale, uncertainty, and training-plan connection.",
		"h1": "Resonance Frequency Profile",
		"intro": "Resonance Frequency Profile is a practitioner-only HRV biofeedback rationale tool. It helps practitioners compare already-tested candidate breathing rates, confirm the selected resonance frequency, document the explicit rationale, and connect the target to the training plan.",
		"demoTitle": "Review sample tested-rate data, choose a target, and inspect the rationale profile before saving.",
		"demoPrompt": "Interested in using Resonance Frequency Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0309-f-101-hrvb-003-r001-resonance-frequency-profile.md",
		"specId": "0309-f-101-hrvb-003-r001-resonance-frequency-profile",
		"tags": {
			"framework": [
				"HRV biofeedback"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"Intervention planning",
				"Clinical documentation"
			],
			"topic": [
				"Physiological self-regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Post-assessment scope",
				"body": "This tool documents rationale after rate testing. It does not run the full resonance frequency assessment or pace breathing trials."
			},
			{
				"title": "Evidence basis",
				"body": "The selected rate should be part of the tested candidate set, with response data and notes available for review."
			},
			{
				"title": "History",
				"body": "Historical profiles should remain reviewable so later target adjustments can be understood over time."
			},
			{
				"title": "Boundary",
				"body": "The profile does not diagnose health status or present system-selected rationale as practitioner judgment."
			}
		],
		"faqItems": [
			{
				"question": "Can this profile be completed without candidate-rate data?",
				"answer": "No. Without tested candidate-rate data, the profile has no supported basis."
			},
			{
				"question": "Who writes the rationale?",
				"answer": "The practitioner writes or confirms the rationale; the system may organize comparison evidence."
			},
			{
				"question": "What if the selected rate was not tested?",
				"answer": "It should be marked unsupported or require an explicit practitioner note rather than appearing fully evidenced."
			}
		]
	},
	{
		"toolType": "hrvBiofeedbackTrainingSession",
		"slug": "hrv-biofeedback-training-session",
		"title": "HRV Biofeedback Training Session Tool | Qwoach",
		"metaDescription": "Guide HRV biofeedback practice with an individualized target, live physiological feedback, signal quality, coaching notes, and session summary.",
		"h1": "HRV Biofeedback Training Session",
		"intro": "HRV Biofeedback Training Session is a guided HRV biofeedback training tool for practitioners and clients working together. It helps practitioners use an individualized target, live heart-rate/HRV and respiration feedback where available, and session data to coach the client toward the intended physiological response.",
		"demoTitle": "Explore sample live feedback, switch display modes, pause the session, and review the session summary before saving.",
		"demoPrompt": "Interested in using HRV Biofeedback Training Session with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0310-f-101-hrvb-004-r001-hrv-biofeedback-training-session.md",
		"specId": "0310-f-101-hrvb-004-r001-hrv-biofeedback-training-session",
		"tags": {
			"framework": [
				"HRV biofeedback"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Physiological self-regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner and client roles",
				"body": "The practitioner sets the target and coaches the session. The client follows the pacer, practices, and may view simplified feedback."
			},
			{
				"title": "Partial sessions",
				"body": "Interrupted sessions retain usable segments and clearly indicate pauses or invalid signal periods."
			},
			{
				"title": "Respiration availability",
				"body": "If respiration is unavailable, HRV and heart-rate feedback can still be shown while respiration alignment remains unresolved."
			},
			{
				"title": "Boundary",
				"body": "The tool does not establish baseline, determine resonance frequency, diagnose physiology, or replace practitioner judgment about coaching adjustments."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool choose the client's training target?",
				"answer": "No. The session uses an individualized target selected or confirmed before training."
			},
			{
				"question": "Can the client use the session view independently?",
				"answer": "The supported configuration is practitioner-led; the client may see a simplified pacer and feedback display during the session."
			},
			{
				"question": "What happens if signal quality is poor?",
				"answer": "Poor signal quality should visibly limit interpretation and be reflected in the session summary."
			},
			{
				"question": "What if the target is not tolerable?",
				"answer": "The practitioner can pause, adjust coaching, or stop the session without marking success."
			}
		]
	},
	{
		"toolType": "homePracticePlan",
		"slug": "home-practice-plan",
		"title": "Home Practice Plan for HRV Biofeedback | Qwoach",
		"metaDescription": "Create an HRV biofeedback home practice plan with target breathing, dose, context notes, and returned adherence information for review.",
		"h1": "Home Practice Plan for HRV Biofeedback",
		"intro": "Home Practice Plan is a ready-to-send HRV biofeedback tool for practitioners who need to turn supervised training parameters into a feasible between-session routine. It helps the practitioner specify target breathing, practice dose, context considerations, and the adherence or symptom/context notes the client should return.",
		"demoTitle": "Compose a sample plan and preview the client view.",
		"demoPrompt": "Interested in using Home Practice Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0311-f-101-hrvb-005-r001-home-practice-plan.md",
		"specId": "0311-f-101-hrvb-005-r001-home-practice-plan",
		"tags": {
			"framework": [
				"HRV biofeedback"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Physiological self-regulation",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after supervised HRVB training has established an individualized target breathing parameter and the client needs a feasible between-session routine."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures the target breathing reference, intended training dose, relevant context or symptom considerations, and adherence/context notes returned by the client."
			},
			{
				"title": "Version-Aware Review",
				"body": "If the practitioner changes the plan, prior versions and their returned notes should remain distinct so later review does not mix different routines."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool choose the client's breathing target?",
				"answer": "No. The practitioner supplies the individualized target breathing parameter from the client's HRVB training work."
			},
			{
				"question": "Does the client edit the practice dose?",
				"answer": "No. The client can view the assigned dose and return adherence or symptom/context notes, but the practitioner controls the target and dose."
			},
			{
				"question": "Does the tool interpret symptom notes?",
				"answer": "No. Symptom and context notes are preserved as reported information for practitioner review."
			},
			{
				"question": "What happens if the target breathing field is missing?",
				"answer": "The plan is incomplete and should not be treated as ready to send."
			}
		]
	},
	{
		"toolType": "homePracticeLog",
		"slug": "home-practice-log",
		"title": "Home Practice Log for HRV Biofeedback | Qwoach",
		"metaDescription": "Track HRV biofeedback home practice frequency, duration, gaps, and symptom/context notes over time for practitioner review.",
		"h1": "Home Practice Log for HRV Biofeedback",
		"intro": "Home Practice Log is a ready-to-send HRV biofeedback logging tool for practitioners who need longitudinal evidence of between-session practice dose, conditions, and response. It helps the practitioner see practice frequency, duration, gaps, and symptom/context notes across a selected review window.",
		"demoTitle": "Open the sample log and review the pattern.",
		"demoPrompt": "Interested in using Home Practice Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0312-f-101-hrvb-006-r001-home-practice-log.md",
		"specId": "0312-f-101-hrvb-006-r001-home-practice-log",
		"tags": {
			"framework": [
				"HRV biofeedback"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Physiological self-regulation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The log captures repeated practice occurrence, duration or equivalent dose information, and symptom/context notes tied to dated entries."
			},
			{
				"title": "Why Repeated Entries Matter",
				"body": "The review emphasizes patterns across time. A single entry should be marked insufficient for pattern review."
			},
			{
				"title": "Partial And Missing Data",
				"body": "Partial entries and gaps remain visible because missingness affects whether the pattern can support later adjustment."
			}
		],
		"faqItems": [
			{
				"question": "Does this log measure HRV directly?",
				"answer": "No. The specified tool logs home practice dose, conditions, and response notes; it does not create an HRV measurement graph."
			},
			{
				"question": "Can a partial entry be saved?",
				"answer": "Yes. Partial entries should persist as partial rather than being discarded or completed by the system."
			},
			{
				"question": "Does the tool decide whether to adjust training?",
				"answer": "No. It presents longitudinal adherence, dose, gaps, and notes for practitioner judgment."
			},
			{
				"question": "What if duration is missing?",
				"answer": "Missing duration prevents dose estimation for that entry, but occurrence data can still remain visible."
			}
		]
	},
	{
		"toolType": "sessionHrvProgressGraph",
		"slug": "session-hrv-progress-graph",
		"title": "Session HRV Progress Graph for HRVB Review | Qwoach",
		"metaDescription": "Graph comparable HRV biofeedback session measures over time with baseline or target context for practitioner review and next-step decisions.",
		"h1": "Session HRV Progress Graph",
		"intro": "Session HRV Progress Graph is a practitioner-only HRV biofeedback review tool for clinicians who need to turn repeated session measures into a longitudinal progress view. It helps the practitioner inspect comparable HRV measures across sessions with optional baseline or target references.",
		"demoTitle": "Explore the sample progress graph.",
		"demoPrompt": "Interested in using Session HRV Progress Graph with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0313-f-101-hrvb-007-r001-session-hrv-progress-graph.md",
		"specId": "0313-f-101-hrvb-007-r001-session-hrv-progress-graph",
		"tags": {
			"framework": [
				"HRV biofeedback"
			],
			"toolType": [
				"Graph"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Physiological self-regulation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Comparable Measures Only",
				"body": "The graph should plot one comparable HRV measure across sessions. Non-comparable measures should not be merged into a single trend."
			},
			{
				"title": "Reference Context",
				"body": "Baseline or target overlays are shown only when supplied and should remain explicit so the practitioner can interpret the trend."
			},
			{
				"title": "Insufficient Data",
				"body": "Fewer than two comparable sessions should be marked insufficient for trend review."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client-facing version of this graph?",
				"answer": "No. The specified configuration is practitioner-only."
			},
			{
				"question": "Does the graph decide whether the protocol is working?",
				"answer": "No. It shows measured values, descriptive trend information, and reference context for practitioner interpretation."
			},
			{
				"question": "Can different HRV measures be combined into one trend?",
				"answer": "No. Measures must be comparable before they are plotted as one longitudinal trend."
			},
			{
				"question": "What happens when a session value is missing?",
				"answer": "Missing values should appear as gaps rather than being filled or inferred."
			}
		]
	},
	{
		"toolType": "hrvbProtocolChecklist",
		"slug": "hrvb-protocol-checklist",
		"title": "HRVB Protocol Checklist for Fidelity Review | Qwoach",
		"metaDescription": "Specify HRV biofeedback protocol parameters, track delivery conditions, and flag departures for practitioner fidelity and replication review.",
		"h1": "HRVB Protocol Checklist",
		"intro": "HRVB Protocol Checklist is a practitioner-only HRV biofeedback fidelity tool for practitioners who need protocol delivery to be specified and tracked consistently. It helps make intended protocol parameters, session or training conditions, and departures explicit enough to support later review.",
		"demoTitle": "Open the sample checklist.",
		"demoPrompt": "Interested in using HRVB Protocol Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0314-f-101-hrvb-008-r001-hrvb-protocol-checklist.md",
		"specId": "0314-f-101-hrvb-008-r001-hrvb-protocol-checklist",
		"tags": {
			"framework": [
				"HRV biofeedback"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Intended Versus Delivered",
				"body": "The checklist should keep intended protocol definition separate from delivered conditions so departures remain visible."
			},
			{
				"title": "Unresolved Checklist Content",
				"body": "The product supports categories for parameters, conditions, and departures, but exact item wording must be supplied by the implementing clinical or research program."
			},
			{
				"title": "Protocol Changes",
				"body": "Intentional protocol changes should create a new defined state or version marker rather than rewriting prior fidelity history."
			}
		],
		"faqItems": [
			{
				"question": "Does this checklist include a fixed HRVB protocol?",
				"answer": "No. The specification supports checklist categories, but exact HRVB checklist item content is unresolved unless supplied by the implementing program."
			},
			{
				"question": "Is this a client-facing tool?",
				"answer": "No. HRVB Protocol Checklist is practitioner-only."
			},
			{
				"question": "Do departures overwrite the intended protocol?",
				"answer": "No. Departures should remain visible as deviations from the intended protocol."
			},
			{
				"question": "Does the checklist interpret client outcomes?",
				"answer": "No. It records fidelity information that a practitioner can use when interpreting outcomes or replication."
			}
		]
	},
	{
		"toolType": "pretreatmentClinicalAssessment",
		"slug": "pretreatment-clinical-assessment",
		"title": "Pretreatment Clinical Assessment for Neurofeedback | Qwoach",
		"metaDescription": "Create a practitioner-only neurofeedback pretreatment profile with presenting concerns, baseline functioning, risks, constraints, and scope considerations.",
		"h1": "Pretreatment Clinical Assessment for Neurofeedback",
		"intro": "Pretreatment Clinical Assessment is a practitioner-only neurofeedback intake decision tool for clinicians considering treatment. It helps organize presenting problems, baseline functioning, relevant risks or constraints, and scope considerations before the practitioner decides whether and how to proceed.",
		"demoTitle": "Review the sample pretreatment profile.",
		"demoPrompt": "Interested in using Pretreatment Clinical Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0315-f-102-nf-001-r001-pretreatment-clinical-assessment.md",
		"specId": "0315-f-102-nf-001-r001-pretreatment-clinical-assessment",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Clinical history"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner Interpretation",
				"body": "The tool organizes pretreatment information and surfaces completeness or practitioner-entered concerns. It does not make diagnostic or treatment eligibility decisions."
			},
			{
				"title": "Baseline For Later Comparison",
				"body": "The preserved baseline profile can later support comparison with treatment response in separate outcome tools."
			},
			{
				"title": "Partial Profiles",
				"body": "Missing presenting problems or baseline functioning should keep the profile marked incomplete so the practitioner does not over-rely on unfinished information."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide whether neurofeedback is indicated?",
				"answer": "No. It organizes information that supports practitioner decision-making, but the practitioner remains responsible for interpretation."
			},
			{
				"question": "Is QEEG data part of this assessment?",
				"answer": "No. QEEG data are not part of this tool unless handled by a separate assessment tool."
			},
			{
				"question": "Can risks or constraints be flagged?",
				"answer": "Yes. Practitioner-entered risks or constraints can be surfaced in the review summary."
			},
			{
				"question": "Does the tool create a neurofeedback protocol?",
				"answer": "No. It is a pretreatment assessment profile, not a protocol generator."
			}
		]
	},
	{
		"toolType": "conners3rdEditionRatingScalesConners3",
		"slug": "conners-3rd-edition-rating-scales-conners-3",
		"title": "Conners 3 Rating Configuration for Neurofeedback | Qwoach",
		"metaDescription": "Assign Conners 3 parent, teacher, or youth rating forms by time point and review informant-specific ADHD profiles and change where scoring is available.",
		"h1": "Conners 3 Rating Configuration for Neurofeedback Outcomes",
		"intro": "Conners 3rd Edition Rating Scales (Conners 3) is a standardized multi-informant ADHD symptom and behavior rating configuration for practitioners evaluating neurofeedback. It helps assign parent, teacher, and when appropriate youth forms, track completion by time point, and review informant-specific profiles and baseline-to-follow-up change when valid scoring is available.",
		"demoTitle": "Explore the sample administration setup.",
		"demoPrompt": "Interested in using Conners 3rd Edition Rating Scales (Conners 3) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0316-f-102-nf-002-r001-conners-3rd-edition-rating-scales-conners-3.md",
		"specId": "0316-f-102-nf-002-r001-conners-3rd-edition-rating-scales-conners-3",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"ADHD",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Informants Stay Separate",
				"body": "Parent, teacher, and youth results should be reviewed separately. Missing informants remain visible as gaps."
			},
			{
				"title": "Scoring Availability",
				"body": "Scores and change values appear only when valid form and scoring rules are available. Otherwise the tool can track administration and completion status."
			},
			{
				"title": "Comparable Time Points",
				"body": "Baseline, mid-treatment, end-treatment, and follow-up comparisons require comparable forms and scoring paths."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include Conners 3 item text?",
				"answer": "No. Exact item text and form structure are unresolved unless supplied by the instrument source."
			},
			{
				"question": "Can the system score completed forms automatically?",
				"answer": "Only when valid scoring rules are available. Without them, the system may collect and route completion status but should not invent scores."
			},
			{
				"question": "Are parent and teacher results combined into one score?",
				"answer": "No. Informant-specific profiles remain separate unless a valid scoring rule supports a combined output."
			},
			{
				"question": "Does this tool diagnose ADHD?",
				"answer": "No. It supports rating administration and practitioner review; it does not create automated diagnostic determinations."
			}
		]
	},
	{
		"toolType": "adhdRatingScale5AdhdRs5",
		"slug": "adhd-rating-scale-5-adhd-rs-5",
		"title": "ADHD-RS-5 Rating Configuration for Neurofeedback | Qwoach",
		"metaDescription": "Assign ADHD-RS-5 home or school forms and review setting-specific symptom and impairment change from baseline to follow-up where scoring is available.",
		"h1": "ADHD-RS-5 Rating Configuration for Neurofeedback Outcomes",
		"intro": "ADHD Rating Scale-5 (ADHD-RS-5) is a brief DSM-5-linked parent and teacher rating configuration for practitioners evaluating ADHD-focused neurofeedback. It helps assign home or school forms, track completion, and review setting-specific symptom and impairment scores from baseline to follow-up when valid scoring is available.",
		"demoTitle": "Set up a sample ADHD-RS-5 administration.",
		"demoPrompt": "Interested in using ADHD Rating Scale-5 (ADHD-RS-5) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0317-f-102-nf-002-r002-adhd-rating-scale-5-adhd-rs-5.md",
		"specId": "0317-f-102-nf-002-r002-adhd-rating-scale-5-adhd-rs-5",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"ADHD",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Home And School Stay Distinct",
				"body": "Home and school results should not be merged into one vague score because setting differences are part of the tool's value."
			},
			{
				"title": "Symptoms And Impairment",
				"body": "The review should show symptom and impairment information where valid scoring supports both."
			},
			{
				"title": "Comparison Limits",
				"body": "Baseline without follow-up supports only a baseline profile, and follow-up without matching baseline should not produce change claims."
			}
		],
		"faqItems": [
			{
				"question": "Does ADHD-RS-5 include youth self-report in this configuration?",
				"answer": "No. The supplied configuration supports parent and teacher reports, not youth self-report."
			},
			{
				"question": "Can incomplete forms be scored?",
				"answer": "No. Incomplete forms should be saved as incomplete and should not produce complete score profiles."
			},
			{
				"question": "Are home and school scores combined?",
				"answer": "No. Home and school contexts remain separate unless a valid scoring rule supports a specific combined output."
			},
			{
				"question": "Does the tool diagnose ADHD?",
				"answer": "No. It supports rating collection, scoring when valid rules are available, and practitioner review."
			}
		]
	},
	{
		"toolType": "vanderbiltAdhdDiagnosticRatingScales",
		"slug": "vanderbilt-adhd-diagnostic-rating-scales",
		"title": "Vanderbilt ADHD Rating Configuration for Neurofeedback | Qwoach",
		"metaDescription": "Assign Vanderbilt parent or teacher assessment and follow-up forms and review symptom and performance changes across home and school contexts.",
		"h1": "Vanderbilt ADHD Rating Configuration for Neurofeedback Monitoring",
		"intro": "Vanderbilt ADHD Diagnostic Rating Scales is a parent and teacher rating configuration for practitioners monitoring ADHD-related neurofeedback effects. It helps assign assessment or follow-up forms, track completion, and review symptom and performance ratings across home and school contexts when valid scoring instructions are available.",
		"demoTitle": "Configure a sample Vanderbilt administration.",
		"demoPrompt": "Interested in using Vanderbilt ADHD Diagnostic Rating Scales with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0318-f-102-nf-002-r003-vanderbilt-adhd-diagnostic-rating-scales.md",
		"specId": "0318-f-102-nf-002-r003-vanderbilt-adhd-diagnostic-rating-scales",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"ADHD",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Parent And Teacher Views",
				"body": "Parent and teacher forms should remain separate. Missing teacher or parent data should be shown as missing, not inferred."
			},
			{
				"title": "Assessment And Follow-Up",
				"body": "Assessment and follow-up forms should be compared only when valid scoring rules support that comparison."
			},
			{
				"title": "Performance Items",
				"body": "The review should preserve performance or impairment indicators alongside symptom domains where supported by valid form content."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo reproduce Vanderbilt form items?",
				"answer": "No. Exact form items and scoring instructions are unresolved unless supplied by the instrument source."
			},
			{
				"question": "Can assessment and follow-up forms always be compared?",
				"answer": "No. They should be compared only when valid scoring rules support that comparison."
			},
			{
				"question": "Does missing teacher data count as no concern?",
				"answer": "No. Missing teacher data remains visible as missing and should not be inferred as negative or neutral."
			},
			{
				"question": "Does the tool diagnose ADHD?",
				"answer": "No. It supports rating administration, scoring when valid instructions are available, and practitioner review."
			}
		]
	},
	{
		"toolType": "rawEegQeegAssessment",
		"slug": "raw-eeg-qeeg-assessment",
		"title": "Raw EEG / QEEG Assessment for Neurofeedback | Qwoach",
		"metaDescription": "Organize raw EEG or QEEG outputs, clinical context, and practitioner-identified findings into a baseline profile for neurofeedback planning.",
		"h1": "Raw EEG / QEEG Assessment for Neurofeedback Planning",
		"intro": "Raw EEG / QEEG Assessment is a practitioner-only neurofeedback planning tool for clinicians who need measured EEG-based information before selecting training targets. It helps organize data sources, clinical context, practitioner-identified patterns or deviations, and baseline markers into an interpretable assessment profile.",
		"demoTitle": "Explore the sample assessment profile.",
		"demoPrompt": "Interested in using Raw EEG / QEEG Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0319-f-102-nf-003-r001-raw-eeg-qeeg-assessment.md",
		"specId": "0319-f-102-nf-003-r001-raw-eeg-qeeg-assessment",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Measured Data Versus Interpretation",
				"body": "The tool should keep measured EEG/QEEG data, descriptive summaries, and practitioner interpretation separate."
			},
			{
				"title": "Baseline Value",
				"body": "A designated baseline assessment persists for later neurophysiological comparison when future assessments are available."
			},
			{
				"title": "Readiness Limits",
				"body": "Poor-quality data, missing context, or non-comparable reassessment conditions should be marked as limiting interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool acquire EEG data?",
				"answer": "No. It organizes EEG/QEEG assessment outputs and practitioner context; exact acquisition workflow is outside the specified product."
			},
			{
				"question": "Does it recommend neurofeedback targets?",
				"answer": "No. Training targets are not generated automatically and should only be practitioner-entered or handled in a separate protocol definition tool."
			},
			{
				"question": "Can raw EEG and QEEG outputs be treated as the same evidence type?",
				"answer": "No. Raw EEG and QEEG outputs should not be conflated when they represent different evidence types."
			},
			{
				"question": "Does the tool diagnose from QEEG data?",
				"answer": "No. It must not generate unsupported diagnostic labels or conclusions."
			}
		]
	},
	{
		"toolType": "neurofeedbackProtocolDefinition",
		"slug": "neurofeedback-protocol-definition",
		"title": "Neurofeedback Protocol Definition Tool | Qwoach",
		"metaDescription": "Define neurofeedback training targets, parameters, setup choices, rationale links, and session conditions for reproducible practitioner delivery.",
		"h1": "Neurofeedback Protocol Definition Tool",
		"intro": "Neurofeedback Protocol Definition is a practitioner-only configuration tool for clinicians who need explicit training parameters before delivery. It helps capture practitioner-selected targets, key parameters, setup choices, assessment rationale, and repeated-session conditions so the protocol can guide consistent sessions and later review.",
		"demoTitle": "Build a sample protocol definition.",
		"demoPrompt": "Interested in using Neurofeedback Protocol Definition with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0320-f-102-nf-004-r001-neurofeedback-protocol-definition.md",
		"specId": "0320-f-102-nf-004-r001-neurofeedback-protocol-definition",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Clinical documentation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Entered Content",
				"body": "The tool captures protocol content supplied by the practitioner. It should not invent neurofeedback targets, parameters, or setup options."
			},
			{
				"title": "Session-Ready Status",
				"body": "Missing targets or key parameters keep the protocol from being treated as session-ready."
			},
			{
				"title": "Historical Changes",
				"body": "Protocol changes should create a new current definition or version marker so later fidelity and outcome review can distinguish materially different protocols."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool recommend neurofeedback targets?",
				"answer": "No. Targets and protocol content are practitioner-entered, not automatically recommended."
			},
			{
				"question": "Is this a session progress tracker?",
				"answer": "No. It defines the protocol before delivery; progress tracking would be a separate tool."
			},
			{
				"question": "What makes a protocol not session-ready?",
				"answer": "Missing targets or key parameters should prevent the protocol from being treated as session-ready."
			},
			{
				"question": "What happens when the protocol changes?",
				"answer": "A change should create a new current definition or version marker rather than rewriting history."
			}
		]
	},
	{
		"toolType": "trainingSessionRecord",
		"slug": "training-session-record",
		"title": "Training Session Record for Neurofeedback | Qwoach",
		"metaDescription": "Track comparable neurofeedback session metrics over time so practitioners can review training trajectory, missing values, and session notes.",
		"h1": "Training Session Record",
		"intro": "Training Session Record is a practitioner-only neurofeedback record for clinicians and applied neurofeedback providers. It helps practitioners preserve repeated performance/session metrics, compare sessions in order, and review whether the recorded trajectory is improving, stable, or deteriorating.",
		"demoTitle": "Set up sample metrics and review a demo training history.",
		"demoPrompt": "Interested in using Training Session Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0321-f-102-nf-005-r001-training-session-record.md",
		"specId": "0321-f-102-nf-005-r001-training-session-record",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review",
				"Clinical documentation"
			],
			"topic": [
				"Physiological self-regulation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during a course of repeated neurofeedback training when the practitioner needs session-level metrics to remain comparable over time."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not define protocol-specific metrics, produce diagnostic conclusions, create normative scoring, or recommend protocol changes automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool require client input?",
				"answer": "No. Training Session Record is practitioner-only and uses session metrics available to the practitioner or training system."
			},
			{
				"question": "Can the practitioner choose which metrics to track?",
				"answer": "Yes. The supported setting is the comparable session-level metric configuration for the record."
			},
			{
				"question": "What happens if the metric set changes during training?",
				"answer": "The change should be marked because it can limit historical comparability from that point forward."
			}
		]
	},
	{
		"toolType": "neurofeedbackSuccessRate",
		"slug": "neurofeedback-success-rate",
		"title": "Neurofeedback Success Rate Calculator | Qwoach",
		"metaDescription": "Classify neurofeedback attempts against a predefined criterion and review success rates by session, run, condition, or target level.",
		"h1": "Neurofeedback Success Rate",
		"intro": "Neurofeedback Success Rate is a performance metric tool for neurofeedback clinicians, researchers, and applied psychophysiology practitioners. It helps them classify trials, blocks, or runs against a predefined regulation criterion and review the percentage or ratio of successful attempts within and across training periods.",
		"demoTitle": "Configure a sample criterion and review calculated success rates.",
		"demoPrompt": "Interested in using Neurofeedback Success Rate with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0322-f-102-nf-006-r001-neurofeedback-success-rate.md",
		"specId": "0322-f-102-nf-006-r001-neurofeedback-success-rate",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Physiological self-regulation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures attempt-level classification metadata and aggregate success rates, with enough detail to reproduce the result."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not create thresholds, explain performance, diagnose, or infer clinical meaning. Labels appear only when the practitioner supplies a cutoff."
			}
		],
		"faqItems": [
			{
				"question": "What is the denominator?",
				"answer": "The denominator is the set of trials, blocks, or runs included under the selected grouping and scope."
			},
			{
				"question": "Can it classify learners and non-learners?",
				"answer": "Yes, only when the practitioner supplies an adequate-performance or learner/non-learner cutoff."
			},
			{
				"question": "Can different criteria be compared in one graph?",
				"answer": "Mixed criteria should be blocked or visually separated because they change the meaning of the success rate."
			}
		]
	},
	{
		"toolType": "neurofeedbackLearningIndexLi",
		"slug": "neurofeedback-learning-index-li",
		"title": "Neurofeedback Learning Index Tool | Qwoach",
		"metaDescription": "Quantify neurofeedback learning over ordered training periods with a transparent index, slope, graph, and optional rule-based responder label.",
		"h1": "Neurofeedback Learning Index (LI)",
		"intro": "Neurofeedback Learning Index (LI) is a longitudinal analysis tool for neurofeedback researchers and clinicians. It helps them calculate a transparent index, slope, or change estimate from ordered training values so they can review direction and magnitude of regulation learning.",
		"demoTitle": "Choose sample periods and inspect a learning-index review.",
		"demoPrompt": "Interested in using Neurofeedback Learning Index (LI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0323-f-102-nf-006-r002-neurofeedback-learning-index-li.md",
		"specId": "0323-f-102-nf-006-r002-neurofeedback-learning-index-li",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Physiological self-regulation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for between-run, between-session, within-session, or full-course learning review when ordered training values are available."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent formula variants, responder cutoffs, or explanations for why learning did or did not occur."
			}
		],
		"faqItems": [
			{
				"question": "Is this a single-session score?",
				"answer": "No. Neurofeedback Learning Index represents change over ordered training periods."
			},
			{
				"question": "Can it show responder or nonresponder status?",
				"answer": "Yes, only when an explicit responder rule is supplied before the classification is shown."
			},
			{
				"question": "What happens if there are too few periods?",
				"answer": "The tool should show insufficient data for the selected calculation rather than infer a slope."
			}
		]
	},
	{
		"toolType": "neurofeedbackTransferSuccess",
		"slug": "neurofeedback-transfer-success",
		"title": "Neurofeedback Transfer Success Tool | Qwoach",
		"metaDescription": "Assess no-feedback neurofeedback transfer by comparing target signal change against a defined baseline, control, rest, or pre-training value.",
		"h1": "Neurofeedback Transfer Success",
		"intro": "Neurofeedback Transfer Success is an assessment tool for rt-fMRI or EEG neurofeedback clinician-researchers. It helps them compare no-feedback transfer-run performance against a defined reference value and review whether the target signal changed in the intended direction.",
		"demoTitle": "Set up a sample transfer comparison.",
		"demoPrompt": "Interested in using Neurofeedback Transfer Success with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0324-f-102-nf-006-r003-neurofeedback-transfer-success.md",
		"specId": "0324-f-102-nf-006-r003-neurofeedback-transfer-success",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Physiological self-regulation",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What Counts as Transfer",
				"body": "Transfer means the run or task occurred without active feedback. If feedback was present, the run should not be treated as a transfer condition."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not claim broader everyday functioning or treatment effectiveness. It reviews performance under the defined transfer condition."
			}
		],
		"faqItems": [
			{
				"question": "Does transfer success require no active feedback?",
				"answer": "Yes. The assessment depends on a no-feedback transfer condition."
			},
			{
				"question": "Can it produce a binary success result?",
				"answer": "Yes, only when the practitioner or protocol supplies a binary success criterion."
			},
			{
				"question": "What if the comparison value is missing?",
				"answer": "Comparison-dependent results should be blocked or shown as incomplete when the required reference value is missing."
			}
		]
	},
	{
		"toolType": "transferExercisePlan",
		"slug": "transfer-exercise-plan",
		"title": "Neurofeedback Transfer Exercise Plan | Qwoach",
		"metaDescription": "Create a practitioner-authored neurofeedback transfer plan with real-world contexts, client expectations, and adherence or response review.",
		"h1": "Transfer Exercise Plan",
		"intro": "Transfer Exercise Plan is a ready-to-send neurofeedback tool for practitioners and their clients. It helps practitioners define where and how a trained regulation skill should be tried in everyday contexts and review whether the client attempted it and what happened.",
		"demoTitle": "Create a sample transfer plan and preview the client check-in.",
		"demoPrompt": "Interested in using Transfer Exercise Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0325-f-102-nf-007-r001-transfer-exercise-plan.md",
		"specId": "0325-f-102-nf-007-r001-transfer-exercise-plan",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Physiological self-regulation",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner and Client Roles",
				"body": "The practitioner writes the plan and controls revisions. The client views the active plan and reports adherence or response when invited."
			},
			{
				"title": "Repeat Use",
				"body": "Plans can be revised over time, with prior contexts and expectations preserved historically so review remains clear."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool provide exercise steps?",
				"answer": "No. Exercise content is practitioner-authored because exact prompts and practice steps are not defined by the product record."
			},
			{
				"question": "Can the client report what happened?",
				"answer": "Yes. The client can report adherence and real-world response when the practitioner includes those fields."
			},
			{
				"question": "Does adherence prove transfer occurred?",
				"answer": "No. The tool organizes reported attempts and responses but does not interpret effectiveness or prove transfer."
			}
		]
	},
	{
		"toolType": "adverseEffectsSessionResponseLog",
		"slug": "adverse-effects-session-response-log",
		"title": "Neurofeedback Session Response Log | Qwoach",
		"metaDescription": "Capture neurofeedback adverse effects and session responses over repeated encounters with practitioner-defined fields and review status.",
		"h1": "Adverse Effects / Session Response Log",
		"intro": "Adverse Effects / Session Response Log is a ready-to-send monitoring tool for neurofeedback practitioners. It helps them collect client-reported adverse effects or notable session responses over time and review patterns relevant to training tolerance.",
		"demoTitle": "Configure a sample response log and preview review states.",
		"demoPrompt": "Interested in using Adverse Effects / Session Response Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0326-f-102-nf-008-r001-adverse-effects-session-response-log.md",
		"specId": "0326-f-102-nf-008-r001-adverse-effects-session-response-log",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Risk review"
			],
			"topic": [
				"Treatment tolerability"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures session-related adverse effects or notable responses, timing or severity details only when configured, and review status."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not make automatic safety determinations, triage decisions, or expected-versus-concerning labels unless the practitioner defines the review context."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool include a built-in adverse-effect checklist?",
				"answer": "No. Exact symptom lists and categories are not defined; response fields are practitioner-defined."
			},
			{
				"question": "Can a client report no concerns?",
				"answer": "Yes, when the practitioner configures a clear no-response or no-concern option."
			},
			{
				"question": "Does the system decide whether training should pause?",
				"answer": "No. The practitioner reviews the accumulated pattern and makes continuation, modification, pausing, or further-assessment decisions outside the product."
			}
		]
	},
	{
		"toolType": "neurofeedbackOutcomeReview",
		"slug": "neurofeedback-outcome-review",
		"title": "Neurofeedback Outcome Review Tool | Qwoach",
		"metaDescription": "Combine selected neurofeedback performance and outcome indicators over time with explicit criteria for practitioner treatment-course review.",
		"h1": "Neurofeedback Outcome Review",
		"intro": "Neurofeedback Outcome Review is a practitioner-facing synthesis tool for neurofeedback practitioners. It helps them combine selected training-performance and treatment-effect indicators over a review period and compare the profile against explicit efficacy or response criteria.",
		"demoTitle": "Build a sample outcome review profile.",
		"demoPrompt": "Interested in using Neurofeedback Outcome Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0327-f-102-nf-009-r001-neurofeedback-outcome-review.md",
		"specId": "0327-f-102-nf-009-r001-neurofeedback-outcome-review",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Outcome monitoring",
				"Physiological self-regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Brings Together",
				"body": "The review combines selected training-performance information and treatment-effect indicators without redefining the source measures."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not create efficacy criteria, issue treatment recommendations, or decide clinical justification automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool choose outcome indicators automatically?",
				"answer": "No. The practitioner selects the training-performance and treatment-effect indicators included in the review."
			},
			{
				"question": "Can it recommend continuing or discontinuing treatment?",
				"answer": "No. It supports practitioner review against supplied criteria, but the practitioner records the decision and rationale."
			},
			{
				"question": "What if indicators are missing?",
				"answer": "The review should show missing indicators and may remain provisional or not ready until required information is available."
			}
		]
	},
	{
		"toolType": "qeegGuidedProtocolReview",
		"slug": "qeeg-guided-protocol-review",
		"title": "QEEG-Guided Neurofeedback Protocol Review | Qwoach",
		"metaDescription": "Document QEEG-linked rationale for continuing or changing a neurofeedback protocol, with practitioner-entered findings and review history.",
		"h1": "QEEG-Guided Protocol Review",
		"intro": "QEEG-Guided Protocol Review is a practitioner-only neurofeedback review tool for practitioners using QEEG-guided decisions. It helps them link practitioner-entered quantitative EEG findings to the current protocol target or approach and preserve a clear continue-or-change rationale.",
		"demoTitle": "Create a sample QEEG-linked rationale map.",
		"demoPrompt": "Interested in using QEEG-Guided Protocol Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0328-f-102-nf-010-r001-qeeg-guided-protocol-review.md",
		"specId": "0328-f-102-nf-010-r001-qeeg-guided-protocol-review",
		"tags": {
			"framework": [
				"Neurofeedback"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Physiological self-regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner Control",
				"body": "The practitioner supplies findings and interpretation. The system organizes the relationship between findings, protocol elements, decision, and history."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not interpret QEEG, select protocols, produce diagnostic claims, or apply protocol rules not defined by the practitioner."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool interpret QEEG findings?",
				"answer": "No. The practitioner enters or references findings and controls all interpretation."
			},
			{
				"question": "Does it recommend a protocol?",
				"answer": "No. The output is a documented continue-or-change rationale, not an automated protocol recommendation."
			},
			{
				"question": "Can multiple protocol targets be reviewed?",
				"answer": "Yes, but multiple targets should be separated into distinct rationale entries or clearly separated sections."
			}
		]
	},
	{
		"toolType": "pcl5RepeatedMonitoring",
		"slug": "pcl-5-repeated-monitoring",
		"title": "PCL-5 Repeated Monitoring for CPT | Qwoach",
		"metaDescription": "Track repeated PCL-5 administrations during CPT with longitudinal total-score review, item-level patterns, and missingness states.",
		"h1": "PCL-5 Repeated Monitoring",
		"intro": "PCL-5 Repeated Monitoring is a CPT-related repeated measurement tool for CPT practitioners treating PTSD. It helps practitioners administer and review repeated PCL-5 measurements so they can see longitudinal symptom severity and item-level patterns over treatment.",
		"demoTitle": "Explore a sample repeated-monitoring review.",
		"demoPrompt": "Interested in using PCL-5 Repeated Monitoring with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0329-f-011-cpt-001-r001-pcl-5-repeated-monitoring.md",
		"specId": "0329-f-011-cpt-001-r001-pcl-5-repeated-monitoring",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Measure, Repeated Use",
				"body": "This is not an assessment builder. Repeated administrations use the same PCL-5 structure once the actual instrument content and scoring are supplied."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent item text, scoring rules, cutoffs, diagnostic conclusions, or treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo show the exact PCL-5 items?",
				"answer": "No. Exact item text and response options are unresolved in the supplied product record and should not be invented."
			},
			{
				"question": "Is PCL-5 scoring configurable?",
				"answer": "No. Scoring is instrument-defined once supplied; the practitioner can configure administration timing, not the measure structure."
			},
			{
				"question": "What happens with incomplete responses?",
				"answer": "Incomplete responses should not produce a complete score and should remain visible as incomplete."
			}
		]
	},
	{
		"toolType": "impactStatement",
		"slug": "impact-statement",
		"title": "Impact Statement CPT Assignment Tool | Qwoach",
		"metaDescription": "Assign and review a CPT Impact Statement with client draft/submit flow, practitioner theme notes, and preserved baseline text.",
		"h1": "Impact Statement",
		"intro": "Impact Statement is a CPT practice assignment for CPT practitioners and clients beginning PTSD treatment. It helps the client write their current understanding of the trauma's causes, consequences, and effects on beliefs so the practitioner can identify baseline themes for treatment focus.",
		"demoTitle": "Preview the assignment, client writing flow, and practitioner review.",
		"demoPrompt": "Interested in using Impact Statement with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0330-f-011-cpt-002-r001-impact-statement.md",
		"specId": "0330-f-011-cpt-002-r001-impact-statement",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Assessment"
			],
			"topic": [
				"Trauma",
				"Core beliefs"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client and Practitioner Roles",
				"body": "The client authors the statement. The practitioner reviews, annotates, and identifies themes while preserving the original submitted text."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not create symptom scores, ratings, automated stuck-point extraction, or exact CPT prompt wording not supplied by the care workflow."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool score the Impact Statement?",
				"answer": "No. The Impact Statement is a reflective assignment, not a scored symptom measure."
			},
			{
				"question": "Can the client save a draft?",
				"answer": "Yes. The client writing flow should support draft saving and later submission."
			},
			{
				"question": "Does the system identify themes automatically?",
				"answer": "No. Themes are practitioner-identified; the system may organize annotations but does not infer clinical themes automatically."
			}
		]
	},
	{
		"toolType": "stuckPointLog",
		"slug": "stuck-point-log",
		"title": "Stuck Point Log for CPT | Cognitive Target Tracking | Qwoach",
		"metaDescription": "Track CPT stuck points as specific cognitive targets, review active or recurring beliefs, and save the log setup for your practice.",
		"h1": "Stuck Point Log for CPT cognitive target tracking",
		"intro": "Stuck Point Log is a ready-to-send CPT tool for practitioners who need to maintain an evolving list of a client's trauma-related blocked beliefs. It helps practitioners organize specific stuck points for cognitive work, session focus, and homework review.",
		"demoTitle": "Explore a sample Stuck Point Log",
		"demoPrompt": "Interested in using Stuck Point Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0331-f-011-cpt-003-r001-stuck-point-log.md",
		"specId": "0331-f-011-cpt-003-r001-stuck-point-log",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during CPT when stuck points emerge from session work, submitted materials, homework review, or repeated cognitive themes."
			},
			{
				"title": "What It Captures",
				"body": "The log captures belief text, optional source or context, recurrence, draft or reviewed state, treatment-use status, and change history."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not collect symptom scores, diagnose, rank severity, infer belief meaning, or decide treatment priority."
			}
		],
		"faqItems": [
			{
				"question": "Is this a CPT Stuck Point Log?",
				"answer": "Yes. This page demonstrates a CPT Stuck Point Log for maintaining an evolving list of trauma-related blocked beliefs as cognitive targets."
			},
			{
				"question": "Can clients add stuck points directly?",
				"answer": "Yes, if client contribution mode is enabled. Client submissions remain candidate beliefs until the practitioner reviews and confirms their treatment-use status."
			},
			{
				"question": "Does the tool decide which stuck point is most important?",
				"answer": "No. The tool organizes entries descriptively; the practitioner decides clinical meaning, session focus, and treatment priority."
			},
			{
				"question": "What happens to sample demo entries when I save?",
				"answer": "Sample entries are not saved as real client data by default. Saving preserves the tool and practitioner setup, not fictional demo content."
			}
		]
	},
	{
		"toolType": "abcWorksheet",
		"slug": "abc-worksheet",
		"title": "ABC Worksheet for CPT | Event Belief Emotion Tool | Qwoach",
		"metaDescription": "Explore a CPT ABC Worksheet that separates situations, beliefs, and emotional consequences for practitioner review and repeated comparison.",
		"h1": "ABC Worksheet for CPT event-belief-emotion review",
		"intro": "ABC Worksheet is a ready-to-send CPT worksheet for practitioners who need to see how a client's activating situation, interpretation, and emotional response relate to one another. It helps practitioners identify beliefs that may become cognitive targets.",
		"demoTitle": "Try a sample ABC Worksheet",
		"demoPrompt": "Interested in using ABC Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0332-f-011-cpt-004-r001-abc-worksheet.md",
		"specId": "0332-f-011-cpt-004-r001-abc-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The worksheet captures an activating situation, the client's belief or interpretation, and emotional consequences as distinct but linked parts."
			},
			{
				"title": "Practitioner Review",
				"body": "Review focuses on whether the belief is separate from the situation, tied to the emotional consequence, and specific enough to become a cognitive target."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not collect diagnosis, symptom scoring, automated severity, or unsupported ratings."
			}
		],
		"faqItems": [
			{
				"question": "What does the ABC Worksheet show?",
				"answer": "It shows the reported link between an activating situation, the client's belief or interpretation, and the emotional consequence."
			},
			{
				"question": "Can the worksheet be completed in session?",
				"answer": "Yes. Completion mode can be set to collaborative session completion, client-completed, or practitioner-completed."
			},
			{
				"question": "Does the tool correct a client's belief automatically?",
				"answer": "No. It preserves reported content and flags missing or unclear parts for practitioner review without correcting or interpreting the content."
			},
			{
				"question": "Will demo ABC entries be saved to my account?",
				"answer": "No. Saving preserves the worksheet and selected setup, not fictional demo entries as real client data."
			}
		]
	},
	{
		"toolType": "exploringQuestionsWorksheet",
		"slug": "exploring-questions-worksheet",
		"title": "Exploring Questions Worksheet for CPT | Qwoach",
		"metaDescription": "Review client-provided evidence and alternative interpretations for one CPT target belief, with descriptive completeness and practitioner notes.",
		"h1": "Explore evidence and alternatives for a CPT target belief",
		"intro": "Exploring Questions Worksheet is a CPT worksheet for practitioners who need the client's evidence and alternative interpretations for a targeted trauma-related belief. It helps practitioners review whether the material stays connected to the same belief and can guide further cognitive work.",
		"demoTitle": "Explore a sample target belief",
		"demoPrompt": "Interested in using Exploring Questions Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0333-f-011-cpt-005-r001-exploring-questions-worksheet.md",
		"specId": "0333-f-011-cpt-005-r001-exploring-questions-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after a trauma-related belief has been identified and the practitioner wants client-provided evidence and alternative interpretations for that same target."
			},
			{
				"title": "What It Does Not Do",
				"body": "The worksheet does not generate alternatives, evaluate truth, score symptoms, or make clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does one worksheet cover multiple beliefs?",
				"answer": "No. One worksheet centers on one targeted belief so the evidence and alternatives stay connected to the same cognitive target."
			},
			{
				"question": "Can the target belief come from a Stuck Point Log?",
				"answer": "Yes. The target source can be an existing stuck point or a worksheet-specific target entered for this worksheet."
			},
			{
				"question": "Does the tool write alternative interpretations for the client?",
				"answer": "No. The client or practitioner enters reported material; the system only organizes it and shows completeness descriptively."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The worksheet tool and selected setup are saved. Sample target beliefs and demo responses are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "challengingQuestionsWorksheet",
		"slug": "challenging-questions-worksheet",
		"title": "Challenging Questions Worksheet for CPT | Qwoach",
		"metaDescription": "Explore a CPT worksheet that anchors structured challenge responses to one stuck point for practitioner review and follow-up planning.",
		"h1": "Challenge a specific CPT stuck point",
		"intro": "Challenging Questions Worksheet is a CPT worksheet for practitioners who need to test a specific stuck point through structured cognitive questioning. It helps practitioners review responses, openings for alternative thinking, and follow-up cognitive work needs.",
		"demoTitle": "Challenge a sample stuck point",
		"demoPrompt": "Interested in using Challenging Questions Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0334-f-011-cpt-006-r001-challenging-questions-worksheet.md",
		"specId": "0334-f-011-cpt-006-r001-challenging-questions-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Review Focus",
				"body": "Review centers on whether responses reveal evidence, assumptions, overgeneralizations, or openings for alternative thinking related to the same stuck point."
			},
			{
				"title": "Important Limits",
				"body": "The worksheet does not score belief accuracy, generate interpretations, diagnose, or create unsupported ratings."
			}
		],
		"faqItems": [
			{
				"question": "Does this worksheet require a specific stuck point?",
				"answer": "Yes. Each worksheet is anchored to one specific target belief or stuck point."
			},
			{
				"question": "Can I link the result to a Stuck Point Log?",
				"answer": "Yes. If the target comes from the Stuck Point Log, the reviewed result can connect back to that stuck point's history."
			},
			{
				"question": "Does the tool include official challenge question wording?",
				"answer": "Product-spec conflict: Exact challenge questions, sequence, and response labels are unresolved by the product specification, so the public demo cannot define or invent them."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The worksheet tool and selected target-source setup are saved. Demo target beliefs and sample responses are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "patternsOfProblematicThinkingWorksheet",
		"slug": "patterns-of-problematic-thinking-worksheet",
		"title": "Patterns of Problematic Thinking Worksheet | Qwoach",
		"metaDescription": "Explore a CPT worksheet for grouping client examples into supplied thinking-pattern categories and reviewing a descriptive pattern profile.",
		"h1": "Profile recurring problematic thinking patterns in CPT",
		"intro": "Patterns of Problematic Thinking Worksheet is a CPT worksheet for practitioners who need to identify recurring problematic reasoning patterns across a client's examples. It helps practitioners create a descriptive pattern profile connected to stuck points or trauma themes.",
		"demoTitle": "Build a sample pattern profile",
		"demoPrompt": "Interested in using Patterns of Problematic Thinking Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0335-f-011-cpt-007-r001-patterns-of-problematic-thinking-worksheet.md",
		"specId": "0335-f-011-cpt-007-r001-patterns-of-problematic-thinking-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The worksheet captures multiple examples, supplied pattern category selections, review status, and links to stuck points or trauma themes when explicitly connected."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not invent pattern categories, define categories, diagnose, score symptoms, or assign automated distortion labels."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool provide the pattern categories?",
				"answer": "No. Pattern labels must come from supplied worksheet content; the product does not invent category names or definitions."
			},
			{
				"question": "Can one example fit more than one pattern?",
				"answer": "Yes. The product should allow multiple or uncertain categorization when practitioner review is needed."
			},
			{
				"question": "Is the pattern profile a score?",
				"answer": "No. The profile is descriptive and supports practitioner review; it is not a clinical score."
			},
			{
				"question": "What is saved when I save the worksheet?",
				"answer": "The worksheet, categorization mode, and reusable setup are saved. Fictional examples and demo profile content are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "challengingBeliefsWorksheet",
		"slug": "challenging-beliefs-worksheet",
		"title": "Challenging Beliefs Worksheet for CPT | Qwoach",
		"metaDescription": "Explore a CPT worksheet for before-and-after belief conviction, emotional intensity, and alternative cognition tied to one stuck point.",
		"h1": "Compare belief and emotion change after CPT cognitive restructuring",
		"intro": "Challenging Beliefs Worksheet is a CPT worksheet for practitioners who need before-and-after indicators of a client's belief strength, emotional response, and alternative cognition. It helps practitioners review whether work on a stuck point produced descriptive change that may inform follow-up.",
		"demoTitle": "Compare a sample stuck point",
		"demoPrompt": "Interested in using Challenging Beliefs Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0336-f-011-cpt-008-r001-challenging-beliefs-worksheet.md",
		"specId": "0336-f-011-cpt-008-r001-challenging-beliefs-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The worksheet captures one target stuck point, initial and revised belief conviction, initial and revised emotional intensity, and one alternative cognition."
			},
			{
				"title": "Comparison Limits",
				"body": "The tool displays descriptive change only when paired indicators are present and does not generate alternative thoughts or classify clinical change."
			}
		],
		"faqItems": [
			{
				"question": "Does this worksheet compare before and after indicators?",
				"answer": "Yes. It compares initial and revised belief conviction and emotional intensity for the same stuck point when paired data is present."
			},
			{
				"question": "Can it link back to a Stuck Point Log?",
				"answer": "Yes. If the target is selected from the Stuck Point Log, the comparison can be reviewed in that stuck point's history."
			},
			{
				"question": "Does the tool decide whether cognitive restructuring worked?",
				"answer": "No. It displays descriptive before/after change; the practitioner reviews whether the result indicates more work is needed."
			},
			{
				"question": "Are demo ratings saved as client data?",
				"answer": "No. Saving preserves the worksheet and setup, not fictional demo ratings or sample alternative cognition as real client data."
			}
		]
	},
	{
		"toolType": "alternativeThoughtsWorksheet",
		"slug": "alternative-thoughts-worksheet",
		"title": "Alternative Thoughts Worksheet for CPT | Qwoach",
		"metaDescription": "Explore a CPT worksheet for pairing an original trauma-related belief with an alternative thought and a conviction indicator.",
		"h1": "Capture an alternative cognition and conviction in CPT",
		"intro": "Alternative Thoughts Worksheet is a CPT worksheet for practitioners who need a client's alternative cognition and a sense of how strongly the client believes it. It helps practitioners review whether the alternative thought addresses the same stuck point or trauma-related interpretation.",
		"demoTitle": "Create a sample alternative thought",
		"demoPrompt": "Interested in using Alternative Thoughts Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0337-f-011-cpt-009-r001-alternative-thoughts-worksheet.md",
		"specId": "0337-f-011-cpt-009-r001-alternative-thoughts-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The worksheet captures an original target, an alternative cognition, conviction in that alternative, review state, and revisit history when used longitudinally."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not generate alternative thoughts, judge whether a thought is balanced, infer durability, or collect unsupported symptom scores."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate alternative thoughts?",
				"answer": "No. The client or practitioner enters the alternative cognition; practitioner review determines clinical usability."
			},
			{
				"question": "Does conviction have to use a specific scale?",
				"answer": "Only if a supported conviction scale is supplied. The product should not define unsupported scale semantics."
			},
			{
				"question": "Can alternatives be revisited over time?",
				"answer": "Yes. Persisted state can include target, alternative cognition, conviction, and revisit history."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The worksheet tool and selected setup are saved. Fictional targets, sample alternatives, and demo conviction values are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "thinkingPatternsWorksheet",
		"slug": "thinking-patterns-worksheet",
		"title": "Thinking Patterns Worksheet for CPT | Qwoach",
		"metaDescription": "Explore a CPT worksheet for categorizing examples into supplied thinking-pattern categories and reviewing treatment-relevant profile data.",
		"h1": "Build a CPT profile of problematic thinking patterns",
		"intro": "Thinking Patterns Worksheet is a CPT worksheet for practitioners who need to recognize recurring thinking patterns that maintain trauma-related distress. It helps practitioners review categorized examples and identify which supplied patterns are most prominent for cognitive work.",
		"demoTitle": "Explore a sample pattern profile",
		"demoPrompt": "Interested in using Thinking Patterns Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0338-f-011-cpt-010-r001-thinking-patterns-worksheet.md",
		"specId": "0338-f-011-cpt-010-r001-thinking-patterns-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Client Roles",
				"body": "The client may contribute examples and suggested categories; the practitioner reviews category fit and controls the profile used for treatment planning."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not invent category labels, provide diagnostic labels, score symptoms, or generate treatment steps."
			}
		],
		"faqItems": [
			{
				"question": "Are thinking-pattern categories built into the demo?",
				"answer": "No. Exact categories and definitions must come from supplied worksheet content; the demo uses category placeholders only."
			},
			{
				"question": "Can clients suggest categories?",
				"answer": "Yes. If client-suggested or collaborative mode is selected, client category selections remain distinguishable from practitioner-reviewed categories."
			},
			{
				"question": "Can examples remain uncategorized?",
				"answer": "Yes. Uncategorized or uncertain examples remain available for practitioner review."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The worksheet tool and selected setup are saved. Fictional examples and demo profile content are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "safetyThemeWorksheet",
		"slug": "safety-theme-worksheet",
		"title": "Safety Theme Worksheet for CPT | Qwoach",
		"metaDescription": "Explore a CPT Safety theme worksheet for capturing safety-related beliefs, reviewing treatment-target readiness, and tracking change over time.",
		"h1": "Profile safety-related beliefs in CPT theme work",
		"intro": "Safety Theme Worksheet is a CPT theme-specific worksheet for practitioners who need to understand a client's post-trauma beliefs about safety, danger, vulnerability, and protection. It helps practitioners organize safety-related beliefs for review as possible cognitive treatment targets.",
		"demoTitle": "Explore a sample safety profile",
		"demoPrompt": "Interested in using Safety Theme Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0339-f-011-cpt-011-r001-safety-theme-worksheet.md",
		"specId": "0339-f-011-cpt-011-r001-safety-theme-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Theme Scope",
				"body": "The worksheet remains focused on Safety. Changing it into another theme would change the product identity."
			},
			{
				"title": "Important Limits",
				"body": "The tool is not a formal risk assessment or safety-planning tool and does not provide automated danger evaluation or safety instructions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general safety planning tool?",
				"answer": "No. It is a CPT Safety theme belief profile, not a safety plan or risk assessment."
			},
			{
				"question": "Can the Safety theme be changed to another theme?",
				"answer": "No. The theme scope is fixed to Safety because changing it would change the tool identity."
			},
			{
				"question": "Who decides whether a belief is a treatment target?",
				"answer": "The practitioner decides through review. The system can show draft and reviewed states but does not make clinical interpretations."
			},
			{
				"question": "What happens to demo safety beliefs when I save?",
				"answer": "They are not saved as real client data by default. Saving preserves the worksheet tool and selected entry mode."
			}
		]
	},
	{
		"toolType": "trustThemeWorksheet",
		"slug": "trust-theme-worksheet",
		"title": "Trust Theme Worksheet for CPT | Qwoach",
		"metaDescription": "Explore a CPT Trust theme worksheet for capturing beliefs about trusting self or others, reviewing targets, and tracking theme change.",
		"h1": "Profile trust-related beliefs in CPT theme work",
		"intro": "Trust Theme Worksheet is a CPT theme-specific worksheet for practitioners who need to understand a client's post-trauma beliefs about trusting self or others. It helps practitioners organize trust-related beliefs for review as possible cognitive treatment targets.",
		"demoTitle": "Explore a sample trust profile",
		"demoPrompt": "Interested in using Trust Theme Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0340-f-011-cpt-012-r001-trust-theme-worksheet.md",
		"specId": "0340-f-011-cpt-012-r001-trust-theme-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Theme Scope",
				"body": "The worksheet remains focused on Trust. Changing it into another theme would change the product identity."
			},
			{
				"title": "Important Limits",
				"body": "The tool is not a relationship assessment, interpersonal inventory, or automated trust advice tool."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general relationship assessment?",
				"answer": "No. It is a CPT Trust theme belief profile focused on beliefs about trusting self or others."
			},
			{
				"question": "Can the Trust theme be changed to another CPT theme?",
				"answer": "No. The theme is fixed to Trust because changing it would change the tool identity."
			},
			{
				"question": "Who decides whether a trust belief is specific enough for treatment work?",
				"answer": "The practitioner decides through review. The tool preserves wording and can flag ambiguity, but it does not make clinical interpretations."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The worksheet tool and selected entry mode are saved. Fictional trust beliefs and sample review history are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "powerAndControlThemeWorksheet",
		"slug": "power-and-control-theme-worksheet",
		"title": "Power and Control Theme Worksheet Demo | Qwoach",
		"metaDescription": "Explore a CPT power/control worksheet that organizes client wording into own-control and others-control belief areas for practitioner review.",
		"h1": "Power and Control Theme Worksheet for CPT",
		"intro": "Power and Control Theme Worksheet is a ready-to-send CPT theme worksheet for trauma-focused practitioners. It helps practitioners collect client wording about power, control, coercion, or helplessness after trauma and review it as a theme-specific belief profile.",
		"demoTitle": "Explore the worksheet setup, sample client responses, and practitioner review before saving it to your account.",
		"demoPrompt": "Interested in using Power and Control Theme Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0341-f-011-cpt-013-r001-power-and-control-theme-worksheet.md",
		"specId": "0341-f-011-cpt-013-r001-power-and-control-theme-worksheet",
		"tags": {
			"framework": [
				"CPT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when CPT work is focused on trauma-related beliefs involving power, control, coercion, helplessness, or other people's control."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures client-written belief statements and organizes them descriptively into own-control and others-control areas for practitioner review."
			},
			{
				"title": "Limitations",
				"body": "The tool does not score symptoms, determine whether a belief is true or distorted, or add generic cognitive restructuring steps."
			}
		],
		"faqItems": [
			{
				"question": "Does this worksheet produce a score?",
				"answer": "No. It produces a theme-specific belief profile, not a symptom score or severity rating."
			},
			{
				"question": "Can it compare change over time?",
				"answer": "Yes. When linked to a prior power/control worksheet instance, the review can show current content alongside earlier content for descriptive change review."
			},
			{
				"question": "Does the system interpret the client's beliefs clinically?",
				"answer": "No. The system organizes reported content by supported power/control distinctions and leaves clinical interpretation to the practitioner."
			}
		]
	},
	{
		"toolType": "esteemThemeWorksheet",
		"slug": "esteem-theme-worksheet",
		"title": "Esteem Theme Worksheet Demo | Qwoach",
		"metaDescription": "Explore a CPT esteem worksheet that organizes client wording into self-esteem and other-esteem belief areas for practitioner review.",
		"h1": "Esteem Theme Worksheet for CPT",
		"intro": "Esteem Theme Worksheet is a ready-to-send CPT theme worksheet for trauma-focused practitioners. It helps practitioners collect client wording about self-worth and views of other people and review those responses as an esteem belief profile.",
		"demoTitle": "Explore the worksheet setup, sample client view, and esteem profile review before saving it.",
		"demoPrompt": "Interested in using Esteem Theme Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0342-f-011-cpt-014-r001-esteem-theme-worksheet.md",
		"specId": "0342-f-011-cpt-014-r001-esteem-theme-worksheet",
		"tags": {
			"framework": [
				"CPT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Shame",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when trauma-related beliefs involve self-worth, shame, blame, or judgments about other people's worth, reliability, or character."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures free-text client wording and organizes it into self-esteem and other-esteem areas for practitioner review."
			},
			{
				"title": "Limitations",
				"body": "The tool does not add self-esteem scales, relationship metrics, severity labels, or automated judgments."
			}
		],
		"faqItems": [
			{
				"question": "Is this a self-esteem scale?",
				"answer": "No. It is a CPT esteem theme worksheet that produces a descriptive belief profile, not a scale score."
			},
			{
				"question": "Can one response appear relevant to both self and others?",
				"answer": "Yes. If content spans self and others, the review should preserve it for practitioner review rather than forcing one interpretation."
			},
			{
				"question": "Can I use it for follow-up comparison?",
				"answer": "Yes. Linking to prior esteem worksheet work lets the review show current and earlier content together."
			}
		]
	},
	{
		"toolType": "intimacyThemeWorksheet",
		"slug": "intimacy-theme-worksheet",
		"title": "Intimacy Theme Worksheet Demo | Qwoach",
		"metaDescription": "Explore a CPT intimacy worksheet that organizes client wording into self-intimacy and intimacy-with-others belief areas for review.",
		"h1": "Intimacy Theme Worksheet for CPT",
		"intro": "Intimacy Theme Worksheet is a ready-to-send CPT theme worksheet for trauma-focused practitioners. It helps practitioners collect client wording about self-intimacy and intimacy with others and review it as an intimacy belief profile.",
		"demoTitle": "Explore setup, sample client responses, and practitioner review before saving this worksheet.",
		"demoPrompt": "Interested in using Intimacy Theme Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0343-f-011-cpt-015-r001-intimacy-theme-worksheet.md",
		"specId": "0343-f-011-cpt-015-r001-intimacy-theme-worksheet",
		"tags": {
			"framework": [
				"CPT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when trauma-related stuck points interfere with emotional closeness, self-connection, vulnerability, or intimacy with others."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures written client beliefs and organizes them into self-intimacy and intimacy-with-others areas."
			},
			{
				"title": "Limitations",
				"body": "It does not collect relationship status, sexual history, attachment classifications, intimacy ratings, or system-generated recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is this a relationship assessment?",
				"answer": "No. It is a CPT intimacy theme worksheet focused on trauma-related beliefs, not a broad relationship inventory."
			},
			{
				"question": "Does it score intimacy?",
				"answer": "No. The result is a descriptive belief profile without scores or readiness labels."
			},
			{
				"question": "Can it show change over treatment?",
				"answer": "Yes. When linked to prior intimacy worksheet work, the review can show current and earlier content for comparison."
			}
		]
	},
	{
		"toolType": "finalImpactStatement",
		"slug": "final-impact-statement",
		"title": "Final Impact Statement Demo | Qwoach",
		"metaDescription": "Explore a CPT final impact statement tool for reviewing before-and-after trauma-related beliefs and remaining themes near treatment completion.",
		"h1": "Final Impact Statement for CPT",
		"intro": "Final Impact Statement is a CPT end-of-treatment tool for trauma-focused practitioners. It helps practitioners collect a final client statement and review before-and-after changes in trauma-related beliefs and remaining clinically important themes.",
		"demoTitle": "Explore the final statement setup, sample writing view, and comparison review before saving it.",
		"demoPrompt": "Interested in using Final Impact Statement with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0344-f-011-cpt-016-r001-final-impact-statement.md",
		"specId": "0344-f-011-cpt-016-r001-final-impact-statement",
		"tags": {
			"framework": [
				"CPT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it near treatment completion when the practitioner needs to review changes in trauma-related beliefs and meaning."
			},
			{
				"title": "What It Shows",
				"body": "With earlier material linked, the review shows a before-and-after view of shifted beliefs and remaining themes. Without earlier material, it shows the current final statement only."
			},
			{
				"title": "Limitations",
				"body": "The tool does not make closure decisions, score outcomes, or generate treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool require earlier impact material?",
				"answer": "No. Earlier material enables before-and-after comparison, but the tool can show a final-current-only review when no source is available."
			},
			{
				"question": "Does it decide whether treatment is complete?",
				"answer": "No. It supports practitioner review; closure or further work remains a practitioner decision."
			},
			{
				"question": "Can practitioners mark remaining stuck points?",
				"answer": "Yes. The review can include practitioner-marked remaining themes based on reported content."
			}
		]
	},
	{
		"toolType": "ptsdSymptomAssessmentPcl5",
		"slug": "ptsd-symptom-assessment-pcl-5",
		"title": "PTSD Symptom Assessment / PCL-5 Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send PTSD symptom assessment for PE care with baseline or follow-up setup, score/profile review, and repeated-score comparison.",
		"h1": "PTSD Symptom Assessment / PCL-5",
		"intro": "PTSD Symptom Assessment / PCL-5 is a ready-to-send standardized PTSD symptom assessment for practitioners monitoring clients in prolonged exposure care. It helps practitioners collect symptom ratings, review an overall severity score/profile when scoring rules are supplied, and compare repeated assessments across treatment points.",
		"demoTitle": "Explore baseline and follow-up setup, sample client completion, and practitioner review before saving it.",
		"demoPrompt": "Interested in using PTSD Symptom Assessment / PCL-5 with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0345-f-012-pe-001-r001-ptsd-symptom-assessment-pcl-5.md",
		"specId": "0345-f-012-pe-001-r001-ptsd-symptom-assessment-pcl-5",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for baseline assessment or monitoring points during prolonged exposure care for PTSD symptoms."
			},
			{
				"title": "What It Shows",
				"body": "When instrument content and scoring rules are supplied, the review shows overall score/profile, elevated or changing areas supported by the structure, and repeated-score comparison."
			},
			{
				"title": "Limitations",
				"body": "The tool does not invent item wording, scoring rules, symptom clusters, severity thresholds, diagnostic conclusions, or exposure plan recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo calculate a real PCL-5 score?",
				"answer": "Only when the standardized item wording, response anchors, and scoring rules are supplied. Without them, scoring remains unresolved."
			},
			{
				"question": "What happens if an item is incomplete?",
				"answer": "Incomplete score-bearing items prevent final scoring, but partial responses can remain saved for resume."
			},
			{
				"question": "Does the assessment diagnose PTSD?",
				"answer": "No. It produces a symptom score/profile for practitioner review and does not make diagnostic conclusions."
			}
		]
	},
	{
		"toolType": "traumaInterviewIndexTraumaSelection",
		"slug": "trauma-interview-index-trauma-selection",
		"title": "Index Trauma Selection Tool Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only PE planning tool for selecting a target trauma memory and documenting the rationale for exposure work.",
		"h1": "Trauma Interview / Index Trauma Selection",
		"intro": "Trauma Interview / Index Trauma Selection is a practitioner-only PE planning tool. It helps practitioners identify an agreed-upon target trauma memory and document a rationale that links the selection to current PTSD symptoms or avoidance patterns.",
		"demoTitle": "Explore the practitioner-only planning record and review output before saving it.",
		"demoPrompt": "Interested in using Trauma Interview / Index Trauma Selection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0346-f-012-pe-002-r001-trauma-interview-index-trauma-selection.md",
		"specId": "0346-f-012-pe-002-r001-trauma-interview-index-trauma-selection",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The interface is controlled by the practitioner. Client input may be discussed in session, but there is no separate send-to-client flow."
			},
			{
				"title": "What It Captures",
				"body": "It captures the selected target memory, optional alternatives, rationale, and planning notes needed for subsequent exposure work."
			},
			{
				"title": "Limitations",
				"body": "The tool does not collect exhaustive trauma history, score trauma severity, rank memories automatically, or generate rationale text."
			}
		],
		"faqItems": [
			{
				"question": "Is this sent to the client?",
				"answer": "No. The product is practitioner-only, though the client may participate in the clinical discussion."
			},
			{
				"question": "Does the tool choose the index trauma automatically?",
				"answer": "No. The practitioner selects the target memory and documents the rationale."
			},
			{
				"question": "Are alternative events required?",
				"answer": "No. Alternative-event capture is configurable; the selected memory and rationale are required for completion."
			}
		]
	},
	{
		"toolType": "breathingRetraining",
		"slug": "breathing-retraining",
		"title": "Breathing Retraining Skill Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send PE breathing retraining skill with guided or reference-only presentation and optional completion acknowledgement.",
		"h1": "Breathing Retraining for PE Preparation",
		"intro": "Breathing Retraining is a ready-to-send PE client skill tool for practitioners preparing clients for exposure-based PTSD treatment. It helps clients learn and practice a breathing-based regulation skill for reducing or stabilizing immediate arousal enough to stay engaged in treatment.",
		"demoTitle": "Explore guided practice, reference view, and optional completion status before saving the skill.",
		"demoPrompt": "Interested in using Breathing Retraining with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0347-f-012-pe-003-r001-breathing-retraining.md",
		"specId": "0347-f-012-pe-003-r001-breathing-retraining",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Physiological self-regulation",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when preparing a client for exposure-based PTSD work and they need a simple skill for acute physiological arousal."
			},
			{
				"title": "What It Produces",
				"body": "The tool primarily provides skill instructions and practice. It may show completion acknowledgement if captured, but it has no intrinsic structured practitioner output."
			},
			{
				"title": "Limitations",
				"body": "The tool does not measure physiological arousal, score breathing quality, track avoidance, or add unrelated regulation practices."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool produce clinical data?",
				"answer": "No. It has no intrinsic structured clinical output; it may only show basic completion acknowledgement if captured."
			},
			{
				"question": "Can I save it if there are no detailed settings?",
				"answer": "Yes. Saving adds the Breathing Retraining skill itself to the practitioner account, with the chosen presentation mode if selected."
			},
			{
				"question": "Are the exact breathing instructions defined here?",
				"answer": "No. The exact technique instructions are unresolved and must be supplied before substantive steps are shown."
			}
		]
	},
	{
		"toolType": "inVivoExposureHierarchy",
		"slug": "in-vivo-exposure-hierarchy",
		"title": "In Vivo Exposure Hierarchy Demo | Qwoach",
		"metaDescription": "Explore a collaborative PE hierarchy tool for ordering safe avoided targets by expected distress and therapeutic priority.",
		"h1": "In Vivo Exposure Hierarchy",
		"intro": "In Vivo Exposure Hierarchy is a PE planning tool completed together by practitioner and client. It helps practitioners and clients collect safe avoided targets, add expected distress and therapeutic priority, and order them into a roadmap for gradual real-world exposure.",
		"demoTitle": "Create a sample hierarchy, preview the client roadmap, and review readiness before saving it.",
		"demoPrompt": "Interested in using In Vivo Exposure Hierarchy with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0348-f-012-pe-004-r001-in-vivo-exposure-hierarchy.md",
		"specId": "0348-f-012-pe-004-r001-in-vivo-exposure-hierarchy",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Behavior change",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Collaborative Use",
				"body": "The hierarchy is completed together, with the client contributing avoided targets and expected distress and the practitioner controlling safety, relevance, and final ordering."
			},
			{
				"title": "What It Captures",
				"body": "It captures target descriptions, expected distress, therapeutic priority, safety/relevance confirmation, functional-goal linkage, ordering, and revision history."
			},
			{
				"title": "Limitations",
				"body": "The hierarchy does not log completed practice, generate targets, determine safety automatically, or prescribe the next assignment by itself."
			}
		],
		"faqItems": [
			{
				"question": "Can the client mark a target as safe?",
				"answer": "No. Practitioner safety and relevance confirmation controls readiness."
			},
			{
				"question": "Does this tool track exposure completion?",
				"answer": "No. It creates the ordered roadmap; completion logging belongs to assignment or practice log tools."
			},
			{
				"question": "Can the order be changed later?",
				"answer": "Yes. The hierarchy can be revised over time while preserving prior states for comparison."
			}
		]
	},
	{
		"toolType": "inVivoExposureAssignment",
		"slug": "in-vivo-exposure-assignment",
		"title": "In Vivo Exposure Assignment Demo | Qwoach",
		"metaDescription": "Explore a PE between-session exposure assignment tool with task details, optional hierarchy linkage, and completion and learning review.",
		"h1": "In Vivo Exposure Assignment",
		"intro": "In Vivo Exposure Assignment is a ready-to-send PE between-session task tool for practitioners. It helps practitioners give a PTSD client a specific, clinically appropriate in-vivo exposure task and review attempt, completion, and client learning when post-task logging is enabled.",
		"demoTitle": "Create a sample assignment, preview the client task and log, and review the result before saving it.",
		"demoPrompt": "Interested in using In Vivo Exposure Assignment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0349-f-012-pe-005-r001-in-vivo-exposure-assignment.md",
		"specId": "0349-f-012-pe-005-r001-in-vivo-exposure-assignment",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Trauma",
				"Homework",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for one between-session in-vivo exposure task when the client is ready to approach a safe avoided situation."
			},
			{
				"title": "What It Captures",
				"body": "It captures task details and, when logging is enabled, whether the task was attempted, whether it was completed as intended, and what the client reported learning."
			},
			{
				"title": "Limitations",
				"body": "It is not the hierarchy builder and not a repeated practice trend log. It does not determine safety, invent distress scales, or advance the client automatically."
			}
		],
		"faqItems": [
			{
				"question": "Can this assignment be created from a hierarchy target?",
				"answer": "Yes. It can be linked to an existing hierarchy target or created as a standalone task."
			},
			{
				"question": "Does every assignment collect post-task data?",
				"answer": "No. The practitioner can require completion/learning logging or provide instructions only."
			},
			{
				"question": "Does the tool decide the next exposure step?",
				"answer": "No. It shows assignment and logged information for practitioner review; next-step decisions remain with the practitioner."
			}
		]
	},
	{
		"toolType": "inVivoExposurePracticeLog",
		"slug": "in-vivo-exposure-practice-log",
		"title": "In Vivo Exposure Practice Log Demo | Qwoach",
		"metaDescription": "Explore a PE practice log for repeated in-vivo exposure entries, adherence summaries, task trends, barriers, and response patterns.",
		"h1": "In Vivo Exposure Practice Log",
		"intro": "In Vivo Exposure Practice Log is a ready-to-send PE logging tool for practitioners whose clients are doing repeated real-world exposure practice. It helps practitioners review which tasks were attempted, how often, what barriers appeared, and response patterns when those fields are included.",
		"demoTitle": "Explore task linkage, sample client entries, and trend review before saving the log.",
		"demoPrompt": "Interested in using In Vivo Exposure Practice Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0350-f-012-pe-006-r001-in-vivo-exposure-practice-log.md",
		"specId": "0350-f-012-pe-006-r001-in-vivo-exposure-practice-log",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Homework",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when repeated between-session in-vivo exposure practice is underway and recall alone is not enough for review."
			},
			{
				"title": "What It Captures",
				"body": "It captures practice entries, task linkage or labels, attempt/completion status, optional response or barrier fields, and practitioner review notes."
			},
			{
				"title": "Limitations",
				"body": "The log does not build hierarchies, create single assignments, infer missing practice from silence, invent distress scales, or decide treatment progression automatically."
			}
		],
		"faqItems": [
			{
				"question": "Can clients log unplanned practice?",
				"answer": "Yes, if free-label mode is enabled. Those entries may require practitioner reconciliation in review."
			},
			{
				"question": "Do missing entries mean the client did not practice?",
				"answer": "No. Missing entries cannot be assumed to mean no practice."
			},
			{
				"question": "Can the log track distress or response patterns?",
				"answer": "Yes, only if the exact log structure supplies response fields. The tool must not invent unsupported scales."
			}
		]
	},
	{
		"toolType": "sudsDistressRating",
		"slug": "suds-distress-rating",
		"title": "SUDS / Distress Rating Demo for Exposure Work | Qwoach",
		"metaDescription": "Track subjective distress ratings by exposure task or moment and review descriptive trajectories for prolonged exposure treatment planning.",
		"h1": "SUDS / Distress Rating for Exposure Process Tracking",
		"intro": "SUDS / Distress Rating is a ready-to-send distress-tracking tool for prolonged exposure practitioners. It helps clinicians capture subjective distress ratings tied to exposure tasks or moments so they can review how fear or arousal changes during or across exposure work.",
		"demoTitle": "Configure a sample exposure rating flow",
		"demoPrompt": "Interested in using SUDS / Distress Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0351-f-012-pe-007-r001-suds-distress-rating.md",
		"specId": "0351-f-012-pe-007-r001-suds-distress-rating",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during live exposure work, between-session exposure assignments, or retrospective entry when the practitioner needs distress ratings tied to specific exposure moments."
			},
			{
				"title": "What It Does Not Conclude",
				"body": "The tool describes rating patterns. It does not infer safety, clinical success, readiness, avoidance, or therapeutic meaning beyond reported ratings and practitioner interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score exposure success?",
				"answer": "No. It shows reported distress ratings and descriptive movement over time, but the practitioner interprets what the pattern means clinically."
			},
			{
				"question": "Can missing ratings be reviewed?",
				"answer": "Yes. Missing or incomplete rating points are shown as gaps rather than being filled in or estimated."
			},
			{
				"question": "Can the tool be used across multiple exposure tasks?",
				"answer": "Yes. Ratings can be grouped by task or session so later review preserves the exposure context."
			}
		]
	},
	{
		"toolType": "imaginalExposureSession",
		"slug": "imaginal-exposure-session",
		"title": "Imaginal Exposure Session Demo for PE Clinicians | Qwoach",
		"metaDescription": "Support live imaginal exposure documentation with target memory context, session status, observations, distress response, and processing themes.",
		"h1": "Imaginal Exposure Session Live Documentation Tool",
		"intro": "Imaginal Exposure Session is a live-session-only prolonged exposure tool for practitioners. It helps clinicians structure the session record while observing content, distress response, and clinically important processing themes as a client revisits a selected trauma memory in session.",
		"demoTitle": "Open a sample live session record",
		"demoPrompt": "Interested in using Imaginal Exposure Session with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0352-f-012-pe-008-r001-imaginal-exposure-session.md",
		"specId": "0352-f-012-pe-008-r001-imaginal-exposure-session",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"In-session support",
				"Clinical documentation"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Live Session Boundary",
				"body": "This is for practitioner-controlled in-session use. It is not a standalone client self-guided exposure product."
			},
			{
				"title": "Incomplete Sessions",
				"body": "Paused or incomplete sessions keep documented observations and clearly show that the session was not completed as recorded."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool provide an imaginal exposure script?",
				"answer": "No. The supplied specification does not define a script or protocol prompts, so the tool supports structure and documentation rather than supplying therapeutic script content."
			},
			{
				"question": "Can distress ratings be captured in the session record?",
				"answer": "Yes, if the practitioner enables distress-rating inclusion for the session configuration."
			},
			{
				"question": "Does the system decide whether processing occurred?",
				"answer": "No. It organizes observations and themes; clinical interpretation remains practitioner-controlled."
			}
		]
	},
	{
		"toolType": "imaginalExposureRecording",
		"slug": "imaginal-exposure-recording",
		"title": "Imaginal Exposure Recording Demo for PE Practice | Qwoach",
		"metaDescription": "Assign between-session imaginal exposure recording practice, keep it tied to the intended memory, and review adherence and client reactions.",
		"h1": "Imaginal Exposure Recording Practice Tool",
		"intro": "Imaginal Exposure Recording is a ready-to-send between-session support tool for prolonged exposure practitioners. It helps clinicians assign repeated use of an intended trauma-memory recording and review whether the client practiced and how they responded.",
		"demoTitle": "Set up a sample recording practice assignment",
		"demoPrompt": "Interested in using Imaginal Exposure Recording with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0353-f-012-pe-009-r001-imaginal-exposure-recording.md",
		"specId": "0353-f-012-pe-009-r001-imaginal-exposure-recording",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring"
			],
			"topic": [
				"Trauma",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Recording Anchor",
				"body": "Every practice entry belongs to an intended recording or memory context so later review does not mix unlike exposure practice."
			},
			{
				"title": "Adherence and Reaction Data",
				"body": "The tool separates whether practice occurred from how the client responded, keeping practitioner interpretation separate from reported data."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool store or analyze the trauma recording?",
				"answer": "No. The specified tool uses a recording or memory reference for assignment continuity and does not analyze recording content."
			},
			{
				"question": "Can skipped practice be logged?",
				"answer": "Yes. Skipped, completed, and incomplete practice entries remain visible as separate states."
			},
			{
				"question": "Does the tool decide the next exposure focus?",
				"answer": "No. It provides adherence and reaction information for practitioner review."
			}
		]
	},
	{
		"toolType": "imaginalExposureHomeworkLog",
		"slug": "imaginal-exposure-homework-log",
		"title": "Imaginal Exposure Homework Log Demo | Qwoach",
		"metaDescription": "Collect repeated adherence and response data for between-session imaginal exposure practice and review patterns across practice attempts.",
		"h1": "Imaginal Exposure Homework Log for Between-Session Practice",
		"intro": "Imaginal Exposure Homework Log is a ready-to-send repeated log for prolonged exposure practitioners. It helps clinicians capture whether assigned imaginal exposure practice occurred and how the client responded across attempts outside session.",
		"demoTitle": "Configure a sample homework log",
		"demoPrompt": "Interested in using Imaginal Exposure Homework Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0354-f-012-pe-010-r001-imaginal-exposure-homework-log.md",
		"specId": "0354-f-012-pe-010-r001-imaginal-exposure-homework-log",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring"
			],
			"topic": [
				"Trauma",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Attempt-by-Attempt History",
				"body": "One entry represents one practice attempt, so the review preserves how practice changed across the assignment period."
			},
			{
				"title": "Missed Practice",
				"body": "Missed and incomplete attempts remain visible instead of being hidden in a completion total."
			}
		],
		"faqItems": [
			{
				"question": "Is this the exposure recording itself?",
				"answer": "No. This is the homework log for between-session imaginal exposure practice, not the recording or media tool."
			},
			{
				"question": "Can the log capture avoidance or helpfulness?",
				"answer": "Yes, when those supported response categories are selected for the assignment."
			},
			{
				"question": "Does the tool label a client as avoiding?",
				"answer": "No. It records occurrence and configured responses; practitioner interpretation remains separate."
			}
		]
	},
	{
		"toolType": "postImaginalProcessingReview",
		"slug": "post-imaginal-processing-review",
		"title": "Post-Imaginal Processing Review Demo | Qwoach",
		"metaDescription": "Guide post-exposure reflection on emotions, thoughts, meanings, new learning, stuck points, and next-step focus after imaginal exposure.",
		"h1": "Post-Imaginal Processing Review for Exposure Sessions",
		"intro": "Post-Imaginal Processing Review is a ready-to-complete-together review tool for practitioners and clients after imaginal exposure. It helps structure reflection on post-exposure learning, emotions, thoughts, meanings, cognitive themes, remaining stuck points, and next-step focus.",
		"demoTitle": "Start a sample post-exposure review",
		"demoPrompt": "Interested in using Post-Imaginal Processing Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0355-f-012-pe-011-r001-post-imaginal-processing-review.md",
		"specId": "0355-f-012-pe-011-r001-post-imaginal-processing-review",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Completed Together",
				"body": "The tool is designed for live practitioner-client reflection after imaginal exposure, with practitioner control over clinical notes and treatment planning entries."
			},
			{
				"title": "No Forced Meaning",
				"body": "The review can leave themes unresolved or deferred; it does not force a client to endorse a specific learning or interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include a full processing script?",
				"answer": "No. It captures supported review domains but does not invent exact prompts or a separate cognitive-processing protocol."
			},
			{
				"question": "Can the client type directly?",
				"answer": "Yes, if client direct entry is enabled for co-completion; otherwise the practitioner can record verbal contributions."
			},
			{
				"question": "Does the review produce a score?",
				"answer": "No. It produces a structured reflection summary, not a score."
			}
		]
	},
	{
		"toolType": "avoidanceInventory",
		"slug": "avoidance-inventory",
		"title": "Avoidance Inventory Demo for PE Planning | Qwoach",
		"metaDescription": "Collect avoided safe situations, activities, and reminders, then review candidate targets for in-vivo exposure planning and prioritization.",
		"h1": "Avoidance Inventory for In-Vivo Exposure Planning",
		"intro": "Avoidance Inventory is a ready-to-send exposure-planning tool for prolonged exposure practitioners. It helps clinicians identify avoided safe situations, activities, and reminders that may become in-vivo exposure targets after practitioner review.",
		"demoTitle": "Create a sample avoidance inventory",
		"demoPrompt": "Interested in using Avoidance Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0356-f-012-pe-012-r001-avoidance-inventory.md",
		"specId": "0356-f-012-pe-012-r001-avoidance-inventory",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Safety behaviors"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Inventory Before Plan",
				"body": "This tool collects and reviews candidate targets before they become exposure tasks or a graded exposure plan."
			},
			{
				"title": "Practitioner Review",
				"body": "Candidate targets are not automatically approved. Specificity and safety suitability remain practitioner-reviewed."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide whether a target is safe?",
				"answer": "No. It helps collect and organize candidate targets, but practitioner review determines suitability."
			},
			{
				"question": "Is this a fear hierarchy builder?",
				"answer": "No. It creates an inventory for target generation and prioritization; it does not generate hierarchy scoring."
			},
			{
				"question": "Can original client wording be preserved?",
				"answer": "Yes. The tool should preserve original client wording alongside practitioner-edited phrasing or review notes."
			}
		]
	},
	{
		"toolType": "exposureProgressReview",
		"slug": "exposure-progress-review",
		"title": "Exposure Progress Review Demo | Qwoach",
		"metaDescription": "Review exposure progress across tasks or sessions using distress, avoidance, engagement, and supported source data while preserving context.",
		"h1": "Exposure Progress Review for Prolonged Exposure Treatment",
		"intro": "Exposure Progress Review is a ready-to-complete-together longitudinal review tool for prolonged exposure practitioners. It helps clinicians consolidate supported data on symptoms when available, distress responses, avoidance, and task engagement so they can decide how to adapt the exposure plan.",
		"demoTitle": "Open a sample progress review",
		"demoPrompt": "Interested in using Exposure Progress Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0357-f-012-pe-013-r001-exposure-progress-review.md",
		"specId": "0357-f-012-pe-013-r001-exposure-progress-review",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Longitudinal Requirement",
				"body": "The review requires more than one task or session to support longitudinal progress review; a single session can be shown but must be labeled as insufficient for longitudinal comparison."
			},
			{
				"title": "Source Traceability",
				"body": "Summaries link back to source logs, ratings, or inventories so different exposure contexts are not flattened into unsupported global scores."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide whether treatment is effective?",
				"answer": "No. It summarizes supported data descriptively; treatment interpretation and adaptation decisions remain practitioner-controlled."
			},
			{
				"question": "Can it work with missing data?",
				"answer": "Yes. Partial reviews are allowed when missing domains and unavailable sources are clearly shown."
			},
			{
				"question": "Can symptoms be included?",
				"answer": "Yes, when symptom data is available from a supported source; the tool does not create a new symptom scale."
			}
		]
	},
	{
		"toolType": "treatmentGoalsReview",
		"slug": "treatment-goals-review",
		"title": "Treatment Goals Review Demo | Qwoach",
		"metaDescription": "Compare current functioning with earlier exposure-treatment goals and review improved, stalled, or unmet functional goals together.",
		"h1": "Treatment Goals Review for Functional Progress in Exposure Treatment",
		"intro": "Treatment Goals Review is a ready-to-complete-together functional outcome review for exposure-based PTSD treatment practitioners. It helps clinicians and clients compare current functioning with earlier treatment goals and discuss next priorities or readiness for completion.",
		"demoTitle": "Review sample treatment goals",
		"demoPrompt": "Interested in using Treatment Goals Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0358-f-012-pe-014-r001-treatment-goals-review.md",
		"specId": "0358-f-012-pe-014-r001-treatment-goals-review",
		"tags": {
			"framework": [
				"Prolonged Exposure"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Goal Comparison",
				"body": "The review preserves earlier goal wording so current functioning can be compared with the aims that mattered at the start of treatment."
			},
			{
				"title": "Practitioner-Led Decisions",
				"body": "The tool organizes progress information but does not automatically decide completion readiness or next treatment priority."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general goal-setting tool?",
				"answer": "No. It reviews functional goals connected to exposure-based PTSD treatment rather than managing broad personal goals."
			},
			{
				"question": "Can the review work without numeric ratings?",
				"answer": "Yes. Narrative current-functioning notes or practitioner-entered statuses are sufficient unless a supported scale is supplied elsewhere."
			},
			{
				"question": "What happens if goals changed during treatment?",
				"answer": "Historical comparisons should preserve original wording and show review context so changed goals are not overwritten."
			}
		]
	},
	{
		"toolType": "sleepDiary",
		"slug": "sleep-diary",
		"title": "Sleep Diary Demo for CBT-I Monitoring | Qwoach",
		"metaDescription": "Collect longitudinal sleep timing, wakefulness, and duration data across nights to support practitioner-led CBT-I treatment adjustments.",
		"h1": "Sleep Diary for CBT-I Monitoring",
		"intro": "Sleep Diary is a ready-to-send CBT-I monitoring tool for insomnia treatment practitioners. It helps clinicians collect longitudinal sleep timing, wakefulness, and sleep duration data so they can tailor behavioral sleep intervention to the client's actual sleep-wake behavior.",
		"demoTitle": "Configure a sample sleep diary",
		"demoPrompt": "Interested in using Sleep Diary with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0359-f-013-cbti-001-r001-sleep-diary.md",
		"specId": "0359-f-013-cbti-001-r001-sleep-diary",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Sleep"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Multiple Nights Matter",
				"body": "The diary is designed for longitudinal review; one entry belongs to a specific night or sleep period, and patterns require multiple entries."
			},
			{
				"title": "Descriptive Review Only",
				"body": "The tool shows patterns, variability, and missingness. It does not generate unsupported CBT-I formulas or prescribe a sleep window."
			}
		],
		"faqItems": [
			{
				"question": "Does this use wearable sleep-stage data?",
				"answer": "No. The specified tool captures client-reported sleep diary data, not device-derived sleep staging."
			},
			{
				"question": "Can clients backfill missed nights?",
				"answer": "Yes, when backfill is enabled, late entries keep clear dates so review remains interpretable."
			},
			{
				"question": "Does the diary calculate sleep restriction recommendations?",
				"answer": "No. It supports practitioner review and treatment adjustment, but it does not prescribe changes without supported rules."
			}
		]
	},
	{
		"toolType": "insomniaSeverityIndexIsi",
		"slug": "insomnia-severity-index-isi",
		"title": "Insomnia Severity Index (ISI) Demo | Qwoach",
		"metaDescription": "Assign the standardized ISI, collect client responses, and review current insomnia severity and score history once fixed content is resolved.",
		"h1": "Insomnia Severity Index (ISI) for Insomnia Severity Monitoring",
		"intro": "Insomnia Severity Index (ISI) is a ready-to-send standardized insomnia severity monitoring tool for practitioners using insomnia treatment. It helps clinicians collect client responses, calculate the instrument-defined severity score, and compare repeated scores over time once the fixed ISI item text, response options, scoring rules, and severity bands are supplied.",
		"demoTitle": "Review the ISI workflow boundary",
		"demoPrompt": "Interested in using Insomnia Severity Index (ISI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0360-f-013-cbti-002-r001-insomnia-severity-index-isi.md",
		"specId": "0360-f-013-cbti-002-r001-insomnia-severity-index-isi",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Sleep",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Standardized Structure",
				"body": "The ISI item set, response options, scoring, and severity interpretation are fixed content structures once resolved. Practitioners should not edit them in the live instrument workflow."
			},
			{
				"title": "Incomplete Administrations",
				"body": "Unanswered or partial administrations remain incomplete and should not produce a final score unless the resolved instrument rules support scoring with missing items."
			}
		],
		"faqItems": [
			{
				"question": "Can the ISI items be customized?",
				"answer": "No. The ISI workflow is standardized once resolved, so live item edits and custom substitutions are not supported."
			},
			{
				"question": "Can the demo show a scored ISI result now?",
				"answer": "No. The supplied specification does not include scoring rules or severity bands, so a scored public demo would invent product behavior."
			},
			{
				"question": "What does the practitioner review after completion?",
				"answer": "The practitioner reviews completion status, item responses when reviewable, current score, instrument-defined severity indication, prior scores, and treatment notes once the fixed content is resolved."
			}
		]
	},
	{
		"toolType": "sleepEfficiencyCalculation",
		"slug": "sleep-efficiency-calculation",
		"title": "Sleep Efficiency Calculation for CBT-I Practitioners | Qwoach",
		"metaDescription": "Calculate diary-derived sleep efficiency for CBT-I review, with time asleep, time in bed, diary coverage, and interval comparison visible.",
		"h1": "Sleep Efficiency Calculation",
		"intro": "Sleep Efficiency Calculation is a CBT-I practitioner tool for clinicians treating insomnia. It helps the practitioner calculate the proportion of time in bed spent asleep from recent sleep diary data so the next sleep-window decision can be reviewed with the calculation basis visible.",
		"demoTitle": "Explore a sample diary interval and view the calculated sleep efficiency.",
		"demoPrompt": "Interested in using Sleep Efficiency Calculation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0361-f-013-cbti-003-r001-sleep-efficiency-calculation.md",
		"specId": "0361-f-013-cbti-003-r001-sleep-efficiency-calculation",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Sleep",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Use With Diary Data",
				"body": "The calculator consumes already-collected sleep diary values that distinguish time in bed from time actually asleep. It does not define a new diary structure."
			},
			{
				"title": "Partial Coverage",
				"body": "If sample diary data is incomplete, the demo marks the result as partial and shows which days are missing or excluded instead of filling in values."
			},
			{
				"title": "Review Boundary",
				"body": "The tool displays a descriptive calculation and comparison. Practitioner interpretation and sleep-window decisions remain separate from the calculated result."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool collect a new sleep diary?",
				"answer": "No. It consumes structured or previously captured sleep diary values that already distinguish time in bed from time asleep."
			},
			{
				"question": "Does the calculator recommend whether to restrict or expand the sleep window?",
				"answer": "No. It calculates and displays sleep efficiency and comparison context; the practitioner makes and records the treatment decision separately."
			},
			{
				"question": "Can incomplete diary data be reviewed?",
				"answer": "Yes. Incomplete coverage can be shown as a partial result when enough valid time-in-bed and time-asleep values are available."
			},
			{
				"question": "What gets saved from the demo?",
				"answer": "The tool and reusable practitioner configuration are saved. Sample diary values and fictional demo results are not saved as real client data."
			}
		]
	},
	{
		"toolType": "sleepRestrictionSleepSchedulingPrescription",
		"slug": "sleep-restriction-sleep-scheduling-prescription",
		"title": "CBT-I Sleep Scheduling Prescription Tool | Qwoach",
		"metaDescription": "Create a CBT-I sleep-wake schedule with bed time, wake time, sleep opportunity duration, diary basis, and client-readable schedule output.",
		"h1": "Sleep Restriction / Sleep Scheduling Prescription",
		"intro": "Sleep Restriction / Sleep Scheduling Prescription is a CBT-I practitioner tool for clinicians treating insomnia. It helps the practitioner turn recent sleep diary response into a specific bed time, wake time, and sleep opportunity window that the client can follow during the coming interval.",
		"demoTitle": "Adjust a sample sleep schedule and preview the client-facing prescription.",
		"demoPrompt": "Interested in using Sleep Restriction / Sleep Scheduling Prescription with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0362-f-013-cbti-004-r001-sleep-restriction-sleep-scheduling-prescription.md",
		"specId": "0362-f-013-cbti-004-r001-sleep-restriction-sleep-scheduling-prescription",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Sleep",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client-Readable Output",
				"body": "The client receives the current schedule as bed time, wake time, sleep opportunity duration, and coming interval. The client does not need to calculate duration."
			},
			{
				"title": "Schedule History",
				"body": "Prior schedules remain visible with their associated diary basis so the practitioner can review progression over treatment intervals."
			},
			{
				"title": "Practitioner Confirmation",
				"body": "The schedule is not generated as an independent recommendation. Practitioner confirmation is required before it becomes the current prescription."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool automatically decide the sleep window?",
				"answer": "No. The practitioner enters or confirms the schedule. The system calculates duration and shows comparison context."
			},
			{
				"question": "Can the schedule cross midnight?",
				"answer": "Yes. The schedule must calculate sleep opportunity duration correctly when bed time and wake time cross midnight."
			},
			{
				"question": "What does the client see?",
				"answer": "The client sees the current bed time, wake time, sleep opportunity window, and coming interval in a simple schedule receipt."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool and reusable practitioner configuration are saved. Fictional diary response and sample schedules are not saved as real client records."
			}
		]
	},
	{
		"toolType": "sleepRestrictionDiagram",
		"slug": "sleep-restriction-diagram",
		"title": "CBT-I Sleep Restriction Diagram Demo | Qwoach",
		"metaDescription": "Use a shared CBT-I diagram to discuss time in bed, sleep drive, sleep efficiency, and sleep consolidation with optional annotations.",
		"h1": "Sleep Restriction Diagram",
		"intro": "Sleep Restriction Diagram is a CBT-I education tool for practitioners and insomnia clients. It helps the practitioner explain how time in bed, sleep drive, sleep efficiency, and sleep consolidation relate so the client can discuss the sleep scheduling rationale with less confusion.",
		"demoTitle": "Open the shared diagram and try a sample annotation.",
		"demoPrompt": "Interested in using Sleep Restriction Diagram with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0363-f-013-cbti-005-r001-sleep-restriction-diagram.md",
		"specId": "0363-f-013-cbti-005-r001-sleep-restriction-diagram",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Sleep"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client finds reducing time in bed confusing or counterintuitive and needs a visual explanation before or during sleep scheduling work."
			},
			{
				"title": "What It Does Not Do",
				"body": "The diagram does not calculate sleep efficiency, prescribe bed and wake times, infer adherence, or measure client understanding."
			},
			{
				"title": "Content Boundary",
				"body": "The exact diagram layout and labels must come from supplied content. The public demo uses a placeholder structure limited to the supported concepts."
			}
		],
		"faqItems": [
			{
				"question": "Is this a calculator?",
				"answer": "No. It is a conceptual education diagram and does not calculate sleep efficiency or prescribe a schedule."
			},
			{
				"question": "Can clients complete it on their own?",
				"answer": "They can view the diagram and optionally add a question or takeaway if sent asynchronously, but it is designed primarily as a practitioner-guided education aid."
			},
			{
				"question": "Does reviewed status mean the client understood it?",
				"answer": "No. Reviewed status only indicates the rationale was reviewed; it does not score or prove understanding."
			},
			{
				"question": "What gets saved?",
				"answer": "The fixed diagram tool is saved as-is. Demo annotations and fictional client notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "stimulusControlPlan",
		"slug": "stimulus-control-plan",
		"title": "CBT-I Stimulus Control Plan Demo | Qwoach",
		"metaDescription": "Prepare a CBT-I stimulus control plan with rule categories, client-specific clarifications, barriers, acknowledgement, and review status.",
		"h1": "Stimulus Control Plan",
		"intro": "Stimulus Control Plan is a CBT-I tool for practitioners treating insomnia. It helps the practitioner prepare and send behaviorally clear sleep-context rules so the client knows what to do when unable to sleep and can raise barriers or questions for follow-up.",
		"demoTitle": "Review a sample plan structure and preview the client version.",
		"demoPrompt": "Interested in using Stimulus Control Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0364-f-013-cbti-006-r001-stimulus-control-plan.md",
		"specId": "0364-f-013-cbti-006-r001-stimulus-control-plan",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Sleep",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Required Categories",
				"body": "A complete plan includes supported categories for unable-to-sleep behavior, sleep-compatible behaviors, wake-promoting behaviors, and nighttime awakenings."
			},
			{
				"title": "Barrier Review",
				"body": "Barriers and questions are preserved as follow-up material. The tool does not judge whether the client followed the plan."
			},
			{
				"title": "Rule Text Boundary",
				"body": "The exact substantive rule wording must be supplied by the practitioner or approved content source. The product does not invent rule text."
			}
		],
		"faqItems": [
			{
				"question": "Is this a sleep hygiene checklist?",
				"answer": "No. It is a CBT-I stimulus-control plan focused on sleep-context rules, not a broad sleep hygiene checklist."
			},
			{
				"question": "Does the tool score adherence?",
				"answer": "No. It can preserve acknowledgement, questions, and barriers, but it does not produce an adherence score."
			},
			{
				"question": "Can the client add barriers?",
				"answer": "Yes. The client can optionally add barriers or questions, and those notes are available for practitioner review."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool and reusable plan setup are saved. Fictional sample barriers, acknowledgements, and client notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "sleepyActivitiesList",
		"slug": "sleepy-activities-list",
		"title": "CBT-I Sleepy Activities List Demo | Qwoach",
		"metaDescription": "Create a personalized CBT-I list of quiet, low-arousal activities for out-of-bed nighttime wakefulness, with preferences and barriers.",
		"h1": "Sleepy Activities List",
		"intro": "Sleepy Activities List is a CBT-I tool for practitioners and insomnia clients. It helps the client identify feasible, quiet, low-arousal activities to use while out of bed and waiting for sleepiness to return, with preferences and barriers available for practitioner review.",
		"demoTitle": "Create a sample low-arousal activity list and preview it as a client.",
		"demoPrompt": "Interested in using Sleepy Activities List with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0365-f-013-cbti-007-r001-sleepy-activities-list.md",
		"specId": "0365-f-013-cbti-007-r001-sleepy-activities-list",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Sleep",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client and Practitioner Roles",
				"body": "Clients can suggest activities and barriers. Practitioners can review whether the final list fits the stimulus-control purpose and nighttime constraints."
			},
			{
				"title": "Low Structured Output",
				"body": "The output is a practical personalized list, not a measurement tool. History is useful mainly when barriers explain difficulty using stimulus control."
			},
			{
				"title": "Content Source Boundary",
				"body": "Because exact activity examples are not supplied in the product specification, the demo uses blank entry and fictional examples only when the visitor adds them."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend activities automatically?",
				"answer": "No. Activities come from the client, practitioner, or separately supplied content; the tool organizes them."
			},
			{
				"question": "Is this a sleep diary?",
				"answer": "No. It is a practical activity list for wakeful out-of-bed periods, not a nightly log or outcome tracker."
			},
			{
				"question": "Can barriers be reviewed later?",
				"answer": "Yes. Barriers and preferences can be preserved for practitioner review if following stimulus control is difficult."
			},
			{
				"question": "What gets saved?",
				"answer": "The tool itself is saved as a ready-to-send tool. Demo activities and fictional barriers are not saved as real client data."
			}
		]
	},
	{
		"toolType": "challengingThoughtsWorksheet",
		"slug": "challenging-thoughts-worksheet",
		"title": "CBT-I Challenging Thoughts Worksheet Demo | Qwoach",
		"metaDescription": "Capture sleep-related thoughts and balanced alternatives in linked pairs for CBT-I cognitive restructuring and practitioner review.",
		"h1": "Challenging Thoughts Worksheet",
		"intro": "Challenging Thoughts Worksheet is a CBT-I worksheet for practitioners and insomnia clients. It helps identify sleep-related beliefs, predictions, or self-talk that increase arousal or sleep effort and pair them with more balanced, credible alternatives for practitioner review.",
		"demoTitle": "Try a sample thought-and-alternative entry and review the result.",
		"demoPrompt": "Interested in using Challenging Thoughts Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0366-f-013-cbti-008-r001-challenging-thoughts-worksheet.md",
		"specId": "0366-f-013-cbti-008-r001-challenging-thoughts-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Sleep",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The worksheet captures client-reported sleep-related thoughts and their linked alternative interpretations. It can also preserve practitioner review notes."
			},
			{
				"title": "What It Omits",
				"body": "The tool does not generate alternative thoughts, label cognitive distortions, score thought accuracy, or infer clinical improvement."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated worksheets may reveal recurring cognitive targets over treatment, but the number of entries alone should not be treated as progress."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write alternative thoughts for the client?",
				"answer": "No. The client records alternatives, and the practitioner reviews them. The system does not generate alternatives."
			},
			{
				"question": "Are there cognitive distortion labels?",
				"answer": "No. Distortion labels are not supported by the supplied product specification."
			},
			{
				"question": "Can a worksheet be partially complete?",
				"answer": "Yes. Partial completion is allowed, and blank alternatives remain incomplete rather than being filled automatically."
			},
			{
				"question": "What gets saved from the demo?",
				"answer": "The worksheet tool and reusable assignment configuration are saved. Fictional thought entries and sample notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "constructiveWorryWorksheet",
		"slug": "constructive-worry-worksheet",
		"title": "CBT-I Constructive Worry Worksheet Demo | Qwoach",
		"metaDescription": "Separate actionable worries from concerns that cannot be solved immediately, add next steps, and review themes in CBT-I treatment.",
		"h1": "Constructive Worry Worksheet",
		"intro": "Constructive Worry Worksheet is a CBT-I worksheet for practitioners and insomnia clients. It helps the client separate actionable concerns from worries that cannot be solved immediately and record next steps for issues within their control so the practitioner can review worry themes and actionability.",
		"demoTitle": "Try sorting sample worries and review the worksheet result.",
		"demoPrompt": "Interested in using Constructive Worry Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0367-f-013-cbti-009-r001-constructive-worry-worksheet.md",
		"specId": "0367-f-013-cbti-009-r001-constructive-worry-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Problem solving"
			],
			"topic": [
				"Sleep",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The worksheet captures client-reported worries, whether each is actionable or not immediately solvable, and next steps for actionable concerns."
			},
			{
				"title": "Not a Task Manager",
				"body": "The worksheet does not create reminders, due dates, productivity tracking, or automated problem-solving advice."
			},
			{
				"title": "Review Use",
				"body": "Practitioners can review themes and actionability, while clinical interpretation remains separate from the worksheet grouping."
			}
		],
		"faqItems": [
			{
				"question": "Does every concern need a next step?",
				"answer": "No. Only concerns marked actionable require a next step. Concerns that cannot be solved immediately can be complete without one."
			},
			{
				"question": "Does the worksheet give advice?",
				"answer": "No. It organizes client-reported concerns and next steps but does not generate advice or solve problems automatically."
			},
			{
				"question": "Can a concern stay undecided?",
				"answer": "Yes. A draft or undecided state should be supported when the client is not sure how to categorize a concern."
			},
			{
				"question": "What is saved after exploring the demo?",
				"answer": "The worksheet tool and supported assignment configuration are saved. Fictional worries and sample next steps are not saved as real client data."
			}
		]
	},
	{
		"toolType": "mindfulnessWorksheet",
		"slug": "mindfulness-worksheet",
		"title": "CBT-I Mindfulness Worksheet Demo | Qwoach",
		"metaDescription": "Deliver a low-pressure CBT-I mindfulness worksheet for sleep-related thoughts, sensations, or sleep effort, with optional effects and barriers.",
		"h1": "Mindfulness Worksheet",
		"intro": "Mindfulness Worksheet is a CBT-I support tool for practitioners and insomnia clients. It helps the client relate differently to intrusive thoughts, sensations, or sleep effort around bedtime or nighttime wakefulness, while preserving optional effects or barriers for practitioner review.",
		"demoTitle": "Preview the worksheet flow and optional review notes.",
		"demoPrompt": "Interested in using Mindfulness Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0368-f-013-cbti-010-r001-mindfulness-worksheet.md",
		"specId": "0368-f-013-cbti-010-r001-mindfulness-worksheet",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Sleep",
				"Mindfulness"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Low-Pressure Design",
				"body": "The worksheet should avoid ratings, streaks, and performance mechanics because the skill is meant to reduce sleep effort rather than become another task."
			},
			{
				"title": "Optional Review",
				"body": "Effects and barriers can be discussed in follow-up when useful, especially if the client reports that the practice increases effort or frustration."
			},
			{
				"title": "Content Boundary",
				"body": "Exact mindfulness prompts and practice steps must be supplied by content source or practitioner; the product does not invent them."
			}
		],
		"faqItems": [
			{
				"question": "Does this worksheet score mindfulness skill?",
				"answer": "No. It has no proficiency score, streak, or performance rating."
			},
			{
				"question": "Can the client complete it without writing a note?",
				"answer": "Yes. The client can complete by reviewing the content; effect or barrier notes are optional."
			},
			{
				"question": "Does the tool provide a mindfulness script?",
				"answer": "Only supplied content should be presented. The product specification does not define exact prompts or practice steps."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed worksheet tool is saved as-is. Fictional notes and temporary completion states are not saved as real client data."
			}
		]
	},
	{
		"toolType": "progressiveMuscleRelaxation2",
		"slug": "progressive-muscle-relaxation-2",
		"title": "CBT-I Progressive Muscle Relaxation Demo | Qwoach",
		"metaDescription": "Guide CBT-I clients through supplied PMR tense-release practice with script or step mode, completion state, and optional effect or barrier notes.",
		"h1": "Progressive Muscle Relaxation",
		"intro": "Progressive Muscle Relaxation is a CBT-I relaxation-practice tool for practitioners and insomnia clients. It helps the client follow a supplied sequence of tensing and relaxing muscle groups so they can practice lowering bodily tension or somatic arousal before or during sleep opportunities.",
		"demoTitle": "Preview the guided practice and optional review notes.",
		"demoPrompt": "Interested in using Progressive Muscle Relaxation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0369-f-013-cbti-011-r001-progressive-muscle-relaxation.md",
		"specId": "0369-f-013-cbti-011-r001-progressive-muscle-relaxation",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Sleep",
				"Physiological self-regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practice Formats",
				"body": "The same supplied PMR content can be presented as a script, guided step mode, or supplied recording link when those formats exist."
			},
			{
				"title": "Review Boundary",
				"body": "Optional reported effect or barrier notes are client-reported information for practitioner review, not system-derived effectiveness conclusions."
			},
			{
				"title": "Content Boundary",
				"body": "Exact muscle groups, sequence wording, timing, and script content must be supplied. The product does not invent them."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool include a built-in PMR score?",
				"answer": "No. Progressive Muscle Relaxation has no inherent structured score in this product."
			},
			{
				"question": "Can the client pause and restart?",
				"answer": "Yes. Interruption should allow resume or restart without creating a score from skipped steps."
			},
			{
				"question": "Does the product create the PMR script?",
				"answer": "No. Script, sequence, timing, and prompts must come from supplied content or practitioner-provided material."
			},
			{
				"question": "What gets saved after demo exploration?",
				"answer": "The PMR tool and delivery-format preference, if selected, are saved. Fictional practice notes and placeholder sequence data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "diaphragmaticBreathing",
		"slug": "diaphragmatic-breathing",
		"title": "CBT-I Diaphragmatic Breathing Demo | Qwoach",
		"metaDescription": "Guide CBT-I clients through supplied diaphragmatic breathing practice with optional pace or duration, completion state, and barrier notes.",
		"h1": "Diaphragmatic Breathing",
		"intro": "Diaphragmatic Breathing is a CBT-I relaxation-practice tool for practitioners and insomnia clients. It helps the client practice slow abdominal or diaphragmatic breathing with attention to pace, belly movement, and relaxed exhalation so they can use a portable arousal-reduction skill at bedtime or during nighttime awakenings.",
		"demoTitle": "Preview the guided breathing flow and optional review notes.",
		"demoPrompt": "Interested in using Diaphragmatic Breathing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0370-f-013-cbti-011-r002-diaphragmatic-breathing.md",
		"specId": "0370-f-013-cbti-011-r002-diaphragmatic-breathing",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Sleep",
				"Physiological self-regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Portable Practice",
				"body": "The practice is intended to be simple enough for bedtime or nighttime awakenings and should avoid unnecessary reading or performance pressure."
			},
			{
				"title": "Optional Review",
				"body": "Comfort, perceived effect, barriers, or completion can be reviewed when useful, but none are required ratings."
			},
			{
				"title": "Content Boundary",
				"body": "Exact script, pace, and duration remain supplied or practitioner-entered content. The product does not invent a universal cadence."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool measure breathing or oxygen levels?",
				"answer": "No. It does not collect physiological respiratory measurements or oxygen data."
			},
			{
				"question": "Is a rating required after practice?",
				"answer": "No. Optional notes can capture comfort, perceived effect, or barriers, but ratings are not required."
			},
			{
				"question": "Can the practitioner set the breathing pace?",
				"answer": "Only if pace or duration is supplied or practitioner-entered as part of the breathing exercise. The product does not invent a universal ratio."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The breathing tool and selected duration or pace setup, when applicable, are saved. Fictional notes and sample completion states are not saved as real client data."
			}
		]
	},
	{
		"toolType": "guidedImagery",
		"slug": "guided-imagery",
		"title": "Guided Imagery CBT-I Relaxation Practice | Qwoach",
		"metaDescription": "Create a CBT-I guided imagery exercise with prompt, delivery mode, optional duration, client scene, and descriptive practice review.",
		"h1": "Guided Imagery for CBT-I",
		"intro": "Guided Imagery is a CBT-I relaxation practice for clinicians working with clients whose attention is captured by sleep effort, worry, or threat-focused imagery. It helps the client follow a spoken or written prompt, focus on a personally calming scene, and report descriptive practice completion or response when collected.",
		"demoTitle": "Configure a sample guided imagery exercise and preview the client practice card.",
		"demoPrompt": "Interested in using Guided Imagery with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0371-f-013-cbti-011-r003-guided-imagery.md",
		"specId": "0371-f-013-cbti-011-r003-guided-imagery",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Sleep",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when a CBT-I client needs a relaxation practice that redirects attention from worry, sleep effort, or threat-focused imagery toward a calming sensory focus."
			},
			{
				"title": "What It Captures",
				"body": "The tool can capture the assigned prompt or recording, delivery mode, optional duration, optional client-selected scene, completion state, and optional descriptive response."
			},
			{
				"title": "Important Boundary",
				"body": "Guided Imagery is not a nightmare-focused imagery rehearsal tool, meditation library, assessment, score, or interpretation engine."
			}
		],
		"faqItems": [
			{
				"question": "Does Guided Imagery produce a score?",
				"answer": "No. Guided Imagery produces descriptive practice information such as completion state, selected scene if captured, duration if used, and optional client-reported response."
			},
			{
				"question": "Can the practitioner use a recording?",
				"answer": "Yes. Delivery mode can be therapist-guided, recording, or written handout, and the result can reference the delivered format."
			},
			{
				"question": "Does the client need to enter detailed intrusive thoughts?",
				"answer": "No. The tool deliberately avoids detailed intrusive content and focuses on a calming scene or sensory experience."
			},
			{
				"question": "What happens if the scene is not calming?",
				"answer": "The result can mark the practice as not useful or needing adjustment without interpreting why it was not calming."
			}
		]
	},
	{
		"toolType": "sleepHygieneReview",
		"slug": "sleep-hygiene-review",
		"title": "Sleep Hygiene Review CBT-I Tool | Qwoach",
		"metaDescription": "Identify client-reported sleep-influencing factors and organize them into a modifiable sleep-factor profile for CBT-I review.",
		"h1": "Sleep Hygiene Review",
		"intro": "Sleep Hygiene Review is a CBT-I review tool for practitioners treating insomnia. It helps the client report lifestyle, environment, substance-use, and routine factors so the practitioner can build a client-specific profile of modifiable sleep-influencing factors.",
		"demoTitle": "Open the sample review and inspect the sleep-factor profile.",
		"demoPrompt": "Interested in using Sleep Hygiene Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0372-f-013-cbti-012-r001-sleep-hygiene-review.md",
		"specId": "0372-f-013-cbti-012-r001-sleep-hygiene-review",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Sleep"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The review captures client-reported sleep-influencing factors and can include context, unknown or not applicable responses, free text, and incomplete sections."
			},
			{
				"title": "Practitioner And Client Roles",
				"body": "The client supplies factor information. The practitioner reviews the profile and controls prioritization and clinical notes."
			},
			{
				"title": "History And Comparison",
				"body": "Historical profiles can be revisited to discuss whether targeted practical barriers changed, especially when the same review structure is reused."
			}
		],
		"faqItems": [
			{
				"question": "Does Sleep Hygiene Review diagnose insomnia causes?",
				"answer": "No. It organizes client-reported sleep-influencing factors and does not infer clinical causality or diagnose sleep problems."
			},
			{
				"question": "Can incomplete responses still be reviewed?",
				"answer": "Yes. Incomplete responses produce a partial profile with missing areas visible instead of blocking practitioner review."
			},
			{
				"question": "Who decides which factors are most important?",
				"answer": "The practitioner decides clinical priority. The system may organize information but does not decide clinical importance."
			},
			{
				"question": "Can the review be repeated?",
				"answer": "Yes. Prior profiles can be revisited or compared when the review structure supports comparison."
			}
		]
	},
	{
		"toolType": "cbtIActionPlan",
		"slug": "cbt-i-action-plan",
		"title": "CBT-I Action Plan Self-Management Tool | Qwoach",
		"metaDescription": "Create a personalized CBT-I action plan with targets, barriers, agreed actions, and guidance for what to continue or resume.",
		"h1": "CBT-I Action Plan",
		"intro": "CBT-I Action Plan is a self-management planning tool for CBT-I practitioners and clients. It helps convert current insomnia targets, barriers, and agreed recommendations into a personalized plan for everyday actions and for what to continue, change, or resume when sleep worsens.",
		"demoTitle": "Build a sample action plan and preview the shared client version.",
		"demoPrompt": "Interested in using CBT-I Action Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0373-f-013-cbti-013-r001-cbt-i-action-plan.md",
		"specId": "0373-f-013-cbti-013-r001-cbt-i-action-plan",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Sleep",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the action plan near a transition point, between-session assignment, or consolidation phase when the client needs specific self-management steps."
			},
			{
				"title": "Draft Versus Agreed Items",
				"body": "The tool distinguishes client draft notes and uncertain items from agreed plan content that is ready for client use."
			},
			{
				"title": "Review Over Time",
				"body": "Prior finalized plans persist so later treatment contact can compare changes in targets, barriers, and agreed actions."
			}
		],
		"faqItems": [
			{
				"question": "Does the CBT-I Action Plan generate treatment recommendations?",
				"answer": "No. The system organizes plan content but does not invent CBT-I advice beyond what the practitioner enters or what a supplied plan structure defines."
			},
			{
				"question": "Can the client draft parts of the plan?",
				"answer": "Yes, if client draft plus practitioner review is selected. Draft content remains distinct from agreed plan items."
			},
			{
				"question": "Can finalized plans be updated?",
				"answer": "Yes. Plans can be updated when targets or barriers change, while prior finalized versions remain reviewable."
			},
			{
				"question": "What makes the plan ready?",
				"answer": "The plan is ready when actions are specific enough to guide behavior and agreed items are distinguished from drafts or unresolved discussion points."
			}
		]
	},
	{
		"toolType": "cbtICoachSleepTracker",
		"slug": "cbt-i-coach-sleep-tracker",
		"title": "CBT-I Sleep Tracker and Diary | Qwoach",
		"metaDescription": "Assign a CBT-I sleep tracker for nightly diary entries, missing-night visibility, timing summaries, and practitioner-led review.",
		"h1": "CBT-I Coach Sleep Tracker",
		"intro": "CBT-I Coach Sleep Tracker is a longitudinal sleep diary for CBT-I practitioners and clients. It helps clients record sleep timing and continuity over a review period so practitioners can inspect coverage, patterns, and descriptive summaries during clinical review.",
		"demoTitle": "Explore a sample review window and sleep diary summary.",
		"demoPrompt": "Interested in using CBT-I Coach Sleep Tracker with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0374-f-013-cbti-014-r001-cbt-i-coach-sleep-tracker.md",
		"specId": "0374-f-013-cbti-014-r001-cbt-i-coach-sleep-tracker",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Sleep",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Coverage Matters",
				"body": "The review shows completed, partial, and missing nights so sparse data is visible and not presented as a stable pattern."
			},
			{
				"title": "Reported And Derived Data",
				"body": "Client-reported entries remain separate from descriptive summaries derived from those entries."
			},
			{
				"title": "Longitudinal Review",
				"body": "Historical review periods can be compared when the same diary variables are collected."
			}
		],
		"faqItems": [
			{
				"question": "Does the tracker prescribe sleep restriction or other CBT-I changes?",
				"answer": "No. The tracker presents diary data and descriptive summaries; treatment decisions remain practitioner-led."
			},
			{
				"question": "Can clients enter estimates?",
				"answer": "Yes. Uncertain estimates can be allowed when exact recall is unavailable, while unknown values remain distinguishable from skipped fields."
			},
			{
				"question": "What happens with missing nights?",
				"answer": "Missing nights remain visible in coverage indicators and are not silently averaged away."
			},
			{
				"question": "Can the practitioner compare review periods?",
				"answer": "Yes, comparison is supported when diary structure is consistent across periods."
			}
		]
	},
	{
		"toolType": "activityMonitoringDiary",
		"slug": "activity-monitoring-diary",
		"title": "Activity Monitoring Diary BA Tool | Qwoach",
		"metaDescription": "Map client activities and mood across time with a Behavioral Activation diary for coverage review and practitioner-led target selection.",
		"h1": "Activity Monitoring Diary",
		"intro": "Activity Monitoring Diary is a Behavioral Activation monitoring tool for practitioners and clients. It helps clients record activities and mood close enough in time to show daily patterns that can inform practitioner-led activation target selection.",
		"demoTitle": "Explore a sample activity/mood map.",
		"demoPrompt": "Interested in using Activity Monitoring Diary with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0375-f-014-ba-001-r001-activity-monitoring-diary.md",
		"specId": "0375-f-014-ba-001-r001-activity-monitoring-diary",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Assessment"
			],
			"topic": [
				"Depression",
				"Behavior analysis",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Time Linkage",
				"body": "Activity and mood entries need enough timing information to support meaningful pattern review."
			},
			{
				"title": "Partial Data",
				"body": "Partial days and missing periods remain visible so sparse data is not overstated."
			},
			{
				"title": "Next Step",
				"body": "The diary can inform an activity planning diary, weekly activity schedule, or pleasure and mastery review."
			}
		],
		"faqItems": [
			{
				"question": "Is this a depression assessment?",
				"answer": "No. It is an activity monitoring diary that maps reported activities and mood; it does not produce a diagnostic score."
			},
			{
				"question": "Can the diary use flexible entries instead of fixed intervals?",
				"answer": "Yes. The diary time structure can use fixed intervals or flexible timestamped entries."
			},
			{
				"question": "What if the client records activity without mood?",
				"answer": "The entry remains visible as incomplete linkage rather than being discarded."
			},
			{
				"question": "Who identifies avoidance or low reinforcement?",
				"answer": "The practitioner interprets the reported pattern. The system may organize data descriptively but does not make clinical conclusions."
			}
		]
	},
	{
		"toolType": "activityPlanningDiary",
		"slug": "activity-planning-diary",
		"title": "Activity Planning Diary BA Tool | Qwoach",
		"metaDescription": "Plan specific Behavioral Activation activities, track completed and missed items, and review mood or reinforcement information.",
		"h1": "Activity Planning Diary",
		"intro": "Activity Planning Diary is a Behavioral Activation planning tool for practitioners and clients. It helps clients schedule specific activities, record what was completed or missed, and provide activity-level mood or reinforcement information when collected.",
		"demoTitle": "Create a sample activity plan and review completion outcomes.",
		"demoPrompt": "Interested in using Activity Planning Diary with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0376-f-014-ba-002-r001-activity-planning-diary.md",
		"specId": "0376-f-014-ba-002-r001-activity-planning-diary",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Behavior change",
				"Depression"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Plan Versus Completion",
				"body": "The central review shows planned activities next to completion outcomes so follow-through is visible."
			},
			{
				"title": "Mood Or Reinforcement",
				"body": "When configured, mood or reinforcement information is tied to specific activities rather than collected as a global rating."
			},
			{
				"title": "Cycle-To-Cycle Use",
				"body": "Prior planning cycles can remain available to compare what was realistic, repeated, modified, or replaced."
			}
		],
		"faqItems": [
			{
				"question": "Does the diary recommend activities automatically?",
				"answer": "No. Activities are entered by the client or practitioner; the system does not prescribe unsupported activity recommendations."
			},
			{
				"question": "Can missed activities remain useful?",
				"answer": "Yes. Missed activities remain reviewable and can inform discussion of barriers and next-cycle planning."
			},
			{
				"question": "Can mood or reinforcement be captured?",
				"answer": "Yes, when configured. The information is tied to specific activities and supports practitioner-led review."
			},
			{
				"question": "What happens if a planned activity is vague?",
				"answer": "The activity can remain draft or need clarification until it is specific enough to attempt."
			}
		]
	},
	{
		"toolType": "weeklyActivitySchedule3",
		"slug": "weekly-activity-schedule-3",
		"title": "Weekly Activity Schedule BA Tool | Qwoach",
		"metaDescription": "Build a week-level Behavioral Activation schedule with planned activities, completion status, distribution review, and history.",
		"h1": "Weekly Activity Schedule",
		"intro": "Weekly Activity Schedule is a Behavioral Activation scheduling tool for practitioners and clients. It helps place specific mood-supporting or value-relevant activities into workable times across the week, then review completion and distribution afterward.",
		"demoTitle": "Plan a sample week and review adherence patterns.",
		"demoPrompt": "Interested in using Weekly Activity Schedule with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0377-f-014-ba-003-r001-weekly-activity-schedule.md",
		"specId": "0377-f-014-ba-003-r001-weekly-activity-schedule",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Depression"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Week-Level Visibility",
				"body": "The whole week is visible so clustered, empty, or unevenly distributed activities can be reviewed."
			},
			{
				"title": "Adherence Review",
				"body": "Completed, missed, partial, or unresolved states are shown according to the configured status set."
			},
			{
				"title": "Historical Weeks",
				"body": "Completed weeks persist for comparison with later weeks when schedules repeat."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general calendar?",
				"answer": "No. It is a Behavioral Activation weekly schedule focused on activity targets, distribution, adherence, and review."
			},
			{
				"question": "Can empty days be valid?",
				"answer": "Yes. Empty days are shown but not automatically treated as a problem; practitioner interpretation depends on the plan."
			},
			{
				"question": "Can clients edit the schedule midweek?",
				"answer": "Yes. Future items can be edited, while past completion reports should remain historically stable."
			},
			{
				"question": "Does the tool infer avoidance?",
				"answer": "No. It can show missed activities and patterns, but avoidance interpretation remains practitioner-led."
			}
		]
	},
	{
		"toolType": "myBehaviouralAntidepressants2",
		"slug": "my-behavioural-antidepressants-2",
		"title": "My Behavioural Antidepressants BA Tool | Qwoach",
		"metaDescription": "Create a personalized Behavioral Activation target list with feasible activities, reinforcing qualities, readiness, and scheduling handoff.",
		"h1": "My Behavioural Antidepressants",
		"intro": "My Behavioural Antidepressants is a Behavioral Activation target-identification tool for practitioners and clients. It helps create a personalized list of feasible activities that may offer pleasure, mastery, meaning, or social connection and can feed into scheduling or follow-up review.",
		"demoTitle": "Build a sample activation target list.",
		"demoPrompt": "Interested in using My Behavioural Antidepressants with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0378-f-014-ba-004-r001-my-behavioural-antidepressants.md",
		"specId": "0378-f-014-ba-004-r001-my-behavioural-antidepressants",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Depression"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Produces",
				"body": "The result is a personalized list of possible activation targets, not a schedule or automatic prescription."
			},
			{
				"title": "Feasibility",
				"body": "Targets can be marked ready, needing refinement, not now, or another configured readiness state."
			},
			{
				"title": "Natural Next Step",
				"body": "Selected activities can feed an activity planning diary, weekly schedule, or follow-up review."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate activity recommendations?",
				"answer": "No. The tool organizes client and practitioner activity ideas; it does not auto-generate unsupported prescriptions."
			},
			{
				"question": "Are pleasure, mastery, meaning, and social connection scores?",
				"answer": "No. They are optional descriptive qualities attached to activities when captured."
			},
			{
				"question": "Can the list include ideas that are not feasible now?",
				"answer": "Yes. Not-current or needs-refinement states can preserve ideas without treating them as ready targets."
			},
			{
				"question": "Can selected targets move into scheduling?",
				"answer": "Yes. Selected targets are intended to feed scheduling or follow-up review."
			}
		]
	},
	{
		"toolType": "funActivitiesCatalogue",
		"slug": "fun-activities-catalogue",
		"title": "Fun Activities Catalogue BA Tool | Qwoach",
		"metaDescription": "Present supplied activity prompts, capture selected feasible options, and review barriers for Behavioral Activation planning.",
		"h1": "Fun Activities Catalogue",
		"intro": "Fun Activities Catalogue is a Behavioral Activation prompting aid for practitioners and clients. It presents supplied activity prompts so clients can identify feasible enjoyable or engaging options and carry selected activities into activation planning or follow-up discussion.",
		"demoTitle": "Browse a sample supplied catalogue and review selected options.",
		"demoPrompt": "Interested in using Fun Activities Catalogue with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0379-f-014-ba-005-r001-fun-activities-catalogue.md",
		"specId": "0379-f-014-ba-005-r001-fun-activities-catalogue",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Depression"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Supplied Content Required",
				"body": "The tool presents a supplied catalogue. It does not fabricate catalogue items or categories."
			},
			{
				"title": "Selection Without Rating Every Item",
				"body": "Clients can quickly mark activities that fit without rating every prompt."
			},
			{
				"title": "Planning Handoff",
				"body": "Selected options can be discussed for barriers and moved into activation planning."
			}
		],
		"faqItems": [
			{
				"question": "Does the Fun Activities Catalogue invent activity prompts?",
				"answer": "No. The catalogue requires supplied content from the practitioner or another configured source."
			},
			{
				"question": "Can clients add activities not in the catalogue?",
				"answer": "Yes, if enabled. Client-added options are labeled separately from catalogue items."
			},
			{
				"question": "What if no activities are selected?",
				"answer": "No selection is preserved as a useful review state for practitioner discussion."
			},
			{
				"question": "Does the tool rank activities by expected benefit?",
				"answer": "No. It captures selections and notes but does not infer reward value or rank activities unless supplied by the client or practitioner."
			}
		]
	},
	{
		"toolType": "pleasureAndMasteryRatings",
		"slug": "pleasure-and-mastery-ratings",
		"title": "Pleasure and Mastery Ratings BA Tool | Qwoach",
		"metaDescription": "Capture activity-level pleasure and mastery ratings for Behavioral Activation review, with separate dimensions and descriptive summaries.",
		"h1": "Pleasure and Mastery Ratings",
		"intro": "Pleasure and Mastery Ratings is a Behavioral Activation rating tool for practitioners and clients. It helps clients rate specific activities on separate pleasure and mastery dimensions so practitioners can review activity-level reinforcement patterns.",
		"demoTitle": "Rate sample activities and review the activity-level summary.",
		"demoPrompt": "Interested in using Pleasure and Mastery Ratings with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0380-f-014-ba-006-r001-pleasure-and-mastery-ratings.md",
		"specId": "0380-f-014-ba-006-r001-pleasure-and-mastery-ratings",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Behavior change",
				"Depression"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Activity-Level Ratings",
				"body": "Ratings are tied to specific activities rather than collected as global mood reports."
			},
			{
				"title": "Separate Dimensions",
				"body": "Pleasure and mastery remain distinct so review can consider enjoyment and accomplishment separately."
			},
			{
				"title": "Sparse And Partial Data",
				"body": "Activities with one missing dimension remain partially rated, and sparse data is shown as sparse."
			}
		],
		"faqItems": [
			{
				"question": "Are pleasure and mastery diagnostic scores?",
				"answer": "No. They are descriptive client-reported ratings tied to specific activities."
			},
			{
				"question": "Can the tool be used with an activity schedule?",
				"answer": "Yes. Rated activity source can be a monitoring diary, planning diary, schedule, or direct activity list."
			},
			{
				"question": "What happens if only pleasure or only mastery is rated?",
				"answer": "The entry remains visible as partially rated rather than being treated as complete."
			},
			{
				"question": "Does a high rating guarantee symptom improvement?",
				"answer": "No. The tool shows reported activity-level patterns and does not predict clinical outcomes."
			}
		]
	},
	{
		"toolType": "trapAnalysis",
		"slug": "trap-analysis",
		"title": "TRAP Analysis Demo for Behavioral Activation | Qwoach",
		"metaDescription": "Explore TRAP Analysis, a behavioral activation tool for mapping trigger, response, avoidance pattern, and consequences in client work.",
		"h1": "TRAP Analysis for Behavioral Activation",
		"intro": "TRAP Analysis is a behavioral activation functional-analysis tool for practitioners working with depressed or behaviorally withdrawn clients. It helps identify a real-life Trigger, immediate Response, Avoidance Pattern, and Consequences so the practitioner can understand the maintaining cycle.",
		"demoTitle": "Try a sample TRAP analysis",
		"demoPrompt": "Interested in using TRAP Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0381-f-014-ba-007-r001-trap-analysis.md",
		"specId": "0381-f-014-ba-007-r001-trap-analysis",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Depression"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when avoidance is suspected and the practitioner needs one clear functional sequence rather than a general mood report."
			},
			{
				"title": "What It Does Not Do",
				"body": "TRAP Analysis does not score severity, diagnose, recommend a specific intervention, or infer clinical meaning beyond the reported and organized pattern."
			},
			{
				"title": "History",
				"body": "When several TRAP analyses exist, prior chains can be compared side by side for recurring triggers, responses, or avoidance functions without change scores."
			}
		],
		"faqItems": [
			{
				"question": "Is TRAP Analysis a symptom scale?",
				"answer": "No. TRAP Analysis organizes a functional avoidance sequence and does not collect symptom scores or produce severity ratings."
			},
			{
				"question": "Can the client leave partial answers?",
				"answer": "Yes. Partial answers remain visible, and the review shows which TRAP elements are missing."
			},
			{
				"question": "What changes when I choose recurring-pattern mode?",
				"answer": "Recurring-pattern mode frames the prompts around a repeated pattern and displays a generalized chain with examples when multiple entries exist."
			},
			{
				"question": "Does the tool interpret the client's avoidance for me?",
				"answer": "No. It separates and displays reported information; clinical interpretation remains with the practitioner."
			}
		]
	},
	{
		"toolType": "tracPlan",
		"slug": "trac-plan",
		"title": "TRAC Plan Demo for Alternative Coping | Qwoach",
		"metaDescription": "Explore TRAC Plan, a behavioral activation tool for planning an alternative coping response and reviewing what happened afterward.",
		"h1": "TRAC Plan for Behavioral Activation",
		"intro": "TRAC Plan is a behavioral activation planning tool for practitioners helping clients shift from an identified avoidance response toward a concrete alternative coping response. It helps create a plan for the next recognizable trigger and, when enabled, review what happened afterward.",
		"demoTitle": "Build a sample TRAC plan",
		"demoPrompt": "Interested in using TRAC Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0382-f-014-ba-008-r001-trac-plan.md",
		"specId": "0382-f-014-ba-008-r001-trac-plan",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after an avoidance pattern has been identified and the client needs a concrete response to try before the next trigger occurs."
			},
			{
				"title": "Outcome States",
				"body": "Outcome review can record that the trigger did not occur, the plan was not attempted, or the plan was attempted, with free-text details."
			},
			{
				"title": "What It Does Not Do",
				"body": "TRAC Plan does not recommend coping strategies, score success, diagnose, or decide whether the response was clinically effective."
			}
		],
		"faqItems": [
			{
				"question": "Does TRAC Plan choose the coping strategy for the client?",
				"answer": "No. The practitioner and client define the alternative coping response; the tool records and organizes the plan."
			},
			{
				"question": "Can I use it without a later outcome review?",
				"answer": "Yes. Outcome review can be turned off, in which case the plan represents readiness rather than later learning."
			},
			{
				"question": "What if the trigger never happens?",
				"answer": "The outcome state records that the trigger did not occur instead of treating the plan as failed."
			},
			{
				"question": "Can the client attempt a different response than planned?",
				"answer": "Yes. The review preserves the difference between the intended response and what the client actually tried."
			}
		]
	},
	{
		"toolType": "valuesToActivityMap",
		"slug": "values-to-activity-map",
		"title": "Values-to-Activity Map Demo | Qwoach",
		"metaDescription": "Explore a behavioral activation map that connects client-stated values to feasible activity targets and rationale for scheduling.",
		"h1": "Values-to-Activity Map for Behavioral Activation",
		"intro": "Values-to-Activity Map is a behavioral activation mapping tool for practitioners helping clients choose meaningful activity targets. It helps clients name personal values, link them to feasible activities, and state why those activities are worth trying.",
		"demoTitle": "Map sample values to activities",
		"demoPrompt": "Interested in using Values-to-Activity Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0383-f-014-ba-009-r001-values-to-activity-map.md",
		"specId": "0383-f-014-ba-009-r001-values-to-activity-map",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Values",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client is trying to become more active but proposed activities feel arbitrary, obligation-driven, or disconnected from what matters."
			},
			{
				"title": "What It Captures",
				"body": "The map captures values in the client's own terms, activity targets, and rationale connecting the activity to recovery goals."
			},
			{
				"title": "Limitations",
				"body": "The tool does not provide a standardized values inventory, value ranking, symptom score, diagnostic interpretation, or system-generated values."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool define the client's values?",
				"answer": "No. Values are entered by the client or seeded by the practitioner from prior discussion; the system does not invent them."
			},
			{
				"question": "Can one value have more than one activity?",
				"answer": "Yes. The map supports one or more activity targets linked to a value."
			},
			{
				"question": "What happens if an activity is too broad?",
				"answer": "The review flags broad targets for refinement so they can become specific enough for scheduling or follow-up."
			},
			{
				"question": "Can I start from values already discussed in session?",
				"answer": "Yes. Practitioner-seeded mode lets you begin with priority value areas already discussed."
			}
		]
	},
	{
		"toolType": "avoidancePatternLog",
		"slug": "avoidance-pattern-log",
		"title": "Avoidance Pattern Log Demo | Qwoach",
		"metaDescription": "Explore a behavioral activation log for repeated avoidance episodes, contexts, consequences, and descriptive pattern review.",
		"h1": "Avoidance Pattern Log for Behavioral Activation",
		"intro": "Avoidance Pattern Log is a behavioral activation repeated-data log for practitioners who need longitudinal functional information about avoidance episodes. It helps capture contexts, triggers, avoidance responses, and consequences so recurring patterns can be reviewed.",
		"demoTitle": "Explore a sample avoidance log",
		"demoPrompt": "Interested in using Avoidance Pattern Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0384-f-014-ba-010-r001-avoidance-pattern-log.md",
		"specId": "0384-f-014-ba-010-r001-avoidance-pattern-log",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when one example is not enough and the practitioner needs repeated functional data across time or situations."
			},
			{
				"title": "Pattern Review",
				"body": "Summaries show descriptive recurrence and remain traceable to underlying entries; they do not create severity scores or diagnostic conclusions."
			},
			{
				"title": "Partial And Sparse Data",
				"body": "Sparse entries are preserved, partial fields remain visible, and insufficient data is labeled rather than filled in."
			}
		],
		"faqItems": [
			{
				"question": "Is this a daily mood diary?",
				"answer": "No. The log captures avoidance episodes and functional context, not unrelated daily diary content or symptom scores."
			},
			{
				"question": "Can clients record approximate timing?",
				"answer": "Yes. Approximate timing is supported to reduce burden while preserving useful sequence information."
			},
			{
				"question": "What happens with partial entries?",
				"answer": "Partial entries remain reviewable, and missing fields stay visible in the result."
			},
			{
				"question": "Can summaries be traced back to entries?",
				"answer": "Yes. Pattern summaries must remain traceable to the individual episodes that produced them."
			}
		]
	},
	{
		"toolType": "taskPlanningAndAchievementRecord",
		"slug": "task-planning-and-achievement-record",
		"title": "Task Planning and Achievement Record Demo | Qwoach",
		"metaDescription": "Explore a therapeutic task planning and review tool for tracking follow-through, achievement, barriers, and next adjustment decisions.",
		"h1": "Task Planning and Achievement Record",
		"intro": "Task Planning and Achievement Record is a behavioral activation and therapeutic-task follow-through tool for practitioners assigning between-session tasks. It helps define the intended task, capture achievement and barriers, and support the next adjustment decision.",
		"demoTitle": "Try a sample task record",
		"demoPrompt": "Interested in using Task Planning and Achievement Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0385-f-014-ba-011-r001-task-planning-and-achievement-record.md",
		"specId": "0385-f-014-ba-011-r001-task-planning-and-achievement-record",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Homework",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Completion States",
				"body": "The review supports completed, partially completed, not attempted, and blocked outcomes so noncompletion can still produce useful information."
			},
			{
				"title": "Repeated Tasks",
				"body": "Repeated-attempt mode shows changes in completion and barriers over time while keeping each outcome attached to the original task wording."
			},
			{
				"title": "Limitations",
				"body": "The tool does not provide generic productivity metrics, automated task difficulty recommendations, or unrelated calendar features."
			}
		],
		"faqItems": [
			{
				"question": "Is this a productivity tracker?",
				"answer": "No. It is anchored to therapeutic or activation tasks and focuses on achievement, barriers, and clinical adjustment."
			},
			{
				"question": "Can a client submit when they did not complete the task?",
				"answer": "Yes. Not attempted and blocked outcomes are valid because barriers are useful review information."
			},
			{
				"question": "What if the task is too vague?",
				"answer": "The tool flags unclear task definitions as not reviewable until the task is specific enough to judge follow-through."
			},
			{
				"question": "Can the same task be reviewed more than once?",
				"answer": "Yes. Repeated-attempt mode supports a sequence of attempts and barriers for the same task."
			}
		]
	},
	{
		"toolType": "weeklyGoalsRecord2",
		"slug": "weekly-goals-record-2",
		"title": "Weekly Goals Record Demo | Qwoach",
		"metaDescription": "Explore a weekly goal progress record for behavioral activation, including follow-through, obstacles, blocked attempts, and next decisions.",
		"h1": "Weekly Goals Record for Behavioral Activation",
		"intro": "Weekly Goals Record is a depression and behavioral activation goal progress tool for practitioners and clients working with agreed weekly goals. It helps track follow-through, progress, blocked attempts, obstacles, and next-step decisions for the week.",
		"demoTitle": "Explore a sample weekly record",
		"demoPrompt": "Interested in using Weekly Goals Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0386-f-014-ba-012-r001-weekly-goals-record.md",
		"specId": "0386-f-014-ba-012-r001-weekly-goals-record",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Depression"
			],
			"population": []
		},
		"sections": [
			{
				"title": "The Unit Of Review",
				"body": "The week is the unit of review. Goals anchor all progress entries and obstacles for that interval."
			},
			{
				"title": "Progress And Obstacles",
				"body": "The record distinguishes no data, no attempt, blocked attempt, partial progress, and completed progress when those states are reported."
			},
			{
				"title": "History",
				"body": "Sequential weekly history can show goal progression and repeated barriers without converting them into unsupported scores."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create goals automatically?",
				"answer": "No. The practitioner sets or confirms agreed weekly goals; the tool tracks what happens with them."
			},
			{
				"question": "Can blocked attempts be recorded separately from no attempt?",
				"answer": "Yes. Blocked attempts are preserved separately from non-attempts because they support different review decisions."
			},
			{
				"question": "What if a goal changes midweek?",
				"answer": "The original and revised wording remain visible so the weekly review is not confused."
			},
			{
				"question": "Is this a calendar app?",
				"answer": "No. It uses week boundaries for goal review but does not collect unrelated calendar events or generic reminders."
			}
		]
	},
	{
		"toolType": "gradedTaskAssignment2",
		"slug": "graded-task-assignment-2",
		"title": "Graded Task Assignment Demo | Qwoach",
		"metaDescription": "Explore a behavioral activation tool for breaking overwhelming tasks into graded steps and reviewing step completion and barriers.",
		"h1": "Graded Task Assignment for Behavioral Activation",
		"intro": "Graded Task Assignment is a behavioral activation tool for practitioners helping depressed or behaviorally inactive clients approach a larger task in manageable steps. It helps define an ordered path, assign the current next step, and review completion and barriers.",
		"demoTitle": "Build a sample graded task",
		"demoPrompt": "Interested in using Graded Task Assignment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0387-f-014-ba-013-r001-graded-task-assignment.md",
		"specId": "0387-f-014-ba-013-r001-graded-task-assignment",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Goals",
				"Depression"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client Visibility",
				"body": "Next-step-only mode can reduce overwhelm; full-path mode supports orientation. Both preserve the same step data for review."
			},
			{
				"title": "Barriers And Skips",
				"body": "Skipped steps, blocked attempts, and barriers remain visible rather than being forced into linear completion."
			},
			{
				"title": "Limitations",
				"body": "The tool does not auto-generate substantive graded steps, assign clinical mastery scores, or add generic project-management fields."
			}
		],
		"faqItems": [
			{
				"question": "Does the system generate the graded steps?",
				"answer": "No. The practitioner and client provide the steps; the tool organizes and tracks them."
			},
			{
				"question": "Can the client see only the next step?",
				"answer": "Yes. Step visibility can be set to next-step-only or full-path."
			},
			{
				"question": "What happens if a step is skipped?",
				"answer": "The record preserves the skipped step without forcing linear completion."
			},
			{
				"question": "Can barriers be recorded if no step was attempted?",
				"answer": "Yes. Barriers can still be recorded and reviewed because they may guide adjustment."
			}
		]
	},
	{
		"toolType": "activationReview",
		"slug": "activation-review",
		"title": "Activation Review Demo | Qwoach",
		"metaDescription": "Explore a behavioral activation review tool for learning from attempted activities and deciding what to repeat, adapt, or replace.",
		"h1": "Activation Review for Behavioral Activation",
		"intro": "Activation Review is a behavioral activation review tool for practitioners and clients after planned activities have been tried. It helps capture what happened, what was learned about mood, reward, barriers, or avoidance, and what to repeat, adapt, or replace next.",
		"demoTitle": "Review a sample activity",
		"demoPrompt": "Interested in using Activation Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0388-f-014-ba-014-r001-activation-review.md",
		"specId": "0388-f-014-ba-014-r001-activation-review",
		"tags": {
			"framework": [
				"Behavioral Activation"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after planned activation activities have been attempted, blocked, avoided, or completed and the next planning cycle needs better information."
			},
			{
				"title": "Supported Review Outcomes",
				"body": "The tool supports successful, mixed, blocked, avoided, and incomplete attempts as useful review data."
			},
			{
				"title": "Limitations",
				"body": "Activation Review does not schedule activities by itself, produce unsupported mood scales, or make automated treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can I review an activity that was not completed?",
				"answer": "Yes. Noncompletion, avoidance, and barriers can still inform the next planning decision."
			},
			{
				"question": "Does the tool decide whether an activity worked?",
				"answer": "No. It captures descriptive learning and next-step implications; clinical interpretation remains with the practitioner."
			},
			{
				"question": "Can several activities be reviewed together?",
				"answer": "Yes. Activity-set review can summarize a small set while keeping each activity identifiable."
			},
			{
				"question": "What are the next-step implication options?",
				"answer": "The review supports repeat, adapt, or replace implications when selected by the practitioner or client."
			}
		]
	},
	{
		"toolType": "eatingDisorderExaminationEde",
		"slug": "eating-disorder-examination-ede",
		"title": "Eating Disorder Examination EDE Demo | Qwoach",
		"metaDescription": "Explore the practitioner-only EDE assessment workflow for structured profile capture, completion tracking, and comparable reassessment handling.",
		"h1": "Eating Disorder Examination (EDE) Practitioner Assessment",
		"intro": "Eating Disorder Examination (EDE) is a practitioner-only structured eating-disorder psychopathology assessment for practitioners assessing suspected or known eating-disorder presentations. It helps organize defined severity, diagnostic-relevant, and symptom-profile information when the exact EDE content is available.",
		"demoTitle": "Preview the practitioner assessment workflow",
		"demoPrompt": "Interested in using Eating Disorder Examination (EDE) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0389-f-015-cbte-001-r001-eating-disorder-examination-ede.md",
		"specId": "0389-f-015-cbte-001-r001-eating-disorder-examination-ede",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Eating disorders"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "There is no separate self-directed client workflow in this configuration. The assessed person provides information through practitioner administration."
			},
			{
				"title": "Unresolved Measure Structure",
				"body": "Exact EDE prompts, item structure, scoring rules, domains, and administration rules are not supplied in the product specification and must remain unavailable rather than approximated."
			},
			{
				"title": "Reassessment",
				"body": "Reassessment comparison is supported only when the same defined EDE structure is used across assessments."
			}
		],
		"faqItems": [
			{
				"question": "Does this demo include EDE interview questions?",
				"answer": "No. Exact EDE prompts and item structures are not supplied, so the demo does not invent or approximate them."
			},
			{
				"question": "Is there a client self-report view?",
				"answer": "No. This configuration is practitioner-only; the assessed person participates through practitioner administration."
			},
			{
				"question": "Can the tool calculate EDE outputs?",
				"answer": "Only when calculations or summaries are explicitly defined by supplied EDE content; otherwise derivations are withheld."
			},
			{
				"question": "What happens if an assessment is incomplete?",
				"answer": "Incomplete administrations are marked partial and do not present complete-profile outputs."
			}
		]
	},
	{
		"toolType": "cbtEAssessmentTopicsChecklist",
		"slug": "cbt-e-assessment-topics-checklist",
		"title": "CBT-E Assessment Topics Checklist Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only CBT-E assessment coverage workflow for tracking topics, gaps, notes, and formulation readiness.",
		"h1": "CBT-E Assessment Topics Checklist",
		"intro": "CBT-E Assessment Topics Checklist is a practitioner-only structured coverage checklist for practitioners assessing eating problems in CBT-E-oriented care. It helps track covered topics, notes, gaps, and formulation readiness once the exact supported topic structure is supplied.",
		"demoTitle": "Preview the checklist workflow",
		"demoPrompt": "Interested in using CBT-E Assessment Topics Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0390-f-015-cbte-002-r001-cbt-e-assessment-topics-checklist.md",
		"specId": "0390-f-015-cbte-002-r001-cbt-e-assessment-topics-checklist",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Eating disorders"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Coverage Aid",
				"body": "The checklist supports the practitioner's assessment conversation and does not create a separate client self-report workflow."
			},
			{
				"title": "Unresolved Topics",
				"body": "Exact CBT-E topics, wording, prompts, fields, and allowed statuses are not supplied, so the demo must label the topic structure as unresolved."
			},
			{
				"title": "Gaps And Notes",
				"body": "Once topics are defined, the review can show covered topics, missing topics, practitioner notes, and current/background distinctions where entered."
			}
		],
		"faqItems": [
			{
				"question": "Does this demo include the CBT-E topic list?",
				"answer": "No. Exact CBT-E topics are not supplied, so the demo does not invent a topic list."
			},
			{
				"question": "Is this a scoring instrument?",
				"answer": "No. The checklist tracks coverage and gaps; it does not create ratings, severity scores, or automated formulations."
			},
			{
				"question": "Is there a client form to fill out?",
				"answer": "No. This configuration is practitioner-only and supports the practitioner's assessment conversation."
			},
			{
				"question": "What happens if topics are incomplete or unresolved?",
				"answer": "The product labels the structure as unresolved and does not imply comprehensive coverage."
			}
		]
	},
	{
		"toolType": "realTimeSelfMonitoringRecord",
		"slug": "real-time-self-monitoring-record",
		"title": "Real-Time Self-Monitoring Record for CBT-E | Qwoach",
		"metaDescription": "Explore a CBT-E self-monitoring record for capturing eating-related episodes in real time and reviewing descriptive patterns across days.",
		"h1": "Real-Time Self-Monitoring Record",
		"intro": "The Real-Time Self-Monitoring Record is a CBT-E tool for practitioners working with clients whose eating-related episodes, thoughts, emotions, circumstances, or behaviors need to be understood close to when they occur. It helps the practitioner collect high-frequency treatment data and review visible patterns across repeated entries.",
		"demoTitle": "Start with sample entries, adjust the practitioner instruction, then preview the client record and practitioner review.",
		"demoPrompt": "Interested in using Real-Time Self-Monitoring Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0391-f-015-cbte-003-r001-real-time-self-monitoring-record.md",
		"specId": "0391-f-015-cbte-003-r001-real-time-self-monitoring-record",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Eating disorders"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during periods when eating-related events need to be recorded close to occurrence rather than reconstructed later."
			},
			{
				"title": "What It Captures",
				"body": "The record captures client-reported eating-related episodes or behaviors and supported details such as timing, circumstances, thoughts, emotions, and compensatory behaviors where available."
			},
			{
				"title": "Important Limits",
				"body": "The tool organizes reported data and descriptive summaries. It does not diagnose, score severity, identify definitive maintaining mechanisms, or recommend interventions."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool score eating-disorder severity?",
				"answer": "No. The tool does not score severity or produce diagnostic conclusions; it organizes reported entries for practitioner review."
			},
			{
				"question": "Can clients submit incomplete entries?",
				"answer": "Yes. Partial entries can remain visible as partial so the practitioner can distinguish incomplete data from completed records."
			},
			{
				"question": "What happens if no entries are submitted during a period?",
				"answer": "No entries are treated as absence of submitted data, not as proof that no episodes occurred."
			},
			{
				"question": "Can the practitioner change the monitoring focus?",
				"answer": "Yes. The practitioner can clarify what kinds of events to record, and focus changes should remain visible because they affect comparison over time."
			}
		]
	},
	{
		"toolType": "weightChart",
		"slug": "weight-chart",
		"title": "CBT-E Weight Chart Demo | Qwoach",
		"metaDescription": "Explore a CBT-E weight chart for recording repeated weight points, viewing longitudinal trends, and supporting practitioner-led review.",
		"h1": "Weight Chart",
		"intro": "The Weight Chart is a CBT-E tool for practitioners who monitor weight change collaboratively over time. It helps the practitioner record repeated weight points, view the client's trajectory, and discuss the trend in relation to treatment context.",
		"demoTitle": "Use fictional measurements to inspect the chart, add a point, and review the longitudinal graph.",
		"demoPrompt": "Interested in using Weight Chart with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0392-f-015-cbte-004-r001-weight-chart.md",
		"specId": "0392-f-015-cbte-004-r001-weight-chart",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Graph"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Eating disorders",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Shows",
				"body": "The chart shows recorded weight values across dated time points, with the graph as the primary view and exact point details available for inspection."
			},
			{
				"title": "Sparse Data",
				"body": "A single point is shown as a baseline rather than a trend. Missing periods appear as gaps rather than assumed stability."
			},
			{
				"title": "Important Limits",
				"body": "The tool charts recorded values and basic descriptive change. It does not diagnose, assign risk labels, set goals, or interpret clinical significance automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does the chart assign eating-disorder risk categories?",
				"answer": "No. The chart displays recorded weight data over time and leaves clinical interpretation to the practitioner."
			},
			{
				"question": "Can the chart show only one measurement?",
				"answer": "Yes. One measurement is shown as a baseline because a trend requires repeated time points."
			},
			{
				"question": "Are missing sessions treated as stable weight?",
				"answer": "No. Missing sessions appear as gaps rather than assumed stability or change."
			},
			{
				"question": "Can clients enter their own values?",
				"answer": "A separate client-entered experience is not required by the supplied specification; the supported client experience is collaborative viewing during weighing or review."
			}
		]
	},
	{
		"toolType": "personalCbtEFormulation",
		"slug": "personal-cbt-e-formulation",
		"title": "Personal CBT-E Formulation Demo | Qwoach",
		"metaDescription": "Explore a collaborative CBT-E formulation tool for mapping client-specific experiences, language, and maintaining mechanisms.",
		"h1": "Personal CBT-E Formulation",
		"intro": "The Personal CBT-E Formulation is a collaborative CBT-E tool for practitioners and clients working to understand what maintains an eating problem. It helps them map client-specific experiences, wording, and maintaining mechanisms into a shared formulation for treatment discussion.",
		"demoTitle": "Open the sample map, add a fictional client phrase, link elements, and review the working formulation.",
		"demoPrompt": "Interested in using Personal CBT-E Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0393-f-015-cbte-005-r001-personal-cbt-e-formulation.md",
		"specId": "0393-f-015-cbte-005-r001-personal-cbt-e-formulation",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning",
				"In-session support"
			],
			"topic": [
				"Eating disorders"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Collaborative Roles",
				"body": "The practitioner facilitates and edits the clinical formulation; the client contributes wording, examples, and recognition of whether the map fits their experience."
			},
			{
				"title": "Working Drafts",
				"body": "Incomplete maps should be labeled as working formulations so they are not mistaken for final shared understanding."
			},
			{
				"title": "Important Limits",
				"body": "The tool organizes entered formulation elements and links. It does not generate clinical conclusions, diagnose, score, or choose interventions."
			}
		],
		"faqItems": [
			{
				"question": "Is this completed by the client alone?",
				"answer": "No. The specified experience is collaborative completion with practitioner facilitation and client contribution."
			},
			{
				"question": "Does the tool generate the formulation automatically?",
				"answer": "No. The system visually organizes entered elements and links; formulation content comes from practitioner and client input."
			},
			{
				"question": "Can the formulation change over time?",
				"answer": "Yes. The formulation can be revised as treatment understanding develops, with prior states kept distinguishable where needed."
			},
			{
				"question": "Are exact CBT-E diagram labels defined?",
				"answer": "No. The exact diagram structure, prompts, labels, and worksheet fields are unresolved in the supplied specification."
			}
		]
	},
	{
		"toolType": "transdiagnosticCbtEFormulation",
		"slug": "transdiagnostic-cbt-e-formulation",
		"title": "Transdiagnostic CBT-E Formulation Demo | Qwoach",
		"metaDescription": "Explore a structured CBT-E formulation tool for mapping transdiagnostic maintaining processes to a client-specific presentation.",
		"h1": "Transdiagnostic CBT-E Formulation",
		"intro": "The Transdiagnostic CBT-E Formulation is a collaborative tool for CBT-E practitioners and clients. It helps represent how common transdiagnostic maintaining processes apply to a specific eating-disorder presentation so treatment focus can be discussed clearly.",
		"demoTitle": "Use fictional examples to populate the structured map, link elements, and review the working formulation.",
		"demoPrompt": "Interested in using Transdiagnostic CBT-E Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0394-f-015-cbte-006-r001-transdiagnostic-cbt-e-formulation.md",
		"specId": "0394-f-015-cbte-006-r001-transdiagnostic-cbt-e-formulation",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning",
				"In-session support"
			],
			"topic": [
				"Eating disorders"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Structured but Case-Specific",
				"body": "The formulation keeps a stable transdiagnostic structure while allowing practitioner and client to add case-specific content where supported."
			},
			{
				"title": "Revision Over Time",
				"body": "Working formulations can be revisited as treatment understanding changes, with prior states preserved enough to avoid confusing old and current conceptualizations."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not invent model content, score the case, or automatically sequence interventions."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool automatically choose CBT-E interventions?",
				"answer": "No. It supports formulation and treatment-focus discussion but does not generate intervention sequences."
			},
			{
				"question": "Can the structure be freely changed?",
				"answer": "No. The formulation should remain a stable structured CBT-E formulation; case-specific entries and links are editable content."
			},
			{
				"question": "Is client input part of the tool?",
				"answer": "Yes. The client contributes examples and checks whether the structured model relates to their current difficulties."
			},
			{
				"question": "Are exact fields defined?",
				"answer": "No. The exact formulation labels, prompts, and field structure are unresolved in the supplied specification."
			}
		]
	},
	{
		"toolType": "regularEatingPlan",
		"slug": "regular-eating-plan",
		"title": "CBT-E Regular Eating Plan Demo | Qwoach",
		"metaDescription": "Explore a CBT-E regular eating plan for setting a daily pattern, tracking adherence, and reviewing missed, delayed, or disrupted episodes.",
		"h1": "Regular Eating Plan",
		"intro": "The Regular Eating Plan is a CBT-E tool for practitioners working with clients whose eating is irregular, restrictive, or reactive. It helps define a daily eating pattern, track completed, missed, delayed, or disrupted episodes, and review barriers over time.",
		"demoTitle": "Create a fictional daily plan, mark sample episodes, and inspect the plan-versus-actual review.",
		"demoPrompt": "Interested in using Regular Eating Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0395-f-015-cbte-007-r001-regular-eating-plan.md",
		"specId": "0395-f-015-cbte-007-r001-regular-eating-plan",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Eating disorders",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Tracks",
				"body": "The tool tracks the intended eating pattern, recorded completion, missed or delayed episodes, disruptions, and barriers."
			},
			{
				"title": "Plan Changes",
				"body": "When the practitioner changes the plan, the change applies prospectively so prior adherence remains tied to the plan active at that time."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not prescribe nutritional content, judge dietary adequacy, score compliance morally, or generate treatment conclusions."
			}
		],
		"faqItems": [
			{
				"question": "What is saved when I save the demo plan?",
				"answer": "The tool itself and the practitioner-defined eating pattern are saved; fictional sample statuses and barriers are not saved as real client data."
			},
			{
				"question": "Does the tool track calories or nutrition?",
				"answer": "No. It tracks the regular eating pattern and client-reported follow-through, disruptions, and barriers."
			},
			{
				"question": "Are incomplete days treated as missed eating?",
				"answer": "No. Incomplete daily data are marked separately from missed episodes."
			},
			{
				"question": "Can the plan change over time?",
				"answer": "Yes. Plan changes apply to future monitoring and preserve past comparisons against the plan used at that time."
			}
		]
	},
	{
		"toolType": "bingeAnalysis",
		"slug": "binge-analysis",
		"title": "CBT-E Binge Analysis Demo | Qwoach",
		"metaDescription": "Explore a CBT-E binge analysis tool for mapping antecedents, episode features, consequences, and recurring patterns across episodes.",
		"h1": "Binge Analysis",
		"intro": "Binge Analysis is a CBT-E tool for practitioners and clients working to understand binge-eating episodes. It helps organize antecedents, episode features, thoughts, emotions, dietary patterns, triggers, and consequences so possible treatment targets can be discussed.",
		"demoTitle": "Analyze a fictional episode, link before/during/after details, and review the functional sequence.",
		"demoPrompt": "Interested in using Binge Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0396-f-015-cbte-008-r001-binge-analysis.md",
		"specId": "0396-f-015-cbte-008-r001-binge-analysis",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Eating disorders",
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Organizes",
				"body": "The analysis organizes antecedents, episode features, thoughts, emotions, dietary patterns, triggers, and consequences around a specific binge episode."
			},
			{
				"title": "Unknown Details",
				"body": "When the client cannot recall a detail, the field can remain unknown rather than being forced."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not diagnose binge eating, score severity, make causal conclusions, or prescribe interventions."
			}
		],
		"faqItems": [
			{
				"question": "Is Binge Analysis a diagnostic tool?",
				"answer": "No. It organizes reported episode information for functional analysis and treatment discussion; it does not diagnose."
			},
			{
				"question": "Can details be left unknown?",
				"answer": "Yes. Unknown or unrecalled details can remain unknown rather than being forced into the record."
			},
			{
				"question": "Can multiple episodes be compared?",
				"answer": "Yes. Multiple analyses can support comparison of recurring antecedents or consequences over time."
			},
			{
				"question": "Does the tool recommend interventions?",
				"answer": "No. The analysis may make possible targets visible, but intervention planning remains outside the tool."
			}
		]
	},
	{
		"toolType": "shapeCheckingMonitoringRecord",
		"slug": "shape-checking-monitoring-record",
		"title": "Shape Checking Monitoring Record Demo | Qwoach",
		"metaDescription": "Explore a CBT-E monitoring record for tracking shape-checking episodes, frequency, context, form of checking, and change over time.",
		"h1": "Shape Checking Monitoring Record",
		"intro": "The Shape Checking Monitoring Record is a CBT-E tool for practitioners working with clients who engage in shape checking. It helps record when, how often, and under what circumstances checking occurs so frequency, context, form, and change over time can be reviewed.",
		"demoTitle": "Try a sample monitoring focus, log fictional checking episodes, and review the frequency and context view.",
		"demoPrompt": "Interested in using Shape Checking Monitoring Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0397-f-015-cbte-009-r001-shape-checking-monitoring-record.md",
		"specId": "0397-f-015-cbte-009-r001-shape-checking-monitoring-record",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Eating disorders",
				"Safety behaviors"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The record captures checking episodes, timing or frequency information, context or trigger, and form of checking where supported."
			},
			{
				"title": "No-Entry Periods",
				"body": "No entries should be treated as missing data unless otherwise confirmed, not as proof that no checking occurred."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not collect body measurements, appearance judgments, unsupported ratings, or clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool ask clients to evaluate their appearance?",
				"answer": "No. It tracks checking behavior, context, and form without collecting appearance judgments."
			},
			{
				"question": "Can repeated checking be grouped?",
				"answer": "Only if the practitioner defines that instruction; otherwise repeated episodes should remain clear for review."
			},
			{
				"question": "Does no entry mean no shape checking occurred?",
				"answer": "No. No entries are missing submitted data unless explicitly confirmed otherwise."
			},
			{
				"question": "Can the monitoring focus change?",
				"answer": "Yes. The practitioner may clarify the focus, and changes should remain visible because they affect comparability."
			}
		]
	},
	{
		"toolType": "bodyImageRecord",
		"slug": "body-image-record",
		"title": "CBT-E Body Image Record Demo | Qwoach",
		"metaDescription": "Explore a CBT-E Body Image Record for monitoring body-image experiences, triggers, responses, and descriptive patterns over time.",
		"h1": "Body Image Record",
		"intro": "The Body Image Record is a CBT-E tool for practitioners working with active body-image concerns in eating-disorder treatment. It helps clients record body-image experiences, triggers, thoughts, feelings, behaviors, and responses so patterns can be reviewed clinically.",
		"demoTitle": "Use fictional entries to try the client record, adjust the monitoring focus, and inspect the trigger-response review.",
		"demoPrompt": "Interested in using Body Image Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0398-f-015-cbte-010-r001-body-image-record.md",
		"specId": "0398-f-015-cbte-010-r001-body-image-record",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Eating disorders"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The record captures reported body-image experiences, situations or triggers, thoughts, feelings, behaviors, and responses to distress where available."
			},
			{
				"title": "Neutral Recording",
				"body": "The client experience should preserve the client's wording without requiring appearance judgments or unsupported ratings."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not score body image, evaluate appearance, diagnose, or automatically decide which processes maintain the eating disorder."
			}
		],
		"faqItems": [
			{
				"question": "Does the Body Image Record ask for body measurements?",
				"answer": "No. Body measurements are deliberately not collected by this tool."
			},
			{
				"question": "Can entries be incomplete?",
				"answer": "Yes. Partial entries are allowed when the client remembers only part of the experience or response."
			},
			{
				"question": "Does the tool identify maintaining processes automatically?",
				"answer": "No. It organizes reported data descriptively; practitioner interpretation happens during review."
			},
			{
				"question": "Does no entry mean no body-image distress occurred?",
				"answer": "No. No entries should be treated as missing submitted data, not as proof that distress was absent."
			}
		]
	},
	{
		"toolType": "dietaryRulesInventory",
		"slug": "dietary-rules-inventory",
		"title": "CBT-E Dietary Rules Inventory Demo | Qwoach",
		"metaDescription": "Explore a CBT-E Dietary Rules Inventory for identifying rigid food rules, effects on eating, and priority targets for treatment planning.",
		"h1": "Dietary Rules Inventory",
		"intro": "The Dietary Rules Inventory is a CBT-E tool for practitioners and clients when eating is shaped by rigid food or eating rules. It helps name specific rules, record how they constrain eating, and distinguish priority rules for intervention planning.",
		"demoTitle": "Add fictional rules, record their effects, mark a priority, and review the inventory.",
		"demoPrompt": "Interested in using Dietary Rules Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0399-f-015-cbte-011-r001-dietary-rules-inventory.md",
		"specId": "0399-f-015-cbte-011-r001-dietary-rules-inventory",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Eating disorders",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Specificity Matters",
				"body": "The inventory is for naming specific dietary rules rather than broad labels such as general restriction."
			},
			{
				"title": "Priority Is Selected",
				"body": "Priority rules are distinguished by practitioner/client selection, not by automated scoring."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate rules, prescribe dietary changes, provide calorie targets, or conduct rule-challenging work."
			}
		],
		"faqItems": [
			{
				"question": "Does the inventory automatically rank dietary rules?",
				"answer": "No. Priority is selected by the practitioner and client; it is not automatically inferred or scored."
			},
			{
				"question": "Can a rule be entered without a clear effect?",
				"answer": "Yes. Uncertain effects can remain unresolved and be edited later."
			},
			{
				"question": "Does the tool prescribe what the client should eat?",
				"answer": "No. It identifies rules and reported effects; dietary change planning happens outside the inventory."
			},
			{
				"question": "Are broad categories of rules required?",
				"answer": "No. The supplied specification does not define rule categories, so the inventory should avoid forcing unsupported categories."
			}
		]
	},
	{
		"toolType": "overEvaluationOfShapeWeightFormulation",
		"slug": "over-evaluation-of-shape-weight-formulation",
		"title": "Over-evaluation of Shape/Weight Formulation Demo | Qwoach",
		"metaDescription": "Explore a CBT-E formulation tool for mapping how over-evaluation of shape or weight links to behaviors, emotions, and feedback loops.",
		"h1": "Over-evaluation of Shape/Weight Formulation",
		"intro": "The Over-evaluation of Shape/Weight Formulation is a collaborative CBT-E tool for practitioners and clients. It helps make explicit how excessive importance placed on shape or weight links to behaviors, emotional consequences, and maintaining feedback loops in a client's own experience.",
		"demoTitle": "Add fictional examples, connect feedback loops, and review the shared working formulation.",
		"demoPrompt": "Interested in using Over-evaluation of Shape/Weight Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0400-f-015-cbte-012-r001-over-evaluation-of-shape-weight-formulation.md",
		"specId": "0400-f-015-cbte-012-r001-over-evaluation-of-shape-weight-formulation",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning",
				"In-session support"
			],
			"topic": [
				"Eating disorders"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Shared Formulation",
				"body": "The tool is completed collaboratively: the practitioner facilitates and edits, and the client contributes examples and checks whether the formulation applies."
			},
			{
				"title": "Feedback Loops",
				"body": "The map should make maintaining feedback loops visible enough to guide discussion of treatment focus."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not rate appearance, score self-worth, diagnose, or generate automatic intervention recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool ask the client to rate their appearance or self-worth?",
				"answer": "No. The specification excludes unsupported appearance or self-worth ratings."
			},
			{
				"question": "Is the formulation automatically generated?",
				"answer": "No. The system displays and organizes the content entered by the practitioner and client."
			},
			{
				"question": "What if the client does not recognize the formulation?",
				"answer": "Client disagreement or lack of recognition should remain visible as a formulation issue rather than being forced into completion."
			},
			{
				"question": "Can the formulation be revised later?",
				"answer": "Yes. The formulation can be revisited and revised, with prior understanding preserved where clinically relevant."
			}
		]
	},
	{
		"toolType": "feelingsOfFatnessAnalysis",
		"slug": "feelings-of-fatness-analysis",
		"title": "Feelings of Fatness Analysis Demo | Qwoach",
		"metaDescription": "Explore a CBT-E tool for mapping situations, meanings, and emotions behind a client's reported feelings of fatness during treatment.",
		"h1": "Feelings of Fatness Analysis",
		"intro": "Feelings of Fatness Analysis is a CBT-E structured reflection aid for eating-disorder practitioners. It helps a practitioner and client identify the situations, meanings, and emotions associated with the client reporting a feeling of fatness.",
		"demoTitle": "Try the shared analysis with sample, non-identifying entries.",
		"demoPrompt": "Interested in using Feelings of Fatness Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0401-f-015-cbte-013-r001-feelings-of-fatness-analysis.md",
		"specId": "0401-f-015-cbte-013-r001-feelings-of-fatness-analysis",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"In-session support"
			],
			"topic": [
				"Eating disorders"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during eating-disorder treatment when the client reports feeling fat and the practitioner wants to understand the subjective experience, its triggers, and its meanings."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not assess body size, calculate scores, diagnose, prescribe treatment steps, collect measurements, or act as a generic thought record."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool assess body size?",
				"answer": "No. It distinguishes reported feelings from objective body-size information and focuses on triggers, meanings, and related emotions."
			},
			{
				"question": "Can the analysis be incomplete?",
				"answer": "Yes. Unresolved cues, meanings, or examples can remain visibly incomplete rather than forcing an answer."
			},
			{
				"question": "Does the tool generate treatment recommendations?",
				"answer": "No. It can organize plausible maintaining-process targets from entered material, but the practitioner controls interpretation and treatment decisions."
			}
		]
	},
	{
		"toolType": "overEvaluationOfControlOverEatingFormulation",
		"slug": "over-evaluation-of-control-over-eating-formulation",
		"title": "Control over Eating Formulation Demo | Qwoach",
		"metaDescription": "Explore a CBT-E formulation tool for mapping how overvalued control over eating may maintain eating-disorder symptoms and distress.",
		"h1": "Over-evaluation of Control over Eating Formulation",
		"intro": "Over-evaluation of Control over Eating Formulation is a CBT-E structured formulation tool for eating-disorder practitioners. It helps a practitioner and client understand how excessive importance placed on controlling eating may maintain eating-disorder difficulties.",
		"demoTitle": "Build a sample formulation map.",
		"demoPrompt": "Interested in using Over-evaluation of Control over Eating Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0402-f-015-cbte-014-r001-over-evaluation-of-control-over-eating-formulation.md",
		"specId": "0402-f-015-cbte-014-r001-over-evaluation-of-control-over-eating-formulation",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Eating disorders"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Client Roles",
				"body": "The client contributes examples and checks whether links reflect current experience. The practitioner controls the formulation, interpretation, and treatment-priority notes."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not score food control, provide dietary advice, select a treatment focus automatically, or expand into a complete CBT-E case formulation builder."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool score control over eating?",
				"answer": "No. It maps formulation elements and feedback loops rather than producing a score."
			},
			{
				"question": "Can a disputed link stay in the formulation?",
				"answer": "Yes, but it should be marked tentative or removed; the system does not preserve disputed links as fact."
			},
			{
				"question": "Does the tool choose treatment priorities automatically?",
				"answer": "No. The practitioner records treatment-priority interpretation based on the formulation."
			}
		]
	},
	{
		"toolType": "clinicalPerfectionismFormulation",
		"slug": "clinical-perfectionism-formulation",
		"title": "Clinical Perfectionism Formulation Demo | Qwoach",
		"metaDescription": "Explore a CBT-E formulation tool for mapping standards, self-criticism, and perfectionism links to eating-disorder distress.",
		"h1": "Clinical Perfectionism Formulation",
		"intro": "Clinical Perfectionism Formulation is a CBT-E structured formulation tool for eating-disorder practitioners. It helps a practitioner and client understand how rigid standards, self-criticism, perfectionistic striving, and performance-based self-evaluation may connect to eating-disorder behaviors or distress.",
		"demoTitle": "Try a sample perfectionism formulation.",
		"demoPrompt": "Interested in using Clinical Perfectionism Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0403-f-015-cbte-015-r001-clinical-perfectionism-formulation.md",
		"specId": "0403-f-015-cbte-015-r001-clinical-perfectionism-formulation",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Eating disorders",
				"Perfectionism",
				"Self-criticism"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Focused Scope",
				"body": "The tool stays focused on clinical perfectionism as a maintaining mechanism in an eating-disorder presentation. It is not a general perfectionism workbook."
			},
			{
				"title": "Partial Formulations",
				"body": "The formulation can remain partial when perfectionism is uncertain, when examples are incomplete, or when the practitioner and client need more information."
			}
		],
		"faqItems": [
			{
				"question": "Is this a perfectionism test?",
				"answer": "No. It is a formulation map, not a general perfectionism assessment or score."
			},
			{
				"question": "Can standards unrelated to eating-disorder distress be recorded?",
				"answer": "Yes. They can be recorded as context, but they should not be treated as maintaining links unless connected to eating-disorder distress or behaviors."
			},
			{
				"question": "Does the tool prescribe interventions?",
				"answer": "No. It records practitioner-noted targets but does not generate treatment steps automatically."
			}
		]
	},
	{
		"toolType": "coreLowSelfEsteemFormulation",
		"slug": "core-low-self-esteem-formulation",
		"title": "Core Low Self-Esteem Formulation Demo | Qwoach",
		"metaDescription": "Explore a CBT-E formulation tool for mapping negative self-beliefs, symptom links, and maintenance cycles in eating-disorder treatment.",
		"h1": "Core Low Self-Esteem Formulation",
		"intro": "Core Low Self-Esteem Formulation is a CBT-E structured formulation tool for eating-disorder practitioners. It helps a practitioner and client understand how persistent negative beliefs about the self may relate to symptoms and maintenance cycles.",
		"demoTitle": "Try a sample self-esteem formulation.",
		"demoPrompt": "Interested in using Core Low Self-Esteem Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0404-f-015-cbte-016-r001-core-low-self-esteem-formulation.md",
		"specId": "0404-f-015-cbte-016-r001-core-low-self-esteem-formulation",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Eating disorders",
				"Core beliefs"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Sensitive Completion",
				"body": "The tool supports partial work and practitioner pacing. It should not force a client to name beliefs or complete sensitive sections before they are ready."
			},
			{
				"title": "What It Does Not Measure",
				"body": "It does not measure self-esteem, track mood, diagnose, or assign improvement or worsening scores over time."
			}
		],
		"faqItems": [
			{
				"question": "Is this a self-esteem scale?",
				"answer": "No. It is a maintaining-cycle formulation, not a standardized self-esteem score."
			},
			{
				"question": "What if the client's distress seems temporary?",
				"answer": "The tool can record a distinction note rather than treating temporary distress as core low self-esteem."
			},
			{
				"question": "Can the formulation be updated later?",
				"answer": "Yes. The formulation persists and can be updated or reviewed descriptively over time."
			}
		]
	},
	{
		"toolType": "interpersonalHistoryTable",
		"slug": "interpersonal-history-table",
		"title": "Interpersonal History Table Demo | Qwoach",
		"metaDescription": "Explore a CBT-E adolescent table for organizing relevant relationships, interpersonal events, recurring patterns, and treatment hypotheses.",
		"h1": "Interpersonal History Table",
		"intro": "Interpersonal History Table is a CBT-E adolescent assessment and pattern-organization aid for eating-disorder practitioners. It helps a practitioner and adolescent client build a coherent picture of relevant interpersonal history, recurring relationship patterns, and plausible links to the presenting difficulties.",
		"demoTitle": "Explore the table with sample relationship entries.",
		"demoPrompt": "Interested in using Interpersonal History Table with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0405-f-015-cbte-017-r001-interpersonal-history-table.md",
		"specId": "0405-f-015-cbte-017-r001-interpersonal-history-table",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Eating disorders",
				"Clinical history"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Adolescent CBT-E Context",
				"body": "The table is intended for adolescent eating-disorder work where interpersonal history and recurring relationship patterns may inform treatment hypotheses."
			},
			{
				"title": "Sensitive Information",
				"body": "The table should allow minimal or partial entries for sensitive relationships or events and should not force exhaustive detail."
			}
		],
		"faqItems": [
			{
				"question": "Does the table score relationships?",
				"answer": "No. It organizes interpersonal history and patterns without relationship ratings or scores."
			},
			{
				"question": "Can entries be partial?",
				"answer": "Yes. Unknown or sensitive details can remain blank or unresolved."
			},
			{
				"question": "Does the tool infer family dynamics?",
				"answer": "No. It may organize entered patterns descriptively, but practitioner hypotheses remain separate from reported history."
			}
		]
	},
	{
		"toolType": "moodIntoleranceFormulation",
		"slug": "mood-intolerance-formulation",
		"title": "Mood Intolerance Formulation Demo | Qwoach",
		"metaDescription": "Explore a CBT-E adolescent formulation tool for mapping mood states, responses, eating-disorder behaviors, and maintenance cycles.",
		"h1": "Mood Intolerance Formulation",
		"intro": "Mood Intolerance Formulation is a CBT-E adolescent structured formulation tool for eating-disorder practitioners. It helps a practitioner and adolescent client map how difficulty tolerating or regulating intense mood states may connect to responses, eating-disorder behaviors, and maintenance cycles.",
		"demoTitle": "Create a sample emotional-maintenance map.",
		"demoPrompt": "Interested in using Mood Intolerance Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0406-f-015-cbte-018-r001-mood-intolerance-formulation.md",
		"specId": "0406-f-015-cbte-018-r001-mood-intolerance-formulation",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Eating disorders",
				"Emotion regulation"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures mood states, responses to difficult emotions, eating-disorder behavior connections, maintenance loops, and practitioner target notes."
			},
			{
				"title": "Relevant Limits",
				"body": "It does not teach emotion-regulation skills, create a coping plan, track mood over time, or assign risk classifications."
			}
		],
		"faqItems": [
			{
				"question": "Does the client need to name emotions precisely?",
				"answer": "No. The tool can accept descriptive mood language and leave emotion labels unresolved."
			},
			{
				"question": "Is this a mood tracker?",
				"answer": "No. It maps a maintenance cycle and does not collect generic mood ratings or diary entries."
			},
			{
				"question": "Can multiple mood states be included?",
				"answer": "Yes. The map can support multiple cycles without forcing one primary mood."
			}
		]
	},
	{
		"toolType": "treatmentReviewObstaclesToChange",
		"slug": "treatment-review-obstacles-to-change",
		"title": "Treatment Review and Obstacles Demo | Qwoach",
		"metaDescription": "Explore a CBT-E review tool for distinguishing treatment progress, non-progress, obstacles, implications, and agreed next steps.",
		"h1": "Treatment Review / Obstacles to Change",
		"intro": "Treatment Review / Obstacles to Change is a CBT-E progress review and barrier-clarification tool for eating-disorder practitioners. It helps a practitioner and client form a current shared understanding of treatment progress and the specific obstacles preventing change.",
		"demoTitle": "Try a sample progress and obstacle review.",
		"demoPrompt": "Interested in using Treatment Review / Obstacles to Change with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0407-f-015-cbte-019-r001-treatment-review-obstacles-to-change.md",
		"specId": "0407-f-015-cbte-019-r001-treatment-review-obstacles-to-change",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Eating disorders",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Repeat Use",
				"body": "The tool is designed for recurring reviews during active treatment. Historical reviews can show repeated, newly identified, or resolved obstacles descriptively."
			},
			{
				"title": "Disagreement And Uncertainty",
				"body": "The review can capture practitioner and client disagreement or uncertainty instead of forcing consensus."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool judge whether progress is adequate?",
				"answer": "No. It organizes progress and obstacles; adequacy judgments are recorded only if the practitioner enters them."
			},
			{
				"question": "Can the review be completed if no obstacles are identified?",
				"answer": "Yes. The result should show that no specific obstacles were identified yet, without inventing barriers."
			},
			{
				"question": "Does it include symptom scores?",
				"answer": "No. Unsupported symptom scores and outcome benchmarking are outside this tool."
			},
			{
				"question": "Can prior reviews be compared?",
				"answer": "Yes. Prior reviews can be compared descriptively to show recurring, continuing, or resolved obstacles."
			}
		]
	},
	{
		"toolType": "shortTermMaintenancePlan",
		"slug": "short-term-maintenance-plan",
		"title": "Short-Term Maintenance Plan Demo | Qwoach",
		"metaDescription": "Explore a CBT-E ready-to-send plan for near-term recovery maintenance, early setbacks, current gains, vulnerabilities, and next actions.",
		"h1": "Short-Term Maintenance Plan",
		"intro": "Short-Term Maintenance Plan is a CBT-E recovery maintenance and relapse-prevention planning tool for eating-disorder practitioners and clients approaching the end of active treatment. It helps the client identify near-term risk situations, early warning signs or setbacks, specific responses, current gains and vulnerabilities, and immediate next actions.",
		"demoTitle": "Preview the client plan and practitioner review.",
		"demoPrompt": "Interested in using Short-Term Maintenance Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0408-f-015-cbte-020-r001-short-term-maintenance-plan.md",
		"specId": "0408-f-015-cbte-020-r001-short-term-maintenance-plan",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Eating disorders",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Short-Term Scope",
				"body": "The plan is for the immediate post-treatment period. It should not be presented as a long-term relapse-prevention strategy."
			},
			{
				"title": "Practitioner Review",
				"body": "The practitioner reviews client entries for specificity and practicality, adds comments or clarifications, and finalizes the shared version."
			}
		],
		"faqItems": [
			{
				"question": "Is this the long-term maintenance plan?",
				"answer": "No. This plan is specifically for the short-term, immediate period after active treatment reduces or ends."
			},
			{
				"question": "Can the client save partial work?",
				"answer": "Yes. Partial work can be saved, with incomplete sections visible for later completion or practitioner review."
			},
			{
				"question": "Does the plan predict relapse risk?",
				"answer": "No. It does not rate or predict relapse risk; it organizes risks, warning signs, responses, gains, vulnerabilities, and next actions."
			}
		]
	},
	{
		"toolType": "longTermMaintenancePlan",
		"slug": "long-term-maintenance-plan",
		"title": "Long-Term Maintenance Plan Demo | Qwoach",
		"metaDescription": "Explore a CBT-E ready-to-send plan for long-term recovery maintenance, future relapse risks, warning signs, protective responses, and support-seeking.",
		"h1": "Long-Term Maintenance Plan",
		"intro": "Long-Term Maintenance Plan is a CBT-E longitudinal relapse-prevention and recovery maintenance planning tool for eating-disorder practitioners and clients moving beyond active treatment. It helps the client anticipate longer-term risks, warning signs, protective routines or responses, future stressors, and how to seek support if difficulties re-emerge.",
		"demoTitle": "Preview the long-term plan and review flow.",
		"demoPrompt": "Interested in using Long-Term Maintenance Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0409-f-015-cbte-021-r001-long-term-maintenance-plan.md",
		"specId": "0409-f-015-cbte-021-r001-long-term-maintenance-plan",
		"tags": {
			"framework": [
				"CBT-E"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Eating disorders",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Long-Term Scope",
				"body": "The plan is for recovery maintenance over time after formal treatment support has ended. It should remain distinct from the short-term immediate transition plan."
			},
			{
				"title": "Support-Seeking",
				"body": "The plan includes how the client will seek support if difficulties re-emerge, and practitioner review can flag vague support-seeking steps for clarification."
			}
		],
		"faqItems": [
			{
				"question": "Is this a daily monitoring tool?",
				"answer": "No. It is a long-term maintenance strategy, not a daily tracker or surveillance tool."
			},
			{
				"question": "Does the plan predict relapse?",
				"answer": "No. It organizes risks, warning signs, protective responses, stressors, and support-seeking without assigning relapse probability."
			},
			{
				"question": "How is this different from the short-term plan?",
				"answer": "This plan focuses on longer-term recovery over time after formal treatment support has ended, not only the immediate post-treatment transition."
			}
		]
	},
	{
		"toolType": "interpersonalInventory",
		"slug": "interpersonal-inventory",
		"title": "Interpersonal Inventory Demo | Qwoach",
		"metaDescription": "Explore an IPT practitioner-only inventory for mapping significant relationships, support resources, interpersonal stressors, and presenting-problem links.",
		"h1": "Interpersonal Inventory",
		"intro": "Interpersonal Inventory is a practitioner-only IPT assessment tool for practitioners assessing a client for interpersonal psychotherapy. It helps the practitioner organize significant relationships, social supports, interpersonal stressors, and relationship-context links to the presenting problem.",
		"demoTitle": "Explore a sample practitioner-only inventory.",
		"demoPrompt": "Interested in using Interpersonal Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0410-f-016-ipt-001-r001-interpersonal-inventory.md",
		"specId": "0410-f-016-ipt-001-r001-interpersonal-inventory",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The interface is optimized for practitioner capture and clinical organization. It should not require client login, independent client forms, or client ratings."
			},
			{
				"title": "Mixed Support And Strain",
				"body": "A relationship can be represented as both supportive and stressful. The tool should not force a single category when the clinical picture is mixed."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not manage contacts, import social media data, score relationships, diagnose, or choose the interpersonal treatment focus automatically."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client-facing version?",
				"answer": "No. The tool is practitioner-only; client information is incorporated through the practitioner's assessment process."
			},
			{
				"question": "Can one relationship be both supportive and stressful?",
				"answer": "Yes. The tool should allow mixed support and strain characterization."
			},
			{
				"question": "Does the inventory choose the IPT treatment focus?",
				"answer": "No. It informs interpersonal formulation, but the practitioner chooses or refines the treatment focus."
			},
			{
				"question": "Is this a contact list?",
				"answer": "No. It is a clinical relationship-context map, not a contact-management tool."
			}
		]
	},
	{
		"toolType": "interpersonalCircle",
		"slug": "interpersonal-circle",
		"title": "Interpersonal Circle IPT Support Network Map | Qwoach",
		"metaDescription": "Map a client's IPT support network with centrality, closeness, and reported supportive or stressful relationship qualities.",
		"h1": "Interpersonal Circle",
		"intro": "Interpersonal Circle is an interpersonal psychotherapy support-network mapping tool for practitioners and clients working together in session. It helps them create a shared visual picture of key people in the client's network, relative closeness or importance, and reported supportive or stressful relationship qualities.",
		"demoTitle": "Explore a sample circle, then save this tool for your practice.",
		"demoPrompt": "Interested in using Interpersonal Circle with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0411-f-016-ipt-002-r001-interpersonal-circle.md",
		"specId": "0411-f-016-ipt-002-r001-interpersonal-circle",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during IPT assessment, formulation, or follow-up when the practitioner and client need a shared map of the client's current support network."
			},
			{
				"title": "What It Captures",
				"body": "It captures people in the network, relative closeness or importance, reported supportive or stressful/problematic qualities, mixed or unresolved relationships, and the dated map state."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not collect contact details, social media data, diagnostic conclusions, standardized scores, or system-generated clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Is Interpersonal Circle completed by the client alone?",
				"answer": "No. Interpersonal Circle is a collaborative in-session tool used by practitioner and client together."
			},
			{
				"question": "Does the tool score the client's relationships?",
				"answer": "No. It visually organizes reported closeness, importance, and relationship qualities without standardized scores."
			},
			{
				"question": "Can a partial circle be saved?",
				"answer": "Yes. Partial maps remain reviewable, and unresolved relationship qualities should be shown as incomplete rather than interpreted."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "Only the tool itself is saved. Fictional demo people, sample relationship qualities, and temporary edits do not become real client data."
			}
		]
	},
	{
		"toolType": "interpersonalFormulation",
		"slug": "interpersonal-formulation",
		"title": "Interpersonal Formulation IPT Treatment Planning Tool | Qwoach",
		"metaDescription": "Create a practitioner-only IPT formulation linking symptoms, interpersonal context, relationship events, focus, and rationale.",
		"h1": "Interpersonal Formulation",
		"intro": "Interpersonal Formulation is a practitioner-only interpersonal psychotherapy treatment formulation tool. It helps IPT practitioners connect presenting symptoms with interpersonal context, relationship patterns or life events, and a justified treatment focus.",
		"demoTitle": "Review a sample formulation structure, then save this tool for your practice.",
		"demoPrompt": "Interested in using Interpersonal Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0412-f-016-ipt-003-r001-interpersonal-formulation.md",
		"specId": "0412-f-016-ipt-003-r001-interpersonal-formulation",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The product is controlled and completed by the practitioner. Client information may inform the formulation, but the tool does not require client completion."
			},
			{
				"title": "What It Organizes",
				"body": "It organizes symptoms, interpersonal circumstances, relationship patterns or events, selected focus, rationale, and planning implications."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not auto-select a focus, generate clinical meaning from incomplete data, assign diagnosis, or add standardized scoring."
			}
		],
		"faqItems": [
			{
				"question": "Is Interpersonal Formulation a questionnaire?",
				"answer": "No. It is a practitioner-only structured clinical synthesis tool, not a questionnaire or scoring instrument."
			},
			{
				"question": "Does the system choose the IPT focus?",
				"answer": "No. The practitioner records the candidate or selected focus and rationale."
			},
			{
				"question": "Can a formulation remain provisional?",
				"answer": "Yes. Partial and provisional formulation states are supported, with unresolved elements visible."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool itself is saved. Fictional sample formulation text and temporary demo edits do not become real client data."
			}
		]
	},
	{
		"toolType": "interpersonalSummary",
		"slug": "interpersonal-summary",
		"title": "Interpersonal Summary IPT Compact Case Synthesis | Qwoach",
		"metaDescription": "Create a compact practitioner-only IPT treatment summary with presenting problem, interpersonal context, focus, and key events.",
		"h1": "Interpersonal Summary",
		"intro": "Interpersonal Summary is a practitioner-only compact clinical synthesis tool for interpersonal psychotherapy. It helps practitioners capture the presenting problem, interpersonal context, selected treatment focus, and key relationships or events in a concise treatment summary.",
		"demoTitle": "Explore a sample summary, then save this tool for your practice.",
		"demoPrompt": "Interested in using Interpersonal Summary with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0413-f-016-ipt-004-r001-interpersonal-summary.md",
		"specId": "0413-f-016-ipt-004-r001-interpersonal-summary",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Clinical documentation",
				"Session preparation"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when an IPT case needs a concise clinical synthesis for planning, review, or communication."
			},
			{
				"title": "What It Captures",
				"body": "It captures the main presenting problem, interpersonal context, selected treatment focus, key relationships or events, and a concise synthesis."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not generate substantive formulation, infer the treatment focus, add scoring, or become a full progress note."
			}
		],
		"faqItems": [
			{
				"question": "Is Interpersonal Summary for client completion?",
				"answer": "No. It is a practitioner-only summary tool."
			},
			{
				"question": "Does the tool write the summary for the practitioner?",
				"answer": "No. The practitioner authors the summary; the system organizes supported sections and highlights gaps."
			},
			{
				"question": "Can the summary be incomplete?",
				"answer": "Yes. Incomplete summaries can show unresolved placeholders without implying completion."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "Only the fixed tool is saved. Fictional summary content and temporary edits do not become real client data."
			}
		]
	},
	{
		"toolType": "iptTimeline",
		"slug": "ipt-timeline",
		"title": "IPT Timeline for Interpersonal Events and Symptoms | Qwoach",
		"metaDescription": "Build a collaborative IPT timeline of interpersonal events, transitions, symptom changes, timing precision, and practitioner hypotheses.",
		"h1": "IPT Timeline",
		"intro": "IPT Timeline is a collaborative interpersonal psychotherapy chronology tool for practitioners and clients. It helps them place relevant interpersonal events, transitions, and symptom changes over time so the practitioner can understand temporal relationships and record a practitioner-authored treatment hypothesis.",
		"demoTitle": "Explore a sample timeline, then save this tool for your practice.",
		"demoPrompt": "Interested in using IPT Timeline with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0414-f-016-ipt-005-r001-ipt-timeline.md",
		"specId": "0414-f-016-ipt-005-r001-ipt-timeline",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Clinical history",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures interpersonal events, role changes or transitions, symptom-change markers, timing precision, notes, and practitioner-entered hypotheses."
			},
			{
				"title": "Handling Uncertain Timing",
				"body": "The tool supports exact dates, approximate periods, and relative order so clients are not forced to remember precise dates."
			},
			{
				"title": "Relevant Limits",
				"body": "The timeline does not infer causality, generate treatment hypotheses, or collect exhaustive life history."
			}
		],
		"faqItems": [
			{
				"question": "Does IPT Timeline require exact dates?",
				"answer": "No. It supports exact dates, approximate periods, and relative ordering."
			},
			{
				"question": "Does the tool decide that an event caused a symptom change?",
				"answer": "No. It shows descriptive timing; causal interpretation remains practitioner-authored."
			},
			{
				"question": "Can a partial timeline be saved?",
				"answer": "Yes. Partial and approximate timelines remain useful and visibly marked."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool and intentional timing-precision setup can be saved. Fictional demo chronology and sample clinical content do not become real client data."
			}
		]
	},
	{
		"toolType": "interpersonalProblemAreaSelection",
		"slug": "interpersonal-problem-area-selection",
		"title": "IPT Interpersonal Problem Area Selection Tool | Qwoach",
		"metaDescription": "Select and document an IPT interpersonal problem area with supporting history, symptom connection, alternatives, and rationale.",
		"h1": "Interpersonal Problem Area Selection",
		"intro": "Interpersonal Problem Area Selection is a practitioner-only IPT treatment-focus decision tool. It helps practitioners select the interpersonal problem area that best explains a client's current difficulties and treatment needs after assessment.",
		"demoTitle": "Explore a sample focus selection, then save this tool for your practice.",
		"demoPrompt": "Interested in using Interpersonal Problem Area Selection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0415-f-016-ipt-006-r001-interpersonal-problem-area-selection.md",
		"specId": "0415-f-016-ipt-006-r001-interpersonal-problem-area-selection",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner Decision Support",
				"body": "The tool structures a practitioner decision by showing the defined options, evidence for the chosen focus, alternatives considered, and rationale."
			},
			{
				"title": "Provisional State",
				"body": "If assessment information is insufficient, the selection can remain provisional or unselected until the practitioner is ready."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not auto-select, score, diagnose, or add unsupported problem-area categories."
			}
		],
		"faqItems": [
			{
				"question": "Does the system choose the interpersonal problem area?",
				"answer": "No. The practitioner selects the focus and records the rationale."
			},
			{
				"question": "Can more than one area be considered?",
				"answer": "Yes. Alternatives can be documented, but the result distinguishes the primary focus when selected."
			},
			{
				"question": "Can I add a custom problem area?",
				"answer": "No. The tool uses the fixed defined IPT problem-area choice set."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "Only the tool itself is saved. Fictional demo selections and rationale do not become real client data."
			}
		]
	},
	{
		"toolType": "iptDisputeGraph",
		"slug": "ipt-dispute-graph",
		"title": "IPT Dispute Graph Conflict Mapping Tool | Qwoach",
		"metaDescription": "Map an active IPT dispute with parties, central issue, expectations, maintaining pattern, and possible communication targets.",
		"h1": "IPT Dispute Graph",
		"intro": "IPT Dispute Graph is a collaborative interpersonal psychotherapy conflict-structure tool for practitioners and clients. It helps them identify the parties, central issue, differing expectations or positions, maintaining pattern, and possible communication or problem-solving targets.",
		"demoTitle": "Explore a sample dispute graph, then save this tool for your practice.",
		"demoPrompt": "Interested in using IPT Dispute Graph with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0416-f-016-ipt-007-r001-ipt-dispute-graph.md",
		"specId": "0416-f-016-ipt-007-r001-ipt-dispute-graph",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures parties, central conflict issue, expectations or positions, uncertainty, maintaining pattern, possible targets, and date/context."
			},
			{
				"title": "Collaborative Use",
				"body": "The graph is created in session with the client contributing their account while the practitioner controls the saved clinical artifact."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not determine who is correct, assign blame, record legal claims, score conflict severity, or generate unsupported advice."
			}
		],
		"faqItems": [
			{
				"question": "Does IPT Dispute Graph decide who is right?",
				"answer": "No. It organizes reported positions and practitioner-entered formulation without adjudicating accuracy or blame."
			},
			{
				"question": "Can the graph include more than two parties?",
				"answer": "Yes. More than two parties may be represented if the graph remains understandable."
			},
			{
				"question": "Can uncertain information be marked?",
				"answer": "Yes. Positions or patterns can be marked uncertain when the client is inferring or the account is incomplete."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "Only the fixed tool is saved. Fictional dispute details and temporary edits do not become real client data."
			}
		]
	},
	{
		"toolType": "transitionTimeline",
		"slug": "transition-timeline",
		"title": "Transition Timeline IPT Role Transition Tool | Qwoach",
		"metaDescription": "Map an IPT role transition with old and new roles, timing, losses, gains, stressors, adaptation difficulties, and targets.",
		"h1": "Transition Timeline",
		"intro": "Transition Timeline is a collaborative interpersonal psychotherapy tool for practitioners and clients working with a major role transition. It helps clarify old and new roles or circumstances, timing, losses, gains, stressors, adaptation difficulties, and practitioner-entered interpersonal treatment targets.",
		"demoTitle": "Explore a sample transition, then save this tool for your practice.",
		"demoPrompt": "Interested in using Transition Timeline with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0417-f-016-ipt-008-r001-transition-timeline.md",
		"specId": "0417-f-016-ipt-008-r001-transition-timeline",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Clinical history",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures transition description, timing, old and new role distinction, losses, gains, stressors, adaptation difficulties, targets, and date/context."
			},
			{
				"title": "Unresolved Content",
				"body": "Missing gains, losses, or role labels can remain unknown rather than being treated as absent."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not generate coping plans, score adjustment, diagnose, or turn the transition into unrelated life-planning work."
			}
		],
		"faqItems": [
			{
				"question": "Does Transition Timeline require a single exact transition date?",
				"answer": "No. It supports exact dates, approximate periods, and relative transition phases."
			},
			{
				"question": "Can gains or losses remain unclear?",
				"answer": "Yes. Unresolved categories can remain marked as unknown without implying absence."
			},
			{
				"question": "Does the tool generate adaptation tasks?",
				"answer": "No. It organizes entered content; treatment targets are practitioner-entered."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool and intentional timing-precision setup can be saved. Fictional transition details and sample targets do not become real client data."
			}
		]
	},
	{
		"toolType": "griefAndLossCrossroads",
		"slug": "grief-and-loss-crossroads",
		"title": "Grief and Loss Crossroads IPT Formulation Tool | Qwoach",
		"metaDescription": "Explore an IPT grief-focused formulation tool for loss, personal meaning, current difficulties, relationship links, and targets.",
		"h1": "Grief and Loss Crossroads",
		"intro": "Grief and Loss Crossroads is a collaborative IPT grief-focused formulation tool for practitioners and clients. It helps them organize a significant loss, personal meaning, current grief-related difficulties, symptom or relationship connections, and practitioner-entered grief-focused targets.",
		"demoTitle": "Explore a sample grief formulation, then save this tool for your practice.",
		"demoPrompt": "Interested in using Grief and Loss Crossroads with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0418-f-016-ipt-009-r001-grief-and-loss-crossroads.md",
		"specId": "0418-f-016-ipt-009-r001-grief-and-loss-crossroads",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Grief and loss",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Sensitive Partial Completion",
				"body": "The tool supports paced work and partial saving when a client is not ready to discuss every area."
			},
			{
				"title": "What It Captures",
				"body": "It captures the significant loss, personal meaning, current grief-related difficulties, symptom or relationship connections, practitioner-entered targets, and date/context."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not classify grief stage, score severity, diagnose, generate treatment steps, or invent exact crossroads categories."
			}
		],
		"faqItems": [
			{
				"question": "Does Grief and Loss Crossroads use grief stages?",
				"answer": "No. The tool does not classify grief stages or recovery status."
			},
			{
				"question": "Can the client leave parts unresolved?",
				"answer": "Yes. Partial completion is supported, and missing content should be marked unresolved rather than interpreted."
			},
			{
				"question": "Does the tool generate grief-focused targets?",
				"answer": "No. Targets are practitioner-entered based on the clinical formulation."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "Only the fixed tool is saved. Fictional loss details and temporary demo formulation content do not become real client data."
			}
		]
	},
	{
		"toolType": "interpersonalIncident",
		"slug": "interpersonal-incident",
		"title": "Interpersonal Incident IPT Interaction Analysis Tool | Qwoach",
		"metaDescription": "Reconstruct a specific IPT interpersonal episode with sequence, feelings, interpretations, responses, consequences, and targets.",
		"h1": "Interpersonal Incident",
		"intro": "Interpersonal Incident is a collaborative IPT session-level tool for practitioners and clients. It helps them examine a specific interpersonal episode by reconstructing the sequence, feelings, intentions, interpretations, other-person responses, consequences, and practitioner-entered pattern or intervention target.",
		"demoTitle": "Explore a sample incident, then save this tool for your practice.",
		"demoPrompt": "Interested in using Interpersonal Incident with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0419-f-016-ipt-010-r001-interpersonal-incident.md",
		"specId": "0419-f-016-ipt-010-r001-interpersonal-incident",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"In-session support"
			],
			"topic": [
				"Behavior analysis",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Session-Level Use",
				"body": "The tool is designed for a specific interpersonal episode that comes up in session, not for continuous diary tracking."
			},
			{
				"title": "What It Captures",
				"body": "It captures episode context, sequence steps, feelings, intentions, interpretations, other-person responses or role, consequences, uncertainty, and practitioner-entered pattern or target."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not infer motives, decide what objectively happened, score the incident, or generate intervention steps."
			}
		],
		"faqItems": [
			{
				"question": "Is Interpersonal Incident a daily diary?",
				"answer": "No. It focuses on reconstructing one specific interpersonal episode."
			},
			{
				"question": "Can uncertain details be included?",
				"answer": "Yes. Memory gaps, unclear order, and uncertainty about another person's intent can be marked."
			},
			{
				"question": "Does the tool infer motives?",
				"answer": "No. It keeps client interpretations and reported actions distinct and does not infer motives as facts."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "Only the fixed tool is saved. Fictional incident details and temporary sample edits do not become real client data."
			}
		]
	},
	{
		"toolType": "communicationAnalysis",
		"slug": "communication-analysis",
		"title": "Communication Analysis IPT Live-Session Tool | Qwoach",
		"metaDescription": "Analyze a specific IPT communication exchange live in session and record verbal, emotional, pattern, and alternative plan details.",
		"h1": "Communication Analysis",
		"intro": "Communication Analysis is a live-session IPT technique tool for practitioners and clients. It helps them examine a specific interpersonal exchange, identify verbal and emotional aspects of the communication pattern, clarify its link to interpersonal difficulty, and record a plausible alternative response or communication plan.",
		"demoTitle": "Explore a sample exchange, then save this tool for your practice.",
		"demoPrompt": "Interested in using Communication Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0420-f-016-ipt-011-r001-communication-analysis.md",
		"specId": "0420-f-016-ipt-011-r001-communication-analysis",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Problem solving"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Live-Session Use",
				"body": "The tool is designed for use during session with the client, not as an asynchronous client assignment."
			},
			{
				"title": "What It Captures",
				"body": "It captures the exchange description, sequence details, verbal and emotional aspects, interpersonal difficulty link, alternative response or plan, and date/context."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not score communication quality, generate scripts, send messages, surveil communications, or guarantee that an alternative will work."
			}
		],
		"faqItems": [
			{
				"question": "Is Communication Analysis an asynchronous client assignment?",
				"answer": "No. It is a live-session IPT tool used with the practitioner."
			},
			{
				"question": "Does the tool generate scripts for the client?",
				"answer": "No. The alternative response or plan is defined by the practitioner and client in session."
			},
			{
				"question": "Can a session end before the alternative is defined?",
				"answer": "Yes. The partial analysis can be saved, with the alternative plan marked unresolved."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "Only the fixed tool is saved. Fictional exchange content and temporary alternative plans do not become real client data."
			}
		]
	},
	{
		"toolType": "rolePlay",
		"slug": "role-play",
		"title": "Role Play IPT Session Tool Demo | Qwoach",
		"metaDescription": "Explore an IPT role play tool for live sessions. Set up a difficult exchange, capture observations, and review communication change points.",
		"h1": "Role Play for IPT Sessions",
		"intro": "Role Play is a live-session IPT tool for practitioners. It helps a practitioner set up a specific difficult interpersonal exchange, observe the client's communication strengths and barriers, and record actionable change points from the enactment.",
		"demoTitle": "Explore a sample role play",
		"demoPrompt": "Interested in using Role Play with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0421-f-016-ipt-012-r001-role-play.md",
		"specId": "0421-f-016-ipt-012-r001-role-play",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during a live session when a concrete interpersonal exchange needs to be practiced or examined closely enough for communication strengths, barriers, and change points to become visible."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not generate scripts, rate communication, diagnose relationship quality, or provide generic advice. It organizes practitioner observations from the role play."
			}
		],
		"faqItems": [
			{
				"question": "Is Role Play a client worksheet?",
				"answer": "No. Role Play is a live-session practitioner tool. The client participates in the enactment, but the observation artifact is practitioner-facing by default."
			},
			{
				"question": "Does the tool score communication?",
				"answer": "No. It records practitioner observations and completion status only. It does not calculate ratings, norms, or communication scores."
			},
			{
				"question": "Can incomplete role plays be saved?",
				"answer": "Yes. Interrupted or insufficiently specific role plays can remain incomplete with missing observations clearly marked."
			}
		]
	},
	{
		"toolType": "goalDirectedActionPlan",
		"slug": "goal-directed-action-plan",
		"title": "Goal-Directed Action Plan IPT Demo | Qwoach",
		"metaDescription": "Explore an IPT action-planning tool for turning an interpersonal problem area into concrete next steps and later review focus.",
		"h1": "Goal-Directed Action Plan for Interpersonal Change",
		"intro": "Goal-Directed Action Plan is an IPT action-planning tool for practitioners and clients working together. It helps translate an identified interpersonal problem area into a specific intended change, concrete next steps, fit notes, and a later review focus.",
		"demoTitle": "Build a sample action plan",
		"demoPrompt": "Interested in using Goal-Directed Action Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0422-f-016-ipt-013-r001-goal-directed-action-plan.md",
		"specId": "0422-f-016-ipt-013-r001-goal-directed-action-plan",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the treatment focus is clear enough to become an intended interpersonal change the client can try outside the session."
			},
			{
				"title": "Review Over Time",
				"body": "Completed plans persist with review status so a later session can compare the intended change with what the client reports happened, descriptively and without automated scoring."
			}
		],
		"faqItems": [
			{
				"question": "Does this replace a task manager?",
				"answer": "No. It is limited to IPT-relevant interpersonal action planning and does not manage unrelated tasks, due dates, reminders, or productivity statuses."
			},
			{
				"question": "Can the plan stay unfinished?",
				"answer": "Yes. Partial plans remain drafts with missing elements visible until the problem area, intended change, next steps, and review focus are specific enough."
			},
			{
				"question": "Does the tool judge whether the plan worked?",
				"answer": "No. Follow-up review records what happened descriptively. The system does not score success or failure."
			}
		]
	},
	{
		"toolType": "terminationMaintenanceReview",
		"slug": "termination-maintenance-review",
		"title": "IPT Termination Maintenance Review Demo | Qwoach",
		"metaDescription": "Explore an IPT termination review tool for linking treatment gains, future risks, maintenance strategies, and help-seeking indicators.",
		"h1": "Termination / Maintenance Review for IPT",
		"intro": "Termination / Maintenance Review is an IPT tool for practitioners and clients near the end of treatment. It helps consolidate gains linked to the interpersonal problem area, identify likely future triggers or relapse risks, document maintenance strategies, and clarify follow-up or help-seeking indicators.",
		"demoTitle": "Review a sample maintenance summary",
		"demoPrompt": "Interested in using Termination / Maintenance Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0423-f-016-ipt-014-r001-termination-maintenance-review.md",
		"specId": "0423-f-016-ipt-014-r001-termination-maintenance-review",
		"tags": {
			"framework": [
				"IPT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it near treatment conclusion, or as a draft across multiple termination sessions, when maintenance understanding needs to be made explicit."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not produce risk scores, forecasts, crisis protocols, or discharge determinations. It organizes entered gains, risks, strategies, and indicators."
			}
		],
		"faqItems": [
			{
				"question": "Is this a discharge summary?",
				"answer": "No. It is an IPT termination and maintenance review focused on gains, future stressors or relapse risks, strategies, and help-seeking indicators."
			},
			{
				"question": "Can no future risks be documented?",
				"answer": "Yes. The practitioner can explicitly document that no future risks were identified instead of forcing risk content."
			},
			{
				"question": "Does the tool predict relapse?",
				"answer": "No. It does not infer risk level, prognosis, or relapse prediction."
			}
		]
	},
	{
		"toolType": "mentalizingCaseFormulation",
		"slug": "mentalizing-case-formulation",
		"title": "Mentalizing Case Formulation MBT Demo | Qwoach",
		"metaDescription": "Explore an MBT formulation workspace for linking presenting problems, mentalizing strengths, vulnerabilities, relational patterns, and treatment focus.",
		"h1": "Mentalizing Case Formulation for MBT Practitioners",
		"intro": "Mentalizing Case Formulation is a practitioner-only MBT tool. It helps practitioners organize clinical material into a coherent formulation linking presenting problems with mentalizing capacities, vulnerabilities, relational patterns, breakdown contexts, and treatment focus.",
		"demoTitle": "Explore a sample formulation",
		"demoPrompt": "Interested in using Mentalizing Case Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0424-f-017-mbt-001-r001-mentalizing-case-formulation.md",
		"specId": "0424-f-017-mbt-001-r001-mentalizing-case-formulation",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The tool is designed for practitioner reasoning and treatment planning. It does not require client entry, symptom rating, or client review."
			},
			{
				"title": "Updates Over Time",
				"body": "Formulations can be revised as treatment reveals new information. Historical updates remain descriptive and do not imply correctness scores."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate a case formulation?",
				"answer": "No. The practitioner enters and interprets the substantive content. The system organizes links and missing areas only."
			},
			{
				"question": "Is there a client version?",
				"answer": "No. This is a practitioner-only MBT formulation workspace."
			},
			{
				"question": "Does it recommend interventions?",
				"answer": "No. It supports treatment focus by organizing formulation elements, but it does not prescribe interventions."
			}
		]
	},
	{
		"toolType": "mentalizingProfile",
		"slug": "mentalizing-profile",
		"title": "Mentalizing Profile MBT Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only MBT profile for organizing mentalizing strengths, vulnerabilities, contexts, and relational or affective patterns.",
		"h1": "Mentalizing Profile for MBT Practitioners",
		"intro": "Mentalizing Profile is a practitioner-only MBT tool. It helps practitioners organize mentalizing strengths, vulnerabilities, vulnerable contexts, and relevant relational or affective patterns so treatment focus can be selected or adjusted.",
		"demoTitle": "Explore a sample profile",
		"demoPrompt": "Interested in using Mentalizing Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0425-f-017-mbt-002-r001-mentalizing-profile.md",
		"specId": "0425-f-017-mbt-002-r001-mentalizing-profile",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Context Matters",
				"body": "The profile is designed to avoid treating mentalizing as globally present or absent. Entries are most useful when attached to specific relational or affective contexts."
			},
			{
				"title": "Descriptive History",
				"body": "Updates over time show how the practitioner's understanding has changed. The tool does not create progress scores."
			}
		],
		"faqItems": [
			{
				"question": "Is Mentalizing Profile a standardized assessment?",
				"answer": "No. It is a practitioner-only profile of entered strengths, vulnerabilities, contexts, and patterns."
			},
			{
				"question": "Does it produce a mentalizing score?",
				"answer": "No. It does not calculate global ratings, severity bands, or subscale scores."
			},
			{
				"question": "Can the profile include contradictory observations?",
				"answer": "Yes. Contradictory observations can be entered with examples instead of forcing resolution."
			}
		]
	},
	{
		"toolType": "mentalizingFamilyProfile",
		"slug": "mentalizing-family-profile",
		"title": "Mentalizing Family Profile MBT-F Demo | Qwoach",
		"metaDescription": "Explore an MBT-F family interaction map for practitioner-entered members, patterns, supported or disrupted mentalizing, and treatment focus.",
		"h1": "Mentalizing Family Profile for MBT-F",
		"intro": "Mentalizing Family Profile is a practitioner-only MBT-F tool. It helps practitioners map relevant family members, interaction patterns, where mentalizing is supported or disrupted, unhelpful recurring patterns, and a shared family treatment focus.",
		"demoTitle": "Explore a sample family map",
		"demoPrompt": "Interested in using Mentalizing Family Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0426-f-017-mbt-003-r001-mentalizing-family-profile.md",
		"specId": "0426-f-017-mbt-003-r001-mentalizing-family-profile",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Only Mapping",
				"body": "Family material may inform the map, but the product does not require family members to complete fields, rate each other, or access the artifact."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not create a complete genogram, custody record, family score, blame label, diagnosis, or intervention prescription."
			}
		],
		"faqItems": [
			{
				"question": "Is this a genogram tool?",
				"answer": "No. It is a mentalizing-focused family interaction map, not a full family history or genogram builder."
			},
			{
				"question": "Do family members fill it out?",
				"answer": "No. The practitioner creates and edits the map based on clinical material."
			},
			{
				"question": "Does the map assign blame or severity?",
				"answer": "No. Supported and disrupted mentalizing markers are practitioner-entered observations, and the system does not infer blame or severity."
			}
		]
	},
	{
		"toolType": "relationalGoalsFormulation",
		"slug": "relational-goals-formulation",
		"title": "Relational Goals Formulation MBT-C Demo | Qwoach",
		"metaDescription": "Explore an MBT-C practitioner tool for defining relational treatment goals that fit child/family context and include recognizable progress markers.",
		"h1": "Relational Goals Formulation for MBT-C",
		"intro": "Relational Goals Formulation is a practitioner-only MBT-C tool. It helps practitioners define explicit relational goals for work with a child and family, connect those goals to current difficulties and developmental context, and describe how progress could be recognized over time.",
		"demoTitle": "Draft sample relational goals",
		"demoPrompt": "Interested in using Relational Goals Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0427-f-017-mbt-004-r001-relational-goals-formulation.md",
		"specId": "0427-f-017-mbt-004-r001-relational-goals-formulation",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Interpersonal relationships"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "Relational, Not Symptom-Only",
				"body": "Each goal should describe a desired change in relationships. Symptom-only entries are treated as outside scope unless restated relationally."
			},
			{
				"title": "Recognizing Progress",
				"body": "Progress markers are descriptive. The tool does not create quantitative goal progress scores."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate treatment goals?",
				"answer": "No. The practitioner writes the goals. The system organizes them and indicates whether required relational-goal sections are complete."
			},
			{
				"question": "Can a symptom goal be entered?",
				"answer": "A symptom-only goal is outside the tool's scope unless the practitioner restates it as a desired relational change."
			},
			{
				"question": "Is progress scored?",
				"answer": "No. Progress is recognized descriptively through practitioner-entered markers, not system scoring."
			}
		]
	},
	{
		"toolType": "mentalizingSkillsCurriculum",
		"slug": "mentalizing-skills-curriculum",
		"title": "Mentalizing Skills Curriculum Demo | Qwoach",
		"metaDescription": "Explore an MBT practice workflow for selected skill areas, in-session or between-session practice, client reports, and practitioner review.",
		"h1": "Mentalizing Skills Curriculum Practice Workflow",
		"intro": "Mentalizing Skills Curriculum is an MBT practice workflow for practitioners and clients. It helps a practitioner select a supplied targeted skill area, match it to the client's current mentalizing needs, support in-session or between-session practice, and review demonstration, reported use, observations, and generalization when entered.",
		"demoTitle": "Explore the practice workflow",
		"demoPrompt": "Interested in using Mentalizing Skills Curriculum with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0428-f-017-mbt-005-r001-mentalizing-skills-curriculum.md",
		"specId": "0428-f-017-mbt-005-r001-mentalizing-skills-curriculum",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"Between-session monitoring"
			],
			"topic": [
				"Skills use",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Content Dependency",
				"body": "Exact skill areas, practice prompts, lesson sequence, and worksheets are unresolved in the supplied specification. The demo must not fill that gap with invented curriculum content."
			},
			{
				"title": "Practice Evidence",
				"body": "The review separates client report, observed demonstration, practitioner observation, and practitioner interpretation. Completion alone is not presented as improvement."
			}
		],
		"faqItems": [
			{
				"question": "Does this demo include the actual curriculum lessons?",
				"answer": "No. Exact curriculum content, exercises, prompts, and sequence are not supplied in the product specification, so the demo shows only the supported workflow shell."
			},
			{
				"question": "Can clients submit practice reports?",
				"answer": "Yes, where a practice activity is shared or assigned, the client can indicate completion or provide a brief use report."
			},
			{
				"question": "Does the tool score mastery?",
				"answer": "No. It tracks recorded practice instances and descriptive review content, but it does not create mastery levels or skill scores."
			},
			{
				"question": "Can practitioners author lessons in this tool?",
				"answer": "No. Editable lesson authoring is not part of this configuration because the exact curriculum content structure is unresolved."
			}
		]
	},
	{
		"toolType": "affectFocus",
		"slug": "affect-focus",
		"title": "Affect Focus MBT Session Tool Demo | Qwoach",
		"metaDescription": "Explore a lightweight MBT live-session support for linking affect to relational context and documenting brief practitioner observations.",
		"h1": "Affect Focus for Live MBT Sessions",
		"intro": "Affect Focus is a live-session MBT support tool for practitioners. It helps a practitioner briefly identify or clarify relevant affect, link it to relational context, note engagement, and record whether the session focus moved toward understanding mental states.",
		"demoTitle": "Try a brief affect-focus note",
		"demoPrompt": "Interested in using Affect Focus with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0429-f-017-mbt-006-r001-affect-focus.md",
		"specId": "0429-f-017-mbt-006-r001-affect-focus",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Minimal by Design",
				"body": "The tool is intentionally low-friction because affect focus occurs in live therapeutic conversation. It supports short notes, not questionnaires."
			},
			{
				"title": "No Required Artifact",
				"body": "A practitioner can use the technique without saving a final artifact. Saved notes are descriptive session context only."
			}
		],
		"faqItems": [
			{
				"question": "Is Affect Focus an emotion rating tool?",
				"answer": "No. It does not include emotion intensity scores, standardized categories, or affect trends."
			},
			{
				"question": "Does the client fill anything out?",
				"answer": "No. The client participates in live therapeutic conversation, but there is no client form or required direct entry."
			},
			{
				"question": "Can the affect be unclear?",
				"answer": "Yes. The practitioner can record that the affect is unclear or being clarified rather than forcing a label."
			}
		]
	},
	{
		"toolType": "cognitiveAffectBalance",
		"slug": "cognitive-affect-balance",
		"title": "Cognitive-Affect Balance MBT Boundary | Qwoach",
		"metaDescription": "Understand why Cognitive-Affect Balance is represented as a live MBT stance with no standalone form, rating, client task, or structured output.",
		"h1": "Cognitive-Affect Balance Is Not a Standalone Tool",
		"intro": "Cognitive-Affect Balance is an MBT live-session stance for practitioners. It concerns keeping a client within a workable balance between detached cognition and overwhelming affect so mentalizing can continue, but the supplied specification does not support a standalone tool, client view, form, rating, or structured output.",
		"demoTitle": "Review the product boundary",
		"demoPrompt": "Interested in using Cognitive-Affect Balance with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0430-f-017-mbt-007-r001-cognitive-affect-balance.md",
		"specId": "0430-f-017-mbt-007-r001-cognitive-affect-balance",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Why There Is No Demo",
				"body": "The specification states that Cognitive-Affect Balance is an in-session stance or adjustment with no inherent structured output. Creating fields, ratings, worksheets, prompts, or review artifacts would redefine the product."
			},
			{
				"title": "Where Documentation Belongs",
				"body": "If a practitioner wants to document a session moment, that belongs in ordinary session notes outside this tool boundary."
			}
		],
		"faqItems": [
			{
				"question": "Is Cognitive-Affect Balance a standalone tool?",
				"answer": "No. The specification marks it ineligible for standalone productization because it has no inherent structured output."
			},
			{
				"question": "Can this be made into a rating scale?",
				"answer": "No. Cognitive or affective balance ratings are unsupported by the supplied specification."
			},
			{
				"question": "Is there a client worksheet?",
				"answer": "No. The concept is a live practitioner stance, not a client-facing completion flow."
			},
			{
				"question": "Can the system detect balance automatically?",
				"answer": "No. Automated balance detection or classification is unsupported."
			}
		]
	},
	{
		"toolType": "notKnowingStance",
		"slug": "not-knowing-stance",
		"title": "Not-Knowing Stance MBT Session Support | Qwoach",
		"metaDescription": "A live MBT stance support for practitioners preserving curiosity, uncertainty, and multiple perspectives during therapeutic conversation.",
		"h1": "Not-Knowing Stance",
		"intro": "Not-Knowing Stance is a live MBT clinician posture support for practitioners who need to preserve curiosity and uncertainty about a client's mental states during therapy. It helps the practitioner keep interpretations tentative, invite clarification or disagreement, and leave multiple perspectives available.",
		"demoTitle": "Open the stance card and try an optional practitioner reflection.",
		"demoPrompt": "Interested in using Not-Knowing Stance with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0431-f-017-mbt-008-r001-not-knowing-stance.md",
		"specId": "0431-f-017-mbt-008-r001-not-knowing-stance",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this support during live MBT work when certainty about a client's mental states may close down curiosity, clarification, or alternative perspectives."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not collect client ratings, infer what the client really thinks or feels, produce an adherence score, or require a worksheet to be completed."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client worksheet?",
				"answer": "No. Not-Knowing Stance is a practitioner-facing live stance support, not a client worksheet or form."
			},
			{
				"question": "Does the tool generate interpretations of the client's mental state?",
				"answer": "No. The system does not infer what the client thinks or feels; it only supports the practitioner in keeping hypotheses tentative."
			},
			{
				"question": "Is there anything to save if there are no settings?",
				"answer": "Yes. Saving adds the fixed Not-Knowing Stance tool itself to the practitioner's account."
			}
		]
	},
	{
		"toolType": "empathicValidation",
		"slug": "empathic-validation",
		"title": "Empathic Validation MBT Support | Qwoach",
		"metaDescription": "A live MBT clinician support for acknowledging a client's emotional experience while preserving space for later mentalizing work.",
		"h1": "Empathic Validation",
		"intro": "Empathic Validation is a live MBT clinician response support for practitioners who need to recognize a client's emotional experience enough for the client to remain engaged in reflective work. It helps the practitioner validate subjective experience without automatically endorsing every conclusion or action.",
		"demoTitle": "Open the validation support and preview optional reflection.",
		"demoPrompt": "Interested in using Empathic Validation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0432-f-017-mbt-009-r001-empathic-validation.md",
		"specId": "0432-f-017-mbt-009-r001-empathic-validation",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this support when recognition of the client's subjective emotional experience is needed before moving toward self/other mental-state reflection."
			},
			{
				"title": "Important Boundary",
				"body": "The support does not judge whether the client's conclusions are accurate, generate therapeutic scripts, or measure client outcomes."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool tell me what to say?",
				"answer": "No. Exact validation wording is not defined; the tool supports the clinician's focus and optional reflection rather than generating scripts."
			},
			{
				"question": "Does empathic validation mean endorsing every conclusion or action?",
				"answer": "No. The tool explicitly supports recognizing emotional experience without necessarily endorsing all conclusions or actions."
			},
			{
				"question": "Is there a client screen?",
				"answer": "No. The client participates in conversation, but the product has no separate client-facing task."
			}
		]
	},
	{
		"toolType": "mentalizingBreakdownNonMentalizingModeIdentification",
		"slug": "mentalizing-breakdown-non-mentalizing-mode-identification",
		"title": "Mentalizing Breakdown Identification for MBT | Qwoach",
		"metaDescription": "A practitioner-only MBT tracking aid for recording breakdown context, non-mentalizing response patterns, triggers, and future session focus.",
		"h1": "Mentalizing Breakdown / Non-Mentalizing Mode Identification",
		"intro": "Mentalizing Breakdown / Non-Mentalizing Mode Identification is a practitioner-only MBT tracking aid for clinicians who need to record contexts and patterns in which mentalizing gives way to unhelpful non-mentalizing responses. It helps the practitioner organize breakdown context, response pattern, linked triggers or relational conditions, and future session focus.",
		"demoTitle": "Try a sample breakdown entry and review the pattern view.",
		"demoPrompt": "Interested in using Mentalizing Breakdown / Non-Mentalizing Mode Identification with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0433-f-017-mbt-010-r001-mentalizing-breakdown-non-mentalizing-mode-identification.md",
		"specId": "0433-f-017-mbt-010-r001-mentalizing-breakdown-non-mentalizing-mode-identification",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures practitioner-entered breakdown context, observed or reported cues, non-mentalizing response pattern, linked triggers or relational conditions, and optional future session focus."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not diagnose, score severity, automatically classify modes, infer mental states, or claim that a trigger caused the response."
			},
			{
				"title": "Repeat Use",
				"body": "Ongoing tracking can preserve prior entries so the practitioner can review repeated contexts or patterns descriptively over time."
			}
		],
		"faqItems": [
			{
				"question": "Is this client-facing?",
				"answer": "No. The tool is practitioner-only; client or family material may inform the entry through session conversation, but clients do not complete a product form."
			},
			{
				"question": "Does the system classify the non-mentalizing mode for me?",
				"answer": "No. The system organizes practitioner-entered descriptions but does not assign automated clinical labels or interpretations."
			},
			{
				"question": "Can I save a partial entry?",
				"answer": "Yes. Partial entries can be saved with unresolved context, pattern, or trigger information visible."
			},
			{
				"question": "What configuration is saved?",
				"answer": "The tool, selected tracking scope, selected entry mode, and reusable setup are saved; sample demo entries are not saved as real client data."
			}
		]
	},
	{
		"toolType": "interactionRewindPerspectiveExploration",
		"slug": "interaction-rewind-perspective-exploration",
		"title": "MBT Interaction Rewind Tool | Qwoach",
		"metaDescription": "A live MBT timeline tool for exploring difficult interactions, relational moves, tentative perspectives, and possible mentalizing shifts.",
		"h1": "Interaction Rewind / Perspective Exploration",
		"intro": "Interaction Rewind / Perspective Exploration is a live MBT session tool for practitioners, clients, and families examining a difficult interaction. It helps them build a chronological sequence, add plausible feelings, intentions, or interpretations as hypotheses, and identify where mentalizing may have been lost or could be restored.",
		"demoTitle": "Explore a sample rewind timeline.",
		"demoPrompt": "Interested in using Interaction Rewind / Perspective Exploration with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0434-f-017-mbt-011-r001-interaction-rewind-perspective-exploration.md",
		"specId": "0434-f-017-mbt-011-r001-interaction-rewind-perspective-exploration",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Practitioner And Client Roles",
				"body": "The practitioner structures and facilitates the rewind. Clients or family members can clarify, revise, disagree, or add perspectives during the session."
			},
			{
				"title": "What The Timeline Preserves",
				"body": "The timeline preserves ordered moves, reported actions, participant-provided mental-state descriptions, practitioner hypotheses, unresolved moments, and marked possible breakdown/restoration points."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not infer true intentions, decide blame, rank hypotheses, or produce clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Can clients or family members use this without an account?",
				"answer": "Yes. In the supported live-session configuration, participants can collaborate in session without a separate account or prework."
			},
			{
				"question": "Does the tool decide which perspective is true?",
				"answer": "No. Mental-state entries remain hypotheses, and the tool does not rank truth or assign blame."
			},
			{
				"question": "Can a partial rewind be saved?",
				"answer": "Yes. A partial timeline can preserve completed steps and mark unresolved moments."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The tool and selected configuration are saved; fictional timeline content and sample participant details are not carried into owned client data."
			}
		]
	},
	{
		"toolType": "noticingAndNaming",
		"slug": "noticing-and-naming",
		"title": "Noticing and Naming MBT-C Tool | Qwoach",
		"metaDescription": "A live MBT-C support for clinicians noticing and naming here-and-now cues to help a child re-engage shared attention.",
		"h1": "Noticing and Naming",
		"intro": "Noticing and Naming is a clinician-led MBT-C live-session support for child and family mental health clinicians. It helps the clinician notice and plainly name what is happening in the here and now so a child can re-engage shared attention and regain enough attentional regulation for later emotion or mental-state work.",
		"demoTitle": "Try the live cue card with sample, non-identifying context.",
		"demoPrompt": "Interested in using Noticing and Naming with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0435-f-017-mbt-013-r001-noticing-and-naming.md",
		"specId": "0435-f-017-mbt-013-r001-noticing-and-naming",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation",
				"Attention regulation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during MBT-C sessions when a child's attention or regulation makes it hard to stay with the shared therapeutic interaction."
			},
			{
				"title": "Teletherapy Context",
				"body": "Teletherapy support is limited to noting screen or remote-session context where it affects the here-and-now shared focus."
			},
			{
				"title": "Repeat Use",
				"body": "When observation capture is enabled, repeated notes can descriptively show attention-response patterns by context without formal scoring."
			}
		],
		"faqItems": [
			{
				"question": "Does the child fill anything out?",
				"answer": "No. The child does not complete a form; the clinician uses a live cue and observes the child's response."
			},
			{
				"question": "Can this be used in teletherapy?",
				"answer": "Yes. The supported teletherapy adaptation is noting screen or remote-session context as part of the here-and-now shared focus."
			},
			{
				"question": "Does the tool score attention control?",
				"answer": "No. It records optional clinician observations only and does not produce formal attention scores or diagnoses."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected settings are saved; fictional child context and sample observation notes are not carried over as real client data."
			}
		]
	},
	{
		"toolType": "mbtAdherenceScale",
		"slug": "mbt-adherence-scale",
		"title": "MBT Adherence Scale Tool | Qwoach",
		"metaDescription": "A practitioner-only MBT adherence review tool for structured performance evaluation, supervision notes, drafts, finals, and history.",
		"h1": "MBT Adherence Scale",
		"intro": "MBT Adherence Scale is a practitioner-only evaluation tool for MBT supervisors, trainers, evaluators, or practitioners reviewing practice. It helps them record structured practitioner-performance information, reviewer evidence notes, supervision focus, and longitudinal change where comparable scale data exist.",
		"demoTitle": "Preview the adherence review workflow.",
		"demoPrompt": "Interested in using MBT Adherence Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0436-f-017-mbt-015-r001-mbt-adherence-scale.md",
		"specId": "0436-f-017-mbt-015-r001-mbt-adherence-scale",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "What It Evaluates",
				"body": "The tool evaluates practitioner adherence and performance in MBT delivery, not client symptoms, satisfaction, diagnosis, or treatment outcomes."
			},
			{
				"title": "Draft And Final Reviews",
				"body": "Draft reviews may be incomplete and must show missing entries. Final reviews preserve the evaluation state for supervision and longitudinal comparison where comparable."
			},
			{
				"title": "Scoring Boundary",
				"body": "Totals, domains, trends, thresholds, or categories can appear only when the underlying scale defines how they are calculated."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool collect client data?",
				"answer": "No. It is practitioner-only and focuses on practitioner-performance data, not client symptom or outcome data."
			},
			{
				"question": "Can the public demo show the full scale items?",
				"answer": "No. The supplied specification does not include exact scale items, anchors, or scoring rules, so the demo cannot invent them."
			},
			{
				"question": "Can I save a draft review?",
				"answer": "Yes. Draft state supports incomplete capture with missing items visible."
			},
			{
				"question": "Can the tool calculate totals?",
				"answer": "Only if defined scoring rules are supplied. Without those rules, the system cannot calculate totals or interpretation categories."
			}
		]
	},
	{
		"toolType": "mbtCFidelityAdherenceScale",
		"slug": "mbt-c-fidelity-adherence-scale",
		"title": "MBT-C Fidelity Scale Tool | Qwoach",
		"metaDescription": "A practitioner-only MBT-C fidelity review tool for clinician behavior evaluation, evidence notes, draft/final review, and history.",
		"h1": "MBT-C Fidelity / Adherence Scale",
		"intro": "MBT-C Fidelity / Adherence Scale is a practitioner-only evaluation tool for MBT-C supervisors, trainers, evaluators, or clinicians reviewing practice. It helps them record structured clinician-fidelity information, evidence notes, strengths and weaknesses, and comparable history where the defined scale supports it.",
		"demoTitle": "Preview the MBT-C fidelity review workflow.",
		"demoPrompt": "Interested in using MBT-C Fidelity / Adherence Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0437-f-017-mbt-016-r001-mbt-c-fidelity-adherence-scale.md",
		"specId": "0437-f-017-mbt-016-r001-mbt-c-fidelity-adherence-scale",
		"tags": {
			"framework": [
				"MBT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Focuses On",
				"body": "The review focuses on clinician practice in child-focused MBT and the fidelity strengths and weaknesses relevant to supervision or development."
			},
			{
				"title": "What It Excludes",
				"body": "It does not collect child symptom change, family satisfaction, diagnostic conclusions, or treatment outcome claims."
			},
			{
				"title": "Comparable History",
				"body": "Final reviews can support comparison across sessions or time only when the same or comparable scale structure is used."
			}
		],
		"faqItems": [
			{
				"question": "Is this a tool for children or families to complete?",
				"answer": "No. It is a practitioner-only fidelity and adherence evaluation tool."
			},
			{
				"question": "Does it measure child outcomes?",
				"answer": "No. It assesses clinician practice, not child symptoms, family outcomes, or treatment results."
			},
			{
				"question": "Can the public demo include real scoring?",
				"answer": "No. Scoring can be shown only when exact scoring rules are supplied; the current specification does not include them."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected setup are saved; placeholder notes and fictional review data are not saved as real clinician-fidelity records."
			}
		]
	},
	{
		"toolType": "partsMapInternalSystemMap",
		"slug": "parts-map-internal-system-map",
		"title": "IFS Parts Map Tool | Qwoach",
		"metaDescription": "A collaborative IFS map for practitioners and clients to represent parts, relationships, conflicts, and supported dynamics over time.",
		"h1": "Parts Map / Internal System Map",
		"intro": "Parts Map / Internal System Map is a collaborative IFS visualization tool for practitioners and clients working with multiple inner experiences, conflicts, or protective responses. It helps them differentiate active parts, represent relationships or conflicts, and update the internal system picture as new dynamics emerge.",
		"demoTitle": "Build a sample parts map.",
		"demoPrompt": "Interested in using Parts Map / Internal System Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0438-f-018-ifs-001-r001-parts-map-internal-system-map.md",
		"specId": "0438-f-018-ifs-001-r001-parts-map-internal-system-map",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "What It Represents",
				"body": "The map represents parts or inner states, relationships or conflicts, supported protective/vulnerable indications, practitioner notes, unresolved areas, and update history."
			},
			{
				"title": "Client Collaboration",
				"body": "The client can participate by naming, correcting, moving, splitting, merging, or revising parts and relationships during collaborative use."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not diagnose, score, impose a taxonomy, infer hidden dynamics, or generate treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the map start with predefined part categories?",
				"answer": "No. Defaults favor a blank, client-led map rather than pre-filled categories."
			},
			{
				"question": "Can the client edit the map during session?",
				"answer": "Yes. In shared in-session mapping mode, the client can help name, move, correct, and revise parts or relationships."
			},
			{
				"question": "Can I use a list instead of a visual canvas?",
				"answer": "Yes. Map view can be visual canvas or structured list, and switching views preserves the same content."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool and selected settings are saved; fictional demo parts and relationships are not saved as real client data."
			}
		]
	},
	{
		"toolType": "protectorMap",
		"slug": "protector-map",
		"title": "IFS Protector Map Tool | Qwoach",
		"metaDescription": "A collaborative IFS protector profile for mapping protective parts, roles, fears or concerns, current effects, and treatment pace.",
		"h1": "Protector Map",
		"intro": "Protector Map is a collaborative IFS tool for practitioners and clients when protective responses are prominent. It helps them differentiate protective parts or responses, describe roles or functions, name fears or concerns where supported, and understand how protectors affect current functioning and treatment pace.",
		"demoTitle": "Create a sample protector profile.",
		"demoPrompt": "Interested in using Protector Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0439-f-018-ifs-002-r001-protector-map.md",
		"specId": "0439-f-018-ifs-002-r001-protector-map",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The profile captures protector description, role/function, what the protector is trying to prevent, how it operates, effects on current functioning, and pace implications."
			},
			{
				"title": "Client Language",
				"body": "The client can use preferred descriptions, correct practitioner framing, reject a role description, or leave concerns unresolved."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not infer hidden fears, require formal labels, score readiness, diagnose, or prescribe treatment steps."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as a full parts map?",
				"answer": "No. Protector Map is focused on protective parts or responses, not the client's entire internal system."
			},
			{
				"question": "Do all protectors need formal categories?",
				"answer": "No. The tool allows client-preferred descriptions and does not require mandatory categories for every protector."
			},
			{
				"question": "Can unknown concerns remain blank?",
				"answer": "Yes. Unknown role, fear, or function can remain unresolved and visible."
			},
			{
				"question": "What saves from the demo?",
				"answer": "The tool and selected settings are saved; fictional protector profiles and sample notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "partExternalization",
		"slug": "part-externalization",
		"title": "IFS Part Externalization Tool | Qwoach",
		"metaDescription": "A collaborative IFS tool for capturing a part representation through drawing, object/image capture, arrangement, or text description.",
		"h1": "Part Externalization",
		"intro": "Part Externalization is a collaborative IFS tool for practitioners and clients, especially child clients, when an inner part is hard to talk about directly or feels too fused with the whole self. It helps them create or capture an observable representation, describe relevant attributes, and keep the representation separate from practitioner interpretation.",
		"demoTitle": "Try a sample part representation.",
		"demoPrompt": "Interested in using Part Externalization with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0440-f-018-ifs-003-r001-part-externalization.md",
		"specId": "0440-f-018-ifs-003-r001-part-externalization",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Representation Modes",
				"body": "The tool supports captured object/image, drawing, digital arrangement, or text-only description as ways to make a part observable."
			},
			{
				"title": "Child-Oriented Use",
				"body": "For children, the interaction should be concrete, low in reading demand, and able to pause without forcing completion."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not analyze symbols, diagnose, score, require a full parts map, or infer meaning from drawings or objects."
			}
		],
		"faqItems": [
			{
				"question": "Does the system interpret the drawing or object?",
				"answer": "No. The system does not perform symbolic analysis or infer meaning from the representation."
			},
			{
				"question": "Can the activity be text-only?",
				"answer": "Yes. Text-only description is a supported representation mode when no visual capture is available or preferred."
			},
			{
				"question": "Can a child revise the representation later?",
				"answer": "Yes. The workflow supports replacing or revising the representation, with revision history when enabled."
			},
			{
				"question": "What saves from the demo?",
				"answer": "The tool and selected settings are saved; fictional representations, sample media, labels, attributes, and notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "6FSProcess",
		"slug": "6-f-s-process",
		"title": "6 F's Process Demo for IFS Parts Inquiry | Qwoach",
		"metaDescription": "Explore a guided 6 F's Process session aid for clarifying an active part's role, fears, relationship, and unresolved areas.",
		"h1": "6 F's Process for IFS Parts Inquiry",
		"intro": "6 F's Process is a guided IFS parts-inquiry tool for practitioners working with clients in session. It helps practitioner and client clarify an active part's role, fears or concerns, and relationship within the client's internal system.",
		"demoTitle": "Start with sample part notes",
		"demoPrompt": "Interested in using 6 F's Process with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0441-f-018-ifs-004-r001-6-f-s-process.md",
		"specId": "0441-f-018-ifs-004-r001-6-f-s-process",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Assessment"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool during live or near-live parts work when one active part seems present but its role, fears, and relationship to the client are not yet clear."
			},
			{
				"title": "What It Captures",
				"body": "The record captures part identity cues, role or function, fears or concerns, relationship to the client or internal system, openness or curiosity evidence, practitioner observations, and unresolved areas."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide exact 6 F's prompt wording, score Self access, diagnose parts, infer part types, or prescribe next therapeutic steps."
			}
		],
		"faqItems": [
			{
				"question": "Is this a standalone worksheet for clients?",
				"answer": "No. 6 F's Process is a practitioner-guided session aid for live or near-live use, with optional shared completion."
			},
			{
				"question": "Does the demo use the exact six 6 F's prompts?",
				"answer": "No. The product specification does not define the exact six prompts, so the demo uses neutral supported section labels instead of invented wording."
			},
			{
				"question": "What is saved when I save the tool?",
				"answer": "The tool itself and the selected capture configuration are saved into your account. Demo notes and fictional sample content are not saved as real client data."
			},
			{
				"question": "Does the result score the client's state?",
				"answer": "No. The result is descriptive and shows recorded support, unresolved areas, and readiness for continuation based only on entered information."
			}
		]
	},
	{
		"toolType": "unblending",
		"slug": "unblending",
		"title": "Unblending Demo for IFS Live Sessions | Qwoach",
		"metaDescription": "Explore a live-session Unblending support tool for tracking part identification, separation evidence, steadiness, and readiness notes.",
		"h1": "Unblending Live-Session Support Tool",
		"intro": "Unblending is a live-session IFS process support tool for practitioners. It helps practitioners document separation from an active feeling, belief, impulse, or part and assess whether the client is steady enough to continue therapeutic work.",
		"demoTitle": "Open the live state card",
		"demoPrompt": "Interested in using Unblending with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0442-f-018-ifs-005-r001-unblending.md",
		"specId": "0442-f-018-ifs-005-r001-unblending",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Assessment"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it only during live session work when a client is strongly identified with an active part, feeling, belief, or impulse."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures client language, evidence of noticing or separation, steadiness indicators, practitioner observations, pause reasons, and readiness for deeper work."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not perform unblending, score intensity, infer Self access, issue safety determinations, or prescribe clinical steps."
			}
		],
		"faqItems": [
			{
				"question": "Can a client complete Unblending on their own?",
				"answer": "No. The tool is live-session-only and practitioner-guided."
			},
			{
				"question": "Does Unblending score intensity or Self access?",
				"answer": "No. It records descriptive evidence and practitioner-entered readiness states without numeric scoring."
			},
			{
				"question": "What is saved for this fixed tool?",
				"answer": "The Unblending tool itself is saved as-is, with the optional display preference if selected. Fictional demo state content is not saved as client data."
			},
			{
				"question": "What happens if the client remains fully blended?",
				"answer": "The record can remain partial or be marked insufficient, paused, or ongoing without treating that as a product failure."
			}
		]
	},
	{
		"toolType": "protectorFearsInquiry",
		"slug": "protector-fears-inquiry",
		"title": "Protector Fears Inquiry Demo | Qwoach",
		"metaDescription": "Explore an IFS protector inquiry tool for clarifying fears, protective function, permission needs, and bypass or escalation risk.",
		"h1": "Protector Fears Inquiry for IFS Sessions",
		"intro": "Protector Fears Inquiry is a guided IFS protector inquiry tool for practitioners and clients working together in session. It helps make a protective part's fears, protective function, and conditions for further work explicit enough for the practitioner to respond respectfully.",
		"demoTitle": "Build a sample protector concern brief",
		"demoPrompt": "Interested in using Protector Fears Inquiry with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0443-f-018-ifs-006-r001-protector-fears-inquiry.md",
		"specId": "0443-f-018-ifs-006-r001-protector-fears-inquiry",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before vulnerable work when a protector's reluctance, reactivity, or obstruction needs respectful clarification."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures protector identification, feared outcome, protective function, reassurance or permission needs, escalation or bypass risk, and practitioner next-work status."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate reassurance scripts, label protector types, rate cooperation, or decide that permission has been granted."
			}
		],
		"faqItems": [
			{
				"question": "Is this a fear-rating scale?",
				"answer": "No. Protector Fears Inquiry captures specific protector fears and functions descriptively without numeric ratings."
			},
			{
				"question": "Who decides whether further work can proceed?",
				"answer": "The practitioner decides and records the next-work state; the system does not automate clinical permission."
			},
			{
				"question": "Can unclear protector concerns be saved?",
				"answer": "Yes. The review can preserve vague or unresolved fears and show that further work may be premature."
			},
			{
				"question": "What is saved when I use the public demo?",
				"answer": "Only the tool and selected capture mode are saved after account creation or login. Fictional demo content is not saved as client data."
			}
		]
	},
	{
		"toolType": "polarizationMap",
		"slug": "polarization-map",
		"title": "Polarization Map Demo for IFS Parts Work | Qwoach",
		"metaDescription": "Explore a two-sided IFS conflict map for distinguishing opposing parts, aims, concerns, relationship patterns, and readiness notes.",
		"h1": "Polarization Map for IFS Internal Conflict",
		"intro": "Polarization Map is an IFS internal conflict mapping tool for practitioners working with clients in session. It helps practitioner and client represent opposing parts, urges, values, or responses so the conflict structure is clear enough for mediation or further parts work.",
		"demoTitle": "Create a sample two-sided map",
		"demoPrompt": "Interested in using Polarization Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0444-f-018-ifs-007-r001-polarization-map.md",
		"specId": "0444-f-018-ifs-007-r001-polarization-map",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client is caught between opposing parts, urges, values, or responses and the structure of the conflict needs to be visible."
			},
			{
				"title": "What It Captures",
				"body": "The map captures side names or descriptions, each side's protective aim or concern, the interaction pattern, unresolved areas, and perspective/readiness notes."
			},
			{
				"title": "History And Reuse",
				"body": "Historical maps can show how a conflict structure changes across sessions without overwriting earlier maps or implying progress automatically."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not score conflict severity, decide which side is right, merge sides automatically, or provide a mediation protocol."
			}
		],
		"faqItems": [
			{
				"question": "Is Polarization Map a decision matrix?",
				"answer": "No. It maps internal conflict structure between parts or positions; it does not rank options or choose an answer."
			},
			{
				"question": "Can the map include more than two sides?",
				"answer": "Yes, only as an edge case when the conflict cannot be represented accurately by two sides. The primary polarization remains clear."
			},
			{
				"question": "What happens if one side is vague?",
				"answer": "The map shows that side as unresolved instead of inventing a label or aim."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The tool, selected layout, and collaboration setting are saved. Fictional demo map content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "trailheadIdentification",
		"slug": "trailhead-identification",
		"title": "Trailhead Identification Demo | Qwoach",
		"metaDescription": "Explore an IFS trailhead tool for linking a present-moment thought, feeling, sensation, image, or reaction to a target part.",
		"h1": "Trailhead Identification for IFS Session Focus",
		"intro": "Trailhead Identification is an IFS session-orientation tool for practitioners and clients working together. It helps identify a specific target part or internal response from the client's present-moment thought, feeling, sensation, image, or reaction.",
		"demoTitle": "Try a sample cue-to-target card",
		"demoPrompt": "Interested in using Trailhead Identification with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0445-f-018-ifs-008-r001-trailhead-identification.md",
		"specId": "0445-f-018-ifs-008-r001-trailhead-identification",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Session preparation",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a current thought, feeling, sensation, image, or reaction may be a useful entry point for parts work."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the present-moment cue, candidate target, distinctness, emotional relevance, tolerance concerns, and practitioner next-step decision."
			},
			{
				"title": "Important Limits",
				"body": "The tool stops at identifying a workable trailhead and target. It does not infer hidden parts, diagnose meaning, or generate therapeutic directions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a full part exploration tool?",
				"answer": "No. Trailhead Identification identifies a cue and target entry point; it does not create a complete part formulation."
			},
			{
				"question": "Can the result be unresolved?",
				"answer": "Yes. A cue can be preserved with no clear target, multiple candidates, or a too-intense workability state."
			},
			{
				"question": "Does the tool choose the target automatically?",
				"answer": "No. The practitioner records or selects the target and next-step decision."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected capture mode are saved. Fictional cue and target content from the demo is not saved as real client data."
			}
		]
	},
	{
		"toolType": "inSight",
		"slug": "in-sight",
		"title": "In-sight Demo for IFS Inner Awareness | Qwoach",
		"metaDescription": "Explore an In-sight documentation tool for capturing a client's reported inner awareness of a part's beliefs, feelings, needs, or concerns.",
		"h1": "In-sight Live-Session Documentation Tool",
		"intro": "In-sight is a live-session IFS inner-awareness support and documentation tool for practitioners. It helps capture a client's reported awareness of a part's beliefs, feelings, needs, or concerns while tracking separation, specificity, and uncertainty.",
		"demoTitle": "Open a sample In-sight note",
		"demoPrompt": "Interested in using In-sight with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0446-f-018-ifs-009-r001-in-sight.md",
		"specId": "0446-f-018-ifs-009-r001-in-sight",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Clinical documentation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client can attend inwardly to a part and report what they notice from that inner awareness."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures reported beliefs, feelings, needs, concerns, uncertainty markers, separation observations, specificity, and practitioner next-response notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not verify inner awareness, generate clinical prompts, diagnose part content, or automate the next intervention."
			}
		],
		"faqItems": [
			{
				"question": "Is In-sight the same as Direct Access?",
				"answer": "No. In-sight documents the client's inward awareness of a part; Direct Access documents practitioner contact with a part in live session."
			},
			{
				"question": "Can uncertain or speculative reports be recorded?",
				"answer": "Yes. The tool can mark material as speculative or unclear instead of presenting it as direct awareness."
			},
			{
				"question": "Does the client fill this out independently?",
				"answer": "No. In-sight is live-session support, with optional minimal shared display only."
			},
			{
				"question": "What gets saved?",
				"answer": "The In-sight tool itself is saved, with optional shared visibility preference if selected. Fictional demo notes are not saved as client data."
			}
		]
	},
	{
		"toolType": "directAccess",
		"slug": "direct-access",
		"title": "Direct Access Demo for IFS Practitioners | Qwoach",
		"metaDescription": "Explore a Direct Access documentation tool for recording part voice, beliefs, fears, containment notes, and practitioner next response.",
		"h1": "Direct Access Live-Session Documentation Tool",
		"intro": "Direct Access is a live-session IFS practitioner-contact support and documentation tool. It helps practitioners record a part's distinguishable voice or perspective, beliefs, fears, concerns, containment observations, and next-response decision.",
		"demoTitle": "Open a sample interaction note",
		"demoPrompt": "Interested in using Direct Access with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0447-f-018-ifs-010-r001-direct-access.md",
		"specId": "0447-f-018-ifs-010-r001-direct-access",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"In-session support",
				"Clinical documentation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during live session work when practitioner contact with a part is clinically relevant and client-mediated contact may be insufficient."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures part voice or perspective, beliefs, fears, concerns, containment observations, speaker or perspective distinctions, and practitioner next-response states."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate therapeutic dialogue, negotiate with parts, verify authenticity, automate safety clearance, or present Direct Access as self-guided."
			}
		],
		"faqItems": [
			{
				"question": "Does Direct Access talk to parts for the practitioner?",
				"answer": "No. The tool documents practitioner-led live contact; it does not simulate dialogue or generate scripts."
			},
			{
				"question": "Can I mark the part voice as unclear?",
				"answer": "Yes. If the part's perspective is not distinguishable, the record should mark it unclear rather than claiming Direct Access produced explicit content."
			},
			{
				"question": "Is there a client form for this tool?",
				"answer": "No. There is no standalone client form; optional shared visibility is minimal and practitioner-controlled."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The fixed Direct Access tool is saved into the account. Fictional interaction content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "exileWitnessing",
		"slug": "exile-witnessing",
		"title": "Exile Witnessing Demo for IFS Practitioners | Qwoach",
		"metaDescription": "Explore an Exile Witnessing documentation tool for recording burdened experience, unmet need, compassion, containment, and readiness.",
		"h1": "Exile Witnessing Live-Session Documentation Tool",
		"intro": "Exile Witnessing is a live-session IFS healing-step support and documentation tool for practitioners. It helps record a vulnerable part's painful experience and unmet need being witnessed with clarity and compassion, while tracking containment and practitioner readiness judgment.",
		"demoTitle": "Open a sample witnessing note",
		"demoPrompt": "Interested in using Exile Witnessing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0448-f-018-ifs-011-r001-exile-witnessing.md",
		"specId": "0448-f-018-ifs-011-r001-exile-witnessing",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"In-session support",
				"Clinical documentation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after protective concerns have been sufficiently addressed and a vulnerable part's burdened experience is available in live session."
			},
			{
				"title": "What It Captures",
				"body": "The record captures readiness conditions, burdened experience, unmet need or wound, client stance, compassion or support, overwhelm or containment, and practitioner readiness state."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not elicit trauma content, force narrative detail, prescribe witnessing prompts, score distress, or determine readiness automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does Exile Witnessing ask the client to write a trauma narrative?",
				"answer": "No. The tool supports sparse practitioner documentation and should not force painful detail."
			},
			{
				"question": "Can a session pause before completion?",
				"answer": "Yes. Pause, unclear, and partial states are valid and preserved in the record."
			},
			{
				"question": "Who decides readiness for subsequent healing work?",
				"answer": "The practitioner records readiness; the system does not decide it automatically."
			},
			{
				"question": "What is saved into the account?",
				"answer": "The fixed Exile Witnessing tool is saved. Fictional demo content and sample vulnerable part notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "retrieval",
		"slug": "retrieval",
		"title": "Retrieval Demo for IFS Healing-Step Tracking | Qwoach",
		"metaDescription": "Explore a Retrieval documentation tool for tracking before/after context, transition status, protector resistance, overwhelm, and stabilization.",
		"h1": "Retrieval Minimal Live-Session Documentation Tool",
		"intro": "Retrieval is a live-session IFS healing-step support and minimal documentation tool for practitioners. It helps track whether a vulnerable part is experienced as no longer trapped in an original distressing context after witnessing.",
		"demoTitle": "Open a sample transition card",
		"demoPrompt": "Interested in using Retrieval with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0449-f-018-ifs-012-r001-retrieval.md",
		"specId": "0449-f-018-ifs-012-r001-retrieval",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"In-session support",
				"Clinical documentation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after witnessing when the vulnerable part is still experienced as located in a distressing past context."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures initial and later experienced context, transition status, protector resistance, overwhelm, and stabilization notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide retrieval scripts, imagery instructions, detailed trauma reconstruction, distress scores, or automated healing claims."
			}
		],
		"faqItems": [
			{
				"question": "Does Retrieval generate imagery or steps?",
				"answer": "No. Retrieval documents the live process; it does not generate imagery, scripts, or instructions."
			},
			{
				"question": "Can the result be not transitioned?",
				"answer": "Yes. Not transitioned, paused, unclear, and partial outcomes are supported and are not product failures."
			},
			{
				"question": "Why is the review so minimal?",
				"answer": "The tool intentionally has little structured output and focuses on before/after experiential context and stabilization notes."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed Retrieval tool is saved as-is. Fictional transition content and sample notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "unburdening",
		"slug": "unburdening",
		"title": "Unburdening Demo for IFS Practitioners | Qwoach",
		"metaDescription": "Explore an Unburdening documentation tool for recording before burden, reported change, new state or role, and settledness notes.",
		"h1": "Unburdening Before-and-After Documentation Tool",
		"intro": "Unburdening is a live-session IFS healing-step documentation tool for practitioners. It helps record a before-and-after internal shift in which a burdened part is relieved of a burdened belief, feeling, or role and shows a changed state or role.",
		"demoTitle": "Open a sample before-and-after card",
		"demoPrompt": "Interested in using Unburdening with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0450-f-018-ifs-013-r001-unburdening.md",
		"specId": "0450-f-018-ifs-013-r001-unburdening",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Clinical documentation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a burdened part has been accessed, witnessed, and is ready for a change in what it carries."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures readiness confirmations, before burden, reported or observed reduction, new preferred state or role, internal settledness, partial or unclear outcomes, and practitioner observations."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate unburdening steps, rituals, symbolic content, symptom outcome scores, or automated claims that healing occurred."
			},
			{
				"title": "Repeat Review",
				"body": "Historical records can support later consolidation by showing prior burdens and changed states, without implying symptom outcomes automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does Unburdening provide a ritual or script?",
				"answer": "No. The tool documents practitioner-guided live work and does not generate rituals, scripts, or symbolic content."
			},
			{
				"question": "Can a partial shift be recorded?",
				"answer": "Yes. Partial, unclear, paused, and unsettled states are supported and shown plainly in review."
			},
			{
				"question": "Does the result prove healing occurred?",
				"answer": "No. The result is a descriptive before/after comparison and settledness note; it does not make automated healing claims."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The fixed Unburdening tool is saved, with optional shared display preference if selected. Fictional demo before/after content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "futureImaging",
		"slug": "future-imaging",
		"title": "Future Imaging Demo for IFS Practitioners | Qwoach",
		"metaDescription": "Explore Future Imaging, a live-session IFS-oriented tool for mapping future situations, anticipated part responses, and obstacles.",
		"h1": "Future Imaging for IFS-oriented consolidation work",
		"intro": "Future Imaging is a live-session IFS-oriented consolidation tool for practitioners. It helps practitioner and client imagine a relevant future context after internal-system change and record anticipated part responses, workable future roles, fears, and obstacles.",
		"demoTitle": "Try the sample future image",
		"demoPrompt": "Interested in using Future Imaging with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0451-f-018-ifs-014-r001-future-imaging.md",
		"specId": "0451-f-018-ifs-014-r001-future-imaging",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during or just after a consolidation point in a live session, when the client can imagine a relevant future context and report how internal responses may differ."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not score stability, predict future behavior, provide fixed prompts, or interpret the clinical meaning of responses."
			}
		],
		"faqItems": [
			{
				"question": "Does Future Imaging predict whether change will hold?",
				"answer": "No. Future Imaging records the client's imagined future situation, anticipated internal responses, and obstacles; it does not predict outcomes."
			},
			{
				"question": "Do parts have to be named?",
				"answer": "No. The practitioner can capture named part entries or use general internal response entries when the client does not name parts."
			},
			{
				"question": "Can a partial future image be saved?",
				"answer": "Yes. A scenario can remain incomplete when responses are unclear or fears and obstacles are still emerging."
			}
		]
	},
	{
		"toolType": "partsTableSeatAtTheTableMap",
		"slug": "parts-table-seat-at-the-table-map",
		"title": "Parts Table Map Demo for IFS Practitioners | Qwoach",
		"metaDescription": "Explore an IFS-oriented parts table map for distinguishing key parts, roles, alliances, conflicts, and next-focus notes.",
		"h1": "Map parts, roles, and relationships in one shared view",
		"intro": "Parts Table / Seat-at-the-Table Map is an IFS-oriented internal-system mapping tool for practitioners and clients. It helps them distinguish key parts, capture roles or positions, show important relationships, and decide what part or relationship may need attention next.",
		"demoTitle": "Open the sample parts map",
		"demoPrompt": "Interested in using Parts Table / Seat-at-the-Table Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0452-f-018-ifs-015-r001-parts-table-seat-at-the-table-map.md",
		"specId": "0452-f-018-ifs-015-r001-parts-table-seat-at-the-table-map",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Client Roles",
				"body": "The practitioner creates and edits the formal record; the client can help name parts, clarify roles, and describe relationships during collaborative work."
			},
			{
				"title": "Longitudinal Use",
				"body": "The same map can be reopened later, updated as new parts emerge, and compared over time while preserving earlier labels and relationships."
			},
			{
				"title": "Limitations",
				"body": "The tool does not infer hidden parts, assign archetypes, score severity, or automatically decide which part should be addressed next."
			}
		],
		"faqItems": [
			{
				"question": "Can the map start with only one part?",
				"answer": "Yes. A one-part map can be saved as provisional, with relationships marked as not yet available."
			},
			{
				"question": "Are table view and seat-at-the-table view different tools?",
				"answer": "No. They are two representations of the same parts, role notes, and relationship links."
			},
			{
				"question": "Does the tool decide which part to work with next?",
				"answer": "No. The practitioner can add a next-focus note, but the tool does not automatically sequence parts work."
			}
		]
	},
	{
		"toolType": "unburdenedInternalSystemMandala",
		"slug": "unburdened-internal-system-mandala",
		"title": "Unburdened Internal System Mandala Demo | Qwoach",
		"metaDescription": "Explore a reflective IFS-oriented visual tool for discussing preferred internal-system configuration and client responses.",
		"h1": "Reflect on a preferred internal system state",
		"intro": "Unburdened Internal System Mandala is an IFS-oriented reflective visual tool for practitioners using live discussion after or alongside healing-oriented parts work. It helps practitioner and client discuss a preferred internal system, relieved or transformed roles, healthier relationships, and whether that state feels believable or stable.",
		"demoTitle": "Try the reflection record",
		"demoPrompt": "Interested in using Unburdened Internal System Mandala with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0453-f-018-ifs-016-r001-unburdened-internal-system-mandala.md",
		"specId": "0453-f-018-ifs-016-r001-unburdened-internal-system-mandala",
		"tags": {
			"framework": [
				"IFS"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during a reflective session moment after or alongside healing-oriented parts work, when the client is considering a preferred internal configuration."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not define exact mandala content, require a worksheet sequence, score stability, or interpret symbolic meaning."
			}
		],
		"faqItems": [
			{
				"question": "Does the client have to complete every part of the image?",
				"answer": "No. The tool supports visual presentation plus optional notes or annotations; it does not require labeling every part."
			},
			{
				"question": "What if the image does not resonate?",
				"answer": "Record that response. Non-resonance can be captured as useful discussion material without treating the reflection as failed."
			},
			{
				"question": "Does the tool score whether the system is harmonious?",
				"answer": "No. It organizes reported discussion and concerns but does not score harmony, stability, or transformation."
			}
		]
	},
	{
		"toolType": "externalisingConversationMap",
		"slug": "externalising-conversation-map",
		"title": "Externalising Conversation Map Demo | Qwoach",
		"metaDescription": "Explore a narrative therapy map for naming an externalized problem, its characteristics, and the client-problem relationship.",
		"h1": "Separate the person from the problem in a shared map",
		"intro": "Externalising Conversation Map is a narrative therapy tool for practitioners and clients. It helps them understand a problem as separate from the person by recording a separate problem name, the problem's characteristics or patterns, and the client's relationship to the problem.",
		"demoTitle": "Build a sample externalized profile",
		"demoPrompt": "Interested in using Externalising Conversation Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0454-f-019-nar-001-r001-externalising-conversation-map.md",
		"specId": "0454-f-019-nar-001-r001-externalising-conversation-map",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Minimum Useful Record",
				"body": "A minimally complete map includes a separate problem name and at least one characteristic, effect, pattern, or relationship note."
			},
			{
				"title": "What It Does Not Do",
				"body": "The map does not diagnose, rate severity, assign causes, or impose the correct externalized name."
			}
		],
		"faqItems": [
			{
				"question": "Can the problem name be provisional?",
				"answer": "Yes. Candidate names can remain unresolved and be revised without deleting the history of the conversation."
			},
			{
				"question": "Does the tool require original wording?",
				"answer": "No. Original wording comparison is optional and can be turned off."
			},
			{
				"question": "Does the map provide a diagnosis?",
				"answer": "No. It records externalized language and reported relationship notes; it does not diagnose or rate severity."
			}
		]
	},
	{
		"toolType": "mappingTheInfluenceOfTheProblem",
		"slug": "mapping-the-influence-of-the-problem",
		"title": "Problem Influence Map Demo | Qwoach",
		"metaDescription": "Explore a narrative therapy impact map for organizing an externalized problem's effects across editable life domains.",
		"h1": "Map where an externalized problem has influence",
		"intro": "Mapping the Influence of the Problem is a narrative therapy impact-mapping tool for practitioners and clients. It helps them make an externalized problem's influence clear across relevant life domains so they can evaluate effects and choose possible areas for therapeutic focus.",
		"demoTitle": "Explore the sample influence map",
		"demoPrompt": "Interested in using Mapping the Influence of the Problem with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0455-f-019-nar-002-r001-mapping-the-influence-of-the-problem.md",
		"specId": "0455-f-019-nar-002-r001-mapping-the-influence-of-the-problem",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The map captures an externalized problem label, editable domains, multiple effect entries per domain, optional evaluation notes, and practitioner-marked focus areas."
			},
			{
				"title": "Partial Maps",
				"body": "A one-domain map can be saved as in-progress, but it should not be presented as a complete multidomain map."
			},
			{
				"title": "Limitations",
				"body": "The tool does not score severity, require a fixed domain inventory, explain causes, or automatically prioritize domains."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool require fixed life domains?",
				"answer": "No. Domains are editable, removable, and can be defined by the practitioner and client."
			},
			{
				"question": "What if the problem has not been externalized yet?",
				"answer": "A problem label is required before completing the influence map; the label can be provisional."
			},
			{
				"question": "Does the map rank which area matters most?",
				"answer": "No. Candidate focus areas are selected by people, not automatically ranked by the system."
			}
		]
	},
	{
		"toolType": "mappingThePersonSInfluenceOnTheProblem",
		"slug": "mapping-the-person-s-influence-on-the-problem",
		"title": "Person's Influence on the Problem Demo | Qwoach",
		"metaDescription": "Explore a narrative therapy agency inventory for mapping actions, choices, values, and exceptions tied to a problem.",
		"h1": "Map the client's responses to the problem",
		"intro": "Mapping the Person's Influence on the Problem is a narrative therapy agency-mapping tool for practitioners and clients. It helps them record specific moments when the client resisted, reduced, or altered an externalized problem's influence and connect those moments to actions, choices, skills, values, or intentions.",
		"demoTitle": "Create a sample agency inventory",
		"demoPrompt": "Interested in using Mapping the Person's Influence on the Problem with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0456-f-019-nar-003-r001-mapping-the-person-s-influence-on-the-problem.md",
		"specId": "0456-f-019-nar-003-r001-mapping-the-person-s-influence-on-the-problem",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Minimum Useful Entry",
				"body": "A minimal entry needs a specific moment or example and an explicit connection to the externalized problem. Values or skills can be added later."
			},
			{
				"title": "How Grouping Works",
				"body": "Grouping is descriptive. It helps review entered examples through different lenses but does not infer traits or score agency."
			}
		],
		"faqItems": [
			{
				"question": "Can an example be saved without a named value?",
				"answer": "Yes. A moment and response can be saved when connected to the problem, even if values or skills are not yet clear."
			},
			{
				"question": "What if a positive example is not connected to the problem?",
				"answer": "It can be captured as unresolved, but it is not complete agency evidence until the connection is clarified."
			},
			{
				"question": "Does the tool infer the client's strengths?",
				"answer": "No. Skills, values, and intentions are entered from client or practitioner discussion; the system does not infer them."
			}
		]
	},
	{
		"toolType": "uniqueOutcomesMap",
		"slug": "unique-outcomes-map",
		"title": "Unique Outcomes Map Demo | Qwoach",
		"metaDescription": "Explore a narrative therapy map for identifying exceptions, significance, values, and preferred-identity links.",
		"h1": "Map credible exceptions to the dominant problem story",
		"intro": "Unique Outcomes Map is a narrative therapy tool for practitioners and clients. It helps them identify specific experiences, actions, or meanings that do not fit a dominant problem-saturated story and connect those exceptions to significance, values, intentions, or preferred identity.",
		"demoTitle": "Explore the sample unique outcomes",
		"demoPrompt": "Interested in using Unique Outcomes Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0457-f-019-nar-004-r001-unique-outcomes-map.md",
		"specId": "0457-f-019-nar-004-r001-unique-outcomes-map",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Thin And Developed Entries",
				"body": "An exception can be captured before its significance is fully explored. Review marks these as needing further development rather than treating them as complete evidence."
			},
			{
				"title": "Limits",
				"body": "The tool does not decide what counts as significant, score exception strength, or write the preferred story automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does every positive event count as a unique outcome?",
				"answer": "No. The entry needs a clear relation to the dominant problem story; otherwise the contradiction remains unresolved."
			},
			{
				"question": "Can significance be added later?",
				"answer": "Yes. Entries without significance can remain thin and be developed in later conversation."
			},
			{
				"question": "Does the tool generate preferred identity statements?",
				"answer": "No. Identity connections must be grounded in entered examples and client or practitioner discussion."
			}
		]
	},
	{
		"toolType": "reAuthoringConversationMap",
		"slug": "re-authoring-conversation-map",
		"title": "Re-authoring Conversation Map Demo | Qwoach",
		"metaDescription": "Explore a narrative therapy map for linking preferred events, meanings, values, identity claims, and future actions.",
		"h1": "Connect preferred events into a grounded story",
		"intro": "Re-authoring Conversation Map is a narrative therapy tool for practitioners and clients. It helps them link preferred events or exceptions to meanings, values, hopes, commitments, identity claims, and possible future actions so an emerging preferred story is grounded in experience.",
		"demoTitle": "Map a sample preferred story",
		"demoPrompt": "Interested in using Re-authoring Conversation Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0458-f-019-nar-005-r001-re-authoring-conversation-map.md",
		"specId": "0458-f-019-nar-005-r001-re-authoring-conversation-map",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Grounding Matters",
				"body": "The map can show when an identity claim is not yet linked to concrete experience, so the practitioner can keep the story grounded."
			},
			{
				"title": "Use Over Time",
				"body": "The map can begin as fragments and develop into a more coherent preferred story as additional events and meanings are added."
			},
			{
				"title": "Limits",
				"body": "The tool structures entered material but does not automatically author the preferred story or create identity claims."
			}
		],
		"faqItems": [
			{
				"question": "Can the map start with only one event?",
				"answer": "Yes. A preferred story can begin with one concrete event linked to meaning or identity-related content."
			},
			{
				"question": "Are future actions required?",
				"answer": "No. Future actions are a natural continuation but may be absent in early drafts."
			},
			{
				"question": "Does the tool write the preferred story automatically?",
				"answer": "No. A readable summary may only reflect entered content and should remain editable by the practitioner or client."
			}
		]
	},
	{
		"toolType": "reMemberingConversationMap",
		"slug": "re-membering-conversation-map",
		"title": "Re-membering Conversation Map Demo | Qwoach",
		"metaDescription": "Explore a narrative therapy relational identity map for people, communities, histories, influences, and contributions.",
		"h1": "Map relationships that support preferred identity",
		"intro": "Re-membering Conversation Map is a narrative therapy relational identity mapping tool for practitioners and clients. It helps them identify significant people, communities, histories, influences, and the client's contributions that support a preferred identity or story.",
		"demoTitle": "Explore the sample relational map",
		"demoPrompt": "Interested in using Re-membering Conversation Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0459-f-019-nar-006-r001-re-membering-conversation-map.md",
		"specId": "0459-f-019-nar-006-r001-re-membering-conversation-map",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The map captures people, communities, or histories; how they influence preferred identity; what the client contributes; and whether the relationship supports the preferred story when discussed."
			},
			{
				"title": "Privacy-Conscious Exploration",
				"body": "The tool does not require contact information. Public demo exploration uses placeholders instead of real names."
			},
			{
				"title": "Limits",
				"body": "The tool does not measure relationship quality, calculate social-network metrics, or infer what a relationship means."
			}
		],
		"faqItems": [
			{
				"question": "Does the map require contact details?",
				"answer": "No. Contact management is outside the tool; relational nodes can be named or described without contact information."
			},
			{
				"question": "Can communities or histories be added instead of individual people?",
				"answer": "Yes. People, communities, and histories can all be nodes when they are meaningful to the preferred identity."
			},
			{
				"question": "What if a relationship reinforces the problem story?",
				"answer": "Capture that distinction rather than excluding or converting it; the review can show how it relates to the preferred story."
			}
		]
	},
	{
		"toolType": "outsiderWitnessProcess",
		"slug": "outsider-witness-process",
		"title": "Outsider-Witness Process Demo | Qwoach",
		"metaDescription": "Explore a live narrative therapy record for witness reflections, preferred identity themes, and client response.",
		"h1": "Capture live witnessing of a preferred story",
		"intro": "Outsider-Witness Process is a live-session narrative therapy configuration for practitioners. It helps capture a preferred-story context, witness reflections, identity-recognizing themes, and the client's response when a preferred story or identity claim is socially witnessed.",
		"demoTitle": "Open the sample witnessing record",
		"demoPrompt": "Interested in using Outsider-Witness Process with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0460-f-019-nar-007-r001-outsider-witness-process.md",
		"specId": "0460-f-019-nar-007-r001-outsider-witness-process",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Live Process Boundary",
				"body": "The tool supports live witnessing and reflection capture. It is not a self-service substitute for an outsider-witness process."
			},
			{
				"title": "What It Captures",
				"body": "The record includes preferred-story context, multiple witness reflections, reflected themes, links to preferred identity statements, and client response."
			},
			{
				"title": "Partial Records",
				"body": "A record can remain partial when reflections are captured before the client has responded, or when preferred-story context is entered before witnesses speak."
			}
		],
		"faqItems": [
			{
				"question": "Can the process be completed without witnesses?",
				"answer": "No. Without witnesses, it cannot be completed as an outsider-witness process."
			},
			{
				"question": "Does the tool rate witness reflections?",
				"answer": "No. It records and groups reflections descriptively; it does not score quality or social validity."
			},
			{
				"question": "What if a reflection focuses on the problem instead of preferred identity?",
				"answer": "Capture it as off-target or not connected rather than converting it into preferred-identity content."
			}
		]
	},
	{
		"toolType": "therapeuticLetter",
		"slug": "therapeutic-letter",
		"title": "Therapeutic Letter for Narrative Therapy | Qwoach",
		"metaDescription": "Create a practitioner-authored therapeutic letter that carries client language, preferred identity claims, and commitments beyond the session.",
		"h1": "Therapeutic Letter",
		"intro": "Therapeutic Letter is a practitioner-authored narrative therapy document for therapists who want to carry forward a client's own language, preferred identity claims, commitments, discoveries, and therapeutic developments into life outside the session.",
		"demoTitle": "Explore a sample letter workspace",
		"demoPrompt": "Interested in using Therapeutic Letter with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0461-f-019-nar-008-r001-therapeutic-letter.md",
		"specId": "0461-f-019-nar-008-r001-therapeutic-letter",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Therapeutic document"
			],
			"workflow": [
				"Therapeutic consolidation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after a conversation that produced language, values, discoveries, exceptions, or commitments the client may benefit from revisiting."
			},
			{
				"title": "Practitioner And Client Roles",
				"body": "The practitioner authors and controls the draft. The client receives the shared letter and can respond only when the practitioner has invited a response."
			},
			{
				"title": "History",
				"body": "Prior shared letters can be retained so later therapy can return to specific wording, commitments, and developments over time."
			}
		],
		"faqItems": [
			{
				"question": "Is Therapeutic Letter a questionnaire?",
				"answer": "No. Therapeutic Letter is a practitioner-authored narrative document, not a questionnaire, score, or assessment."
			},
			{
				"question": "Can the client respond?",
				"answer": "Yes, if the practitioner turns on the invite client response setting. The response area does not convert the tool into a questionnaire."
			},
			{
				"question": "What gets saved when I save the demo?",
				"answer": "The tool and selected settings are saved. Fictional demo notes, sample letter content, and sample responses do not become real client records."
			},
			{
				"question": "Does the tool write clinical interpretations automatically?",
				"answer": "No. Practitioner authorship is central, and the tool preserves authored text rather than generating clinical meanings."
			}
		]
	},
	{
		"toolType": "therapeuticCertificateDeclaration",
		"slug": "therapeutic-certificate-declaration",
		"title": "Therapeutic Certificate / Declaration for Narrative Therapy | Qwoach",
		"metaDescription": "Create a practitioner-authored certificate or declaration recognizing a client's achievement, commitment, or identity shift in narrative therapy.",
		"h1": "Therapeutic Certificate / Declaration",
		"intro": "Therapeutic Certificate / Declaration is a practitioner-authored narrative therapy document for therapists who want to recognize a client's meaningful achievement, commitment, or identity shift as part of a richer alternative story.",
		"demoTitle": "Build a sample declaration",
		"demoPrompt": "Interested in using Therapeutic Certificate / Declaration with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0462-f-019-nar-009-r001-therapeutic-certificate-declaration.md",
		"specId": "0462-f-019-nar-009-r001-therapeutic-certificate-declaration",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Therapeutic document"
			],
			"workflow": [
				"Therapeutic consolidation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Milestone Use",
				"body": "This tool is intended for clinically meaningful points where a specific achievement, commitment, or identity shift should be recognized, not routine progress tracking."
			},
			{
				"title": "Client Collaboration",
				"body": "When enabled, client collaboration is limited to wording feedback before finalization."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not create achievement scales, badges, diagnostic claims, or predefined achievement categories."
			}
		],
		"faqItems": [
			{
				"question": "Is this a progress tracker?",
				"answer": "No. It creates one recognition document for a specific achievement, commitment, or identity shift."
			},
			{
				"question": "Can the client help shape the wording?",
				"answer": "Yes, if collaborative wording is enabled before finalization."
			},
			{
				"question": "Does the presentation format change the therapeutic content?",
				"answer": "No. Certificate versus declaration changes visual framing, not the required recognition content."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool and selected settings are saved. Fictional milestone content and demo feedback are not saved as real client data."
			}
		]
	},
	{
		"toolType": "doubleStoriedAssessment",
		"slug": "double-storied-assessment",
		"title": "Double-Storied Assessment for Narrative Therapy | Qwoach",
		"metaDescription": "Explore a narrative therapy assessment that records problem effects alongside client skills, values, hopes, relationships, and preferred identity material.",
		"h1": "Double-Storied Assessment",
		"intro": "Double-Storied Assessment is a narrative therapy assessment for mental-health professionals who need a balanced clinical understanding of a client's problem context, responses, skills, values, hopes, relationships, and preferred identity developments.",
		"demoTitle": "Open the assessment demo",
		"demoPrompt": "Interested in using Double-Storied Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0463-f-019-nar-010-r001-double-storied-assessment.md",
		"specId": "0463-f-019-nar-010-r001-double-storied-assessment",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Values",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Balanced Capture",
				"body": "The assessment keeps problem effects and preferred-story material visible together so the record does not become deficit-only."
			},
			{
				"title": "Partial Assessment",
				"body": "Partial records are valid. Missing areas are shown as incomplete without being treated as clinical failure."
			},
			{
				"title": "History",
				"body": "Repeated assessments can be compared over time while preserving the structure of the original record."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include the exact six-part assessment prompts?",
				"answer": "No. The source record references a six-part tool but does not supply the exact prompts, so the demo does not invent them."
			},
			{
				"question": "Does Double-Storied Assessment produce a diagnosis?",
				"answer": "No. It organizes entered material into a balanced assessment record without diagnostic conclusions or scoring."
			},
			{
				"question": "Can the client help complete it?",
				"answer": "Yes. Completion mode can be collaborative in-session or practitioner-only entry."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool, completion mode, and any valid supplied section configuration are saved. Fictional assessment content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "treeOfLife",
		"slug": "tree-of-life",
		"title": "Tree of Life Narrative Therapy Map | Qwoach",
		"metaDescription": "Explore a collaborative Tree of Life map for identity, strengths, relationships, histories, values, hopes, supports, and future possibilities.",
		"h1": "Tree of Life",
		"intro": "Tree of Life is a collaborative narrative therapy mapping methodology for practitioners helping a client, family, or group explore identity, resources, relationships, strengths, histories, and hopes in an accessible visual form.",
		"demoTitle": "Try the sample tree map",
		"demoPrompt": "Interested in using Tree of Life with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0464-f-019-nar-011-r001-tree-of-life.md",
		"specId": "0464-f-019-nar-011-r001-tree-of-life",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Values",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Participant Modes",
				"body": "The tool supports individual, family, and group contexts without interpreting uneven group participation as agreement or conflict."
			},
			{
				"title": "Partial Maps",
				"body": "A map can remain partial. Empty areas do not imply failure or absence unless the practitioner and client decide that meaning together."
			},
			{
				"title": "Practitioner Notes",
				"body": "Practitioner notes can remain private for follow-up planning or be included in the shared review when appropriate."
			}
		],
		"faqItems": [
			{
				"question": "Does Tree of Life require clients to focus on trauma?",
				"answer": "No. The tool does not require trauma or deficit to be the organizing story."
			},
			{
				"question": "Can it be used with families or groups?",
				"answer": "Yes. Participant mode can be individual, family, or group."
			},
			{
				"question": "Are empty tree areas allowed?",
				"answer": "Yes. Partial maps are valid, and clients may decline to fill some areas."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected configuration are saved. Fictional map entries and sample participant content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "soundtrackOfYourLife",
		"slug": "soundtrack-of-your-life",
		"title": "Soundtrack of Your Life Narrative Therapy Tool | Qwoach",
		"metaDescription": "Map client-chosen music to stories, meanings, relationships, resources, themes, and preferred identity threads in narrative therapy.",
		"h1": "Soundtrack of Your Life",
		"intro": "Soundtrack of Your Life is a narrative therapy methodology for practitioners working with a young person or client whose identity, relationships, resources, and experiences may be easier to explore through client-chosen music and associated stories.",
		"demoTitle": "Create a sample soundtrack map",
		"demoPrompt": "Interested in using Soundtrack of Your Life with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0465-f-019-nar-012-r001-soundtrack-of-your-life.md",
		"specId": "0465-f-019-nar-012-r001-soundtrack-of-your-life",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Values",
				"Interpersonal relationships"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "No Streaming Required",
				"body": "Music references can be entered as text. The tool does not require uploads, external music services, lyric extraction, or song analysis."
			},
			{
				"title": "Client Meaning Leads",
				"body": "The map records the client's associations and meanings rather than interpreting music choices."
			},
			{
				"title": "Further Work",
				"body": "Entries can create openings for later re-authoring, re-membering, or witnessing conversations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool analyze songs or lyrics?",
				"answer": "No. It records client-chosen music references and the meanings the client or practitioner enters."
			},
			{
				"question": "Does the client need a streaming account?",
				"answer": "No. A free-text music reference is enough."
			},
			{
				"question": "Can clients add entries between sessions?",
				"answer": "Yes, if the practitioner selects shared between-session contribution mode."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected settings are saved. Fictional song references and sample associations are not saved as real client data."
			}
		]
	},
	{
		"toolType": "deconstructionQuestions",
		"slug": "deconstruction-questions",
		"title": "Deconstruction Questions for Narrative Therapy | Qwoach",
		"metaDescription": "Map a fixed belief or problem story to social, relational, cultural, historical, and power contexts with a narrative therapy tool.",
		"h1": "Deconstruction Questions",
		"intro": "Deconstruction Questions is a narrative therapy questioning map for practitioners and clients who need to contextualize beliefs, meanings, or problem stories by linking them to culture, relationships, history, and power rather than treating them as fixed identity truths.",
		"demoTitle": "Open a sample deconstruction map",
		"demoPrompt": "Interested in using Deconstruction Questions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0466-f-019-nar-013-r001-deconstruction-questions.md",
		"specId": "0466-f-019-nar-013-r001-deconstruction-questions",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Core beliefs",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Tentative Links",
				"body": "Contextual links can be tentative or rejected so the map does not treat uncertain material as established."
			},
			{
				"title": "Prompt Boundaries",
				"body": "The tool can use practitioner-entered or supplied prompts, but it does not invent exact deconstruction questions."
			},
			{
				"title": "What It Does Not Infer",
				"body": "The map does not determine truth, assign blame, infer causality, or generate cultural or diagnostic conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide whether a belief is true or false?",
				"answer": "No. It organizes entered contexts and alternatives without making truth or causality determinations."
			},
			{
				"question": "Are exact deconstruction questions included?",
				"answer": "No. Exact question wording is unresolved unless supplied by the practitioner or a valid configuration."
			},
			{
				"question": "Can the client reject a contextual link?",
				"answer": "Yes. Links can be tentative or rejected and should not be treated as established."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected settings are saved. Fictional focus statements and sample contextual material are not saved as real client data."
			}
		]
	},
	{
		"toolType": "scaffoldingConversationMap",
		"slug": "scaffolding-conversation-map",
		"title": "Scaffolding Conversation Map for Narrative Therapy | Qwoach",
		"metaDescription": "Develop preferred stories by linking exceptions to meanings, values, identity claims, and possible future actions in a narrative therapy map.",
		"h1": "Scaffolding Conversation Map",
		"intro": "Scaffolding Conversation Map is a narrative therapy conversation structure for practitioners and clients who need to develop a thin or tentative preferred story into linked events, meanings, values, identity claims, and possible future actions.",
		"demoTitle": "Try a sample scaffolding map",
		"demoPrompt": "Interested in using Scaffolding Conversation Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0467-f-019-nar-014-r001-scaffolding-conversation-map.md",
		"specId": "0467-f-019-nar-014-r001-scaffolding-conversation-map",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Values",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Paced Development",
				"body": "The map supports stopping at any layer. Incompleteness can be clinically meaningful and is not treated as an error."
			},
			{
				"title": "Tentative Links",
				"body": "Links can be marked tentative or removed when the client does not accept a proposed connection."
			},
			{
				"title": "Continuation",
				"body": "The continuation point is preserved so the same preferred-story thread can be developed later."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate identity claims for the client?",
				"answer": "No. Identity claims and meanings must come from client language or practitioner-entered material."
			},
			{
				"question": "Can the conversation stop before future action?",
				"answer": "Yes. Partial maps are valid and can preserve the current continuation point."
			},
			{
				"question": "Are exact scaffolding prompts included?",
				"answer": "No. Exact prompts are used only when supplied by a valid scaffold configuration."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected configuration are saved. Fictional layer content and sample links are not saved as real client data."
			}
		]
	},
	{
		"toolType": "statementOfPositionMap",
		"slug": "statement-of-position-map",
		"title": "Statement of Position Map for Narrative Therapy | Qwoach",
		"metaDescription": "Help clients clarify a position on a problem by naming it, evaluating effects, articulating values, and identifying preferred direction.",
		"h1": "Statement of Position Map",
		"intro": "Statement of Position Map is a narrative therapy mapping tool for practitioners and clients who need to name or externalize a problem, evaluate its effects, articulate values or reasons, and identify a preferred direction for future responses or choices.",
		"demoTitle": "Map a sample position",
		"demoPrompt": "Interested in using Statement of Position Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0468-f-019-nar-015-r001-statement-of-position-map.md",
		"specId": "0468-f-019-nar-015-r001-statement-of-position-map",
		"tags": {
			"framework": [
				"Narrative therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Values",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Four-Part Position",
				"body": "The supported structure is problem naming or externalization, evaluation of effects, values or reasons, and preferred direction."
			},
			{
				"title": "Partial And Tentative Work",
				"body": "The map can remain partial or tentative when the client is not ready to name a problem or preferred direction."
			},
			{
				"title": "History",
				"body": "Completed positions can be preserved as point-in-time stances for later comparison."
			}
		],
		"faqItems": [
			{
				"question": "Does the map tell the client what to do?",
				"answer": "No. It structures the client's own stance and preferred direction without generating advice."
			},
			{
				"question": "Can a map be saved if the preferred direction is not ready?",
				"answer": "Yes. Partial maps are valid and should show what remains incomplete."
			},
			{
				"question": "Does the tool score agency or values?",
				"answer": "No. It records position content without scoring agency, values, or clinical meaning."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected configuration are saved. Fictional position content and sample problem material are not saved as real client data."
			}
		]
	},
	{
		"toolType": "selfIdealQSort",
		"slug": "self-ideal-q-sort",
		"title": "Self-Ideal Q-Sort for Person-Centred Practice | Qwoach",
		"metaDescription": "Compare current and ideal self-view with a configured Q-sort that shows item-level congruence, discrepancy, and repeatable review over time.",
		"h1": "Self-Ideal Q-Sort",
		"intro": "Self-Ideal Q-Sort is a person-centred assessment tool for practitioners who need a structured, comparable picture of how a client's current self-view differs from their ideal self-view and where the greatest congruences or discrepancies appear.",
		"demoTitle": "Try the sample Q-sort flow",
		"demoPrompt": "Interested in using Self-Ideal Q-Sort with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0469-f-020-pct-001-r001-self-ideal-q-sort.md",
		"specId": "0469-f-020-pct-001-r001-self-ideal-q-sort",
		"tags": {
			"framework": [
				"Person-centred therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Configuration Required",
				"body": "A substantive Q-sort requires a valid item set and sorting rules. Without them, the tool can show the mechanic but cannot administer a real assessment."
			},
			{
				"title": "Two-Pass Sorting",
				"body": "The same items are sorted for current self-view and ideal self-view so placements can be compared."
			},
			{
				"title": "Longitudinal Comparison",
				"body": "Repeat comparison depends on compatible item sets, distribution rules, and scoring/display methods."
			}
		],
		"faqItems": [
			{
				"question": "Can the tool run without a Q-sort item set?",
				"answer": "No. Without a valid item set and rules, it cannot administer a substantive Q-sort."
			},
			{
				"question": "Does the tool interpret why discrepancies exist?",
				"answer": "No. It shows supported differences and leaves interpretation to therapeutic review."
			},
			{
				"question": "Can it use ratings instead of sorting?",
				"answer": "Only if the supplied configuration explicitly uses ratings. Otherwise the Q-sort mechanic is preserved."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected configuration are saved. Fictional placements and placeholder demo results are not saved as real client data."
			}
		]
	},
	{
		"toolType": "realIdealSelfCongruenceProfile",
		"slug": "real-ideal-self-congruence-profile",
		"title": "Real-Ideal Self Congruence Profile for Person-Centred Practice | Qwoach",
		"metaDescription": "Create a practitioner-only profile comparing current self-experience, ideal self-concept, and salient real-ideal discrepancy themes.",
		"h1": "Real-Ideal Self Congruence Profile",
		"intro": "Real-Ideal Self Congruence Profile is a practitioner-only person-centred formulation tool for clinicians who need to organize how a client's current self-experience differs from their ideal self-concept and identify salient discrepancy themes.",
		"demoTitle": "Create a sample profile",
		"demoPrompt": "Interested in using Real-Ideal Self Congruence Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0470-f-020-pct-002-r001-real-ideal-self-congruence-profile.md",
		"specId": "0470-f-020-pct-002-r001-real-ideal-self-congruence-profile",
		"tags": {
			"framework": [
				"Person-centred therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The client does not complete this product directly. The practitioner enters material from therapy while keeping it anchored in the client's perspective."
			},
			{
				"title": "Not A Q-Sort",
				"body": "This profile does not collect Q-sort placements, scores, or standardized item responses."
			},
			{
				"title": "Baseline And Updates",
				"body": "The practitioner can create a point-in-time baseline or update an evolving formulation while preserving prior baselines used for comparison."
			}
		],
		"faqItems": [
			{
				"question": "Does the client complete this tool?",
				"answer": "No. It is practitioner-only and uses client-perspective material from therapy."
			},
			{
				"question": "Is this the same as Self-Ideal Q-Sort?",
				"answer": "No. This is a clinician-held profile and does not use Q-sort items, placements, or scoring."
			},
			{
				"question": "Does the tool score real-ideal incongruence?",
				"answer": "No. It structures discrepancy themes without standardized scores or normative judgments."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected setup are saved. Fictional profile entries and sample themes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "empathicReflection",
		"slug": "empathic-reflection",
		"title": "Empathic Reflection Live Session Tool | Qwoach",
		"metaDescription": "Support live empathic reflection in person-centred therapy with optional notes for client language, reflection offered, and observed fit.",
		"h1": "Empathic Reflection for Person-Centred Sessions",
		"intro": "Empathic Reflection is a live-session support tool for person-centred practitioners. It helps therapists and counselors stay close to a client's own language, offer a reflection, and optionally record whether the reflection was confirmed, corrected, or followed by continued exploration.",
		"demoTitle": "Explore a sample reflection moment",
		"demoPrompt": "Interested in using Empathic Reflection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0471-f-020-pct-003-r001-empathic-reflection.md",
		"specId": "0471-f-020-pct-003-r001-empathic-reflection",
		"tags": {
			"framework": [
				"Person-centred therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during or after a live session moment when the practitioner offers a reflection and wants optional continuity material about how closely the reflection matched the client's felt experience."
			},
			{
				"title": "Important Boundary",
				"body": "The system organizes practitioner-entered material. It does not evaluate the client, generate interpretations, score reflection quality, or require an artifact for the skill to be complete."
			}
		],
		"faqItems": [
			{
				"question": "Does the client complete this tool?",
				"answer": "No. The client participates through live dialogue, not through required product entry."
			},
			{
				"question": "Can a reflection note be incomplete?",
				"answer": "Yes. Empty and partial notes are valid because empathic reflection is primarily a live therapeutic interaction."
			},
			{
				"question": "Does the tool generate reflection scripts?",
				"answer": "No. It provides generic capture fields only and does not supply substantive reflection wording."
			}
		]
	},
	{
		"toolType": "clarification",
		"slug": "clarification",
		"title": "Clarification Therapy Note Tool | Qwoach",
		"metaDescription": "Track clarification moments in person-centred therapy with optional notes for unclear expression, client refinement, and next focus.",
		"h1": "Clarification for Person-Centred Sessions",
		"intro": "Clarification is a live-session support tool for person-centred practitioners. It helps therapists and counselors optionally record a vague or tangled client expression, the clarification offered or invited, and the client's own refinement or unresolved uncertainty.",
		"demoTitle": "Try a sample clarification trace",
		"demoPrompt": "Interested in using Clarification with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0472-f-020-pct-004-r001-clarification.md",
		"specId": "0472-f-020-pct-004-r001-clarification",
		"tags": {
			"framework": [
				"Person-centred therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client statement is ambiguous, mixed, or uncertain and the practitioner wants to preserve the client's autonomy and meaning-making while supporting clearer exploration."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not determine what the client really means. It organizes practitioner-entered wording and client refinements without adding interpretations or scores."
			}
		],
		"faqItems": [
			{
				"question": "Can a clarification stay unresolved?",
				"answer": "Yes. Unresolved or partial clarity is a supported result and does not need to be forced into a summary."
			},
			{
				"question": "Does the tool prescribe clarification prompts?",
				"answer": "No. The product uses generic empty capture labels and does not prescribe exact prompts."
			},
			{
				"question": "Who controls the record?",
				"answer": "The practitioner creates and edits the record. The client contributes through live session dialogue."
			}
		]
	},
	{
		"toolType": "awarenessContinuum",
		"slug": "awareness-continuum",
		"title": "Awareness Continuum Gestalt Tool | Qwoach",
		"metaDescription": "Facilitate a Gestalt awareness continuum with live or practitioner-only tracking of sensations, feelings, thoughts, cues, and shifts.",
		"h1": "Awareness Continuum for Gestalt Sessions",
		"intro": "Awareness Continuum is a Gestalt therapy tool for practitioners and clients working together in session. It helps them notice and record current sensations, feelings, thoughts, environmental cues, shifts, interruptions, or pauses as present experience unfolds.",
		"demoTitle": "Start a sample awareness stream",
		"demoPrompt": "Interested in using Awareness Continuum with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0473-f-021-gst-001-r001-awareness-continuum.md",
		"specId": "0473-f-021-gst-001-r001-awareness-continuum",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Mindfulness"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures brief present-moment entries, broad categories when enabled, practitioner observations, shifts, interruptions, uncertainty, and pauses."
			},
			{
				"title": "How History Is Used",
				"body": "History may show recurring reported or observed patterns across sessions descriptively. It does not label traits or explain why patterns occur."
			},
			{
				"title": "Client And Practitioner Roles",
				"body": "The client may contribute entries in shared mode. Practitioner-only observations remain distinct and should not imply client endorsement."
			}
		],
		"faqItems": [
			{
				"question": "Is Awareness Continuum a questionnaire?",
				"answer": "No. It is a live observation stream, not a questionnaire or fixed worksheet."
			},
			{
				"question": "Can the client skip or pause?",
				"answer": "Yes. The client can skip, pause, or resume at the current moment without reconstructing a full sequence."
			},
			{
				"question": "Does the tool interpret awareness patterns?",
				"answer": "No. It organizes entries by time, source, and optional broad category but does not infer meaning."
			}
		]
	},
	{
		"toolType": "hereAndNowFocusing",
		"slug": "here-and-now-focusing",
		"title": "Here-and-Now Focusing Tool | Qwoach",
		"metaDescription": "Support Gestalt here-and-now focusing with optional notes for abstract narration, present experience, and observed shifts in contact.",
		"h1": "Here-and-Now Focusing for Gestalt Sessions",
		"intro": "Here-and-Now Focusing is a live Gestalt therapy support tool for practitioners and clients in session. It helps a practitioner redirect from abstract, historical, or intellectual narration toward current bodily, emotional, relational, and environmental experience, with optional observation capture.",
		"demoTitle": "Explore a sample focusing episode",
		"demoPrompt": "Interested in using Here-and-Now Focusing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0474-f-021-gst-002-r001-here-and-now-focusing.md",
		"specId": "0474-f-021-gst-002-r001-here-and-now-focusing",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Mindfulness"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the session needs to move from talking about experience at a distance toward direct contact with what is happening now."
			},
			{
				"title": "Partial Notes Are Valid",
				"body": "The note can capture only the shift, only the material that emerged, or the difficulty accessing present experience."
			}
		],
		"faqItems": [
			{
				"question": "Is this a mindfulness tool?",
				"answer": "No. It is a Gestalt live-session focusing aid for redirecting therapeutic attention to current experience."
			},
			{
				"question": "Does the tool provide a fixed focusing sequence?",
				"answer": "No. Exact prompts and practice steps are not defined, so the product uses neutral placeholders only."
			},
			{
				"question": "Can historical context still matter?",
				"answer": "Yes. The tool marks the focusing attempt; it does not suppress historical context when it remains relevant."
			}
		]
	},
	{
		"toolType": "emptyChairExperiment",
		"slug": "empty-chair-experiment",
		"title": "Empty-Chair Experiment Tool | Qwoach",
		"metaDescription": "Facilitate and review Gestalt empty-chair experiments with notes for represented focus, direct speech, observations, and next focus.",
		"h1": "Empty-Chair Experiment for Gestalt Sessions",
		"intro": "Empty-Chair Experiment is a live Gestalt enactment tool for practitioners working with clients who have unfinished business, unspoken emotion, or unresolved relationship material. It helps the practitioner set a represented focus, capture key direct expressions and observations, and review what became available for further work.",
		"demoTitle": "Open a sample experiment record",
		"demoPrompt": "Interested in using Empty-Chair Experiment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0475-f-021-gst-003-r001-empty-chair-experiment.md",
		"specId": "0475-f-021-gst-003-r001-empty-chair-experiment",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships",
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The record can include represented focus, direct speech, observed affect, posture, hesitation, role changes if observed, new awareness, and next focus."
			},
			{
				"title": "Limits",
				"body": "The product facilitates and records the experiment. It does not conduct therapy independently, score resolution, or interpret hidden meaning."
			}
		],
		"faqItems": [
			{
				"question": "Does the client have to type during the experiment?",
				"answer": "No. The primary client experience is live enactment; typing is not required."
			},
			{
				"question": "What if no resolution emerges?",
				"answer": "No resolution is required. The result can preserve the clearer next focus or unresolved material."
			},
			{
				"question": "Can the represented focus change?",
				"answer": "Yes. The record should preserve both the initial and emergent focus when that happens."
			}
		]
	},
	{
		"toolType": "twoChairDialogue",
		"slug": "two-chair-dialogue",
		"title": "Two-Chair Dialogue Tool | Qwoach",
		"metaDescription": "Support Gestalt two-chair dialogue with two-position capture, observed shifts, and review of each side's statements, needs, and meanings.",
		"h1": "Two-Chair Dialogue for Internal Conflict",
		"intro": "Two-Chair Dialogue is a live Gestalt chair-work tool for practitioners and clients working with opposing parts, impulses, or positions. It helps the practitioner capture what each side expresses, observe shifts between positions, and review possible movement toward integration, negotiation, or a clearer next focus.",
		"demoTitle": "Try a sample two-chair dialogue",
		"demoPrompt": "Interested in using Two-Chair Dialogue with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0476-f-021-gst-004-r001-two-chair-dialogue.md",
		"specId": "0476-f-021-gst-004-r001-two-chair-dialogue",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Exactly Two Positions",
				"body": "Each dialogue episode supports exactly two active positions. If more parts emerge, the practitioner should close or start another two-chair episode rather than silently expanding this tool."
			},
			{
				"title": "Unresolved Conflict",
				"body": "No integration is required for the record to be useful. A differentiated conflict and clearer next focus are valid results."
			}
		],
		"faqItems": [
			{
				"question": "Can the chair positions remain unnamed?",
				"answer": "Yes. Positions may remain unnamed or provisional until clearer labels emerge."
			},
			{
				"question": "Does the tool support more than two parts?",
				"answer": "No. This configuration supports exactly two active positions per dialogue episode."
			},
			{
				"question": "Does it score integration?",
				"answer": "No. The tool does not score integration or interpret the conflict."
			}
		]
	},
	{
		"toolType": "emptyChairTechnique",
		"slug": "empty-chair-technique",
		"title": "Empty Chair Technique Tool | Qwoach",
		"metaDescription": "Facilitate Empty Chair Technique episodes with represented focus, direct-address notes, optional role-shift capture, observations, and next focus.",
		"h1": "Empty Chair Technique for Gestalt Chair Work",
		"intro": "Empty Chair Technique is a live Gestalt practitioner tool for facilitated chair-based role-play and dialogue. It helps therapists and counselors represent an imagined other, absent figure, or self-part, capture direct speech or optional role-shift responses, and review observed emotion, bodily cues, new awareness, and next therapeutic focus.",
		"demoTitle": "Explore a sample chair-dialogue episode",
		"demoPrompt": "Interested in using Empty Chair Technique with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0477-f-021-gst-005-r001-empty-chair-technique.md",
		"specId": "0477-f-021-gst-005-r001-empty-chair-technique",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships",
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Role Shift Is Optional",
				"body": "If role reversal is not used, the episode remains valid as direct-address chair work."
			},
			{
				"title": "Partial And Stopped Episodes",
				"body": "Paused, stopped, direct-address-only, and no-clear-integration states are supported and should remain visible in review."
			},
			{
				"title": "What It Does Not Do",
				"body": "The product does not provide unsupported chair-work scripts, generate interpretations, score outcomes, or expand into a generic role-play tool."
			}
		],
		"faqItems": [
			{
				"question": "Is role reversal required?",
				"answer": "No. Role-shift capture is optional, and direct-address-only episodes remain valid."
			},
			{
				"question": "Can the client stop or pause?",
				"answer": "Yes. The episode can be marked paused or stopped without forcing completion."
			},
			{
				"question": "Does the tool interpret what the chair represents?",
				"answer": "No. The represented focus is entered by the practitioner in the client's terms; the system does not infer hidden meaning."
			}
		]
	},
	{
		"toolType": "twoChairDialogueTwoChairTechnique",
		"slug": "two-chair-dialogue-two-chair-technique",
		"title": "Two-Chair Technique Tool | Qwoach",
		"metaDescription": "Facilitate two-chair work for internal polarities with side-by-side or switch-timeline capture, observations, and integration themes.",
		"h1": "Two-Chair Dialogue / Two-Chair Technique",
		"intro": "Two-Chair Dialogue / Two-Chair Technique is a live chair-work tool for practitioners helping clients encounter internal splits, polarities, self-critical conflict, or competing parts of self. It helps capture each side's voice, feeling, need, or demand, observe role shifts, and review possible softening, negotiation, integration, or next steps.",
		"demoTitle": "Start a sample two-chair episode",
		"demoPrompt": "Interested in using Two-Chair Dialogue / Two-Chair Technique with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0478-f-021-gst-005-r002-two-chair-dialogue-two-chair-technique.md",
		"specId": "0478-f-021-gst-005-r002-two-chair-dialogue-two-chair-technique",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Self-criticism"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Two Active Chairs",
				"body": "Each episode remains limited to two active positions. If more parts emerge, the practitioner can end the episode or start another rather than expanding the tool into a multi-part map."
			},
			{
				"title": "Label History",
				"body": "If a chair label changes, the review should preserve that history so later comparison is descriptive and grounded."
			}
		],
		"faqItems": [
			{
				"question": "Can I begin before the two sides are named?",
				"answer": "Yes. Role labels can remain unnamed until the client's terms become clearer."
			},
			{
				"question": "What if one side is underdeveloped?",
				"answer": "An underdeveloped side is a supported partial state and should not be forced into completion."
			},
			{
				"question": "Does the tool recommend integration steps?",
				"answer": "No. It records any integration, softening, negotiation, or next step that emerges, but it does not generate recommendations."
			}
		]
	},
	{
		"toolType": "makingTheRoundsGoAround",
		"slug": "making-the-rounds-go-around",
		"title": "Making the Rounds Tool | Qwoach",
		"metaDescription": "Facilitate a Gestalt group round with member order, per-encounter notes, optional feedback capture, and review of contact differences.",
		"h1": "Making the Rounds / Go-Around for Gestalt Group Work",
		"intro": "Making the Rounds / Go-Around is a live Gestalt group-work tool for practitioners facilitating a focal group member's direct statement or interpersonal action with multiple group members. It helps track member order, progress, contact differences, optional feedback, and grounded awareness that emerges during the round.",
		"demoTitle": "Try a sample group round",
		"demoPrompt": "Interested in using Making the Rounds / Go-Around with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0479-f-021-gst-005-r003-making-the-rounds-go-around.md",
		"specId": "0479-f-021-gst-005-r003-making-the-rounds-go-around",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Group Roles",
				"body": "The practitioner controls the round, the focal client performs the interpersonal action, and other members participate live. Other group members do not need separate product accounts or product tasks."
			},
			{
				"title": "Partial Rounds",
				"body": "Stopped, paused, and skipped encounters remain visible because participation differences may be meaningful."
			},
			{
				"title": "What It Does Not Capture",
				"body": "The tool does not rate group members, rank relationships, diagnose dynamics, or operate as a group management system."
			}
		],
		"faqItems": [
			{
				"question": "Is this for individual therapy?",
				"answer": "No. This configuration is for live group therapy or workshop rounds, not a one-to-one technique except by adaptation outside this product definition."
			},
			{
				"question": "Can a group member be skipped?",
				"answer": "Yes. A skipped encounter should be recorded as skipped rather than completed."
			},
			{
				"question": "Does every group member give feedback?",
				"answer": "No. Feedback capture is optional and only appears when facilitated and enabled."
			}
		]
	},
	{
		"toolType": "roleReversal",
		"slug": "role-reversal",
		"title": "Role Reversal Tool | Qwoach",
		"metaDescription": "Facilitate live role reversal with two-role capture, observed shifts, enacted perspective notes, and review of clarified next focus.",
		"h1": "Role Reversal for Gestalt Sessions",
		"intro": "Role Reversal is a live Gestalt experiential tool for practitioners and clients working with a relationship, conflict, or situation from more than one perspective. It helps name the original and alternate roles, capture enacted responses, observe shifts, and review new perspective, meaning, or a clarified next focus.",
		"demoTitle": "Try a sample role reversal",
		"demoPrompt": "Interested in using Role Reversal with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0480-f-021-gst-006-r001-role-reversal.md",
		"specId": "0480-f-021-gst-006-r001-role-reversal",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Enacted Perspective",
				"body": "Alternate-role content is presented as the client's enacted perspective, not as factual knowledge about another person's thoughts, feelings, or needs."
			},
			{
				"title": "When No New Meaning Emerges",
				"body": "If the client cannot access the alternate role or no new meaning emerges, the clarified stuck point can still be the useful result."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool claim to know the other person's perspective?",
				"answer": "No. Alternate-role material is recorded only as the client's enacted perspective."
			},
			{
				"question": "Can the client decline or pause role reversal?",
				"answer": "Yes. The client can pause, decline, or return to the original role as part of facilitation."
			},
			{
				"question": "Does the tool score empathy?",
				"answer": "No. It does not use empathy scores or correctness ratings."
			}
		]
	},
	{
		"toolType": "exaggerationExperiment",
		"slug": "exaggeration-experiment",
		"title": "Exaggeration Experiment for Gestalt Therapy | Qwoach",
		"metaDescription": "A live-session Gestalt tool for amplifying a client's expression and recording affect, sensation, meaning, and contact observations.",
		"h1": "Exaggeration Experiment",
		"intro": "Exaggeration Experiment is a live-session Gestalt tool for practitioners who notice a client's gesture, phrase, movement, or affective expression becoming partly available. It helps the practitioner invite amplification and record what changes in affect, sensation, meaning, or contact in the present session.",
		"demoTitle": "Explore a sample exaggeration experiment note",
		"demoPrompt": "Interested in using Exaggeration Experiment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0481-f-021-gst-007-r001-exaggeration-experiment.md",
		"specId": "0481-f-021-gst-007-r001-exaggeration-experiment",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during a live session when an expression is present but muted, habitual, or only partly available to awareness."
			},
			{
				"title": "What It Records",
				"body": "The record separates the selected expression, amplification moments, client-noticed changes, practitioner observations, and integration notes."
			},
			{
				"title": "Limits",
				"body": "The tool does not prescribe meaning, require conclusions, use scores, or replace live practitioner judgment."
			}
		],
		"faqItems": [
			{
				"question": "Is this a questionnaire?",
				"answer": "No. Exaggeration Experiment is a live-session Gestalt experiment note, not a questionnaire or assessment."
			},
			{
				"question": "Does the tool interpret what the expression means?",
				"answer": "No. It records reported and observed changes, while interpretation remains practitioner-entered."
			},
			{
				"question": "Can the client use it independently?",
				"answer": "No independent client workflow is required. A client-facing view may be shown only as in-session support if the practitioner chooses."
			},
			{
				"question": "What happens if no new awareness emerges?",
				"answer": "The result records that no new awareness emerged without forcing a meaning or conclusion."
			}
		]
	},
	{
		"toolType": "bodyAwarenessScan",
		"slug": "body-awareness-scan",
		"title": "Body Awareness Scan for Gestalt Practitioners | Qwoach",
		"metaDescription": "A collaborative Gestalt somatic awareness tool for recording sensations, tension, movement, posture, and present-moment body patterns.",
		"h1": "Body Awareness Scan",
		"intro": "Body Awareness Scan is a collaborative Gestalt tool for practitioners working with emotional or relational issues that may appear through sensation, posture, tension, movement, or absence of sensation. It helps practitioner and client record present body experience and review the somatic pattern that emerges.",
		"demoTitle": "Try a sample body awareness scan",
		"demoPrompt": "Interested in using Body Awareness Scan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0482-f-021-gst-008-r001-body-awareness-scan.md",
		"specId": "0482-f-021-gst-008-r001-body-awareness-scan",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Mindfulness"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when an emotional or relational issue may be reflected in bodily sensation, posture, tension, movement, or lack of sensation."
			},
			{
				"title": "Repeat Use",
				"body": "Prior scans may be reviewed for descriptive recurring patterns or differences, without implying automatic improvement or clinical interpretation."
			},
			{
				"title": "Limits",
				"body": "The tool does not require a fixed body map, rating scale, diagnostic meaning, or complete scan of every body area."
			}
		],
		"faqItems": [
			{
				"question": "Does the Body Awareness Scan use intensity ratings?",
				"answer": "No. The specification does not define intensity ratings, so the public demo uses flexible descriptive notes instead."
			},
			{
				"question": "Is absence of sensation a valid result?",
				"answer": "Yes. Absence of sensation can be recorded as clinically relevant present-moment information."
			},
			{
				"question": "Does the tool interpret body areas?",
				"answer": "No. It does not assign diagnostic or symbolic meanings to body regions."
			},
			{
				"question": "Can it be used collaboratively in session?",
				"answer": "Yes. It is designed as a ready-to-complete-together tool, while the practitioner controls clinical notes and interpretation."
			}
		]
	},
	{
		"toolType": "unfinishedBusinessDialogue",
		"slug": "unfinished-business-dialogue",
		"title": "Unfinished Business Dialogue Tool for Gestalt Therapy | Qwoach",
		"metaDescription": "A live-session Gestalt dialogue tool for recording unresolved feelings, needs, wishes, resentments, and observed contact patterns.",
		"h1": "Unfinished Business Dialogue",
		"intro": "Unfinished Business Dialogue is a live-session Gestalt tool for practitioners working with unresolved feelings, unmet needs, or incomplete expression connected to an absent person or past experience. It helps the practitioner stage the dialogue, capture what the client expresses, and review what remains incomplete or needed.",
		"demoTitle": "Explore a sample unfinished business dialogue",
		"demoPrompt": "Interested in using Unfinished Business Dialogue with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0483-f-021-gst-009-r001-unfinished-business-dialogue.md",
		"specId": "0483-f-021-gst-009-r001-unfinished-business-dialogue",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Client Roles",
				"body": "The practitioner stages and records the dialogue. The client speaks toward the represented person or experience and notices what becomes explicit."
			},
			{
				"title": "Partial Work",
				"body": "Paused or stopped dialogues preserve what was expressed and what remains unresolved without requiring a predetermined ending."
			},
			{
				"title": "Limits",
				"body": "The tool does not script exact dialogue, prescribe reparative action, or assert that unfinished material has been resolved."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool require a complete dialogue?",
				"answer": "No. Paused, stopped, and partial dialogues can be saved as valid records of what became available."
			},
			{
				"question": "Does the tool tell the practitioner what the unfinished material means?",
				"answer": "No. It organizes entered material descriptively; practitioner interpretation remains practitioner-entered."
			},
			{
				"question": "Can the client type directly into the tool?",
				"answer": "Direct client entry is optional and secondary to live dialogue. If used, it should support brief phrases."
			},
			{
				"question": "What if the represented focus is unclear?",
				"answer": "The tool can remain in setup and record the focus as unclear rather than forcing a selection."
			}
		]
	},
	{
		"toolType": "dreamEnactment",
		"slug": "dream-enactment",
		"title": "Dream Enactment Tool for Gestalt Sessions | Qwoach",
		"metaDescription": "A live-session Gestalt dream exploration tool for recording enacted dream elements, affect, resistance, polarity, and personal meaning.",
		"h1": "Dream Enactment",
		"intro": "Dream Enactment is a live-session Gestalt tool for practitioners working with emotionally charged, fragmented, or disowned dream material. It helps the practitioner select dream elements, support experiential engagement, and record affect, meaning, resistance, or polarity that becomes available to the client.",
		"demoTitle": "Explore a sample dream enactment",
		"demoPrompt": "Interested in using Dream Enactment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0484-f-021-gst-010-r001-dream-enactment.md",
		"specId": "0484-f-021-gst-010-r001-dream-enactment",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when dream material is emotionally charged, fragmented, personally important, or connected to unclear or disowned experience."
			},
			{
				"title": "What It Captures",
				"body": "It captures selected dream elements, reported affect or meaning, observed resistance or identification, possible polarity, and integration notes."
			},
			{
				"title": "Limits",
				"body": "The tool does not use dream dictionaries, universal symbol meanings, diagnostic interpretations, fixed scores, or automated conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does Dream Enactment interpret symbols?",
				"answer": "No. The tool records client-discovered meaning and practitioner observations; it does not assign symbol meanings."
			},
			{
				"question": "Does the full dream need to be entered?",
				"answer": "No. Fragment-level work is supported when the client remembers only parts of the dream."
			},
			{
				"question": "Can only some dream elements be explored?",
				"answer": "Yes. Completion depends on enough material becoming available for therapeutic exploration, not on processing every element."
			},
			{
				"question": "What if no meaning emerges?",
				"answer": "The result records what was explored and notes that no meaning emerged, without forcing interpretation."
			}
		]
	},
	{
		"toolType": "emptyChairTechnique2",
		"slug": "empty-chair-technique-2",
		"title": "Empty Chair Technique for Gestalt Chairwork | Qwoach",
		"metaDescription": "A Gestalt chairwork tool for setting up empty-chair dialogue, direct address, optional role reversal, and post-experiment awareness notes.",
		"h1": "Empty Chair Technique",
		"intro": "Empty Chair Technique is a Gestalt chairwork tool for practitioners helping clients encounter an absent person, image, or self-aspect through direct address to an empty chair and possible role reversal. It helps set up the chair positions, record live affect and role language, and review what became unfinished or newly possible.",
		"demoTitle": "Explore a sample empty-chair dialogue",
		"demoPrompt": "Interested in using Empty Chair Technique with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0485-f-021-gst-011-r001-empty-chair-technique.md",
		"specId": "0485-f-021-gst-011-r001-empty-chair-technique",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Chairwork Roles",
				"body": "One position anchors the client role and one position represents the absent person, image, or self-aspect. Role reversal is supported but not required."
			},
			{
				"title": "Virtual Use",
				"body": "The represented chair positions may be shown onscreen for virtual work without changing the core mechanic."
			},
			{
				"title": "Limits",
				"body": "The tool is not a generic role-play builder. It remains focused on empty-chair encounter for unfinished relational or intrapsychic material."
			}
		],
		"faqItems": [
			{
				"question": "Is role reversal required?",
				"answer": "No. Role reversal is supported but not forced; direct-address-only work can be recorded."
			},
			{
				"question": "Does the tool require the client to type during chairwork?",
				"answer": "No. The client-facing display can show positions and current role, while practitioner capture can happen during or after the exercise."
			},
			{
				"question": "Can the represented focus change during the exercise?",
				"answer": "Yes. The practitioner can update the focus or create a separate instance when a different figure or aspect needs to remain clear."
			},
			{
				"question": "Does the result claim the issue is resolved?",
				"answer": "No. The result records expression, observations, and awareness without assigning a resolution label."
			}
		]
	},
	{
		"toolType": "twoChairDialogueTwoChairTechnique2",
		"slug": "two-chair-dialogue-two-chair-technique-2",
		"title": "Two-Chair Dialogue for Gestalt Polarity Work | Qwoach",
		"metaDescription": "A Gestalt two-chair tool for mapping internal polarity dialogue, side-specific language, affect, posture, stuck points, and integration themes.",
		"h1": "Two-Chair Dialogue / Two-Chair Technique",
		"intro": "Two-Chair Dialogue / Two-Chair Technique is an in-session Gestalt tool for practitioners working with internal splits, ambivalence, or conflict between parts of self. It helps the practitioner label two sides, track alternating embodied dialogue, and review what the interaction reveals about needs, power balance, stuck points, or integration themes.",
		"demoTitle": "Explore a sample two-chair dialogue",
		"demoPrompt": "Interested in using Two-Chair Dialogue / Two-Chair Technique with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0486-f-021-gst-011-r002-two-chair-dialogue-two-chair-technique.md",
		"specId": "0486-f-021-gst-011-r002-two-chair-dialogue-two-chair-technique",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when two parts, positions, or impulses are both present and the practitioner wants to make their relationship observable."
			},
			{
				"title": "Unresolved Conflict",
				"body": "Unresolved polarity is a valid result. The tool preserves differentiation and stuck points without implying failure."
			},
			{
				"title": "More Than Two Parts",
				"body": "If more than two parts emerge, the practitioner narrows to two sides or creates another instance."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as generic role play?",
				"answer": "No. The tool is specifically for internal polarity or conflict between parts of self using two spatial positions."
			},
			{
				"question": "Does the tool require integration to occur?",
				"answer": "No. It can record differentiation, stuck points, and unresolved conflict as useful results."
			},
			{
				"question": "Can one side be unclear or unavailable?",
				"answer": "Yes. The practitioner can record an absent or unclear side rather than forcing dialogue."
			},
			{
				"question": "Does the tool use predefined part categories?",
				"answer": "No. The specification does not require fixed part taxonomies; side labels are practitioner-defined for the instance."
			}
		]
	},
	{
		"toolType": "gestaltDreamWork",
		"slug": "gestalt-dream-work",
		"title": "Gestalt Dream Work for Experiential Therapy | Qwoach",
		"metaDescription": "An experiential Gestalt dreamwork tool for present-tense retelling, dream element roles, dialogues, emotional awareness, and processing notes.",
		"h1": "Gestalt Dream Work",
		"intro": "Gestalt Dream Work is an experiential dreamwork tool for practitioners whose clients bring dreams for exploration rather than symbolic interpretation. It helps capture dream material, support present-tense re-entry and role enactment, and record the personal meaning, emotions, conflicts, or disowned aspects that emerge.",
		"demoTitle": "Explore a sample dreamwork session",
		"demoPrompt": "Interested in using Gestalt Dream Work with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0487-f-021-gst-011-r003-gestalt-dream-work.md",
		"specId": "0487-f-021-gst-011-r003-gestalt-dream-work",
		"tags": {
			"framework": [
				"Gestalt therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Between-Session Notes",
				"body": "Dream notes may be used as input, but live experiential exploration remains the core product experience."
			},
			{
				"title": "What It Captures",
				"body": "It captures dream elements, present-tense retelling notes, role statements, element dialogues, observed affect/resistance/identification/conflict, and emergent awareness."
			},
			{
				"title": "Limits",
				"body": "It is not a dream journal, dream dictionary, or automated symbolic interpretation tool."
			}
		],
		"faqItems": [
			{
				"question": "Does Gestalt Dream Work generate dream interpretations?",
				"answer": "No. Meaning is client-discovered through experiential engagement and is not generated by the system."
			},
			{
				"question": "Can clients add dream notes before session?",
				"answer": "Yes. Between-session dream notes may be included as input, while the core work remains in-session experiential exploration."
			},
			{
				"question": "Does every dream element need to be processed?",
				"answer": "No. The practitioner and client can select clinically relevant elements and leave others unexplored."
			},
			{
				"question": "What if the client cannot inhabit a dream element?",
				"answer": "The tool records the resistance or inability descriptively rather than forcing enactment."
			}
		]
	},
	{
		"toolType": "eftEmotionAssessment",
		"slug": "eft-emotion-assessment",
		"title": "EFT Emotion Assessment for Practitioners | Qwoach",
		"metaDescription": "A practitioner-only EFT tool for organizing emotional responses, process status, supporting evidence, gaps, and treatment-focus implications.",
		"h1": "EFT Emotion Assessment",
		"intro": "EFT Emotion Assessment is a practitioner-only Emotion-Focused Therapy tool for clinicians beginning or revising emotion-focused work. It helps organize presenting problems, emotional responses or patterns, supporting evidence, process status, and immediate treatment-focus implications into an emotion-process formulation.",
		"demoTitle": "Build a sample emotion-process formulation",
		"demoPrompt": "Interested in using EFT Emotion Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0488-f-022-eft-001-r001-eft-emotion-assessment.md",
		"specId": "0488-f-022-eft-001-r001-eft-emotion-assessment",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The tool is for practitioner assessment and formulation. Client material may be summarized as evidence, but the client does not complete a product workflow."
			},
			{
				"title": "Revision Over Time",
				"body": "Draft and revised formulations remain reviewable so the practitioner can understand descriptive changes as new information emerges."
			},
			{
				"title": "Limits",
				"body": "The tool does not diagnose, score the client, assign automated process labels, or generate unsupported task recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is EFT Emotion Assessment a client questionnaire?",
				"answer": "No. It is a practitioner-only assessment and formulation tool."
			},
			{
				"question": "Does the tool automatically decide the client's emotion process?",
				"answer": "No. It organizes evidence and formulation elements; final interpretation belongs to the practitioner."
			},
			{
				"question": "Can a formulation be saved if evidence is incomplete?",
				"answer": "Yes. Draft and provisional formulations are valid and should show unresolved elements."
			},
			{
				"question": "Does the tool include fixed EFT assessment prompts?",
				"answer": "Not yet. Exact assessment prompts, fields, and permissible labels are unresolved and require validation."
			}
		]
	},
	{
		"toolType": "eftCaseFormulation",
		"slug": "eft-case-formulation",
		"title": "EFT Case Formulation Treatment Map | Qwoach",
		"metaDescription": "A practitioner-only EFT treatment-map tool for linking presenting issues, emotional processes, change targets, likely tasks, and revisions.",
		"h1": "EFT Case Formulation",
		"intro": "EFT Case Formulation is a practitioner-only Emotion-Focused Therapy tool for clinicians organizing presenting problems, emotional processes, and change targets into a coherent treatment direction. It helps link difficulties to likely therapeutic tasks or change processes and keeps the map updateable over time.",
		"demoTitle": "Build a sample EFT case formulation",
		"demoPrompt": "Interested in using EFT Case Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0489-f-022-eft-002-r001-eft-case-formulation.md",
		"specId": "0489-f-022-eft-002-r001-eft-case-formulation",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning",
				"Session preparation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Across-Session Use",
				"body": "The formulation can be revised as new emotional process information emerges, while prior states remain reviewable for descriptive continuity."
			},
			{
				"title": "Practitioner-Only Use",
				"body": "Client information may inform the map, but the product does not require a client form or direct client workflow."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide generic case-management features, administrative planning, unsupported labels, automated diagnoses, or fixed scoring."
			}
		],
		"faqItems": [
			{
				"question": "Is EFT Case Formulation a treatment plan template for any therapy model?",
				"answer": "No. It is an EFT-focused formulation map linking difficulties to emotional processes, change targets, and likely EFT tasks or change processes."
			},
			{
				"question": "Can the map be incomplete?",
				"answer": "Yes. Draft maps are useful when some schemes, markers, or links are unresolved."
			},
			{
				"question": "Does the tool automatically rank priorities?",
				"answer": "No. The practitioner orders priorities; the tool does not invent scoring."
			},
			{
				"question": "Does the client complete any part of this tool?",
				"answer": "No. The supplied configuration is practitioner-only."
			}
		]
	},
	{
		"toolType": "markerIdentification",
		"slug": "marker-identification",
		"title": "EFT Marker Identification for Practitioners | Qwoach",
		"metaDescription": "A practitioner-only EFT tool for organizing process evidence, candidate markers, nearby states, uncertainty, and next task focus.",
		"h1": "Marker Identification",
		"intro": "Marker Identification is a practitioner-only Emotion-Focused Therapy tool for clinicians observing an in-session process moment. It helps organize client language, affect, behavior, or interaction patterns so the practitioner can identify a supported marker, differentiate nearby states, and note a plausible next task or intervention focus.",
		"demoTitle": "Identify a sample process marker",
		"demoPrompt": "Interested in using Marker Identification with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0490-f-022-eft-003-r001-marker-identification.md",
		"specId": "0490-f-022-eft-003-r001-marker-identification",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "In-Session And Near-Session Use",
				"body": "The tool can support rapid capture during session or reflective identification shortly afterward."
			},
			{
				"title": "Uncertainty",
				"body": "Unresolved or provisional identifications are valid and can be reviewed later without forcing a marker selection."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide client ratings, diagnostic labels, unsupported marker taxonomies, or automated clinical decisions."
			}
		],
		"faqItems": [
			{
				"question": "Does Marker Identification automatically choose the marker?",
				"answer": "No. The practitioner confirms the marker or marks it provisional or unresolved."
			},
			{
				"question": "Does the client fill out this tool?",
				"answer": "No. The tool is practitioner-only and uses observed session evidence entered by the practitioner."
			},
			{
				"question": "Can nearby states be saved without a final answer?",
				"answer": "Yes. Differential options and uncertainty can be preserved when the process state is unclear."
			},
			{
				"question": "Are marker lists and task links included?",
				"answer": "Only source-supported marker taxonomies and task links should be included; the exact list is unresolved in the specification."
			}
		]
	},
	{
		"toolType": "focusing",
		"slug": "focusing",
		"title": "Focusing EFT Task Demo | Qwoach",
		"metaDescription": "Explore a live-session Focusing tool for EFT practitioners to capture felt sense, emergent meaning, emotion, direction, and shift.",
		"h1": "Focusing for Felt-Sense Clarification",
		"intro": "Focusing is a live-session emotion-focused therapy task for practitioners working with clients who have a vague, unclear, or bodily felt concern. It helps the practitioner capture what becomes clearer as emotion, meaning, image, word, bodily shift, or direction.",
		"demoTitle": "Open the sample focusing workspace",
		"demoPrompt": "Interested in using Focusing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0491-f-022-eft-004-r001-focusing.md",
		"specId": "0491-f-022-eft-004-r001-focusing",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during live work when experience is sensed but not yet symbolized clearly enough for deeper processing."
			},
			{
				"title": "Partial Work Is Valid",
				"body": "A session may end with only a located felt sense and no emergent shift. The review should show that as incomplete clarification, not failure."
			}
		],
		"faqItems": [
			{
				"question": "Is this a self-guided client exercise?",
				"answer": "No. Focusing is specified as a live-session practitioner-guided task. Client participation is collaborative and optional within the shared workspace."
			},
			{
				"question": "Does the tool interpret the felt sense?",
				"answer": "No. The tool organizes what is entered but does not infer meanings, diagnose, score, or generate therapeutic conclusions."
			},
			{
				"question": "Can I save the tool if there are no settings?",
				"answer": "Yes. Saving adds the fixed Focusing tool itself to the practitioner's account as-is."
			}
		]
	},
	{
		"toolType": "clearingASpace",
		"slug": "clearing-a-space",
		"title": "Clearing a Space EFT Demo | Qwoach",
		"metaDescription": "Explore a live-session Clearing a Space tool for EFT practitioners to separate concerns, note distance or relief, and find a workable focus.",
		"h1": "Clearing a Space for Diffuse Concerns",
		"intro": "Clearing a Space is a live-session emotion-focused therapy task for practitioners working with clients who arrive with multiple concerns, diffuse distress, or internal clutter. It helps separate concerns, note distance or relief, and identify whether a manageable focus is available.",
		"demoTitle": "Explore the sample concern map",
		"demoPrompt": "Interested in using Clearing a Space with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0492-f-022-eft-005-r001-clearing-a-space.md",
		"specId": "0492-f-022-eft-005-r001-clearing-a-space",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when multiple concerns or diffuse distress make it hard to identify the therapeutic focus."
			},
			{
				"title": "No Forced Focus",
				"body": "If no focal concern emerges, the separated map remains a valid partial result for later continuation."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool prioritize the client's concerns?",
				"answer": "No. It separates concerns and may mark one workable focus if it emerges, but it does not rank or score priorities."
			},
			{
				"question": "Can the client complete it alone?",
				"answer": "No. The specified use is live-session only, with optional shared visibility for collaborative confirmation."
			},
			{
				"question": "What happens if the client remains overwhelmed?",
				"answer": "The map records insufficient distance or relief rather than forcing selection of a focus."
			}
		]
	},
	{
		"toolType": "systematicEvocativeUnfolding",
		"slug": "systematic-evocative-unfolding",
		"title": "Systematic Evocative Unfolding Demo | Qwoach",
		"metaDescription": "Explore a live-session EFT episode map that helps practitioners clarify reaction sequence, meanings, bodily shifts, and intervention targets.",
		"h1": "Systematic Evocative Unfolding for Emotional Reaction Episodes",
		"intro": "Systematic Evocative Unfolding is a live-session EFT task for practitioners working with a puzzling, painful, or significant emotional reaction episode. It helps clarify the sequence, triggers, meanings, bodily-affective shifts, action tendencies, and practitioner-labeled intervention targets where supported by the client's account.",
		"demoTitle": "Open the sample episode map",
		"demoPrompt": "Interested in using Systematic Evocative Unfolding with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0493-f-022-eft-006-r001-systematic-evocative-unfolding.md",
		"specId": "0493-f-022-eft-006-r001-systematic-evocative-unfolding",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One Episode at a Time",
				"body": "Each unfolding is anchored to one emotional reaction episode. Multiple episodes should become separate entries rather than one merged sequence."
			},
			{
				"title": "Unknown Elements Are Allowed",
				"body": "The map can remain partial when the client's account does not support every element."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate the clinical formulation?",
				"answer": "No. It organizes entered episode data and keeps practitioner targets labeled separately; it does not generate clinical conclusions."
			},
			{
				"question": "Does every field have to be complete?",
				"answer": "No. Unsupported elements can remain unknown, and the partial episode map can still be reviewed."
			},
			{
				"question": "Can side categories or process elements be customized?",
				"answer": "No. The process-element structure is fixed by the tool configuration and should not be changed as ordinary settings."
			}
		]
	},
	{
		"toolType": "twoChairDialogueForSelfCriticism",
		"slug": "two-chair-dialogue-for-self-criticism",
		"title": "Two-Chair Self-Criticism EFT Demo | Qwoach",
		"metaDescription": "Explore a live-session EFT chairwork tool for capturing critic messages, affected-self needs, new responses, and emotional shifts.",
		"h1": "Two-Chair Dialogue for Self-Criticism",
		"intro": "Two-Chair Dialogue for Self-Criticism is a live-session EFT chairwork tool for practitioners working with harsh self-criticism or an internal attacking split. It helps capture critic messages, the affected self's pain and needs, and any new response, softening, differentiation, or emotional shift.",
		"demoTitle": "Open the sample two-chair dialogue",
		"demoPrompt": "Interested in using Two-Chair Dialogue for Self-Criticism with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0494-f-022-eft-007-r001-two-chair-dialogue-for-self-criticism.md",
		"specId": "0494-f-022-eft-007-r001-two-chair-dialogue-for-self-criticism",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Self-criticism"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Positions",
				"body": "The tool uses Critic and Affected Self positions. It is not an arbitrary role-dialogue builder."
			},
			{
				"title": "Unresolved Dialogue Is Valid",
				"body": "A record may show critic material without a new response yet. That partial state can support later continuation."
			}
		],
		"faqItems": [
			{
				"question": "Can I rename the two positions?",
				"answer": "No. This configuration keeps the positions fixed as Critic and Affected Self."
			},
			{
				"question": "Does the tool provide chairwork scripts?",
				"answer": "No. Exact prompts and scripts are not defined; the tool captures live session content and observations."
			},
			{
				"question": "Does it score progress in self-criticism?",
				"answer": "No. It records evidence of new response, softening, differentiation, or shift without a score."
			}
		]
	},
	{
		"toolType": "twoChairConflictSplit",
		"slug": "two-chair-conflict-split",
		"title": "Two-Chair Conflict Split Demo | Qwoach",
		"metaDescription": "Explore a live-session EFT chairwork map for differentiating two conflict sides, unmet needs, interaction patterns, and movement status.",
		"h1": "Two-Chair Conflict Split for Internal Conflict",
		"intro": "Two-Chair Conflict Split is a live-session EFT chairwork tool for practitioners helping clients caught between conflicting parts, wishes, evaluations, or action tendencies. It helps map each side's wants, fears, emotions, meanings, action tendencies, unmet needs, and any movement toward softening, integration, a new stance, or a clearer decision point.",
		"demoTitle": "Open the sample conflict map",
		"demoPrompt": "Interested in using Two-Chair Conflict Split with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0495-f-022-eft-008-r001-two-chair-conflict-split.md",
		"specId": "0495-f-022-eft-008-r001-two-chair-conflict-split",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Editable Side Labels",
				"body": "Side labels can use client language while the underlying structure remains Side A and Side B."
			},
			{
				"title": "Not a Decision Tool",
				"body": "The tool records differentiation and movement; it does not recommend what the client should choose."
			}
		],
		"faqItems": [
			{
				"question": "Can more than two voices be mapped?",
				"answer": "No. This tool preserves a two-chair conflict focus; the practitioner chooses the two active opposing sides for the instance."
			},
			{
				"question": "What if one side is unclear?",
				"answer": "The map can remain partial. One underdeveloped side does not block review or continuation."
			},
			{
				"question": "Are side labels saved?",
				"answer": "Yes. For this configurable tool, selected side labels are saved with the tool configuration, while sample demo content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "selfInterruptionTask",
		"slug": "self-interruption-task",
		"title": "Self-Interruption EFT Demo | Qwoach",
		"metaDescription": "Explore a live-session EFT map for identifying interruption mechanisms, blocked emotion or need, and alternative responses without scoring.",
		"h1": "Self-Interruption Task for Blocked Emotional Processing",
		"intro": "Self-Interruption Task is a live-session EFT tool for practitioners working when a client blocks, suppresses, avoids, or interrupts emerging emotion or action tendency. It helps identify the interruption mechanism, the blocked emotion, need, or action tendency, and any alternative response that becomes available.",
		"demoTitle": "Open the sample interruption map",
		"demoPrompt": "Interested in using Self-Interruption Task with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0496-f-022-eft-009-r001-self-interruption-task.md",
		"specId": "0496-f-022-eft-009-r001-self-interruption-task",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation",
				"Safety behaviors"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Flexible Entry Order",
				"body": "The blocked emotion may appear before the mechanism is clear, or the mechanism may be visible before the blocked experience is accessible."
			},
			{
				"title": "No Forced Alternative",
				"body": "If no alternative response is available, the review records that state rather than implying failure."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool diagnose avoidance?",
				"answer": "No. It descriptively maps interruption mechanisms and blocked experience without diagnostic labels."
			},
			{
				"question": "Can multiple interruption forms be recorded?",
				"answer": "Yes. Multiple forms can be captured descriptively without ranking them."
			},
			{
				"question": "Does it include practice steps?",
				"answer": "No. Prescribed practice steps are outside the specified tool behavior."
			}
		]
	},
	{
		"toolType": "emptyChairDialogueForUnfinishedBusiness",
		"slug": "empty-chair-dialogue-for-unfinished-business",
		"title": "Empty-Chair Unfinished Business Demo | Qwoach",
		"metaDescription": "Explore a live-session EFT empty-chair record for unresolved relational emotions, unmet needs, direct statements, and shift evidence.",
		"h1": "Empty-Chair Dialogue for Unfinished Business",
		"intro": "Empty-Chair Dialogue for Unfinished Business is a live-session EFT chairwork tool for practitioners working with unresolved relational pain, anger, hurt, grief, longing, or unmet needs connected to an absent significant person. It helps capture direct statements, emotional differentiation, unmet needs, and meaningful shift evidence.",
		"demoTitle": "Open the sample empty-chair record",
		"demoPrompt": "Interested in using Empty-Chair Dialogue for Unfinished Business with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0497-f-022-eft-010-r001-empty-chair-dialogue-for-unfinished-business.md",
		"specId": "0497-f-022-eft-010-r001-empty-chair-dialogue-for-unfinished-business",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships",
				"Grief and loss"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Direct Expression Is Central",
				"body": "The record is organized around what the client expresses toward the absent person, not around generated dialogue or the absent person's response."
			},
			{
				"title": "No Required Shift",
				"body": "Expression may deepen without clear shift. That partial state remains useful for continuation."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write dialogue for the client?",
				"answer": "No. It captures the client's direct expression and does not supply substantive dialogue."
			},
			{
				"question": "Does the review measure closure?",
				"answer": "No. The tool does not score closure or require forgiveness, reconciliation, or any specific outcome."
			},
			{
				"question": "Can multiple absent people be included in one record?",
				"answer": "No. Separate task instances should be used to avoid merging unfinished business for multiple significant people."
			}
		]
	},
	{
		"toolType": "selfSoothingTask",
		"slug": "self-soothing-task",
		"title": "Self-Soothing EFT Task Demo | Qwoach",
		"metaDescription": "Explore a live-session EFT self-soothing map for distressed part needs, compassionate responses, emotional credibility, and shifts.",
		"h1": "Self-Soothing Task for Self-Directed Compassionate Responding",
		"intro": "Self-Soothing Task is a live-session EFT tool for practitioners working with emotionally distressed clients who lack access to a compassionate, protective, validating, or calming response toward themselves. It helps capture the distressed part's need, the client's own soothing response, emotional credibility, and any shift in distress, self-contact, or capacity to stay with emotion.",
		"demoTitle": "Open the sample self-soothing map",
		"demoPrompt": "Interested in using Self-Soothing Task with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0498-f-022-eft-011-r001-self-soothing-task.md",
		"specId": "0498-f-022-eft-011-r001-self-soothing-task",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Emotion regulation",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client Language Comes First",
				"body": "The tool captures the client's own soothing response rather than inserting canned compassionate statements."
			},
			{
				"title": "Intellectual-Only Responses Are Visible",
				"body": "A response can be recorded as not yet emotionally credible so the practitioner can continue refining it."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include soothing scripts?",
				"answer": "No. Required scripts are outside the specified behavior; the client's own response is central."
			},
			{
				"question": "Does distress have to reduce for the task to be useful?",
				"answer": "No. The review can also record increased self-contact or greater capacity to stay with emotion, and partial states remain valid."
			},
			{
				"question": "Can multiple needs be recorded?",
				"answer": "Yes. More than one need-response pair can be captured if they emerge in the same task."
			}
		]
	},
	{
		"toolType": "emotionSchemeCoreEmotionMap",
		"slug": "emotion-scheme-core-emotion-map",
		"title": "Core Emotion Map EFT Demo | Qwoach",
		"metaDescription": "Explore a collaborative EFT core emotion map linking recurring situations, emotions, meanings, bodily responses, needs, and action tendencies.",
		"h1": "Emotion Scheme / Core Emotion Map",
		"intro": "Emotion Scheme / Core Emotion Map is a collaborative EFT formulation tool for practitioners and clients completing a structured map together. It helps identify recurring links between situations, core emotions, meanings, bodily responses, needs, and action tendencies so the practitioner can target emotional deepening, transformation, or treatment planning.",
		"demoTitle": "Open the sample core emotion map",
		"demoPrompt": "Interested in using Emotion Scheme / Core Emotion Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0499-f-022-eft-012-r001-emotion-scheme-core-emotion-map.md",
		"specId": "0499-f-022-eft-012-r001-emotion-scheme-core-emotion-map",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Recurring Pattern, Not One Episode",
				"body": "The map helps distinguish central recurring emotional organization from isolated examples."
			},
			{
				"title": "Collaborative Completion",
				"body": "Client-reported content can be completed together while practitioner hypotheses and planning notes stay clearly labeled."
			},
			{
				"title": "Historical Refinement",
				"body": "Maps may be revisited as new examples clarify or revise the recurring scheme."
			}
		],
		"faqItems": [
			{
				"question": "Does the system infer the client's core emotion scheme?",
				"answer": "No. The system structures entered material; practitioner hypotheses remain practitioner-entered and labeled."
			},
			{
				"question": "Can fields remain unknown?",
				"answer": "Yes. The map can remain partial and be refined as more examples become available."
			},
			{
				"question": "Is this a symptom assessment?",
				"answer": "No. It does not collect symptom severity scores or provide diagnostic output."
			}
		]
	},
	{
		"toolType": "emotionEpisodeReview",
		"slug": "emotion-episode-review",
		"title": "Emotion Episode Review Demo | Qwoach",
		"metaDescription": "Explore a collaborative EFT episode review tool for mapping one concrete emotional episode, process elements, and practitioner-labeled targets.",
		"h1": "Emotion Episode Review for Process Mapping",
		"intro": "Emotion Episode Review is a collaborative EFT tool for practitioners and clients reviewing one clinically important emotional episode together. It helps anchor the episode in a concrete situation and organize trigger, appraisal, feeling, meaning, need, bodily response, action tendency, response pattern, and practitioner-labeled hypothesis or intervention target.",
		"demoTitle": "Open the sample episode review",
		"demoPrompt": "Interested in using Emotion Episode Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0500-f-022-eft-013-r001-emotion-episode-review.md",
		"specId": "0500-f-022-eft-013-r001-emotion-episode-review",
		"tags": {
			"framework": [
				"Emotion-Focused Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Concrete Anchor Required",
				"body": "A complete review requires a specific episode anchor rather than a vague general pattern."
			},
			{
				"title": "One Episode Per Review",
				"body": "If multiple episodes are mixed together, they should be separated into distinct reviews."
			},
			{
				"title": "Hypotheses Stay Labeled",
				"body": "Practitioner hypotheses and intervention targets are separate from client-reported episode data."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend the next intervention?",
				"answer": "No. The practitioner records the hypothesis or intervention target; the system does not generate treatment recommendations."
			},
			{
				"question": "Can a review be partial?",
				"answer": "Yes. Elements can remain unknown when unsupported, as long as the review is anchored in a concrete episode."
			},
			{
				"question": "Does this create a core emotion scheme automatically?",
				"answer": "No. It reviews one episode and does not generalize automatically to a recurring core pattern."
			}
		]
	},
	{
		"toolType": "psychodiagnosticChartPdc2Pdc3",
		"slug": "psychodiagnostic-chart-pdc-2-pdc-3",
		"title": "Psychodiagnostic Chart PDC-2/PDC-3 Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only PDC-2/PDC-3 psychodynamic profile for organizing ratings, notes, completion status, and comparable review.",
		"h1": "Psychodiagnostic Chart (PDC-2/PDC-3)",
		"intro": "Psychodiagnostic Chart (PDC-2/PDC-3) is a practitioner-only structured psychodynamic profiling tool for clinicians. It helps clinicians organize diagnosis-relevant functioning, personality patterns, symptoms, and formulation targets into a profile for assessment, progress reporting, or outcome review.",
		"demoTitle": "Explore a sample practitioner profile",
		"demoPrompt": "Interested in using Psychodiagnostic Chart (PDC-2/PDC-3) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0501-f-023-pdt-001-r001-psychodiagnostic-chart-pdc-2-pdc-3.md",
		"specId": "0501-f-023-pdt-001-r001-psychodiagnostic-chart-pdc-2-pdc-3",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during psychodynamic diagnosis, formulation, progress reporting, or outcome assessment when the clinician needs a structured view of functioning rather than a narrative impression alone."
			},
			{
				"title": "What It Captures",
				"body": "It captures practitioner ratings, optional evidence notes, assessment purpose, completion state, not-assessed domains, and comparable historical profiles when the same structure is repeated."
			},
			{
				"title": "Important Limits",
				"body": "The public demo must not invent PDC domains, item wording, anchors, scoring, automated diagnoses, or treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the client complete this tool?",
				"answer": "No. This is practitioner-only; client material may inform the clinician's ratings outside the product."
			},
			{
				"question": "Does the tool generate a diagnosis?",
				"answer": "No. It organizes practitioner-entered ratings and notes into a structured psychodynamic profile without automated diagnostic conclusions."
			},
			{
				"question": "Can profiles be compared over time?",
				"answer": "Yes, descriptively, when profiles use the same supported rating structure."
			},
			{
				"question": "What happens to sample demo entries when I save?",
				"answer": "Sample ratings, fictional notes, and demo case data are not saved as real client data; the tool and selected configuration are saved."
			}
		]
	},
	{
		"toolType": "pdmPersonalityFunctioningProfile",
		"slug": "pdm-personality-functioning-profile",
		"title": "PDM Personality Functioning Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only PDM personality-functioning profile for organizing adaptive capacities, vulnerabilities, patterns, and notes.",
		"h1": "PDM Personality Functioning Profile",
		"intro": "PDM Personality Functioning Profile is a practitioner-only psychodynamic assessment configuration for clinicians. It helps clinicians organize healthy and disordered personality functioning, including adaptive capacities, vulnerabilities, enduring patterns, and symptom-pattern distinctions.",
		"demoTitle": "Explore a sample personality-functioning profile",
		"demoPrompt": "Interested in using PDM Personality Functioning Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0502-f-023-pdt-002-r001-pdm-personality-functioning-profile.md",
		"specId": "0502-f-023-pdt-002-r001-pdm-personality-functioning-profile",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when personality functioning needs to inform psychodynamic treatment focus, stance, and expected therapeutic challenges."
			},
			{
				"title": "What It Captures",
				"body": "It captures practitioner-entered strengths, vulnerabilities, disorder-relevant patterns, symptom/personality distinctions, evidence notes, and completion state."
			},
			{
				"title": "Important Limits",
				"body": "It is not a general personality test, client self-report measure, symptom checklist, or automated diagnostic tool."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client questionnaire?",
				"answer": "No. The profile is completed by the practitioner using clinical material."
			},
			{
				"question": "Does it diagnose personality disorder?",
				"answer": "No. It organizes practitioner-entered personality-functioning information and does not generate automated diagnoses."
			},
			{
				"question": "Can I compare profiles over time?",
				"answer": "Yes, when comparable profiles use the same supported profile structure."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected profile structure are saved; fictional demo content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "pdmMentalFunctioningProfile",
		"slug": "pdm-mental-functioning-profile",
		"title": "PDM Mental Functioning Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only PDM mental-functioning profile for organizing capacities, limitations, evidence notes, and review.",
		"h1": "PDM Mental Functioning Profile",
		"intro": "PDM Mental Functioning Profile is a practitioner-only psychodynamic assessment configuration for clinicians. It helps clinicians organize a client's mental capacities, strengths, limitations, and evidence notes across supported psychological domains.",
		"demoTitle": "Explore a sample mental-functioning profile",
		"demoPrompt": "Interested in using PDM Mental Functioning Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0503-f-023-pdt-003-r001-pdm-mental-functioning-profile.md",
		"specId": "0503-f-023-pdt-003-r001-pdm-mental-functioning-profile",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when mental capacities and psychological functioning need to be organized for psychodynamic formulation and treatment planning."
			},
			{
				"title": "What It Captures",
				"body": "It captures practitioner observations, ratings or notes, evidence for strengths and limitations, uncertainty, not-assessed states, and profile completion."
			},
			{
				"title": "Important Limits",
				"body": "It is not a general cognitive assessment, symptom severity scale, client self-report workflow, or intervention planner."
			}
		],
		"faqItems": [
			{
				"question": "Does the system infer mental capacities automatically?",
				"answer": "No. The practitioner enters observations, ratings, and notes; the system organizes them."
			},
			{
				"question": "Can a domain be left unrated?",
				"answer": "Yes. Unfinished and not-assessed areas remain visible and distinct from impairment."
			},
			{
				"question": "Does the result recommend treatment pacing?",
				"answer": "No. The profile can inform practitioner decisions, but it does not generate treatment instructions."
			},
			{
				"question": "What is saved after the public demo?",
				"answer": "The tool and selected supported form/version are saved; fictional demo profile content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "pdmSubjectiveSymptomExperienceProfile",
		"slug": "pdm-subjective-symptom-experience-profile",
		"title": "PDM Subjective Symptom Experience Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only symptom-experience profile for organizing subjective distress, meaning, supported links, and review.",
		"h1": "PDM Subjective Symptom Experience Profile",
		"intro": "PDM Subjective Symptom Experience Profile is a practitioner-only psychodynamic profiling configuration for clinicians. It helps clinicians organize how a client subjectively experiences, makes meaning of, and psychologically organizes presenting symptoms.",
		"demoTitle": "Explore a sample symptom-experience profile",
		"demoPrompt": "Interested in using PDM Subjective Symptom Experience Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0504-f-023-pdt-004-r001-pdm-subjective-symptom-experience-profile.md",
		"specId": "0504-f-023-pdt-004-r001-pdm-subjective-symptom-experience-profile",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when treatment formulation depends on how the client experiences symptoms emotionally and psychologically, not simply whether symptoms are present."
			},
			{
				"title": "What It Captures",
				"body": "It captures symptom references, subjective experience, distress or meaning notes, supported formulation links, uncertainty, and completion state."
			},
			{
				"title": "Important Limits",
				"body": "It is not a symptom checklist, diagnostic screener, client diary, automated meaning generator, or treatment exercise."
			}
		],
		"faqItems": [
			{
				"question": "Does this replace a symptom scale?",
				"answer": "No. It focuses on practitioner-organized subjective symptom experience rather than generic symptom severity scoring."
			},
			{
				"question": "Can the client fill it out?",
				"answer": "No. The supported product is practitioner-only; client statements may be represented by the clinician as clinical material."
			},
			{
				"question": "Does the tool interpret symptom meaning?",
				"answer": "No. Formulation links must be entered by the practitioner and supported by clinical material."
			},
			{
				"question": "What carries over when I save?",
				"answer": "The tool and selected supported form/version carry over; fictional demo symptom content does not become real client data."
			}
		]
	},
	{
		"toolType": "opd3SemiStandardizedInterview",
		"slug": "opd-3-semi-standardized-interview",
		"title": "OPD-3 Interview Workflow Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only OPD-3 interview workflow for organizing multiaxial notes, findings, treatment foci, and review.",
		"h1": "OPD-3 Semi-Standardized Interview",
		"intro": "OPD-3 Semi-Standardized Interview is a practitioner-only clinically oriented psychodynamic interview workflow for clinicians. It helps clinicians gather and organize multiaxial diagnostic information across illness experience, relational patterns, conflict, structure, and symptoms for diagnosis and treatment planning.",
		"demoTitle": "Explore a sample OPD-3 interview workflow",
		"demoPrompt": "Interested in using OPD-3 Semi-Standardized Interview with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0505-f-023-pdt-005-r001-opd-3-semi-standardized-interview.md",
		"specId": "0505-f-023-pdt-005-r001-opd-3-semi-standardized-interview",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when psychodynamic diagnosis and treatment planning require a coherent multiaxial case picture rather than separate descriptive findings."
			},
			{
				"title": "Full And Partial Assessments",
				"body": "The workflow can represent a full OPD-3 interview or a documented partial assessment; partial results remain visibly partial."
			},
			{
				"title": "Important Limits",
				"body": "The demo must not invent OPD-3 interview questions, axes beyond those supplied, substructures, anchors, coding rules, automated ratings, or treatment plans."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client self-administered interview?",
				"answer": "No. The practitioner conducts the clinical interview and completes the product workflow."
			},
			{
				"question": "Does the tool generate priority treatment foci?",
				"answer": "No. Priority treatment foci are entered by the practitioner; the system organizes them with the axis material."
			},
			{
				"question": "Can I save an interrupted interview?",
				"answer": "Yes. Partial axis notes and completion state can be saved and resumed."
			},
			{
				"question": "Can OPD-3 assessments be compared over time?",
				"answer": "Yes, descriptively, when assessments use compatible OPD-3 structures."
			}
		]
	},
	{
		"toolType": "opdAxisIIllnessExperienceTreatmentPreconditions",
		"slug": "opd-axis-i-illness-experience-treatment-preconditions",
		"title": "OPD Axis I Treatment Preconditions Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only OPD Axis I profile for illness experience, motivation, resources, expectations, barriers, and review.",
		"h1": "OPD Axis I: Illness Experience & Treatment Preconditions",
		"intro": "OPD Axis I: Illness Experience & Treatment Preconditions is a practitioner-only psychodynamic assessment configuration for clinicians. It helps clinicians organize illness experience, motivation, resources, expectations, likely barriers, and treatment setup implications.",
		"demoTitle": "Explore a sample Axis I profile",
		"demoPrompt": "Interested in using OPD Axis I: Illness Experience & Treatment Preconditions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0506-f-023-pdt-006-r001-opd-axis-i-illness-experience-treatment-preconditions.md",
		"specId": "0506-f-023-pdt-006-r001-opd-axis-i-illness-experience-treatment-preconditions",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before or during treatment setup when illness experience, motivation, expectations, resources, or barriers may affect engagement."
			},
			{
				"title": "What It Captures",
				"body": "It captures practitioner-entered illness experience, treatment-relevant preconditions, barriers, resources, expectations, setup implications, uncertainty, and completion state."
			},
			{
				"title": "Important Limits",
				"body": "It does not predict engagement probability, create readiness scores, manage scheduling, send reminders, or generate treatment-plan instructions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a readiness score?",
				"answer": "No. It organizes treatment-precondition information without generating an automated readiness score."
			},
			{
				"question": "Can unclear expectations be recorded?",
				"answer": "Yes. Unclear or shifting expectations can be marked uncertain and updated later."
			},
			{
				"question": "Does the client enter information directly?",
				"answer": "No. The practitioner completes the profile using clinical conversation and observations."
			},
			{
				"question": "What is saved when I add it to my account?",
				"answer": "The Axis I tool, selected version/form, and selected scope are saved; fictional demo profile content is not."
			}
		]
	},
	{
		"toolType": "opdAxisIiRelationshipPattern",
		"slug": "opd-axis-ii-relationship-pattern",
		"title": "OPD Axis II Relationship Pattern Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only OPD Axis II tool for mapping relationship episodes, recurring patterns, responses, and review.",
		"h1": "OPD Axis II: Relationship Pattern",
		"intro": "OPD Axis II: Relationship Pattern is a practitioner-only psychodynamic formulation configuration for clinicians. It helps clinicians organize recurring interpersonal material into a relational formulation that distinguishes client contributions, responses of others, and maintenance dynamics.",
		"demoTitle": "Explore a sample relationship-pattern map",
		"demoPrompt": "Interested in using OPD Axis II: Relationship Pattern with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0507-f-023-pdt-007-r001-opd-axis-ii-relationship-pattern.md",
		"specId": "0507-f-023-pdt-007-r001-opd-axis-ii-relationship-pattern",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when recurring interpersonal difficulties appear central and relationship material can support a pattern formulation."
			},
			{
				"title": "Evidence And Formulation",
				"body": "The tool keeps relationship episodes separate from the formulated pattern so the practitioner can see what supports the formulation."
			},
			{
				"title": "Important Limits",
				"body": "It is not a relationship satisfaction score, couples worksheet, automated interpersonal analysis engine, or full OPD assessment."
			}
		],
		"faqItems": [
			{
				"question": "Can I use one relationship episode?",
				"answer": "Yes, but the formulation should be marked tentative when recurrence is not supported across contexts."
			},
			{
				"question": "Does the tool create the relational pattern automatically?",
				"answer": "No. The practitioner authors the pattern; the system organizes evidence and completion state."
			},
			{
				"question": "Can conflicting episodes be recorded?",
				"answer": "Yes. Conflicting material can be kept as notes or uncertainty rather than forced into one pattern."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected configuration are saved; fictional relationship episodes and sample formulations are not real client data."
			}
		]
	},
	{
		"toolType": "opdAxisIiiConflict",
		"slug": "opd-axis-iii-conflict",
		"title": "OPD Axis III Conflict Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only OPD Axis III profile for linking conflict patterns to symptoms, affect, relationships, coping, and review.",
		"h1": "OPD Axis III: Conflict",
		"intro": "OPD Axis III: Conflict is a practitioner-only psychodynamic assessment configuration for clinicians. It helps clinicians organize clinical material into a conflict profile showing supported conflict patterns, clinical links, priority, and uncertainty.",
		"demoTitle": "Explore a sample conflict profile",
		"demoPrompt": "Interested in using OPD Axis III: Conflict with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0508-f-023-pdt-008-r001-opd-axis-iii-conflict.md",
		"specId": "0508-f-023-pdt-008-r001-opd-axis-iii-conflict",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when clinical material suggests psychodynamic conflicts that may organize symptoms, affect, relationships, or coping."
			},
			{
				"title": "Evidence Matters",
				"body": "The profile keeps clinical support visible so a generic theme is not treated as a supported conflict without practitioner evidence."
			},
			{
				"title": "Important Limits",
				"body": "It does not auto-detect conflicts, infer unconscious meaning, supply unsupported conflict taxonomies, or generate treatment plans."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool identify conflicts automatically?",
				"answer": "No. Conflict formulation and priority are practitioner-entered."
			},
			{
				"question": "Can more than one conflict be recorded?",
				"answer": "Yes. Multiple supported patterns can be recorded with practitioner-entered priority where supported."
			},
			{
				"question": "What if the evidence is weak?",
				"answer": "The profile can mark a conflict as tentative, uncertain, or not assessed rather than treating it as supported."
			},
			{
				"question": "What carries over after saving?",
				"answer": "The tool and selected configuration carry over; fictional demo conflict material does not become real client data."
			}
		]
	},
	{
		"toolType": "opdAxisIvStructure",
		"slug": "opd-axis-iv-structure",
		"title": "OPD Axis IV Structure Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only OPD Axis IV profile for structural capacities, impairments, evidence notes, uncertainty, and review.",
		"h1": "OPD Axis IV: Structure",
		"intro": "OPD Axis IV: Structure is a practitioner-only psychodynamic assessment configuration for clinicians. It helps clinicians organize capacities and impairments in personality functioning for treatment planning, pacing, stance, and support decisions.",
		"demoTitle": "Explore a sample structural-function profile",
		"demoPrompt": "Interested in using OPD Axis IV: Structure with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0509-f-023-pdt-009-r001-opd-axis-iv-structure.md",
		"specId": "0509-f-023-pdt-009-r001-opd-axis-iv-structure",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when personality structure and functional capacities need to inform psychodynamic treatment planning."
			},
			{
				"title": "Mixed Profiles",
				"body": "The profile can show strengths and vulnerabilities in different areas without forcing an unsupported single summary."
			},
			{
				"title": "Important Limits",
				"body": "It is not a generic functioning scale, full personality assessment, automated level calculator, or treatment recommendation engine."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool calculate the client's structure level?",
				"answer": "No. Practitioner-entered level or summary can be represented where supported, but the system does not calculate it automatically."
			},
			{
				"question": "Can strengths and vulnerabilities both be shown?",
				"answer": "Yes. The profile is designed to show mixed capacities without collapsing them into one unsupported label."
			},
			{
				"question": "Does the result recommend treatment intensity?",
				"answer": "No. It can inform practitioner decisions but does not generate treatment intensity, stance, or support recommendations."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The Axis IV tool and selected configuration are saved; fictional structural-function entries are not saved as real client data."
			}
		]
	},
	{
		"toolType": "coreConflictualRelationshipThemeCcrt",
		"slug": "core-conflictual-relationship-theme-ccrt",
		"title": "CCRT Formulation Tool Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only CCRT workflow for organizing relationship episodes, wishes, responses of others, responses of self, and theme review.",
		"h1": "Core Conflictual Relationship Theme (CCRT)",
		"intro": "Core Conflictual Relationship Theme (CCRT) is a practitioner-only structured psychodynamic case-formulation method for clinicians. It helps clinicians organize relationship anecdotes into central wishes or needs, responses of others, responses of self, and a practitioner-authored recurring theme.",
		"demoTitle": "Explore a sample CCRT matrix",
		"demoPrompt": "Interested in using Core Conflictual Relationship Theme (CCRT) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0510-f-023-pdt-010-r001-core-conflictual-relationship-theme-ccrt.md",
		"specId": "0510-f-023-pdt-010-r001-core-conflictual-relationship-theme-ccrt",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when relationship anecdotes suggest a recurring interpersonal theme relevant to the client's distress or current difficulties."
			},
			{
				"title": "What It Captures",
				"body": "It captures concrete episodes, wishes or needs, responses of others, responses of self, repeated elements, incomplete components, and a practitioner-authored theme."
			},
			{
				"title": "Important Limits",
				"body": "It is not a generic relationship journal, OPD Axis II tool, automated interpersonal analysis engine, or symptom scoring tool."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate the CCRT theme?",
				"answer": "No. The practitioner authors the final recurring relationship theme; the system organizes episodes and component completion."
			},
			{
				"question": "What are the core components?",
				"answer": "The supported components are wish or need, response of others, and response of self for each relationship episode."
			},
			{
				"question": "Can I save a tentative theme?",
				"answer": "Yes. Too few episodes, incomplete components, or conflicting patterns can be represented as tentative rather than forced into one pattern."
			},
			{
				"question": "What happens if there are no configurable settings?",
				"answer": "The fixed CCRT tool is still saved as-is; no fictional demo anecdotes or themes become real client data."
			}
		]
	},
	{
		"toolType": "relationshipAnecdotesParadigmRapInterview",
		"slug": "relationship-anecdotes-paradigm-rap-interview",
		"title": "RAP Interview Demo for Psychodynamic Formulation | Qwoach",
		"metaDescription": "Explore a practitioner-led RAP Interview demo for collecting structured relationship episodes to support later psychodynamic formulation.",
		"h1": "Relationship Anecdotes Paradigm Interview",
		"intro": "The Relationship Anecdotes Paradigm Interview is a practitioner-administered structured psychodynamic interview for psychodynamic practitioners. It helps the practitioner collect multiple relationship episodes with details about significant others, wishes, emotions, responses, and interpersonal outcomes so the material can support later CCRT coding or psychodynamic formulation.",
		"demoTitle": "Start with sample episodes",
		"demoPrompt": "Interested in using Relationship Anecdotes Paradigm (RAP) Interview with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0511-f-023-pdt-011-r001-relationship-anecdotes-paradigm-rap-interview.md",
		"specId": "0511-f-023-pdt-011-r001-relationship-anecdotes-paradigm-rap-interview",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a psychodynamic practitioner needs multiple relationship episodes that are structured enough for later coding or formulation of interpersonal themes."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures episode-by-episode material about significant others or relationship contexts, situations, wishes, emotions, responses, outcomes, narrative text, and practitioner clarifications."
			},
			{
				"title": "Important Boundary",
				"body": "The tool organizes episode material. It does not score, diagnose, or automatically formulate a relationship theme."
			}
		],
		"faqItems": [
			{
				"question": "Does the RAP Interview generate a CCRT formulation?",
				"answer": "No. It produces a standardized relationship-episode corpus that can later support CCRT coding or psychodynamic formulation."
			},
			{
				"question": "Does the client complete this tool independently?",
				"answer": "No. The supported experience is practitioner-led interview capture; the client contributes narrative material in the clinical encounter."
			},
			{
				"question": "Can incomplete episodes be saved?",
				"answer": "Yes. Incomplete episodes persist as partial interview material and are marked with missing-element indicators."
			}
		]
	},
	{
		"toolType": "transferencePatternMap",
		"slug": "transference-pattern-map",
		"title": "Transference Pattern Map for Psychodynamic Formulation | Qwoach",
		"metaDescription": "Explore a practitioner-only map for tracking transference observations, broader interpersonal patterns, and evolving formulation updates.",
		"h1": "Transference Pattern Map",
		"intro": "The Transference Pattern Map is a practitioner-only longitudinal psychodynamic formulation aid for psychodynamic practitioners. It helps the practitioner connect in-session relational expectations or reactions with broader recurring interpersonal patterns so the current transference formulation can guide therapeutic response, interpretation, or timing.",
		"demoTitle": "Open the sample map",
		"demoPrompt": "Interested in using Transference Pattern Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0512-f-023-pdt-012-r001-transference-pattern-map.md",
		"specId": "0512-f-023-pdt-012-r001-transference-pattern-map",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning",
				"Session preparation"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Connects",
				"body": "The map connects observed in-session relational expectations or reactions to broader recurring interpersonal patterns and a current practitioner-authored formulation."
			},
			{
				"title": "How History Helps",
				"body": "Prior formulation states and update markers help the practitioner see how the formulation changed as new therapeutic-relationship material emerged."
			},
			{
				"title": "Important Boundary",
				"body": "The system shows links and chronology. It does not infer transference meaning or produce clinical conclusions independently."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client questionnaire?",
				"answer": "No. The Transference Pattern Map is a practitioner-only formulation aid."
			},
			{
				"question": "Can observations remain tentative?",
				"answer": "Yes. Observations can remain unlinked until the practitioner has enough clinical basis."
			},
			{
				"question": "Does the tool interpret transference automatically?",
				"answer": "No. The practitioner writes and revises the formulation; the system organizes links and update history."
			}
		]
	},
	{
		"toolType": "defenseMechanismsRatingScalesDmrs",
		"slug": "defense-mechanisms-rating-scales-dmrs",
		"title": "DMRS Observer Rating Demo for Defensive Functioning | Qwoach",
		"metaDescription": "Explore a trained-observer DMRS demo for coding defenses from clinical material and reviewing defensive-functioning profiles.",
		"h1": "Defense Mechanisms Rating Scales",
		"intro": "Defense Mechanisms Rating Scales is a trained-observer defense coding and rating system for psychodynamic clinicians, supervisors, researchers, and trained raters. It helps the rater identify defense instances in clinical material and summarize individual defenses, defense levels, and Overall Defensive Functioning when supported scoring rules are supplied.",
		"demoTitle": "Try sample coding",
		"demoPrompt": "Interested in using Defense Mechanisms Rating Scales (DMRS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0513-f-023-pdt-013-r001-defense-mechanisms-rating-scales-dmrs.md",
		"specId": "0513-f-023-pdt-013-r001-defense-mechanisms-rating-scales-dmrs",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Defense mechanisms"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Who Uses It",
				"body": "The supported users are trained observers such as psychodynamic clinicians, supervisors, researchers, and raters working from clinical material."
			},
			{
				"title": "What The Result Contains",
				"body": "The result can include individual defense scores, defense-level summaries, Overall Defensive Functioning, and qualitative examples when the necessary taxonomy and scoring rules are supplied."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not generate defense codes automatically or replace rater judgment."
			}
		],
		"faqItems": [
			{
				"question": "Does the patient complete the DMRS?",
				"answer": "No. DMRS is supported here as a trained-observer rating from clinical material."
			},
			{
				"question": "Can the demo produce final DMRS scores?",
				"answer": "Only if supplied scoring rules are available. Otherwise the demo should show the profile structure and unresolved scoring state without inventing formulas."
			},
			{
				"question": "Can ratings be compared over time?",
				"answer": "Yes. Repeated ratings can be compared when comparable source material and the same scoring structure are used."
			}
		]
	},
	{
		"toolType": "defenseMechanismsRatingScalesQSortVersionDmrsQ",
		"slug": "defense-mechanisms-rating-scales-q-sort-version-dmrs-q",
		"title": "DMRS-Q Clinician Q-sort Demo | Qwoach",
		"metaDescription": "Explore a DMRS-Q demo for clinician-rated forced Q-sort assessment of defensive functioning from sufficient clinical information.",
		"h1": "Defense Mechanisms Rating Scales Q-sort version",
		"intro": "DMRS-Q is a computerized clinician-report Q-sort for clinicians, practitioners, researchers, and raters with sufficient patient information. It helps the rater sort 150 defense-related items into a forced distribution so the completed sort can produce a Defensive Profile Narrative, Overall Defensive Functioning, seven defense-level scores, and 30 individual defense scores when the instrument rules are supplied.",
		"demoTitle": "Try the Q-sort demo",
		"demoPrompt": "Interested in using Defense Mechanisms Rating Scales Q-sort version (DMRS-Q) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0514-f-023-pdt-013-r002-defense-mechanisms-rating-scales-q-sort-version-dmrs-q.md",
		"specId": "0514-f-023-pdt-013-r002-defense-mechanisms-rating-scales-q-sort-version-dmrs-q",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Defense mechanisms"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What The Q-sort Does",
				"body": "The forced distribution requires the rater to prioritize standardized defense-related items rather than simply checking all applicable items."
			},
			{
				"title": "When Results Are Available",
				"body": "A final profile is available only after the distribution is valid and the needed scoring and narrative rules are supplied."
			},
			{
				"title": "Repeat Use",
				"body": "Completed ratings can be repeated at later time points and compared when the same DMRS-Q structure is used."
			}
		],
		"faqItems": [
			{
				"question": "Is DMRS-Q a patient self-report questionnaire?",
				"answer": "No. DMRS-Q is supported here as a clinician-report Q-sort based on sufficient clinical information."
			},
			{
				"question": "Can I generate a profile from an incomplete sort?",
				"answer": "No. Incomplete sorts show progress, but a final defensive profile should not be generated until the forced distribution is valid."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The DMRS-Q tool and supported reusable setup are saved; sample item placements and fictional patient data are not saved as real records."
			}
		]
	},
	{
		"toolType": "opdConflictQuestionnaireOpdCq",
		"slug": "opd-conflict-questionnaire-opd-cq",
		"title": "OPD-CQ Conflict Coping Questionnaire Demo | Qwoach",
		"metaDescription": "Explore an OPD-CQ demo for client-completed conflict coping assessment and practitioner review within OPD-informed formulation.",
		"h1": "OPD Conflict Questionnaire",
		"intro": "The OPD Conflict Questionnaire is a client-completed OPD-based self-report questionnaire for psychodynamic practitioners and researchers using an OPD framework. It helps the practitioner review active and passive coping modes across six OPD conflicts, including defended perception of conflict and emotions, when the 66-item instrument and scoring rules are supplied.",
		"demoTitle": "Preview the questionnaire flow",
		"demoPrompt": "Interested in using OPD Conflict Questionnaire (OPD-CQ) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0515-f-023-pdt-013-r003-opd-conflict-questionnaire-opd-cq.md",
		"specId": "0515-f-023-pdt-013-r003-opd-conflict-questionnaire-opd-cq",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Client Roles",
				"body": "The practitioner initiates and reviews OPD-CQ. The client completes the questionnaire responses, which become input for practitioner formulation."
			},
			{
				"title": "What It Captures",
				"body": "The questionnaire captures responses about coping with unconscious conflicts, emotional experience, and defended conflict perception within the supported OPD-CQ structure."
			},
			{
				"title": "Result Boundary",
				"body": "The tool produces a profile for review; it does not generate an automatic psychodynamic diagnosis or treatment recommendation."
			}
		],
		"faqItems": [
			{
				"question": "Does OPD-CQ diagnose the client automatically?",
				"answer": "No. OPD-CQ produces structured conflict-coping information for practitioner review within OPD-informed formulation."
			},
			{
				"question": "Can a partial questionnaire produce a final profile?",
				"answer": "No. Partial completion should show progress only and should not generate final scoring."
			},
			{
				"question": "Who completes OPD-CQ?",
				"answer": "The client completes the questionnaire; the practitioner assigns, reviews, and interprets the resulting profile."
			}
		]
	},
	{
		"toolType": "coreConflictualRelationshipThemeMethodCcrt",
		"slug": "core-conflictual-relationship-theme-method-ccrt",
		"title": "CCRT Method Demo for Brief Psychodynamic Focus | Qwoach",
		"metaDescription": "Explore a CCRT demo for organizing relationship narratives into a concise practitioner-authored dynamic treatment focus.",
		"h1": "Core Conflictual Relationship Theme Method",
		"intro": "The Core Conflictual Relationship Theme Method is a psychodynamic relationship-theme formulation and treatment-focus method for practitioners conducting brief psychodynamic or supportive-expressive therapy. It helps the practitioner gather relationship narratives, organize wishes and responses, and write a concise CCRT focus that therapist and client can use across treatment.",
		"demoTitle": "Draft a sample focus",
		"demoPrompt": "Interested in using Core Conflictual Relationship Theme Method (CCRT) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0516-f-023-pdt-014-r001-core-conflictual-relationship-theme-method-ccrt.md",
		"specId": "0516-f-023-pdt-014-r001-core-conflictual-relationship-theme-method-ccrt",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Shared Treatment Focus",
				"body": "The tool supports a practitioner-authored focus that can be shared with the client when the practitioner decides it is clinically ready."
			},
			{
				"title": "Evidence Stays Visible",
				"body": "Relationship narratives and W-RO-RS organization remain visible beside the focus so the practitioner can see what the formulation is grounded in."
			},
			{
				"title": "Important Boundary",
				"body": "The system does not infer the CCRT focus. The formulation is authored and revised by the practitioner."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write the CCRT focus automatically?",
				"answer": "No. The practitioner writes and revises the CCRT focus; the system organizes supporting material."
			},
			{
				"question": "Can the client see the formulation?",
				"answer": "Yes, when the practitioner chooses to share a client-facing focus statement."
			},
			{
				"question": "What happens if there are too few narratives?",
				"answer": "The focus remains draft or tentative until enough narrative support is available."
			}
		]
	},
	{
		"toolType": "operationalizedPsychodynamicDiagnosisOpd2Opd3",
		"slug": "operationalized-psychodynamic-diagnosis-opd-2-opd-3",
		"title": "OPD-2/OPD-3 Assessment Demo | Qwoach",
		"metaDescription": "Explore an OPD-2/OPD-3 demo for clinician-rated psychodynamic assessment, multiaxial formulation, and treatment focus selection.",
		"h1": "Operationalized Psychodynamic Diagnosis OPD-2/OPD-3",
		"intro": "Operationalized Psychodynamic Diagnosis OPD-2/OPD-3 is a clinician-rated multiaxial psychodynamic diagnostic, formulation, and treatment-planning system for psychodynamically oriented clinicians and researchers. It helps the practitioner organize interview findings, rate OPD domains, select therapeutic foci, and document treatment-planning implications.",
		"demoTitle": "Explore the OPD assessment",
		"demoPrompt": "Interested in using Operationalized Psychodynamic Diagnosis (OPD-2/OPD-3) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0517-f-023-pdt-014-r002-operationalized-psychodynamic-diagnosis-opd-2-opd-3.md",
		"specId": "0517-f-023-pdt-014-r002-operationalized-psychodynamic-diagnosis-opd-2-opd-3",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Assessment Scope",
				"body": "The tool supports multiaxial psychodynamic assessment across OPD domains where clinically relevant, with focus selection and treatment-planning notes."
			},
			{
				"title": "Version Awareness",
				"body": "When OPD-2 and OPD-3 are both supported, version choice must remain visible because it affects structure, results, and comparability."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not generate automated psychodynamic diagnoses or treatment strategies. Practitioner interpretation remains explicit."
			}
		],
		"faqItems": [
			{
				"question": "Is OPD-2/OPD-3 a client questionnaire?",
				"answer": "No. The supported product is a clinician-rated assessment based on a clinician-led psychodynamic interview."
			},
			{
				"question": "Can the tool select treatment foci automatically?",
				"answer": "No. The practitioner selects treatment foci; the system organizes the assessment and focus-selection workspace."
			},
			{
				"question": "What happens if an assessment is incomplete?",
				"answer": "Incomplete assessments show unresolved axes or missing focus selection and should not present a complete formulation."
			}
		]
	},
	{
		"toolType": "interpersonalAffectiveFocusIpafInDynamicInterpersonalTherapy",
		"slug": "interpersonal-affective-focus-ipaf-in-dynamic-interpersonal-therapy",
		"title": "IPAF Demo for Dynamic Interpersonal Therapy | Qwoach",
		"metaDescription": "Explore an IPAF demo for drafting and sharing a concise interpersonal-affective focus in Dynamic Interpersonal Therapy.",
		"h1": "Interpersonal-Affective Focus in Dynamic Interpersonal Therapy",
		"intro": "The Interpersonal-Affective Focus tool is a DIT-specific psychodynamic case-formulation focus for practitioners using Dynamic Interpersonal Therapy. It helps the practitioner link symptoms or presenting difficulties to a recurring interpersonal pattern and affective response, then prepare concise wording that can be shared in treatment conversation.",
		"demoTitle": "Build a sample IPAF",
		"demoPrompt": "Interested in using Interpersonal-Affective Focus (IPAF) in Dynamic Interpersonal Therapy with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0518-f-023-pdt-014-r003-interpersonal-affective-focus-ipaf-in-dynamic-interpersonal-therapy.md",
		"specId": "0518-f-023-pdt-014-r003-interpersonal-affective-focus-ipaf-in-dynamic-interpersonal-therapy",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Two Linked Components",
				"body": "The IPAF formulation keeps the interpersonal pattern and affective response visible as separate but connected parts of the treatment focus."
			},
			{
				"title": "Shared Language",
				"body": "The tool supports wording that can be used in treatment conversation when the practitioner is ready to share it."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not add DIT protocol content, scoring, or automated causal interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Is the IPAF completed by the patient alone?",
				"answer": "No. The IPAF is therapist-developed and may be reviewed collaboratively with the patient in treatment conversation."
			},
			{
				"question": "What makes an IPAF incomplete?",
				"answer": "An IPAF is incomplete when the interpersonal component, affective component, or symptom/presenting difficulty link is missing or clinically unclear."
			},
			{
				"question": "Can multiple candidate focuses be drafted?",
				"answer": "Yes. Multiple candidates can be held during drafting, then one central IPAF can be selected when ready."
			}
		]
	},
	{
		"toolType": "psychodiagnosticChart2PsychodiagnosticChart3Pdc2Pdc3",
		"slug": "psychodiagnostic-chart-2-psychodiagnostic-chart-3-pdc-2-pdc-3",
		"title": "PDC-2/PDC-3 Progress Chart Demo | Qwoach",
		"metaDescription": "Explore a PDC-2/PDC-3 demo for clinician-rated PDM-oriented profiles and repeated psychodynamic progress comparison.",
		"h1": "Psychodiagnostic Chart-2 / Psychodiagnostic Chart-3",
		"intro": "Psychodiagnostic Chart-2 / Psychodiagnostic Chart-3 is a clinician-rated PDM-oriented psychodynamic profile and progress chart for psychodynamic clinicians, supervisors, and researchers. It helps the practitioner rate domains such as personality organization, personality patterns or disorders, mental functioning, symptoms, and contextual factors, then compare current ratings with earlier ratings over treatment.",
		"demoTitle": "Review a sample comparison",
		"demoPrompt": "Interested in using Psychodiagnostic Chart-2 / Psychodiagnostic Chart-3 (PDC-2/PDC-3) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0519-f-023-pdt-015-r001-psychodiagnostic-chart-2-psychodiagnostic-chart-3-pdc-2-pdc-3.md",
		"specId": "0519-f-023-pdt-015-r001-psychodiagnostic-chart-2-psychodiagnostic-chart-3-pdc-2-pdc-3",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for treatment review, progress reporting, outcome assessment, or follow-up formulation when structured PDM-oriented comparison is useful."
			},
			{
				"title": "Comparison Behavior",
				"body": "Change indicators require comparable domains and visible version history. If there is no prior rating, the tool produces a current profile rather than a change result."
			},
			{
				"title": "Important Boundary",
				"body": "The system compares clinician-entered ratings; clinical meaning and treatment revisions remain practitioner interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Can PDC-2/PDC-3 show progress over time?",
				"answer": "Yes. Repeated clinician ratings can show change or stability when comparable domains and versions are used."
			},
			{
				"question": "What if there is no prior PDC rating?",
				"answer": "The tool shows a current profile, not a before/after change result."
			},
			{
				"question": "Does the client complete the PDC chart?",
				"answer": "No. PDC-2/PDC-3 is supported here as a clinician-rated form."
			}
		]
	},
	{
		"toolType": "operationalizedPsychodynamicDiagnosisOpd2",
		"slug": "operationalized-psychodynamic-diagnosis-opd-2",
		"title": "OPD-2 Change Measurement Demo | Qwoach",
		"metaDescription": "Explore an OPD-2 demo for clinician-rated psychodynamic diagnosis, treatment focus selection, strategy notes, and change review.",
		"h1": "Operationalized Psychodynamic Diagnosis OPD-2",
		"intro": "Operationalized Psychodynamic Diagnosis OPD-2 is a clinician-rated multiaxial psychodynamic diagnosis, treatment-focus, and change-measurement system for psychodynamically oriented clinicians and researchers. It helps the practitioner document OPD-2 ratings, identify treatment foci, enter strategy implications, and compare compatible ratings across treatment points.",
		"demoTitle": "Explore OPD-2 review",
		"demoPrompt": "Interested in using Operationalized Psychodynamic Diagnosis OPD-2 with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0520-f-023-pdt-015-r002-operationalized-psychodynamic-diagnosis-opd-2.md",
		"specId": "0520-f-023-pdt-015-r002-operationalized-psychodynamic-diagnosis-opd-2",
		"tags": {
			"framework": [
				"Psychodynamic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Assessment Time Points",
				"body": "The tool supports intake, treatment planning, treatment review, discharge, and follow-up contexts through assessment time-point state."
			},
			{
				"title": "Change Review",
				"body": "Change information appears only when there is a compatible prior OPD-2 rating. Without a baseline, the result is a current profile and focus plan."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not generate automated OPD ratings or treatment strategy. Those remain clinician-entered clinical work."
			}
		],
		"faqItems": [
			{
				"question": "Can OPD-2 be used for change measurement?",
				"answer": "Yes. OPD-2 repeated ratings can show change when compatible ratings are available across treatment points."
			},
			{
				"question": "What if there is no baseline assessment?",
				"answer": "The tool shows diagnostic and focus-planning information without making change claims."
			},
			{
				"question": "Does OPD-2 include direct client completion in this product?",
				"answer": "No. The supported configuration is clinician-led interview and clinician-rated assessment."
			}
		]
	},
	{
		"toolType": "gottmanRelationshipCheckup",
		"slug": "gottman-relationship-checkup",
		"title": "Gottman Relationship Checkup Demo for Clinicians | Qwoach",
		"metaDescription": "Explore a couples assessment that both partners complete to produce scored clinician reports, concern areas, and treatment-planning targets.",
		"h1": "Gottman Relationship Checkup for Couples Treatment Planning",
		"intro": "The Gottman Relationship Checkup is a couples-therapy relationship assessment for clinicians. Both partners complete the assessment so the clinician can review scored reports, relationship strengths, concern areas, and recommended treatment targets for treatment planning.",
		"demoTitle": "Explore the sample couple assessment",
		"demoPrompt": "Interested in using Gottman Relationship Checkup with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0521-f-024-got-001-r001-gottman-relationship-checkup.md",
		"specId": "0521-f-024-got-001-r001-gottman-relationship-checkup",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Outcome monitoring"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at intake or during a treatment-plan update when both partners' relationship information needs to be organized into a scored clinician report."
			},
			{
				"title": "What It Shows",
				"body": "The review experience shows completion status, scored report information, strengths, concern areas, recommended treatment targets, and comparison with prior administrations where available."
			},
			{
				"title": "Important Limits",
				"body": "The demo does not define exact assessment items, scoring rules, scale meanings, thresholds, recommendation logic, or whether partners see the clinician report."
			}
		],
		"faqItems": [
			{
				"question": "Is this a questionnaire builder?",
				"answer": "No. It is represented as the Gottman Relationship Checkup, a ready-to-send structured couples assessment with automatic scoring and clinician-facing reports."
			},
			{
				"question": "Do both partners complete it?",
				"answer": "Yes. Both partners provide assessment responses, and the couple-level formulation depends on the represented scoring requirements."
			},
			{
				"question": "What happens if only one partner completes the assessment?",
				"answer": "The clinician can see partner-level completion, but the couple-level scored formulation remains incomplete unless the represented checkup supports partial scoring."
			},
			{
				"question": "Can I change the scoring or assessment content?",
				"answer": "No. The supplied specification does not support changing item content, scoring rules, domains, thresholds, or recommendation logic."
			}
		]
	},
	{
		"toolType": "soundRelationshipHouse",
		"slug": "sound-relationship-house",
		"title": "Sound Relationship House Demo for Couples Therapists | Qwoach",
		"metaDescription": "Explore a couples-therapy domain map that organizes assessment findings into strengths, vulnerabilities, and intervention priorities.",
		"h1": "Sound Relationship House Relationship-Domain Map",
		"intro": "Sound Relationship House is a couples-therapy formulation map for clinicians. It helps practitioners place relationship assessment findings into a structured domain view so strengths, vulnerabilities, and intervention needs are easier to review.",
		"demoTitle": "Explore the sample map",
		"demoPrompt": "Interested in using Sound Relationship House with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0522-f-024-got-002-r001-sound-relationship-house.md",
		"specId": "0522-f-024-got-002-r001-sound-relationship-house",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after assessment findings are available and the clinician needs to organize the couple's strengths, vulnerabilities, and intervention needs into one visual case picture."
			},
			{
				"title": "What It Captures",
				"body": "The artifact can preserve mapped findings, source context, clinician notes, and dated map states for later review."
			},
			{
				"title": "Important Limits",
				"body": "The demo does not supply exact domain labels, diagram structure, scoring, ratings, or treatment prescriptions beyond the represented map behavior."
			}
		],
		"faqItems": [
			{
				"question": "Is Sound Relationship House a standalone assessment?",
				"answer": "No. It is represented as a domain-map formulation aid used with assessment findings."
			},
			{
				"question": "Do clients complete this tool directly?",
				"answer": "No separate client completion workflow is required by the supplied specification."
			},
			{
				"question": "Can I change the map structure?",
				"answer": "No. The represented domain structure is fixed; exact labels and structure require validation before implementation."
			}
		]
	},
	{
		"toolType": "loveMapCardDeck",
		"slug": "love-map-card-deck",
		"title": "Love Map Card Deck Demo for Couples Therapists | Qwoach",
		"metaDescription": "Explore a couples prompt deck that helps clinicians observe partner knowledge, updates, gaps, and connection-building areas.",
		"h1": "Love Map Card Deck for Partner Knowledge and Attunement",
		"intro": "The Love Map Card Deck is a couples-therapy discussion prompt deck for clinicians. Partners use card prompts so the practitioner can observe current knowledge, gaps, corrections, curiosity, and areas for connection-building.",
		"demoTitle": "Try the sample card session",
		"demoPrompt": "Interested in using Love Map Card Deck with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0523-f-024-got-003-r001-love-map-card-deck.md",
		"specId": "0523-f-024-got-003-r001-love-map-card-deck",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the clinician wants to observe how current and specific each partner's knowledge is, especially when emotional connection or friendship needs attention."
			},
			{
				"title": "What It Captures",
				"body": "The deck session can capture responses, guesses, corrections, updated details, participation status, and clinician observations."
			},
			{
				"title": "Important Limits",
				"body": "The output is descriptive. It does not score compatibility, diagnose the relationship, or infer emotional quality beyond captured responses and observations."
			}
		],
		"faqItems": [
			{
				"question": "Is this a scored quiz?",
				"answer": "No. It is a descriptive prompt-card exercise, not a scored compatibility or relationship-health test."
			},
			{
				"question": "Can partners use it outside session?",
				"answer": "Yes, the specification supports ready-to-send use where assigned completion is used, with pause and resume behavior."
			},
			{
				"question": "Does the demo include the actual card prompts?",
				"answer": "No. Exact card prompts and categories are unresolved, so the public demo uses placeholder prompts to show the interaction without redefining the deck."
			}
		]
	},
	{
		"toolType": "openEndedQuestionsCardDeck",
		"slug": "open-ended-questions-card-deck",
		"title": "Open-Ended Questions Card Deck Demo for Clinicians | Qwoach",
		"metaDescription": "Explore a couples prompt deck that helps clinicians surface meaningful themes, partner perspectives, and next areas for exploration.",
		"h1": "Open-Ended Questions Card Deck for Couples Therapy",
		"intro": "The Open-Ended Questions Card Deck is a couples-therapy discussion prompt deck for clinicians. It helps practitioners invite partner perspectives and surface emotionally meaningful themes that can guide deeper exploration or intervention.",
		"demoTitle": "Start the sample prompt deck",
		"demoPrompt": "Interested in using Open-Ended Questions Card Deck with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0524-f-024-got-004-r001-open-ended-questions-card-deck.md",
		"specId": "0524-f-024-got-004-r001-open-ended-questions-card-deck",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the clinician needs a simple way to invite new personal perspectives or uncover themes that were not already explicit."
			},
			{
				"title": "What It Captures",
				"body": "The session artifact can capture prompts used, partner contributions, skipped prompts, emergent themes, and clinician notes."
			},
			{
				"title": "Important Limits",
				"body": "The deck does not score relationship quality, judge response depth, or create automated therapeutic interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Is this an assessment?",
				"answer": "No. It is represented as an open-ended discussion prompt deck, not an assessment or scored measure."
			},
			{
				"question": "Can the clinician skip or stop cards?",
				"answer": "Yes. The practitioner experience supports advancing, skipping, or stopping when enough clinically useful material has emerged."
			},
			{
				"question": "Does the public demo provide the real question text?",
				"answer": "No. Exact deck questions are unresolved, so the demo uses placeholders to show the product flow."
			}
		]
	},
	{
		"toolType": "ritualsOfConnectionCardDeck",
		"slug": "rituals-of-connection-card-deck",
		"title": "Rituals of Connection Card Deck Demo for Clinicians | Qwoach",
		"metaDescription": "Explore a couples deck that helps clinicians guide partners to select realistic connection rituals and save a revisitible plan.",
		"h1": "Rituals of Connection Card Deck for Couples Therapy",
		"intro": "The Rituals of Connection Card Deck is a couples-therapy connection-routine planning deck for clinicians. It helps practitioners guide partners from card discussion to selected shared rituals, partner agreement, and a reviewable plan for later sessions.",
		"demoTitle": "Build a sample ritual plan",
		"demoPrompt": "Interested in using Rituals of Connection Card Deck with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0525-f-024-got-005-r001-rituals-of-connection-card-deck.md",
		"specId": "0525-f-024-got-005-r001-rituals-of-connection-card-deck",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior change"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the therapy focus includes strengthening everyday connection through realistic shared routines."
			},
			{
				"title": "What It Captures",
				"body": "The plan can capture selected rituals, agreement status, connection purpose, plan specificity, and clinician notes for later review."
			},
			{
				"title": "Important Limits",
				"body": "The tool is not a habit tracker or calendar scheduler, and it does not score adherence or promise relationship improvement."
			}
		],
		"faqItems": [
			{
				"question": "What is saved from a completed ritual plan?",
				"answer": "In real use, selected rituals, plan details, agreement status, and review history can persist. In the public demo, fictional sample plan data is not saved as real client data."
			},
			{
				"question": "Can partners disagree about a ritual?",
				"answer": "Yes. If partners disagree, the tool preserves each partner's position and does not present the ritual as agreed."
			},
			{
				"question": "Does the tool track chores or tasks?",
				"answer": "No. It centers connection rituals rather than generic chores, task completion, or productivity tracking."
			}
		]
	},
	{
		"toolType": "salsaCardDecks",
		"slug": "salsa-card-decks",
		"title": "Salsa Card Decks Demo for Couples Therapists | Qwoach",
		"metaDescription": "Explore consent-centered couples decks for reviewing intimacy preferences, boundaries, comfort, mismatch, and shared interest.",
		"h1": "Salsa Card Decks for Intimacy Preference and Boundary Exploration",
		"intro": "Salsa Card Decks are couples-therapy intimacy preference and boundary exploration decks for clinicians. They help practitioners review partner comfort, discomfort, uncertainty, shared interest, mismatch, and boundaries when intimate connection is part of treatment.",
		"demoTitle": "Explore the sample intimacy profile",
		"demoPrompt": "Interested in using Salsa Card Decks with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0526-f-024-got-006-r001-salsa-card-decks.md",
		"specId": "0526-f-024-got-006-r001-salsa-card-decks",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it only when sexual or intimate connection is part of treatment and the clinician needs respectful clarification of preferences and boundaries."
			},
			{
				"title": "What It Captures",
				"body": "The artifact can capture partner-specific responses, boundaries, shared interest, mismatch, uncertainty, skips, pause states, and clinician notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not prescribe sexual activity, score desire, judge either partner, diagnose pathology, or pressure agreement."
			}
		],
		"faqItems": [
			{
				"question": "Is partner agreement required?",
				"answer": "No. Each partner can express comfort, discomfort, uncertainty, preferences, and boundaries without being required to agree."
			},
			{
				"question": "What happens if one partner skips or declines?",
				"answer": "The skipped or declined response is preserved descriptively, and couple-level overlap is not inferred when there is insufficient partner input."
			},
			{
				"question": "Are the three Salsa deck options fully defined in the demo?",
				"answer": "No. The specification identifies three Salsa decks, but exact titles, prompts, categories, and response options require validation."
			}
		]
	},
	{
		"toolType": "repairChecklist",
		"slug": "repair-checklist",
		"title": "Repair Checklist Demo for Couples Therapists | Qwoach",
		"metaDescription": "Explore a couples checklist that helps clinicians compare preferred and disliked repair attempts and identify agreed conflict repairs.",
		"h1": "Repair Checklist for Couples Conflict Repair Strategies",
		"intro": "Repair Checklist is a couples-therapy conflict repair strategy checklist for clinicians. It helps practitioners compare each partner's preferred and disliked repair attempts, identify overlap or mismatch, and formalize agreed repairs for later conflict review.",
		"demoTitle": "Compare sample repair selections",
		"demoPrompt": "Interested in using Repair Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0527-f-024-got-007-r001-repair-checklist.md",
		"specId": "0527-f-024-got-007-r001-repair-checklist",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Interpersonal relationships",
				"Problem solving"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when conflict repair needs to become specific, recognizable, acceptable to both partners, and reviewable after future conflict episodes."
			},
			{
				"title": "What It Captures",
				"body": "The tool can capture partner-specific selections, disliked attempts, overlap, mismatch, agreed repairs, clarification needs, and review notes."
			},
			{
				"title": "Important Limits",
				"body": "The checklist does not assign blame, score conflict severity, rank partners, or guarantee that a repair will prevent escalation."
			}
		],
		"faqItems": [
			{
				"question": "Does agreement require both partners to accept a repair?",
				"answer": "Yes. The tool should mark a strategy as agreed only when both partners can recognize and accept it."
			},
			{
				"question": "What if only one partner completes the checklist?",
				"answer": "The clinician can review an individual preference profile, but mutual agreement and overlap are not inferred."
			},
			{
				"question": "Are the actual checklist items defined here?",
				"answer": "No. Exact item text and response options are unresolved, so the demo uses placeholders to show the selection and review behavior."
			}
		]
	},
	{
		"toolType": "fourHorsemenAntidotes",
		"slug": "four-horsemen-antidotes",
		"title": "Four Horsemen & Antidotes Demo for Clinicians | Qwoach",
		"metaDescription": "Explore a joint couples-therapy tool for identifying destructive conflict patterns and linking them to healthier responses.",
		"h1": "Four Horsemen & Antidotes Conflict-Pattern Profile",
		"intro": "Four Horsemen & Antidotes is a ready-to-complete-together couples-therapy tool for clinicians. It helps practitioners identify recurring destructive conflict patterns, connect each represented pattern to a healthier response, and create non-blaming coaching targets for session work.",
		"demoTitle": "Build a sample conflict-pattern profile",
		"demoPrompt": "Interested in using Four Horsemen & Antidotes with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0528-f-024-got-008-r001-four-horsemen-antidotes.md",
		"specId": "0528-f-024-got-008-r001-four-horsemen-antidotes",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Skill practice"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior change"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when recurring conflict patterns need to be identified, discussed without blame, and connected to healthier responses for coaching."
			},
			{
				"title": "What It Captures",
				"body": "The profile can capture selected patterns, linked alternatives, examples, recognition differences, clinician notes, and coaching priorities."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not score severity, allocate blame, diagnose either partner, or invent pattern definitions or antidote content."
			}
		],
		"faqItems": [
			{
				"question": "Is this completed by one partner alone?",
				"answer": "No. The represented configuration is ready to complete together with clinician guidance."
			},
			{
				"question": "Does the profile assign blame?",
				"answer": "No. The experience should show both partners' contributions without ranking fault or creating a blame record."
			},
			{
				"question": "Can I edit the antidote links?",
				"answer": "No. The represented pattern-to-antidote links are fixed by the material; exact content requires validation."
			}
		]
	},
	{
		"toolType": "conflictBlueprintExercise",
		"slug": "conflict-blueprint-exercise",
		"title": "Conflict Blueprint Exercise Demo for Couples Therapists | Qwoach",
		"metaDescription": "Explore a joint couples-therapy exercise for observing conflict process breakdowns, pause points, and next coaching needs.",
		"h1": "Conflict Blueprint Exercise for Structured Couples Conflict Work",
		"intro": "Conflict Blueprint Exercise is a ready-to-complete-together couples-therapy exercise for clinicians. It helps practitioners guide a structured conflict conversation, observe breakdown points, and identify capacities or skills that may need coaching next.",
		"demoTitle": "Run the sample conflict sequence",
		"demoPrompt": "Interested in using Conflict Blueprint Exercise with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0529-f-024-got-009-r001-conflict-blueprint-exercise.md",
		"specId": "0529-f-024-got-009-r001-conflict-blueprint-exercise",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Problem solving"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a couple needs a structured way to work through a difficult disagreement while the clinician observes where the process becomes hard to sustain."
			},
			{
				"title": "What It Captures",
				"body": "The exercise can capture topic framing, sequence progress, pause or discontinue states, breakdown observations, partner-role observations, and next-focus notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not decide blame, score conflict severity, produce a winner, or invent blueprint steps beyond the represented exercise."
			}
		],
		"faqItems": [
			{
				"question": "Is this a conflict journal?",
				"answer": "No. It is a structured in-session conflict process exercise, not a general journal or debate tool."
			},
			{
				"question": "What happens if the couple escalates during the exercise?",
				"answer": "The clinician can pause or discontinue the exercise and preserve partial observations."
			},
			{
				"question": "Can the demo show the exact Conflict Blueprint steps?",
				"answer": "No. Exact steps and prompts are unresolved, so the demo uses placeholder sequence steps to show behavior without redefining the exercise."
			}
		]
	},
	{
		"toolType": "dreamsWithinConflict",
		"slug": "dreams-within-conflict",
		"title": "Dreams Within Conflict Demo for Couples Therapists | Qwoach",
		"metaDescription": "Explore a joint couples exercise for mapping surface positions to deeper values, meanings, hopes, and vulnerabilities in gridlocked conflict.",
		"h1": "Dreams Within Conflict Meaning Map for Gridlocked Couples Issues",
		"intro": "Dreams Within Conflict is a ready-to-complete-together couples-therapy exercise for clinicians. It helps practitioners separate surface conflict positions from deeper values, meanings, hopes, or vulnerabilities so the couple can move toward empathy-oriented dialogue.",
		"demoTitle": "Explore the sample meaning map",
		"demoPrompt": "Interested in using Dreams Within Conflict with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0530-f-024-got-010-r001-dreams-within-conflict.md",
		"specId": "0530-f-024-got-010-r001-dreams-within-conflict",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Values"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for recurring gridlocked issues where immediate problem solving is premature because the deeper meaning beneath each position is not yet clear."
			},
			{
				"title": "What It Captures",
				"body": "The exercise can capture the issue, each partner's surface position, deeper meaning material, vulnerabilities, completeness state, clinician notes, and later updates."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate compromises, prescribe solutions, infer hidden motives automatically, assign blame, or score the conflict."
			}
		],
		"faqItems": [
			{
				"question": "Is this a problem-solving worksheet?",
				"answer": "No. It is a meaning exploration exercise that supports empathy before immediate problem solving."
			},
			{
				"question": "Does a complete formulation require both partners' deeper material?",
				"answer": "Yes. The specification requires both partners' deeper material for a complete formulation."
			},
			{
				"question": "What happens if only surface positions are captured?",
				"answer": "The exercise is marked incomplete for deeper formulation until underlying meaning material is captured."
			},
			{
				"question": "Are the exact prompts included in the public demo?",
				"answer": "No. Exact prompts and worksheet fields are unresolved, so the demo uses placeholder fields to show the supported flow."
			}
		]
	},
	{
		"toolType": "gottmanRapoportIntervention",
		"slug": "gottman-rapoport-intervention",
		"title": "Gottman-Rapoport Intervention Demo for Couples Therapists | Qwoach",
		"metaDescription": "Explore a live-session couples dialogue tool for capturing each partner's perspective and practitioner-observed barriers to understanding.",
		"h1": "Gottman-Rapoport Intervention for Live Couples Dialogue",
		"intro": "Gottman-Rapoport Intervention is a live-session couples-therapy dialogue tool for practitioners. It helps therapists structure a two-partner disagreement conversation, capture each partner's perspective, and record observed barriers to understanding such as defensiveness, invalidation, or misunderstanding.",
		"demoTitle": "Open the live dialogue demo",
		"demoPrompt": "Interested in using Gottman-Rapoport Intervention with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0531-f-024-got-011-r001-gottman-rapoport-intervention.md",
		"specId": "0531-f-024-got-011-r001-gottman-rapoport-intervention",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Live Session Use",
				"body": "This tool is designed for practitioner-controlled use during a couples session. It is not a standalone client questionnaire."
			},
			{
				"title": "Partial States",
				"body": "If one partner cannot participate or the conversation needs to pause, the result remains partial and shows which perspective or listening opportunity is missing."
			},
			{
				"title": "Result Boundaries",
				"body": "The review stays descriptive. It does not decide who is right, assign blame, diagnose the relationship, or score the conflict."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score the couple's conflict?",
				"answer": "No. The tool organizes perspectives and practitioner observations but does not produce conflict scores, blame assignments, or diagnostic conclusions."
			},
			{
				"question": "Can partners use it on their own?",
				"answer": "The primary experience is live and practitioner-facilitated. A minimal shared view can support in-session participation, but the practitioner controls the intervention state."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool itself and intentional setup are saved. Fictional demo dialogue, sample observations, and temporary case content are not saved as real client data by default."
			},
			{
				"question": "What happens if only one partner contributes?",
				"answer": "The result is marked partial and shows which perspective or listening opportunity is incomplete."
			}
		]
	},
	{
		"toolType": "artOfCompromise",
		"slug": "art-of-compromise",
		"title": "Art of Compromise Demo for Couples Therapists | Qwoach",
		"metaDescription": "Explore a couples compromise-mapping tool that separates each partner's core needs from flexible areas for realistic agreement discussion.",
		"h1": "Art of Compromise for Couples Therapy",
		"intro": "Art of Compromise is a couples-therapy compromise-mapping tool for practitioners. It helps therapists organize one disagreement by separating each partner's core needs from negotiable preferences so compromise discussion can stay balanced and realistic.",
		"demoTitle": "Open the compromise map demo",
		"demoPrompt": "Interested in using Art of Compromise with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0532-f-024-got-012-r001-art-of-compromise.md",
		"specId": "0532-f-024-got-012-r001-art-of-compromise",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning",
				"Problem solving"
			],
			"topic": [
				"Interpersonal relationships",
				"Problem solving"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when one disagreement needs to be clarified before compromise discussion, especially when needs and preferences are being mixed together."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures partner-specific core needs and flexible areas. It can also hold practitioner notes for review."
			},
			{
				"title": "Limitations",
				"body": "The tool does not draft agreements, rate fairness, rank values, or decide whether a compromise is healthy."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend the compromise?",
				"answer": "No. It organizes entered needs and flexible areas so the practitioner can guide discussion."
			},
			{
				"question": "Can both partners complete it together?",
				"answer": "Yes. The client view supports completion together around one disagreement, with both partners represented separately."
			},
			{
				"question": "What happens if a partner has no flexible areas yet?",
				"answer": "The map remains valid and shows that no flexible area has been identified for that partner."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool itself and intentional setup are saved. Fictional needs, preferences, and sample notes are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "aftermathOfAFight",
		"slug": "aftermath-of-a-fight",
		"title": "Aftermath of a Fight Demo for Couples Therapists | Qwoach",
		"metaDescription": "Explore a structured post-conflict tool for couples therapists to organize fight sequence, emotional impact, contributions, and repair commitments.",
		"h1": "Aftermath of a Fight for Couples Therapy",
		"intro": "Aftermath of a Fight is a structured couples-therapy post-conflict analysis and repair tool for practitioners. It helps therapists guide partners through one fight, organize what happened, capture emotional impact and bounded contributions, and record concrete repair commitments.",
		"demoTitle": "Open the aftermath demo",
		"demoPrompt": "Interested in using Aftermath of a Fight with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0533-f-024-got-013-r001-aftermath-of-a-fight.md",
		"specId": "0533-f-024-got-013-r001-aftermath-of-a-fight",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Problem solving"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "One Fight at a Time",
				"body": "Each instance is for one fight or rupture so chronology, emotional impact, and repair commitments stay clear."
			},
			{
				"title": "Repair-Oriented Review",
				"body": "The practitioner controls completion because the result should support repair rather than simply fill all fields."
			},
			{
				"title": "Partial Completion",
				"body": "If the discussion escalates or a section is incomplete, the practitioner can pause and save a partial state."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide who caused the fight?",
				"answer": "No. It records sequence, impact, bounded contributions, and repair commitments without assigning global blame."
			},
			{
				"question": "Can partners complete it together?",
				"answer": "Yes. The tool supports a shared worksheet experience, with practitioner review and completion control."
			},
			{
				"question": "What if repair commitments are vague?",
				"answer": "The result can be marked as needing refinement rather than treating vague commitments as complete."
			},
			{
				"question": "What is saved after public exploration?",
				"answer": "The tool itself and intentional setup are saved. Fictional fight details, sample entries, and temporary demo notes are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "fondnessAdmirationExercises",
		"slug": "fondness-admiration-exercises",
		"title": "Fondness & Admiration Exercises Demo | Qwoach",
		"metaDescription": "Explore a couples connection exercise for collecting specific appreciations, positive memories, and admired qualities for practitioner review.",
		"h1": "Fondness & Admiration Exercises for Couples Therapy",
		"intro": "Fondness & Admiration Exercises is a couples-therapy connection exercise set for practitioners. It helps therapists invite partners to record specific appreciations, positive memories, and admired qualities so the material can be reviewed for connection-focused treatment goals.",
		"demoTitle": "Open the exercise demo",
		"demoPrompt": "Interested in using Fondness & Admiration Exercises with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0534-f-024-got-014-r001-fondness-admiration-exercises.md",
		"specId": "0534-f-024-got-014-r001-fondness-admiration-exercises",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures partner-supplied appreciations, positive memories, and admired qualities. It does not generate positive content for the couple."
			},
			{
				"title": "Practitioner Review",
				"body": "The practitioner reviews whether entries are specific and emotionally credible for the couple's current state."
			},
			{
				"title": "History",
				"body": "Saved real entries can be revisited later as descriptive material for connection-focused work, without longitudinal scoring."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate appreciations for clients?",
				"answer": "No. Positive content is supplied by partners and organized for practitioner review."
			},
			{
				"question": "Does it measure relationship quality?",
				"answer": "No. It does not produce relationship-strength scores, satisfaction ratings, or automated positivity analysis."
			},
			{
				"question": "Can the exercise be sent outside session?",
				"answer": "Yes. The usage mode supports sending it, and partners can provide entries for later practitioner review."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself is saved. Fictional appreciations, memories, admired qualities, and temporary notes are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "smallThingsOften",
		"slug": "small-things-often",
		"title": "Small Things Often Demo for Couples Therapists | Qwoach",
		"metaDescription": "Explore a couples therapy behavior tracking tool for assigning small positive relationship behaviors and reviewing repeated logs over time.",
		"h1": "Small Things Often Behavior Tracking for Couples Therapy",
		"intro": "Small Things Often is a couples-therapy between-session behavior practice and tracking tool for practitioners. It helps therapists assign small, concrete, repeatable positive relationship behaviors and review whether partners are logging a pattern over time.",
		"demoTitle": "Open the behavior tracking demo",
		"demoPrompt": "Interested in using Small Things Often with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0535-f-024-got-015-r001-small-things-often.md",
		"specId": "0535-f-024-got-015-r001-small-things-often",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Configurable Behavior Set",
				"body": "The practitioner-defined behavior set is central because it determines what partners log and what can be compared over time."
			},
			{
				"title": "Pattern Review",
				"body": "The review emphasizes repeated information: occurrences, gaps, and whether the pattern appears increasing, steady, fading, or insufficient to judge."
			},
			{
				"title": "Result Boundaries",
				"body": "The tool does not infer motivation, relationship quality, or therapeutic success from the logs."
			}
		],
		"faqItems": [
			{
				"question": "Can the practitioner define the behaviors?",
				"answer": "Yes. The behavior set is a supported configuration and is saved with the tool setup."
			},
			{
				"question": "Does the tool score relationship warmth?",
				"answer": "No. It tracks logged behavior frequency and gaps but does not score relationship health or warmth."
			},
			{
				"question": "What if no one logs anything?",
				"answer": "The review shows unavailable or non-engagement data without inferring the reason."
			},
			{
				"question": "What carries over after saving?",
				"answer": "The tool itself, behavior set, and review-period configuration carry over. Fictional demo logs do not become real client data."
			}
		]
	},
	{
		"toolType": "howToBeAGreatListener",
		"slug": "how-to-be-a-great-listener",
		"title": "How to Be a Great Listener Demo | Qwoach",
		"metaDescription": "Explore a couples listening-skill guide with practitioner observation notes for behaviors, barriers, and next communication coaching needs.",
		"h1": "How to Be a Great Listener for Couples Therapy",
		"intro": "How to Be a Great Listener is a couples-therapy listening-skill guide for practitioners. It helps therapists send or present a guide, observe partner interaction, record listening behaviors and barriers, and decide what communication coaching may be needed next.",
		"demoTitle": "Open the listening guide demo",
		"demoPrompt": "Interested in using How to Be a Great Listener with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0536-f-024-got-016-r001-how-to-be-a-great-listener.md",
		"specId": "0536-f-024-got-016-r001-how-to-be-a-great-listener",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships",
				"Skills use"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Guide Completion Is Not Skill Mastery",
				"body": "The tool can show whether a guide was sent, viewed, or practiced, but practitioner observation is required for demonstrated listening behavior."
			},
			{
				"title": "Observed Barriers",
				"body": "Barriers such as interrupting, defensiveness, or advice-giving are recorded descriptively and without assigning motive."
			},
			{
				"title": "Unresolved Guide Content",
				"body": "The public demo should use a guide container only and must not invent exact listening steps or source-specific wording."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score listening skill?",
				"answer": "No. It organizes practitioner observations and does not produce automated skill levels or communication scores."
			},
			{
				"question": "Can it be sent to clients?",
				"answer": "Yes. The guide can be sent, but guide completion should not be treated as demonstrated skill."
			},
			{
				"question": "What if no interaction is observed?",
				"answer": "The result can show guide status, but it cannot claim listening behaviors were demonstrated."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself is saved. Fictional practice status, sample observations, and demo notes are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "relaxationSelfSoothingGuide",
		"slug": "relaxation-self-soothing-guide",
		"title": "Relaxation / Self-Soothing Guide Demo | Qwoach",
		"metaDescription": "Explore a couples therapy regulation tool for mapping overwhelm triggers, self-soothing strategies, reported effects, and timeout plan notes.",
		"h1": "Relaxation / Self-Soothing Guide for Couples Therapy",
		"intro": "Relaxation / Self-Soothing Guide is a couples-therapy regulation support tool for practitioners. It helps therapists identify overwhelm triggers, match partner-specific self-soothing strategies, track reported effects on escalation or distress, and connect useful strategies to conflict or timeout agreements.",
		"demoTitle": "Open the self-soothing demo",
		"demoPrompt": "Interested in using Relaxation / Self-Soothing Guide with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0537-f-024-got-017-r001-relaxation-self-soothing-guide.md",
		"specId": "0537-f-024-got-017-r001-relaxation-self-soothing-guide",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Emotion regulation",
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Strategy Fit",
				"body": "The tool tracks when a strategy is used and what effect is reported, because a strategy's usefulness depends on the partner and trigger."
			},
			{
				"title": "Timeout Agreements",
				"body": "Practitioner notes can connect useful strategies to conflict or timeout agreements."
			},
			{
				"title": "Result Boundaries",
				"body": "The tool does not supply relaxation instructions, make safety determinations, or infer clinical conclusions from a log."
			}
		],
		"faqItems": [
			{
				"question": "Can the practitioner choose which strategies to track?",
				"answer": "Yes. Partner-specific strategy sets are supported configuration and are saved with the tool setup."
			},
			{
				"question": "Does the guide include relaxation exercises?",
				"answer": "Not in the supplied specification. Exact relaxation instructions and strategy lists are unresolved and should not be invented in the demo."
			},
			{
				"question": "Can effect be unknown?",
				"answer": "Yes. A strategy can be logged with unknown or unclear effect rather than being treated as helpful."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and configured strategy sets are saved. Fictional triggers, sample effect notes, and temporary demo content are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "gottmanRelationshipBuilder",
		"slug": "gottman-relationship-builder",
		"title": "Gottman Relationship Builder Demo for Clinicians | Qwoach",
		"metaDescription": "Explore a clinician intervention assignment tool for tracking couples' between-session engagement, completion status, and progress over time.",
		"h1": "Gottman Relationship Builder for Clinician-Assigned Relationship Work",
		"intro": "Gottman Relationship Builder is a clinician intervention tool for practitioners who assign relationship-building work outside session. It helps therapists deliver configured interventions, track client engagement and completion over time, and review current progress information before the next meeting.",
		"demoTitle": "Open the progress tracking demo",
		"demoPrompt": "Interested in using Gottman Relationship Builder with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0538-f-024-got-018-r001-gottman-relationship-builder.md",
		"specId": "0538-f-024-got-018-r001-gottman-relationship-builder",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Interpersonal relationships",
				"Outcome monitoring"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Assignment-Driven Workflow",
				"body": "The practitioner-selected intervention drives what clients complete and what progress data can be reviewed."
			},
			{
				"title": "Progress Visibility",
				"body": "The dashboard shows engagement and completion over time, including gaps and insufficient-data states."
			},
			{
				"title": "Unresolved Intervention Content",
				"body": "The public demo should not invent intervention libraries, prompts, progress measures, scoring rules, or improvement cutoffs."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool recommend treatment changes?",
				"answer": "No. It shows assignment and progress information so the practitioner can decide what to reinforce, modify, or address."
			},
			{
				"question": "Can clients see practitioner interpretations?",
				"answer": "Not by default. The client view should show assigned work and completion state, while practitioner interpretations remain in practitioner review unless intentionally shared."
			},
			{
				"question": "What if clients do not engage?",
				"answer": "The dashboard shows non-engagement or insufficient data without inferring the reason."
			},
			{
				"question": "What is saved after exploration?",
				"answer": "The tool itself, selected assignment setup, and supported parameters are saved. Fictional progress and sample client activity are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "negativeInteractionCycleMap",
		"slug": "negative-interaction-cycle-map",
		"title": "Negative Interaction Cycle Map Demo for EFCT | Qwoach",
		"metaDescription": "Explore an EFCT dyadic cycle map for organizing each partner's triggers, protective moves, behaviors, and emotional responses in a shared loop.",
		"h1": "Negative Interaction Cycle Map for EFCT Couples Therapy",
		"intro": "Negative Interaction Cycle Map is an emotionally focused couples therapy formulation tool for practitioners. It helps therapists map each partner's triggers, protective moves, observable behaviors, and emotional or attachment responses into a dyadic loop that externalizes the negative cycle.",
		"demoTitle": "Open the cycle map demo",
		"demoPrompt": "Interested in using Negative Interaction Cycle Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0539-f-025-efct-001-r001-negative-interaction-cycle-map.md",
		"specId": "0539-f-025-efct-001-r001-negative-interaction-cycle-map",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning",
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships",
				"Emotion regulation"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Dyadic Formulation",
				"body": "The tool represents both partners and the loop between them, rather than creating a one-person problem list."
			},
			{
				"title": "Practitioner-Authored Interpretation",
				"body": "Underlying emotion or attachment response is entered or reviewed by the practitioner; the system does not infer it automatically."
			},
			{
				"title": "Version History",
				"body": "When real maps change over time, prior formulations should remain historically distinguishable rather than silently overwritten."
			}
		],
		"faqItems": [
			{
				"question": "Does the map assign blame?",
				"answer": "No. The cycle is framed as the shared problem, and the tool avoids fault rankings or blame assignments."
			},
			{
				"question": "Can clients complete the map without the practitioner?",
				"answer": "The practitioner remains central. Clients may contribute descriptions and view the externalized cycle, but clinical formulation is practitioner-controlled."
			},
			{
				"question": "What if only one partner's position is known?",
				"answer": "The map remains partial and shows the missing partner components or unresolved links."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool itself and intentional partner-label or cycle-focus setup are saved. Fictional cycle content and demo notes are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "aREQuestionnaire",
		"slug": "a-r-e-questionnaire",
		"title": "A.R.E. Questionnaire Demo for EFCT Practitioners | Qwoach",
		"metaDescription": "Explore an EFCT attachment-bond questionnaire flow for partner-specific responses across accessibility, responsiveness, and engagement.",
		"h1": "A.R.E. Questionnaire for EFCT Attachment Bond Review",
		"intro": "A.R.E. Questionnaire is an emotionally focused couples therapy attachment-bond questionnaire for practitioners. It helps therapists assign private partner questionnaires, organize responses across Accessibility, Responsiveness, and Engagement, and review differences in perceived attachment bond.",
		"demoTitle": "Open the questionnaire demo",
		"demoPrompt": "Interested in using A.R.E. Questionnaire with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0540-f-025-efct-002-r001-a-r-e-questionnaire.md",
		"specId": "0540-f-025-efct-002-r001-a-r-e-questionnaire",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Private Partner Completion",
				"body": "Each partner completes their own questionnaire privately. The other partner's responses are not shown during completion."
			},
			{
				"title": "A.R.E. Domains",
				"body": "Review is organized around Accessibility, Responsiveness, and Engagement, preserving the domain structure."
			},
			{
				"title": "Scoring Boundary",
				"body": "Scores, cutoffs, strengths, vulnerabilities, and difference indicators are shown only when the source-defined item mapping and scoring rules are supplied."
			}
		],
		"faqItems": [
			{
				"question": "Can practitioners edit the questionnaire items?",
				"answer": "No. The questionnaire content is fixed by the A.R.E. configuration once supplied and should not be practitioner-configurable."
			},
			{
				"question": "Does the demo include the actual questions?",
				"answer": "No. Exact items and response options are unresolved in the supplied specification, so the public demo should not invent them."
			},
			{
				"question": "Can the result compare partners if only one completes it?",
				"answer": "No. A one-partner result is partial and cannot show dyadic comparison."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The questionnaire tool itself is saved as-is. Fictional responses, placeholder completion states, and sample profiles are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "attachmentInterview",
		"slug": "attachment-interview",
		"title": "Attachment Interview EFCT Formulation Tool | Qwoach",
		"metaDescription": "Explore a practitioner-only Attachment Interview for organizing partner histories, fears, needs, meanings, and targets in EFCT couple formulation.",
		"h1": "Attachment Interview for EFCT Couple Formulation",
		"intro": "Attachment Interview is a practitioner-only EFCT intake and formulation tool for therapists working with couples. It helps the practitioner capture each partner's attachment-relevant history, fears, needs, meanings, and relationship expectations, then connect that material to current relational distress and possible therapeutic targets.",
		"demoTitle": "Explore the sample interview record and review the formulation view.",
		"demoPrompt": "Interested in using Attachment Interview with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0541-f-025-efct-003-r001-attachment-interview.md",
		"specId": "0541-f-025-efct-003-r001-attachment-interview",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The supported product is controlled by the practitioner. Partners may provide information during the interview, but the record and formulation are practitioner-facing by default."
			},
			{
				"title": "Partial And Historical States",
				"body": "The interview can remain incomplete across sessions. Missing partner or formulation areas stay visible instead of being inferred, and historical formulation states can preserve what was used for treatment planning at a given time."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide fixed scores, standardized attachment classifications, symptom ratings, diagnoses, risk assessment content, or unsupported interview prompts."
			}
		],
		"faqItems": [
			{
				"question": "Does Attachment Interview classify a partner's attachment style?",
				"answer": "No. Attachment Interview organizes practitioner-entered attachment-relevant material and formulation links; it does not assign attachment classifications or scores."
			},
			{
				"question": "Can clients complete this tool on their own?",
				"answer": "No. The supported product is practitioner-only, although partners may provide interview information during session."
			},
			{
				"question": "What happens if one partner's information is missing?",
				"answer": "The review shows an asymmetric or incomplete formulation rather than filling the gap automatically."
			},
			{
				"question": "Are exact interview questions included?",
				"answer": "No. Exact interview prompts and worksheet fields are unresolved in the supplied specification, so the demo uses structure and sample placeholders without inventing prompt content."
			}
		]
	},
	{
		"toolType": "eftMapGoalsInterventionsForm",
		"slug": "eft-map-goals-interventions-form",
		"title": "EFT Map Goals Interventions Form Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only EFCT planning form that connects a couple's attachment map, therapy goals, and intervention priorities.",
		"h1": "EFT Map, Goals, and Interventions Treatment Planning Form",
		"intro": "EFT Map / Goals / Interventions Form is a practitioner-only EFCT treatment planning form for therapists working with couples. It helps the practitioner organize the couple's distress cycle and attachment themes, then align therapy goals and intervention priorities with the current treatment direction.",
		"demoTitle": "Open the sample plan and review the map-goals-interventions alignment.",
		"demoPrompt": "Interested in using EFT Map / Goals / Interventions Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0542-f-025-efct-004-r001-eft-map-goals-interventions-form.md",
		"specId": "0542-f-025-efct-004-r001-eft-map-goals-interventions-form",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the form after enough information about the couple's distress cycle exists to organize treatment direction before or during ongoing therapy."
			},
			{
				"title": "Alignment Review",
				"body": "The form is designed to show whether goals and intervention priorities are linked to the mapped pattern. Missing links remain visible instead of being filled automatically."
			},
			{
				"title": "Important Limits",
				"body": "The form does not recommend interventions, define stages, score adherence, predict outcomes, or add generic treatment plan fields outside the map-goals-interventions mechanic."
			}
		],
		"faqItems": [
			{
				"question": "Does this form recommend EFT interventions?",
				"answer": "No. The practitioner enters intervention priorities; the tool organizes and shows alignment with the map and goals."
			},
			{
				"question": "Is there a client-facing version?",
				"answer": "No. The supported product is practitioner-only, with optional sharing of selected plan language outside the core product flow."
			},
			{
				"question": "Can plans change over time?",
				"answer": "Yes. The practitioner can update the plan as therapy develops, while prior plan states remain distinguishable when longitudinal review is needed."
			},
			{
				"question": "What if the map is incomplete?",
				"answer": "The goals and intervention priorities are shown as provisional or unlinked rather than automatically completed."
			}
		]
	},
	{
		"toolType": "eftTango",
		"slug": "eft-tango",
		"title": "EFT Tango EFCT Session Support Demo | Qwoach",
		"metaDescription": "Explore an EFT Tango support tool for live EFCT sessions, with optional notes on primary affect, attachment meaning, and next relational step.",
		"h1": "EFT Tango Live-Session Support",
		"intro": "EFT Tango is a live-session EFCT process support tool for practitioners working with couples or clients in emotionally focused therapy. It helps the practitioner orient to a bounded live process and optionally document primary affect, attachment meaning, relational response, and a usable next relational step.",
		"demoTitle": "Try the live guide with sample session material.",
		"demoPrompt": "Interested in using EFT Tango with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0543-f-025-efct-005-r001-eft-tango.md",
		"specId": "0543-f-025-efct-005-r001-eft-tango",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation",
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Live First",
				"body": "The tool is designed for live-session orientation with optional documentation afterward, so sparse or partial records are valid."
			},
			{
				"title": "What It Can Capture",
				"body": "When the practitioner chooses to document, the record can capture primary affect, attachment meaning, relational response, and a usable next relational step."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide exact move instructions, scripts, client worksheets, scores, transcripts, or automated clinical interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does EFT Tango provide the exact move sequence?",
				"answer": "No. The supplied specification does not define exact moves, prompts, or scripts, so the demo does not display invented process content."
			},
			{
				"question": "Can the tool be used without producing a full note?",
				"answer": "Yes. Live-session use may result in a sparse or partial process note because practitioner attention stays with the session."
			},
			{
				"question": "Does the client interact with the product?",
				"answer": "No. Clients participate in the live therapeutic interaction guided by the practitioner, not through a separate product view."
			},
			{
				"question": "Does the system decide the next intervention?",
				"answer": "No. The practitioner records any next relational step; the system only organizes practitioner-entered information."
			}
		]
	},
	{
		"toolType": "rissssc",
		"slug": "rissssc",
		"title": "RISSSSC EFCT Technique Support Demo | Qwoach",
		"metaDescription": "Explore a lightweight RISSSSC live-session aid for EFCT practitioners, with optional notes on engagement, specificity, and workability.",
		"h1": "RISSSSC Live Emotion-Heightening Support",
		"intro": "RISSSSC is a live-session EFCT technique support tool for practitioners working with clients whose important emotion is present but muted, intellectualized, or not fully experienced. It helps the practitioner stay oriented to engagement, emotional specificity, and therapeutic workability, with optional brief documentation after the moment.",
		"demoTitle": "Open the minimal live aid and try an optional process note.",
		"demoPrompt": "Interested in using RISSSSC with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0544-f-025-efct-006-r001-rissssc.md",
		"specId": "0544-f-025-efct-006-r001-rissssc",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Optional Output",
				"body": "RISSSSC has no inherent structured output in the supplied record. Notes are optional and absence of a note does not mean the technique was unused."
			},
			{
				"title": "What A Note Can Capture",
				"body": "A brief note can capture engagement with emotion, specificity in body sensation, meaning, image, or relational context, and practitioner-observed workability or containment."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not include acronym details, exact prompts, scoring, automated emotional interpretation, or required client interaction."
			}
		],
		"faqItems": [
			{
				"question": "Does RISSSSC require a saved note?",
				"answer": "No. The tool can be used live without producing a structured result."
			},
			{
				"question": "Does the demo explain the RISSSSC acronym?",
				"answer": "No. The supplied specification does not define the acronym elements, so the page must not invent them."
			},
			{
				"question": "Can clients complete RISSSSC on their own?",
				"answer": "No. The supported product is a practitioner-guided live-session aid."
			},
			{
				"question": "Does the tool judge whether a client is dysregulated?",
				"answer": "No. Any workability or containment observation is entered by the practitioner; the system does not make that determination."
			}
		]
	},
	{
		"toolType": "evocativeResponding",
		"slug": "evocative-responding",
		"title": "Evocative Responding EFCT Tool Demo | Qwoach",
		"metaDescription": "Explore live EFCT support for tracking surface conflict, deeper emotional layers, attachment fears or needs, and next intervention clarity.",
		"h1": "Evocative Responding Live EFCT Support",
		"intro": "Evocative Responding is a live-session EFCT intervention support tool for practitioners working with clients or couples whose conflict is still at the surface level. It helps the practitioner organize emerging deeper emotional layers, relationship-connected fears or needs, and the clarity needed to shape the next intervention.",
		"demoTitle": "Try the sample live moment and review the emerging-theme note.",
		"demoPrompt": "Interested in using Evocative Responding with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0545-f-025-efct-007-r001-evocative-responding.md",
		"specId": "0545-f-025-efct-007-r001-evocative-responding",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation",
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Multiple Moments",
				"body": "The tool supports several evocative moments within a session because vulnerable meaning may emerge gradually."
			},
			{
				"title": "Partial States",
				"body": "If no deeper layer emerges, the note remains at surface content and does not invent fears or needs."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate evocative prompts, assign attachment meaning, score vulnerability, or provide unsupported response scripts."
			}
		],
		"faqItems": [
			{
				"question": "Does Evocative Responding generate therapist prompts?",
				"answer": "No. Exact prompts and scripts are not supplied, so the tool organizes practitioner-entered material without generating prompt recommendations."
			},
			{
				"question": "What if no deeper emotion emerges?",
				"answer": "The result stays partial and shows that deeper material has not yet emerged."
			},
			{
				"question": "Can the tool track several attempts in one session?",
				"answer": "Yes. The practitioner can document multiple moments or leave individual entries incomplete."
			},
			{
				"question": "Does the client complete a worksheet?",
				"answer": "No. The supported product is practitioner-guided live-session support, not a client worksheet."
			}
		]
	},
	{
		"toolType": "enactmentChoreographedEncounter",
		"slug": "enactment-choreographed-encounter",
		"title": "EFCT Enactment Encounter Support Demo | Qwoach",
		"metaDescription": "Explore live EFCT encounter support for preparing vulnerable messages, observing partner responses, blockers, and safer pattern movement.",
		"h1": "Enactment and Choreographed Encounter Support for EFCT",
		"intro": "Enactment / Choreographed Encounter is a live-session EFCT encounter support tool for practitioners guiding couples into direct partner-to-partner expression. It helps the practitioner prepare the vulnerable message or theme, observe how it is received, and document blockers, escalation, or movement toward a safer relational pattern.",
		"demoTitle": "Set up the sample encounter and review the observation record.",
		"demoPrompt": "Interested in using Enactment / Choreographed Encounter with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0546-f-025-efct-008-r001-enactment-choreographed-encounter.md",
		"specId": "0546-f-025-efct-008-r001-enactment-choreographed-encounter",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "What It Observes",
				"body": "The tool focuses on direct expression, receiving response, blockers or escalation, and implications for safer relational pattern movement."
			},
			{
				"title": "Partial Encounters",
				"body": "An encounter may be prepared, attempted, paused, or stopped before direct expression. The review reflects the actual point reached."
			},
			{
				"title": "Important Limits",
				"body": "The product does not offer self-guided couple exercises, fixed scripts, readiness algorithms, automated responsiveness scores, or unsupported choreography."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool script what partners should say?",
				"answer": "No. Exact scripts and choreography are not supplied, so the practitioner prepares and records the message or theme in their own language."
			},
			{
				"question": "What if the vulnerable message is not expressed directly?",
				"answer": "The record shows that the enactment did not reach direct partner expression and leaves later areas incomplete."
			},
			{
				"question": "Does the tool rate partner openness?",
				"answer": "No. The practitioner can note observed openness, blocking, or escalation, but the system does not score the response."
			},
			{
				"question": "Is this a client exercise?",
				"answer": "No. It is practitioner-guided live-session support, not a self-guided partner exercise."
			}
		]
	},
	{
		"toolType": "withdrawerEngagementProcess",
		"slug": "withdrawer-engagement-process",
		"title": "Withdrawer Engagement EFCT Tool Demo | Qwoach",
		"metaDescription": "Explore EFCT withdrawer engagement support for tracking protective withdrawal, vulnerable experience, attachment communication, and response opportunity.",
		"h1": "Withdrawer Engagement Process Support",
		"intro": "Withdrawer Engagement Process is a live-session EFCT change-event support tool for practitioners working with a partner whose protective response is withdrawal. It helps the practitioner organize movement from distance, shutdown, or avoidance toward vulnerable experience, direct attachment-relevant communication, and an opportunity for the other partner to respond.",
		"demoTitle": "Try the sample withdrawer engagement progression.",
		"demoPrompt": "Interested in using Withdrawer Engagement Process with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0547-f-025-efct-009-r001-withdrawer-engagement-process.md",
		"specId": "0547-f-025-efct-009-r001-withdrawer-engagement-process",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation",
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Role-Specific Process",
				"body": "The tool applies when the identified partner's withdrawal is the relevant protective response for the process instance."
			},
			{
				"title": "Incomplete Progression",
				"body": "If vulnerable experience is not named or the other partner does not have a response opportunity, the record stops there instead of filling the gap."
			},
			{
				"title": "Important Limits",
				"body": "The product does not classify partners automatically, prescribe exact interventions, use fixed labels outside the process instance, or score engagement."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool label a partner as a withdrawer permanently?",
				"answer": "No. Partner role selection is specific to the process instance and does not create a fixed trait label."
			},
			{
				"question": "What if the partner cannot name vulnerable experience?",
				"answer": "The record remains at that process state and does not infer the vulnerable experience."
			},
			{
				"question": "Does the tool include exact withdrawer engagement steps?",
				"answer": "No. Exact steps and prompts are unresolved in the specification, so the demo uses only supported process-state areas."
			},
			{
				"question": "Can the history show change over time?",
				"answer": "Yes. Historical records may show increasing accessibility over time without converting it into a score."
			}
		]
	},
	{
		"toolType": "pursuerSofteningProcess",
		"slug": "pursuer-softening-process",
		"title": "Pursuer Softening EFCT Tool Demo | Qwoach",
		"metaDescription": "Explore EFCT pursuer softening support for tracking protest, primary attachment fear or need, softened expression, and response opportunity.",
		"h1": "Pursuer Softening Process Support",
		"intro": "Pursuer Softening Process is a live-session EFCT change-event support tool for practitioners working with a partner whose attachment threat response appears as pursuit, protest, criticism, demand, or escalation. It helps the practitioner track movement toward explicit primary attachment fear or need, softer vulnerable expression, and an opportunity for the receiving partner to respond.",
		"demoTitle": "Try the sample pursuer softening progression.",
		"demoPrompt": "Interested in using Pursuer Softening Process with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0548-f-025-efct-010-r001-pursuer-softening-process.md",
		"specId": "0548-f-025-efct-010-r001-pursuer-softening-process",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation",
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Role-Specific Process",
				"body": "The tool applies when pursuing, protesting, or escalating is the clinically relevant response for the process instance."
			},
			{
				"title": "Partial Process Records",
				"body": "If primary fear or softened expression does not emerge, the record remains incomplete at the actual state reached."
			},
			{
				"title": "Important Limits",
				"body": "The product does not determine readiness, classify partner traits, score vulnerability, provide fixed scripts, or broaden into generic conflict de-escalation."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide whether a couple is ready for pursuer softening?",
				"answer": "No. Readiness is a practitioner judgment and is not determined automatically by the product."
			},
			{
				"question": "What if softened expression does not happen?",
				"answer": "The record shows the furthest state reached and does not force or infer softened expression."
			},
			{
				"question": "Does the tool label a partner permanently as a pursuer?",
				"answer": "No. Role selection is specific to the process instance and does not become a fixed trait label."
			},
			{
				"question": "Are exact pursuer softening prompts included?",
				"answer": "No. Exact prompts and steps are unresolved, so the demo uses only supported process-state structure."
			}
		]
	},
	{
		"toolType": "attachmentInjuryAssessment",
		"slug": "attachment-injury-assessment",
		"title": "Attachment Injury Assessment Tool Demo | Qwoach",
		"metaDescription": "Explore an EFCT assessment tool for organizing injury narrative, attachment meaning, hurt, unmet need, partner role, and impasse clarity.",
		"h1": "Attachment Injury Assessment for EFCT",
		"intro": "Attachment Injury Assessment is an EFCT assessment and formulation tool for practitioners working with couples affected by a specific past betrayal, abandonment, or failure of responsiveness. It helps the practitioner organize the injury narrative, attachment meaning, hurt, unmet need, the other partner's role and responsiveness, and whether the injury appears central to the therapy impasse.",
		"demoTitle": "Explore the sample assessment and review the injury formulation.",
		"demoPrompt": "Interested in using Attachment Injury Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0549-f-025-efct-011-r001-attachment-injury-assessment.md",
		"specId": "0549-f-025-efct-011-r001-attachment-injury-assessment",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Completed Together Or Practitioner-Led",
				"body": "The practitioner may enter information during a conjoint discussion or from session notes. Partner statements remain distinguishable from practitioner interpretation."
			},
			{
				"title": "What It Clarifies",
				"body": "The assessment clarifies specificity of the incident or pattern, attachment meaning, hurt, unmet need, partner role, responsiveness, and whether focused repair may be needed."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not determine truth, assign blame, make legal conclusions, score injury severity, or perform the repair process itself."
			}
		],
		"faqItems": [
			{
				"question": "Does Attachment Injury Assessment decide who is responsible?",
				"answer": "No. The tool organizes reported material and practitioner formulation; it does not adjudicate facts, blame, or legal responsibility."
			},
			{
				"question": "Can partners complete it by themselves?",
				"answer": "No. A self-service client workflow is not supported; the practitioner controls the assessment record."
			},
			{
				"question": "What if the incident is not specific enough?",
				"answer": "The result shows insufficient specificity rather than forcing an injury formulation."
			},
			{
				"question": "Does the tool automatically classify the injury as central?",
				"answer": "No. Central-impasse clarification is a practitioner assessment, not an automated classification."
			}
		]
	},
	{
		"toolType": "attachmentInjuryResolutionProcess",
		"slug": "attachment-injury-resolution-process",
		"title": "Attachment Injury Resolution EFCT Demo | Qwoach",
		"metaDescription": "Explore EFCT live repair-process support for tracking hurt expression, responsiveness, blocking effect, and wound-connected commitments.",
		"h1": "Attachment Injury Resolution Process Support",
		"intro": "Attachment Injury Resolution Process is a live-session EFCT repair-process support tool for practitioners working with couples after an attachment injury has been identified. It helps the practitioner document hurt and attachment need expression, acknowledgment or responsiveness, changes in the injury's blocking effect, and any commitments connected to the wound.",
		"demoTitle": "Try the sample repair-process record.",
		"demoPrompt": "Interested in using Attachment Injury Resolution Process with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0550-f-025-efct-012-r001-attachment-injury-resolution-process.md",
		"specId": "0550-f-025-efct-012-r001-attachment-injury-resolution-process",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Repair Attempt Records",
				"body": "The process may be prepared, attempted, paused, partially completed, or continued later. The record reflects actual movement rather than assumed resolution."
			},
			{
				"title": "Commitment Linkage",
				"body": "Commitments, if recorded, should be connected to the attachment wound being repaired. Generic promises unrelated to the wound are not treated as repair commitments."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not assess the injury itself, determine readiness, validate full resolution, script apologies, score trust, or capture legal admissions."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool declare that an attachment injury is resolved?",
				"answer": "No. The tool records practitioner-entered observations of repair movement; it does not automatically determine resolution."
			},
			{
				"question": "Can it be used before an injury is assessed?",
				"answer": "No. The process applies after an unresolved attachment injury has been identified and the practitioner judges a repair attempt appropriate."
			},
			{
				"question": "What if responsiveness is blocked?",
				"answer": "The record shows blocked responsiveness or partial repair movement rather than forcing commitments or completion."
			},
			{
				"question": "Are commitments required?",
				"answer": "No. Commitments are recorded only if they occur, and they should be linked to the identified attachment wound."
			}
		]
	},
	{
		"toolType": "cycleDeEscalationReview",
		"slug": "cycle-de-escalation-review",
		"title": "Cycle De-escalation Review for EFCT Practitioners | Qwoach",
		"metaDescription": "Review EFCT Stage 1 de-escalation indicators, organize couple-cycle evidence, and view a descriptive readiness/progress indicator before saving.",
		"h1": "Cycle De-escalation Review",
		"intro": "Cycle De-escalation Review is an EFCT progress-assessment tool for couple therapists. It helps practitioners organize observations about a couple's negative interaction cycle and review whether Stage 1 change is sufficiently supported before moving into deeper restructuring work.",
		"demoTitle": "Explore the review with sample session observations.",
		"demoPrompt": "Interested in using Cycle De-escalation Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0551-f-025-efct-013-r001-cycle-de-escalation-review.md",
		"specId": "0551-f-025-efct-013-r001-cycle-de-escalation-review",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Outcome monitoring"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at a Stage 1 decision point when the practitioner needs to determine whether the couple's negative cycle is de-escalated enough for deeper restructuring work."
			},
			{
				"title": "What It Captures",
				"body": "The review captures observations about shared cycle recognition, reduced escalation, each partner's role, emotion, and attachment meaning, and stability for next-stage work."
			},
			{
				"title": "Limits",
				"body": "The tool does not produce a diagnosis, symptom severity score, global relationship outcome score, or automated treatment decision."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide whether the couple is ready for the next stage?",
				"answer": "No. It organizes de-escalation evidence into a descriptive progress indicator, while the practitioner retains responsibility for pacing interpretation."
			},
			{
				"question": "Can the couple complete this together with the therapist?",
				"answer": "Yes. A limited shared-completion view may capture couple language, but partners are not asked to self-score Stage 1 completion or decide readiness."
			},
			{
				"question": "What happens when readiness indicators are incomplete?",
				"answer": "Incomplete or unresolved indicators remain visible in the result so the review does not imply readiness prematurely."
			},
			{
				"question": "Are there configurable settings?",
				"answer": "No. The tool is saved as a fixed de-escalation readiness review with its supported indicator structure."
			}
		]
	},
	{
		"toolType": "bondingEventSecureAttachmentNarrative",
		"slug": "bonding-event-secure-attachment-narrative",
		"title": "Secure Attachment Narrative Tool for Couple Therapists | Qwoach",
		"metaDescription": "Capture a shared narrative after couple repair or emotional change, including old distress, new response, attachment meaning, and maintenance themes.",
		"h1": "Bonding Event / Secure Attachment Narrative",
		"intro": "Bonding Event / Secure Attachment Narrative is a consolidation tool for couple therapists using EFCT or attachment-focused couple therapy. It helps practitioners capture a shared narrative of how distress changed, what new relational response emerged, and what needs to be maintained after a repair or emotional shift.",
		"demoTitle": "Build a sample change narrative.",
		"demoPrompt": "Interested in using Bonding Event / Secure Attachment Narrative with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0552-f-025-efct-014-r001-bonding-event-secure-attachment-narrative.md",
		"specId": "0552-f-025-efct-014-r001-bonding-event-secure-attachment-narrative",
		"tags": {
			"framework": [
				"Emotionally Focused Couples Therapy"
			],
			"toolType": [
				"Therapeutic document"
			],
			"workflow": [
				"Therapeutic consolidation"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after a repair, bonding event, or meaningful emotional shift when the couple needs language for what changed and what supports maintenance."
			},
			{
				"title": "What It Produces",
				"body": "The result is a concise change narrative with maintenance themes and notes on whether both partners' perspectives are represented."
			},
			{
				"title": "Limits",
				"body": "The tool does not score attachment security, predict permanence of gains, or provide a scripted maintenance protocol."
			}
		],
		"faqItems": [
			{
				"question": "Is this a couple story builder?",
				"answer": "No. It is a bounded consolidation narrative for a bonding event, repair, or emotional shift, organized around supported therapy-change elements."
			},
			{
				"question": "Can both partners contribute wording?",
				"answer": "Yes. The couple-facing view can capture shared language and each partner's words when useful, while the practitioner controls the final framing."
			},
			{
				"question": "What if the narrative feels one-sided?",
				"answer": "The result should show partial consolidation or unresolved elements rather than forcing completion."
			},
			{
				"question": "Are there settings to configure?",
				"answer": "No. The narrative structure is fixed and the tool is saved as-is."
			}
		]
	},
	{
		"toolType": "deepFormulation",
		"slug": "deep-formulation",
		"title": "DEEP Formulation Workspace for IBCT Practitioners | Qwoach",
		"metaDescription": "Create a practitioner-only IBCT DEEP formulation using differences, emotional sensitivities, external stressors, and interaction patterns.",
		"h1": "DEEP Formulation",
		"intro": "DEEP Formulation is a practitioner-only IBCT case formulation tool for couple therapists. It helps practitioners structure a couple's distress through differences, emotional sensitivities, external stressors, and interaction patterns so treatment targets can be considered in context.",
		"demoTitle": "Explore a sample DEEP formulation.",
		"demoPrompt": "Interested in using DEEP Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0553-f-026-ibct-001-r001-deep-formulation.md",
		"specId": "0553-f-026-ibct-001-r001-deep-formulation",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "What It Organizes",
				"body": "The tool organizes practitioner-entered material into differences, emotional sensitivities, external stressors, and interaction patterns."
			},
			{
				"title": "Practitioner-Only Use",
				"body": "Client material may inform the formulation through therapy, but the product itself does not include client entry or submission."
			},
			{
				"title": "Limits",
				"body": "The tool does not diagnose, score the couple, assign blame, or prescribe interventions."
			}
		],
		"faqItems": [
			{
				"question": "Is DEEP Formulation client-facing?",
				"answer": "No. It is a practitioner-only formulation workspace."
			},
			{
				"question": "What are the formulation domains?",
				"answer": "The formulation domains are differences, emotional sensitivities, external stressors, and interaction patterns."
			},
			{
				"question": "Does the tool choose an intervention?",
				"answer": "No. It can link formulation elements to plausible acceptance or change targets, but the practitioner chooses interventions."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The fixed DEEP Formulation tool itself is saved as-is."
			}
		]
	},
	{
		"toolType": "themeIdentification",
		"slug": "theme-identification",
		"title": "IBCT Theme Identification Tool for Couple Conflict | Qwoach",
		"metaDescription": "Identify a central IBCT conflict theme from repeated couple disputes, with support for partner balance, cross-topic fit, and contextual meaning.",
		"h1": "Theme Identification",
		"intro": "Theme Identification is a practitioner-only IBCT conflict formulation aid for couple therapists. It helps practitioners organize recurring argument examples, represent both partners' positions, and draft a central conflict theme that connects disputes across situations.",
		"demoTitle": "Draft a sample central theme.",
		"demoPrompt": "Interested in using Theme Identification with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0554-f-026-ibct-002-r001-theme-identification.md",
		"specId": "0554-f-026-ibct-002-r001-theme-identification",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior analysis"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when multiple disputes appear connected and the practitioner needs a central theme rather than a list of separate incidents."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures recurring conflict examples, each partner's position, contextual or emotional meanings, candidate themes, and a final central theme statement."
			},
			{
				"title": "Limits",
				"body": "The tool does not create an exhaustive conflict log, score blame, diagnose either partner, or generate a treatment plan."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool require multiple conflict examples?",
				"answer": "Yes. A theme supported by only one incident should be marked as unsupported by multiple topics."
			},
			{
				"question": "Can there be more than one candidate theme?",
				"answer": "Yes. Candidate themes can be explored before the practitioner selects or drafts a final central theme."
			},
			{
				"question": "Is there a client view?",
				"answer": "No. The tool is practitioner-only, though the practitioner may translate the theme into session language."
			},
			{
				"question": "Does the system decide the theme?",
				"answer": "No. The system supports organization and cues; the practitioner interprets and finalizes the central theme."
			}
		]
	},
	{
		"toolType": "polarizationTrapMap",
		"slug": "polarization-trap-map",
		"title": "IBCT Polarization Trap Map for Couple Therapists | Qwoach",
		"metaDescription": "Map reciprocal couple polarization in IBCT with triggers, reactions, escalation notes, and possible interruption points for practitioner review.",
		"h1": "Polarization Trap Map",
		"intro": "Polarization Trap Map is a practitioner-only IBCT interaction mapping tool for couple therapists. It helps practitioners show how each partner's triggering behavior and reaction pull the other into a more polarized conflict position.",
		"demoTitle": "Explore a sample polarization loop.",
		"demoPrompt": "Interested in using Polarization Trap Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0555-f-026-ibct-003-r001-polarization-trap-map.md",
		"specId": "0555-f-026-ibct-003-r001-polarization-trap-map",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior analysis"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "What It Maps",
				"body": "The map captures triggering behaviors, corresponding reactions, escalation sequence, contextual notes, and possible interruption points."
			},
			{
				"title": "Practitioner Role",
				"body": "The practitioner controls map edits and clinical framing. The map may be shown in session, but it is practitioner-facing by default."
			},
			{
				"title": "Limits",
				"body": "The tool does not assign fault, score severity, diagnose either partner, or recommend a required intervention."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic interaction diagram?",
				"answer": "No. It is specifically a polarization trap map focused on reciprocal escalation into opposing positions."
			},
			{
				"question": "Can one-sided data be saved?",
				"answer": "Yes. One-sided or incomplete maps can be saved as drafts and should remain visibly incomplete."
			},
			{
				"question": "Can I map multiple traps?",
				"answer": "Yes. Distinct polarization traps should be kept as separate maps rather than collapsed into one."
			},
			{
				"question": "Does the tool prescribe interruption points?",
				"answer": "No. Possible interruption points can be noted, but the practitioner interprets and chooses next steps."
			}
		]
	},
	{
		"toolType": "mutualTrapFormulation",
		"slug": "mutual-trap-formulation",
		"title": "IBCT Mutual Trap Formulation Tool | Qwoach",
		"metaDescription": "Create a balanced IBCT mutual-trap formulation with each partner's contribution, contextual understandability, and shared-problem statement.",
		"h1": "Mutual Trap Formulation",
		"intro": "Mutual Trap Formulation is a practitioner-only IBCT formulation tool for couple therapists. It helps practitioners describe how both partners' understandable responses sustain a distressing shared pattern neither partner wants.",
		"demoTitle": "Explore a sample mutual-trap formulation.",
		"demoPrompt": "Interested in using Mutual Trap Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0556-f-026-ibct-004-r001-mutual-trap-formulation.md",
		"specId": "0556-f-026-ibct-004-r001-mutual-trap-formulation",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior analysis"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures both partners' contributions, contextual understandability, real conflict examples, and a shared-problem statement."
			},
			{
				"title": "How It Helps",
				"body": "It supports moving from partner-versus-partner blame toward a shared-pattern formulation the practitioner can use in later detachment or acceptance work."
			},
			{
				"title": "Limits",
				"body": "The tool does not assign blame, moralize behavior, provide exact scripts, or automate acceptance-work instructions."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool require both partners' contributions?",
				"answer": "Yes. Both partners' contributions and contextual understandability are core to the mutual-trap formulation."
			},
			{
				"question": "Can a draft be saved if one side is incomplete?",
				"answer": "Yes. The draft can be saved with incomplete or missing-context cues visible."
			},
			{
				"question": "Is this a client worksheet?",
				"answer": "No. It is practitioner-only, though the practitioner may use the formulation as an in-session explanation."
			},
			{
				"question": "Does it teach acceptance work?",
				"answer": "No. It creates a basis for shared detachment or acceptance work but does not provide unsupported intervention scripts."
			}
		]
	},
	{
		"toolType": "empathicJoining",
		"slug": "empathic-joining",
		"title": "IBCT Empathic Joining Live-Session Capture Tool | Qwoach",
		"metaDescription": "Capture vulnerable meanings, partner responses, and observed softening during IBCT empathic joining in live couple therapy sessions.",
		"h1": "Empathic Joining",
		"intro": "Empathic Joining is a live-session support tool for couple therapists using IBCT. It helps practitioners capture difficult behavior, the vulnerable emotional meaning that emerges beneath it, the other partner's response, and whether the interaction softens or remains defensive.",
		"demoTitle": "Try a sample live-session capture.",
		"demoPrompt": "Interested in using Empathic Joining with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0557-f-026-ibct-005-r001-empathic-joining.md",
		"specId": "0557-f-026-ibct-005-r001-empathic-joining",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"In-session support",
				"Clinical documentation"
			],
			"topic": [
				"Interpersonal relationships",
				"Emotion regulation"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Live-Session Use",
				"body": "The tool is designed for rapid practitioner capture during a live session, not for standalone client homework."
			},
			{
				"title": "What It Captures",
				"body": "It captures difficult behavior, vulnerable meaning, partner response, and observed softening or continued defensiveness."
			},
			{
				"title": "Limits",
				"body": "The tool does not score empathy, automate clinical conclusions, provide exact prompts, or imply that harmful behavior is excused."
			}
		],
		"faqItems": [
			{
				"question": "Is Empathic Joining a worksheet for clients?",
				"answer": "No. It is a live-session practitioner capture aid, not a standalone client worksheet."
			},
			{
				"question": "Can unsuccessful attempts be recorded?",
				"answer": "Yes. If vulnerable meaning does not emerge or defensiveness remains, the capture can remain partial or unresolved."
			},
			{
				"question": "Does the tool provide exact prompts?",
				"answer": "No. Exact empathic joining scripts are not supported by the product specification."
			},
			{
				"question": "Does understanding a vulnerable meaning excuse harm?",
				"answer": "No. The tool must preserve the distinction between understanding vulnerable meaning and excusing harmful behavior."
			}
		]
	},
	{
		"toolType": "unifiedDetachment",
		"slug": "unified-detachment",
		"title": "IBCT Unified Detachment Live-Session Tool | Qwoach",
		"metaDescription": "Capture a shared contextual problem description, likely conditions, and observed reactivity during IBCT unified detachment in live sessions.",
		"h1": "Unified Detachment",
		"intro": "Unified Detachment is a live-session support tool for couple therapists using IBCT. It helps practitioners capture a shared, contextual description of the problem, the conditions that make it more likely, and whether the couple can discuss it with less immediate escalation.",
		"demoTitle": "Try a sample shared-problem capture.",
		"demoPrompt": "Interested in using Unified Detachment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0558-f-026-ibct-006-r001-unified-detachment.md",
		"specId": "0558-f-026-ibct-006-r001-unified-detachment",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior analysis"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures conflict content, a shared contextual problem description, conditions that make the pattern more likely, and observed discussion reactivity."
			},
			{
				"title": "Live-Session Role",
				"body": "The couple participates in the practitioner-guided discussion, but there is no separate client-controlled product flow."
			},
			{
				"title": "Limits",
				"body": "The tool does not diagnose character, score blame, provide a full treatment plan, or function as a generic problem-solving worksheet."
			}
		],
		"faqItems": [
			{
				"question": "Is Unified Detachment a client worksheet?",
				"answer": "No. It is live-session practitioner support for capturing a shared contextual problem description."
			},
			{
				"question": "What if the couple stays escalated?",
				"answer": "The attempt can be saved as partial with continued reactivity noted rather than marked as successful."
			},
			{
				"question": "Does the tool create a behavior-change plan?",
				"answer": "No. It creates room for acceptance, tolerance, or targeted behavior change, but it does not produce a prescriptive plan."
			},
			{
				"question": "Can multiple problem descriptions be saved?",
				"answer": "Yes. Distinct patterns should be kept as separate descriptions."
			}
		]
	},
	{
		"toolType": "pointingOutPositiveAspectsOfNegativeBehavior",
		"slug": "pointing-out-positive-aspects-of-negative-behavior",
		"title": "IBCT Tolerance Frame Tool for Persistent Negative Behavior | Qwoach",
		"metaDescription": "Build an IBCT tolerance frame for one persistent negative behavior, preserving impact while noting credible positive or functional aspects.",
		"h1": "Pointing Out Positive Aspects of Negative Behavior",
		"intro": "Pointing Out Positive Aspects of Negative Behavior is an IBCT tolerance-building tool for couple therapists. It helps practitioners guide a structured positive-function reframing of one persistent negative partner behavior while keeping the behavior's negative impact visible.",
		"demoTitle": "Explore a sample tolerance frame.",
		"demoPrompt": "Interested in using Pointing Out Positive Aspects of Negative Behavior with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0559-f-026-ibct-007-r001-pointing-out-positive-aspects-of-negative-behavior.md",
		"specId": "0559-f-026-ibct-007-r001-pointing-out-positive-aspects-of-negative-behavior",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior change"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures one behavior target, negative impact, credible positive or functional aspects, credibility to each partner, and observed reactivity or tolerance."
			},
			{
				"title": "Client Role",
				"body": "Clients may contribute reflections only when between-session reflection is selected. The tool must not pressure the distressed partner to endorse a positive frame."
			},
			{
				"title": "Limits",
				"body": "The tool does not require forgiveness, promise behavior change, generate gratitude lists, or automatically decide that tolerance is clinically appropriate."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool hide the negative impact of the behavior?",
				"answer": "No. The negative impact remains visible in the frame and result."
			},
			{
				"question": "Can the distressed partner reject the positive frame?",
				"answer": "Yes. Responses such as not credible, unresolved, or still distressing are supported."
			},
			{
				"question": "What is configurable?",
				"answer": "The practitioner can choose live session only or live session plus between-session reflection."
			},
			{
				"question": "Does saving preserve sample client reflections?",
				"answer": "No. Saving preserves the tool and selected usage mode, not fictional demo reflections or case data."
			}
		]
	},
	{
		"toolType": "practicingNegativeBehaviorInTheTherapySession",
		"slug": "practicing-negative-behavior-in-the-therapy-session",
		"title": "IBCT In-Session Negative Behavior Enactment Tool | Qwoach",
		"metaDescription": "Record controlled IBCT in-session enactments with consent and safety judgment, reactions, regulation, impact awareness, and response alternatives.",
		"h1": "Practicing Negative Behavior in the Therapy Session",
		"intro": "Practicing Negative Behavior in the Therapy Session is a live therapist-guided IBCT enactment tool for couple therapists. It helps practitioners record a specific triggering behavior, consent and safety judgment, observed partner reactions, escalation risks, impact awareness, and workable response alternatives during a controlled session exercise.",
		"demoTitle": "Explore a sample enactment record.",
		"demoPrompt": "Interested in using Practicing Negative Behavior in the Therapy Session with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0560-f-026-ibct-007-r002-practicing-negative-behavior-in-the-therapy-session.md",
		"specId": "0560-f-026-ibct-007-r002-practicing-negative-behavior-in-the-therapy-session",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"In-session support",
				"Risk review"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior change"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Safety-Sensitive Setup",
				"body": "The tool requires practitioner-entered consent and safety judgment before enactment capture. It does not automate safety clearance."
			},
			{
				"title": "What It Records",
				"body": "The observation record includes target behavior, partner regulation and reactions, awareness of impact, escalation risks, response alternatives, and stopped, partial, or completed states."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide unsupervised instructions, generic role-play scripts, exposure scores, or automated treatment decisions."
			}
		],
		"faqItems": [
			{
				"question": "Can clients use this tool on their own?",
				"answer": "No. It is live-session-only and therapist-guided; clients should not independently initiate or repeat the exercise through the product."
			},
			{
				"question": "What happens if consent or safety judgment is not adequate?",
				"answer": "The exercise cannot proceed and remains a non-completed setup record."
			},
			{
				"question": "Can stopped or harmful enactments be recorded?",
				"answer": "Yes. Stopped, partial, and harmful or non-supportive outcomes are valid recorded states and should not be hidden."
			},
			{
				"question": "Does the tool decide that an enactment is safe?",
				"answer": "No. Safety suitability is practitioner-entered and practitioner interpreted; the product does not automate clearance."
			}
		]
	},
	{
		"toolType": "fakingNegativeBehaviorsAtHomeBetweenSessions",
		"slug": "faking-negative-behaviors-at-home-between-sessions",
		"title": "Faking Negative Behaviors at Home Between Sessions | Qwoach",
		"metaDescription": "Explore an IBCT homework tool for bounded simulated behavior practice, partner observations, limit concerns, and therapist review.",
		"h1": "Faking Negative Behaviors at Home Between Sessions",
		"intro": "Faking Negative Behaviors at Home Between Sessions is an IBCT homework tool for couple therapists. It helps practitioners assign one safe, agreed simulation of a recurring disliked partner behavior and review partner observations about triggers, emotions, impulses, limits, and responses at home.",
		"demoTitle": "Configure a sample homework assignment, preview the partner observation form, then review the demo trial timeline.",
		"demoPrompt": "Interested in using Faking Negative Behaviors at Home Between Sessions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0561-f-026-ibct-007-r003-faking-negative-behaviors-at-home-between-sessions.md",
		"specId": "0561-f-026-ibct-007-r003-faking-negative-behaviors-at-home-between-sessions",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"Between-session monitoring"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior change"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it between sessions when a selected recurring disliked behavior is suitable for deliberate, bounded simulation and the therapist wants to review whether home responses are less avoidant or escalatory."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not choose the target behavior, judge safety, prescribe exposure intensity, verify behavior, assign blame, or produce diagnostic conclusions. Limit concerns interrupt ordinary continuation for practitioner review."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated trials remain tied to their target and limits. If configuration changes, history distinguishes old and revised assignments so comparisons remain descriptive."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide which behavior is safe to simulate?",
				"answer": "No. The practitioner defines the target behavior and limits; the tool only organizes the assignment and reported observations."
			},
			{
				"question": "Can partners stop or skip the exercise?",
				"answer": "Yes. Partners can mark the trial skipped, stopped, or not safe or appropriate to continue, and the result preserves that state for review."
			},
			{
				"question": "Does it score whether tolerance improved?",
				"answer": "No. It can show descriptive changes in reported escalation, avoidance, or flexibility across trials, but clinical meaning remains practitioner interpreted."
			},
			{
				"question": "Can both partners submit separate reports?",
				"answer": "Yes. Separate reporting is a configurable mode, and partner disagreement is preserved rather than forced into one account."
			}
		]
	},
	{
		"toolType": "behaviorExchange",
		"slug": "behavior-exchange",
		"title": "Behavior Exchange for IBCT Couples Work | Qwoach",
		"metaDescription": "Explore an IBCT behavior exchange tool for concrete partner agreements, completion reports, recognition, effects, and therapist review.",
		"h1": "Behavior Exchange",
		"intro": "Behavior Exchange is an IBCT tool for couple therapists. It helps practitioners define concrete partner-specific behaviors tied to an identified relationship problem, then review completion, partner recognition, reported effects, and barriers.",
		"demoTitle": "Build a sample exchange, preview partner reports, and review the paired behavior table.",
		"demoPrompt": "Interested in using Behavior Exchange with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0562-f-026-ibct-008-r001-behavior-exchange.md",
		"specId": "0562-f-026-ibct-008-r001-behavior-exchange",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Behavior change",
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures concrete partner-specific behaviors, partner confirmations, completion reports, recognition, observed effects, barriers, and longitudinal history."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not generate behavior recommendations, score relationship quality, rank partners, or infer sincerity."
			},
			{
				"title": "Review Over Time",
				"body": "Revised or retired behaviors stay historically distinct so completion and effect can be discussed in relation to the version active at that time."
			}
		],
		"faqItems": [
			{
				"question": "Is Behavior Exchange a generic habit tracker?",
				"answer": "No. It is tied to a couple’s identified relationship problem and tracks partner-specific observable behaviors and their effects on interaction."
			},
			{
				"question": "Can the practitioner review partial reports?",
				"answer": "Yes. One partner’s report can be reviewed without requiring full completion by both partners."
			},
			{
				"question": "Does the tool suggest what behaviors partners should choose?",
				"answer": "No. The practitioner and couple define behaviors; the tool checks and organizes specificity, completion, recognition, and effect reporting."
			},
			{
				"question": "Can mismatches be reviewed?",
				"answer": "Yes. If one partner reports completion and the other does not recognize the behavior, the mismatch is preserved for discussion."
			}
		]
	},
	{
		"toolType": "speakerListenerTechnique",
		"slug": "speaker-listener-technique",
		"title": "Speaker-Listener Technique for Couple Communication | Qwoach",
		"metaDescription": "Explore a structured couple communication protocol with speaker turns, listener paraphrases, confirmation, role switching, and review.",
		"h1": "Speaker-Listener Technique",
		"intro": "Speaker-Listener Technique is a structured communication tool for couples therapists, marriage and family therapists, relationship educators, and practitioners teaching couple communication. It helps partners discuss sensitive topics through brief speaker turns, listener paraphrases, speaker confirmation or correction, and delayed problem solving.",
		"demoTitle": "Start a sample conversation, switch roles, and review the protocol timeline.",
		"demoPrompt": "Interested in using Speaker-Listener Technique with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0563-f-026-ibct-009-r001-speaker-listener-technique.md",
		"specId": "0563-f-026-ibct-009-r001-speaker-listener-technique",
		"tags": {
			"framework": [],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Protocol Boundaries",
				"body": "The tool guides role separation, paraphrase, confirmation or correction, and delayed problem solving. It does not decide who is right or provide substantive conflict prompts."
			},
			{
				"title": "Live And Homework Use",
				"body": "Live mode supports practitioner coaching during a session. Homework mode preserves the same role-guided sequence for later review."
			},
			{
				"title": "Partial Conversations",
				"body": "Interrupted or stopped conversations keep the last completed step and reason, because incomplete protocol cycles can still matter for review."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool allow problem solving right away?",
				"answer": "No. Problem solving remains closed or flagged until both perspectives have been understood through the role sequence."
			},
			{
				"question": "Can the speaker reject a paraphrase?",
				"answer": "Yes. The speaker can correct the paraphrase, and the listener can try again without the correction being treated as failure."
			},
			{
				"question": "Does it score listening skill?",
				"answer": "No. It shows protocol descriptors such as missing paraphrases, confirmations, role balance, and premature problem-solving markers."
			},
			{
				"question": "Can it be used outside the session?",
				"answer": "Yes. Homework mode supports assigned practice, while live mode supports practitioner-facilitated use."
			}
		]
	},
	{
		"toolType": "gottmanRapoportIntervention2",
		"slug": "gottman-rapoport-intervention-2",
		"title": "Gottman-Rapoport Intervention Demo | Qwoach",
		"metaDescription": "Explore a clinician-guided conflict conversation workflow for partner perspectives, listening, validation, heard status, and review.",
		"h1": "Gottman-Rapoport Intervention",
		"intro": "Gottman-Rapoport Intervention is a conflict communication tool for Gottman Method couples therapists and clinicians using Gottman-style interventions. It helps practitioners guide partners through expressing perspectives, listening, offering validation, and checking whether each partner feels heard before compromise or problem solving.",
		"demoTitle": "Open a sample conflict topic, guide both sides of the conversation, and review the two-sided conflict map.",
		"demoPrompt": "Interested in using Gottman-Rapoport Intervention with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0564-f-026-ibct-009-r002-gottman-rapoport-intervention.md",
		"specId": "0564-f-026-ibct-009-r002-gottman-rapoport-intervention",
		"tags": {
			"framework": [
				"Gottman Method Couples Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Supported Structure",
				"body": "The page exposes only the supported structure: perspective, listening, validation, heard/understood status, and practitioner review."
			},
			{
				"title": "Not A Compromise Plan",
				"body": "The tool prepares a clearer shared basis for later compromise or problem solving. It does not create the compromise plan itself."
			},
			{
				"title": "Partial And Stopped States",
				"body": "If validation is missing, one partner does not feel heard, or the conversation escalates, the result remains partial or stopped for practitioner review."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include exact worksheet prompts?",
				"answer": "No. Exact prompt and worksheet structure are unresolved in the supplied specification, so the demo uses only the supported generic conversation structure."
			},
			{
				"question": "Does the tool decide when a conflict is resolved?",
				"answer": "No. It tracks whether perspectives, listening, validation, and heard/understood status are present; the practitioner decides the next step."
			},
			{
				"question": "Can one partner say they do not feel heard?",
				"answer": "Yes. The result remains incomplete or partial rather than marking mutual understanding complete."
			},
			{
				"question": "Can this be used as assigned practice?",
				"answer": "Yes. Assigned mode is supported, alongside live clinician-guided use."
			}
		]
	},
	{
		"toolType": "coupleProblemSolving",
		"slug": "couple-problem-solving",
		"title": "Couple Problem-Solving Tool for IBCT | Qwoach",
		"metaDescription": "Explore a live IBCT problem-solving tool for concrete relationship problems, shared decisions, action paths, responsibilities, and review.",
		"h1": "Couple Problem-Solving",
		"intro": "Couple Problem-Solving is a live-session tool for couple therapists using IBCT. It helps practitioners help partners define one specific relationship problem, record a mutually understood decision or next action, and clarify responsibilities or expectations for later review.",
		"demoTitle": "Create a sample problem-solving plan and inspect the reviewable action summary.",
		"demoPrompt": "Interested in using Couple Problem-Solving with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0565-f-026-ibct-010-r001-couple-problem-solving.md",
		"specId": "0565-f-026-ibct-010-r001-couple-problem-solving",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Problem solving",
				"Intervention planning"
			],
			"topic": [
				"Problem solving",
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Live Session Focus",
				"body": "The tool is designed for live-session problem solving, with optional partner-facing confirmation or sharing when useful."
			},
			{
				"title": "Reviewable Responsibilities",
				"body": "Responsibilities or expectations must be clear enough to revisit. If they are unclear, the plan remains draft rather than reviewable."
			},
			{
				"title": "Plan History",
				"body": "Unresolved, agreed, revised, completed, and retired plans remain distinguishable so follow-up corresponds to the version actually agreed."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate solutions for the couple?",
				"answer": "No. It structures the practitioner-guided decision and action path; it does not recommend solutions."
			},
			{
				"question": "Can a plan remain unresolved?",
				"answer": "Yes. If partners cannot agree or responsibilities are unclear, the plan remains unresolved or draft for review."
			},
			{
				"question": "Is partner confirmation required?",
				"answer": "It is configurable. When enabled, partner confirmation changes the completion threshold."
			},
			{
				"question": "Does follow-up tracking have to be used?",
				"answer": "No. Follow-up tracking is a setting that changes whether the plan persists into later review cycles."
			}
		]
	},
	{
		"toolType": "coreProblemSelection",
		"slug": "core-problem-selection",
		"title": "Core Problem Selection for IBCT Practice | Qwoach",
		"metaDescription": "Explore a practitioner-only IBCT tool for selecting one prioritized core relationship problem, rationale, recognition notes, and revisions.",
		"h1": "Core Problem Selection",
		"intro": "Core Problem Selection is a practitioner-only IBCT tool for clinicians beginning work with a couple. It helps practitioners organize presenting concerns into one prioritized core relationship problem, document why it is central, note whether both partners can recognize it, and revisit the target as therapy progresses.",
		"demoTitle": "Try a sample candidate list, select a core problem, and review the current focus card.",
		"demoPrompt": "Interested in using Core Problem Selection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0566-f-026-ibct-011-r001-core-problem-selection.md",
		"specId": "0566-f-026-ibct-011-r001-core-problem-selection",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The practitioner creates and controls the selected core problem. Partner input may inform judgment outside the tool, but no direct partner completion flow is required."
			},
			{
				"title": "Revision Over Time",
				"body": "When the core problem changes, the prior selection remains in history so the treatment focus can be revisited rather than overwritten invisibly."
			},
			{
				"title": "Scope",
				"body": "The tool selects and documents a core relationship problem. It does not diagnose, rank problems automatically, or build a full case formulation."
			}
		],
		"faqItems": [
			{
				"question": "Does the system choose the core problem?",
				"answer": "No. The practitioner selects the core problem and documents rationale; the system does not rank or diagnose."
			},
			{
				"question": "Is there a client form?",
				"answer": "No. Client/User View is not applicable for this practitioner-only configuration."
			},
			{
				"question": "Can the selected problem change later?",
				"answer": "Yes. Revisions are preserved as dated history rather than overwriting the prior focus invisibly."
			},
			{
				"question": "Can the practitioner skip candidate problems?",
				"answer": "Yes. The practitioner can directly enter a selected problem if rationale and recognition notes are still captured according to settings."
			}
		]
	},
	{
		"toolType": "individualPerspectiveForm",
		"slug": "individual-perspective-form",
		"title": "Individual Perspective Form for IBCT-Informed Practice | Qwoach",
		"metaDescription": "Explore a paired partner perspective form for separate core-problem responses, submission tracking, side-by-side review, and feedback prep.",
		"h1": "Individual Perspective Form",
		"intro": "Individual Perspective Form is a ready-to-send tool for practitioners using an IBCT-informed process. It helps collect each partner’s separate perspective on the couple’s core problem so the practitioner can compare similarities and differences and prepare feedback toward a less one-sided shared understanding.",
		"demoTitle": "Set a sample core problem, preview separate partner forms, and review the paired perspective comparison.",
		"demoPrompt": "Interested in using Individual Perspective Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0567-f-026-ibct-012-r001-individual-perspective-form.md",
		"specId": "0567-f-026-ibct-012-r001-individual-perspective-form",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Session preparation"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Separate Before Shared",
				"body": "Responses remain partner-specific and separately collected so immediate mutual influence does not erase differences before practitioner review."
			},
			{
				"title": "Prompt Structure",
				"body": "Exact source form prompts are not defined in the product specification. The demo supports practitioner-defined prompts or a generic perspective field without adding unsupported scales."
			},
			{
				"title": "Partial Review",
				"body": "If configured, one submitted response can be reviewed while the missing partner response remains visible as incomplete."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool include fixed assessment scales?",
				"answer": "No. Unsupported ratings or dimensions are not included because exact form structure is unresolved."
			},
			{
				"question": "Can partners see each other’s responses immediately?",
				"answer": "Only if the practitioner configures visibility that way after submission. The default protects separate completion before review."
			},
			{
				"question": "Can the practitioner review one response if the other partner has not submitted?",
				"answer": "Yes, if review after one submission is enabled. The pair remains marked partial."
			},
			{
				"question": "Does the system create a shared formulation automatically?",
				"answer": "No. It presents paired perspectives and descriptive comparison material for practitioner-authored feedback."
			}
		]
	},
	{
		"toolType": "structuredSharingConversation",
		"slug": "structured-sharing-conversation",
		"title": "Structured Sharing Conversation for IBCT-Informed Couples Work | Qwoach",
		"metaDescription": "Explore a guided couple conversation for sharing core-problem understandings, reciprocal responses, shared account, and review.",
		"h1": "Structured Sharing Conversation",
		"intro": "Structured Sharing Conversation is a guided couple conversation tool for practitioners using an IBCT-informed process. It helps partners share their individual understandings of a core relationship problem, respond to each other, and capture a clearer shared account or unresolved differences.",
		"demoTitle": "Start a sample sharing conversation, switch partner turns, and review the shared-account summary.",
		"demoPrompt": "Interested in using Structured Sharing Conversation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0568-f-026-ibct-013-r001-structured-sharing-conversation.md",
		"specId": "0568-f-026-ibct-013-r001-structured-sharing-conversation",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Shared But Not Forced",
				"body": "The conversation is shared by nature, but the shared-account field can include unresolved differences rather than forcing consensus."
			},
			{
				"title": "Before Change Planning",
				"body": "The result is shared understanding and responses. Concrete action planning belongs in a separate tool."
			},
			{
				"title": "Unresolved Structure",
				"body": "Exact prompts and sequence details are not defined in the product specification, so the demo avoids unsupported worksheet fields."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool require partners to agree?",
				"answer": "No. It can capture unresolved differences when forced agreement would misrepresent the conversation."
			},
			{
				"question": "Can prior individual perspectives be shown?",
				"answer": "Yes. Prior perspective visibility is configurable by the practitioner."
			},
			{
				"question": "Does the tool create a change plan?",
				"answer": "No. It supports shared understanding; change planning is a natural next step in a separate tool."
			},
			{
				"question": "What happens if one partner does not contribute?",
				"answer": "The conversation remains partial, and the missing contribution is visible for practitioner review."
			}
		]
	},
	{
		"toolType": "concreteChangePlan",
		"slug": "concrete-change-plan",
		"title": "Concrete Change Plan for IBCT-Informed Couples Work | Qwoach",
		"metaDescription": "Explore a dyadic action-planning tool for concrete observable changes, partner roles, confirmation, follow-through, and effect review.",
		"h1": "Concrete Change Plan",
		"intro": "Concrete Change Plan is a ready-to-complete-together tool for practitioners using an IBCT-informed process. It helps couples convert a shared understanding of their core relationship problem into observable changes, clear partner roles, mutual confirmation, and follow-up review.",
		"demoTitle": "Build a sample dyadic change plan, preview partner confirmation, and review follow-through fields.",
		"demoPrompt": "Interested in using Concrete Change Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0569-f-026-ibct-014-r001-concrete-change-plan.md",
		"specId": "0569-f-026-ibct-014-r001-concrete-change-plan",
		"tags": {
			"framework": [
				"IBCT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Interpersonal relationships"
			],
			"population": [
				"Couples"
			]
		},
		"sections": [
			{
				"title": "Dyadic Action Only",
				"body": "Each change is tied to the shared relationship problem and includes roles for the partners. Individual goals unrelated to the dyadic problem are outside this tool."
			},
			{
				"title": "Follow-Up Review",
				"body": "When enabled, follow-up tracking preserves partner reports of what happened, perceived effect, barriers, and revisions."
			},
			{
				"title": "Draft And Revision States",
				"body": "Vague items, missing roles, pending confirmation, revisions, completed items, and retired items remain distinguishable."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool suggest changes the couple should make?",
				"answer": "No. The couple and practitioner define changes; the tool structures them for clarity, confirmation, and review."
			},
			{
				"question": "Can one partner confirm while the other does not?",
				"answer": "Yes. The plan remains pending or partial when mutual confirmation is required but incomplete."
			},
			{
				"question": "Does it measure relationship improvement?",
				"answer": "No. It records reported follow-through and effect without assigning a relationship improvement score."
			},
			{
				"question": "Can plans be revised?",
				"answer": "Yes. Revisions preserve prior versions so follow-up stays tied to the plan active at that time."
			}
		]
	},
	{
		"toolType": "structuralFamilyMap",
		"slug": "structural-family-map",
		"title": "Structural Family Map for Structural Family Therapy | Qwoach",
		"metaDescription": "Explore a practitioner-only structural family therapy map for members, relationship features, problem-linking notes, and version history.",
		"h1": "Structural Family Map",
		"intro": "Structural Family Map is a practitioner-only tool for structural family therapists and practitioners using structural family therapy. It helps create a two-dimensional map of relevant family members, relationship or structural features, and notes linking family organization to the presenting problem.",
		"demoTitle": "Build a sample structural map, add labeled links, and review version history.",
		"demoPrompt": "Interested in using Structural Family Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0570-f-027-sft-001-r001-structural-family-map.md",
		"specId": "0570-f-027-sft-001-r001-structural-family-map",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Authored Formulation",
				"body": "The map reflects the practitioner’s assessment and notes. The system stores layout and metadata but does not assign structural meaning automatically."
			},
			{
				"title": "Version History",
				"body": "Updated maps create dated versions so earlier formulations remain available for comparison as the family changes."
			},
			{
				"title": "Scope",
				"body": "The tool is for structural family therapy mapping, not a generic diagram builder, genogram, family tree, or intervention recommendation engine."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client or family entry flow?",
				"answer": "No. Client/User View is not applicable because the supplied configuration is practitioner-only."
			},
			{
				"question": "Does the tool define structural symbols automatically?",
				"answer": "No. It supports generic or practitioner-defined notation and does not impose unsupported symbol meanings."
			},
			{
				"question": "Can prior maps be preserved?",
				"answer": "Yes. Version history preserves prior formulations rather than overwriting them invisibly."
			},
			{
				"question": "Does it recommend interventions?",
				"answer": "No. The map helps the practitioner choose interventions, but the system does not generate recommendations."
			}
		]
	},
	{
		"toolType": "subsystemMap",
		"slug": "subsystem-map",
		"title": "Subsystem Map Demo for Family Therapy Practitioners | Qwoach",
		"metaDescription": "Explore a practitioner-only Subsystem Map for organizing family groupings, roles, and problem-relevant interactions across session snapshots.",
		"h1": "Subsystem Map for Structural Family Therapy",
		"intro": "Subsystem Map is a practitioner-only structural family therapy mapping tool. Family therapy practitioners use it to distinguish functional or problematic relational groupings, describe practitioner-entered roles or functions, and see how those subsystems relate to the presenting problem.",
		"demoTitle": "Explore a sample map, adjust subsystem groupings, then save the tool for your account.",
		"demoPrompt": "Interested in using Subsystem Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0571-f-027-sft-002-r001-subsystem-map.md",
		"specId": "0571-f-027-sft-002-r001-subsystem-map",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during or after case review when the clinical question is how the family is organized into functional or problematic subsystems related to the presenting problem."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not score family functioning, infer pathology, prescribe intervention targets, or turn the map into a full structural-family formulation."
			},
			{
				"title": "Repeat Use",
				"body": "Saved snapshots let the practitioner compare later subsystem organization with an earlier session while preserving prior maps for review."
			}
		],
		"faqItems": [
			{
				"question": "Does Subsystem Map generate clinical interpretations?",
				"answer": "No. Subsystem Map organizes and compares practitioner-entered participants, groupings, notes, and interactions; it does not infer pathology, causality, or intervention targets."
			},
			{
				"question": "Can one participant appear in more than one subsystem?",
				"answer": "Yes. The map must support overlapping membership when the practitioner's formulation requires it."
			},
			{
				"question": "Is there a client-facing version?",
				"answer": "No. Subsystem Map is practitioner-only; clients may inform the practitioner's entries through session interaction, but they do not complete the tool."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The tool itself and intentional reusable setup are saved. Fictional demo case content and sample snapshots are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "boundaryMap",
		"slug": "boundary-map",
		"title": "Boundary Map Demo for Family Therapy Practitioners | Qwoach",
		"metaDescription": "Explore a practitioner-only Boundary Map for profiling family boundary patterns, problem relevance, and before/after comparison.",
		"h1": "Boundary Map for Structural Family Therapy",
		"intro": "Boundary Map is a practitioner-only structural family therapy tool. Practitioners use it to identify relational boundary patterns, record whether those patterns are functional, unhealthy, or problem-maintaining, and compare boundary profiles across snapshots.",
		"demoTitle": "Explore a sample boundary profile, adjust mapped relationships, and save the tool for your account.",
		"demoPrompt": "Interested in using Boundary Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0572-f-027-sft-003-r001-boundary-map.md",
		"specId": "0572-f-027-sft-003-r001-boundary-map",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use Boundary Map when the practitioner needs a focused profile of boundaries related to a presenting concern and wants a before/after view of later boundary-pattern changes."
			},
			{
				"title": "Practitioner Role",
				"body": "The practitioner enters boundary observations and any functional or unhealthy distinctions. The system organizes, filters, and compares those entries without deciding boundary health."
			},
			{
				"title": "Relevant Limitations",
				"body": "Unassessed relationships are labeled not assessed, not healthy. The tool does not score severity, prescribe restructuring steps, or infer clinical success."
			}
		],
		"faqItems": [
			{
				"question": "Does Boundary Map decide whether a boundary is unhealthy?",
				"answer": "No. The practitioner enters any functional, unhealthy, or problem-maintaining distinction; the system only displays and compares the entered information."
			},
			{
				"question": "Can I leave a boundary pattern unresolved?",
				"answer": "Yes. The tool should allow unresolved or needs-observation states when the practitioner has not yet determined the boundary pattern."
			},
			{
				"question": "Is Boundary Map client-facing?",
				"answer": "No. Boundary Map is a practitioner-only formulation and review aid."
			},
			{
				"question": "What happens to demo boundary data when I save?",
				"answer": "Demo boundary data is not saved as real client data by default. Saving preserves the tool itself and intentional reusable configuration."
			}
		]
	},
	{
		"toolType": "hierarchyPowerMap",
		"slug": "hierarchy-power-map",
		"title": "Hierarchy / Power Map Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only map for family authority structure, power relationships, problem relevance, and snapshot comparison.",
		"h1": "Hierarchy / Power Map for Family Therapy Practitioners",
		"intro": "Hierarchy / Power Map is a practitioner-only structural family therapy mapping tool. Practitioners use it to represent family authority structure, power dynamics, and hierarchy patterns, then review which relationships or roles may require a practitioner-identified shift.",
		"demoTitle": "Explore a sample power profile, change relationship details, and save the tool for your account.",
		"demoPrompt": "Interested in using Hierarchy / Power Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0573-f-027-sft-004-r001-hierarchy-power-map.md",
		"specId": "0573-f-027-sft-004-r001-hierarchy-power-map",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when authority structure, power dynamics, or hierarchy patterns appear relevant to a presenting problem and need a focused practitioner profile."
			},
			{
				"title": "What the System Does",
				"body": "The system organizes practitioner-entered relationships, highlights marked patterns, and compares snapshots; it does not judge whether a hierarchy is healthy or dysfunctional."
			},
			{
				"title": "Comparison Use",
				"body": "Historical comparison shows specific shifts in relationships or roles while preserving prior profiles."
			}
		],
		"faqItems": [
			{
				"question": "Does Hierarchy / Power Map score family power dynamics?",
				"answer": "No. The tool does not use numeric power scores or automated hierarchy classifications."
			},
			{
				"question": "Who decides whether a hierarchy pattern is dysfunctional?",
				"answer": "The practitioner decides and enters that distinction. The system only represents it."
			},
			{
				"question": "Can multiple authority patterns coexist in the map?",
				"answer": "Yes. The product should allow multiple authority patterns without forcing a single hierarchy when the practitioner needs that representation."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and reusable configuration are saved. Fictional case data and sample snapshots are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "allianceCoalitionMap",
		"slug": "alliance-coalition-map",
		"title": "Alliance / Coalition Map Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only map for family affiliations, conflicts, coalitions, overinvolvement, and alignment changes over time.",
		"h1": "Alliance / Coalition Map for Structural Family Therapy",
		"intro": "Alliance / Coalition Map is a practitioner-only structural family therapy tool. Practitioners use it to map family affiliations, conflicts, overinvolvement, supportive alliances, and problematic coalitions that are relevant to the presenting problem.",
		"demoTitle": "Explore a sample alignment map, filter relationship types, and save the tool for your account.",
		"demoPrompt": "Interested in using Alliance / Coalition Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0574-f-027-sft-005-r001-alliance-coalition-map.md",
		"specId": "0574-f-027-sft-005-r001-alliance-coalition-map",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when affiliations, conflicts, overinvolvement, or coalitions appear to organize the presenting problem and the practitioner needs a focused alignment picture."
			},
			{
				"title": "Filtering Without Data Loss",
				"body": "Relationship-type filters reduce visual density while preserving the underlying practitioner-entered map."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not automatically detect coalitions, score relationship health, or prescribe a restructuring plan."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool identify problematic coalitions automatically?",
				"answer": "No. Problematic coalition labels are practitioner-entered; the system organizes and displays them."
			},
			{
				"question": "Can one relationship have more than one alignment type?",
				"answer": "Yes. Multiple relationship patterns between the same members should be supported when clinically meaningful."
			},
			{
				"question": "Do visibility filters delete map data?",
				"answer": "No. Filters only change what is visible in the review; the underlying relationship entries remain unchanged."
			},
			{
				"question": "Is there a client view?",
				"answer": "No. Alliance / Coalition Map is practitioner-only."
			}
		]
	},
	{
		"toolType": "joining",
		"slug": "joining",
		"title": "Joining Support Demo for Practitioners | Qwoach",
		"metaDescription": "Explore a practitioner-only live-session Joining support view with optional private notes and no structured client task or score.",
		"h1": "Joining Support for Structural Family Therapy",
		"intro": "Joining is a practitioner-only live-session support view. Family therapy practitioners use it to keep the purpose and success criteria of joining visible while establishing therapeutic connection and credibility with a family before later structural assessment or restructuring.",
		"demoTitle": "Open the sample orientation view, try an optional private note, and save the tool for your account.",
		"demoPrompt": "Interested in using Joining with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0575-f-027-sft-006-r001-joining.md",
		"specId": "0575-f-027-sft-006-r001-joining",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Why There Is No Client Task",
				"body": "Joining happens through live therapeutic interaction. The supported product does not ask clients to complete ratings, prompts, or forms."
			},
			{
				"title": "Optional Notes",
				"body": "Private notes may support continuity, but the tool remains useful without any note because no structured output is required."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not provide scripts, exact prompts, rapport scores, or automated conclusions about whether joining has been achieved."
			}
		],
		"faqItems": [
			{
				"question": "Does Joining produce a report?",
				"answer": "No. The supplied product has no structured output; it is a practitioner-only live-session orientation view."
			},
			{
				"question": "Can clients complete Joining in the product?",
				"answer": "No. Clients participate through live therapeutic interaction, not through a product interface."
			},
			{
				"question": "Are optional status notes scored?",
				"answer": "No. Any status or note is practitioner-authored and is not a validated measure."
			},
			{
				"question": "What is saved if there is no configuration?",
				"answer": "The fixed Joining tool itself is saved as-is. No configuration is required."
			}
		]
	},
	{
		"toolType": "tracking",
		"slug": "tracking",
		"title": "Tracking Demo for Family Therapy Practitioners | Qwoach",
		"metaDescription": "Explore a practitioner-only Tracking tool for capturing observed family interaction sequences, event roles, and structural notes.",
		"h1": "Tracking for Observed Family Interaction Sequences",
		"intro": "Tracking is a practitioner-only live-session observation aid. Family therapy practitioners use it to record who initiates, responds, escalates, withdraws, or redirects an observed interaction and connect that sequence to the presenting concern and structural assessment.",
		"demoTitle": "Try a sample interaction timeline, reorder events, and save the tool for your account.",
		"demoPrompt": "Interested in using Tracking with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0576-f-027-sft-007-r001-tracking.md",
		"specId": "0576-f-027-sft-007-r001-tracking",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"In-session support"
			],
			"topic": [
				"Behavior analysis",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use Tracking when the practitioner needs a working grasp of a recurring interaction pattern as it unfolds in session."
			},
			{
				"title": "Partial Capture",
				"body": "Incomplete sequences remain usable and are marked partial rather than forced into a finished assessment."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not transcribe sessions, automate coding, infer roles or hierarchy, or prescribe treatment steps."
			}
		],
		"faqItems": [
			{
				"question": "Does Tracking create a transcript?",
				"answer": "No. Tracking captures practitioner-entered observed events in sequence; it is not a full audio or video transcript tool."
			},
			{
				"question": "Can event order be changed?",
				"answer": "Yes. Events can be reordered or marked approximate because live observation may be captured imperfectly."
			},
			{
				"question": "Are role labels inferred by the system?",
				"answer": "No. Role labels such as initiates, responds, escalates, withdraws, or redirects are entered by the practitioner."
			},
			{
				"question": "Can clients use the Tracking interface?",
				"answer": "No. Tracking is practitioner-facing by default and requires no client input."
			}
		]
	},
	{
		"toolType": "enactment",
		"slug": "enactment",
		"title": "Enactment Support Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only Enactment support view for initiation, facilitation, closing, and optional live-process notes.",
		"h1": "Enactment Support for Live Family Therapy Sessions",
		"intro": "Enactment is a practitioner-only live-session support tool. Family therapy practitioners use it to orient initiation, facilitation, and closing while bringing a problem-relevant interaction into the session so the pattern becomes visible and workable.",
		"demoTitle": "Open the phase-based demo, try optional notes, and save the tool for your account.",
		"demoPrompt": "Interested in using Enactment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0577-f-027-sft-008-r001-enactment.md",
		"specId": "0577-f-027-sft-008-r001-enactment",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Behavior change",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Why It Is Phase-Based",
				"body": "The supported structure is initiation, facilitation, and closing. The tool uses those phases to organize optional practitioner notes without prescribing exact prompts."
			},
			{
				"title": "Boundary From Observation Records",
				"body": "Use Enactment for live intervention support. Use an Enactment Observation Record when structured observed-interaction data is needed."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not score enactment quality, generate clinical scripts, or require a completed artifact."
			}
		],
		"faqItems": [
			{
				"question": "Does Enactment provide exact prompts or scripts?",
				"answer": "No. Exact enactment prompts and clinical scripts are unresolved in the product specification and should not be invented."
			},
			{
				"question": "Is there a client interface?",
				"answer": "No. Clients participate through live interaction, not through a product workflow."
			},
			{
				"question": "Can an enactment record be partial?",
				"answer": "Yes. An enactment may have initiation notes without facilitation or closing notes, and the partial state should be preserved."
			},
			{
				"question": "Does this replace the Enactment Observation Record?",
				"answer": "No. This tool supports the live intervention; structured observation and coding-ready review belong to the Enactment Observation Record."
			}
		]
	},
	{
		"toolType": "enactmentObservationRecord",
		"slug": "enactment-observation-record",
		"title": "Enactment Observation Record Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only record for therapist interventions, family responses, sequence order, labels, and enactment comparison.",
		"h1": "Enactment Observation Record for Family Therapy Review",
		"intro": "Enactment Observation Record is a practitioner-only structured observation tool. Family therapy practitioners use it to record therapist interventions, family member responses, sequence order, optional practitioner-provided labels, and comparisons across enactments or sessions.",
		"demoTitle": "Try the sample observation table, add events, and save the tool for your account.",
		"demoPrompt": "Interested in using Enactment Observation Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0578-f-027-sft-009-r001-enactment-observation-record.md",
		"specId": "0578-f-027-sft-009-r001-enactment-observation-record",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the practitioner needs reliable structured data about therapist interventions and family member responses during enactments."
			},
			{
				"title": "Labels Are Practitioner-Provided",
				"body": "The product may store local labels if the practitioner uses them, but it does not supply a complete coding manual or invent code categories."
			},
			{
				"title": "Comparison Limits",
				"body": "Comparison preserves original event sequences and compares like fields only where records contain comparable entries."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool include a coding manual?",
				"answer": "No. Exact intervention and response code categories are unresolved; the tool can store practitioner-provided labels without inventing a coding taxonomy."
			},
			{
				"question": "Can one response include multiple family members?",
				"answer": "Yes. A response entry should allow multiple actors when more than one family member is involved."
			},
			{
				"question": "Does the record infer whether an intervention was effective?",
				"answer": "No. The tool does not infer effectiveness, causality, or clinical conclusions."
			},
			{
				"question": "Can events be reordered after entry?",
				"answer": "Yes. Entries can be corrected or reordered while preserving the final observed sequence."
			}
		]
	},
	{
		"toolType": "boundaryMakingIntervention",
		"slug": "boundary-making-intervention",
		"title": "Boundary-Making Intervention Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only support tool for live boundary-making work with target, before pattern, after pattern, and review notes.",
		"h1": "Boundary-Making Intervention Support",
		"intro": "Boundary-Making Intervention is a practitioner-only live-session support tool. Family therapy practitioners use it to identify a targeted boundary problem, record the before and after boundary patterns, and review whether the relevant relationship or subsystem interaction shows a practitioner-recognized shift.",
		"demoTitle": "Explore a sample before/after capture, change timing, and save the tool for your account.",
		"demoPrompt": "Interested in using Boundary-Making Intervention with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0579-f-027-sft-010-r001-boundary-making-intervention.md",
		"specId": "0579-f-027-sft-010-r001-boundary-making-intervention",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the practitioner is working live with a boundary problem and wants a concise record of before and after boundary patterns."
			},
			{
				"title": "Partial Captures",
				"body": "A target-only or before-only capture is valid when the boundary problem is not yet observable or no after pattern has occurred."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not prescribe boundary-making steps, score boundary health, or claim that a shift generalized beyond the observed interaction."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool prescribe boundary-making interventions?",
				"answer": "No. The product supports target and before/after capture but does not provide scripts or prescribed practice steps."
			},
			{
				"question": "Who decides whether the after pattern is healthier?",
				"answer": "The practitioner records any interpretation. The system does not automatically determine boundary health."
			},
			{
				"question": "Can I save a before-only capture?",
				"answer": "Yes. Partial captures are supported when the intervention has not yet produced an after pattern."
			},
			{
				"question": "Should multiple targeted relationships go in one capture?",
				"answer": "No. If multiple relationships are targeted, each should be a separate capture."
			}
		]
	},
	{
		"toolType": "unbalancing",
		"slug": "unbalancing",
		"title": "Unbalancing Support Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only live-session Unbalancing support view with optional target, observed shift, and continuation notes.",
		"h1": "Unbalancing Support for Structural Family Therapy",
		"intro": "Unbalancing is a practitioner-only live-session support view. Family therapy practitioners use it to stay oriented to a problem-maintaining alignment or power pattern, optionally note an observed shift, and record possible leverage for further restructuring.",
		"demoTitle": "Open the sample support view, try an optional target-and-shift note, and save the tool for your account.",
		"demoPrompt": "Interested in using Unbalancing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0580-f-027-sft-011-r001-unbalancing.md",
		"specId": "0580-f-027-sft-011-r001-unbalancing",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Behavior change",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Why There Is No Required Output",
				"body": "The supplied product treats unbalancing as a live clinician-mediated intervention with no structured output requirement."
			},
			{
				"title": "Optional Notes",
				"body": "Notes can support practitioner continuity around target, shift, and continuation leverage, but the product remains usable with no notes."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not prescribe tactics, determine clinical appropriateness, score outcomes, or replace a mapping tool when structured before/after review is needed."
			}
		],
		"faqItems": [
			{
				"question": "Does Unbalancing provide a protocol or script?",
				"answer": "No. The product must not prescribe tactics or exact intervention steps because those details are not supplied."
			},
			{
				"question": "Is there a client task?",
				"answer": "No. Unbalancing is practitioner-led live-session work with no client product workflow."
			},
			{
				"question": "What happens if I do not enter notes?",
				"answer": "Nothing is incomplete. The tool has no required structured output."
			},
			{
				"question": "What is saved when there are no settings?",
				"answer": "The fixed Unbalancing tool itself is saved as-is, even though no configuration is required."
			}
		]
	},
	{
		"toolType": "reframing",
		"slug": "reframing",
		"title": "Reframing Tool for Structural Family Therapy | Qwoach",
		"metaDescription": "Document a live structural family therapy reframe from a blaming problem frame to a shared relational formulation and structural focus.",
		"h1": "Reframing for Structural Family Therapy Sessions",
		"intro": "Reframing is a live-session structural family therapy tool for practitioners. It helps the practitioner record a family's current blaming or symptom-focused frame, capture a shared less blaming relational formulation, and connect that formulation to a structural focus for continued work.",
		"demoTitle": "Try the before/after formulation view with sample session language, then save the tool for your practice.",
		"demoPrompt": "Interested in using Reframing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0581-f-027-sft-012-r001-reframing.md",
		"specId": "0581-f-027-sft-012-r001-reframing",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during or immediately after a structural family therapy session when shared meaning is shifting and the practitioner wants to document the old frame, the emerging reframe, and the structural focus."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not generate reframing language, assess family members, assign blame, produce scores, or prescribe the next intervention. The practitioner authors the clinical wording."
			}
		],
		"faqItems": [
			{
				"question": "Does Reframing create the reframe for me?",
				"answer": "No. The practitioner writes or revises the reframe based on the live clinical conversation."
			},
			{
				"question": "Is there a client form to complete?",
				"answer": "No. There is no standalone client form; family participation happens in the session conversation."
			},
			{
				"question": "Can I save an incomplete reframe?",
				"answer": "Yes. A draft can remain tentative or incomplete if shared wording has not yet emerged."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The fixed Reframing tool is saved to the practitioner's account. Fictional sample session content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "structuralHypothesis",
		"slug": "structural-hypothesis",
		"title": "Structural Hypothesis Tool for Family Therapy | Qwoach",
		"metaDescription": "Organize structural family therapy observations into a revisable hypothesis that links family patterns to possible intervention focus.",
		"h1": "Build a Testable Structural Hypothesis",
		"intro": "Structural Hypothesis is a practitioner-only structural family therapy tool. It helps practitioners organize assessment observations, state a testable understanding of family structure, and link that hypothesis to possible intervention focus.",
		"demoTitle": "Draft a sample hypothesis, inspect evidence and uncertainty, then save the tool to your account.",
		"demoPrompt": "Interested in using Structural Hypothesis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0582-f-027-sft-013-r001-structural-hypothesis.md",
		"specId": "0582-f-027-sft-013-r001-structural-hypothesis",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Revision Over Time",
				"body": "The hypothesis is expected to change as new interactional evidence emerges. Earlier versions remain distinguishable from the current working hypothesis when history is retained."
			},
			{
				"title": "Interpretation Boundary",
				"body": "The tool organizes practitioner-entered observations and uncertainty. It does not diagnose, create the hypothesis, or infer clinical meaning."
			}
		],
		"faqItems": [
			{
				"question": "Is Structural Hypothesis a diagnostic tool?",
				"answer": "No. It organizes structural family therapy assessment observations into a practitioner-authored hypothesis and intervention focus."
			},
			{
				"question": "Can I track competing hypotheses?",
				"answer": "Yes. Multiple candidate hypotheses can be recorded and marked as alternatives or tentative."
			},
			{
				"question": "Does the client complete anything?",
				"answer": "No. This is a practitioner-only tool informed by session information and assessment observations."
			},
			{
				"question": "What gets saved?",
				"answer": "The Structural Hypothesis tool is saved to the practitioner's account. Demo observations and fictional case content do not carry over as real client data."
			}
		]
	},
	{
		"toolType": "beforeAfterStructuralMap",
		"slug": "before-after-structural-map",
		"title": "Before/After Structural Map for Structural Family Therapy | Qwoach",
		"metaDescription": "Compare earlier and current structural family maps side by side, highlight visible changes, and add practitioner review notes.",
		"h1": "Compare Earlier and Current Family Structure",
		"intro": "Before/After Structural Map is a practitioner-only structural family therapy tool. It helps practitioners compare an earlier family structure with a current structure, highlight visible shifts, and connect those shifts to treatment goals or remaining obstacles.",
		"demoTitle": "Compare the sample maps, change the baseline, then save the tool for your account.",
		"demoPrompt": "Interested in using Before/After Structural Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0583-f-027-sft-014-r001-before-after-structural-map.md",
		"specId": "0583-f-027-sft-014-r001-before-after-structural-map",
		"tags": {
			"framework": [
				"Structural Family Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Outcome monitoring",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Comparable Map Scope",
				"body": "A useful comparison requires earlier and current maps that represent the same family scope and comparable structural dimensions."
			},
			{
				"title": "No Change Score",
				"body": "The tool highlights descriptive differences and supports practitioner notes. It does not compute clinical improvement or assert treatment success."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool score structural progress?",
				"answer": "No. It shows descriptive visual differences between two maps and leaves interpretation to the practitioner."
			},
			{
				"question": "What setting matters in the demo?",
				"answer": "Baseline selection matters because it determines which earlier structure the current map is compared against."
			},
			{
				"question": "Can I use it if one map is incomplete?",
				"answer": "Yes. The comparison can be saved as incomplete, and the missing or non-comparable parts should be visible."
			},
			{
				"question": "What gets saved after exploring?",
				"answer": "The Before/After Structural Map tool and intentional comparison setup are saved. Fictional demo maps do not become real client data."
			}
		]
	},
	{
		"toolType": "familyDiagramBowenFamilyDiagram",
		"slug": "family-diagram-bowen-family-diagram",
		"title": "Family Diagram Tool for Bowen Family Systems Work | Qwoach",
		"metaDescription": "Create a practitioner-only multigenerational family diagram with membership, major events, relationship patterns, and inquiry notes.",
		"h1": "Map a Multigenerational Family System",
		"intro": "Family Diagram / Bowen Family Diagram is a practitioner-only Bowen family systems tool. It helps practitioners organize family membership, major events, and relationship patterns across generations so they can form systems hypotheses for clinical work, coaching, or training.",
		"demoTitle": "Explore a sample multigenerational map, choose the scope, and save the tool for your account.",
		"demoPrompt": "Interested in using Family Diagram / Bowen Family Diagram with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0584-f-028-bow-001-r001-family-diagram-bowen-family-diagram.md",
		"specId": "0584-f-028-bow-001-r001-family-diagram-bowen-family-diagram",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Clinical history",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Incomplete Information Is Expected",
				"body": "Unknown names, uncertain relationships, incomplete events, and conflicting reports can be marked without forcing the map to appear finished."
			},
			{
				"title": "Practitioner Interpretation Remains Separate",
				"body": "The system organizes the visual structure. Systems hypotheses and clinical interpretation remain practitioner-authored."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic genealogy tool?",
				"answer": "No. It is a Bowen-oriented practitioner tool for clinical, coaching, or training inquiry, not a genealogy product."
			},
			{
				"question": "Can the diagram be incomplete?",
				"answer": "Yes. Incomplete diagrams can still guide further inquiry, and unknowns should remain visible."
			},
			{
				"question": "Does the tool interpret the family system?",
				"answer": "No. It lays out members, relationships, events, and patterns; hypotheses remain practitioner-authored."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The Family Diagram / Bowen Family Diagram tool and intentional scope setup are saved. Demo family content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "threeGenerationFamilyDiagram",
		"slug": "three-generation-family-diagram",
		"title": "Three-Generation Family Diagram for Bowen Work | Qwoach",
		"metaDescription": "Build a shared three-generation family diagram with family structure, significant events, relationship patterns, and uncertainty markers.",
		"h1": "Create a Shared Three-Generation Family Diagram",
		"intro": "Three-Generation Family Diagram is a shared Bowen family systems tool for practitioners and clients. It helps them create a factual three-generation picture of family structure, significant events, and relationship patterns so cross-generational patterns can be discussed.",
		"demoTitle": "Try the shared diagram with sample data, then save the tool for your practice.",
		"demoPrompt": "Interested in using Three-Generation Family Diagram with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0585-f-028-bow-002-r001-three-generation-family-diagram.md",
		"specId": "0585-f-028-bow-002-r001-three-generation-family-diagram",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"In-session support"
			],
			"topic": [
				"Clinical history",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Shared Roles",
				"body": "The client helps provide or correct family information while the practitioner guides completion and controls clinical documentation."
			},
			{
				"title": "Unknowns Are Allowed",
				"body": "Blank branches, uncertain relationships, and incomplete events can remain visible so the diagram can guide further inquiry."
			}
		],
		"faqItems": [
			{
				"question": "Can I change the diagram to more than three generations?",
				"answer": "No. The three-generation scope is fixed for this tool."
			},
			{
				"question": "Does the client complete this alone?",
				"answer": "No. The product is designed as a shared-session experience guided by the practitioner."
			},
			{
				"question": "Does the tool identify emotional processes automatically?",
				"answer": "No. It organizes the three-generation picture and may highlight visible repeated patterns descriptively, but interpretation remains practitioner-guided."
			},
			{
				"question": "What saves after the demo?",
				"answer": "The fixed Three-Generation Family Diagram tool is saved. Fictional demo family data does not carry over as real client data."
			}
		]
	},
	{
		"toolType": "triangleMap",
		"slug": "triangle-map",
		"title": "Triangle Map for Bowen Relationship Patterns | Qwoach",
		"metaDescription": "Map a recurring three-person relationship pattern with roles, triggers, reactive sequence, and a client-identified shift point.",
		"h1": "Map a Three-Person Reactivity Pattern",
		"intro": "Triangle Map is a shared Bowen family systems tool for practitioners and clients. It helps them identify a recurring three-person relationship pattern, describe roles, triggers, and reactive sequence, and locate where the client may shift their own functioning.",
		"demoTitle": "Complete a sample triangle, review the sequence, and save the tool for your practice.",
		"demoPrompt": "Interested in using Triangle Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0586-f-028-bow-003-r001-triangle-map.md",
		"specId": "0586-f-028-bow-003-r001-triangle-map",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Emotion regulation"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Exactly Three Participants",
				"body": "Each Triangle Map represents one three-person unit. More complex cases use separate linked maps rather than expanding one map into a generic network."
			},
			{
				"title": "No Blame Assignment",
				"body": "The tool describes roles, triggers, and sequences as entered. It does not infer responsibility or prescribe a response."
			}
		],
		"faqItems": [
			{
				"question": "Can a triangle include more than three people?",
				"answer": "No. One map has exactly three primary participants; additional people require separate triangle maps."
			},
			{
				"question": "Does the tool provide role categories?",
				"answer": "No. Role or position notes are practitioner/client-authored because fixed role categories are not supplied in the specification."
			},
			{
				"question": "Can a map be saved without a shift point?",
				"answer": "Yes. It can be marked incomplete if the shift point is not yet clear."
			},
			{
				"question": "What saves into my account?",
				"answer": "The Triangle Map tool is saved. Fictional demo participants and sequence details do not become real client data."
			}
		]
	},
	{
		"toolType": "nuclearFamilyEmotionalProcessMap",
		"slug": "nuclear-family-emotional-process-map",
		"title": "Nuclear Family Emotional Process Map | Qwoach",
		"metaDescription": "Organize Bowen-oriented observations of nuclear family stress, recurring responses, symptoms or conflict, and emotional process.",
		"h1": "Map a Nuclear Family Anxiety-Management Pattern",
		"intro": "Nuclear Family Emotional Process Map is a practitioner-only Bowen family systems tool. It helps practitioners organize how a nuclear family responds to stress or anxiety, connect symptoms or conflict to the wider emotional process, and guide further questioning or coaching.",
		"demoTitle": "Map a sample stress-response pattern, review the process chain, and save the tool.",
		"demoPrompt": "Interested in using Nuclear Family Emotional Process Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0587-f-028-bow-004-r001-nuclear-family-emotional-process-map.md",
		"specId": "0587-f-028-bow-004-r001-nuclear-family-emotional-process-map",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Emotion regulation"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Mechanism Categories Are Not Predefined Here",
				"body": "The supplied specification notes four primary mechanisms but does not provide exact labels or definitions, so the demo uses practitioner-authored pattern fields instead of invented options."
			},
			{
				"title": "Process Versus Content",
				"body": "The tool keeps dispute content examples separate from the practitioner's formulation of the recurring family emotional process."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool include the four mechanism categories?",
				"answer": "No. The supplied product specification does not define exact category labels or descriptions, so they are not exposed as options."
			},
			{
				"question": "Is this a symptom checklist?",
				"answer": "No. It maps a practitioner-authored emotional process formulation rather than scoring symptoms."
			},
			{
				"question": "Can I record multiple possible patterns?",
				"answer": "Yes. Competing tentative formulations can be recorded without forcing a final pattern."
			},
			{
				"question": "What saves after the demo?",
				"answer": "The Nuclear Family Emotional Process Map tool is saved. Fictional examples and temporary demo formulations do not become real client data."
			}
		]
	},
	{
		"toolType": "familyProjectionProcessMap",
		"slug": "family-projection-process-map",
		"title": "Family Projection Process Map for Bowen Work | Qwoach",
		"metaDescription": "Map adult worry or involvement, a focal child's response, relational context, and possible adult shift points without child labeling.",
		"h1": "Map a Focal-Child Pattern as a Relational Sequence",
		"intro": "Family Projection Process Map is a shared Bowen family systems tool for practitioners and parents or caregivers. It helps them understand how family anxiety may be directed toward a focal child, how the child responds in relational context, and where adult functioning could change.",
		"demoTitle": "Complete a sample sequence, review the adult shift point, and save the tool.",
		"demoPrompt": "Interested in using Family Projection Process Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0588-f-028-bow-005-r001-family-projection-process-map.md",
		"specId": "0588-f-028-bow-005-r001-family-projection-process-map",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Emotion regulation"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Non-Blaming Structure",
				"body": "The layout emphasizes adult-process context and child response in sequence, rather than representing the child as a fixed problem."
			},
			{
				"title": "Step Wording Boundary",
				"body": "The supplied specification does not provide exact source step wording, so the demo uses generic sequence positions rather than hard-coded step labels."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool diagnose the child?",
				"answer": "No. It maps a relational sequence and does not diagnose, label, or score the child."
			},
			{
				"question": "Does it provide parenting advice?",
				"answer": "No. It helps identify where adult functioning could shift, but it does not prescribe parenting techniques."
			},
			{
				"question": "Can the map be incomplete?",
				"answer": "Yes. Partial sequences can be saved as tentative or incomplete."
			},
			{
				"question": "What saves after exploration?",
				"answer": "The Family Projection Process Map tool is saved. Fictional focal-child demo content does not become real client data."
			}
		]
	},
	{
		"toolType": "multigenerationalTransmissionPatternMap",
		"slug": "multigenerational-transmission-pattern-map",
		"title": "Multigenerational Transmission Pattern Map | Qwoach",
		"metaDescription": "Trace recurring relationship or functioning patterns across generations with evidence notes, uncertainty, and current-functioning links.",
		"h1": "Trace a Relationship Pattern Across Generations",
		"intro": "Multigenerational Transmission Pattern Map is a practitioner-only Bowen family systems tool. It helps practitioners trace recurring relationship or functioning patterns across generations, connect them to family relationships, and use the map to guide further family research or clinical hypotheses.",
		"demoTitle": "Choose a sample pattern focus, trace it across generations, and save the tool.",
		"demoPrompt": "Interested in using Multigenerational Transmission Pattern Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0589-f-028-bow-006-r001-multigenerational-transmission-pattern-map.md",
		"specId": "0589-f-028-bow-006-r001-multigenerational-transmission-pattern-map",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Clinical history",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Pattern Focus Matters",
				"body": "Each map traces one selected relationship or functioning pattern. Multiple patterns should remain separate or clearly layered rather than merged into one conclusion."
			},
			{
				"title": "Descriptive, Not Deterministic",
				"body": "The tool can show recurrence and evidence gaps, but it does not assert transmission, causality, genetic inheritance, or diagnosis."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool prove that a pattern was transmitted?",
				"answer": "No. It traces descriptive recurrence and leaves interpretation to the practitioner."
			},
			{
				"question": "Can I use partial family history?",
				"answer": "Yes. Partial generational evidence and uncertainty markers are supported."
			},
			{
				"question": "What is the main setting?",
				"answer": "Pattern focus selection is the main setting because it determines what the map traces."
			},
			{
				"question": "What gets saved after the demo?",
				"answer": "The Multigenerational Transmission Pattern Map tool and intentional pattern-focus setup are saved. Fictional demo history does not become real client data."
			}
		]
	},
	{
		"toolType": "emotionalCutoffMap",
		"slug": "emotional-cutoff-map",
		"title": "Emotional Cutoff Map for Bowen Family Systems Work | Qwoach",
		"metaDescription": "Map family relationship distance, no contact, or withdrawal with descriptive intensity, consequences, and current-functioning links.",
		"h1": "Map Emotional Cutoff Without Prescribing Contact",
		"intro": "Emotional Cutoff Map is a shared Bowen family systems tool for practitioners and clients. It helps them identify where emotional cutoffs exist, describe the form and intensity of distance, and connect relational consequences to current functioning.",
		"demoTitle": "Map a sample cutoff relationship, review the consequences, and save the tool.",
		"demoPrompt": "Interested in using Emotional Cutoff Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0590-f-028-bow-007-r001-emotional-cutoff-map.md",
		"specId": "0590-f-028-bow-007-r001-emotional-cutoff-map",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Assessment"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "No Contact Prescription",
				"body": "The tool maps distance and consequences. It does not recommend contact, reconciliation, separation, or any safety/legal action."
			},
			{
				"title": "Descriptive Intensity",
				"body": "Because no standardized cutoff scale is supplied, intensity is captured through descriptive practitioner/client language."
			}
		],
		"faqItems": [
			{
				"question": "Does Emotional Cutoff Map tell a client to reconnect?",
				"answer": "No. It does not prescribe contact, reconciliation, or separation."
			},
			{
				"question": "Is intensity scored?",
				"answer": "No. Intensity is descriptive unless a defined scale is supplied later."
			},
			{
				"question": "Can multiple cutoffs be mapped?",
				"answer": "Yes. Multiple affected relationships can be entered separately on one map."
			},
			{
				"question": "What saves into my account?",
				"answer": "The Emotional Cutoff Map tool is saved. Fictional demo relationship data and sample notes do not become real client data."
			}
		]
	},
	{
		"toolType": "differentiationSelfObservationLog",
		"slug": "differentiation-self-observation-log",
		"title": "Differentiation Self-Observation Log Demo | Qwoach",
		"metaDescription": "Preview a Bowen-oriented self-observation log for tracking client reactivity, responses, and relationship patterns between sessions.",
		"h1": "Differentiation Self-Observation Log",
		"intro": "Differentiation Self-Observation Log is a ready-to-send Bowen-oriented observation tool for practitioners working with clients on differentiation between sessions. It helps the practitioner and client collect repeated descriptive observations of relational contexts, emotional reactivity, automatic reactions, more thoughtful responses, and relationship responses over time.",
		"demoTitle": "Explore the log with sample relationship observations, then save the tool for your practice.",
		"demoPrompt": "Interested in using Differentiation Self-Observation Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0591-f-028-bow-008-r001-differentiation-self-observation-log.md",
		"specId": "0591-f-028-bow-008-r001-differentiation-self-observation-log",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Emotion regulation",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it between sessions when the practitioner needs repeated, specific observations of relationship situations that trigger reactivity and show how the client responds."
			},
			{
				"title": "What It Captures",
				"body": "The log captures real relational context, trigger description, automatic emotional reaction, more thoughtful response when reported, relationship response, completion status, timestamps or sequence order, and practitioner review markers."
			},
			{
				"title": "Limits",
				"body": "The tool is descriptive. It does not assign a differentiation level, diagnose the client, prescribe steps, or interpret family-system meaning without practitioner review."
			}
		],
		"faqItems": [
			{
				"question": "Is this a scored differentiation assessment?",
				"answer": "No. The log does not score differentiation or assign a level; it organizes repeated descriptive observations for practitioner review."
			},
			{
				"question": "Can the practitioner focus the log on one relationship context?",
				"answer": "Yes. The practitioner can leave observation open-ended or specify a relevant relationship context for the client to watch."
			},
			{
				"question": "What happens to incomplete client entries?",
				"answer": "Incomplete entries are saved separately and marked incomplete so they are not mistaken for reviewed observations."
			},
			{
				"question": "Does the demo require real client information?",
				"answer": "No. The public demo uses fictional sample entries and placeholders so visitors can explore without entering sensitive or identifying information."
			}
		]
	},
	{
		"toolType": "iPositionExercise",
		"slug": "i-position-exercise",
		"title": "I-Position Exercise Demo | Qwoach",
		"metaDescription": "Preview a Bowen-oriented I-position exercise for drafting a self-defined position, checking blame/control, and reviewing relational response.",
		"h1": "I-Position Exercise",
		"intro": "I-Position Exercise is a Bowen-oriented shared exercise for practitioners and clients working on self-definition under relationship pressure. It helps a client draft an I-position from their own thinking and responsibility, distinguish it from blame or directing another person, and consider likely relational responses.",
		"demoTitle": "Try a sample I-position draft and review how the exercise separates position, blame/control checks, and relational response.",
		"demoPrompt": "Interested in using I-Position Exercise with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0592-f-028-bow-009-r001-i-position-exercise.md",
		"specId": "0592-f-028-bow-009-r001-i-position-exercise",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client is reacting under relationship pressure and needs to state a position from self-responsibility rather than blame or control."
			},
			{
				"title": "Practitioner And Client Roles",
				"body": "The client supplies the situation, draft, and reflections. The practitioner frames the exercise, guides revision, and may add coaching notes."
			},
			{
				"title": "Limits",
				"body": "The exercise does not provide a correctness score, clinical interpretation, or script for changing another person."
			}
		],
		"faqItems": [
			{
				"question": "Is the I-position automatically judged as correct?",
				"answer": "No. The tool organizes the draft and reflection sections, but it does not judge clinical quality or score the statement."
			},
			{
				"question": "Can the client complete it before session?",
				"answer": "Yes. Completion mode can be set to client draft before practitioner review."
			},
			{
				"question": "What if the client writes a statement that directs another person?",
				"answer": "The statement can remain in the draft and be visibly marked for revision rather than rejected."
			},
			{
				"question": "Does the demo use real relationship details?",
				"answer": "No. The demo uses fictional placeholders so visitors can explore without entering identifying or sensitive information."
			}
		]
	},
	{
		"toolType": "familyOfOriginResearchPlan",
		"slug": "family-of-origin-research-plan",
		"title": "Family-of-Origin Research Plan Demo | Qwoach",
		"metaDescription": "Preview a Bowen-oriented research plan for organizing family-of-origin facts, relationship information, events, open questions, and findings.",
		"h1": "Family-of-Origin Research Plan",
		"intro": "Family-of-Origin Research Plan is a Bowen-oriented planning and tracking tool for practitioners and clients gathering multigenerational family facts, relationship information, and relevant events. It helps them identify what is known, what remains unknown, what new information has been gathered, and how findings relate to observation of the client's own functioning.",
		"demoTitle": "Explore a sample research plan, adjust its focus, and review how findings and uncertainty are organized.",
		"demoPrompt": "Interested in using Family-of-Origin Research Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0593-f-028-bow-010-r001-family-of-origin-research-plan.md",
		"specId": "0593-f-028-bow-010-r001-family-of-origin-research-plan",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Clinical history",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when current coaching needs better evidence about family-of-origin facts, relationships, or events rather than impressions alone."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures research focus, known information, open questions, new findings, uncertainty labels, fact/impression distinctions, client reflections, and practitioner review notes."
			},
			{
				"title": "Limits",
				"body": "The tool is not a generic family-history builder and does not automatically infer family-system meaning or require a complete family tree."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create a family diagram?",
				"answer": "No. It can organize information that may later inform a family diagram, but a diagram is not part of the required mechanic."
			},
			{
				"question": "Can unknown or conflicting information be recorded?",
				"answer": "Yes. Unknown, uncertain, and conflicting information can remain in the plan without forcing certainty."
			},
			{
				"question": "Does the system generate Bowen hypotheses?",
				"answer": "No. It organizes findings and open questions; hypotheses remain practitioner-interpreted."
			},
			{
				"question": "Can the plan continue across sessions?",
				"answer": "Yes. The persisted plan supports updates, open questions, new findings, and practitioner review across sessions."
			}
		]
	},
	{
		"toolType": "detrianglingPractice",
		"slug": "detriangling-practice",
		"title": "Detriangling Practice Demo | Qwoach",
		"metaDescription": "Preview a Bowen-oriented live-session detriangling support with optional notes for role, triangle pressure, response, and next focus.",
		"h1": "Detriangling Practice",
		"intro": "Detriangling Practice is a Bowen-oriented live-session coaching support for practitioners working with clients caught in recurring triangle pressure. It helps the practitioner focus on the client's usual role, pressure to take sides, mediate, rescue, or withdraw, and a self-responsible response that supports staying connected with less reactivity.",
		"demoTitle": "Explore the live prompt surface and optional brief note mode.",
		"demoPrompt": "Interested in using Detriangling Practice with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0594-f-028-bow-011-r001-detriangling-practice.md",
		"specId": "0594-f-028-bow-011-r001-detriangling-practice",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Emotion regulation",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it in live coaching when triangle pressure is active and the client is trying to manage others' relationships, take sides, rescue, mediate, withdraw, or absorb anxiety."
			},
			{
				"title": "Why The Artifact Is Optional",
				"body": "The supplied product is a live-session practice with no inherent artifact. A brief note is optional for continuity only."
			},
			{
				"title": "Limits",
				"body": "The tool does not classify triangles, score detriangling capacity, require client homework, or automate interpretation of relationship dynamics."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client form to send?",
				"answer": "No. The product has no required separate client-facing form; it is used in live session."
			},
			{
				"question": "Can the practitioner save nothing from the session?",
				"answer": "Yes. Artifact mode can be set to no saved artifact, and the live practice support is still saved as a tool."
			},
			{
				"question": "What does brief-note mode save?",
				"answer": "Brief-note mode can save a concise practitioner note about role, pressure, self-responsible response, and next focus."
			},
			{
				"question": "Does the tool score triangle dynamics?",
				"answer": "No. It does not score, classify, or automatically interpret triangle dynamics."
			}
		]
	},
	{
		"toolType": "bowenTheoryCoaching",
		"slug": "bowen-theory-coaching",
		"title": "Bowen Theory Coaching Demo | Qwoach",
		"metaDescription": "Preview a Bowen coaching session support for organizing self-observation, relationship process, family-system facts, hypotheses, and next steps.",
		"h1": "Bowen Theory Coaching",
		"intro": "Bowen Theory Coaching is a live session-based coaching or consultation configuration for Bowen family systems therapists, coaches, consultants, and faculty practitioners. It helps organize a client's self-observation, family-system facts, working hypotheses, and next steps focused on the client's own functioning in family or work relationship systems.",
		"demoTitle": "Explore a sample coaching session workspace and choose what summary, if any, would be shared with a client.",
		"demoPrompt": "Interested in using Bowen Theory Coaching with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0595-f-028-bow-012-r001-bowen-theory-coaching.md",
		"specId": "0595-f-028-bow-012-r001-bowen-theory-coaching",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support",
				"Clinical documentation"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Couples",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during or after live Bowen coaching or consultation when the practitioner needs continuity around self-observation, relationship process, family-system facts, hypotheses, and next steps."
			},
			{
				"title": "Practitioner-Controlled Summaries",
				"body": "The practitioner controls the coaching record and any client-facing summary. Shared summaries should reflect client-owned observations and next steps, not independent system interpretation."
			},
			{
				"title": "Limits",
				"body": "The product is not a generic therapy note, scored assessment, treatment-plan builder, or automated Bowen-theory interpreter."
			}
		],
		"faqItems": [
			{
				"question": "Is this a worksheet for clients to complete?",
				"answer": "No. It is a live session-based coaching configuration; clients contribute through conversation, not a required standalone form."
			},
			{
				"question": "Can the practitioner share a summary with the client?",
				"answer": "Yes. Summary sharing can be set to practitioner-only or shared client summary."
			},
			{
				"question": "Does the system create Bowen hypotheses automatically?",
				"answer": "No. Hypotheses are practitioner working hypotheses; the system only organizes them."
			},
			{
				"question": "What contexts are supported?",
				"answer": "Supported coaching contexts are individual, couple, family, leader, and trainee."
			}
		]
	},
	{
		"toolType": "bowenianProcessQuestions",
		"slug": "bowenian-process-questions",
		"title": "Bowenian Process Questions Demo | Qwoach",
		"metaDescription": "Preview Bowenian process-question support for live sessions, with optional notes on sequence, reactivity, client role, and dynamics.",
		"h1": "Bowenian Process Questions",
		"intro": "Bowenian Process Questions is a live in-session questioning configuration for Bowenian family therapy and family-systems practice. It helps practitioners ask or capture process-focused questions about interaction sequence, emotional reactivity, the client's role and choices, and triangulation when relevant.",
		"demoTitle": "Try a process focus, use prompt-only mode, or create a sample process note.",
		"demoPrompt": "Interested in using Bowenian Process Questions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0596-f-028-bow-012-r002-bowenian-process-questions.md",
		"specId": "0596-f-028-bow-012-r002-bowenian-process-questions",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Emotion regulation",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it in live sessions when discussion is organized around fault, content disputes, or emotionally reactive descriptions and the practitioner wants to clarify relationship process."
			},
			{
				"title": "Prompt-Only Or Notes",
				"body": "Prompt-only mode supports the live conversation without creating an artifact. Prompt-plus-note mode creates a concise process map for later review."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide a client questionnaire, score, diagnosis, or definitive interpretation of family process."
			}
		],
		"faqItems": [
			{
				"question": "Is triangulation always part of the note?",
				"answer": "No. Triangulation is available when relevant but should not be forced into every process map."
			},
			{
				"question": "Can the tool be used without saving session notes?",
				"answer": "Yes. Prompt-only mode supports live questioning without a reviewable artifact."
			},
			{
				"question": "Does the tool supply exact required questions?",
				"answer": "No. Exact substantive wording is unresolved; the tool supports functional focus areas for practitioner-led questioning."
			},
			{
				"question": "Can content-dispute details be recorded?",
				"answer": "Yes. They can be captured, but they should remain visually separate from process observations."
			}
		]
	},
	{
		"toolType": "bowenianRelationshipExperiments",
		"slug": "bowenian-relationship-experiments",
		"title": "Bowenian Relationship Experiments Demo | Qwoach",
		"metaDescription": "Preview a Bowenian relationship experiment tool for planning a less reactive action, observing system response, and reviewing what was learned.",
		"h1": "Bowenian Relationship Experiments",
		"intro": "Bowenian Relationship Experiments is a between-session planning and review tool for Bowenian family systems practitioners and clients. It helps connect a repeated emotional-response pattern to a specific alternative action, then collect observations about the client's functioning, the relationship system's response, and what supported or interfered with less reactive action.",
		"demoTitle": "Build a sample experiment, enter fictional observations, and review the plan versus reported attempt.",
		"demoPrompt": "Interested in using Bowenian Relationship Experiments with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0597-f-028-bow-012-r003-bowenian-relationship-experiments.md",
		"specId": "0597-f-028-bow-012-r003-bowenian-relationship-experiments",
		"tags": {
			"framework": [
				"Bowen family systems"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after a repeated emotional-response pattern has been clarified and the client is ready to test a more thoughtful response in the relationship system."
			},
			{
				"title": "History And Comparison",
				"body": "Repeated experiments can be retained as qualitative history, showing planned actions, attempts, observations, and practitioner review without scoring progress."
			},
			{
				"title": "Limits",
				"body": "The tool does not import generic prediction-testing fields, score success, diagnose, or automate clinical interpretation."
			}
		],
		"faqItems": [
			{
				"question": "What if the client does not attempt the experiment?",
				"answer": "The client can mark it not attempted and record what interfered, so the information remains useful for review."
			},
			{
				"question": "Does the tool rate the experiment as successful or failed?",
				"answer": "No. It records qualitative observations and status; it does not assign success or failure scores."
			},
			{
				"question": "Can observation focus be limited to the client?",
				"answer": "Yes. Observation focus can be client functioning, system response, or both."
			},
			{
				"question": "Are planned action and actual attempt kept separate?",
				"answer": "Yes. The tool distinguishes the planned alternative action from what the client reports actually happened."
			}
		]
	},
	{
		"toolType": "eybergChildBehaviorInventoryEcbi",
		"slug": "eyberg-child-behavior-inventory-ecbi",
		"title": "ECBI Demo for PCIT Practitioners | Qwoach",
		"metaDescription": "Preview ECBI administration and review for PCIT, including Intensity and Problem scores, item-level profile, and longitudinal comparison.",
		"h1": "Eyberg Child Behavior Inventory (ECBI)",
		"intro": "Eyberg Child Behavior Inventory (ECBI) is a standardized repeated caregiver-report measure for PCIT practitioners who need to quantify child disruptive behavior problems at intake, during treatment, or termination. It helps the practitioner review Intensity and Problem scores, item-level concerns, and score changes across administrations.",
		"demoTitle": "Preview the assignment, caregiver completion, and practitioner review experience with sample non-client data.",
		"demoPrompt": "Interested in using Eyberg Child Behavior Inventory (ECBI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0598-f-029-pcit-001-r001-eyberg-child-behavior-inventory-ecbi.md",
		"specId": "0598-f-029-pcit-001-r001-eyberg-child-behavior-inventory-ecbi",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it in PCIT contexts at intake, during treatment, or termination when repeated caregiver-report behavior ratings are needed for practitioner review."
			},
			{
				"title": "What It Shows",
				"body": "The review shows Intensity and Problem scores, item-level profile, administration time point, prior administrations, and change over time when administrations are validly completed."
			},
			{
				"title": "Limits",
				"body": "The public demo does not invent ECBI items, response options, scoring rules, cutoffs, or interpretations. Those must come from the instrument specification before implementation."
			}
		],
		"faqItems": [
			{
				"question": "Can the practitioner change ECBI items or scoring?",
				"answer": "No. The ECBI is a standardized measure, and the product does not make instrument content or scoring configurable."
			},
			{
				"question": "What settings are available?",
				"answer": "The supported setup is administration time point, such as intake, during treatment, or termination, plus recipient assignment."
			},
			{
				"question": "Are incomplete administrations scored?",
				"answer": "No. Incomplete administrations are marked incomplete and excluded from final score comparison until validly completed."
			},
			{
				"question": "Does the demo require real caregiver or child data?",
				"answer": "No. The public demo uses sample non-real data and placeholders for exploration."
			}
		]
	},
	{
		"toolType": "dyadicParentChildInteractionCodingSystemDpics",
		"slug": "dyadic-parent-child-interaction-coding-system-dpics",
		"title": "DPICS Demo for PCIT Practitioners | Qwoach",
		"metaDescription": "Preview DPICS practitioner-only coding for parent skills, commands, child compliance, interaction behavior, and longitudinal review.",
		"h1": "Dyadic Parent-Child Interaction Coding System (DPICS)",
		"intro": "Dyadic Parent-Child Interaction Coding System (DPICS) is a practitioner-only structured observational coding system for PCIT practitioners. It helps record parent skill counts or categories, parent commands, child compliance, and interaction behavior so the practitioner can identify coaching targets and compare change across coding sessions.",
		"demoTitle": "Preview a sample coding session, completion state, and longitudinal review using non-real data.",
		"demoPrompt": "Interested in using Dyadic Parent-Child Interaction Coding System (DPICS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0599-f-029-pcit-002-r001-dyadic-parent-child-interaction-coding-system-dpics.md",
		"specId": "0599-f-029-pcit-002-r001-dyadic-parent-child-interaction-coding-system-dpics",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Skills use",
				"Outcome monitoring",
				"Problem behavior"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The practitioner creates and controls the coding session. Parent and child behavior is observed during treatment, but they do not complete product forms."
			},
			{
				"title": "What It Shows",
				"body": "The review shows structured coding data, coding context, completion or finalization status, category summaries, and comparison with prior coding sessions."
			},
			{
				"title": "Limits",
				"body": "The public demo does not invent DPICS code definitions, timing rules, scoring algorithms, mastery rules, or unsupported behavior categories."
			}
		],
		"faqItems": [
			{
				"question": "Do parents or children complete anything in DPICS?",
				"answer": "No. In this configuration DPICS is practitioner-only; parent and child participate in the observed interaction."
			},
			{
				"question": "Can partial coding sessions be compared as full sessions?",
				"answer": "No. Partial sessions must be clearly marked incomplete or limited and not treated as full comparable data."
			},
			{
				"question": "Does the tool automatically judge parenting quality?",
				"answer": "No. It summarizes coded observations and leaves interpretation to the practitioner."
			},
			{
				"question": "What setup can the practitioner change?",
				"answer": "The practitioner can set coding session context or segment label and manage coding state; DPICS semantics are not configurable in the demo."
			}
		]
	},
	{
		"toolType": "cdiHomeworkSpecialTimeSheet",
		"slug": "cdi-homework-special-time-sheet",
		"title": "CDI Homework Sheet Demo for PCIT | Qwoach",
		"metaDescription": "Preview a PCIT CDI homework sheet for tracking home practice, missed entries, barriers, interval summaries, and practitioner review.",
		"h1": "CDI Homework / Special Time Sheet",
		"intro": "CDI Homework / Special Time Sheet is a ready-to-send PCIT home-practice adherence and barrier-tracking tool for practitioners assigning child-directed interaction practice between sessions. It helps the practitioner understand whether the caregiver carried skills into home routines and what barriers interfered, so coaching can address current home-practice needs.",
		"demoTitle": "Preview a sample practice interval, caregiver entries, and practitioner review summary.",
		"demoPrompt": "Interested in using CDI Homework / Special Time Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0600-f-029-pcit-003-r001-cdi-homework-special-time-sheet.md",
		"specId": "0600-f-029-pcit-003-r001-cdi-homework-special-time-sheet",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring"
			],
			"topic": [
				"Homework",
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after a PCIT session when the caregiver is expected to practice child-directed interaction skills at home before the next session."
			},
			{
				"title": "What It Captures",
				"body": "The sheet captures practice completion information, missed or unclear entries, barriers to home use, interval completion status, and practitioner review notes."
			},
			{
				"title": "Limits",
				"body": "The tool does not teach the CDI skill set, score parent skill quality, score child behavior, or generate automated treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the sheet measure CDI skill quality?",
				"answer": "No. It tracks home-practice adherence and barriers, not skill quality."
			},
			{
				"question": "Can caregivers record barriers without long explanations?",
				"answer": "Yes. Barriers can be recorded briefly so missed or difficult practice is visible without requiring a long narrative."
			},
			{
				"question": "Are missed entries treated as no practice?",
				"answer": "No. Missed entries are distinguishable from reported no practice or unclear information."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool and selected practice-interval setup are saved; fictional practice entries and sample barriers are not saved as real client data."
			}
		]
	},
	{
		"toolType": "prideSkillsTracking",
		"slug": "pride-skills-tracking",
		"title": "PRIDE Skills Tracking Demo for PCIT Practitioners | Qwoach",
		"metaDescription": "Track observed PRIDE skill counts, mastery status, and session-to-session patterns during PCIT child-directed interaction coaching.",
		"h1": "PRIDE Skills Tracking for PCIT CDI Sessions",
		"intro": "PRIDE Skills Tracking is a PCIT child-directed interaction tool for practitioners. It helps practitioners record observed caregiver use of targeted positive interaction skills, mark mastery status, and compare patterns across sessions to support coaching focus and readiness decisions.",
		"demoTitle": "Try a sample CDI observation",
		"demoPrompt": "Interested in using PRIDE Skills Tracking with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0601-f-029-pcit-004-r001-pride-skills-tracking.md",
		"specId": "0601-f-029-pcit-004-r001-pride-skills-tracking",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Skills use",
				"Outcome monitoring"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "This tool is used during or immediately after CDI caregiver-child interaction observation when the practitioner needs quantified skill-frequency and mastery information."
			},
			{
				"title": "Limits",
				"body": "The tool does not diagnose caregiver capacity, explain why a skill changed, provide hidden scoring, or automatically decide phase transition."
			}
		],
		"faqItems": [
			{
				"question": "Does the caregiver need to enter data?",
				"answer": "No. The practitioner can complete the tracker from observed caregiver behavior. A caregiver may review a shared summary if the practitioner chooses."
			},
			{
				"question": "What does the result show?",
				"answer": "The result shows observed counts by skill type, practitioner-entered mastery status, prior-session comparison, and descriptive trend direction."
			},
			{
				"question": "Can partial observations be saved?",
				"answer": "Yes. Partial observations are labeled separately so they do not distort completed-session longitudinal patterns."
			}
		]
	},
	{
		"toolType": "avoidSkillsTracking",
		"slug": "avoid-skills-tracking",
		"title": "Avoid Skills Tracking Demo for PCIT Practitioners | Qwoach",
		"metaDescription": "Count observed CDI avoid behaviors, review high-frequency targets, and compare descriptive trends across PCIT child-directed interaction sessions.",
		"h1": "Avoid Skills Tracking for PCIT CDI Coaching",
		"intro": "Avoid Skills Tracking is a PCIT child-directed interaction tool for practitioners. It helps practitioners record how often caregivers use interaction behaviors targeted for reduction, compare those counts across sessions, and identify remaining coaching priorities.",
		"demoTitle": "Try a sample avoid-skills count",
		"demoPrompt": "Interested in using Avoid Skills Tracking with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0602-f-029-pcit-005-r001-avoid-skills-tracking.md",
		"specId": "0602-f-029-pcit-005-r001-avoid-skills-tracking",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Outcome monitoring"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during live or near-live CDI observation when target reduction behaviors need to be counted consistently."
			},
			{
				"title": "Limits",
				"body": "The tool does not explain why behaviors occur, generate coaching instructions, score severity, or decide phase readiness automatically."
			}
		],
		"faqItems": [
			{
				"question": "What is counted in this tool?",
				"answer": "The tool counts observed caregiver interaction behaviors targeted for reduction during the relevant CDI interaction period."
			},
			{
				"question": "Does zero mean the same thing as missing data?",
				"answer": "No. Zero means the behavior was observed as absent; not recorded or unobserved categories are labeled separately."
			},
			{
				"question": "Can the trend show readiness to progress?",
				"answer": "The trend can support a practitioner readiness judgment, but the system does not make an automatic readiness decision."
			}
		]
	},
	{
		"toolType": "cdiSkillMasteryCheck",
		"slug": "cdi-skill-mastery-check",
		"title": "CDI Skill Mastery Check Demo | Qwoach",
		"metaDescription": "Review recent observed CDI evidence, mark mastered and not-yet-mastered skill areas, and record a practitioner-controlled mastery determination.",
		"h1": "CDI Skill Mastery Check for PCIT Practitioners",
		"intro": "CDI Skill Mastery Check is a practitioner-only PCIT tool. It helps practitioners review recent observed child-directed interaction evidence, mark required skill areas as mastered or not yet mastered, and record an explicit current mastery determination.",
		"demoTitle": "Review a sample mastery check",
		"demoPrompt": "Interested in using CDI Skill Mastery Check with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0603-f-029-pcit-006-r001-cdi-skill-mastery-check.md",
		"specId": "0603-f-029-pcit-006-r001-cdi-skill-mastery-check",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Skills use",
				"Outcome monitoring"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the practitioner is reviewing whether observed CDI performance supports a current mastery determination."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide unsupported thresholds, generate clinical rationale, or move a family to another phase automatically."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the mastery check?",
				"answer": "The practitioner completes it. The tool is practitioner-only and does not require caregiver entry."
			},
			{
				"question": "Does the system decide mastery?",
				"answer": "No. Mastery status and the overall determination are practitioner-entered."
			},
			{
				"question": "What happens if evidence is incomplete?",
				"answer": "Incomplete evidence is labeled so the determination is not presented as complete without practitioner support."
			}
		]
	},
	{
		"toolType": "pdiEffectiveCommandPractice",
		"slug": "pdi-effective-command-practice",
		"title": "PDI Effective Command Practice Demo | Qwoach",
		"metaDescription": "Structure PDI command practice, record command attempts, observe child responses, and review recurring coaching targets during PCIT sessions.",
		"h1": "PDI Effective Command Practice for PCIT Coaching",
		"intro": "PDI Effective Command Practice is a PCIT parent-directed interaction practice support tool for practitioners. It helps practitioners structure caregiver command attempts, observe whether each command creates a child response opportunity, and identify command-quality issues for coaching.",
		"demoTitle": "Try a sample practice sequence",
		"demoPrompt": "Interested in using PDI Effective Command Practice with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0604-f-029-pcit-007-r001-pdi-effective-command-practice.md",
		"specId": "0604-f-029-pcit-007-r001-pdi-effective-command-practice",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Skills use",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during PDI teach, role play, coding, or coaching when the practitioner is shaping how the caregiver gives commands."
			},
			{
				"title": "Limits",
				"body": "The tool does not invent command scripts, prescribe discipline steps, assign unsupported quality scores, or explain child noncompliance."
			}
		],
		"faqItems": [
			{
				"question": "Is this a home program?",
				"answer": "No. It is a practitioner-led PDI command-practice support tool for coached opportunities."
			},
			{
				"question": "Can role play be recorded?",
				"answer": "Yes. Role play without an observed child response is recorded separately from live child interaction."
			},
			{
				"question": "What does the review summarize?",
				"answer": "The review summarizes practice opportunities, observed response categories where recorded, practitioner-noted command-quality issues, and recurring coaching targets."
			}
		]
	},
	{
		"toolType": "childComplianceTracking",
		"slug": "child-compliance-tracking",
		"title": "Child Compliance Tracking Demo for PCIT | Qwoach",
		"metaDescription": "Record child responses to caregiver commands, calculate compliance rate, and review descriptive response patterns across PCIT PDI sessions.",
		"h1": "Child Compliance Tracking for PCIT PDI Sessions",
		"intro": "Child Compliance Tracking is a practitioner-only PCIT parent-directed interaction tool. It helps practitioners record child responses to caregiver commands, calculate compliance rate in the coached context, and review response patterns across sessions.",
		"demoTitle": "Try a sample compliance session",
		"demoPrompt": "Interested in using Child Compliance Tracking with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0605-f-029-pcit-008-r001-child-compliance-tracking.md",
		"specId": "0605-f-029-pcit-008-r001-child-compliance-tracking",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during relevant PDI coached interactions where caregiver commands create observable child response opportunities."
			},
			{
				"title": "Limits",
				"body": "The tool does not diagnose the child, generalize beyond the observed context, infer causes, or make treatment decisions automatically."
			}
		],
		"faqItems": [
			{
				"question": "What creates a data point?",
				"answer": "A data point is tied to a caregiver command opportunity and the child's observed response category."
			},
			{
				"question": "Does the tool calculate a compliance rate?",
				"answer": "Yes. It calculates descriptive compliance and noncompliance rates from recorded command-response opportunities."
			},
			{
				"question": "How are ambiguous responses handled?",
				"answer": "Ambiguous or unobserved responses can be marked separately when the configured categories support that option."
			}
		]
	},
	{
		"toolType": "pdiHomeworkLog",
		"slug": "pdi-homework-log",
		"title": "PDI Homework Log Demo for PCIT Practitioners | Qwoach",
		"metaDescription": "Send a PDI homework log to capture caregiver practice frequency, concrete home difficulties, child responses, and barriers for review.",
		"h1": "PDI Homework Log for Between-Session Practice Review",
		"intro": "PDI Homework Log is a ready-to-send PCIT parent-directed interaction tool for practitioners. It helps practitioners gather caregiver-reported practice frequency, consistency, home implementation difficulties, child responses, and barriers so the next coaching focus can be selected.",
		"demoTitle": "Preview a sample homework log",
		"demoPrompt": "Interested in using PDI Homework Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0606-f-029-pcit-009-r001-pdi-homework-log.md",
		"specId": "0606-f-029-pcit-009-r001-pdi-homework-log",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Homework",
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after assigning PDI practice and before the next session so the practitioner can review adherence and implementation difficulties."
			},
			{
				"title": "Caregiver Role",
				"body": "The caregiver reports what happened at home, including practice, no practice, situations, child responses or difficulties, and barriers."
			},
			{
				"title": "Limits",
				"body": "The tool does not judge caregiver effort, interpret child behavior clinically, or provide PDI practice steps not supplied in the configuration."
			}
		],
		"faqItems": [
			{
				"question": "Can a caregiver report that they did not practice?",
				"answer": "Yes. No practice is a valid entry and is distinguished from no response or an incomplete log."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews practice frequency, consistency, concrete situations, difficulties, barriers, and missing or partial entries."
			},
			{
				"question": "Does the tool choose the coaching focus?",
				"answer": "No. The practitioner can mark a coaching focus after reviewing the descriptive summary."
			}
		]
	},
	{
		"toolType": "houseRulesPlan",
		"slug": "house-rules-plan",
		"title": "House Rules Plan Demo for PCIT Practitioners | Qwoach",
		"metaDescription": "Create explicit household rules, link them to caregiver responses, and identify adherence issues in a later-PDI PCIT planning workflow.",
		"h1": "House Rules Plan for Later PDI",
		"intro": "House Rules Plan is a later-PDI PCIT planning tool for practitioners and caregivers. It helps them make household behavior expectations explicit, connect each rule to predictable caregiver responses, and identify adherence issues or exceptions.",
		"demoTitle": "Build a sample house rules plan",
		"demoPrompt": "Interested in using House Rules Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0607-f-029-pcit-010-r001-house-rules-plan.md",
		"specId": "0607-f-029-pcit-010-r001-house-rules-plan",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Problem behavior"
			],
			"population": [
				"Families",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it in later PDI when household expectations need to be made explicit and connected to consistent caregiver responses."
			},
			{
				"title": "Revision History",
				"body": "Plan revisions should preserve enough version context to know the current plan and what changed over time."
			},
			{
				"title": "Limits",
				"body": "The tool does not invent rules, prescribe consequences, score rule quality, or add unrelated household management modules."
			}
		],
		"faqItems": [
			{
				"question": "Who creates the house rules?",
				"answer": "The practitioner and caregiver create them collaboratively; the system structures the plan but does not invent the rules."
			},
			{
				"question": "What makes a rule incomplete?",
				"answer": "A rule remains incomplete when it is too vague or lacks a linked caregiver response."
			},
			{
				"question": "Are exceptions part of the plan?",
				"answer": "Yes. Known adherence problems or exceptions can be captured without replacing the main rule."
			}
		]
	},
	{
		"toolType": "publicBehaviorPlan",
		"slug": "public-behavior-plan",
		"title": "Public Behavior Plan Demo for PCIT | Qwoach",
		"metaDescription": "Plan how caregivers will use PDI skills in public settings by mapping situations, expected behavior, responses, likely problems, and feasibility.",
		"h1": "Public Behavior Plan for PDI Skill Generalization",
		"intro": "Public Behavior Plan is a PCIT parent-directed interaction generalization tool for practitioners and caregivers. It helps them identify public situations of concern, specify expected child behavior and caregiver responses, and account for likely public adherence or escalation problems.",
		"demoTitle": "Create a sample public behavior plan",
		"demoPrompt": "Interested in using Public Behavior Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0608-f-029-pcit-011-r001-public-behavior-plan.md",
		"specId": "0608-f-029-pcit-011-r001-public-behavior-plan",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Problem behavior"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when PDI skills need to carry into everyday community settings and the caregiver needs a concrete public-setting strategy."
			},
			{
				"title": "Repeat Use",
				"body": "The plan can be revised as new public settings or adherence problems emerge, while prior context remains available."
			},
			{
				"title": "Limits",
				"body": "The tool does not generate public behavior scripts, evaluate likely success, provide escalation protocols, or interpret child behavior clinically."
			}
		],
		"faqItems": [
			{
				"question": "Is this an outing planner?",
				"answer": "No. It is a PDI generalization plan for behavior strategies in public settings."
			},
			{
				"question": "What must each public situation include?",
				"answer": "Each situation should include the setting, expected child behavior, caregiver response, and known likely problems or feasibility notes."
			},
			{
				"question": "Does the system create the caregiver response?",
				"answer": "No. The caregiver response is entered through the practitioner-caregiver planning workflow."
			}
		]
	},
	{
		"toolType": "siblingSessionPlan",
		"slug": "sibling-session-plan",
		"title": "Sibling Session Plan Demo for PCIT | Qwoach",
		"metaDescription": "Prepare sibling-context scenarios, record intended caregiver responses, observe skill transfer, and identify PCIT coaching targets.",
		"h1": "Sibling Session Plan for PCIT Generalization",
		"intro": "Sibling Session Plan is a PCIT planning and observation support tool for practitioners. It helps practitioners and caregivers identify sibling-specific challenges, record intended caregiver responses, and observe whether interaction and discipline skills transfer to sibling contexts.",
		"demoTitle": "Plan a sample sibling session",
		"demoPrompt": "Interested in using Sibling Session Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0609-f-029-pcit-012-r001-sibling-session-plan.md",
		"specId": "0609-f-029-pcit-012-r001-sibling-session-plan",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Skills use",
				"Interpersonal relationships"
			],
			"population": [
				"Families",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it only when sibling contexts are relevant to the family and skill generalization needs preparation or observation."
			},
			{
				"title": "Preparation And Observation",
				"body": "The plan can remain preparation-only when a scenario has not occurred, or become an observation record when the practitioner records sibling-context skill transfer."
			},
			{
				"title": "Limits",
				"body": "The tool does not diagnose siblings, interpret family dynamics, score sibling success, or create sibling intervention content."
			}
		],
		"faqItems": [
			{
				"question": "Should families without siblings use this tool?",
				"answer": "No. The tool is for families where sibling context is relevant."
			},
			{
				"question": "Can planned scenarios remain unobserved?",
				"answer": "Yes. Planned-but-not-observed scenarios are labeled separately from observed sibling-session data."
			},
			{
				"question": "Who records observation notes?",
				"answer": "The practitioner records observation notes and coaching targets; the caregiver may help complete preparation fields."
			}
		]
	},
	{
		"toolType": "pcitFamilyTracker",
		"slug": "pcit-family-tracker",
		"title": "PCIT Family Tracker Demo | Qwoach",
		"metaDescription": "Track PCIT family progress across sessions with phase status, progress indicators, fidelity-relevant gaps, coaching history, and follow-up needs.",
		"h1": "PCIT Family Tracker for Longitudinal Case Progress",
		"intro": "PCIT Family Tracker is a practitioner-only longitudinal case-management and fidelity-relevant tracking tool. It helps PCIT practitioners organize session-by-session progress, phase status, transition-relevant indicators, coaching focus history, and case-management needs.",
		"demoTitle": "Explore a sample family timeline",
		"demoPrompt": "Interested in using PCIT Family Tracker with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0610-f-029-pcit-013-r001-pcit-family-tracker.md",
		"specId": "0610-f-029-pcit-013-r001-pcit-family-tracker",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review",
				"Clinical documentation"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it as the longitudinal home for a PCIT family case when session sequence, phase status, progress indicators, and case-management needs must stay organized."
			},
			{
				"title": "Related Tool Outputs",
				"body": "The tracker may link to outputs from specific tools such as skill trackers, mastery checks, compliance tracking, homework logs, or plans when those records exist."
			},
			{
				"title": "Limits",
				"body": "The tracker does not replace an EHR, add billing or unrelated administrative data, invent fidelity rules, or make automatic protocol judgments."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client view?",
				"answer": "No. PCIT Family Tracker is practitioner-only."
			},
			{
				"question": "What does the tracker organize?",
				"answer": "It organizes session sequence, phase status, progress indicators, fidelity-relevant information, coaching focus history, and case-management needs."
			},
			{
				"question": "Can it link to other PCIT tool outputs?",
				"answer": "Yes. Related tool outputs may be linked or summarized when those records exist, with source and date shown."
			},
			{
				"question": "Does it decide phase movement?",
				"answer": "No. It shows descriptive longitudinal information; the practitioner makes phase movement decisions."
			}
		]
	},
	{
		"toolType": "sessionFidelityChecklist",
		"slug": "session-fidelity-checklist",
		"title": "Session Fidelity Checklist for PCIT Treatment Integrity | Qwoach",
		"metaDescription": "PCIT fidelity checklist for therapists to account for required session elements, identify concerns, and review session-level fidelity data.",
		"h1": "Session Fidelity Checklist",
		"intro": "Session Fidelity Checklist is a practitioner-only PCIT treatment-integrity tool for therapists. It helps practitioners account for required session elements, identify omitted or altered components, and produce treatment fidelity data for review.",
		"demoTitle": "Explore a sample fidelity checklist",
		"demoPrompt": "Interested in using Session Fidelity Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0611-f-029-pcit-014-r001-session-fidelity-checklist.md",
		"specId": "0611-f-029-pcit-014-r001-session-fidelity-checklist",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during post-session documentation or during a session when fidelity components need to be tracked without adding client-entered data."
			},
			{
				"title": "Historical Review",
				"body": "Completed results preserve the checklist version used for that session so fidelity information can be compared across sessions without merging unlike checklist versions."
			},
			{
				"title": "Limits",
				"body": "The tool does not define PCIT protocol content, invent checklist items, score clinical progress, or infer family outcomes from fidelity data."
			}
		],
		"faqItems": [
			{
				"question": "Does a caregiver complete this checklist?",
				"answer": "No. Session Fidelity Checklist is practitioner-only and does not include a caregiver, child, or family-facing submission."
			},
			{
				"question": "What does the result show?",
				"answer": "The result shows treatment fidelity data for the session, including component statuses, omitted or altered components, concern notes, and a descriptive fidelity summary."
			},
			{
				"question": "Can the demo use real client information?",
				"answer": "No. Public exploration should use fictional or placeholder session details and should not require real client-identifying or sensitive case information."
			},
			{
				"question": "Are the official checklist items included?",
				"answer": "The exact checklist items are unresolved in the product specification, so the demo must treat any displayed items as sample or configured content rather than authoritative PCIT content."
			}
		]
	},
	{
		"toolType": "graduationCriteriaChecklist",
		"slug": "graduation-criteria-checklist",
		"title": "PCIT Graduation Criteria Checklist | Qwoach",
		"metaDescription": "Structured PCIT completion checklist for practitioners to review graduation criteria, remaining concerns, and readiness before treatment completion.",
		"h1": "Graduation Criteria Checklist",
		"intro": "Graduation Criteria Checklist is a practitioner-only PCIT completion-decision tool. It helps practitioners structure whether a family meets established graduation criteria, account for caregiver skill mastery and child behavior progress, and identify remaining concerns before treatment completion.",
		"demoTitle": "Explore a sample graduation checklist",
		"demoPrompt": "Interested in using Graduation Criteria Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0612-f-029-pcit-015-r001-graduation-criteria-checklist.md",
		"specId": "0612-f-029-pcit-015-r001-graduation-criteria-checklist",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when PCIT completion is being considered and remaining concerns need to be reviewed before proceeding to graduation."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not create new graduation criteria, score outcomes, generate discharge planning content, or make unsupported clinical recommendations."
			},
			{
				"title": "Historical Basis",
				"body": "Completed decisions preserve the criteria set used so later review can understand what was considered at the time."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide graduation automatically?",
				"answer": "No. It produces a structured completion-readiness summary from practitioner entries; the practitioner uses that information to decide whether completion is appropriate."
			},
			{
				"question": "Can caregivers complete it?",
				"answer": "No. The product specification defines no separate caregiver or family-facing experience for this checklist."
			},
			{
				"question": "What happens if criteria are unresolved?",
				"answer": "Unresolved criteria remain visible and the checklist should not present the graduation decision as complete."
			},
			{
				"question": "Are exact PCIT criteria included in the demo?",
				"answer": "Exact criteria are unresolved in the product specification, so demo criteria must be sample or configured content, not invented authoritative criteria."
			}
		]
	},
	{
		"toolType": "liveCoachingViaBugInTheEar",
		"slug": "live-coaching-via-bug-in-the-ear",
		"title": "PCIT Bug-in-the-Ear Live Coaching Capability | Qwoach",
		"metaDescription": "PCIT live coaching delivery method for discreet real-time caregiver guidance, with channel readiness and connection-state boundaries.",
		"h1": "Live Coaching via Bug-in-the-Ear",
		"intro": "Live Coaching via Bug-in-the-Ear is a PCIT delivery method for practitioners and caregivers. It helps the practitioner send immediate, discreet guidance to the caregiver during a live caregiver-child interaction while the interaction continues.",
		"demoTitle": "Preview channel readiness states",
		"demoPrompt": "Interested in using Live Coaching via Bug-in-the-Ear with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0613-f-029-pcit-016-r001-live-coaching-via-bug-in-the-ear.md",
		"specId": "0613-f-029-pcit-016-r001-live-coaching-via-bug-in-the-ear",
		"tags": {
			"framework": [
				"PCIT"
			],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Is",
				"body": "It is a real-time delivery method for discreet practitioner-to-caregiver guidance during an observed interaction."
			},
			{
				"title": "What It Is Not",
				"body": "It is not a standalone worksheet, checklist, documentation tool, fidelity form, transcript, rating system, or treatment-result review."
			},
			{
				"title": "Operational Edge Cases",
				"body": "The experience should account for audio failure, unclear hearing, disruption, lack of observation, and latency that prevents timely guidance."
			}
		],
		"faqItems": [
			{
				"question": "Does this produce a clinical artifact?",
				"answer": "No. The product specification says this delivery method does not produce a worksheet, score, transcript, log, or durable assessment artifact."
			},
			{
				"question": "What can be saved?",
				"answer": "The delivery capability setup itself can be saved, including supported channel settings if the platform operationalizes them."
			},
			{
				"question": "Is there a result page?",
				"answer": "No artifact result page is applicable. The only represented state is whether discreet live guidance can reach the caregiver."
			},
			{
				"question": "Can the demo include coaching notes?",
				"answer": "No. Coaching logs or documentation would be separate tools and are not supported by this record."
			}
		]
	},
	{
		"toolType": "circleOfSecurityDiagram",
		"slug": "circle-of-security-diagram",
		"title": "Circle of Security Diagram for Shared Caregiver Formulation | Qwoach",
		"metaDescription": "Shared Circle of Security diagram tool for practitioners to annotate child needs, caregiving-cycle location, and caregiver responses.",
		"h1": "Circle of Security Diagram",
		"intro": "Circle of Security Diagram is a shared practitioner-caregiver formulation tool. It helps practitioners and caregivers identify a child's attachment-related need, locate it in the caregiving cycle, and connect it to the caregiver's actual or typical response.",
		"demoTitle": "Annotate a sample Circle",
		"demoPrompt": "Interested in using Circle of Security Diagram with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0614-f-030-cosp-001-r001-circle-of-security-diagram.md",
		"specId": "0614-f-030-cosp-001-r001-circle-of-security-diagram",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during caregiver work when a child behavior or need needs to be understood within a caregiving relationship."
			},
			{
				"title": "Shared Roles",
				"body": "The practitioner facilitates and controls final wording; the caregiver contributes examples and responses."
			},
			{
				"title": "Limits",
				"body": "The tool does not infer attachment status, diagnose, score severity, or prescribe intervention steps."
			}
		],
		"faqItems": [
			{
				"question": "Is this a questionnaire?",
				"answer": "No. The diagram is the organizing surface; the work is visual mapping with annotation, not questionnaire scoring."
			},
			{
				"question": "What makes an annotation complete?",
				"answer": "An annotation is complete when it includes the child need, its Circle location, and the linked caregiver response."
			},
			{
				"question": "Can prior diagrams be reviewed?",
				"answer": "Yes. Historical review may compare annotations descriptively across sessions without implying quantified change."
			},
			{
				"question": "Can the demo use a real family example?",
				"answer": "No. Public exploration should use fictional or non-identifying examples only."
			}
		]
	},
	{
		"toolType": "adolescentCircleOfSecurityDiagram",
		"slug": "adolescent-circle-of-security-diagram",
		"title": "Adolescent Circle Diagram for Caregiver Formulation | Qwoach",
		"metaDescription": "Shared adolescent Circle diagram tool for practitioners to annotate teen relational needs, caregiver response patterns, and autonomy-connection themes.",
		"h1": "Adolescent Circle of Security Diagram",
		"intro": "Adolescent Circle of Security Diagram is a shared formulation tool for practitioners working with caregivers. It helps them identify an adolescent relational or attachment need, map it in an age-relevant Circle frame, and connect it to the caregiver response pattern.",
		"demoTitle": "Annotate a sample adolescent Circle",
		"demoPrompt": "Interested in using Adolescent Circle of Security Diagram with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0615-f-030-cosp-002-r001-adolescent-circle-of-security-diagram.md",
		"specId": "0615-f-030-cosp-002-r001-adolescent-circle-of-security-diagram",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Adolescents",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when caregiver work concerns an adolescent's need for autonomy, connection, comfort, or protection."
			},
			{
				"title": "What It Captures",
				"body": "It captures the adolescent need, caregiver response pattern, and brief notes that preserve the age-relevant formulation."
			},
			{
				"title": "Limits",
				"body": "It does not perform adolescent assessment, behavior tracking, risk assessment, scoring, or diagnosis."
			}
		],
		"faqItems": [
			{
				"question": "How is this different from the general Circle diagram?",
				"answer": "This tool uses the adolescent diagram variant so the formulation can reflect adolescent-specific needs for independence and connection."
			},
			{
				"question": "Can multiple needs be entered?",
				"answer": "Multiple needs should be separated into separate annotations when they represent different formulation points."
			},
			{
				"question": "Does the tool rate caregiver responses?",
				"answer": "No. It descriptively links the caregiver response pattern to the adolescent need without scoring or classifying the response."
			},
			{
				"question": "What must be included before review?",
				"answer": "A complete annotation needs an identified adolescent need and a linked caregiver response pattern."
			}
		]
	},
	{
		"toolType": "traumaticEventCircleDiagram",
		"slug": "traumatic-event-circle-diagram",
		"title": "Traumatic Event Circle Diagram for Caregiver Support | Qwoach",
		"metaDescription": "Adapted Circle diagram tool for practitioners to map trauma-related child needs, caregiver responses, and strengths or gaps in support.",
		"h1": "Traumatic Event Circle Diagram",
		"intro": "Traumatic Event Circle Diagram is a shared caregiver-practitioner formulation tool. It helps practitioners and caregivers understand how a traumatic event relates to a child's needs for safety, comfort, protection, or connection and the caregiver response to those needs.",
		"demoTitle": "Annotate a sample traumatic-event Circle",
		"demoPrompt": "Interested in using Traumatic Event Circle Diagram with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0616-f-030-cosp-003-r001-traumatic-event-circle-diagram.md",
		"specId": "0616-f-030-cosp-003-r001-traumatic-event-circle-diagram",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Interpersonal relationships"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Sensitive Use",
				"body": "The tool should minimize required detail about the traumatic event and allow pausing or resuming shared reflection."
			},
			{
				"title": "What It Captures",
				"body": "It captures child cues or needs, caregiver responses, need distinctions where relevant, and strengths or gaps in caregiving response."
			},
			{
				"title": "Limits",
				"body": "It does not investigate the event, assess trauma severity, determine risk, diagnose, or select a treatment protocol."
			}
		],
		"faqItems": [
			{
				"question": "Does the caregiver need to describe the traumatic event in detail?",
				"answer": "No. The tool should collect only enough context to support the formulation and should not force unnecessary event detail."
			},
			{
				"question": "Is this a trauma assessment?",
				"answer": "No. It is a shared visual formulation tool and does not produce diagnosis, severity scores, or risk determinations."
			},
			{
				"question": "Can the reflection be paused?",
				"answer": "Yes. The product specification supports pausing and resuming because trauma-context reflection may need careful pacing."
			},
			{
				"question": "What is reviewed after completion?",
				"answer": "The practitioner reviews the annotated diagram, linked caregiver responses, and visible strengths or gaps."
			}
		]
	},
	{
		"toolType": "circleStory",
		"slug": "circle-story",
		"title": "Circle Story Tool for Caregiver Narrative Review | Qwoach",
		"metaDescription": "Circle Story narrative tool for practitioners to review caregiver reflections on child needs, Shark Music, strengths, struggles, and change over time.",
		"h1": "Circle Story",
		"intro": "Circle Story is a Circle of Security narrative artifact for practitioners. It helps practitioners collect and review a caregiver narrative that may show attachment concept integration, Shark Music, caregiving strengths and struggles, and signs of change over time.",
		"demoTitle": "Review a sample Circle Story",
		"demoPrompt": "Interested in using Circle Story with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0617-f-030-cosp-004-r001-circle-story.md",
		"specId": "0617-f-030-cosp-004-r001-circle-story",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Therapeutic document"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Interpersonal relationships",
				"Outcome monitoring"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when narrative reflection can help the practitioner understand caregiver integration, sensitivities, strengths, struggles, and change."
			},
			{
				"title": "Longitudinal Value",
				"body": "History matters because repeated Circle Stories can be reviewed descriptively to see how the caregiver's understanding or responses are changing over time."
			},
			{
				"title": "Limits",
				"body": "The tool does not score the narrative, create automated clinical interpretations, or invent prompts or rubric dimensions."
			}
		],
		"faqItems": [
			{
				"question": "Does Circle Story use scores?",
				"answer": "No. The product specification supports narrative review and descriptive theme organization, not scoring."
			},
			{
				"question": "Can caregivers save a draft?",
				"answer": "Yes. The caregiver experience should support saving and resuming because narrative reflection may take time."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews the full narrative and supported themes: needs linkage, trigger reactions or sensitivities, strengths, struggles, and signs of change."
			},
			{
				"question": "Are exact prompts included?",
				"answer": "Exact prompts are unresolved in the product specification, so the demo must not invent required Circle Story prompts."
			}
		]
	},
	{
		"toolType": "sharkMusicReflection",
		"slug": "shark-music-reflection",
		"title": "Shark Music Reflection for Caregiver Trigger Patterns | Qwoach",
		"metaDescription": "Caregiver reflection tool for identifying child cues, sensitivity patterns, current responses, effects, and alternative responses.",
		"h1": "Shark Music Reflection",
		"intro": "Shark Music Reflection is a caregiver reflection tool for Circle of Security practitioners and caregivers. It helps caregivers recognize a recurring sensitivity pattern, connect it to child cues or situations, describe the current response and effect, and identify a more secure alternative response.",
		"demoTitle": "Complete a sample reflection",
		"demoPrompt": "Interested in using Shark Music Reflection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0618-f-030-cosp-005-r001-shark-music-reflection.md",
		"specId": "0618-f-030-cosp-005-r001-shark-music-reflection",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures the activating child cue or situation, caregiver sensitivity or personal meaning, current response and effect, and a specific alternative response."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated reflections can show a history of patterns and alternative responses, but they are not merged into a score."
			},
			{
				"title": "Limits",
				"body": "The tool does not infer causes, diagnose, score severity, or require detailed personal history beyond the supported sensitivity field."
			}
		],
		"faqItems": [
			{
				"question": "What is the output?",
				"answer": "The output is a recognized Shark Music pattern and an identified alternative response for future similar moments."
			},
			{
				"question": "Does the tool interpret the cause of the reaction?",
				"answer": "No. It organizes what the caregiver reports and must not infer etiology or clinical meaning beyond the text."
			},
			{
				"question": "Can a caregiver pause the reflection?",
				"answer": "Yes. The client view should support save and resume because the reflection may be emotionally difficult or need more time."
			},
			{
				"question": "Are there practitioner settings?",
				"answer": "No substantive settings are supported by the supplied specification unless authoritative prompts are later supplied."
			}
		]
	},
	{
		"toolType": "coreSensitivitiesReflection",
		"slug": "core-sensitivities-reflection",
		"title": "Core Sensitivities Reflection for Caregiver Profiles | Qwoach",
		"metaDescription": "Shared reflection tool for practitioners to build caregiver sensitivity profiles with themes, activating situations, response impact, and support needs.",
		"h1": "Core Sensitivities Reflection",
		"intro": "Core Sensitivities Reflection is a practitioner-supported Circle of Security reflection tool for practitioners and caregivers. It helps identify caregiver sensitivity themes, the child cues or caregiving situations that activate them, their impact on responses, and support or coaching needs.",
		"demoTitle": "Build a sample sensitivity profile",
		"demoPrompt": "Interested in using Core Sensitivities Reflection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0619-f-030-cosp-006-r001-core-sensitivities-reflection.md",
		"specId": "0619-f-030-cosp-006-r001-core-sensitivities-reflection",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation",
				"Interpersonal relationships"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures sensitivity themes, activating child cues or caregiving situations, response impact, and support or coaching needs."
			},
			{
				"title": "Shared Completion",
				"body": "The caregiver contributes reflection content while the practitioner facilitates and helps identify clinically useful support focus."
			},
			{
				"title": "Limits",
				"body": "The tool does not invent sensitivity categories, score sensitivities, assign diagnoses, or interpret personality."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include fixed sensitivity categories?",
				"answer": "Not from the supplied specification. Exact categories are unresolved, so the product must not invent a taxonomy."
			},
			{
				"question": "Can more than one theme be entered?",
				"answer": "Yes. The product must support multiple profile entries, each organized by theme, activation context, response impact, and support need."
			},
			{
				"question": "Does the profile produce a score?",
				"answer": "No. The profile is descriptive and does not score sensitivities or rank caregivers."
			},
			{
				"question": "What if a caregiver can identify a situation but not a theme?",
				"answer": "The entry can remain partial; the missing theme should be visible rather than auto-labeled by the system."
			}
		]
	},
	{
		"toolType": "biggerStrongerWiserKindReflection",
		"slug": "bigger-stronger-wiser-kind-reflection",
		"title": "Bigger Stronger Wiser Kind Caregiving Reflection | Qwoach",
		"metaDescription": "Shared caregiving-stance reflection tool for identifying strengths, gaps, concrete situations, and a next growth focus.",
		"h1": "Bigger Stronger Wiser Kind Reflection",
		"intro": "Bigger Stronger Wiser Kind Reflection is a practitioner-supported Circle of Security reflection tool for practitioners and caregivers. It helps them identify strengths and gaps in organized guidance, firm leadership, wisdom, warmth, confidence, and kind emotional availability in concrete caregiving situations.",
		"demoTitle": "Complete a sample stance reflection",
		"demoPrompt": "Interested in using Bigger Stronger Wiser Kind Reflection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0620-f-030-cosp-007-r001-bigger-stronger-wiser-kind-reflection.md",
		"specId": "0620-f-030-cosp-007-r001-bigger-stronger-wiser-kind-reflection",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Interpersonal relationships"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures concrete situations, caregiving strengths, gaps or imbalances, and a next focus for caregiver growth."
			},
			{
				"title": "Shared Wording",
				"body": "The caregiver and practitioner can revise wording together so the reflection stays concrete and nonjudgmental."
			},
			{
				"title": "Limits",
				"body": "The tool does not score parenting quality, classify parenting style, judge competence, or invent official prompts or practice steps."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool rate the caregiver?",
				"answer": "No. It creates a descriptive strengths/gaps reflection and must not convert entries into scores or parenting classifications."
			},
			{
				"question": "What makes an entry useful?",
				"answer": "A useful entry links a strength or gap to a concrete caregiving situation and identifies a next growth focus when possible."
			},
			{
				"question": "Can the caregiver revise wording?",
				"answer": "Yes. The shared experience should allow caregiver and practitioner to revise wording together."
			},
			{
				"question": "Are official prompts included?",
				"answer": "Exact prompts and scales are unresolved in the supplied specification, so the demo must not invent them."
			}
		]
	},
	{
		"toolType": "securityIn25WordsOrLess",
		"slug": "security-in-25-words-or-less",
		"title": "Security in 25 Words or Less | Caregiver Psychoeducation Demo | Qwoach",
		"metaDescription": "Explore a concise attachment-focused handout reference that helps caregivers discuss a child's need for security in plain language.",
		"h1": "Security in 25 Words or Less",
		"intro": "Security in 25 Words or Less is an attachment-focused psychoeducation handout reference for practitioners working with caregivers. It helps caregivers discuss a child's core security need in plain language and connect the idea to everyday caregiver-child interactions.",
		"demoTitle": "Open the handout reference and try the optional discussion notes.",
		"demoPrompt": "Interested in using Security in 25 Words or Less with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0621-f-030-cosp-008-r001-security-in-25-words-or-less.md",
		"specId": "0621-f-030-cosp-008-r001-security-in-25-words-or-less",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during caregiver psychoeducation when the practitioner wants a concise, recallable way to discuss a child's need for comfort, protection, exploration, and support."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not score caregiver understanding, assess attachment security, create diagnoses, or generate a formal report."
			}
		],
		"faqItems": [
			{
				"question": "Is this an assessment?",
				"answer": "No. Security in 25 Words or Less is a psychoeducational reference, not an assessment, rating scale, or diagnostic tool."
			},
			{
				"question": "Can caregivers type responses?",
				"answer": "Yes, optionally. A caregiver may enter a brief plain-language restatement and one everyday example, but blank fields are allowed."
			},
			{
				"question": "What is saved when I add it to my account?",
				"answer": "The fixed handout reference tool is saved as-is. Demo notes and fictional examples do not become real client records."
			}
		]
	},
	{
		"toolType": "cosp8ChapterVideoCurriculum",
		"slug": "cosp-8-chapter-video-curriculum",
		"title": "COSP 8-Chapter Video Curriculum | Practitioner Demo | Qwoach",
		"metaDescription": "Explore a practitioner companion for tracking progress, notes, and supported reflections across an 8-chapter video-based parenting curriculum.",
		"h1": "COSP 8-Chapter Video Curriculum",
		"intro": "COSP 8-Chapter Video Curriculum is a practitioner companion for facilitators delivering an 8-chapter video-based attachment-focused parenting intervention. It helps practitioners track chapter progress, preserve session continuity, and review supported caregiver reflections or concrete caregiving responses across sessions.",
		"demoTitle": "Explore the 8-chapter progress map and review a sample session state.",
		"demoPrompt": "Interested in using COSP 8-Chapter Video Curriculum with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0622-f-030-cosp-009-r001-cosp-8-chapter-video-curriculum.md",
		"specId": "0622-f-030-cosp-009-r001-cosp-8-chapter-video-curriculum",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "What It Tracks",
				"body": "The companion tracks chapter progress, completion state, missing chapters, and descriptive per-chapter artifacts entered by the practitioner or supported reflection flow."
			},
			{
				"title": "Limits Of The Demo",
				"body": "The demo does not supply official chapter content, facilitator prompts, reflection questions, scores, or clinical interpretations."
			},
			{
				"title": "Individual Or Group Use",
				"body": "Individual and group containers may organize participation, but they do not change the fixed curriculum sequence or product meaning."
			}
		],
		"faqItems": [
			{
				"question": "Does this generate COSP chapter content?",
				"answer": "No. The companion represents the fixed 8-chapter sequence and progress state, but it does not generate chapter content, scripts, or facilitator prompts."
			},
			{
				"question": "Can caregivers complete reflections?",
				"answer": "Only where reflections are supported by supplied facilitator materials. In the demo, any reflection area is generic and practitioner-specified."
			},
			{
				"question": "What does the review show?",
				"answer": "The review shows covered chapters, current chapter, pending chapters, and descriptive notes or reflections when entered."
			},
			{
				"question": "Are there scores?",
				"answer": "No. The tool derives progress and presence of reflection artifacts only; it does not score caregivers or interpret relationship quality."
			}
		]
	},
	{
		"toolType": "cospFacilitatorManual",
		"slug": "cosp-facilitator-manual",
		"title": "COSP Facilitator Manual | Practitioner Delivery Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only companion for session coverage, delivery consistency, and descriptive adaptation notes in a structured parenting intervention.",
		"h1": "COSP Facilitator Manual",
		"intro": "COSP Facilitator Manual is a practitioner-only delivery-support companion for facilitators of a structured attachment-focused parenting intervention. It helps practitioners review session structure, mark covered topics, and record intentional adaptations or deviations without collecting client data.",
		"demoTitle": "Explore the practitioner-only coverage and deviation review.",
		"demoPrompt": "Interested in using COSP Facilitator Manual with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0623-f-030-cosp-010-r001-cosp-facilitator-manual.md",
		"specId": "0623-f-030-cosp-010-r001-cosp-facilitator-manual",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"Session preparation",
				"In-session support"
			],
			"topic": [],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The product is designed for facilitator preparation, in-session orientation, and post-session delivery review. It does not include a participant-facing view."
			},
			{
				"title": "What The Review Contains",
				"body": "The review contains descriptive coverage state and practitioner-entered adaptation or deviation notes, not automated fidelity scores."
			},
			{
				"title": "Multiple Groups",
				"body": "Separate delivery histories should be kept for different groups so consistency can be reviewed without mixing records."
			}
		],
		"faqItems": [
			{
				"question": "Does this collect client information?",
				"answer": "No. The COSP Facilitator Manual companion is practitioner-only and does not collect client symptoms, ratings, or outcome data."
			},
			{
				"question": "Does it score fidelity?",
				"answer": "No. Coverage completeness and deviation presence are descriptive only; the product does not generate an automated quality judgment."
			},
			{
				"question": "Can I record adaptations?",
				"answer": "Yes. Practitioners can enter descriptive notes about intentional adaptations or deviations, separate from coverage state."
			},
			{
				"question": "Is there a client view?",
				"answer": "No. A separate client or participant view is not applicable for this product."
			}
		]
	},
	{
		"toolType": "empathyExplorationResourcingChoicePoint",
		"slug": "empathy-exploration-resourcing-choice-point",
		"title": "Empathy Exploration Resourcing Choice Point | Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only live-session aid for choosing empathy, exploration, or resourcing as the next caregiver response mode.",
		"h1": "Empathy / Exploration / Resourcing Choice Point",
		"intro": "Empathy / Exploration / Resourcing Choice Point is a practitioner-only live-session decision aid for caregiver sessions. It helps practitioners quickly choose whether a caregiver statement calls for empathy, exploration, or resourcing while keeping practitioner judgment central.",
		"demoTitle": "Try the three response modes.",
		"demoPrompt": "Interested in using Empathy / Exploration / Resourcing Choice Point with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0624-f-030-cosp-011-r001-empathy-exploration-resourcing-choice-point.md",
		"specId": "0624-f-030-cosp-011-r001-empathy-exploration-resourcing-choice-point",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Designed For Live Use",
				"body": "The interface should be usable without typing and should not pull attention away from the caregiver relationship."
			},
			{
				"title": "Optional Record",
				"body": "A practitioner can use the tool without creating a record. Optional note capture is limited to selected mode and brief rationale."
			},
			{
				"title": "What It Avoids",
				"body": "The tool does not classify caregiver readiness, generate exact therapeutic wording, or score engagement."
			}
		],
		"faqItems": [
			{
				"question": "Is this caregiver-facing?",
				"answer": "No. The tool is practitioner-only; the caregiver experiences the practitioner's in-session response, not the interface."
			},
			{
				"question": "Does the system recommend a mode automatically?",
				"answer": "No. The practitioner chooses the mode. The system does not classify statements or generate therapeutic judgments."
			},
			{
				"question": "Do I have to write a note?",
				"answer": "No. The tool remains valid as a momentary aid with no note and no structured output."
			},
			{
				"question": "What is saved?",
				"answer": "The fixed three-mode decision aid is saved as-is. Demo selections and sample notes are not saved as real session records."
			}
		]
	},
	{
		"toolType": "divingBoardFramework",
		"slug": "diving-board-framework",
		"title": "Diving Board Framework | Unresolved Practitioner Framework Demo | Qwoach",
		"metaDescription": "Review an unresolved practitioner-only framework record that identifies missing purpose, mechanic, inputs, outputs, and success criteria.",
		"h1": "Diving Board Framework",
		"intro": "Diving Board Framework is a practitioner-only reflection framework record for reviewers and practitioners. It helps identify that the framework exists, but its purpose, target decision, inputs, outputs, and success criteria are unresolved and must be supplied before it becomes an active tool.",
		"demoTitle": "Review the unresolved framework card.",
		"demoPrompt": "Interested in using Diving Board Framework with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0625-f-030-cosp-012-r001-diving-board-framework.md",
		"specId": "0625-f-030-cosp-012-r001-diving-board-framework",
		"tags": {
			"framework": [
				"Circle of Security"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"Clinical documentation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Why Active Use Is Blocked",
				"body": "The supplied record does not define the framework's purpose, target decision, mechanic, inputs, outputs, or success criteria, so the demo must not invent them."
			},
			{
				"title": "What Can Be Reviewed",
				"body": "Reviewers can see the named framework, practitioner-only orientation, source context summary, and the list of missing definition areas."
			}
		],
		"faqItems": [
			{
				"question": "Can I use this as a worksheet?",
				"answer": "No. The supplied specification does not support worksheet prompts, reflection questions, or completion steps for this framework."
			},
			{
				"question": "Is there a client version?",
				"answer": "No. Client participation is not supported by the record and is not part of this product state."
			},
			{
				"question": "Why is the demo non-completable?",
				"answer": "The demo is non-completable because the framework's purpose, mechanic, inputs, outputs, and success criteria are unresolved."
			},
			{
				"question": "What is saved?",
				"answer": "The unresolved framework record itself is saved as-is, not a finished active tool."
			}
		]
	},
	{
		"toolType": "weeklyHomeActivities",
		"slug": "weekly-home-activities",
		"title": "Weekly Home Activities | Parent Training Demo | Qwoach",
		"metaDescription": "Explore a weekly parent-training assignment tool for tracking home practice attempts, barriers, observed outcomes, and follow-up needs.",
		"h1": "Weekly Home Activities",
		"intro": "Weekly Home Activities is a between-session home practice assignment and follow-up tracker for parent-training practitioners. It helps practitioners assign a weekly parenting activity, collect parent-reported attempts, barriers, and observed outcomes, and use that information for follow-up coaching.",
		"demoTitle": "Set up a sample weekly activity and preview the parent report.",
		"demoPrompt": "Interested in using Weekly Home Activities with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0626-f-031-iy-001-r001-weekly-home-activities.md",
		"specId": "0626-f-031-iy-001-r001-weekly-home-activities",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Homework",
				"Behavior change"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures practitioner-specified activity details, parent attempt status, barriers, observed outcomes, and review state."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated weekly use creates a descriptive history of practice attempts, persistent barriers, and reported outcomes across weeks."
			},
			{
				"title": "Limitations",
				"body": "The tool does not provide parenting skill content, rating scales, diagnostic conclusions, or automated recommendations unless those are supplied separately."
			}
		],
		"faqItems": [
			{
				"question": "Who writes the weekly activity?",
				"answer": "The practitioner writes the weekly target activity or skill and any brief instructions."
			},
			{
				"question": "What does the parent report?",
				"answer": "The parent reports whether they attempted the activity, any barriers, and observed outcomes from home practice."
			},
			{
				"question": "Does it score adherence?",
				"answer": "No. It shows attempt status and descriptive patterns, but it does not create a clinical score or parent performance grade."
			},
			{
				"question": "What carries over when saved?",
				"answer": "The tool and practitioner configuration carry over. Fictional demo parent responses and sample case data do not."
			}
		]
	},
	{
		"toolType": "parentGoalSheet",
		"slug": "parent-goal-sheet",
		"title": "Parent Goal Sheet | Parent Training Goal Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send parent goal sheet for capturing meaningful parenting goals, observable progress, and links to home activities.",
		"h1": "Parent Goal Sheet",
		"intro": "Parent Goal Sheet is a parent-training goal setting and progress reference tool for practitioners. It helps practitioners capture a personally meaningful, observable parenting goal, connect it to home activities, and revisit progress over time.",
		"demoTitle": "Create a sample goal and review the active goal card.",
		"demoPrompt": "Interested in using Parent Goal Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0627-f-031-iy-002-r001-parent-goal-sheet.md",
		"specId": "0627-f-031-iy-002-r001-parent-goal-sheet",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Homework"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at the start or continuation of parent-training home activities so later work can be connected to what matters to the parent."
			},
			{
				"title": "Progress Over Time",
				"body": "Progress is discussed descriptively across sessions through observations and notes, not through invented scores or percentages."
			},
			{
				"title": "Goal Changes",
				"body": "If a goal changes, prior goal history should remain available and the new goal should be marked as current."
			}
		],
		"faqItems": [
			{
				"question": "Who provides the goal?",
				"answer": "The parent provides the goal content, with practitioner support to make it specific, meaningful, and observable."
			},
			{
				"question": "Can it connect to home activities?",
				"answer": "Yes. Home activities can optionally be linked back to the active goal for follow-up."
			},
			{
				"question": "Does the tool score goal progress?",
				"answer": "No. Progress is captured as observations or discussion notes, not as a score or percentage."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The goal sheet tool and configuration are saved. Fictional demo goals and progress notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "parentWeeklySelfReflectionInventory",
		"slug": "parent-weekly-self-reflection-inventory",
		"title": "Parent Weekly Self-Reflection Inventory | Demo | Qwoach",
		"metaDescription": "Explore a recurring parent reflection inventory for tracking weekly parenting skill use, obstacles, confidence issues, and coaching priorities.",
		"h1": "Parent Weekly Self-Reflection Inventory",
		"intro": "Parent Weekly Self-Reflection Inventory is a recurring self-reflection and practitioner coaching review tool for parent-training practitioners. It helps practitioners see which parenting skills parents report using, avoiding, forgetting, or needing support with across repeated weeks.",
		"demoTitle": "Configure sample skills and view the weekly pattern matrix.",
		"demoPrompt": "Interested in using Parent Weekly Self-Reflection Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0628-f-031-iy-003-r001-parent-weekly-self-reflection-inventory.md",
		"specId": "0628-f-031-iy-003-r001-parent-weekly-self-reflection-inventory",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Skills use",
				"Behavior change"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures weekly parent self-reflection on supplied parenting skills, including use patterns and reflections on obstacles or confidence issues when the inventory structure supports them."
			},
			{
				"title": "Comparability",
				"body": "Historical entries remain comparable when the same inventory structure is used. Changes to skill lists or inventory versions should be preserved in version history."
			},
			{
				"title": "Missing Content State",
				"body": "If inventory items or response options are not supplied, the product should not fabricate them; it should require supplied content or mark the structure unresolved."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include official inventory items?",
				"answer": "No. The demo uses fictional practitioner-supplied skill labels unless supplied inventory content is available."
			},
			{
				"question": "What does the parent complete each week?",
				"answer": "The parent completes the supplied skill items and response structure for that week, including reflections where provided."
			},
			{
				"question": "Can I compare weeks?",
				"answer": "Yes. The review organizes responses by week and skill so repeated patterns can be reviewed descriptively."
			},
			{
				"question": "Does it score parenting skill use?",
				"answer": "No. It shows reported use patterns and reflections without automated adherence judgments or clinical scores."
			}
		]
	},
	{
		"toolType": "praiseLog",
		"slug": "praise-log",
		"title": "Praise Log | Parent Training Home Practice Demo | Qwoach",
		"metaDescription": "Explore a parent praise log for tracking praise frequency, behavior or context, observed child response, and coaching patterns over time.",
		"h1": "Praise Log",
		"intro": "Praise Log is a recurring parent home-practice tracking log for parent-training practitioners. It helps practitioners see whether praise is happening, what child behaviors or contexts it is linked to, and what child responses parents observe.",
		"demoTitle": "Set a focus and preview the parent praise log.",
		"demoPrompt": "Interested in using Praise Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0629-f-031-iy-004-r001-praise-log.md",
		"specId": "0629-f-031-iy-004-r001-praise-log",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Skills use",
				"Behavior change"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The log captures praise frequency or events, the child behavior or context praised, and observed child response when entered."
			},
			{
				"title": "Event Or Daily Summary",
				"body": "Event-based logging preserves more detail, while daily summary logging reduces parent burden. Both are supported configuration choices."
			},
			{
				"title": "Review Limits",
				"body": "The review is descriptive. It does not prescribe a praise quota, rate praise quality, or infer whether reinforcement caused behavior change."
			}
		],
		"faqItems": [
			{
				"question": "Can parents log each praise moment?",
				"answer": "Yes. Event-based logging can capture individual praise moments when selected by the practitioner."
			},
			{
				"question": "Can the log be simpler?",
				"answer": "Yes. Daily summary mode lets parents record approximate frequency with behavior/context and child response details."
			},
			{
				"question": "Does the tool judge praise quality?",
				"answer": "No. It organizes reported frequency, context, and child response without scoring praise quality or parent competence."
			},
			{
				"question": "What is saved when I add it to my account?",
				"answer": "The Praise Log tool and practitioner configuration are saved. Fictional demo praise entries and sample child responses are not saved as real data."
			}
		]
	},
	{
		"toolType": "rewardChartIncentiveProgram",
		"slug": "reward-chart-incentive-program",
		"title": "Reward Chart / Incentive Program | Parent Training Demo | Qwoach",
		"metaDescription": "Explore a reward chart setup for defining target behavior, incentive, reward contingency, and tracking behavior frequency and follow-through.",
		"h1": "Reward Chart / Incentive Program",
		"intro": "Reward Chart / Incentive Program is a positive reinforcement planning and monitoring tool for parent-training practitioners. It helps practitioners and families define a specific target behavior, choose a feasible incentive, clarify when the reward is earned, and track behavior frequency and reward delivery over time.",
		"demoTitle": "Build a sample reward chart and preview tracking.",
		"demoPrompt": "Interested in using Reward Chart / Incentive Program with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0630-f-031-iy-005-r001-reward-chart-incentive-program.md",
		"specId": "0630-f-031-iy-005-r001-reward-chart-incentive-program",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Behavior change",
				"Problem behavior"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Setup Requirements",
				"body": "Tracking cannot begin until the target behavior is specific and observable and an incentive is defined."
			},
			{
				"title": "What It Tracks",
				"body": "The chart tracks reported behavior occurrence or frequency and whether the agreed reward was delivered as arranged."
			},
			{
				"title": "When Plans Change",
				"body": "If the target behavior or incentive changes, a revised arrangement state should be created so prior history remains understandable."
			},
			{
				"title": "Limitations",
				"body": "The tool does not create behavior targets, assign reward values, or produce behavior-change rules beyond the family's positive reinforcement arrangement."
			}
		],
		"faqItems": [
			{
				"question": "What has to be defined before tracking starts?",
				"answer": "An observable target behavior and an incentive must be defined before tracking begins."
			},
			{
				"question": "Who records home tracking?",
				"answer": "The parent or family records behavior occurrence or frequency and whether the agreed reward was delivered."
			},
			{
				"question": "Can there be more than one target behavior?",
				"answer": "Yes, only if the practitioner intentionally creates separate targets. Multiple behaviors should not be mixed into one chart."
			},
			{
				"question": "Does it recommend rewards?",
				"answer": "No. The tool records the incentive chosen with the family; it does not generate reward menus or values."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool and configured arrangement are saved. Fictional tracking entries and sample case data do not carry over as real client data."
			}
		]
	},
	{
		"toolType": "householdRulesPlan",
		"slug": "household-rules-plan",
		"title": "Household Rules Plan for Parent Training | Qwoach",
		"metaDescription": "Create a clear household rule set with caregivers, tied to home routines, agreement status, and follow-through notes for practitioner review.",
		"h1": "Household Rules Plan",
		"intro": "Household Rules Plan is a ready-to-complete-together parent-training tool for practitioners working with caregivers who need clearer expectations and more consistent limits at home. It helps the practitioner and caregivers define a few understandable household rules, connect them to routines or conflict points, and record caregiver agreement and follow-through notes.",
		"demoTitle": "Explore a sample household rules plan",
		"demoPrompt": "Interested in using Household Rules Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0631-f-031-iy-006-r001-household-rules-plan.md",
		"specId": "0631-f-031-iy-006-r001-household-rules-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change"
			],
			"population": [
				"Parents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when household expectations are unclear, handled inconsistently across caregivers, or tied to recurring routines and conflict points."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures caregiver-supplied or practitioner-entered rule text, optional context grouping, agreement status, follow-through notes, and draft or finalized state."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not generate rules, prescribe consequences, score caregivers, collect diagnoses, or make clinical conclusions about family functioning."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create household rules automatically?",
				"answer": "No. Every rule is supplied by the caregiver or entered by the practitioner; the system only organizes and describes completeness."
			},
			{
				"question": "Can a plan be saved before all caregivers agree?",
				"answer": "Yes. Disagreement prevents a ready or agreed state, but partial plans can be saved and resumed."
			},
			{
				"question": "Is this a behavior plan?",
				"answer": "No. It is a household rule-set plan, not a broader behavior-plan builder, discipline plan, or scoring tool."
			}
		]
	},
	{
		"toolType": "routinePlan",
		"slug": "routine-plan",
		"title": "Routine Plan for Parent Training | Qwoach",
		"metaDescription": "Build a concrete family routine with ordered steps, optional timing cues, and adherence barriers for parent-training review.",
		"h1": "Routine Plan",
		"intro": "Routine Plan is a ready-to-complete-together parent-training tool for practitioners working with families struggling with predictable routines and limit setting in daily life. It helps the practitioner and caregiver name a specific daily situation, build an ordered routine, and identify where adherence problems may occur.",
		"demoTitle": "Explore a sample routine plan",
		"demoPrompt": "Interested in using Routine Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0632-f-031-iy-007-r001-routine-plan.md",
		"specId": "0632-f-031-iy-007-r001-routine-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Problem solving"
			],
			"topic": [
				"Behavior change",
				"Problem behavior"
			],
			"population": [
				"Parents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for a specific daily routine that repeatedly becomes unpredictable, conflictual, or difficult to follow."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures the target situation, ordered steps, optional timing cues, adherence barriers, draft or reviewed state, and prior routine versions."
			},
			{
				"title": "Important Limitations",
				"body": "The tool is not a calendar, reminder system, reward plan, or automated explanation of why adherence problems occur."
			}
		],
		"faqItems": [
			{
				"question": "Can a routine be saved without barrier notes?",
				"answer": "Yes. Barrier notes can remain blank if the immediate need is to define the sequence."
			},
			{
				"question": "Does the tool generate routine steps?",
				"answer": "No. Routine steps are entered by the caregiver or practitioner and are not invented by the system."
			},
			{
				"question": "What happens if steps are reordered?",
				"answer": "Attached barriers stay with their steps so the routine sequence and troubleshooting information remain connected."
			}
		]
	},
	{
		"toolType": "rewritingCommandsWorksheet",
		"slug": "rewriting-commands-worksheet",
		"title": "Rewriting Commands Worksheet for Parent Training | Qwoach",
		"metaDescription": "Help parents pair real target situations with original commands and clearer revised directions for practitioner review.",
		"h1": "Rewriting Commands Worksheet",
		"intro": "Rewriting Commands Worksheet is a ready-to-send parent-training worksheet for practitioners working with parents whose commands are unclear, overly negative, or ineffective in target situations. It helps parents record real commands, rewrite them as clearer directions, and give the practitioner paired examples for review.",
		"demoTitle": "Explore a sample command worksheet",
		"demoPrompt": "Interested in using Rewriting Commands Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0633-f-031-iy-008-r001-rewriting-commands-worksheet.md",
		"specId": "0633-f-031-iy-008-r001-rewriting-commands-worksheet",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Skills use",
				"Behavior change"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when parent instructions are ambiguous, overly negative, too complex, or not leading to cooperation in real target situations."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures situation, original command, revised direction, optional notes, and practitioner review status."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not auto-generate directions, score parent language, infer child capability, or become a broader communication coaching product."
			}
		],
		"faqItems": [
			{
				"question": "Does the worksheet write better commands for the parent?",
				"answer": "No. Parents or practitioners enter the revised wording; the system organizes the pairings and flags missing fields."
			},
			{
				"question": "Can a row be saved if the original command is missing?",
				"answer": "Yes. A row can remain partial when the parent only knows the revised wording they want to try."
			},
			{
				"question": "Can one command have multiple revised options?",
				"answer": "Yes. Multiple revisions for one command can be stored as alternatives for review."
			}
		]
	},
	{
		"toolType": "visualCommandCards",
		"slug": "visual-command-cards",
		"title": "Visual Command Cards for Parent Training | Qwoach",
		"metaDescription": "Create visual cue cards for selected caregiver commands with situations, consistency notes, and optional child response observations.",
		"h1": "Visual Command Cards",
		"intro": "Visual Command Cards is a ready-to-complete-together parent-training tool for practitioners working with parents of children with autism spectrum or language-delay needs. It helps practitioners and parents select real caregiver commands, attach accessible visual cues, and record whether the cues appear useful during child response observations.",
		"demoTitle": "Explore a sample command-card set",
		"demoPrompt": "Interested in using Visual Command Cards with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0634-f-031-iy-009-r001-visual-command-cards.md",
		"specId": "0634-f-031-iy-009-r001-visual-command-cards",
		"tags": {
			"framework": [],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Skills use",
				"Autism"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for selected recurring situations where a child may need a visual cue paired with a spoken caregiver direction."
			},
			{
				"title": "What It Captures",
				"body": "The card set captures command, situation, visual cue, use notes, optional response notes, card status, and cue history when cues change."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not diagnose language needs, create a broad communication system, select commands automatically, or make developmental interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Can a card exist without a command?",
				"answer": "No. A cue without a command is invalid because the tool is built around command-cue pairing."
			},
			{
				"question": "Are response notes required?",
				"answer": "No. Response notes are optional when tracking is enabled; a card can remain usable while review is incomplete."
			},
			{
				"question": "Does the tool choose the best visual cue?",
				"answer": "No. The practitioner or parent supplies or selects the cue, and the system records the pairing and observations."
			}
		]
	},
	{
		"toolType": "limitSettingRecordSheet",
		"slug": "limit-setting-record-sheet",
		"title": "Limit Setting Record Sheet for Parent Training | Qwoach",
		"metaDescription": "Record home limit-setting situations with context, parent strategy, and child outcome for descriptive practitioner coaching review.",
		"h1": "Limit Setting Record Sheet",
		"intro": "Limit Setting Record Sheet is a ready-to-send parent-training log for practitioners whose parents are practicing limit setting at home. It helps the practitioner review triggering situations, the strategy the parent used, and the child outcome so coaching can be grounded in reported real events.",
		"demoTitle": "Explore a sample limit-setting log",
		"demoPrompt": "Interested in using Limit Setting Record Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0635-f-031-iy-010-r001-limit-setting-record-sheet.md",
		"specId": "0635-f-031-iy-010-r001-limit-setting-record-sheet",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it while parents are practicing limit setting at home and the practitioner needs concrete event information for follow-up coaching."
			},
			{
				"title": "What It Captures",
				"body": "Each entry captures triggering context, parent strategy, child response or outcome, optional difficulty notes, ordering, and review status."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not score parenting quality, prescribe strategies, infer effectiveness, or treat missing outcomes as known."
			}
		],
		"faqItems": [
			{
				"question": "What counts as a reviewable entry?",
				"answer": "A reviewable entry needs at least a context and either a strategy or outcome."
			},
			{
				"question": "Does the record sheet evaluate whether a strategy worked?",
				"answer": "No. It shows reported events and descriptive patterns for practitioner coaching discussion."
			},
			{
				"question": "What happens if no entries are submitted?",
				"answer": "The review shows an empty state, not a conclusion about whether limit setting occurred."
			}
		]
	},
	{
		"toolType": "problemSolvingChart",
		"slug": "problem-solving-chart",
		"title": "Problem-Solving Chart for Parent Training | Qwoach",
		"metaDescription": "Guide parents from a specific problem to considered response options, a selected solution, and optional follow-up review.",
		"h1": "Problem-Solving Chart",
		"intro": "Problem-Solving Chart is a ready-to-complete-together parent-training tool for practitioners working with parents facing recurring child or family problems. It helps define the problem specifically, consider possible responses, select a workable solution, and preserve a basis for later review.",
		"demoTitle": "Explore a sample problem-solving chart",
		"demoPrompt": "Interested in using Problem-Solving Chart with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0636-f-031-iy-011-r001-problem-solving-chart.md",
		"specId": "0636-f-031-iy-011-r001-problem-solving-chart",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Problem solving",
				"Skill practice"
			],
			"topic": [
				"Problem solving"
			],
			"population": [
				"Parents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a parent faces a recurring child or family problem and needs a structured way to choose a response."
			},
			{
				"title": "What It Captures",
				"body": "The chart captures problem definition, possible responses, selected solution, optional feasibility or review notes, and chart status."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not generate solutions, score options, provide risk assessment, or function as a treatment planner."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend which option to choose?",
				"answer": "No. The parent and practitioner select the solution; the system only records and organizes the staged chart."
			},
			{
				"question": "Can a chart be saved with only one option?",
				"answer": "Yes. It can be saved, but review shows that multiple options have not yet been considered."
			},
			{
				"question": "Is follow-up review required?",
				"answer": "No. Follow-up review is a setting; the chart can stop at selected solution when that configuration is used."
			}
		]
	},
	{
		"toolType": "emotionCoachingPracticeLog",
		"slug": "emotion-coaching-practice-log",
		"title": "Emotion Coaching Practice Log for Parent Training | Qwoach",
		"metaDescription": "Track parent emotion-coaching attempts by context, frequency, and child response for descriptive practitioner review and support.",
		"h1": "Emotion Coaching Practice Log",
		"intro": "Emotion Coaching Practice Log is a ready-to-send parent-training log for practitioners whose parents are learning emotion coaching. It helps the practitioner see how often emotion coaching is used, in what child emotion situations, and with what reported child response.",
		"demoTitle": "Explore a sample practice log",
		"demoPrompt": "Interested in using Emotion Coaching Practice Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0637-f-031-iy-012-r001-emotion-coaching-practice-log.md",
		"specId": "0637-f-031-iy-012-r001-emotion-coaching-practice-log",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Emotion regulation",
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when parents are practicing emotion coaching at home and the practitioner needs to see frequency, contexts, and reported child responses."
			},
			{
				"title": "What It Captures",
				"body": "The log captures practice period, entries, child emotion situation or context, parent use, child response, optional notes, review status, and coaching notes."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not collect clinical emotion ratings, standardized regulation scores, diagnosis, or automated judgments of parent skill."
			}
		],
		"faqItems": [
			{
				"question": "Is this a child mood tracker?",
				"answer": "No. It records parent emotion-coaching attempts, not child mood generally."
			},
			{
				"question": "What if no entries are submitted?",
				"answer": "No entries means there is no home-practice evidence in the log; it is not treated as proof that practice did not occur."
			},
			{
				"question": "Can parents use daily counts instead of event entries?",
				"answer": "Yes. Daily count with examples is a supported entry mode, but it provides less context-specific detail than event-by-event entries."
			}
		]
	},
	{
		"toolType": "socialPersistenceAcademicCoachingLog",
		"slug": "social-persistence-academic-coaching-log",
		"title": "Social, Persistence, and Academic Coaching Log | Qwoach",
		"metaDescription": "Record parent coaching practice by target type, context, and parent-use detail for descriptive practitioner review over time.",
		"h1": "Social/Persistence/Academic Coaching Log",
		"intro": "Social/Persistence/Academic Coaching Log is a ready-to-send parent-training log for practitioners whose parents are learning to coach social, persistence, or academic skills through everyday interactions. It helps the practitioner see target type, context, and parent-use detail so practice patterns and support needs are visible.",
		"demoTitle": "Explore a sample coaching log",
		"demoPrompt": "Interested in using Social/Persistence/Academic Coaching Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0638-f-031-iy-013-r001-social-persistence-academic-coaching-log.md",
		"specId": "0638-f-031-iy-013-r001-social-persistence-academic-coaching-log",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when parents are practicing social, persistence, or academic coaching through everyday parent-child interactions."
			},
			{
				"title": "What It Captures",
				"body": "The log captures target category, context, parent-use detail, optional notes, optional child response notes, practice period, and review status."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not assess child development, grade academics, rate coaching quality, or invent coaching category definitions beyond supported labels."
			}
		],
		"faqItems": [
			{
				"question": "Can the practitioner enable only one coaching target?",
				"answer": "Yes. The target set can include social, persistence, academic, or a subset for a practice period."
			},
			{
				"question": "Does the log define each coaching category for parents?",
				"answer": "No. Unsupported category definitions are not invented by the tool; practitioners may provide framing outside the captured structure."
			},
			{
				"question": "What does no submitted entry mean?",
				"answer": "No submitted entry means no logged practice data is available; it is not interpreted as no coaching."
			}
		]
	},
	{
		"toolType": "parentEvaluationForm",
		"slug": "parent-evaluation-form",
		"title": "Parent Evaluation Form for Parent Training | Qwoach",
		"metaDescription": "Collect parent satisfaction and process feedback after a parent-training session or segment for descriptive delivery review.",
		"h1": "Parent Evaluation Form",
		"intro": "Parent Evaluation Form is a ready-to-send parent-training feedback form for practitioners who need parent satisfaction and process experience after a session or program segment. It helps the practitioner review what helped learning, what did not help, and what concerns or barriers may affect participation.",
		"demoTitle": "Explore a sample evaluation form",
		"demoPrompt": "Interested in using Parent Evaluation Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0639-f-031-iy-014-r001-parent-evaluation-form.md",
		"specId": "0639-f-031-iy-014-r001-parent-evaluation-form",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Service satisfaction"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after a parent-training session or program segment to collect feedback on parent satisfaction and process experience."
			},
			{
				"title": "What It Captures",
				"body": "The form captures session or segment reference, satisfaction/process feedback, helpful or unhelpful aspects, concerns, participation barriers, submission status, and review status."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not measure child progress, invent rating scales, profile demographics, or create automated sentiment conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a clinical outcome measure?",
				"answer": "No. It captures parent-training process feedback, not clinical outcomes."
			},
			{
				"question": "Can comments be optional?",
				"answer": "Yes. Comments can be optional, or explanations can be required for low or negative feedback if those fields exist."
			},
			{
				"question": "Does the tool assume feedback is anonymous?",
				"answer": "No. Anonymous versus identified feedback is unresolved by the product specification and should not be assumed in the demo."
			}
		]
	},
	{
		"toolType": "leaderSessionChecklist",
		"slug": "leader-session-checklist",
		"title": "Leader Session Checklist for Parent-Training Fidelity | Qwoach",
		"metaDescription": "Record session-specific content and process delivery, omissions, deviations, and review states for parent-training fidelity monitoring.",
		"h1": "Leader Session Checklist",
		"intro": "Leader Session Checklist is a practitioner-only fidelity-monitoring checklist for practitioners leading structured parent-training sessions. It helps the practitioner record whether session-specific content and process standards were delivered, omitted, or deviated from, then compare fidelity information across comparable sessions or leaders.",
		"demoTitle": "Explore a sample session checklist",
		"demoPrompt": "Interested in using Leader Session Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0640-f-031-iy-015-r001-leader-session-checklist.md",
		"specId": "0640-f-031-iy-015-r001-leader-session-checklist",
		"tags": {
			"framework": [],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after or during debrief for structured parent-training sessions where fidelity to required content and process standards must be monitored."
			},
			{
				"title": "What It Captures",
				"body": "The checklist captures session identifier, supplied checklist item states, omissions, deviations, facilitator or process notes, completion state, review status, and historical records."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not invent checklist items, create curricula, manage attendance, schedule sessions, generate fidelity scores unless explicitly supplied, or evaluate clinical outcomes."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client or parent view?",
				"answer": "No. The Leader Session Checklist is practitioner-only."
			},
			{
				"question": "Does the tool create checklist items?",
				"answer": "No. Checklist content must be supplied by the session-specific program configuration."
			},
			{
				"question": "Can incomplete checklists be used as fidelity evidence?",
				"answer": "No. Incomplete checklists remain drafts and should not be treated as completed fidelity records."
			},
			{
				"question": "Can records be compared across leaders?",
				"answer": "Yes, when session and item definitions are consistent enough for comparable records."
			}
		]
	},
	{
		"toolType": "videoVignetteDiscussion",
		"slug": "video-vignette-discussion",
		"title": "Video Vignette Discussion Tool | Qwoach",
		"metaDescription": "A live-session video discussion tool for parent-training practitioners to connect realistic vignettes with parenting strategies and group reflection.",
		"h1": "Video Vignette Discussion",
		"intro": "Video Vignette Discussion is a live-session tool for parent-training practitioners. It helps facilitators use realistic parent-child video scenarios so parents can identify behaviors, compare responses, connect examples to a parenting strategy, and name how they might apply the strategy at home.",
		"demoTitle": "Open the sample vignette discussion",
		"demoPrompt": "Interested in using Video Vignette Discussion with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0641-f-031-iy-016-r001-video-vignette-discussion.md",
		"specId": "0641-f-031-iy-016-r001-video-vignette-discussion",
		"tags": {
			"framework": [],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Behavior change",
				"Skills use"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during a live parent-training session when parents need to see and discuss a concrete parent-child example connected to the strategy being taught."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the selected vignette, linked strategy, discussion-step coverage, and optional descriptive notes. It does not require structured written answers or scoring."
			},
			{
				"title": "Limitations",
				"body": "The tool does not infer parenting competence, predict home use, score parent responses, or create clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score parent discussion?",
				"answer": "No. The tool supports live discussion and can show whether discussion steps were covered, but it does not score parents or infer skill mastery."
			},
			{
				"question": "Do parents need their own accounts?",
				"answer": "No. Parents participate live by watching and discussing the vignette; a separate digital client workflow is not required."
			},
			{
				"question": "What is saved when I save the tool?",
				"answer": "The tool and selected vignette/strategy setup are saved. Demo notes and fictional session content are not saved as real client data."
			},
			{
				"question": "Can I use it without taking notes?",
				"answer": "Yes. Optional notes are available, but the default experience works without note-taking."
			}
		]
	},
	{
		"toolType": "rolePlayPractice",
		"slug": "role-play-practice",
		"title": "Role Play / Practice Tool | Qwoach",
		"metaDescription": "A live-session practice tool for parenting practitioners to set up skill rehearsal, observe enactment, and record coaching focus before home use.",
		"h1": "Role Play / Practice",
		"intro": "Role Play / Practice is a live-session tool for practitioners teaching parenting interaction skills. It helps them set a target skill, frame a simulated parent-child situation, observe how the parent enacts the skill, and record whether correction, coaching, or reinforcement is needed before home use.",
		"demoTitle": "Start a sample practice activity",
		"demoPrompt": "Interested in using Role Play / Practice with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0642-f-031-iy-017-r001-role-play-practice.md",
		"specId": "0642-f-031-iy-017-r001-role-play-practice",
		"tags": {
			"framework": [],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Skills use",
				"Behavior change"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during live teaching when the practitioner needs to observe whether a parent can enact a parenting skill before home use."
			},
			{
				"title": "What It Captures",
				"body": "It captures the target skill, practice scenario, optional reaction cue, descriptive observations, coaching status, and home-use focus."
			},
			{
				"title": "Limitations",
				"body": "The tool does not supply invented scripts, formal rubrics, automatic confidence ratings, clinical scores, or claims that home behavior will generalize."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool include built-in role-play scripts?",
				"answer": "No. Exact prompts, skill steps, and scripts are source-defined or practitioner-entered because they are not supplied in the product specification."
			},
			{
				"question": "Can the practitioner record coaching needs?",
				"answer": "Yes. The practitioner can record descriptive observations and whether correction, coaching, or reinforcement is needed."
			},
			{
				"question": "Is this an asynchronous client activity?",
				"answer": "No. The tool is designed for live role play and facilitator observation during a session."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and reusable setup are saved. Fictional observations and sample participant content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "everyParentSFamilyWorkbook",
		"slug": "every-parent-s-family-workbook",
		"title": "Every Parent's Family Workbook | Qwoach",
		"metaDescription": "A longitudinal workbook tool for individual Standard Triple P delivery, keeping goals, strategies, home practice, and barriers visible across sessions.",
		"h1": "Every Parent's Family Workbook",
		"intro": "Every Parent's Family Workbook is a longitudinal workbook tool for practitioners delivering an individual Standard Triple P parenting program. It helps the practitioner and parent keep goals, selected strategies, home application attempts, barriers, and program-stage context organized across sessions.",
		"demoTitle": "Explore the sample workbook pathway",
		"demoPrompt": "Interested in using Every Parent's Family Workbook with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0643-f-032-tp-001-r001-every-parent-s-family-workbook.md",
		"specId": "0643-f-032-tp-001-r001-every-parent-s-family-workbook",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Homework"
			],
			"population": [
				"Parents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it throughout an individual Standard Triple P program to keep goals, strategies, home practice, barriers, and program sequence connected."
			},
			{
				"title": "Practitioner And Parent Roles",
				"body": "The practitioner controls program framing, selected strategies, and review comments. The parent controls their own workbook entries about goals, home attempts, barriers, and reflections where source-defined."
			},
			{
				"title": "Limitations",
				"body": "Exact workbook prompts and sections are not supplied by the specification. The demo must mark unresolved source content rather than inventing worksheet structure."
			}
		],
		"faqItems": [
			{
				"question": "Does this demo include the exact workbook pages?",
				"answer": "No. The product specification does not supply exact prompts, pages, fields, or worksheet structure, so unresolved content is marked rather than invented."
			},
			{
				"question": "Can parents use the workbook between sessions?",
				"answer": "Yes. The parent view supports a pathway for goals, selected strategies, home application attempts, and barriers where the source workbook supports those entries."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews goals, selected strategies, home application attempts, barriers, program-stage context, and optional review notes."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The workbook tool and reusable configuration are saved. Fictional demo family entries and sample barriers are not saved as real client data."
			}
		]
	},
	{
		"toolType": "everyParentSGroupWorkbook",
		"slug": "every-parent-s-group-workbook",
		"title": "Every Parent's Group Workbook | Qwoach",
		"metaDescription": "A group parenting workbook tool that keeps a cohort aligned to a shared sequence while parents apply content to their own family context.",
		"h1": "Every Parent's Group Workbook",
		"intro": "Every Parent's Group Workbook is a group parenting program workbook for practitioners delivering Triple P-style group programs. It helps the practitioner keep a cohort aligned to a shared program sequence while each participating parent records individualized goals, reflections, home applications, barriers, or questions where the workbook structure supports them.",
		"demoTitle": "Explore the sample group workbook",
		"demoPrompt": "Interested in using Every Parent's Group Workbook with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0644-f-032-tp-002-r001-every-parent-s-group-workbook.md",
		"specId": "0644-f-032-tp-002-r001-every-parent-s-group-workbook",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Homework"
			],
			"population": [
				"Parents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during a group parenting program when all parents follow the same sequence but need to apply content to their own family situations."
			},
			{
				"title": "Privacy Boundary",
				"body": "The group sequence is shared. Individual parent entries are visible to that parent and the practitioner; sharing a barrier or question with the group is intentional, not automatic."
			},
			{
				"title": "Limitations",
				"body": "Exact workbook prompts and worksheets are not provided in the specification, so the demo cannot invent them."
			}
		],
		"faqItems": [
			{
				"question": "Can parents see each other’s entries?",
				"answer": "No, not by default. Each parent sees their own entries, and sharing a barrier or question with the group must be intentional if supported."
			},
			{
				"question": "Does the tool compare parents against each other?",
				"answer": "No. The tool supports group sequence alignment and individual application, not comparative ranking or scoring."
			},
			{
				"question": "What does the practitioner configure?",
				"answer": "The practitioner configures the current group program stage and works with participant-specific workbook states. Substantive workbook content remains source-defined."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The workbook tool and reusable group-stage setup are saved. Fictional cohort and participant entries are not saved as real client data."
			}
		]
	},
	{
		"toolType": "selfHelpWorkbook",
		"slug": "self-help-workbook",
		"title": "Self-Help Workbook Tool | Qwoach",
		"metaDescription": "A 10-week self-directed parenting skills workbook that shows current stage, progress, incomplete steps, and barriers when practitioner review is enabled.",
		"h1": "Self-Help Workbook",
		"intro": "Self-Help Workbook is a self-directed structured parenting skills workbook for practitioners supporting parents with limited direct contact. It helps a parent move through a 10-week pathway, see the current stage, track completion, and identify barriers to continuing when review is part of delivery.",
		"demoTitle": "Explore the 10-week pathway",
		"demoPrompt": "Interested in using Self-Help Workbook with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0645-f-032-tp-003-r001-self-help-workbook.md",
		"specId": "0645-f-032-tp-003-r001-self-help-workbook",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Skills use",
				"Behavior change"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a parent needs a structured 10-week parenting skills pathway with limited direct practitioner contact."
			},
			{
				"title": "Review Visibility",
				"body": "Practitioner review is optional in the product specification. When enabled, review focuses on stage progress and barriers, not clinical scoring."
			},
			{
				"title": "Limitations",
				"body": "The product specification does not provide exact week topics or tasks, so those content slots must remain source-defined or unresolved."
			}
		],
		"faqItems": [
			{
				"question": "Is the 10-week sequence configurable?",
				"answer": "No. The 10-week sequence is fixed by the represented tool; starting stage and review visibility are the configurable settings."
			},
			{
				"question": "Can the practitioner review progress?",
				"answer": "Yes, when review visibility is enabled. Review shows stage progress, incomplete or skipped stages, and barriers."
			},
			{
				"question": "Does the workbook score parenting skills?",
				"answer": "No. Progress is descriptive and does not indicate skill mastery or clinical change."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The tool, starting stage, and review visibility are saved. Sample progress and fictional barriers are not saved as real client data."
			}
		]
	},
	{
		"toolType": "triplePOnline",
		"slug": "triple-p-online",
		"title": "Triple P Online Demo | Qwoach",
		"metaDescription": "An eight-session web-based Level 4 parenting intervention pathway with session progress, completion visibility, and available outcome review.",
		"h1": "Triple P Online",
		"intro": "Triple P Online is a web-based Level 4 parenting intervention for practitioners supporting families when regular in-person delivery is constrained. It helps parents move through an eight-session online program while the practitioner can review completion status and available outcome information where the program defines it.",
		"demoTitle": "Explore the online program pathway",
		"demoPrompt": "Interested in using Triple P Online with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0646-f-032-tp-004-r001-triple-p-online.md",
		"specId": "0646-f-032-tp-004-r001-triple-p-online",
		"tags": {
			"framework": [],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Skills use",
				"Outcome monitoring",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a family needs Level 4 parenting intervention access online because in-person delivery is constrained."
			},
			{
				"title": "What Review Shows",
				"body": "Review shows session progress, completion visibility, and available outcome information when source-defined measures are present."
			},
			{
				"title": "Limitations",
				"body": "The tool does not invent Level 4 session materials, activities, outcome instruments, scoring frameworks, or clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Can I change the eight-session structure?",
				"answer": "No. The eight-session Level 4 structure is fixed by the represented tool and is not configurable in the demo."
			},
			{
				"question": "What happens if outcome information is not available?",
				"answer": "The review shows progress only and marks outcome review as unavailable rather than inventing data."
			},
			{
				"question": "What can the parent see?",
				"answer": "The parent sees the online session path, current session, completed sessions, remaining sessions, and resume state."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The tool, access state, and practitioner review visibility are saved. Fictional progress and sample outcome data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "prePostClinicalQuestionnaireBattery",
		"slug": "pre-post-clinical-questionnaire-battery",
		"title": "Pre/Post Clinical Questionnaire Battery | Qwoach",
		"metaDescription": "A before-and-after questionnaire battery for parenting intervention monitoring, showing comparable domains, scores, change, and missing data.",
		"h1": "Pre/Post Clinical Questionnaire Battery",
		"intro": "Pre/Post Clinical Questionnaire Battery is an outcome monitoring tool for practitioners starting and ending a parenting intervention. It helps them collect the same relevant parent, child, and family questionnaire domains at baseline and follow-up, compare supported scores or indicators over time, and identify improvement, deterioration, or remaining concern where source-defined rules allow.",
		"demoTitle": "Explore the sample outcome profile",
		"demoPrompt": "Interested in using Pre/Post Clinical Questionnaire Battery with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0647-f-032-tp-005-r001-pre-post-clinical-questionnaire-battery.md",
		"specId": "0647-f-032-tp-005-r001-pre-post-clinical-questionnaire-battery",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at the start and end of a parenting intervention when the practitioner needs comparable outcome information."
			},
			{
				"title": "Comparability",
				"body": "The same relevant domains must be available at baseline and follow-up for comparison. Missing, incomplete, or different measures are shown as limited or non-comparable."
			},
			{
				"title": "Limitations",
				"body": "The tool does not invent questionnaires, items, domains, thresholds, clinical diagnoses, or next-step recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can the tool compare different measures across baseline and follow-up?",
				"answer": "No. Domains are compared only when the selected measures and scoring rules support comparability."
			},
			{
				"question": "What if scoring rules are unavailable?",
				"answer": "The tool can organize responses and completion status, but scoring is marked unresolved rather than calculated."
			},
			{
				"question": "Does the system make clinical decisions?",
				"answer": "No. The system shows supported scores and comparisons; the practitioner adds interpretation and next-step decisions."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool, selected battery, and time-point configuration are saved. Fictional responses and sample scores are not saved as real client data."
			}
		]
	},
	{
		"toolType": "strengthsAndDifficultiesQuestionnaireSdq",
		"slug": "strengths-and-difficulties-questionnaire-sdq",
		"title": "SDQ Questionnaire Tool | Qwoach",
		"metaDescription": "An SDQ administration and review tool for child behavior outcomes, with source-defined scoring, domain profile, and repeat comparison when available.",
		"h1": "Strengths and Difficulties Questionnaire (SDQ)",
		"intro": "Strengths and Difficulties Questionnaire (SDQ) is a standardized child behavioral and emotional outcome questionnaire for practitioners evaluating parenting programs. It helps them administer the source-defined SDQ form, calculate supported score profiles when rules are supplied, and compare results over time when repeated administrations are comparable.",
		"demoTitle": "Explore a sample SDQ administration",
		"demoPrompt": "Interested in using Strengths and Difficulties Questionnaire (SDQ) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0648-f-032-tp-006-r001-strengths-and-difficulties-questionnaire-sdq.md",
		"specId": "0648-f-032-tp-006-r001-strengths-and-difficulties-questionnaire-sdq",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when child behavioral and emotional difficulty scores are needed as part of parenting program evaluation."
			},
			{
				"title": "Repeat Comparison",
				"body": "Repeated administrations can be compared only when the version and scoring framework support comparison."
			},
			{
				"title": "Limitations",
				"body": "The tool does not invent SDQ items, domains, thresholds, diagnosis, treatment recommendations, or unsupported interpretation labels."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include SDQ item text?",
				"answer": "No. The product specification does not supply item text, so the demo uses source-defined item slots rather than invented items."
			},
			{
				"question": "Can SDQ results be compared over time?",
				"answer": "Yes, when repeated administrations are comparable under the supplied SDQ version and scoring framework."
			},
			{
				"question": "What happens if scoring rules are unavailable?",
				"answer": "Responses and completion status can be shown, but scoring is marked unresolved."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The SDQ tool and selected administration setup are saved. Fictional responses and sample scores are not saved as real client data."
			}
		]
	},
	{
		"toolType": "eybergChildBehaviorInventoryEcbi2",
		"slug": "eyberg-child-behavior-inventory-ecbi-2",
		"title": "ECBI Questionnaire Tool | Qwoach",
		"metaDescription": "An ECBI administration and review tool for standardized child behavior problem scores, scoring status, and repeat comparison when rules are supplied.",
		"h1": "Eyberg Child Behavior Inventory (ECBI)",
		"intro": "Eyberg Child Behavior Inventory (ECBI) is a standardized clinical child behavior measure for practitioners supporting families in parenting interventions. It helps them administer the source-defined ECBI, calculate supported behavior scores when rules are supplied, and compare repeated administrations to understand whether behavior problems are improving or persisting.",
		"demoTitle": "Explore a sample ECBI administration",
		"demoPrompt": "Interested in using Eyberg Child Behavior Inventory (ECBI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0649-f-032-tp-007-r001-eyberg-child-behavior-inventory-ecbi.md",
		"specId": "0649-f-032-tp-007-r001-eyberg-child-behavior-inventory-ecbi",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when standardized child behavior problem scores are needed to evaluate behavior change and guide parenting-support discussion."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated scores can be compared only when administrations use compatible versions and source-defined scoring rules."
			},
			{
				"title": "Limitations",
				"body": "The tool does not invent ECBI items, response scales, thresholds, subdomains, diagnosis, or treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include ECBI item text?",
				"answer": "No. Item text is not supplied in the product specification, so the demo uses source-defined item slots rather than invented content."
			},
			{
				"question": "Can the tool show improvement or persistence?",
				"answer": "Yes, only when repeated administrations are comparable and scoring rules support the change comparison."
			},
			{
				"question": "What if responses are incomplete?",
				"answer": "The administration remains incomplete unless the source scoring rules allow calculation with missing responses."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The ECBI tool and administration setup are saved. Fictional responses and sample scores are not saved as real client data."
			}
		]
	},
	{
		"toolType": "parentingScale",
		"slug": "parenting-scale",
		"title": "Parenting Scale Tool | Qwoach",
		"metaDescription": "A Parenting Scale administration and review tool for discipline-practices profiles, scoring status, and baseline/follow-up comparison.",
		"h1": "Parenting Scale",
		"intro": "Parenting Scale is a standardized measure for practitioners evaluating a parent’s discipline or parenting style as part of a parenting program. It helps them administer the source-defined measure, calculate supported profile scores when rules are supplied, and compare baseline and follow-up profiles when administrations are comparable.",
		"demoTitle": "Explore a sample Parenting Scale administration",
		"demoPrompt": "Interested in using Parenting Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0650-f-032-tp-008-r001-parenting-scale.md",
		"specId": "0650-f-032-tp-008-r001-parenting-scale",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Outcome monitoring"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when discipline practices or parenting style need to be reviewed as part of parenting program evaluation."
			},
			{
				"title": "Baseline And Follow-Up",
				"body": "Profiles can be compared over time only when administrations are compatible under the measure’s scoring framework."
			},
			{
				"title": "Limitations",
				"body": "The tool does not invent item text, response scales, parenting dimensions, thresholds, coaching recommendations, or clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create a coaching plan?",
				"answer": "No. The tool can show supported profile outputs; the practitioner decides feedback or coaching focus."
			},
			{
				"question": "Can it identify strengths and concerns?",
				"answer": "Yes, only where source-defined scoring and interpretation rules support those labels."
			},
			{
				"question": "What happens if scoring rules are unavailable?",
				"answer": "The review marks scoring unresolved and does not calculate unsupported profile outputs."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The Parenting Scale tool and administration setup are saved. Fictional responses and sample profile data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "parentProblemChecklist",
		"slug": "parent-problem-checklist",
		"title": "Parent Problem Checklist Demo | Qwoach",
		"metaDescription": "Explore a coparenting problem checklist for two-parent families that helps practitioners review parenting-related disagreement and severity.",
		"h1": "Parent Problem Checklist for Two-Parent Coparenting Problems",
		"intro": "The Parent Problem Checklist is a ready-to-send checklist for practitioners working with two-parent families. It helps practitioners identify parenting-related disagreement or coordination problem areas and review their severity so caregiver alignment can be considered during parenting support.",
		"demoTitle": "Preview the checklist, then review a sample coparenting problem profile.",
		"demoPrompt": "Interested in using Parent Problem Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0651-f-032-tp-009-r001-parent-problem-checklist.md",
		"specId": "0651-f-032-tp-009-r001-parent-problem-checklist",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Parents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when parenting-related disagreement or coordination between caregivers may affect parenting consistency in a two-parent family."
			},
			{
				"title": "What It Shows",
				"body": "It shows a checklist-derived profile of coparenting problem areas and severity, with longitudinal comparison only when comparable repeat administrations exist."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate diagnoses, causal explanations, legal or custody details, relationship history, or parenting strategy recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can practitioners edit the checklist items?",
				"answer": "No. The checklist items, response anchors, scoring, and severity labels are fixed by the instrument definition once supplied."
			},
			{
				"question": "Does this replace a general relationship assessment?",
				"answer": "No. It is limited to parenting-related coparenting disagreement or coordination problems in a two-parent family context."
			},
			{
				"question": "Can results be compared over time?",
				"answer": "Yes. Results can be compared when repeated administrations use the same checklist structure and scoring basis."
			},
			{
				"question": "What happens if only one caregiver responds?",
				"answer": "The result shows whose report is present and avoids implying a complete dyadic picture unless the instrument supports that use."
			}
		]
	},
	{
		"toolType": "relationshipQualityIndex",
		"slug": "relationship-quality-index",
		"title": "Relationship Quality Index Demo | Qwoach",
		"metaDescription": "Explore a relationship quality score measure for parenting support contexts, with practitioner review of score, interpretation, and change over time.",
		"h1": "Relationship Quality Index for Parenting Support Contexts",
		"intro": "The Relationship Quality Index is a ready-to-send measure for practitioners when relationship quality may affect parenting intervention outcomes. It helps practitioners obtain an interpretable score for the relevant caregiver relationship and compare repeated scores over time.",
		"demoTitle": "Preview the measure and review a sample relationship quality score.",
		"demoPrompt": "Interested in using Relationship Quality Index with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0652-f-032-tp-010-r001-relationship-quality-index.md",
		"specId": "0652-f-032-tp-010-r001-relationship-quality-index",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Interpersonal relationships",
				"Outcome monitoring"
			],
			"population": [
				"Parents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the caregiver relationship context may affect parenting intervention participation, progress, or outcome evaluation."
			},
			{
				"title": "What It Captures",
				"body": "It captures fixed relationship quality item responses and produces a score with instrument-supported interpretation where available."
			},
			{
				"title": "Important Limits",
				"body": "It does not provide relationship diagnosis, cause analysis, couples-treatment recommendations, safety determinations, or parenting outcome predictions."
			}
		],
		"faqItems": [
			{
				"question": "Is the Relationship Quality Index configurable?",
				"answer": "No. Practitioners select the measure and administration context, but item content, scoring, and interpretation labels are fixed by the instrument."
			},
			{
				"question": "Can multiple respondents complete it?",
				"answer": "Yes, if multiple respondents are used, the review must show whose responses produced each score and must not merge scores unless the instrument defines a combined method."
			},
			{
				"question": "Can scores be trended?",
				"answer": "Yes. Repeated scores can be compared only when the same scoring basis is used."
			}
		]
	},
	{
		"toolType": "dass21",
		"slug": "dass-21",
		"title": "DASS-21 Demo for Parenting Support | Qwoach",
		"metaDescription": "Explore DASS-21 for parent adjustment review, with depression, anxiety, and stress scores, supported concern levels, and repeat comparison.",
		"h1": "DASS-21 Parent Adjustment Scores for Parenting Support",
		"intro": "DASS-21 is a ready-to-send 21-item measure for practitioners working in parenting support contexts. It helps practitioners review parent adjustment scores for depression, anxiety, and stress so parent wellbeing can be considered in planning and evaluation.",
		"demoTitle": "Preview the parent measure and review a sample three-domain score profile.",
		"demoPrompt": "Interested in using DASS-21 with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0653-f-032-tp-011-r001-dass-21.md",
		"specId": "0653-f-032-tp-011-r001-dass-21",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Depression",
				"Anxiety",
				"Stress"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Domains Reviewed",
				"body": "The result distinguishes depression, anxiety, and stress domains rather than combining parent adjustment into a single broad note."
			},
			{
				"title": "Repeat Monitoring",
				"body": "Repeated results can be reviewed by domain when the same scoring basis is used."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate diagnosis, risk conclusions, treatment recommendations, parenting-capacity judgments, or advice for the parent."
			}
		],
		"faqItems": [
			{
				"question": "Does DASS-21 provide three separate scores?",
				"answer": "Yes. The review distinguishes depression, anxiety, and stress domain scores."
			},
			{
				"question": "Can practitioners change the scoring or severity labels?",
				"answer": "No. Scoring and severity or concern labels are fixed by the supported measure definition."
			},
			{
				"question": "What happens with incomplete responses?",
				"answer": "Incomplete administrations are marked incomplete and do not produce final scores unless the measure defines partial scoring."
			},
			{
				"question": "Does the tool provide treatment guidance?",
				"answer": "No. It presents supported scores and concern levels but does not provide diagnosis, treatment guidance, or crisis triage."
			}
		]
	},
	{
		"toolType": "parentDailyReportChecklist",
		"slug": "parent-daily-report-checklist",
		"title": "Parent Daily Report Checklist Demo | Qwoach",
		"metaDescription": "Explore a repeated parent daily report checklist that tracks child behavior frequency over time and shows missing, partial, and trend states.",
		"h1": "Parent Daily Report Checklist for Repeated Behavior Frequency Tracking",
		"intro": "The Parent Daily Report Checklist is a repeated reporting tool for practitioners monitoring specific child behaviors during parenting support. It helps practitioners collect parent-reported frequency data from the home context and review whether target behaviors are increasing, decreasing, or stable.",
		"demoTitle": "Set up sample behavior tracking and review the time-based pattern.",
		"demoPrompt": "Interested in using Parent Daily Report Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0654-f-032-tp-012-r001-parent-daily-report-checklist.md",
		"specId": "0654-f-032-tp-012-r001-parent-daily-report-checklist",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Outcome monitoring"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures parent-reported frequency for tracked behaviors at each relevant day or time point."
			},
			{
				"title": "Missing Is Not Zero",
				"body": "Missed entries are shown as gaps, while zero-frequency reports are treated as completed reports with zero occurrence."
			},
			{
				"title": "Comparison Limits",
				"body": "Trend comparison remains valid only while behavior definitions and frequency basis remain consistent."
			}
		],
		"faqItems": [
			{
				"question": "Can practitioners choose which behaviors to track?",
				"answer": "Yes, only if the instrument supports choosing tracked behaviors from a defined set."
			},
			{
				"question": "Does a missed daily report count as zero behavior?",
				"answer": "No. Missed entries are shown as missing and are not converted into zero-frequency reports."
			},
			{
				"question": "Does the tool explain why behavior changed?",
				"answer": "No. It shows reported frequency patterns and trend direction but does not infer causes."
			},
			{
				"question": "Can multiple children be tracked together?",
				"answer": "No. Multiple children should have child-specific reporting kept separate."
			}
		]
	},
	{
		"toolType": "clientSatisfactionQuestionnaire",
		"slug": "client-satisfaction-questionnaire",
		"title": "Client Satisfaction Questionnaire Demo | Qwoach",
		"metaDescription": "Explore a post-service parent feedback questionnaire that helps practitioners review satisfaction, perceived fit, concern areas, and summaries.",
		"h1": "Client Satisfaction Questionnaire for Parenting Service Feedback",
		"intro": "The Client Satisfaction Questionnaire is a ready-to-send post-service feedback measure for practitioners and program reviewers. It helps collect parent feedback about satisfaction with the intervention and perceived fit so service acceptability can be reviewed and improved.",
		"demoTitle": "Preview the parent feedback form and review a sample satisfaction summary.",
		"demoPrompt": "Interested in using Client Satisfaction Questionnaire with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0655-f-032-tp-013-r001-client-satisfaction-questionnaire.md",
		"specId": "0655-f-032-tp-013-r001-client-satisfaction-questionnaire",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Service satisfaction"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after parenting support so feedback reflects the parent's actual service experience."
			},
			{
				"title": "Individual And Program Views",
				"body": "Individual feedback supports service episode review, while aggregate summaries support program-level service acceptability review when response counts are available."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not infer clinical outcomes, adjudicate complaints, automatically evaluate staff, or run unsupported sentiment analysis."
			}
		],
		"faqItems": [
			{
				"question": "When should the questionnaire be sent?",
				"answer": "It should be sent after a parent has received parenting support."
			},
			{
				"question": "Can practitioners edit the satisfaction questions?",
				"answer": "No. Questionnaire content, response options, scoring, and summary rules are fixed by the questionnaire definition."
			},
			{
				"question": "Can feedback be summarized across a program?",
				"answer": "Yes. Aggregate summaries can be shown where enough responses exist and counts and time periods are clear."
			},
			{
				"question": "Does the tool judge service quality automatically?",
				"answer": "No. It summarizes reported feedback and does not invent service-quality conclusions."
			}
		]
	},
	{
		"toolType": "automaticScoringAndReportingApplicationAsra",
		"slug": "automatic-scoring-and-reporting-application-asra",
		"title": "ASRA Scoring and Reporting Demo | Qwoach",
		"metaDescription": "Explore practitioner-only scoring and reporting for supported parenting evaluation data, including individual, longitudinal, and aggregate views.",
		"h1": "ASRA Scoring and Reporting for Parenting Evaluation Data",
		"intro": "Automatic Scoring and Reporting Application (ASRA) is a practitioner-only scoring and reporting application for supported parenting-program evaluation data. It helps practitioners convert raw evaluation data into calculated scores, report-ready views, longitudinal profiles, and aggregate summaries for clinical or program review.",
		"demoTitle": "Load sample evaluation data and review scoring, reports, and aggregate views.",
		"demoPrompt": "Interested in using Automatic Scoring and Reporting Application (ASRA) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0656-f-032-tp-014-r001-automatic-scoring-and-reporting-application-asra.md",
		"specId": "0656-f-032-tp-014-r001-automatic-scoring-and-reporting-application-asra",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review",
				"Clinical documentation"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Reporting Scopes",
				"body": "ASRA supports individual, longitudinal, group/program, and regional reporting scopes where supported by the underlying data and definitions."
			},
			{
				"title": "Data Quality",
				"body": "Missing values, unsupported measures, duplicate records, small aggregate groups, and changed scoring bases are flagged rather than silently scored or merged."
			},
			{
				"title": "Important Limits",
				"body": "ASRA does not score unknown measures, generate causal interpretations, provide clinical recommendations, or serve as a general survey builder or analytics warehouse."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client-facing ASRA view?",
				"answer": "No. ASRA is practitioner-only; client data comes from upstream questionnaire or evaluation sources."
			},
			{
				"question": "Can ASRA score any questionnaire?",
				"answer": "No. It scores only supported measures with defined scoring rules."
			},
			{
				"question": "What happens with missing values?",
				"answer": "Missing values are flagged and handled only according to defined rules."
			},
			{
				"question": "Can aggregate summaries be reviewed?",
				"answer": "Yes. Aggregate summaries are available for supported group, program, or regional scopes with counts and inclusion basis shown."
			}
		]
	},
	{
		"toolType": "positiveParentingGoalPlan",
		"slug": "positive-parenting-goal-plan",
		"title": "Positive Parenting Goal Plan Demo | Qwoach",
		"metaDescription": "Explore a collaborative parenting goal plan that helps practitioners and parents capture meaningful goals, concrete actions, and progress review.",
		"h1": "Positive Parenting Goal Plan for Parent-Owned Goals and Actions",
		"intro": "The Positive Parenting Goal Plan is a collaborative planning tool for practitioners and parents. It helps define personally meaningful parenting changes, connect them to concrete actions, and keep the plan ready for progress review over time.",
		"demoTitle": "Build a sample goal-action plan and preview the parent view.",
		"demoPrompt": "Interested in using Positive Parenting Goal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0657-f-032-tp-015-r001-positive-parenting-goal-plan.md",
		"specId": "0657-f-032-tp-015-r001-positive-parenting-goal-plan",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Behavior change"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Parent Ownership",
				"body": "The plan should reflect goals the parent understands and endorses as meaningful for their family."
			},
			{
				"title": "Actions Matter",
				"body": "A goal without a connected action remains incomplete because the plan is meant to support home practice."
			},
			{
				"title": "Progress Review",
				"body": "Review is descriptive and tied to selected goals; the tool does not score goal quality or generate strategies."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate parenting strategies?",
				"answer": "No. The tool organizes parent-owned goals and concrete actions but does not generate prescribed strategies."
			},
			{
				"question": "Can a plan have more than one goal?",
				"answer": "Yes. Multiple goals are supported, but the product does not force unsupported categories or counts."
			},
			{
				"question": "What makes a goal plan complete?",
				"answer": "A plan is complete when goals are connected to concrete actions and parent ownership is confirmed."
			},
			{
				"question": "Can progress be reviewed later?",
				"answer": "Yes. Historical plans persist so progress can be reviewed against the selected goals over time."
			}
		]
	},
	{
		"toolType": "behaviorProblemPlan",
		"slug": "behavior-problem-plan",
		"title": "Behavior Problem Plan Demo | Qwoach",
		"metaDescription": "Explore a collaborative behavior problem plan that links a recognizable target behavior to selected strategies and progress markers.",
		"h1": "Behavior Problem Plan for Target Behavior, Strategies, and Progress Markers",
		"intro": "The Behavior Problem Plan is a ready-to-complete-together tool for practitioners and families. It helps define a recognizable target behavior, record selected parenting strategies, and identify progress markers so the parent can respond consistently and review change over time.",
		"demoTitle": "Build a sample behavior plan and review the parent home view.",
		"demoPrompt": "Interested in using Behavior Problem Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0658-f-032-tp-016-r001-behavior-problem-plan.md",
		"specId": "0658-f-032-tp-016-r001-behavior-problem-plan",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "One Focused Target",
				"body": "The plan is designed around a specific behavior problem. Multiple problems should be separated to avoid mixing progress."
			},
			{
				"title": "Progress Markers",
				"body": "A progress marker is required so later review can judge change in relation to the target behavior."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not invent strategies, diagnose behavior, assign risk grades, or score progress with unsupported rubrics."
			}
		],
		"faqItems": [
			{
				"question": "What must be included for the plan to be complete?",
				"answer": "The plan needs a recognizable target behavior, selected strategies, and a progress marker."
			},
			{
				"question": "Can one plan cover multiple behavior problems?",
				"answer": "No. Separate behavior problems should be handled in separate plans or clearly separated targets."
			},
			{
				"question": "Does the tool recommend strategies automatically?",
				"answer": "No. Strategy selection comes from practitioner and family work within the surrounding program; the tool records the selected strategies."
			},
			{
				"question": "What happens when strategies change?",
				"answer": "Strategy changes should be visible in history so review periods before and after the change remain understandable."
			}
		]
	},
	{
		"toolType": "triplePDiscussionGroupWorkbookDealingWithDisobedience",
		"slug": "triple-p-discussion-group-workbook-dealing-with-disobedience",
		"title": "Dealing with Disobedience Workbook Demo | Qwoach",
		"metaDescription": "Explore a Level 3 discussion group workbook flow for disobedience, with target situations, selected strategies, response plans, and reflections.",
		"h1": "Triple P Discussion Group Workbook: Dealing with Disobedience",
		"intro": "Triple P Discussion Group Workbook: Dealing with disobedience is a topic-specific workbook for trained practitioners facilitating Level 3 groups with parents of children up to 12. It helps parents identify disobedience situations, select strategies, describe how they will respond to noncompliance, and record reflections for follow-up.",
		"demoTitle": "Preview the workbook flow and review a sample home approach summary.",
		"demoPrompt": "Interested in using Triple P Discussion Group Workbook: Dealing with disobedience with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0659-f-032-tp-017-r001-triple-p-discussion-group-workbook-dealing-with-disobedience.md",
		"specId": "0659-f-032-tp-017-r001-triple-p-discussion-group-workbook-dealing-with-disobedience",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Problem behavior",
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Topic Scope",
				"body": "This workbook is specific to disobedience, listening, following directions, and noncompliance for parents of children up to 12."
			},
			{
				"title": "Practitioner And Parent Roles",
				"body": "The practitioner facilitates the group and review; the parent completes workbook responses, reflections, and home practice notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not add workbook prompts, scoring, diagnosis, video content, or generalized parenting recommendations beyond the supported workbook content."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general behavior planning tool?",
				"answer": "No. It is specific to the Dealing with disobedience Level 3 discussion group workbook topic."
			},
			{
				"question": "Can the practitioner edit the workbook content?",
				"answer": "No. Substantive workbook prompts, exercises, strategy content, and video content are fixed once supplied."
			},
			{
				"question": "What if a parent misses part of the group?",
				"answer": "Partial workbook progress is preserved and supported take-home sections can be completed where the workbook allows."
			},
			{
				"question": "Does the review prove the approach worked?",
				"answer": "No. Review can show reflections and follow-up discussion, but it does not infer success or strategy effectiveness."
			}
		]
	},
	{
		"toolType": "triplePDiscussionGroupWorkbookManagingFightingAndAggression",
		"slug": "triple-p-discussion-group-workbook-managing-fighting-and-aggression",
		"title": "Managing Fighting and Aggression Demo | Qwoach",
		"metaDescription": "Explore a Level 3 discussion group workbook flow for fighting and aggression, including target situations, intervention notes, and reflections.",
		"h1": "Triple P Discussion Group Workbook: Managing Fighting and Aggression",
		"intro": "Triple P Discussion Group Workbook: Managing fighting and aggression is a topic-specific workbook for trained practitioners facilitating Level 3 groups with parents of children up to 12. It helps parents identify aggressive behaviors and situations, record selected strategies, describe how they will intervene, and note how they will teach alternative behavior.",
		"demoTitle": "Preview the workbook flow and review a sample aggression-topic home approach.",
		"demoPrompt": "Interested in using Triple P Discussion Group Workbook: Managing fighting and aggression with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0660-f-032-tp-017-r002-triple-p-discussion-group-workbook-managing-fighting-and-aggression.md",
		"specId": "0660-f-032-tp-017-r002-triple-p-discussion-group-workbook-managing-fighting-and-aggression",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Problem behavior",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Topic Scope",
				"body": "This workbook is specific to fighting, biting, hitting, or related aggression for parents of children up to 12."
			},
			{
				"title": "What It Captures",
				"body": "It captures targeted aggressive behaviors or situations, selected strategies, intervention response, alternative-behavior teaching notes, and home practice reflections."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide aggression severity scores, safety classifications, diagnoses, invented strategy content, or automatic recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general aggression risk tool?",
				"answer": "No. It is a topic-specific Level 3 discussion group workbook, not a risk scoring or safety classification tool."
			},
			{
				"question": "Can the practitioner edit workbook prompts?",
				"answer": "No. Workbook prompts, exercises, strategy descriptions, and video content are fixed once supplied."
			},
			{
				"question": "What makes the home approach incomplete?",
				"answer": "The home approach is incomplete when the target behavior or situation, intervention response, or alternative-behavior teaching plan is missing."
			},
			{
				"question": "Does the tool prove the approach is safe or effective?",
				"answer": "No. It organizes the parent’s plan and reflections but does not infer safety level or strategy effectiveness."
			}
		]
	},
	{
		"toolType": "triplePDiscussionGroupWorkbookDevelopingGoodBedtimeRoutines",
		"slug": "triple-p-discussion-group-workbook-developing-good-bedtime-routines",
		"title": "Developing Good Bedtime Routines Workbook Demo | Qwoach",
		"metaDescription": "Explore a Triple P bedtime routines workbook flow for practitioners facilitating parent discussion groups, planning, practice notes, and review.",
		"h1": "Developing good bedtime routines workbook for Triple P Discussion Groups",
		"intro": "The Developing good bedtime routines workbook is a topic-specific Triple P Discussion Group tool for trained practitioners working with caregivers of children up to 12. It helps practitioners guide caregivers to describe bedtime problems, plan consistent bedtime responses, and review home practice notes.",
		"demoTitle": "Explore the bedtime workbook demo with sample caregiver entries, then save the tool for your practice.",
		"demoPrompt": "Interested in using Triple P Discussion Group Workbook: Developing good bedtime routines with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0661-f-032-tp-017-r003-triple-p-discussion-group-workbook-developing-good-bedtime-routines.md",
		"specId": "0661-f-032-tp-017-r003-triple-p-discussion-group-workbook-developing-good-bedtime-routines",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Sleep",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this workbook during or after a Level 3 Discussion Group for caregivers of children up to 12 when bedtime is marked by resistance, inconsistent routines, or difficulty staying in bed."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures caregiver-reported bedtime difficulties, current routine points, goals, selected plan elements, reflections, and home practice notes. It deliberately avoids sleep scores, diagnoses, and unsupported sleep metrics."
			},
			{
				"title": "Review Over Time",
				"body": "Practice notes remain linked to the plan version used so later changes do not overwrite what the caregiver tried at home."
			}
		],
		"faqItems": [
			{
				"question": "Is this a sleep tracker?",
				"answer": "No. This is a topic-specific bedtime routine workbook for guided planning and reflection, not a sleep tracker or diagnostic sleep assessment."
			},
			{
				"question": "Can caregivers complete it at home?",
				"answer": "Yes. The supported completion mode can be during-session, take-home, or mixed, and the result labels planning and practice content accordingly."
			},
			{
				"question": "Does the tool recommend bedtime strategies automatically?",
				"answer": "No. It organizes caregiver-entered plan elements and practitioner-supported choices where available, but it does not generate unsupported recommendations."
			},
			{
				"question": "What happens if practice notes are missing?",
				"answer": "The plan can remain ready for practice, and the review surface marks practice review as unavailable or incomplete."
			}
		]
	},
	{
		"toolType": "triplePDiscussionGroupWorkbookHassleFreeShoppingWithChildren",
		"slug": "triple-p-discussion-group-workbook-hassle-free-shopping-with-children",
		"title": "Hassle-Free Shopping With Children Workbook Demo | Qwoach",
		"metaDescription": "Explore a Triple P shopping outing workbook demo for practitioners guiding caregiver planning, community practice, reflection, and review.",
		"h1": "Hassle-free shopping with children workbook for Triple P Discussion Groups",
		"intro": "The Hassle-free shopping with children workbook is a topic-specific Triple P Discussion Group tool for trained practitioners supporting caregivers of children up to 12. It helps practitioners guide caregivers to identify outing problems, set expectations, plan preventive steps and responses, and reflect after community practice.",
		"demoTitle": "Explore the shopping workbook demo with sample outing content, then save the tool for your practice.",
		"demoPrompt": "Interested in using Triple P Discussion Group Workbook: Hassle-free shopping with children with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0662-f-032-tp-017-r004-triple-p-discussion-group-workbook-hassle-free-shopping-with-children.md",
		"specId": "0662-f-032-tp-017-r004-triple-p-discussion-group-workbook-hassle-free-shopping-with-children",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this workbook when caregivers need to prepare for shopping trips or public outings that often become stressful or disruptive because of child behavior."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the outing context, triggers or child behaviors, goals, preventive steps, expectations, responses, reflections, and practice notes. It does not collect purchase details or location tracking."
			},
			{
				"title": "Multiple Outing Types",
				"body": "If more than one outing type is discussed, plans should remain separate by context so triggers and responses are not blended."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general behavior tracker?",
				"answer": "No. It is a fixed Triple P shopping/public-outing workbook flow for planning and reflection around a specific outing context."
			},
			{
				"question": "Can a caregiver complete the plan before an actual outing?",
				"answer": "Yes. The plan can be marked ready for practice, with practice notes pending until an outing occurs."
			},
			{
				"question": "Does the tool compare different outings automatically?",
				"answer": "No. It preserves plans by outing context and can show practice notes, but it does not create unsupported behavior categories or scores."
			},
			{
				"question": "What if a caregiver has no upcoming shopping trip?",
				"answer": "The plan can be completed and marked practice pending until a real shopping trip or public outing occurs."
			}
		]
	},
	{
		"toolType": "triplePDiscussionGroupWorkbookHassleFreeMealtimesWithChildren",
		"slug": "triple-p-discussion-group-workbook-hassle-free-mealtimes-with-children",
		"title": "Hassle-Free Mealtimes With Children Workbook Demo | Qwoach",
		"metaDescription": "Explore a Triple P mealtimes workbook demo for practitioners guiding caregiver planning, home practice reflections, and mealtime review.",
		"h1": "Hassle-free mealtimes with children workbook for Triple P Discussion Groups",
		"intro": "The Hassle-free mealtimes with children workbook is a topic-specific Triple P Discussion Group tool for trained practitioners working with caregivers of children up to 12. It helps practitioners guide caregivers to identify mealtime problems, choose strategies, plan routines or expectations, and reflect on home practice.",
		"demoTitle": "Explore the mealtimes workbook demo with sample caregiver content, then save the tool for your practice.",
		"demoPrompt": "Interested in using Triple P Discussion Group Workbook: Hassle-free mealtimes with children with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0663-f-032-tp-017-r005-triple-p-discussion-group-workbook-hassle-free-mealtimes-with-children.md",
		"specId": "0663-f-032-tp-017-r005-triple-p-discussion-group-workbook-hassle-free-mealtimes-with-children",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this workbook when caregivers need a practical approach for family mealtimes involving conflict, fussiness, or difficult behavior."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures caregiver-reported mealtime problems, goals, selected strategies, planned routines or expectations, reflections, and practice notes. It does not collect dietary intake or create nutrition recommendations."
			},
			{
				"title": "Practice Review",
				"body": "Practice notes stay linked to the plan version used so revisions do not overwrite what was tried at home."
			}
		],
		"faqItems": [
			{
				"question": "Is this a nutrition planner?",
				"answer": "No. This is a mealtime behavior planning and reflection workbook, not a dietary analysis, food log, or medical feeding assessment."
			},
			{
				"question": "Can partial entries be saved?",
				"answer": "Yes. Partial entries are preserved as draft or incomplete so the practitioner can discuss missing areas without treating the plan as finished."
			},
			{
				"question": "Does the tool decide whether the plan worked?",
				"answer": "No. It organizes reported practice notes and missing elements, but it does not infer efficacy, causes, or clinical conclusions."
			},
			{
				"question": "Can the same caregiver record different meal contexts?",
				"answer": "Yes, different meal or context notes can be organized descriptively, but not as a new score or unsupported measurement dimension."
			}
		]
	},
	{
		"toolType": "17PositiveParentingStrategies",
		"slug": "17-positive-parenting-strategies",
		"title": "17 Positive Parenting Strategies Reference Demo | Qwoach",
		"metaDescription": "Explore a fixed Triple P strategy reference with optional selected-strategy notes for practitioners supporting caregiver understanding and fit.",
		"h1": "17 Positive Parenting Strategies reference for intensive parenting intervention",
		"intro": "17 Positive Parenting Strategies is a fixed reference and strategy-selection support tool for practitioners delivering intensive Triple P parenting intervention. It helps practitioners present the core strategy set so caregivers can distinguish broad purposes, choose relevant strategies, and explain when and how they would use them.",
		"demoTitle": "Explore the reference and optional selection summary, then save the tool for your practice.",
		"demoPrompt": "Interested in using 17 Positive Parenting Strategies with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0664-f-032-tp-018-r001-17-positive-parenting-strategies.md",
		"specId": "0664-f-032-tp-018-r001-17-positive-parenting-strategies",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Problem behavior"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Reference-Only Use",
				"body": "When used as psychoeducation only, the tool does not create an artificial result. It functions as a fixed reference during practitioner-led discussion."
			},
			{
				"title": "Optional Summary Use",
				"body": "When selected-strategy summary mode is enabled, the tool records caregiver selections and intended-use notes for later follow-up."
			},
			{
				"title": "Unresolved Strategy Content",
				"body": "The demo must not display invented strategy names, descriptions, categories, or practice instructions where official content has not been supplied."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool have a required structured output?",
				"answer": "No. The record states there is no inherent structured output; selected-strategy capture is optional when the practitioner enables summary mode."
			},
			{
				"question": "Can the demo list all 17 strategy names?",
				"answer": "No. The exact strategy names and descriptions are unresolved unless supplied by program materials, so the demo uses unresolved content slots rather than invented names."
			},
			{
				"question": "Does the tool recommend which strategies to choose?",
				"answer": "No. The practitioner supports discussion of fit, and the tool can record caregiver selections, but it does not operate as a recommendation engine."
			},
			{
				"question": "What is saved if the practitioner uses reference-only mode?",
				"answer": "The fixed tool is saved as-is with reference-only mode selected, even though no structured client result is created."
			}
		]
	},
	{
		"toolType": "sessionSummaryFidelityChecklist",
		"slug": "session-summary-fidelity-checklist",
		"title": "Session Summary / Fidelity Checklist Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only fidelity checklist for structured parenting sessions, including component status, participation, deviations, and review.",
		"h1": "Session Summary / Fidelity Checklist for structured parenting sessions",
		"intro": "Session Summary / Fidelity Checklist is a practitioner-only implementation monitoring tool for structured parenting sessions. It helps practitioners or quality leads capture required component status, attendance or participation, and deviations so session fidelity can be reviewed over time.",
		"demoTitle": "Complete a sample session checklist, review the fidelity summary, then save the tool for your account.",
		"demoPrompt": "Interested in using Session Summary / Fidelity Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0665-f-032-tp-019-r001-session-summary-fidelity-checklist.md",
		"specId": "0665-f-032-tp-019-r001-session-summary-fidelity-checklist",
		"tags": {
			"framework": [
				"Triple P"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Tool",
				"body": "This tool is completed by the practitioner or authorized quality role after session delivery. There is no parent-facing worksheet or client completion flow."
			},
			{
				"title": "What It Captures",
				"body": "The checklist captures required component status, attendance or participation, deviation notes, completion state, and review notes."
			},
			{
				"title": "Comparison Over Time",
				"body": "Completed summaries can be compared only when the checklist structure and version support like-for-like comparison."
			}
		],
		"faqItems": [
			{
				"question": "Do clients complete this checklist?",
				"answer": "No. This is a practitioner-only fidelity and implementation tool; clients may be represented only in attendance or participation data."
			},
			{
				"question": "Does the checklist rate practitioner competence?",
				"answer": "No. It records implementation data and deviations, but it does not create an automated competence judgment."
			},
			{
				"question": "Can a checklist be saved as a draft?",
				"answer": "Yes. Missing attendance or incomplete component status can leave the checklist in draft state with clear incomplete markers."
			},
			{
				"question": "Can sessions with different templates be compared?",
				"answer": "Only comparable fields from the same checklist structure or version should be compared; different templates should be separated or clearly marked."
			}
		]
	},
	{
		"toolType": "signsOfSafetyAssessmentAndPlanningMap",
		"slug": "signs-of-safety-assessment-and-planning-map",
		"title": "Signs of Safety Assessment and Planning Map Demo | Qwoach",
		"metaDescription": "Explore a child safety mapping demo for organizing worries, strengths, safety, complicating factors, perspectives, and next direction.",
		"h1": "Signs of Safety Assessment and Planning Map for child safety formulation",
		"intro": "The Signs of Safety Assessment and Planning Map is a structured child safety formulation tool for practitioners working with family, child, network, and professional perspectives. It helps practitioners organize worries, strengths, existing safety, complicating factors, and direction for change so safety planning can be grounded in a shared case understanding.",
		"demoTitle": "Explore a sample map with fictional entries, then save the tool for your account.",
		"demoPrompt": "Interested in using Signs of Safety Assessment and Planning Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0666-f-033-sos-001-r001-signs-of-safety-assessment-and-planning-map.md",
		"specId": "0666-f-033-sos-001-r001-signs-of-safety-assessment-and-planning-map",
		"tags": {
			"framework": [
				"Signs of Safety"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Risk review"
			],
			"topic": [
				"Crisis response"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "Collaborative Use",
				"body": "The map can be completed with family, child, network, and professional perspectives, while the practitioner controls the formal case map and keeps contributions attributable."
			},
			{
				"title": "What It Shows",
				"body": "The map shows worries, strengths, existing safety, complicating factors, and direction for change within the defined framework structure."
			},
			{
				"title": "History and Updates",
				"body": "When new evidence changes the formulation, the current map can be updated while decision-relevant prior snapshots are preserved."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide whether a child is safe?",
				"answer": "No. It organizes case information for practitioner formulation and review, but it does not make automated safety decisions or assign risk levels."
			},
			{
				"question": "Can conflicting perspectives be recorded?",
				"answer": "Yes. Conflicting perspectives should remain as distinct attributed entries rather than being merged automatically."
			},
			{
				"question": "Is this the same as a generic risk assessment builder?",
				"answer": "No. It preserves the Signs of Safety map structure and does not create unsupported categories or generic assessment prompts."
			},
			{
				"question": "What happens if some perspectives are missing?",
				"answer": "The map can remain draft or partial, and missing perspectives are flagged rather than invented."
			}
		]
	},
	{
		"toolType": "dangerStatement",
		"slug": "danger-statement",
		"title": "Danger Statement Drafting Demo | Qwoach",
		"metaDescription": "Explore a focused child protection danger statement demo for drafting explicit worries, feared harm, review status, and version history.",
		"h1": "Danger Statement drafting tool for child protection practice",
		"intro": "Danger Statement is a focused formulation tool for child protection practitioners using Signs of Safety practice. It helps practitioners draft and review a clear statement of who is worried, what adult behavior or condition creates danger, which child may be harmed, and what adults fear could happen if nothing changes.",
		"demoTitle": "Draft a sample danger statement with fictional details, then save the tool for your practice.",
		"demoPrompt": "Interested in using Danger Statement with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0667-f-033-sos-002-r001-danger-statement.md",
		"specId": "0667-f-033-sos-002-r001-danger-statement",
		"tags": {
			"framework": [
				"Signs of Safety"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Crisis response"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "Focused Scope",
				"body": "The tool supports drafting and reviewing a danger statement only. It does not create the full assessment map, safety goal, safety plan, or case decision."
			},
			{
				"title": "Participant Perspectives",
				"body": "Family or network perspectives can be captured separately during practitioner-facilitated review, while the formal statement remains practitioner-controlled."
			},
			{
				"title": "Version History",
				"body": "Revisions preserve prior versions when statements have been used in meetings or planning."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool write the danger statement for the practitioner?",
				"answer": "No. It organizes supported elements and flags missing or vague areas, but the practitioner controls the final wording."
			},
			{
				"question": "Does it create a risk score?",
				"answer": "No. The output is an explicit danger statement, not a risk level, score, or automated safety conclusion."
			},
			{
				"question": "Can family disagreement be recorded?",
				"answer": "Yes. Family or network perspectives can be captured separately from the practitioner-formulated statement."
			},
			{
				"question": "Can there be more than one danger statement?",
				"answer": "Yes. Multiple children or harms should be handled as separate statements or clearly separated references rather than blended concerns."
			}
		]
	},
	{
		"toolType": "safetyGoal",
		"slug": "safety-goal",
		"title": "Safety Goal Drafting Demo | Qwoach",
		"metaDescription": "Explore a focused safety goal demo for defining observable safety endpoints tied to child protection worries, review status, and history.",
		"h1": "Safety Goal drafting tool for child safety planning",
		"intro": "Safety Goal is a focused Signs of Safety formulation tool for child protection practitioners. It helps practitioners draft an observable safety endpoint tied to an identified worry, including adult behaviors and child safety conditions that family and network members can understand and show over time.",
		"demoTitle": "Draft a sample safety goal with fictional details, then save the tool for your practice.",
		"demoPrompt": "Interested in using Safety Goal with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0668-f-033-sos-003-r001-safety-goal.md",
		"specId": "0668-f-033-sos-003-r001-safety-goal",
		"tags": {
			"framework": [
				"Signs of Safety"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Risk review"
			],
			"topic": [
				"Crisis response",
				"Goals"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "Focused Scope",
				"body": "The tool drafts and reviews the safety goal only. It does not create the danger statement, safety plan actions, risk score, or safety decision."
			},
			{
				"title": "Observable Endpoint",
				"body": "The goal should describe adult behaviors and child safety conditions that can be reviewed against evidence over time."
			},
			{
				"title": "Revisions",
				"body": "When a goal changes after planning or evidence review, prior versions remain linked to earlier planning context."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool generate a safety plan?",
				"answer": "No. It supports the safety goal endpoint only; concrete safety plan actions are developed separately."
			},
			{
				"question": "Does the tool decide whether the goal has been achieved?",
				"answer": "No. It can preserve the goal for evidence review, but it does not determine safety sufficiency or achievement."
			},
			{
				"question": "What if the goal is too abstract?",
				"answer": "The tool can flag missing observable behavior or conditions, but the practitioner must revise the substantive wording."
			},
			{
				"question": "Can multiple dangers have separate goals?",
				"answer": "Yes. Multiple dangers should use separate goals or clearly linked goal sections rather than one blended endpoint."
			}
		]
	},
	{
		"toolType": "safetyScale",
		"slug": "safety-scale",
		"title": "Safety Scale Rating and Rationale Demo | Qwoach",
		"metaDescription": "Explore a Signs of Safety scale demo for collecting specific 0-10 safety ratings, rationales, stakeholder comparison, and trends.",
		"h1": "Safety Scale for 0-10 child safety judgments with rationale",
		"intro": "Safety Scale is a Signs of Safety rating-and-rationale tool for child safety practitioners. It helps practitioners collect a 0-10 safety judgment tied to a specific safety question, record each respondent’s rationale, and compare family, network, and professional perspectives over time.",
		"demoTitle": "Try a sample safety question and ratings, then save the tool for your practice.",
		"demoPrompt": "Interested in using Safety Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0669-f-033-sos-004-r001-safety-scale.md",
		"specId": "0669-f-033-sos-004-r001-safety-scale",
		"tags": {
			"framework": [
				"Signs of Safety"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Crisis response",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "Question-Specific Ratings",
				"body": "Each rating is meaningful only in relation to the exact safety question asked. Ratings from different questions should not be trended as the same scale."
			},
			{
				"title": "Rationale Matters",
				"body": "A complete response includes both the 0-10 rating and the respondent’s evidence or reasoning."
			},
			{
				"title": "Descriptive Comparison",
				"body": "The tool can show differences between stakeholders and changes over time, but it does not resolve disagreement or make a safety decision."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool average ratings into a safety decision?",
				"answer": "No. Ratings are compared descriptively with rationales; the tool does not average them into a decision score."
			},
			{
				"question": "Can ratings be collected from different stakeholders?",
				"answer": "Yes. Family members, network members, and professionals can each provide or have recorded a rating and rationale."
			},
			{
				"question": "Can a rating be complete without a rationale?",
				"answer": "No. A rating without rationale is marked incomplete for review."
			},
			{
				"question": "Can different safety questions be trended together?",
				"answer": "No. Ratings should be trended only when they refer to the same specific safety question."
			}
		]
	},
	{
		"toolType": "myThreeHouses",
		"slug": "my-three-houses",
		"title": "My Three Houses Child Perspective Demo | Qwoach",
		"metaDescription": "Explore a My Three Houses demo for capturing child worries, positives, hopes, practitioner notes, review status, and planning links.",
		"h1": "My Three Houses child-perspective tool for safety casework",
		"intro": "My Three Houses is a child-centered Signs of Safety perspective-gathering tool for child safety practitioners. It helps practitioners capture what a child says or shows about what is worrying, what is going well or feels safe, and what they want to be different so the child’s perspective can inform assessment and planning.",
		"demoTitle": "Explore a sample three-house record, then save the tool for your practice.",
		"demoPrompt": "Interested in using My Three Houses with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0670-f-033-sos-005-r001-my-three-houses.md",
		"specId": "0670-f-033-sos-005-r001-my-three-houses",
		"tags": {
			"framework": [
				"Signs of Safety"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Crisis response"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Facilitated Use",
				"body": "The child experience is facilitated by the practitioner by default. The child is not expected to complete a stand-alone self-service workflow."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the child’s worries, what is going well or feels safe or comforting, and hopes or wanted differences, using words, representations, or labeled summaries."
			},
			{
				"title": "Non-Interpretive Record",
				"body": "The tool preserves what was shared and how it was recorded, but does not interpret drawings, score statements, or judge credibility."
			}
		],
		"faqItems": [
			{
				"question": "Is My Three Houses a clinical interpretation tool?",
				"answer": "No. It captures the child’s perspective in a structured format but does not interpret drawings or statements clinically."
			},
			{
				"question": "Does the child have to complete every house?",
				"answer": "No. Partial perspective should be preserved without forcing completion of all three areas."
			},
			{
				"question": "Can practitioners summarize what the child said?",
				"answer": "Yes. Practitioner summaries can be recorded, but they must be labeled separately from the child’s own words or representations."
			},
			{
				"question": "Can the record connect to wider safety planning?",
				"answer": "Yes. The practitioner can link the child’s perspective to wider assessment or planning notes where appropriate."
			}
		]
	},
	{
		"toolType": "wordsAndPicturesExplanation",
		"slug": "words-and-pictures-explanation",
		"title": "Words and Pictures Explanation Demo | Qwoach",
		"metaDescription": "Explore a Words and Pictures Explanation tool for creating agreed child-facing narratives about worries, events, and safety arrangements.",
		"h1": "Words and Pictures Explanation for Child Safety Communication",
		"intro": "Words and Pictures Explanation is a child safety communication tool for practitioners, caregivers, and relevant professionals. It helps them create an agreed, developmentally understandable narrative about serious worries, past events, current safety arrangements, and what adults are doing to keep the child safe.",
		"demoTitle": "Explore a sample explanation workspace",
		"demoPrompt": "Interested in using Words and Pictures Explanation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0671-f-033-sos-006-r001-words-and-pictures-explanation.md",
		"specId": "0671-f-033-sos-006-r001-words-and-pictures-explanation",
		"tags": {
			"framework": [
				"Signs of Safety"
			],
			"toolType": [
				"Therapeutic document"
			],
			"workflow": [
				"Therapeutic consolidation"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when serious family safety concerns and adult safety actions affect a child and adults need a clear, agreed explanation that avoids unnecessary detail or minimization."
			},
			{
				"title": "What It Tracks",
				"body": "The tool tracks the narrative, the worries and safety arrangements it connects, participant agreement, section status, unresolved content, and prior agreed versions when the explanation changes."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not determine truth, severity, blame, or clinical meaning. Exact wording, picture representation, and sharing method remain practitioner-authored."
			}
		],
		"faqItems": [
			{
				"question": "Does the child complete this tool?",
				"answer": "No. The child does not need a data-entry experience. The child-facing experience is receiving the agreed explanation when adults decide it is ready to share."
			},
			{
				"question": "Can caregivers review the explanation?",
				"answer": "Yes. A caregiver or professional review surface may allow invited adults to suggest corrections, identify confusing or unsafe wording, and indicate agreement or concern."
			},
			{
				"question": "Does the tool write the explanation automatically?",
				"answer": "No. The practitioner authors the exact wording and any pictures or child-facing presentation because the supplied specification does not define those details."
			},
			{
				"question": "What happens if adults disagree?",
				"answer": "The explanation remains unresolved and should not be marked agreed until concerns are resolved or clearly tracked as unresolved."
			}
		]
	},
	{
		"toolType": "safetyPlan",
		"slug": "safety-plan",
		"title": "Safety Plan Demo for Child Safety Planning | Qwoach",
		"metaDescription": "Explore a child safety plan tool that maps worries to observable adult actions, role assignments, review methods, and implementation evidence.",
		"h1": "Safety Plan for Observable Child Safety Arrangements",
		"intro": "Safety Plan is a child safety planning tool for practitioners working with caregivers and safety networks. It helps them define concrete adult behaviors, assign responsibility, record review methods, and see whether agreed arrangements are occurring in everyday situations.",
		"demoTitle": "Explore a sample safety plan",
		"demoPrompt": "Interested in using Safety Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0672-f-033-sos-007-r001-safety-plan.md",
		"specId": "0672-f-033-sos-007-r001-safety-plan",
		"tags": {
			"framework": [
				"Signs of Safety"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures identified safety worries, everyday situations, observable arrangements, assigned people or roles, review methods, implementation evidence, and changes over time."
			},
			{
				"title": "Practitioner And Network Roles",
				"body": "The practitioner controls plan acceptance and interpretation. Caregivers and network members may help shape feasible arrangements and provide review information about whether actions occurred."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool is not a generic task tracker and does not compute unsupported safety conclusions. Arrangements must be observable, assigned, connected to worries, and reviewable."
			}
		],
		"faqItems": [
			{
				"question": "Is this just a task list?",
				"answer": "No. The plan is specifically for child safety arrangements linked to identified worries, everyday situations, assigned adult behaviors, and review evidence."
			},
			{
				"question": "Can network members enter review information?",
				"answer": "Yes, where invited. They may confirm role understanding, record whether an agreed behavior occurred, and add brief factual notes."
			},
			{
				"question": "What happens if an arrangement is not observable?",
				"answer": "It should be revised before being treated as active because observable adult behavior is required for the plan to satisfy its purpose."
			},
			{
				"question": "Does the tool decide the child is safe?",
				"answer": "No. It shows arrangements and review evidence. Practitioner interpretation of whether safety is adequate remains separate."
			}
		]
	},
	{
		"toolType": "safetyNetworkMap",
		"slug": "safety-network-map",
		"title": "Safety Network Map Demo | Qwoach",
		"metaDescription": "Explore a safety network map that links named people to child safety concerns, roles, availability, confirmation status, and coverage gaps.",
		"h1": "Safety Network Map for Child Safety Roles and Coverage",
		"intro": "Safety Network Map is a child safety network-mapping tool for practitioners, families, and safety network members. It helps identify named people who understand the safety concerns, have realistic availability, and hold clear roles in supporting or monitoring child safety.",
		"demoTitle": "Explore a sample network map",
		"demoPrompt": "Interested in using Safety Network Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0673-f-033-sos-008-r001-safety-network-map.md",
		"specId": "0673-f-033-sos-008-r001-safety-network-map",
		"tags": {
			"framework": [
				"Signs of Safety"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "What Counts As Network Coverage",
				"body": "A person counts toward coverage only when they are realistically available, understand the relevant safety concern, and have a role clear enough to act on."
			},
			{
				"title": "Participant Roles",
				"body": "The practitioner facilitates and reviews the full map. Family members may suggest people and roles. Network members may confirm role understanding where appropriate."
			},
			{
				"title": "Relevant Limitations",
				"body": "The map is not a generic contact list, family tree, or support directory. It does not infer trustworthiness, legal authority, or safety adequacy."
			}
		],
		"faqItems": [
			{
				"question": "Can someone be listed without counting as coverage?",
				"answer": "Yes. A person without an actionable safety role or realistic availability can be listed but remains unresolved for coverage."
			},
			{
				"question": "Do network members complete assessments?",
				"answer": "No. Their interaction is limited to clarifying availability, understanding the relevant concern, and confirming their role where appropriate."
			},
			{
				"question": "What happens if a high-concern time has no coverage?",
				"answer": "The result highlights the gap so the practitioner can address it in planning."
			},
			{
				"question": "Is this a contact directory?",
				"answer": "No. Inclusion depends on actionable safety relevance, not general family or support contact status."
			}
		]
	},
	{
		"toolType": "safetyTimelineTrajectory",
		"slug": "safety-timeline-trajectory",
		"title": "Safety Timeline / Trajectory Demo | Qwoach",
		"metaDescription": "Explore a child safety trajectory tool for mapping dangers, safety goals, milestones, responsibilities, review points, and expected evidence.",
		"h1": "Safety Timeline / Trajectory for Child Safety Case Progression",
		"intro": "Safety Timeline / Trajectory is a practitioner-only child safety case pathway tool. It helps practitioners coordinate current dangers, safety goals, planned actions, milestones, responsibilities, review points, and expected evidence of progress over time.",
		"demoTitle": "Explore a sample trajectory",
		"demoPrompt": "Interested in using Safety Timeline / Trajectory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0674-f-033-sos-009-r001-safety-timeline-trajectory.md",
		"specId": "0674-f-033-sos-009-r001-safety-timeline-trajectory",
		"tags": {
			"framework": [
				"Signs of Safety"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a practitioner needs to coordinate a child safety case over time and make the pathway from concerns to demonstrated safety explicit."
			},
			{
				"title": "History And Comparison",
				"body": "Prior trajectory states, milestone expectations, review points, and status changes persist so the practitioner can compare what was expected with what changed."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool is not a generic scheduler. Milestones must connect to child safety concerns, safety goals, and expected evidence."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include a client-facing view?",
				"answer": "No. The supplied specification defines practitioner-only usage for this tool."
			},
			{
				"question": "What does a milestone need to include?",
				"answer": "A milestone should include timing, responsibility, a linked danger or safety goal, planned action, review point, and expected evidence."
			},
			{
				"question": "Can the trajectory be updated when evidence changes?",
				"answer": "Yes. The trajectory can be updated while preserving prior states for historical comparison."
			},
			{
				"question": "Does the tool predict whether the case will become safe?",
				"answer": "No. It organizes the pathway and evidence status; it does not create unsupported safety predictions."
			}
		]
	},
	{
		"toolType": "middleColumnStrengthsSafetyMapping",
		"slug": "middle-column-strengths-safety-mapping",
		"title": "Middle Column Strengths/Safety Mapping Demo | Qwoach",
		"metaDescription": "Explore a middle-column mapping tool for identifying strengths, demonstrated safety actions, resources, and planning relevance in child safety work.",
		"h1": "Middle Column Strengths/Safety Mapping for Existing Safety Evidence",
		"intro": "Middle Column Strengths/Safety Mapping is an assessment mapping tool for child safety practitioners and contributors. It helps identify existing strengths, demonstrated protective actions, and family or network resources that can support future safety planning.",
		"demoTitle": "Explore a sample middle-column map",
		"demoPrompt": "Interested in using Middle Column Strengths/Safety Mapping with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0675-f-033-sos-010-r001-middle-column-strengths-safety-mapping.md",
		"specId": "0675-f-033-sos-010-r001-middle-column-strengths-safety-mapping",
		"tags": {
			"framework": [
				"Signs of Safety"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "What It Distinguishes",
				"body": "The tool distinguishes general strengths from demonstrated safety actions and resources. Demonstrated safety requires specific behavior tied to a real situation where safety was maintained."
			},
			{
				"title": "How Contributors Participate",
				"body": "Family and network contributors may provide examples and clarification. The practitioner decides how entries are classified and whether they are strong enough for planning."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool is not a generic strengths questionnaire and does not claim that existing strengths prove future safety."
			}
		],
		"faqItems": [
			{
				"question": "What is the difference between a strength and demonstrated safety?",
				"answer": "Demonstrated safety is a specific protective action tied to a real situation where safety was maintained. A general strength may be positive but not yet specific enough to count as demonstrated safety."
			},
			{
				"question": "Can family members contribute examples?",
				"answer": "Yes. A collaborative view may allow plain-language examples, which the practitioner reviews and classifies."
			},
			{
				"question": "Does the tool score safety?",
				"answer": "No. It organizes examples and specificity cues but does not invent safety ratings or claim future safety is assured."
			},
			{
				"question": "What happens to vague entries?",
				"answer": "Vague entries remain visible for clarification and are not treated as demonstrated safety until they include specific behavior and a real situation."
			}
		]
	},
	{
		"toolType": "mandatoryReporterGuideMrg",
		"slug": "mandatory-reporter-guide-mrg",
		"title": "Mandatory Reporter Guide Demo | Qwoach",
		"metaDescription": "Explore an MRG decision-support tool for structured report/no-report routing, unknown handling, next action, and reviewable rationale.",
		"h1": "Mandatory Reporter Guide for Child Protection Reporting Decisions",
		"intro": "Mandatory Reporter Guide (MRG) is a practitioner-only decision-support tool for practitioners who receive information suggesting a child may be at risk. It helps them work through configured harm, risk, vulnerability, and caregiver factors to identify a report/no-report, consultation, or support-pathway result with rationale and next action.",
		"demoTitle": "Explore a sample MRG decision path",
		"demoPrompt": "Interested in using Mandatory Reporter Guide (MRG) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0676-f-034-sdm-001-r001-mandatory-reporter-guide-mrg.md",
		"specId": "0676-f-034-sdm-001-r001-mandatory-reporter-guide-mrg",
		"tags": {
			"framework": [
				"SDM"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Risk review"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Requires",
				"body": "The tool requires authoritative decision content before it can generate a valid automated disposition. Without that configuration, the decision content remains unresolved."
			},
			{
				"title": "What It Records",
				"body": "The tool records entered facts, relevant factor responses, unknowns, decision path, final disposition where supported, next action, and rationale."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not conduct an investigation, diagnose harm, or invent reporting thresholds. It is practitioner-only decision support."
			}
		],
		"faqItems": [
			{
				"question": "Can the public demo produce a real report/no-report result?",
				"answer": "No. A valid automated disposition requires authoritative MRG decision content and thresholds, which are not supplied in the demo specification."
			},
			{
				"question": "Does a client or family complete this tool?",
				"answer": "No. The MRG is a practitioner-only intake/reporting decision-support tool."
			},
			{
				"question": "What happens when information is unknown?",
				"answer": "Unknown information is marked explicitly and remains visible in the rationale and review state."
			},
			{
				"question": "What is saved if I save the tool?",
				"answer": "The MRG tool itself is saved, along with any selected authoritative configuration if available. Fictional demo concern details and sample responses are not saved as real client data."
			}
		]
	},
	{
		"toolType": "screeningAndResponsePriorityToolsScrpt",
		"slug": "screening-and-response-priority-tools-scrpt",
		"title": "SCRPT Demo for Intake Screening | Qwoach",
		"metaDescription": "Explore SCRPT intake decision support for screening disposition, response priority, unknown handling, rationale, and required operational response.",
		"h1": "SCRPT for Intake Screening and Response Priority",
		"intro": "Screening and Response Priority Tools (SCRPT) is a practitioner-only intake decision-support tool for child welfare practitioners. It helps determine whether intake information should be accepted for response and how urgently it should be handled, based on configured screening and priority criteria.",
		"demoTitle": "Explore a sample SCRPT workflow",
		"demoPrompt": "Interested in using Screening and Response Priority Tools (SCRPT) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0677-f-034-sdm-002-r001-screening-and-response-priority-tools-scrpt.md",
		"specId": "0677-f-034-sdm-002-r001-screening-and-response-priority-tools-scrpt",
		"tags": {
			"framework": [
				"SDM"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Risk review"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Two Linked Decisions",
				"body": "SCRPT separates whether the intake is accepted for response from how urgent that response is, while keeping the rationale and unknowns visible."
			},
			{
				"title": "Configuration Dependency",
				"body": "Exact disposition categories, priority levels, required response actions, and rules must come from authoritative configuration."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool is not a full investigation, long-term risk classification, or service planning form."
			}
		],
		"faqItems": [
			{
				"question": "Does SCRPT produce both disposition and priority?",
				"answer": "Yes. The result includes both screening disposition and response priority when configured decision content is available."
			},
			{
				"question": "Can the demo invent priority levels?",
				"answer": "No. Exact priority labels and rules must come from authoritative SCRPT configuration."
			},
			{
				"question": "Is there a client-facing version?",
				"answer": "No. SCRPT is a practitioner-only intake screening and prioritization tool."
			},
			{
				"question": "What happens if intake facts are incomplete?",
				"answer": "Unknowns and incomplete factors remain visible, and the result follows configured rules or remains incomplete if a valid decision cannot be generated."
			}
		]
	},
	{
		"toolType": "safetyAssessment",
		"slug": "safety-assessment",
		"title": "Safety Assessment Demo | Qwoach",
		"metaDescription": "Explore a child protection Safety Assessment for present safety status, immediate threats, protective capacities, required actions, and rationale.",
		"h1": "Safety Assessment for Present Child Safety Decisions",
		"intro": "Safety Assessment is a practitioner-only child protection decision-support tool. It helps practitioners determine whether a child is currently safe at a decision point and identify immediate protective actions needed while assessment and case decisions continue.",
		"demoTitle": "Explore a sample safety assessment",
		"demoPrompt": "Interested in using Safety Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0678-f-034-sdm-003-r001-safety-assessment.md",
		"specId": "0678-f-034-sdm-003-r001-safety-assessment",
		"tags": {
			"framework": [
				"SDM"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Present Safety, Not Future Risk",
				"body": "The assessment focuses on current safety at a decision point and required immediate action. Longer-term future risk belongs in a different assessment unless configured content says otherwise."
			},
			{
				"title": "Immediate Action Specificity",
				"body": "If immediate actions are required, they must be specific enough to implement and monitor before the assessment can be treated as complete."
			},
			{
				"title": "Decision-Point History",
				"body": "Prior decision points, facts known, safety status, actions, and rationale persist so later reassessment can be compared."
			}
		],
		"faqItems": [
			{
				"question": "Is this a risk assessment?",
				"answer": "No. This tool concerns current safety and immediate protective action, not future maltreatment risk classification."
			},
			{
				"question": "Does the family complete this assessment?",
				"answer": "No. The tool is practitioner-only, although facts may come from conversations or observation outside the product."
			},
			{
				"question": "What happens if an immediate action is vague?",
				"answer": "The assessment remains incomplete because required actions must be specific enough to implement and monitor."
			},
			{
				"question": "Can the tool create safety status labels without configuration?",
				"answer": "No. Formal safety status labels and decision rules require authoritative safety-assessment configuration."
			}
		]
	},
	{
		"toolType": "riskAssessment",
		"slug": "risk-assessment",
		"title": "Risk Assessment Demo | Qwoach",
		"metaDescription": "Explore a structured child welfare Risk Assessment for factor capture, future-risk classification, rationale, unknowns, and decision support.",
		"h1": "Risk Assessment for Future Maltreatment Risk Classification",
		"intro": "Risk Assessment is a practitioner-only child welfare risk classification tool. It helps practitioners capture caregiver, child, household, and case-history factors to support a structured future-risk classification for service intensity, monitoring, or case planning when authoritative model rules are configured.",
		"demoTitle": "Explore a sample risk assessment",
		"demoPrompt": "Interested in using Risk Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0679-f-034-sdm-004-r001-risk-assessment.md",
		"specId": "0679-f-034-sdm-004-r001-risk-assessment",
		"tags": {
			"framework": [
				"SDM"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Risk review"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "Future Risk, Not Present Safety",
				"body": "The assessment differentiates likelihood of future maltreatment from current safety concerns. Immediate safety threats should be addressed through a safety assessment unless the configured risk model explicitly includes them."
			},
			{
				"title": "Model Configuration",
				"body": "Automated classification requires authoritative factor definitions, weights, thresholds, classification labels, and unknown-handling rules."
			},
			{
				"title": "Reassessment History",
				"body": "Assessment context, factor responses, unknowns, classification, rationale, and model version persist for later comparison."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo calculate a risk classification without model rules?",
				"answer": "No. Automated classification requires authoritative actuarial model configuration."
			},
			{
				"question": "Is this the same as a Safety Assessment?",
				"answer": "No. Risk Assessment concerns future-risk classification; Safety Assessment concerns current safety and immediate protective action."
			},
			{
				"question": "Does a family complete this tool?",
				"answer": "No. The tool is practitioner-only, although assessment facts may come from case information and conversations outside the product."
			},
			{
				"question": "What is saved with the tool?",
				"answer": "The Risk Assessment tool itself is saved, along with any selected actuarial model configuration. Fictional demo factor responses are not saved as real client data."
			}
		]
	},
	{
		"toolType": "familyStrengthsAndNeedsAssessment",
		"slug": "family-strengths-and-needs-assessment",
		"title": "Family Strengths and Needs Assessment Demo | Qwoach",
		"metaDescription": "Explore a family strengths and needs assessment for prioritizing service targets tied to child safety, risk, and family functioning.",
		"h1": "Family Strengths and Needs Assessment for Service Planning",
		"intro": "Family Strengths and Needs Assessment is a child welfare assessment tool for practitioners working with families. It helps identify strengths to build on, needs requiring attention, and prioritized service targets connected to child safety, risk, or family functioning.",
		"demoTitle": "Explore a sample strengths and needs assessment",
		"demoPrompt": "Interested in using Family Strengths and Needs Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0680-f-034-sdm-005-r001-family-strengths-and-needs-assessment.md",
		"specId": "0680-f-034-sdm-005-r001-family-strengths-and-needs-assessment",
		"tags": {
			"framework": [
				"SDM"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "What It Produces",
				"body": "The assessment produces prioritized targets for service planning, with links to strengths, needs, and child safety, risk, or family functioning concerns."
			},
			{
				"title": "Family Participation",
				"body": "Families can review strengths, needs, and priorities in plain language, add context, and understand how targets relate to goals, referrals, or case-plan actions."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not invent assessment domains, ratings, scoring, service recommendations, or eligibility determinations without authoritative configuration."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool prioritize needs?",
				"answer": "Yes. Prioritization is essential; an undifferentiated list of needs does not satisfy the tool’s purpose."
			},
			{
				"question": "Does the family complete a scoring form?",
				"answer": "No. The family may participate through plain-language review, clarification, and context rather than a technical scoring instrument."
			},
			{
				"question": "What if no strengths are entered?",
				"answer": "The result is incomplete because the assessment must identify strengths to build on as well as needs requiring attention."
			},
			{
				"question": "Can the demo show formal ratings?",
				"answer": "No. Formal ratings require authoritative assessment-content configuration, including domains and rating rules."
			}
		]
	},
	{
		"toolType": "reunificationRestorationAssessment",
		"slug": "reunification-restoration-assessment",
		"title": "Reunification / Restoration Assessment Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only restoration assessment for organizing evidence, barriers, rationale, and a reunification recommendation.",
		"h1": "Reunification / Restoration Assessment",
		"intro": "Reunification / Restoration Assessment is a practitioner-only structured decision tool for child welfare practitioners managing restoration decisions. It helps organize current safety, risk, caregiver capacity, child wellbeing, supportive conditions, unresolved barriers, and rationale into a case-specific reunification recommendation.",
		"demoTitle": "Explore a sample restoration assessment",
		"demoPrompt": "Interested in using Reunification / Restoration Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0681-f-034-sdm-006-r001-reunification-restoration-assessment.md",
		"specId": "0681-f-034-sdm-006-r001-reunification-restoration-assessment",
		"tags": {
			"framework": [
				"SDM"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the tool at a restoration or reunification decision point when current conditions must be reviewed against safety, risk, caregiver capacity, child wellbeing, supportive conditions, and unresolved barriers."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not provide hidden scoring, unsupported risk thresholds, legal findings, or invented assessment prompts. It organizes and summarizes entered information while keeping recommendation responsibility with the practitioner."
			},
			{
				"title": "History and Review",
				"body": "Completed assessments preserve the recommendation, rationale, assessment date, and entered evidence so later reassessments can compare decision points without changing the original record."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client-facing reunification questionnaire?",
				"answer": "No. This is a practitioner-only restoration assessment. Family information may be incorporated through normal casework, but the product does not include a standalone client questionnaire."
			},
			{
				"question": "What recommendation states are supported?",
				"answer": "The supported recommendation states are proceed, delay, or require additional safety changes."
			},
			{
				"question": "Does the tool calculate a reunification score?",
				"answer": "No. The tool does not include unsupported scoring rules, thresholds, or hidden interpretation logic."
			},
			{
				"question": "What happens if information is missing?",
				"answer": "Missing or unknown information remains visible in the draft or partial result and should not be treated as a completed recommendation."
			}
		]
	},
	{
		"toolType": "riskReassessment",
		"slug": "risk-reassessment",
		"title": "Risk Reassessment Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only child welfare risk reassessment for updating current risk classification and comparing change over time.",
		"h1": "Risk Reassessment",
		"intro": "Risk Reassessment is a practitioner-only structured child welfare review tool for practitioners reviewing open cases after prior intervention. It helps produce an updated longitudinal risk classification that reflects current circumstances and shows whether risk has increased, decreased, or persisted.",
		"demoTitle": "Explore a sample risk reassessment",
		"demoPrompt": "Interested in using Risk Reassessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0682-f-034-sdm-007-r001-risk-reassessment.md",
		"specId": "0682-f-034-sdm-007-r001-risk-reassessment",
		"tags": {
			"framework": [
				"SDM"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Risk review",
				"Progress review"
			],
			"topic": [
				"Child safety",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the tool during review of an open child welfare case after prior intervention, especially when the current risk classification needs to be compared with a previous decision."
			},
			{
				"title": "Longitudinal Comparison",
				"body": "The result can show whether the current classification increased, decreased, or persisted compared with the prior point, based only on entered classifications."
			},
			{
				"title": "Limits",
				"body": "The tool does not invent risk domains, classification labels, hidden actuarial calculations, service eligibility determinations, or automated causal explanations."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool require a prior risk decision?",
				"answer": "A prior risk decision or known baseline supports comparison. If no prior classification is available, the reassessment can record that no comparable baseline exists and must not fabricate change direction."
			},
			{
				"question": "Is the change direction automated?",
				"answer": "Yes, but only descriptively from entered prior and current classifications. The product does not infer causes or hidden risk meaning."
			},
			{
				"question": "Can a reassessment stay incomplete?",
				"answer": "Yes. Draft reassessments can exist, but no current classification should be treated as final until the reassessment is completed."
			},
			{
				"question": "Does the tool recommend services?",
				"answer": "No. It exposes the current classification and implications for service intensity or planning, but it does not invent service recommendations."
			}
		]
	},
	{
		"toolType": "closingSafelyAssessment",
		"slug": "closing-safely-assessment",
		"title": "Closing Safely Assessment Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only child welfare closure assessment for documenting current safety, supports, remaining needs, and closure rationale.",
		"h1": "Closing Safely Assessment",
		"intro": "Closing Safely Assessment is a practitioner-only child welfare decision tool for practitioners considering case closure. It helps determine whether ending agency involvement would leave the child safe enough without ongoing statutory oversight by organizing original concerns, current conditions, remaining needs, support pathways, and rationale.",
		"demoTitle": "Explore a sample closure assessment",
		"demoPrompt": "Interested in using Closing Safely Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0683-f-034-sdm-008-r001-closing-safely-assessment.md",
		"specId": "0683-f-034-sdm-008-r001-closing-safely-assessment",
		"tags": {
			"framework": [
				"SDM"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Risk review",
				"Clinical documentation"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the tool when ending agency involvement is being considered and the practitioner must show that current conditions and outside supports are understood."
			},
			{
				"title": "What It Captures",
				"body": "The assessment captures original concerns, current safety and risk, protective factors, support conditions, remaining needs, follow-up pathways, closure decision, and rationale."
			},
			{
				"title": "Limits",
				"body": "The tool does not create legal determinations, invented safety scales, automated approvals, or unrelated administrative closure metadata."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool approve case closure automatically?",
				"answer": "No. The tool organizes the closure decision and rationale; it does not generate an automated closure approval."
			},
			{
				"question": "What if remaining needs do not have a support pathway?",
				"answer": "The gap remains visible in the result so it cannot be hidden inside the rationale."
			},
			{
				"question": "Can original concerns be marked unavailable?",
				"answer": "Yes. The practitioner can note unavailable history, and the result should show that limitation."
			},
			{
				"question": "Is there a client view?",
				"answer": "No. Family information may inform the assessment through casework, but there is no separate client-facing product surface."
			}
		]
	},
	{
		"toolType": "collaborativeAssessmentAndPlanningCapFramework",
		"slug": "collaborative-assessment-and-planning-cap-framework",
		"title": "CAP Framework Demo for Reunification Planning | Qwoach",
		"metaDescription": "Explore a collaborative CAP planning tool for recording reunification priorities, actions, responsibilities, and shared rationale.",
		"h1": "Collaborative Assessment and Planning (CAP) Framework",
		"intro": "Collaborative Assessment and Planning (CAP) Framework is a collaborative reunification and restoration planning tool for practitioners working with families and case participants. It helps create a shared, actionable understanding of priorities, responsibilities, and reasoning needed to support safe reunification planning.",
		"demoTitle": "Explore a sample CAP plan",
		"demoPrompt": "Interested in using Collaborative Assessment and Planning (CAP) Framework with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0684-f-034-sdm-009-r001-collaborative-assessment-and-planning-cap-framework.md",
		"specId": "0684-f-034-sdm-009-r001-collaborative-assessment-and-planning-cap-framework",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Child safety",
				"Goals"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Practitioner and Family Roles",
				"body": "The practitioner initiates and facilitates the CAP plan. Family participants can contribute to priorities, actions, responsibilities, and understanding of why actions matter."
			},
			{
				"title": "Repeat Use",
				"body": "The plan can be revisited as circumstances change, with prior plan states or revisions preserved where supported."
			},
			{
				"title": "Limits",
				"body": "The tool does not invent CAP prompts, ratings, scoring, family compliance labels, or substantive sections beyond the confirmed planning structure."
			}
		],
		"faqItems": [
			{
				"question": "Is this a practitioner-only assessment?",
				"answer": "No. The CAP Framework is collaborative and includes a family or participant experience for shared planning."
			},
			{
				"question": "What does the CAP plan produce?",
				"answer": "It produces a shared plan with priorities, actions, responsibilities, rationale, restoration-related conditions, unresolved items, and revision context."
			},
			{
				"question": "Does the tool force consensus?",
				"answer": "No. Conflicting views or unresolved differences can be recorded descriptively without forcing consensus or interpreting motives."
			},
			{
				"question": "Can unfinished plans be saved?",
				"answer": "Yes. Incomplete plans can persist as drafts or working plans and should not appear finalized."
			}
		]
	},
	{
		"toolType": "supervisoryCaseReadingTool",
		"slug": "supervisory-case-reading-tool",
		"title": "Supervisory Case Reading Tool Demo | Qwoach",
		"metaDescription": "Explore a supervisory child welfare case reading tool for recording reunification practice strengths, fidelity concerns, and quality gaps.",
		"h1": "Supervisory Case Reading Tool",
		"intro": "Supervisory Case Reading Tool is a practitioner-only supervisory review tool for child welfare supervisors reviewing reunification-related casework. It helps produce fidelity and quality findings about practice and records in supervised cases for supervision, feedback, coaching, or quality improvement.",
		"demoTitle": "Explore a sample case reading",
		"demoPrompt": "Interested in using Supervisory Case Reading Tool with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0685-f-034-sdm-010-r001-supervisory-case-reading-tool.md",
		"specId": "0685-f-034-sdm-010-r001-supervisory-case-reading-tool",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review",
				"Clinical documentation"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures reviewed case reference, finding text, finding category, connection to case decision or practitioner action, review status, and date."
			},
			{
				"title": "Pattern Review",
				"body": "When multiple readings exist, descriptive pattern summaries can show repeated issue types while remaining traceable to individual findings."
			},
			{
				"title": "Limits",
				"body": "The tool does not create official fidelity rubrics, personnel ratings, disciplinary conclusions, invented scores, or automated conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a staff performance rating tool?",
				"answer": "No. It is a supervisory case reading tool for quality and fidelity findings, not a personnel rating or disciplinary system."
			},
			{
				"question": "Can findings stay in draft?",
				"answer": "Yes. Draft findings should remain distinguishable from finalized supervisory findings."
			},
			{
				"question": "Does the tool include official fidelity standards?",
				"answer": "Not unless confirmed separately. The demo does not invent official criteria or scoring rubrics."
			},
			{
				"question": "Can multiple case readings be summarized?",
				"answer": "Yes. Multiple readings can support descriptive pattern summaries that remain traceable to individual findings."
			}
		]
	},
	{
		"toolType": "safemeasuresReporting",
		"slug": "safemeasures-reporting",
		"title": "SafeMeasures Reporting Demo | Qwoach",
		"metaDescription": "Explore operational child welfare reporting for reunification-related trends, exceptions, fidelity patterns, outcomes, and segments.",
		"h1": "SafeMeasures Reporting",
		"intro": "SafeMeasures Reporting is a practitioner-only operational reporting configuration for child welfare practitioners, supervisors, and managers monitoring reunification-related cases. It helps provide a current view of practice performance, fidelity, outcome patterns, exceptions, and trends across configured measures.",
		"demoTitle": "Explore sample reports",
		"demoPrompt": "Interested in using SafeMeasures Reporting with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0686-f-034-sdm-011-r001-safemeasures-reporting.md",
		"specId": "0686-f-034-sdm-011-r001-safemeasures-reporting",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Reports",
				"body": "The reporting view can show configured operational, fidelity, and outcome measures, with trends, exceptions, segment comparisons, and measure definitions."
			},
			{
				"title": "Segmentation",
				"body": "Reports can be scoped by useful operational levels such as time period, team, unit, or case type where supported by the data."
			},
			{
				"title": "Limits",
				"body": "The tool does not invent measures, benchmarks, causal explanations, individualized clinical interpretations, or unsupported outcome definitions."
			}
		],
		"faqItems": [
			{
				"question": "Is this an individual child welfare assessment?",
				"answer": "No. SafeMeasures Reporting is aggregate operational reporting across reunification-related cases."
			},
			{
				"question": "What settings can be saved?",
				"answer": "Reporting scope and selected configured measure set can be saved when available. The tool itself is always saved."
			},
			{
				"question": "Does the report explain why an exception happened?",
				"answer": "No. Exceptions are descriptive and grounded in configured measures; the product does not generate unsupported causal claims."
			},
			{
				"question": "What if data is missing?",
				"answer": "Missing or unavailable data should be visible through completeness indicators or unavailable values."
			}
		]
	},
	{
		"toolType": "fgcReferralForm",
		"slug": "fgc-referral-form",
		"title": "FGC Referral Form Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only Family Group Conferencing referral form for structuring purpose, case context, urgency, safety concerns, and remit.",
		"h1": "FGC Referral Form",
		"intro": "FGC Referral Form is a practitioner-only structured referral tool for child welfare practitioners initiating access to Family Group Conferencing. It helps provide the conferencing service with case context, eligibility-relevant information, referral purpose, safety concerns, urgency, and remit so the service can triage, accept, or prepare.",
		"demoTitle": "Explore a sample FGC referral",
		"demoPrompt": "Interested in using FGC Referral Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0687-f-035-fgc-001-r001-fgc-referral-form.md",
		"specId": "0687-f-035-fgc-001-r001-fgc-referral-form",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Clinical documentation"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the form when a practitioner believes a case may benefit from Family Group Conferencing and needs to initiate access to that process."
			},
			{
				"title": "What It Transfers",
				"body": "The form transfers referral purpose, case context, eligibility-relevant information, safety concerns, family circumstances, urgency, remit, and known preparation context."
			},
			{
				"title": "Limits",
				"body": "The tool does not infer referral acceptance, invent exact criteria, create a conference plan, or map the family network."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide whether the referral is accepted?",
				"answer": "No. It structures information so the receiving conferencing service can triage, accept, request more information, or prepare according to its process."
			},
			{
				"question": "Is there a family-facing referral form?",
				"answer": "No. The supplied record supports practitioner-only completion."
			},
			{
				"question": "Can an urgent referral be marked?",
				"answer": "Yes. Urgency can be conveyed as referral information, but it is not a tool setting."
			},
			{
				"question": "What happens if information is missing?",
				"answer": "The referral can remain draft or be flagged with missing critical context before handoff."
			}
		]
	},
	{
		"toolType": "familyNetworkInvitationMap",
		"slug": "family-network-invitation-map",
		"title": "Family/Network Invitation Map Demo | Qwoach",
		"metaDescription": "Explore a collaborative Family Group Conferencing invitation map for identifying relatives, supporters, roles, and follow-up gaps.",
		"h1": "Family/Network Invitation Map",
		"intro": "Family/Network Invitation Map is a collaborative Family Group Conferencing preparation tool for practitioners and family participants. It helps create a family-defined view of relatives, significant others, and supporters who should be considered for invitation or involvement, including relationship, relevance, likely role, and follow-up needs.",
		"demoTitle": "Explore a sample network map",
		"demoPrompt": "Interested in using Family/Network Invitation Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0688-f-035-fgc-002-r001-family-network-invitation-map.md",
		"specId": "0688-f-035-fgc-002-r001-family-network-invitation-map",
		"tags": {
			"framework": [],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Session preparation",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Family Influence",
				"body": "The map is designed to make family input visible by capturing who family participants identify as relevant to decision-making or support."
			},
			{
				"title": "Follow-Up Gaps",
				"body": "People can be included with incomplete information, and missing role or relevance can remain visible for follow-up."
			},
			{
				"title": "Limits",
				"body": "The tool does not make final invitation decisions, automate exclusion, assign suitability ratings, or function as a contact manager or genogram."
			}
		],
		"faqItems": [
			{
				"question": "Does the map decide who will be invited?",
				"answer": "No. It supports invitation consideration by showing the family-defined network, but it does not approve, deny, or automate invitations."
			},
			{
				"question": "Can someone be added with incomplete details?",
				"answer": "Yes. A person can be added with unknown or incomplete details and marked for follow-up."
			},
			{
				"question": "Is contact information required?",
				"answer": "No. Private contact details are not required by the supplied record unless a confirmed workflow later requires them."
			},
			{
				"question": "Can family members disagree about the network?",
				"answer": "Yes. Conflicting views can be recorded descriptively without forcing a single interpretation."
			}
		]
	},
	{
		"toolType": "timeline",
		"slug": "timeline",
		"title": "Timeline Demo for Family-Led Planning | Qwoach",
		"metaDescription": "Explore a collaborative chronology tool for mapping major case, family, placement, contact, and relationship events over time.",
		"h1": "Timeline",
		"intro": "Timeline is a collaborative chronology-building tool for practitioners, coordinators, and family participants preparing family-led planning or lifelong connection work. It helps place major events, placements, separations, contacts, and relationship changes in sequence so current relationships and needs can be understood in context.",
		"demoTitle": "Explore a sample timeline",
		"demoPrompt": "Interested in using Timeline with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0690-f-035-fgc-004-r001-timeline.md",
		"specId": "0690-f-035-fgc-004-r001-timeline",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Session preparation"
			],
			"topic": [
				"Clinical history",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Approximate History",
				"body": "Events can be placed by exact date, known year, period, or relative order when precise dates are not available."
			},
			{
				"title": "Collaborative Correction",
				"body": "Family participants can add context, correct events, and mark uncertainty so the chronology remains recognizable and discussable."
			},
			{
				"title": "Limits",
				"body": "The tool does not infer causation, assign event ratings, create trauma interpretation, or function as a risk assessment."
			}
		],
		"faqItems": [
			{
				"question": "Does every event need an exact date?",
				"answer": "No. Events can use an exact date, approximate period, year, or relative order when precise dates are unavailable."
			},
			{
				"question": "Can family participants correct the timeline?",
				"answer": "Yes. The supported experience allows family participants to add or correct events and provide context in plain language."
			},
			{
				"question": "Does the timeline explain why events happened?",
				"answer": "No. The tool orders and groups events but does not infer causation or provide interpretive conclusions."
			},
			{
				"question": "What happens when accounts conflict?",
				"answer": "Conflicting accounts or uncertainty can be recorded descriptively without forcing false certainty."
			}
		]
	},
	{
		"toolType": "circlesNetworkCircles",
		"slug": "circles-network-circles",
		"title": "Circles / Network Circles Demo | Qwoach",
		"metaDescription": "Explore a relationship-mapping tool for family-led planning that shows closeness, support potential, peripheral links, and unresolved leads.",
		"h1": "Circles / Network Circles for family-led planning",
		"intro": "Circles / Network Circles is a relationship-mapping tool for practitioners preparing family-led planning or Lifelong Links work. It helps practitioners and families build a visual support map that distinguishes close, peripheral, supportive, important, and potentially relevant connections.",
		"demoTitle": "Start with a sample network map and adjust the focal frame, circle labels, people, placements, notes, and uncertainty markers.",
		"demoPrompt": "Interested in using Circles / Network Circles with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0691-f-035-fgc-005-r001-circles-network-circles.md",
		"specId": "0691-f-035-fgc-005-r001-circles-network-circles",
		"tags": {
			"framework": [
				"Family group conferencing"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Child safety"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during preparation for family-led planning or lifelong connection work when the network around a child or family needs to be understood from the family’s or child’s perspective."
			},
			{
				"title": "What It Captures",
				"body": "The map captures people, groups, community links, placements by closeness or support potential, participant-perspective notes, and unresolved leads."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not decide who is safe, suitable, or required to participate. It organizes relationship information for practitioner-led planning conversations."
			}
		],
		"faqItems": [
			{
				"question": "Does Circles / Network Circles score relationships?",
				"answer": "No. It shows relationship placement, notes, uncertainty, and grouping, but it does not create scores or automated interpretations."
			},
			{
				"question": "Can a family or child contribute to the map?",
				"answer": "Yes. The supported experience allows a family member or child to contribute perspective in a shared mapping session with the practitioner."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected practitioner setup are saved. Fictional sample people, exploratory placements, and demo notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "mobilityMapping",
		"slug": "mobility-mapping",
		"title": "Mobility Mapping Demo | Qwoach",
		"metaDescription": "Explore a mobility mapping tool that links past places, moves, people, and community supports to planning leads for family engagement.",
		"h1": "Mobility Mapping for family-led planning",
		"intro": "Mobility Mapping is a preparation tool for practitioners working in family-led planning or Lifelong Links contexts. It helps practitioners map a child’s or family’s movement history and connect past places, living arrangements, people, and community links to possible support leads.",
		"demoTitle": "Explore a sample movement-history map and adjust the focal frame, timeframe granularity, places, associated people, and lead status.",
		"demoPrompt": "Interested in using Mobility Mapping with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0692-f-035-fgc-006-r001-mobility-mapping.md",
		"specId": "0692-f-035-fgc-006-r001-mobility-mapping",
		"tags": {
			"framework": [
				"Family group conferencing"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Clinical history",
				"Interpersonal relationships"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when past places, moves, or living arrangements may reveal people or supports not visible in current case contacts."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures places, approximate chronology, associated people and supports, community links, uncertainty markers, gaps, and follow-up notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not require exact dates or addresses and does not perform identity matching, safety assessment, or automated suitability review."
			}
		],
		"faqItems": [
			{
				"question": "Does Mobility Mapping require a complete timeline?",
				"answer": "No. Approximate dates, partial place names, unknown periods, and uncertain memories are supported."
			},
			{
				"question": "What is the main result?",
				"answer": "The main result is an ordered place history with attached people, supports, community links, gaps, and plausible follow-up leads."
			},
			{
				"question": "Can sample demo history be saved as a real client record?",
				"answer": "No. Saving preserves the tool and setup, not fictional demo places, people, or exploratory lead content as real client data."
			}
		]
	},
	{
		"toolType": "conferenceInformationPack",
		"slug": "conference-information-pack",
		"title": "Conference Information Pack Demo | Qwoach",
		"metaDescription": "Explore a family group conference information pack for explaining stages, roles, information sharing, and private planning expectations.",
		"h1": "Conference Information Pack for family group conferencing",
		"intro": "Conference Information Pack is a family group conferencing preparation reference tool for practitioners and coordinators. It helps them provide participants with clear information about conference stages, roles, information sharing, private family planning, and relevant case or safety information.",
		"demoTitle": "Open a sample pack, review practitioner-editable sections, preview the participant view, and check whether required sections are complete.",
		"demoPrompt": "Interested in using Conference Information Pack with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0693-f-035-fgc-007-r001-conference-information-pack.md",
		"specId": "0693-f-035-fgc-007-r001-conference-information-pack",
		"tags": {
			"framework": [
				"Family group conferencing"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"Session preparation"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before a family group conference so participants can understand the process, their roles, what information will be shared, and what decisions or plans may be discussed."
			},
			{
				"title": "What It Captures",
				"body": "The pack captures practitioner-provided process details, role expectations, information-sharing content, private family planning explanation, and usable case or safety information."
			},
			{
				"title": "Important Limits",
				"body": "The pack is not a family plan, assessment, consent workflow, or participant readiness score."
			}
		],
		"faqItems": [
			{
				"question": "Does the Conference Information Pack require participants to submit answers?",
				"answer": "No. Participants may optionally ask questions if supported, but the core pack does not require client-generated output."
			},
			{
				"question": "What does the practitioner configure?",
				"answer": "The practitioner configures conference-specific process details, role descriptions, information-sharing content, and case or safety information."
			},
			{
				"question": "Does viewing the pack prove that participants understand it?",
				"answer": "No. Review or viewed-state indicators may show activity, but the tool does not infer participant readiness or understanding."
			}
		]
	},
	{
		"toolType": "privateFamilyPlan",
		"slug": "private-family-plan",
		"title": "Private Family Plan Demo | Qwoach",
		"metaDescription": "Explore a private family planning workspace for proposed arrangements, responsibilities, actions, timing, unresolved items, and agency review.",
		"h1": "Private Family Plan for family group conferencing",
		"intro": "Private Family Plan is a structured planning workspace for practitioners supporting family group conferences. It helps the family network turn identified child safety, care, and support needs into proposed arrangements with responsibilities, actions, timing, and unresolved items for agency review.",
		"demoTitle": "Explore the practitioner preparation view, the private family planning workspace, and the review-ready plan summary using fictional sample content.",
		"demoPrompt": "Interested in using Private Family Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0694-f-035-fgc-008-r001-private-family-plan.md",
		"specId": "0694-f-035-fgc-008-r001-private-family-plan",
		"tags": {
			"framework": [
				"Family group conferencing"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "Practitioner and Family Roles",
				"body": "The practitioner prepares the concerns and needs to be addressed. The family controls the proposed arrangements during private planning until the plan is submitted for review."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures proposed arrangements, responsibilities, actions, timing, unresolved items, and review-ready summary content."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not approve plans automatically, replace family decisions with practitioner-authored content, or hide unresolved items."
			}
		],
		"faqItems": [
			{
				"question": "Who writes the Private Family Plan?",
				"answer": "The family network creates the proposed arrangements during private planning. Practitioner-provided concerns and later review notes remain separate."
			},
			{
				"question": "Can the family leave something unresolved?",
				"answer": "Yes. Unresolved items can be marked explicitly so they remain visible during review."
			},
			{
				"question": "Does the tool decide whether the plan is approved?",
				"answer": "No. The tool creates a reviewable family proposal and completeness cues, but approval or required changes are determined outside the automated system by the reviewer or agency process."
			}
		]
	},
	{
		"toolType": "agencyReviewApprovalChecklist",
		"slug": "agency-review-approval-checklist",
		"title": "Agency Review Checklist Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only checklist for reviewing a family-proposed plan against child safety concerns, needs, issues, and amendments.",
		"h1": "Agency Review / Approval Checklist for family-led plans",
		"intro": "Agency Review / Approval Checklist is a practitioner-only family group conferencing decision aid for child welfare practitioners and agency reviewers. It helps them test a family-proposed plan against identified safety concerns and child needs, then record approval, issues, or required amendments.",
		"demoTitle": "Open a fictional submitted plan, check it against sample review criteria, record issues or amendments, and preview the outcome summary.",
		"demoPrompt": "Interested in using Agency Review / Approval Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0695-f-035-fgc-009-r001-agency-review-approval-checklist.md",
		"specId": "0695-f-035-fgc-009-r001-agency-review-approval-checklist",
		"tags": {
			"framework": [
				"Family group conferencing"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Risk review"
			],
			"topic": [
				"Child safety"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after a family-led plan has been submitted and a practitioner or agency reviewer must record whether it adequately addresses identified concerns and needs."
			},
			{
				"title": "What It Captures",
				"body": "The checklist captures concern-by-concern review, addressed or unaddressed status, issue descriptions, required amendments, review status, and final decision."
			},
			{
				"title": "Important Limits",
				"body": "The tool reviews the family proposal. It does not author a replacement plan, automate approval, or generate safeguarding judgments beyond the reviewer’s recorded input."
			}
		],
		"faqItems": [
			{
				"question": "Is this tool completed by the family?",
				"answer": "No. It is a practitioner-only review tool. The family plan being reviewed may have been created by the family in the surrounding process."
			},
			{
				"question": "Does the checklist approve plans automatically?",
				"answer": "No. Decisions are recorded by the practitioner or agency reviewer."
			},
			{
				"question": "What happens when changes are required?",
				"answer": "The reviewer records specific issues and amendments tied to the identified concerns or needs so they can be returned through the surrounding process."
			}
		]
	},
	{
		"toolType": "fgcPlanReview",
		"slug": "fgc-plan-review",
		"title": "FGC Plan Review Demo | Qwoach",
		"metaDescription": "Explore a longitudinal family group conference plan review tool for action status, outcome notes, perspectives, and follow-up needs.",
		"h1": "FGC Plan Review for active family-led plans",
		"intro": "FGC Plan Review is a longitudinal review tool for practitioners reviewing an active family group conference plan. It helps practitioners track agreed actions, child and family outcome information, family and practitioner perspectives, and follow-up actions across review instances.",
		"demoTitle": "Explore a sample baseline plan, record a fictional review, and compare action status and outcome notes across review dates.",
		"demoPrompt": "Interested in using FGC Plan Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0696-f-035-fgc-010-r001-fgc-plan-review.md",
		"specId": "0696-f-035-fgc-010-r001-fgc-plan-review",
		"tags": {
			"framework": [
				"Family group conferencing"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Child safety",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after an agreed family-led plan is active, especially when repeated review is needed to understand implementation and follow-up needs."
			},
			{
				"title": "What It Captures",
				"body": "The review captures action statuses, outcome notes, delayed or unmet reasons, family and practitioner perspectives, follow-up actions, and historical review instances."
			},
			{
				"title": "Important Limits",
				"body": "The tool is anchored to the agreed plan and does not create unsupported outcome scores or automatic judgments about plan effectiveness."
			}
		],
		"faqItems": [
			{
				"question": "Does FGC Plan Review create a new plan?",
				"answer": "No. It reviews an existing agreed family-led plan and records follow-up actions or needed changes."
			},
			{
				"question": "Can family members contribute updates?",
				"answer": "Yes. Family members may contribute updates and perspectives during a shared review, with source attribution."
			},
			{
				"question": "What happens when the baseline plan changes?",
				"answer": "A plan amendment should create a new comparable baseline or version marker because historical comparison depends on the baseline."
			}
		]
	},
	{
		"toolType": "advocacyPreparationTool",
		"slug": "advocacy-preparation-tool",
		"title": "Advocacy Preparation Tool Demo | Qwoach",
		"metaDescription": "Explore a child-voice preparation tool for wishes, worries, priorities, concerns, advocacy needs, and conference representation.",
		"h1": "Advocacy Preparation Tool for child voice in family group conferencing",
		"intro": "Advocacy Preparation Tool is a family group conferencing preparation tool for practitioners, coordinators, and advocates. It helps capture a child or young person’s wishes, worries, priorities, concerns, and participation or advocacy support needs so their perspective can inform safety, care, and support decisions.",
		"demoTitle": "Try a fictional child-voice preparation record, switch representation mode, separate child words from adult notes, and preview the conference-ready summary.",
		"demoPrompt": "Interested in using Advocacy Preparation Tool with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0697-f-035-fgc-011-r001-advocacy-preparation-tool.md",
		"specId": "0697-f-035-fgc-011-r001-advocacy-preparation-tool",
		"tags": {
			"framework": [
				"Family group conferencing"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Session preparation"
			],
			"topic": [
				"Child voice"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before or during family group conference preparation when a child or young person may need support to express or have their perspective represented."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures wishes, worries, priorities, concerns, participation preferences, advocacy support needs, adult notes, attribution, and readiness status."
			},
			{
				"title": "Important Limits",
				"body": "The tool prepares representation of child voice. It does not assess the child, reinterpret adult views as child views, or generate recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can the child skip questions?",
				"answer": "Yes. The child can skip areas they cannot answer, and partial preparation can still be useful when clearly marked."
			},
			{
				"question": "Does the tool keep child voice separate from adult notes?",
				"answer": "Yes. Child words, advocate summaries, and practitioner notes are shown with source attribution."
			},
			{
				"question": "Does the tool decide what the conference should do?",
				"answer": "No. It prepares the child’s perspective for representation and does not make automated recommendations or decisions."
			}
		]
	},
	{
		"toolType": "pieWorksheet",
		"slug": "pie-worksheet",
		"title": "PIE Worksheet Demo | Qwoach",
		"metaDescription": "Explore a PIE Worksheet assessment workspace for organizing functioning, roles, relationships, environmental context, and planning notes.",
		"h1": "PIE Worksheet for person-in-environment assessment",
		"intro": "PIE Worksheet is a Person-in-Environment assessment worksheet for practitioners conducting holistic assessment and service planning. It helps practitioners organize reported and practitioner-assessed information about personal functioning, social roles, relationships, environmental conditions, and needs into an integrated profile.",
		"demoTitle": "Explore a sample worksheet structure, source attribution, completion mode, and integrated profile without using real client information.",
		"demoPrompt": "Interested in using PIE Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0698-f-036-pie-001-r001-pie-worksheet.md",
		"specId": "0698-f-036-pie-001-r001-pie-worksheet",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when assessment and service planning require individual functioning and environmental context to be considered together."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures client-reported information, practitioner observations, practitioner interpretation, organized profile sections, completeness indicators, and review notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not invent PIE fields, codes, ratings, scoring, diagnostic logic, or intervention recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the PIE Worksheet include automatic diagnoses?",
				"answer": "No. It organizes assessment information and practitioner interpretation but does not generate diagnostic conclusions."
			},
			{
				"question": "Are exact PIE fields shown in the demo?",
				"answer": "No. Exact fields and codes are unresolved by the supplied record, so the demo uses configuration placeholders rather than fabricated form content."
			},
			{
				"question": "Can the client complete it directly?",
				"answer": "A separate client workflow is not required. Shared completion may support client-reported information and review, with source attribution."
			}
		]
	},
	{
		"toolType": "factorISocialRoleRelationshipFunctioning",
		"slug": "factor-i-social-role-relationship-functioning",
		"title": "Factor I Role Functioning Demo | Qwoach",
		"metaDescription": "Explore a focused PIE Factor I profile for social roles, relationships, strengths, difficulties, attribution, and presenting needs.",
		"h1": "Factor I: Social Role & Relationship Functioning",
		"intro": "Factor I: Social Role & Relationship Functioning is a Person-in-Environment assessment configuration for practitioners assessing how a client is functioning in social roles and relationships. It helps practitioners organize strengths, adequate functioning, difficulties, and links to broader presenting needs.",
		"demoTitle": "Explore a sample Factor I profile with fictional role entries, source attribution, strength and difficulty distinctions, and a review output.",
		"demoPrompt": "Interested in using Factor I: Social Role & Relationship Functioning with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0699-f-036-pie-002-r001-factor-i-social-role-relationship-functioning.md",
		"specId": "0699-f-036-pie-002-r001-factor-i-social-role-relationship-functioning",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when social role and relationship functioning need focused assessment within a broader person-in-environment understanding."
			},
			{
				"title": "What It Captures",
				"body": "The profile captures role or relationship domain entries, reported and observed functioning, strengths, difficulties, source attribution, and links to presenting needs."
			},
			{
				"title": "Important Limits",
				"body": "The tool is Factor I, not a full PIE worksheet, relationship map, diagnosis tool, or environmental problem profile."
			}
		],
		"faqItems": [
			{
				"question": "Does Factor I include the full PIE assessment?",
				"answer": "No. It is limited to social role and relationship functioning and may feed into a broader PIE assessment where applicable."
			},
			{
				"question": "Are exact Factor I domains included in the demo?",
				"answer": "No. Exact domains and codes are unresolved by the supplied record, so the demo uses a configuration placeholder rather than fabricated content."
			},
			{
				"question": "Can strengths and difficulties appear in the same domain?",
				"answer": "Yes. Strengths and difficulties may coexist in the same role or relationship domain and should remain visible."
			}
		]
	},
	{
		"toolType": "factorIiProblemsInTheEnvironment",
		"slug": "factor-ii-problems-in-the-environment",
		"title": "Factor II Environment Problems Demo | Qwoach",
		"metaDescription": "Explore a focused PIE Factor II profile for environmental barriers, effects on functioning, attribution, and planning relevance.",
		"h1": "Factor II: Problems in the Environment",
		"intro": "Factor II: Problems in the Environment is a Person-in-Environment assessment configuration for practitioners assessing environmental conditions that affect a client’s functioning and needs. It helps practitioners describe contextual barriers, their effects, and planning relevance while distinguishing them from individual symptoms or role-function concerns.",
		"demoTitle": "Explore a sample Factor II profile with fictional environmental barriers, source attribution, effect descriptions, and review output.",
		"demoPrompt": "Interested in using Factor II: Problems in the Environment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0700-f-036-pie-003-r001-factor-ii-problems-in-the-environment.md",
		"specId": "0700-f-036-pie-003-r001-factor-ii-problems-in-the-environment",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when contextual barriers need to be documented separately from individual symptoms or role-function concerns."
			},
			{
				"title": "What It Captures",
				"body": "The profile captures environmental problem entries, source attribution, descriptions of effects on functioning or wellbeing, practitioner observations, and planning relevance notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool is Factor II, not a full PIE worksheet, resource directory, generic social determinants screener, or automated referral engine."
			}
		],
		"faqItems": [
			{
				"question": "Does Factor II make referral decisions?",
				"answer": "No. It organizes environmental barriers and planning relevance but does not match referrals or make eligibility decisions."
			},
			{
				"question": "Are exact Factor II categories included in the demo?",
				"answer": "No. Exact categories and codes are unresolved by the supplied record, so the demo uses a configuration placeholder rather than fabricated content."
			},
			{
				"question": "Can unverified client-reported barriers be recorded?",
				"answer": "Yes. Reported barriers can be recorded with source attribution so they are not confused with practitioner verification."
			}
		]
	},
	{
		"toolType": "factorIiiMentalHealthConditions",
		"slug": "factor-iii-mental-health-conditions",
		"title": "Factor III: Mental Health Conditions Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only PIE tool for representing relevant mental health conditions as a distinct case formulation domain.",
		"h1": "Factor III: Mental Health Conditions for PIE Case Formulation",
		"intro": "Factor III: Mental Health Conditions is a practitioner-only person-in-environment case formulation tool. Practitioners use it to record relevant mental health condition representations in a standardized case domain so they can be considered alongside the client’s broader situation.",
		"demoTitle": "Open the sample Factor III workspace",
		"demoPrompt": "Interested in using Factor III: Mental Health Conditions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0701-f-036-pie-004-r001-factor-iii-mental-health-conditions.md",
		"specId": "0701-f-036-pie-004-r001-factor-iii-mental-health-conditions",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Clinical documentation"
			],
			"topic": [
				"Mental health conditions"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-only use",
				"body": "Client information may inform the practitioner’s entry, but the product does not create a separate client workflow. Any client discussion happens outside the tool or through practitioner-led review."
			},
			{
				"title": "Boundaries",
				"body": "The tool organizes practitioner-entered condition information under Factor III. It does not infer diagnosis, severity, risk, urgency, or treatment direction."
			},
			{
				"title": "History and comparison",
				"body": "Historical Factor III entries can remain visible so wording or coding changes are clear over time. The system should not present those changes as automated clinical change detection."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool diagnose mental health conditions?",
				"answer": "No. It records practitioner-entered mental health condition representations as Factor III within a PIE case formulation and does not diagnose or interpret clinical meaning."
			},
			{
				"question": "Can a client complete Factor III directly?",
				"answer": "No. Factor III is practitioner-only in this specification. Client information may inform the practitioner’s entry, but there is no client-facing form."
			},
			{
				"question": "What happens if no relevant mental health condition is represented?",
				"answer": "The practitioner can mark that no relevant condition is currently represented, so the Factor III domain is clear without forcing an entry."
			},
			{
				"question": "Are severity scores included?",
				"answer": "No. Factor III does not include severity scoring. It only represents mental health conditions as a distinct PIE domain."
			}
		]
	},
	{
		"toolType": "factorIvPhysicalHealthConditions",
		"slug": "factor-iv-physical-health-conditions",
		"title": "Factor IV: Physical Health Conditions Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only PIE tool for recording relevant physical health conditions as a distinct case formulation domain.",
		"h1": "Factor IV: Physical Health Conditions for PIE Case Formulation",
		"intro": "Factor IV: Physical Health Conditions is a practitioner-only person-in-environment tool. Practitioners use it to represent relevant physical health conditions in a standardized case domain so health-related constraints and needs can be considered during planning.",
		"demoTitle": "Open the sample Factor IV workspace",
		"demoPrompt": "Interested in using Factor IV: Physical Health Conditions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0702-f-036-pie-005-r001-factor-iv-physical-health-conditions.md",
		"specId": "0702-f-036-pie-005-r001-factor-iv-physical-health-conditions",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Clinical documentation"
			],
			"topic": [
				"Physical health conditions"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Domain separation",
				"body": "Factor IV keeps physical health condition information separate from mental health and environmental factors so it can be considered clearly during planning."
			},
			{
				"title": "Medical boundary",
				"body": "The tool records practitioner-entered health condition information for case formulation. It does not collect medical measurements, assign acuity, or recommend care."
			},
			{
				"title": "Review over time",
				"body": "Prior Factor IV entries can remain reviewable so changes in represented health conditions are visible without implying automated clinical trend analysis."
			}
		],
		"faqItems": [
			{
				"question": "Is Factor IV a medical assessment?",
				"answer": "No. Factor IV records relevant physical health condition representations within PIE and does not perform medical assessment, diagnosis, triage, or treatment guidance."
			},
			{
				"question": "Can clients fill out Factor IV?",
				"answer": "No. The specified product is practitioner-only. Client information may inform practitioner entries, but there is no client-facing workflow."
			},
			{
				"question": "What if the practitioner has partial health information?",
				"answer": "Partial information can remain incomplete so it is visible without being treated as finalized."
			},
			{
				"question": "Can more than one physical health condition be represented?",
				"answer": "Yes. The tool should support multiple distinct entries so conditions are not collapsed into one narrative."
			}
		]
	},
	{
		"toolType": "severityIndex",
		"slug": "severity-index",
		"title": "Severity Index Demo for PIE Cases | Qwoach",
		"metaDescription": "Explore a practitioner-only PIE indicator for attaching standardized severity information to identified case problems or conditions.",
		"h1": "Severity Index for PIE Case Formulation",
		"intro": "The Severity Index is a practitioner-only PIE case formulation tool. Practitioners use it to record a standardized severity indication for an already identified problem or condition so severity can be reviewed across issues or over time.",
		"demoTitle": "Open the sample Severity Index",
		"demoPrompt": "Interested in using Severity Index with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0703-f-036-pie-006-r001-severity-index.md",
		"specId": "0703-f-036-pie-006-r001-severity-index",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Requires a focal issue",
				"body": "A severity indication is meaningful only when attached to a specific identified problem or condition. The tool should prevent final severity entry without that connection."
			},
			{
				"title": "Comparison boundary",
				"body": "The review may show higher, lower, changed, or missing only when the underlying index structure supports comparison. It must not create direct trend claims across incompatible structures."
			},
			{
				"title": "Practitioner interpretation",
				"body": "The system displays the severity indication and history; intervention urgency and intensity remain practitioner decisions."
			}
		],
		"faqItems": [
			{
				"question": "Does the Severity Index decide intervention urgency?",
				"answer": "No. It records and displays a severity indication. Decisions about urgency or intensity remain practitioner interpreted."
			},
			{
				"question": "Can severity be entered without a problem or condition?",
				"answer": "No. A severity value must be tied to a focal problem or condition."
			},
			{
				"question": "Are the severity levels included in this public demo?",
				"answer": "No. Exact levels, labels, anchors, and scoring rules are unresolved and must come from the underlying index structure."
			},
			{
				"question": "Can repeated severity ratings be compared?",
				"answer": "Yes, when compatible index structures are used. Historical ratings should remain separate and reviewable."
			}
		]
	},
	{
		"toolType": "durationIndex",
		"slug": "duration-index",
		"title": "Duration Index Demo for PIE Cases | Qwoach",
		"metaDescription": "Explore a practitioner-only PIE indicator for representing the time course of an identified case problem in standardized form.",
		"h1": "Duration Index for PIE Case Formulation",
		"intro": "The Duration Index is a practitioner-only PIE case formulation tool. Practitioners use it to represent the duration of an identified client problem in a standardized temporal form for assessment, planning, and later review.",
		"demoTitle": "Open the sample Duration Index",
		"demoPrompt": "Interested in using Duration Index with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0704-f-036-pie-007-r001-duration-index.md",
		"specId": "0704-f-036-pie-007-r001-duration-index",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Problem-linked duration",
				"body": "Each duration indication attaches to one identified problem. The tool should not record duration without a focal problem."
			},
			{
				"title": "Unknown and incomplete states",
				"body": "When duration is uncertain, the practitioner can leave it unknown or incomplete rather than forcing a value."
			},
			{
				"title": "History without overreach",
				"body": "Prior duration indicators can remain visible for review, but the system does not infer prognosis or recurrence rules."
			}
		],
		"faqItems": [
			{
				"question": "Does the Duration Index predict whether a problem will persist?",
				"answer": "No. It represents temporal status and does not infer prognosis."
			},
			{
				"question": "Can the tool classify a problem as acute, chronic, or recurring?",
				"answer": "Only if those categories are supplied by the underlying index. The demo must not invent categories or thresholds."
			},
			{
				"question": "Can duration be recorded without a focal problem?",
				"answer": "No. The duration indicator must attach to an identified problem."
			},
			{
				"question": "What happens if duration is unknown?",
				"answer": "The practitioner can mark duration as unknown or incomplete so the case formulation does not imply a value."
			}
		]
	},
	{
		"toolType": "copingIndex",
		"slug": "coping-index",
		"title": "Coping Index Demo for PIE Cases | Qwoach",
		"metaDescription": "Explore a shared PIE tool for recording coping capacity in relation to specific case demands and reviewing change over time.",
		"h1": "Coping Index for PIE Practitioner-Client Review",
		"intro": "The Coping Index is a PIE practitioner-client case formulation tool. Practitioners use it with clients to create a structured coping indicator tied to the specific life or environment-related problems being addressed.",
		"demoTitle": "Start the shared Coping Index demo",
		"demoPrompt": "Interested in using Coping Index with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0705-f-036-pie-008-r001-coping-index.md",
		"specId": "0705-f-036-pie-008-r001-coping-index",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Shared completion",
				"body": "The tool supports practitioner-client discussion during completion. It is not an independent client self-report workflow after the session."
			},
			{
				"title": "Demand-specific coping",
				"body": "Coping is represented in relation to selected problems or demands, not as a general personality trait."
			},
			{
				"title": "Incomplete and disagreement states",
				"body": "If the client is unavailable, participation is incomplete, or practitioner and client disagree, the result can remain draft or unresolved instead of forcing consensus."
			}
		],
		"faqItems": [
			{
				"question": "Is the Coping Index a coping-skills program?",
				"answer": "No. It records a coping indicator and shared discussion context. It does not provide exercises, coaching steps, or support recommendations."
			},
			{
				"question": "Can the client participate?",
				"answer": "Yes. The specified mode is ready to complete together, so client input can be included during practitioner-facilitated completion."
			},
			{
				"question": "Does coping have to be linked to a demand?",
				"answer": "Yes. A final coping indication should relate to the specific problems or demands being addressed."
			},
			{
				"question": "Can coping be compared over time?",
				"answer": "Yes, historical indicators can be reviewed when repeated use and compatible indicator structure support comparison."
			}
		]
	},
	{
		"toolType": "strengthsIndex",
		"slug": "strengths-index",
		"title": "Strengths Index Demo for PIE Planning | Qwoach",
		"metaDescription": "Explore a shared PIE tool for identifying client strengths in a structured profile for collaborative service planning.",
		"h1": "Strengths Index for Collaborative PIE Planning",
		"intro": "The Strengths Index is a PIE collaborative case planning tool. Practitioners use it with clients to record relevant strengths in a structured profile that can be considered alongside problems, coping, and contextual factors.",
		"demoTitle": "Start the shared Strengths Index demo",
		"demoPrompt": "Interested in using Strengths Index with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0706-f-036-pie-009-r001-strengths-index.md",
		"specId": "0706-f-036-pie-009-r001-strengths-index",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Collaborative planning role",
				"body": "The Strengths Index is completed with client input during planning. The practitioner controls the official case record."
			},
			{
				"title": "Structured, not scored",
				"body": "The result is a structured profile of relevant strengths. The tool does not score, rank, or interpret strengths automatically."
			},
			{
				"title": "Changing context",
				"body": "Prior profiles can remain reviewable with their planning context so later changes do not erase earlier understanding."
			}
		],
		"faqItems": [
			{
				"question": "Is the Strengths Index a generic strengths worksheet?",
				"answer": "No. It is a PIE index for recording strengths relevant to the current service-planning context."
			},
			{
				"question": "Can the client contribute to the Strengths Index?",
				"answer": "Yes. The specified mode is ready to complete together, so the client contributes during collaborative planning."
			},
			{
				"question": "Does the tool score or rank strengths?",
				"answer": "No. It records and organizes strengths without unsupported scoring, ranking, or interpretation."
			},
			{
				"question": "What if no strengths are identified yet?",
				"answer": "The tool can show an explicit empty or incomplete state without implying that the client has no strengths."
			}
		]
	},
	{
		"toolType": "pieInterventionPlan",
		"slug": "pie-intervention-plan",
		"title": "PIE Intervention Plan Demo | Qwoach",
		"metaDescription": "Explore a shared PIE planning tool for turning assessed problems, needs, and resources into targets, responsibilities, and next steps.",
		"h1": "PIE Intervention Plan for Collaborative Case Planning",
		"intro": "The PIE Intervention Plan is a practitioner-client case planning tool. Practitioners use it with clients to organize assessed person-in-environment problems, needs, and resources into clear targets, responsibilities, next steps, and service direction.",
		"demoTitle": "Build a sample intervention plan",
		"demoPrompt": "Interested in using PIE Intervention Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0707-f-036-pie-010-r001-pie-intervention-plan.md",
		"specId": "0707-f-036-pie-010-r001-pie-intervention-plan",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Grounded in assessment",
				"body": "The plan starts from assessed person-in-environment problems, needs, and resources. Draft planning is possible before assessment is complete, but missing source factors should be visible."
			},
			{
				"title": "Shared action",
				"body": "The client-facing summary focuses on what is being worked on, who is responsible, and what happens next."
			},
			{
				"title": "Lifecycle states",
				"body": "Draft, agreed, and reviewed states keep unresolved plans separate from confirmed pathways and preserve prior agreed plans when revisions occur."
			},
			{
				"title": "Completeness cues",
				"body": "The system can show missing responsibilities, unaddressed assessed factors, or incomplete next steps as structure cues, not clinical judgments."
			}
		],
		"faqItems": [
			{
				"question": "Does the PIE Intervention Plan recommend interventions?",
				"answer": "No. It organizes practitioner-client plan content and does not generate treatment recommendations."
			},
			{
				"question": "Can the client participate in the plan?",
				"answer": "Yes. The tool is ready to complete together, and the client can participate in confirming goals, responsibilities, and next steps."
			},
			{
				"question": "Can a plan be marked agreed if responsibilities are missing?",
				"answer": "No. The plan should remain draft or incomplete when required targets, responsibilities, or next steps are missing."
			},
			{
				"question": "What happens when the client’s situation changes?",
				"answer": "The practitioner can review and revise the plan while preserving prior agreed plans for context."
			}
		]
	},
	{
		"toolType": "compupie",
		"slug": "compupie",
		"title": "CompuPIE Demo Workspace | Qwoach",
		"metaDescription": "Explore a practitioner-only PIE workspace for organizing, updating, retrieving, and reviewing structured case data across active domains.",
		"h1": "CompuPIE PIE Information-Management Workspace",
		"intro": "CompuPIE is practitioner-facing person-in-environment information-management software. Practitioners use it to organize, maintain, retrieve, and update structured case data across relevant PIE domains for assessment, planning, review, and communication.",
		"demoTitle": "Explore the sample CompuPIE workspace",
		"demoPrompt": "Interested in using CompuPIE with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0708-f-036-pie-011-r001-compupie.md",
		"specId": "0708-f-036-pie-011-r001-compupie",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Only supported configuration",
				"body": "Active PIE domain availability is the only practitioner configuration. It determines workspace navigation, summaries, and completeness views."
			},
			{
				"title": "Not a general EHR",
				"body": "CompuPIE is limited to structured PIE case information management. It does not include administrative scheduling, billing, messaging, or generic case management modules."
			},
			{
				"title": "History and continuity",
				"body": "Updates should preserve enough history to support continuity, show current values, and make domain changes clear over time."
			},
			{
				"title": "Empty does not mean absent",
				"body": "An empty domain means no data recorded in the workspace. It should not imply that the issue is absent from the client’s life."
			}
		],
		"faqItems": [
			{
				"question": "Is CompuPIE client-facing?",
				"answer": "No. CompuPIE is practitioner-only in this specification and does not provide client portals or self-report tasks."
			},
			{
				"question": "What can practitioners configure?",
				"answer": "Practitioners can configure active PIE domains. Other case entries and updates are case data, not tool settings."
			},
			{
				"question": "Does CompuPIE replace an EHR?",
				"answer": "No. It is a PIE information-management workspace and does not include generic EHR, scheduling, billing, or messaging functions."
			},
			{
				"question": "What happens if a domain is removed from active use?",
				"answer": "Historical data should be preserved and the domain should be clearly indicated as not currently active."
			}
		]
	},
	{
		"toolType": "mohost",
		"slug": "mohost",
		"title": "MOHOST Demo for OT Screening | Qwoach",
		"metaDescription": "Explore a practitioner-only MOHOST workflow for structured occupational participation profiling, completion tracking, and review over time.",
		"h1": "MOHOST Occupational Participation Screening Demo",
		"intro": "MOHOST is a practitioner-only occupational therapy screening assessment using MOHO constructs. Occupational therapy practitioners use it to create a structured profile of a client’s occupational participation strengths and barriers for screening decisions and next assessment focus.",
		"demoTitle": "Open the sample MOHOST administration",
		"demoPrompt": "Interested in using MOHOST with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0709-f-037-moho-001-r001-mohost.md",
		"specId": "0709-f-037-moho-001-r001-mohost",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-only administration",
				"body": "The product supports practitioner entry of observations or assessment information. It does not create a client-completed form."
			},
			{
				"title": "Assessment content boundary",
				"body": "Exact items, factor names, ratings, scoring, and profile layout must come from the assessment materials or configuration, not the public demo."
			},
			{
				"title": "Longitudinal review",
				"body": "Completed compatible profiles can be preserved separately and compared over time when participation changes."
			}
		],
		"faqItems": [
			{
				"question": "Is MOHOST completed by the client?",
				"answer": "No. In this specification, MOHOST is practitioner-only. The client may be observed or interviewed as part of practice, but the product does not provide a client form."
			},
			{
				"question": "Does the demo include MOHOST items and rating anchors?",
				"answer": "No. Exact items, ratings, scoring rules, and profile structure are unresolved in the supplied record and must not be invented."
			},
			{
				"question": "Can MOHOST results be compared over time?",
				"answer": "Yes, completed profiles can be compared when repeated administrations use compatible structures."
			},
			{
				"question": "Does MOHOST generate a treatment plan?",
				"answer": "No. It produces a structured participation profile for practitioner screening decisions and next assessment or intervention focus."
			}
		]
	},
	{
		"toolType": "osaOccupationalSelfAssessment",
		"slug": "osa-occupational-self-assessment",
		"title": "OSA Occupational Self Assessment Demo | Qwoach",
		"metaDescription": "Explore a sendable OSA workflow for client competence and importance self-ratings, profile review, and shared OT goal setting.",
		"h1": "OSA Occupational Self Assessment Demo for OT Goal Setting",
		"intro": "OSA (Occupational Self Assessment) is a client-completed occupational therapy self-assessment. Practitioners send it to clients to collect perceived competence and importance responses, then use the resulting profile to support shared occupational therapy goal setting.",
		"demoTitle": "Preview the sendable OSA",
		"demoPrompt": "Interested in using OSA (Occupational Self Assessment) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0710-f-037-moho-002-r001-osa-occupational-self-assessment.md",
		"specId": "0710-f-037-moho-002-r001-osa-occupational-self-assessment",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Goal setting"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client self-assessment",
				"body": "OSA depends on the client’s own competence and importance responses. Practitioner ratings are not substitutes for the client’s submitted self-assessment."
			},
			{
				"title": "Version and language context",
				"body": "When multiple versions or languages are available, results should remain tied to the version used and comparisons should warn when versions differ."
			},
			{
				"title": "Priority visibility",
				"body": "The profile can make priority areas visible through the relationship between perceived competence and importance when supported by the assessment structure."
			},
			{
				"title": "Partial completion",
				"body": "In-progress assessments should preserve responses and remain incomplete until submitted or intentionally reviewed as partial."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the OSA?",
				"answer": "The client completes the OSA. The practitioner assigns it and reviews the submitted competence/importance profile."
			},
			{
				"question": "Does OSA include both competence and importance?",
				"answer": "Yes. The tool captures the client’s perceived competence and occupational importance according to the OSA structure."
			},
			{
				"question": "Can the demo include real OSA items or scoring?",
				"answer": "No. Exact items, response scales, scoring, translations, and profile calculations are unresolved in the supplied record and must not be invented."
			},
			{
				"question": "Can OSA results be compared over time?",
				"answer": "Yes, prior completed profiles can be compared when versions are compatible or clearly labeled when versions differ."
			},
			{
				"question": "Does the tool create OT goals automatically?",
				"answer": "No. The profile supports shared goal setting, but goals are decided through practitioner-client interpretation and discussion."
			}
		]
	},
	{
		"toolType": "ocairs",
		"slug": "ocairs",
		"title": "OCAIRS Occupational Adaptation Profile Demo | Qwoach",
		"metaDescription": "Explore OCAIRS, a practitioner-administered MOHO assessment for structured occupational adaptation profiles, supports, barriers, and review.",
		"h1": "OCAIRS occupational adaptation assessment demo",
		"intro": "OCAIRS is a practitioner-administered MOHO occupational therapy assessment configuration for occupational therapy practitioners. It helps the practitioner organize client circumstances, occupational functioning, supports, barriers, and participation patterns into a structured occupational adaptation profile.",
		"demoTitle": "Open the sample OCAIRS practitioner workspace and review the profile flow.",
		"demoPrompt": "Interested in using OCAIRS with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0711-f-037-moho-003-r001-ocairs.md",
		"specId": "0711-f-037-moho-003-r001-ocairs",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Occupational participation",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-only assessment",
				"body": "OCAIRS is controlled by the practitioner. The demo does not create a client portal task or client worksheet."
			},
			{
				"title": "History and comparison",
				"body": "Repeated OCAIRS profiles can be compared descriptively over time when the assessment structure remains comparable."
			},
			{
				"title": "Important limitation",
				"body": "The demo does not invent official OCAIRS prompts, item wording, scoring, diagnoses, treatment plans, or intervention recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is OCAIRS client-facing in this demo?",
				"answer": "No. OCAIRS is represented as a practitioner-only assessment workspace."
			},
			{
				"question": "What does the result show?",
				"answer": "The result shows a structured occupational adaptation profile with supports, barriers, participation patterns, practitioner interpretation, and incomplete areas where applicable."
			},
			{
				"question": "Can I configure OCAIRS scoring or sections?",
				"answer": "No. The supported settings are limited to assessment date/context and new versus follow-up profile unless official structure is separately configured."
			},
			{
				"question": "Does sample demo content become client data when I save?",
				"answer": "No. Saving keeps the OCAIRS tool and practitioner setup, but fictional demo entries do not become real client records."
			}
		]
	},
	{
		"toolType": "ophiIi",
		"slug": "ophi-ii",
		"title": "OPHI-II Narrative and Rating Assessment Demo | Qwoach",
		"metaDescription": "Explore OPHI-II, a practitioner-administered MOHO assessment for occupational identity, occupational competence, narrative, and ratings.",
		"h1": "OPHI-II occupational identity and competence assessment demo",
		"intro": "OPHI-II is a practitioner-administered MOHO assessment configuration for occupational therapy practitioners. It helps the practitioner organize client life history, current circumstances, narrative information, and supported ratings into a coherent occupational identity and occupational competence formulation.",
		"demoTitle": "Open the sample OPHI-II practitioner workspace.",
		"demoPrompt": "Interested in using OPHI-II with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0712-f-037-moho-004-r001-ophi-ii.md",
		"specId": "0712-f-037-moho-004-r001-ophi-ii",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Occupational participation",
				"Clinical history"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Narrative and ratings stay connected",
				"body": "The review view helps the practitioner see whether ratings have supporting narrative entered, without adding unsupported conclusions."
			},
			{
				"title": "Partial assessments",
				"body": "Narrative without ratings or ratings without narrative support remain visible as partial rather than complete formulation states."
			},
			{
				"title": "Bounded scope",
				"body": "OPHI-II does not generate therapy plans, diagnostic conclusions, personality traits, or invented interview content."
			}
		],
		"faqItems": [
			{
				"question": "Is OPHI-II a client questionnaire in this product?",
				"answer": "No. The supported product is a practitioner-only assessment and formulation workspace."
			},
			{
				"question": "What does OPHI-II produce?",
				"answer": "It produces an occupational identity and occupational competence formulation grounded in narrative information and supported ratings."
			},
			{
				"question": "Can the demo create OPHI-II prompts or rating anchors?",
				"answer": "No. Official prompts, rating anchors, fields, and worksheet structure remain unresolved unless separately configured."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The OPHI-II tool and practitioner setup are saved; fictional demo narrative and sample assessment content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "roleChecklist",
		"slug": "role-checklist",
		"title": "Role Checklist Role Profile Demo | Qwoach",
		"metaDescription": "Explore Role Checklist, a ready-to-send MOHO-related assessment for occupational role participation patterns and longitudinal role profiles.",
		"h1": "Role Checklist occupational role profile demo",
		"intro": "Role Checklist is a ready-to-send MOHO-related assessment configuration for occupational therapy practitioners. It helps the practitioner collect supported role participation responses and review a longitudinal profile of a client's occupational roles and role patterns.",
		"demoTitle": "Preview the sample checklist and role profile.",
		"demoPrompt": "Interested in using Role Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0713-f-037-moho-005-r001-role-checklist.md",
		"specId": "0713-f-037-moho-005-r001-role-checklist",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it when role maintenance, restoration, or development is part of therapy discussion and role participation across time needs to be visible."
			},
			{
				"title": "Practitioner and client roles",
				"body": "The practitioner creates and reviews the checklist. The client may complete supported role responses in ready-to-send mode."
			},
			{
				"title": "Comparison limits",
				"body": "History comparison is descriptive and should be shown only when checklist structures are comparable."
			}
		],
		"faqItems": [
			{
				"question": "Can the Role Checklist be sent to a client?",
				"answer": "Yes. The supported configuration includes ready-to-send client completion and practitioner-completed entry with the client."
			},
			{
				"question": "What does the Role Checklist result show?",
				"answer": "It shows a longitudinal role profile using supported role and time categories, with incomplete items and practitioner notes visible."
			},
			{
				"question": "Does the tool decide which roles are clinically important?",
				"answer": "No. The system can display supported responses; practitioner notes and discussion identify intervention focus."
			},
			{
				"question": "What is saved when I use the CTA?",
				"answer": "The Role Checklist tool and setup choices are saved; fictional demo responses are not converted into client records."
			}
		]
	},
	{
		"toolType": "interestChecklistModifiedInterestChecklist",
		"slug": "interest-checklist-modified-interest-checklist",
		"title": "Interest Checklist Activity Profile Demo | Qwoach",
		"metaDescription": "Explore Interest Checklist / Modified Interest Checklist for ready-to-send activity interest profiles and practitioner review in occupational therapy.",
		"h1": "Interest Checklist / Modified Interest Checklist demo",
		"intro": "Interest Checklist / Modified Interest Checklist is a ready-to-send MOHO-related assessment configuration for occupational therapy practitioners. It helps the practitioner collect supported interest and activity preference responses and review a profile of activities that may be meaningful or motivating for the client.",
		"demoTitle": "Open the sample checklist and profile review.",
		"demoPrompt": "Interested in using Interest Checklist / Modified Interest Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0714-f-037-moho-006-r001-interest-checklist-modified-interest-checklist.md",
		"specId": "0714-f-037-moho-006-r001-interest-checklist-modified-interest-checklist",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Variant handling",
				"body": "When both Interest Checklist and Modified Interest Checklist are configured, variant selection is a real setting because it changes inputs, results, and comparability."
			},
			{
				"title": "Repeat use",
				"body": "Prior profiles can be shown for descriptive comparison when repeated administrations use comparable structures."
			},
			{
				"title": "Limitations",
				"body": "The tool displays and organizes responses; it does not prescribe activities, infer motivation scores, or generate therapy goals."
			}
		],
		"faqItems": [
			{
				"question": "Can this be sent to a client?",
				"answer": "Yes. The supported workflow includes ready-to-send completion and practitioner-completed entry with the client."
			},
			{
				"question": "What does the profile show?",
				"answer": "It shows activities of interest and supported response strength or relevance categories, plus missing items and practitioner notes."
			},
			{
				"question": "Can the demo recommend interventions?",
				"answer": "No. The system does not generate activity prescriptions or intervention recommendations."
			},
			{
				"question": "What carries over when saved?",
				"answer": "The tool and selected reusable setup carry over; fictional sample responses and demo content do not become real client data."
			}
		]
	},
	{
		"toolType": "occupationalQuestionnaireOq",
		"slug": "occupational-questionnaire-oq",
		"title": "OQ Routine and Time-Use Profile Demo | Qwoach",
		"metaDescription": "Explore Occupational Questionnaire (OQ), a ready-to-send assessment for daily routine, time-use profiles, practitioner review, and history.",
		"h1": "Occupational Questionnaire (OQ) routine and time-use demo",
		"intro": "Occupational Questionnaire (OQ) is a ready-to-send MOHO-related assessment configuration for occupational therapy practitioners. It helps the practitioner collect daily activity and time-use information and review a structured occupational routine profile that shows how a client spends time.",
		"demoTitle": "Open the sample OQ timeline and review.",
		"demoPrompt": "Interested in using Occupational Questionnaire (OQ) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0715-f-037-moho-007-r001-occupational-questionnaire-oq.md",
		"specId": "0715-f-037-moho-007-r001-occupational-questionnaire-oq",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What it captures",
				"body": "OQ captures supported daily activity and time-use information in chronological form."
			},
			{
				"title": "What review shows",
				"body": "Review centers on a timeline or time-block table, descriptive summaries, incomplete areas, and practitioner interpretation notes."
			},
			{
				"title": "Relevant limitations",
				"body": "OQ does not add wellbeing scores, habit coaching, reminders, routine recommendations, or multi-day tracking unless specified by the configured OQ structure."
			}
		],
		"faqItems": [
			{
				"question": "Can OQ be completed by the client?",
				"answer": "Yes. The supported configuration includes ready-to-send client completion and practitioner-completed entry."
			},
			{
				"question": "What does the OQ result show?",
				"answer": "It shows a chronological routine/time-use profile with activity entries, incomplete time areas, descriptive patterns, and practitioner notes."
			},
			{
				"question": "Does OQ recommend routine changes automatically?",
				"answer": "No. The tool organizes entered time-use data; routine changes come from practitioner review and discussion."
			},
			{
				"question": "Does sample time-use data carry over when saved?",
				"answer": "No. Saving preserves the OQ tool and setup, not fictional demo entries or sample client data."
			}
		]
	},
	{
		"toolType": "volitionalQuestionnaireVq",
		"slug": "volitional-questionnaire-vq",
		"title": "VQ Observational Volition Profile Demo | Qwoach",
		"metaDescription": "Explore VQ, a practitioner-only MOHO observational assessment for volitional strengths, limitations, support needs, and history review.",
		"h1": "Volitional Questionnaire (VQ) observational volition demo",
		"intro": "Volitional Questionnaire (VQ) is a practitioner-only MOHO observational assessment configuration for occupational therapy practitioners. It helps the practitioner record observed occupational behavior and review an observational profile of volitional strengths, limitations, and support needs.",
		"demoTitle": "Open the sample VQ observation workspace.",
		"demoPrompt": "Interested in using Volitional Questionnaire (VQ) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0716-f-037-moho-008-r001-volitional-questionnaire-vq.md",
		"specId": "0716-f-037-moho-008-r001-volitional-questionnaire-vq",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Observation-based scope",
				"body": "VQ is based on practitioner observation of occupational behavior, not client self-report."
			},
			{
				"title": "Partial observation handling",
				"body": "Incomplete observations remain partial and do not produce complete-profile claims."
			},
			{
				"title": "History",
				"body": "Repeated VQ observations can be compared descriptively when structures and contexts are comparable."
			}
		],
		"faqItems": [
			{
				"question": "Does the client complete the VQ?",
				"answer": "No. VQ is practitioner-only and observational in this product configuration."
			},
			{
				"question": "What does VQ produce?",
				"answer": "It produces an observational volition profile showing observable indicators, strengths, limitations, support needs, context, and practitioner interpretation."
			},
			{
				"question": "Can VQ generate activity recommendations?",
				"answer": "No. The tool does not generate unsupported activity or environmental recommendations."
			},
			{
				"question": "What is saved?",
				"answer": "The VQ tool and setup choices are saved; fictional demo observations are not saved as real client data."
			}
		]
	},
	{
		"toolType": "pediatricVolitionalQuestionnairePvq",
		"slug": "pediatric-volitional-questionnaire-pvq",
		"title": "PVQ Pediatric Volition Profile Demo | Qwoach",
		"metaDescription": "Explore PVQ, a practitioner-only pediatric MOHO observational assessment for child volitional behaviors, strengths, barriers, and support needs.",
		"h1": "Pediatric Volitional Questionnaire (PVQ) observation demo",
		"intro": "Pediatric Volitional Questionnaire (PVQ) is a practitioner-only pediatric MOHO observational assessment configuration for occupational therapy practitioners. It helps the practitioner record a child's observed occupational behavior and review a pediatric profile of volitional strengths, barriers, and support needs.",
		"demoTitle": "Open the sample PVQ observation workspace.",
		"demoPrompt": "Interested in using Pediatric Volitional Questionnaire (PVQ) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0717-f-037-moho-009-r001-pediatric-volitional-questionnaire-pvq.md",
		"specId": "0717-f-037-moho-009-r001-pediatric-volitional-questionnaire-pvq",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Occupational participation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Pediatric-specific scope",
				"body": "PVQ is represented as child-specific and should not import adult VQ assumptions."
			},
			{
				"title": "No child task",
				"body": "The child does not complete a digital form in the supported PVQ configuration."
			},
			{
				"title": "Comparison limits",
				"body": "History comparison is descriptive and should flag limits when structures or contexts differ."
			}
		],
		"faqItems": [
			{
				"question": "Is PVQ the same as adult VQ?",
				"answer": "No. PVQ is represented as a pediatric observational assessment and should remain separate from adult VQ content."
			},
			{
				"question": "Does the child complete the PVQ digitally?",
				"answer": "No. PVQ is practitioner-only; the child participates through observed occupational activity."
			},
			{
				"question": "What does the result show?",
				"answer": "It shows observed pediatric volitional behaviors, context, strengths, barriers, support needs, incomplete areas, and practitioner interpretation."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The PVQ tool and setup choices are saved; fictional demo observations and sample child data are not saved as real records."
			}
		]
	},
	{
		"toolType": "cosaChildOccupationalSelfAssessment",
		"slug": "cosa-child-occupational-self-assessment",
		"title": "COSA Child Priority Profile Demo | Qwoach",
		"metaDescription": "Explore COSA, a ready-to-send child occupational self-assessment for child-defined priorities, perceived strengths, difficulties, and review.",
		"h1": "COSA child occupational self-assessment demo",
		"intro": "COSA (Child Occupational Self Assessment) is a ready-to-send MOHO child self-assessment configuration for occupational therapy practitioners. It helps the practitioner collect the child's own view of occupational competence, priorities, strengths, and difficulties so child-centered goal discussion can be supported.",
		"demoTitle": "Preview the child self-assessment and practitioner review.",
		"demoPrompt": "Interested in using COSA (Child Occupational Self Assessment) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0718-f-037-moho-010-r001-cosa-child-occupational-self-assessment.md",
		"specId": "0718-f-037-moho-010-r001-cosa-child-occupational-self-assessment",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Goal setting"
			],
			"topic": [
				"Occupational participation",
				"Goals"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Child's own view",
				"body": "COSA review preserves child responses separately from practitioner notes so the child's priorities remain visible."
			},
			{
				"title": "Collaborative completion",
				"body": "Collaborative completion is supported when the child needs assistance, while preserving the response as the child's self-assessment when appropriate."
			},
			{
				"title": "What it does not do",
				"body": "COSA does not automatically create therapy goals, add caregiver ratings, or invent child-friendly item wording beyond configured content."
			}
		],
		"faqItems": [
			{
				"question": "Is COSA client-facing?",
				"answer": "Yes. COSA includes a child-facing self-assessment flow in the supported ready-to-send configuration."
			},
			{
				"question": "What does COSA produce?",
				"answer": "It produces a child-defined priority profile showing the child's priorities, perceived strengths, perceived difficulties, incomplete items, and practitioner notes."
			},
			{
				"question": "Can a practitioner complete COSA with the child?",
				"answer": "Yes. Collaborative completion is supported while keeping child responses distinct from practitioner interpretation."
			},
			{
				"question": "Does saving preserve sample child responses?",
				"answer": "No. Saving preserves the COSA tool and setup choices, not fictional demo responses or sample child data."
			}
		]
	},
	{
		"toolType": "acis",
		"slug": "acis",
		"title": "ACIS Interaction Skill Profile Demo | Qwoach",
		"metaDescription": "Explore ACIS, a practitioner-only MOHO assessment for communication and interaction skill strengths, limitations, context, and history.",
		"h1": "ACIS interaction skill assessment demo",
		"intro": "ACIS is a practitioner-only MOHO assessment configuration for occupational therapy practitioners. It helps the practitioner record participation-relevant communication and interaction skill behavior and review a structured profile of specific interaction skill strengths and limitations.",
		"demoTitle": "Open the sample ACIS assessment workspace.",
		"demoPrompt": "Interested in using ACIS with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0719-f-037-moho-011-r001-acis.md",
		"specId": "0719-f-037-moho-011-r001-acis",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Occupational participation",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Participation-grounded behavior",
				"body": "ACIS review keeps the assessment tied to behavior in occupational or social participation contexts."
			},
			{
				"title": "Tracking change",
				"body": "Follow-up ACIS profiles can support descriptive tracking of interaction skill change over time when structures are comparable."
			},
			{
				"title": "Bounded scope",
				"body": "ACIS does not create client questionnaires, language test scores, diagnostic conclusions, broad personality labels, or automated interventions."
			}
		],
		"faqItems": [
			{
				"question": "Does the client complete ACIS?",
				"answer": "No. ACIS is practitioner-only in this product configuration."
			},
			{
				"question": "What does ACIS produce?",
				"answer": "It produces a structured interaction skill profile showing strengths, limitations, context, supporting observations or ratings, incomplete areas, and practitioner interpretation."
			},
			{
				"question": "Can ACIS track change over time?",
				"answer": "Yes. Later ACIS profiles can be compared descriptively when the structures are comparable."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The ACIS tool and setup choices are saved; fictional observations and temporary demo notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "weis",
		"slug": "weis",
		"title": "WEIS Work-Environment Fit Demo | Qwoach",
		"metaDescription": "Explore WEIS, a practitioner-only MOHO work-focused assessment for environmental supports, barriers, fit, misfit, and review.",
		"h1": "WEIS work-environment fit assessment demo",
		"intro": "WEIS is a practitioner-only MOHO work-focused assessment configuration for occupational therapy practitioners. It helps the practitioner organize work-environment information into a profile of supports, barriers, fit, and misfit related to the client's work participation.",
		"demoTitle": "Open the sample WEIS assessment workspace.",
		"demoPrompt": "Interested in using WEIS with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0720-f-037-moho-012-r001-weis.md",
		"specId": "0720-f-037-moho-012-r001-weis",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Occupational participation",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Work context matters",
				"body": "WEIS profiles are tied to a specific work environment; different work environments should remain distinct unless the configured structure supports combined assessment."
			},
			{
				"title": "Practitioner interpretation",
				"body": "The tool can organize entered information descriptively, while planning notes remain practitioner interpretation."
			},
			{
				"title": "Limitations",
				"body": "WEIS does not create legal determinations, mandated accommodations, employer-side workflows, productivity scores, or automated support strategies."
			}
		],
		"faqItems": [
			{
				"question": "Is WEIS client-facing in this demo?",
				"answer": "No. WEIS is represented as a practitioner-only assessment workflow."
			},
			{
				"question": "What does the WEIS profile show?",
				"answer": "It shows environmental supports and barriers, areas of fit and misfit, work context, incomplete areas, and practitioner notes."
			},
			{
				"question": "Does WEIS automatically recommend accommodations?",
				"answer": "No. The tool does not generate automated accommodations or legal conclusions."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The WEIS tool and reusable setup choices are saved; fictional demo work details and sample notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "wri",
		"slug": "wri",
		"title": "WRI Work Readiness Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only WRI profile for work readiness, barriers, strengths, return-to-work status, and follow-up comparison.",
		"h1": "WRI Work Readiness and Return-to-Work Profile",
		"intro": "WRI is a practitioner-only work readiness and return-to-work profiling tool for occupational therapy practitioners evaluating clients whose ability to enter, remain in, or return to work is uncertain. It helps the practitioner organize work-related strengths, barriers, readiness status, and planning targets into a reviewable profile.",
		"demoTitle": "Explore the sample WRI profile",
		"demoPrompt": "Interested in using WRI with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0721-f-037-moho-013-r001-wri.md",
		"specId": "0721-f-037-moho-013-r001-wri",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "WRI is used when a practitioner needs to evaluate work readiness or return-to-work status and organize work participation strengths and barriers for occupation-focused planning."
			},
			{
				"title": "Longitudinal Review",
				"body": "Dated profile snapshots can be preserved so the practitioner can compare readiness, strengths, barriers, and planning targets over time."
			},
			{
				"title": "Important Limits",
				"body": "The demo must not create WRI item content, scoring, readiness thresholds, accommodations, or return-to-work decisions that are not supplied by WRI materials."
			}
		],
		"faqItems": [
			{
				"question": "Is WRI client-facing in this product?",
				"answer": "No. WRI is practitioner-only in the supplied specification; client information may inform the assessment, but there is no separate client digital flow."
			},
			{
				"question": "Does the demo calculate a WRI score?",
				"answer": "No. Exact WRI scoring rules are unresolved, so the demo shows structured profile organization without invented scores."
			},
			{
				"question": "What happens if profile information is incomplete?",
				"answer": "Incomplete areas remain visibly partial, and the product does not generate unsupported readiness conclusions from missing information."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The WRI tool itself is saved as a fixed practitioner-only profiling tool; sample demo client content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "scope",
		"slug": "scope",
		"title": "SCOPE Pediatric Participation Demo | Qwoach",
		"metaDescription": "Explore a practitioner-led SCOPE screen that organizes pediatric daily participation strengths, limitations, concerns, and baseline review.",
		"h1": "SCOPE Pediatric Participation Profile",
		"intro": "SCOPE is a practitioner-facing MOHO pediatric participation screening tool for occupational therapy practitioners screening children whose daily occupational participation may be limited or at risk. It helps the practitioner organize participation strengths, limitations, and areas of concern into a baseline profile for next-step planning.",
		"demoTitle": "Explore the sample SCOPE screen",
		"demoPrompt": "Interested in using SCOPE with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0722-f-037-moho-014-r001-scope.md",
		"specId": "0722-f-037-moho-014-r001-scope",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Occupational participation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "SCOPE is used when a practitioner needs to screen pediatric participation in daily occupations and identify strengths and concerns that can guide next-step assessment or intervention."
			},
			{
				"title": "Baseline Use",
				"body": "A completed SCOPE screen can be retained as a baseline and compared with later screening information."
			},
			{
				"title": "Important Limits",
				"body": "The product must not create unsupported SCOPE domains, rating scales, scores, developmental conclusions, or intervention recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is SCOPE completed by the child or caregiver online?",
				"answer": "No. The supplied specification defines a practitioner-facing screen; child or caregiver input may inform the assessment but is not a separate product flow."
			},
			{
				"question": "Does the demo score SCOPE?",
				"answer": "No. Exact scoring and rating rules are unresolved, so the demo only shows supported profile organization and partial-state handling."
			},
			{
				"question": "Can I use sample pediatric data in the public demo?",
				"answer": "Yes. The demo uses fictional, non-identifying sample content and does not require real child or caregiver information."
			},
			{
				"question": "What is saved after exploration?",
				"answer": "The SCOPE tool itself is saved as a fixed screening tool; demo child records and sample screening entries are not saved as real client data."
			}
		]
	},
	{
		"toolType": "remotivationProcess",
		"slug": "remotivation-process",
		"title": "Remotivation Process Demo | Qwoach",
		"metaDescription": "Explore a practitioner-led Remotivation Process record for occupational engagement observations, barriers, progress, and next-step review.",
		"h1": "Remotivation Process Progress Record",
		"intro": "Remotivation Process is a practitioner-led MOHO therapeutic process support for occupational therapy practitioners working with clients whose motivation for occupational engagement appears reduced. It helps the practitioner document engagement, interest, choice, initiation, barriers, and progress over time to guide the next supported therapeutic step.",
		"demoTitle": "Explore the sample progression record",
		"demoPrompt": "Interested in using Remotivation Process with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0723-f-037-moho-015-r001-remotivation-process.md",
		"specId": "0723-f-037-moho-015-r001-remotivation-process",
		"tags": {
			"framework": [
				"MOHO"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Occupational participation",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when a client has reduced readiness or initiation for meaningful occupations and the practitioner needs to document a structured therapeutic progression over time."
			},
			{
				"title": "Progress and Lack of Progress",
				"body": "The record should show both progress and lack of progress without treating lack of progress as failure or generating unsupported conclusions."
			},
			{
				"title": "Important Limits",
				"body": "The product must not invent Remotivation Process stages, therapeutic activities, motivation scores, readiness thresholds, or generic mood tracking."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client motivation self-tracker?",
				"answer": "No. Remotivation Process is practitioner-led in the supplied specification and documents therapeutic progression rather than independent client self-tracking."
			},
			{
				"question": "Does the demo include specific Remotivation Process stages?",
				"answer": "No. Exact stages and progression criteria are unresolved, so the demo uses neutral progression documentation only."
			},
			{
				"question": "Can lack of progress be recorded?",
				"answer": "Yes. The review experience should represent lack of progress without treating it as failure or generating unsupported conclusions."
			},
			{
				"question": "What is saved into the account?",
				"answer": "The Remotivation Process tool itself is saved; fictional sample session notes and demo client content do not become real client data."
			}
		]
	},
	{
		"toolType": "canadianOccupationalPerformanceMeasureCopm",
		"slug": "canadian-occupational-performance-measure-copm",
		"title": "COPM Assessment Demo | Qwoach",
		"metaDescription": "Explore a shared COPM flow for client-defined occupational problems, priorities, performance and satisfaction ratings, and reassessment comparison.",
		"h1": "Canadian Occupational Performance Measure COPM Demo",
		"intro": "The Canadian Occupational Performance Measure is a client-centred occupational therapy assessment for practitioners completing the COPM together with a client. It helps the practitioner capture client-prioritized occupational performance problems, record performance and satisfaction status, and compare ratings over time.",
		"demoTitle": "Try the sample COPM flow",
		"demoPrompt": "Interested in using Canadian Occupational Performance Measure (COPM) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0724-f-038-cmop-001-r001-canadian-occupational-performance-measure-copm.md",
		"specId": "0724-f-038-cmop-001-r001-canadian-occupational-performance-measure-copm",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Occupational participation",
				"Outcome monitoring",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "COPM is used when the practitioner needs client-centred occupational therapy planning or review based on the client's own occupational performance concerns."
			},
			{
				"title": "Repeated Measurement",
				"body": "Baseline and reassessment ratings are comparable when they use the same selected targets and rating type."
			},
			{
				"title": "Important Limits",
				"body": "The product must not replace client priorities with practitioner-generated priorities, invent unsupported prompts or anchors, or make normative or causal claims from the ratings."
			}
		],
		"faqItems": [
			{
				"question": "Does the client participate in this tool?",
				"answer": "Yes. COPM is completed together, with the client providing problem wording, importance information, target endorsement, and performance and satisfaction ratings."
			},
			{
				"question": "What is different between baseline and reassessment?",
				"answer": "Baseline creates the initial target and rating record; reassessment reuses the selected targets so later ratings can be compared."
			},
			{
				"question": "Does COPM show improvement?",
				"answer": "It shows individualized change where comparable baseline and reassessment ratings exist; it does not make unsupported causal or normative claims."
			},
			{
				"question": "What is saved after the public demo?",
				"answer": "The COPM tool itself and reusable practitioner setup are saved; fictional demo client wording, ratings, and change results are not saved as real client data."
			}
		]
	},
	{
		"toolType": "copmProblemDefinition",
		"slug": "copm-problem-definition",
		"title": "COPM Problem Definition Demo | Qwoach",
		"metaDescription": "Explore COPM Step 1 for capturing client-defined occupational performance problems with shared wording, clarification, and readiness review.",
		"h1": "COPM Problem Definition Step",
		"intro": "COPM Problem Definition is the Step 1 problem-capture portion of the Canadian Occupational Performance Measure for occupational therapy practitioners completing the assessment with a client. It helps the practitioner record client-defined occupational performance problems before prioritization and later COPM steps.",
		"demoTitle": "Try the sample problem definition step",
		"demoPrompt": "Interested in using COPM Problem Definition with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0725-f-038-cmop-002-r001-copm-problem-definition.md",
		"specId": "0725-f-038-cmop-002-r001-copm-problem-definition",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Goal setting"
			],
			"topic": [
				"Occupational participation",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this step at the beginning of a COPM process when the practitioner needs the client's own description of occupational performance problems."
			},
			{
				"title": "What It Captures",
				"body": "It captures multiple problem entries and optional clarification notes while keeping client wording primary."
			},
			{
				"title": "What It Does Not Do",
				"body": "This step does not collect importance ratings, performance ratings, satisfaction ratings, change scores, or practitioner-only goals."
			}
		],
		"faqItems": [
			{
				"question": "Is this the full COPM?",
				"answer": "No. This is only the COPM Problem Definition step for capturing client-defined occupational performance problems."
			},
			{
				"question": "Can the practitioner rewrite the client's wording?",
				"answer": "The practitioner can clarify meaning, but the product should keep the client's wording primary and avoid replacing it with practitioner shorthand."
			},
			{
				"question": "Are ratings included in this step?",
				"answer": "No. Importance, performance, satisfaction, and change ratings are outside this configuration."
			},
			{
				"question": "What is saved?",
				"answer": "The COPM Problem Definition tool itself is saved; fictional demo problems and notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "copmImportanceRating",
		"slug": "copm-importance-rating",
		"title": "COPM Importance Rating Demo | Qwoach",
		"metaDescription": "Explore COPM Step 2 for rating the importance of client-defined occupational performance problems and viewing relative priorities.",
		"h1": "COPM Importance Rating Step",
		"intro": "COPM Importance Rating is the COPM prioritization step for occupational therapy practitioners completing the assessment with a client. It uses a 10-point importance rating to help differentiate which client-defined occupational performance problems matter most before intervention targets are selected.",
		"demoTitle": "Rate sample problem importance",
		"demoPrompt": "Interested in using COPM Importance Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0726-f-038-cmop-003-r001-copm-importance-rating.md",
		"specId": "0726-f-038-cmop-003-r001-copm-importance-rating",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Occupational participation",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this step after problem definition and before selecting intervention targets."
			},
			{
				"title": "What It Captures",
				"body": "It captures one client-informed 10-point importance rating for each included occupational performance problem."
			},
			{
				"title": "Important Limits",
				"body": "The product must not invent anchors, thresholds, selection rules, or clinical interpretation beyond the rating values and priority visibility."
			}
		],
		"faqItems": [
			{
				"question": "Is the 10-point importance rating configurable?",
				"answer": "No. The 10-point importance rating is fixed by the represented COPM step."
			},
			{
				"question": "What happens when ratings are tied?",
				"answer": "Tied ratings remain visible; the product should not force a false ranking."
			},
			{
				"question": "Does this step select intervention targets?",
				"answer": "No. It shows priority differences; target selection occurs in a separate COPM step."
			},
			{
				"question": "What is saved?",
				"answer": "The COPM Importance Rating tool itself is saved; sample problems and ratings from the demo are not saved as real client data."
			}
		]
	},
	{
		"toolType": "copmProblemSelection",
		"slug": "copm-problem-selection",
		"title": "COPM Problem Selection Demo | Qwoach",
		"metaDescription": "Explore COPM Step 3 for selecting up to five client-endorsed occupational performance targets from prioritized problems.",
		"h1": "COPM Problem Selection Step",
		"intro": "COPM Problem Selection is the COPM step for occupational therapy practitioners narrowing prioritized client-identified occupational performance problems into a manageable intervention target set. It helps practitioner and client select up to five problems as focused targets for later rating and review.",
		"demoTitle": "Select sample COPM targets",
		"demoPrompt": "Interested in using COPM Problem Selection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0727-f-038-cmop-004-r001-copm-problem-selection.md",
		"specId": "0727-f-038-cmop-004-r001-copm-problem-selection",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Occupational participation",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this step after importance rating and before baseline performance or satisfaction rating."
			},
			{
				"title": "What It Captures",
				"body": "It captures selected and unselected status, confirms agreement, and enforces the up-to-five target set."
			},
			{
				"title": "Important Limits",
				"body": "The product must not invent automatic selection rules, goal-writing content, ratings, or change interpretation."
			}
		],
		"faqItems": [
			{
				"question": "How many targets can be selected?",
				"answer": "Up to five targets can be selected in this configuration."
			},
			{
				"question": "Does this step create goals?",
				"answer": "No. It selects intervention targets; goal-writing content is outside this product step."
			},
			{
				"question": "Are unselected problems deleted?",
				"answer": "No. Unselected prioritized problems remain visible as context but are not rated in this step."
			},
			{
				"question": "What is saved?",
				"answer": "The COPM Problem Selection tool itself is saved; fictional sample target selections are not saved as real client data."
			}
		]
	},
	{
		"toolType": "copmPerformanceRating",
		"slug": "copm-performance-rating",
		"title": "COPM Performance Rating Demo | Qwoach",
		"metaDescription": "Explore COPM performance rating for selected occupational targets, baseline and reassessment modes, and comparable change review.",
		"h1": "COPM Performance Rating Step",
		"intro": "COPM Performance Rating is the COPM rating step for occupational therapy practitioners completing ratings with a client. It helps the practitioner record the client's perceived performance for each selected occupational performance target at baseline or reassessment and compare ratings over time when the same target is rated again.",
		"demoTitle": "Rate sample performance targets",
		"demoPrompt": "Interested in using COPM Performance Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0728-f-038-cmop-005-r001-copm-performance-rating.md",
		"specId": "0728-f-038-cmop-005-r001-copm-performance-rating",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Occupational participation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this step after COPM targets have been selected and performance status needs to be recorded at baseline or reassessment."
			},
			{
				"title": "Comparison Behavior",
				"body": "Reassessment comparison is available only when the same target identity has comparable performance ratings at different time points."
			},
			{
				"title": "Important Limits",
				"body": "The product must not mix satisfaction ratings into performance results or invent anchors, thresholds, or clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Is this performance rating or satisfaction rating?",
				"answer": "This tool captures performance rating only; satisfaction rating is a separate COPM configuration."
			},
			{
				"question": "Can reassessment work without baseline ratings?",
				"answer": "No. Without comparable baseline performance ratings, change is unavailable for that target."
			},
			{
				"question": "What happens if a target is added later?",
				"answer": "The added target can be rated, but it is not comparable until it has ratings at a later time point."
			},
			{
				"question": "What is saved?",
				"answer": "The COPM Performance Rating tool itself and reusable time point setup are saved; demo targets and sample ratings are not saved as real client data."
			}
		]
	},
	{
		"toolType": "copmSatisfactionRating",
		"slug": "copm-satisfaction-rating",
		"title": "COPM Satisfaction Rating Demo | Qwoach",
		"metaDescription": "Explore COPM satisfaction rating for selected occupational targets, baseline and reassessment modes, and comparable change review.",
		"h1": "COPM Satisfaction Rating Step",
		"intro": "COPM Satisfaction Rating is the COPM rating step for occupational therapy practitioners completing ratings with a client. It helps the practitioner record the client's satisfaction with their performance for each selected occupational performance target at baseline or reassessment and compare ratings over time when valid.",
		"demoTitle": "Rate sample satisfaction targets",
		"demoPrompt": "Interested in using COPM Satisfaction Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0729-f-038-cmop-006-r001-copm-satisfaction-rating.md",
		"specId": "0729-f-038-cmop-006-r001-copm-satisfaction-rating",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Occupational participation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this step after COPM targets have been selected and satisfaction status needs to be recorded at baseline or reassessment."
			},
			{
				"title": "Comparison Behavior",
				"body": "Reassessment comparison is available only when the same target identity has comparable satisfaction ratings at different time points."
			},
			{
				"title": "Important Limits",
				"body": "The product must not mix performance ratings into satisfaction results or invent anchors, thresholds, or clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Is this satisfaction rating or performance rating?",
				"answer": "This tool captures satisfaction rating only; performance rating is a separate COPM configuration."
			},
			{
				"question": "Can satisfaction change be calculated without baseline?",
				"answer": "No. Without comparable baseline satisfaction ratings, change is unavailable for that target."
			},
			{
				"question": "Who provides the satisfaction rating?",
				"answer": "The client provides the satisfaction rating during the shared practitioner-client session."
			},
			{
				"question": "What is saved?",
				"answer": "The COPM Satisfaction Rating tool itself and reusable time point setup are saved; demo targets and sample satisfaction ratings are not saved as real client data."
			}
		]
	},
	{
		"toolType": "copmChangeScore",
		"slug": "copm-change-score",
		"title": "COPM Change Score Demo | Qwoach",
		"metaDescription": "Explore COPM Change Score review for target-specific performance or satisfaction change from comparable baseline and follow-up ratings.",
		"h1": "COPM Change Score Review",
		"intro": "COPM Change Score is a practitioner-only outcome calculation for occupational therapy practitioners reviewing clients with baseline and reassessment COPM ratings. It helps the practitioner see the amount and direction of change in performance or satisfaction for each comparable client-selected occupational performance target.",
		"demoTitle": "Review sample change scores",
		"demoPrompt": "Interested in using COPM Change Score with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0730-f-038-cmop-007-r001-copm-change-score.md",
		"specId": "0730-f-038-cmop-007-r001-copm-change-score",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Occupational participation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use COPM Change Score after baseline and reassessment ratings exist for the same selected occupational performance targets."
			},
			{
				"title": "Comparable Ratings",
				"body": "Change is calculated only when target identity and rating type match across the selected time points."
			},
			{
				"title": "Important Limits",
				"body": "The product must not calculate change across different clients, nonmatching targets, or different rating types, and must not infer causality or apply unsupported thresholds."
			}
		],
		"faqItems": [
			{
				"question": "Does COPM Change Score collect new ratings?",
				"answer": "No. It uses previously captured COPM ratings and calculates change from comparable time points."
			},
			{
				"question": "What makes a comparison valid?",
				"answer": "A comparison is valid when the same target identity and same rating type have baseline and follow-up ratings."
			},
			{
				"question": "Can it compare performance and satisfaction together?",
				"answer": "No. Change is rating-type-specific, so performance and satisfaction are compared separately."
			},
			{
				"question": "What is saved?",
				"answer": "The COPM Change Score tool itself and reusable comparison setup are saved; fictional sample ratings and change results are not saved as real client data."
			}
		]
	},
	{
		"toolType": "copmApp",
		"slug": "copm-app",
		"title": "COPM App Demo for Occupational Performance Review | Qwoach",
		"metaDescription": "Explore a practitioner-facing COPM App demo for priorities, performance and satisfaction ratings, reassessment comparison, and digital results.",
		"h1": "COPM App for Digital Occupational Performance Assessment",
		"intro": "The COPM App is a practitioner-facing digital occupational performance assessment and reassessment tool for occupational therapy practitioners. It helps practitioners organize client-prioritized occupational performance problems, performance ratings, satisfaction ratings, and change over time.",
		"demoTitle": "Start with a sample COPM assessment, then switch to reassessment to see how repeated ratings compare.",
		"demoPrompt": "Interested in using COPM App with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0731-f-038-cmop-008-r001-copm-app.md",
		"specId": "0731-f-038-cmop-008-r001-copm-app",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Occupational participation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at initial assessment to record prioritized occupational performance problems and ratings, then return at reassessment to compare repeated ratings for the same relevant priorities."
			},
			{
				"title": "What It Shows",
				"body": "The result shows priorities, performance ratings, satisfaction ratings, reassessment values, and descriptive change where comparison is possible."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide diagnosis, treatment recommendations, unsupported normative interpretation, or broader occupational therapy record features."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo require real client information?",
				"answer": "No. The public demo uses fictional sample priorities and ratings so practitioners can explore the workflow without entering sensitive or client-identifying information."
			},
			{
				"question": "Is there a separate client portal?",
				"answer": "No. The specified usage mode is practitioner-only; client information is elicited during assessment and entered by the practitioner."
			},
			{
				"question": "What is saved when I save the tool?",
				"answer": "The COPM App itself and intentional practitioner setup are saved. Sample priorities, sample ratings, and fictional demo records are not saved as real client data."
			},
			{
				"question": "Does the app interpret whether change is clinically meaningful?",
				"answer": "No. The app shows descriptive change from earlier to later ratings; the practitioner interprets the pattern."
			}
		]
	},
	{
		"toolType": "cmopEPersonOccupationEnvironmentFormulation",
		"slug": "cmop-e-person-occupation-environment-formulation",
		"title": "CMOP-E Formulation Demo for Occupational Performance | Qwoach",
		"metaDescription": "Explore a CMOP-E-informed formulation demo for mapping person, occupation, and environment factors around an occupational performance issue.",
		"h1": "CMOP-E Person-Occupation-Environment Formulation Tool",
		"intro": "CMOP-E Person-Occupation-Environment Formulation is a structured occupational performance formulation tool for occupational therapy practitioners. It helps practitioners organize personal factors, occupation or task features, environmental supports or barriers, and relationship explanations for a client's occupational performance issue.",
		"demoTitle": "Open a sample formulation and complete the person, occupation, and environment areas.",
		"demoPrompt": "Interested in using CMOP-E Person-Occupation-Environment Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0732-f-038-cmop-009-r001-cmop-e-person-occupation-environment-formulation.md",
		"specId": "0732-f-038-cmop-009-r001-cmop-e-person-occupation-environment-formulation",
		"tags": {
			"framework": [
				"CMOP-E"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Occupational participation",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Client Roles",
				"body": "The client may contribute lived detail; the practitioner organizes factors and authors the relationship explanation."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures one occupational performance issue, person factors, occupation or task features, environmental supports or barriers, and a relationship explanation."
			},
			{
				"title": "Limits",
				"body": "The tool does not score, diagnose, infer causality, prescribe intervention, or provide fixed worksheet prompts beyond the supported factor categories."
			}
		],
		"faqItems": [
			{
				"question": "Is this a scoring tool?",
				"answer": "No. The result is a descriptive formulation, not a standardized rating or score."
			},
			{
				"question": "Can a client complete it independently?",
				"answer": "No standalone client workflow is specified. The supported experience is collaborative completion led by the practitioner."
			},
			{
				"question": "Does the system decide which factor is most important?",
				"answer": "No. The system organizes entered information; practitioner interpretation remains separate."
			},
			{
				"question": "What happens if one section is empty?",
				"answer": "Empty factor areas are shown as gaps so the practitioner can see that the formulation is incomplete or sparse."
			}
		]
	},
	{
		"toolType": "goalAttainmentScale",
		"slug": "goal-attainment-scale",
		"title": "Goal Attainment Scale Demo for Follow-Up Scoring | Qwoach",
		"metaDescription": "Explore a Goal Attainment Scale demo with individualized goals, -2 to +2 attainment levels, expected outcome at 0, and follow-up scoring.",
		"h1": "Goal Attainment Scale for Individualized Outcome Scoring",
		"intro": "Goal Attainment Scale is an individualized longitudinal outcome scaling tool for practitioners working with personalized goals. It helps practitioners define five ordered attainment levels from -2 to +2, mark 0 as the expected outcome, and convert follow-up attainment into a score.",
		"demoTitle": "Create a sample goal scale, then select the follow-up level that matches actual attainment.",
		"demoPrompt": "Interested in using Goal Attainment Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0733-f-039-gas-001-r001-goal-attainment-scale.md",
		"specId": "0733-f-039-gas-001-r001-goal-attainment-scale",
		"tags": {
			"framework": [
				"Goal Attainment Scaling"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Goal setting",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after meaningful individualized goals are identified and before follow-up review, so each goal has predefined levels for later scoring."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures goal text, five ordered attainment levels, expected outcome at 0, follow-up selection, and score."
			},
			{
				"title": "Limits",
				"body": "The tool does not write goals automatically, recommend treatment, or assign clinical meaning beyond the selected attainment score."
			}
		],
		"faqItems": [
			{
				"question": "What scale does the tool use?",
				"answer": "It uses a fixed five-point Goal Attainment Scale from -2 to +2, with 0 as the expected outcome."
			},
			{
				"question": "Can the goal levels be changed at follow-up?",
				"answer": "Follow-up scoring should use the predefined levels. Changing anchors after baseline compromises comparability and should be marked."
			},
			{
				"question": "Does the tool score automatically?",
				"answer": "The score comes from the practitioner-selected predefined attainment level; the system does not infer attainment without that selection."
			},
			{
				"question": "Is weighting required?",
				"answer": "No. Weighting is optional only if the supported GAS workflow includes it."
			}
		]
	},
	{
		"toolType": "smartGoalDefinition",
		"slug": "smart-goal-definition",
		"title": "SMART Goal Definition Demo for Practitioners | Qwoach",
		"metaDescription": "Explore a SMART Goal Definition demo for turning vague intervention aims into explicit, measurable goals with outcome, context, and timeframe.",
		"h1": "SMART Goal Definition for Measurable Intervention Goals",
		"intro": "SMART Goal Definition is a structured measurable goal-definition tool for practitioners and clients working together. It helps them create an explicit, measurable goal with an observable outcome, review basis, relevance, context, and timeframe.",
		"demoTitle": "Enter a sample vague aim and complete the components needed for a reviewable goal.",
		"demoPrompt": "Interested in using SMART Goal Definition with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0734-f-039-gas-002-r001-smart-goal-definition.md",
		"specId": "0734-f-039-gas-002-r001-smart-goal-definition",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before outcome review or GAS scaling when the current intervention aim does not yet specify an observable result, review basis, or timeframe."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the draft aim, observable outcome, measurement or review basis, relevance, context or conditions, and timeframe."
			},
			{
				"title": "Limits",
				"body": "The tool does not create GAS attainment levels, compute scores, recommend treatment, or invent goal content."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create a full Goal Attainment Scale?",
				"answer": "No. It creates an explicit measurable goal; GAS attainment levels and follow-up scoring are separate steps."
			},
			{
				"question": "Can the system write the goal for me?",
				"answer": "No. The system can compose or display entered components, but it must not invent substantive goal content."
			},
			{
				"question": "Is client participation required?",
				"answer": "The supported mode is ready to complete together, so client input may help confirm relevance and meaningfulness, but the practitioner controls the record."
			},
			{
				"question": "What is saved?",
				"answer": "The fixed SMART Goal Definition tool is saved as-is. Demo goal text is not saved as real client data."
			}
		]
	},
	{
		"toolType": "expectedOutcome0Definition",
		"slug": "expected-outcome-0-definition",
		"title": "Expected Outcome 0 Definition Demo for GAS | Qwoach",
		"metaDescription": "Explore a focused GAS demo for defining the 0 expected outcome anchor linked to an individualized goal for later scoring.",
		"h1": "Define the GAS 0 Expected Outcome Anchor",
		"intro": "Expected Outcome (0) Definition is a focused Goal Attainment Scaling anchor-definition tool for practitioners and clients working together. It helps define the expected level of achievement for an individualized goal as an observable future state for later scoring.",
		"demoTitle": "Select a sample goal and write the 0 expected outcome anchor.",
		"demoPrompt": "Interested in using Expected Outcome (0) Definition with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0735-f-039-gas-003-r001-expected-outcome-0-definition.md",
		"specId": "0735-f-039-gas-003-r001-expected-outcome-0-definition",
		"tags": {
			"framework": [
				"Goal Attainment Scaling"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after selecting an individualized goal and before defining neighboring GAS anchors or scoring follow-up."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the goal link, expected observable future state, and optional context about the intervention period."
			},
			{
				"title": "Limits",
				"body": "The tool does not generate -1, -2, +1, or +2 anchors and does not score follow-up attainment."
			}
		],
		"faqItems": [
			{
				"question": "What does 0 mean in this tool?",
				"answer": "0 is the expected outcome level for the individualized goal in Goal Attainment Scaling."
			},
			{
				"question": "Can this tool stand alone without a goal?",
				"answer": "No. The 0 anchor must be linked to a specific individualized goal."
			},
			{
				"question": "Does the tool decide whether the expectation is realistic?",
				"answer": "No. It may show a place for practitioner judgment, but it does not determine clinical realism automatically."
			},
			{
				"question": "What is saved?",
				"answer": "The fixed 0-anchor definition tool is saved as-is; sample goal and anchor text are not saved as real client data."
			}
		]
	},
	{
		"toolType": "lessThanExpectedAnchors12",
		"slug": "less-than-expected-anchors-1-2",
		"title": "Less-than-Expected GAS Anchors Demo | Qwoach",
		"metaDescription": "Explore a focused GAS demo for defining -1 and -2 lower anchors around a 0 expected outcome for consistent underachievement scoring.",
		"h1": "Define GAS -1 and -2 Less-than-Expected Anchors",
		"intro": "Less-than-Expected Anchors (-1/-2) is a focused Goal Attainment Scaling lower-anchor definition tool for practitioners and clients working together. It helps define below-expected attainment states for an individualized goal so partial or minimal progress can be scored consistently.",
		"demoTitle": "Start with a sample 0 expected outcome and define the -1 and -2 lower anchors.",
		"demoPrompt": "Interested in using Less-than-Expected Anchors (-1/-2) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0736-f-039-gas-004-r001-less-than-expected-anchors-1-2.md",
		"specId": "0736-f-039-gas-004-r001-less-than-expected-anchors-1-2",
		"tags": {
			"framework": [
				"Goal Attainment Scaling"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after the expected 0 outcome is defined and before follow-up scoring, so below-expected attainment can be matched consistently."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures -1 and -2 descriptions linked to a goal and expected 0 outcome."
			},
			{
				"title": "Limits",
				"body": "The tool does not define +1 or +2 anchors, compute scores, decide clinical plausibility, or suggest anchor wording."
			}
		],
		"faqItems": [
			{
				"question": "Can I use this without a 0 expected outcome?",
				"answer": "No. Lower anchors cannot be meaningfully defined without the expected outcome reference."
			},
			{
				"question": "What is the difference between -1 and -2?",
				"answer": "-1 is less-than-expected achievement, while -2 is more severe underachievement."
			},
			{
				"question": "Does the system decide whether an anchor is clinically plausible?",
				"answer": "No. Plausibility remains a practitioner judgment; the system may only flag structural issues such as missing or duplicate content."
			},
			{
				"question": "What is saved?",
				"answer": "The fixed lower-anchor tool is saved as-is; fictional demo goal and anchor content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "betterThanExpectedAnchors12",
		"slug": "better-than-expected-anchors-1-2",
		"title": "Better-than-Expected GAS Anchors Demo | Qwoach",
		"metaDescription": "Explore a focused GAS demo for defining +1 and +2 higher anchors around a 0 expected outcome for consistent exceptional progress scoring.",
		"h1": "Define GAS +1 and +2 Better-than-Expected Anchors",
		"intro": "Better-than-Expected Anchors (+1/+2) is a focused Goal Attainment Scaling higher-anchor definition tool for practitioners and clients working together. It helps define above-expected attainment states for an individualized goal so exceptional improvement can be scored consistently.",
		"demoTitle": "Start with a sample 0 expected outcome and define the +1 and +2 higher anchors.",
		"demoPrompt": "Interested in using Better-than-Expected Anchors (+1/+2) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0737-f-039-gas-005-r001-better-than-expected-anchors-1-2.md",
		"specId": "0737-f-039-gas-005-r001-better-than-expected-anchors-1-2",
		"tags": {
			"framework": [
				"Goal Attainment Scaling"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after the expected 0 outcome is defined and before follow-up scoring, so above-expected attainment can be matched consistently."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures +1 and +2 descriptions linked to a goal and expected 0 outcome."
			},
			{
				"title": "Limits",
				"body": "The tool does not define -1 or -2 anchors, compute scores, decide clinical plausibility, or suggest anchor wording."
			}
		],
		"faqItems": [
			{
				"question": "Can I use this without a 0 expected outcome?",
				"answer": "No. Higher anchors cannot be meaningfully defined without the expected outcome reference."
			},
			{
				"question": "What is the difference between +1 and +2?",
				"answer": "+1 is moderately better-than-expected achievement, while +2 is substantially better achievement."
			},
			{
				"question": "Does the system decide whether higher anchors are realistic?",
				"answer": "No. Plausibility remains a practitioner judgment; the system may only flag structural issues such as missing or duplicate content."
			},
			{
				"question": "What is saved?",
				"answer": "The fixed higher-anchor tool is saved as-is; fictional demo goal and anchor content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "goalImportanceWeight",
		"slug": "goal-importance-weight",
		"title": "Goal Importance Weight Demo for GAS | Qwoach",
		"metaDescription": "Explore a GAS importance weighting demo for assigning client-informed priority values to multiple individualized goals.",
		"h1": "Goal Importance Weight for Client-Informed GAS Priorities",
		"intro": "Goal Importance Weight is a Goal Attainment Scaling weighting tool for practitioners and clients working together. It helps assign client-informed importance values to multiple individualized goals so overall goal progress can reflect what matters most to the client.",
		"demoTitle": "Review sample goals and assign importance values to see the weighted priority view.",
		"demoPrompt": "Interested in using Goal Importance Weight with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0738-f-039-gas-006-r001-goal-importance-weight.md",
		"specId": "0738-f-039-gas-006-r001-goal-importance-weight",
		"tags": {
			"framework": [
				"Goal Attainment Scaling"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it with multiple goals when client priorities differ and overall interpretation should show what matters most to the client."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures one client-informed importance value per goal and keeps each value linked to its goal."
			},
			{
				"title": "Limits",
				"body": "The tool does not capture goal difficulty, define attainment levels, score follow-up, or infer priority from goal content."
			}
		],
		"faqItems": [
			{
				"question": "Is this useful for a single goal?",
				"answer": "Usually not. Importance weighting has little standalone value when there is only one goal."
			},
			{
				"question": "Who provides the importance value?",
				"answer": "The value is client-informed; the practitioner records the client's view of relative priority."
			},
			{
				"question": "Does the tool define the weighting scale?",
				"answer": "No. The exact scale or method remains unresolved unless supplied by the surrounding GAS workflow."
			},
			{
				"question": "What is saved?",
				"answer": "The tool and selected supported weighting method are saved. Sample goals and demo importance values are not saved as real client data."
			}
		]
	},
	{
		"toolType": "goalDifficultyWeight",
		"slug": "goal-difficulty-weight",
		"title": "Goal Difficulty Weight Demo for GAS | Qwoach",
		"metaDescription": "Explore a practitioner-only GAS difficulty weighting demo for assigning challenge values to multiple individualized goals.",
		"h1": "Goal Difficulty Weight for Practitioner-Informed GAS Interpretation",
		"intro": "Goal Difficulty Weight is a practitioner-only Goal Attainment Scaling weighting tool for practitioners working with multiple individualized goals. It helps assign practitioner- or team-informed difficulty values so overall goal progress can account for differences in expected challenge.",
		"demoTitle": "Assign difficulty values to sample goals and review the relative challenge view.",
		"demoPrompt": "Interested in using Goal Difficulty Weight with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0739-f-039-gas-007-r001-goal-difficulty-weight.md",
		"specId": "0739-f-039-gas-007-r001-goal-difficulty-weight",
		"tags": {
			"framework": [
				"Goal Attainment Scaling"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it with multiple goals when expected challenge differs and difficulty should be visible during overall interpretation."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures one practitioner- or team-informed difficulty value per goal and keeps it linked to that goal."
			},
			{
				"title": "Limits",
				"body": "The tool does not collect client importance values, define attainment levels, score follow-up, or infer difficulty from goal text."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client-facing view?",
				"answer": "No. This tool is practitioner-only, and client entry or approval is not part of the specified product."
			},
			{
				"question": "Does the system calculate difficulty from the goal text?",
				"answer": "No. Difficulty values come from practitioner or team judgment, not automatic inference."
			},
			{
				"question": "Can this be used with one goal?",
				"answer": "It has little standalone value for a single goal because the purpose is relative difficulty across multiple goals."
			},
			{
				"question": "What is saved?",
				"answer": "The tool and selected supported weighting method are saved. Sample goals and demo difficulty values are not saved as real client data."
			}
		]
	},
	{
		"toolType": "goalAttainmentReview",
		"slug": "goal-attainment-review",
		"title": "Goal Attainment Review Demo for GAS Scoring | Qwoach",
		"metaDescription": "Explore a Goal Attainment Review demo for matching actual performance to predefined GAS levels and displaying goal attainment scores.",
		"h1": "Goal Attainment Review for GAS Follow-Up Scoring",
		"intro": "Goal Attainment Review is a Goal Attainment Scaling follow-up scoring and outcome review tool for practitioners and clients working together. It helps practitioners compare actual performance with predefined personalized goal levels and express the selected attainment level as an outcome score.",
		"demoTitle": "Open a sample GAS record and select the level that best matches actual attainment.",
		"demoPrompt": "Interested in using Goal Attainment Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0740-f-039-gas-008-r001-goal-attainment-review.md",
		"specId": "0740-f-039-gas-008-r001-goal-attainment-review",
		"tags": {
			"framework": [
				"Goal Attainment Scaling"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after intervention, when the GAS scale was defined before review and actual performance needs to be matched to those levels."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures practitioner-selected actual attainment levels and displays the score derived from each selected predefined level."
			},
			{
				"title": "Limits",
				"body": "The tool does not rewrite anchors during review, invent intermediate scores, generate treatment decisions, or start new goal definition inside the current review score."
			}
		],
		"faqItems": [
			{
				"question": "Can I change anchors during review?",
				"answer": "No. Review should use predefined levels unchanged; changing anchors after intervention compromises scoring consistency."
			},
			{
				"question": "How is the score created?",
				"answer": "The score comes from the practitioner-selected predefined attainment level for each goal."
			},
			{
				"question": "What if actual performance falls between two levels?",
				"answer": "The practitioner must choose the best matching predefined level or mark the item unresolved; the system must not invent an intermediate score."
			},
			{
				"question": "Does the tool decide whether to continue or end intervention?",
				"answer": "No. It provides outcome information that supports practitioner decision-making, but it does not make the decision automatically."
			}
		]
	},
	{
		"toolType": "aggregateGasTScore",
		"slug": "aggregate-gas-t-score",
		"title": "Aggregate GAS T-Score Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only GAS T-score calculator for summarizing individualized goal-attainment ratings across multiple goals.",
		"h1": "Aggregate GAS T-Score",
		"intro": "Aggregate GAS T-Score is a practitioner-only calculation tool for clinicians and other practitioners using individualized Goal Attainment Scaling ratings. It helps the practitioner combine ratings across multiple goals into one standardized numerical T-score and compare overall attainment with the expected-attainment reference point.",
		"demoTitle": "Enter sample goal ratings and calculate a demo T-score.",
		"demoPrompt": "Interested in using Aggregate GAS T-Score with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0741-f-039-gas-009-r001-aggregate-gas-t-score.md",
		"specId": "0741-f-039-gas-009-r001-aggregate-gas-t-score",
		"tags": {
			"framework": [
				"Goal Attainment Scaling"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool after individualized GAS ratings are available for multiple goals at the same review point."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not create goals, recommend interventions, explain why progress changed, or generate clinical conclusions beyond the aggregate score and supported descriptive positioning."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create GAS goals?",
				"answer": "No. It summarizes existing individualized goal-attainment ratings; it is not a goal authoring system."
			},
			{
				"question": "Can a client complete this tool directly?",
				"answer": "No. The supplied configuration is practitioner-only."
			},
			{
				"question": "Is the T-score saved with the sample demo data?",
				"answer": "No. Saving keeps the tool and supported reusable configuration, not the fictional sample ratings or demo client data."
			},
			{
				"question": "Can the result be compared over time?",
				"answer": "Yes. Comparable aggregate scores for the same client can be reviewed across review points when the inputs and method assumptions remain comparable."
			}
		]
	},
	{
		"toolType": "gasGoalLadder",
		"slug": "gas-goal-ladder",
		"title": "GAS Goal Ladder Demo | Qwoach",
		"metaDescription": "Explore a collaborative GAS goal ladder for defining observable attainment levels from current performance to expected and higher outcomes.",
		"h1": "GAS Goal Ladder",
		"intro": "GAS Goal Ladder is a collaborative Goal Attainment Scaling tool for practitioners working with a client, caregiver, or team. It helps define an ordered visual progression from current performance through expected and better-than-expected attainment so later rating can use clear observable levels.",
		"demoTitle": "Complete a sample goal ladder.",
		"demoPrompt": "Interested in using GAS Goal Ladder with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0742-f-039-gas-010-r001-gas-goal-ladder.md",
		"specId": "0742-f-039-gas-010-r001-gas-goal-ladder",
		"tags": {
			"framework": [
				"Goal Attainment Scaling"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Collaborative Use",
				"body": "The ladder can be shown during goal-setting so clients, caregivers, or team members can discuss whether each level describes meaningful real-world change."
			},
			{
				"title": "Draft And Final States",
				"body": "Draft ladders preserve entered text and mark unresolved levels. Finalized ladders preserve the descriptions intended for later rating."
			},
			{
				"title": "Boundary",
				"body": "The tool does not invent goal content, assign ratings, generate treatment steps, or calculate aggregate scores."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write the goal levels for me?",
				"answer": "No. The practitioner and participants supply the wording; the system only organizes the ladder and marks structural issues."
			},
			{
				"question": "Can a client edit the ladder independently?",
				"answer": "Not as an independent workflow. Participant input may inform wording during collaboration, but the practitioner controls the official ladder."
			},
			{
				"question": "Can one ladder include multiple goals?",
				"answer": "No. Each ladder represents one individualized goal trajectory."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and supported reusable setup are saved. Fictional sample goal content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "operationalBehaviorDefinition",
		"slug": "operational-behavior-definition",
		"title": "Operational Behavior Definition Demo | Qwoach",
		"metaDescription": "Explore an ABA tool for defining target behavior in observable, measurable terms with examples, non-examples, and boundary review.",
		"h1": "Operational Behavior Definition",
		"intro": "Operational Behavior Definition is a practitioner-only ABA tool for practitioners preparing behavior measurement or intervention implementation. It helps define a target behavior in observable and measurable terms, with clear boundaries, examples, and non-examples for what counts.",
		"demoTitle": "Draft a sample operational definition.",
		"demoPrompt": "Interested in using Operational Behavior Definition with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0743-f-040-aba-001-r001-operational-behavior-definition.md",
		"specId": "0743-f-040-aba-001-r001-operational-behavior-definition",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures the target label, observable definition, boundaries when relevant, examples, and non-examples."
			},
			{
				"title": "What It Does Not Determine",
				"body": "It does not infer behavior function, certify observer agreement, assign severity, diagnose, or recommend intervention procedures."
			},
			{
				"title": "Version Clarity",
				"body": "When a finalized definition is revised after data collection begins, prior definition versions should remain visible for historical clarity."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool determine the function of behavior?",
				"answer": "No. It defines observable measurement boundaries and does not assess behavior function."
			},
			{
				"question": "Does the tool certify observer agreement?",
				"answer": "No. It supports clarity for observers, but observer agreement requires separate data."
			},
			{
				"question": "Can the demo use real client behavior?",
				"answer": "No real client-identifying or sensitive case details are needed; the public demo uses fictional sample content."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The fixed Operational Behavior Definition tool is saved as-is."
			}
		]
	},
	{
		"toolType": "frequencyEventRecording",
		"slug": "frequency-event-recording",
		"title": "Frequency/Event Recording Demo | Qwoach",
		"metaDescription": "Explore an ABA event recording tool for counting discrete behavior occurrences and calculating rate when observation period data exists.",
		"h1": "Frequency/Event Recording",
		"intro": "Frequency/Event Recording is an ABA measurement tool for practitioners and assigned recorders observing a discrete, countable target behavior. It helps capture how often the behavior occurs during a defined period and calculate rate when the observation or opportunity denominator is known.",
		"demoTitle": "Start a sample event recording session.",
		"demoPrompt": "Interested in using Frequency/Event Recording with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0744-f-040-aba-002-r001-frequency-event-recording.md",
		"specId": "0744-f-040-aba-002-r001-frequency-event-recording",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Fits",
				"body": "Use it for behaviors with clear onset and offset points that can be counted as separate occurrences."
			},
			{
				"title": "Rate Requirements",
				"body": "Rate is shown only when the observation time or opportunity denominator is available."
			},
			{
				"title": "Limits",
				"body": "The tool does not infer behavior function, explain behavior change, or prescribe treatment decisions."
			}
		],
		"faqItems": [
			{
				"question": "When is rate displayed?",
				"answer": "Rate is displayed only when the required observation time or opportunity denominator is available."
			},
			{
				"question": "Can I correct accidental counts?",
				"answer": "Yes. The recording experience supports correction controls, with final count integrity visible in review."
			},
			{
				"question": "Is this for behaviors without clear separate occurrences?",
				"answer": "No. The target behavior needs clear occurrence boundaries before event recording is reliable."
			},
			{
				"question": "Does the demo save sample observations?",
				"answer": "No. Saving keeps the tool and reusable setup, not fictional sample sessions."
			}
		]
	},
	{
		"toolType": "durationRecording",
		"slug": "duration-recording",
		"title": "Duration Recording Demo | Qwoach",
		"metaDescription": "Explore an ABA duration recording tool for timing behavior episodes, reviewing total duration, and comparing repeated observations.",
		"h1": "Duration Recording",
		"intro": "Duration Recording is an ABA timing tool for practitioners and assigned recorders monitoring a target behavior where persistence over time matters. It helps record start and stop times for behavior episodes, derive duration values, and review total or episode-level timing across observation periods.",
		"demoTitle": "Time a sample behavior episode.",
		"demoPrompt": "Interested in using Duration Recording with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0745-f-040-aba-003-r001-duration-recording.md",
		"specId": "0745-f-040-aba-003-r001-duration-recording",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Fits",
				"body": "Use it when start and end points can be defined clearly enough to time behavior episodes."
			},
			{
				"title": "Incomplete Timing",
				"body": "An active episode at session end must be stopped, discarded, or marked incomplete instead of silently becoming a final duration."
			},
			{
				"title": "Limits",
				"body": "The tool measures time and does not determine causes, treatment effectiveness, or intervention recommendations by itself."
			}
		],
		"faqItems": [
			{
				"question": "Can the tool record more than one episode?",
				"answer": "Yes. It supports multiple behavior episodes within an observation period."
			},
			{
				"question": "What happens if an episode is still running?",
				"answer": "The session cannot silently finalize it; the active episode must be stopped, discarded, or marked incomplete."
			},
			{
				"question": "Does this tool explain why duration changed?",
				"answer": "No. It reports recorded and derived duration values without causal explanation."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool and selected reusable duration focus are saved; sample timing data is not saved as real client data."
			}
		]
	},
	{
		"toolType": "latencyRecording",
		"slug": "latency-recording",
		"title": "Latency Recording Demo | Qwoach",
		"metaDescription": "Explore an ABA latency recording tool for timing delay from a defined antecedent to target response onset across opportunities.",
		"h1": "Latency Recording",
		"intro": "Latency Recording is an ABA timing tool for practitioners and assigned recorders measuring how long it takes a client to begin a target response after a specified antecedent, cue, or instruction. It helps capture latency values across comparable opportunities and review whether delay is increasing, decreasing, or stable over time.",
		"demoTitle": "Time a sample latency opportunity.",
		"demoPrompt": "Interested in using Latency Recording with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0746-f-040-aba-004-r001-latency-recording.md",
		"specId": "0746-f-040-aba-004-r001-latency-recording",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Complete Timing Pairs",
				"body": "A latency value requires both a start event and a stop event; incomplete pairs remain visibly incomplete."
			},
			{
				"title": "Non-Response",
				"body": "The supplied record does not define a scoring convention for non-response, so the demo marks it unresolved unless a supported rule is configured later."
			},
			{
				"title": "Limits",
				"body": "The tool does not choose prompts, infer skill mastery, explain delay, or recommend teaching procedures."
			}
		],
		"faqItems": [
			{
				"question": "What starts the timer?",
				"answer": "A practitioner-defined antecedent, cue, or instruction starts the timer."
			},
			{
				"question": "What stops the timer?",
				"answer": "The practitioner-defined response onset stops the timer."
			},
			{
				"question": "Can a latency value be created without a stop event?",
				"answer": "No. Missing stop events remain incomplete and do not become completed latency values."
			},
			{
				"question": "Does the tool score non-response?",
				"answer": "Not by default. The supplied record does not define a non-response scoring convention."
			}
		]
	},
	{
		"toolType": "interresponseTimeRecording",
		"slug": "interresponse-time-recording",
		"title": "Interresponse Time Recording Demo | Qwoach",
		"metaDescription": "Explore an ABA IRT recording tool for measuring time between consecutive target behavior occurrences and reviewing response spacing.",
		"h1": "Interresponse Time Recording",
		"intro": "Interresponse Time Recording is a practitioner-only ABA timing tool for practitioners who need to understand response spacing. It helps mark consecutive target behavior occurrences, derive the time between them, and compare spacing patterns across comparable sessions.",
		"demoTitle": "Mark sample occurrences.",
		"demoPrompt": "Interested in using Interresponse Time Recording with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0747-f-040-aba-005-r001-interresponse-time-recording.md",
		"specId": "0747-f-040-aba-005-r001-interresponse-time-recording",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Fits",
				"body": "Use it when separate occurrences are clear and the practitioner needs response-spacing data rather than count, duration, or latency from an antecedent."
			},
			{
				"title": "Gap Handling",
				"body": "Session breaks and unrelated observation gaps should be marked so they do not silently become interresponse intervals."
			},
			{
				"title": "Limits",
				"body": "The tool does not explain why spacing changed or prescribe intervention schedules."
			}
		],
		"faqItems": [
			{
				"question": "Why does the first occurrence produce no IRT value?",
				"answer": "IRT requires at least two consecutive occurrences because it measures time between instances."
			},
			{
				"question": "Can long observation gaps be excluded?",
				"answer": "Yes. The tool supports boundary handling so unrelated gaps are not treated as consecutive response intervals."
			},
			{
				"question": "Does the tool measure latency?",
				"answer": "No. IRT measures time between behavior occurrences, not delay after an antecedent."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and boundary handling setup are saved; sample occurrence marks and intervals are not saved as client data."
			}
		]
	},
	{
		"toolType": "partialIntervalRecording",
		"slug": "partial-interval-recording",
		"title": "Partial-Interval Recording Demo | Qwoach",
		"metaDescription": "Explore an ABA partial-interval recording tool for scoring whether behavior occurred at least once in each observation interval.",
		"h1": "Partial-Interval Recording",
		"intro": "Partial-Interval Recording is an ABA interval measurement tool for practitioners and assigned recorders when continuous exact counting is impractical. It helps score whether the target behavior occurred at least once within each interval and calculates the percentage of intervals with occurrence.",
		"demoTitle": "Score a sample interval session.",
		"demoPrompt": "Interested in using Partial-Interval Recording with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0748-f-040-aba-006-r001-partial-interval-recording.md",
		"specId": "0748-f-040-aba-006-r001-partial-interval-recording",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Scoring Rule",
				"body": "An interval is scored as occurrence if the behavior happens at any point within that interval."
			},
			{
				"title": "Result Meaning",
				"body": "The result is an interval occurrence estimate, not an exact event count or exact duration."
			},
			{
				"title": "Rule Separation",
				"body": "Partial-interval scoring remains separate from whole-interval and momentary time sampling rules."
			}
		],
		"faqItems": [
			{
				"question": "What counts as occurrence in partial-interval recording?",
				"answer": "Occurrence means the behavior happened at least once at any point during the interval."
			},
			{
				"question": "Does this tool count every behavior event?",
				"answer": "No. It calculates the percentage of intervals with occurrence and does not produce exact counts."
			},
			{
				"question": "What happens if an interval is unscored?",
				"answer": "The session is marked incomplete or handled with transparent denominator rules, depending on validated product behavior."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected interval structure are saved; fictional interval scores are not saved as real client data."
			}
		]
	},
	{
		"toolType": "wholeIntervalRecording",
		"slug": "whole-interval-recording",
		"title": "Whole-Interval Recording Demo | Qwoach",
		"metaDescription": "Explore an ABA whole-interval recording tool for scoring intervals only when behavior is present for the entire interval.",
		"h1": "Whole-Interval Recording",
		"intro": "Whole-Interval Recording is an ABA interval measurement tool for practitioners and assigned recorders observing sustained behavior. It helps score an interval as present only when the target behavior occurs for the entire interval and calculates the percentage of whole intervals scored present.",
		"demoTitle": "Score a sample whole-interval session.",
		"demoPrompt": "Interested in using Whole-Interval Recording with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0749-f-040-aba-007-r001-whole-interval-recording.md",
		"specId": "0749-f-040-aba-007-r001-whole-interval-recording",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Scoring Rule",
				"body": "An interval is scored present only when the behavior is present for the entire interval."
			},
			{
				"title": "Result Meaning",
				"body": "The output is an interval percentage, not exact duration and not exact count."
			},
			{
				"title": "Rule Separation",
				"body": "Whole-interval scoring remains distinct from partial-interval recording and momentary time sampling."
			}
		],
		"faqItems": [
			{
				"question": "What counts as present in whole-interval recording?",
				"answer": "Present means the target behavior occurred for the entire interval."
			},
			{
				"question": "How should partial-interval behavior be scored?",
				"answer": "If the behavior occurs for only part of the interval, it is not scored present for whole-interval recording."
			},
			{
				"question": "Does the tool calculate exact duration?",
				"answer": "No. It calculates an interval percentage and does not produce exact duration."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected interval structure are saved; fictional interval scores are not saved as real client data."
			}
		]
	},
	{
		"toolType": "momentaryTimeSampling",
		"slug": "momentary-time-sampling",
		"title": "Momentary Time Sampling Demo | Qwoach",
		"metaDescription": "Explore an ABA momentary time sampling tool for scoring behavior at predetermined moments and reviewing sampled occurrence estimates.",
		"h1": "Momentary Time Sampling",
		"intro": "Momentary Time Sampling is an ABA measurement tool for practitioners and assigned recorders who need an efficient estimate of behavior occurrence without continuous observation. It helps set predetermined sampling moments, score whether the target behavior is occurring exactly then, and review a sampled occurrence estimate.",
		"demoTitle": "Run a sample sampling schedule.",
		"demoPrompt": "Interested in using Momentary Time Sampling with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0750-f-040-aba-008-r001-momentary-time-sampling.md",
		"specId": "0750-f-040-aba-008-r001-momentary-time-sampling",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Scoring Rule",
				"body": "Behavior is scored based only on whether it is occurring at the exact sampling moment."
			},
			{
				"title": "Missed Moments",
				"body": "A missed sampling moment is recorded separately from not-present behavior."
			},
			{
				"title": "Limits",
				"body": "The tool does not infer behavior between sampling moments and does not produce exact counts or durations."
			}
		],
		"faqItems": [
			{
				"question": "What does the recorder score?",
				"answer": "The recorder scores whether the target behavior is occurring at the exact predetermined sampling moment."
			},
			{
				"question": "Is a missed prompt the same as not present?",
				"answer": "No. Missed moments are tracked separately from not-present scores."
			},
			{
				"question": "Does the tool measure behavior between sampling moments?",
				"answer": "No. It does not infer occurrence between moments."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected sampling schedule configuration are saved; fictional moment scores and sample estimates are not saved as real client data."
			}
		]
	},
	{
		"toolType": "permanentProductRecording",
		"slug": "permanent-product-recording",
		"title": "Permanent Product Recording Demo for ABA Practitioners | Qwoach",
		"metaDescription": "Explore Permanent Product Recording for ABA: define a target product, record objective values, preserve context, and review comparable entries.",
		"h1": "Permanent Product Recording for ABA Measurement",
		"intro": "Permanent Product Recording is an ABA measurement tool for practitioners. It helps an ABA practitioner record an objective count or objective-quality value for a product left by a target behavior, with the period, opportunity, or task context needed for comparison over time.",
		"demoTitle": "Define a sample product and record a demo measurement occasion.",
		"demoPrompt": "Interested in using Permanent Product Recording with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0751-f-040-aba-009-r001-permanent-product-recording.md",
		"specId": "0751-f-040-aba-009-r001-permanent-product-recording",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when a target behavior leaves a countable or inspectable outcome that can be linked to a known period, opportunity, or task context."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not replace live observation when live observation is required, infer why behavior occurred, or make treatment recommendations from the values."
			}
		],
		"faqItems": [
			{
				"question": "Is this for continuous observation?",
				"answer": "No. Permanent Product Recording is for post-event measurement when the behavior leaves a countable or inspectable outcome."
			},
			{
				"question": "Can the demo use real client information?",
				"answer": "No. Public exploration should use fictional or non-identifying sample data; demo entries are not saved as real client data."
			},
			{
				"question": "What makes an entry comparable?",
				"answer": "An entry is comparable when the same product definition and required attribution context are present."
			}
		]
	},
	{
		"toolType": "behaviorGraph",
		"slug": "behavior-graph",
		"title": "Behavior Graph Demo for ABA Practitioners | Qwoach",
		"metaDescription": "Explore an ABA Behavior Graph demo: plot repeated measurements, mark phases, and inspect level, trend, variability, and current data.",
		"h1": "Behavior Graph for ABA Data Review",
		"intro": "Behavior Graph is an ABA graphing tool for practitioners. It helps an ABA practitioner display repeated behavior measurements over time, distinguish relevant phases or conditions, and inspect level, trend, variability, and the latest data point.",
		"demoTitle": "Build a sample graph and inspect the visual pattern.",
		"demoPrompt": "Interested in using Behavior Graph with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0752-f-040-aba-010-r001-behavior-graph.md",
		"specId": "0752-f-040-aba-010-r001-behavior-graph",
		"tags": {
			"framework": [],
			"toolType": [
				"Graph"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Displays",
				"body": "The graph displays repeated measurements in order, relevant phases or conditions, missing-data markers when needed, and the most recent included data point."
			},
			{
				"title": "Limits of the Display",
				"body": "The graph organizes and displays behavior data. It does not diagnose, infer behavioral function, declare treatment effects, or prescribe decisions."
			}
		],
		"faqItems": [
			{
				"question": "Does the graph decide whether an intervention worked?",
				"answer": "No. The graph displays data patterns; the practitioner interprets level, trend, variability, and phase changes."
			},
			{
				"question": "Can I save a graph with no real client data?",
				"answer": "Yes. The graph setup can be saved while fictional demo data are discarded."
			},
			{
				"question": "What happens if measurement units change?",
				"answer": "The graph should separate or clearly mark the discontinuity because continuity depends on the same measurement unit."
			}
		]
	},
	{
		"toolType": "multipleStimulusWithoutReplacementMswoPreferenceAssessment",
		"slug": "multiple-stimulus-without-replacement-mswo-preference-assessment",
		"title": "MSWO Preference Assessment Demo for ABA Practitioners | Qwoach",
		"metaDescription": "Explore an MSWO preference assessment demo: enter items, record selections, remove chosen items, and review a ranked preference hierarchy.",
		"h1": "Multiple Stimulus without Replacement Preference Assessment",
		"intro": "Multiple Stimulus without Replacement Preference Assessment is an ABA direct preference assessment for practitioners. It helps a practitioner present several visible candidate items, record client selections, remove selected items, and produce a ranked preference hierarchy for likely reinforcer candidates.",
		"demoTitle": "Start a sample MSWO session with fictional items.",
		"demoPrompt": "Interested in using Multiple Stimulus without Replacement (MSWO) Preference Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0753-f-040-aba-011-r001-multiple-stimulus-without-replacement-mswo-preference-assessment.md",
		"specId": "0753-f-040-aba-011-r001-multiple-stimulus-without-replacement-mswo-preference-assessment",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Fits",
				"body": "MSWO fits when the client can scan several visible items and choose from an array, and the practitioner wants a time-efficient direct preference assessment."
			},
			{
				"title": "Result Boundary",
				"body": "The hierarchy identifies observed preference patterns and likely reinforcer candidates. It does not prove reinforcement effects."
			}
		],
		"faqItems": [
			{
				"question": "Does the selected item stay in the array?",
				"answer": "No. In MSWO, the selected item is removed from the remaining rounds in that session."
			},
			{
				"question": "Is there a client-facing digital form?",
				"answer": "No. The client participates in the live item-choice interaction while the practitioner records choices."
			},
			{
				"question": "Can a stopped session still be reviewed?",
				"answer": "Yes. A stopped session remains partial direct-choice evidence with the stopping point clearly marked."
			}
		]
	},
	{
		"toolType": "pairedStimulusPreferenceAssessment",
		"slug": "paired-stimulus-preference-assessment",
		"title": "Paired Stimulus Preference Assessment Demo | Qwoach",
		"metaDescription": "Explore paired stimulus assessment: generate item pairs, record two-option choices, track pair completion, and review selection percentages.",
		"h1": "Paired Stimulus Preference Assessment for ABA",
		"intro": "Paired Stimulus Preference Assessment is an ABA direct preference assessment for practitioners. It helps a practitioner present two candidate stimuli per trial, record client choices across all pairwise comparisons, and review relative preference strength from selection counts or percentages.",
		"demoTitle": "Generate sample pairs and record demo choices.",
		"demoPrompt": "Interested in using Paired Stimulus Preference Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0754-f-040-aba-011-r002-paired-stimulus-preference-assessment.md",
		"specId": "0754-f-040-aba-011-r002-paired-stimulus-preference-assessment",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Fits",
				"body": "Use this assessment when a client can make two-option choices and a detailed comparison across candidate stimuli is needed."
			},
			{
				"title": "Partial Results",
				"body": "Incomplete assessments show completed and missing pairs rather than forcing a full hierarchy."
			}
		],
		"faqItems": [
			{
				"question": "Does every item need to be paired with every other item?",
				"answer": "Yes. The paired stimulus mechanic depends on comparing each candidate stimulus with every other relevant stimulus."
			},
			{
				"question": "Does the tool prove an item is an effective reinforcer?",
				"answer": "No. It identifies preference strength from choices and likely reinforcer candidates for practitioner consideration."
			},
			{
				"question": "Can side bias be reviewed?",
				"answer": "Yes. When side/location tracking is enabled, the result may expose possible side or position patterns without making unsupported conclusions."
			}
		]
	},
	{
		"toolType": "freeOperantObservation",
		"slug": "free-operant-observation",
		"title": "Free Operant Observation Demo for ABA Practitioners | Qwoach",
		"metaDescription": "Explore Free Operant Observation: set accessible items, record engagement duration or frequency, and review high- and low-engagement options.",
		"h1": "Free Operant Observation for Preference Assessment",
		"intro": "Free Operant Observation is an ABA direct preference assessment for practitioners. It helps a practitioner arrange multiple accessible items or activities, record approach and engagement duration or frequency with minimal intrusion, and identify preliminary reinforcer candidates from observed engagement.",
		"demoTitle": "Set up a sample observation and record engagement.",
		"demoPrompt": "Interested in using Free Operant Observation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0755-f-040-aba-011-r003-free-operant-observation.md",
		"specId": "0755-f-040-aba-011-r003-free-operant-observation",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Fits",
				"body": "This assessment fits when the client can access multiple items or activities and the practitioner wants minimally intrusive preference information."
			},
			{
				"title": "What It Captures",
				"body": "It captures observed approach, engagement duration, engagement frequency, non-engagement, actual observation interval, and exposure differences when relevant."
			}
		],
		"faqItems": [
			{
				"question": "Is this a forced-choice assessment?",
				"answer": "No. Free Operant Observation records natural engagement across concurrently available options."
			},
			{
				"question": "Can an interrupted observation be saved?",
				"answer": "Yes. An interrupted observation is marked partial and shows the actual observed interval."
			},
			{
				"question": "Does high engagement prove an item is a reinforcer?",
				"answer": "No. High engagement identifies a preliminary candidate for practitioner consideration or further assessment."
			}
		]
	},
	{
		"toolType": "vbMappVerbalBehaviorMilestonesAssessmentAndPlacementProgram",
		"slug": "vb-mapp-verbal-behavior-milestones-assessment-and-placement-program",
		"title": "VB-MAPP Demo for Practitioners | Qwoach",
		"metaDescription": "Explore a VB-MAPP workflow for supported component scoring, completion tracking, learner profile review, and progress comparison over time.",
		"h1": "VB-MAPP Component Scoring and Profile Review",
		"intro": "VB-MAPP is a criterion-referenced ABA and verbal-behavior assessment program for practitioners. It helps BCBAs, therapists, educators, and related practitioners organize supported scores for verbal-behavior milestones, learning barriers, transition-related skills, task-analysis items, and scoring grids so they can review learner profiles and compare assessment occasions over time.",
		"demoTitle": "Explore a sample component profile without real learner data.",
		"demoPrompt": "Interested in using VB-MAPP (Verbal Behavior Milestones Assessment and Placement Program) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0756-f-040-aba-012-r001-vb-mapp-verbal-behavior-milestones-assessment-and-placement-program.md",
		"specId": "0756-f-040-aba-012-r001-vb-mapp-verbal-behavior-milestones-assessment-and-placement-program",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Autism",
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Content Boundary",
				"body": "The workflow supports recording and organizing supplied or practitioner-entered scores. It does not invent VB-MAPP prompts, scoring anchors, grids, instructional goals, or placement decisions."
			},
			{
				"title": "Partial Profiles",
				"body": "Partial assessments show completed and incomplete components so practitioners can review progress without implying full assessment coverage."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include exact VB-MAPP items?",
				"answer": "No. Exact item prompts, scoring anchors, grids, and domain structures appear only if supplied by approved source materials."
			},
			{
				"question": "Is there a learner-facing digital experience?",
				"answer": "No. The learner participates through direct assessment or observation conducted by the practitioner."
			},
			{
				"question": "Can profiles be compared over time?",
				"answer": "Yes. Date-stamped assessment occasions can be organized for longitudinal comparison where supported scores are available."
			}
		]
	},
	{
		"toolType": "abllsRAssessmentOfBasicLanguageAndLearningSkillsRevised",
		"slug": "ablls-r-assessment-of-basic-language-and-learning-skills-revised",
		"title": "ABLLS-R Demo for Practitioners | Qwoach",
		"metaDescription": "Explore an ABLLS-R workflow for supported skill-area scoring, tracking-grid review, partial assessment status, and progress comparison.",
		"h1": "ABLLS-R Skill Scoring and Tracking Review",
		"intro": "ABLLS-R is a criterion-referenced language, learning, and developmental skills assessment workflow for practitioners. It helps behavior analysts, clinicians, educators, and school teams organize supported practitioner-entered scores across skill areas, review mastered, emerging, and missing skills, and compare progress across assessment periods.",
		"demoTitle": "Explore a sample skill-area profile.",
		"demoPrompt": "Interested in using ABLLS-R (Assessment of Basic Language and Learning Skills-Revised) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0757-f-040-aba-012-r002-ablls-r-assessment-of-basic-language-and-learning-skills-revised.md",
		"specId": "0757-f-040-aba-012-r002-ablls-r-assessment-of-basic-language-and-learning-skills-revised",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Autism",
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Content Boundary",
				"body": "The workflow supports supplied or practitioner-entered score organization. It does not invent ABLLS-R items, scoring definitions, tracking grids, objectives, or instructional recommendations."
			},
			{
				"title": "Progress Review",
				"body": "Historical assessment periods remain date-stamped so progress monitoring remains tied to the period and supported score structure used."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include exact ABLLS-R task items?",
				"answer": "No. Exact task items, prompts, scoring anchors, and grid structures appear only if supplied by source materials."
			},
			{
				"question": "Can partial assessments be reviewed?",
				"answer": "Yes. Partial assessments show which skill areas and items have been scored and which remain incomplete."
			},
			{
				"question": "Does the tool write IEP objectives automatically?",
				"answer": "No. It organizes supported scores and profiles; objective writing remains practitioner-controlled unless exact supported content is provided."
			}
		]
	},
	{
		"toolType": "aflsAssessmentOfFunctionalLivingSkills",
		"slug": "afls-assessment-of-functional-living-skills",
		"title": "AFLS Demo for Practitioners | Qwoach",
		"metaDescription": "Explore an AFLS workflow for protocol-domain selection, supported score capture, tracking-grid review, priority targets, and progress comparison.",
		"h1": "AFLS Functional Living Skills Profile Review",
		"intro": "AFLS is a criterion-referenced functional living skills assessment workflow for practitioners. It helps clinicians, BCBAs, educators, caregivers working with practitioners, and developmental-disability service providers organize supported protocol-domain scores, review functional living-skill profiles, mark practitioner-selected priority targets, and monitor progress over time.",
		"demoTitle": "Explore a sample functional skills profile.",
		"demoPrompt": "Interested in using AFLS (Assessment of Functional Living Skills) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0758-f-040-aba-012-r003-afls-assessment-of-functional-living-skills.md",
		"specId": "0758-f-040-aba-012-r003-afls-assessment-of-functional-living-skills",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Autism",
				"Behavior analysis",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Domain Coverage",
				"body": "The workflow shows which life-skill domains are included and which are incomplete so the practitioner can judge whether the profile fits the learner’s real contexts."
			},
			{
				"title": "Content Boundary",
				"body": "The workflow does not invent AFLS protocol items, scoring rules, task analyses, teaching steps, or recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the system choose priority targets automatically?",
				"answer": "No. Priority targets are practitioner-selected or source-supported; the system does not infer them unsupported."
			},
			{
				"question": "Can caregiver or team information be included?",
				"answer": "Yes. Practitioner-requested ratings or context information may inform scoring, but the practitioner controls interpretation."
			},
			{
				"question": "What happens if only some domains are assessed?",
				"answer": "The profile is marked partial and shows included domains and missing protocol areas."
			}
		]
	},
	{
		"toolType": "taskAnalysis",
		"slug": "task-analysis",
		"title": "Task Analysis Demo for ABA Practitioners | Qwoach",
		"metaDescription": "Explore Task Analysis for ABA: define a target skill, add observable ordered steps, reorder the sequence, and review an implementer-ready view.",
		"h1": "Task Analysis for ABA Skill Sequencing",
		"intro": "Task Analysis is an ABA instructional planning and measurement tool for practitioners. It helps an ABA practitioner represent a complex skill as observable, teachable component steps in the order needed for consistent chaining instruction and step-by-step measurement.",
		"demoTitle": "Create a sample task analysis.",
		"demoPrompt": "Interested in using Task Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0759-f-040-aba-013-r001-task-analysis.md",
		"specId": "0759-f-040-aba-013-r001-task-analysis",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures the target skill, relevant context, and ordered practitioner-authored component steps."
			},
			{
				"title": "What It Does Not Add",
				"body": "It does not invent steps, prompting procedures, reinforcement procedures, mastery criteria, or progress data."
			}
		],
		"faqItems": [
			{
				"question": "Can the system generate the task steps?",
				"answer": "No. The practitioner authors the substantive steps; the system can number, reorder, and flag empty sequence elements."
			},
			{
				"question": "Is there a learner-facing view?",
				"answer": "No. The tool is practitioner-only, though implementers may use the resulting sequence during instruction."
			},
			{
				"question": "What if the sequence changes after data collection begins?",
				"answer": "Prior data should remain tied to the sequence used at that time because sequence changes affect comparability."
			}
		]
	},
	{
		"toolType": "skillAcquisitionPlan",
		"slug": "skill-acquisition-plan",
		"title": "Skill Acquisition Plan Demo for ABA Practitioners | Qwoach",
		"metaDescription": "Explore an ABA Skill Acquisition Plan: define target skill, teaching conditions, prompting, reinforcement, correction, data rules, and mastery criteria.",
		"h1": "Skill Acquisition Plan for ABA Instruction",
		"intro": "Skill Acquisition Plan is an ABA instructional protocol tool for practitioners. It helps an ABA practitioner define a new target skill, teaching conditions, prompting and reinforcement procedures, correction procedures, data rules, and mastery expectations so the instructional team can teach consistently and evaluate acquisition.",
		"demoTitle": "Draft a sample plan and review readiness.",
		"demoPrompt": "Interested in using Skill Acquisition Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0760-f-040-aba-014-r001-skill-acquisition-plan.md",
		"specId": "0760-f-040-aba-014-r001-skill-acquisition-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Behavior change",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Required Components",
				"body": "The plan includes target skill, learner/context, teaching conditions, prompting, reinforcement, correction, data rules, mastery criteria, and data-decision criteria."
			},
			{
				"title": "Readiness Boundary",
				"body": "The system may flag missing sections and present the protocol clearly. It does not choose procedures or judge clinical appropriateness."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write ABA procedures for me?",
				"answer": "No. Procedures, data rules, and mastery criteria are practitioner-authored."
			},
			{
				"question": "Can a plan be saved while incomplete?",
				"answer": "Yes. Incomplete plans save as drafts with missing required components visible."
			},
			{
				"question": "What happens if the plan changes after teaching starts?",
				"answer": "Material changes should be distinguishable so later data can be interpreted against the correct procedure."
			}
		]
	},
	{
		"toolType": "tokenEconomyBoard",
		"slug": "token-economy-board",
		"title": "Token Economy Board Demo for ABA Reinforcement Tracking | Qwoach",
		"metaDescription": "Demo a token economy board for ABA practitioners to define a target behavior, show learner token progress, and optionally track response data.",
		"h1": "Token Economy Board for Visible Reinforcement Progress",
		"intro": "Token Economy Board is a behavior-support reinforcement tool for ABA practitioners and intervention teams. It helps practitioners define one target behavior, show the learner current progress toward a backup reinforcer, and optionally track response and reinforcement information tied to the contingency.",
		"demoTitle": "Configure a sample token board, switch to learner view, then review the tracked sample events before saving the tool.",
		"demoPrompt": "Interested in using Token Economy Board with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0761-f-040-aba-015-r001-token-economy-board.md",
		"specId": "0761-f-040-aba-015-r001-token-economy-board",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Behavior analysis",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool during token-based reinforcement when the learner needs a clear display of earned and remaining tokens and the practitioner needs the contingency visible during use."
			},
			{
				"title": "What It Tracks",
				"body": "When tracking is enabled, the tool records descriptive reinforcement delivery and response information tied to the target behavior. When tracking is disabled, the board still functions as a visible contingency tool."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not infer motivation, diagnose behavior, identify behavioral function, or conclude that behavior has strengthened."
			}
		],
		"faqItems": [
			{
				"question": "Does the learner complete anything?",
				"answer": "No. The learner-facing view shows progress, the token goal, remaining tokens, and backup reinforcer; the practitioner controls setup and records."
			},
			{
				"question": "Can I use it without tracking response data?",
				"answer": "Yes. Tracking can be disabled, and the board remains a visible token contingency with earned and remaining tokens."
			},
			{
				"question": "What happens when the learner reaches the token requirement?",
				"answer": "The board indicates that exchange is due or completed, and the practitioner can mark exchange."
			},
			{
				"question": "Does the tool decide whether the contingency is effective?",
				"answer": "No. It shows descriptive token, response, and reinforcement information for practitioner interpretation."
			}
		]
	},
	{
		"toolType": "contingencyContract",
		"slug": "contingency-contract",
		"title": "Contingency Contract Demo for ABA Practitioners | Qwoach",
		"metaDescription": "Create a sample contingency contract with target behavior, success criterion, consequence or reinforcer, and party responsibilities.",
		"h1": "Contingency Contract for Clear Behavior-Change Agreements",
		"intro": "Contingency Contract is a behavior-change agreement tool for ABA practitioners and intervention teams. It helps practitioners create a shared agreement with a learner and relevant adults about the target behavior, success criterion, linked consequence or reinforcer, and each person’s responsibilities.",
		"demoTitle": "Build a fictional contract draft, preview the shared agreement, and review what must be complete before saving.",
		"demoPrompt": "Interested in using Contingency Contract with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0762-f-040-aba-016-r001-contingency-contract.md",
		"specId": "0762-f-040-aba-016-r001-contingency-contract",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when a learner and relevant adults need a shared, explicit contingency for a specific behavior-change goal."
			},
			{
				"title": "What Must Be Clear",
				"body": "A usable contract links an observable behavior, a specific success criterion, a consequence or reinforcer, and each responsible party’s role."
			},
			{
				"title": "Limitations",
				"body": "The tool does not add legal-style clauses, score motivation, or decide whether a contract is clinically appropriate."
			}
		],
		"faqItems": [
			{
				"question": "Is this a questionnaire?",
				"answer": "No. It is a structured contingency agreement, not a questionnaire or broad behavior plan."
			},
			{
				"question": "What makes the contract usable?",
				"answer": "A usable contract includes the target behavior, performance criterion, consequence or reinforcer, and responsible parties."
			},
			{
				"question": "Can participants acknowledge the agreement?",
				"answer": "Yes. The shared view can show participant acknowledgement or confirmation of roles when completed together."
			},
			{
				"question": "Does the tool explain why a learner meets or misses the criterion?",
				"answer": "No. It can record descriptive follow-through status, but it does not infer causes or motivation."
			}
		]
	},
	{
		"toolType": "selfManagementDataSheet",
		"slug": "self-management-data-sheet",
		"title": "Self-Management Data Sheet Demo for ABA Practitioners | Qwoach",
		"metaDescription": "Demo a self-management data sheet for client-recorded target behavior entries across real-life occasions, with chronological review and trends.",
		"h1": "Self-Management Data Sheet for Client-Generated Behavior Data",
		"intro": "Self-Management Data Sheet is a client-generated behavior data tool for ABA practitioners and behavior support teams. It helps practitioners define one target behavior, send a repeated-entry sheet to the client, and review behavior information across occasions or settings they cannot directly observe.",
		"demoTitle": "Configure a sample sheet, preview client entry, add fictional entries, and review the chronological pattern before saving.",
		"demoPrompt": "Interested in using Self-Management Data Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0763-f-040-aba-017-r001-self-management-data-sheet.md",
		"specId": "0763-f-040-aba-017-r001-self-management-data-sheet",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Behavior change",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when the practitioner needs behavior information from real-life contexts that are not directly observed."
			},
			{
				"title": "What It Captures",
				"body": "The sheet captures repeated client entries tied to the target behavior, timing, and relevant occasion or context."
			},
			{
				"title": "Review Limits",
				"body": "The tool does not infer causes, fill missed entries, or claim a trend when entries are too few or inconsistent."
			}
		],
		"faqItems": [
			{
				"question": "Does the client complete this tool?",
				"answer": "Yes. The client completes repeated entries, while the practitioner configures the target behavior and reviews the data."
			},
			{
				"question": "Can it show trends?",
				"answer": "Yes, when enough comparable entries exist. Sparse or inconsistent entries are labeled as limited rather than treated as a stable trend."
			},
			{
				"question": "What if the client misses entries?",
				"answer": "Missed entries remain visible as gaps; the tool does not invent missing values."
			},
			{
				"question": "Does it include mood logs or symptom ratings?",
				"answer": "No. It is limited to target behavior data for self-management evaluation unless the practitioner’s supported entry structure defines a behavior measure."
			}
		]
	},
	{
		"toolType": "fbaReferralProblemIdentificationForm",
		"slug": "fba-referral-problem-identification-form",
		"title": "FBA Referral Form Demo for Problem Identification | Qwoach",
		"metaDescription": "Demo a practitioner-only FBA referral form that clarifies a behavior concern, rationale, and prioritized target for functional assessment.",
		"h1": "FBA Referral and Problem Identification Form",
		"intro": "FBA Referral / Problem Identification Form is a practitioner-only intake and prioritization tool for functional behavior assessment. It helps practitioners describe a challenging behavior concern, document why it warrants assessment, and select a target narrow enough to guide the next FBA steps.",
		"demoTitle": "Complete a fictional referral draft and review whether the target and rationale are sufficient before saving the form.",
		"demoPrompt": "Interested in using FBA Referral / Problem Identification Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0764-f-041-fba-001-r001-fba-referral-problem-identification-form.md",
		"specId": "0764-f-041-fba-001-r001-fba-referral-problem-identification-form",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this form at the beginning of FBA work when a concern must be prioritized before definition and data collection."
			},
			{
				"title": "What It Produces",
				"body": "The result is a prioritized behavior focus and rationale for assessment, not a functional hypothesis or intervention plan."
			},
			{
				"title": "Readiness Limits",
				"body": "A broad concern, missing rationale, or multiple unprioritized concerns keeps the form in draft or revision status."
			}
		],
		"faqItems": [
			{
				"question": "Is this a full FBA?",
				"answer": "No. It is an intake and prioritization form that identifies the FBA focus and rationale."
			},
			{
				"question": "Does a client or caregiver complete this?",
				"answer": "No. The specified configuration is practitioner-only."
			},
			{
				"question": "What information is required?",
				"answer": "The form requires a behavior concern, rationale for assessment significance, and a selected target behavior."
			},
			{
				"question": "Does it generate a behavior function?",
				"answer": "No. It does not generate functional hypotheses, ABC data, or intervention recommendations."
			}
		]
	},
	{
		"toolType": "operationalDefinitionForm",
		"slug": "operational-definition-form",
		"title": "Operational Definition Form Demo for FBA Workflows | Qwoach",
		"metaDescription": "Demo a practitioner-only form for defining target behavior with observable wording, onset, offset, examples, and non-examples.",
		"h1": "Operational Definition Form for Observable Behavior Definitions",
		"intro": "Operational Definition Form is a practitioner-only behavior definition tool for FBA and behavior support workflows. It helps practitioners define a selected target behavior in observable, measurable terms, including onset, offset, examples, and non-examples so observers and implementers can identify the same behavior.",
		"demoTitle": "Draft a sample definition, check its boundaries, and review the observer-ready result before saving the form.",
		"demoPrompt": "Interested in using Operational Definition Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0765-f-041-fba-002-r001-operational-definition-form.md",
		"specId": "0765-f-041-fba-002-r001-operational-definition-form",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this form before reliable observation, data collection, interviews, or intervention planning that depends on a shared behavior definition."
			},
			{
				"title": "What It Clarifies",
				"body": "The form clarifies observable description, onset, offset, examples, and non-examples so common edge cases are less ambiguous."
			},
			{
				"title": "What It Does Not Do",
				"body": "The form does not infer function, cause, severity, diagnosis, or intervention steps."
			}
		],
		"faqItems": [
			{
				"question": "Is this tool for clients to complete?",
				"answer": "No. The specified configuration is practitioner-only."
			},
			{
				"question": "What makes a definition ready?",
				"answer": "A ready definition describes what can be seen or heard, includes onset and offset, and uses examples and non-examples to clarify boundaries."
			},
			{
				"question": "Can the tool flag vague wording?",
				"answer": "Yes. It can surface ambiguity or inferred-intent wording for practitioner revision."
			},
			{
				"question": "Does it recommend an intervention?",
				"answer": "No. It produces the behavior definition needed before observation or support design."
			}
		]
	},
	{
		"toolType": "indirectFbaInterview",
		"slug": "indirect-fba-interview",
		"title": "Indirect FBA Interview Demo for Practitioners | Qwoach",
		"metaDescription": "Demo a practitioner-guided indirect FBA interview that organizes informant observations into context and preliminary hypotheses.",
		"h1": "Indirect FBA Interview for Informant Context and Preliminary Hypotheses",
		"intro": "Indirect FBA Interview is a practitioner-guided informant interview tool for functional behavior assessment. It helps practitioners gather contextual knowledge from people who have observed a target behavior and organize descriptions into antecedents, setting conditions, consequences, and plausible functions to test or verify.",
		"demoTitle": "Run through a fictional interview structure, add sample informant notes, and review the organized hypothesis summary before saving.",
		"demoPrompt": "Interested in using Indirect FBA Interview with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0766-f-041-fba-003-r001-indirect-fba-interview.md",
		"specId": "0766-f-041-fba-003-r001-indirect-fba-interview",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this interview when informant observations can help shape direct observation and further FBA activities."
			},
			{
				"title": "What It Organizes",
				"body": "The tool organizes behavior descriptions, contexts, antecedents, setting conditions, consequences, and plausible functions to test."
			},
			{
				"title": "Important Limits",
				"body": "Indirect information remains preliminary. The tool does not confirm behavioral function, prescribe intervention, or supply standardized prompt wording."
			}
		],
		"faqItems": [
			{
				"question": "Who answers the interview questions?",
				"answer": "An informant who has observed the behavior contributes responses while the practitioner guides and controls the interview record."
			},
			{
				"question": "Does the tool confirm the behavior function?",
				"answer": "No. It organizes reports into preliminary hypotheses that need testing or verification through further data collection."
			},
			{
				"question": "Can conflicting informant reports be entered?",
				"answer": "Yes. Conflicting reports should be preserved side by side rather than resolved by the system."
			},
			{
				"question": "Are exact interview prompts included?",
				"answer": "No. The product supports section structure; exact prompt wording is unresolved unless supplied by practitioner protocol or future validated content design."
			}
		]
	},
	{
		"toolType": "abcDataSheet",
		"slug": "abc-data-sheet",
		"title": "ABC Data Sheet Demo for FBA Observation | Qwoach",
		"metaDescription": "Demo an ABC Data Sheet for recording antecedent, behavior, and consequence episodes during direct observation and reviewing patterns.",
		"h1": "ABC Data Sheet for Event-Level Functional Behavior Data",
		"intro": "ABC Data Sheet is a direct-observation functional behavior assessment tool for practitioners and observers. It helps teams record naturally occurring episodes as antecedent, behavior, and consequence sequences so practitioners can review event-level data and recurring observed patterns.",
		"demoTitle": "Set a fictional observation context, add sample ABC episodes, and review descriptive patterns before saving.",
		"demoPrompt": "Interested in using ABC Data Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0767-f-041-fba-004-r001-abc-data-sheet.md",
		"specId": "0767-f-041-fba-004-r001-abc-data-sheet",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool during direct observation when the practitioner needs event-level information about what precedes and follows the target behavior."
			},
			{
				"title": "Observer Role",
				"body": "Observers record the antecedent, behavior, and consequence for each episode. The practitioner reviews and interprets the data."
			},
			{
				"title": "Limitations",
				"body": "The tool does not confirm function, produce intervention plans, or replace practitioner interpretation."
			}
		],
		"faqItems": [
			{
				"question": "What must be included in a complete episode?",
				"answer": "A complete ABC episode includes what happened before, the behavior observed, and what happened after."
			},
			{
				"question": "Can observers use this during live observation?",
				"answer": "Yes. The observer view supports rapid event entry during or shortly after naturally occurring episodes."
			},
			{
				"question": "Does the tool decide the function of behavior?",
				"answer": "No. It organizes observed evidence and descriptive patterns for practitioner interpretation."
			},
			{
				"question": "What happens if an episode is incomplete?",
				"answer": "Incomplete episodes remain drafts or are flagged so the practitioner can review them without treating them as complete ABC records."
			}
		]
	},
	{
		"toolType": "scatterplot",
		"slug": "scatterplot",
		"title": "Behavior Scatterplot Demo for FBA and Support Planning | Qwoach",
		"metaDescription": "Demo a behavior scatterplot that maps target behavior occurrences by time, activity, or routine and shows temporal heatmap patterns.",
		"h1": "Scatterplot for Temporal Behavior Patterns",
		"intro": "Scatterplot is a temporal behavior-pattern tool for practitioners using FBA or behavior support planning. It helps practitioners define a target behavior, map occurrences into time blocks, activities, or routines, and review a heatmap showing higher- and lower-occurrence periods.",
		"demoTitle": "Configure a sample grid, mark fictional occurrences, and review the temporal heatmap before saving.",
		"demoPrompt": "Interested in using Scatterplot with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0768-f-041-fba-005-r001-scatterplot.md",
		"specId": "0768-f-041-fba-005-r001-scatterplot",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Graph"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when the key question is when a target behavior is more or less likely across time, activity, or routine."
			},
			{
				"title": "What It Shows",
				"body": "The heatmap shows cell totals or intensity, observation coverage, and descriptive clusters based on recorded data."
			},
			{
				"title": "Limits",
				"body": "The tool does not collect ABC sequences, confirm function, recommend intervention, or treat blank and unobserved cells as the same when coverage information is available."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as ABC recording?",
				"answer": "No. Scatterplot focuses on temporal patterns, not full antecedent-behavior-consequence chains."
			},
			{
				"question": "Can observers mark occurrences?",
				"answer": "Yes. Observers can mark occurrences or counts in configured time, activity, or routine cells."
			},
			{
				"question": "Does a blank cell mean no behavior occurred?",
				"answer": "Not always. Blank cells should distinguish no occurrence from no observation when that information is available."
			},
			{
				"question": "Does the heatmap explain the cause of behavior?",
				"answer": "No. It shows temporal clustering descriptively and leaves interpretation to the practitioner."
			}
		]
	},
	{
		"toolType": "eventSamplingForm",
		"slug": "event-sampling-form",
		"title": "Event Sampling Form Demo for FBA Observation | Qwoach",
		"metaDescription": "Demo an event sampling form for recording naturally occurring behavior events by context or condition and reviewing descriptive patterns.",
		"h1": "Event Sampling Form for Behavior Event Patterns",
		"intro": "Event Sampling Form is a structured direct-observation tool for practitioners and observers. It helps practitioners define a target behavior, collect naturally occurring event records tied to observation contexts or conditions, and review descriptive patterns that can guide FBA hypotheses or support decisions.",
		"demoTitle": "Configure a sample event structure, enter fictional events, and review grouped patterns before saving.",
		"demoPrompt": "Interested in using Event Sampling Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0769-f-041-fba-006-r001-event-sampling-form.md",
		"specId": "0769-f-041-fba-006-r001-event-sampling-form",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "How It Differs From ABC Recording",
				"body": "Event sampling captures structured event-pattern information broadly and does not require every entry to include a full antecedent-behavior-consequence chain."
			},
			{
				"title": "What It Requires",
				"body": "Each complete event must be tied to the relevant observation context or condition so patterns can be compared."
			},
			{
				"title": "Limits",
				"body": "The tool does not impose unsupported fields, merge incompatible event structures, infer function, or recommend interventions."
			}
		],
		"faqItems": [
			{
				"question": "Does every event need a context or condition?",
				"answer": "Yes. Complete events must be tied to a context or condition so patterns can be compared."
			},
			{
				"question": "Are the event fields fixed?",
				"answer": "No. Exact fields are unresolved and should be supplied by the practitioner’s event sampling structure."
			},
			{
				"question": "Is this an ABC data sheet?",
				"answer": "No. It focuses on event-pattern information and does not require a full ABC chain for every entry."
			},
			{
				"question": "Does it identify the function of behavior?",
				"answer": "No. It provides descriptive event patterns for practitioner interpretation."
			}
		]
	},
	{
		"toolType": "frequencyEventRecordingForm",
		"slug": "frequency-event-recording-form",
		"title": "Frequency/Event Recording Form Demo for Direct Observation | Qwoach",
		"metaDescription": "Demo a frequency/event recording form for tallying discrete target behavior, capturing observation time, and calculating count or rate.",
		"h1": "Frequency/Event Recording Form for Behavior Counts and Rates",
		"intro": "Frequency/Event Recording Form is a direct-observation data sheet for FBA and behavior-monitoring teams. It helps practitioners define a discrete target behavior, capture live occurrence counts during an observation period, and review total frequency and rate when observation time is available.",
		"demoTitle": "Set a sample observation period, use the live tally, and review total and rate before saving.",
		"demoPrompt": "Interested in using Frequency/Event Recording Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0770-f-041-fba-007-r001-frequency-event-recording-form.md",
		"specId": "0770-f-041-fba-007-r001-frequency-event-recording-form",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this form for discrete target behaviors that can be counted consistently during a defined observation period."
			},
			{
				"title": "Frequency Versus Rate",
				"body": "Frequency is the total count. Rate is calculated only when observation time is available and should be reviewed with duration visible."
			},
			{
				"title": "Comparison Limits",
				"body": "Counts from different durations should not be compared without rate or duration context, and definition changes should remain visible in historical comparisons."
			}
		],
		"faqItems": [
			{
				"question": "When can the form calculate rate?",
				"answer": "Rate can be calculated only when observation time or duration is available."
			},
			{
				"question": "Can this be used for duration recording?",
				"answer": "No. This tool is for frequency/event counts and rate when duration is available; duration recording is outside its scope."
			},
			{
				"question": "What if the observation is interrupted?",
				"answer": "The result should be marked partial with the actual observed duration and count status preserved."
			},
			{
				"question": "Does the tool interpret intervention effectiveness?",
				"answer": "No. It can show descriptive increase, decrease, or stability across comparable observations, but it does not make causal conclusions."
			}
		]
	},
	{
		"toolType": "durationRecordingForm",
		"slug": "duration-recording-form",
		"title": "Duration Recording Form for FBA Timing Data | Qwoach",
		"metaDescription": "Record start and end times for target-behavior episodes, calculate duration, and review total or average time across FBA observations.",
		"h1": "Duration Recording Form",
		"intro": "Duration Recording Form is a direct-observation FBA and behavior-monitoring timing form for practitioners and classroom observers. It helps the behavior-monitoring team record start and end times for a defined target behavior, calculate episode durations, and summarize total time during a defined observation period.",
		"demoTitle": "Try a sample observation, record example episodes, and review the calculated duration summary.",
		"demoPrompt": "Interested in using Duration Recording Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0771-f-041-fba-007-r002-duration-recording-form.md",
		"specId": "0771-f-041-fba-007-r002-duration-recording-form",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when behavior episodes vary in length or when duration is more useful than frequency alone for baseline, monitoring, or review."
			},
			{
				"title": "What It Captures",
				"body": "The form captures observation setup, episode start times, episode end times, calculated durations, and completion or partial status."
			},
			{
				"title": "Limits",
				"body": "The tool calculates and summarizes duration. It does not infer behavior function, explain cause, recommend interventions, or replace practitioner interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does the student or client complete this form?",
				"answer": "No. The observed student or client does not enter information; the practitioner or observer records timing data during observation."
			},
			{
				"question": "Can I use manual times instead of a live timer?",
				"answer": "Yes. The product supports manual clock entry and timer-style capture because the timing record is based on start and end times."
			},
			{
				"question": "What happens if an episode has no end time?",
				"answer": "An incomplete episode is not included in finalized totals until the missing time is resolved."
			},
			{
				"question": "Does the result say whether an intervention worked?",
				"answer": "No. The result shows descriptive duration change over comparable observations; practitioner interpretation of intervention impact remains separate."
			}
		]
	},
	{
		"toolType": "replacementBehaviorDataForm",
		"slug": "replacement-behavior-data-form",
		"title": "Replacement Behavior Data Form for Progress Monitoring | Qwoach",
		"metaDescription": "Track whether a defined replacement behavior is emerging across contexts, intervention phases, and practitioner-defined progress evidence.",
		"h1": "Replacement Behavior Data Form",
		"intro": "Replacement Behavior Data Form is an FBA and intervention progress-monitoring form for practitioners and behavior-support teams. It helps them define an adaptive alternative to a challenging behavior, record progress evidence in relevant contexts, and review whether the replacement behavior is becoming more frequent, independent, or functional relative to the intervention goal.",
		"demoTitle": "Set up a sample replacement behavior and review example progress entries.",
		"demoPrompt": "Interested in using Replacement Behavior Data Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0772-f-041-fba-008-r001-replacement-behavior-data-form.md",
		"specId": "0772-f-041-fba-008-r001-replacement-behavior-data-form",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Problem behavior",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Tracks",
				"body": "The form tracks adaptive replacement behavior progress, not the challenging behavior itself."
			},
			{
				"title": "Comparison Requirements",
				"body": "Progress comparisons require stable behavior definitions, contexts, and evidence types. Sparse or inconsistent data should be shown as insufficient rather than as a confident trend."
			},
			{
				"title": "Limits",
				"body": "The tool does not determine behavior function, invent goals, provide intervention strategies, or hard-code unsupported scales."
			}
		],
		"faqItems": [
			{
				"question": "Can the form track occurrence, quality, or independence?",
				"answer": "Yes, when that evidence type is defined by the practitioner or support plan. The product does not invent the exact scale or criteria."
			},
			{
				"question": "Is this a challenging-behavior frequency form?",
				"answer": "No. This form tracks the adaptive replacement behavior intended to compete with the challenging behavior."
			},
			{
				"question": "What if the replacement behavior is not defined clearly?",
				"answer": "The entry should be blocked or marked unresolved because unclear definitions make progress data unreliable."
			},
			{
				"question": "Can progress be compared across phases?",
				"answer": "Yes, when the replacement behavior definition and evidence type remain stable across comparable intervention phases."
			}
		]
	},
	{
		"toolType": "settingEventsAntecedentAnalysis",
		"slug": "setting-events-antecedent-analysis",
		"title": "FBA Setting Events and Antecedent Analysis | Qwoach",
		"metaDescription": "Map pre-behavior conditions, distinguish setting events from immediate antecedents, and identify candidate predictors linked to behavior episodes.",
		"h1": "Setting Events / Antecedent Analysis",
		"intro": "Setting Events / Antecedent Analysis is a practitioner-only FBA configuration for practitioners and FBA team members. It helps them distinguish broader setting events from immediate antecedents, connect those conditions to observed or reported behavior episodes, and confirm candidate predictors for later prevention planning.",
		"demoTitle": "Try a sample two-lane analysis with fictional behavior episodes and pre-behavior conditions.",
		"demoPrompt": "Interested in using Setting Events / Antecedent Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0773-f-041-fba-009-r001-setting-events-antecedent-analysis.md",
		"specId": "0773-f-041-fba-009-r001-setting-events-antecedent-analysis",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner Role",
				"body": "The practitioner controls classification and confirmation of candidate predictors. Informants may contribute reports, but they do not determine function or prevention strategies inside this tool."
			},
			{
				"title": "Evidence Links",
				"body": "Each condition should be tied to an observed or reported episode when possible so the candidate predictor remains connected to its evidence source."
			},
			{
				"title": "Limits",
				"body": "The tool does not analyze consequences, confirm function, make causal claims, or recommend prevention strategies."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool identify the function of the behavior?",
				"answer": "No. It identifies candidate setting-event and antecedent predictors; function synthesis belongs outside this tool."
			},
			{
				"question": "Can I enter conditions without an episode link?",
				"answer": "Yes, but they should be marked as unlinked reports rather than treated as episode-based patterns."
			},
			{
				"question": "Are setting events and antecedents the same thing?",
				"answer": "No. The tool separates broader setting events from immediate antecedents so the practitioner can review them distinctly."
			},
			{
				"question": "Does the tool include a fixed checklist?",
				"answer": "No. Exact prompts and categories are unresolved, so the demo uses generic entry and practitioner classification."
			}
		]
	},
	{
		"toolType": "consequenceAnalysis",
		"slug": "consequence-analysis",
		"title": "FBA Consequence Analysis Tool | Qwoach",
		"metaDescription": "Map what happens after target-behavior episodes, review recurring consequence patterns, and identify candidate maintaining consequences.",
		"h1": "Consequence Analysis",
		"intro": "Consequence Analysis is a practitioner-only FBA configuration for practitioners and FBA team members. It helps them link target-behavior episodes to reported post-behavior events, review recurring consequence patterns, and confirm candidate maintaining consequences when supported by the entered data.",
		"demoTitle": "Map sample post-behavior events to fictional episodes and review candidate consequence patterns.",
		"demoPrompt": "Interested in using Consequence Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0774-f-041-fba-010-r001-consequence-analysis.md",
		"specId": "0774-f-041-fba-010-r001-consequence-analysis",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What Counts Here",
				"body": "The tool focuses on events after the target behavior. Events before behavior belong in antecedent or setting-event analysis."
			},
			{
				"title": "Interpretation Boundary",
				"body": "Maintaining consequence labels are practitioner-confirmed candidate interpretations, not automatic function determinations."
			},
			{
				"title": "Partial Evidence",
				"body": "Sparse, conflicting, or unlinked reports remain visible and should not be presented as confident maintaining-consequence claims."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool automatically identify behavioral function?",
				"answer": "No. It summarizes reported consequences and lets the practitioner confirm candidate maintaining consequences."
			},
			{
				"question": "Can informants use the tool?",
				"answer": "Only to report what happened after observed episodes if that workflow exists; they are not asked to determine function."
			},
			{
				"question": "What happens to events that occurred before the behavior?",
				"answer": "Events before the behavior are out of scope for this tool and should be flagged or moved to antecedent analysis."
			},
			{
				"question": "Can labels like access or escape be used?",
				"answer": "Yes, as practitioner-selected candidate interpretations tied to supporting data, not as automatic conclusions."
			}
		]
	},
	{
		"toolType": "hypothesisStatement",
		"slug": "hypothesis-statement",
		"title": "FBA Hypothesis Statement Builder | Qwoach",
		"metaDescription": "Create a practitioner-authored FBA hypothesis linking target behavior, context, antecedents, consequences, likely function, and evidence.",
		"h1": "Hypothesis Statement",
		"intro": "Hypothesis Statement is a practitioner-only FBA synthesis tool for practitioners and FBA team members. It helps them record a practitioner-authored explanation that names the target behavior and context, connects antecedent and consequence findings, proposes a likely function, and keeps supporting evidence visible.",
		"demoTitle": "Build a sample draft hypothesis and review completeness and evidence alignment.",
		"demoPrompt": "Interested in using Hypothesis Statement with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0775-f-041-fba-011-r001-hypothesis-statement.md",
		"specId": "0775-f-041-fba-011-r001-hypothesis-statement",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner Authorship",
				"body": "The hypothesis is authored by the practitioner. The product can show missing elements and evidence links, but it does not write unsupported function conclusions."
			},
			{
				"title": "Evidence Alignment",
				"body": "Each component can be linked to available assessment data so the team can see what supports the statement."
			},
			{
				"title": "Limits",
				"body": "The tool does not collect the full FBA from scratch, conduct functional analysis, author a BIP, or confirm the hypothesis."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool automatically determine the function?",
				"answer": "No. The practitioner enters the likely function; the tool shows components and evidence alignment."
			},
			{
				"question": "Can I finalize a hypothesis with missing components?",
				"answer": "A missing target behavior prevents a valid statement, and missing antecedent, consequence, or function components should leave the hypothesis incomplete."
			},
			{
				"question": "Does this create an intervention plan?",
				"answer": "No. The natural next step may be intervention selection or BIP development, but this tool only records the hypothesis statement."
			},
			{
				"question": "Can evidence conflicts be shown?",
				"answer": "Yes. Conflicting evidence should remain visible rather than being hidden or resolved automatically."
			}
		]
	},
	{
		"toolType": "functionalAnalysis",
		"slug": "functional-analysis",
		"title": "Functional Analysis for FBA Condition Comparison | Qwoach",
		"metaDescription": "Set up hypothesis-linked test conditions, record session-level behavior data, and review descriptive functional analysis comparisons.",
		"h1": "Functional Analysis",
		"intro": "Functional Analysis is a practitioner-only experimental FBA tool for qualified practitioners. It helps them define a target behavior, organize hypothesis-linked test conditions, record session-level data, document safety constraints, and review descriptive comparisons across conditions when descriptive assessment is not sufficient.",
		"demoTitle": "Set up sample conditions and review a fictional condition-comparison display.",
		"demoPrompt": "Interested in using Functional Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0776-f-041-fba-012-r001-functional-analysis.md",
		"specId": "0776-f-041-fba-012-r001-functional-analysis",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Scope",
				"body": "The tool organizes functional analysis data and review. It does not provide procedural scripts, treatment recommendations, competence verification, or ethics determinations."
			},
			{
				"title": "Partial Data",
				"body": "Insufficient, uneven, or missing condition data should prevent strong differentiation claims and remain visible in review."
			},
			{
				"title": "Practitioner Control",
				"body": "The system shows descriptive comparisons; the qualified practitioner records interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool prescribe functional analysis procedures?",
				"answer": "No. Exact procedures and protocols are unresolved and must be supplied by the qualified practitioner or another supported source."
			},
			{
				"question": "Does the product automatically diagnose function?",
				"answer": "No. It displays descriptive condition comparisons and leaves interpretation to the practitioner."
			},
			{
				"question": "What happens if safety documentation is missing?",
				"answer": "The analysis should be blocked from finalization or marked unresolved when required safety/status documentation is missing."
			},
			{
				"question": "Can supervised data collectors enter session data?",
				"answer": "Yes, if part of the workflow, they may enter condition/session data under practitioner control."
			}
		]
	},
	{
		"toolType": "behaviorInterventionSupportPlanBipBsp",
		"slug": "behavior-intervention-support-plan-bip-bsp",
		"title": "Function-Linked BIP/BSP Planning Tool | Qwoach",
		"metaDescription": "Create a practitioner-authored BIP/BSP with prevention, teaching, reinforcement, response strategies, roles, and progress monitoring.",
		"h1": "Behavior Intervention / Support Plan (BIP/BSP)",
		"intro": "Behavior Intervention / Support Plan (BIP/BSP) is a practitioner-only support-plan product for practitioners and behavior-support teams. It helps them create a function-linked plan that specifies prevention supports, replacement behavior teaching, reinforcement, response strategies, implementer roles, and progress-monitoring expectations.",
		"demoTitle": "Build a sample plan and preview the implementer action view.",
		"demoPrompt": "Interested in using Behavior Intervention / Support Plan (BIP/BSP) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0777-f-041-fba-013-r001-behavior-intervention-support-plan-bip-bsp.md",
		"specId": "0777-f-041-fba-013-r001-behavior-intervention-support-plan-bip-bsp",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Problem behavior",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner and Implementer Roles",
				"body": "The practitioner creates and controls plan content. Implementers see the relevant executable instructions and may enter monitoring data only if the plan specifies it."
			},
			{
				"title": "Readiness Review",
				"body": "Completeness checks help identify missing function link, plan components, role clarity, or monitoring expectations before the plan is implementer-ready."
			},
			{
				"title": "Limits",
				"body": "The tool does not conduct or validate the FBA, automatically select strategies, or infer clinical outcomes."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create the FBA?",
				"answer": "No. It starts from FBA results and organizes the practitioner-authored behavior support plan."
			},
			{
				"question": "Can implementers use it?",
				"answer": "Yes. Implementers can view assigned actions by role or setting and may record monitoring data if the plan requires it."
			},
			{
				"question": "Does the system choose interventions?",
				"answer": "No. Strategies are supplied by the practitioner; the system shows completeness and alignment cues."
			},
			{
				"question": "What makes the plan incomplete?",
				"answer": "A missing function link, missing before/during/after instructions, or missing progress-monitoring expectations can leave the plan not ready for implementation."
			}
		]
	},
	{
		"toolType": "fbaBipQualityReviewTate",
		"slug": "fba-bip-quality-review-tate",
		"title": "TATE FBA/BIP Quality and Fidelity Review | Qwoach",
		"metaDescription": "Review existing FBA and BIP/BSP work with supplied TATE criteria, evidence notes, profile summaries, strengths, gaps, and repeated-review comparison.",
		"h1": "FBA/BIP Quality Review (TATE)",
		"intro": "FBA/BIP Quality Review (TATE) is a practitioner-only quality and fidelity review tool for practitioners, coaches, and reviewers. It helps them apply supplied review criteria to an existing FBA and behavior support plan, record ratings and evidence notes, and produce a profile of strengths, gaps, and change over repeated reviews.",
		"demoTitle": "Explore a sample review workflow with placeholder criteria and partial-profile handling.",
		"demoPrompt": "Interested in using FBA/BIP Quality Review (TATE) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0778-f-041-fba-014-r001-fba-bip-quality-review-tate.md",
		"specId": "0778-f-041-fba-014-r001-fba-bip-quality-review-tate",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring",
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Existing Work Required",
				"body": "The review cannot proceed meaningfully without an existing FBA and BIP/BSP to review."
			},
			{
				"title": "Instrument Content",
				"body": "Exact criteria, item text, scoring anchors, and cutoffs must come from supplied instrument content. The product must not invent them."
			},
			{
				"title": "Repeated Reviews",
				"body": "Change over time is comparable only when the same instrument version and scoring structure are used."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include the exact TATE items?",
				"answer": "No. Exact TATE items and scoring are unresolved unless supplied through the instrument content."
			},
			{
				"question": "Can this create an FBA or BIP?",
				"answer": "No. It reviews existing FBA and BIP/BSP work; it does not create the assessment or support plan."
			},
			{
				"question": "When is a profile final?",
				"answer": "A profile is final only when the required ratings are complete according to the supplied instrument rules."
			},
			{
				"question": "Can repeated reviews show improvement?",
				"answer": "Yes, repeated reviews can show quality or fidelity change when comparable instrument structure and scoring are used."
			}
		]
	},
	{
		"toolType": "pbisTieredFidelityInventoryTfi30",
		"slug": "pbis-tiered-fidelity-inventory-tfi-3-0",
		"title": "PBIS TFI 3.0 Fidelity Profile Tool | Qwoach",
		"metaDescription": "Complete tier-separated TFI 3.0 administrations, review PBIS fidelity strengths and gaps, and compare profiles over time when scoring is supplied.",
		"h1": "PBIS Tiered Fidelity Inventory (TFI) 3.0",
		"intro": "PBIS Tiered Fidelity Inventory (TFI) 3.0 is a practitioner-only fidelity measure for school and district PBIS teams. It helps teams complete supplied TFI 3.0 items by tier, review current strengths and gaps, and compare fidelity profiles over time when administrations are comparable.",
		"demoTitle": "Explore a sample tier-separated administration and profile review.",
		"demoPrompt": "Interested in using PBIS Tiered Fidelity Inventory (TFI) 3.0 with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0779-f-042-pbis-001-r001-pbis-tiered-fidelity-inventory-tfi-3-0.md",
		"specId": "0779-f-042-pbis-001-r001-pbis-tiered-fidelity-inventory-tfi-3-0",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Tier Separation",
				"body": "Tier 1, Tier 2, and Tier 3 results remain separated so partial tier administrations are not presented as whole-system fidelity."
			},
			{
				"title": "Version Comparability",
				"body": "Longitudinal comparison requires comparable administrations and instrument version tracking."
			},
			{
				"title": "Limits",
				"body": "The tool produces a fidelity profile. It does not create an action plan, add unsupported scoring, or make causal claims about student outcomes."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include exact TFI 3.0 items?",
				"answer": "No. Exact item content and scoring are unresolved unless supplied through the instrument structure."
			},
			{
				"question": "Can the tool compare results over time?",
				"answer": "Yes, when prior administrations are comparable by instrument version, context, tiers, and scoring structure."
			},
			{
				"question": "Is this an action planning tool?",
				"answer": "No. It produces a tier-specific fidelity profile; action planning is a separate continuation."
			},
			{
				"question": "What happens if only one tier is completed?",
				"answer": "The result should show a partial tier administration and avoid presenting it as whole-system fidelity."
			}
		]
	},
	{
		"toolType": "tfi30ActionPlan",
		"slug": "tfi-3-0-action-plan",
		"title": "TFI 3.0 Action Plan for PBIS Gaps | Qwoach",
		"metaDescription": "Turn TFI 3.0 fidelity gaps into linked PBIS action steps with priorities, owners, checkpoints, status updates, and revisit history.",
		"h1": "TFI 3.0 Action Plan",
		"intro": "TFI 3.0 Action Plan is a practitioner-only PBIS implementation planning tool for PBIS teams. It helps teams link identified fidelity gaps to priority actions, assign an owner or responsible role, set timelines or checkpoints, update status, and revisit whether implementation work has advanced.",
		"demoTitle": "Create sample gap-linked actions and review plan completeness.",
		"demoPrompt": "Interested in using TFI 3.0 Action Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0780-f-042-pbis-002-r001-tfi-3-0-action-plan.md",
		"specId": "0780-f-042-pbis-002-r001-tfi-3-0-action-plan",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Gap-Linked Actions",
				"body": "Core actions should link to identified fidelity gaps so the plan remains focused on implementation improvement rather than becoming a generic task list."
			},
			{
				"title": "Accountability Fields",
				"body": "Owner or responsible role and checkpoint are required for accountable follow-through."
			},
			{
				"title": "Limits",
				"body": "The tool does not conduct TFI scoring, generate PBIS recommendations, or treat status updates as proof of fidelity improvement."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score the TFI 3.0?",
				"answer": "No. It starts from identified fidelity gaps and turns them into implementation actions."
			},
			{
				"question": "Can actions be unlinked to a fidelity gap?",
				"answer": "They can be marked unlinked or out of scope, but core plan actions should link to a gap."
			},
			{
				"question": "What makes an action incomplete?",
				"answer": "An action without an owner or responsible role, or without a checkpoint, is incomplete for accountable follow-through."
			},
			{
				"question": "Do completed actions prove fidelity improved?",
				"answer": "No. Status updates show follow-through on the plan; fidelity improvement requires later review or reassessment."
			}
		]
	},
	{
		"toolType": "schoolWideExpectationsMatrix",
		"slug": "school-wide-expectations-matrix",
		"title": "School-Wide Expectations Matrix for PBIS Teams | Qwoach",
		"metaDescription": "Create a PBIS expectations matrix with 3-5 positive expectations defined in observable terms across school settings and routines.",
		"h1": "School-Wide Expectations Matrix",
		"intro": "The School-Wide Expectations Matrix is a PBIS tool for school PBIS practitioners and teams. It helps them create a small set of positively stated behavior expectations and define each expectation in observable terms across common school settings and routines.",
		"demoTitle": "Start with a sample matrix, edit expectations and routines, and review the completed staff-ready view.",
		"demoPrompt": "Interested in using School-Wide Expectations Matrix with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0781-f-042-pbis-003-r001-school-wide-expectations-matrix.md",
		"specId": "0781-f-042-pbis-003-r001-school-wide-expectations-matrix",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during PBIS setup or revision when staff need consistent school-wide language for expected student behavior."
			},
			{
				"title": "What It Captures",
				"body": "It captures expectation labels, settings or routines, and observable behavior definitions for each intersection."
			},
			{
				"title": "Important Limits",
				"body": "The tool organizes and checks the matrix. It does not create lesson plans, reinforcement systems, discipline workflows, student conclusions, or implementation fidelity ratings."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create the school's expectations for me?",
				"answer": "No. The practitioner or PBIS team enters the expectations and definitions; the tool organizes them and shows completeness or configuration issues."
			},
			{
				"question": "How many expectations does the matrix support?",
				"answer": "It supports drafting any count, but marks fewer than 3 or more than 5 expectations as outside the source-supported target range."
			},
			{
				"question": "Is there a student-facing version?",
				"answer": "No. The product specification defines this as a practitioner-only configuration tool."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The tool, expectation labels, settings/routines, and matrix cell definitions are saved as the reusable school-wide matrix."
			}
		]
	},
	{
		"toolType": "officeDisciplineReferralOdrForm",
		"slug": "office-discipline-referral-odr-form",
		"title": "Office Discipline Referral Form for PBIS Incident Data | Qwoach",
		"metaDescription": "Capture office discipline referrals with consistent PBIS incident fields for comparable records, filtering, grouping, and trend-ready review.",
		"h1": "Office Discipline Referral Form",
		"intro": "The Office Discipline Referral Form is a PBIS tool for practitioners and school teams that record office-level behavior incidents. It helps them capture who was involved, what happened, and where or when it occurred using consistent fields so the PBIS team can review patterns over time.",
		"demoTitle": "Enter a sample referral, resolve validation prompts, and view the resulting incident table.",
		"demoPrompt": "Interested in using Office Discipline Referral (ODR) Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0782-f-042-pbis-004-r001-office-discipline-referral-odr-form.md",
		"specId": "0782-f-042-pbis-004-r001-office-discipline-referral-odr-form",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Problem behavior"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The form captures consistent incident fields sufficient to distinguish who was involved, what happened, and where or when the incident occurred."
			},
			{
				"title": "How Review Works",
				"body": "Submitted records can be filtered, grouped, and counted by supported dimensions such as student, behavior category, time, and setting."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not determine consequences, diagnose students, infer behavior function, or select supports automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does the form decide what consequence should happen?",
				"answer": "No. It captures and organizes referral data; practitioner and team decisions remain outside the form."
			},
			{
				"question": "Can incomplete referrals be saved?",
				"answer": "Yes. Incomplete referrals can remain drafts and are excluded from aggregates or clearly marked until required standardized fields are complete."
			},
			{
				"question": "Can categories change over time?",
				"answer": "Yes. Category changes can be configured, but historical labels or mappings must be preserved so trends are not misleading."
			},
			{
				"question": "What happens to sample referrals in the demo?",
				"answer": "Sample referrals are not saved as real student records when the tool is added to an account."
			}
		]
	},
	{
		"toolType": "pbisDataDashboardSwis",
		"slug": "pbis-data-dashboard-swis",
		"title": "PBIS Data Dashboard for School and Student Trends | Qwoach",
		"metaDescription": "Review PBIS behavior data over time with school-level summaries, student-level drilldowns, filters, and visible data gaps.",
		"h1": "PBIS Data Dashboard / SWIS",
		"intro": "The PBIS Data Dashboard / SWIS is a practitioner-only dashboard for PBIS teams. It helps teams review current school-level and student-level behavior trends over selected time ranges so they can use descriptive data during recurring PBIS decision-making cycles.",
		"demoTitle": "Explore sample trends, adjust filters, and switch between school-level and student-level review.",
		"demoPrompt": "Interested in using PBIS Data Dashboard / SWIS with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0783-f-042-pbis-005-r001-pbis-data-dashboard-swis.md",
		"specId": "0783-f-042-pbis-005-r001-pbis-data-dashboard-swis",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Problem behavior"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during recurring PBIS data meetings when teams need current trend visibility rather than isolated counts."
			},
			{
				"title": "What It Shows",
				"body": "It shows descriptive school-level and student-level trends over time, with filterable breakdowns when the underlying data support them."
			},
			{
				"title": "Important Limits",
				"body": "The dashboard does not assign causes, create risk scores, prescribe interventions, or replace team interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does the dashboard make intervention recommendations?",
				"answer": "No. It displays descriptive trends and gaps; PBIS teams interpret the data and decide next actions."
			},
			{
				"question": "Can I review individual students?",
				"answer": "Yes. The dashboard supports student-level drilldown when student-level source data are available."
			},
			{
				"question": "What happens if data are missing?",
				"answer": "Missing or delayed source data are shown as gaps or currency indicators rather than being smoothed or invented."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The dashboard tool and view configuration are saved; fictional trend data and sample student records are not."
			}
		]
	},
	{
		"toolType": "schoolClimateSurveyScs",
		"slug": "school-climate-survey-scs",
		"title": "School Climate Survey for PBIS Stakeholder Input | Qwoach",
		"metaDescription": "Send a PBIS school climate survey, monitor aggregate completion, and review a stakeholder climate profile with comparable history.",
		"h1": "School Climate Survey",
		"intro": "The School Climate Survey is a ready-to-send PBIS survey tool for practitioners and PBIS teams. It helps them collect stakeholder perceptions of the school environment and review an aggregated climate profile for data-based decision-making.",
		"demoTitle": "Set up a sample survey administration, preview the respondent view, and review sample aggregate results.",
		"demoPrompt": "Interested in using School Climate Survey (SCS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0784-f-042-pbis-006-r001-school-climate-survey-scs.md",
		"specId": "0784-f-042-pbis-006-r001-school-climate-survey-scs",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"School climate"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures stakeholder survey responses according to a defined SCS structure and aggregates them into a climate profile."
			},
			{
				"title": "Comparison Over Time",
				"body": "Prior-administration comparison is available only when the same structure, or a clearly comparable structure, is used."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not invent survey questions, rating scales, climate dimensions, scoring methods, causal explanations, or improvement plans."
			}
		],
		"faqItems": [
			{
				"question": "Can I write my own survey questions?",
				"answer": "No. The product is not a generic survey builder; survey content depends on a defined SCS structure."
			},
			{
				"question": "Do respondents have a separate view?",
				"answer": "Yes. Respondents use a survey link or assigned access point to answer defined SCS items and submit."
			},
			{
				"question": "Can results be compared over time?",
				"answer": "Yes, when comparable administrations use the same survey structure or clearly mapped structures."
			},
			{
				"question": "Are demo responses saved?",
				"answer": "No. Fictional responses and sample profile data do not become real owned respondent data."
			}
		]
	},
	{
		"toolType": "benchmarksOfQualityBoq",
		"slug": "benchmarks-of-quality-boq",
		"title": "Benchmarks of Quality for Tier 1 PBIS Fidelity Review | Qwoach",
		"metaDescription": "Complete a structured BoQ administration, track progress, and review a Tier 1 PBIS strength-gap profile over time.",
		"h1": "Benchmarks of Quality",
		"intro": "Benchmarks of Quality is a PBIS assessment tool for practitioners and PBIS teams. It helps them complete a defined Tier 1 PBIS fidelity assessment and review a strength-gap profile for action-planning discussions.",
		"demoTitle": "Complete sample assessment items, check draft status, and review a sample Tier 1 profile.",
		"demoPrompt": "Interested in using Benchmarks of Quality (BoQ) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0785-f-042-pbis-007-r001-benchmarks-of-quality-boq.md",
		"specId": "0785-f-042-pbis-007-r001-benchmarks-of-quality-boq",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at periodic Tier 1 PBIS review points when the team needs a fidelity profile to inform action planning."
			},
			{
				"title": "Draft and Final States",
				"body": "Incomplete assessments remain draft or partial and should not be presented as final fidelity profiles."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not invent BoQ items, scoring thresholds, domains, action steps, or unrelated school-practice measures."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool include BoQ scoring automatically?",
				"answer": "Only if a defined BoQ scoring/profile method is supplied. Without it, the tool can show completion and entered responses but not unsupported strength-gap calculations."
			},
			{
				"question": "Can incomplete assessments produce final profiles?",
				"answer": "No. Incomplete assessments are marked draft or partial and should not be treated as final fidelity profiles."
			},
			{
				"question": "Can I compare results over time?",
				"answer": "Yes, when administrations use the same or clearly mapped BoQ structure."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and setup are saved; fictional responses, profiles, and prior sample administrations are not saved as real data."
			}
		]
	},
	{
		"toolType": "selfAssessmentSurveySas",
		"slug": "self-assessment-survey-sas",
		"title": "Self-Assessment Survey for PBIS Staff Priorities | Qwoach",
		"metaDescription": "Send a PBIS Self-Assessment Survey to staff, monitor aggregate completion, and review implementation status and priority results.",
		"h1": "Self-Assessment Survey",
		"intro": "The Self-Assessment Survey is a ready-to-send PBIS survey tool for practitioners and PBIS teams. It helps them collect staff perceptions about PBIS implementation status and priority needs, then review an aggregated profile for improvement planning.",
		"demoTitle": "Set up a sample staff survey, preview staff response, and review aggregate priority results.",
		"demoPrompt": "Interested in using Self-Assessment Survey (SAS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0786-f-042-pbis-008-r001-self-assessment-survey-sas.md",
		"specId": "0786-f-042-pbis-008-r001-self-assessment-survey-sas",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures staff responses about PBIS implementation status and priority needs according to a defined SAS format."
			},
			{
				"title": "How Results Are Used",
				"body": "The aggregate profile supports team-level improvement planning by showing staff-reported perceptions and priorities."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not evaluate individual staff, invent SAS items, create unsupported fidelity scores, or generate improvement actions automatically."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic staff survey builder?",
				"answer": "No. The product remains SAS and depends on a defined SAS structure for content and scoring."
			},
			{
				"question": "Do staff receive interpretations of their answers?",
				"answer": "No. Staff complete the survey; practitioners review aggregate results without unsupported individual interpretation."
			},
			{
				"question": "Can results show priorities?",
				"answer": "Yes, when priority summaries are defined by the SAS scoring or profile structure."
			},
			{
				"question": "What happens to demo staff responses?",
				"answer": "They are not saved as real response data when the survey is added to an account."
			}
		]
	},
	{
		"toolType": "checkInCheckOutCicoDailyProgressReport",
		"slug": "check-in-check-out-cico-daily-progress-report",
		"title": "CICO Daily Progress Report for Tier 2 PBIS | Qwoach",
		"metaDescription": "Track daily CICO progress tied to student goals and school periods, with missing-entry indicators and accumulated progress data.",
		"h1": "Check-In Check-Out Daily Progress Report",
		"intro": "The Check-In Check-Out Daily Progress Report is a ready-to-send PBIS tool for practitioners supporting a student receiving Tier 2 CICO-style support. It helps them collect timely daily information about progress toward targeted behavior goals across relevant settings or periods.",
		"demoTitle": "Set up a sample daily report, complete period entries, and review the day's progress data.",
		"demoPrompt": "Interested in using Check-In Check-Out (CICO) Daily Progress Report with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0787-f-042-pbis-009-r001-check-in-check-out-cico-daily-progress-report.md",
		"specId": "0787-f-042-pbis-009-r001-check-in-check-out-cico-daily-progress-report",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during Tier 2 CICO-style support when daily progress information needs to be captured across the school day."
			},
			{
				"title": "What It Captures",
				"body": "It captures feedback or ratings tied to targeted goals and specific settings or periods, plus completion status."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not invent behavior goals, define scoring scales, infer function, or automatically decide whether support should change."
			}
		],
		"faqItems": [
			{
				"question": "Does the report choose the student's goals?",
				"answer": "No. The practitioner enters the targeted behavior goals; the tool organizes daily tracking around them."
			},
			{
				"question": "Can staff complete entries during the day?",
				"answer": "Yes. Participating users can complete brief entries for relevant settings or periods."
			},
			{
				"question": "How are missing entries handled?",
				"answer": "Missing period entries are marked partial and distinguished from low ratings or poor progress."
			},
			{
				"question": "Are demo student entries saved?",
				"answer": "No. Fictional student identifiers and sample daily entries are not saved as real student data by default."
			}
		]
	},
	{
		"toolType": "cicoGoalProgressGraph",
		"slug": "cico-goal-progress-graph",
		"title": "CICO Goal/Progress Graph for Tier 2 PBIS Review | Qwoach",
		"metaDescription": "Graph accumulated CICO progress across days or weeks against a goal line, with missing days and goal changes clearly shown.",
		"h1": "CICO Goal/Progress Graph",
		"intro": "The CICO Goal/Progress Graph is a PBIS review tool for practitioners and teams supporting a student in Tier 2 CICO-style support. It helps them view accumulated progress across multiple days or weeks relative to a goal line so the trend can inform team decisions.",
		"demoTitle": "Choose a sample data series, adjust the goal line, and inspect the resulting progress graph.",
		"demoPrompt": "Interested in using CICO Goal/Progress Graph with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0788-f-042-pbis-010-r001-cico-goal-progress-graph.md",
		"specId": "0788-f-042-pbis-010-r001-cico-goal-progress-graph",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Graph"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Goals"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after multiple days or weeks of CICO data have accumulated and the team needs to review response over time."
			},
			{
				"title": "What It Shows",
				"body": "It shows plotted CICO progress values across time, a goal reference line, underlying data points, and gaps or non-comparable days."
			},
			{
				"title": "Important Limits",
				"body": "The graph does not create daily reports, invent scores, label response automatically, or decide the intervention next step."
			}
		],
		"faqItems": [
			{
				"question": "Does the graph change the original daily report data?",
				"answer": "No. Graph settings affect display only; source daily records remain separate."
			},
			{
				"question": "Can it show missing days?",
				"answer": "Yes. Missing days are shown as gaps rather than treated as zero."
			},
			{
				"question": "Does it decide whether to maintain or change support?",
				"answer": "No. The graph shows the trend; the practitioner or team makes the intervention decision."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The graph tool and configuration are saved; fictional student values and sample history are not."
			}
		]
	},
	{
		"toolType": "tier2IdentificationDecisionRules",
		"slug": "tier-2-identification-decision-rules",
		"title": "Tier 2 Identification Decision Rules for PBIS Teams | Qwoach",
		"metaDescription": "Define objective PBIS Tier 2 identification rules, apply them to available student data, and review flagged or missing-data cases.",
		"h1": "Tier 2 Identification Decision Rules",
		"intro": "Tier 2 Identification Decision Rules is a practitioner-only PBIS tool for Tier 2 teams. It helps them define objective criteria using available student data and apply those rules consistently so students can be identified for targeted support review.",
		"demoTitle": "Create a sample rule, apply it to fictional data, and review which students meet, do not meet, or cannot be evaluated.",
		"demoPrompt": "Interested in using Tier 2 Identification Decision Rules with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0789-f-042-pbis-011-r001-tier-2-identification-decision-rules.md",
		"specId": "0789-f-042-pbis-011-r001-tier-2-identification-decision-rules",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Problem behavior"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "What It Defines",
				"body": "It defines explicit criteria based on available student data, including data source, condition, threshold or value, and activation status."
			},
			{
				"title": "How Results Should Be Read",
				"body": "A rule match means a student meets configured criteria for Tier 2 consideration; it is not the same as final intervention placement."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not invent thresholds, select interventions automatically, create clinical conclusions, or hide the logic behind a match."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide who receives Tier 2 support?",
				"answer": "No. It applies configured criteria for team review; the team makes final support decisions."
			},
			{
				"question": "What happens when student data are missing?",
				"answer": "Missing data are marked as cannot evaluate, not treated as evidence that the student does not meet criteria."
			},
			{
				"question": "Can rules be tested before they are official?",
				"answer": "Yes. Draft rules can be configured separately from active criteria."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and rule configuration are saved; fictional student data and sample matches are not."
			}
		]
	},
	{
		"toolType": "tier3FbaBip",
		"slug": "tier-3-fba-bip",
		"title": "Tier 3 FBA/BIP Tool for Function-Based PBIS Planning | Qwoach",
		"metaDescription": "Organize Tier 3 FBA/BIP information, connect assessment to individualized support, and track completeness and monitoring readiness.",
		"h1": "Tier 3 FBA/BIP",
		"intro": "Tier 3 FBA/BIP is a practitioner-only PBIS workflow for Tier 3 teams. It helps them organize formal assessment information, record practitioner-entered function-based understanding, connect that understanding to individualized support strategies, and prepare monitoring for the target behavior.",
		"demoTitle": "Review a fictional FBA/BIP record, add assessment-to-plan links, and check completeness.",
		"demoPrompt": "Interested in using Tier 3 FBA/BIP with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0790-f-042-pbis-012-r001-tier-3-fba-bip.md",
		"specId": "0790-f-042-pbis-012-r001-tier-3-fba-bip",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "What It Organizes",
				"body": "It organizes target behavior, assessment information, practitioner-entered likely function, support approach, and monitoring information when defined."
			},
			{
				"title": "How Review Works",
				"body": "The review view shows whether assessment information, function understanding, support strategies, and monitoring are visibly connected."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not infer function, diagnose, invent strategies, prescribe plans, or make support-effect conclusions without entered monitoring data and practitioner interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool identify the behavior function automatically?",
				"answer": "No. The likely function is practitioner-entered or team-entered; the system only organizes information and checks completeness or linkage."
			},
			{
				"question": "Can the tool recommend support strategies?",
				"answer": "No. It does not invent or prescribe strategies unless a defined source structure supplies selectable options."
			},
			{
				"question": "Is there a student-facing experience?",
				"answer": "No. The supplied specification defines a practitioner-only workflow."
			},
			{
				"question": "What happens to the fictional demo record?",
				"answer": "It is not saved as real student data by default; saving preserves the tool and selected workflow setup."
			}
		]
	},
	{
		"toolType": "tipsMeetingMinuteWorksheet",
		"slug": "tips-meeting-minute-worksheet",
		"title": "TIPS Meeting Minute Worksheet Demo | Qwoach",
		"metaDescription": "Explore a PBIS meeting worksheet for recording problem definitions, decisions, action items, owners, and follow-up responsibilities.",
		"h1": "TIPS Meeting Minute Worksheet for PBIS Team Decisions",
		"intro": "TIPS Meeting Minute Worksheet is a practitioner-only PBIS meeting documentation tool for PBIS teams. It helps practitioners record problem definitions, team decisions, assigned actions, responsible people, and follow-up expectations so meeting decisions can be reviewed after the meeting.",
		"demoTitle": "Open the sample worksheet and try recording a PBIS team decision.",
		"demoPrompt": "Interested in using TIPS Meeting Minute Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0791-f-042-pbis-013-r001-tips-meeting-minute-worksheet.md",
		"specId": "0791-f-042-pbis-013-r001-tips-meeting-minute-worksheet",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Problem solving"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during PBIS data meetings and at the start of later meetings when the team reviews prior decisions and action status."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures meeting context, problem definitions, decisions, action items, responsible people, follow-up expectations or timelines, and action status where recorded."
			},
			{
				"title": "Important Limits",
				"body": "The tool organizes meeting decisions and responsibilities. It does not infer whether a decision is correct, score PBIS quality, or recommend what the team should decide."
			}
		],
		"faqItems": [
			{
				"question": "Is this a student-facing PBIS tool?",
				"answer": "No. TIPS Meeting Minute Worksheet is a practitioner-only PBIS team worksheet for meeting decisions and action tracking."
			},
			{
				"question": "Can the worksheet show unfinished meeting notes?",
				"answer": "Yes. Partial states should show unfinished notes and incomplete action details without treating them as final decisions."
			},
			{
				"question": "Does the tool recommend PBIS decisions?",
				"answer": "No. The tool organizes practitioner-entered meeting content and does not judge decision quality or generate recommendations."
			}
		]
	},
	{
		"toolType": "recognitionSystemPlan",
		"slug": "recognition-system-plan",
		"title": "Recognition System Plan Demo | Qwoach",
		"metaDescription": "Build a PBIS recognition system plan that connects expected behaviors, recognition strategies, continuum structure, and fidelity targets.",
		"h1": "PBIS Recognition System Plan",
		"intro": "Recognition System Plan is a practitioner-only PBIS planning tool for PBIS teams. It helps practitioners define expected behaviors, recognition strategies, continuum structure, and fidelity targets so staff have a common approach for acknowledging expected student behavior.",
		"demoTitle": "Start with the sample recognition plan and review its completeness.",
		"demoPrompt": "Interested in using Recognition System Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0792-f-042-pbis-014-r001-recognition-system-plan.md",
		"specId": "0792-f-042-pbis-014-r001-recognition-system-plan",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during PBIS planning or revision cycles when the team needs a common school-wide recognition approach."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures expected behaviors, recognition strategies, continuum structure, staff-use expectations where supplied, and fidelity targets."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not evaluate reward effectiveness, score student behavior, or invent recognition content."
			}
		],
		"faqItems": [
			{
				"question": "Is this a student reward tracker?",
				"answer": "No. Recognition System Plan is a practitioner planning tool for defining a school-wide recognition system, not tracking individual student rewards."
			},
			{
				"question": "Can staff view the finalized plan?",
				"answer": "Yes. Staff may consult the finalized plan if the practitioner shares it, but there is no separate staff completion workflow."
			},
			{
				"question": "Does the tool tell us which recognition strategies to use?",
				"answer": "No. Recognition strategies are practitioner-provided; the tool organizes them and shows completeness."
			}
		]
	},
	{
		"toolType": "responseCorrectionContinuum",
		"slug": "response-correction-continuum",
		"title": "Response/Correction Continuum Demo | Qwoach",
		"metaDescription": "Explore a PBIS response continuum for matching behavior concerns with correction strategies and reviewing policy completeness.",
		"h1": "PBIS Response/Correction Continuum",
		"intro": "Response/Correction Continuum is a practitioner-only PBIS policy planning tool for PBIS teams. It helps practitioners define behavior concern levels or types, correction and response strategies, and matching relationships so staff can respond consistently and instructionally across the school.",
		"demoTitle": "Try matching sample responses to behavior concern categories.",
		"demoPrompt": "Interested in using Response/Correction Continuum with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0793-f-042-pbis-015-r001-response-correction-continuum.md",
		"specId": "0793-f-042-pbis-015-r001-response-correction-continuum",
		"tags": {
			"framework": [
				"PBIS"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Problem behavior",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during PBIS planning, staff orientation, consistency review, or policy revision."
			},
			{
				"title": "What It Captures",
				"body": "The continuum captures PBIS expectations, concern categories or levels, correction and response strategies, and the fit between concerns and responses."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not log incidents, make student-specific discipline decisions, assign severity ratings, or recommend punitive actions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a discipline referral system?",
				"answer": "No. Response/Correction Continuum is a PBIS policy planning tool, not an incident log or referral workflow."
			},
			{
				"question": "Can schools define their own behavior concern categories?",
				"answer": "Yes. The supported configuration allows practitioner-defined concern categories or levels because exact categories are unresolved."
			},
			{
				"question": "Does the tool decide which response to use for an individual student?",
				"answer": "No. It organizes the school’s policy continuum and does not automate student-specific decisions."
			}
		]
	},
	{
		"toolType": "schoolCounselingProgramDataPriorities",
		"slug": "school-counseling-program-data-priorities",
		"title": "School Counseling Program Data Priorities Demo | Qwoach",
		"metaDescription": "Explore a school counseling data-priority tool for selecting specific student outcome indicators for planning and evaluation.",
		"h1": "School Counseling Program Data Priorities",
		"intro": "School Counseling Program Data Priorities is a practitioner-only ASCA program planning and evaluation tool for school counselors. It helps practitioners select specific student outcomes and indicators so counseling program planning and evaluation stay focused on the evidence they intend to use.",
		"demoTitle": "Create a sample priority set for a planning cycle.",
		"demoPrompt": "Interested in using School Counseling Program Data Priorities with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0794-f-043-asca-001-r001-school-counseling-program-data-priorities.md",
		"specId": "0794-f-043-asca-001-r001-school-counseling-program-data-priorities",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during periodic school counseling program planning, evaluation, or review cycles."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures specific student outcome indicators, practitioner-entered relevance or context, cycle labels, and prior priority sets."
			},
			{
				"title": "Important Limits",
				"body": "The tool organizes and preserves selected priorities. It does not analyze all student data, rank indicators, or create program conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a data dashboard?",
				"answer": "No. It is a priority-selection tool for school counseling program planning and evaluation, not a full analytics dashboard."
			},
			{
				"question": "Does the tool choose priorities automatically?",
				"answer": "No. Priorities are selected by the practitioner; the system organizes them and shows completeness."
			},
			{
				"question": "Can priorities be revisited later?",
				"answer": "Yes. Historical priority sets can be preserved across planning or evaluation cycles for later review."
			}
		]
	},
	{
		"toolType": "achievementGapPlanAndDataReport",
		"slug": "achievement-gap-plan-and-data-report",
		"title": "Achievement Gap Plan and Data Report Demo | Qwoach",
		"metaDescription": "Explore a school counseling report for defining an achievement gap, entering baseline and follow-up data, and reviewing measured change.",
		"h1": "Achievement Gap Plan and Data Report",
		"intro": "Achievement Gap Plan and Data Report is a practitioner-only ASCA school counseling planning and outcome-reporting tool for school counselors. It helps practitioners define a targeted achievement gap, record intended change, compare baseline and follow-up student outcome status, and review whether further action is indicated.",
		"demoTitle": "Try a sample before-and-after gap report.",
		"demoPrompt": "Interested in using Achievement Gap Plan and Data Report with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0795-f-043-asca-002-r001-achievement-gap-plan-and-data-report.md",
		"specId": "0795-f-043-asca-002-r001-achievement-gap-plan-and-data-report",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after identifying a specific achievement gap the school counseling program is expected to address."
			},
			{
				"title": "What It Captures",
				"body": "The report captures the target group, outcome gap, intended change, intervention connection, baseline data, follow-up data, measured change, and further-action status where recorded."
			},
			{
				"title": "Important Limits",
				"body": "The tool displays change when data are comparable. It does not claim the intervention caused the change or generate equity conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does this report prove the intervention caused the outcome change?",
				"answer": "No. It shows baseline-to-follow-up change for a targeted gap and keeps causal interpretation with the practitioner."
			},
			{
				"question": "What happens if baseline and follow-up use different measures?",
				"answer": "The report should mark the data as non-comparable and not calculate an unsupported before/after result."
			},
			{
				"question": "Is student data entered by students?",
				"answer": "No. The product is practitioner-only; student outcome information is practitioner-provided for the targeted comparison."
			}
		]
	},
	{
		"toolType": "ascaStudentStandardsDeliveryPlan",
		"slug": "asca-student-standards-delivery-plan",
		"title": "ASCA Student Standards Delivery Plan Demo | Qwoach",
		"metaDescription": "Explore a school counseling delivery plan that maps student standards to planned supports, target settings, and delivery details.",
		"h1": "ASCA Student Standards Delivery Plan",
		"intro": "ASCA Student Standards Delivery Plan is a practitioner-only school counseling planning tool for school counselors. It helps practitioners identify student standards, define the target population or setting, and align planned counseling supports so delivery can be reviewed later.",
		"demoTitle": "Try mapping a sample support to a prioritized student standard.",
		"demoPrompt": "Interested in using ASCA Student Standards Delivery Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0796-f-043-asca-003-r001-asca-student-standards-delivery-plan.md",
		"specId": "0796-f-043-asca-003-r001-asca-student-standards-delivery-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when preparing counseling supports that need to align with prioritized student standards."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures intended standards, planned supports, target population or setting, delivery details, and support-to-standard alignment."
			},
			{
				"title": "Important Limits",
				"body": "The tool organizes alignment. It does not define standards, generate lesson content, score mastery, or create evaluation criteria."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create counseling lessons?",
				"answer": "No. It plans delivery alignment between standards and supports; it does not generate lesson content."
			},
			{
				"question": "Can a support align to more than one standard?",
				"answer": "Yes. The plan should show which supports map to which intended standards, including multiple alignments where the practitioner provides them."
			},
			{
				"question": "Is there a student-facing view?",
				"answer": "No. This is a practitioner-only planning tool; students do not complete anything in the product."
			}
		]
	},
	{
		"toolType": "lessonPlanAndDataReport",
		"slug": "lesson-plan-and-data-report",
		"title": "Lesson Plan and Data Report Demo | Qwoach",
		"metaDescription": "Explore a school counseling lesson report that links intended student outcomes, objectives, evidence, and before/after change.",
		"h1": "Lesson Plan and Data Report",
		"intro": "Lesson Plan and Data Report is a practitioner-only ASCA school counseling lesson planning and outcome-reporting tool for school counselors. It helps practitioners state an intended student outcome, connect outcome evidence to the lesson objective, and review before/after change when comparable data are provided.",
		"demoTitle": "Try a sample lesson report with before-and-after evidence.",
		"demoPrompt": "Interested in using Lesson Plan and Data Report with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0797-f-043-asca-004-r001-lesson-plan-and-data-report.md",
		"specId": "0797-f-043-asca-004-r001-lesson-plan-and-data-report",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before and after a school counseling lesson when the practitioner wants lesson outcome evidence connected to the objective."
			},
			{
				"title": "What It Captures",
				"body": "The report captures lesson context, intended student outcome, outcome type, lesson objective, outcome evidence, and before/after data when applicable."
			},
			{
				"title": "Important Limits",
				"body": "The tool organizes evidence and displays supported change. It does not explain why change occurred or recommend lesson improvements."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool generate lesson plans?",
				"answer": "No. It captures lesson outcome planning and evidence review; it does not generate substantive lesson content."
			},
			{
				"question": "Can a lesson report work without before/after data?",
				"answer": "Yes. It can show non-comparative outcome evidence, but it should not present a before/after change result without comparable data."
			},
			{
				"question": "Who enters the evidence?",
				"answer": "The practitioner enters or manages the evidence in the product; no separate student completion flow is supported."
			}
		]
	},
	{
		"toolType": "smallGroupPlanAndDataReport",
		"slug": "small-group-plan-and-data-report",
		"title": "Small-Group Plan and Data Report Demo | Qwoach",
		"metaDescription": "Explore a school counseling small-group report for tracking group goals, member progress, outcome data, and follow-up decisions.",
		"h1": "Small-Group Plan and Data Report",
		"intro": "Small-Group Plan and Data Report is a practitioner-only ASCA school counseling small-group planning and outcome-reporting tool for school counselors. It helps practitioners define group goals, record progress or outcome information, and review whether students improved relative to the group’s intended goals.",
		"demoTitle": "Try a sample small-group report.",
		"demoPrompt": "Interested in using Small-Group Plan and Data Report with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0798-f-043-asca-005-r001-small-group-plan-and-data-report.md",
		"specId": "0798-f-043-asca-005-r001-small-group-plan-and-data-report",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Outcome monitoring",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when planning and reviewing a small-group counseling intervention for students with a shared need."
			},
			{
				"title": "What It Captures",
				"body": "The report captures shared need, group goals, group or member tracking information, progress/outcome data, and practitioner decision notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool summarizes progress relative to practitioner-defined goals. It does not diagnose students, create therapy notes, or automatically recommend services."
			}
		],
		"faqItems": [
			{
				"question": "Is this a group therapy record?",
				"answer": "No. It is a school counseling small-group planning and data-reporting tool, not a therapy process note or case-management system."
			},
			{
				"question": "Can progress be tracked for the whole group instead of each member?",
				"answer": "Yes. The supported configuration allows group-level, member-level, or hybrid tracking when the practitioner provides the corresponding data."
			},
			{
				"question": "Does the tool decide whether to continue the group?",
				"answer": "No. It organizes outcome information and supports practitioner decisions without generating recommendations."
			}
		]
	},
	{
		"toolType": "annualAdministratorConference",
		"slug": "annual-administrator-conference",
		"title": "Annual Administrator Conference Demo | Qwoach",
		"metaDescription": "Explore an annual school counseling alignment record for program priorities, counselor role expectations, and support conditions.",
		"h1": "Annual Administrator Conference",
		"intro": "Annual Administrator Conference is a practitioner-only ASCA school counseling alignment tool for school counselors. It helps practitioners record shared agreement on program priorities, counselor role expectations, and implementation support conditions for the year.",
		"demoTitle": "Prepare a sample annual conference record.",
		"demoPrompt": "Interested in using Annual Administrator Conference with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0799-f-043-asca-006-r001-annual-administrator-conference.md",
		"specId": "0799-f-043-asca-006-r001-annual-administrator-conference",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Clinical documentation"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before, during, or after the annual conversation that aligns the counseling program with administrator expectations."
			},
			{
				"title": "What It Captures",
				"body": "The record captures program priorities, counselor role expectations, implementation support conditions, unresolved items, and the annual cycle."
			},
			{
				"title": "Important Limits",
				"body": "The tool captures alignment and agreement. It does not provide performance evaluation, approval status, contract management, or scheduling."
			}
		],
		"faqItems": [
			{
				"question": "Is this an administrator evaluation form?",
				"answer": "No. It is an annual alignment record for program priorities, role expectations, and support conditions."
			},
			{
				"question": "Does the administrator need a separate account to complete it?",
				"answer": "No separate administrator completion flow is supported by the product specification."
			},
			{
				"question": "Can unresolved disagreement be recorded?",
				"answer": "Yes. Unresolved areas should be representable without forcing a false agreement."
			}
		]
	},
	{
		"toolType": "useOfTime5DayCalculator",
		"slug": "use-of-time-5-day-calculator",
		"title": "Use-of-Time 5-Day Calculator Demo | Qwoach",
		"metaDescription": "Explore a 5-day school counseling time calculator that totals activity categories and shows workload percentage distribution.",
		"h1": "Use-of-Time 5-Day Calculator",
		"intro": "Use-of-Time 5-Day Calculator is a practitioner-only ASCA school counseling workload review tool for school counselors. It helps practitioners record actual work time across five days, categorize activities, and calculate percentage distribution across counseling program activity categories.",
		"demoTitle": "Try a sample five-day time calculation.",
		"demoPrompt": "Interested in using Use-of-Time 5-Day Calculator with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0800-f-043-asca-007-r001-use-of-time-5-day-calculator.md",
		"specId": "0800-f-043-asca-007-r001-use-of-time-5-day-calculator",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"School counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during periodic workload review when the practitioner wants a multi-day picture of time allocation."
			},
			{
				"title": "What It Calculates",
				"body": "The calculator totals time by activity category and calculates percentage distribution across the selected five-day period."
			},
			{
				"title": "Important Limits",
				"body": "The tool is not a continuous time-tracking platform, productivity judge, staff evaluation system, or scheduling optimizer."
			}
		],
		"faqItems": [
			{
				"question": "Does the calculator track time continuously?",
				"answer": "No. It is a bounded five-day calculator, not a continuous monitoring or productivity platform."
			},
			{
				"question": "What happens if fewer than five days are entered?",
				"answer": "The result is partial and should show that fewer than five days are recorded."
			},
			{
				"question": "Does the tool tell me how to change my workload?",
				"answer": "No. It calculates totals and percentages and may show descriptive alignment or misalignment when priorities are provided, but it does not prescribe changes."
			}
		]
	},
	{
		"toolType": "schoolCounselingProgramAssessment",
		"slug": "school-counseling-program-assessment",
		"title": "School Counseling Program Assessment Demo | Qwoach",
		"metaDescription": "Assess a school counseling program with a structured strengths and gaps profile that can be revisited over time for improvement planning.",
		"h1": "School Counseling Program Assessment",
		"intro": "School Counseling Program Assessment is a practitioner-only tool for school counselors or program leads. It helps them evaluate a school counseling program against defined expectations and produce a program-level picture of strengths and gaps before choosing improvements.",
		"demoTitle": "Start a sample program assessment",
		"demoPrompt": "Interested in using School Counseling Program Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0801-f-043-asca-008-r001-school-counseling-program-assessment.md",
		"specId": "0801-f-043-asca-008-r001-school-counseling-program-assessment",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"School counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at program review points when the practitioner needs a program-level view of strengths and gaps before improvement planning."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not assess individual counselor performance, analyze individual student cases, create unsupported ASCA scoring, or automatically prioritize improvements."
			},
			{
				"title": "Longitudinal Review",
				"body": "Completed snapshots are preserved so comparable profiles can be revisited over time. If assessment structures differ, comparison is limited to shared comparable fields."
			}
		],
		"faqItems": [
			{
				"question": "Is this completed by students or families?",
				"answer": "No. This is a practitioner-only tool for evaluating a school counseling program."
			},
			{
				"question": "Does it create an improvement plan automatically?",
				"answer": "No. It produces a strengths/gaps profile that can inform later improvement priorities, but it does not automatically create or rank an improvement plan."
			},
			{
				"question": "Can unfinished assessment areas be saved?",
				"answer": "Yes. Partial work is preserved, and incomplete or unknown areas are shown separately from final strengths and gaps."
			},
			{
				"question": "Does the demo require real program data?",
				"answer": "No. The public demo uses sample non-identifying program-level content and does not require real student, counselor, or case information."
			}
		]
	},
	{
		"toolType": "schoolCounselorSelfAssessment",
		"slug": "school-counselor-self-assessment",
		"title": "School Counselor Self-Assessment Demo | Qwoach",
		"metaDescription": "Create a school counselor competency profile with strengths, areas for growth, incomplete areas, and baseline comparison over time.",
		"h1": "School Counselor Self-Assessment",
		"intro": "School Counselor Self-Assessment is a practitioner-only professional self-assessment tool for school counselors. It helps a counselor understand current school counseling competencies, identify strengths and areas for growth, and preserve a baseline for later comparison.",
		"demoTitle": "Try a sample self-assessment",
		"demoPrompt": "Interested in using School Counselor Self-Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0802-f-043-asca-009-r001-school-counselor-self-assessment.md",
		"specId": "0802-f-043-asca-009-r001-school-counselor-self-assessment",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"School counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a school counselor wants a structured baseline of professional capability before selecting development priorities."
			},
			{
				"title": "What It Is Not",
				"body": "It is not a supervisor appraisal, certification system, employment decision tool, or full professional development management system."
			},
			{
				"title": "Baseline Comparison",
				"body": "Completed profiles persist as dated baselines. Comparisons are shown only when the assessment structures are compatible."
			}
		],
		"faqItems": [
			{
				"question": "Is this a supervisor evaluation?",
				"answer": "No. It is a practitioner self-assessment completed by the school counselor."
			},
			{
				"question": "Does it recommend professional development activities?",
				"answer": "No. It identifies strengths and areas for growth; the counselor may use those areas to choose development priorities."
			},
			{
				"question": "Are unanswered items counted as weak areas?",
				"answer": "No. Unanswered competency areas are shown separately from areas for growth."
			},
			{
				"question": "Does the demo require real employment information?",
				"answer": "No. The public demo uses fictional sample responses and does not require supervisor, student, or employment data."
			}
		]
	},
	{
		"toolType": "schoolCounselorPerformanceAppraisal",
		"slug": "school-counselor-performance-appraisal",
		"title": "School Counselor Performance Appraisal Demo | Qwoach",
		"metaDescription": "Use a structured school counselor appraisal workspace to document role-specific performance strengths, improvement needs, and draft status.",
		"h1": "School Counselor Performance Appraisal",
		"intro": "School Counselor Performance Appraisal is a practitioner-only structured appraisal tool for evaluators of school counselors. It helps document role-specific performance strengths and improvement needs so follow-up expectations or support can be grounded in a defensible profile.",
		"demoTitle": "Open a sample appraisal",
		"demoPrompt": "Interested in using School Counselor Performance Appraisal with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0803-f-043-asca-010-r001-school-counselor-performance-appraisal.md",
		"specId": "0803-f-043-asca-010-r001-school-counselor-performance-appraisal",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"School counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Evaluator Role",
				"body": "The tool is for the practitioner responsible for appraisal. It does not define a counselor acknowledgment or response workflow."
			},
			{
				"title": "Boundaries",
				"body": "It does not create employment decisions, disciplinary recommendations, generic HR reviews, or unsupported scoring."
			},
			{
				"title": "Draft And Final States",
				"body": "Draft appraisals remain clearly marked. Finalized appraisals persist as historical snapshots with structure context."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as counselor self-assessment?",
				"answer": "No. This is an evaluator-completed performance appraisal, not a school counselor’s self-assessment."
			},
			{
				"question": "Does it make employment decisions?",
				"answer": "No. It produces a role-specific performance profile and does not infer employment outcomes."
			},
			{
				"question": "Can missing evidence appear as poor performance?",
				"answer": "No. Missing evidence or incomplete sections are shown separately from improvement needs."
			},
			{
				"question": "Does the demo require a real counselor name?",
				"answer": "No. The demo uses fictional, non-identifying role context and sample notes."
			}
		]
	},
	{
		"toolType": "studentAppraisalAdvisementProfile",
		"slug": "student-appraisal-advisement-profile",
		"title": "Student Appraisal & Advisement Profile Demo | Qwoach",
		"metaDescription": "Create a collaborative student advisement profile with academic context, career direction, student perspective, and planning inputs.",
		"h1": "Student Appraisal & Advisement Profile",
		"intro": "Student Appraisal & Advisement Profile is a collaborative school counseling tool for counselors and students. It helps them create an individualized understanding of the student’s academic situation, career direction, student perspective, and advisement needs before pathway planning.",
		"demoTitle": "Try the shared profile demo",
		"demoPrompt": "Interested in using Student Appraisal & Advisement Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0804-f-043-asca-011-r001-student-appraisal-advisement-profile.md",
		"specId": "0804-f-043-asca-011-r001-student-appraisal-advisement-profile",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Career counseling"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during individual appraisal and advisement before creating or updating an Academic & Career Plan."
			},
			{
				"title": "Counselor And Student Roles",
				"body": "The counselor controls the profile and review. The student contributes perspective through shared or assigned student-facing portions when used."
			},
			{
				"title": "Boundary With Planning",
				"body": "The profile identifies planning inputs and unresolved information. It does not silently convert those inputs into a final pathway."
			}
		],
		"faqItems": [
			{
				"question": "Does this create the student’s final academic and career plan?",
				"answer": "No. It creates a shared appraisal and advisement profile that can feed a separate Academic & Career Plan."
			},
			{
				"question": "Can the student complete part of it?",
				"answer": "Yes. When shared, the student can provide perspective through student-appropriate prompts and mark items unsure or skipped."
			},
			{
				"question": "What happens if the student does not contribute?",
				"answer": "The profile shows student perspective as missing rather than inferring it."
			},
			{
				"question": "Can conflicting counselor and student information be resolved automatically?",
				"answer": "No. Conflicting information is shown side by side for review rather than automatically reconciled."
			}
		]
	},
	{
		"toolType": "academicCareerPlan",
		"slug": "academic-career-plan",
		"title": "Academic & Career Plan Demo | Qwoach",
		"metaDescription": "Create a student-readable academic and career pathway connecting academic direction, career direction, goals, and explicit next steps.",
		"h1": "Academic & Career Plan",
		"intro": "Academic & Career Plan is a collaborative school counseling planning tool for counselors and students. It helps turn appraisal and advisement inputs into an individualized academic and career pathway with goals and next steps.",
		"demoTitle": "Build a sample pathway",
		"demoPrompt": "Interested in using Academic & Career Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0805-f-043-asca-012-r001-academic-career-plan.md",
		"specId": "0805-f-043-asca-012-r001-academic-career-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Career counseling",
				"Goals"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after or during appraisal and advisement when the student needs an explicit academic and career pathway."
			},
			{
				"title": "Student Role",
				"body": "The student contributes goals, preferences, direction, constraints, or clarification where supported, and reviews the plan in plain language."
			},
			{
				"title": "Plan History",
				"body": "Finalized plans persist as snapshots so later updates can preserve prior pathway history."
			}
		],
		"faqItems": [
			{
				"question": "Does this recommend a career pathway automatically?",
				"answer": "No. The tool organizes entered planning inputs and next steps; it does not infer a recommended pathway or career suitability."
			},
			{
				"question": "What if the student is unsure about career direction?",
				"answer": "The plan shows the uncertainty rather than inventing a direction."
			},
			{
				"question": "Can it import appraisal and advisement inputs?",
				"answer": "Yes, when available, it can start from completed appraisal/advisement inputs while keeping those inputs traceable in the plan workflow."
			},
			{
				"question": "Does the public demo save fictional student data?",
				"answer": "No. Demo pathway content is temporary and does not carry into real owned student data by default."
			}
		]
	},
	{
		"toolType": "relapsePreventionPlan",
		"slug": "relapse-prevention-plan",
		"title": "Relapse Prevention Plan Demo | Qwoach",
		"metaDescription": "Create an individualized relapse prevention plan with risks, warning signs, coping and support responses, urgent steps, and review gaps.",
		"h1": "Relapse Prevention Plan",
		"intro": "Relapse Prevention Plan is a recovery-support planning tool for practitioners and clients in recovery. It helps identify personal relapse risks, warning signs, coping and support responses, and urgent-risk actions so the client has specific steps ready when risk increases.",
		"demoTitle": "Create a sample relapse prevention plan",
		"demoPrompt": "Interested in using Relapse Prevention Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0806-f-044-rp-001-r001-relapse-prevention-plan.md",
		"specId": "0806-f-044-rp-001-r001-relapse-prevention-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Risk review"
			],
			"topic": [
				"Relapse prevention",
				"Substance use",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before or during periods of increased relapse risk so the client has responses ready before risk escalates."
			},
			{
				"title": "Practitioner And Client Roles",
				"body": "The client reports personal risks, warning signs, responses, and supports. The practitioner guides completion and reviews fit and completeness."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not predict relapse, assign clinical urgency, provide emergency protocols, or create treatment recommendations beyond the entered plan content."
			}
		],
		"faqItems": [
			{
				"question": "Does this predict whether a client will relapse?",
				"answer": "No. It organizes client and practitioner-entered planning information and does not predict relapse."
			},
			{
				"question": "Can the client complete it outside session?",
				"answer": "Yes, when client-completed mode is used, the client can enter plan content and save partial work for review."
			},
			{
				"question": "What happens if a risk has no response?",
				"answer": "The plan flags that risk as unmatched or incomplete rather than treating the plan as ready."
			},
			{
				"question": "Does the public demo require real recovery details?",
				"answer": "No. The demo uses fictional examples and does not require real client-identifying or sensitive case information."
			}
		]
	},
	{
		"toolType": "triggerIdentificationList",
		"slug": "trigger-identification-list",
		"title": "Trigger Identification List Demo | Qwoach",
		"metaDescription": "Create a client-specific relapse trigger profile with recognizable descriptions, unclear-entry flags, practitioner review, and update history.",
		"h1": "Trigger Identification List",
		"intro": "Trigger Identification List is a recovery-support tool for practitioners and clients in recovery. It helps them identify personal relapse triggers and describe them clearly enough to recognize before or during high-risk moments.",
		"demoTitle": "Build a sample trigger profile",
		"demoPrompt": "Interested in using Trigger Identification List with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0807-f-044-rp-002-r001-trigger-identification-list.md",
		"specId": "0807-f-044-rp-002-r001-trigger-identification-list",
		"tags": {
			"framework": [],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Relapse prevention",
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it early in relapse-prevention work when triggers need to be named and made recognizable before action planning."
			},
			{
				"title": "What It Captures",
				"body": "It captures trigger names, recognizable descriptions, uncertainty or unclear flags, practitioner notes where provided, and update history."
			},
			{
				"title": "Boundary With Action Planning",
				"body": "The result can feed a Trigger Action Plan or Relapse Prevention Plan, but this tool does not create coping steps or response mappings."
			}
		],
		"faqItems": [
			{
				"question": "Does this include coping strategies?",
				"answer": "No. It identifies and describes triggers; coping or response steps belong in a separate planning tool."
			},
			{
				"question": "What if a client enters a vague trigger?",
				"answer": "The entry can be flagged for clarification rather than removed or treated as complete."
			},
			{
				"question": "Can triggers be updated over time?",
				"answer": "Yes. The trigger profile supports updates and history as new triggers are identified."
			},
			{
				"question": "Does no trigger entry mean there are no triggers?",
				"answer": "No. No entries means no trigger profile has been created, not an inferred absence of triggers."
			}
		]
	},
	{
		"toolType": "triggerActionPlan",
		"slug": "trigger-action-plan",
		"title": "Trigger Action Plan Demo | Qwoach",
		"metaDescription": "Create a trigger-response plan that maps priority relapse triggers to concrete actions, flags unmatched triggers, and supports review.",
		"h1": "Trigger Action Plan",
		"intro": "Trigger Action Plan is a recovery-support planning tool for practitioners and clients in recovery. It helps turn identified personal triggers into specific, realistic responses the client can use when those triggers occur.",
		"demoTitle": "Create a sample trigger action plan",
		"demoPrompt": "Interested in using Trigger Action Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0808-f-044-rp-003-r001-trigger-action-plan.md",
		"specId": "0808-f-044-rp-003-r001-trigger-action-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Substance use",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after triggers are identified and the client needs concrete responses tied to those triggers."
			},
			{
				"title": "What It Captures",
				"body": "It captures trigger-response mappings, feasibility or support notes where entered, unmatched triggers, incomplete responses, and update history."
			},
			{
				"title": "Important Limits",
				"body": "It does not discover triggers beyond what is needed to populate the plan, recommend coping responses, or provide clinical risk ratings."
			}
		],
		"faqItems": [
			{
				"question": "Can this import triggers from a Trigger Identification List?",
				"answer": "Yes. When available, triggers can be imported to reduce re-entry and preserve continuity."
			},
			{
				"question": "Can it be used without a prior trigger list?",
				"answer": "Yes. Priority triggers can be entered directly when no prior list is available."
			},
			{
				"question": "What makes a plan complete?",
				"answer": "A finalized plan requires each priority trigger to have at least one usable response."
			},
			{
				"question": "Does it recommend actions for the client?",
				"answer": "No. Responses are entered by the client and practitioner or supported by the source structure; the system does not invent recommendations."
			}
		]
	},
	{
		"toolType": "earlyWarningSignsChecklist",
		"slug": "early-warning-signs-checklist",
		"title": "Early Warning Signs Checklist Demo | Qwoach",
		"metaDescription": "Identify individualized early warning signs of increased relapse risk with a checklist profile, uncertainty flags, and practitioner review.",
		"h1": "Early Warning Signs Checklist",
		"intro": "Early Warning Signs Checklist is a recovery-support checklist for practitioners and clients in recovery. It helps identify individualized early warning signs so the client can recognize rising relapse risk before it escalates.",
		"demoTitle": "Try a sample checklist",
		"demoPrompt": "Interested in using Early Warning Signs Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0809-f-044-rp-004-r001-early-warning-signs-checklist.md",
		"specId": "0809-f-044-rp-004-r001-early-warning-signs-checklist",
		"tags": {
			"framework": [],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Risk review"
			],
			"topic": [
				"Relapse prevention",
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the client and practitioner need to notice relapse risk earlier by naming recognizable warning signs."
			},
			{
				"title": "What It Captures",
				"body": "It captures warning signs, recognition details, unsure or incomplete states, practitioner notes where entered, and update history."
			},
			{
				"title": "Boundary With Response Planning",
				"body": "The checklist can feed a Relapse Prevention Plan, Trigger Action Plan, or Coping Plan, but it does not itself prescribe responses."
			}
		],
		"faqItems": [
			{
				"question": "Does this score relapse risk?",
				"answer": "No. It identifies warning signs and does not infer severity, imminent risk, or clinical meaning."
			},
			{
				"question": "What if the client is unsure whether something is a warning sign?",
				"answer": "The client can mark it unsure so the practitioner can review it later."
			},
			{
				"question": "Does no selected sign mean there is no relapse risk?",
				"answer": "No. No selected signs should not be interpreted as no risk."
			},
			{
				"question": "Can the checklist change over time?",
				"answer": "Yes. Warning-sign profiles can be updated, and checklist version context should be preserved if source-defined items change."
			}
		]
	},
	{
		"toolType": "copingPlan",
		"slug": "coping-plan",
		"title": "Coping Plan Demo | Qwoach",
		"metaDescription": "Create a substance use recovery coping plan that maps urges, triggers, or distress situations to concrete realistic strategies.",
		"h1": "Coping Plan",
		"intro": "Coping Plan is a substance-use treatment recovery-support tool for practitioners and clients. It helps create a concrete set of coping strategies matched to urges, triggers, distress, or high-risk situations the client may face.",
		"demoTitle": "Create a sample coping plan",
		"demoPrompt": "Interested in using Coping Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0810-f-044-rp-005-r001-coping-plan.md",
		"specId": "0810-f-044-rp-005-r001-coping-plan",
		"tags": {
			"framework": [
				"CBT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Coping",
				"Substance use",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client needs concrete coping options ready for urges, triggers, distress, or other high-risk moments."
			},
			{
				"title": "What It Captures",
				"body": "It captures high-risk situations, one or more coping strategies for each, feasibility or access notes, unmatched situations, and update history."
			},
			{
				"title": "Important Limits",
				"body": "It does not create a full treatment plan, score clinical risk, provide emergency protocols, or recommend strategies not entered or source-supported."
			}
		],
		"faqItems": [
			{
				"question": "Does this recommend coping strategies automatically?",
				"answer": "No. Strategies are entered by the client and practitioner or supported by the source structure; the system does not invent recommendations."
			},
			{
				"question": "Can a strategy exist without a matched situation?",
				"answer": "Yes. It can remain as a general option, but it should be distinguished from matched strategies."
			},
			{
				"question": "What happens when a situation has no strategy?",
				"answer": "The plan flags the situation as unmatched or incomplete until a coping option is added or clarified."
			},
			{
				"question": "Can situations be imported from trigger or risk tools?",
				"answer": "Yes, when available, related trigger or risk profiles can supply situations so the coping plan does not require duplicate entry."
			}
		]
	},
	{
		"toolType": "cravingUrgeMonitoringLog",
		"slug": "craving-urge-monitoring-log",
		"title": "Craving / Urge Monitoring Log for Relapse Prevention | Qwoach",
		"metaDescription": "Explore a relapse-prevention log for tracking craving or urge episodes over time, with descriptive patterns for practitioner review.",
		"h1": "Craving / Urge Monitoring Log",
		"intro": "Craving / Urge Monitoring Log is a relapse-prevention self-monitoring tool for practitioners who need to understand how a client's cravings or urges change over time. It helps the practitioner review episode timing, intensity or frequency changes, and reported links to contexts, triggers, or coping responses when available.",
		"demoTitle": "Explore the sample log and review the emerging pattern",
		"demoPrompt": "Interested in using Craving / Urge Monitoring Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0811-f-044-rp-006-r001-craving-urge-monitoring-log.md",
		"specId": "0811-f-044-rp-006-r001-craving-urge-monitoring-log",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a practitioner needs repeated craving or urge information across time and situations rather than a single recall-based impression."
			},
			{
				"title": "What It Captures",
				"body": "The supported content is craving or urge episode information, including timing, intensity or frequency information when available, and reported context, trigger, or coping-response information when available."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not score relapse risk, infer causes, diagnose, predict relapse, or generate clinical recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the log create a relapse-risk score?",
				"answer": "No. The log produces a descriptive pattern of reported craving or urge episodes, not a relapse-risk score or prediction."
			},
			{
				"question": "Can the client submit partial entries?",
				"answer": "Yes. The client can record an episode even when some details are missing, and missing information is shown as absent rather than inferred."
			},
			{
				"question": "When is it a longitudinal pattern instead of a single episode record?",
				"answer": "A longitudinal pattern requires multiple episodes. With fewer than two entries, the result should be treated as an episode record."
			},
			{
				"question": "Are the demo entries saved into my account?",
				"answer": "No. Saving keeps the tool itself; fictional demo entries and sample summaries do not become real client data."
			}
		]
	},
	{
		"toolType": "highRiskSituationMap",
		"slug": "high-risk-situation-map",
		"title": "High-Risk Situation Map for Relapse Prevention | Qwoach",
		"metaDescription": "Explore a collaborative relapse-prevention map for identifying specific contexts and situations associated with higher relapse risk.",
		"h1": "High-Risk Situation Map",
		"intro": "High-Risk Situation Map is a relapse-prevention mapping tool for practitioners working collaboratively with clients in recovery. It helps practitioner and client identify specific contexts and situations most associated with relapse risk so they can plan avoidance, preparation, or different responses.",
		"demoTitle": "Build a sample risk-context map",
		"demoPrompt": "Interested in using High-Risk Situation Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0812-f-044-rp-007-r001-high-risk-situation-map.md",
		"specId": "0812-f-044-rp-007-r001-high-risk-situation-map",
		"tags": {
			"framework": [],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during relapse-prevention work when practitioner and client need to make risk contexts specific enough to recognize and plan around."
			},
			{
				"title": "Practitioner And Client Roles",
				"body": "The client contributes situation details; the practitioner guides clarification and uses the map for planning. The system organizes reported content without interpreting it."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not rank risk, predict relapse, or generate coping strategies beyond what practitioner and client enter."
			}
		],
		"faqItems": [
			{
				"question": "Is this a relapse-risk score?",
				"answer": "No. It is a descriptive map of reported risk situations, not a score or prediction."
			},
			{
				"question": "Can the map include both past triggers and future risks?",
				"answer": "Yes. The map can include prior triggering situations and likely future risk situations when those are reported."
			},
			{
				"question": "What happens when an entry is vague?",
				"answer": "Vague entries should be flagged for clarification rather than interpreted by the system."
			},
			{
				"question": "Are sample situations saved when I save the tool?",
				"answer": "No. Saving keeps the fixed tool; fictional sample situations do not become real client data."
			}
		]
	},
	{
		"toolType": "lapseAnalysis",
		"slug": "lapse-analysis",
		"title": "Lapse Analysis Tool for Relapse Prevention | Qwoach",
		"metaDescription": "Explore a collaborative relapse-prevention tool for analyzing one lapse incident and capturing learning points for future strategy changes.",
		"h1": "Lapse Analysis",
		"intro": "Lapse Analysis is a collaborative relapse-prevention incident-analysis tool for practitioners working with a client after a lapse. It helps clarify the high-risk situation, the coping response or absence of response, and learning points that can inform future relapse-prevention strategies.",
		"demoTitle": "Analyze a sample lapse incident",
		"demoPrompt": "Interested in using Lapse Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0813-f-044-rp-008-r001-lapse-analysis.md",
		"specId": "0813-f-044-rp-008-r001-lapse-analysis",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One Incident At A Time",
				"body": "Each analysis centers on a specific lapse. Multiple incidents should be separate analyses rather than automatically merged."
			},
			{
				"title": "What It Captures",
				"body": "The supported content is the lapse incident, the high-risk situation, the coping response or lack of response, and learning points specific enough to modify future strategies."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not assign blame, predict recurrence, diagnose, or generate treatment steps beyond entered content."
			}
		],
		"faqItems": [
			{
				"question": "Can this analyze several lapses at once?",
				"answer": "No. One analysis centers on one lapse incident; multiple incidents should be handled as separate analyses."
			},
			{
				"question": "What if the client did not use a coping response?",
				"answer": "The absence of a coping response should be explicitly representable in the analysis."
			},
			{
				"question": "Does the tool explain the cause of the lapse?",
				"answer": "No. It organizes entered incident information and learning points without generating causal conclusions."
			},
			{
				"question": "Will the demo incident be saved?",
				"answer": "No. Saving keeps the tool itself; fictional incident content does not become real client data."
			}
		]
	},
	{
		"toolType": "emergencySupportContactList",
		"slug": "emergency-support-contact-list",
		"title": "Emergency Support Contact List for Relapse Prevention | Qwoach",
		"metaDescription": "Explore a relapse-prevention contact list for arranging support people, services, and emergency options for high-risk moments.",
		"h1": "Emergency Support Contact List",
		"intro": "Emergency Support Contact List is a relapse-prevention support-network and contact-sequence tool for practitioners helping clients prepare for cravings, triggers, relapse risk, or emergencies. It helps the client know whom to contact, under what circumstances, and how emergency escalation is included when needed.",
		"demoTitle": "Arrange a sample contact sequence",
		"demoPrompt": "Interested in using Emergency Support Contact List with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0814-f-044-rp-009-r001-emergency-support-contact-list.md",
		"specId": "0814-f-044-rp-009-r001-emergency-support-contact-list",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Relapse prevention",
				"Crisis response"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The list captures support people or services, contact methods, circumstances for use, reachability information when known, sequence order, and emergency escalation entries when included."
			},
			{
				"title": "Reachability Matters",
				"body": "A contact without a contact method should not be marked reachable. Unreachable or incomplete contacts are flagged for update."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not guarantee a contact will respond, grade clinical risk, or generate emergency instructions beyond entered content."
			}
		],
		"faqItems": [
			{
				"question": "Is contact order configurable?",
				"answer": "Yes. Contact sequence order is a supported setting because it changes who is considered first during urgent moments."
			},
			{
				"question": "What happens if a contact method is missing?",
				"answer": "The contact should be shown as missing reachability details and should not be marked reachable."
			},
			{
				"question": "Does the tool provide emergency instructions?",
				"answer": "No. It displays entered support contacts and emergency escalation entries; it does not generate crisis instructions."
			},
			{
				"question": "Are fictional demo contacts saved?",
				"answer": "No. Saving can preserve the tool and intentional reusable setup, but sample contacts do not become real client data."
			}
		]
	},
	{
		"toolType": "reasonsForRecoveryConsequencesReminder",
		"slug": "reasons-for-recovery-consequences-reminder",
		"title": "Reasons for Recovery Reminder for Relapse Prevention | Qwoach",
		"metaDescription": "Explore a relapse-prevention reminder for capturing personal reasons for not using and consequences of using during vulnerable moments.",
		"h1": "Reasons for Recovery / Consequences Reminder",
		"intro": "Reasons for Recovery / Consequences Reminder is a relapse-prevention motivational reminder tool for practitioners helping clients prepare for urges or relapse risk. It captures the client's personal positive reasons for not using and personal negative consequences of using so those reminders can be revisited when needed.",
		"demoTitle": "Create a sample two-part reminder",
		"demoPrompt": "Interested in using Reasons for Recovery / Consequences Reminder with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0815-f-044-rp-010-r001-reasons-for-recovery-consequences-reminder.md",
		"specId": "0815-f-044-rp-010-r001-reasons-for-recovery-consequences-reminder",
		"tags": {
			"framework": [],
			"toolType": [
				"Therapeutic document"
			],
			"workflow": [
				"Therapeutic consolidation"
			],
			"topic": [
				"Substance use",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Two Supported Content Areas",
				"body": "The reminder captures positive reasons for not using and negative consequences of using. Empty sections remain visible as incomplete."
			},
			{
				"title": "Client Wording",
				"body": "The reminder preserves the client's own wording and does not generate substantive reasons or consequences."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not measure readiness, score motivation, or provide clinical interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate reasons for the client?",
				"answer": "No. The tool organizes client-provided reasons and consequences; it does not generate substantive motivational content."
			},
			{
				"question": "Can one section be left blank?",
				"answer": "Yes. The reminder can be saved in an incomplete state, and the empty section should be clearly shown."
			},
			{
				"question": "What if the reminder sounds generic?",
				"answer": "Generic entries should remain visible for practitioner review as possibly less personal, not automatically rejected."
			},
			{
				"question": "Are sample reminders saved to my account?",
				"answer": "No. Saving keeps the fixed tool; fictional demo reminder text does not become real client data."
			}
		]
	},
	{
		"toolType": "recoveryRewardPlan",
		"slug": "recovery-reward-plan",
		"title": "Recovery Reward Plan for Relapse Prevention | Qwoach",
		"metaDescription": "Explore a relapse-prevention plan for linking specific recovery-supporting behaviors with meaningful client rewards.",
		"h1": "Recovery Reward Plan",
		"intro": "Recovery Reward Plan is a relapse-prevention reinforcement-planning tool for practitioners helping clients strengthen positive recovery actions. It helps identify specific recovery-supporting behaviors and pair them with rewards that are meaningful to the client.",
		"demoTitle": "Build sample behavior-reward pairs",
		"demoPrompt": "Interested in using Recovery Reward Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0816-f-044-rp-011-r001-recovery-reward-plan.md",
		"specId": "0816-f-044-rp-011-r001-recovery-reward-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Relapse prevention",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures specific recovery-supporting behaviors, meaningful rewards, and explicit pairings between them."
			},
			{
				"title": "Incomplete Pairs",
				"body": "A behavior without a reward or a reward without a behavior remains visible as incomplete so the practitioner can review it."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not add point systems, reinforcement schedules, notifications, compliance judgments, or reward-delivery tracking."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool track whether rewards were delivered?",
				"answer": "No. The supported tool creates behavior-reward pairings; reward-delivery tracking is not defined."
			},
			{
				"question": "Can behaviors and rewards be drafted separately?",
				"answer": "Yes. Behaviors and rewards can be entered before pairing, and unpaired items should be shown as incomplete."
			},
			{
				"question": "Does the system suggest rewards?",
				"answer": "No. Rewards are supplied by the client and/or practitioner; the system does not invent them."
			},
			{
				"question": "Are demo pairings saved?",
				"answer": "No. Saving keeps the fixed tool; fictional demo behaviors and rewards do not become real client data."
			}
		]
	},
	{
		"toolType": "happinessScale",
		"slug": "happiness-scale",
		"title": "Happiness Scale for CRA Treatment Planning | Qwoach",
		"metaDescription": "Explore a CRA assessment and monitoring tool for domain-specific satisfaction profiles and repeatable progress review over time.",
		"h1": "Happiness Scale",
		"intro": "Happiness Scale is a Community Reinforcement Approach assessment and monitoring tool for practitioners beginning or monitoring substance use treatment. It helps produce a domain-specific profile of the client's current satisfaction and a repeatable signal of progress over time for treatment planning.",
		"demoTitle": "Preview the sample profile and reassessment review",
		"demoPrompt": "Interested in using Happiness Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0817-f-045-cra-001-r001-happiness-scale.md",
		"specId": "0817-f-045-cra-001-r001-happiness-scale",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Repeatability",
				"body": "The same domains must be reassessed over time to support progress or setback review. Changed domains or anchors should be treated as a new structure rather than silently merged."
			},
			{
				"title": "First Administration",
				"body": "A first administration can produce a current profile but has no progress signal until there is a prior administration for comparison."
			},
			{
				"title": "Important Limits",
				"body": "The demo must not invent life domains, scale anchors, item wording, summary scoring, diagnoses, or treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo show the official domains and rating scale?",
				"answer": "No. The supplied specification does not resolve exact domains, anchors, item wording, or scoring, so the demo must avoid inventing them."
			},
			{
				"question": "Can practitioners customize domains?",
				"answer": "No. Once the Happiness Scale structure is defined, domains should remain fixed for comparability over time."
			},
			{
				"question": "What happens on the first administration?",
				"answer": "The first administration can show a current domain profile, but it has no progress comparison yet."
			},
			{
				"question": "Are sample profile values saved?",
				"answer": "No. Saving keeps the fixed tool; fictional sample administrations do not become real client data."
			}
		]
	},
	{
		"toolType": "craTreatmentPlan",
		"slug": "cra-treatment-plan",
		"title": "CRA Treatment Plan for Individualized Priorities | Qwoach",
		"metaDescription": "Explore a collaborative CRA planning tool for turning assessment concerns into individualized treatment priorities and first-focus direction.",
		"h1": "CRA Treatment Plan",
		"intro": "CRA Treatment Plan is a Community Reinforcement Approach planning tool for practitioners translating assessment information into treatment direction. It helps practitioner and client identify individualized priorities, connect them to assessed life-domain concerns where available, and decide what will be addressed first.",
		"demoTitle": "Create a sample priority plan",
		"demoPrompt": "Interested in using CRA Treatment Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0818-f-045-cra-002-r001-cra-treatment-plan.md",
		"specId": "0818-f-045-cra-002-r001-cra-treatment-plan",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Assessment Linkage",
				"body": "Priorities can be linked to assessed concerns where available. If assessment information is missing, the plan can be drafted but should show weaker linkage."
			},
			{
				"title": "First Focus",
				"body": "The order or first-focus selection matters because it shapes what practitioner and client understand will be addressed first."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not automatically generate priorities, interventions, or generic care-plan content."
			}
		],
		"faqItems": [
			{
				"question": "Can the tool create priorities automatically from assessment data?",
				"answer": "No. Priorities are entered through practitioner-client collaboration; the system organizes and displays them."
			},
			{
				"question": "Is priority order a supported setting?",
				"answer": "Yes. Priority order or first-focus selection is supported because it changes treatment direction and review."
			},
			{
				"question": "Can the plan be drafted without assessment information?",
				"answer": "Yes. It can be drafted, but it should show weak linkage to assessed concerns."
			},
			{
				"question": "Are sample priorities saved as client data?",
				"answer": "No. Saving preserves the tool and intentional setup, but fictional sample priorities do not become real client data."
			}
		]
	},
	{
		"toolType": "goalsOfCounselingForm",
		"slug": "goals-of-counseling-form",
		"title": "Goals of Counseling Form for CRA Counseling | Qwoach",
		"metaDescription": "Explore a CRA counseling form for linking treatment priorities to measurable goals, concrete actions, and reviewable progress.",
		"h1": "Goals of Counseling Form",
		"intro": "Goals of Counseling Form is a Community Reinforcement Approach counseling tool for practitioners working with clients to define concrete change targets. It helps connect treatment priorities to measurable goals, specific actions, and reviewable progress over time.",
		"demoTitle": "Build sample goal-action pairs",
		"demoPrompt": "Interested in using Goals of Counseling Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0819-f-045-cra-003-r001-goals-of-counseling-form.md",
		"specId": "0819-f-045-cra-003-r001-goals-of-counseling-form",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting",
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The form captures treatment-priority links, desired life changes, measurable goals, concrete actions, and reviewable progress state where entered."
			},
			{
				"title": "Incomplete Items",
				"body": "A goal without an action, or an action without a linked goal or priority, should remain visible for review and revision."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not invent action steps, calculate progress scores, or interpret progress automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does the form generate action steps?",
				"answer": "No. Actions are entered by the practitioner and client; the system organizes and links them."
			},
			{
				"question": "Can a goal be saved without an action?",
				"answer": "A goal without an action can be shown as incomplete for review and revision."
			},
			{
				"question": "How is progress assessed?",
				"answer": "Progress is assessed over time against reviewable goal-action entries; unsupported measures or interpretations are not added by the system."
			},
			{
				"question": "Are sample goals saved?",
				"answer": "No. Saving keeps the fixed tool; fictional demo goals and actions do not become real client data."
			}
		]
	},
	{
		"toolType": "functionalAnalysisOfSubstanceUse",
		"slug": "functional-analysis-of-substance-use",
		"title": "Functional Analysis of Substance Use for CRA | Qwoach",
		"metaDescription": "Explore a CRA formulation tool for mapping substance-use antecedents, consequences, reinforcers, and competing alternatives.",
		"h1": "Functional Analysis of Substance Use",
		"intro": "Functional Analysis of Substance Use is a Community Reinforcement Approach formulation tool for practitioners working with clients when substance use is maintained by unclear contexts, consequences, or reinforcers. It helps organize antecedents or contexts, immediate and longer-term consequences or reinforcers, and potential competing alternatives into a use-function formulation.",
		"demoTitle": "Build a sample functional map",
		"demoPrompt": "Interested in using Functional Analysis of Substance Use with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0820-f-045-cra-004-r001-functional-analysis-of-substance-use.md",
		"specId": "0820-f-045-cra-004-r001-functional-analysis-of-substance-use",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Functional Components",
				"body": "The supported components are antecedents or contexts associated with use, immediate and longer-term consequences or reinforcers, and potential competing alternatives."
			},
			{
				"title": "Separate Information Types",
				"body": "The result should distinguish client-reported information, system organization, and practitioner interpretation where practitioner notes are used."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create diagnoses, causal certainty, risk scores, or intervention recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide what causes the client's substance use?",
				"answer": "No. It organizes reported information into a descriptive functional map without automated causal certainty."
			},
			{
				"question": "Can one map include several substance-use patterns?",
				"answer": "Multiple patterns may require separate analyses if they have different antecedents or reinforcers."
			},
			{
				"question": "What happens if a component is missing?",
				"answer": "The formulation should be shown as incomplete, with the missing component visible for review."
			},
			{
				"question": "Are demo formulation notes saved?",
				"answer": "No. Saving keeps the fixed tool; fictional components and sample notes do not become real client data."
			}
		]
	},
	{
		"toolType": "functionalAnalysisOfHealthyBehavior",
		"slug": "functional-analysis-of-healthy-behavior",
		"title": "Functional Analysis of Healthy Behavior Demo | Qwoach",
		"metaDescription": "Explore a CRA formulation tool for mapping healthy non-using behavior, reinforcers, cues, consequences, and reinforcement targets.",
		"h1": "Functional Analysis of Healthy Behavior",
		"intro": "Functional Analysis of Healthy Behavior is a CRA-focused formulation tool for substance use treatment practitioners. It helps practitioners and clients identify a healthy, non-using behavior and organize the situations, cues, consequences, and reinforcers that can strengthen it.",
		"demoTitle": "Explore the formulation map",
		"demoPrompt": "Interested in using Functional Analysis of Healthy Behavior with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0821-f-045-cra-005-r001-functional-analysis-of-healthy-behavior.md",
		"specId": "0821-f-045-cra-005-r001-functional-analysis-of-healthy-behavior",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when treatment is focused on increasing rewarding alternatives to substance use and the practitioner needs to understand what already supports a client's healthy activity."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the behavior or activity, contexts and cues, consequences, existing reinforcement, potential reinforcement, actionable targets, unresolved areas, and practitioner notes."
			},
			{
				"title": "Longitudinal Use",
				"body": "Prior formulations remain viewable so the practitioner can compare targets, reinforcers, and circumstances over time."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool analyze substance-use episodes?",
				"answer": "No. It is limited to healthy, recovery-compatible behavior and reinforcement targets."
			},
			{
				"question": "Does it score motivation or readiness?",
				"answer": "No. It organizes entered formulation information and shows unresolved elements without creating scores."
			},
			{
				"question": "Can the client complete it alone?",
				"answer": "The supported mode is guided participation during shared completion with the practitioner."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The tool itself is saved as-is. Fictional demo entries are not saved as real client records."
			}
		]
	},
	{
		"toolType": "problemSolvingWorksheet",
		"slug": "problem-solving-worksheet",
		"title": "Problem-Solving Worksheet for CRA Treatment | Qwoach",
		"metaDescription": "Explore a CRA-related worksheet for defining recovery-relevant problems, considering responses, choosing actions, and reviewing next steps.",
		"h1": "Problem-Solving Worksheet",
		"intro": "Problem-Solving Worksheet is a CRA-related structured worksheet for substance use treatment practitioners to send to clients. It helps clients define a concrete recovery-relevant problem, consider possible responses and likely consequences, choose a feasible action, and record how they will review whether it helped.",
		"demoTitle": "Try the worksheet",
		"demoPrompt": "Interested in using Problem-Solving Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0822-f-045-cra-006-r001-problem-solving-worksheet.md",
		"specId": "0822-f-045-cra-006-r001-problem-solving-worksheet",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Problem solving"
			],
			"topic": [
				"Substance use",
				"Problem solving"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client faces a concrete problem that blocks recovery-supporting behavior or engagement."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures the problem, possible responses, likely consequences, selected action, next steps, feasibility details, and review basis."
			},
			{
				"title": "Follow-Up",
				"body": "Prior problem/action records persist so the practitioner can later review whether the attempted action improved the problem."
			}
		],
		"faqItems": [
			{
				"question": "Does the worksheet generate advice for the client?",
				"answer": "No. It organizes client-entered options and consequences but does not generate substantive options or decide the best action."
			},
			{
				"question": "Can partial worksheets be reviewed?",
				"answer": "Yes. Partial work remains reviewable, and missing sequence elements are visible."
			},
			{
				"question": "Can one worksheet include several problems?",
				"answer": "No. The supported structure is one concrete problem at a time; multiple problems should be separated."
			},
			{
				"question": "What gets saved from the demo?",
				"answer": "The tool itself is saved. Fictional problem content and sample responses are not saved as real client data."
			}
		]
	},
	{
		"toolType": "communicationSkillsWorksheet",
		"slug": "communication-skills-worksheet",
		"title": "Communication Skills Worksheet for CRA Treatment | Qwoach",
		"metaDescription": "Explore a CRA-related worksheet for identifying communication targets, response patterns, and recovery-supporting relationship goals.",
		"h1": "Communication Skills Worksheet",
		"intro": "Communication Skills Worksheet is a CRA-related worksheet for substance use treatment practitioners to send to clients. It helps clients identify relevant people and situations, clarify the desired message or outcome, prepare a usable response pattern, and connect the target to a relationship or recovery-supporting goal.",
		"demoTitle": "Build a sample target",
		"demoPrompt": "Interested in using Communication Skills Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0823-f-045-cra-007-r001-communication-skills-worksheet.md",
		"specId": "0823-f-045-cra-007-r001-communication-skills-worksheet",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Substance use",
				"Interpersonal relationships",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client's interpersonal interactions affect recovery or access to non-using social reinforcement."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures people, situations, desired messages or outcomes, response patterns, linked goals, barriers, review status, and practitioner notes."
			},
			{
				"title": "Practice And Follow-Up",
				"body": "The result can support role-play or real-world tryout, followed by review of what happened."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write scripts for the client?",
				"answer": "No. It captures response patterns entered by the client or refined with the practitioner; it does not invent definitive scripts."
			},
			{
				"question": "Can a client enter more than one communication target?",
				"answer": "Yes. Multiple targets are supported and should be separated by person or situation."
			},
			{
				"question": "Does it score communication skill?",
				"answer": "No. It shows completeness and organization only, without hidden ratings or unsupported classifications."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself is saved as-is. Fictional demo targets are not saved as real client data."
			}
		]
	},
	{
		"toolType": "drinkDrugRefusalPlan",
		"slug": "drink-drug-refusal-plan",
		"title": "Drink/Drug Refusal Plan for CRA Treatment | Qwoach",
		"metaDescription": "Explore a CRA refusal planning tool for substance-use offers, cues, social pressure, refusal responses, fallback actions, and barriers.",
		"h1": "Drink/Drug Refusal Plan",
		"intro": "Drink/Drug Refusal Plan is a CRA-related situation-response planning tool for substance use treatment practitioners to send to clients. It helps clients identify likely offers, cues, or pressure to drink or use drugs, prepare refusal responses, add fallback actions, and anticipate barriers.",
		"demoTitle": "Plan a sample response",
		"demoPrompt": "Interested in using Drink/Drug Refusal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0824-f-045-cra-008-r001-drink-drug-refusal-plan.md",
		"specId": "0824-f-045-cra-008-r001-drink-drug-refusal-plan",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Substance use",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before expected exposure to drink or drug offers, cues, or social pressure."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures high-risk situations, social context, refusal responses, fallback actions, anticipated barriers, review status, and practitioner notes."
			},
			{
				"title": "History",
				"body": "Prior plans remain available so recurring or changing situations can be compared over time."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool predict relapse risk?",
				"answer": "No. It organizes situation-response planning and does not create risk scores or predictions."
			},
			{
				"question": "Does it generate refusal scripts?",
				"answer": "No. It captures responses entered by the client or refined with the practitioner."
			},
			{
				"question": "Can one plan include multiple situations?",
				"answer": "Yes. Multiple distinct situations are supported, and each should have its own response row."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool itself is saved as-is. Sample situations and responses are not saved as real client data."
			}
		]
	},
	{
		"toolType": "jobSkillsPlan",
		"slug": "job-skills-plan",
		"title": "Job Skills Plan for CRA Treatment | Qwoach",
		"metaDescription": "Explore a CRA vocational action plan for defining employment-related needs, skill gaps, realistic next steps, barriers, and supports.",
		"h1": "Job Skills Plan",
		"intro": "Job Skills Plan is a CRA-related vocational action planning tool for substance use treatment practitioners and clients to complete together. It helps define an employment-related target, identify skill gaps or work-readiness tasks, choose realistic next steps, and address practical barriers and supports.",
		"demoTitle": "Explore a sample plan",
		"demoPrompt": "Interested in using Job Skills Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0825-f-045-cra-009-r001-job-skills-plan.md",
		"specId": "0825-f-045-cra-009-r001-job-skills-plan",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when vocational functioning is relevant to non-using reinforcement in substance use treatment."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures the vocational target or need, skill gaps, work-readiness tasks, next steps, barriers, supports, practitioner notes, and unresolved areas."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not recommend careers, score employability, analyze labor markets, or automate job search."
			}
		],
		"faqItems": [
			{
				"question": "Is this a career assessment?",
				"answer": "No. It is a CRA-related vocational action plan focused on feasible employment-supporting steps."
			},
			{
				"question": "Can the client complete it alone?",
				"answer": "The supported default is collaborative completion with the practitioner."
			},
			{
				"question": "Does it score work readiness?",
				"answer": "No. It shows descriptive plan elements and unresolved areas without readiness scores."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself is saved as-is. Fictional vocational entries are not saved as real client data."
			}
		]
	},
	{
		"toolType": "socialRecreationalActivityPlan",
		"slug": "social-recreational-activity-plan",
		"title": "Social/Recreational Activity Plan for CRA | Qwoach",
		"metaDescription": "Explore a CRA activity plan for identifying recovery-compatible social or recreational alternatives, practical details, and obstacles.",
		"h1": "Social/Recreational Activity Plan",
		"intro": "Social/Recreational Activity Plan is a CRA-related activity planning worksheet for substance use treatment practitioners to send to clients. It helps clients identify rewarding social or recreational alternatives to substance use, match activities to interests and circumstances, confirm recovery compatibility, and define practical details and obstacles.",
		"demoTitle": "Plan a sample activity",
		"demoPrompt": "Interested in using Social/Recreational Activity Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0826-f-045-cra-010-r001-social-recreational-activity-plan.md",
		"specId": "0826-f-045-cra-010-r001-social-recreational-activity-plan",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client needs accessible social or recreational alternatives that can support non-use or recovery goals."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures activity, interest and circumstance fit, recovery compatibility, practical participation details, obstacles, review notes, and history."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool is not a generic activity recommender, calendar, or habit tracker."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend activities?",
				"answer": "No. It organizes activities entered by the client and reviewed by the practitioner."
			},
			{
				"question": "Can clients enter several activities?",
				"answer": "Yes. Multiple activities are supported, and each should have its own practical details."
			},
			{
				"question": "Does it track location or calendars?",
				"answer": "No. Location tracking and calendar automation are not part of the core tool."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself is saved as-is. Sample demo activities are not saved as real client data."
			}
		]
	},
	{
		"toolType": "relationshipHappinessScale",
		"slug": "relationship-happiness-scale",
		"title": "Relationship Happiness Scale for CRA Treatment | Qwoach",
		"metaDescription": "Explore the CRA-related Relationship Happiness Scale concept for reviewing relationship satisfaction areas, priorities, and change over time.",
		"h1": "Relationship Happiness Scale",
		"intro": "Relationship Happiness Scale is a CRA-related scale/profile assessment for substance use treatment practitioners. It helps practitioners review client-reported relationship satisfaction across relevant areas so strengths, dissatisfaction points, priority areas, and repeated changes can be compared when the scale structure is available.",
		"demoTitle": "Preview the review flow",
		"demoPrompt": "Interested in using Relationship Happiness Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0827-f-045-cra-011-r001-relationship-happiness-scale.md",
		"specId": "0827-f-045-cra-011-r001-relationship-happiness-scale",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Interpersonal relationships",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Can Show",
				"body": "When the scale structure is resolved, the tool can show reported satisfaction values by relationship area, strengths, dissatisfaction points, priority areas, and change over time."
			},
			{
				"title": "Important Boundary",
				"body": "The supplied specification does not define the exact areas, anchors, scoring rules, or worksheet layout, so the public page must not invent them."
			},
			{
				"title": "Comparison Over Time",
				"body": "Repeated administrations can be compared only when the same scale structure is used or version differences are clearly marked."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo show the exact scale items?",
				"answer": "No. The exact areas and anchors are unresolved in the supplied product specification."
			},
			{
				"question": "Does the tool create relationship diagnoses?",
				"answer": "No. It reports and organizes satisfaction information without diagnostic conclusions."
			},
			{
				"question": "Can partial responses be reviewed?",
				"answer": "Yes. Incomplete responses should produce a partial profile without imputing missing values."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself is saved as-is. Fictional ratings or invented scale content are not saved."
			}
		]
	},
	{
		"toolType": "perfectRelationshipWorksheet",
		"slug": "perfect-relationship-worksheet",
		"title": "Perfect Relationship Worksheet for CRA | Qwoach",
		"metaDescription": "Explore a CRA relationship goals worksheet for clarifying desired behaviors, expectations, current gaps, and priority changes.",
		"h1": "Perfect Relationship Worksheet",
		"intro": "Perfect Relationship Worksheet is a CRA-related guided worksheet for substance use treatment practitioners and clients to complete together. It helps clarify desired relationship behaviors and expectations, compare them with the current relationship, and identify priority changes that can support recovery-focused relationship work.",
		"demoTitle": "Explore the worksheet",
		"demoPrompt": "Interested in using Perfect Relationship Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0828-f-045-cra-012-r001-perfect-relationship-worksheet.md",
		"specId": "0828-f-045-cra-012-r001-perfect-relationship-worksheet",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Interpersonal relationships",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when relationship goals and expectations are unclear but relationship functioning matters for the client's recovery environment."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures relationship focus, desired behaviors, expectations, current-to-desired gaps, priority changes, unresolved markers, practitioner notes, and revisions."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not rate the relationship, evaluate a partner, or provide scripted interventions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a relationship satisfaction scale?",
				"answer": "No. It is a goals and expectations worksheet based on current-vs-desired clarification."
			},
			{
				"question": "Can multiple relationships be addressed in one worksheet?",
				"answer": "Multiple relationships should be separated into distinct worksheet instances or clearly separated sections."
			},
			{
				"question": "Does the system judge whether expectations are realistic?",
				"answer": "No. The practitioner can mark realism or actionability concerns, but the system does not make that judgment."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself is saved as-is. Fictional demo relationship content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "selfReminderToBeNice",
		"slug": "self-reminder-to-be-nice",
		"title": "Self-Reminder to Be Nice for CRA | Qwoach",
		"metaDescription": "Explore a CRA cue plan for recurring relationship situations, personal reminders, intended prosocial behavior, and optional noticed-use tracking.",
		"h1": "Self-Reminder to Be Nice",
		"intro": "Self-Reminder to Be Nice is a CRA-related personal cue tool for substance use treatment practitioners to send to clients. It helps clients define a recurring relationship situation, create a salient reminder cue, link it to a kind or prosocial behavior, and optionally notice use over time when tracking is enabled.",
		"demoTitle": "Set up a sample cue",
		"demoPrompt": "Interested in using Self-Reminder to Be Nice with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0829-f-045-cra-013-r001-self-reminder-to-be-nice.md",
		"specId": "0829-f-045-cra-013-r001-self-reminder-to-be-nice",
		"tags": {
			"framework": [
				"Community Reinforcement Approach"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Skill practice",
				"Between-session monitoring"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior change",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client wants a noticeable cue for responding differently in recurring relationship moments relevant to recovery-supporting relationships."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the recurring situation, personal cue, intended kind or prosocial behavior, relevance note, setup status, revisions, and optional noticed-use entries."
			},
			{
				"title": "Tracking Boundary",
				"body": "When tracking is off, the tool does not infer adherence. When tracking is on, reported use remains descriptive."
			}
		],
		"faqItems": [
			{
				"question": "Is this a full habit tracker?",
				"answer": "No. It is a simple cue-behavior tool with optional brief noticed-use tracking."
			},
			{
				"question": "Does it judge the quality of the client's behavior?",
				"answer": "No. It records the intended behavior and optional reported use without behavior quality ratings."
			},
			{
				"question": "What happens if use tracking is off?",
				"answer": "The result shows only the cue card and does not infer adherence."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself and selected use-tracking setting are saved. Fictional cue content and sample use records are not saved as real client data."
			}
		]
	},
	{
		"toolType": "targetBehaviorDefinition",
		"slug": "target-behavior-definition",
		"title": "Target Behavior Definition for Contingency Management | Qwoach",
		"metaDescription": "Explore a practitioner-only contingency management setup tool for defining objective target behavior, threshold, time window, and verification method.",
		"h1": "Target Behavior Definition",
		"intro": "Target Behavior Definition is a practitioner-only contingency management setup tool for substance use treatment practitioners. It helps practitioners specify the observable target behavior, achievement threshold, time window, objective verification method, and treatment-goal alignment that control incentive eligibility.",
		"demoTitle": "Define a sample target",
		"demoPrompt": "Interested in using Target Behavior Definition with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0830-f-046-cm-001-r001-target-behavior-definition.md",
		"specId": "0830-f-046-cm-001-r001-target-behavior-definition",
		"tags": {
			"framework": [
				"Contingency Management"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during contingency management setup when reward eligibility must be tied to a specific objectively verifiable behavior."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures target behavior, observable definition, achievement threshold, time window, objective verification method, treatment-goal alignment, readiness status, practitioner notes, and revisions."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not manage reward inventory, calculate incentives, schedule testing, verify outcomes, or adjudicate reward delivery."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client-facing version of this tool?",
				"answer": "No. The supplied configuration is practitioner-only."
			},
			{
				"question": "Can a target be marked ready without a verification method?",
				"answer": "No. A feasible objective verification method is required for readiness."
			},
			{
				"question": "Does this tool calculate incentives?",
				"answer": "No. It only defines the behavior criterion for incentive eligibility."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself is saved as-is. Fictional demo target definitions are not saved as real client data."
			}
		]
	},
	{
		"toolType": "verificationSchedule",
		"slug": "verification-schedule",
		"title": "Verification Schedule Demo for CM Programs | Qwoach",
		"metaDescription": "Build a practitioner-only verification schedule for objective checks, timing, responsibility, and exception handling in contingency management.",
		"h1": "Verification Schedule for Contingency Management",
		"intro": "Verification Schedule is a practitioner-only contingency management tool for practitioners who need objective checks scheduled for abstinence or another target behavior. It helps define evidence, frequency, timing, responsibility, and exception handling so incentive eligibility can be determined consistently.",
		"demoTitle": "Configure a sample verification schedule and review the generated check list.",
		"demoPrompt": "Interested in using Verification Schedule with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0831-f-046-cm-002-r001-verification-schedule.md",
		"specId": "0831-f-046-cm-002-r001-verification-schedule",
		"tags": {
			"framework": [
				"Contingency Management"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool before and during a contingency management intervention when incentive eligibility depends on objective checks occurring at the right frequency and with clear responsibility."
			},
			{
				"title": "What It Tracks",
				"body": "The schedule tracks evidence type, timing, responsible party, planned check instances, supported status, and exception handling. It does not track incentive value, treatment goals, symptom ratings, or clinical conclusions."
			},
			{
				"title": "History and Changes",
				"body": "Prospective configuration changes should preserve earlier schedule history so later review can distinguish what was planned from what occurred under each protocol version."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide whether a client is abstinent?",
				"answer": "No. It defines and displays objective verification checks and their statuses; it does not infer abstinence or clinical progress from schedule data alone."
			},
			{
				"question": "Can clients fill this out?",
				"answer": "No separate client experience is required. The tool is practitioner-only, although a surrounding platform may show practitioner-selected verification expectations."
			},
			{
				"question": "What statuses can be recorded?",
				"answer": "The supported check statuses are complete, missed, invalid, unavailable, and pending according to practitioner-entered status."
			},
			{
				"question": "What happens if required setup is missing?",
				"answer": "A draft schedule with missing evidence type, frequency, timing, or responsibility cannot be activated until those fields are resolved."
			}
		]
	},
	{
		"toolType": "urinePocTestRecord",
		"slug": "urine-poc-test-record",
		"title": "Urine/POC Test Record Demo | Qwoach",
		"metaDescription": "Record repeated urine or point-of-care test events with dates, target outcomes, and result states for contingency management review.",
		"h1": "Urine/POC Test Record for Contingency Management",
		"intro": "Urine/POC Test Record is a practitioner-only contingency management record for practitioners who need repeated rapid objective testing evidence. It helps capture urine or point-of-care test events over time so abstinence-contingent incentives can be awarded or withheld accurately.",
		"demoTitle": "Add sample test events and review the chronological testing history.",
		"demoPrompt": "Interested in using Urine/POC Test Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0832-f-046-cm-003-r001-urine-poc-test-record.md",
		"specId": "0832-f-046-cm-003-r001-urine-poc-test-record",
		"tags": {
			"framework": [
				"Contingency Management"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The record captures structured testing events over time: date or period, target outcome, result state, and optional note context when needed."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not diagnose, adjudicate biological disputes, define laboratory cutoffs, recommend treatment changes, or manage incentive redemption accounting."
			},
			{
				"title": "Corrections and Review",
				"body": "Corrected events should preserve enough history to understand later incentive decisions and update dependent descriptive sequence summaries."
			}
		],
		"faqItems": [
			{
				"question": "Can this tool record positive, negative, and invalid results?",
				"answer": "Yes. The supported result states include negative, positive, and invalid, with any additional non-result status only when explicitly configured."
			},
			{
				"question": "Does it determine clinical recovery status?",
				"answer": "No. It records objective test events and descriptive sequence information for incentive review; it does not make clinical conclusions."
			},
			{
				"question": "Is there a client form?",
				"answer": "No. The product is practitioner-only, and real-world testing participation is outside the product interaction."
			},
			{
				"question": "What makes an event incomplete?",
				"answer": "A test event is incomplete if it lacks the required client association, date or period, or result state."
			}
		]
	},
	{
		"toolType": "attendanceAdherenceRecord",
		"slug": "attendance-adherence-record",
		"title": "Attendance / Adherence Record Demo | Qwoach",
		"metaDescription": "Track verified attendance or medication adherence by incentive period with target behavior, verification source, and achievement status.",
		"h1": "Attendance / Adherence Record for Incentive Periods",
		"intro": "Attendance / Adherence Record is a practitioner-only contingency management record for practitioners who tie incentives to treatment attendance or medication adherence. It helps document verified achievement or non-achievement for each incentive period so incentives reinforce the target behavior only when earned.",
		"demoTitle": "Set up a sample target behavior and review period-by-period status.",
		"demoPrompt": "Interested in using Attendance / Adherence Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0833-f-046-cm-004-r001-attendance-adherence-record.md",
		"specId": "0833-f-046-cm-004-r001-attendance-adherence-record",
		"tags": {
			"framework": [
				"Contingency Management"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Medication adherence"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when the incentivized behavior is attendance or adherence and each incentive period needs verified achievement evidence."
			},
			{
				"title": "Practitioner and Staff Roles",
				"body": "The practitioner defines the target and reviews the record. Staff may enter period evidence when they are the verification source or delegated recorder."
			},
			{
				"title": "History and Comparison",
				"body": "When target behavior definitions or verification sources change, earlier periods should remain tied to the configuration in effect at that time."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool manage appointments or medication schedules?",
				"answer": "No. It records verified achievement or non-achievement for incentive periods; it does not manage treatment schedules or medication regimens."
			},
			{
				"question": "Can missed visits and nonadherence be shown separately?",
				"answer": "Yes, if configured distinctly. Missed visits and nonadherence should remain visibly distinct from achieved and unresolved periods."
			},
			{
				"question": "Is client self-report required?",
				"answer": "No. The supplied product is practitioner-only and uses practitioner or staff entry from the verification source."
			},
			{
				"question": "What blocks activation?",
				"answer": "Activation is blocked when the target behavior, period structure, or verification source is missing."
			}
		]
	},
	{
		"toolType": "escalatingVoucherSchedule",
		"slug": "escalating-voucher-schedule",
		"title": "Escalating Voucher Schedule Demo | Qwoach",
		"metaDescription": "Configure base value, escalation, bonus, and reset rules, then review current and cumulative earned voucher value from verified events.",
		"h1": "Escalating Voucher Schedule for Contingency Management",
		"intro": "Escalating Voucher Schedule is a practitioner-only contingency management tool for practitioners using increasing incentive value after consecutive target-behavior achievements. It helps calculate current and cumulative earned value from explicit base, escalation, bonus, and reset rules.",
		"demoTitle": "Configure sample rules and review the derived voucher history.",
		"demoPrompt": "Interested in using Escalating Voucher Schedule with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0834-f-046-cm-005-r001-escalating-voucher-schedule.md",
		"specId": "0834-f-046-cm-005-r001-escalating-voucher-schedule",
		"tags": {
			"framework": [
				"Contingency Management"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when consecutive verified achievements increase incentive value and non-achievement changes the next incentive state."
			},
			{
				"title": "What It Calculates",
				"body": "The schedule calculates rule-derived current value, bonus application, reset points, current streak or level, and cumulative earned value from ordered verified events."
			},
			{
				"title": "Rule Changes",
				"body": "Future rule changes should apply prospectively by default, with prior events tied to the rules in effect when values were earned."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool verify whether the target behavior happened?",
				"answer": "No. It calculates earned value from verified achievement or non-achievement inputs supplied manually or by source records."
			},
			{
				"question": "Can it show why a value was earned?",
				"answer": "Yes. The review should show each event, the rule applied, any bonus or reset, and the resulting current and cumulative value."
			},
			{
				"question": "Does it manage voucher redemption?",
				"answer": "No. Redemption belongs in a separate ledger; this tool calculates schedule-derived earned value."
			},
			{
				"question": "What happens when rules are incomplete?",
				"answer": "An incomplete or contradictory schedule cannot activate until the required base, escalation, bonus where used, and reset logic are resolved."
			}
		]
	},
	{
		"toolType": "voucherLedger",
		"slug": "voucher-ledger",
		"title": "Voucher Ledger Demo for Incentive Accounting | Qwoach",
		"metaDescription": "Review earned, issued, redeemed, and remaining incentive credits in an auditable practitioner-only contingency management ledger.",
		"h1": "Voucher Ledger for Contingency Management Credits",
		"intro": "Voucher Ledger is a practitioner-only contingency management accounting record for practitioners who track redeemable incentive credits. It helps maintain an auditable history of credits earned, issued, redeemed, and remaining so incentive accounting stays clear.",
		"demoTitle": "Review a sample ledger and inspect the running balance.",
		"demoPrompt": "Interested in using Voucher Ledger with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0835-f-046-cm-006-r001-voucher-ledger.md",
		"specId": "0835-f-046-cm-006-r001-voucher-ledger",
		"tags": {
			"framework": [
				"Contingency Management"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The ledger captures earning, issuing, redemption, dates, values, statuses, source references, adjustments when supported, and running balance."
			},
			{
				"title": "Reconciliation",
				"body": "The review emphasizes totals earned, issued, redeemed, remaining, pending issue, pending redemption, and unreconciled entries."
			},
			{
				"title": "Limitations",
				"body": "The ledger does not verify target behavior, select incentives, manage inventory, or calculate annual caps inside this tool."
			}
		],
		"faqItems": [
			{
				"question": "Does the Voucher Ledger have configurable settings?",
				"answer": "No substantive practitioner settings are required by the supplied record. The fixed ledger tool is still saved as-is."
			},
			{
				"question": "Does the ledger verify whether an incentive was earned?",
				"answer": "No. Each earning entry must tie to verified target-behavior achievement from another source or reference."
			},
			{
				"question": "Can redeemed value exceed the available balance?",
				"answer": "No, not without explicit correction or adjustment handling. A negative balance should be treated as an exception requiring resolution."
			},
			{
				"question": "Is there a client redemption portal?",
				"answer": "No. The supplied product is practitioner-only and does not include a client-facing shopping or redemption workflow."
			}
		]
	},
	{
		"toolType": "prizeDrawFishbowlRecord",
		"slug": "prize-draw-fishbowl-record",
		"title": "Prize Draw / Fishbowl Record Demo | Qwoach",
		"metaDescription": "Track earned draw opportunities, fishbowl outcomes, prizes awarded, and cumulative exposure after verified achievements in CM programs.",
		"h1": "Prize Draw / Fishbowl Record for Contingency Management",
		"intro": "Prize Draw / Fishbowl Record is a practitioner-only contingency management record for practitioners using chance-based prize opportunities after verified target-behavior achievements. It helps account for draw opportunities earned, outcomes recorded, prizes awarded, and cumulative prize exposure.",
		"demoTitle": "Configure sample draw rules and record sample prize outcomes.",
		"demoPrompt": "Interested in using Prize Draw / Fishbowl Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0836-f-046-cm-007-r001-prize-draw-fishbowl-record.md",
		"specId": "0836-f-046-cm-007-r001-prize-draw-fishbowl-record",
		"tags": {
			"framework": [
				"Contingency Management"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Physical or System Draws",
				"body": "If physical draws occur outside the system, the tool records outcomes. If a surrounding product performs a draw, the result is still recorded as an outcome tied to the earned opportunity."
			},
			{
				"title": "Pending and Incomplete States",
				"body": "Earned but unperformed draws remain pending. Performed draws without outcomes are incomplete until recorded."
			},
			{
				"title": "Handoffs",
				"body": "Awarded prize values can feed a voucher ledger or annual cap monitor when values are entered or derivable from configured categories."
			}
		],
		"faqItems": [
			{
				"question": "Does every draw opportunity need a verified achievement?",
				"answer": "Yes, draw opportunities should be tied to verified achievement unless a practitioner override is explicitly supported and recorded."
			},
			{
				"question": "Can this tool record physical fishbowl draws?",
				"answer": "Yes. If the draw happens outside the system, staff can record the outcome and prize awarded."
			},
			{
				"question": "Does it define prize probabilities?",
				"answer": "No. It does not invent unsupported probability distributions beyond configured draw rules and outcome recording."
			},
			{
				"question": "What happens to earned but unperformed draws?",
				"answer": "They remain pending until the draw is performed or otherwise handled."
			}
		]
	},
	{
		"toolType": "resetRuleTracker",
		"slug": "reset-rule-tracker",
		"title": "Reset Rule Tracker Demo | Qwoach",
		"metaDescription": "Track current contingency level, streak, and reset events from positive tests, missed checks, or other non-achievements in CM schedules.",
		"h1": "Reset Rule Tracker for Contingency Management",
		"intro": "Reset Rule Tracker is a practitioner-only contingency management tool for practitioners whose incentive schedules change after positive tests, missed checks, or other non-achievements. It helps keep the current contingency level accurate by applying configured reset rules to recent verified events.",
		"demoTitle": "Configure a sample reset rule and review the state timeline.",
		"demoPrompt": "Interested in using Reset Rule Tracker with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0837-f-046-cm-008-r001-reset-rule-tracker.md",
		"specId": "0837-f-046-cm-008-r001-reset-rule-tracker",
		"tags": {
			"framework": [
				"Contingency Management"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tracker when the next incentive state depends on whether recent results preserve escalation or trigger a reset."
			},
			{
				"title": "Explainable State",
				"body": "The current level should always be explainable from the configured rule and recent source events."
			},
			{
				"title": "Corrections",
				"body": "Out-of-order or corrected source events require recalculation of later transitions, with updated history visible for review."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide incentive value?",
				"answer": "No. It tracks current contingency level and reset state; value calculation belongs in a schedule or incentive tool."
			},
			{
				"question": "Can missed checks trigger a reset?",
				"answer": "Yes, if the practitioner-configured rule specifies that missed checks or other supported non-achievement statuses trigger a reset."
			},
			{
				"question": "What if the starting level is unknown?",
				"answer": "The tracker remains unresolved until a starting level or current baseline is provided."
			},
			{
				"question": "Does a reset mean clinical relapse?",
				"answer": "No. Reset events are rule-derived contingency states, not clinical interpretations."
			}
		]
	},
	{
		"toolType": "reinforcerPreferenceList",
		"slug": "reinforcer-preference-list",
		"title": "Reinforcer Preference List Demo | Qwoach",
		"metaDescription": "Send a low-burden preference request so clients can share motivating incentive options while practitioners review feasibility constraints.",
		"h1": "Reinforcer Preference List for Contingency Management",
		"intro": "Reinforcer Preference List is a ready-to-send contingency management tool for practitioners who need client-specific incentive preferences. It helps collect preferred recovery-supporting incentives and review feasibility when program cost or availability constraints are provided.",
		"demoTitle": "Set up a sample preference request and preview the client response.",
		"demoPrompt": "Interested in using Reinforcer Preference List with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0838-f-046-cm-009-r001-reinforcer-preference-list.md",
		"specId": "0838-f-046-cm-009-r001-reinforcer-preference-list",
		"tags": {
			"framework": [
				"Contingency Management"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner and Client Roles",
				"body": "The practitioner prepares constraints and reviews the profile. The client provides preferred incentives or updates when preferences change."
			},
			{
				"title": "Feasibility Review",
				"body": "Feasibility appears only when the practitioner supplies cost or availability constraints. Unavailable options remain visible as preferences but are not currently feasible."
			},
			{
				"title": "Unresolved Content Structure",
				"body": "Exact prompt wording, categories, ranking, and rating scales are not defined by the supplied record, so the public demo should not present them as fixed product content."
			}
		],
		"faqItems": [
			{
				"question": "Can clients complete this tool?",
				"answer": "Yes. This is a ready-to-send tool with a client response experience for sharing incentive preferences."
			},
			{
				"question": "Does the tool rank motivational strength?",
				"answer": "No. It must not infer motivational strength unless a supported ranking or rating structure is supplied, and none is defined in the record."
			},
			{
				"question": "Can practitioners provide a list of available options?",
				"answer": "Yes. Practitioners can use provided-option mode and include program options the client can select from."
			},
			{
				"question": "What if a client submits no preferences?",
				"answer": "No preferences should be represented as no response or an explicit no-preference response, not as inferred disinterest."
			}
		]
	},
	{
		"toolType": "cmProgressGraph",
		"slug": "cm-progress-graph",
		"title": "CM Progress Graph Demo | Qwoach",
		"metaDescription": "Visualize target-behavior results and reinforcement exposure over time with streaks, setbacks, gaps, and point-level detail for CM review.",
		"h1": "CM Progress Graph for Behavior and Reinforcement Trajectory",
		"intro": "CM Progress Graph is a practitioner-only contingency management visualization for practitioners reviewing repeated objective measurements and reinforcement decisions. It helps show the longitudinal trajectory of target-behavior achievement and reinforcement exposure so the contingency strategy can be reviewed.",
		"demoTitle": "Select sample series and inspect the progress graph.",
		"demoPrompt": "Interested in using CM Progress Graph with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0839-f-046-cm-010-r001-cm-progress-graph.md",
		"specId": "0839-f-046-cm-010-r001-cm-progress-graph",
		"tags": {
			"framework": [
				"Contingency Management"
			],
			"toolType": [
				"Graph"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Source Records Stay Authoritative",
				"body": "The graph visualizes existing test, attendance/adherence, voucher, prize, and ledger records. Primary corrections happen in those source tools."
			},
			{
				"title": "What the Graph Shows",
				"body": "The graph shows repeated results, incentive exposure, streaks, setbacks, gaps, invalid or missing data, and point-level details."
			},
			{
				"title": "Limitations",
				"body": "The graph does not determine clinical significance, recommend treatment changes, or create new incentive calculations beyond existing source data."
			}
		],
		"faqItems": [
			{
				"question": "Does the graph collect new test or adherence data?",
				"answer": "No. It visualizes existing structured CM records and keeps source records authoritative."
			},
			{
				"question": "Can the graph show gaps or invalid results?",
				"answer": "Yes. Sparse data, missing incentives, missing behavior results, and invalid results should appear as visible gaps or distinct states."
			},
			{
				"question": "Is there a client-facing graph?",
				"answer": "No separate client experience is required. Practitioners may discuss the graph with a client outside the product workflow."
			},
			{
				"question": "What settings can be saved?",
				"answer": "The saved setup can include selected data sources or series and time range, while sample graph data is not saved as real client data."
			}
		]
	},
	{
		"toolType": "annualIncentiveCapMonitor",
		"slug": "annual-incentive-cap-monitor",
		"title": "Annual Incentive Cap Monitor Demo | Qwoach",
		"metaDescription": "Monitor cumulative annual incentive value against a configured per-patient cap, check pending incentives, and review the accounting trail.",
		"h1": "Annual Incentive Cap Monitor for Contingency Management",
		"intro": "Annual Incentive Cap Monitor is a practitioner-only contingency management accounting tool for practitioners operating under an annual per-patient incentive limit. It helps compare a client's cumulative annual incentive value against a configured cap and check pending incentives before delivery.",
		"demoTitle": "Configure a sample cap and run a pending incentive check.",
		"demoPrompt": "Interested in using Annual Incentive Cap Monitor with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0840-f-046-cm-011-r001-annual-incentive-cap-monitor.md",
		"specId": "0840-f-046-cm-011-r001-annual-incentive-cap-monitor",
		"tags": {
			"framework": [
				"Contingency Management"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "What It Monitors",
				"body": "The monitor compares cumulative incentive value for a configured patient-year against the cap amount set by the practitioner or program."
			},
			{
				"title": "Pending Checks",
				"body": "Before delivery, a pending incentive value can be checked to show the projected post-incentive total and whether it would exceed the configured cap."
			},
			{
				"title": "Accounting Trail",
				"body": "Included events remain traceable to source records with dates, values, inclusion status, and unresolved values shown explicitly."
			}
		],
		"faqItems": [
			{
				"question": "Is the cap amount configurable?",
				"answer": "Yes. The monitor compares values to the cap amount configured by the practitioner or program because applicable limits may vary by context."
			},
			{
				"question": "Does the tool decide which cap applies?",
				"answer": "No. It compares incentive values to the configured cap and does not determine program applicability."
			},
			{
				"question": "Can pending incentives be checked before delivery?",
				"answer": "Yes. A pending value can be compared against the current total and remaining amount before the incentive is delivered."
			},
			{
				"question": "What happens when an incentive value is missing?",
				"answer": "Missing source values remain unresolved and cannot be included in the final total until resolved."
			}
		]
	},
	{
		"toolType": "familyStructuralDiagnosis",
		"slug": "family-structural-diagnosis",
		"title": "Family Structural Diagnosis Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only BSFT formulation tool for organizing family-function evidence, structural dimensions, and intervention-priority notes.",
		"h1": "Family Structural Diagnosis for BSFT Formulation",
		"intro": "Family Structural Diagnosis is a practitioner-only BSFT formulation tool for family therapy practitioners. It helps practitioners organize observed and reported family functioning across supported structural dimensions so intervention priorities can be guided by a coherent formulation rather than by isolated individual pathology.",
		"demoTitle": "Explore the sample formulation",
		"demoPrompt": "Interested in using Family Structural Diagnosis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0841-f-047-bsft-001-r001-family-structural-diagnosis.md",
		"specId": "0841-f-047-bsft-001-r001-family-structural-diagnosis",
		"tags": {
			"framework": [
				"BSFT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When to Use It",
				"body": "Use this tool near the beginning of family work or when new interaction data requires the practitioner to revise the family-function formulation."
			},
			{
				"title": "What It Keeps Separate",
				"body": "The workspace keeps reported evidence, observed evidence, practitioner interpretation, and intervention-priority notes distinct so the formulation does not become an unsupported automatic conclusion."
			},
			{
				"title": "Limitations",
				"body": "The tool does not collect symptom ratings, produce diagnostic labels, score family functioning, generate interventions automatically, or add unsupported dimensions."
			}
		],
		"faqItems": [
			{
				"question": "Is Family Structural Diagnosis a client questionnaire?",
				"answer": "No. Family Structural Diagnosis is practitioner-only and does not require clients to complete a worksheet, rating, or submission."
			},
			{
				"question": "Does the tool score family functioning?",
				"answer": "No. The result is a structured formulation with evidence, interpretation, and update history, not a score or standardized severity rating."
			},
			{
				"question": "What settings can be saved?",
				"answer": "The practitioner can save the tool, selected supported structural dimensions, and reusable member or subsystem setup choices."
			},
			{
				"question": "Can the formulation be updated later?",
				"answer": "Yes. The tool supports updates as new family interaction data emerges and preserves prior formulation statements for review."
			}
		]
	},
	{
		"toolType": "diagnosticEnactment",
		"slug": "diagnostic-enactment",
		"title": "Diagnostic Enactment Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only live-session BSFT observation tool for capturing family interaction sequences, roles, responses, and formulation notes.",
		"h1": "Diagnostic Enactment Observation Tool",
		"intro": "Diagnostic Enactment is a live-session BSFT observation tool for family therapy practitioners. It helps practitioners obtain direct interactional evidence when verbal reports do not show how family members actually respond to one another around the presenting concern.",
		"demoTitle": "Try the observation capture demo",
		"demoPrompt": "Interested in using Diagnostic Enactment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0842-f-047-bsft-002-r001-diagnostic-enactment.md",
		"specId": "0842-f-047-bsft-002-r001-diagnostic-enactment",
		"tags": {
			"framework": [
				"BSFT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"In-session support",
				"Assessment"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Designed for Session Flow",
				"body": "The capture surface is intentionally lightweight so the practitioner can record quick sequence, role, and response notes without lengthy forms."
			},
			{
				"title": "Observation, Not Interpretation Automation",
				"body": "The product can organize sequence notes and links to formulation updates, but it does not assign clinical meanings or recommend interventions."
			},
			{
				"title": "When Evidence Is Limited",
				"body": "An attempted enactment can be saved as insufficient or incomplete without implying that the missing behavior was absent."
			}
		],
		"faqItems": [
			{
				"question": "Do clients complete anything in Diagnostic Enactment?",
				"answer": "No. Clients do not operate the product; the practitioner records observations from live session interaction."
			},
			{
				"question": "Does the tool provide enactment scripts?",
				"answer": "No. The product does not generate substantive enactment scripts because the specification supports observation capture, not script creation."
			},
			{
				"question": "Can notes be completed after the session?",
				"answer": "Yes. The product supports interruption and later completion without treating missing details as absence of behavior."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The Diagnostic Enactment tool and reusable configuration are saved; fictional session observations are not saved as real client records."
			}
		]
	},
	{
		"toolType": "interactionSequenceMap",
		"slug": "interaction-sequence-map",
		"title": "Interaction Sequence Map Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only BSFT sequence map for recurring family interaction patterns, participants, evidence, and selected leverage points.",
		"h1": "Map Recurring Family Interaction Sequences",
		"intro": "Interaction Sequence Map is a practitioner-only BSFT pattern-mapping tool for family therapy practitioners. It helps practitioners represent recurring family interaction sequences tied to a presenting problem so leverage points selected by the practitioner are visible for planning.",
		"demoTitle": "Build a sample sequence map",
		"demoPrompt": "Interested in using Interaction Sequence Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0843-f-047-bsft-003-r001-interaction-sequence-map.md",
		"specId": "0843-f-047-bsft-003-r001-interaction-sequence-map",
		"tags": {
			"framework": [
				"BSFT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior analysis"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Recurring Pattern Focus",
				"body": "The map is intended for repeated interaction sequences; a single incident can be captured as insufficient for recurring-pattern status."
			},
			{
				"title": "Practitioner-Selected Leverage Points",
				"body": "Leverage points are selected by the practitioner and remain visible in review without becoming automated recommendations."
			},
			{
				"title": "Historical Comparison",
				"body": "When enabled, prior versions can be compared by sequence structure and leverage-point changes while preserving earlier maps."
			}
		],
		"faqItems": [
			{
				"question": "Is this a genogram?",
				"answer": "No. Interaction Sequence Map represents recurring interaction steps over time, not family genealogy or a general family tree."
			},
			{
				"question": "Does the product identify leverage points automatically?",
				"answer": "No. Leverage points are selected by the practitioner and shown in the map for review."
			},
			{
				"question": "Can an incomplete map be saved?",
				"answer": "Yes. Partial maps can include unresolved steps or missing repetition evidence without being treated as complete."
			},
			{
				"question": "Can clients fill out the map?",
				"answer": "No. The product specification defines no separate client entry experience."
			}
		]
	},
	{
		"toolType": "allianceHierarchyMap",
		"slug": "alliance-hierarchy-map",
		"title": "Alliance / Hierarchy Map Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only BSFT map for family hierarchy, alliances, coalitions, evidence notes, uncertainty, and restructuring priorities.",
		"h1": "Map Family Hierarchy and Alliances",
		"intro": "Alliance / Hierarchy Map is a practitioner-only BSFT structural mapping tool for family therapy practitioners. It helps practitioners clarify authority structure, alliances, coalitions, and loyalty dynamics as they relate to the presenting concern.",
		"demoTitle": "Explore the sample structure map",
		"demoPrompt": "Interested in using Alliance / Hierarchy Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0844-f-047-bsft-004-r001-alliance-hierarchy-map.md",
		"specId": "0844-f-047-bsft-004-r001-alliance-hierarchy-map",
		"tags": {
			"framework": [
				"BSFT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Hierarchy and Alliance Stay Distinct",
				"body": "The map visually separates authority structure from alliance or coalition relationships so the practitioner can review alignment and tension."
			},
			{
				"title": "Uncertainty Is Allowed",
				"body": "Tentative or conflicting relationship information can be marked as unresolved instead of forced into a single fixed structure."
			},
			{
				"title": "Limitations",
				"body": "The tool does not detect coalitions automatically, assign blame, score relationships, or prescribe restructuring interventions."
			}
		],
		"faqItems": [
			{
				"question": "Is Alliance / Hierarchy Map a family tree?",
				"answer": "No. It represents authority and alliance structure relevant to a presenting concern, not genealogy beyond what is needed for the structural map."
			},
			{
				"question": "Does the tool judge whether a relationship is healthy?",
				"answer": "No. The practitioner records evidence and interpretation; the product does not generate health scores or automatic judgments."
			},
			{
				"question": "Can uncertain relationships be shown?",
				"answer": "Yes. The tool can show uncertain relationships on the map or hold them in notes, depending on practitioner configuration."
			},
			{
				"question": "What carries over after saving?",
				"answer": "The tool and selected configuration carry over; fictional demo map content does not become client data."
			}
		]
	},
	{
		"toolType": "resonanceClosenessDistanceMap",
		"slug": "resonance-closeness-distance-map",
		"title": "Resonance / Closeness-Distance Map Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only BSFT closeness-distance profile for dyads, subsystems, evidence notes, unresolved areas, and concern links.",
		"h1": "Map Family Closeness and Distance Patterns",
		"intro": "Resonance / Closeness-Distance Map is a practitioner-only BSFT formulation tool for family therapy practitioners. It helps practitioners clarify closeness, distance, overinvolvement, or disengagement among family members in relation to the presenting problem.",
		"demoTitle": "Explore the sample distance profile",
		"demoPrompt": "Interested in using Resonance / Closeness-Distance Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0845-f-047-bsft-005-r001-resonance-closeness-distance-map.md",
		"specId": "0845-f-047-bsft-005-r001-resonance-closeness-distance-map",
		"tags": {
			"framework": [
				"BSFT"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Relationship-Specific View",
				"body": "The tool captures differences across dyads or subsystems rather than reducing the family to a single global impression."
			},
			{
				"title": "Unresolved Does Not Mean Balanced",
				"body": "Relationships without enough evidence can remain unresolved so missing information is not interpreted as a clinical judgment."
			},
			{
				"title": "Limitations",
				"body": "The product does not create relationship satisfaction scores, attachment classifications, automated healthy/unhealthy judgments, or fixed rating scales not supplied by the specification."
			}
		],
		"faqItems": [
			{
				"question": "Is this a relationship satisfaction survey?",
				"answer": "No. The tool is a practitioner-entered closeness-distance profile tied to the presenting concern."
			},
			{
				"question": "Can the practitioner map subsystems instead of dyads?",
				"answer": "Yes. The supported granularity setting allows dyad or subsystem relationship entries."
			},
			{
				"question": "Does the tool recommend boundary changes automatically?",
				"answer": "No. Boundary or connection shift notes are entered by the practitioner."
			},
			{
				"question": "What happens to sample relationship entries after saving?",
				"answer": "They are not preserved as real client data; only the tool and selected configuration carry into the account."
			}
		]
	},
	{
		"toolType": "identifiedPatienthoodAssessment",
		"slug": "identified-patienthood-assessment",
		"title": "Identified Patienthood Assessment Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only BSFT profile for separating a named problem bearer from systemic family responses and broader relational patterns.",
		"h1": "Profile Identified Patienthood in the Family System",
		"intro": "Identified Patienthood Assessment is a practitioner-only BSFT formulation tool for family therapy practitioners. It helps practitioners understand how a family’s designation of one member as the problem bearer is maintained, reinforced, amplified, or challenged within broader family interactions.",
		"demoTitle": "Explore the sample problem-location profile",
		"demoPrompt": "Interested in using Identified Patienthood Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0846-f-047-bsft-006-r001-identified-patienthood-assessment.md",
		"specId": "0846-f-047-bsft-006-r001-identified-patienthood-assessment",
		"tags": {
			"framework": [
				"BSFT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Built to Avoid Blame Reinforcement",
				"body": "The layout separates the named problem bearer from systemic responses so the practitioner can keep the formulation focused on family-level patterns."
			},
			{
				"title": "Changing Designations",
				"body": "The tool supports multiple or changing designations and preserves prior formulations for historical comparison."
			},
			{
				"title": "Limitations",
				"body": "The product does not diagnose the identified person, score blame, assign responsibility, or infer systemic meaning automatically."
			}
		],
		"faqItems": [
			{
				"question": "Is this an individual diagnostic assessment?",
				"answer": "No. It is a systemic problem-location profile, not an individual diagnosis tool."
			},
			{
				"question": "Can more than one person be treated as the problem bearer?",
				"answer": "Yes. The product supports multiple or changing designations while preserving prior formulations."
			},
			{
				"question": "Does the tool decide who is responsible?",
				"answer": "No. It does not assign responsibility, score blame, or make culpability judgments."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool and configuration are saved; fictional family roles and sample responses are not saved as real client data."
			}
		]
	},
	{
		"toolType": "conflictResolutionStyleAssessment",
		"slug": "conflict-resolution-style-assessment",
		"title": "Conflict Resolution Style Assessment Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only BSFT conflict-pattern profile for recurring behaviors, evidence, member differences, and change needs.",
		"h1": "Profile Recurring Family Conflict Patterns",
		"intro": "Conflict Resolution Style Assessment is a practitioner-only BSFT formulation tool for family therapy practitioners. It helps practitioners understand recurring family conflict behaviors and how those behaviors affect the presenting problem.",
		"demoTitle": "Explore the sample conflict profile",
		"demoPrompt": "Interested in using Conflict Resolution Style Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0847-f-047-bsft-007-r001-conflict-resolution-style-assessment.md",
		"specId": "0847-f-047-bsft-007-r001-conflict-resolution-style-assessment",
		"tags": {
			"framework": [
				"BSFT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Behavior and Recurrence",
				"body": "The profile supports recurring behavior entries and can mark when there is not enough evidence to treat a single incident as a pattern."
			},
			{
				"title": "Repair Attempts Included",
				"body": "Repair attempts can be captured alongside escalation, avoidance, or blaming so the profile does not only record problem behaviors."
			},
			{
				"title": "Limitations",
				"body": "The product does not create standardized scores, personality labels, automatic behavior labels, blame judgments, or conflict-resolution curricula."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client communication quiz?",
				"answer": "No. It is a practitioner-entered conflict-pattern profile based on observation and reports."
			},
			{
				"question": "Does the tool score conflict style?",
				"answer": "No. The product organizes behaviors and evidence but does not generate standardized conflict style scores."
			},
			{
				"question": "Can repair attempts be recorded?",
				"answer": "Yes. Repair attempts are supported as recurring conflict behaviors where observed or reported."
			},
			{
				"question": "Can different subsystems have different profiles?",
				"answer": "Yes. The scope setting can be family-wide, subsystem-specific, or member-specific."
			}
		]
	},
	{
		"toolType": "reframing2",
		"slug": "reframing-2",
		"title": "Reframing Product Boundary | Qwoach",
		"metaDescription": "Understand why Reframing is treated as live BSFT clinical work with no standalone worksheet, generator, artifact, settings, or client product flow.",
		"h1": "Reframing Is Not a Standalone Digital Product",
		"intro": "Reframing is represented in the supplied specification as a BSFT in-session therapeutic intervention for practitioners. It helps a family view a situation in a less blaming and more change-oriented way through live clinical judgment, but it is not defined as a standalone digital worksheet, builder, or artifact.",
		"demoTitle": "Review the product boundary",
		"demoPrompt": "Interested in using Reframing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0848-f-047-bsft-008-r001-reframing.md",
		"specId": "0848-f-047-bsft-008-r001-reframing",
		"tags": {
			"framework": [
				"BSFT"
			],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Behavior change"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Why There Is No Demo",
				"body": "The supplied specification defines Reframing as an in-session therapeutic action with no inherent artifact, no standalone practitioner UX, and no product result."
			},
			{
				"title": "What Must Not Be Added",
				"body": "The page must not add AI-generated reframes, standardized prompts, client ratings, blame scores, motivation scores, worksheet answers, or required digital steps."
			}
		],
		"faqItems": [
			{
				"question": "Is Reframing available as a standalone digital tool?",
				"answer": "No. The specification defines Reframing as live clinical work with no standalone product unit."
			},
			{
				"question": "Can the demo generate reframes?",
				"answer": "No. Generating substantive reframes would exceed the supplied product specification."
			},
			{
				"question": "Is there a client worksheet for Reframing?",
				"answer": "No. No separate client product experience or worksheet is supported."
			},
			{
				"question": "Can Reframing be saved into an account as a tool?",
				"answer": "No standalone save behavior is supported by the specification; requiring it creates a product-spec conflict."
			}
		]
	},
	{
		"toolType": "restructuringTaskPlan",
		"slug": "restructuring-task-plan",
		"title": "Restructuring Task Plan Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only BSFT plan for shifting a current family interaction pattern toward an observable new interaction sequence.",
		"h1": "Plan a Concrete Family Restructuring Task",
		"intro": "Restructuring Task Plan is a practitioner-only BSFT planning tool for family therapy practitioners. It helps practitioners translate an identified family interaction pattern into a concrete sequence that can be introduced in session and extended outside session where appropriate.",
		"demoTitle": "Build a sample restructuring plan",
		"demoPrompt": "Interested in using Restructuring Task Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0849-f-047-bsft-009-r001-restructuring-task-plan.md",
		"specId": "0849-f-047-bsft-009-r001-restructuring-task-plan",
		"tags": {
			"framework": [
				"BSFT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Session preparation"
			],
			"topic": [
				"Behavior change",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Before-to-After Planning",
				"body": "The plan view keeps the current pattern and intended observable pattern side by side so the change target remains explicit."
			},
			{
				"title": "Outside-Session Extension Is Optional",
				"body": "The plan can include an outside-session extension where appropriate, but the extension can remain off when carryover planning is not suitable."
			},
			{
				"title": "Limitations",
				"body": "The product does not generate interventions, invent task steps, or force a plan when formulation clarity is insufficient."
			}
		],
		"faqItems": [
			{
				"question": "Does Restructuring Task Plan generate the task for me?",
				"answer": "No. The practitioner supplies the substantive task content; the product structures the plan and shows completeness cues."
			},
			{
				"question": "Can a plan stay in draft?",
				"answer": "Yes. Partial plans can be saved as drafts while required elements are incomplete."
			},
			{
				"question": "Is outside-session extension required?",
				"answer": "No. It is an optional setting used only where appropriate."
			},
			{
				"question": "Can the plan link back to a formulation?",
				"answer": "Yes. A source formulation link is a supported setting for traceability and review."
			}
		]
	},
	{
		"toolType": "familyHomeworkTask",
		"slug": "family-homework-task",
		"title": "Family Homework Task Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send BSFT homework task for extending in-session change into observable out-of-session family interaction.",
		"h1": "Create a Ready-to-Send Family Homework Task",
		"intro": "Family Homework Task is a ready-to-send BSFT task configuration for family therapy practitioners. It helps practitioners create a realistic out-of-session behavior change target connected to a successful or emerging in-session interaction pattern.",
		"demoTitle": "Create a sample homework task",
		"demoPrompt": "Interested in using Family Homework Task with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0850-f-047-bsft-010-r001-family-homework-task.md",
		"specId": "0850-f-047-bsft-010-r001-family-homework-task",
		"tags": {
			"framework": [
				"BSFT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Homework"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Ready to Send, Not a Generic Library",
				"body": "The tool creates one task linked to an in-session change rather than offering unrelated homework content."
			},
			{
				"title": "Low-Burden Family View",
				"body": "When send mode is enabled, the family sees a concise task and may provide simple descriptive follow-up if direct response is enabled."
			},
			{
				"title": "Review States",
				"body": "The task can be draft, sent but not reviewed, attempted with no report, or reviewed with occurrence and effect notes."
			},
			{
				"title": "Limitations",
				"body": "The product does not add unsupported reminders, schedules, adherence scores, automated clinical interpretation, or generic homework analytics."
			}
		],
		"faqItems": [
			{
				"question": "Is Family Homework Task ready to send to a family?",
				"answer": "Yes. When send mode is enabled and required content is present, the practitioner can prepare a concise family-facing task."
			},
			{
				"question": "Does the family complete ratings?",
				"answer": "No. Follow-up is descriptive and limited to whether the new pattern occurred and what effect it had, where captured."
			},
			{
				"question": "Does the tool include reminders or schedules?",
				"answer": "No. Generic reminders and schedules are outside the supplied product specification."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool and selected configuration are saved; fictional task content and sample follow-up do not become real client data."
			}
		]
	},
	{
		"toolType": "initialSystemicHypothesis",
		"slug": "initial-systemic-hypothesis",
		"title": "Initial Systemic Hypothesis Tool Demo | Qwoach",
		"metaDescription": "Create a tentative systemic formulation that links a family presenting problem, relational pattern, hypothesis, and inquiry direction.",
		"h1": "Initial Systemic Hypothesis",
		"intro": "Initial Systemic Hypothesis is a practitioner-only systemic formulation tool for family practitioners. It helps practitioners record a tentative, revisable relational explanation of a family problem so it can guide questions or observation without closing down alternative meanings.",
		"demoTitle": "Try a sample formulation, then review the current initial hypothesis.",
		"demoPrompt": "Interested in using Initial Systemic Hypothesis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0851-f-048-milan-001-r001-initial-systemic-hypothesis.md",
		"specId": "0851-f-048-milan-001-r001-initial-systemic-hypothesis",
		"tags": {
			"framework": [
				"Milan systemic therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Session preparation",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it before or early in work with a family system when a practitioner needs an initial explanation to guide inquiry while keeping alternative meanings open."
			},
			{
				"title": "What it does not do",
				"body": "The tool does not create diagnoses, certainty ratings, symptom scores, clinical conclusions, or automated interpretations. It organizes practitioner-entered formulation content."
			}
		],
		"faqItems": [
			{
				"question": "Is this a diagnosis tool?",
				"answer": "No. Initial Systemic Hypothesis records a tentative relational formulation and does not produce diagnosis, scoring, certainty ratings, or clinical conclusions."
			},
			{
				"question": "Do family members complete this tool?",
				"answer": "No. This is a practitioner-only reasoning artifact; family information may be represented only as practitioner-entered reported or observed context."
			},
			{
				"question": "Can the hypothesis be revised?",
				"answer": "Yes. The tool is designed to keep the hypothesis initial, current, tentative, and editable as new information emerges."
			}
		]
	},
	{
		"toolType": "hypothesisTestingRevisionRecord",
		"slug": "hypothesis-testing-revision-record",
		"title": "Hypothesis Testing and Revision Record Demo | Qwoach",
		"metaDescription": "Track systemic hypotheses over time by recording what was tested, what changed, what was set aside, and the current formulation.",
		"h1": "Hypothesis Testing / Revision Record",
		"intro": "Hypothesis Testing / Revision Record is a practitioner-only longitudinal formulation history tool for systemic family practitioners. It helps practitioners record earlier hypotheses, new family interaction information, revision decisions, and the current formulation so inquiry stays responsive rather than fixed.",
		"demoTitle": "Review a sample history and update the current formulation.",
		"demoPrompt": "Interested in using Hypothesis Testing / Revision Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0852-f-048-milan-002-r001-hypothesis-testing-revision-record.md",
		"specId": "0852-f-048-milan-002-r001-hypothesis-testing-revision-record",
		"tags": {
			"framework": [
				"Milan systemic therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it after or during sessions when new family interaction information changes, challenges, or elaborates a working systemic hypothesis."
			},
			{
				"title": "History and comparison",
				"body": "Earlier hypotheses remain visible for comparison, including hypotheses that were revised, set aside, alternative, or unresolved. The current formulation stays prominent."
			},
			{
				"title": "Limits",
				"body": "The tool does not prove hypotheses, assign causal certainty, create scores, or generate diagnostic conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does the system decide whether a hypothesis is true?",
				"answer": "No. The practitioner records how session information affected the hypothesis; the system organizes chronology, comparison, and descriptive status only."
			},
			{
				"question": "Can discarded hypotheses stay visible?",
				"answer": "Yes. A set-aside hypothesis remains in history but should not appear as the current formulation."
			},
			{
				"question": "Do family members complete this record?",
				"answer": "No. This is a practitioner-only revision record; family interaction or responses may be summarized by the practitioner as session information."
			}
		]
	},
	{
		"toolType": "circularQuestionSet",
		"slug": "circular-question-set",
		"title": "Circular Question Set Tool Demo | Qwoach",
		"metaDescription": "Capture relational perspective data from practitioner-led circular questions with participant labels, responses, and cross-perspective review.",
		"h1": "Circular Question Set",
		"intro": "Circular Question Set is a co-completed systemic questioning tool for family practitioners. It helps practitioners ask practitioner-entered circular questions, record multiple family members' responses, and review relational perspective data that can inform the next formulation or therapeutic question.",
		"demoTitle": "Set up sample participants, add a question, and review captured perspectives.",
		"demoPrompt": "Interested in using Circular Question Set with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0853-f-048-milan-003-r001-circular-question-set.md",
		"specId": "0853-f-048-milan-003-r001-circular-question-set",
		"tags": {
			"framework": [
				"Milan systemic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Practitioner and family roles",
				"body": "The practitioner creates and controls the question set. Family members may answer during the shared session interaction, while the practitioner retains the resulting record."
			},
			{
				"title": "Prompt handling",
				"body": "Exact substantive prompts are practitioner-entered because the product record supports the question type and intended information, not a fixed prompt set."
			},
			{
				"title": "Limits",
				"body": "The tool does not include ratings, diagnostic categories, truth judgments, fixed dimensions, or automatic interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include fixed circular question prompts?",
				"answer": "No. The product supports practitioner-entered circular questions because fixed substantive prompts are not supplied by the product specification."
			},
			{
				"question": "Can family members enter responses directly?",
				"answer": "Yes, if used in direct-entry mode, they see the current practitioner-entered question and a narrative response field without scoring or interpretation."
			},
			{
				"question": "What does the result show?",
				"answer": "The result shows organized relational perspective data by respondent, relational target, question, response, and coverage of represented perspectives."
			}
		]
	},
	{
		"toolType": "triadicDifferenceQuestions",
		"slug": "triadic-difference-questions",
		"title": "Triadic and Difference Questions Demo | Qwoach",
		"metaDescription": "Capture practitioner-led triadic and difference-question responses as a networked view of family comparisons and relational distinctions.",
		"h1": "Triadic / Difference Questions",
		"intro": "Triadic / Difference Questions is a co-completed systemic questioning configuration for family practitioners. It helps practitioners ask practitioner-entered triadic or difference questions, capture responses about relationships between members, and review networked differences relevant to the presenting problem.",
		"demoTitle": "Set up a sample family network and review captured differences.",
		"demoPrompt": "Interested in using Triadic / Difference Questions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0854-f-048-milan-004-r001-triadic-difference-questions.md",
		"specId": "0854-f-048-milan-004-r001-triadic-difference-questions",
		"tags": {
			"framework": [
				"Milan systemic therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it when differences in perception, position, role, behavior, or relationship are clinically relevant to understanding the presenting problem."
			},
			{
				"title": "Prompt handling",
				"body": "The product does not invent substantive prompts. The practitioner supplies the triadic or difference questions used in session."
			},
			{
				"title": "Limits",
				"body": "The tool organizes networked differences but does not produce objective relationship truth, diagnostic judgments, or unsupported scores."
			}
		],
		"faqItems": [
			{
				"question": "What makes this different from ordinary self-report?",
				"answer": "It captures perspectives about relationships, roles, or differences involving other family members, not only a person's report about themselves."
			},
			{
				"question": "Are question prompts built in?",
				"answer": "No. The practitioner enters the triadic or difference questions because fixed prompts are not supplied by the specification."
			},
			{
				"question": "What happens if a response lacks comparison targets?",
				"answer": "The response can be retained, but it cannot be fully placed in the networked comparison view until targets are identified."
			}
		]
	},
	{
		"toolType": "sequenceQuestions",
		"slug": "sequence-questions",
		"title": "Sequence Questions Tool Demo | Qwoach",
		"metaDescription": "Map before, during, and after actions around a presenting problem with practitioner-led sequence questions and interaction review.",
		"h1": "Sequence Questions",
		"intro": "Sequence Questions is a co-completed systemic questioning tool for family practitioners. It helps practitioners ask practitioner-entered sequence questions, record what family members describe before, during, and after a problem episode, and review the interaction order without assigning blame or causality.",
		"demoTitle": "Build a sample before/during/after sequence.",
		"demoPrompt": "Interested in using Sequence Questions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0855-f-048-milan-005-r001-sequence-questions.md",
		"specId": "0855-f-048-milan-005-r001-sequence-questions",
		"tags": {
			"framework": [
				"Milan systemic therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"In-session support"
			],
			"topic": [
				"Behavior analysis",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it when the practitioner needs a process account of what tends to happen around a problem episode rather than an isolated anecdote."
			},
			{
				"title": "Partial sequences",
				"body": "If before, during, or after areas are incomplete, the result remains partial and shows what has not yet been captured."
			},
			{
				"title": "Limits",
				"body": "The tool does not assign blame, infer causality, prescribe interventions, or supply fixed substantive prompts."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide what caused the problem?",
				"answer": "No. It organizes reported actions and responses in order but does not infer causality or blame."
			},
			{
				"question": "Can I use stages other than before, during, and after?",
				"answer": "Yes. The product supports before/during/after or practitioner-defined ordered steps as the sequence structure."
			},
			{
				"question": "What if the family gives isolated anecdotes?",
				"answer": "The anecdotes can be preserved, but the result should show that repetition or sequence patterning has not yet been established."
			}
		]
	},
	{
		"toolType": "reflexiveQuestions",
		"slug": "reflexive-questions",
		"title": "Reflexive Questions Tool Demo | Qwoach",
		"metaDescription": "Use practitioner-led reflexive questions to capture preferred possibilities, anticipated effects, and resources in a family session.",
		"h1": "Reflexive Questions",
		"intro": "Reflexive Questions is a co-completed systemic questioning configuration for family practitioners. It helps practitioners ask practitioner-entered reflexive questions and capture family responses about desired alternatives, anticipated relational or system effects, and resources, values, or capacities.",
		"demoTitle": "Try a sample reflexive question and review the grouped reflection.",
		"demoPrompt": "Interested in using Reflexive Questions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0856-f-048-milan-006-r001-reflexive-questions.md",
		"specId": "0856-f-048-milan-006-r001-reflexive-questions",
		"tags": {
			"framework": [
				"Milan systemic therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Values",
				"Strengths"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Practitioner and family roles",
				"body": "The practitioner creates and guides the question set. Family members provide substantive reflections during the shared conversation."
			},
			{
				"title": "What it captures",
				"body": "The tool captures desired alternatives, anticipated relationship or system effects, and resources, values, or capacities named in responses."
			},
			{
				"title": "Limits",
				"body": "The tool is not a planning worksheet and does not include ratings, commitment scores, homework steps, or clinical predictions."
			}
		],
		"faqItems": [
			{
				"question": "Does this create an action plan?",
				"answer": "No. Reflexive Questions captures articulated possibilities, anticipated effects, and resources; it does not prescribe practice steps or homework."
			},
			{
				"question": "Are fixed question prompts included?",
				"answer": "No. The practitioner enters the reflexive questions because fixed substantive prompts are not supplied by the specification."
			},
			{
				"question": "Can family members respond directly?",
				"answer": "Yes, if direct entry is used, family members provide narrative responses to practitioner-entered questions without ratings or prescriptive fields."
			}
		]
	},
	{
		"toolType": "strategicQuestions",
		"slug": "strategic-questions",
		"title": "Strategic Questions Tool Demo | Qwoach",
		"metaDescription": "Capture practitioner-led strategic question responses and clarify a concrete change direction tied to a family interaction pattern.",
		"h1": "Strategic Questions",
		"intro": "Strategic Questions is a practitioner-led systemic questioning configuration for family practitioners. It helps practitioners ask practitioner-entered strategic questions, capture family responses, and organize an action-oriented understanding of the behavior or interaction direction that needs to shift.",
		"demoTitle": "Try a sample focus behavior and review the change-direction result.",
		"demoPrompt": "Interested in using Strategic Questions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0857-f-048-milan-007-r001-strategic-questions.md",
		"specId": "0857-f-048-milan-007-r001-strategic-questions",
		"tags": {
			"framework": [
				"Milan systemic therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Problem behavior"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it when the session calls for more directive clarification of a behavior or interaction that needs to change."
			},
			{
				"title": "What it captures",
				"body": "The tool captures presenting concern, problematic interaction focus, family responses, practical implications, and an entered change-direction statement."
			},
			{
				"title": "Limits",
				"body": "The tool is not a behavior plan, compliance tracker, intervention protocol, or outcome-measure tool."
			}
		],
		"faqItems": [
			{
				"question": "Does this assign next steps to the family?",
				"answer": "No. Strategic Questions clarifies a change direction; next-step planning happens outside this tool."
			},
			{
				"question": "Does the tool include fixed strategic question prompts?",
				"answer": "No. The practitioner enters the strategic questions because the specification does not supply a fixed prompt set."
			},
			{
				"question": "What if no change direction emerges?",
				"answer": "The result remains incomplete rather than forcing a change direction."
			}
		]
	},
	{
		"toolType": "neutralityCuriosityStance",
		"slug": "neutrality-curiosity-stance",
		"title": "Neutrality / Curiosity Stance Product Boundary | Qwoach",
		"metaDescription": "Neutrality / Curiosity Stance is a Milan systemic practice stance, not a standalone product with inputs, outputs, settings, or results.",
		"h1": "Neutrality / Curiosity Stance is not a standalone tool",
		"intro": "Neutrality / Curiosity Stance is not a standalone tool for practitioners or clients. The supplied record defines it as a Milan systemic practice stance that supports balanced, curious inquiry, but it does not define product inputs, outputs, settings, completion, or a reviewable artifact.",
		"demoTitle": "Review why no interactive demo is provided.",
		"demoPrompt": "Interested in using Neutrality / Curiosity Stance with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0858-f-048-milan-008-r001-neutrality-curiosity-stance.md",
		"specId": "0858-f-048-milan-008-r001-neutrality-curiosity-stance",
		"tags": {
			"framework": [
				"Milan systemic therapy"
			],
			"toolType": [
				"Non-product concept"
			],
			"workflow": [
				"Product boundary"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Why no demo is shown",
				"body": "The supplied record identifies a therapeutic stance with no inherent artifact, no product input, no output, and no review state. Creating a checklist, rating, note template, or completion flow would exceed the specification."
			},
			{
				"title": "How it may appear elsewhere",
				"body": "The stance may inform contextual language in other systemic tools, but it should not create a separate product mechanic or artifact."
			}
		],
		"faqItems": [
			{
				"question": "Is Neutrality / Curiosity Stance a tool I can save?",
				"answer": "No. The product specification says this row is not a standalone product unit and should not be implemented as a saveable tool."
			},
			{
				"question": "Why not make it a checklist or reflection form?",
				"answer": "A checklist or reflection form would invent product fields and outputs not supported by the supplied record."
			},
			{
				"question": "Does a client complete anything for this concept?",
				"answer": "No. There is no client/user product experience for this concept."
			}
		]
	},
	{
		"toolType": "familyGamePatternHypothesisMap",
		"slug": "family-game-pattern-hypothesis-map",
		"title": "Family Pattern Hypothesis Map Demo | Qwoach",
		"metaDescription": "Map a tentative system-level family pattern hypothesis with roles, positions, meanings, interactions, and presenting-problem links.",
		"h1": "Family Game / Pattern Hypothesis Map",
		"intro": "Family Game / Pattern Hypothesis Map is a practitioner-only systemic formulation artifact for family practitioners. It helps practitioners organize family members' roles, positions, meanings, and interactions into a tentative system-level pattern hypothesis connected to the presenting problem.",
		"demoTitle": "Build a sample pattern map and review the current hypothesis.",
		"demoPrompt": "Interested in using Family Game / Pattern Hypothesis Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0859-f-048-milan-009-r001-family-game-pattern-hypothesis-map.md",
		"specId": "0859-f-048-milan-009-r001-family-game-pattern-hypothesis-map",
		"tags": {
			"framework": [
				"Milan systemic therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning",
				"Session preparation"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it when a practitioner needs to formulate a recurring system-level pattern behind a family presenting problem rather than focus on isolated symptoms."
			},
			{
				"title": "Revision",
				"body": "The map should remain testable and revisable. Prior states may be preserved for comparison if revisions are made."
			},
			{
				"title": "Limits",
				"body": "The tool does not automatically detect hidden patterns, assign certainty, diagnose, or generate intervention prescriptions."
			}
		],
		"faqItems": [
			{
				"question": "Does the system generate the family pattern hypothesis?",
				"answer": "No. The practitioner writes the hypothesis; the system organizes entered roles, meanings, positions, interactions, and presenting-problem links."
			},
			{
				"question": "Is this a genogram?",
				"answer": "No. It is a system-level pattern hypothesis map, not a generic genogram or relationship diagram."
			},
			{
				"question": "What happens if only one person is represented?",
				"answer": "The map can retain the entry, but review should show insufficient systemic coverage because multiple roles or positions are central."
			}
		]
	},
	{
		"toolType": "sessionTeamHypothesisNotes",
		"slug": "session-team-hypothesis-notes",
		"title": "Session Team Hypothesis Notes Demo | Qwoach",
		"metaDescription": "Coordinate practitioner-team systemic hypotheses, alternatives, session information, and planned questioning or observation in one shared note.",
		"h1": "Session Team Hypothesis Notes",
		"intro": "Session Team Hypothesis Notes is a practitioner-team collaboration tool for Milan systemic family sessions. It helps practitioner teams record leading and alternative hypotheses, relevant session information, and planned lines of questioning or observation so the therapeutic interview stays coordinated.",
		"demoTitle": "Explore a sample team reasoning board and current interview direction.",
		"demoPrompt": "Interested in using Session Team Hypothesis Notes with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0860-f-048-milan-010-r001-session-team-hypothesis-notes.md",
		"specId": "0860-f-048-milan-010-r001-session-team-hypothesis-notes",
		"tags": {
			"framework": [
				"Milan systemic therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Session preparation",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Team use",
				"body": "The tool is for practitioner-team reasoning. Family members are not primary users and do not complete or review the notes as part of the product."
			},
			{
				"title": "Current and alternative hypotheses",
				"body": "The review keeps the current leading direction prominent while preserving alternatives for comparison and revision."
			},
			{
				"title": "Limits",
				"body": "The tool is not a full team chat, EHR note, supervision record, workflow manager, or automated recommendation engine."
			}
		],
		"faqItems": [
			{
				"question": "Can more than one practitioner contribute?",
				"answer": "Yes. The product must support multiple practitioner contributors and shared current-state visibility within the session notes."
			},
			{
				"question": "Do clients see or complete these notes?",
				"answer": "No. Session Team Hypothesis Notes are practitioner-team notes with no client/user product experience."
			},
			{
				"question": "Does the system choose the correct hypothesis?",
				"answer": "No. The team records and revises hypotheses; the system only organizes leading, alternative, linked inquiry, and revision information."
			}
		]
	},
	{
		"toolType": "relationalReframe",
		"slug": "relational-reframe",
		"title": "Relational Reframe for Adolescent-Caregiver Therapy | Qwoach",
		"metaDescription": "Live-session aid for practitioners to reframe adolescent-caregiver therapy around relational repair, shared aims, and next-session focus.",
		"h1": "Relational Reframe",
		"intro": "Relational Reframe is a live-session practitioner aid for early therapy with an adolescent and caregiver. Practitioners use it to shift the working frame from blame, symptoms, or individual fault toward shared interpersonal development and attachment repair.",
		"demoTitle": "Open the sample reframing workspace and review how a presenting frame becomes a documented relational focus.",
		"demoPrompt": "Interested in using Relational Reframe with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0861-f-049-abft-001-r001-relational-reframe.md",
		"specId": "0861-f-049-abft-001-r001-relational-reframe",
		"tags": {
			"framework": [
				"ABFT"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Adolescents",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at the beginning of relationship-focused treatment when the dyad’s presenting problems need to be reframed around interpersonal development and attachment repair."
			},
			{
				"title": "What It Captures",
				"body": "It captures the presenting frame, adolescent perspective, caregiver perspective, emerging relational frame, relational aims, buy-in or resistance, and next-session implications."
			},
			{
				"title": "Important Limits",
				"body": "It does not diagnose, score, generate therapy scripts, decide the correct relational meaning, or claim that repair has occurred."
			}
		],
		"faqItems": [
			{
				"question": "Does Relational Reframe create a treatment plan?",
				"answer": "No. Relational Reframe documents a shared relational focus and possible goals; it is not a full treatment plan or generic goal builder."
			},
			{
				"question": "Can the adolescent and caregiver complete it on their own?",
				"answer": "No. The adolescent and caregiver participate through practitioner-led conversation; the practitioner documents the reframe."
			},
			{
				"question": "What happens if one person is not bought in yet?",
				"answer": "The entry can remain partial. The tool preserves disagreement or resistance instead of forcing consensus."
			},
			{
				"question": "Can a summary be shared with the family?",
				"answer": "Yes. If selected, the shared view contains only a brief relational focus statement and agreed relational aims suitable for review."
			}
		]
	},
	{
		"toolType": "relationalContractGoal",
		"slug": "relational-contract-goal",
		"title": "Relational Contract Goal Tool for Dyadic Therapy | Qwoach",
		"metaDescription": "Create shared adolescent-caregiver relational goals with role recognition, resistance notes, and session priorities for therapy alignment.",
		"h1": "Relational Contract / Goal",
		"intro": "Relational Contract / Goal is an ABFT-aligned shared-goal tool for practitioners working with an adolescent and caregiver. Practitioners use it to establish explicit dyadic treatment goals that are acceptable enough to both parties to guide attachment-focused work.",
		"demoTitle": "Start with the sample dyad-visible contract and review how proposed goals become agreed or unresolved.",
		"demoPrompt": "Interested in using Relational Contract / Goal with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0862-f-049-abft-002-r001-relational-contract-goal.md",
		"specId": "0862-f-049-abft-002-r001-relational-contract-goal",
		"tags": {
			"framework": [
				"ABFT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals",
				"Interpersonal relationships"
			],
			"population": [
				"Adolescents",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when treatment alignment depends on explicit relationship-specific goals that both adolescent and caregiver can recognize enough to guide the work."
			},
			{
				"title": "What It Captures",
				"body": "It captures separate expectations, resistance or disagreement, proposed and agreed relational goals, party role recognition, and upcoming-session priorities."
			},
			{
				"title": "Relevant Limits",
				"body": "It does not provide goal libraries, clinical scripts, scoring, or automated conclusions about whether the contract is clinically adequate."
			}
		],
		"faqItems": [
			{
				"question": "Is this a full treatment plan?",
				"answer": "No. It is a bounded relational contract or goal record for dyadic relationship work."
			},
			{
				"question": "Can disagreement remain in the result?",
				"answer": "Yes. Goals can be proposed, agreed, or unresolved, and disagreement is preserved rather than overwritten."
			},
			{
				"question": "Can the dyad see the tool during session?",
				"answer": "Yes. The shared-session display supports dyad-visible completion while keeping private practitioner notes separate."
			},
			{
				"question": "What makes a goal complete?",
				"answer": "A goal must be relationship-specific and include each party’s recognized role before it is treated as agreed."
			}
		]
	},
	{
		"toolType": "adolescentAllianceAttachmentNarrative",
		"slug": "adolescent-alliance-attachment-narrative",
		"title": "Adolescent Attachment Narrative Tool for Practitioners | Qwoach",
		"metaDescription": "Organize adolescent attachment narratives, unmet needs, alliance notes, and repair targets for later caregiver preparation and conjoint work.",
		"h1": "Adolescent Alliance / Attachment Narrative",
		"intro": "Adolescent Alliance / Attachment Narrative is an ABFT-aligned practitioner tool for work with an adolescent. Practitioners use it to understand attachment experiences that make caregiver engagement emotionally difficult and to identify repair targets grounded in the adolescent’s lived experience.",
		"demoTitle": "Open the sample narrative-to-repair map and review how reported experiences stay distinct from practitioner-formulated repair targets.",
		"demoPrompt": "Interested in using Adolescent Alliance / Attachment Narrative with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0863-f-049-abft-003-r001-adolescent-alliance-attachment-narrative.md",
		"specId": "0863-f-049-abft-003-r001-adolescent-alliance-attachment-narrative",
		"tags": {
			"framework": [
				"ABFT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during adolescent-focused alliance work before caregiver preparation or future conjoint repair work."
			},
			{
				"title": "What It Captures",
				"body": "It captures adolescent-reported experiences, disappointments, unmet needs, barriers to caregiver engagement, repair targets, and alliance or feeling-understood observations."
			},
			{
				"title": "Important Limits",
				"body": "It does not provide elicitation prompts, trauma-processing steps, diagnostic labels, severity ratings, or automated caregiver-preparation instructions."
			}
		],
		"faqItems": [
			{
				"question": "Is this an adolescent intake form?",
				"answer": "No. It is focused on attachment narrative and repair targets, not general intake, mood assessment, or trauma inventory."
			},
			{
				"question": "Does the tool interpret the adolescent’s experiences automatically?",
				"answer": "No. It organizes practitioner-entered material and keeps reported adolescent language distinct from practitioner formulation."
			},
			{
				"question": "Can the adolescent complete it directly?",
				"answer": "No separate adolescent product experience is required. The adolescent participates through therapeutic conversation."
			},
			{
				"question": "What if repair targets are unclear?",
				"answer": "The record can remain partial and mark targets as needing clarification."
			}
		]
	},
	{
		"toolType": "caregiverAllianceCaregivingHistory",
		"slug": "caregiver-alliance-caregiving-history",
		"title": "Caregiver Alliance and History Tool for Repair Preparation | Qwoach",
		"metaDescription": "Map caregiver history, stressors, empathy barriers, readiness, and preparation needs before adolescent-caregiver repair work.",
		"h1": "Caregiver Alliance / Caregiving History",
		"intro": "Caregiver Alliance / Caregiving History is an ABFT-aligned practitioner tool for engaging a caregiver. Practitioners use it to organize caregiver history, stress, defensiveness, empathy barriers, readiness, and preparation needs before relational repair work with an adolescent.",
		"demoTitle": "Open the sample caregiver formulation map and review how history, barriers, readiness, and preparation needs stay distinct.",
		"demoPrompt": "Interested in using Caregiver Alliance / Caregiving History with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0864-f-049-abft-004-r001-caregiver-alliance-caregiving-history.md",
		"specId": "0864-f-049-abft-004-r001-caregiver-alliance-caregiving-history",
		"tags": {
			"framework": [
				"ABFT"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during or after caregiver alliance sessions when caregiver readiness and barriers need to be understood before conjoint repair work."
			},
			{
				"title": "What It Captures",
				"body": "It captures caregiver-reported history and stressors, practitioner observations, empathy and accountability barriers, readiness, alliance, and preparation needs."
			},
			{
				"title": "Relevant Limits",
				"body": "It does not provide parenting scores, diagnoses, readiness scales, empathy exercises, or prescribed intervention steps."
			}
		],
		"faqItems": [
			{
				"question": "Is this a parenting-skills plan?",
				"answer": "No. It is a caregiver formulation tool focused on alliance, history, barriers, readiness, and preparation for relational repair."
			},
			{
				"question": "Can caregivers complete it as a worksheet?",
				"answer": "No separate caregiver product experience is required. Caregiver information is gathered through practitioner-led conversation."
			},
			{
				"question": "Can some content be shared with the caregiver?",
				"answer": "Yes. The practitioner can choose selected shared preparation themes while keeping the full formulation private."
			},
			{
				"question": "What if readiness is unclear?",
				"answer": "Readiness can remain uncertain. The tool preserves incomplete formulation states and preparation gaps."
			}
		]
	},
	{
		"toolType": "attachmentRuptureInventory",
		"slug": "attachment-rupture-inventory",
		"title": "Attachment Rupture Inventory for Repair Target Planning | Qwoach",
		"metaDescription": "Identify, organize, and manually prioritize adolescent-caregiver relationship ruptures as clear targets for staged repair work.",
		"h1": "Attachment Rupture Inventory",
		"intro": "Attachment Rupture Inventory is an ABFT-aligned practitioner tool for adolescent-caregiver relationships with multiple hurts, conflicts, or attachment wounds. Practitioners use it to identify specific ruptures, preserve relevant perspectives, and manually prioritize clear repair targets for staged therapeutic work.",
		"demoTitle": "Open the sample rupture board and try selecting repair targets without merging conflicting perspectives.",
		"demoPrompt": "Interested in using Attachment Rupture Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0865-f-049-abft-005-r001-attachment-rupture-inventory.md",
		"specId": "0865-f-049-abft-005-r001-attachment-rupture-inventory",
		"tags": {
			"framework": [
				"ABFT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Adolescents",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when multiple hurts or attachment wounds could anchor treatment and the practitioner needs to choose a staged repair focus."
			},
			{
				"title": "What It Captures",
				"body": "It captures candidate ruptures, adolescent and caregiver perspectives, relevance to current disconnection or symptoms, feasibility, priority, and target status."
			},
			{
				"title": "Relevant Limits",
				"body": "It does not assign blame, adjudicate facts, compute clinical priority, create severity scores, or impose unsupported rupture categories."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool choose the most important rupture automatically?",
				"answer": "No. Prioritization is practitioner-mediated and based on captured perspectives, current relevance, and feasibility."
			},
			{
				"question": "Can disagreement stay visible?",
				"answer": "Yes. Separate perspectives are preserved and are not merged into a false shared story."
			},
			{
				"question": "Can clients use the inventory during session?",
				"answer": "Yes, in facilitated dyad-visible entry mode, they can help name and clarify rupture descriptions."
			},
			{
				"question": "What happens to vague rupture items?",
				"answer": "Vague items can remain in clarification status until they are specific enough to discuss."
			}
		]
	},
	{
		"toolType": "caregiverPreparationPlan",
		"slug": "caregiver-preparation-plan",
		"title": "Caregiver Preparation Plan for Repair Conversations | Qwoach",
		"metaDescription": "Practitioner-only plan for caregiver readiness, likely barriers, support strategies, and preparation decisions before repair work.",
		"h1": "Caregiver Preparation Plan",
		"intro": "Caregiver Preparation Plan is an ABFT-aligned practitioner-only tool for preparing a caregiver before an attachment repair conversation with an adolescent. Practitioners use it to assess readiness, anticipate barriers, pair barriers with support strategies, and decide whether further preparation is needed before conjoint repair work.",
		"demoTitle": "Open the sample readiness and barrier plan and pair each barrier with a support strategy.",
		"demoPrompt": "Interested in using Caregiver Preparation Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0866-f-049-abft-006-r001-caregiver-preparation-plan.md",
		"specId": "0866-f-049-abft-006-r001-caregiver-preparation-plan",
		"tags": {
			"framework": [
				"ABFT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before an attachment repair conversation when caregiver defensiveness, avoidance, blame, or overwhelm could derail the session."
			},
			{
				"title": "What It Captures",
				"body": "It captures the planned repair conversation, readiness notes, likely barriers, support strategies, and whether further preparation is needed."
			},
			{
				"title": "Relevant Limits",
				"body": "It does not provide scripts, caregiver worksheets, readiness scores, standardized thresholds, or automated proceed/no-proceed decisions."
			}
		],
		"faqItems": [
			{
				"question": "Is this tool shared with the caregiver?",
				"answer": "No. The core product is practitioner-only."
			},
			{
				"question": "Does the tool decide whether the caregiver is ready?",
				"answer": "No. Readiness is a practitioner judgment supported by entered notes, not a system verdict."
			},
			{
				"question": "What if a barrier has no support strategy yet?",
				"answer": "The plan can remain incomplete, and the missing support can be highlighted before proceeding is treated as planned."
			},
			{
				"question": "Can it handle multiple caregivers?",
				"answer": "Yes. Multiple caregivers should have separate preparation plans because readiness and barriers may differ."
			}
		]
	},
	{
		"toolType": "attachmentRepairSession",
		"slug": "attachment-repair-session",
		"title": "Attachment Repair Session Aid for Conjoint Therapy | Qwoach",
		"metaDescription": "Live-session aid for practitioners to document repair targets, adolescent communication, caregiver response, repair movement, and unresolved issues.",
		"h1": "Attachment Repair Session",
		"intro": "Attachment Repair Session is an ABFT-aligned live-session tool for practitioners facilitating a conjoint repair conversation between an adolescent and caregiver. Practitioners use it to track the rupture target, adolescent communication, caregiver response, observable repair movement, and unresolved issues.",
		"demoTitle": "Open the sample live-session capture and review how partial, stalled, and unresolved repair states are represented.",
		"demoPrompt": "Interested in using Attachment Repair Session with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0867-f-049-abft-007-r001-attachment-repair-session.md",
		"specId": "0867-f-049-abft-007-r001-attachment-repair-session",
		"tags": {
			"framework": [
				"ABFT"
			],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support",
				"Clinical documentation"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Adolescents",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before, during, or immediately after a conjoint repair conversation when a specific rupture target is being addressed."
			},
			{
				"title": "What It Captures",
				"body": "It captures the repair target, adolescent communication, caregiver response, observed movement or lack of movement, escalation, and unresolved issues."
			},
			{
				"title": "Relevant Limits",
				"body": "It does not script therapy, score attachment repair, interpret transcripts, assign blame, or claim that attachment security has been restored."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client worksheet?",
				"answer": "No. It is a live-session practitioner aid and outcome note for a facilitated repair conversation."
			},
			{
				"question": "Does it tell the practitioner what to say?",
				"answer": "No. The tool does not provide scripts or automated therapeutic decisions."
			},
			{
				"question": "Can a stalled repair be documented?",
				"answer": "Yes. Partial, stalled, escalated, and unresolved states are valid outcomes."
			},
			{
				"question": "Can the note be completed after the session?",
				"answer": "Yes. Documentation timing can be live quick capture or post-session completion."
			}
		]
	},
	{
		"toolType": "repairSessionReview",
		"slug": "repair-session-review",
		"title": "Repair Session Review Tool for Post-Repair Therapy | Qwoach",
		"metaDescription": "Review repair conversations with adolescent and caregiver perspectives, repair status, unresolved issues, and next therapeutic direction.",
		"h1": "Repair Session Review",
		"intro": "Repair Session Review is an ABFT-aligned post-session review tool for practitioners after an attachment-focused repair conversation. Practitioners use it to capture adolescent and caregiver perspectives, distinguish repair progress, identify remaining ruptures or barriers, and decide the next therapeutic step.",
		"demoTitle": "Open the sample review and compare practitioner-only and facilitated dyad review modes.",
		"demoPrompt": "Interested in using Repair Session Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0868-f-049-abft-008-r001-repair-session-review.md",
		"specId": "0868-f-049-abft-008-r001-repair-session-review",
		"tags": {
			"framework": [
				"ABFT"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Adolescents",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after a repair conversation to understand actual relational movement and decide what should happen next."
			},
			{
				"title": "What It Captures",
				"body": "It captures adolescent and caregiver perspectives, practitioner evidence, descriptive repair status, unresolved barriers or ruptures, and next therapeutic direction."
			},
			{
				"title": "Relevant Limits",
				"body": "It does not create a numeric outcome score, automate treatment recommendations, or claim repair is complete."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general session note?",
				"answer": "No. It is specifically a bounded review of an attachment-focused repair conversation."
			},
			{
				"question": "Can the dyad complete the review together?",
				"answer": "Yes. Facilitated dyad review can capture each person’s perspective while keeping practitioner assessment separate."
			},
			{
				"question": "What if perspectives conflict?",
				"answer": "Conflicting perspectives are preserved and attributed instead of being forced into one conclusion."
			},
			{
				"question": "Does the tool measure outcomes numerically?",
				"answer": "No. Repair status is descriptive and practitioner-mediated, not a score."
			}
		]
	},
	{
		"toolType": "autonomyPromotingConversationPlan",
		"slug": "autonomy-promoting-conversation-plan",
		"title": "Autonomy Conversation Plan for Adolescent-Caregiver Therapy | Qwoach",
		"metaDescription": "Create shared autonomy goals and agreements with adolescent voice, caregiver limits, support commitments, and unresolved items.",
		"h1": "Autonomy-Promoting Conversation Plan",
		"intro": "Autonomy-Promoting Conversation Plan is an ABFT-aligned tool for practitioners facilitating adolescent-caregiver conversations about independence and competence. Practitioners use it to create clear autonomy goals and agreements that include the adolescent’s voice, caregiver expectations and limits, and relational support.",
		"demoTitle": "Open the sample shared agreement and check whether it includes adolescent voice, caregiver limits, and support commitments.",
		"demoPrompt": "Interested in using Autonomy-Promoting Conversation Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0869-f-049-abft-009-r001-autonomy-promoting-conversation-plan.md",
		"specId": "0869-f-049-abft-009-r001-autonomy-promoting-conversation-plan",
		"tags": {
			"framework": [
				"ABFT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Interpersonal relationships"
			],
			"population": [
				"Adolescents",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after enough relational repair has occurred to support a conversation about independence, competence, expectations, and limits."
			},
			{
				"title": "What It Captures",
				"body": "It captures autonomy goals, adolescent voice, caregiver expectations and limits, support commitments, family agreements, unresolved disagreements, and revision history."
			},
			{
				"title": "Relevant Limits",
				"body": "It does not impose autonomy domains, developmental ratings, legal authority rules, behavior scores, or generic behavior-contract language."
			}
		],
		"faqItems": [
			{
				"question": "Is this a behavior contract?",
				"answer": "No. It is an autonomy-promoting conversation plan that balances adolescent competence with relational support."
			},
			{
				"question": "Is the adolescent’s voice required?",
				"answer": "Yes. The agreement cannot be marked complete without the adolescent’s voice represented."
			},
			{
				"question": "Can caregiver limits stay unresolved?",
				"answer": "Yes. Unresolved limits can be preserved with a next conversation focus."
			},
			{
				"question": "Can the family use the agreement outside session?",
				"answer": "Yes. Shared agreement content is family-facing so it can support daily-life use and later review."
			}
		]
	},
	{
		"toolType": "abftAdherenceMeasure",
		"slug": "abft-adherence-measure",
		"title": "ABFT Adherence Measure Fidelity Profile Tool | Qwoach",
		"metaDescription": "Practitioner-only fidelity profile structure for observed-practice ratings, evidence notes, adherence gaps, deviations, and supervision planning.",
		"h1": "ABFT Adherence Measure",
		"intro": "ABFT Adherence Measure is a practitioner-only fidelity assessment tool for evaluating whether delivery of an attachment-based family therapy case aligns with required model tasks and standards. Practitioners use it to produce a fidelity profile showing adherent areas, gaps, specific deviations, evidence notes, and supervision or correction needs.",
		"demoTitle": "Review the assessment structure and settings; substantive measure items are not shown unless supplied by the actual measure.",
		"demoPrompt": "Interested in using ABFT Adherence Measure with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0870-f-049-abft-010-r001-abft-adherence-measure.md",
		"specId": "0870-f-049-abft-010-r001-abft-adherence-measure",
		"tags": {
			"framework": [
				"ABFT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for practitioner-only review of observed practice when the goal is to identify model adherence strengths, gaps, deviations, and supervision or correction needs."
			},
			{
				"title": "What It Requires",
				"body": "A substantive assessment requires the actual adherence item set, rating or differentiation structure, anchors or standards, observed-practice basis, evidence notes, and rater attribution."
			},
			{
				"title": "Relevant Limits",
				"body": "It does not invent adherence items, rating anchors, scoring rules, competence certification, client outcome interpretation, or general therapist performance ratings outside the adherence scope."
			}
		],
		"faqItems": [
			{
				"question": "Can the public demo complete a real adherence assessment?",
				"answer": "No. A real assessment requires the actual supplied adherence measure content, including item structure and rating rules."
			},
			{
				"question": "Is this tool client-facing?",
				"answer": "No. ABFT Adherence Measure is practitioner-only and tied to observed practice."
			},
			{
				"question": "Does the tool certify therapist competence?",
				"answer": "No. It produces a fidelity profile from supplied measure content and practitioner-entered or rater-entered evidence; it does not make certification claims."
			},
			{
				"question": "Can repeated assessments be compared?",
				"answer": "Yes, when they use the same measure version/content set. Mixed versions must be labeled as not directly comparable."
			}
		]
	},
	{
		"toolType": "engagementMotivationRiskStrengthsFormulation",
		"slug": "engagement-motivation-risk-strengths-formulation",
		"title": "Engagement/Motivation Risk Formulation Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only FFT engagement formulation aid for organizing risks, strengths, relational reframes, and motivation-building implications.",
		"h1": "Engagement/Motivation Risk & Strengths Formulation",
		"intro": "Engagement/Motivation Risk & Strengths Formulation is a practitioner-only Functional Family Therapy formulation aid for family-treatment practitioners. It helps practitioners organize engagement risks, sources of resistance, family strengths or protective motivations, and non-blaming relational reframes so early motivation-building intervention can be guided by a workable formulation.",
		"demoTitle": "Explore the formulation workspace with sample, non-identifying family information.",
		"demoPrompt": "Interested in using Engagement/Motivation Risk & Strengths Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0871-f-050-fft-001-r001-engagement-motivation-risk-strengths-formulation.md",
		"specId": "0871-f-050-fft-001-r001-engagement-motivation-risk-strengths-formulation",
		"tags": {
			"framework": [
				"Functional Family Therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Strengths"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it early in treatment when engagement, resistance, negativity, or low motivation could prevent behavior-change work."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures practitioner-entered risks/resistance, strengths/protective motivations, relational reframes, and motivation-building implications."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not collect symptom scores, diagnoses, blame ratings, standardized scales, or unsupported worksheet fields."
			}
		],
		"faqItems": [
			{
				"question": "Is this completed by the family?",
				"answer": "No. This is a practitioner-only formulation aid. Family information may inform the practitioner’s entries, but there is no separate structured family digital workflow."
			},
			{
				"question": "Does the tool score motivation or readiness?",
				"answer": "No. It organizes descriptive formulation content and visible gaps; it does not produce motivation scores, readiness scores, diagnoses, or blame ratings."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool itself and selected practitioner scope are saved. Fictional demo family data and temporary sample formulation content are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "relationalAssessment",
		"slug": "relational-assessment",
		"title": "Relational Assessment Tool Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only FFT relational assessment tool for mapping family patterns, behavior functions, and interaction targets before intervention.",
		"h1": "Relational Assessment",
		"intro": "Relational Assessment is a practitioner-only FFT assessment tool for family-treatment practitioners. It helps practitioners organize relationship patterns, key behaviors, relational functions, and interaction targets so intervention choices can be matched to the family’s relational dynamics.",
		"demoTitle": "Explore a sample relational-function profile using non-identifying demo material.",
		"demoPrompt": "Interested in using Relational Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0872-f-050-fft-002-r001-relational-assessment.md",
		"specId": "0872-f-050-fft-002-r001-relational-assessment",
		"tags": {
			"framework": [
				"Functional Family Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior analysis"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before intervention selection when the practitioner needs a coherent relational-function profile."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures relationship patterns, members or dyads, key behaviors, surface conflict content, practitioner-entered functions, and interaction targets."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate functions, diagnoses, scores, moral judgments, or intervention prescriptions."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool assign relational functions automatically?",
				"answer": "No. Relational functions are practitioner-entered. The system organizes the profile and shows missing-link cues."
			},
			{
				"question": "Can clients complete the assessment?",
				"answer": "No. Clients may provide information in conversation, but this product has no separate client digital assessment workflow."
			},
			{
				"question": "What happens to demo entries after saving?",
				"answer": "Demo entries do not become real client data by default. Saving preserves the tool itself and selected assessment scope."
			}
		]
	},
	{
		"toolType": "interactionSequencePointingProcessMap",
		"slug": "interaction-sequence-pointing-process-map",
		"title": "Interaction Sequence Map Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only FFT sequence mapping tool for observable family interactions, reciprocal links, and target points for redirection.",
		"h1": "Interaction Sequence / Pointing Process Map",
		"intro": "Interaction Sequence / Pointing Process Map is a practitioner-only FFT mapping tool for family-treatment practitioners. It helps practitioners place observable behaviors in sequence, connect reciprocal actions and reactions, and mark points where in-session redirection or skills work may target the cycle.",
		"demoTitle": "Try a sample sequence map with fictional, non-identifying interaction steps.",
		"demoPrompt": "Interested in using Interaction Sequence / Pointing Process Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0873-f-050-fft-003-r001-interaction-sequence-pointing-process-map.md",
		"specId": "0873-f-050-fft-003-r001-interaction-sequence-pointing-process-map",
		"tags": {
			"framework": [
				"Functional Family Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning",
				"In-session support"
			],
			"topic": [
				"Behavior analysis",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a recurring family interaction is visible but the maintaining sequence needs to be mapped in observable terms."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures family members, observable behavior steps, reciprocal links, target points, and optional context notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not infer hidden motives, score severity, assign blame, or provide skills scripts."
			}
		],
		"faqItems": [
			{
				"question": "Can the map be shown as a cycle?",
				"answer": "Yes. The supported setting allows linear step order or loop/cycle view while preserving the same sequence meaning."
			},
			{
				"question": "Does the tool interpret why people behave that way?",
				"answer": "No. It maps observable behaviors and practitioner-marked points; relational-function conclusions are outside this tool unless entered separately as notes."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and selected orientation are saved. Fictional sequence content and sample case notes are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "relationalFunctionMap",
		"slug": "relational-function-map",
		"title": "Relational Function Map Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only FFT function map for linking family behaviors to relational functions, reframe notes, and intervention implications.",
		"h1": "Relational Function Map",
		"intro": "Relational Function Map is a practitioner-only FFT formulation tool for family-treatment practitioners. It helps practitioners link key behaviors to plausible relational functions, map how functions interact across family members, and record non-blaming reframe notes that can guide matched behavior-change strategies.",
		"demoTitle": "Explore a sample function map with fictional behaviors and practitioner-authored function notes.",
		"demoPrompt": "Interested in using Relational Function Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0874-f-050-fft-004-r001-relational-function-map.md",
		"specId": "0874-f-050-fft-004-r001-relational-function-map",
		"tags": {
			"framework": [
				"Functional Family Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the practitioner needs to understand relational functions behind behavior, not only the conflict topics."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures family members, key behaviors, practitioner-authored functions, cross-function links, reframe notes, and intervention implication notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide fixed function categories, scores, diagnoses, or system-generated interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool supply relational-function categories?",
				"answer": "No. The supplied product uses practitioner-authored functions and does not impose unsupported categories."
			},
			{
				"question": "Is there a client version?",
				"answer": "No. This configuration is practitioner-only. The practitioner may discuss selected reframes clinically, but clients do not complete the tool."
			},
			{
				"question": "What carries into my account?",
				"answer": "The tool itself and selected map scope carry into the account. Fictional demo formulation content does not become real client data by default."
			}
		]
	},
	{
		"toolType": "behaviorChangePlan",
		"slug": "behavior-change-plan",
		"title": "Behavior Change Plan Tool Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only FFT planning tool for linking target behaviors, relational formulation, intervention targets, and feasibility notes.",
		"h1": "Behavior Change Plan",
		"intro": "Behavior Change Plan is a practitioner-only FFT planning tool for family-treatment practitioners. It helps practitioners link target behaviors to the family’s relational formulation, strengths, risks, current motivation and capacities, and intervention targets so behavior-change work is specific enough to practice or monitor.",
		"demoTitle": "Explore a sample individualized pathway using fictional, non-identifying plan content.",
		"demoPrompt": "Interested in using Behavior Change Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0875-f-050-fft-005-r001-behavior-change-plan.md",
		"specId": "0875-f-050-fft-005-r001-behavior-change-plan",
		"tags": {
			"framework": [
				"Functional Family Therapy"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Problem behavior"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the family is ready for behavior-change planning and intervention targets need to match relational formulation."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures target behaviors, formulation links, strengths, risks, functions, intervention targets, motivation/capacity notes, and feasibility notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate intervention protocols, scripted practice steps, generic advice, scores, or clinical recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool provide intervention techniques?",
				"answer": "No. The practitioner enters intervention target content. The tool organizes links, fit, feasibility, and completeness."
			},
			{
				"question": "Is there anything to save if there are no settings?",
				"answer": "Yes. The fixed tool itself is saved as-is, even though no formal practitioner settings are required."
			},
			{
				"question": "Does demo plan content become client data?",
				"answer": "No. Fictional target behaviors, sample formulation links, and temporary plan notes are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "communicationSkillsPractice",
		"slug": "communication-skills-practice",
		"title": "Communication Skills Practice Demo | Qwoach",
		"metaDescription": "Explore an FFT practice support tool for practitioner-guided family communication practice, observations, relational fit, and support-needed notes.",
		"h1": "Communication Skills Practice",
		"intro": "Communication Skills Practice is an FFT behavior-change practice support tool completed together by practitioner and family members. It helps practitioners record the interaction context, practitioner-authored communication behavior focus, relational-fit notes, observed clarity and less-blaming behavior, and areas improving or still needing support.",
		"demoTitle": "Try a sample in-session practice record with fictional, non-identifying content.",
		"demoPrompt": "Interested in using Communication Skills Practice with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0876-f-050-fft-006-r001-communication-skills-practice.md",
		"specId": "0876-f-050-fft-006-r001-communication-skills-practice",
		"tags": {
			"framework": [
				"Functional Family Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Skills use",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during behavior-change work when family members practice communication in a relevant interaction with practitioner guidance."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures context, practitioner-authored behavior focus, relational-fit notes, observed skill-use notes, and improvement/support-needed markers."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not include defined skill taxonomies, scripts, numeric ratings, scoring interpretation, or homework steps in this configuration."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include communication scripts?",
				"answer": "No. Exact scripts and skill prompts are not defined in the product specification and must not be invented."
			},
			{
				"question": "Can the therapist rate skill use?",
				"answer": "Not in the base demo. Ratings are unresolved because no rating structure is defined in the supplied record."
			},
			{
				"question": "Who completes the tool?",
				"answer": "The practitioner controls the record while family members participate in guided practice together with the practitioner."
			}
		]
	},
	{
		"toolType": "parentingBehaviorManagementPlan",
		"slug": "parenting-behavior-management-plan",
		"title": "Parenting Behavior Management Plan Demo | Qwoach",
		"metaDescription": "Explore an FFT planning tool for practitioner-guided caregiver expectations, responses, follow-through, relational fit, and commitment notes.",
		"h1": "Parenting / Behavior Management Plan",
		"intro": "Parenting / Behavior Management Plan is an FFT behavior-change planning tool completed together by practitioner and caregivers. It helps practitioners and caregivers specify expectations, planned responses, follow-through, relational fit, blame or disengagement risks, and caregiver understanding and commitment.",
		"demoTitle": "Explore a sample caregiver plan with fictional, non-identifying family content.",
		"demoPrompt": "Interested in using Parenting / Behavior Management Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0877-f-050-fft-007-r001-parenting-behavior-management-plan.md",
		"specId": "0877-f-050-fft-007-r001-parenting-behavior-management-plan",
		"tags": {
			"framework": [
				"Functional Family Therapy"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Problem behavior",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during behavior-change work when caregivers need a clear, family-specific response approach."
			},
			{
				"title": "Practitioner And Caregiver Roles",
				"body": "The practitioner guides formulation fit and risk notes; caregivers contribute practical expectations, responses, follow-through, concerns, and commitment."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not prescribe parenting methods, generate consequences or rewards, score caregivers, or make competence judgments."
			}
		],
		"faqItems": [
			{
				"question": "Do caregivers participate in the tool?",
				"answer": "Yes. Caregivers participate together with the practitioner and should see plain-language plan elements they can understand and try."
			},
			{
				"question": "Does the tool prescribe discipline strategies?",
				"answer": "No. Exact parenting techniques, consequences, rewards, and scripts are not generated by the tool."
			},
			{
				"question": "What is saved after demo exploration?",
				"answer": "The tool itself and selected plan scope are saved. Fictional caregiver details and sample plan content are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "generalizationPlan",
		"slug": "generalization-plan",
		"title": "Generalization Plan Tool Demo | Qwoach",
		"metaDescription": "Explore an FFT generalization tool for practitioner-guided maintenance planning across settings, stressors, outside-session uses, and supports.",
		"h1": "Generalization Plan",
		"intro": "Generalization Plan is an FFT planning tool completed together by practitioner and family. It helps practitioners and families identify treatment gains to maintain, settings and stressors where those gains must transfer, concrete outside-session uses, likely breakdown points, and broader systems or supports when needed.",
		"demoTitle": "Explore a sample maintenance pathway with fictional, non-identifying family context.",
		"demoPrompt": "Interested in using Generalization Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0878-f-050-fft-008-r001-generalization-plan.md",
		"specId": "0878-f-050-fft-008-r001-generalization-plan",
		"tags": {
			"framework": [
				"Functional Family Therapy"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Behavior change"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it near or after active behavior-change work when treatment gains need to hold in daily life and future stressors."
			},
			{
				"title": "Practitioner And Family Roles",
				"body": "The practitioner guides treatment links and review; the family contributes daily-life settings, stressors, barriers, and feasible uses."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide reminder systems, monitoring, referral lookup, relapse scores, or unsupported predictions."
			}
		],
		"faqItems": [
			{
				"question": "Can the plan include supports beyond the household?",
				"answer": "Yes. Broader-systems transfer is a supported scope when external settings or supports are needed."
			},
			{
				"question": "Does the tool find community resources?",
				"answer": "No. This tool identifies broader supports descriptively when needed; it does not perform resource lookup or referral management."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The tool itself and selected plan scope are saved. Fictional gains, stressors, and demo support entries are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "communityResourceLinkageMap",
		"slug": "community-resource-linkage-map",
		"title": "Community Resource Linkage Map Demo | Qwoach",
		"metaDescription": "Explore an FFT generalization support tool for mapping known external supports to treatment goals, roles, next steps, and barriers.",
		"h1": "Community Resource Linkage Map",
		"intro": "Community Resource Linkage Map is an FFT generalization support tool completed together by practitioner and family. It helps practitioners and families connect known school, community, service, or other external supports to treatment goals, clarify roles and next steps, and identify barriers to follow-through.",
		"demoTitle": "Explore a sample external support pathway using fictional, non-identifying entries.",
		"demoPrompt": "Interested in using Community Resource Linkage Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0879-f-050-fft-009-r001-community-resource-linkage-map.md",
		"specId": "0879-f-050-fft-009-r001-community-resource-linkage-map",
		"tags": {
			"framework": [
				"Functional Family Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning",
				"Problem solving"
			],
			"topic": [
				"Environmental barriers",
				"Goals"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during generalization work when change depends on supports beyond the household."
			},
			{
				"title": "Practitioner And Family Roles",
				"body": "The practitioner connects supports to treatment goals; the family contributes known supports, barriers, access constraints, preferences, and role capacity."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not search for resources, recommend services, determine eligibility, collect legal consents, schedule appointments, or manage referrals."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool search for local resources?",
				"answer": "No. The supplied configuration supports manual mapping of known or identified supports only."
			},
			{
				"question": "Is this a referral platform?",
				"answer": "No. It creates an actionable support pathway but does not manage referrals, eligibility, consents, or scheduling."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The fixed tool itself is saved as-is. Fictional support-pathway entries from the demo are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "mstFitDriverAnalysis",
		"slug": "mst-fit-driver-analysis",
		"title": "MST Fit Driver Analysis Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only MST analytic tool for mapping target-specific drivers across family, peers, school, community, and other systems.",
		"h1": "MST Fit / Driver Analysis",
		"intro": "MST Fit / Driver Analysis is a practitioner-only Multisystemic Therapy analytic tool for clinicians working with youth whose serious behavioral problems are shaped by multiple systems. It helps practitioners define a specific target behavior, map drivers across relevant systems, distinguish maintaining factors from background context, and organize priority notes for intensive intervention focus.",
		"demoTitle": "Explore a sample cross-system driver map using fictional, non-identifying youth case material.",
		"demoPrompt": "Interested in using MST Fit / Driver Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0880-f-051-mst-001-r001-mst-fit-driver-analysis.md",
		"specId": "0880-f-051-mst-001-r001-mst-fit-driver-analysis",
		"tags": {
			"framework": [
				"Multisystemic Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Problem behavior"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a youth’s target behavior appears to be maintained by factors across family, peers, school, community, or other relevant systems."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures target behavior, relevant systems, drivers, driver-to-target links, maintaining-factor or background-context classification, evidence notes, and priority notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate causality, diagnose, score risk, recommend interventions, determine services, or create a referral map."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide what caused the behavior?",
				"answer": "No. The practitioner enters and classifies drivers. The system organizes links and shows missing information without generating automated causal claims."
			},
			{
				"question": "Can systems be customized?",
				"answer": "Yes. System scope is configurable. Defaults include family, peers, school, and community, and practitioners can include other relevant systems."
			},
			{
				"question": "Does the demo require real youth information?",
				"answer": "No. Public exploration uses fictional, non-identifying case material. Demo drivers and notes are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "caseSpecificTreatmentGoals",
		"slug": "case-specific-treatment-goals",
		"title": "Case-Specific Treatment Goals MST Demo | Qwoach",
		"metaDescription": "Explore an MST goal-planning tool for defining observable case-specific treatment goals and tracking youth, family, and participant agreement.",
		"h1": "Case-Specific Treatment Goals for MST Cases",
		"intro": "Case-Specific Treatment Goals is a collaborative MST case-planning tool for practitioners. It helps MST practitioners draft explicit individualized treatment goals, connect them to case context and priority outcomes, and track whether the youth, family, and key participants understand and agree.",
		"demoTitle": "Explore a sample goal workspace",
		"demoPrompt": "Interested in using Case-Specific Treatment Goals with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0881-f-051-mst-002-r001-case-specific-treatment-goals.md",
		"specId": "0881-f-051-mst-002-r001-case-specific-treatment-goals",
		"tags": {
			"framework": [
				"Multisystemic Therapy"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals"
			],
			"population": [
				"Adolescents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it at the start of MST or when revising treatment focus because the case definition of success has changed."
			},
			{
				"title": "What it tracks",
				"body": "The tool tracks goal wording, relevant case context, priority outcomes, participant agreement, unresolved concerns, active status, and revisions over time."
			},
			{
				"title": "Important limitation",
				"body": "The tool organizes and checks completeness of goal information. It does not generate treatment goals, score clinical adequacy, or provide MST decision rules."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create MST treatment goals automatically?",
				"answer": "No. The practitioner drafts the treatment goals; the tool organizes them and shows whether wording, context links, and participant agreement are complete."
			},
			{
				"question": "Can youth and family members participate?",
				"answer": "Yes. A shared completion view can present goal language and collect confirmation, disagreement, or clarification from relevant participants."
			},
			{
				"question": "What happens if one participant has not agreed?",
				"answer": "Partial agreement remains visible. Missing or unresolved participant input is not treated as full alignment."
			},
			{
				"question": "Are goals scored?",
				"answer": "No. The result uses descriptive completeness indicators and agreement state, not scoring or clinical adequacy judgments."
			}
		]
	},
	{
		"toolType": "weeklyGoalActionPlan",
		"slug": "weekly-goal-action-plan",
		"title": "Weekly Goal / Action Plan MST Demo | Qwoach",
		"metaDescription": "Explore an MST weekly action-planning tool for linking treatment goals to actions, responsible people, adherence review, and barriers.",
		"h1": "Weekly Goal / Action Plan for MST Treatment Cycles",
		"intro": "Weekly Goal / Action Plan is a recurring MST planning and monitoring tool for practitioners. It helps MST practitioners define current weekly actions tied to treatment goals, identify responsible people and expectations, and review adherence and barriers across cycles.",
		"demoTitle": "Explore a sample weekly cycle",
		"demoPrompt": "Interested in using Weekly Goal / Action Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0882-f-051-mst-003-r001-weekly-goal-action-plan.md",
		"specId": "0882-f-051-mst-003-r001-weekly-goal-action-plan",
		"tags": {
			"framework": [
				"Multisystemic Therapy"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Homework"
			],
			"population": [
				"Adolescents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it during active MST treatment when goals need to become near-term actions and follow-through needs repeated review."
			},
			{
				"title": "What it captures",
				"body": "The tool captures weekly actions, linked goals, responsible people, near-term expectations, reported adherence, and barriers for the next cycle."
			},
			{
				"title": "Important limitation",
				"body": "The tool does not add generic reminders, scheduling, productivity metadata, or unsupported clinical scoring."
			}
		],
		"faqItems": [
			{
				"question": "Is this a task manager?",
				"answer": "No. It is a goal-linked MST weekly planning and adherence review tool, not a general productivity or scheduling product."
			},
			{
				"question": "Can participants report what happened?",
				"answer": "Yes. A shared view can let participants report completion, non-completion, partial progress where supported, and barriers for actions relevant to them."
			},
			{
				"question": "Does the tool infer adherence if no one reviews an action?",
				"answer": "No. Adherence cannot be inferred when no review has occurred; unresolved review remains visible."
			},
			{
				"question": "Can unfinished actions move to the next week?",
				"answer": "Yes. Relevant unresolved actions can be carried forward while preserving their original cycle history."
			}
		]
	},
	{
		"toolType": "familyPeerSchoolCommunitySystemMap",
		"slug": "family-peer-school-community-system-map",
		"title": "MST System Map Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only MST system map for organizing family, peer, school, and community influences around a youth's target problem.",
		"h1": "Family, Peer, School, and Community System Map for MST",
		"intro": "Family/Peer/School/Community System Map is a practitioner-only MST formulation aid. It helps MST practitioners represent relevant people, settings, and influences across family, peer, school, and community systems so they can identify actionable intervention targets.",
		"demoTitle": "Explore a sample system map",
		"demoPrompt": "Interested in using Family/Peer/School/Community System Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0883-f-051-mst-004-r001-family-peer-school-community-system-map.md",
		"specId": "0883-f-051-mst-004-r001-family-peer-school-community-system-map",
		"tags": {
			"framework": [
				"Multisystemic Therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis",
				"Interpersonal relationships"
			],
			"population": [
				"Adolescents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it during MST intervention planning when the practitioner needs to see influences across ecological systems rather than only one setting."
			},
			{
				"title": "What it captures",
				"body": "The tool captures target problems, mapped influences, domain assignments, relationship descriptions, protective or risk-maintaining distinctions, unresolved unknowns, and selected intervention targets."
			},
			{
				"title": "Important limitation",
				"body": "The map organizes practitioner formulation. It does not calculate risk, prove causality, recommend interventions, or collect exhaustive social history unrelated to target problems."
			}
		],
		"faqItems": [
			{
				"question": "Can the domain labels be customized?",
				"answer": "No. The tool uses the fixed family, peer, school, and community domains defined by the product specification."
			},
			{
				"question": "Is there a family or client view?",
				"answer": "No. This product is practitioner-only; information from others may inform the map outside the product workflow."
			},
			{
				"question": "Does the system recommend intervention targets?",
				"answer": "No. The practitioner identifies actionable targets; the system organizes and displays them."
			},
			{
				"question": "What if one domain has no known information?",
				"answer": "The domain can remain empty. Unknown information should not be forced or guessed."
			}
		]
	},
	{
		"toolType": "therapistAdherenceMeasureRevisedTamR",
		"slug": "therapist-adherence-measure-revised-tam-r",
		"title": "TAM-R MST Fidelity Measure Demo | Qwoach",
		"metaDescription": "Explore the TAM-R workflow for caregiver-reported MST therapist fidelity administration, completion tracking, scoring, and longitudinal review.",
		"h1": "Therapist Adherence Measure-Revised (TAM-R) for MST Fidelity Review",
		"intro": "Therapist Adherence Measure-Revised (TAM-R) is a standardized caregiver-reported MST therapist fidelity measure for MST practitioners or quality-assurance leads. It helps administer a fixed 28-item caregiver measure and review standardized fidelity score or findings when the instrument content and scoring rules are supplied.",
		"demoTitle": "Explore the TAM-R administration flow",
		"demoPrompt": "Interested in using Therapist Adherence Measure-Revised (TAM-R) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0884-f-051-mst-005-r001-therapist-adherence-measure-revised-tam-r.md",
		"specId": "0884-f-051-mst-005-r001-therapist-adherence-measure-revised-tam-r",
		"tags": {
			"framework": [
				"Multisystemic Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it when caregiver-reported fidelity information is needed to support MST supervision or quality-improvement review."
			},
			{
				"title": "What it captures",
				"body": "The tool captures caregiver responses to the fixed 28-item measure, completion state, administration metadata, and score or findings only according to supplied scoring rules."
			},
			{
				"title": "Important limitation",
				"body": "The demo cannot supply TAM-R item text, response options, scoring, thresholds, or item-level interpretations unless those are provided by the source configuration."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo show the TAM-R item text?",
				"answer": "No. The supplied product specification does not include item text, so the demo shows the administration structure without inventing content."
			},
			{
				"question": "Can practitioners change TAM-R questions or scoring?",
				"answer": "No. TAM-R is a standardized fixed measure; item wording, response options, scoring, and thresholds are not practitioner settings."
			},
			{
				"question": "Can incomplete administrations be scored?",
				"answer": "No final score should be produced from an incomplete administration unless supplied scoring rules explicitly permit partial scoring."
			},
			{
				"question": "Who completes the measure?",
				"answer": "The caregiver completes the fixed measure; the practitioner or QA lead sets up and reviews the administration."
			}
		]
	},
	{
		"toolType": "supervisorAdherenceMeasure",
		"slug": "supervisor-adherence-measure",
		"title": "Supervisor Adherence Measure MST Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only MST QA workflow for supervision fidelity review, completion validation, findings, and comparison over time.",
		"h1": "Supervisor Adherence Measure for MST Quality Assurance",
		"intro": "Supervisor Adherence Measure is a practitioner-only MST quality-assurance tool for program QA practitioners. It helps collect and review supervision fidelity information, compare patterns over time or across supervisors, and identify supervision practices needing reinforcement or correction when measure definitions are supplied.",
		"demoTitle": "Explore a sample supervision review",
		"demoPrompt": "Interested in using Supervisor Adherence Measure with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0885-f-051-mst-006-r001-supervisor-adherence-measure.md",
		"specId": "0885-f-051-mst-006-r001-supervisor-adherence-measure",
		"tags": {
			"framework": [
				"Multisystemic Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it for MST program quality assurance when supervision fidelity needs to be reviewed repeatedly over time or across supervisors."
			},
			{
				"title": "What it captures",
				"body": "The tool captures review target, period, measure-supported fidelity information, completeness, measure-defined findings, and reviewer notes."
			},
			{
				"title": "Important limitation",
				"body": "The product cannot define items, standards, or scores that are not supplied by the measure structure."
			}
		],
		"faqItems": [
			{
				"question": "Is there a caregiver or client form?",
				"answer": "No. This product is practitioner-only and is used within QA workflow."
			},
			{
				"question": "Can the demo show final supervision scores?",
				"answer": "Only if scoring rules are supplied. Without supplied rules, the demo can show completion and review structure but not invented scores."
			},
			{
				"question": "Can results be compared across supervisors?",
				"answer": "Yes, comparison is supported when the same measure content and scoring basis are used consistently."
			},
			{
				"question": "Are reviewer notes the same as measure findings?",
				"answer": "No. Reviewer-entered notes remain distinct from measure-derived findings."
			}
		]
	},
	{
		"toolType": "consultantAdherenceMeasure",
		"slug": "consultant-adherence-measure",
		"title": "Consultant Adherence Measure MST Demo | Qwoach",
		"metaDescription": "Explore an MST QA workflow for consultation fidelity review, period-based findings, and longitudinal drift or improvement tracking.",
		"h1": "Consultant Adherence Measure for MST Implementation QA",
		"intro": "Consultant Adherence Measure is a practitioner-only MST quality-assurance tool for program QA practitioners. It helps collect consultation fidelity information, review measure-defined findings, and examine longitudinal drift or improvement when the measure structure and standards are supplied.",
		"demoTitle": "Explore a sample consultant review",
		"demoPrompt": "Interested in using Consultant Adherence Measure with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0886-f-051-mst-007-r001-consultant-adherence-measure.md",
		"specId": "0886-f-051-mst-007-r001-consultant-adherence-measure",
		"tags": {
			"framework": [
				"Multisystemic Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it for MST implementation quality assurance when consultation fidelity needs repeated review over time."
			},
			{
				"title": "What it captures",
				"body": "The tool captures consultant or consultation context, review period, measure-supported fidelity information, completion state, findings, and longitudinal comparison state."
			},
			{
				"title": "Important limitation",
				"body": "The product cannot invent consultation items, standards, scores, or implementation ratings that are not supplied by the measure."
			}
		],
		"faqItems": [
			{
				"question": "Is this used by clients or families?",
				"answer": "No. This product is practitioner-only and belongs to program QA workflow."
			},
			{
				"question": "Does the tool detect drift automatically?",
				"answer": "It can summarize longitudinal patterns using supplied measure definitions, but it must not invent standards or unsupported drift rules."
			},
			{
				"question": "Can different consultation contexts be compared?",
				"answer": "Comparison is supported only when content and scoring remain consistent enough for the comparison to be meaningful."
			},
			{
				"question": "What happens when data is incomplete?",
				"answer": "Incomplete data cannot produce final findings unless the supplied measure rules allow it."
			}
		]
	},
	{
		"toolType": "programImplementationReview",
		"slug": "program-implementation-review",
		"title": "MST Program Implementation Review Demo | Qwoach",
		"metaDescription": "Explore a periodic MST program review tool for implementation findings, strengths, gaps, improvement needs, and comparison across review cycles.",
		"h1": "Program Implementation Review for MST Quality Assurance",
		"intro": "Program Implementation Review is a periodic MST program-level quality-assurance tool for QA practitioners and program leads. It helps organize implementation-performance findings, strengths, gaps, improvement needs, and change across repeated review periods.",
		"demoTitle": "Explore a sample program review",
		"demoPrompt": "Interested in using Program Implementation Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0887-f-051-mst-008-r001-program-implementation-review.md",
		"specId": "0887-f-051-mst-008-r001-program-implementation-review",
		"tags": {
			"framework": [
				"Multisystemic Therapy"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring",
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it for periodic MST program implementation review, including biannual review when that timing is part of the surrounding workflow."
			},
			{
				"title": "What it captures",
				"body": "The tool captures program scope, review period, evidence notes, findings, strengths, gaps, improvement needs, completeness state, and repeated-review comparison."
			},
			{
				"title": "Important limitation",
				"body": "The tool does not invent implementation domains, benchmarks, scores, or standards absent supplied review content."
			}
		],
		"faqItems": [
			{
				"question": "Is biannual timing fixed inside the tool?",
				"answer": "Not from the supplied specification. The record describes biannual review, but whether that timing is fixed in-product requires validation."
			},
			{
				"question": "Can the tool compare reviews over time?",
				"answer": "Yes. It can compare repeated reviews when the review structure is consistent enough to support comparison."
			},
			{
				"question": "Does the system generate program ratings?",
				"answer": "No. The system organizes review-based findings and comparisons; it does not invent scores or benchmarks."
			},
			{
				"question": "What happens if review areas are incomplete?",
				"answer": "Incomplete review areas must be marked incomplete rather than omitted silently."
			}
		]
	},
	{
		"toolType": "dischargeOutcomeRecord",
		"slug": "discharge-outcome-record",
		"title": "MST Discharge Outcome Record Demo | Qwoach",
		"metaDescription": "Explore an MST case-closure tool for recording standardized discharge outcomes, validating required domains, and preparing program-monitoring data.",
		"h1": "Discharge Outcome Record for MST Case Closure",
		"intro": "Discharge Outcome Record is a practitioner-only MST case-closure tool for practitioners and program monitoring users. It helps record required standardized discharge outcome information, validate completion, and prepare comparable outcome data for program monitoring.",
		"demoTitle": "Explore a sample discharge record",
		"demoPrompt": "Interested in using Discharge Outcome Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0888-f-051-mst-009-r001-discharge-outcome-record.md",
		"specId": "0888-f-051-mst-009-r001-discharge-outcome-record",
		"tags": {
			"framework": [
				"Multisystemic Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it at MST case closure when standardized discharge outcome information must be recorded consistently."
			},
			{
				"title": "What it captures",
				"body": "The tool captures case closure instance, required outcome-domain values when supplied, completion state, finalization state, and aggregate-ready program monitoring data."
			},
			{
				"title": "Important limitation",
				"body": "The supplied specification does not include the exact three outcome domains or status definitions, so the demo must not name or score them."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo list the three MST discharge outcomes?",
				"answer": "No. The supplied specification says three outcomes are tracked but does not include their exact domains, so the demo must not invent them."
			},
			{
				"question": "Can practitioners change the outcome domains?",
				"answer": "No. Outcome domains and definitions are fixed once supplied and are not practitioner settings."
			},
			{
				"question": "Can incomplete records be finalized?",
				"answer": "No. Missing required domains prevent finalization."
			},
			{
				"question": "Is incomplete data the same as an unsuccessful outcome?",
				"answer": "No. Cases ending without complete data must remain distinguishable from completed unsuccessful outcomes."
			}
		]
	},
	{
		"toolType": "mstiCaseDataSystem",
		"slug": "msti-case-data-system",
		"title": "MSTI Case Data System Demo | Qwoach",
		"metaDescription": "Explore an MST case and program data system for longitudinal progress, fidelity, implementation, outcomes, reporting periods, and drill-down review.",
		"h1": "MSTI Case Data System for Longitudinal MST Monitoring",
		"intro": "MSTI Case Data System is a practitioner-only longitudinal MST case and program data product for practitioners, supervisors, and program managers. It helps review supported case progress, fidelity, implementation, and outcomes across cases, caseloads, programs, and reporting periods.",
		"demoTitle": "Explore a sample MST data dashboard",
		"demoPrompt": "Interested in using MSTI Case Data System with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0889-f-051-mst-010-r001-msti-case-data-system.md",
		"specId": "0889-f-051-mst-010-r001-msti-case-data-system",
		"tags": {
			"framework": [
				"Multisystemic Therapy"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it during ongoing MST case, supervision, and program management when longitudinal evidence is needed across cases or reporting periods."
			},
			{
				"title": "What it includes",
				"body": "The system can show case progress, fidelity information, implementation data, outcomes, program summaries, completeness indicators, and drill-down to underlying records where supported."
			},
			{
				"title": "Important limitation",
				"body": "The system is not a generic EHR, CRM, or analytics builder and should not invent fields, measures, benchmarks, or clinical recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does this system include a client-facing experience?",
				"answer": "No. The MSTI Case Data System itself is practitioner-only; client or caregiver input may come through connected tools when those tools define it."
			},
			{
				"question": "Can aggregate summaries be traced back to cases?",
				"answer": "Yes. Aggregate summaries should support drill-down so missing or unusual underlying records are not hidden."
			},
			{
				"question": "Are incomplete records included as final outcomes?",
				"answer": "No. Draft, unresolved, or incomplete records must not be treated as finalized outcomes."
			},
			{
				"question": "Can practitioners change MST data definitions?",
				"answer": "No. Review scope and reporting period are configurable, but fixed data definitions from underlying measures or program requirements are not practitioner settings."
			}
		]
	},
	{
		"toolType": "familyNeedsInformationAssessment",
		"slug": "family-needs-information-assessment",
		"title": "Family Needs Information Assessment Demo | Qwoach",
		"metaDescription": "Explore a family psychoeducation intake tool for identifying family questions, concerns, support needs, priorities, and first topics to address.",
		"h1": "Family Needs / Information Assessment for Family Psychoeducation",
		"intro": "Family Needs / Information Assessment is a family psychoeducation intake and tailoring tool for practitioners. It helps practitioners gather family-reported questions, concerns, information needs, and support priorities so education, support, and problem solving can be tailored to the family's actual needs.",
		"demoTitle": "Explore a sample family assessment",
		"demoPrompt": "Interested in using Family Needs / Information Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0890-f-052-fpe-001-r001-family-needs-information-assessment.md",
		"specId": "0890-f-052-fpe-001-r001-family-needs-information-assessment",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When it is used",
				"body": "Use it at the start of family psychoeducation or when family priorities need to be revisited as needs evolve."
			},
			{
				"title": "What it captures",
				"body": "The tool captures family-reported questions, concerns, information needs, support priorities, optional ordering, unresolved items, and practitioner clarification notes."
			},
			{
				"title": "Important limitation",
				"body": "The tool organizes needs for tailoring focus. It does not diagnose, score family functioning, recommend a curriculum, or infer family motives."
			}
		],
		"faqItems": [
			{
				"question": "Can family members enter their own needs?",
				"answer": "Yes. A shared completion view can let family members enter plain-language questions, concerns, and support needs."
			},
			{
				"question": "Can the practitioner record needs after a discussion?",
				"answer": "Yes. Completion mode can support practitioner-recorded entry from discussion while preserving source distinction."
			},
			{
				"question": "Does the tool recommend education topics automatically?",
				"answer": "No. It summarizes needs and priorities so the practitioner can choose the education and problem-solving focus."
			},
			{
				"question": "What if family members disagree about priorities?",
				"answer": "Conflicting family perspectives can coexist; the tool should not force a single artificial priority."
			}
		]
	},
	{
		"toolType": "schizophreniaAFamilyEducationCurriculum",
		"slug": "schizophrenia-a-family-education-curriculum",
		"title": "Schizophrenia Family Education Curriculum Demo | Qwoach",
		"metaDescription": "Explore a practitioner-led schizophrenia family education curriculum for delivering sessions, handouts, discussion notes, and course progress review.",
		"h1": "Schizophrenia: A Family Education Curriculum",
		"intro": "Schizophrenia: A Family Education Curriculum is a practitioner-led family psychoeducation curriculum for clinicians, family educators, trainers, and community mental health program staff. It helps practitioners deliver a structured 12-hour course about schizophrenia, treatment, relapse risk, and family coping while tracking session delivery, shared materials, questions, and follow-up needs.",
		"demoTitle": "Explore a sample session workspace",
		"demoPrompt": "Interested in using Schizophrenia: A Family Education Curriculum with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0891-f-052-fpe-002-r001-schizophrenia-a-family-education-curriculum.md",
		"specId": "0891-f-052-fpe-002-r001-schizophrenia-a-family-education-curriculum",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support",
				"Progress review"
			],
			"topic": [
				"Psychosis",
				"Relapse prevention"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for educator-led family education classes, clinician-led family sessions, trainer preparation, or community mental health program delivery for relatives of adults with schizophrenia."
			},
			{
				"title": "What It Tracks",
				"body": "The tool tracks session delivery, shared handouts, attendance or participation, family questions, concerns addressed, unresolved follow-up items, and course completion status."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not diagnose, score family knowledge, rate relapse risk, or generate new curriculum content. Exact session breakdown and content must be supplied where placeholders remain unresolved."
			}
		],
		"faqItems": [
			{
				"question": "Is this a scored assessment?",
				"answer": "No. This tool supports curriculum delivery and descriptive review; it does not produce a family knowledge score or clinical rating."
			},
			{
				"question": "Can family members use it without the educator?",
				"answer": "No. The family view supports handouts, exercises, and questions, but the curriculum is practitioner-led."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The curriculum tool and practitioner configuration are saved. Sample family data and demo discussion notes are not saved as real client data."
			},
			{
				"question": "Can I edit the curriculum content in the demo?",
				"answer": "No. The product preserves the named curriculum structure and does not act as a generic course authoring system."
			}
		]
	},
	{
		"toolType": "depressionBipolarDisorderFamilyPsychoeducationalGroupManualTherapistGuide",
		"slug": "depression-bipolar-disorder-family-psychoeducational-group-manual-therapist-guide",
		"title": "Mood Disorder Family Psychoeducation Manual Demo | Qwoach",
		"metaDescription": "Explore a therapist-led family psychoeducation manual for depression and bipolar disorder sessions, handouts, questions, and group progress review.",
		"h1": "Depression & Bipolar Disorder: Family Psychoeducational Group Manual - Therapist Guide",
		"intro": "Depression & Bipolar Disorder: Family Psychoeducational Group Manual - Therapist Guide is a therapist-led family psychoeducation manual for therapists, group leaders, and mental health program staff. It helps practitioners deliver structured group sessions for relatives supporting someone with major depression or bipolar disorder, share participant handouts, capture questions, and review follow-up concerns.",
		"demoTitle": "Explore the group session demo",
		"demoPrompt": "Interested in using Depression & Bipolar Disorder: Family Psychoeducational Group Manual - Therapist Guide with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0892-f-052-fpe-002-r002-depression-bipolar-disorder-family-psychoeducational-group-manual-therapist-guide.md",
		"specId": "0892-f-052-fpe-002-r002-depression-bipolar-disorder-family-psychoeducational-group-manual-therapist-guide",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support",
				"Progress review"
			],
			"topic": [
				"Depression",
				"Bipolar disorder"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for therapist-led family psychoeducation groups for relatives supporting someone diagnosed with major depression or bipolar disorder."
			},
			{
				"title": "Practitioner And Participant Roles",
				"body": "The practitioner uses leader directions and records delivery status. Family participants view handouts, discuss questions, and retain participant-facing materials."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not create treatment recommendations, symptom ratings, caregiver scores, or invented worksheet fields. Exact content and language availability must be supplied."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create a clinical score?",
				"answer": "No. It records psychoeducation delivery, handouts, questions, concerns, and follow-up items without producing a disorder severity score or family competence rating."
			},
			{
				"question": "Can handouts be shown in French?",
				"answer": "Yes, where French participant materials are available from the supplied manual content, the handout language can be selected."
			},
			{
				"question": "Can I use it for any diagnosis?",
				"answer": "No. This tool is for the named depression and bipolar disorder family psychoeducation manual, not a generic psychoeducation builder."
			},
			{
				"question": "What happens to demo group data when I save?",
				"answer": "Demo group data is not saved as real client data. The tool and practitioner configuration are saved."
			}
		]
	},
	{
		"toolType": "navigateFamilyEducationProgramManual",
		"slug": "navigate-family-education-program-manual",
		"title": "NAVIGATE Family Education Program Demo | Qwoach",
		"metaDescription": "Explore a staged NAVIGATE family education workspace for first-episode psychosis sessions, family concerns, collaboration needs, and progress review.",
		"h1": "NAVIGATE Family Education Program Manual",
		"intro": "NAVIGATE Family Education Program Manual is a staged family education tool for family clinicians and coordinated specialty care team members. It helps practitioners engage relatives or significant others of a young person experiencing first-episode psychosis and track education, concerns, collaboration needs, relapse prevention, and recovery support over time.",
		"demoTitle": "Explore the staged family education demo",
		"demoPrompt": "Interested in using NAVIGATE Family Education Program Manual with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0893-f-052-fpe-002-r003-navigate-family-education-program-manual.md",
		"specId": "0893-f-052-fpe-002-r003-navigate-family-education-program-manual",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support",
				"Progress review"
			],
			"topic": [
				"Psychosis",
				"Relapse prevention"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Staged Work",
				"body": "The demo organizes work into engagement/orientation/assessment, stabilization and recovery, consolidating gains, and promoting prolonged recovery."
			},
			{
				"title": "Care Team Use",
				"body": "The practitioner record can support continuity for authorized team members by preserving descriptive concerns, collaboration needs, and stage status."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not define consent mechanics, treatment decisions, clinical risk scores, or generic crisis pathways. Exact manual materials must be supplied."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic psychosis education tool?",
				"answer": "No. It represents the NAVIGATE Family Education Program Manual within first-episode psychosis coordinated specialty care."
			},
			{
				"question": "Does it score relapse risk or family readiness?",
				"answer": "No. It provides descriptive stage progress and concern tracking without clinical risk scoring or family competence ratings."
			},
			{
				"question": "Can family members submit concerns?",
				"answer": "Yes, where participant access exists, family members or significant others can submit questions or concerns for practitioner review."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The program tool and practitioner configuration are saved. Fictional family concerns and sample care-context data are not saved as real client records."
			}
		]
	},
	{
		"toolType": "communicationSkillsHandout",
		"slug": "communication-skills-handout",
		"title": "Family Communication Skills Handout Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send family communication skills handout for sharing, discussion, optional questions, and descriptive practice follow-up.",
		"h1": "Communication Skills Handout",
		"intro": "Communication Skills Handout is a ready-to-send family psychoeducation handout for practitioners supporting families in mental health care. It helps practitioners share concrete communication behaviors for symptoms, support, boundaries, or conflict and optionally review whether the skills seem relevant or usable for the family.",
		"demoTitle": "Explore the handout demo",
		"demoPrompt": "Interested in using Communication Skills Handout with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0894-f-052-fpe-003-r001-communication-skills-handout.md",
		"specId": "0894-f-052-fpe-003-r001-communication-skills-handout",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships",
				"Skills use"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when communication around symptoms, boundaries, support, or conflict has become a focus in family consultation or psychoeducation."
			},
			{
				"title": "Review Scope",
				"body": "Review is optional and descriptive. The practitioner can review whether the handout was understood, discussed, or tried without scoring communication ability."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not invent communication skill prompts, rate family communication, diagnose relationships, or require mandatory practice logs."
			}
		],
		"faqItems": [
			{
				"question": "Is practice review required?",
				"answer": "No. Practice review is optional because the product supports ready-to-send handout delivery with possible review."
			},
			{
				"question": "Does the tool score family communication?",
				"answer": "No. It records sharing, discussion, questions, and optional practice reports without rating communication quality."
			},
			{
				"question": "Can I customize the handout content?",
				"answer": "No. The underlying handout content is fixed or externally supplied. You can add context and target situations without creating new skills."
			},
			{
				"question": "What gets saved?",
				"answer": "The handout tool and practitioner setup are saved. Demo questions, target situations, and reflections are not saved as real client data."
			}
		]
	},
	{
		"toolType": "problemSolvingWorksheet2",
		"slug": "problem-solving-worksheet-2",
		"title": "Family Problem-Solving Worksheet Demo | Qwoach",
		"metaDescription": "Explore a family psychoeducation worksheet for defining a concrete problem, considering solutions, selecting an action, and reviewing next steps.",
		"h1": "Problem-Solving Worksheet",
		"intro": "Problem-Solving Worksheet is a family psychoeducation worksheet for practitioners supporting families facing a concrete mental illness or recovery-related problem. It helps practitioners guide the family through a structured problem-solving process that defines the problem, considers possible solutions, selects a course of action, and records next steps for follow-up.",
		"demoTitle": "Try the worksheet flow",
		"demoPrompt": "Interested in using Problem-Solving Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0895-f-052-fpe-004-r001-problem-solving-worksheet.md",
		"specId": "0895-f-052-fpe-004-r001-problem-solving-worksheet",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Problem solving"
			],
			"topic": [
				"Problem solving"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a family needs to move from distress or disagreement into coordinated problem solving around one concrete mental illness or recovery-related issue."
			},
			{
				"title": "What It Produces",
				"body": "The result is a practical problem-and-action-plan summary with options considered, selected solution, next steps, and follow-up indicators where provided."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not invent seven-step labels, score the family, resolve disagreements automatically, or generate clinical recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can the worksheet be sent before a session?",
				"answer": "Yes. It can be sent for family preparation or completed together in session."
			},
			{
				"question": "What makes a worksheet action-ready?",
				"answer": "It needs at least a specific problem, a selected solution, and next steps; responsibilities or follow-up indicators improve reviewability."
			},
			{
				"question": "What happens if the family disagrees?",
				"answer": "The worksheet can remain unresolved and record multiple options without forcing a selected solution."
			},
			{
				"question": "Does saving keep demo worksheet answers?",
				"answer": "No. Saving keeps the tool and practitioner setup, not fictional worksheet answers or sample family content."
			}
		]
	},
	{
		"toolType": "warningSignAssessment",
		"slug": "warning-sign-assessment",
		"title": "Warning Sign Assessment for Family Psychoeducation | Qwoach",
		"metaDescription": "Explore a warning-sign assessment for collecting family observations, comparing baseline, and reviewing an individualized warning-sign profile.",
		"h1": "Warning Sign Assessment",
		"intro": "Warning Sign Assessment is a family psychoeducation assessment for practitioners helping families support someone with severe mental illness. It helps practitioners collect family observations, distinguish possible early warning signs from baseline behavior where possible, and review an individualized warning-sign profile that can inform prevention or response planning.",
		"demoTitle": "Explore the warning-sign profile demo",
		"demoPrompt": "Interested in using Warning Sign Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0896-f-052-fpe-005-r001-warning-sign-assessment.md",
		"specId": "0896-f-052-fpe-005-r001-warning-sign-assessment",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Risk review"
			],
			"topic": [
				"Relapse prevention",
				"Mental health conditions"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures observed early changes, examples, baseline descriptions where available, uncertainty, and practitioner review status."
			},
			{
				"title": "Planning Handoff",
				"body": "A reviewed warning-sign profile can inform a separate relapse-prevention or crisis-response planning workflow; the assessment itself does not generate response steps."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not calculate relapse probability, assign crisis risk, diagnose relapse, or supply generic warning signs as individualized findings."
			}
		],
		"faqItems": [
			{
				"question": "Does this predict relapse or crisis?",
				"answer": "No. It organizes reported warning signs and baseline distinctions; it does not predict relapse, crisis, or severity."
			},
			{
				"question": "Can family members submit observations on their own?",
				"answer": "Yes. The assessment can be sent for family input or completed together with the practitioner."
			},
			{
				"question": "What if baseline behavior is unknown?",
				"answer": "Unknown baseline is marked as missing or needing clarification rather than invented."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The assessment tool and practitioner setup are saved. Fictional warning signs and sample observations are not saved as real client data."
			}
		]
	},
	{
		"toolType": "symptomTrackingWorksheet",
		"slug": "symptom-tracking-worksheet",
		"title": "Symptom Tracking Worksheet for Family Observations | Qwoach",
		"metaDescription": "Explore a longitudinal symptom tracking worksheet for repeated family observations, missing periods, descriptive trends, and practitioner review.",
		"h1": "Symptom Tracking Worksheet",
		"intro": "Symptom Tracking Worksheet is a longitudinal family psychoeducation worksheet for practitioners monitoring a relative's mental health symptoms between service contacts. It helps practitioners collect repeated family observations, organize them by date or period, and review descriptive changes, patterns, missing periods, and notes without creating unsupported clinical scores.",
		"demoTitle": "Explore the tracking demo",
		"demoPrompt": "Interested in using Symptom Tracking Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0897-f-052-fpe-006-r001-symptom-tracking-worksheet.md",
		"specId": "0897-f-052-fpe-006-r001-symptom-tracking-worksheet",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Mental health conditions"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Longitudinal Value",
				"body": "The tool is designed for repeated observations so practitioners can review change, patterns, gaps, or escalation over time rather than relying on isolated impressions."
			},
			{
				"title": "Multiple Observers",
				"body": "If multiple observers are used, different reports should remain source-distinct rather than being merged as a single fact."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not invent symptom lists, scales, thresholds, alerts, diagnoses, relapse predictions, or treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include built-in symptom scales?",
				"answer": "No. Exact fields and scales are unresolved unless supplied; targets may be source-defined or practitioner-defined."
			},
			{
				"question": "Does the system alert on worsening symptoms?",
				"answer": "No. It may show descriptive changes if the data supports them, but it does not create alerts or clinical thresholds."
			},
			{
				"question": "What happens when entries are missed?",
				"answer": "Missed entries are shown as missing periods, not as zero symptoms or normal status."
			},
			{
				"question": "What is saved after public exploration?",
				"answer": "The tracker tool and practitioner configuration are saved. Fictional sample entries and trend data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "familyRelapsePreventionWorksheet",
		"slug": "family-relapse-prevention-worksheet",
		"title": "Family Relapse Prevention Worksheet Demo | Qwoach",
		"metaDescription": "Explore a collaborative relapse-prevention worksheet for warning signs, preventive actions, response steps, review status, and shared plan use.",
		"h1": "Family Relapse Prevention Worksheet",
		"intro": "Family Relapse Prevention Worksheet is a collaborative planning worksheet for practitioners, a person with serious mental illness, and involved family members. It helps them identify individualized warning signs or risk situations, define feasible preventive actions, and write response steps for when symptoms worsen.",
		"demoTitle": "Explore the relapse-prevention plan demo",
		"demoPrompt": "Interested in using Family Relapse Prevention Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0898-f-052-fpe-007-r001-family-relapse-prevention-worksheet.md",
		"specId": "0898-f-052-fpe-007-r001-family-relapse-prevention-worksheet",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Risk review"
			],
			"topic": [
				"Relapse prevention",
				"Mental health conditions"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "What The Plan Includes",
				"body": "The shared plan is organized around warning signs or risk situations, preventive actions, response steps, collaboration status, feasibility notes, and unresolved items."
			},
			{
				"title": "Relationship To Crisis Planning",
				"body": "The worksheet may hand off to a separate crisis resource plan when response steps involve crisis escalation. It does not replace crisis planning."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not calculate relapse probability, decide crisis status, create legal directives, or invent plan content."
			}
		],
		"faqItems": [
			{
				"question": "Can this use warning signs identified earlier?",
				"answer": "Yes. The worksheet can reference previously identified warning signs if available, but it also works on its own."
			},
			{
				"question": "Can the plan be used before practitioner review?",
				"answer": "Draft input can be captured, but asynchronous plans remain unreviewed until practitioner confirmation."
			},
			{
				"question": "Does the tool create response steps automatically?",
				"answer": "No. Response steps come from participants, practitioner facilitation, or supplied source content; the system does not generate clinical directives."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The worksheet tool and practitioner setup are saved. Fictional relapse-prevention plan entries are not saved as real client data."
			}
		]
	},
	{
		"toolType": "crisisResourcePlan",
		"slug": "crisis-resource-plan",
		"title": "Crisis Resource Plan for Family Psychoeducation | Qwoach",
		"metaDescription": "Explore a family crisis resource plan for defining escalation situations, resources, contacts, practical steps, review status, and current plan view.",
		"h1": "Crisis Resource Plan",
		"intro": "Crisis Resource Plan is a family psychoeducation crisis response planning tool for practitioners and families. It helps them define recognizable crisis indicators or escalation situations, identify specific resources or contacts, and write practical response steps for periods of acute need.",
		"demoTitle": "Explore the crisis plan demo",
		"demoPrompt": "Interested in using Crisis Resource Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0899-f-052-fpe-008-r001-crisis-resource-plan.md",
		"specId": "0899-f-052-fpe-008-r001-crisis-resource-plan",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Crisis response",
				"Mental health conditions"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Current Plan Clarity",
				"body": "The reviewed/current plan must be unambiguous so families do not confuse outdated or draft steps with current guidance."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures escalation situations, resources or contacts, response steps, urgent-help guidance as provided, unresolved gaps, and review status."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not automate triage, invent local resources, determine risk severity, create legal instructions, or dispatch emergency support."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool provide emergency dispatch or triage?",
				"answer": "No. It organizes practitioner-provided crisis resources and steps; it does not dispatch services or make triage decisions."
			},
			{
				"question": "Can the demo invent local crisis resources?",
				"answer": "No. Resource and contact fields use fictional placeholders in the demo and must be supplied by the practitioner or source workflow for real use."
			},
			{
				"question": "Can a draft plan be used by the family?",
				"answer": "Draft plans are visibly incomplete. A plan should be reviewed/current before the family relies on it."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The crisis planning tool and practitioner configuration are saved. Fictional crisis content, contacts, and sample steps are not saved as real client data."
			}
		]
	},
	{
		"toolType": "familySupportBurdenCheckIn",
		"slug": "family-support-burden-check-in",
		"title": "Family Support and Burden Check-In Demo | Qwoach",
		"metaDescription": "Explore a longitudinal family support and burden check-in for repeated caregiver reports, missing periods, support needs, and practitioner review.",
		"h1": "Family Support / Burden Check-In",
		"intro": "Family Support / Burden Check-In is a ready-to-send longitudinal check-in for practitioners monitoring family support capacity, burden, and support needs in family psychoeducation. It helps practitioners collect repeated family reports over time, review changes in strain, identify follow-up needs, and protect recovery-supporting involvement.",
		"demoTitle": "Explore the check-in demo",
		"demoPrompt": "Interested in using Family Support / Burden Check-In with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0900-f-052-fpe-009-r001-family-support-burden-check-in.md",
		"specId": "0900-f-052-fpe-009-r001-family-support-burden-check-in",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when family strain or support capacity needs to be monitored repeatedly rather than addressed as a one-time concern."
			},
			{
				"title": "Follow-Up Use",
				"body": "Practitioner review may point to education, problem solving, adjusted support expectations, or continued monitoring, but these remain practitioner decisions."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not include unsupported burden scales, caregiver diagnoses, family-capacity judgments, or automated intervention recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include a caregiver burden score?",
				"answer": "No. Exact scales are unresolved unless supplied; the tool records reported support and burden information over time."
			},
			{
				"question": "Can more than one family member complete it?",
				"answer": "Yes. A respondent roster can keep different family members' reports visible without merging them as one fact."
			},
			{
				"question": "What happens if a check-in is skipped?",
				"answer": "A skipped check-in appears as missing data, not as low burden or no support need."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The check-in tool and practitioner configuration are saved. Fictional respondents and sample check-in data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "fpeFidelityMeasure",
		"slug": "fpe-fidelity-measure",
		"title": "FPE Fidelity Measure Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only Family Psychoeducation fidelity tool for reviewing implementation consistency across components, teams, sites, or time.",
		"h1": "FPE Fidelity Measure for Family Psychoeducation Quality Review",
		"intro": "FPE Fidelity Measure is a practitioner-only implementation-quality tool for Family Psychoeducation services. Practitioners, supervisors, and program leads use it to produce a fidelity profile that shows reliable, weak, inconsistent, and incomplete areas of service delivery.",
		"demoTitle": "Open a sample fidelity administration",
		"demoPrompt": "Interested in using FPE Fidelity Measure with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0901-f-052-fpe-010-r001-fpe-fidelity-measure.md",
		"specId": "0901-f-052-fpe-010-r001-fpe-fidelity-measure",
		"tags": {
			"framework": [
				"Family psychoeducation"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a practitioner or program lead needs to review whether Family Psychoeducation services are being delivered as intended across cases, teams, time periods, or implementation sites."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent fidelity items, anchors, scoring rules, domains, thresholds, causes of low fidelity, or staff performance conclusions. Unresolved measure structure is shown explicitly."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include the exact FPE fidelity items?",
				"answer": "Only if the exact measure structure has been configured from the source instrument. If not, the demo shows external-score capture and marks the item structure unresolved."
			},
			{
				"question": "Is there a client form?",
				"answer": "No. The FPE Fidelity Measure is practitioner-only."
			},
			{
				"question": "Can results be compared over time?",
				"answer": "Yes, when administrations use compatible measure versions, component definitions, and scoring rules."
			}
		]
	},
	{
		"toolType": "cppChildAssessmentBattery",
		"slug": "cpp-child-assessment-battery",
		"title": "CPP Child Assessment Battery Demo | Qwoach",
		"metaDescription": "Explore a CPP assessment battery that organizes selected child domains and measures into a baseline profile for treatment planning.",
		"h1": "CPP Child Assessment Battery for Baseline Child Profiles",
		"intro": "CPP Child Assessment Battery is a ready-to-send assessment configuration for CPP clinicians and child-parent trauma-treatment practitioners. It helps them gather selected child-domain information across symptoms, development, and functioning so they can shape an initial treatment plan for the child-caregiver dyad.",
		"demoTitle": "Explore the assessment battery",
		"demoPrompt": "Interested in using CPP Child Assessment Battery with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0902-f-053-cpp-001-r001-cpp-child-assessment-battery.md",
		"specId": "0902-f-053-cpp-001-r001-cpp-child-assessment-battery",
		"tags": {
			"framework": [
				"Child-Parent Psychotherapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Practitioner And Caregiver Roles",
				"body": "The practitioner controls domain and measure selection, interpretation, and treatment-priority notes. Caregivers provide responses only for assigned caregiver-report measures."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent measure content, scoring, unsupported domains, or automated clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic assessment builder?",
				"answer": "No. It is a CPP child assessment battery organized around selected CPP-relevant child domains and measures."
			},
			{
				"question": "Can caregiver forms be sent from the demo?",
				"answer": "The demo can preview caregiver-report flow for assigned measures, but it uses fictional/sample data and does not create real client records."
			},
			{
				"question": "What happens if exact measure content is not configured?",
				"answer": "The product marks the structure unresolved and supports high-level tracking or external-result entry instead of inventing items."
			}
		]
	},
	{
		"toolType": "childTraumaHistoryScreen",
		"slug": "child-trauma-history-screen",
		"title": "Child Trauma History Screen Demo | Qwoach",
		"metaDescription": "Explore a trauma-exposure screen for CPP and child trauma treatment that preserves reported exposures, sources, unknowns, and missing areas.",
		"h1": "Child Trauma History Screen for Trauma-Focused Dyadic Assessment",
		"intro": "Child Trauma History Screen is a ready-to-send trauma-exposure assessment tool for CPP clinicians and child trauma-treatment practitioners. It helps them produce a clinically usable profile of reported trauma exposures, unknowns, sources, and missing areas for assessment review.",
		"demoTitle": "Try the exposure-profile demo",
		"demoPrompt": "Interested in using Child Trauma History Screen with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0903-f-053-cpp-002-r001-child-trauma-history-screen.md",
		"specId": "0903-f-053-cpp-002-r001-child-trauma-history-screen",
		"tags": {
			"framework": [
				"Child-Parent Psychotherapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures supported reported exposure fields, unknown or missing responses, respondent/source, date, and practitioner notes."
			},
			{
				"title": "Relevant Limits",
				"body": "It does not collect invented exposure categories, diagnosis, legal determinations, safety conclusions, or trauma-impact inferences."
			}
		],
		"faqItems": [
			{
				"question": "Does the screen diagnose trauma-related conditions?",
				"answer": "No. It organizes reported exposure information and leaves diagnosis or clinical interpretation to the practitioner."
			},
			{
				"question": "Can a caregiver complete it?",
				"answer": "Yes, when the practitioner selects a caregiver or informant respondent path supported by the configured screen."
			},
			{
				"question": "What if the respondent is unsure?",
				"answer": "Uncertainty is preserved when the configured screen supports unknown or unsure responses."
			}
		]
	},
	{
		"toolType": "cppSymptomScreenerChildParentPsychotherapySymptomScreener",
		"slug": "cpp-symptom-screener-child-parent-psychotherapy-symptom-screener",
		"title": "CPP Symptom Screener Demo | Qwoach",
		"metaDescription": "Explore a CPP caregiver-report screener for young children's trauma-related reactions, baseline scoring, and compatible follow-up comparison.",
		"h1": "CPP Symptom Screener for Caregiver-Reported Child Trauma Reactions",
		"intro": "CPP Symptom Screener is a CPP-specific caregiver-report symptom screener for young children's post-traumatic reactions. CPP clinicians and early-childhood mental health practitioners use it to establish a baseline symptom profile, review severity, and compare compatible follow-up administrations.",
		"demoTitle": "Preview the screener flow",
		"demoPrompt": "Interested in using CPP Symptom Screener / Child-Parent Psychotherapy Symptom Screener with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0904-f-053-cpp-003-r001-cpp-symptom-screener-child-parent-psychotherapy-symptom-screener.md",
		"specId": "0904-f-053-cpp-003-r001-cpp-symptom-screener-child-parent-psychotherapy-symptom-screener",
		"tags": {
			"framework": [
				"Child-Parent Psychotherapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Repeat Use",
				"body": "Repeated administrations can be compared over time only when the same compatible screener version and scoring approach are used."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not add diagnostic conclusions, unsupported subscales, clinical cutoff labels, or psychometric interpretation not supplied by the source."
			}
		],
		"faqItems": [
			{
				"question": "What score range is supported?",
				"answer": "The supplied record supports a 0-93 total score range where higher scores indicate worse outcome."
			},
			{
				"question": "Is the screener described as psychometrically validated?",
				"answer": "No. The product should not make unsupported validation claims."
			},
			{
				"question": "Can it track change over time?",
				"answer": "Yes, when repeated administrations use compatible screener versions and scoring."
			}
		]
	},
	{
		"toolType": "traumaSymptomChecklistForYoungChildrenTscyc",
		"slug": "trauma-symptom-checklist-for-young-children-tscyc",
		"title": "TSCYC Assessment Demo | Qwoach",
		"metaDescription": "Explore TSCYC setup, caregiver-report administration, external score entry, validity indicators, and trauma symptom profile review.",
		"h1": "Trauma Symptom Checklist for Young Children Assessment Demo",
		"intro": "Trauma Symptom Checklist for Young Children (TSCYC) is a standardized, normed caretaker-report trauma symptom assessment for children ages 3-12. Qualified practitioners use it to review validity indicators, clinical scale scores, PTSD-related information, and associated emotional or behavioral concerns.",
		"demoTitle": "Explore TSCYC review",
		"demoPrompt": "Interested in using Trauma Symptom Checklist for Young Children (TSCYC) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0905-f-053-cpp-003-r002-trauma-symptom-checklist-for-young-children-tscyc.md",
		"specId": "0905-f-053-cpp-003-r002-trauma-symptom-checklist-for-young-children-tscyc",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Trauma",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Validity Comes First",
				"body": "The review starts with validity indicators because interpretability is part of the assessment result before clinical scale review."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent item text, scoring algorithms, norms, cutoffs, diagnostic decisions, or treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Who is the TSCYC for?",
				"answer": "It is for children ages 3-12 when a qualified practitioner needs standardized caregiver-report trauma symptom information."
			},
			{
				"question": "Can the demo show the full questionnaire?",
				"answer": "Only if exact TSCYC content has been configured. Otherwise the product supports external-score entry and profile review."
			},
			{
				"question": "Why are validity indicators shown first?",
				"answer": "Validity indicators support whether the caregiver report can be interpreted before reviewing clinical scales."
			}
		]
	},
	{
		"toolType": "childBehaviorChecklistForAges155Cbcl155",
		"slug": "child-behavior-checklist-for-ages-1-5-5-cbcl-1-5-5",
		"title": "CBCL/1.5-5 Assessment Demo | Qwoach",
		"metaDescription": "Explore CBCL/1.5-5 setup, caregiver-report or external profile entry, scored symptom profiles, range labels, and comparison review.",
		"h1": "Child Behavior Checklist for Ages 1.5-5 Assessment Demo",
		"intro": "Child Behavior Checklist for Ages 1.5-5 (CBCL/1.5-5) is a normed parent/caregiver-report assessment for preschool emotional and behavioral functioning. Clinicians use it to review caregiver concerns and strengths, scored symptom profiles, supported range classifications, and baseline or change information.",
		"demoTitle": "Explore CBCL profile review",
		"demoPrompt": "Interested in using Child Behavior Checklist for Ages 1.5-5 (CBCL/1.5-5) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0906-f-053-cpp-003-r003-child-behavior-checklist-for-ages-1-5-5-cbcl-1-5-5.md",
		"specId": "0906-f-053-cpp-003-r003-child-behavior-checklist-for-ages-1-5-5-cbcl-1-5-5",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Mental health conditions",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "It captures caregiver ratings and supported concern/strength fields when configured, or externally generated profile outputs when administered elsewhere."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent CBCL items, scoring, norms, thresholds, diagnoses, or treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "What age range does this configuration support?",
				"answer": "It supports the CBCL/1.5-5 age range for preschool children ages 1.5-5."
			},
			{
				"question": "Can the tool show typical, borderline, and clinical ranges?",
				"answer": "Yes, when supported official scoring and range classifications are configured or externally entered."
			},
			{
				"question": "Can externally scored profiles be entered?",
				"answer": "Yes. External profile entry is supported when the questionnaire is completed through paper or another scoring system."
			}
		]
	},
	{
		"toolType": "agesStagesQuestionnairesSocialEmotionalSecondEditionAsqSe2",
		"slug": "ages-stages-questionnaires-social-emotional-second-edition-asq-se-2",
		"title": "ASQ:SE-2 Screening Demo | Qwoach",
		"metaDescription": "Explore ASQ:SE-2 setup, age-interval routing, caregiver completion, total score, interpretation category, and practitioner review.",
		"h1": "ASQ:SE-2 Social-Emotional Screening Demo",
		"intro": "ASQ:SE-2 is an age-interval, parent/caregiver-completed social-emotional screening system for young children. Early childhood and CPP practitioners use it to produce a total score and supported interpretation category for monitoring, further assessment, or follow-up decisions.",
		"demoTitle": "Explore ASQ:SE-2 screening",
		"demoPrompt": "Interested in using Ages & Stages Questionnaires: Social-Emotional, Second Edition (ASQ:SE-2) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0907-f-053-cpp-004-r001-ages-stages-questionnaires-social-emotional-second-edition-asq-se-2.md",
		"specId": "0907-f-053-cpp-004-r001-ages-stages-questionnaires-social-emotional-second-edition-asq-se-2",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Developmental functioning"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a young child's social-emotional or regulatory functioning needs structured screening during CPP or early childhood assessment."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent ASQ:SE-2 items, scoring rules, cutoffs, diagnosis, or follow-up recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Who completes ASQ",
				"answer": "SE-2?: The caregiver completes the age-appropriate questionnaire, and the practitioner scores and interprets the result."
			},
			{
				"question": "Does the caregiver choose the age interval?",
				"answer": "No. The practitioner or configured age-routing rules determine the age interval whenever possible."
			},
			{
				"question": "What does the result show?",
				"answer": "It shows the age interval/form, total score, supported interpretation category, caregiver concerns, missingness, and practitioner notes."
			}
		]
	},
	{
		"toolType": "bayleyScalesOfInfantAndToddlerDevelopmentFourthEditionBayley4",
		"slug": "bayley-scales-of-infant-and-toddler-development-fourth-edition-bayley-4",
		"title": "Bayley-4 Assessment Demo | Qwoach",
		"metaDescription": "Explore Bayley-4 practitioner setup, domain tracking, external score entry, and multidomain developmental profile review.",
		"h1": "Bayley-4 Developmental Assessment Demo",
		"intro": "Bayley-4 is a practitioner-administered standardized developmental assessment for infants and toddlers. Qualified practitioners use it to produce a multidomain profile across cognitive, language, motor, social-emotional, and adaptive functioning.",
		"demoTitle": "Explore Bayley-4 profile review",
		"demoPrompt": "Interested in using Bayley Scales of Infant and Toddler Development, Fourth Edition (Bayley-4) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0908-f-053-cpp-004-r002-bayley-scales-of-infant-and-toddler-development-fourth-edition-bayley-4.md",
		"specId": "0908-f-053-cpp-004-r002-bayley-scales-of-infant-and-toddler-development-fourth-edition-bayley-4",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Developmental functioning"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Led Use",
				"body": "The primary interaction is setup, administration tracking, score capture, and profile review by a qualified practitioner."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not recreate Bayley-4 items, stimuli, administration prompts, norms, scoring rules, diagnoses, or recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is there a self-service child experience?",
				"answer": "No. Bayley-4 is practitioner-administered; the child does not navigate the product."
			},
			{
				"question": "Can external score reports be entered?",
				"answer": "Yes. External score/report entry is supported when official digital scoring is not implemented in the product."
			},
			{
				"question": "What domains are shown in review?",
				"answer": "The profile covers cognitive, language, motor, social-emotional, and adaptive functioning where supported outputs are available."
			}
		]
	},
	{
		"toolType": "mullenScalesOfEarlyLearning",
		"slug": "mullen-scales-of-early-learning",
		"title": "Mullen Scales Assessment Demo | Qwoach",
		"metaDescription": "Explore Mullen assessment setup, scale completion tracking, external score entry, Early Learning Composite, and profile review.",
		"h1": "Mullen Scales of Early Learning Assessment Demo",
		"intro": "Mullen Scales of Early Learning is a practitioner-administered standardized early childhood developmental assessment. Qualified practitioners use it to produce a profile of developmental strengths and weaknesses across gross motor, visual reception, fine motor, expressive language, receptive language, and Early Learning Composite outputs.",
		"demoTitle": "Explore Mullen profile review",
		"demoPrompt": "Interested in using Mullen Scales of Early Learning with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0909-f-053-cpp-004-r003-mullen-scales-of-early-learning.md",
		"specId": "0909-f-053-cpp-004-r003-mullen-scales-of-early-learning",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Developmental functioning"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Scale-Based Review",
				"body": "The result separates gross motor, visual reception, fine motor, expressive language, receptive language, and composite information where supported."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent Mullen task content, stimuli, scoring rules, norms, diagnostic conclusions, or automated referral recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is this a caregiver questionnaire?",
				"answer": "No. Mullen Scales of Early Learning is practitioner-administered through structured child tasks."
			},
			{
				"question": "Can scores from another official scoring process be entered?",
				"answer": "Yes. External score entry is supported when task materials or official scoring are not implemented in the product."
			},
			{
				"question": "What does the profile include?",
				"answer": "It includes supported scale-level scores and Early Learning Composite outputs, plus missingness and practitioner interpretation."
			}
		]
	},
	{
		"toolType": "caregiverResponseToChildTraumaRating",
		"slug": "caregiver-response-to-child-trauma-rating",
		"title": "Caregiver Response Rating Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only CPP rating tool for separating factual caregiver actions from emotional responses to child trauma.",
		"h1": "Caregiver Response to Child Trauma Rating for CPP Assessment",
		"intro": "Caregiver Response to Child Trauma Rating is a practitioner-only CPP assessment tool for child-parent trauma-treatment practitioners. It helps them produce a caregiver-response profile that distinguishes factual actions from emotional responses and can be reviewed alongside the child's trauma and symptom profile.",
		"demoTitle": "Explore the rating profile",
		"demoPrompt": "Interested in using Caregiver Response to Child Trauma Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0910-f-053-cpp-005-r001-caregiver-response-to-child-trauma-rating.md",
		"specId": "0910-f-053-cpp-005-r001-caregiver-response-to-child-trauma-rating",
		"tags": {
			"framework": [
				"Child-Parent Psychotherapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Interpersonal relationships"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Two-Part Coding",
				"body": "The rating keeps factual caregiver actions and emotional responses in separate lanes so the practitioner can review each aspect clearly."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent categories, anchors, scoring, caregiver traits, blame/fault determinations, diagnosis, or relational conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does the caregiver complete this tool?",
				"answer": "No. This is a practitioner-only rating based on assessment information."
			},
			{
				"question": "What if the exact coding categories are not configured?",
				"answer": "The product marks the structure unresolved and supports external coded-result entry instead of inventing categories."
			},
			{
				"question": "Can the rating connect to trauma and symptom profiles?",
				"answer": "Yes. Integration links can show related trauma-history and symptom profiles alongside the caregiver-response result."
			}
		]
	},
	{
		"toolType": "cppContactLog",
		"slug": "cpp-contact-log",
		"title": "CPP Contact Log for Treatment Contact Tracking | Qwoach",
		"metaDescription": "Track CPP treatment contacts over time with an episode-based log showing sequence, frequency, gaps, and descriptive process summaries.",
		"h1": "CPP Contact Log",
		"intro": "The CPP Contact Log is a practitioner-only longitudinal treatment process tracker for CPP practitioners. It helps the practitioner record treatment contacts over time and review sequence, frequency, gaps, and changes in contact patterns for supervision or treatment-course review.",
		"demoTitle": "Explore a sample contact timeline",
		"demoPrompt": "Interested in using CPP Contact Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0911-f-053-cpp-006-r001-cpp-contact-log.md",
		"specId": "0911-f-053-cpp-006-r001-cpp-contact-log",
		"tags": {
			"framework": [
				"Child-Parent Psychotherapy"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during an ongoing CPP treatment episode when contact continuity, engagement pattern, or supervision review requires a longitudinal view."
			},
			{
				"title": "What It Shows",
				"body": "The log shows recorded contacts in sequence, frequency over time, date-based spacing when available, visible gaps, and incomplete entries."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not generate clinical conclusions, engagement explanations, treatment effectiveness claims, or fidelity ratings from contact frequency alone."
			}
		],
		"faqItems": [
			{
				"question": "Does the CPP Contact Log require client completion?",
				"answer": "No. The CPP Contact Log is practitioner-only and does not require client, caregiver, or child product input."
			},
			{
				"question": "Does the log score treatment fidelity?",
				"answer": "No. It shows descriptive contact-process information and does not generate fidelity scores or judgments."
			},
			{
				"question": "What happens if a contact has no date?",
				"answer": "A contact without a date can remain in entry sequence, but it cannot support date-based interval calculations."
			}
		]
	},
	{
		"toolType": "cppInterventionFidelityForm",
		"slug": "cpp-intervention-fidelity-form",
		"title": "CPP Intervention Fidelity Form for Session Review | Qwoach",
		"metaDescription": "Record CPP intervention fidelity data across sessions and review descriptive presence, absence, and completion patterns for supervision.",
		"h1": "CPP Intervention Fidelity Form",
		"intro": "The CPP Intervention Fidelity Form is a practitioner-only structured fidelity data tool for CPP practitioners. It helps the practitioner record whether source-defined intervention elements were present or absent and review descriptive patterns that can support supervision and model-consistent care.",
		"demoTitle": "Try a sample fidelity review",
		"demoPrompt": "Interested in using CPP Intervention Fidelity Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0912-f-053-cpp-007-r001-cpp-intervention-fidelity-form.md",
		"specId": "0912-f-053-cpp-007-r001-cpp-intervention-fidelity-form",
		"tags": {
			"framework": [
				"Child-Parent Psychotherapy"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after or during review of a session when the practitioner needs structured fidelity data for CPP intervention elements."
			},
			{
				"title": "What It Captures",
				"body": "The form captures practitioner-entered presence, absence, or other source-supported responses for intended intervention elements once the exact source structure is defined."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not generate fidelity scores, pass/fail thresholds, practitioner competence conclusions, clinical outcome inferences, or corrective recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client form?",
				"answer": "No. The CPP Intervention Fidelity Form is completed by the practitioner and does not require client submission."
			},
			{
				"question": "Does the tool calculate a fidelity score?",
				"answer": "No. It can show descriptive summaries when the response format supports them, but it does not create unsupported scores or thresholds."
			},
			{
				"question": "Can a practitioner change the intervention elements?",
				"answer": "No. The elements are source-defined; the tool is not a generic fidelity-form builder."
			}
		]
	},
	{
		"toolType": "foundationalPhaseProceduresChecklist",
		"slug": "foundational-phase-procedures-checklist",
		"title": "CPP Foundational Phase Procedures Checklist | Qwoach",
		"metaDescription": "Review CPP foundational phase procedure status, identify missing early-phase work, and support readiness discussion before active intervention.",
		"h1": "Foundational Phase Procedures Checklist",
		"intro": "The Foundational Phase Procedures Checklist is a practitioner-only phase-completion checklist for CPP practitioners. It helps the practitioner record source-defined foundational procedure statuses, identify missing or incomplete early-phase work, and support readiness discussion before moving forward.",
		"demoTitle": "Review a sample foundational checklist",
		"demoPrompt": "Interested in using Foundational Phase Procedures Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0913-f-053-cpp-008-r001-foundational-phase-procedures-checklist.md",
		"specId": "0913-f-053-cpp-008-r001-foundational-phase-procedures-checklist",
		"tags": {
			"framework": [
				"Child-Parent Psychotherapy"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it while foundational work is ongoing and when considering whether the treatment episode is ready to move into the active intervention phase."
			},
			{
				"title": "What It Captures",
				"body": "The checklist captures practitioner-recorded status for source-defined foundational procedures and shows missing or incomplete early-phase work."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not create new procedures, apply a scoring threshold, or authorize a treatment phase transition."
			}
		],
		"faqItems": [
			{
				"question": "Does the checklist decide whether the dyad is ready for the next phase?",
				"answer": "No. It organizes completion and gap information; the practitioner makes the clinical readiness judgment."
			},
			{
				"question": "Can clients complete this checklist?",
				"answer": "No. The checklist is practitioner-only and does not require client or caregiver product input."
			},
			{
				"question": "Can procedures be added to the checklist?",
				"answer": "No. The procedures are source-defined and should remain part of the fixed CPP foundational-phase checklist structure."
			}
		]
	},
	{
		"toolType": "coreInterventionPhaseProceduresChecklist",
		"slug": "core-intervention-phase-procedures-checklist",
		"title": "CPP Core Intervention Phase Procedures Checklist | Qwoach",
		"metaDescription": "Track CPP core intervention procedure status over time and review descriptive gaps, imbalances, and coverage for supervision.",
		"h1": "Core Intervention Phase Procedures Checklist",
		"intro": "The Core Intervention Phase Procedures Checklist is a practitioner-only CPP process and fidelity checklist. It helps the practitioner record source-defined core intervention procedure statuses and review gaps, imbalances, and changes over time for supervision and course correction.",
		"demoTitle": "Explore a sample core-phase review",
		"demoPrompt": "Interested in using Core Intervention Phase Procedures Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0914-f-053-cpp-009-r001-core-intervention-phase-procedures-checklist.md",
		"specId": "0914-f-053-cpp-009-r001-core-intervention-phase-procedures-checklist",
		"tags": {
			"framework": [
				"Child-Parent Psychotherapy"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during the active core intervention phase when the practitioner needs to monitor delivered procedure coverage over time."
			},
			{
				"title": "What It Shows",
				"body": "The review shows source-defined procedure statuses, incomplete items, coverage summaries, visible gaps, and imbalances across sessions or review intervals."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not generate compliance thresholds, treatment recommendations, clinical outcome conclusions, or automated model-alignment verdicts."
			}
		],
		"faqItems": [
			{
				"question": "Is this a treatment plan builder?",
				"answer": "No. It is a core-phase process and fidelity checklist, not a treatment-plan builder or intervention library."
			},
			{
				"question": "Does an absent procedure mean the treatment is wrong?",
				"answer": "No. The tool records and summarizes procedure status descriptively; gaps may reflect clinical choice and require practitioner interpretation."
			},
			{
				"question": "Can clients or caregivers complete the checklist?",
				"answer": "No. The checklist is practitioner-only and does not include a client-facing completion flow."
			}
		]
	},
	{
		"toolType": "closingPhaseForm",
		"slug": "closing-phase-form",
		"title": "CPP Closing Phase Form for Treatment End Review | Qwoach",
		"metaDescription": "Record CPP treatment-end status, process and outcome information, and missing closing details for follow-up or care-transition review.",
		"h1": "Closing Phase Form",
		"intro": "The Closing Phase Form is a practitioner-only end-of-treatment process and outcome form for CPP practitioners. It helps the practitioner record closing status, key treatment-end information, and details relevant to follow-up, referral, or continued care decisions.",
		"demoTitle": "Review a sample closing summary",
		"demoPrompt": "Interested in using Closing Phase Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0915-f-053-cpp-010-r001-closing-phase-form.md",
		"specId": "0915-f-053-cpp-010-r001-closing-phase-form",
		"tags": {
			"framework": [
				"Child-Parent Psychotherapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Clinical documentation",
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a CPP treatment episode is ending, including when closure is planned or disrupted."
			},
			{
				"title": "What It Captures",
				"body": "The form captures source-supported closing status, process completion information, outcome information, and any supported follow-up or transition details."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not generate care recommendations, referral requirements, risk classifications, or unsupported outcome domains."
			}
		],
		"faqItems": [
			{
				"question": "Does the Closing Phase Form create a discharge recommendation?",
				"answer": "No. It organizes recorded closing information; the practitioner decides what follow-up, referral, or continued care is appropriate."
			},
			{
				"question": "Can disrupted endings be represented?",
				"answer": "Yes. Disrupted or unplanned endings can be represented with partial information and explicit missing-information markers."
			},
			{
				"question": "Does the client complete this form?",
				"answer": "No. The Closing Phase Form is practitioner-only and does not require client submission."
			}
		]
	},
	{
		"toolType": "traumaRelationshipFormulation",
		"slug": "trauma-relationship-formulation",
		"title": "Trauma–Relationship Formulation for CPP-Informed Care | Qwoach",
		"metaDescription": "Build a practitioner-led dyadic formulation linking trauma, child functioning, caregiver responses, relationship patterns, and treatment priorities.",
		"h1": "Trauma–Relationship Formulation",
		"intro": "Trauma–Relationship Formulation is a collaborative practitioner-led dyadic case formulation tool for CPP-informed practitioners. It helps the practitioner organize gathered trauma, child symptom or developmental, and caregiver-response information into an integrated formulation with relational strengths, vulnerabilities, and treatment priorities.",
		"demoTitle": "Build a sample formulation",
		"demoPrompt": "Interested in using Trauma–Relationship Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0916-f-053-cpp-011-r001-trauma-relationship-formulation.md",
		"specId": "0916-f-053-cpp-011-r001-trauma-relationship-formulation",
		"tags": {
			"framework": [
				"Child-Parent Psychotherapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Interpersonal relationships"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after trauma, symptom or developmental, and caregiver-response information has been gathered and the practitioner needs to integrate those domains."
			},
			{
				"title": "Practitioner and Caregiver Roles",
				"body": "The practitioner authors and controls the formulation. In together mode, caregiver contributions are captured through practitioner-led discussion rather than independent client submission."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not generate diagnoses, infer mechanisms automatically, create treatment protocols, or prescribe interventions."
			}
		],
		"faqItems": [
			{
				"question": "Can this tool be completed with a caregiver in session?",
				"answer": "Yes. The supported together mode is practitioner-led, meaning the practitioner controls pacing, wording, and what is entered."
			},
			{
				"question": "Does the tool generate the formulation automatically?",
				"answer": "No. The tool organizes domains and links, but the practitioner authors the formulation and treatment priorities."
			},
			{
				"question": "Is there an independent client worksheet?",
				"answer": "No. The specification supports practitioner-led together mode, not an independent client submission workflow."
			},
			{
				"question": "What does the result show?",
				"answer": "The result shows an integrated dyadic formulation summary and linkage view connecting trauma, child functioning, caregiver responses, relational strengths/vulnerabilities, and treatment priorities."
			}
		]
	},
	{
		"toolType": "marschakInteractionMethodMim",
		"slug": "marschak-interaction-method-mim",
		"title": "MIM Observed Dyadic Relationship Assessment | Qwoach",
		"metaDescription": "Capture observed caregiver-child interaction notes and organize practitioner-identified dyadic strengths and needs for treatment planning.",
		"h1": "Marschak Interaction Method (MIM)",
		"intro": "Marschak Interaction Method (MIM) is a practitioner-led observed dyadic relationship assessment. It helps the practitioner record caregiver-child interaction observations and synthesize observed strengths and needs for relationship-focused treatment planning.",
		"demoTitle": "Explore a sample MIM profile",
		"demoPrompt": "Interested in using Marschak Interaction Method (MIM) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0917-f-054-ther-001-r001-marschak-interaction-method-mim.md",
		"specId": "0917-f-054-ther-001-r001-marschak-interaction-method-mim",
		"tags": {
			"framework": [
				"Marschak Interaction Method"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Strengths"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when relationship-focused treatment planning needs evidence from observed caregiver-child interaction."
			},
			{
				"title": "Practitioner and Client Roles",
				"body": "The caregiver and child participate in the observed interaction. The practitioner records observations, identifies strengths and needs, and interprets the profile."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not invent MIM tasks, infer scores, generate diagnoses, create attachment labels, or produce automated treatment activities."
			}
		],
		"faqItems": [
			{
				"question": "Is MIM a self-report questionnaire in this product?",
				"answer": "No. MIM is represented as an observed dyadic assessment, not a self-report questionnaire."
			},
			{
				"question": "Do caregivers or children log in to complete it?",
				"answer": "No. They participate in observed interaction; the practitioner records and synthesizes assessment information."
			},
			{
				"question": "Does the tool score or classify the dyad automatically?",
				"answer": "No. The tool organizes practitioner-entered observations and interpretations without automated scoring or classification."
			}
		]
	},
	{
		"toolType": "mimTaskSet",
		"slug": "mim-task-set",
		"title": "MIM Task Set for Standardized Dyadic Observation | Qwoach",
		"metaDescription": "Prepare and track a MIM task set for standardized caregiver-child interaction observation, including readiness and completion status.",
		"h1": "MIM Task Set",
		"intro": "The MIM Task Set is a practitioner-only standardized elicitation setup for practitioners preparing a caregiver-child observation. It helps the practitioner prepare and track a source-defined task set so the interaction context is consistent enough to support later assessment of dyadic strengths and needs.",
		"demoTitle": "Prepare a sample task set",
		"demoPrompt": "Interested in using MIM Task Set with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0918-f-054-ther-002-r001-mim-task-set.md",
		"specId": "0918-f-054-ther-002-r001-mim-task-set",
		"tags": {
			"framework": [
				"Marschak Interaction Method"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Session preparation",
				"Assessment"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before and during a MIM observation to prepare and track the standardized interaction context."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures task readiness and administration status, including completed, skipped, interrupted, and unknown states when supported."
			},
			{
				"title": "Important Limitations",
				"body": "The task set does not generate MIM tasks, interpret caregiver-child behavior, score the dyad, or produce the full observed strengths-and-needs profile."
			}
		],
		"faqItems": [
			{
				"question": "Does the MIM Task Set interpret the dyad's interaction?",
				"answer": "No. It prepares and tracks the elicitation context; interpretation happens in the appropriate MIM assessment workflow."
			},
			{
				"question": "Can I create new tasks in the demo?",
				"answer": "No. The tool supports source-defined tasks and does not function as a generic task builder."
			},
			{
				"question": "Do caregiver and child use the software directly?",
				"answer": "No. The practitioner administers real-world tasks; caregiver and child do not submit product data."
			}
		]
	},
	{
		"toolType": "mimStructureAnalysis",
		"slug": "mim-structure-analysis",
		"title": "MIM Structure Analysis for Dyadic Interaction Review | Qwoach",
		"metaDescription": "Organize observed caregiver direction, limits, organization, and child response into a focused MIM Structure strengths-and-needs profile.",
		"h1": "MIM Structure Analysis",
		"intro": "MIM Structure Analysis is a practitioner-only focused dyadic interaction analysis for practitioners interpreting observed caregiver-child interaction. It helps the practitioner organize evidence about caregiver guidance, direction, limits, organization, and child response to structure into a focused strengths-and-needs profile.",
		"demoTitle": "Analyze a sample Structure profile",
		"demoPrompt": "Interested in using MIM Structure Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0919-f-054-ther-003-r001-mim-structure-analysis.md",
		"specId": "0919-f-054-ther-003-r001-mim-structure-analysis",
		"tags": {
			"framework": [
				"Marschak Interaction Method"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when interpreting observed interaction specifically for structure-related strengths and needs."
			},
			{
				"title": "What It Captures",
				"body": "The analysis captures practitioner-entered observation evidence, caregiver direction or organization, child response to structure, strengths, gaps, and planning implications."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not create a full MIM profile, generate scores, diagnose the dyad, or prescribe interventions."
			}
		],
		"faqItems": [
			{
				"question": "Is Structure Analysis the full MIM assessment?",
				"answer": "No. It is a focused analysis of the Structure dimension and does not include the full MIM profile unless other analyses are completed separately."
			},
			{
				"question": "Does the tool rate parenting automatically?",
				"answer": "No. It organizes practitioner-entered evidence and interpretation without automated ratings or global parenting judgments."
			},
			{
				"question": "Why separate caregiver behavior and child response?",
				"answer": "The Structure profile needs both caregiver direction, limits, or organization and the child's response to structure represented distinctly."
			}
		]
	},
	{
		"toolType": "mimEngagementAnalysis",
		"slug": "mim-engagement-analysis",
		"title": "MIM Engagement Analysis for Dyadic Interaction Review | Qwoach",
		"metaDescription": "Organize observed emotional involvement, shared connection, and child responsiveness into a focused MIM Engagement profile.",
		"h1": "MIM Engagement Analysis",
		"intro": "MIM Engagement Analysis is a practitioner-only focused dyadic interaction analysis for practitioners interpreting observed caregiver-child interaction. It helps the practitioner organize evidence about emotional connection, shared involvement, and the child's openness, avoidance, or responsiveness into a focused engagement-related strengths-and-needs profile.",
		"demoTitle": "Analyze a sample Engagement profile",
		"demoPrompt": "Interested in using MIM Engagement Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0920-f-054-ther-004-r001-mim-engagement-analysis.md",
		"specId": "0920-f-054-ther-004-r001-mim-engagement-analysis",
		"tags": {
			"framework": [
				"Marschak Interaction Method"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when interpreting observed interaction specifically for engagement-related strengths and needs."
			},
			{
				"title": "What It Captures",
				"body": "The analysis captures practitioner-entered observation evidence, emotional involvement, child openness or avoidance or responsiveness, strengths, gaps, and planning implications."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not create a full MIM profile, generate scores, classify emotions, diagnose the dyad, or prescribe interventions."
			}
		],
		"faqItems": [
			{
				"question": "Is Engagement Analysis the full MIM assessment?",
				"answer": "No. It is a focused analysis of the Engagement dimension and does not include the full MIM profile unless other analyses are completed separately."
			},
			{
				"question": "Does the tool detect emotions automatically?",
				"answer": "No. The practitioner records and interprets observations; the system only organizes entered information descriptively."
			},
			{
				"question": "Can caregivers or children complete this analysis?",
				"answer": "No. They participate in the observed interaction, but the analysis is completed by the practitioner."
			}
		]
	},
	{
		"toolType": "mimNurtureAnalysis",
		"slug": "mim-nurture-analysis",
		"title": "MIM Nurture Analysis Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only Nurture profile tool for organizing caregiver-child strengths, support needs, observations, and follow-up comparison.",
		"h1": "MIM Nurture Analysis",
		"intro": "MIM Nurture Analysis is a practitioner-only assessment analysis tool for Theraplay-oriented treatment. Practitioners use it to organize observations about comfort, soothing, and meeting the child's needs into a Nurture profile that distinguishes strengths from areas needing support.",
		"demoTitle": "Explore a sample Nurture profile",
		"demoPrompt": "Interested in using MIM Nurture Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0921-f-054-ther-005-r001-mim-nurture-analysis.md",
		"specId": "0921-f-054-ther-005-r001-mim-nurture-analysis",
		"tags": {
			"framework": [
				"Marschak Interaction Method"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Interpersonal relationships",
				"Strengths"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use during or after assessment when the practitioner needs a Nurture-specific view of comfort, soothing, and needs-meeting patterns for a caregiver-child dyad."
			},
			{
				"title": "Longitudinal Review",
				"body": "Finalized profiles remain available as historical snapshots so later Nurture profiles can be compared descriptively over time."
			},
			{
				"title": "Limitations",
				"body": "The demo does not include rating scales, standardized scores, full MIM scoring content, diagnosis, or prompts for other dimensions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client form?",
				"answer": "No. MIM Nurture Analysis is practitioner-only and does not require caregivers or children to enter information directly."
			},
			{
				"question": "Does the tool score the Nurture profile?",
				"answer": "No. The tool organizes practitioner-entered observations into strengths, areas needing support, and descriptive comparison when prior profiles exist."
			},
			{
				"question": "What settings can I configure?",
				"answer": "You can choose whether the profile is an initial baseline or a follow-up comparison. Exact profile fields and rubrics are unresolved in the supplied specification."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The tool itself and selected practitioner configuration are saved. Fictional demo observations and sample dyad content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "mimChallengeAnalysis",
		"slug": "mim-challenge-analysis",
		"title": "MIM Challenge Analysis Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only Challenge profile tool for organizing dyadic observations, category distinctions, strengths, gaps, and change over time.",
		"h1": "MIM Challenge Analysis",
		"intro": "MIM Challenge Analysis is a practitioner-only assessment analysis tool for Theraplay-oriented treatment. Practitioners use it to organize observations about age-appropriate challenge, structure, and confidence-building into a Challenge profile that identifies strengths, gaps, and whether challenge is supportive, absent, excessive, or poorly matched where observed.",
		"demoTitle": "Explore a sample Challenge profile",
		"demoPrompt": "Interested in using MIM Challenge Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0922-f-054-ther-006-r001-mim-challenge-analysis.md",
		"specId": "0922-f-054-ther-006-r001-mim-challenge-analysis",
		"tags": {
			"framework": [
				"Marschak Interaction Method"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Interpersonal relationships",
				"Strengths"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use when assessment observations need to be organized around challenge, structure, and confidence-building in a caregiver-child relationship."
			},
			{
				"title": "Comparison Over Time",
				"body": "Follow-up profiles can be compared with prior finalized Challenge profiles to show descriptive continuity and change."
			},
			{
				"title": "Limitations",
				"body": "The tool does not include numeric scores, automated recommendations, diagnoses, or content from other dimensions."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool choose the right challenge level?",
				"answer": "No. The practitioner enters and interprets observations; the tool organizes supported category distinctions and profile content."
			},
			{
				"question": "Can caregivers complete this tool directly?",
				"answer": "No. The supplied specification defines this as practitioner-only."
			},
			{
				"question": "What happens if a category is unclear?",
				"answer": "Unclear category distinctions remain unresolved instead of being forced into a classification."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself and practitioner configuration are saved. Fictional demo observations and sample profile content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "mimFeedbackGoals",
		"slug": "mim-feedback-goals",
		"title": "MIM Feedback Goals Demo | Qwoach",
		"metaDescription": "Explore a collaborative goal-setting tool that turns dyadic assessment feedback into shared caregiver-practitioner relational goals.",
		"h1": "MIM Feedback Goals",
		"intro": "MIM Feedback Goals is a collaborative goal-setting tool for practitioners and caregivers after structured dyadic assessment feedback. Practitioners use it to create explicit caregiver-child relational goals tied to feedback, so treatment can be organized around agreed-upon priorities.",
		"demoTitle": "Explore sample feedback goals",
		"demoPrompt": "Interested in using MIM Feedback Goals with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0923-f-054-ther-007-r001-mim-feedback-goals.md",
		"specId": "0923-f-054-ther-007-r001-mim-feedback-goals",
		"tags": {
			"framework": [
				"Marschak Interaction Method"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Interpersonal relationships"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Practitioner And Caregiver Roles",
				"body": "The practitioner controls the clinical record and feedback linkage. Caregivers participate by reviewing wording, raising concerns, and indicating understanding or acceptance."
			},
			{
				"title": "Goal History",
				"body": "Accepted goals persist for later review. Later changes should be recorded as updates rather than silently replacing prior goals."
			},
			{
				"title": "Limitations",
				"body": "The tool does not include goal libraries, goal scores, automated recommendations, or exact goal prompts not supplied in the product specification."
			}
		],
		"faqItems": [
			{
				"question": "Can caregivers participate in the demo flow?",
				"answer": "Yes. The demo includes a shared in-session caregiver view for reviewing goal wording and acceptance status."
			},
			{
				"question": "Does the tool generate goals automatically?",
				"answer": "No. Goal wording is practitioner-entered and collaboratively revised with caregivers."
			},
			{
				"question": "What if caregivers do not accept a goal?",
				"answer": "The goal remains proposed or unresolved instead of being finalized as accepted."
			},
			{
				"question": "What is saved after exploration?",
				"answer": "The tool itself and selected goal-cycle setup are saved. Fictional sample feedback, demo goals, and caregiver comments do not become real client data."
			}
		]
	},
	{
		"toolType": "theraplayActivityPlan",
		"slug": "theraplay-activity-plan",
		"title": "Theraplay Activity Plan Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only session-planning tool for sequencing selected activities, goals, dimension references, and adjustment notes.",
		"h1": "Theraplay Activity Plan",
		"intro": "Theraplay Activity Plan is a practitioner-only planning tool for Theraplay-oriented treatment. Practitioners use it to create a sequenced session structure with selected activities tied to a specific caregiver-child dyad's goals, needs, and assessment findings.",
		"demoTitle": "Explore a sample activity plan",
		"demoPrompt": "Interested in using Theraplay Activity Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0924-f-054-ther-008-r001-theraplay-activity-plan.md",
		"specId": "0924-f-054-ther-008-r001-theraplay-activity-plan",
		"tags": {
			"framework": [
				"Theraplay"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Session preparation",
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Interpersonal relationships"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use before a Theraplay-oriented session to turn current dyad priorities into a sequenced plan for what happens in the room."
			},
			{
				"title": "Adjustment After Response",
				"body": "After a session, the practitioner can preserve what was planned and record adjustments or response notes for future planning."
			},
			{
				"title": "Limitations",
				"body": "The tool does not supply activity instructions, an activity catalog, dimension definitions, selection algorithms, or outcome scoring."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend activities?",
				"answer": "No. The practitioner selects or enters activities; the tool structures and reviews the plan."
			},
			{
				"question": "Can clients use the plan directly?",
				"answer": "No. The product specification defines this as practitioner-only."
			},
			{
				"question": "What if no activities are selected?",
				"answer": "The plan cannot be marked ready for session without selected activities."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself and selected plan configuration are saved. Fictional sample activities and demo case content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "parentHomeTheraplayPlan",
		"slug": "parent-home-theraplay-plan",
		"title": "Parent Home Theraplay Plan Demo | Qwoach",
		"metaDescription": "Explore a sendable home-practice plan for assigning Theraplay-oriented practices and reviewing caregiver-reported use and dyad response.",
		"h1": "Parent Home Theraplay Plan",
		"intro": "Parent Home Theraplay Plan is a sendable home-practice tool for Theraplay-oriented relational work. Practitioners use it to assign caregiver-facing practices tied to dyad goals and caregiver capacity, then review whether the practices were used and how the dyad responded.",
		"demoTitle": "Explore a sample home plan",
		"demoPrompt": "Interested in using Parent Home Theraplay Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0925-f-054-ther-009-r001-parent-home-theraplay-plan.md",
		"specId": "0925-f-054-ther-009-r001-parent-home-theraplay-plan",
		"tags": {
			"framework": [
				"Theraplay"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Skill practice",
				"Between-session monitoring"
			],
			"topic": [
				"Homework",
				"Skills use",
				"Interpersonal relationships"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Caregiver Role",
				"body": "Caregivers receive assigned practices and report whether they were tried, with descriptive response notes when requested."
			},
			{
				"title": "Review And Revision",
				"body": "Sent plans persist even with partial reporting. Revised plans preserve what was originally sent and show changes over time."
			},
			{
				"title": "Limitations",
				"body": "The tool does not include prefilled practice protocols, adherence scoring, effect ratings, or automated interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include exact Theraplay activity instructions?",
				"answer": "No. Instructions are practitioner-entered because exact home-practice content is unresolved in the product specification."
			},
			{
				"question": "Can caregivers submit partial reports?",
				"answer": "Yes. Partial use and response information remains usable for practitioner review."
			},
			{
				"question": "What happens if the caregiver does not report?",
				"answer": "The plan still persists for in-session discussion, and missing reporting is visible rather than treated as completion."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The tool itself and selected settings are saved. Fictional home practices and sample caregiver reports are not saved as real client data."
			}
		]
	},
	{
		"toolType": "threeSessionProgressReview",
		"slug": "three-session-progress-review",
		"title": "Three-Session Progress Review Demo | Qwoach",
		"metaDescription": "Explore a collaborative progress review for three-session blocks, prior goals, caregiver observations, focus direction, and next-step goals.",
		"h1": "Three-Session Progress Review",
		"intro": "Three-Session Progress Review is a collaborative progress and goal review tool for Theraplay-oriented treatment. Practitioners use it with caregivers after a small block of sessions to review prior goals, incorporate caregiver observations, and set next-step goals for the following sessions.",
		"demoTitle": "Explore a sample progress review",
		"demoPrompt": "Interested in using Three-Session Progress Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0926-f-054-ther-010-r001-three-session-progress-review.md",
		"specId": "0926-f-054-ther-010-r001-three-session-progress-review",
		"tags": {
			"framework": [
				"Theraplay"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Goal setting"
			],
			"topic": [
				"Goals",
				"Outcome monitoring",
				"Interpersonal relationships"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Recurring Use",
				"body": "Each finalized review persists as a longitudinal milestone for the dyad's treatment history."
			},
			{
				"title": "Caregiver Input",
				"body": "Caregiver observations remain labeled separately from practitioner observations and interpretation."
			},
			{
				"title": "Limitations",
				"body": "The tool does not include standardized scoring, exact review prompts, automated recommendations, or progress calculations."
			}
		],
		"faqItems": [
			{
				"question": "Why is the review anchored to three sessions?",
				"answer": "The product specification defines the review as a recurring progress and goal update after a three-session block."
			},
			{
				"question": "Can the review happen early?",
				"answer": "Yes, an off-cycle draft can be created if the practitioner chooses to review early, and it should be clearly labeled."
			},
			{
				"question": "Does the tool decide whether to continue, shift, or intensify?",
				"answer": "No. The practitioner records the focus direction; the system does not determine it automatically."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself and selected review configuration are saved. Fictional demo observations and sample goals are not saved as real client data."
			}
		]
	},
	{
		"toolType": "targetBehaviorDefinition2",
		"slug": "target-behavior-definition-2",
		"title": "Target Behavior Definition Demo | Qwoach",
		"metaDescription": "Explore a collaborative PMT tool for defining observable target behaviors, examples, recognizability, and version-ready target sets.",
		"h1": "Target Behavior Definition",
		"intro": "Target Behavior Definition is a collaborative parent management training tool for practitioners and families. Practitioners use it to turn broad child behavior concerns into a limited set of measurable, observable target behaviors that parents can recognize during home practice.",
		"demoTitle": "Explore sample target definitions",
		"demoPrompt": "Interested in using Target Behavior Definition with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0927-f-055-pmt-001-r001-target-behavior-definition.md",
		"specId": "0927-f-055-pmt-001-r001-target-behavior-definition",
		"tags": {
			"framework": [
				"Parent Management Training"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Problem behavior",
				"Behavior change",
				"Behavior analysis"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Collaborative Role",
				"body": "Practitioner and parent co-create definitions. Parents contribute real-world examples and confirm whether they can recognize the target at home."
			},
			{
				"title": "Version History",
				"body": "Once targets are used for tracking, later wording changes should create a revised definition or new version to preserve comparability."
			},
			{
				"title": "Limitations",
				"body": "The tool does not create a full behavior-change plan, reinforcement system, tracking chart, diagnosis, or intervention protocol."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool choose which behaviors the family should target?",
				"answer": "No. The practitioner and family select targets; the tool helps define them in observable terms."
			},
			{
				"question": "Can parents use the definitions?",
				"answer": "Yes. Parents see the finalized target definitions and confirm whether they can recognize the behaviors at home."
			},
			{
				"question": "What if a target is too vague?",
				"answer": "It remains a draft until the definition is specific enough to support recognition and repeated measurement."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself and selected setup are saved. Fictional sample concerns and target definitions are not saved as real client data."
			}
		]
	},
	{
		"toolType": "dailyBehaviorTrackingChart",
		"slug": "daily-behavior-tracking-chart",
		"title": "Daily Behavior Tracking Chart Demo | Qwoach",
		"metaDescription": "Explore a sendable PMT chart for tracking defined target behaviors across days or routines with parent entries, missingness, and trends.",
		"h1": "Daily Behavior Tracking Chart",
		"intro": "Daily Behavior Tracking Chart is a sendable home monitoring tool for parent management training. Practitioners use it to collect longitudinal parent-entered data about defined target child behaviors so patterns, missing entries, and change over time can be reviewed in session.",
		"demoTitle": "Explore a sample tracking chart",
		"demoPrompt": "Interested in using Daily Behavior Tracking Chart with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0928-f-055-pmt-002-r001-daily-behavior-tracking-chart.md",
		"specId": "0928-f-055-pmt-002-r001-daily-behavior-tracking-chart",
		"tags": {
			"framework": [
				"Parent Management Training"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Problem behavior",
				"Outcome monitoring"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Target-Linked Tracking",
				"body": "The chart should reuse observable target definitions when available so parents know what counts."
			},
			{
				"title": "Missing Data",
				"body": "Missing entries remain visible and are not treated as zero behavior."
			},
			{
				"title": "Limitations",
				"body": "The tool does not define targets, infer causes, prescribe strategies, score severity, or recommend treatment changes automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool define target behaviors?",
				"answer": "No. It tracks already-defined active target behaviors, preferably carried forward from a target definition tool."
			},
			{
				"question": "Can parents submit partial charts?",
				"answer": "Yes. Partial entries are allowed, and missing days or routines remain visible for review."
			},
			{
				"question": "Does the chart explain why behavior changed?",
				"answer": "No. It shows descriptive patterns and missingness; causal interpretation belongs to the practitioner."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself and selected chart configuration are saved. Fictional target data and sample parent entries are not saved as real client data."
			}
		]
	},
	{
		"toolType": "positiveReinforcementPlan",
		"slug": "positive-reinforcement-plan",
		"title": "Positive Reinforcement Plan Demo | Qwoach",
		"metaDescription": "Explore a collaborative PMT contingency plan linking observable positive behaviors to feasible reinforcement, delivery conditions, and review notes.",
		"h1": "Positive Reinforcement Plan",
		"intro": "Positive Reinforcement Plan is a collaborative parent management training tool for practitioners and parents. It helps create a clear contingency structure that links observable positive child behaviors to meaningful, feasible reinforcement and specifies when and how parents should deliver it.",
		"demoTitle": "Explore a sample reinforcement plan",
		"demoPrompt": "Interested in using Positive Reinforcement Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0929-f-055-pmt-003-r001-positive-reinforcement-plan.md",
		"specId": "0929-f-055-pmt-003-r001-positive-reinforcement-plan",
		"tags": {
			"framework": [
				"Parent Management Training"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Behavior change",
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Parent Role",
				"body": "Parents contribute reinforcer ideas, feasibility constraints, understanding checks, and later use or barrier information."
			},
			{
				"title": "Troubleshooting",
				"body": "Follow-up review exposes use and barrier information without deciding whether the plan worked or failed."
			},
			{
				"title": "Limitations",
				"body": "The tool does not include reinforcer taxonomies, standardized schedules, behavior scoring, punishment plans, or automated strategy changes."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool provide a list of reinforcers?",
				"answer": "No. Reinforcers are entered collaboratively by practitioner and parents because no supported reinforcer list is defined."
			},
			{
				"question": "When is a plan ready?",
				"answer": "A plan is ready when behavior, reinforcement, and delivery condition are not blank and parent understanding and feasibility are checked."
			},
			{
				"question": "Does the tool decide if reinforcement worked?",
				"answer": "No. It organizes use and barrier information for practitioner interpretation."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself and selected configuration are saved. Fictional demo contingencies and sample parent notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "praisePracticeLog",
		"slug": "praise-practice-log",
		"title": "Praise Practice Log Demo | Qwoach",
		"metaDescription": "Explore a sendable PMT praise log for parent skill-use entries, context, barriers, missingness, and coaching-ready summaries over time.",
		"h1": "Praise Practice Log",
		"intro": "Praise Practice Log is a sendable parent management training tool for capturing real-world parent use of praise and encouragement. Practitioners use it to review where praise happened, how often or in what context it was practiced, and what barriers got in the way between sessions.",
		"demoTitle": "Explore a sample praise log",
		"demoPrompt": "Interested in using Praise Practice Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0930-f-055-pmt-004-r001-praise-practice-log.md",
		"specId": "0930-f-055-pmt-004-r001-praise-practice-log",
		"tags": {
			"framework": [
				"Parent Management Training"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Skill practice"
			],
			"topic": [
				"Skills use",
				"Homework"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Low-Burden Parent Entry",
				"body": "Parents can record praise use quickly and add context or barriers without proving every instance."
			},
			{
				"title": "Coaching Review",
				"body": "The practitioner reviews descriptive patterns, missingness, and barriers to support coaching toward more consistent positive involvement."
			},
			{
				"title": "Limitations",
				"body": "The tool does not score praise quality, infer parenting competence, track child behavior outcomes, or generate coaching instructions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a child behavior tracker?",
				"answer": "No. Praise Practice Log tracks parent praise and encouragement practice, not child behavior outcomes."
			},
			{
				"question": "Can parents log partial information?",
				"answer": "Yes. Partial logging is supported, and gaps remain visible for review."
			},
			{
				"question": "Does the tool rate praise quality?",
				"answer": "No. It records parent-reported use, context, and barriers without a praise-quality score."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself and selected logging setup are saved. Fictional demo entries and sample barrier notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "effectiveInstructionsChecklist",
		"slug": "effective-instructions-checklist",
		"title": "Effective Instructions Checklist Demo | Qwoach",
		"metaDescription": "Explore a PMT checklist for identifying target situations and reviewing instruction quality with parents during direction-giving coaching.",
		"h1": "Effective Instructions Checklist for Parent Management Training",
		"intro": "Effective Instructions Checklist is a parent management training coaching aid for practitioners and parents. It helps identify specific situations where effective instructions should be used and supports review of direction quality against concrete behavioral features supplied by the checklist.",
		"demoTitle": "Explore the joint checklist with sample parent-child situations.",
		"demoPrompt": "Interested in using Effective Instructions Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0931-f-055-pmt-005-r001-effective-instructions-checklist.md",
		"specId": "0931-f-055-pmt-005-r001-effective-instructions-checklist",
		"tags": {
			"framework": [
				"Parent Management Training"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Behavior change",
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during direction-giving or limit-setting coaching when the practitioner and parent need to identify specific situations and distinguish clearer directions from vague or ineffective ones."
			},
			{
				"title": "Important Boundary",
				"body": "The demo must not display invented checklist items or scoring. If authoritative feature labels are unavailable, the page should show unresolved placeholders rather than substantive checklist content."
			}
		],
		"faqItems": [
			{
				"question": "Is this a parent self-assessment?",
				"answer": "No. It is a practitioner-guided checklist that parents may complete together with the practitioner during coaching."
			},
			{
				"question": "Does it score child compliance?",
				"answer": "No. It organizes target situations and instruction-quality review; it does not score child compliance or infer outcomes."
			},
			{
				"question": "Can incomplete work be saved?",
				"answer": "Yes. Incomplete target situations or unevaluated examples remain visible as unfinished coaching material."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool itself is saved as-is. Fictional demo situations, sample parent examples, and exploratory notes do not become real client data."
			}
		]
	},
	{
		"toolType": "theHomePointSystem",
		"slug": "the-home-point-system",
		"title": "Home Point System Demo for PMT | Qwoach",
		"metaDescription": "Explore a PMT home point system for target behaviors, point values, daily recording, reward exchanges, and practitioner review.",
		"h1": "The Home Point System for Parent Management Training",
		"intro": "The Home Point System is a parent management training tool for practitioners coaching parents. It helps define target child behaviors, assign point gains or losses, record home entries, total points, and connect accumulated points to reinforcers or privileges for review.",
		"demoTitle": "Configure a sample point plan and preview the home chart.",
		"demoPrompt": "Interested in using The Home Point System with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0932-f-055-pmt-006-r001-the-home-point-system.md",
		"specId": "0932-f-055-pmt-006-r001-the-home-point-system",
		"tags": {
			"framework": [
				"Parent Management Training"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Problem behavior"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The system captures configured target behaviors, point gains or losses, daily entries, running totals, reward eligibility, delivered rewards, parent notes, and missing-record indicators."
			},
			{
				"title": "Review Boundaries",
				"body": "Review summaries are descriptive. Plan adjustment, fading, and interpretation remain practitioner decisions."
			}
		],
		"faqItems": [
			{
				"question": "Can the practitioner use response cost?",
				"answer": "Yes. Response-cost fines are available only when the practitioner configures them for the plan."
			},
			{
				"question": "Does the system calculate points?",
				"answer": "Yes. It calculates daily and cumulative totals from configured point rules and recorded entries."
			},
			{
				"question": "What happens when a parent misses a day?",
				"answer": "The day is marked missing or partial rather than treated as zero behavior."
			},
			{
				"question": "Are rewards automatically delivered?",
				"answer": "No. The system can show reward eligibility and record delivery, but parents deliver rewards or privileges according to the plan."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and practitioner configuration are saved. Fictional daily records, sample notes, and demo reward exchanges are not saved as real client data."
			}
		]
	},
	{
		"toolType": "rubiTokenEconomySystems",
		"slug": "rubi-token-economy-systems",
		"title": "RUBI Token Economy Systems Demo | Qwoach",
		"metaDescription": "Explore a RUBI token economy setup for targets, token format, rewards, home practice, fidelity review, barriers, and fading status.",
		"h1": "RUBI Token Economy Systems for Parent Training",
		"intro": "RUBI Token Economy Systems is a manualized parent-training tool for RUBI-trained clinicians coaching parents of an autistic child. It helps select target behaviors, choose a token, point, or star format, build a reward menu, plan token-value teaching, record home practice, and review fit and fidelity.",
		"demoTitle": "Configure a sample token economy and inspect the parent practice view.",
		"demoPrompt": "Interested in using RUBI Token Economy Systems with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0933-f-055-pmt-006-r002-rubi-token-economy-systems.md",
		"specId": "0933-f-055-pmt-006-r002-rubi-token-economy-systems",
		"tags": {
			"framework": [
				"Applied Behavior Analysis"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Autism",
				"Behavior change",
				"Problem behavior"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Manualized Content Boundary",
				"body": "The demo may reserve spaces for therapist scripts, activity sheets, parent handouts, and fidelity checklist items, but it must not fill them with invented RUBI content."
			},
			{
				"title": "Parent And Clinician Roles",
				"body": "The clinician controls setup, fidelity review, and plan changes. Parents provide preferences, implement the system at home, and report practice data and barriers."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic token economy builder?",
				"answer": "No. It is scoped to RUBI Token Economy Systems with clinician-led setup, home practice, fidelity review, and fading or adjustment."
			},
			{
				"question": "Can the demo show RUBI scripts or checklist wording?",
				"answer": "Only if that content is supplied by an approved source. Otherwise those fields remain unresolved placeholders."
			},
			{
				"question": "Can parents use the system at home?",
				"answer": "Yes. Parents can use the active token, point, or star display and record implementation, rewards, and barriers."
			},
			{
				"question": "Does the tool decide when to fade?",
				"answer": "No. It shows information relevant to fading review; the clinician makes the decision."
			},
			{
				"question": "What is saved?",
				"answer": "The tool and clinician configuration are saved. Fictional home-practice entries and sample case details are not saved as real client data."
			}
		]
	},
	{
		"toolType": "incredibleYearsTangibleRewardsStickerChartsAndPointSystems",
		"slug": "incredible-years-tangible-rewards-sticker-charts-and-point-systems",
		"title": "Incredible Years Sticker Chart Demo | Qwoach",
		"metaDescription": "Explore an Incredible Years tangible rewards tool for behavior goals, sticker or point charts, reward menus, progress entries, and fading review.",
		"h1": "Incredible Years Tangible Rewards: Sticker Charts and Point Systems",
		"intro": "Incredible Years Tangible Rewards / Sticker Charts and Point Systems is a parent-training tool for practitioners coaching caregivers. It helps set a concrete behavior goal, choose a sticker chart or point system, build a feasible reward menu with child preference input, track earned progress, record reward exchanges, and support later fading discussion.",
		"demoTitle": "Set up a sample sticker or point chart.",
		"demoPrompt": "Interested in using Incredible Years Tangible Rewards / Sticker Charts and Point Systems with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0934-f-055-pmt-006-r003-incredible-years-tangible-rewards-sticker-charts-and-point-systems.md",
		"specId": "0934-f-055-pmt-006-r003-incredible-years-tangible-rewards-sticker-charts-and-point-systems",
		"tags": {
			"framework": [
				"Parent Management Training"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Behavior change",
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a caregiver is learning to build momentum for a specific rare or difficult positive behavior using visible earned progress and incentives."
			},
			{
				"title": "Review Boundaries",
				"body": "The result supports monitoring and practitioner coaching. It does not provide unsupported developmental conclusions or automatic fading decisions."
			}
		],
		"faqItems": [
			{
				"question": "Does the child directly operate the tool?",
				"answer": "No. The caregiver uses the chart with the child; child preferences can inform the reward menu."
			},
			{
				"question": "Can the chart use stickers or points?",
				"answer": "Yes. The practitioner can configure either a sticker chart or a point system."
			},
			{
				"question": "What if the reward menu is empty?",
				"answer": "The chart is not ready for active use until at least one feasible incentive is present."
			},
			{
				"question": "Does missing chart use mean the behavior did not occur?",
				"answer": "No. Missing entries are marked as missing rather than interpreted as no behavior."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and chart configuration are saved. Fictional entries, sample observations, and demo child preferences are not saved as real client data."
			}
		]
	},
	{
		"toolType": "timeOutConsequencePlan",
		"slug": "time-out-consequence-plan",
		"title": "Time-Out / Consequence Plan Demo | Qwoach",
		"metaDescription": "Explore a PMT consequence plan for defining target behaviors, recording a practitioner-entered strategy, and reviewing parent adherence.",
		"h1": "Time-Out / Consequence Plan for Parent Management Training",
		"intro": "Time-Out / Consequence Plan is a parent management training tool for practitioners and parents. It helps define specific child misbehaviors or noncompliance, record a practitioner-approved consequence strategy, and collect adherence information for later review.",
		"demoTitle": "Explore a sample consequence plan with fictional adherence logs.",
		"demoPrompt": "Interested in using Time-Out / Consequence Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0935-f-055-pmt-007-r001-time-out-consequence-plan.md",
		"specId": "0935-f-055-pmt-007-r001-time-out-consequence-plan",
		"tags": {
			"framework": [
				"Parent Management Training"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Problem behavior",
				"Behavior change"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures defined behavior triggers, practitioner-entered consequence strategy, parent adherence logs, barriers, uncertainty, escalation notes, and plan versions."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not provide generic discipline advice or fill in time-out procedure steps that are not supplied by the practitioner or applicable PMT protocol."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool teach a specific time-out procedure?",
				"answer": "No. It records a practitioner-approved consequence strategy; exact procedure content is not supplied by the specification."
			},
			{
				"question": "Can parents record uncertainty?",
				"answer": "Yes. Parent uncertainty should be recordable when they are not sure whether the target definition applied."
			},
			{
				"question": "Can the plan be used without a target behavior?",
				"answer": "No. Activation requires a defined target behavior and a specified consequence strategy."
			},
			{
				"question": "Does the result judge whether the consequence is clinically appropriate?",
				"answer": "No. It shows adherence and troubleshooting information for practitioner review."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and practitioner configuration are saved. Fictional logs and sample case content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "parentMonitoringPlan",
		"slug": "parent-monitoring-plan",
		"title": "Parent Monitoring Plan Demo | Qwoach",
		"metaDescription": "Explore a PMT monitoring plan for supervision targets, check expectations, parent adherence records, barriers, and practitioner review.",
		"h1": "Parent Monitoring Plan for PMT Supervision",
		"intro": "Parent Monitoring Plan is a parent management training tool for practitioners and parents. It helps define supervision targets for a child's activities, whereabouts, peers, or routines and review whether parent checks or follow-ups are happening as intended.",
		"demoTitle": "Build a sample monitoring plan with fictional check records.",
		"demoPrompt": "Interested in using Parent Monitoring Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0936-f-055-pmt-008-r001-parent-monitoring-plan.md",
		"specId": "0936-f-055-pmt-008-r001-parent-monitoring-plan",
		"tags": {
			"framework": [
				"Parent Management Training"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures supervision targets, check expectations, parent adherence entries, missed checks, not-applicable routines, uncertainty, barriers, and plan history."
			},
			{
				"title": "Privacy Boundary",
				"body": "This is not a real-time location or surveillance product. It relies on parent-reported checks and follow-ups."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool track a child's location?",
				"answer": "No. It does not collect real-time location data unless a separate supported capability is explicitly added."
			},
			{
				"question": "What can parents record?",
				"answer": "Parents can record checks, follow-ups, barriers, not-applicable routines, and uncertainty."
			},
			{
				"question": "Does a missed check mean risk occurred?",
				"answer": "No. Missed checks are shown as missing adherence, not as risk events or behavior absence."
			},
			{
				"question": "Can targets change over time?",
				"answer": "Yes. Target changes should preserve historical versions so old adherence data remains interpretable."
			},
			{
				"question": "What is saved?",
				"answer": "The tool and practitioner configuration are saved. Fictional check records and sample case details are not saved as real client data."
			}
		]
	},
	{
		"toolType": "familyProblemSolvingWorksheet",
		"slug": "family-problem-solving-worksheet",
		"title": "Family Problem-Solving Worksheet Demo | Qwoach",
		"metaDescription": "Explore a PMT worksheet for defining one family problem, agreeing on action steps, assigning next behaviors, and reviewing progress later.",
		"h1": "Family Problem-Solving Worksheet for PMT",
		"intro": "Family Problem-Solving Worksheet is a parent management training tool for practitioners guiding families. It helps define a recurring home problem, record agreed solution steps and responsibilities or next behaviors, and preserve the plan for later review.",
		"demoTitle": "Complete a sample problem-solving worksheet.",
		"demoPrompt": "Interested in using Family Problem-Solving Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0937-f-055-pmt-009-r001-family-problem-solving-worksheet.md",
		"specId": "0937-f-055-pmt-009-r001-family-problem-solving-worksheet",
		"tags": {
			"framework": [
				"Parent Management Training"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Problem solving",
				"Intervention planning"
			],
			"topic": [
				"Problem solving",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a recurring home problem needs shared agreement and concrete follow-through, not when the practitioner needs a general task manager or diagnostic assessment."
			},
			{
				"title": "Repeat Use",
				"body": "Each worksheet stays focused on one problem/action path. A practitioner can start another worksheet for a different recurring problem."
			}
		],
		"faqItems": [
			{
				"question": "Does the worksheet support multiple family problems at once?",
				"answer": "No. Each worksheet should stay focused on one recurring problem and action path."
			},
			{
				"question": "Can disagreement be recorded?",
				"answer": "Yes. Disagreement or unresolved responsibility can remain unresolved rather than being forced into consensus."
			},
			{
				"question": "Is this a task manager?",
				"answer": "No. It records a collaborative PMT problem/action plan and progress review, not a broad project-management workflow."
			},
			{
				"question": "What makes the worksheet complete?",
				"answer": "It needs a specific problem statement and at least one agreed action step before it is considered complete."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The worksheet tool is saved as-is. Fictional family content and sample action steps are not saved as real client data."
			}
		]
	},
	{
		"toolType": "parentSkillFidelityCompetencyRating",
		"slug": "parent-skill-fidelity-competency-rating",
		"title": "Parent Skill Fidelity Rating Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only PMT rating tool for observable parent skill ratings, evidence notes, not-observed marks, and mastery profile trends.",
		"h1": "Parent Skill Fidelity / Competency Rating for PMT",
		"intro": "Parent Skill Fidelity / Competency Rating is a practitioner-only parent management training tool. It helps practitioners rate observable parent application of relevant PMT skills, attach behavior-based notes, and build a longitudinal skill mastery profile for coaching decisions.",
		"demoTitle": "Explore a sample practitioner-only rating session.",
		"demoPrompt": "Interested in using Parent Skill Fidelity / Competency Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0938-f-055-pmt-010-r001-parent-skill-fidelity-competency-rating.md",
		"specId": "0938-f-055-pmt-010-r001-parent-skill-fidelity-competency-rating",
		"tags": {
			"framework": [
				"Parent Management Training"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring",
				"Skills use"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "This tool is for practitioner rating and review. Parent-facing feedback, if given, occurs through a separate coaching conversation."
			},
			{
				"title": "Content Boundary",
				"body": "The page must not invent skill domains, anchors, scoring, thresholds, or coaching recommendations. Missing source content should be visibly unresolved."
			}
		],
		"faqItems": [
			{
				"question": "Do parents complete this rating?",
				"answer": "No. This is a practitioner-only tool based on practitioner observation or review of parent skill use."
			},
			{
				"question": "Can the tool rate skills that were not observed?",
				"answer": "No. Skills that were not observed should be marked not observed instead of forced into a rating."
			},
			{
				"question": "Does it create a total competency score?",
				"answer": "No. A total score or threshold should not appear unless supplied by the approved rating structure."
			},
			{
				"question": "Does the tool recommend coaching steps automatically?",
				"answer": "No. It shows ratings, notes, and trends; coaching interpretation remains with the practitioner."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and any supplied configuration are saved. Fictional ratings and sample observation notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "ccptTreatmentGoals",
		"slug": "ccpt-treatment-goals",
		"title": "CCPT Treatment Goals Demo | Qwoach",
		"metaDescription": "Explore a CCPT goal-setting tool for parent priorities, presenting concerns, explicit treatment goals, confirmation, and revisit history.",
		"h1": "CCPT Treatment Goals for Collaborative Planning",
		"intro": "CCPT Treatment Goals is a child-centered play therapy planning tool for practitioners and parents. It helps gather parent presenting concerns and priorities, formulate explicit treatment goals, confirm shared understanding, and preserve goals for later review while staying responsive to the child.",
		"demoTitle": "Draft sample treatment goals with fictional parent priorities.",
		"demoPrompt": "Interested in using CCPT Treatment Goals with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0939-f-056-ccpt-001-r001-ccpt-treatment-goals.md",
		"specId": "0939-f-056-ccpt-001-r001-ccpt-treatment-goals",
		"tags": {
			"framework": [
				"Child-centered play therapy"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Progress review"
			],
			"topic": [
				"Goals"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at the beginning of CCPT and at review points when parent priorities and explicit treatment goals need to be revisited."
			},
			{
				"title": "Shared Direction Boundary",
				"body": "The tool supports shared direction with parents while preserving the child-centered need to remain responsive to the child during treatment."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool generate treatment goals automatically?",
				"answer": "No. The practitioner formulates goals with parents; the system organizes and preserves them."
			},
			{
				"question": "Can parents score progress?",
				"answer": "No. Parent progress scoring is not supported unless a valid scale is supplied separately."
			},
			{
				"question": "Is this a full intake assessment?",
				"answer": "No. It captures treatment goals linked to concerns and priorities; it is not a diagnosis tool or intake battery."
			},
			{
				"question": "Can goals be revised later?",
				"answer": "Yes. Revisions should preserve earlier wording so treatment direction can be revisited over time."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself is saved as-is. Fictional concerns, sample goals, and demo notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "familyObservation",
		"slug": "family-observation",
		"title": "Family Observation CCPT Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only CCPT observation tool for family interaction notes, strengths, concerns, planning links, and observation history.",
		"h1": "Family Observation for Child-Centered Play Therapy Planning",
		"intro": "Family Observation is a practitioner-only child-centered play therapy assessment tool. It helps practitioners document caregiver-child or family interaction patterns, relational strengths and concerns, and planning notes before play therapy so treatment planning is informed by observed context as well as parent report.",
		"demoTitle": "Explore a sample practitioner observation record.",
		"demoPrompt": "Interested in using Family Observation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0940-f-056-ccpt-002-r001-family-observation.md",
		"specId": "0940-f-056-ccpt-002-r001-family-observation",
		"tags": {
			"framework": [
				"Child-centered play therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Strengths"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "Family members are observed but do not enter data. Any parent-facing feedback is a separate clinical conversation, not a required product view."
			},
			{
				"title": "Observation Boundary",
				"body": "The tool captures observed interaction data and practitioner-entered grouping. It does not add unsupported coding categories or scores."
			}
		],
		"faqItems": [
			{
				"question": "Do family members complete this tool?",
				"answer": "No. This is practitioner-only observation capture; family members participate by being present in the observed interaction."
			},
			{
				"question": "Does the tool score family functioning?",
				"answer": "No. It does not generate family functioning scores, diagnostic labels, or standardized codes."
			},
			{
				"question": "Can strengths and concerns both be recorded?",
				"answer": "Yes. The record should support observed strengths and concerns without forcing either category."
			},
			{
				"question": "What if no direct observation occurred?",
				"answer": "The record should not be finalized as an observation if no direct observation occurred."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself is saved as-is. Fictional observation notes and sample family details are not saved as real client data."
			}
		]
	},
	{
		"toolType": "ccptSkillsChecklist",
		"slug": "ccpt-skills-checklist",
		"title": "CCPT Skills Checklist for Fidelity Review | Qwoach",
		"metaDescription": "Explore a practitioner-only CCPT fidelity checklist for reviewing observed therapist skills, strengths, gaps, and comparable change across sessions.",
		"h1": "CCPT Skills Checklist",
		"intro": "The CCPT Skills Checklist is a practitioner-only fidelity review tool for child-centered play therapy practitioners. It helps practitioners record observed in-session therapist behavior and produce a fidelity profile showing which skill areas appear consistently present, which need correction or supervision, and which lack enough evidence.",
		"demoTitle": "Explore the fidelity review",
		"demoPrompt": "Interested in using CCPT Skills Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0941-f-056-ccpt-003-r001-ccpt-skills-checklist.md",
		"specId": "0941-f-056-ccpt-003-r001-ccpt-skills-checklist",
		"tags": {
			"framework": [
				"Child-centered play therapy"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Observation-Based Review",
				"body": "Entries should reflect observed in-session therapist behavior rather than general impressions. Practitioner interpretation should remain distinct from observation notes."
			},
			{
				"title": "Comparison Limits",
				"body": "Historical comparison is available only when profiles use the same checklist structure. Structure changes must be marked as limiting direct comparison."
			}
		],
		"faqItems": [
			{
				"question": "Does the child complete this checklist?",
				"answer": "No. The CCPT Skills Checklist is practitioner-only; the child does not enter information or interact with the product."
			},
			{
				"question": "Does the tool generate CCPT skill items or scoring rules?",
				"answer": "No. The tool must use configured checklist content and does not invent items, wording, rating anchors, thresholds, or clinical conclusions."
			},
			{
				"question": "Can incomplete or insufficient observations be recorded?",
				"answer": "Yes. Items can be left incomplete or marked insufficient evidence so missing observation is not treated as skill absence."
			},
			{
				"question": "Can profiles be compared over time?",
				"answer": "Yes, when multiple completed profiles use the same checklist structure. Changed structures must be marked as not directly comparable."
			}
		]
	},
	{
		"toolType": "playThemeTracking",
		"slug": "play-theme-tracking",
		"title": "Play Theme Tracking for CCPT Sessions | Qwoach",
		"metaDescription": "Explore a practitioner-only CCPT tool for recording play themes by session and reviewing recurring, changing, isolated, and emerging themes over time.",
		"h1": "Play Theme Tracking",
		"intro": "Play Theme Tracking is a practitioner-only tool for child-centered play therapy practitioners. It helps practitioners record observed play material by session, identify practitioner-named themes, and review how themes recur, shift, emerge, or disappear over time.",
		"demoTitle": "Explore the theme timeline",
		"demoPrompt": "Interested in using Play Theme Tracking with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0942-f-056-ccpt-004-r001-play-theme-tracking.md",
		"specId": "0942-f-056-ccpt-004-r001-play-theme-tracking",
		"tags": {
			"framework": [
				"Child-centered play therapy"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Observation And Interpretation",
				"body": "The tool separates observed play material, practitioner-identified themes, derived recurrence or change summaries, and practitioner interpretation."
			},
			{
				"title": "Single-Session Limits",
				"body": "A single session can be recorded, but recurrence cannot be established until later entries show a pattern."
			}
		],
		"faqItems": [
			{
				"question": "Does Play Theme Tracking interpret symbolic meaning automatically?",
				"answer": "No. The tool organizes practitioner-entered themes and does not assign fixed meanings, diagnoses, or treatment conclusions."
			},
			{
				"question": "Can I use free-text themes?",
				"answer": "Yes. Free-text theme capture is supported when no legitimate theme vocabulary has been configured, though free text may reduce comparability."
			},
			{
				"question": "Can the child use this tool?",
				"answer": "No. This is a practitioner-only tracking tool; the child does not enter or review information through the product."
			},
			{
				"question": "What happens when a theme vocabulary changes?",
				"answer": "Changing the vocabulary affects grouping and may limit historical comparison, so prior entries should preserve their original meaning."
			}
		]
	},
	{
		"toolType": "playBehaviorObservationLog",
		"slug": "play-behavior-observation-log",
		"title": "Play Behavior Observation Log for CCPT | Qwoach",
		"metaDescription": "Explore a practitioner-only CCPT observation log for recording observable play behaviors, separating interpretation, and comparing changes across sessions.",
		"h1": "Play Behavior Observation Log",
		"intro": "The Play Behavior Observation Log is a practitioner-only tool for child-centered play therapy practitioners. It helps practitioners capture salient observable play behaviors by session, keep interpretation separate, and review how behavior patterns evolve across therapy.",
		"demoTitle": "Explore the observation log",
		"demoPrompt": "Interested in using Play Behavior Observation Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0943-f-056-ccpt-005-r001-play-behavior-observation-log.md",
		"specId": "0943-f-056-ccpt-005-r001-play-behavior-observation-log",
		"tags": {
			"framework": [
				"Child-centered play therapy"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Observable Behavior Focus",
				"body": "Behavior entries should describe what was observed. Interpretation can be recorded only in a visibly separate field."
			},
			{
				"title": "Missing Observation",
				"body": "Missing observation is not treated as behavior absence. The tool supports insufficient-observation and incomplete states."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as play theme tracking?",
				"answer": "No. This tool records observable play behaviors and descriptive change, not symbolic theme meaning."
			},
			{
				"question": "Does the tool infer clinical meaning from behavior?",
				"answer": "No. It organizes recorded behavior but does not diagnose, score, predict outcomes, or infer symbolic meaning."
			},
			{
				"question": "Can entries be compared over time?",
				"answer": "Yes. Behavior changes can be compared over time when entries use consistent labels or clear free-text review."
			},
			{
				"question": "Can a session with no salient behavior be recorded?",
				"answer": "Yes. The tool supports no-salient-behavior and insufficient-observation states."
			}
		]
	},
	{
		"toolType": "limitSettingSequence",
		"slug": "limit-setting-sequence",
		"title": "Limit-Setting Sequence for CCPT Sessions | Qwoach",
		"metaDescription": "Explore a compact CCPT live-session prompt for configured limit-setting steps, quick reset, rehearsal, and optional post-session reflection.",
		"h1": "Limit-Setting Sequence",
		"intro": "The Limit-Setting Sequence is a live-session support and rehearsal tool for child-centered play therapy practitioners. It helps practitioners follow a configured limit-setting sequence when a child approaches or crosses a therapeutic limit, while keeping the interface compact enough for use during a session.",
		"demoTitle": "Open the live prompt",
		"demoPrompt": "Interested in using Limit-Setting Sequence with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0944-f-056-ccpt-006-r001-limit-setting-sequence.md",
		"specId": "0944-f-056-ccpt-006-r001-limit-setting-sequence",
		"tags": {
			"framework": [
				"Child-centered play therapy"
			],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support",
				"Skill practice"
			],
			"topic": [
				"Problem behavior"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Live Use Constraint",
				"body": "The tool must remain readable quickly, avoid required live data entry, and allow immediate reset if interrupted."
			},
			{
				"title": "Optional Reflection",
				"body": "Reflection may be used after a session for supervision or skill refinement, but the supplied product does not require an artifact."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool provide exact limit-setting scripts?",
				"answer": "No. Exact scripts or steps are shown only when legitimate sequence content is configured; the tool does not generate them."
			},
			{
				"question": "Is documentation required after using the prompt?",
				"answer": "No. The product has no inherent artifact; post-session reflection is optional."
			},
			{
				"question": "Does the child use the tool?",
				"answer": "No. The tool supports the practitioner; the child does not interact with it."
			},
			{
				"question": "What if the session situation is urgent?",
				"answer": "Urgent safety situations may require action outside the tool. The product must not slow the practitioner's live response."
			}
		]
	},
	{
		"toolType": "parentConsultationReview",
		"slug": "parent-consultation-review",
		"title": "Parent Consultation Review for CCPT | Qwoach",
		"metaDescription": "Explore a practitioner-led CCPT consultation review for capturing parent-observed behaviors, concerns, gains, and change over time.",
		"h1": "Parent Consultation Review",
		"intro": "Parent Consultation Review is a practitioner-led consultation tool for child-centered play therapy practitioners meeting with a parent. It helps practitioners capture concrete parent observations, perceived gains, ongoing concerns, and changes in everyday life so the information can support clinical reflection and consultation.",
		"demoTitle": "Try the consultation review",
		"demoPrompt": "Interested in using Parent Consultation Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0945-f-056-ccpt-007-r001-parent-consultation-review.md",
		"specId": "0945-f-056-ccpt-007-r001-parent-consultation-review",
		"tags": {
			"framework": [
				"Child-centered play therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Progress review",
				"In-session support"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Parent And Practitioner Roles",
				"body": "The parent provides everyday observations during a practitioner-led review. The practitioner controls the clinical record and keeps parent report distinct from practitioner notes."
			},
			{
				"title": "Comparison Over Time",
				"body": "Prior reviews can support discussion of change when comparable fields exist; narrative comparison should be marked when prompt structures differ."
			}
		],
		"faqItems": [
			{
				"question": "Is this a parent intake form?",
				"answer": "No. It is a practitioner-led consultation review focused on parent-observed progress, concerns, gains, and change during a child's play therapy course."
			},
			{
				"question": "Does the tool score child outcomes?",
				"answer": "No. It does not create outcome scores, diagnoses, parenting evaluations, or automated clinical recommendations."
			},
			{
				"question": "Can parents skip items they have not observed?",
				"answer": "Yes. Unknown or skipped states are supported when the parent has not observed a behavior or situation."
			},
			{
				"question": "Can multiple caregiver perspectives be included?",
				"answer": "Multiple caregivers may report different observations if included, but the exact workflow for distinguishing them requires configuration."
			}
		]
	},
	{
		"toolType": "ccptResearchIntegrityFidelityChecklist",
		"slug": "ccpt-research-integrity-fidelity-checklist",
		"title": "CCPT Research Integrity and Fidelity Checklist | Qwoach",
		"metaDescription": "Explore a reviewer-only CCPT integrity checklist for evidence-grounded fidelity profiles, drift review, insufficient evidence, and comparable reviews.",
		"h1": "CCPT Research Integrity / Fidelity Checklist",
		"intro": "The CCPT Research Integrity / Fidelity Checklist is a practitioner- and reviewer-only tool for research, training, supervision, or quality review contexts. It helps reviewers record observable implementation evidence and produce an integrity profile showing configured model elements, deviations, drift, inconsistency, and insufficient-evidence areas.",
		"demoTitle": "Explore the integrity review",
		"demoPrompt": "Interested in using CCPT Research Integrity / Fidelity Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0946-f-056-ccpt-008-r001-ccpt-research-integrity-fidelity-checklist.md",
		"specId": "0946-f-056-ccpt-008-r001-ccpt-research-integrity-fidelity-checklist",
		"tags": {
			"framework": [
				"Child-centered play therapy"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Formal Review Context",
				"body": "The tool is narrower than a general skills checklist and is intended for research, training, supervision, or quality review contexts where implementation integrity matters."
			},
			{
				"title": "Evidence Standards",
				"body": "Judgments must be grounded in observable implementation evidence or marked insufficient evidence. Insufficient evidence is distinct from non-adherence."
			}
		],
		"faqItems": [
			{
				"question": "Does the checklist decide whether a study or practitioner is valid?",
				"answer": "No. The tool does not make automatic validity conclusions, pass/fail decisions, or unsupported competence judgments."
			},
			{
				"question": "Can incomplete reviews support integrity conclusions?",
				"answer": "No. Incomplete reviews are marked incomplete and cannot support defensible integrity conclusions on their own."
			},
			{
				"question": "Does the tool invent required model elements?",
				"answer": "No. Required elements, deviations, response options, and thresholds must come from configured checklist content."
			},
			{
				"question": "Can integrity reviews be compared over time?",
				"answer": "Yes, but direct comparison requires matching checklist structure and response rules."
			}
		]
	},
	{
		"toolType": "specialPlaytimePlan",
		"slug": "special-playtime-plan",
		"title": "Special Playtime Plan for CPRT Home Practice | Qwoach",
		"metaDescription": "Explore a CPRT home practice plan for weekly special playtime, parent barriers, adherence review, and practitioner follow-up.",
		"h1": "Special Playtime Plan",
		"intro": "Special Playtime Plan is a parent-facing home practice tool for practitioners guiding parents in child-parent relationship therapy. It helps parents identify when and how a structured weekly play interaction will happen, name barriers, and later report whether practice occurred so the practitioner can review consistency and experience.",
		"demoTitle": "Preview the parent plan",
		"demoPrompt": "Interested in using Special Playtime Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0947-f-057-cprt-001-r001-special-playtime-plan.md",
		"specId": "0947-f-057-cprt-001-r001-special-playtime-plan",
		"tags": {
			"framework": [
				"Child-Parent Relationship Therapy"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Homework",
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Parent Role",
				"body": "The parent uses the plan to identify when and how the special play interaction will occur and to notice barriers that may interfere."
			},
			{
				"title": "Review Role",
				"body": "The practitioner reviews planned versus reported practice and barriers without the tool rating parent success or scoring child outcomes."
			}
		],
		"faqItems": [
			{
				"question": "Is this a full CPRT curriculum?",
				"answer": "No. This tool supports a special playtime plan and review; it does not teach the full curriculum or invent skill instructions."
			},
			{
				"question": "Does the parent use this tool?",
				"answer": "Yes. The parent completes or updates the plan and may report adherence or experience if the practitioner requests review."
			},
			{
				"question": "What if the parent misses the planned playtime?",
				"answer": "Missed playtime is recorded as adherence information for review, not as an automated judgment of failure."
			},
			{
				"question": "What gets saved when there are no configured instructions yet?",
				"answer": "The fixed tool is still saved as-is, with unresolved instruction slots until legitimate content is configured."
			}
		]
	},
	{
		"toolType": "videorecordedPlaySession",
		"slug": "videorecorded-play-session",
		"title": "Videorecorded Play Session for CPRT Supervision | Qwoach",
		"metaDescription": "Explore a CPRT video submission and review tool for parent-child play sessions, timestamped notes, coaching moments, and progress comparison.",
		"h1": "Videorecorded Play Session",
		"intro": "Videorecorded Play Session is a parent-submitted video evidence tool for practitioners supervising child-parent relationship therapy practice. It helps parents submit a clear record of a play interaction and helps practitioners review parent responses, child reactions, sequence moments, and coaching points with timestamped notes.",
		"demoTitle": "Preview video review",
		"demoPrompt": "Interested in using Videorecorded Play Session with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0948-f-057-cprt-002-r001-videorecorded-play-session.md",
		"specId": "0948-f-057-cprt-002-r001-videorecorded-play-session",
		"tags": {
			"framework": [
				"Child-Parent Relationship Therapy"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Review Without Automation",
				"body": "The tool organizes submitted video and practitioner-entered notes. It does not perform automated skill assessment, diagnosis, emotion analysis, or feedback generation."
			},
			{
				"title": "Partial Review States",
				"body": "Failed upload, unsupported files, unclear video, or wrong submissions can be marked failed, not reviewable, or partially reviewable."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool analyze the video automatically?",
				"answer": "No. It does not perform automated coding, scoring, facial or emotion analysis, diagnosis, or clinical interpretation."
			},
			{
				"question": "What does the parent submit?",
				"answer": "The parent submits a video recording of the requested play interaction and may add a short context note if supported."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews video playback, adds timestamped notes, identifies coaching moments, and compares practitioner-entered notes across sessions when available."
			},
			{
				"question": "What if the video is unclear?",
				"answer": "The practitioner can mark the video not reviewable or partially reviewable when it does not show the requested interaction clearly enough."
			}
		]
	},
	{
		"toolType": "cprtParentSkillsChecklist",
		"slug": "cprt-parent-skills-checklist",
		"title": "CPRT Parent Skills Checklist for Supervision | Qwoach",
		"metaDescription": "Explore a practitioner-only CPRT checklist for reviewing parent play skills, observed evidence, coaching needs, and development over time.",
		"h1": "CPRT Parent Skills Checklist",
		"intro": "The CPRT Parent Skills Checklist is a practitioner-only review tool for practitioners supervising parents learning child-centered play skills. It helps practitioners record observed or reviewable parent behavior and generate a skill profile showing strengths, coaching needs, insufficient-evidence areas, and development over time.",
		"demoTitle": "Explore the parent skill profile",
		"demoPrompt": "Interested in using CPRT Parent Skills Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0949-f-057-cprt-003-r001-cprt-parent-skills-checklist.md",
		"specId": "0949-f-057-cprt-003-r001-cprt-parent-skills-checklist",
		"tags": {
			"framework": [
				"Child-Parent Relationship Therapy"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Observation-Based Skill Review",
				"body": "The checklist reflects observed or reviewable parent behavior, not parent self-report or broad personality judgments."
			},
			{
				"title": "Coaching Continuation",
				"body": "The profile can inform focused coaching, but the tool does not generate a coaching plan or substantive coaching content."
			}
		],
		"faqItems": [
			{
				"question": "Does the parent complete this checklist?",
				"answer": "No. This specified product is practitioner-only; the parent does not complete the checklist."
			},
			{
				"question": "Does the tool generate coaching advice?",
				"answer": "No. It highlights coaching needs from checklist entries but does not generate coaching content or a coaching plan."
			},
			{
				"question": "Can insufficient evidence be recorded?",
				"answer": "Yes. Skill areas can be marked insufficient evidence when the observation source does not support a judgment."
			},
			{
				"question": "Can parent skill development be tracked over time?",
				"answer": "Yes, when repeated reviews use the same checklist structure or are clearly marked as having limited comparability."
			}
		]
	},
	{
		"toolType": "reflectingFeelingsPractice",
		"slug": "reflecting-feelings-practice",
		"title": "Reflecting Feelings Practice for CPRT Parents | Qwoach",
		"metaDescription": "Explore a CPRT parent practice activity for reflecting feelings, parent-generated examples, practitioner review notes, and coaching discussion.",
		"h1": "Reflecting Feelings Practice",
		"intro": "Reflecting Feelings Practice is a parent-facing skill practice activity for practitioners teaching child-parent relationship therapy skills. It helps parents enter example responses that recognize a child's expressed feeling, and it helps practitioners review those examples for coaching without automatic scoring.",
		"demoTitle": "Preview the practice activity",
		"demoPrompt": "Interested in using Reflecting Feelings Practice with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0950-f-057-cprt-004-r001-reflecting-feelings-practice.md",
		"specId": "0950-f-057-cprt-004-r001-reflecting-feelings-practice",
		"tags": {
			"framework": [
				"Child-Parent Relationship Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Emotion regulation",
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "Single Skill Focus",
				"body": "The activity stays focused on reflecting feelings and does not expand into a full CPRT curriculum or general emotion-coaching course."
			},
			{
				"title": "Review Without Scoring",
				"body": "Validation checks that a response exists. The practitioner reviews examples for coaching; the product does not score correctness or provide correct answers."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool grade parent responses?",
				"answer": "No. It does not auto-score, judge correctness, or assign standardized emotion-recognition scores."
			},
			{
				"question": "Does the tool generate practice scenarios?",
				"answer": "No. Prompts or scenarios must be supplied through legitimate configured content; otherwise the demo shows unresolved practice slots."
			},
			{
				"question": "Can parents save drafts?",
				"answer": "Yes. Draft responses can be preserved before submission, and unfinished responses can be marked for discussion."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews parent-generated examples, adds coaching notes, and uses them for discussion or later practice."
			}
		]
	},
	{
		"toolType": "trackingBehaviorPractice",
		"slug": "tracking-behavior-practice",
		"title": "Tracking Behavior Practice for Parent Play Coaching | Qwoach",
		"metaDescription": "Demo a parent practice tool for tracking child play behavior with observable language, reviewable examples, and practitioner feedback.",
		"h1": "Tracking Behavior Practice",
		"intro": "Tracking Behavior Practice is a ready-to-send parent skill practice for child-parent relationship therapy practitioners. Practitioners use it to collect concrete examples of how a parent describes observable child play behavior while following the child's lead.",
		"demoTitle": "Explore the practice, switch between setup and parent view, then save the tool for your account.",
		"demoPrompt": "Interested in using Tracking Behavior Practice with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0951-f-057-cprt-005-r001-tracking-behavior-practice.md",
		"specId": "0951-f-057-cprt-005-r001-tracking-behavior-practice",
		"tags": {
			"framework": [
				"Child-Parent Relationship Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this practice while teaching a parent to describe child play behavior in concrete language during parent-child play sessions."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures play moments, parent tracking-language examples, completion state, and practitioner feedback. It does not collect diagnoses, symptom ratings, relationship scores, or interpretations of child play content."
			},
			{
				"title": "Repeat Use",
				"body": "Submitted practices can remain available as prior examples so the practitioner can compare learning over time without turning the activity into a scoring rubric."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide whether a parent's response is correct?",
				"answer": "No. The tool preserves the parent's response and leaves feedback and interpretation to the practitioner."
			},
			{
				"question": "Can I provide my own play moments?",
				"answer": "Yes. The supported setting lets the practitioner provide play moments or have the parent enter examples from actual play."
			},
			{
				"question": "Does the demo require real client information?",
				"answer": "No. The public demo should use fictional play moments and placeholder responses only."
			}
		]
	},
	{
		"toolType": "returningResponsibilityPractice",
		"slug": "returning-responsibility-practice",
		"title": "Returning Responsibility Practice for Parent Play Coaching | Qwoach",
		"metaDescription": "Demo a parent practice tool for responses to child help, reassurance, or decision-seeking during therapeutic play.",
		"h1": "Returning Responsibility Practice",
		"intro": "Returning Responsibility Practice is a ready-to-send parent skill practice for child-parent relationship therapy practitioners. Practitioners use it to collect example parent responses when a child seeks help, reassurance, or decisions during therapeutic play.",
		"demoTitle": "Explore setup, try the parent response view, and save the practice for your account.",
		"demoPrompt": "Interested in using Returning Responsibility Practice with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0952-f-057-cprt-006-r001-returning-responsibility-practice.md",
		"specId": "0952-f-057-cprt-006-r001-returning-responsibility-practice",
		"tags": {
			"framework": [
				"Child-Parent Relationship Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Skills use",
				"Problem solving"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this practice when a parent is learning how to respond to a child's requests for help, reassurance, or decisions during child-led play."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures situations, child cues, parent response examples, optional parent uncertainty, completion state, and practitioner feedback."
			},
			{
				"title": "Important Limit",
				"body": "The tool does not make automated safety decisions or tell the parent when adult action is required. Those judgments remain practitioner-entered feedback."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool give safety advice?",
				"answer": "No. It lets the practitioner flag examples for limit-setting or safety discussion, but it does not provide automated safety instructions."
			},
			{
				"question": "Can parents enter real play situations?",
				"answer": "Yes. The practitioner can choose parent-entered real situations instead of practitioner-provided situations."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected reusable setup are saved. Demo responses and fictional sample situations are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "limitSettingPractice",
		"slug": "limit-setting-practice",
		"title": "Limit-Setting Practice for Therapeutic Play Coaching | Qwoach",
		"metaDescription": "Demo a parent practice tool for limit-setting responses to misbehavior or unsafe behavior during therapeutic play.",
		"h1": "Limit-Setting Practice",
		"intro": "Limit-Setting Practice is a ready-to-send parent skill practice for child-parent relationship therapy practitioners. Practitioners use it to collect parent examples of limit-setting responses to misbehavior or unsafe behavior during therapeutic play.",
		"demoTitle": "Explore the practice setup, enter sample parent responses, and save the tool for your account.",
		"demoPrompt": "Interested in using Limit-Setting Practice with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0953-f-057-cprt-007-r001-limit-setting-practice.md",
		"specId": "0953-f-057-cprt-007-r001-limit-setting-practice",
		"tags": {
			"framework": [
				"Child-Parent Relationship Therapy"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Skills use",
				"Problem behavior"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this practice when a parent is preparing for likely misbehavior or unsafe behavior during therapeutic play and needs concrete limit-setting language."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the behavior situation, parent response, source of the situation, completion state, and practitioner feedback about coaching needs."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not perform automated safety triage, score the parent, or recommend discipline plans."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool handle unsafe situations automatically?",
				"answer": "No. It preserves the reported situation for practitioner review and does not issue automated safety instructions."
			},
			{
				"question": "Can I use parent-entered situations?",
				"answer": "Yes. The practitioner can choose parent-entered situations to reveal actual concerns and coaching needs."
			},
			{
				"question": "Are responses scored?",
				"answer": "No. Responses are organized for review, and feedback is entered by the practitioner."
			}
		]
	},
	{
		"toolType": "parentHomeworkSheet",
		"slug": "parent-homework-sheet",
		"title": "Parent Homework Sheet for CPRT Between-Session Practice | Qwoach",
		"metaDescription": "Demo a parent homework sheet that captures home practice follow-through, learning or confusion, and barriers for practitioner review.",
		"h1": "Parent Homework Sheet",
		"intro": "Parent Homework Sheet is a ready-to-send child-parent relationship therapy homework record for practitioners. Practitioners use it to review parent follow-through, learning or confusion, and barriers between sessions.",
		"demoTitle": "Explore the homework setup, complete a sample parent entry, and save the sheet for your practice.",
		"demoPrompt": "Interested in using Parent Homework Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0954-f-057-cprt-008-r001-parent-homework-sheet.md",
		"specId": "0954-f-057-cprt-008-r001-parent-homework-sheet",
		"tags": {
			"framework": [
				"Child-Parent Relationship Therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Homework"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this sheet between sessions when parents are carrying child-parent relationship therapy learning into home practice."
			},
			{
				"title": "What It Captures",
				"body": "The sheet captures completed, partial, or missed practice as reported by the parent, learning or confusion, barriers, submission state, and practitioner notes."
			},
			{
				"title": "Repeat Use",
				"body": "The tool supports repeated sheets over sessions so adherence patterns and recurring barriers can be reviewed without becoming a complex tracking system."
			}
		],
		"faqItems": [
			{
				"question": "Does the sheet score parent compliance?",
				"answer": "No. It records parent-reported follow-through, learning or confusion, and barriers without scoring or blame-oriented labels."
			},
			{
				"question": "Can partial practice be recorded?",
				"answer": "Yes. Partial adherence is a supported state and can include barriers or context."
			},
			{
				"question": "Is a session-specific focus required?",
				"answer": "No. The practitioner may add a focus when helpful, or leave the sheet reusable for general home practice review."
			}
		]
	},
	{
		"toolType": "parentPlaySessionFeedbackForm",
		"slug": "parent-play-session-feedback-form",
		"title": "Parent Play Session Feedback Form for CPRT Review | Qwoach",
		"metaDescription": "Demo a play-session feedback form for observed moments, strengths, growth areas, coaching priorities, and longitudinal review.",
		"h1": "Parent Play Session Feedback Form",
		"intro": "Parent Play Session Feedback Form is a ready-to-complete-together child-parent relationship therapy review tool for practitioners. Practitioners use it to connect observed parent-child interaction moments with strengths, growth areas, and coaching priorities.",
		"demoTitle": "Explore practitioner and shared review modes, add sample feedback, and save the form for your account.",
		"demoPrompt": "Interested in using Parent Play Session Feedback Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0955-f-057-cprt-009-r001-parent-play-session-feedback-form.md",
		"specId": "0955-f-057-cprt-009-r001-parent-play-session-feedback-form",
		"tags": {
			"framework": [
				"Child-Parent Relationship Therapy"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Skills use"
			],
			"population": [
				"Parents",
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this form during or after review of a parent's therapeutic play session when feedback needs to stay connected to observed interaction moments."
			},
			{
				"title": "Practitioner And Parent Roles",
				"body": "The practitioner creates and controls the feedback. In together-completion mode, the parent can view the feedback and may contribute reflections if invited."
			},
			{
				"title": "Longitudinal Review",
				"body": "Prior forms can be referenced to see recurring priorities or changes across play-session reviews without adding unsupported ratings."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool analyze video?",
				"answer": "No. It records practitioner-entered observed moments and feedback; it does not provide automated video analysis."
			},
			{
				"question": "Can the form be completed with the parent?",
				"answer": "Yes. Completion mode can be set to completed together with the parent or practitioner-completed after observation."
			},
			{
				"question": "Does it score parent skill?",
				"answer": "No. It organizes feedback, strengths, growth areas, and priorities without standardized scores."
			}
		]
	},
	{
		"toolType": "sandTrayScene",
		"slug": "sand-tray-scene",
		"title": "Sand Tray Scene Tool for Symbolic Scene Preservation | Qwoach",
		"metaDescription": "Demo a sandtray scene tool that preserves selected symbols, spatial arrangement, and practitioner notes without automated interpretation.",
		"h1": "Sand Tray Scene",
		"intro": "Sand Tray Scene is a ready-to-complete-together sandtray therapy artifact for practitioners and clients. It helps preserve selected symbols, placement, and spatial relationships so the practitioner can attend to the scene without requiring immediate verbal explanation.",
		"demoTitle": "Build a sample scene, review the preserved arrangement, and save the scene tool for your account.",
		"demoPrompt": "Interested in using Sand Tray Scene with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0956-f-058-sand-001-r001-sand-tray-scene.md",
		"specId": "0956-f-058-sand-001-r001-sand-tray-scene",
		"tags": {
			"framework": [
				"Sandtray therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Clinical documentation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool during or immediately after a sandtray process when the scene itself needs to remain available for therapeutic attention."
			},
			{
				"title": "What It Preserves",
				"body": "The tool preserves selected symbols or placeholders, object placement, arrangement, descriptive spatial relationships, and practitioner notes kept outside the client's scene."
			},
			{
				"title": "Relevant Limitation",
				"body": "The tool does not require verbal explanation and does not interpret the scene or assign symbolic meaning."
			}
		],
		"faqItems": [
			{
				"question": "Does the client have to explain the scene?",
				"answer": "No. The scene can be created and preserved without required verbal labels, ratings, or explanations."
			},
			{
				"question": "Can a physical tray be reconstructed?",
				"answer": "Yes. The capture mode can be practitioner-recorded reconstruction of a physical tray."
			},
			{
				"question": "Does the tool interpret symbols?",
				"answer": "No. It preserves symbols and arrangement descriptively and leaves interpretation to the practitioner."
			}
		]
	},
	{
		"toolType": "trayPhotograph",
		"slug": "tray-photograph",
		"title": "Tray Photograph Tool for Sandtray Scene Records | Qwoach",
		"metaDescription": "Demo a practitioner-only tool for capturing, linking, and reviewing sandtray photographs as durable visual records.",
		"h1": "Tray Photograph",
		"intro": "Tray Photograph is a practitioner-only sandtray therapy record for practitioners. It helps capture or upload a photograph of a sandtray scene, link it to the relevant session, and revisit the visual record later for reflection and comparison.",
		"demoTitle": "Explore capture and upload states, link a sample photo, and save the tool for your account.",
		"demoPrompt": "Interested in using Tray Photograph with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0957-f-058-sand-002-r001-tray-photograph.md",
		"specId": "0957-f-058-sand-002-r001-tray-photograph",
		"tags": {
			"framework": [
				"Sandtray therapy"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool at the end of or after a sandtray session when the tray composition needs to remain available for later review."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures or stores the tray photograph, session linkage, order in the tray sequence, and optional practitioner notes."
			},
			{
				"title": "Incomplete States",
				"body": "A record can remain incomplete if the image is missing, unusable, or not linked to a session."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client-facing experience?",
				"answer": "No. Tray Photograph is practitioner-only."
			},
			{
				"question": "Can I upload a photo taken outside the product?",
				"answer": "Yes. The acquisition method can be upload existing photograph."
			},
			{
				"question": "Does the tool identify symbols in the photo?",
				"answer": "No. It preserves the photograph and related session information without automated symbol extraction."
			}
		]
	},
	{
		"toolType": "traySequenceProcessTimeline",
		"slug": "tray-sequence-process-timeline",
		"title": "Tray Sequence Timeline for Sandtray Process Review | Qwoach",
		"metaDescription": "Demo a practitioner-only sandtray timeline for chronological scene review, visual comparison, and practitioner-entered recurrence notes.",
		"h1": "Tray Sequence / Process Timeline",
		"intro": "Tray Sequence / Process Timeline is a practitioner-only sandtray therapy review tool for practitioners. It helps order multiple sandtray scene records chronologically, compare scenes, and preserve practitioner-entered notes about recurrence or change.",
		"demoTitle": "Explore the sample timeline, compare scenes, and save the tool for your account.",
		"demoPrompt": "Interested in using Tray Sequence / Process Timeline with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0958-f-058-sand-003-r001-tray-sequence-process-timeline.md",
		"specId": "0958-f-058-sand-003-r001-tray-sequence-process-timeline",
		"tags": {
			"framework": [
				"Sandtray therapy"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool after multiple sandtray scene records exist and the practitioner wants to review the process across time."
			},
			{
				"title": "What It Shows",
				"body": "The timeline shows ordered scenes, thumbnails or summaries, optional notes, and comparison views for selected records."
			},
			{
				"title": "One-Scene State",
				"body": "A single scene can appear as a valid starting timeline, while recurrence and change remain unavailable until more scenes exist."
			}
		],
		"faqItems": [
			{
				"question": "Does the timeline interpret themes automatically?",
				"answer": "No. Recurrence and change notes are practitioner-entered; the system only orders and displays records."
			},
			{
				"question": "Can I curate which scenes appear?",
				"answer": "Yes. The inclusion rule can use all linked scene records or practitioner-selected records."
			},
			{
				"question": "Is there a client view?",
				"answer": "No. This timeline is a practitioner-only longitudinal review surface."
			}
		]
	},
	{
		"toolType": "symbolMiniatureInventory",
		"slug": "symbol-miniature-inventory",
		"title": "Symbol / Miniature Inventory for Sandtray Scene Review | Qwoach",
		"metaDescription": "Demo a practitioner-only sandtray inventory for scene elements, notable symbols, notes, and recurrence based on entered labels.",
		"h1": "Symbol / Miniature Inventory",
		"intro": "Symbol / Miniature Inventory is a practitioner-only sandtray therapy review tool for practitioners. It helps identify significant symbols and miniature elements in a scene so they can be reviewed in context and recognized across sessions when labels match.",
		"demoTitle": "Build a sample inventory, review recurrence indicators, and save the tool for your account.",
		"demoPrompt": "Interested in using Symbol / Miniature Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0959-f-058-sand-004-r001-symbol-miniature-inventory.md",
		"specId": "0959-f-058-sand-004-r001-symbol-miniature-inventory",
		"tags": {
			"framework": [
				"Sandtray therapy"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when reviewing a sandtray scene and needing a descriptive list of major symbols or miniature elements."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures element names or identifiers, scene linkage, optional notes, notable markers, and recurrence based on matching labels."
			},
			{
				"title": "Relevant Limitation",
				"body": "The tool is not a symbolic dictionary and does not assign meanings, scores, or diagnostic categories."
			}
		],
		"faqItems": [
			{
				"question": "Does the inventory explain what a symbol means?",
				"answer": "No. It identifies elements and leaves meaning-making to practitioner judgment."
			},
			{
				"question": "Can I enter custom miniature names?",
				"answer": "Yes. Custom element names are supported when no existing label fits."
			},
			{
				"question": "How is recurrence shown?",
				"answer": "Recurrence is shown only when practitioner-entered labels match or have been reconciled by the practitioner."
			}
		]
	},
	{
		"toolType": "spatialPatternRecord",
		"slug": "spatial-pattern-record",
		"title": "Spatial Pattern Record for Sandtray Scene Review | Qwoach",
		"metaDescription": "Demo a practitioner-only sandtray tool for recording placement, grouping, boundaries, and organization as overlays or notes.",
		"h1": "Spatial Pattern Record",
		"intro": "Spatial Pattern Record is a practitioner-only sandtray therapy review tool for practitioners. It helps capture placement, grouping, boundaries, and overall organization so the practitioner can reflect on scene structure separately from the symbol inventory.",
		"demoTitle": "Mark a sample spatial pattern, compare review modes, and save the tool for your account.",
		"demoPrompt": "Interested in using Spatial Pattern Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0960-f-058-sand-005-r001-spatial-pattern-record.md",
		"specId": "0960-f-058-sand-005-r001-spatial-pattern-record",
		"tags": {
			"framework": [
				"Sandtray therapy"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when the arrangement of space in a sandtray scene appears important for practitioner reflection."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures practitioner-entered observations about placement, grouping, boundaries, separations, and overall organization, linked to the source scene."
			},
			{
				"title": "How It Differs From Inventory",
				"body": "The record focuses on spatial structure, not just which symbols or miniatures are present."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool interpret spatial zones?",
				"answer": "No. It records practitioner observations and does not assign meanings or diagnostic scores to placement."
			},
			{
				"question": "Can I use notes instead of drawing overlays?",
				"answer": "Yes. Spatial capture mode can be visual overlay/marking or structured descriptive notes."
			},
			{
				"question": "What happens if there is no source scene?",
				"answer": "The record remains incomplete because reliable spatial review requires a linked source scene image or arrangement."
			}
		]
	},
	{
		"toolType": "clientNarrativeTitle",
		"slug": "client-narrative-title",
		"title": "Client Narrative / Title Demo | Qwoach",
		"metaDescription": "Capture a client's own title, theme, or story for a completed sandtray scene and review it beside the scene reference without scoring.",
		"h1": "Client Narrative / Title for sandtray reflection",
		"intro": "Client Narrative / Title is a sandtray reflection capture tool for practitioners working with clients after a symbolic scene has been created. It helps the practitioner record the client's own title, theme, story, or central meaning so later discussion stays connected to the client's authored language.",
		"demoTitle": "Open the demo with a fictional scene reference and capture sample client-authored wording.",
		"demoPrompt": "Interested in using Client Narrative / Title with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0961-f-058-sand-006-r001-client-narrative-title.md",
		"specId": "0961-f-058-sand-006-r001-client-narrative-title",
		"tags": {
			"framework": [
				"Sandtray therapy"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Therapeutic consolidation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it immediately after a sandtray scene has been created, when the client can name or describe the conscious meaning they attach to the scene."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not analyze symbols, assign clinical meaning, classify themes, score the scene, or create practitioner conclusions as if they were client meaning."
			},
			{
				"title": "Revisions And History",
				"body": "Partial wording remains visible as partial. Later revisions should preserve enough history to compare meaning over time without erasing earlier wording."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool interpret the sandtray scene?",
				"answer": "No. Client Narrative / Title records the client's own title, theme, story, or meaning and keeps practitioner observations separate."
			},
			{
				"question": "Can the client decline to provide meaning?",
				"answer": "Yes. The scene can be preserved as having no client-authored narrative rather than filling the gap with practitioner interpretation."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The tool and selected capture format are saved. Fictional demo wording and sample scene information are not saved as real client data."
			}
		]
	},
	{
		"toolType": "initialTrayReview",
		"slug": "initial-tray-review",
		"title": "Initial Tray Review Demo | Qwoach",
		"metaDescription": "Create a practitioner-only baseline review for an initial sandtray scene, separating observed material, context, and formulation for later comparison.",
		"h1": "Initial Tray Review for sandtray baseline formulation",
		"intro": "Initial Tray Review is a practitioner-only sandtray baseline formulation tool for practitioners beginning a sandtray-oriented therapeutic process. It helps the practitioner record observed symbolic material, available client context, and a formulation that can orient early treatment and support comparison with later sandtray work.",
		"demoTitle": "Review a fictional initial tray and build a sample baseline formulation.",
		"demoPrompt": "Interested in using Initial Tray Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0962-f-058-sand-007-r001-initial-tray-review.md",
		"specId": "0962-f-058-sand-007-r001-initial-tray-review",
		"tags": {
			"framework": [
				"Sandtray therapy"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "This tool is for practitioner formulation. Client input may inform available context outside the product, but the demo does not create a separate client workflow."
			},
			{
				"title": "Later Comparison",
				"body": "The baseline is preserved so later sandtray scenes can be reviewed against the initial symbolic formulation without overwriting the original review."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide symbol dictionaries, automated interpretation, diagnosis, scoring, or formulation areas beyond those supported by the specification."
			}
		],
		"faqItems": [
			{
				"question": "Is Initial Tray Review a client form?",
				"answer": "No. Initial Tray Review is practitioner-only; the practitioner creates and reviews the baseline formulation."
			},
			{
				"question": "Can some formulation areas be blank?",
				"answer": "Yes. Areas that are not relevant or not yet supported by available context can remain blank without implying absence."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The fixed Initial Tray Review tool is saved as-is. Fictional demo content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "strengthsAssessmentSa",
		"slug": "strengths-assessment-sa",
		"title": "Strengths Assessment (SA) Demo | Qwoach",
		"metaDescription": "Explore a collaborative Strengths Assessment that organizes aspirations, strengths, past resources, supports, priorities, and review information.",
		"h1": "Strengths Assessment (SA) for strengths-based case management",
		"intro": "Strengths Assessment (SA) is a collaborative Strengths Model Case Management assessment for case managers, social workers, and behavioral health practitioners. It helps practitioner and service user organize aspirations, current capacities, past resources, environmental supports, and priority focus areas so planning can be oriented around strengths and self-directed recovery or empowerment.",
		"demoTitle": "Explore the assessment matrix with fictional service-user entries and adjust the supported settings.",
		"demoPrompt": "Interested in using Strengths Assessment (SA) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0963-f-059-str-001-r001-strengths-assessment-sa.md",
		"specId": "0963-f-059-str-001-r001-strengths-assessment-sa",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Strengths",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use SA early in Strengths Model case management or when new context emerges, then update it as aspirations, resources, priorities, or review information change."
			},
			{
				"title": "Practitioner And Client Roles",
				"body": "The practitioner facilitates and records; the client supplies substantive content about values, capacities, resources, supports, and priorities."
			},
			{
				"title": "Limits",
				"body": "The SA feeds planning but is not itself a full goal-plan product. It does not collect diagnostic scores, deficit ratings, eligibility determinations, or unsupported interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Is the Strengths Assessment a score or test?",
				"answer": "No. Strengths Assessment (SA) is a collaborative strengths/resource profile, not a diagnostic score, deficit rating, or trait test."
			},
			{
				"question": "Does every life domain have to be completed?",
				"answer": "No. Domains can be left blank or deferred when they are not relevant or not yet known."
			},
			{
				"question": "What settings are saved?",
				"answer": "The selected life domains and periodic review field setting are saved with the tool. Fictional demo responses are not saved as client data."
			},
			{
				"question": "Can the profile change over time?",
				"answer": "Yes. The SA is designed to be updated as new strengths, resources, priorities, and review information emerge."
			}
		]
	},
	{
		"toolType": "personalStrengthsInventory",
		"slug": "personal-strengths-inventory",
		"title": "Personal Strengths Inventory Demo | Qwoach",
		"metaDescription": "Send a strengths-focused inventory clients complete to name capacities, talents, skills, values, and assets for practitioner review.",
		"h1": "Personal Strengths Inventory for client-recognized assets",
		"intro": "Personal Strengths Inventory is a ready-to-send strengths-perspective tool for practitioners whose clients may be stuck in a deficit-focused problem story. It helps clients identify personal capacities, talents, skills, values, and other assets so the practitioner can review a usable personal asset profile.",
		"demoTitle": "Open the demo, choose the inventory organization, and enter fictional sample assets.",
		"demoPrompt": "Interested in using Personal Strengths Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0964-f-059-str-002-r001-personal-strengths-inventory.md",
		"specId": "0964-f-059-str-002-r001-personal-strengths-inventory",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Strengths",
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client has difficulty seeing personal capacities or values because the conversation has centered on problems or needs."
			},
			{
				"title": "Client Ownership",
				"body": "The asset content should come from the client. Practitioner-added observations can be included only when clearly separated from client-recognized assets."
			},
			{
				"title": "Limits",
				"body": "The tool does not score strengths, rank traits, apply a proprietary talent model, or collect deficit-centered fields."
			}
		],
		"faqItems": [
			{
				"question": "Is this a standardized strengths test?",
				"answer": "No. Personal Strengths Inventory is an open-text client asset profile, not a standardized score or trait assessment."
			},
			{
				"question": "Can the client enter only a few assets?",
				"answer": "Yes. Few entries can be saved as a partial profile and revisited as circumstances evolve."
			},
			{
				"question": "What configuration is saved?",
				"answer": "The selected organization style is saved with the tool. Fictional demo assets and notes do not become real client data."
			}
		]
	},
	{
		"toolType": "socialSupportRelationshipStrengthsMap",
		"slug": "social-support-relationship-strengths-map",
		"title": "Relationship Strengths Map Demo | Qwoach",
		"metaDescription": "Create a collaborative support network map showing people or groups, support types, and availability for strengths-based planning.",
		"h1": "Map relational strengths and usable supports",
		"intro": "Social Support / Relationship Strengths Map is a collaborative mapping tool for strengths-perspective practitioners and clients. It helps identify supportive people or groups, describe what support each can provide, and distinguish reliable or helpful supports from weaker, unavailable, or uncertain connections.",
		"demoTitle": "Build a sample relationship map with fictional people and support descriptions.",
		"demoPrompt": "Interested in using Social Support / Relationship Strengths Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0965-f-059-str-003-r001-social-support-relationship-strengths-map.md",
		"specId": "0965-f-059-str-003-r001-social-support-relationship-strengths-map",
		"tags": {
			"framework": [],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Strengths",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when planning would benefit from knowing which people or groups the client may realistically draw on for support."
			},
			{
				"title": "What It Captures",
				"body": "The map captures people or groups, client-described support type, availability or usefulness, and goal relevance when known."
			},
			{
				"title": "Limits",
				"body": "The tool is not a contact manager, social-risk assessor, relationship-scoring instrument, or automated judgment of relationship quality."
			}
		],
		"faqItems": [
			{
				"question": "Does the map decide which relationships are safe or appropriate?",
				"answer": "No. The map records client-described supports and availability; practitioner and client review are still required."
			},
			{
				"question": "Can the map show that no supports are available?",
				"answer": "Yes. If the client identifies no supports, the result can show an empty or gap state instead of forcing invented resources."
			},
			{
				"question": "What gets saved from the demo?",
				"answer": "The tool and selected map representation are saved. Fictional names and sample support details are not saved as real client data."
			}
		]
	},
	{
		"toolType": "communityResourceMap",
		"slug": "community-resource-map",
		"title": "Community Resource Map Demo | Qwoach",
		"metaDescription": "Build a collaborative map of community, institutional, cultural, or environmental resources, current use, possible access, barriers, and gaps.",
		"h1": "Map community and environmental resources for client priorities",
		"intro": "Community Resource Map is a collaborative mapping tool for practitioners and clients working from a strengths perspective. It helps identify community, institutional, cultural, or environmental resources, distinguish resources already used from those that might be accessed next, and make barriers or gaps visible for planning.",
		"demoTitle": "Create a sample resource map using fictional priorities and non-identifying resources.",
		"demoPrompt": "Interested in using Community Resource Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0966-f-059-str-004-r001-community-resource-map.md",
		"specId": "0966-f-059-str-004-r001-community-resource-map",
		"tags": {
			"framework": [],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Strengths",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when planning depends on real-world supports outside the practitioner-client relationship."
			},
			{
				"title": "What It Captures",
				"body": "The map captures reported resources, priority relevance, current or potential access, and barriers or gaps."
			},
			{
				"title": "Limits",
				"body": "The tool is not a public resource directory, referral engine, eligibility system, or external availability verification service."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool verify that a resource is available?",
				"answer": "No. Community Resource Map organizes client/practitioner-reported information; it does not verify availability or eligibility."
			},
			{
				"question": "Can the result show resource gaps?",
				"answer": "Yes. If no resources are known for a priority, the map can show a gap rather than forcing an entry."
			},
			{
				"question": "What configuration is saved?",
				"answer": "The selected grouping style is saved with the tool. Fictional demo resources and barriers do not become real client data."
			}
		]
	},
	{
		"toolType": "survivalQuestions",
		"slug": "survival-questions",
		"title": "Survival Questions Demo | Qwoach",
		"metaDescription": "Explore open survival and coping prompts that capture client-reported strategies, resilience patterns, and resources without scoring.",
		"h1": "Survival Questions for strengths-oriented coping reflection",
		"intro": "Survival Questions is a strengths-oriented coping and resilience reflection tool for practitioners working with clients who have endured difficult circumstances. It helps capture client-reported coping strategies, resilience patterns, and survival resources so support can build from proven strengths rather than a deficit-only frame.",
		"demoTitle": "Try a fictional open-response reflection and review the coping/resilience summary.",
		"demoPrompt": "Interested in using Survival Questions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0967-f-059-str-005-r001-survival-questions.md",
		"specId": "0967-f-059-str-005-r001-survival-questions",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"In-session support"
			],
			"topic": [
				"Strengths",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Sensitive Completion",
				"body": "The client can skip items or answer briefly. Completion should not force disclosure of adversity details."
			},
			{
				"title": "Practitioner Review",
				"body": "Review focuses on concrete coping methods, what helped the client endure or manage, and capacities that may be validated or adapted."
			},
			{
				"title": "Limits",
				"body": "The tool does not score resilience, diagnose, analyze trauma, or automatically classify whether a strategy is adaptive."
			}
		],
		"faqItems": [
			{
				"question": "Does the client have to describe traumatic details?",
				"answer": "No. Survival Questions should not force disclosure of adversity details; it focuses on coping, persistence, protection, and resources the client chooses to share."
			},
			{
				"question": "Does the tool label coping strategies as healthy or unhealthy?",
				"answer": "No. The tool records strategies descriptively and leaves interpretation to the practitioner."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and selected completion mode are saved. Fictional responses and sample sensitive content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "exceptionQuestions",
		"slug": "exception-questions",
		"title": "Exception Questions Demo | Qwoach",
		"metaDescription": "Capture specific times a problem was less intense, absent, or handled better, with actions, conditions, and supports linked to better functioning.",
		"h1": "Exception Questions for identifying what already works",
		"intro": "Exception Questions is a strengths-oriented reflection tool for practitioners and clients working with a persistent problem. It helps identify specific times when the problem was less intense, absent, or handled more effectively, and captures the actions, conditions, or supports associated with better functioning.",
		"demoTitle": "Use fictional examples to capture exceptions and review workable factors.",
		"demoPrompt": "Interested in using Exception Questions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0968-f-059-str-006-r001-exception-questions.md",
		"specId": "0968-f-059-str-006-r001-exception-questions",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Strengths",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a persistent problem makes it hard for the client to notice better moments or workable responses that already exist."
			},
			{
				"title": "No Exception Yet",
				"body": "If no exception is identified, the result can preserve an unresolved state rather than forcing positivity."
			},
			{
				"title": "Limits",
				"body": "The tool does not score symptoms, infer causality, or generate treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the client have to identify an exception?",
				"answer": "No. If the client cannot identify one yet, the tool can preserve an open or unresolved state."
			},
			{
				"question": "Does the tool prove what caused the better moment?",
				"answer": "No. It records reported associations across actions, conditions, and supports without claiming causal certainty."
			},
			{
				"question": "What gets saved after the demo?",
				"answer": "The tool and selected settings are saved. Fictional problem contexts and sample exceptions are not saved as real client data."
			}
		]
	},
	{
		"toolType": "possibilityFutureQuestions",
		"slug": "possibility-future-questions",
		"title": "Possibility / Future Questions Demo | Qwoach",
		"metaDescription": "Capture client-defined aspirations and preferred futures in the client's own words, with optional constraints, for strengths-based support.",
		"h1": "Possibility / Future Questions for client-defined aspirations",
		"intro": "Possibility / Future Questions is a strengths-perspective reflection tool for practitioners helping clients shift from problem saturation toward hope and preferred futures. It helps clients articulate personally meaningful aspirations or possibilities for how life could be different, while allowing current constraints to be acknowledged.",
		"demoTitle": "Try a fictional future reflection and review the client-defined aspiration summary.",
		"demoPrompt": "Interested in using Possibility / Future Questions with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0969-f-059-str-007-r001-possibility-future-questions.md",
		"specId": "0969-f-059-str-007-r001-possibility-future-questions",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Strengths",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when problem saturation makes it hard for the client to imagine or name a preferred direction."
			},
			{
				"title": "Constraints",
				"body": "Constraints can be captured so the reflection surfaces hope or possibility without dismissing current realities."
			},
			{
				"title": "Limits",
				"body": "The tool does not auto-generate goals, prescribe steps, score hope, or impose practitioner targets."
			}
		],
		"faqItems": [
			{
				"question": "Is this a goal-planning tool?",
				"answer": "No. Possibility / Future Questions captures client-defined aspirations that may later inform goals, but it does not automatically create a plan."
			},
			{
				"question": "Can the client be tentative or unsure?",
				"answer": "Yes. Tentative or partial future statements can be saved and expanded later."
			},
			{
				"question": "What configuration is saved?",
				"answer": "Completion mode and the constraint-capture setting are saved with the tool. Fictional demo aspirations are not saved as real client data."
			}
		]
	},
	{
		"toolType": "strengthsToGoalsPlan",
		"slug": "strengths-to-goals-plan",
		"title": "Strengths-to-Goals Plan Demo | Qwoach",
		"metaDescription": "Create a collaborative plan that links client-priority goals to strengths, supports, resources, and concrete next steps for later review.",
		"h1": "Strengths-to-Goals Plan for strength-linked action steps",
		"intro": "Strengths-to-Goals Plan is a collaborative action planning tool for practitioners and clients who have already identified strengths and goals. It helps create a goal pathway that explicitly connects desired outcomes with personal strengths, supports, accessible resources, and concrete next steps the client is willing to attempt.",
		"demoTitle": "Build a fictional strength-linked goal pathway and review whether it is complete.",
		"demoPrompt": "Interested in using Strengths-to-Goals Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0970-f-059-str-008-r001-strengths-to-goals-plan.md",
		"specId": "0970-f-059-str-008-r001-strengths-to-goals-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Strengths",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after strengths and goals are available and the practitioner-client pair needs to translate them into actionable next steps."
			},
			{
				"title": "Completeness",
				"body": "A pathway is complete only when it includes a desired outcome, at least one connected strength or support, and at least one concrete step."
			},
			{
				"title": "Review And Adjustment",
				"body": "The pathway can be reviewed and adjusted over time while preserving prior versions or adjustment history where needed."
			},
			{
				"title": "Limits",
				"body": "The tool does not select goals automatically, score goal quality, manage unrelated tasks, or generate clinical recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does this replace a Strengths Assessment?",
				"answer": "No. Strengths-to-Goals Plan assumes strengths and goals have already been identified or can be entered; it does not replace a full strengths assessment."
			},
			{
				"question": "Can a goal be marked complete without a strength or support?",
				"answer": "No. A completed pathway must connect the goal to at least one relevant strength or support and one concrete next step."
			},
			{
				"question": "What settings are saved?",
				"answer": "Planning orientation and goal display scope are saved with the tool. Fictional demo goals, strengths, and next steps are not saved as real client data."
			},
			{
				"question": "Can the plan be adjusted later?",
				"answer": "Yes. The pathway can be reviewed and adjusted over time while preserving prior pathway information for review."
			}
		]
	},
	{
		"toolType": "targetProblemList",
		"slug": "target-problem-list",
		"title": "Target Problem List Demo for Task-Centered Practice | Qwoach",
		"metaDescription": "Explore a task-centered Target Problem List that helps practitioners and clients choose concrete, manageable problems for short-term work.",
		"h1": "Target Problem List for Task-Centered Work",
		"intro": "Target Problem List is a task-centered intake and focusing tool for practitioners working collaboratively with clients. It helps the practitioner and client turn competing concerns into a manageable prioritized problem set for short-term action.",
		"demoTitle": "Try the demo with sample concerns, then save the tool for your practice.",
		"demoPrompt": "Interested in using Target Problem List with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0971-f-060-tcp-001-r001-target-problem-list.md",
		"specId": "0971-f-060-tcp-001-r001-target-problem-list",
		"tags": {
			"framework": [
				"Task-centered practice"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool at the beginning of task-centered work when the practitioner and client need to choose a concrete focus from several possible concerns."
			},
			{
				"title": "What It Captures",
				"body": "It captures candidate concerns, selected target problems, priority order or selected subset, and unresolved specificity notes. It deliberately avoids diagnoses, severity scores, treatment recommendations, and detailed goal or task plans."
			},
			{
				"title": "Repeat Use",
				"body": "The selected problem set can be revised later while preserving earlier selected problems for comparison and continuity."
			}
		],
		"faqItems": [
			{
				"question": "Does Target Problem List diagnose or score client problems?",
				"answer": "No. Target Problem List organizes candidate concerns into selected target problems and priority order; it does not diagnose, score severity, or interpret clinical meaning."
			},
			{
				"question": "Can lower-priority concerns stay visible?",
				"answer": "Yes. Lower-priority concerns can remain visible for context without becoming parallel work unless the list is intentionally revised."
			},
			{
				"question": "Does this tool create goals or tasks?",
				"answer": "No. It stops at a focused target problem set. Goals and tasks are natural next steps but are separate workflows."
			}
		]
	},
	{
		"toolType": "problemPriorityRating",
		"slug": "problem-priority-rating",
		"title": "Problem Priority Rating Demo for Task-Centered Work | Qwoach",
		"metaDescription": "Explore a task-centered prioritization tool for ranking target problems and choosing the first focus without unsupported severity scoring.",
		"h1": "Problem Priority Rating for Task-Centered Practice",
		"intro": "Problem Priority Rating is a task-centered prioritization tool for practitioners and clients deciding where limited intervention time should go first. It helps create an explicit priority order while keeping lower-priority issues visible.",
		"demoTitle": "Rank the sample target problems and review the current priority order.",
		"demoPrompt": "Interested in using Problem Priority Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0972-f-060-tcp-002-r001-problem-priority-rating.md",
		"specId": "0972-f-060-tcp-002-r001-problem-priority-rating",
		"tags": {
			"framework": [
				"Task-centered practice"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "What It Does Not Do",
				"body": "The tool does not create severity ratings, clinical importance scores, symptom scales, diagnoses, or automated treatment decisions."
			},
			{
				"title": "When Priorities Change",
				"body": "A new order can be created later without erasing the historical order, so shifts in intervention focus remain reviewable."
			}
		],
		"faqItems": [
			{
				"question": "Is this a clinical severity rating?",
				"answer": "No. Problem Priority Rating creates an agreed order for task-centered focus; it does not score clinical severity or risk."
			},
			{
				"question": "What happens if the practitioner and client do not agree?",
				"answer": "The order can remain unresolved or provisional rather than forcing agreement."
			},
			{
				"question": "Can one problem be confirmed as first?",
				"answer": "Yes. If there is only one target problem, the tool can confirm it as first without requiring ranking."
			}
		]
	},
	{
		"toolType": "problemSpecificationSheet",
		"slug": "problem-specification-sheet",
		"title": "Problem Specification Sheet Demo | Qwoach",
		"metaDescription": "Explore a task-centered sheet for defining a target problem by appearance, occurrence, and affecting conditions before planning goals or tasks.",
		"h1": "Problem Specification Sheet for Task-Centered Work",
		"intro": "Problem Specification Sheet is a task-centered problem-definition tool for practitioners working with clients after a target problem has been chosen. It helps define how the problem appears, when it occurs, and what conditions maintain or affect it.",
		"demoTitle": "Specify a sample target problem and review the operational definition.",
		"demoPrompt": "Interested in using Problem Specification Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0973-f-060-tcp-003-r001-problem-specification-sheet.md",
		"specId": "0973-f-060-tcp-003-r001-problem-specification-sheet",
		"tags": {
			"framework": [
				"Task-centered practice"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One Problem at a Time",
				"body": "Each sheet describes one target problem. Multiple target problems should have separate specifications rather than mixing patterns."
			},
			{
				"title": "Unknown Details",
				"body": "The tool allows frequency, triggers, or other details to remain unknown rather than forcing invented information."
			},
			{
				"title": "Bounded Scope",
				"body": "The tool clarifies a target problem pattern. It does not create a diagnosis, clinical formulation, or treatment prescription."
			}
		],
		"faqItems": [
			{
				"question": "Does the sheet require triggers or frequency?",
				"answer": "No. Triggers or frequency can be marked unknown or not yet clear when the client cannot identify them."
			},
			{
				"question": "Can the client complete this outside the session?",
				"answer": "Yes, if sent for input, the client can respond to supported specification areas for one target problem and save partial work."
			},
			{
				"question": "Does this tool create a goal or task plan?",
				"answer": "No. It creates the operational problem definition that later goals and tasks can reference."
			}
		]
	},
	{
		"toolType": "serviceContract",
		"slug": "service-contract",
		"title": "Service Contract Demo for Task-Centered Practice | Qwoach",
		"metaDescription": "Explore a task-centered service contract for clarifying focus, intended outcomes, responsibilities, and review timing with a client.",
		"h1": "Service Contract for Task-Centered Work",
		"intro": "Service Contract is a task-centered agreement tool for practitioners starting time-limited work with clients. It helps the practitioner and client agree on the work to be done, responsibilities, timeframe or review point, and intended outcomes.",
		"demoTitle": "Review a sample working agreement and see what is required before confirmation.",
		"demoPrompt": "Interested in using Service Contract with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0974-f-060-tcp-004-r001-service-contract.md",
		"specId": "0974-f-060-tcp-004-r001-service-contract",
		"tags": {
			"framework": [
				"Task-centered practice"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Agreement Areas",
				"body": "The supported agreement areas are focus, intended outcome, practitioner responsibilities, client responsibilities, and timeframe or review point."
			},
			{
				"title": "Draft and Confirmed States",
				"body": "The agreement can remain draft when responsibilities, timing, realism, or mutual understanding are unresolved."
			},
			{
				"title": "Bounded Scope",
				"body": "The tool is a task-centered working agreement. It excludes broad consent language, billing terms, service policies, and unsupported treatment-plan fields."
			}
		],
		"faqItems": [
			{
				"question": "Is this a legal contract generator?",
				"answer": "No. Service Contract creates a task-centered working agreement about focus, responsibilities, timing, and intended outcomes."
			},
			{
				"question": "Can the agreement stay in draft?",
				"answer": "Yes. If responsibilities, timing, or shared understanding are unclear, the agreement remains draft or unresolved."
			},
			{
				"question": "Does the tool require a target focus first?",
				"answer": "Yes. If no target focus exists, the contract remains incomplete because the work to be done is not clear."
			}
		]
	},
	{
		"toolType": "goalStatement",
		"slug": "goal-statement",
		"title": "Goal Statement Demo for Task-Centered Practice | Qwoach",
		"metaDescription": "Explore a task-centered goal tool for defining a concrete, meaningful, achievable desired outcome linked to a target problem.",
		"h1": "Goal Statement for Task-Centered Work",
		"intro": "Goal Statement is a task-centered goal-definition tool for practitioners working with clients after a target problem has been identified. It helps create a specific, measurable, and achievable description of the desired outcome for that target problem.",
		"demoTitle": "Write a sample goal and review whether it is ready for task planning.",
		"demoPrompt": "Interested in using Goal Statement with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0975-f-060-tcp-005-r001-goal-statement.md",
		"specId": "0975-f-060-tcp-005-r001-goal-statement",
		"tags": {
			"framework": [
				"Task-centered practice"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Goal Linkage",
				"body": "Every goal remains linked to its target problem so later tasks and progress review stay aligned with the agreed focus."
			},
			{
				"title": "Draft Goals",
				"body": "A vague, unrealistic, or unassessable goal can remain draft until practitioner and client revise it."
			},
			{
				"title": "What It Excludes",
				"body": "The tool does not provide a goal library, treatment recommendations, standardized outcome scores, or unsupported progress scales."
			}
		],
		"faqItems": [
			{
				"question": "Does Goal Statement create tasks?",
				"answer": "No. Goal Statement defines the desired outcome; task planning is a separate next step."
			},
			{
				"question": "Does measurable require a number?",
				"answer": "Not necessarily. The supplied specification supports assessable progress, but the exact measurement format depends on local practice and is not defined here."
			},
			{
				"question": "Can a goal remain draft?",
				"answer": "Yes. A goal remains draft when specificity, achievability, assessability, or client meaning is unresolved."
			}
		]
	},
	{
		"toolType": "taskPlan",
		"slug": "task-plan",
		"title": "Task Plan Demo for Task-Centered Practice | Qwoach",
		"metaDescription": "Explore a task-centered Task Plan for creating specific actions, responsibilities, and timing linked to an agreed goal or target problem.",
		"h1": "Task Plan for Task-Centered Work",
		"intro": "Task Plan is a task-centered action-planning tool for practitioners working with clients after a goal has been set. It helps create specific actions, responsibilities, and timing that move the client toward the target goal.",
		"demoTitle": "Build a sample task plan and review what makes each task assignable.",
		"demoPrompt": "Interested in using Task Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0976-f-060-tcp-006-r001-task-plan.md",
		"specId": "0976-f-060-tcp-006-r001-task-plan",
		"tags": {
			"framework": [
				"Task-centered practice"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Assignable Tasks",
				"body": "A finalized task needs a specific action, responsible party, timing or review point, and linkage to a goal or target problem."
			},
			{
				"title": "Feasibility",
				"body": "Tasks that are too vague or unrealistic can remain draft or be revised before assignment."
			},
			{
				"title": "Natural Continuation",
				"body": "Assigned tasks become the source for later Task Completion Review and, when needed, barrier planning."
			}
		],
		"faqItems": [
			{
				"question": "Does Task Plan track completion?",
				"answer": "No. Task Plan creates assigned tasks; completion is reviewed later in Task Completion Review."
			},
			{
				"question": "Can practitioner-owned tasks be included?",
				"answer": "Yes. The tool supports practitioner responsibilities as well as client-owned actions when they are linked to the goal or target problem."
			},
			{
				"question": "Can a task be finalized without timing?",
				"answer": "No. A finalized task needs action, responsibility, timing or review point, and linkage."
			}
		]
	},
	{
		"toolType": "taskPreparationBarrierPlan",
		"slug": "task-preparation-barrier-plan",
		"title": "Task Preparation / Barrier Plan Demo | Qwoach",
		"metaDescription": "Explore a task-centered barrier plan for preparing agreed tasks with likely obstacles, readiness notes, and practical responses.",
		"h1": "Task Preparation / Barrier Plan for Task-Centered Work",
		"intro": "Task Preparation / Barrier Plan is a task-centered preparation tool for practitioners working with clients when planned tasks may be difficult to carry out. It helps identify likely barriers, readiness issues, and practical responses before the task is attempted.",
		"demoTitle": "Choose a sample task and build a task-linked barrier plan.",
		"demoPrompt": "Interested in using Task Preparation / Barrier Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0977-f-060-tcp-007-r001-task-preparation-barrier-plan.md",
		"specId": "0977-f-060-tcp-007-r001-task-preparation-barrier-plan",
		"tags": {
			"framework": [
				"Task-centered practice"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Problem solving"
			],
			"topic": [
				"Coping",
				"Homework"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Task-Specific Barriers",
				"body": "Barriers are captured for agreed tasks, not as a general life-obstacle inventory."
			},
			{
				"title": "Readiness Without an Invented Scale",
				"body": "The supplied product record does not define a readiness scale, so the tool should use locally supported formats or flexible notes."
			},
			{
				"title": "Task Adjustment",
				"body": "If barrier planning shows the task is unrealistic, the task expectation can be revised rather than finalized unchanged."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool predict whether a task will be completed?",
				"answer": "No. It records preparation for foreseeable barriers and practical responses; it does not predict completion."
			},
			{
				"question": "Does it use a readiness scale?",
				"answer": "Not by default. No readiness scale is supplied in the product specification, so readiness or confidence must be captured in a supported local form."
			},
			{
				"question": "Can the task be changed during preparation?",
				"answer": "Yes. If barriers make the task unrealistic, the task expectation can be revised or marked for task-plan adjustment."
			}
		]
	},
	{
		"toolType": "taskCompletionReview",
		"slug": "task-completion-review",
		"title": "Task Completion Review Demo | Qwoach",
		"metaDescription": "Explore a sendable task-centered review for capturing task follow-through, barriers, supports, changed circumstances, and learning.",
		"h1": "Task Completion Review for Task-Centered Work",
		"intro": "Task Completion Review is a task-centered review tool for practitioners after a client has had time to attempt agreed tasks. It helps capture actual follow-through, barriers, supports, contextual factors, and learning for the next intervention step.",
		"demoTitle": "Preview the client review and inspect the practitioner result.",
		"demoPrompt": "Interested in using Task Completion Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0978-f-060-tcp-008-r001-task-completion-review.md",
		"specId": "0978-f-060-tcp-008-r001-task-completion-review",
		"tags": {
			"framework": [
				"Task-centered practice"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Homework",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client Reporting Role",
				"body": "The client reports what happened. The system organizes the response, and the practitioner uses it for follow-up decisions."
			},
			{
				"title": "Partial Reviews",
				"body": "A partially completed review remains usable, with unanswered task reviews visible rather than hidden."
			},
			{
				"title": "No Compliance Score",
				"body": "The tool distinguishes completed, partially completed, not attempted, changed, or no longer applicable tasks without reducing review to a pass/fail judgment."
			}
		],
		"faqItems": [
			{
				"question": "Can this review be sent to a client?",
				"answer": "Yes. The tool is ready to send and shows the assigned tasks for client task-by-task reporting."
			},
			{
				"question": "Does it score adherence?",
				"answer": "No. It captures descriptive follow-through and learning without unsupported adherence scores or blame judgments."
			},
			{
				"question": "What if circumstances changed?",
				"answer": "The review can distinguish changed circumstances from simple noncompletion so the practitioner can adjust based on real experience."
			}
		]
	},
	{
		"toolType": "problemProgressRating",
		"slug": "problem-progress-rating",
		"title": "Problem Progress Rating Demo | Qwoach",
		"metaDescription": "Explore a task-centered progress rating tool for comparing current and prior ratings on the same target problem over time.",
		"h1": "Problem Progress Rating for Task-Centered Work",
		"intro": "Problem Progress Rating is a task-centered repeated outcome tool for practitioners and clients while work is underway. It helps capture a current, comparable rating of progress on the same target problem over time to support continue, adjust, or redirect discussion.",
		"demoTitle": "Try a sample rating occasion and review comparability with earlier ratings.",
		"demoPrompt": "Interested in using Problem Progress Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0979-f-060-tcp-009-r001-problem-progress-rating.md",
		"specId": "0979-f-060-tcp-009-r001-problem-progress-rating",
		"tags": {
			"framework": [
				"Task-centered practice"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Comparability",
				"body": "Ratings are comparable only when they refer to the same target problem and use the same rating method."
			},
			{
				"title": "Unresolved Scale Details",
				"body": "The supplied product specification does not define a scale, anchors, thresholds, or decision rules. Those must come from a supported implementation context."
			},
			{
				"title": "Decision Support",
				"body": "The tool displays progress information for discussion. It does not decide whether to continue, adjust, or redirect."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include a built-in rating scale?",
				"answer": "No. The product specification does not define a scale or anchors; a rating method must be supplied by the implementation context."
			},
			{
				"question": "Can ratings from different target problems be compared?",
				"answer": "No. The tool centers same-problem comparability, so ratings across unrelated problems are not directly comparable."
			},
			{
				"question": "Does the tool tell the practitioner what decision to make?",
				"answer": "No. It shows current and historical rating information; the practitioner reviews the result with the client and makes the practice decision."
			}
		]
	},
	{
		"toolType": "terminationReview",
		"slug": "termination-review",
		"title": "Termination Review Demo for Task-Centered Practice | Qwoach",
		"metaDescription": "Explore a task-centered closure review for comparing starting problems with current status and recording remaining concerns and next supports.",
		"h1": "Termination Review for Task-Centered Work",
		"intro": "Termination Review is a task-centered closure tool for practitioners ending time-limited work with clients. It helps compare progress from the starting point, identify remaining concerns, and record maintenance needs or next supports.",
		"demoTitle": "Complete a sample closure review and inspect the final summary.",
		"demoPrompt": "Interested in using Termination Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0980-f-060-tcp-010-r001-termination-review.md",
		"specId": "0980-f-060-tcp-010-r001-termination-review",
		"tags": {
			"framework": [
				"Task-centered practice"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Anchored to Original Target Problems",
				"body": "The review compares ending status with the original target problems whenever starting information is available."
			},
			{
				"title": "Remaining Concerns",
				"body": "Unresolved issues can be named realistically without implying failure."
			},
			{
				"title": "Bounded Continuity",
				"body": "Maintenance strategies or next supports are captured, but the tool does not become a full discharge summary or long-term care plan."
			}
		],
		"faqItems": [
			{
				"question": "Does Termination Review require complete progress data?",
				"answer": "No. The review can show available comparison and mark missing starting point or progress information without inventing change."
			},
			{
				"question": "Can client and practitioner perspectives differ?",
				"answer": "Yes. If the client disagrees or is uncertain about progress, that perspective can be preserved as reported information."
			},
			{
				"question": "Is this a discharge summary?",
				"answer": "No. It is a task-centered closure review focused on before-and-after progress, remaining concerns, and maintenance or next supports."
			}
		]
	},
	{
		"toolType": "comprehensiveBiopsychosocialPieAssessment",
		"slug": "comprehensive-biopsychosocial-pie-assessment",
		"title": "Comprehensive Biopsychosocial / PIE Assessment | Qwoach",
		"metaDescription": "Explore a case-management assessment tool for building a person-in-environment profile across needs, strengths, risks, resources, and constraints.",
		"h1": "Comprehensive Biopsychosocial / PIE Assessment",
		"intro": "Comprehensive Biopsychosocial / PIE Assessment is a case-management assessment tool for practitioners beginning or updating work with a client. It helps organize biological, psychological, social, environmental, strengths, needs, risk, resource, and constraint information before planning services.",
		"demoTitle": "Explore a sample assessment",
		"demoPrompt": "Interested in using Comprehensive Biopsychosocial / PIE Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0981-f-061-case-001-r001-comprehensive-biopsychosocial-pie-assessment.md",
		"specId": "0981-f-061-case-001-r001-comprehensive-biopsychosocial-pie-assessment",
		"tags": {
			"framework": [
				"Person-in-Environment"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Environmental barriers",
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at the beginning of case management or when updating a case picture before planning or coordination decisions."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures broad biological, psychological, social, environmental, strengths, needs, risk, resource, and constraint information, with immediate and longer-term need distinctions."
			},
			{
				"title": "Important Boundary",
				"body": "The tool organizes assessment information into a profile. It does not diagnose, score risk, determine eligibility, or generate a service plan."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool produce a diagnosis or score?",
				"answer": "No. It produces a descriptive person-in-environment case profile and omits diagnosis, scoring, ranking, and clinical conclusions."
			},
			{
				"question": "Can the client complete it directly?",
				"answer": "Yes, when the assessment is completed together or shared for direct input, the client can provide plain-language information by broad domain."
			},
			{
				"question": "What happens if the assessment is incomplete?",
				"answer": "Incomplete areas remain visible. Partial assessments can still be reviewed, and missing broad domains are shown descriptively."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The fixed tool is saved into the practitioner's account. Fictional demo case content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "needsPrioritizationMatrix",
		"slug": "needs-prioritization-matrix",
		"title": "Needs Prioritization Matrix for Case Management | Qwoach",
		"metaDescription": "Explore a case-management matrix for ordering client needs by urgency, importance, client preference, and feasibility before next steps.",
		"h1": "Needs Prioritization Matrix",
		"intro": "Needs Prioritization Matrix is a case-management decision-support tool for practitioners working with clients who have multiple needs. It helps compare urgency, importance, client preference, and feasibility so the practitioner can confirm which needs should receive focus first.",
		"demoTitle": "Try the prioritization matrix",
		"demoPrompt": "Interested in using Needs Prioritization Matrix with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0982-f-061-case-002-r001-needs-prioritization-matrix.md",
		"specId": "0982-f-061-case-002-r001-needs-prioritization-matrix",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Problem solving"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when multiple needs compete for attention and the practitioner needs a clear focus for immediate case-management effort."
			},
			{
				"title": "What It Compares",
				"body": "The matrix compares needs using urgency, importance, client preference, and feasibility."
			},
			{
				"title": "Important Boundary",
				"body": "The matrix does not calculate clinical risk, determine eligibility, recommend services, or apply a hidden scoring formula."
			}
		],
		"faqItems": [
			{
				"question": "Does the matrix automatically rank client needs?",
				"answer": "No. It organizes entered factors and supports descriptive ordering, but the practitioner confirms the final priority order."
			},
			{
				"question": "Can urgent or safety-related needs be shown without complete factor data?",
				"answer": "Yes. Urgent or safety-related needs remain visible even when other factor information is incomplete."
			},
			{
				"question": "Can two needs have equal priority?",
				"answer": "Yes. Equal-priority needs are allowed rather than forced into unsupported precision."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed matrix tool is saved. Fictional needs and sample priority decisions are not saved as real client data."
			}
		]
	},
	{
		"toolType": "individualizedServicePlanCarePlan",
		"slug": "individualized-service-plan-care-plan",
		"title": "Individualized Service Plan / Care Plan | Qwoach",
		"metaDescription": "Explore a case-management planning tool that links assessed needs to goals, measurable objectives, agreed actions, responsibilities, and supports.",
		"h1": "Individualized Service Plan / Care Plan",
		"intro": "Individualized Service Plan / Care Plan is a case-management planning tool for practitioners coordinating support over time. It helps link assessed needs and priorities to specific, attainable, measurable objectives, agreed actions, responsibilities, and planned supports.",
		"demoTitle": "Build a sample plan item",
		"demoPrompt": "Interested in using Individualized Service Plan / Care Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0983-f-061-case-003-r001-individualized-service-plan-care-plan.md",
		"specId": "0983-f-061-case-003-r001-individualized-service-plan-care-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after assessment and prioritization indicate that coordinated support over time is needed."
			},
			{
				"title": "What It Organizes",
				"body": "The tool organizes needs or priorities, goals, objectives, agreed actions, responsibilities, and planned supports into one current plan."
			},
			{
				"title": "Important Boundary",
				"body": "The tool supports planning structure and completeness review. It does not generate goals, recommend services, or interpret outcomes."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create service recommendations?",
				"answer": "No. The practitioner enters plan content; the tool organizes links, completeness, and alignment cues."
			},
			{
				"question": "Can clients participate in the plan?",
				"answer": "Yes. When completed together, clients can review proposed goals and actions, contribute preferences or constraints, and confirm understanding where applicable."
			},
			{
				"question": "What happens to incomplete plan items?",
				"answer": "Incomplete items remain visible with unresolved objectives, responsibilities, supports, or alignment cues."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed care plan tool is saved. Fictional sample plan content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "goalObjectiveTracker",
		"slug": "goal-objective-tracker",
		"title": "Goal & Objective Tracker for Case Management | Qwoach",
		"metaDescription": "Explore a case-management tracker for active goals, current status, progress, setbacks, barriers, remaining work, and update history.",
		"h1": "Goal & Objective Tracker",
		"intro": "Goal & Objective Tracker is a longitudinal case-management monitoring tool for practitioners supporting active client goals. It helps show each goal's current status, progress, setbacks, barriers, and remaining work across repeated updates.",
		"demoTitle": "Review sample goal updates",
		"demoPrompt": "Interested in using Goal & Objective Tracker with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0984-f-061-case-004-r001-goal-objective-tracker.md",
		"specId": "0984-f-061-case-004-r001-goal-objective-tracker",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during ongoing case-management work when goals are active and progress needs to be monitored over time."
			},
			{
				"title": "What It Shows",
				"body": "The tracker shows each goal's current status, progress, setbacks, barriers, remaining work, and chronological update history."
			},
			{
				"title": "Important Boundary",
				"body": "The tracker does not set new goals, assign scores, interpret outcomes, or prescribe practice steps."
			}
		],
		"faqItems": [
			{
				"question": "Can clients submit goal updates?",
				"answer": "Yes. The practitioner can send a focused update interaction for existing goals, and client-submitted updates return for practitioner review."
			},
			{
				"question": "Does the tool decide whether a goal succeeded?",
				"answer": "No. It shows status and history; practitioner decisions to continue, revise, or close remain separate from update data."
			},
			{
				"question": "What happens when an update is missed?",
				"answer": "A missed update is shown as absent data, not as lack of progress."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The fixed tracker is saved. Fictional goal histories and sample updates are not saved as real client data."
			}
		]
	},
	{
		"toolType": "referralResourceCoordinationLog",
		"slug": "referral-resource-coordination-log",
		"title": "Referral / Resource Coordination Log | Qwoach",
		"metaDescription": "Explore a practitioner-only case-management log for referral targets, service connection status, barriers, follow-ups, and access history.",
		"h1": "Referral / Resource Coordination Log",
		"intro": "Referral / Resource Coordination Log is a practitioner-only case-management coordination tool for practitioners tracking external services or resources. It helps record which referrals have been pursued, their current status, barriers, and follow-up needs.",
		"demoTitle": "Explore the coordination log",
		"demoPrompt": "Interested in using Referral / Resource Coordination Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0985-f-061-case-005-r001-referral-resource-coordination-log.md",
		"specId": "0985-f-061-case-005-r001-referral-resource-coordination-log",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Clinical documentation",
				"Intervention planning"
			],
			"topic": [
				"Environmental barriers",
				"Case management"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when external services or resources require follow-up, status tracking, or coordination across providers and the client."
			},
			{
				"title": "What It Captures",
				"body": "The log captures service targets, intended resources, current status, barriers, follow-up needs, and update history."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not recommend providers, determine eligibility, schedule appointments, or rate service quality."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client-facing version of this log?",
				"answer": "No. The supplied configuration is practitioner-only."
			},
			{
				"question": "Can a referral target be unknown at first?",
				"answer": "Yes. A needed resource can be captured even when the exact target is not yet known."
			},
			{
				"question": "What happens to closed or unsuccessful connections?",
				"answer": "Closed or unsuccessful connections remain in history so service-access work remains traceable."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed coordination log is saved. Fictional referral entries and sample access history are not saved as real client data."
			}
		]
	},
	{
		"toolType": "serviceProviderCareTeamMap",
		"slug": "service-provider-care-team-map",
		"title": "Service Provider / Care Team Map | Qwoach",
		"metaDescription": "Explore a case-management care team map for providers, informal supports, agencies, roles, responsibilities, contact pathways, and gaps.",
		"h1": "Service Provider / Care Team Map",
		"intro": "Service Provider / Care Team Map is a case-management coordination tool for practitioners working with multiple providers, informal supports, or agencies. It helps map the care network, responsibilities, and communication pathways so gaps and overlaps can be recognized.",
		"demoTitle": "Explore the care team map",
		"demoPrompt": "Interested in using Service Provider / Care Team Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0986-f-061-case-006-r001-service-provider-care-team-map.md",
		"specId": "0986-f-061-case-006-r001-service-provider-care-team-map",
		"tags": {
			"framework": [],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when multiple providers, agencies, or informal supports are involved and coordination depends on understanding each party's role."
			},
			{
				"title": "What It Captures",
				"body": "The map captures parties, roles, responsibilities, contact or communication pathways, gaps, overlaps, and unknown states."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not infer legal status, consent, care quality, authority, provider performance, or automate communication."
			}
		],
		"faqItems": [
			{
				"question": "Can informal supports be included?",
				"answer": "Yes. Informal supports can be included even when formal contact details are incomplete."
			},
			{
				"question": "Does the tool determine whether someone is authorized to receive information?",
				"answer": "No. The tool maps roles and communication pathways entered by the practitioner; it does not infer consent or legal authority."
			},
			{
				"question": "Can one responsibility belong to multiple parties?",
				"answer": "Yes. Shared responsibilities can appear as overlaps, and responsibilities with no party can appear as gaps."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed care team map tool is saved. Fictional network content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "barrierToAccessLog",
		"slug": "barrier-to-access-log",
		"title": "Barrier to Access Log for Case Management | Qwoach",
		"metaDescription": "Explore a case-management log for concrete service access barriers, affected resources, status changes, and unresolved barriers over time.",
		"h1": "Barrier to Access Log",
		"intro": "Barrier to Access Log is a case-management tracking tool for practitioners helping clients access services or resources. It helps identify concrete barriers, link each barrier to the affected service or resource, and track status or change over time.",
		"demoTitle": "Explore sample barriers",
		"demoPrompt": "Interested in using Barrier to Access Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0987-f-061-case-007-r001-barrier-to-access-log.md",
		"specId": "0987-f-061-case-007-r001-barrier-to-access-log",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Intervention planning"
			],
			"topic": [
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when services or resources are not being successfully accessed and concrete obstacles need to be tracked over time."
			},
			{
				"title": "What It Captures",
				"body": "The log captures barriers, affected services or resources, current status, updates, changes, and unresolved barrier visibility."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not determine blame, eligibility, legal conclusions, or prescribed advocacy steps."
			}
		],
		"faqItems": [
			{
				"question": "Can clients report barriers directly?",
				"answer": "Yes. The practitioner can send a focused reporting interaction, and the client's reported content returns for practitioner review."
			},
			{
				"question": "Can one barrier affect multiple resources?",
				"answer": "Yes. One barrier may affect multiple services or resources, and one resource may have multiple barriers."
			},
			{
				"question": "Does the tool tell the practitioner what advocacy step to take?",
				"answer": "No. It makes barriers and changes visible so practical advocacy, accommodation, or coordination can be planned by the practitioner."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed barrier log tool is saved. Fictional barriers and sample client reports are not saved as real client data."
			}
		]
	},
	{
		"toolType": "contactCaseNoteLog",
		"slug": "contact-case-note-log",
		"title": "Contact / Case Note Log for Case Management | Qwoach",
		"metaDescription": "Explore a practitioner-only chronological case note log for contacts, decisions, updates, interventions, follow-ups, and recent history.",
		"h1": "Contact / Case Note Log",
		"intro": "Contact / Case Note Log is a practitioner-only longitudinal case record for case-management practitioners. It helps record contacts, decisions, client updates, interventions, and follow-up needs so the case history remains traceable.",
		"demoTitle": "Explore the note log",
		"demoPrompt": "Interested in using Contact / Case Note Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0988-f-061-case-008-r001-contact-case-note-log.md",
		"specId": "0988-f-061-case-008-r001-contact-case-note-log",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Clinical documentation"
			],
			"topic": [
				"Case management"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after meaningful contacts, case events, decisions, updates, interventions, or follow-up commitments."
			},
			{
				"title": "What It Captures",
				"body": "The log captures chronological note entries, decisions, client updates documented by the practitioner, interventions, follow-up needs, and draft or completed status."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not provide billing codes, compliance conclusions, legal attestations, messaging, or automatic clinical interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client-facing note tool?",
				"answer": "No. The supplied configuration is practitioner-only."
			},
			{
				"question": "Can notes be saved as drafts?",
				"answer": "Yes. Interrupted note writing should preserve a draft state, and completed notes remain chronologically stable."
			},
			{
				"question": "How are follow-ups handled?",
				"answer": "Follow-up commitments remain visible until resolved or superseded."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed note log tool is saved. Fictional notes and sample follow-ups are not saved as real client data."
			}
		]
	},
	{
		"toolType": "reassessment",
		"slug": "reassessment",
		"title": "Reassessment Tool for Case Management | Qwoach",
		"metaDescription": "Explore a case-management reassessment tool for comparing current client status with a prior baseline and reviewing before/after changes.",
		"h1": "Reassessment",
		"intro": "Reassessment is a case-management before-and-after assessment tool for practitioners evaluating change after support has been provided. It helps compare current needs, strengths, risks, and progress with an earlier case picture to inform plan adjustment or evaluation.",
		"demoTitle": "Compare a sample reassessment",
		"demoPrompt": "Interested in using Reassessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0989-f-061-case-009-r001-reassessment.md",
		"specId": "0989-f-061-case-009-r001-reassessment",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after case-management support has been provided and the practitioner needs to understand change since an earlier assessment."
			},
			{
				"title": "Required Baseline",
				"body": "A prior baseline is required for a true reassessment. Without one, the practitioner should create an assessment first."
			},
			{
				"title": "Important Boundary",
				"body": "The tool compares prior and current information descriptively. It does not score outcomes, infer causes, or decide the plan."
			}
		],
		"faqItems": [
			{
				"question": "Does reassessment require a prior assessment?",
				"answer": "Yes. A true reassessment requires a prior baseline or earlier case picture for comparison."
			},
			{
				"question": "Can the baseline be changed?",
				"answer": "Yes, baseline selection is a real setting, and changing it changes the comparison result and should be explicit."
			},
			{
				"question": "Does the tool decide whether the plan should change?",
				"answer": "No. It shows before/after comparison information that supports a practitioner decision."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The reassessment tool is saved, along with intentional reusable baseline-setting configuration if applicable. Fictional reassessment content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "transitionDischargePlan",
		"slug": "transition-discharge-plan",
		"title": "Transition / Discharge Plan for Case Management | Qwoach",
		"metaDescription": "Explore a continuity planning tool for closure, discharge, or transfer with supports, responsible parties, follow-up paths, and client understanding.",
		"h1": "Transition / Discharge Plan",
		"intro": "Transition / Discharge Plan is a case-management continuity planning tool for practitioners preparing for closure, discharge, or transfer. It helps identify post-transition supports, responsible parties, remaining needs or risks, follow-up paths, and whether the client understands what to do if problems arise.",
		"demoTitle": "Explore a sample continuity plan",
		"demoPrompt": "Interested in using Transition / Discharge Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0990-f-061-case-010-r001-transition-discharge-plan.md",
		"specId": "0990-f-061-case-010-r001-transition-discharge-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when active case-management involvement is ending, reducing, or transferring and ongoing needs or supports remain relevant."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures transition type, remaining needs or risks, goal-status context, post-transition supports, responsible parties, follow-up paths, and client understanding."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not determine discharge readiness, create legal forms, prescribe crisis protocols, or decide whether closure or transfer is allowed."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool support closure, discharge, and transfer?",
				"answer": "Yes. Transition type is a real setting, and the practitioner selects closure, discharge, or transfer."
			},
			{
				"question": "Is there a client-facing experience?",
				"answer": "Yes. The client view shows supports, responsible people, follow-up paths, and what to do if foreseeable problems arise in plain language."
			},
			{
				"question": "Does the tool decide whether a client is ready for discharge?",
				"answer": "No. It organizes continuity planning information and does not make automatic readiness or eligibility decisions."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and intentional transition-type configuration are saved. Fictional continuity plan content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "childTraumaScreenCts",
		"slug": "child-trauma-screen-cts",
		"title": "Child Trauma Screen CTS demo for child-serving practitioners | Qwoach",
		"metaDescription": "Explore the Child Trauma Screen CTS for child trauma exposure and PTSD symptom screening, with sample scoring and referral-threshold review.",
		"h1": "Child Trauma Screen (CTS)",
		"intro": "Child Trauma Screen (CTS) is a brief child and adolescent trauma screening tool for child-serving practitioners. It helps clinicians, intake staff, child welfare workers, school personnel, and other providers capture child or caregiver responses about trauma exposure and PTSD-related reactions so they can decide whether fuller assessment, referral, or additional support may be warranted.",
		"demoTitle": "Try a sample CTS administration",
		"demoPrompt": "Interested in using Child Trauma Screen (CTS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0991-f-062-tisw-001-r001-child-trauma-screen-cts.md",
		"specId": "0991-f-062-tisw-001-r001-child-trauma-screen-cts",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Risk review"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "CTS is used in child-serving settings when a practitioner needs a brief trauma exposure and PTSD-related reaction risk signal before deciding whether fuller trauma-focused assessment, treatment referral, or additional support is warranted."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures child or caregiver responses to trauma exposure and PTSD symptom items, then displays exposure signal, reaction/PTSD symptom score, respondent/source, completion status, and cutoff/referral status."
			},
			{
				"title": "Important Limits",
				"body": "CTS is a screening tool. It does not produce a diagnosis, full trauma assessment, treatment plan, trauma narrative, or unsupported severity label."
			}
		],
		"faqItems": [
			{
				"question": "Is the Child Trauma Screen a diagnostic assessment?",
				"answer": "No. The CTS is a brief trauma exposure and PTSD symptom screen that supports triage toward fuller assessment, referral, or additional support when indicated."
			},
			{
				"question": "Can both child and caregiver responses be represented?",
				"answer": "Yes. The product supports child/adolescent and caregiver report forms where appropriate, and results keep respondent/source visible rather than merging sources automatically."
			},
			{
				"question": "What happens if items are missing?",
				"answer": "Missing required responses produce an incomplete state. Incomplete screens are not presented as final threshold determinations unless CTS scoring rules support scoring with missing items."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The CTS tool and selected reusable setup are saved. Fictional responses, sample scores, and temporary demo notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "uclaBriefScreenForChildAdolescentTraumaAndPtsd",
		"slug": "ucla-brief-screen-for-child-adolescent-trauma-and-ptsd",
		"title": "UCLA Brief Screen demo for child trauma and PTSD screening | Qwoach",
		"metaDescription": "Explore the UCLA Brief Screen for child and adolescent trauma/PTSD screening, with sample response flow and positive-screen review.",
		"h1": "UCLA Brief Screen for Child/Adolescent Trauma and PTSD",
		"intro": "UCLA Brief Screen for Child/Adolescent Trauma and PTSD is a brief screening tool for child-serving providers. It helps behavioral health, pediatric, school, child welfare, juvenile justice, disaster recovery, and related providers collect trauma exposure and recent PTSD symptom responses so they can decide whether fuller trauma assessment and treatment consideration are warranted.",
		"demoTitle": "Try a sample brief screen",
		"demoPrompt": "Interested in using UCLA Brief Screen for Child/Adolescent Trauma and PTSD with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0992-f-062-tisw-001-r002-ucla-brief-screen-for-child-adolescent-trauma-and-ptsd.md",
		"specId": "0992-f-062-tisw-001-r002-ucla-brief-screen-for-child-adolescent-trauma-and-ptsd",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Risk review"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "This brief screen is used before deciding whether a child or adolescent needs the full UCLA PTSD Reaction Index or another comprehensive trauma/PTSD assessment."
			},
			{
				"title": "What It Shows",
				"body": "The review shows trauma exposure status, recent PTSD symptom risk, score or positive-screen signal, completion status, source, and fuller-assessment indication."
			},
			{
				"title": "Important Limits",
				"body": "The tool is an initial screen. It does not include the full UCLA PTSD Reaction Index, diagnosis, treatment selection, or unsupported subscales."
			}
		],
		"faqItems": [
			{
				"question": "Is this the full UCLA PTSD Reaction Index?",
				"answer": "No. This is the UCLA Brief Screen, an initial screen that may indicate whether fuller trauma/PTSD assessment is warranted."
			},
			{
				"question": "Can a caregiver complete it?",
				"answer": "Only where a supported caregiver adaptation allows it. Unsupported respondent adaptations should not be offered."
			},
			{
				"question": "Does a positive screen mean the youth has PTSD?",
				"answer": "No. A positive or concerning screen indicates that fuller assessment and treatment consideration may be appropriate."
			},
			{
				"question": "What carries over when I save from the demo?",
				"answer": "The tool and selected reusable setup carry over. Fictional responses and sample results do not become real client data."
			}
		]
	},
	{
		"toolType": "primaryCarePtsdScreenForDsm5PcPtsd5",
		"slug": "primary-care-ptsd-screen-for-dsm-5-pc-ptsd-5",
		"title": "PC-PTSD-5 demo for brief adult PTSD screening | Qwoach",
		"metaDescription": "Explore the PC-PTSD-5 adult PTSD screen with trauma gate, five yes/no symptom items, 0-5 score, and cut-point review.",
		"h1": "Primary Care PTSD Screen for DSM-5 (PC-PTSD-5)",
		"intro": "Primary Care PTSD Screen for DSM-5 (PC-PTSD-5) is a very brief adult PTSD screening tool for health, behavioral health, social-service, primary care, and intake practitioners. It helps practitioners determine whether an adult who endorses trauma exposure shows probable PTSD risk so they can decide whether further assessment, referral, or support planning is needed.",
		"demoTitle": "Try a sample PC-PTSD-5 screen",
		"demoPrompt": "Interested in using Primary Care PTSD Screen for DSM-5 (PC-PTSD-5) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0993-f-062-tisw-001-r003-primary-care-ptsd-screen-for-dsm-5-pc-ptsd-5.md",
		"specId": "0993-f-062-tisw-001-r003-primary-care-ptsd-screen-for-dsm-5-pc-ptsd-5",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Risk review"
			],
			"topic": [
				"Trauma"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Gate-First Interpretation",
				"body": "The trauma exposure gate controls whether the five symptom responses are interpreted as probable PTSD risk."
			},
			{
				"title": "What the Score Means",
				"body": "The score is the count of endorsed symptom items from 0 to 5 and is interpreted against the active cut point shown in the result."
			},
			{
				"title": "Important Limits",
				"body": "PC-PTSD-5 is not a diagnosis, structured interview, full trauma history, treatment plan, or general mental health assessment."
			}
		],
		"faqItems": [
			{
				"question": "Does PC-PTSD-5 diagnose PTSD?",
				"answer": "No. PC-PTSD-5 identifies probable PTSD risk and positive screens require further assessment rather than diagnosis."
			},
			{
				"question": "What happens if the trauma gate is not endorsed?",
				"answer": "Symptom risk is not interpreted as probable PTSD risk when the trauma exposure gate is not endorsed."
			},
			{
				"question": "Can the cut point be changed?",
				"answer": "Only if source-supported guidance permits valid contextual cut-point selection. Otherwise the cut point is fixed for the tool."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The PC-PTSD-5 tool and supported reusable settings are saved. Fictional responses, scores, and demo notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "traumaInformedMentalHealthAssessment",
		"slug": "trauma-informed-mental-health-assessment",
		"title": "Trauma-informed mental health assessment demo | Qwoach",
		"metaDescription": "Explore a practitioner-only trauma-informed mental health assessment workspace for organizing multidomain formulation and care directions.",
		"h1": "Trauma-Informed Mental Health Assessment",
		"intro": "Trauma-Informed Mental Health Assessment is a practitioner-facing formulation tool for mental health evaluation in a trauma-informed context. It helps practitioners organize information about symptoms, functioning, trauma-related influences, risks, strengths, coping resources, support needs, and care directions so planning and coordination can avoid trauma-insensitive responses.",
		"demoTitle": "Explore a sample formulation workspace",
		"demoPrompt": "Interested in using Trauma-Informed Mental Health Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0994-f-062-tisw-002-r001-trauma-informed-mental-health-assessment.md",
		"specId": "0994-f-062-tisw-002-r001-trauma-informed-mental-health-assessment",
		"tags": {
			"framework": [],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Strengths",
				"Mental health conditions"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The supplied product specification does not define a client-facing experience. Client information may be represented only when gathered by the practitioner through ordinary assessment."
			},
			{
				"title": "What the Tool Organizes",
				"body": "The formulation can represent current presentation, trauma-related influences, strengths and coping resources, risks, support needs, and service or treatment directions entered by the practitioner."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create standardized scores, diagnoses, unsupported domain labels, risk stratification, or automated clinical interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client form for this assessment?",
				"answer": "No. The supplied configuration is practitioner-only, so the public demo does not include a client-facing form."
			},
			{
				"question": "Does the tool generate a diagnosis?",
				"answer": "No. The tool organizes practitioner-entered assessment information into a trauma-informed formulation and does not create diagnostic conclusions."
			},
			{
				"question": "Are the exact assessment prompts defined?",
				"answer": "No. Exact prompts, domains, required fields, and completion rules must be defined by source materials or practitioner governance before implementation."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The assessment tool itself is saved. Fictional formulation content and sample client information are not saved as real client data."
			}
		]
	},
	{
		"toolType": "physicalPsychologicalSafetyCheck",
		"slug": "physical-psychological-safety-check",
		"title": "Physical and psychological safety check demo | Qwoach",
		"metaDescription": "Explore a ready-to-send trauma-informed safety check for current physical and psychological safety concerns and changes.",
		"h1": "Physical & Psychological Safety Check",
		"intro": "Physical & Psychological Safety Check is a brief trauma-informed service check for practitioners. It helps practitioners understand whether a client currently feels physically or psychologically unsafe, or whether safety has changed, so services can be adapted to protect safety and reduce harm during care.",
		"demoTitle": "Try a sample safety check",
		"demoPrompt": "Interested in using Physical & Psychological Safety Check with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0995-f-062-tisw-003-r001-physical-psychological-safety-check.md",
		"specId": "0995-f-062-tisw-003-r001-physical-psychological-safety-check",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Risk review"
			],
			"topic": [
				"Crisis response"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The check captures current physical safety concerns, psychological or emotional safety concerns, and changes in safety status at the supported level of detail."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated checks can be shown chronologically so practitioners can see changes over time without converting them into unsupported risk scores."
			},
			{
				"title": "Important Limits",
				"body": "This is a safety-status check, not a full safety plan, risk assessment, legal determination, or automated escalation workflow."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide whether someone is in danger?",
				"answer": "No. It displays reported safety concerns and changes for practitioner review without automated danger classification."
			},
			{
				"question": "Can clients report no concerns?",
				"answer": "Yes. No concern is represented distinctly from a missing or unanswered safety area."
			},
			{
				"question": "Does the tool include an emergency protocol?",
				"answer": "No. Escalation steps can be documented by the practitioner only as entered; the product does not invent emergency protocols."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The safety check tool itself is saved. Fictional safety responses and sample history are not saved as real client data."
			}
		]
	},
	{
		"toolType": "trustTransparencyCheck",
		"slug": "trust-transparency-check",
		"title": "Trust and transparency feedback check demo | Qwoach",
		"metaDescription": "Explore a trauma-informed service-process feedback check for clarity, predictability, trust, mistrust, and practitioner follow-up.",
		"h1": "Trust & Transparency Check",
		"intro": "Trust & Transparency Check is a trauma-informed service-process feedback tool for practitioners. It helps practitioners understand where a client experiences clarity, confusion, trust, or mistrust in the service process so communication and process changes can make care more trustworthy and transparent.",
		"demoTitle": "Try a sample feedback check",
		"demoPrompt": "Interested in using Trust & Transparency Check with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0996-f-062-tisw-004-r001-trust-transparency-check.md",
		"specId": "0996-f-062-tisw-004-r001-trust-transparency-check",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Service satisfaction"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the check when service-process trust and transparency need feedback, especially when clarity, predictability, or communication may affect engagement."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures what the client says is working and what is undermining trust, with specific concerns around service process where supported."
			},
			{
				"title": "Important Limits",
				"body": "This is not a general satisfaction survey, therapeutic alliance scale, complaint system, staff rating, or automated engagement-risk tool."
			}
		],
		"faqItems": [
			{
				"question": "Is this a satisfaction survey?",
				"answer": "No. It is focused on trustworthiness, transparency, clarity, predictability, and service-process feedback."
			},
			{
				"question": "Does the tool score trust?",
				"answer": "No. The supplied product does not define scoring, so the result uses descriptive organization only."
			},
			{
				"question": "Can clients give positive feedback?",
				"answer": "Yes. The tool should distinguish what is working from what is undermining trust."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself is saved. Fictional feedback and sample practitioner actions are not saved as real client data."
			}
		]
	},
	{
		"toolType": "voiceChoicePreferences",
		"slug": "voice-choice-preferences",
		"title": "Voice and choice preferences tool demo | Qwoach",
		"metaDescription": "Explore a collaborative trauma-informed preference tool for participation, communication, boundaries, choices, and service involvement.",
		"h1": "Voice & Choice Preferences",
		"intro": "Voice & Choice Preferences is a trauma-informed service preference tool for practitioners and clients to complete together. It helps practitioners know a client's explicit preferences for participation, communication, choices, boundaries, and service involvement so support can preserve client voice and choice.",
		"demoTitle": "Explore a sample preference summary",
		"demoPrompt": "Interested in using Voice & Choice Preferences with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0997-f-062-tisw-005-r001-voice-choice-preferences.md",
		"specId": "0997-f-062-tisw-005-r001-voice-choice-preferences",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Service preferences"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Client Roles",
				"body": "The client supplies preferences and boundaries; the practitioner records, confirms, and uses the agreed approach in service delivery."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures preferences for participation, communication, choices, boundaries, service involvement, unresolved areas, and dated revisions."
			},
			{
				"title": "Important Limits",
				"body": "The tool is not a treatment plan, consent form, values inventory, or inferred personality profile."
			}
		],
		"faqItems": [
			{
				"question": "Is this completed by the practitioner alone?",
				"answer": "No. The intended usage mode is ready-to-complete-together with the client."
			},
			{
				"question": "Can a client defer a preference?",
				"answer": "Yes. Deferred or unknown areas should remain visible rather than being filled by practitioner assumption."
			},
			{
				"question": "Does the tool rank or score preferences?",
				"answer": "No. The product organizes explicit preferences and changes over time without scoring or ranking them."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself is saved. Fictional preferences, boundaries, and demo revisions are not saved as real client data."
			}
		]
	},
	{
		"toolType": "traumaTriggerReTraumatizationRiskMap",
		"slug": "trauma-trigger-re-traumatization-risk-map",
		"title": "Trauma trigger and re-traumatization risk map demo | Qwoach",
		"metaDescription": "Explore a collaborative trauma trigger map that links service-context risks, distress signals, and protective adjustments.",
		"h1": "Trauma Trigger / Re-traumatization Risk Map",
		"intro": "Trauma Trigger / Re-traumatization Risk Map is a trauma-informed risk mapping tool for practitioners and trauma-affected clients to complete together. It helps practitioners understand likely triggers, re-traumatization risks, distress signals, and protective adjustments in the service context so support can reduce avoidable harm.",
		"demoTitle": "Explore a sample risk map",
		"demoPrompt": "Interested in using Trauma Trigger / Re-traumatization Risk Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0998-f-062-tisw-006-r001-trauma-trigger-re-traumatization-risk-map.md",
		"specId": "0998-f-062-tisw-006-r001-trauma-trigger-re-traumatization-risk-map",
		"tags": {
			"framework": [],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Maps",
				"body": "The map links likely triggers or high-risk service situations to distress signals or risk patterns and protective adjustments."
			},
			{
				"title": "Client Control Over Detail",
				"body": "The client can name broad situations or patterns without being required to disclose detailed trauma narrative."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create severity scores, diagnostic conclusions, exposure hierarchies, treatment exercises, or automated risk rankings."
			}
		],
		"faqItems": [
			{
				"question": "Does the map require detailed trauma disclosure?",
				"answer": "No. The map can use broad situations, interaction patterns, environments, or signals at a tolerable level of detail."
			},
			{
				"question": "Can practitioner observations be included?",
				"answer": "Yes. Practitioner-observed patterns can be included when labeled separately from client-stated risks."
			},
			{
				"question": "Does the tool rank risk severity?",
				"answer": "No. The result organizes links and status without severity scoring or automated ranking."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and supported state behavior are saved. Fictional risks, adjustments, and demo history are not saved as real client data."
			}
		]
	},
	{
		"toolType": "groundingRegulationPreferencesPlan",
		"slug": "grounding-regulation-preferences-plan",
		"title": "Grounding and regulation preferences plan demo | Qwoach",
		"metaDescription": "Explore a trauma-informed regulation preference plan for helpful, acceptable, available, unwanted, and worsening supports.",
		"h1": "Grounding / Regulation Preferences Plan",
		"intro": "Grounding / Regulation Preferences Plan is a trauma-informed personalized support planning tool for practitioners and clients. It helps practitioners know which grounding and regulation supports are acceptable, useful, available, or unwanted for a trauma-affected client so support during distress can fit the client's needs, tolerances, and context.",
		"demoTitle": "Try a sample regulation plan",
		"demoPrompt": "Interested in using Grounding / Regulation Preferences Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/0999-f-062-tisw-007-r001-grounding-regulation-preferences-plan.md",
		"specId": "0999-f-062-tisw-007-r001-grounding-regulation-preferences-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation",
				"Coping",
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures preferred, acceptable, available, unwanted, and potentially worsening supports, plus context and availability notes."
			},
			{
				"title": "Use During Distress",
				"body": "The review is designed to make concrete usable items easy to scan when a client is distressed or when support planning is happening."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide a technique library, automated coping recommendations, distress scores, treatment homework steps, or claims of effectiveness."
			}
		],
		"faqItems": [
			{
				"question": "Does the plan teach grounding exercises?",
				"answer": "No. It captures client preferences about supports but does not invent or teach grounding techniques."
			},
			{
				"question": "Can a client say they do not know what helps?",
				"answer": "Yes. Unknown areas should remain visible rather than being filled by practitioner assumption."
			},
			{
				"question": "Can a support be helpful in one context and unwanted in another?",
				"answer": "Yes. Context notes should preserve when a support is acceptable, available, unwanted, or potentially worsening."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The plan tool itself is saved. Fictional support preferences and sample notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "collaborativeSafetyPlan",
		"slug": "collaborative-safety-plan",
		"title": "Collaborative trauma-informed safety plan demo | Qwoach",
		"metaDescription": "Explore a trauma-informed collaborative safety plan for warning signs, coping steps, supports, next steps, and revisions.",
		"h1": "Collaborative Safety Plan",
		"intro": "Collaborative Safety Plan is a trauma-informed safety planning tool for practitioners and clients to complete together. It helps them share a clear, client-informed direction for recognizing warning signs or safety risks, using coping steps and supports, and taking next steps during unsafe moments while preserving collaboration and client empowerment.",
		"demoTitle": "Explore a sample safety plan",
		"demoPrompt": "Interested in using Collaborative Safety Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1000-f-062-tisw-008-r001-collaborative-safety-plan.md",
		"specId": "1000-f-062-tisw-008-r001-collaborative-safety-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Crisis response",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Includes",
				"body": "The plan includes warning signs or safety risks, client-preferred coping steps, supports, and next steps during unsafe moments as entered."
			},
			{
				"title": "Draft And Current Plan",
				"body": "Draft plans remain distinct from confirmed current plans, and prior versions remain available when the plan changes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not invent a specific safety-planning model, mandated step sequence, emergency protocol, automated risk score, or legal determination."
			}
		],
		"faqItems": [
			{
				"question": "Is this plan completed collaboratively?",
				"answer": "Yes. The intended workflow is practitioner and client completing the plan together and confirming shared safety direction."
			},
			{
				"question": "Does the tool decide when emergency action is required?",
				"answer": "No. It organizes entered plan content and does not automate emergency decisions or risk levels."
			},
			{
				"question": "Can a plan be saved as a draft?",
				"answer": "Yes. Draft and unresolved areas should remain visible and should not be presented as a complete confirmed plan."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The safety plan tool itself is saved. Fictional plan content and demo versions are not saved as real client data."
			}
		]
	},
	{
		"toolType": "traumaInformedServiceReview",
		"slug": "trauma-informed-service-review",
		"title": "Trauma-Informed Service Review Demo | Qwoach",
		"metaDescription": "Review service-setting strengths, gaps, and improvement priorities across trauma-informed principles before saving the tool.",
		"h1": "Trauma-Informed Service Review",
		"intro": "The Trauma-Informed Service Review is a practitioner-only service quality review for practitioners and service leads. It helps them organize observed service practices into trauma-informed strengths, gaps, and improvement priorities across a service setting.",
		"demoTitle": "Explore a sample review",
		"demoPrompt": "Interested in using Trauma-Informed Service Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1001-f-062-tisw-009-r001-trauma-informed-service-review.md",
		"specId": "1001-f-062-tisw-009-r001-trauma-informed-service-review",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Trauma"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the review during service-quality work when a team needs to understand how current practices support or undermine trauma-informed principles."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures observed strengths, observed gaps, insufficient-evidence states, and selected improvement priorities by principle."
			},
			{
				"title": "Important Boundary",
				"body": "The review is about service-setting implementation. It does not assess an individual client, diagnose trauma impact, assign blame, or produce implementation scores."
			}
		],
		"faqItems": [
			{
				"question": "Is this completed by clients?",
				"answer": "No. This is a practitioner-only service review. Clients are intended beneficiaries of service improvement, but they do not complete a form in this product configuration."
			},
			{
				"question": "Does the tool score trauma-informed care?",
				"answer": "No. The result is descriptive. It shows strengths, gaps, incomplete areas, and selected priorities without scores, maturity levels, or compliance labels."
			},
			{
				"question": "Can a review focus on only some principles?",
				"answer": "Yes. Principle inclusion can be changed when a focused review legitimately covers a subset, and that configuration affects the review matrix and later comparison."
			},
			{
				"question": "What happens to unfinished principles?",
				"answer": "Unfinished principles remain visible as incomplete. They are not treated as having no gaps."
			}
		]
	},
	{
		"toolType": "reTraumatizationIncidentReview",
		"slug": "re-traumatization-incident-review",
		"title": "Re-traumatization Incident Review Demo | Qwoach",
		"metaDescription": "Review possible retraumatization incidents by organizing contributors, system factors, individual actions, and safety lessons.",
		"h1": "Re-traumatization Incident Review",
		"intro": "The Re-traumatization Incident Review is a practitioner-only safety and quality learning review for practitioners and service reviewers. It helps them organize what happened, separate possible individual and workflow factors, and document safety lessons for future service encounters.",
		"demoTitle": "Explore a sample incident review",
		"demoPrompt": "Interested in using Re-traumatization Incident Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1002-f-062-tisw-010-r001-re-traumatization-incident-review.md",
		"specId": "1002-f-062-tisw-010-r001-re-traumatization-incident-review",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Crisis response"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this review after a specific service episode when the goal is learning and prevention rather than assigning blame."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures event context, possible contributing factors, factor classification, and safety lessons."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not determine intent, assign liability, generate severity ratings, or make clinical conclusions about trauma impact."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide who is at fault?",
				"answer": "No. The review is learning-oriented. It separates possible contributors and safety lessons without producing blame labels or culpability rankings."
			},
			{
				"question": "Can uncertain information be recorded?",
				"answer": "Yes. Entries can be described as possible contributors, and unknowns can remain visible without forcing unsupported conclusions."
			},
			{
				"question": "Is there a client form?",
				"answer": "No. There is no separate client task. If client perspective is available elsewhere, it can be recorded as reported information."
			},
			{
				"question": "Are completed reviews useful later?",
				"answer": "Yes. Completed reviews persist as learning snapshots for future quality-improvement reference."
			}
		]
	},
	{
		"toolType": "recoverySelfAssessmentRsa",
		"slug": "recovery-self-assessment-rsa",
		"title": "Recovery Self-Assessment Demo | Qwoach",
		"metaDescription": "Preview RSA assessment-cycle setup, stakeholder versions, completion tracking, and recovery-orientation profile review.",
		"h1": "Recovery Self-Assessment (RSA)",
		"intro": "The Recovery Self-Assessment is a ready-to-send assessment for practitioners, evaluators, and program improvement leads. It helps them collect stakeholder responses to RSA versions and review a multidimensional profile of a service or program's recovery orientation.",
		"demoTitle": "Preview an RSA assessment cycle",
		"demoPrompt": "Interested in using Recovery Self-Assessment (RSA) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1003-f-063-rec-001-r001-recovery-self-assessment-rsa.md",
		"specId": "1003-f-063-rec-001-r001-recovery-self-assessment-rsa",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures stakeholder responses to assigned RSA versions and turns completed responses into a recovery-orientation profile according to the resolved RSA structure."
			},
			{
				"title": "Stakeholder Perspectives",
				"body": "The review keeps stakeholder groups distinct where their versions or perspectives differ, and shows participation status so uneven response patterns are not mistaken for consensus."
			},
			{
				"title": "Implementation Boundary",
				"body": "The product must use the resolved RSA items, response options, domain structure, and scoring rules. The demo must not invent those elements."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo show all 36 RSA items?",
				"answer": "No. The supplied specification does not include exact item text, response options, domains, or scoring rules, so the public demo cannot display invented RSA items."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews completion status, stakeholder-perspective views, and a multidimensional recovery-orientation profile based on the resolved RSA structure."
			},
			{
				"question": "Are stakeholder versions merged together?",
				"answer": "No. Responses from different stakeholder versions must remain distinct unless the resolved RSA structure supports aggregation."
			},
			{
				"question": "Can RSA cycles be compared over time?",
				"answer": "Yes. Completed assessment cycles can be compared descriptively when the RSA structure and stakeholder mix support comparison."
			}
		]
	},
	{
		"toolType": "personalRecoveryPlan",
		"slug": "personal-recovery-plan",
		"title": "Personal Recovery Plan Demo | Qwoach",
		"metaDescription": "Create person-centered recovery goals, actions, supports, and revisions with a collaborative Personal Recovery Plan.",
		"h1": "Personal Recovery Plan",
		"intro": "The Personal Recovery Plan is a collaborative care planning tool for practitioners and people receiving mental health support. It helps them create recovery goals, actions, and supports that reflect the person's own priorities and can be revised as circumstances change.",
		"demoTitle": "Explore a sample recovery plan",
		"demoPrompt": "Interested in using Personal Recovery Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1004-f-063-rec-002-r001-personal-recovery-plan.md",
		"specId": "1004-f-063-rec-002-r001-personal-recovery-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner and Client Roles",
				"body": "The person supplies priorities and goals. The practitioner supports planning, feasibility, and connection to supports while keeping practitioner notes separate."
			},
			{
				"title": "Repeat Use",
				"body": "The plan can be revisited as circumstances change, with prior versions preserved for continuity."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not a generic treatment plan builder, symptom tracker, or risk plan. It does not invent goals, required domains, scores, or clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Can the client complete the plan themselves?",
				"answer": "Yes. The practitioner can send it for client completion or complete it together, depending on care context."
			},
			{
				"question": "Does the tool create goals for the person?",
				"answer": "No. Goals come from the person's own priorities and wording. The system organizes them and flags missing actions or supports."
			},
			{
				"question": "What gets reviewed by the practitioner?",
				"answer": "The practitioner reviews goals, actions, supports or strategies, completeness cues, practitioner notes, and revision history."
			},
			{
				"question": "Can the plan change later?",
				"answer": "Yes. The plan supports revision while preserving earlier versions used for care coordination."
			}
		]
	},
	{
		"toolType": "recoveryGoalInventory",
		"slug": "recovery-goal-inventory",
		"title": "Recovery Goal Inventory Demo | Qwoach",
		"metaDescription": "Capture client-stated recovery priorities, optional life-area context, and priority distinctions before service planning.",
		"h1": "Recovery Goal Inventory",
		"intro": "The Recovery Goal Inventory is a ready-to-send profiling tool for practitioners. It helps them collect a client's own recovery priorities, distinguish more important or immediate areas, and use that profile to inform service planning.",
		"demoTitle": "Explore a sample priority profile",
		"demoPrompt": "Interested in using Recovery Goal Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1005-f-063-rec-003-r001-recovery-goal-inventory.md",
		"specId": "1005-f-063-rec-003-r001-recovery-goal-inventory",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the inventory when support planning needs to begin from outcomes the client personally values rather than service-defined targets."
			},
			{
				"title": "What It Captures",
				"body": "It captures client-stated priorities, optional life-area context, and client-indicated importance or immediacy."
			},
			{
				"title": "Natural Continuation",
				"body": "High-priority outcomes can inform a Personal Recovery Plan or another service planning conversation."
			}
		],
		"faqItems": [
			{
				"question": "Is this a full recovery plan?",
				"answer": "No. It is an inventory of priorities. Detailed actions belong in a separate recovery plan."
			},
			{
				"question": "Does the client have to choose a life area?",
				"answer": "No. Life-area prompts are optional, and the client can leave an item uncategorized if no domain fits."
			},
			{
				"question": "Can priorities be unranked?",
				"answer": "Yes. If no clear priority order is provided, the result can show unranked priorities rather than forcing a false ranking."
			},
			{
				"question": "Can priorities be revisited?",
				"answer": "Yes. The inventory can be revisited, and prior snapshots can show how stated priorities changed over time."
			}
		]
	},
	{
		"toolType": "strengthsAndResourcesProfile",
		"slug": "strengths-and-resources-profile",
		"title": "Strengths and Resources Profile Demo | Qwoach",
		"metaDescription": "Map client-meaningful strengths, available resources, optional resource types, and links to recovery goals.",
		"h1": "Strengths and Resources Profile",
		"intro": "The Strengths and Resources Profile is a collaborative recovery-oriented tool for practitioners and clients. It helps them identify personal strengths, available resources, and optional links to recovery goals or next steps.",
		"demoTitle": "Explore a sample strengths profile",
		"demoPrompt": "Interested in using Strengths and Resources Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1006-f-063-rec-004-r001-strengths-and-resources-profile.md",
		"specId": "1006-f-063-rec-004-r001-strengths-and-resources-profile",
		"tags": {
			"framework": [],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The profile captures personal strengths, available resources, resource type distinctions where used, and links to recovery goals or next steps."
			},
			{
				"title": "Practitioner and Client Roles",
				"body": "The client provides lived knowledge of strengths and resources. The practitioner supports organization and planning connections."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not a deficit assessment, service eligibility screen, capability rating, or generic directory."
			}
		],
		"faqItems": [
			{
				"question": "Can resources be left uncategorized?",
				"answer": "Yes. If the type is unclear, a resource can remain uncategorized rather than forcing a category."
			},
			{
				"question": "Does the system rank strengths?",
				"answer": "No. The system may organize entries, but it does not rank strengths or infer capacity."
			},
			{
				"question": "Can practitioner observations be added?",
				"answer": "Yes. Practitioner notes can support planning, but they remain separate from the client's own wording."
			},
			{
				"question": "Can this connect to recovery goals?",
				"answer": "Yes. When goal linking is enabled, strengths and resources can be associated with existing recovery goals or next steps."
			}
		]
	},
	{
		"toolType": "choiceAndPreferencesProfile",
		"slug": "choice-and-preferences-profile",
		"title": "Choice and Preferences Profile Demo | Qwoach",
		"metaDescription": "Capture client-stated service preferences and identify possible mismatches with current service conditions.",
		"h1": "Choice and Preferences Profile",
		"intro": "The Choice and Preferences Profile is a ready-to-send tool for practitioners. It helps them collect explicit client preferences about support approaches, involvement, or service conditions and review possible mismatches with current services.",
		"demoTitle": "Explore a sample preference profile",
		"demoPrompt": "Interested in using Choice and Preferences Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1007-f-063-rec-005-r001-choice-and-preferences-profile.md",
		"specId": "1007-f-063-rec-005-r001-choice-and-preferences-profile",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Service preferences"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The profile captures explicit client preferences about service delivery and optional current-service notes for descriptive mismatch review."
			},
			{
				"title": "What Mismatch Means",
				"body": "A mismatch indicator means a stated preference and current-service note may not align. It is not a decision, satisfaction score, or clinical interpretation."
			},
			{
				"title": "Repeat Use",
				"body": "Preferences can be revisited as the client's needs change, with prior versions preserved for context."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool infer preferences from behavior?",
				"answer": "No. Preferences are explicit and client-stated. The tool does not infer preferences from behavior."
			},
			{
				"question": "Is this a satisfaction survey?",
				"answer": "No. It captures service preferences and possible mismatches, not satisfaction scores."
			},
			{
				"question": "Does a mismatch decide what the service must change?",
				"answer": "No. A mismatch is descriptive. Practitioner decisions and service adjustments happen in the surrounding care workflow."
			},
			{
				"question": "Can preferences be updated later?",
				"answer": "Yes. Preferences can be revisited, and historical versions can show changes over time."
			}
		]
	},
	{
		"toolType": "triggerAndStressorPlan",
		"slug": "trigger-and-stressor-plan",
		"title": "Trigger and Stressor Plan Demo | Qwoach",
		"metaDescription": "Map individualized triggers, stressors, warning signs, and coping responses for recovery support and early intervention.",
		"h1": "Trigger and Stressor Plan",
		"intro": "The Trigger and Stressor Plan is a ready-to-send planning tool for practitioners and clients. It helps them identify individualized triggers, stressors, warning signs or risk patterns, and coping responses that can support routine care and early intervention.",
		"demoTitle": "Explore a sample trigger-response map",
		"demoPrompt": "Interested in using Trigger and Stressor Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1008-f-063-rec-006-r001-trigger-and-stressor-plan.md",
		"specId": "1008-f-063-rec-006-r001-trigger-and-stressor-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Stress",
				"Coping",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures triggers or stressors, warning signs or risk patterns where used, matched coping responses, and practitioner notes."
			},
			{
				"title": "Routine Support and Early Intervention",
				"body": "The result helps practitioners see what patterns to anticipate and which coping responses are already matched or still need follow-up."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not a crisis plan unless the surrounding care context uses it that way. It does not invent emergency guidance or calculate clinical risk."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create a risk score?",
				"answer": "No. The result is descriptive and does not calculate risk level or infer clinical urgency."
			},
			{
				"question": "Can a trigger be saved without a coping response?",
				"answer": "Yes. It can be saved as incomplete and flagged for follow-up."
			},
			{
				"question": "Can coping responses be general rather than matched?",
				"answer": "Yes. General coping notes can be recorded, but they remain distinct from responses matched to a specific trigger or stressor."
			},
			{
				"question": "Can the plan be revised?",
				"answer": "Yes. Historical entries can be preserved while the current plan shows changed patterns and responses."
			}
		]
	},
	{
		"toolType": "dailyWellnessActivitiesPlan",
		"slug": "daily-wellness-activities-plan",
		"title": "Daily Wellness Activities Plan Demo | Qwoach",
		"metaDescription": "Plan concrete daily wellness activities that fit a client's recovery needs, preferences, and everyday life.",
		"h1": "Daily Wellness Activities Plan",
		"intro": "The Daily Wellness Activities Plan is a ready-to-send routine planning tool for practitioners and clients. It helps clients name concrete daily wellness activities that fit their recovery needs, preferences, and everyday life.",
		"demoTitle": "Explore a sample daily routine",
		"demoPrompt": "Interested in using Daily Wellness Activities Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1009-f-063-rec-007-r001-daily-wellness-activities-plan.md",
		"specId": "1009-f-063-rec-007-r001-daily-wellness-activities-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures concrete daily activities, optional notes about fit or preference, practitioner review notes, and revision history."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not send reminders, track adherence, prescribe activities, calculate wellness scores, or infer impact."
			},
			{
				"title": "Repeat Use",
				"body": "The routine can be revised when activities are not working or circumstances change."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool track whether activities were completed?",
				"answer": "No. It plans the routine. Adherence tracking is outside this tool's supported behavior."
			},
			{
				"question": "Does the tool prescribe wellness activities?",
				"answer": "No. Activities are entered by the client and practitioner. The system does not invent activity content."
			},
			{
				"question": "Can an activity be saved without a specific time?",
				"answer": "Yes. The tool does not force a schedule unless timing is provided."
			},
			{
				"question": "Can the routine be changed later?",
				"answer": "Yes. Revisions can show activities that were added, removed, or adjusted based on experience."
			}
		]
	},
	{
		"toolType": "recoveryProgressReview",
		"slug": "recovery-progress-review",
		"title": "Recovery Progress Review Demo | Qwoach",
		"metaDescription": "Review person-defined recovery outcomes over time and identify support strategies that are helping, stalling, or need adjustment.",
		"h1": "Recovery Progress Review",
		"intro": "The Recovery Progress Review is a collaborative longitudinal tool for practitioners and clients. It helps them review person-defined recovery outcomes over time, capture the client's perspective on change, and identify strategies that are helping, stalling, or need adjustment.",
		"demoTitle": "Explore a sample progress review",
		"demoPrompt": "Interested in using Recovery Progress Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1010-f-063-rec-008-r001-recovery-progress-review.md",
		"specId": "1010-f-063-rec-008-r001-recovery-progress-review",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the review during ongoing recovery support when practitioner and client need to understand change over time against outcomes the person finds meaningful."
			},
			{
				"title": "What It Captures",
				"body": "The review captures person-defined outcomes, client perspective on change, strategy notes, practitioner adjustment notes, dates, and historical snapshots."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not create standardized scores, recovery grades, diagnostic conclusions, or generic milestones."
			}
		],
		"faqItems": [
			{
				"question": "What happens if there are no prior outcomes?",
				"answer": "The tool creates a baseline review rather than a longitudinal comparison."
			},
			{
				"question": "Are numerical ratings required?",
				"answer": "No. The experience should avoid numerical ratings unless a resolved configuration supplies them."
			},
			{
				"question": "Who interprets progress?",
				"answer": "The client perspective remains central, and practitioner interpretation is kept distinct from descriptive change displays."
			},
			{
				"question": "Can outcomes change over time?",
				"answer": "Yes. Old outcomes remain historical, and new or revised outcomes are marked clearly for continuity."
			}
		]
	},
	{
		"toolType": "peerSupportGoalPlan",
		"slug": "peer-support-goal-plan",
		"title": "Peer Support Goal Plan for Recovery-Oriented Support | Qwoach",
		"metaDescription": "Create a person-directed peer support plan that connects stated hopes, goals, and preferences to clear recovery support direction.",
		"h1": "Peer Support Goal Plan",
		"intro": "The Peer Support Goal Plan is a collaborative planning tool for practitioners coordinating peer support. It helps the practitioner, person served, and peer support participant clarify hopes, goals, preferences, and how peer support should contribute to recovery direction.",
		"demoTitle": "Open the sample plan and try completing the person-directed fields.",
		"demoPrompt": "Interested in using Peer Support Goal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1011-f-063-rec-009-r001-peer-support-goal-plan.md",
		"specId": "1011-f-063-rec-009-r001-peer-support-goal-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Service preferences"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when peer support is part of recovery coordination and the practitioner needs peer involvement to reflect the person's own direction."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures stated hopes or priorities, support preferences, intended peer support contribution, contributor attribution, and unresolved items."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not collect symptom ratings, determine eligibility, score recovery, infer motivation, or replace the person's goals with service-defined goals."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score recovery progress?",
				"answer": "No. The Peer Support Goal Plan does not calculate scores or interpret recovery status."
			},
			{
				"question": "Can the plan be incomplete?",
				"answer": "Yes. Unresolved areas can remain marked unresolved instead of forcing invented content."
			},
			{
				"question": "Who contributes to the plan?",
				"answer": "The practitioner facilitates, the person served provides hopes, goals, and preferences, and a peer support participant may add practical input in response to the person's direction."
			},
			{
				"question": "What is saved when I save the tool?",
				"answer": "The fixed Peer Support Goal Plan tool is saved into the practitioner's account; demo sample content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "strengthsSummary",
		"slug": "strengths-summary",
		"title": "Strengths Summary for Wraparound Planning | Qwoach",
		"metaDescription": "Build a domain-based inventory of youth and family strengths so wraparound planning can use existing capabilities and assets.",
		"h1": "Strengths Summary",
		"intro": "The Strengths Summary is a collaborative wraparound tool for practitioners preparing support with a youth or family. It helps capture strengths, assets, capabilities, resources, and examples across relevant domains so planning can build from what is already present.",
		"demoTitle": "Explore the sample domains and add non-identifying strengths.",
		"demoPrompt": "Interested in using Strengths Summary with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1012-f-064-wrap-001-r001-strengths-summary.md",
		"specId": "1012-f-064-wrap-001-r001-strengths-summary",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Strengths"
			],
			"population": [
				"Adolescents",
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during preparation or early wraparound work when strengths need to be visible across youth, family, and life domains."
			},
			{
				"title": "What It Captures",
				"body": "The summary captures strengths, assets, capabilities, resources, family examples, optional planning-use notes, and unresolved domains."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not score strengths, infer that blank domains mean lack of capacity, define service eligibility, or replace the family's own view."
			}
		],
		"faqItems": [
			{
				"question": "Are the domains fixed?",
				"answer": "No. The specification allows domain structure to be configurable only when the practitioner has a legitimate local or source-defined domain set."
			},
			{
				"question": "Do all domains need strengths?",
				"answer": "No. Blank domains can remain unexplored or unresolved and are not interpreted as negative findings."
			},
			{
				"question": "Can youth or family wording be preserved?",
				"answer": "Yes. The tool should preserve youth and family wording where it reflects their own view of strengths."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The tool and selected domain setup are saved; fictional strengths and sample case content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "familyConcernsStrengthsPotentialTeamMembersForm",
		"slug": "family-concerns-strengths-potential-team-members-form",
		"title": "Family Concerns, Strengths & Team Members Form | Qwoach",
		"metaDescription": "Capture family concerns, strengths, and possible support team members to guide early wraparound team formation and planning focus.",
		"h1": "Family Concerns, Strengths & Potential Team Members Form",
		"intro": "The Family Concerns, Strengths & Potential Team Members Form is a collaborative wraparound tool for practitioners beginning work with a family. It helps capture the family's priority concerns, strengths, and possible natural or formal supports so team formation and planning focus reflect the family's situation.",
		"demoTitle": "Open the sample form and try adding non-identifying family input.",
		"demoPrompt": "Interested in using Family Concerns, Strengths & Potential Team Members Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1013-f-064-wrap-002-r001-family-concerns-strengths-potential-team-members-form.md",
		"specId": "1013-f-064-wrap-002-r001-family-concerns-strengths-potential-team-members-form",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Session preparation"
			],
			"topic": [
				"Strengths",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when beginning wraparound work and deciding what the team needs to understand before planning begins."
			},
			{
				"title": "What It Captures",
				"body": "The form captures family concerns, family strengths, and potential team members, including role or relationship details when reported."
			},
			{
				"title": "Relevant Limits",
				"body": "The form does not score concerns or strengths, require complete contact data, decide who must join the team, or create a full wraparound plan."
			}
		],
		"faqItems": [
			{
				"question": "Does the form decide who should be on the wraparound team?",
				"answer": "No. It records potential team members but does not decide team membership."
			},
			{
				"question": "Can the family add items in any order?",
				"answer": "Yes. The family can add concerns, strengths, and possible support people in any order."
			},
			{
				"question": "Are full contact details required?",
				"answer": "No. Potential team members can be described even when contact details or role clarity are not yet available."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The fixed form is saved as-is; fictional demo entries are not saved as real client data."
			}
		]
	},
	{
		"toolType": "socialSupportNetworkMatrix",
		"slug": "social-support-network-matrix",
		"title": "Social Support Network Matrix for Wraparound | Qwoach",
		"metaDescription": "Map formal and informal supports, reported roles, and possible involvement to inform wraparound planning and follow-through.",
		"h1": "Social Support Network Matrix",
		"intro": "The Social Support Network Matrix is a collaborative wraparound tool for practitioners working with a youth or family. It helps identify formal and informal supports, reported relationship or role information, and possible involvement so the team can make informed planning and follow-through decisions.",
		"demoTitle": "Open the sample matrix and add fictional support entries.",
		"demoPrompt": "Interested in using Social Support Network Matrix with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1014-f-064-wrap-003-r001-social-support-network-matrix.md",
		"specId": "1014-f-064-wrap-003-r001-social-support-network-matrix",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the practitioner needs to understand the family's formal and informal support network for wraparound involvement decisions."
			},
			{
				"title": "What It Captures",
				"body": "The matrix captures support entries, reported type, relationship or role details, involvement potential, tentative status, and notes where provided."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not infer trust, safety, suitability, relationship quality, or mandatory inclusion."
			}
		],
		"faqItems": [
			{
				"question": "Does the matrix decide who should participate in planning?",
				"answer": "No. It informs discussion but does not decide who should participate."
			},
			{
				"question": "Can supports be listed without complete details?",
				"answer": "Yes. Supports can be entered with incomplete role or relationship details and marked unclear or tentative."
			},
			{
				"question": "Are matrix fields fixed?",
				"answer": "No. Matrix dimensions may be configured only when the practitioner has a legitimate defined local or source-based structure."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool and selected matrix setup are saved; fictional support entries and sample case data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "familyVisionStatement",
		"slug": "family-vision-statement",
		"title": "Family Vision Statement for Wraparound Planning | Qwoach",
		"metaDescription": "Help youth and family define a desired future in their own words so wraparound goals and strategies can stay aligned.",
		"h1": "Family Vision Statement",
		"intro": "The Family Vision Statement is a collaborative wraparound tool for practitioners working with youth and families entering planning. It helps the youth and family draft, revise, and confirm a clear desired future that can orient team goals and strategies.",
		"demoTitle": "Try drafting a sample family vision statement.",
		"demoPrompt": "Interested in using Family Vision Statement with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1015-f-064-wrap-004-r001-family-vision-statement.md",
		"specId": "1015-f-064-wrap-004-r001-family-vision-statement",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Therapeutic document"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it as youth and family enter wraparound planning and need the team to understand the future they want."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures rough notes, alternate phrasings, one current or confirmed statement, unresolved disagreement, and version history where used."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not generate substantive vision content without youth/family confirmation and does not turn the vision into goals, strategies, scores, or clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Who defines the vision statement?",
				"answer": "The youth and family define and approve the vision statement."
			},
			{
				"question": "Can there be multiple drafts?",
				"answer": "Yes. Multiple drafts can exist, but only one statement should be marked current or confirmed."
			},
			{
				"question": "What happens if the family does not agree on wording?",
				"answer": "Disagreement can remain unresolved or appear as multiple draft perspectives until a shared statement is agreed."
			},
			{
				"question": "What is saved when I save the tool?",
				"answer": "The fixed Family Vision Statement tool is saved; fictional demo drafts are not saved as real client data."
			}
		]
	},
	{
		"toolType": "teamMissionStatement",
		"slug": "team-mission-statement",
		"title": "Team Mission Statement for Wraparound Teams | Qwoach",
		"metaDescription": "Create a shared wraparound team purpose that reflects family priorities and helps formal and informal members coordinate work.",
		"h1": "Team Mission Statement",
		"intro": "The Team Mission Statement is a collaborative tool for wraparound practitioners and team members. It helps the team draft and confirm an explicit shared purpose aligned with the family's priorities and desired future so formal and informal members can coordinate their work.",
		"demoTitle": "Draft a sample mission statement and review its status.",
		"demoPrompt": "Interested in using Team Mission Statement with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1016-f-064-wrap-005-r001-team-mission-statement.md",
		"specId": "1016-f-064-wrap-005-r001-team-mission-statement",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Therapeutic document"
			],
			"workflow": [
				"Intervention planning",
				"Therapeutic consolidation"
			],
			"topic": [
				"Goals"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it as formal and informal wraparound team members come together and need a shared purpose for collaboration."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures mission wording, draft or confirmed status, suggested revisions, and family-priority or vision context when provided."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not assign responsibilities, score team alignment, create unapproved mission content, or expand into a full plan."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create the mission statement automatically?",
				"answer": "No. It supports drafting and review, but substantive mission content must be reviewed and confirmed."
			},
			{
				"question": "Can the mission remain draft?",
				"answer": "Yes. If family vision or team agreement is unresolved, the mission can remain draft or marked unclear."
			},
			{
				"question": "Who uses the mission statement?",
				"answer": "The practitioner, family, and formal or informal team members use it as a shared purpose for collaboration."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The fixed Team Mission Statement tool is saved; fictional demo mission content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "needsPrioritization",
		"slug": "needs-prioritization",
		"title": "Needs Prioritization for Wraparound Planning | Qwoach",
		"metaDescription": "Select a manageable set of priority youth or family needs from a broader list while preserving non-selected needs for later.",
		"h1": "Needs Prioritization",
		"intro": "Needs Prioritization is a collaborative wraparound tool for practitioners and teams with more identified needs than they can address at once. It helps the team select a manageable priority set while preserving remaining needs for later and keeping youth and family perspective visible.",
		"demoTitle": "Open the sample needs list and select current priorities.",
		"demoPrompt": "Interested in using Needs Prioritization with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1017-f-064-wrap-006-r001-needs-prioritization.md",
		"specId": "1017-f-064-wrap-006-r001-needs-prioritization",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after a broader set of youth or family needs has been identified and the team needs a focused starting point."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures selected priority needs, remaining needs, optional rationale, family/team perspective, and current or draft status."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not create default ranking criteria, score need severity, recommend priorities automatically, or delete non-selected needs."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool rank needs automatically?",
				"answer": "No. Needs Prioritization supports transparent selection but does not create automated rankings or unsupported scores."
			},
			{
				"question": "What happens to non-selected needs?",
				"answer": "Non-selected needs remain visible for later instead of being deleted."
			},
			{
				"question": "Is there a fixed maximum number of priority needs?",
				"answer": "No. The tool can warn that a selected set may not be manageable, but it does not impose an unsupported exact maximum."
			},
			{
				"question": "What is saved when I save the tool?",
				"answer": "The fixed Needs Prioritization tool is saved; fictional demo needs and selections are not saved as real client data."
			}
		]
	},
	{
		"toolType": "wraparoundPlanOfCare",
		"slug": "wraparound-plan-of-care",
		"title": "Wraparound Plan of Care for Team Coordination | Qwoach",
		"metaDescription": "Maintain a dynamic wraparound plan connecting family vision, strengths, priority needs, strategies, responsibilities, and updates.",
		"h1": "Wraparound Plan of Care",
		"intro": "The Wraparound Plan of Care is a collaborative planning tool for practitioners coordinating ongoing work with a family and wraparound team. It helps maintain a shared dynamic care direction that connects family vision, strengths, prioritized needs, strategies, responsibilities, and updates over time.",
		"demoTitle": "Explore the sample plan and review how connected plan elements work.",
		"demoPrompt": "Interested in using Wraparound Plan of Care with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1018-f-064-wrap-007-r001-wraparound-plan-of-care.md",
		"specId": "1018-f-064-wrap-007-r001-wraparound-plan-of-care",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Strengths"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for ongoing wraparound coordination when multiple people are working toward the family's needs and vision over time."
			},
			{
				"title": "What It Connects",
				"body": "The plan connects family vision, strengths, team, prioritized needs, strategies, responsible people, updates, and unresolved items."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not automate strategy selection, generate clinical conclusions, assign responsibility automatically, or replace family perspective with practitioner interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Is the Plan of Care a static form?",
				"answer": "No. It is a dynamic plan that preserves current and historical states as wraparound work changes."
			},
			{
				"question": "Can strategies exist without priority needs?",
				"answer": "The plan should mark that as incomplete because strategies need to connect to prioritized needs to remain coherent."
			},
			{
				"question": "Does the tool assign responsibilities automatically?",
				"answer": "No. Responsibilities are entered by the practitioner, family, or team and must be clear enough for action."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed Wraparound Plan of Care tool is saved; fictional plan content and sample case data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "crisisSafetyPlan",
		"slug": "crisis-safety-plan",
		"title": "Crisis / Safety Plan for Wraparound Teams | Qwoach",
		"metaDescription": "Create a clear wraparound crisis response plan with anticipated situations, response steps, roles, and contacts for escalation.",
		"h1": "Crisis / Safety Plan",
		"intro": "The Crisis / Safety Plan is a collaborative wraparound tool for practitioners working with families and teams when crisis or safety risk may escalate. It helps organize anticipated situations, response steps, roles, contacts, and family-context notes into a current response direction that can be reviewed quickly.",
		"demoTitle": "Open the sample plan and check what makes it complete.",
		"demoPrompt": "Interested in using Crisis / Safety Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1019-f-064-wrap-008-r001-crisis-safety-plan.md",
		"specId": "1019-f-064-wrap-008-r001-crisis-safety-plan",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Crisis response"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when crisis or safety risk may escalate during wraparound involvement and the family/team needs clear response direction."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures anticipated situations, response steps, roles, contacts, family-context notes, completion status, and current-version review."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not assess risk level, diagnose, automate triage, decide emergency actions beyond entered plan content, or present incomplete content as finalized."
			}
		],
		"faqItems": [
			{
				"question": "Is this tool a clinical risk assessment?",
				"answer": "No. The Crisis / Safety Plan is a response plan, not a clinical risk assessment."
			},
			{
				"question": "Can an incomplete plan be treated as final?",
				"answer": "No. Missing situations, steps, roles, or contacts should keep the plan visibly incomplete."
			},
			{
				"question": "Does the tool create crisis-response steps automatically?",
				"answer": "No. It organizes entered response-direction content and does not invent clinical safety-planning steps."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The fixed Crisis / Safety Plan tool is saved; fictional demo crisis content and sample contacts are not saved as real client data."
			}
		]
	},
	{
		"toolType": "outcomeTrackingFormWraparoundOutcomeScale",
		"slug": "outcome-tracking-form-wraparound-outcome-scale",
		"title": "Wraparound Outcome Tracking Form Demo | Qwoach",
		"metaDescription": "Track defined wraparound outcomes over repeated time points to view trajectory and inform practitioner review of strategy adjustments.",
		"h1": "Outcome Tracking Form / Wraparound Outcome Scale",
		"intro": "The Outcome Tracking Form / Wraparound Outcome Scale is a ready-to-send tracking tool for wraparound practitioners. It helps collect the same defined outcome information over time so the practitioner can view trajectory and consider whether wraparound strategies need adjustment.",
		"demoTitle": "Explore the sample trajectory and unresolved scale setup.",
		"demoPrompt": "Interested in using Outcome Tracking Form / Wraparound Outcome Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1020-f-064-wrap-009-r001-outcome-tracking-form-wraparound-outcome-scale.md",
		"specId": "1020-f-064-wrap-009-r001-outcome-tracking-form-wraparound-outcome-scale",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Graph"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when outcome information needs to be collected repeatedly so the practitioner can view change over time."
			},
			{
				"title": "What It Tracks",
				"body": "The tool tracks only defined outcome items or scale content across repeated administrations and can connect outcomes to wraparound goals or needs when that relationship is provided."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool cannot invent scale items, scoring, thresholds, response options, or clinical interpretations. A single administration is a baseline, not a trajectory."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo create outcome scale questions?",
				"answer": "No. Exact scale items, ratings, scoring, and domains are unresolved unless supplied, so the tool cannot invent substantive questions."
			},
			{
				"question": "Is one completed form a trajectory?",
				"answer": "No. One completion is a baseline or snapshot; trajectory requires repeated comparable data points."
			},
			{
				"question": "What happens if the outcome set changes?",
				"answer": "Changed items, response options, or scoring should annotate or split the trajectory because comparability is affected."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The tool and any selected legitimate outcome set or scale version are saved; fictional responses and sample trajectory data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "teamBuyInParticipationTracker",
		"slug": "team-buy-in-participation-tracker",
		"title": "Team Buy-In / Participation Tracker for Wraparound Teams | Qwoach",
		"metaDescription": "Track wraparound team participation and buy-in separately, review engagement patterns, and identify low or changing involvement across team members.",
		"h1": "Team Buy-In / Participation Tracker",
		"intro": "The Team Buy-In / Participation Tracker is a practitioner-only tool for wraparound coordinators. It helps practitioners record team member participation and buy-in separately, compare review points, and see where engagement is strong, weak, incomplete, or changing.",
		"demoTitle": "Explore the sample tracker",
		"demoPrompt": "Interested in using Team Buy-In / Participation Tracker with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1021-f-064-wrap-010-r001-team-buy-in-participation-tracker.md",
		"specId": "1021-f-064-wrap-010-r001-team-buy-in-participation-tracker",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during wraparound coordination reviews when the practitioner needs to distinguish member participation from buy-in and notice changes over time."
			},
			{
				"title": "What It Captures",
				"body": "The tracker captures team member or role, review date or period, participation information, buy-in information, optional observable-context notes, and optional next-step notes."
			},
			{
				"title": "Important Limits",
				"body": "The tracker does not explain why someone is disengaged, generate a global team health score, or create clinical conclusions about the youth or family."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client-facing tool?",
				"answer": "No. This tracker is practitioner-only. It can include team members or roles as subjects of tracking, but it does not define a participant-facing workflow."
			},
			{
				"question": "Does it score team engagement?",
				"answer": "No unsupported engagement score is defined. The tool shows entered participation and buy-in data, incomplete entries, and descriptive changes when comparable history exists."
			},
			{
				"question": "What happens if some rows are incomplete?",
				"answer": "Incomplete rows remain visible. The tracker should not imply a team-wide conclusion from missing participation or buy-in entries."
			},
			{
				"question": "Can roster changes be tracked over time?",
				"answer": "Yes. Historical entries remain attached to the original member or role, and absence from a prior period should not be treated as low buy-in."
			}
		]
	},
	{
		"toolType": "transitionDischargeSummary",
		"slug": "transition-discharge-summary",
		"title": "Transition / Discharge Summary for Wraparound Continuity | Qwoach",
		"metaDescription": "Create a wraparound transition summary with current status, supports, responsibilities, maintenance needs, warning signs, and unresolved areas.",
		"h1": "Transition / Discharge Summary",
		"intro": "The Transition / Discharge Summary is a ready-to-complete-together tool for practitioners supporting wraparound discharge. It helps organize current status, continuing supports, risks, responsibilities, maintenance needs, and warning signs into a shared handoff record.",
		"demoTitle": "Review the sample summary",
		"demoPrompt": "Interested in using Transition / Discharge Summary with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1022-f-064-wrap-011-r001-transition-discharge-summary.md",
		"specId": "1022-f-064-wrap-011-r001-transition-discharge-summary",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Clinical documentation",
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Strengths"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it near transition or discharge, when ongoing supports and maintenance needs must remain clear after formal services end."
			},
			{
				"title": "Practitioner And Family Roles",
				"body": "The practitioner creates and controls the draft. Client/family and relevant supporters may contribute or confirm information when included in the collaborative workflow."
			},
			{
				"title": "Relevant Limits",
				"body": "The summary is not a generic care plan, readiness score, eligibility determination, or prediction tool."
			}
		],
		"faqItems": [
			{
				"question": "Can this be completed with the family?",
				"answer": "Yes. The supported mode is ready to complete together, with client/family contribution focused on transition-relevant information."
			},
			{
				"question": "Does the tool decide whether someone is ready for discharge?",
				"answer": "No. It organizes the transition picture and marks missing areas, but it does not produce readiness scoring or clinical predictions."
			},
			{
				"question": "What happens to unfinished sections?",
				"answer": "Unfinished sections remain visible in the draft and review so missing information is not hidden."
			},
			{
				"question": "Can the summary be updated if transition timing changes?",
				"answer": "Yes. The summary remains editable until finalized, and the product should distinguish draft from finalized content."
			}
		]
	},
	{
		"toolType": "wraparoundFidelityAssessmentSystemWfas",
		"slug": "wraparound-fidelity-assessment-system-wfas",
		"title": "WFAS Demo for Wraparound Fidelity Assessment | Qwoach",
		"metaDescription": "Explore a multi-source wraparound fidelity assessment with surveys, observation, document review, system support assessment, and profile reporting.",
		"h1": "Wraparound Fidelity Assessment System (WFAS)",
		"intro": "The Wraparound Fidelity Assessment System (WFAS) is a fidelity assessment and reporting system for practitioners and implementation leaders. It helps assess whether wraparound practice, team process, documentation, and system supports align with expected implementation across cases, teams, or systems.",
		"demoTitle": "Explore the sample WFAS assessment",
		"demoPrompt": "Interested in using Wraparound Fidelity Assessment System (WFAS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1023-f-064-wrap-012-r001-wraparound-fidelity-assessment-system-wfas.md",
		"specId": "1023-f-064-wrap-012-r001-wraparound-fidelity-assessment-system-wfas",
		"tags": {
			"framework": [
				"Wraparound"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Multiple Sources Stay Separate",
				"body": "WFAS combines surveys, team observation, document review, and system support assessment where applicable, but the review must keep source status and source-specific evidence visible."
			},
			{
				"title": "Partial Data",
				"body": "Incomplete components are marked as incomplete and should not produce unsupported aggregate conclusions."
			},
			{
				"title": "Quality Improvement Use",
				"body": "Results can guide supervision, training, or system-level improvement conversations by identifying distinguishable strengths and gaps."
			}
		],
		"faqItems": [
			{
				"question": "Does WFAS use more than one data source?",
				"answer": "Yes. The supplied record identifies surveys, team observation, document review, system support assessment, and online reporting as WFAS components."
			},
			{
				"question": "Can the demo show actual WFAS survey questions or scores?",
				"answer": "No. Exact instruments, item wording, respondent roles, scoring rules, and thresholds are unresolved, so the demo must not invent them."
			},
			{
				"question": "What happens when one component is missing?",
				"answer": "The missing component is marked incomplete, and the report should not treat missing data as low fidelity or produce unsupported aggregate conclusions."
			},
			{
				"question": "Is this a satisfaction survey?",
				"answer": "No. WFAS is a fidelity assessment and reporting system, not a satisfaction-only survey."
			}
		]
	},
	{
		"toolType": "peopOccupationalTherapyProcess",
		"slug": "peop-occupational-therapy-process",
		"title": "PEOP Occupational Therapy Process for OT Reasoning | Qwoach",
		"metaDescription": "Use a PEOP-aligned reasoning pathway to connect person, environment, occupation, and performance factors to OT assessment and intervention direction.",
		"h1": "PEOP Occupational Therapy Process",
		"intro": "The PEOP Occupational Therapy Process is a practitioner-only structured reasoning tool for occupational therapy practitioners. It helps connect client information, contextual factors, occupations, performance concerns, assessment priorities, and intervention direction in a coherent PEOP-aligned pathway.",
		"demoTitle": "Explore the sample reasoning pathway",
		"demoPrompt": "Interested in using PEOP Occupational Therapy Process with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1024-f-065-peop-001-r001-peop-occupational-therapy-process.md",
		"specId": "1024-f-065-peop-001-r001-peop-occupational-therapy-process",
		"tags": {
			"framework": [
				"PEOP"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Traceability",
				"body": "Each assessment priority and intervention direction should be linkable to entered contextual or occupational factors."
			},
			{
				"title": "Partial Records",
				"body": "Incomplete pathways remain usable for work in progress while showing which PEOP areas are missing or which decisions are unlinked."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not create PEOP scores, diagnoses, prognosis, treatment protocols, or source-specific prompts that are not validated."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client questionnaire?",
				"answer": "No. The specified configuration is practitioner-only, although client information may inform the practitioner's entries."
			},
			{
				"question": "Does it recommend interventions?",
				"answer": "No. It organizes practitioner-entered reasoning and links intervention direction to factors, but it does not generate intervention recommendations."
			},
			{
				"question": "What makes the pathway PEOP-aligned?",
				"answer": "It represents person, environment, occupation, and performance considerations and connects them to assessment and intervention planning."
			},
			{
				"question": "Can incomplete reasoning be saved?",
				"answer": "Yes. Partial records can be saved while showing missing PEOP areas or unlinked decisions."
			}
		]
	},
	{
		"toolType": "clientNarrativeLifeStory",
		"slug": "client-narrative-life-story",
		"title": "Client Narrative / Life Story for PEOP-Aligned OT | Qwoach",
		"metaDescription": "Capture a client's lived story, priorities, roles, and meaningful contexts for occupational therapy goal setting while preserving client voice.",
		"h1": "Client Narrative / Life Story",
		"intro": "Client Narrative / Life Story is a ready-to-complete-together occupational therapy tool for practitioners and clients. It helps capture the person's lived story, priorities, roles, and meaningful contexts so OT goal setting can reflect what the client values.",
		"demoTitle": "Explore the sample narrative",
		"demoPrompt": "Interested in using Client Narrative / Life Story with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1025-f-065-peop-002-r001-client-narrative-life-story.md",
		"specId": "1025-f-065-peop-002-r001-client-narrative-life-story",
		"tags": {
			"framework": [
				"PEOP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Occupational participation",
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client Voice",
				"body": "The tool keeps client-stated priorities and meanings distinguishable from practitioner notes and assumptions."
			},
			{
				"title": "When It Is Revisited",
				"body": "The narrative can be updated when therapy is revisited or when life context, roles, or priorities change."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool is not a generic intake form, symptom checklist, biography builder, or automatic goal generator."
			}
		],
		"faqItems": [
			{
				"question": "Can the client complete part of this tool?",
				"answer": "Yes. The supported mode is collaborative, with the client contributing narrative content and reviewing whether the summary reflects what they meant."
			},
			{
				"question": "Does the tool force disclosure of personal history?",
				"answer": "No. It should allow skipped or unresolved areas and avoid requiring exhaustive personal history."
			},
			{
				"question": "Does it generate therapy goals automatically?",
				"answer": "No. It presents narrative content for practitioner-client goal-setting work but does not infer or generate goals automatically."
			},
			{
				"question": "How are practitioner notes handled?",
				"answer": "Practitioner notes are kept distinct from client-stated priorities, roles, contexts, and meaning."
			}
		]
	},
	{
		"toolType": "personFactorsProfile",
		"slug": "person-factors-profile",
		"title": "Person Factors Profile for PEOP-Aligned OT | Qwoach",
		"metaDescription": "Create a PEOP-aligned profile linking physical, cognitive, psychological, and other person factors to occupational concerns and OT priorities.",
		"h1": "Person Factors Profile",
		"intro": "Person Factors Profile is a practitioner-only occupational therapy formulation tool. It helps practitioners organize relevant physical, cognitive, psychological, and other personal factors, link them to occupational concerns, and see strengths and limitations for OT planning.",
		"demoTitle": "Explore the sample profile",
		"demoPrompt": "Interested in using Person Factors Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1026-f-065-peop-003-r001-person-factors-profile.md",
		"specId": "1026-f-065-peop-003-r001-person-factors-profile",
		"tags": {
			"framework": [
				"PEOP"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The profile captures occupational concerns, relevant person factors, strength or limitation designation where entered, links to occupational needs, and practitioner notes."
			},
			{
				"title": "Relation-Specific Meaning",
				"body": "A factor can function differently across occupations, so notes and links should show where it is a strength, limitation, or relevant characteristic."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool is not a diagnostic assessment, impairment severity scale, exhaustive medical history, or intervention prescription system."
			}
		],
		"faqItems": [
			{
				"question": "Is this a diagnostic profile?",
				"answer": "No. It is a PEOP-aligned formulation aid for OT planning, not a diagnostic assessment or scoring system."
			},
			{
				"question": "Can a factor be both a strength and a limitation?",
				"answer": "Yes. The same factor may function differently across occupations, so relation-specific notes should be supported."
			},
			{
				"question": "What happens when a factor is not linked to an occupation?",
				"answer": "It remains visible as unlinked so the practitioner can decide whether and how it matters."
			},
			{
				"question": "Does the tool include exact PEOP factor categories?",
				"answer": "No exact taxonomy is supplied beyond physical, cognitive, psychological, and other personal factors, so the demo must not invent detailed subdomains."
			}
		]
	},
	{
		"toolType": "environmentFactorsProfile",
		"slug": "environment-factors-profile",
		"title": "Environment Factors Profile for PEOP-Aligned OT | Qwoach",
		"metaDescription": "Map environmental supports and barriers to a client's occupations, roles, and participation issues for PEOP-aligned occupational therapy planning.",
		"h1": "Environment Factors Profile",
		"intro": "Environment Factors Profile is a ready-to-complete-together occupational therapy tool for practitioners and clients. It helps identify physical, social, and contextual supports or barriers and connect them to the client's occupations, roles, and participation issues.",
		"demoTitle": "Explore the sample environment profile",
		"demoPrompt": "Interested in using Environment Factors Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1027-f-065-peop-004-r001-environment-factors-profile.md",
		"specId": "1027-f-065-peop-004-r001-environment-factors-profile",
		"tags": {
			"framework": [
				"PEOP"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Environmental barriers",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client And Practitioner Roles",
				"body": "The client contributes lived environmental context. The practitioner organizes and links it to OT planning while keeping observations distinct from client descriptions."
			},
			{
				"title": "Mixed Effects",
				"body": "A factor can be both a support and a barrier depending on the occupation or role, and the profile should allow activity-specific designation."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool is not a home-safety checklist, social-needs screener, housing eligibility tool, legal compliance review, or automated adaptation planner."
			}
		],
		"faqItems": [
			{
				"question": "Can clients contribute directly?",
				"answer": "Yes. The supported mode is collaborative, with clients describing surroundings, social context, supports, barriers, and examples."
			},
			{
				"question": "Does the profile score the environment?",
				"answer": "No. Unsupported environmental scores or risk ratings are not defined."
			},
			{
				"question": "Can one factor be both a support and a barrier?",
				"answer": "Yes. Mixed effects should be captured in relation to specific occupations or roles."
			},
			{
				"question": "What happens to unlinked environmental factors?",
				"answer": "Unlinked factors remain visible so the practitioner can decide whether they affect participation or performance."
			}
		]
	},
	{
		"toolType": "occupationRoleProfile",
		"slug": "occupation-role-profile",
		"title": "Occupation / Role Profile for PEOP-Aligned OT Goals | Qwoach",
		"metaDescription": "Identify and prioritize a client's meaningful activities, tasks, and roles to guide participation-focused occupational therapy goals.",
		"h1": "Occupation / Role Profile",
		"intro": "Occupation / Role Profile is a ready-to-complete-together occupational therapy tool for practitioners and clients. It helps identify and prioritize meaningful activities, tasks, and roles so OT goals can focus on participation outcomes the client values.",
		"demoTitle": "Explore the sample priority list",
		"demoPrompt": "Interested in using Occupation / Role Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1028-f-065-peop-005-r001-occupation-role-profile.md",
		"specId": "1028-f-065-peop-005-r001-occupation-role-profile",
		"tags": {
			"framework": [
				"PEOP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Occupational participation",
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client Perspective",
				"body": "Important activities, tasks, and roles should be represented from the client's perspective, with practitioner notes kept adjacent but distinct."
			},
			{
				"title": "Priority Ambiguity",
				"body": "If the client is unsure, entries can remain unranked or grouped as unresolved rather than forcing false precision."
			},
			{
				"title": "Relevant Limits",
				"body": "The profile is not a generic task list, schedule planner, impairment checklist, or automatic goal generator."
			}
		],
		"faqItems": [
			{
				"question": "Can the client prioritize items directly?",
				"answer": "Yes. The collaborative view should allow clients to arrange, group, or mark what matters most using plain language."
			},
			{
				"question": "Does the tool require a fixed number of priorities?",
				"answer": "No fixed number is defined. The tool should not force a fixed count unless source content later requires it."
			},
			{
				"question": "Does it create therapy goals automatically?",
				"answer": "No. It provides a prioritized occupation/role list that can guide goal discussion and planning."
			},
			{
				"question": "Can priorities change over time?",
				"answer": "Yes. The profile should allow revisions while preserving previous priorities for context."
			}
		]
	},
	{
		"toolType": "personEnvironmentOccupationFitMap",
		"slug": "person-environment-occupation-fit-map",
		"title": "Person–Environment–Occupation Fit Map for PEOP OT | Qwoach",
		"metaDescription": "Map fit and mismatch among person, environment, and occupation factors to understand participation barriers and OT leverage points.",
		"h1": "Person–Environment–Occupation Fit Map",
		"intro": "Person–Environment–Occupation Fit Map is a ready-to-complete-together occupational therapy tool for practitioners and clients. It helps formulate where fit and mismatch exist among person contributors, environmental contributors, and occupation demands in relation to participation.",
		"demoTitle": "Explore the sample fit map",
		"demoPrompt": "Interested in using Person–Environment–Occupation Fit Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1029-f-065-peop-006-r001-person-environment-occupation-fit-map.md",
		"specId": "1029-f-065-peop-006-r001-person-environment-occupation-fit-map",
		"tags": {
			"framework": [
				"PEOP"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Occupational participation",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Relational Mapping",
				"body": "The map depends on relationships among person, environment, and occupation; factors entered without links remain visible but are not over-interpreted."
			},
			{
				"title": "Client Review",
				"body": "Client examples and review help ensure mismatches are understandable in everyday terms."
			},
			{
				"title": "Relevant Limits",
				"body": "The map is not a root-cause engine, standardized fit score, causal hierarchy, or automatic intervention recommender."
			}
		],
		"faqItems": [
			{
				"question": "Does the map need all three domains?",
				"answer": "Yes. A meaningful fit map depends on person, environment, and occupation contributors being considered together."
			},
			{
				"question": "Can clients help complete the map?",
				"answer": "Yes. The supported mode is collaborative, with clients contributing lived examples and reviewing whether the formulation makes sense."
			},
			{
				"question": "Does it identify the root cause of participation difficulty?",
				"answer": "No. It maps entered relationships and fit/mismatch labels without making unsupported causality claims."
			},
			{
				"question": "What happens to unlinked contributors?",
				"answer": "Unlinked contributors remain visible as unlinked and should not be treated as part of a mismatch until connected."
			}
		]
	},
	{
		"toolType": "participationGoalPlan",
		"slug": "participation-goal-plan",
		"title": "Participation Goal Plan for PEOP-Aligned OT Goals | Qwoach",
		"metaDescription": "Create client-centered participation goals linked to a client's narrative, priorities, roles, activities, and desired life outcomes.",
		"h1": "Participation Goal Plan",
		"intro": "Participation Goal Plan is a ready-to-complete-together occupational therapy tool for practitioners and clients. It helps translate a client's narrative and occupational priorities into participation goals tied to meaningful roles, activities, and desired life outcomes.",
		"demoTitle": "Explore the sample goal plan",
		"demoPrompt": "Interested in using Participation Goal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1030-f-065-peop-007-r001-participation-goal-plan.md",
		"specId": "1030-f-065-peop-007-r001-participation-goal-plan",
		"tags": {
			"framework": [
				"PEOP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Traceability",
				"body": "Every completed goal should trace to a client-stated priority, role, activity, life context, or desired participation outcome."
			},
			{
				"title": "Draft And Final States",
				"body": "Goals can remain draft while awaiting clearer linkage, client confirmation, or wording revision."
			},
			{
				"title": "Relevant Limits",
				"body": "The plan is not a goal bank, impairment target list, treatment-plan generator, SMART conversion tool, or outcome scoring system unless source-validated structure is later supplied."
			}
		],
		"faqItems": [
			{
				"question": "Can clients revise the goals?",
				"answer": "Yes. The collaborative view should allow clients to confirm, revise, reject, or add missing priorities so goals reflect what matters to them."
			},
			{
				"question": "Does the tool generate goals automatically?",
				"answer": "No. Goals are drafted through the practitioner-client process and linked to client-stated priorities."
			},
			{
				"question": "What happens to a goal without a client priority link?",
				"answer": "It remains draft or incomplete and should be flagged for review rather than treated as a completed participation goal."
			},
			{
				"question": "Can impairment-only goals be completed here?",
				"answer": "No. Completed goals should remain participation-focused and tied to meaningful occupations or life context."
			}
		]
	},
	{
		"toolType": "peopInterventionStrategyMap",
		"slug": "peop-intervention-strategy-map",
		"title": "PEOP Intervention Strategy Map for OT Planning | Qwoach",
		"metaDescription": "Map PEOP person, environment, and occupation factors to OT intervention directions with explicit rationale for planning and review.",
		"h1": "PEOP Intervention Strategy Map",
		"intro": "PEOP Intervention Strategy Map is a practitioner-only occupational therapy planning tool. Occupational therapy practitioners use it to link person, environment, and occupation assessment factors to selected intervention directions and explicit rationale for participation-focused care.",
		"demoTitle": "Try the sample strategy map, then save this tool for your practice.",
		"demoPrompt": "Interested in using PEOP Intervention Strategy Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1031-f-065-peop-008-r001-peop-intervention-strategy-map.md",
		"specId": "1031-f-065-peop-008-r001-peop-intervention-strategy-map",
		"tags": {
			"framework": [
				"PEOP"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after assessment information is available and before or during intervention planning, when the practitioner needs the reasoning chain to remain clear."
			},
			{
				"title": "What It Shows",
				"body": "The map shows person, environment, and occupation factors connected to intervention directions and rationale statements, with incomplete links visible for review."
			},
			{
				"title": "Important Limitation",
				"body": "The tool does not choose interventions, score clients, or interpret clinical adequacy. It organizes practitioner-entered assessment content and rationale."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool choose interventions for me?",
				"answer": "No. The practitioner selects the intervention directions and writes the rationale; the tool organizes the links and shows gaps."
			},
			{
				"question": "Is there a separate client form?",
				"answer": "No. This version is practitioner-only, though the assessment information entered may have originated from client report."
			},
			{
				"question": "What gets saved?",
				"answer": "The PEOP Intervention Strategy Map tool is saved, along with supported practitioner setup. Fictional demo case content is not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "peopOutcomeReview",
		"slug": "peop-outcome-review",
		"title": "PEOP Outcome Review for OT Outcomes | Qwoach",
		"metaDescription": "Compare occupational performance, participation, and well-being over time against client goals or baseline in a PEOP-framed OT review.",
		"h1": "PEOP Outcome Review",
		"intro": "PEOP Outcome Review is a longitudinal occupational therapy outcome review tool. Occupational therapy practitioners use it with clients to compare participation, occupational performance, and well-being information against goals, baseline, or prior review points.",
		"demoTitle": "Explore a sample outcome review and save this tool when it fits your practice.",
		"demoPrompt": "Interested in using PEOP Outcome Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1032-f-065-peop-009-r001-peop-outcome-review.md",
		"specId": "1032-f-065-peop-009-r001-peop-outcome-review",
		"tags": {
			"framework": [
				"PEOP"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Occupational participation",
				"Outcome monitoring",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during therapy or at conclusion when the practitioner needs visible change over time rather than a service activity summary."
			},
			{
				"title": "What It Compares",
				"body": "The review compares participation, occupational performance, and well-being information against goals, baseline, or prior review points."
			},
			{
				"title": "Important Limitation",
				"body": "The tool does not define standardized measures, thresholds, or automatic success judgments. Practitioner interpretation remains separate."
			}
		],
		"faqItems": [
			{
				"question": "Can this be completed with the client?",
				"answer": "Yes. The tool supports a ready-to-complete-together flow where the client contributes current outcome information."
			},
			{
				"question": "What happens if there is no baseline?",
				"answer": "The first completed review becomes the baseline for future comparison and should be labeled as such."
			},
			{
				"question": "Does the system decide whether therapy should end?",
				"answer": "No. The system shows longitudinal information; the practitioner records the interpretation for continuing, changing, or concluding therapy."
			},
			{
				"question": "What gets saved after the demo?",
				"answer": "The PEOP Outcome Review tool and supported setup are saved. Fictional sample responses and demo outcome records are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "kawaRiverDrawing",
		"slug": "kawa-river-drawing",
		"title": "Kawa River Drawing for OT Formulation | Qwoach",
		"metaDescription": "Invite clients to create a Kawa river drawing that expresses life flow, obstacles, personal factors, context, and openings for discussion.",
		"h1": "Kawa River Drawing",
		"intro": "Kawa River Drawing is a client-generated contextual formulation tool for occupational therapy. Practitioners send it to help clients express everyday life context, challenges, supports, well-being, and openings for change through the Kawa river metaphor.",
		"demoTitle": "Preview the drawing activity, review a sample result, and save this tool to share with clients.",
		"demoPrompt": "Interested in using Kawa River Drawing with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1033-f-066-kawa-001-r001-kawa-river-drawing.md",
		"specId": "1033-f-066-kawa-001-r001-kawa-river-drawing",
		"tags": {
			"framework": [
				"Kawa model"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client’s own lived experience needs to shape occupational therapy discussion and planning."
			},
			{
				"title": "Client And Practitioner Roles",
				"body": "The client creates the drawing before submission. The practitioner reviews it and adds interpretation separately."
			},
			{
				"title": "Important Limitation",
				"body": "The tool does not interpret the drawing, assign clinical meaning, or require scores or fixed ratings."
			}
		],
		"faqItems": [
			{
				"question": "Does the client have to label every river component?",
				"answer": "No. Labels and descriptions are optional where the client chooses to add them; the review should show when labels are absent."
			},
			{
				"question": "Can the drawing be completed later?",
				"answer": "Yes. In-progress drawings should be saved so expressive work is not lost."
			},
			{
				"question": "Is this a practitioner-only tool?",
				"answer": "No. The client/user view is central because the client creates the river drawing."
			},
			{
				"question": "What gets saved?",
				"answer": "The fixed Kawa River Drawing tool is saved. Fictional demo drawings and sample notes are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "waterLifeFlowRating",
		"slug": "water-life-flow-rating",
		"title": "Water / Life Flow Rating for OT Review | Qwoach",
		"metaDescription": "Capture a client’s current perceived life flow, energy, well-being, or participation signal and compare it across sessions when comparable.",
		"h1": "Water / Life Flow Rating",
		"intro": "Water / Life Flow Rating is a subjective well-being and participation signal tool for occupational therapy. Practitioners complete it with clients to capture the client’s current sense of life flow, energy, well-being, or participation and compare it over time when the same rating structure is used.",
		"demoTitle": "Review the shared rating flow and save this tool for session use.",
		"demoPrompt": "Interested in using Water / Life Flow Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1034-f-066-kawa-002-r001-water-life-flow-rating.md",
		"specId": "1034-f-066-kawa-002-r001-water-life-flow-rating",
		"tags": {
			"framework": [
				"Kawa model"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Occupational participation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it in session review when the practitioner needs a concise signal of the client’s perceived life flow, energy, well-being, or participation."
			},
			{
				"title": "Comparability",
				"body": "Signals are comparable only when the same rating structure is used over time. Changed structures should preserve history without forcing false trends."
			},
			{
				"title": "Important Limitation",
				"body": "The tool does not define scale anchors or clinical thresholds and does not interpret the meaning of a signal automatically."
			}
		],
		"faqItems": [
			{
				"question": "Is the rating scale defined?",
				"answer": "No. The product specification does not define the exact scale, anchors, labels, or prompt wording."
			},
			{
				"question": "Can signals be compared over time?",
				"answer": "Yes, when the same rating structure is used across entries. Incompatible structures should not be trended as if equivalent."
			},
			{
				"question": "Does the tool interpret a low or high signal?",
				"answer": "No. The system displays the reported signal and descriptive history; practitioner interpretation is recorded separately."
			},
			{
				"question": "What gets saved?",
				"answer": "The Water / Life Flow Rating tool is saved, along with any validated selected rating structure. Demo signals are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "rocksObstaclesMap",
		"slug": "rocks-obstacles-map",
		"title": "Rocks / Obstacles Map for OT Planning | Qwoach",
		"metaDescription": "Invite clients to identify Kawa rocks or obstacles blocking life flow and participation, then review a prioritized obstacle set for planning.",
		"h1": "Rocks / Obstacles Map",
		"intro": "Rocks / Obstacles Map is a client-generated barrier mapping tool for occupational therapy. Practitioners send it to help clients identify obstacles that block everyday life flow or participation and distinguish which barriers feel most important.",
		"demoTitle": "Preview the obstacle map and save this tool to share with a client.",
		"demoPrompt": "Interested in using Rocks / Obstacles Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1035-f-066-kawa-003-r001-rocks-obstacles-map.md",
		"specId": "1035-f-066-kawa-003-r001-rocks-obstacles-map",
		"tags": {
			"framework": [
				"Kawa model"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Environmental barriers",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when therapy planning needs to focus on barriers the client recognizes as meaningful."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures client-perceived obstacles and the client’s indication of relative importance or salience."
			},
			{
				"title": "Important Limitation",
				"body": "The system does not generate barrier categories, severity thresholds, or independent rankings."
			}
		],
		"faqItems": [
			{
				"question": "Does the system prioritize obstacles automatically?",
				"answer": "No. Priority or distinction must come from the client’s input; the system only displays it."
			},
			{
				"question": "Is the prioritization method defined?",
				"answer": "No. The product specification leaves the exact method unresolved, such as ordering, grouping, or sizing."
			},
			{
				"question": "Can a client submit no obstacles?",
				"answer": "Yes, only as an intentional no-obstacle state that is clearly confirmed rather than an accidental empty submission."
			},
			{
				"question": "What gets saved?",
				"answer": "The Rocks / Obstacles Map tool is saved. Fictional demo obstacles and priorities are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "driftwoodPersonalFactorsMap",
		"slug": "driftwood-personal-factors-map",
		"title": "Driftwood Personal Factors Map for OT | Qwoach",
		"metaDescription": "Capture client-identified personal factors that support or disrupt life flow and participation using the Kawa driftwood concept.",
		"h1": "Driftwood / Personal Factors Map",
		"intro": "Driftwood / Personal Factors Map is a client-generated personal-factor mapping tool for occupational therapy. Practitioners send it to help clients identify history, traits, values, resources, or vulnerabilities that may support or disrupt participation and life flow.",
		"demoTitle": "Preview the personal-factor map and save this tool to share with a client.",
		"demoPrompt": "Interested in using Driftwood / Personal Factors Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1036-f-066-kawa-004-r001-driftwood-personal-factors-map.md",
		"specId": "1036-f-066-kawa-004-r001-driftwood-personal-factors-map",
		"tags": {
			"framework": [
				"Kawa model"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Occupational participation",
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when therapy planning needs to account for the client’s own view of resources, vulnerabilities, values, history, or traits."
			},
			{
				"title": "Sensitive Information",
				"body": "Clients should be able to skip, leave vague, or mark factors unclear without forced disclosure."
			},
			{
				"title": "Important Limitation",
				"body": "The tool does not infer personality traits, vulnerabilities, resources, or risk conclusions without user input."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool classify personal factors automatically?",
				"answer": "No. Supportive, disruptive, mixed, or unclear roles come from the client or practitioner input, not system inference."
			},
			{
				"question": "Can a client leave an entry vague?",
				"answer": "Yes. The experience should avoid forcing disclosure beyond what the client chooses to provide."
			},
			{
				"question": "Are fixed personal-factor categories included?",
				"answer": "No. The product specification does not define fixed categories or personality measures."
			},
			{
				"question": "What gets saved?",
				"answer": "The Driftwood / Personal Factors Map tool is saved. Fictional demo entries and notes are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "riverbanksEnvironmentalContextMap",
		"slug": "riverbanks-environmental-context-map",
		"title": "Riverbanks Environmental Context Map for OT | Qwoach",
		"metaDescription": "Capture client-described environmental conditions that support, constrain, or define participation and life flow using the Kawa riverbanks concept.",
		"h1": "Riverbanks / Environmental Context Map",
		"intro": "Riverbanks / Environmental Context Map is a client-generated environmental context mapping tool for occupational therapy. Practitioners send it to help clients identify surrounding conditions that support, constrain, or define participation and life flow.",
		"demoTitle": "Preview the context map and save this tool to share with a client.",
		"demoPrompt": "Interested in using Riverbanks / Environmental Context Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1037-f-066-kawa-005-r001-riverbanks-environmental-context-map.md",
		"specId": "1037-f-066-kawa-005-r001-riverbanks-environmental-context-map",
		"tags": {
			"framework": [
				"Kawa model"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Environmental barriers",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when intervention planning needs to reflect the client’s real-life environmental or contextual conditions."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures client-described conditions and their perceived role as supports, constraints, defining context, mixed, or unclear where entered."
			},
			{
				"title": "Important Limitation",
				"body": "The tool does not provide legal accommodation determinations, safety ratings, standardized scores, or system-generated recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is this an environmental assessment checklist?",
				"answer": "No. It is a Kawa riverbanks context map, not a standardized environmental assessment or checklist."
			},
			{
				"question": "Can a condition be both supportive and constraining?",
				"answer": "Yes. Mixed or unclear roles should be allowed instead of forcing a single classification."
			},
			{
				"question": "Does the system decide what a condition means?",
				"answer": "No. The system groups or displays client-indicated roles; it does not infer environmental meaning independently."
			},
			{
				"question": "What gets saved?",
				"answer": "The Riverbanks / Environmental Context Map tool is saved. Fictional demo context entries are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "spacesInterventionOpportunitiesMap",
		"slug": "spaces-intervention-opportunities-map",
		"title": "Spaces Intervention Opportunities Map for OT | Qwoach",
		"metaDescription": "Identify grounded Kawa spaces or openings where small changes may improve life flow and participation, using client-stated context.",
		"h1": "Spaces / Intervention Opportunities Map",
		"intro": "Spaces / Intervention Opportunities Map is a collaborative occupational therapy planning tool within the Kawa model. Practitioners complete it with clients to identify openings where change may be possible and link each opportunity to the client’s stated obstacles, personal factors, or environmental context.",
		"demoTitle": "Try a sample opportunity map and save this tool for shared planning.",
		"demoPrompt": "Interested in using Spaces / Intervention Opportunities Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1038-f-066-kawa-006-r001-spaces-intervention-opportunities-map.md",
		"specId": "1038-f-066-kawa-006-r001-spaces-intervention-opportunities-map",
		"tags": {
			"framework": [
				"Kawa model"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Occupational participation",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after or during Kawa formulation work when the practitioner and client can identify openings grounded in obstacles, personal factors, or context."
			},
			{
				"title": "Grounding Links",
				"body": "Each opportunity should connect back to the client-stated elements it relates to. Ungrounded opportunities remain visible as incomplete or draft."
			},
			{
				"title": "Important Limitation",
				"body": "The tool does not generate intervention strategies, rank opportunities, or predict success."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create treatment recommendations?",
				"answer": "No. It identifies and organizes possible openings for change; the practitioner remains responsible for planning interpretation."
			},
			{
				"question": "Can it be used without prior Kawa elements?",
				"answer": "Yes, but opportunities should be marked as incompletely grounded when no source elements are linked."
			},
			{
				"question": "What configuration is saved?",
				"answer": "The tool is saved, along with supported source-element selection or review setup where applicable. Demo opportunities are not saved as real client data."
			},
			{
				"question": "Who completes the map?",
				"answer": "It is designed to be completed together by the practitioner and client."
			}
		]
	},
	{
		"toolType": "pastPresentFutureRiver",
		"slug": "past-present-future-river",
		"title": "Past Present Future River for OT Planning | Qwoach",
		"metaDescription": "Invite clients to map past, present, and desired future life flow, obstacles, supports, and goals in a Kawa river narrative.",
		"h1": "Past–Present–Future River",
		"intro": "Past–Present–Future River is a temporal narrative mapping tool for occupational therapy. Practitioners send it to help clients distinguish past, present, and desired future life flow, obstacles, supports, and goals so therapy can align with the client’s change story.",
		"demoTitle": "Preview the three-state river activity and save this tool to share with a client.",
		"demoPrompt": "Interested in using Past–Present–Future River with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1039-f-066-kawa-007-r001-past-present-future-river.md",
		"specId": "1039-f-066-kawa-007-r001-past-present-future-river",
		"tags": {
			"framework": [
				"Kawa model"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Goal setting"
			],
			"topic": [
				"Occupational participation",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at selected planning or review moments when change story and future direction matter for therapy alignment."
			},
			{
				"title": "What It Shows",
				"body": "The result shows past, present, and desired future states as distinct parts of one client-generated narrative."
			},
			{
				"title": "Important Limitation",
				"body": "The tool does not infer goals, assign priorities, or create standardized change scores."
			}
		],
		"faqItems": [
			{
				"question": "Are the time states configurable?",
				"answer": "No. This tool uses three fixed states: past, present, and desired future."
			},
			{
				"question": "Can a future state be tentative?",
				"answer": "Yes. The future state can remain tentative; the tool should not force specificity beyond the client’s expression."
			},
			{
				"question": "Does the system interpret changes across states?",
				"answer": "No. It may show differences in entered content, but practitioner interpretation remains separate."
			},
			{
				"question": "What gets saved?",
				"answer": "The fixed Past–Present–Future River tool is saved. Fictional demo narratives are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "digitalKawaRiverBuilder",
		"slug": "digital-kawa-river-builder",
		"title": "Digital Kawa River Builder for OT | Qwoach",
		"metaDescription": "Send a digital Kawa river builder so clients can create a shareable visual artifact of life flow, obstacles, context, and openings.",
		"h1": "Digital Kawa River Builder",
		"intro": "Digital Kawa River Builder is a digital client-generated visual formulation tool for occupational therapy. Practitioners send it so clients can express everyday life story, life flow, obstacles, personal factors, environmental context, and possible openings for change in a shareable river form outside or between sessions.",
		"demoTitle": "Preview the builder, review a sample artifact, and save this tool to share with clients.",
		"demoPrompt": "Interested in using Digital Kawa River Builder with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1040-f-066-kawa-008-r001-digital-kawa-river-builder.md",
		"specId": "1040-f-066-kawa-008-r001-digital-kawa-river-builder",
		"tags": {
			"framework": [
				"Kawa model"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Between-session monitoring"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it outside or between sessions when the client can create a visual account that will later support therapeutic discussion."
			},
			{
				"title": "What It Captures",
				"body": "The artifact can include life flow, obstacles, personal factors, environmental context, and possible openings for change, plus optional labels or descriptions."
			},
			{
				"title": "Important Limitation",
				"body": "The tool does not generate interpretations, scores, diagnostic conclusions, or unrelated creative features."
			},
			{
				"title": "Accessibility",
				"body": "Non-drawing interactions may support clients who cannot draw digitally, as long as the result remains a visual river artifact with the same component meaning."
			}
		],
		"faqItems": [
			{
				"question": "Is the visual artifact the main result?",
				"answer": "Yes. The completed digital Kawa river artifact is the primary result, with labels or descriptions as supporting detail."
			},
			{
				"question": "Can clients save and resume?",
				"answer": "Yes. The builder should preserve progress and allow recovery from interruption."
			},
			{
				"question": "Does every component have to be included?",
				"answer": "No. The artifact should not force every possible component if the client’s account does not include it."
			},
			{
				"question": "What gets saved?",
				"answer": "The fixed Digital Kawa River Builder tool is saved. Demo artifacts and sample labels are not saved as real client data by default."
			}
		]
	},
	{
		"toolType": "collaborativeGoalSetting",
		"slug": "collaborative-goal-setting",
		"title": "Collaborative Goal Setting Demo for Occupational Goals | Qwoach",
		"metaDescription": "Explore a shared goal-setting tool for capturing client-defined occupational goals tied to priority activities and later strategy work.",
		"h1": "Collaborative Goal Setting",
		"intro": "Collaborative Goal Setting is a shared practitioner-client tool for occupational therapy practitioners beginning goal-focused intervention. It helps the practitioner and client turn the client's priority activities into concrete occupational goals that can guide later strategy work and performance review.",
		"demoTitle": "Start with a sample goal-setting record and add or revise draft goals without entering real client information.",
		"demoPrompt": "Interested in using Collaborative Goal Setting with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1041-f-067-coop-001-r001-collaborative-goal-setting.md",
		"specId": "1041-f-067-coop-001-r001-collaborative-goal-setting",
		"tags": {
			"framework": [
				"CO-OP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Occupational participation",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it at the beginning of goal-focused occupational performance intervention, before later strategy selection, task analysis, or performance review depends on a confirmed goal."
			},
			{
				"title": "What It Captures",
				"body": "The record captures client priority wording, the specific occupational activity or performance context, goal readiness, and unresolved clarification notes."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not add standardized scores, diagnostic interpretation, predefined goal domains, importance ratings, difficulty ratings, or intervention strategies."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create goals from a library?",
				"answer": "No. Goals remain client-defined. The tool organizes client priority wording and concrete occupational activity or performance context rather than supplying a generic goal library."
			},
			{
				"question": "Can a goal stay unfinished?",
				"answer": "Yes. Partial goals remain visible as drafts until the client priority and specific activity or performance context are clear enough for later strategy work."
			},
			{
				"question": "Is there a separate client assignment?",
				"answer": "No. The client participates in a guided shared interaction with the practitioner rather than completing an independent assignment."
			}
		]
	},
	{
		"toolType": "dynamicPerformanceAnalysisDpa",
		"slug": "dynamic-performance-analysis-dpa",
		"title": "Dynamic Performance Analysis Demo for Goal Tasks | Qwoach",
		"metaDescription": "Explore a practitioner-only DPA tool for separating task demands, observed performance difficulties, and key breakdown points.",
		"h1": "Dynamic Performance Analysis (DPA)",
		"intro": "Dynamic Performance Analysis (DPA) is a practitioner-only task analysis tool for occupational therapy practitioners. It helps the practitioner create a task-specific performance profile by distinguishing observable task demands from the client's performance difficulties and identifying key breakdown points.",
		"demoTitle": "Open a fictional goal task and build a sample performance profile without entering real client details.",
		"demoPrompt": "Interested in using Dynamic Performance Analysis (DPA) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1042-f-067-coop-002-r001-dynamic-performance-analysis-dpa.md",
		"specId": "1042-f-067-coop-002-r001-dynamic-performance-analysis-dpa",
		"tags": {
			"framework": [
				"CO-OP"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures the selected goal task, observable task demands, observed performance difficulties, key breakdown points, and optional observation notes."
			},
			{
				"title": "Practitioner Role",
				"body": "The practitioner creates and controls the DPA record. The product can support readable review, but it does not require direct client completion."
			},
			{
				"title": "Relevant Limitations",
				"body": "DPA does not provide standardized scores, diagnosis, strategy prescriptions, generic skill checklists, or automated causal interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Is DPA a client questionnaire?",
				"answer": "No. DPA is practitioner-only. It organizes practitioner observation and analysis of a specific goal task."
			},
			{
				"question": "Can the demo generate intervention strategies?",
				"answer": "No. The tool identifies key breakdown points that may inform later strategy selection, but it does not prescribe strategies."
			},
			{
				"question": "What makes a DPA profile complete?",
				"answer": "A profile is complete when it is tied to an actual goal task, separates task demands from performance difficulties, and identifies specific breakdown points grounded in observed performance."
			}
		]
	},
	{
		"toolType": "globalStrategyGoalPlanDoCheck",
		"slug": "global-strategy-goal-plan-do-check",
		"title": "Goal-Plan-Do-Check Strategy Cycle Demo | Qwoach",
		"metaDescription": "Explore a shared Goal-Plan-Do-Check tool for linking a client goal to a plan, attempt, check, and next adjustment.",
		"h1": "Global Strategy: Goal-Plan-Do-Check",
		"intro": "Global Strategy: Goal-Plan-Do-Check is a shared practitioner-client tool for occupational therapy practitioners supporting meaningful performance goals. It helps the client and practitioner connect a specific goal task to a plan, an observable attempt, a check of what happened, and a next adjustment.",
		"demoTitle": "Try a fictional Goal-Plan-Do-Check cycle and review how a new iteration preserves the prior one.",
		"demoPrompt": "Interested in using Global Strategy: Goal-Plan-Do-Check with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1043-f-067-coop-003-r001-global-strategy-goal-plan-do-check.md",
		"specId": "1043-f-067-coop-003-r001-global-strategy-goal-plan-do-check",
		"tags": {
			"framework": [
				"CO-OP"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Occupational participation",
				"Problem solving",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Repeat Use",
				"body": "Repeating the cycle creates a new iteration rather than overwriting prior Goal, Plan, Do, Check, and adjustment content."
			},
			{
				"title": "Practitioner and Client Roles",
				"body": "The practitioner facilitates and controls the record. The client contributes the plan, participates in the attempt, reflects on what happened, and identifies the next adjustment."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not add scoring, predefined strategy categories, clinical interpretation, or substantive coaching content beyond the named cycle stages."
			}
		],
		"faqItems": [
			{
				"question": "Does the cycle have to be completed in one sitting?",
				"answer": "No. If interrupted, the cycle resumes at the last incomplete stage."
			},
			{
				"question": "Can prior cycles be edited away by repeating the process?",
				"answer": "No. Repeating the cycle creates a new iteration so prior goal, plan, attempt, check, and adjustment content remains available."
			},
			{
				"question": "Does the tool judge whether a plan worked?",
				"answer": "No. It records the client's check of what happened and the next adjustment; it does not score or interpret plan quality."
			}
		]
	},
	{
		"toolType": "domainSpecificStrategyRecord",
		"slug": "domain-specific-strategy-record",
		"title": "Domain-Specific Strategy Record Demo | Qwoach",
		"metaDescription": "Explore a strategy record for preserving client-owned strategies and linking each one to the performance situations where it helped.",
		"h1": "Domain-Specific Strategy Record",
		"intro": "Domain-Specific Strategy Record is a shared or assignable tool for occupational therapy practitioners and clients. It helps preserve individualized cognitive strategies, link each strategy to the performance situation where it was useful, and make those strategies available for similar future tasks.",
		"demoTitle": "Add a fictional strategy entry and see how situation links make it retrievable later.",
		"demoPrompt": "Interested in using Domain-Specific Strategy Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1044-f-067-coop-004-r001-domain-specific-strategy-record.md",
		"specId": "1044-f-067-coop-004-r001-domain-specific-strategy-record",
		"tags": {
			"framework": [
				"CO-OP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Occupational participation",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "Each entry captures strategy wording, the performance situation where it was useful, optional goal or barrier context, ownership status, and practitioner notes kept separate from client-owned content."
			},
			{
				"title": "Repeat Use",
				"body": "Strategies can be retrieved later for similar situations and can accumulate multiple situation links without implying universal effectiveness."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not provide a generic strategy catalog, score strategy quality, or generate strategy recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Are strategies generated by the product?",
				"answer": "No. Strategies are client-generated or client-owned, with practitioner notes kept distinct."
			},
			{
				"question": "Can a strategy apply to more than one situation?",
				"answer": "Yes. A strategy may be linked to multiple situations, and those links remain visible for later retrieval."
			},
			{
				"question": "Can clients use this outside a session?",
				"answer": "The tool can support lightweight client review and contribution where supported, but exact independent client-add behavior remains a product-design assumption requiring validation."
			}
		]
	},
	{
		"toolType": "guidedDiscoveryPromptSet",
		"slug": "guided-discovery-prompt-set",
		"title": "Guided Discovery Prompt Set Demo | Qwoach",
		"metaDescription": "Explore a live-session guided discovery aid for recording client-identified performance features, barriers, and strategies.",
		"h1": "Guided Discovery Prompt Set",
		"intro": "Guided Discovery Prompt Set is a live-session practitioner aid for occupational therapy practitioners. It helps the practitioner track a performance barrier, support the client's own reasoning, and record the client-identified feature or strategy that emerges during guided discovery.",
		"demoTitle": "Open a fictional live-session record and capture the barrier, client-discovered feature, and resulting strategy.",
		"demoPrompt": "Interested in using Guided Discovery Prompt Set with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1045-f-067-coop-005-r001-guided-discovery-prompt-set.md",
		"specId": "1045-f-067-coop-005-r001-guided-discovery-prompt-set",
		"tags": {
			"framework": [
				"CO-OP"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Occupational participation",
				"Problem solving"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Live-Session Use",
				"body": "The tool is intended for use during live practitioner-client interaction, not as a separate client assignment."
			},
			{
				"title": "What It Captures",
				"body": "It captures the performance barrier, client-identified feature, resulting strategy or understanding, ownership note, and optional practitioner facilitation notes."
			},
			{
				"title": "Relevant Limitations",
				"body": "The product must not invent exact prompt wording, standardized scores, diagnostic conclusions, or practitioner-generated answers presented as client discovery."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include scripted guided discovery prompts?",
				"answer": "No. Exact prompt content is unresolved in the product specification, so the demo uses placeholder structure for prompt intent and notes only."
			},
			{
				"question": "Is this a client homework tool?",
				"answer": "No. The tool is live-session-only; the client contributes through conversation and performance problem solving with the practitioner."
			},
			{
				"question": "What makes a record complete?",
				"answer": "A record is complete when it includes the explored barrier, a client-identified performance or task feature, and a resulting strategy or understanding connected to that barrier."
			}
		]
	},
	{
		"toolType": "performanceVideoReview",
		"slug": "performance-video-review",
		"title": "Performance Video Review Demo for Goal Tasks | Qwoach",
		"metaDescription": "Explore a shared video review tool for marking observable performance moments and linking client interpretation to strategies.",
		"h1": "Performance Video Review",
		"intro": "Performance Video Review is a shared practitioner-client tool for occupational therapy practitioners reviewing a recorded goal task. It helps mark observable moments, capture the client's interpretation of what affected performance, and link a strategy or adjustment to what was observed.",
		"demoTitle": "Review a fictional sample video timeline with markers for success, difficulty, client interpretation, and linked adjustments.",
		"demoPrompt": "Interested in using Performance Video Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1046-f-067-coop-006-r001-performance-video-review.md",
		"specId": "1046-f-067-coop-006-r001-performance-video-review",
		"tags": {
			"framework": [
				"CO-OP"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"In-session support"
			],
			"topic": [
				"Occupational participation",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures video-linked moments, descriptive observation notes, client interpretation, and strategies or adjustments connected to those moments."
			},
			{
				"title": "Practitioner and Client Roles",
				"body": "The practitioner creates and controls the review record. The client participates in shared review by noticing moments, interpreting performance, and connecting observations to adjustments."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not perform automated clinical interpretation, scoring, facial or emotion analysis, or broad conclusions beyond the reviewed performance moments."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo work without a video?",
				"answer": "No. Video review requires a video or recorded performance reference; it should not be replaced by a generic reflection form."
			},
			{
				"question": "Does the tool analyze the video automatically?",
				"answer": "No. The tool organizes practitioner and client review using time-anchored markers; it does not generate automated meaning or clinical conclusions."
			},
			{
				"question": "What makes a marker useful?",
				"answer": "A useful marker points to a specific observable moment and can include client interpretation plus a linked strategy or adjustment when one is identified."
			}
		]
	},
	{
		"toolType": "goalPerformanceRating",
		"slug": "goal-performance-rating",
		"title": "Goal Performance Rating Demo | Qwoach",
		"metaDescription": "Explore a longitudinal goal tracking tool for repeated performance information tied to stable client-defined occupational goals.",
		"h1": "Goal Performance Rating",
		"intro": "Goal Performance Rating is a longitudinal tracking tool for occupational therapy practitioners monitoring specific client-defined occupational goals. It helps preserve repeated goal-specific performance information so the practitioner can review whether ability is changing across time.",
		"demoTitle": "Review the sample goal-tracking setup and unresolved rating-structure requirement before saving the tool.",
		"demoPrompt": "Interested in using Goal Performance Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1047-f-067-coop-007-r001-goal-performance-rating.md",
		"specId": "1047-f-067-coop-007-r001-goal-performance-rating",
		"tags": {
			"framework": [
				"CO-OP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Occupational participation",
				"Outcome monitoring",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Tracks",
				"body": "The tool tracks repeated performance information by stable client-defined goal, source, and time point."
			},
			{
				"title": "Comparability Over Time",
				"body": "If goal wording changes, the practitioner must decide whether to continue the old series or start a new comparable series."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool must not import COPM semantics, invent scale anchors, add satisfaction ratings, treat attendance as performance change, or generate discharge recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo enter ratings today?",
				"answer": "No. Rating entry requires a supported performance rating structure, and the supplied product specification does not define the scale or anchors."
			},
			{
				"question": "Does this tool use COPM scoring?",
				"answer": "No. COPM-specific fields or semantics are not part of the supplied product behavior and must not be introduced."
			},
			{
				"question": "What information is preserved for each rating?",
				"answer": "Each real rating must be tied to a stable goal, a source, and a time point so change can be reviewed by goal over time."
			}
		]
	},
	{
		"toolType": "strategyGeneralizationPlan",
		"slug": "strategy-generalization-plan",
		"title": "Strategy Generalization Plan Demo | Qwoach",
		"metaDescription": "Explore a transfer planning tool for linking learned strategies to new everyday target activities and later outcomes.",
		"h1": "Strategy Generalization Plan",
		"intro": "Strategy Generalization Plan is a shared practitioner-client tool for occupational therapy practitioners helping clients apply learned strategies beyond the original task. It helps identify transfer targets, name which strategy applies to each new situation, and later record whether the strategy supported performance there.",
		"demoTitle": "Create a fictional transfer target and review how pending targets become completed outcomes.",
		"demoPrompt": "Interested in using Strategy Generalization Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1048-f-067-coop-008-r001-strategy-generalization-plan.md",
		"specId": "1048-f-067-coop-008-r001-strategy-generalization-plan",
		"tags": {
			"framework": [
				"CO-OP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Occupational participation",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures the original task, learned strategy, transfer target, planned use, pending or completed status, later outcome, and client notes where entered."
			},
			{
				"title": "Transfer Target Requirements",
				"body": "A transfer target should be meaningfully different from the original task while still relevant to the client."
			},
			{
				"title": "Relevant Limitations",
				"body": "The product does not generate target activities, prescribe practice steps, use unsupported generalization scores, or claim universal transfer."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool suggest transfer targets automatically?",
				"answer": "No. Transfer targets are identified by the practitioner and client; the product organizes them and tracks later outcomes."
			},
			{
				"question": "What happens if the target is the same as the original task?",
				"answer": "The target should be flagged because it does not demonstrate transfer to a different context."
			},
			{
				"question": "Are outcomes scored?",
				"answer": "No supported outcome rating structure is defined in the supplied specification, so outcomes are captured descriptively unless a valid structure is supplied elsewhere."
			}
		]
	},
	{
		"toolType": "evaluationInAyresSensoryIntegrationEasi",
		"slug": "evaluation-in-ayres-sensory-integration-easi",
		"title": "EASI Assessment Configuration Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only EASI assessment configuration for standardized sensory integration profiling in children aged 3-12.",
		"h1": "Evaluation in Ayres Sensory Integration (EASI)",
		"intro": "Evaluation in Ayres Sensory Integration (EASI) is a practitioner-only standardized assessment configuration for practitioners evaluating children aged 3-12. It helps record supported EASI test completion and results so a comprehensive sensory integration profile can be generated according to supported scoring rules.",
		"demoTitle": "Inspect the sample practitioner workflow and unresolved scoring-configuration requirement without entering real child information.",
		"demoPrompt": "Interested in using Evaluation in Ayres Sensory Integration (EASI) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1049-f-068-asi-001-r001-evaluation-in-ayres-sensory-integration-easi.md",
		"specId": "1049-f-068-asi-001-r001-evaluation-in-ayres-sensory-integration-easi",
		"tags": {
			"framework": [
				"Ayres Sensory Integration"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Sensory integration",
				"Developmental functioning"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Age Applicability",
				"body": "The defined tool applies to children aged 3-12; children outside that range should be flagged as outside the supported age range."
			},
			{
				"title": "Assessment Fidelity",
				"body": "Incomplete tests remain incomplete, unsupported scoring cannot be substituted, and reported concerns, standardized results, and practitioner interpretation remain distinct."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool must not invent EASI test items, scoring rules, norms, domains, automated diagnoses, or intervention prescriptions."
			}
		],
		"faqItems": [
			{
				"question": "Can the public demo show EASI scores?",
				"answer": "No. Real standardized scores require supported EASI scoring rules and norms, which are unresolved in the supplied product specification."
			},
			{
				"question": "Is there a child or caregiver form?",
				"answer": "No. The product is practitioner-only; the child participates through practitioner-administered testing."
			},
			{
				"question": "What blocks a complete profile?",
				"answer": "Missing test completion or missing supported scoring rules blocks a complete standardized profile."
			}
		]
	},
	{
		"toolType": "easiSensoryPerceptionProfile",
		"slug": "easi-sensory-perception-profile",
		"title": "EASI Sensory Perception Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only EASI sensory perception profile for standardized domain-specific strengths and difficulties.",
		"h1": "EASI Sensory Perception Profile",
		"intro": "EASI Sensory Perception Profile is a practitioner-only standardized EASI domain output for practitioners evaluating children. It helps organize supported sensory perception scores and links to observed participation, learning, or behavior concerns while keeping sensory perception distinct from other sensory or motor domains.",
		"demoTitle": "Inspect the sample domain-profile workflow and unresolved sensory perception scoring requirement.",
		"demoPrompt": "Interested in using EASI Sensory Perception Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1050-f-068-asi-002-r001-easi-sensory-perception-profile.md",
		"specId": "1050-f-068-asi-002-r001-easi-sensory-perception-profile",
		"tags": {
			"framework": [
				"Ayres Sensory Integration"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Sensory integration",
				"Developmental functioning"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Domain-Specific Scope",
				"body": "The profile is sensory-perception-specific and should not mix sensory perception findings with other sensory or motor domain conclusions."
			},
			{
				"title": "Concern Links",
				"body": "Findings can be linked to observed participation, learning, or behavior concerns, while those concerns remain distinct from standardized scores."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool must not invent sensory perception test items, scoring, norms, domain rules, diagnoses, or intervention recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo calculate sensory perception scores?",
				"answer": "No. Score calculation requires valid EASI sensory perception tests, scoring rules, and norms, which are unresolved in the supplied product specification."
			},
			{
				"question": "Is this the full EASI profile?",
				"answer": "No. This tool is a sensory perception domain output and should remain distinct from full EASI profiling and other sensory or motor domains."
			},
			{
				"question": "Can findings be valid without concern links?",
				"answer": "Yes. Findings can remain valid but visibly unlinked when no observed participation, learning, or behavior concern has been connected."
			}
		]
	},
	{
		"toolType": "easiPosturalOcularBilateralMotorProfile",
		"slug": "easi-postural-ocular-bilateral-motor-profile",
		"title": "EASI Postural/Ocular/Bilateral Motor Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only EASI profile for postural, ocular, and bilateral motor integration domains with standardized score review.",
		"h1": "EASI Postural/Ocular/Bilateral Motor Profile",
		"intro": "The EASI Postural/Ocular/Bilateral Motor Profile is a practitioner-only assessment profile for sensory integration practitioners. It helps practitioners organize supported assessment information into standardized postural, ocular, and bilateral motor integration domain scores so motor integration findings can be reviewed in relation to functional performance.",
		"demoTitle": "Try the sample profile and review the three-domain score output.",
		"demoPrompt": "Interested in using EASI Postural/Ocular/Bilateral Motor Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1051-f-068-asi-003-r001-easi-postural-ocular-bilateral-motor-profile.md",
		"specId": "1051-f-068-asi-003-r001-easi-postural-ocular-bilateral-motor-profile",
		"tags": {
			"framework": [
				"Ayres Sensory Integration"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Sensory integration",
				"Occupational participation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Fixed Three-Domain Scope",
				"body": "The profile is limited to postural motor integration, ocular motor integration, and bilateral motor integration. Changing the domain set would create a different product, not a setting."
			},
			{
				"title": "Partial Profiles",
				"body": "Incomplete domains remain visibly incomplete and are not presented as complete standardized score outputs until required supported information is present."
			},
			{
				"title": "History Use",
				"body": "Completed dated profiles can be preserved for later comparison when the same domain scoring basis is available."
			}
		],
		"faqItems": [
			{
				"question": "Can I change the domains in this profile?",
				"answer": "No. The profile is fixed to postural motor integration, ocular motor integration, and bilateral motor integration."
			},
			{
				"question": "Does the tool create intervention recommendations?",
				"answer": "No. It organizes supported assessment information into standardized domain scores and allows practitioner-entered functional links, but it does not prescribe activities or treatment priorities."
			},
			{
				"question": "Is there a client-facing version?",
				"answer": "No. The product is practitioner-only; child participation, if any, happens through practitioner assessment workflow rather than a separate digital task."
			},
			{
				"question": "What happens if a domain is incomplete?",
				"answer": "The incomplete domain remains marked as incomplete, and the tool does not fabricate a complete score for that domain."
			}
		]
	},
	{
		"toolType": "easiPraxisProfile",
		"slug": "easi-praxis-profile",
		"title": "EASI Praxis Profile Demo for Practitioners | Qwoach",
		"metaDescription": "Explore a practitioner-only EASI praxis profile for action planning and execution findings, completion review, and functional examples.",
		"h1": "EASI Praxis Profile",
		"intro": "The EASI Praxis Profile is a practitioner-only assessment profile for sensory integration practitioners. It helps practitioners organize supported praxis assessment information into a profile of strengths and difficulties in action planning and execution, with optional links to everyday activities where action planning matters.",
		"demoTitle": "Try a sample praxis profile and review the practitioner result.",
		"demoPrompt": "Interested in using EASI Praxis Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1052-f-068-asi-004-r001-easi-praxis-profile.md",
		"specId": "1052-f-068-asi-004-r001-easi-praxis-profile",
		"tags": {
			"framework": [
				"Ayres Sensory Integration"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Sensory integration",
				"Occupational participation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Praxis Focus",
				"body": "The tool keeps the result focused on action planning and execution rather than broad motor concerns."
			},
			{
				"title": "Functional Examples",
				"body": "Practitioner-entered everyday-activity examples can be shown beside profile output as context, but they are not treated as scored inputs unless supported by the measure."
			},
			{
				"title": "Draft and History States",
				"body": "Incomplete profiles remain drafts, and completed dated profiles can be preserved for later descriptive comparison when the same structure is used."
			}
		],
		"faqItems": [
			{
				"question": "Is this a therapy activity generator?",
				"answer": "No. The EASI Praxis Profile organizes supported praxis assessment information and does not generate activities or treatment plans."
			},
			{
				"question": "Can I add custom praxis dimensions?",
				"answer": "No. Adding unsupported dimensions would go beyond the fixed represented profile."
			},
			{
				"question": "What can I add as practitioner context?",
				"answer": "You can add concise everyday-activity examples that connect findings to action planning, while keeping them separate from scored assessment output."
			},
			{
				"question": "Does the demo require real child information?",
				"answer": "No. The public demo uses fictional sample context and should not collect real client-identifying information."
			}
		]
	},
	{
		"toolType": "easiSensoryReactivityProfile",
		"slug": "easi-sensory-reactivity-profile",
		"title": "EASI Sensory Reactivity Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only EASI sensory reactivity profile for response-pattern review, completion status, and functional context notes.",
		"h1": "EASI Sensory Reactivity Profile",
		"intro": "The EASI Sensory Reactivity Profile is a practitioner-only assessment profile for sensory integration practitioners. It helps practitioners organize supported sensory reactivity assessment information into a focused profile of sensory response patterns that may relate to learning, behavior, or participation.",
		"demoTitle": "Explore a sample sensory reactivity profile.",
		"demoPrompt": "Interested in using EASI Sensory Reactivity Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1053-f-068-asi-005-r001-easi-sensory-reactivity-profile.md",
		"specId": "1053-f-068-asi-005-r001-easi-sensory-reactivity-profile",
		"tags": {
			"framework": [
				"Ayres Sensory Integration"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Sensory integration"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Focused Reactivity Scope",
				"body": "The profile is limited to sensory reactivity. It should not be used to record perception, praxis, or motor integration results unless supported by the represented profile."
			},
			{
				"title": "Context Notes",
				"body": "Practitioner notes can connect response patterns to learning, behavior, or participation as descriptive context, not as system-generated clinical meaning."
			},
			{
				"title": "Longitudinal Review",
				"body": "Completed profiles can be date-stamped for later comparison when the same supported outputs are available."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create sensory strategies?",
				"answer": "No. It creates a sensory reactivity profile and does not generate environmental supports or intervention protocols."
			},
			{
				"question": "Can I use it for praxis or motor integration scoring?",
				"answer": "No. The tool is limited to sensory reactivity and does not include praxis, perception, or motor integration scores."
			},
			{
				"question": "What happens to incomplete assessment information?",
				"answer": "Incomplete profiles remain draft and identify missing required information rather than creating unsupported patterns."
			},
			{
				"question": "Is there a caregiver form in this product?",
				"answer": "No. The specification supports a practitioner-only workflow and does not define a separate caregiver questionnaire."
			}
		]
	},
	{
		"toolType": "sensoryProcessingMeasureSpm",
		"slug": "sensory-processing-measure-spm",
		"title": "Sensory Processing Measure SPM Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send SPM workflow for context-based sensory reporting, respondent completion, and practitioner profile review.",
		"h1": "Sensory Processing Measure (SPM)",
		"intro": "The Sensory Processing Measure (SPM) is a ready-to-send context-based sensory profile measure for practitioners. It helps practitioners gather caregiver, teacher, or other everyday-context information about a child's sensory functioning and review the resulting context-based sensory profile alongside direct assessment information.",
		"demoTitle": "Choose a sample context and preview the send-and-review flow.",
		"demoPrompt": "Interested in using Sensory Processing Measure (SPM) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1054-f-068-asi-006-r001-sensory-processing-measure-spm.md",
		"specId": "1054-f-068-asi-006-r001-sensory-processing-measure-spm",
		"tags": {
			"framework": [
				"Ayres Sensory Integration"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Sensory integration",
				"Occupational participation"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Respondent and Context Labels",
				"body": "Profiles remain distinct by respondent or everyday context so practitioners can consider where the information came from."
			},
			{
				"title": "Partial Completion",
				"body": "Respondent work can remain pending, with unanswered required items identified before a complete profile is derived."
			},
			{
				"title": "Comparison Use",
				"body": "Completed profiles can be compared by date and context only where compatible forms and outputs are used."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the SPM in this workflow?",
				"answer": "A caregiver, teacher, or other context-based respondent can complete the assigned measure, and the practitioner reviews the returned profile."
			},
			{
				"question": "Can I customize the SPM questions?",
				"answer": "No. The tool does not support custom item editing or invented sensory domains."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews the context-based sensory profile, respondent/context label, completion state, date, and any practitioner notes."
			},
			{
				"question": "Does it replace direct assessment?",
				"answer": "No. The profile is context-based information that can be considered alongside direct assessment results."
			}
		]
	},
	{
		"toolType": "easiScoringProgramEsp",
		"slug": "easi-scoring-program-esp",
		"title": "EASI Scoring Program ESP Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only ESP workflow for entering collected EASI raw data, validating completeness, and reviewing standardized domain scores.",
		"h1": "EASI Scoring Program (ESP)",
		"intro": "The EASI Scoring Program (ESP) is a practitioner-only scoring program for practitioners using collected EASI assessment data. It helps convert supported raw assessment information into calculated standardized scores organized by sensory integration domains for practitioner interpretation.",
		"demoTitle": "Enter sample raw data placeholders and review the score output.",
		"demoPrompt": "Interested in using EASI Scoring Program (ESP) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1055-f-068-asi-007-r001-easi-scoring-program-esp.md",
		"specId": "1055-f-068-asi-007-r001-easi-scoring-program-esp",
		"tags": {
			"framework": [
				"Ayres Sensory Integration"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Sensory integration"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Raw Data to Scores",
				"body": "The tool focuses on converting supported collected EASI raw assessment information into standardized scores."
			},
			{
				"title": "Incomplete and Invalid Entries",
				"body": "Affected scores are withheld until required information is present and valid."
			},
			{
				"title": "Finalized Results",
				"body": "Finalized score outputs should remain stable, with later corrections handled explicitly to preserve scoring history."
			}
		],
		"faqItems": [
			{
				"question": "Does ESP administer EASI assessment items?",
				"answer": "No. The tool starts after assessment data has been collected and focuses on scoring supported raw information."
			},
			{
				"question": "Can I score non-EASI measures?",
				"answer": "No. Unsupported measures or invented fields cannot be scored in this product."
			},
			{
				"question": "What happens if raw data is missing?",
				"answer": "The affected scores are not calculated, and the missing information is shown for correction."
			},
			{
				"question": "Does the tool generate recommendations?",
				"answer": "No. It provides standardized score output for practitioner interpretation and does not create intervention plans."
			}
		]
	},
	{
		"toolType": "asiInterventionFidelityMeasure",
		"slug": "asi-intervention-fidelity-measure",
		"title": "ASI Intervention Fidelity Measure Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only ASI fidelity review workflow for supported observations, completion checks, and fidelity score/profile review.",
		"h1": "ASI Intervention Fidelity Measure",
		"intro": "The ASI Intervention Fidelity Measure is a practitioner-only fidelity assessment profile for sensory integration practitioners. It helps practitioners record supported fidelity observations or ratings and review the degree to which an intervention session matches the intended sensory integration approach rather than generic sensory activity.",
		"demoTitle": "Start a sample fidelity review and inspect the profile output.",
		"demoPrompt": "Interested in using ASI Intervention Fidelity Measure with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1056-f-068-asi-008-r001-asi-intervention-fidelity-measure.md",
		"specId": "1056-f-068-asi-008-r001-asi-intervention-fidelity-measure",
		"tags": {
			"framework": [
				"Ayres Sensory Integration"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring",
				"Sensory integration"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fidelity, Not Outcomes",
				"body": "The product evaluates delivery fidelity of an intervention session, not child progress or treatment outcomes."
			},
			{
				"title": "Supported Criteria Only",
				"body": "The review cannot add invented ASI principles, fidelity items, rating options, or score thresholds."
			},
			{
				"title": "Session History",
				"body": "Finalized fidelity profiles can be preserved by session and date to support quality monitoring over time when the same basis is used."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool plan intervention activities?",
				"answer": "No. It reviews fidelity of intervention delivery and does not prescribe session activities."
			},
			{
				"question": "Can it score child outcomes?",
				"answer": "No. The product is focused on fidelity of ASI intervention delivery, not child outcome scoring."
			},
			{
				"question": "Can I change the fidelity criteria?",
				"answer": "No. Changing fidelity criteria would create a different tool rather than a setting."
			},
			{
				"question": "What happens to incomplete reviews?",
				"answer": "Incomplete reviews remain draft and do not produce a complete fidelity profile."
			}
		]
	},
	{
		"toolType": "sensoryMotorGoalPlan",
		"slug": "sensory-motor-goal-plan",
		"title": "Sensory-Motor Goal Plan Demo | Qwoach",
		"metaDescription": "Explore a collaborative sensory-motor goal plan that links assessed findings, functional needs, and practitioner-authored targets.",
		"h1": "Sensory-Motor Goal Plan",
		"intro": "The Sensory-Motor Goal Plan is a collaborative treatment-planning tool for practitioners. It helps practitioners link assessed sensory-motor findings to functional needs and practitioner-authored intervention targets so treatment direction is grounded in the child's assessment profile and participation needs.",
		"demoTitle": "Create a sample target and review its assessment-to-function links.",
		"demoPrompt": "Interested in using Sensory-Motor Goal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1057-f-068-asi-009-r001-sensory-motor-goal-plan.md",
		"specId": "1057-f-068-asi-009-r001-sensory-motor-goal-plan",
		"tags": {
			"framework": [
				"Ayres Sensory Integration"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Sensory integration",
				"Occupational participation"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Assessment Grounding",
				"body": "Each target should reference an assessed sensory-motor finding before it is treated as grounded."
			},
			{
				"title": "Functional Connection",
				"body": "Targets remain incomplete when they lack a link to participation, learning, behavior, or functional performance needs."
			},
			{
				"title": "Collaborative Context",
				"body": "Caregiver or child-side context can inform functional needs, while the practitioner remains responsible for final target content."
			},
			{
				"title": "Plan History",
				"body": "Dated plan states preserve how treatment direction changes over time rather than silently overwriting earlier plans."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write goals for me?",
				"answer": "No. The practitioner authors the target content; the tool structures links among findings, functional needs, and targets."
			},
			{
				"question": "Can a caregiver contribute?",
				"answer": "Yes. In the collaborative workflow, a caregiver or child-side participant may contribute context about functional needs or priorities."
			},
			{
				"question": "What makes a target complete?",
				"answer": "A target is complete when it has practitioner-authored target text, an assessed sensory-motor finding link, and a functional need connection."
			},
			{
				"question": "Does this include therapy activities?",
				"answer": "No. The tool creates intervention targets and does not generate activity plans."
			}
		]
	},
	{
		"toolType": "sensoryStrategyEnvironmentalSupportPlan",
		"slug": "sensory-strategy-environmental-support-plan",
		"title": "Sensory Strategy Environmental Support Plan Demo | Qwoach",
		"metaDescription": "Explore an individualized sensory support plan with context-linked environmental adjustments and implementer response tracking.",
		"h1": "Sensory Strategy / Environmental Support Plan",
		"intro": "The Sensory Strategy / Environmental Support Plan is a collaborative planning and response-tracking tool for practitioners and everyday implementers. It helps practitioners define individualized sensory and environmental supports matched to a child's sensory response patterns and participation needs, then collect response information from the target context.",
		"demoTitle": "Create a sample support and preview response tracking.",
		"demoPrompt": "Interested in using Sensory Strategy / Environmental Support Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1058-f-068-asi-010-r001-sensory-strategy-environmental-support-plan.md",
		"specId": "1058-f-068-asi-010-r001-sensory-strategy-environmental-support-plan",
		"tags": {
			"framework": [
				"Ayres Sensory Integration"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Sensory integration",
				"Environmental barriers",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Practitioner and Implementer Roles",
				"body": "The practitioner controls sensory pattern links, support definitions, and plan finalization. Implementers view supports relevant to their context and add response information."
			},
			{
				"title": "Response Tracking",
				"body": "Response entries are tied to a support and target context so follow-up review can consider what was used and what was observed."
			},
			{
				"title": "Multiple Contexts",
				"body": "Supports and responses stay separated by context, such as home or classroom, rather than being merged into unsupported conclusions."
			},
			{
				"title": "Plan Updates",
				"body": "When support content changes, prior definitions remain available so response history remains understandable."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend sensory strategies automatically?",
				"answer": "No. The practitioner defines the supports; the tool organizes links and response tracking."
			},
			{
				"question": "Who records response information?",
				"answer": "A caregiver, teacher, or other implementer can record what happened after using a support in the target context."
			},
			{
				"question": "Can I make a plan without response tracking?",
				"answer": "Yes, where response collection mode is supported, the practitioner can create a plan-only draft and defer response fields."
			},
			{
				"question": "Does response tracking prove a support is effective?",
				"answer": "No. Response entries report what was observed and support practitioner review, but the system does not infer clinical effectiveness beyond the reported information."
			},
			{
				"question": "What makes a support incomplete?",
				"answer": "A support is incomplete if it lacks an identified sensory pattern, a target challenge or context, or the practitioner-defined support content needed for use."
			}
		]
	},
	{
		"toolType": "icfChecklist",
		"slug": "icf-checklist",
		"title": "ICF Checklist Demo for Rehabilitation Practitioners | Qwoach",
		"metaDescription": "Explore a practitioner-only ICF Checklist workflow for recording functioning, disability, activity, participation, and contextual factors.",
		"h1": "ICF Checklist",
		"intro": "The ICF Checklist is a practitioner-only standardized functioning and disability profile tool for rehabilitation practitioners. It helps practitioners elicit and record a person's functioning across body, activity, participation, and contextual domains so rehabilitation planning can consider the whole functioning situation.",
		"demoTitle": "Explore a sample ICF Checklist profile.",
		"demoPrompt": "Interested in using ICF Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1059-f-069-icf-001-r001-icf-checklist.md",
		"specId": "1059-f-069-icf-001-r001-icf-checklist",
		"tags": {
			"framework": [
				"ICF"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Functioning and disability",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Whole-Functioning Coverage",
				"body": "The tool keeps body-level issues, activity, participation, and contextual factors visible together."
			},
			{
				"title": "Partial Profiles",
				"body": "Incomplete domains remain visible so practitioners can judge profile coverage."
			},
			{
				"title": "Contextual Factors",
				"body": "Uncertain contextual information should be recorded as unknown or not captured rather than forced into an interpretation."
			},
			{
				"title": "History",
				"body": "Dated profiles can support longitudinal review when comparable checklist content is used."
			}
		],
		"faqItems": [
			{
				"question": "Does the ICF Checklist generate a rehabilitation plan?",
				"answer": "No. It creates a structured functioning profile that can inform planning, but it does not generate the plan itself."
			},
			{
				"question": "Is there a client-facing form?",
				"answer": "No. The product is practitioner-only, though the practitioner may elicit information from the person during assessment."
			},
			{
				"question": "Can I add custom domains?",
				"answer": "No. Adding unsupported domains would go beyond the represented ICF Checklist."
			},
			{
				"question": "What happens if a domain is not complete?",
				"answer": "The profile shows completed and incomplete domains so the practitioner can judge coverage."
			}
		]
	},
	{
		"toolType": "whodas2036Item",
		"slug": "whodas-2-0-36-item",
		"title": "WHODAS 2.0 36-item Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send WHODAS 2.0 36-item workflow with respondent or practitioner entry, completion checks, and total/domain scores.",
		"h1": "WHODAS 2.0 36-item",
		"intro": "WHODAS 2.0 36-item is a ready-to-send standardized disability and functioning assessment for rehabilitation practitioners. It helps practitioners collect 36-item responses and review standardized total and domain-level disability information for rehabilitation planning or outcome tracking.",
		"demoTitle": "Choose a sample administration path and review the score profile.",
		"demoPrompt": "Interested in using WHODAS 2.0 36-item with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1060-f-069-icf-002-r001-whodas-2-0-36-item.md",
		"specId": "1060-f-069-icf-002-r001-whodas-2-0-36-item",
		"tags": {
			"framework": [
				"ICF"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Functioning and disability",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed 36-Item Configuration",
				"body": "The tool preserves the WHODAS 2.0 36-item structure and does not support custom items or added domains."
			},
			{
				"title": "Administration Path",
				"body": "The same assessment can be respondent-completed or practitioner-entered, with the source labeled for review and history."
			},
			{
				"title": "Outcome Tracking",
				"body": "Completed assessments can be compared over time when version and scoring basis are consistent."
			},
			{
				"title": "Partial Completion",
				"body": "Partial assessments are not scored as complete until required responses are present."
			}
		],
		"faqItems": [
			{
				"question": "Can respondents complete WHODAS 2.0 themselves?",
				"answer": "Yes. The tool supports a respondent-completed administration path, and it can also support practitioner-entered responses."
			},
			{
				"question": "Does the administration path change the scores?",
				"answer": "No. The score profile structure remains total and domain scores; the administration source is labeled for context."
			},
			{
				"question": "Can I customize the 36 items?",
				"answer": "No. The product is fixed to WHODAS 2.0 36-item and does not support item edits or added domains."
			},
			{
				"question": "Does the tool create a rehabilitation plan?",
				"answer": "No. It provides standardized disability information for practitioner use in planning or outcome tracking, but it does not generate a plan."
			},
			{
				"question": "Can scores be compared over time?",
				"answer": "Yes. Completed assessments can support comparison when the same version and scoring basis are used."
			}
		]
	},
	{
		"toolType": "whodas2012Item",
		"slug": "whodas-2-0-12-item",
		"title": "WHODAS 2.0 12-item Rehabilitation Demo | Qwoach",
		"metaDescription": "Explore the WHODAS 2.0 12-item assessment for rehabilitation practitioners who need a brief disability profile for baseline and follow-up review.",
		"h1": "WHODAS 2.0 12-item disability profile for rehabilitation",
		"intro": "WHODAS 2.0 12-item is a brief standardized disability and functioning assessment for rehabilitation practitioners. It helps practitioners collect supported item responses and review a concise disability score/profile for baseline needs and follow-up comparison.",
		"demoTitle": "Explore the sample assessment and review the demo profile.",
		"demoPrompt": "Interested in using WHODAS 2.0 12-item with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1061-f-069-icf-003-r001-whodas-2-0-12-item.md",
		"specId": "1061-f-069-icf-003-r001-whodas-2-0-12-item",
		"tags": {
			"framework": [
				"ICF"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Functioning and disability",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool for brief baseline and follow-up measurement when a rehabilitation case needs a standardized disability and functioning profile."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not create diagnoses, treatment recommendations, referral decisions, custom domains, or narrative interpretation."
			},
			{
				"title": "Repeat Use",
				"body": "Follow-up comparison uses the same WHODAS 2.0 12-item configuration so results remain comparable across administrations."
			}
		],
		"faqItems": [
			{
				"question": "Can I change the WHODAS 2.0 12-item questions in this tool?",
				"answer": "No. The tool uses the fixed WHODAS 2.0 12-item configuration and does not support ad hoc item edits."
			},
			{
				"question": "Does the demo require real client information?",
				"answer": "No. The public demo uses fictional sample data and does not require client-identifying information."
			},
			{
				"question": "When is a score/profile shown?",
				"answer": "A final score/profile is shown only after required item responses are complete and valid."
			},
			{
				"question": "Does the tool decide rehabilitation priorities?",
				"answer": "No. The system derives the score/profile; the practitioner interprets it for priorities, referral questions, or follow-up decisions."
			}
		]
	},
	{
		"toolType": "icfFunctioningProfile",
		"slug": "icf-functioning-profile",
		"title": "ICF Functioning Profile Demo | Qwoach",
		"metaDescription": "Explore an ICF-oriented functioning profile for rehabilitation practitioners who need a multidomain case formulation for shared planning.",
		"h1": "ICF Functioning Profile for multidomain rehabilitation formulation",
		"intro": "ICF Functioning Profile is a multidomain rehabilitation formulation tool for practitioners. It helps practitioners organize body, activity, participation, and contextual information into a profile that can support case planning.",
		"demoTitle": "Complete a sample functioning profile.",
		"demoPrompt": "Interested in using ICF Functioning Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1062-f-069-icf-004-r001-icf-functioning-profile.md",
		"specId": "1062-f-069-icf-004-r001-icf-functioning-profile",
		"tags": {
			"framework": [
				"ICF"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Functioning and disability"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Shared Completion",
				"body": "The tool is intended for practitioner-led completion with client contribution when available, not as a separate client progress product."
			},
			{
				"title": "Partial Profiles",
				"body": "Partial profiles can be saved with unresolved domains visible so empty areas are not mistaken for normal or irrelevant domains."
			},
			{
				"title": "Limits",
				"body": "The profile does not add unsupported ratings, diagnoses, goals, treatment prescriptions, or fixed worksheet prompts beyond the configured structure."
			}
		],
		"faqItems": [
			{
				"question": "Is this a scored assessment?",
				"answer": "No. ICF Functioning Profile produces a multidomain formulation, not a severity score."
			},
			{
				"question": "Can the client complete it alone?",
				"answer": "No standalone client workflow is defined. The supported experience is shared completion or practitioner completion from case information."
			},
			{
				"question": "What happens if a domain is not assessed?",
				"answer": "The domain remains visibly marked as not assessed, not currently applicable, or unresolved where the practitioner uses that distinction."
			},
			{
				"question": "Does the tool write goals or interventions?",
				"answer": "No. Goals and intervention decisions remain practitioner-authored outside the tool's automatic behavior."
			}
		]
	},
	{
		"toolType": "icfEnvironmentalFacilitatorsBarriersMap",
		"slug": "icf-environmental-facilitators-barriers-map",
		"title": "ICF Environmental Barriers and Facilitators Demo | Qwoach",
		"metaDescription": "Explore an ICF-aligned map for rehabilitation practitioners linking environmental barriers and facilitators to participation problems.",
		"h1": "Map environmental barriers and facilitators for rehabilitation planning",
		"intro": "ICF Environmental Facilitators/Barriers Map is a contextual rehabilitation planning tool for practitioners. It helps practitioners identify barriers and facilitators in a client's environment and link them to functioning or participation problems.",
		"demoTitle": "Map sample barriers and facilitators.",
		"demoPrompt": "Interested in using ICF Environmental Facilitators/Barriers Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1063-f-069-icf-005-r001-icf-environmental-facilitators-barriers-map.md",
		"specId": "1063-f-069-icf-005-r001-icf-environmental-facilitators-barriers-map",
		"tags": {
			"framework": [
				"ICF"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Environmental barriers",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Barrier and Facilitator Roles",
				"body": "Factors can be grouped as barriers or facilitators, and unresolved factors can remain visible instead of being forced into a category."
			},
			{
				"title": "Actionable Links",
				"body": "A factor becomes part of the target list only when linked to a functioning or participation problem."
			},
			{
				"title": "Limits",
				"body": "The tool does not score environmental risk, determine eligibility, make legal accessibility findings, or prescribe intervention steps."
			}
		],
		"faqItems": [
			{
				"question": "Can one factor be both a barrier and a facilitator?",
				"answer": "Yes, only when the practitioner represents both effects in different functioning contexts or with notes."
			},
			{
				"question": "Does every factor need to be linked?",
				"answer": "No. Unlinked factors can remain visible as unresolved, but they do not enter the actionable target list."
			},
			{
				"question": "Is this a home assessment or accessibility audit?",
				"answer": "No. The tool maps contextual barriers and facilitators only at the level needed for rehabilitation planning."
			},
			{
				"question": "Does the demo need real environmental details?",
				"answer": "No. The demo uses fictional examples and should not collect real sensitive case information."
			}
		]
	},
	{
		"toolType": "activityParticipationGoalMap",
		"slug": "activity-participation-goal-map",
		"title": "Activity & Participation Goal Map Demo | Qwoach",
		"metaDescription": "Explore a rehabilitation goal map that links client-relevant activities and social roles to desired functioning outcomes for planning.",
		"h1": "Map participation-focused rehabilitation goals",
		"intro": "Activity & Participation Goal Map is a rehabilitation goal mapping tool for practitioners. It helps practitioners link client-relevant activities and social roles to desired functioning outcomes for planning and later review.",
		"demoTitle": "Create a sample participation-focused goal.",
		"demoPrompt": "Interested in using Activity & Participation Goal Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1064-f-069-icf-006-r001-activity-participation-goal-map.md",
		"specId": "1064-f-069-icf-006-r001-activity-participation-goal-map",
		"tags": {
			"framework": [
				"ICF"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Goal setting",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Participation Focus",
				"body": "Each goal should link to a real-world activity or role and describe the desired functioning outcome."
			},
			{
				"title": "Draft States",
				"body": "Activities without goal wording and goals without activity links remain draft or unmapped until completed."
			},
			{
				"title": "Limits",
				"body": "The tool does not impose unsupported goal formulas, goal quality scores, treatment steps, or clinical priority rankings."
			}
		],
		"faqItems": [
			{
				"question": "Is this a treatment-plan generator?",
				"answer": "No. The tool maps participation-focused goals; treatment planning remains practitioner-authored outside the automatic behavior."
			},
			{
				"question": "Can a treatment activity be entered as a goal?",
				"answer": "The tool should prompt the practitioner to separate treatment activity from the desired functioning outcome."
			},
			{
				"question": "Can clients suggest goals?",
				"answer": "Yes, clients may suggest activities, roles, or outcomes during shared completion, but practitioner acceptance controls what becomes part of the plan."
			},
			{
				"question": "What gets saved from the public demo?",
				"answer": "The tool is saved, not the fictional activities, sample goals, or demo notes."
			}
		]
	},
	{
		"toolType": "beforeAfterFunctioningProfile",
		"slug": "before-after-functioning-profile",
		"title": "Before/After Functioning Profile Demo | Qwoach",
		"metaDescription": "Explore a rehabilitation outcome comparison tool that pairs baseline and follow-up functioning data to show descriptive change over time.",
		"h1": "Compare rehabilitation functioning before and after intervention",
		"intro": "Before/After Functioning Profile is a rehabilitation outcome comparison tool for practitioners. It helps practitioners pair comparable baseline and follow-up functioning information and review the direction and size of change where supported.",
		"demoTitle": "Compare sample baseline and follow-up data.",
		"demoPrompt": "Interested in using Before/After Functioning Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1065-f-069-icf-007-r001-before-after-functioning-profile.md",
		"specId": "1065-f-069-icf-007-r001-before-after-functioning-profile",
		"tags": {
			"framework": [
				"ICF"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Functioning and disability",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Comparability",
				"body": "Before/after change is displayed only when the selected timepoints use comparable functioning measures or domains."
			},
			{
				"title": "Incomplete Timepoints",
				"body": "If either baseline or follow-up is incomplete, the tool shows partial status and withholds final change conclusions."
			},
			{
				"title": "Limits",
				"body": "The tool does not make causal claims, define treatment success, or generate clinical recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can I compare different measures or versions?",
				"answer": "No, not as a valid before/after comparison. Non-comparable measures or versions are blocked or clearly marked."
			},
			{
				"question": "Does the tool prove an intervention caused improvement?",
				"answer": "No. It shows descriptive change between comparable timepoints; causal meaning is practitioner interpretation."
			},
			{
				"question": "What if follow-up data is missing?",
				"answer": "The comparison remains incomplete and no final change summary is shown."
			},
			{
				"question": "Can decline be shown?",
				"answer": "Yes. Decline is displayed neutrally as a change direction when supported by the comparable data."
			}
		]
	},
	{
		"toolType": "rehabilitationFacilityIndicatorSet",
		"slug": "rehabilitation-facility-indicator-set",
		"title": "Rehabilitation Facility Indicator Set Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only indicator set for entering, validating, and reviewing facility-level rehabilitation service data over time.",
		"h1": "Track rehabilitation facility indicators across reporting periods",
		"intro": "Rehabilitation Facility Indicator Set is a practitioner-only service monitoring tool for rehabilitation program staff and managers. It helps them collect defined facility-level indicators and review service activity, capacity, access, or performance over time.",
		"demoTitle": "Enter sample period indicators.",
		"demoPrompt": "Interested in using Rehabilitation Facility Indicator Set with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1066-f-069-icf-008-r001-rehabilitation-facility-indicator-set.md",
		"specId": "1066-f-069-icf-008-r001-rehabilitation-facility-indicator-set",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Service monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Program-Level Use",
				"body": "The tool works with facility or program indicators rather than patient-level clinical details."
			},
			{
				"title": "Draft and Final Periods",
				"body": "Incomplete reporting periods remain draft or partial and are not treated as finalized comparisons unless explicitly marked partial."
			},
			{
				"title": "Limits",
				"body": "The tool does not add unsupported indicators, patient-level fields, benchmarks, causal analysis, or automated management recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client view?",
				"answer": "No. Rehabilitation Facility Indicator Set is practitioner-only and uses facility/program indicator data."
			},
			{
				"question": "What settings affect the result?",
				"answer": "Reporting period structure and facility/program scope affect grouping, trend intervals, and comparability."
			},
			{
				"question": "Can I add custom indicators in the demo?",
				"answer": "No. The product uses the defined indicator set and does not add unsupported indicators."
			},
			{
				"question": "What happens to missing indicator values?",
				"answer": "Missing required values create incomplete status and must be resolved or clearly marked partial before final comparison."
			}
		]
	},
	{
		"toolType": "dhis2RehabilitationReportingPackage",
		"slug": "dhis2-rehabilitation-reporting-package",
		"title": "DHIS2 Rehabilitation Reporting Package Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only rehabilitation reporting package for facility and aggregate service reports across periods and service units.",
		"h1": "Aggregate rehabilitation service data for routine reporting",
		"intro": "DHIS2 Rehabilitation Reporting Package is a practitioner-only routine reporting package for rehabilitation program and health-information users. It helps aggregate facility service data into reports for monitoring and planning.",
		"demoTitle": "Review a sample aggregate report.",
		"demoPrompt": "Interested in using DHIS2 Rehabilitation Reporting Package with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1067-f-069-icf-009-r001-dhis2-rehabilitation-reporting-package.md",
		"specId": "1067-f-069-icf-009-r001-dhis2-rehabilitation-reporting-package",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Service monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Facility and Aggregate Views",
				"body": "The package supports facility-level and aggregate report views according to the selected reporting level and scope."
			},
			{
				"title": "Partial Aggregates",
				"body": "Missing source submissions create partial aggregate status and identify missing source units."
			},
			{
				"title": "Limits",
				"body": "The tool does not implement a full health information system, invent indicators, or produce automated planning decisions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client-facing product?",
				"answer": "No. It is a practitioner/program-only reporting package for facility and aggregate data."
			},
			{
				"question": "What determines the aggregate report?",
				"answer": "Reporting period, reporting level, and facility/service-unit scope determine included data and aggregation meaning."
			},
			{
				"question": "What happens when a facility submission is missing?",
				"answer": "The aggregate is marked partial and the missing source unit is identified."
			},
			{
				"question": "Does the package recommend resource allocation?",
				"answer": "No. It provides reports and comparisons; planning and resource decisions remain user interpretation."
			}
		]
	},
	{
		"toolType": "careerscope",
		"slug": "careerscope",
		"title": "CareerScope Vocational Assessment Demo | Qwoach",
		"metaDescription": "Explore CareerScope for vocational practitioners who need interest and aptitude results, counselor reports, and traceable career recommendations.",
		"h1": "CareerScope vocational assessment for interests, aptitudes, and career options",
		"intro": "CareerScope is a computerized vocational assessment for vocational rehabilitation counselors, workforce practitioners, and career counselors. It helps practitioners evaluate a client's interests, aptitudes, task-performance strengths, and aligned career or training options.",
		"demoTitle": "Explore a sample CareerScope administration.",
		"demoPrompt": "Interested in using CareerScope with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1068-f-070-vr-001-r001-careerscope.md",
		"specId": "1068-f-070-vr-001-r001-careerscope",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner and Client Roles",
				"body": "The practitioner sets up and interprets the assessment; the client completes the interest and aptitude components."
			},
			{
				"title": "Recommendation Traceability",
				"body": "Career and training matches should be visibly connected to measured interest and aptitude results."
			},
			{
				"title": "Limits",
				"body": "The tool does not invent modules, scoring methods, occupational matches, or unsupported practitioner-only interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Who uses CareerScope?",
				"answer": "Vocational rehabilitation counselors, workforce practitioners, and career counselors use it to assess interests, aptitudes, and aligned options."
			},
			{
				"question": "Does the client complete part of the tool?",
				"answer": "Yes. The client completes the interest inventory and aptitude modules under the configured administration conditions."
			},
			{
				"question": "Can recommendations be edited manually?",
				"answer": "No. Derived scores and recommendations are not manually edited; practitioner interpretation is recorded separately."
			},
			{
				"question": "Does CareerScope guarantee a job match?",
				"answer": "No. It provides traceable recommendations for counseling and planning, not guaranteed placement or employment fit."
			}
		]
	},
	{
		"toolType": "valparComponentWorkSamplesVcws",
		"slug": "valpar-component-work-samples-vcws",
		"title": "Valpar Component Work Samples Demo | Qwoach",
		"metaDescription": "Explore VCWS administration documentation for practitioners recording observed simulated work tasks, timing, scores, and work-capacity evidence.",
		"h1": "Document observed work-sample performance with VCWS",
		"intro": "Valpar Component Work Samples is a hands-on vocational work-sample assessment for vocational evaluators and rehabilitation practitioners. It helps practitioners document direct simulated work performance, timing, observations, scores, and job-relevant work factors.",
		"demoTitle": "Document a sample VCWS module.",
		"demoPrompt": "Interested in using Valpar Component Work Samples (VCWS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1069-f-070-vr-001-r002-valpar-component-work-samples-vcws.md",
		"specId": "1069-f-070-vr-001-r002-valpar-component-work-samples-vcws",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Functioning and disability"
			],
			"population": []
		},
		"sections": [
			{
				"title": "In-Person Administration",
				"body": "The tool supports documenting physical work-sample performance; it does not convert VCWS into a remote or purely digital task."
			},
			{
				"title": "Module-Specific Review",
				"body": "Multiple modules can be included in one evaluation, but scoring and criteria remain separate by module."
			},
			{
				"title": "Limits",
				"body": "The tool does not invent module prompts, scoring sheets, standards, or job-fit recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can the client complete VCWS online alone?",
				"answer": "No. The supported workflow is in-person practitioner-administered physical work-sample assessment."
			},
			{
				"question": "What is configurable in the demo?",
				"answer": "Selected VCWS module or modules are configurable because module selection changes tasks, scoring, and result meaning."
			},
			{
				"question": "What happens if a physical task is incomplete?",
				"answer": "The module remains incomplete, the reason can be recorded, and it is not summarized as completed performance."
			},
			{
				"question": "Does the tool make return-to-work recommendations automatically?",
				"answer": "No. Recommendations are practitioner-authored from the observed evidence."
			}
		]
	},
	{
		"toolType": "mccarronDialSystemMds",
		"slug": "mccarron-dial-system-mds",
		"title": "McCarron-Dial System Evaluation Demo | Qwoach",
		"metaDescription": "Explore MDS evaluation recording for practitioners managing multi-domain vocational profiles, component results, and authored recommendations.",
		"h1": "Manage a multi-factor McCarron-Dial System evaluation",
		"intro": "McCarron-Dial System is a comprehensive multi-factor vocational and neuropsychological evaluation system for qualified practitioners. It helps practitioners organize cognitive, sensory, motor, emotional, coping, work-sample, and behavioral evidence into a functional profile for planning.",
		"demoTitle": "Explore a sample MDS evaluation record.",
		"demoPrompt": "Interested in using McCarron-Dial System (MDS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1070-f-070-vr-001-r003-mccarron-dial-system-mds.md",
		"specId": "1070-f-070-vr-001-r003-mccarron-dial-system-mds",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Functioning and disability",
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Multi-Session Evaluation",
				"body": "The tool supports recording assessment activity across an extended evaluation period with dates and session context where needed."
			},
			{
				"title": "Partial Profiles",
				"body": "Incomplete batteries show completed and pending components and do not present a complete integrated profile until required data are present."
			},
			{
				"title": "Limits",
				"body": "The tool does not act as a generic battery builder, diagnostic engine, automated placement system, or recommendation generator."
			}
		],
		"faqItems": [
			{
				"question": "Who is this tool for?",
				"answer": "It is for qualified practitioners such as vocational evaluators, rehabilitation counselors, psychologists, educational diagnosticians, and specialists."
			},
			{
				"question": "Can the client use MDS as a standalone digital product?",
				"answer": "No. The supported workflow is practitioner-administered assessment with client participation in components and observed activities."
			},
			{
				"question": "What is configurable?",
				"answer": "The assessment component set is configurable only where legitimate MDS administration allows selection for the evaluation question."
			},
			{
				"question": "Does the tool generate recommendations automatically?",
				"answer": "No. Recommendations are practitioner-authored and should follow from the functional profile and observed performance."
			}
		]
	},
	{
		"toolType": "transferableSkillsAnalysis",
		"slug": "transferable-skills-analysis",
		"title": "Transferable Skills Analysis Demo | Qwoach",
		"metaDescription": "Explore a vocational transferable skills analysis that connects prior work history, abilities, restrictions, and qualifications to feasible job matches.",
		"h1": "Transferable Skills Analysis for Vocational Planning",
		"intro": "Transferable Skills Analysis is a practitioner-only vocational planning tool for vocational rehabilitation practitioners and related planners. It helps practitioners derive transferable skills from a client's prior work history or demonstrated abilities and connect those skills to feasible alternative occupations.",
		"demoTitle": "Explore the sample analysis",
		"demoPrompt": "Interested in using Transferable Skills Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1071-f-070-vr-002-r001-transferable-skills-analysis.md",
		"specId": "1071-f-070-vr-002-r001-transferable-skills-analysis",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Career counseling",
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this analysis when vocational planning depends on connecting actual prior work and demonstrated abilities to alternative occupations."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures prior roles, duties, demonstrated abilities, restrictions, qualifications, barriers, and occupation-matching constraints used in the analysis."
			},
			{
				"title": "Important Limit",
				"body": "The tool does not create unsupported skills, restrictions, readiness conclusions, or final employability determinations. Practitioner interpretation remains required."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool replace practitioner judgment?",
				"answer": "No. It organizes evidence into transferable skills and job matches, but vocational recommendations remain practitioner interpreted."
			},
			{
				"question": "What evidence drives the matches?",
				"answer": "Prior work history, duties, demonstrated abilities, restrictions, qualifications, and selected matching constraints drive the matches."
			},
			{
				"question": "Can poor-fit occupations be removed?",
				"answer": "Yes. The practitioner can manually include or exclude matches with a rationale, and poor-fit options can be distinguished from realistic options."
			},
			{
				"question": "Can the public demo use real client details?",
				"answer": "No. The public demo should use fictional or placeholder evidence and should not require sensitive or client-identifying information."
			}
		]
	},
	{
		"toolType": "oNetInterestProfiler",
		"slug": "o-net-interest-profiler",
		"title": "O*NET Interest Profiler Demo | Qwoach",
		"metaDescription": "Explore an O*NET Interest Profiler workflow that scores work-activity preferences into interest areas and links them to occupation options.",
		"h1": "O*NET Interest Profiler for Career Exploration",
		"intro": "The ONET Interest Profiler is a vocational interest assessment for career counselors, vocational rehabilitation counselors, workforce practitioners, and education practitioners. It helps practitioners collect client ratings of work activities, score a RIASEC-style interest profile, and connect the profile to ONET-SOC occupation options.",
		"demoTitle": "Try the sample profiler",
		"demoPrompt": "Interested in using O*NET Interest Profiler with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1072-f-070-vr-003-r001-o-net-interest-profiler.md",
		"specId": "1072-f-070-vr-003-r001-o-net-interest-profiler",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Goal setting"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Client Roles",
				"body": "The client provides work-activity preference ratings. The system scores the supported profile. The practitioner supports interpretation and next-step planning."
			},
			{
				"title": "What It Does Not Measure",
				"body": "The profiler does not measure aptitude, restrictions, diagnosis, employability, or job readiness."
			},
			{
				"title": "Retakes And Comparison",
				"body": "Historical results should preserve the form and filters used so later retakes are not confused with materially different versions or settings."
			}
		],
		"faqItems": [
			{
				"question": "What does the O*NET Interest Profiler produce?",
				"answer": "It produces a RIASEC-style vocational-interest profile and occupation or career exploration options linked to the client's ratings."
			},
			{
				"question": "Can clients complete it themselves?",
				"answer": "Yes. The client can complete the rating flow, and the practitioner can review the scored profile and occupation options afterward."
			},
			{
				"question": "Do interest results show ability or job readiness?",
				"answer": "No. Interest results reflect reported work-activity preferences and should not be treated as aptitude, restriction, or readiness evidence."
			},
			{
				"question": "What happens if responses are incomplete?",
				"answer": "Incomplete responses should prevent final scoring or be marked incomplete according to the supported form."
			}
		]
	},
	{
		"toolType": "strongInterestInventory",
		"slug": "strong-interest-inventory",
		"title": "Strong Interest Inventory Demo | Qwoach",
		"metaDescription": "Explore a practitioner-guided Strong Interest Inventory workflow for interest profiles, pathway links, review notes, and next-step planning.",
		"h1": "Strong Interest Inventory Workflow for Career Counseling",
		"intro": "Strong Interest Inventory is a practitioner-guided career interest inventory for certified Strong practitioners, career counselors, educators, coaches, and related career-development professionals. It helps practitioners administer or capture a supported Strong assessment result, interpret the interest pattern with the client, and plan career or education exploration steps.",
		"demoTitle": "Explore the sample workflow",
		"demoPrompt": "Interested in using Strong Interest Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1073-f-070-vr-003-r002-strong-interest-inventory.md",
		"specId": "1073-f-070-vr-003-r002-strong-interest-inventory",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Goal setting"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Assessment Content Boundary",
				"body": "The workflow does not invent Strong item content, scoring scales, report sections, or interpretive meanings. Those must come from supported Strong materials."
			},
			{
				"title": "Practitioner Interpretation",
				"body": "Practitioner notes are separate from assessment-derived content so counseling interpretation does not overwrite the underlying result."
			},
			{
				"title": "Multiple Administrations",
				"body": "Each administration should remain separate with assessment date, version, source, and report context."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include real Strong assessment items?",
				"answer": "No. The demo should not invent item wording, scoring scales, or report language that is not supplied by supported materials."
			},
			{
				"question": "What can the practitioner save?",
				"answer": "The practitioner can save the tool, supported workflow setup, administration or report option, and review mode."
			},
			{
				"question": "Can practitioners edit the assessment result?",
				"answer": "No. Practitioners can add interpretation and planning notes, but underlying assessment-derived results remain distinct."
			},
			{
				"question": "What does the result support?",
				"answer": "The result supports career or education exploration conversations and next-step planning based on reported interests."
			}
		]
	},
	{
		"toolType": "selfDirectedSearch",
		"slug": "self-directed-search",
		"title": "Self-Directed Search Demo | Qwoach",
		"metaDescription": "Explore a Self-Directed Search workflow that organizes SDS completion, RIASEC summary-code results, matched options, and planning notes.",
		"h1": "Self-Directed Search for Career and Education Exploration",
		"intro": "Self-Directed Search is a Holland/RIASEC-based career assessment for career specialists, counselors, education consultants, college career professionals, and vocational planners. It helps practitioners support assessment completion, review a RIASEC summary code or profile, and connect the result to matched career or education options.",
		"demoTitle": "Explore the SDS workflow",
		"demoPrompt": "Interested in using Self-Directed Search with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1074-f-070-vr-003-r003-self-directed-search.md",
		"specId": "1074-f-070-vr-003-r003-self-directed-search",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Goal setting"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What The Profile Means",
				"body": "The SDS profile or summary code organizes career-interest/personality fit for exploration. Counseling direction and planning implications remain practitioner interpreted."
			},
			{
				"title": "Imported Results",
				"body": "If a result is imported from outside the product, the assessment date, edition or format, and report context should be recorded."
			},
			{
				"title": "Balanced Patterns",
				"body": "Ambiguous or balanced codes should be shown neutrally and used to explore multiple related options."
			}
		],
		"faqItems": [
			{
				"question": "What does Self-Directed Search produce?",
				"answer": "It produces a RIASEC summary code or profile and matched career or education options according to supported SDS materials."
			},
			{
				"question": "Can the practitioner change the SDS result?",
				"answer": "No. The practitioner can add notes and next steps, but the assessment-derived profile remains separate."
			},
			{
				"question": "Does this tool assess work capacity?",
				"answer": "No. It supports career-interest/personality fit and matched exploration options, not aptitude, restrictions, or work capacity."
			},
			{
				"question": "What happens with an incomplete assessment?",
				"answer": "An incomplete assessment should not produce a final interpreted profile unless the supported SDS materials allow it."
			}
		]
	},
	{
		"toolType": "careerscope2",
		"slug": "careerscope-2",
		"title": "CareerScope Demo | Qwoach",
		"metaDescription": "Explore a CareerScope workflow for computerized interest and aptitude sections, fit-score recommendations, client summaries, and counselor reports.",
		"h1": "CareerScope Aptitude and Interest Assessment Workflow",
		"intro": "CareerScope is a computerized vocational aptitude-and-interest assessment for vocational rehabilitation, workforce, education, and veterans employment practitioners. It helps practitioners administer interest inventory and aptitude exercise sections, then review fit-score recommendations, client summaries, and counselor reports for planning.",
		"demoTitle": "Explore the sample assessment",
		"demoPrompt": "Interested in using CareerScope with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1075-f-070-vr-004-r001-careerscope.md",
		"specId": "1075-f-070-vr-004-r001-careerscope",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Career counseling",
				"Functioning and disability"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Combined Evidence",
				"body": "CareerScope review should show interest evidence and aptitude evidence together while preserving each as a distinct input to fit recommendations."
			},
			{
				"title": "Incomplete Sections",
				"body": "Incomplete interest or aptitude sections should prevent full fit recommendations or be clearly marked incomplete."
			},
			{
				"title": "Administration Integrity",
				"body": "Timed or performance-based exercises require interruption handling that preserves assessment integrity."
			}
		],
		"faqItems": [
			{
				"question": "What does CareerScope assess?",
				"answer": "It assesses interests and aptitudes through supported computerized inventory and exercise sections."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews aptitude results, interest results, fit indicators, recommendations, client summary, counselor report, and planning notes where supported."
			},
			{
				"question": "Can scoring be configured?",
				"answer": "No. Internal scoring and FIT Score logic are part of the supported assessment materials and are not practitioner-configurable settings."
			},
			{
				"question": "Does the demo save sample assessment data?",
				"answer": "No. The demo saves the tool and reusable setup, not fictional responses, performance data, or sample reports as real client records."
			}
		]
	},
	{
		"toolType": "generalAptitudeTestBatteryGatb",
		"slug": "general-aptitude-test-battery-gatb",
		"title": "General Aptitude Test Battery Demo | Qwoach",
		"metaDescription": "Explore a GATB workflow for timed subtest administration, multi-domain aptitude scores, comparison references, and planning notes.",
		"h1": "GATB Multi-Aptitude Profile for Vocational Planning",
		"intro": "General Aptitude Test Battery (GATB) is a standardized multi-aptitude vocational test battery for vocational evaluators, rehabilitation counselors, career counselors, and workforce assessment providers. It helps practitioners administer or record timed subtest results, organize aptitude domain scores, and interpret them against supported job or training requirements.",
		"demoTitle": "Explore the sample battery",
		"demoPrompt": "Interested in using General Aptitude Test Battery (GATB) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1076-f-070-vr-004-r002-general-aptitude-test-battery-gatb.md",
		"specId": "1076-f-070-vr-004-r002-general-aptitude-test-battery-gatb",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Career counseling",
				"Functioning and disability"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Measures",
				"body": "The battery covers multiple work-relevant aptitude domains according to supported GATB materials, such as learning, verbal, numerical, spatial, perceptual, clerical, coordination, and dexterity domains."
			},
			{
				"title": "Interrupted Timed Sections",
				"body": "Interrupted timed subtests should be flagged for practitioner review rather than silently resumed as normal."
			},
			{
				"title": "Comparison Limits",
				"body": "Aptitude scores can support comparison only against supported job or training references available to the implementation."
			}
		],
		"faqItems": [
			{
				"question": "What does GATB produce?",
				"answer": "It produces a multi-domain aptitude score profile based on timed subtest performance and supported scoring materials."
			},
			{
				"question": "Is this an interest inventory?",
				"answer": "No. GATB is a multi-aptitude battery, not a vocational interest inventory or job search tool."
			},
			{
				"question": "Can the demo invent scoring norms?",
				"answer": "No. Scoring norms, timing rules, and occupational comparison meanings must come from supported materials."
			},
			{
				"question": "What happens if a subtest is missing?",
				"answer": "The affected domain should be marked incomplete and unsupported full-profile interpretation should be prevented."
			}
		]
	},
	{
		"toolType": "valparComponentWorkSamplesVcws2",
		"slug": "valpar-component-work-samples-vcws-2",
		"title": "Valpar Component Work Samples Demo | Qwoach",
		"metaDescription": "Explore a VCWS workflow for module selection, observed task performance, scoring capture, demand comparison, and practitioner conclusions.",
		"h1": "VCWS Work-Sample Assessment Support",
		"intro": "Valpar Component Work Samples (VCWS) is a practitioner-administered vocational work-sample assessment for vocational evaluators, occupational therapists, rehabilitation counselors, and work-capacity assessors. It helps practitioners record observed performance on selected physical modules and compare results with relevant job demands or standards.",
		"demoTitle": "Explore the sample VCWS record",
		"demoPrompt": "Interested in using Valpar Component Work Samples (VCWS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1077-f-070-vr-004-r003-valpar-component-work-samples-vcws.md",
		"specId": "1077-f-070-vr-004-r003-valpar-component-work-samples-vcws",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Functioning and disability",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Physical Assessment Remains Central",
				"body": "The tool supports recording and reviewing VCWS physical module performance; it does not replace the physical work-sample assessment with a digital simulation."
			},
			{
				"title": "Observation Handling",
				"body": "Pain, fatigue, safety, endurance, behavior, and tolerance notes should be linked to the task where observed or reported."
			},
			{
				"title": "Scope Of Conclusions",
				"body": "Conclusions should not exceed the modules completed and the abilities actually assessed."
			}
		],
		"faqItems": [
			{
				"question": "What does VCWS record?",
				"answer": "It records selected module performance, timing, accuracy, errors, observations, comparison references, and practitioner conclusions."
			},
			{
				"question": "Is there a client-facing software assessment?",
				"answer": "No separate client-facing software experience is required. The client participates by performing physical work-sample tasks."
			},
			{
				"question": "Can conclusions be made for uncompleted modules?",
				"answer": "No. Uncompleted modules should show no conclusion for that module and should explain the result gap."
			},
			{
				"question": "Can practitioners edit module scoring methods?",
				"answer": "No. Module scoring methods and standards come from selected VCWS materials and should not be casual product settings."
			}
		]
	},
	{
		"toolType": "workSampleAssessment",
		"slug": "work-sample-assessment",
		"title": "Work Sample Assessment Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only work sample assessment for observed task performance, strengths, limitations, and vocational planning implications.",
		"h1": "Work Sample Assessment for Vocational Planning",
		"intro": "Work Sample Assessment is a practitioner-only vocational rehabilitation assessment for vocational practitioners, evaluators, and related professionals. It helps practitioners collect structured evidence of observed performance on work-like tasks and use that evidence to identify strengths, limitations, and planning implications.",
		"demoTitle": "Explore the sample record",
		"demoPrompt": "Interested in using Work Sample Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1078-f-070-vr-005-r001-work-sample-assessment.md",
		"specId": "1078-f-070-vr-005-r001-work-sample-assessment",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Occupational participation",
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Task Relevance",
				"body": "Each task should include why it matters to the vocational question before it is used for planning."
			},
			{
				"title": "Qualitative And Measured Evidence",
				"body": "Narrative observations can be captured, but they should remain distinct from measured performance data."
			},
			{
				"title": "Reassessment",
				"body": "Later observations should preserve task definitions and context so comparisons are made cautiously."
			}
		],
		"faqItems": [
			{
				"question": "Is this a standardized scoring tool?",
				"answer": "No. The supplied record does not define standardized tasks, ratings, scoring, or norms, so the tool captures observed performance at a structured generic level."
			},
			{
				"question": "Who uses the tool?",
				"answer": "Vocational rehabilitation practitioners, vocational evaluators, and related practitioners use it to document observed work-like task performance."
			},
			{
				"question": "What happens if a task is not completed?",
				"answer": "The task is marked incomplete and should not be used for unsupported conclusions."
			},
			{
				"question": "Can the public demo require real client information?",
				"answer": "No. The public demo should use fictional or placeholder data and should not require sensitive or identifying client information."
			}
		]
	},
	{
		"toolType": "functionalCapacityWorkToleranceEvaluation",
		"slug": "functional-capacity-work-tolerance-evaluation",
		"title": "Functional Capacity Evaluation Demo | Qwoach",
		"metaDescription": "Explore a work-capacity and restriction evaluation for job demands, tolerance issues, precautions, and return-to-work planning.",
		"h1": "Functional Capacity and Work Tolerance Evaluation",
		"intro": "Functional Capacity / Work Tolerance Evaluation is a practitioner-only vocational rehabilitation and return-to-work capacity evaluation for rehabilitation practitioners, work-capacity evaluators, and return-to-work planners. It helps practitioners organize capacity findings, restrictions, tolerance issues, precautions, and demand relevance for work planning.",
		"demoTitle": "Explore the sample evaluation",
		"demoPrompt": "Interested in using Functional Capacity / Work Tolerance Evaluation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1079-f-070-vr-006-r001-functional-capacity-work-tolerance-evaluation.md",
		"specId": "1079-f-070-vr-006-r001-functional-capacity-work-tolerance-evaluation",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Functioning and disability",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Observed And Reported Information",
				"body": "Observed performance and reported tolerance experiences such as pain or fatigue should remain distinct in the profile."
			},
			{
				"title": "Demand Reference",
				"body": "A demand reference makes the profile more useful for job-fit and accommodation planning. Without it, the result should be marked as limited for job-specific decisions."
			},
			{
				"title": "Partial Evaluations",
				"body": "Incomplete evaluations should show missing capacity areas and avoid unsupported restrictions or conclusions."
			}
		],
		"faqItems": [
			{
				"question": "What does this evaluation produce?",
				"answer": "It produces a work-capacity and restriction profile organized around relevant job demands, limits, tolerance issues, precautions, and planning implications."
			},
			{
				"question": "Does it create medical diagnoses?",
				"answer": "No. The tool should not create unsupported diagnoses, causation conclusions, or final placement decisions."
			},
			{
				"question": "What if there is no job-demand reference?",
				"answer": "The tool can produce a general capacity profile, but it should flag limited usefulness for job-fit comparison."
			},
			{
				"question": "Can a worker self-determine restrictions in the tool?",
				"answer": "No. Reported tolerance can be captured where relevant, but restrictions and planning decisions remain practitioner interpreted."
			}
		]
	},
	{
		"toolType": "jobAnalysis",
		"slug": "job-analysis",
		"title": "Job Analysis Demo | Qwoach",
		"metaDescription": "Explore a vocational job analysis tool for specific job demands, source details, barriers, modifiable demands, and comparison-ready summaries.",
		"h1": "Job Analysis for Return-to-Work Planning",
		"intro": "Job Analysis is a practitioner-only vocational rehabilitation job-demand analysis for vocational rehabilitation practitioners, return-to-work planners, job analysts, and related professionals. It helps practitioners document the physical, cognitive, environmental, and task requirements of a specific job so they can compare them with worker restrictions, capabilities, or accommodation needs.",
		"demoTitle": "Explore the sample job analysis",
		"demoPrompt": "Interested in using Job Analysis with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1080-f-070-vr-007-r001-job-analysis.md",
		"specId": "1080-f-070-vr-007-r001-job-analysis",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Environmental barriers",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Specific Job Over Generic Title",
				"body": "The analysis should describe the actual job's tasks and conditions. Generic occupation information cannot replace specific job demands unless clearly marked as external reference information."
			},
			{
				"title": "Source Clarity",
				"body": "Observed facts, reported facts, descriptive organization, and practitioner interpretation should remain distinguishable."
			},
			{
				"title": "Job Changes",
				"body": "When duties change, the product should create an updated profile rather than silently changing historical demand context."
			}
		],
		"faqItems": [
			{
				"question": "What does Job Analysis produce?",
				"answer": "It produces a specific job-demand profile covering tasks, physical demands, cognitive demands, environmental conditions, barriers, modifiable demands, and unresolved gaps."
			},
			{
				"question": "Is this just a job description editor?",
				"answer": "No. It is a vocational job-demand analysis for comparison with restrictions, capabilities, or accommodation needs."
			},
			{
				"question": "Can contributors decide whether a worker fits the job?",
				"answer": "No. Contributors may provide factual job information if supported, but fit and accommodation conclusions remain practitioner interpreted."
			},
			{
				"question": "What if only a generic title is available?",
				"answer": "The analysis should be marked insufficient for fit decisions because the tool requires actual job-demand data."
			}
		]
	},
	{
		"toolType": "personJobMatchMatrix",
		"slug": "person-job-match-matrix",
		"title": "Person-Job Match Matrix | Vocational Fit Review | Qwoach",
		"metaDescription": "Compare an injured worker's profile with target job requirements to identify suitability, gaps, barriers, and go, modify, or reject decisions.",
		"h1": "Person-Job Match Matrix",
		"intro": "The Person-Job Match Matrix is a practitioner-only vocational rehabilitation tool for evaluating whether an injured worker's occupational goal is medically and vocationally suitable. Vocational rehabilitation practitioners use it to compare restrictions, skills, interests, and labor-market fit against job requirements and identify barriers that must be addressed.",
		"demoTitle": "Open the sample matrix and review the target job comparison.",
		"demoPrompt": "Interested in using Person-Job Match Matrix with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1081-f-070-vr-008-r001-person-job-match-matrix.md",
		"specId": "1081-f-070-vr-008-r001-person-job-match-matrix",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Career counseling",
				"Functioning and disability"
			],
			"population": [
				"Injured workers"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when the practitioner is evaluating whether a specific occupational goal is realistic and suitable enough to pursue, modify, or reject."
			},
			{
				"title": "Important Limitation",
				"body": "The matrix organizes practitioner-entered evidence and descriptive gaps. It does not calculate a suitability score, generate occupations, or make clinical, disability, compensation, or legal determinations."
			},
			{
				"title": "History",
				"body": "Saved matrices preserve the target job, factor entries, gaps, barriers, and final decision at the time of review so later versions can be compared without overwriting the original reasoning."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide whether the job is suitable?",
				"answer": "No. The practitioner selects the go, modify, or reject decision after reviewing the matrix; the system only organizes evidence and descriptive gaps."
			},
			{
				"question": "Can I compare more than one target job?",
				"answer": "Yes. The configuration supports comparing a single worker profile against one or more target jobs."
			},
			{
				"question": "Is there a client form for the worker to complete?",
				"answer": "No. This is practitioner-only; worker information can be entered or confirmed by the practitioner as profile evidence."
			}
		]
	},
	{
		"toolType": "returnToWorkPlan",
		"slug": "return-to-work-plan",
		"title": "Return-to-Work Plan | Vocational Rehabilitation | Qwoach",
		"metaDescription": "Create a vocational return-to-work pathway with employment goals, services, responsibilities, constraints, milestones, and progress status.",
		"h1": "Return-to-Work Plan",
		"intro": "The Return-to-Work Plan is a vocational rehabilitation planning tool for practitioners and injured workers. Practitioners use it to define a suitable employment goal, assign responsibilities, document services and constraints, and monitor concrete next steps toward reemployment.",
		"demoTitle": "Explore a sample return-to-work pathway.",
		"demoPrompt": "Interested in using Return-to-Work Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1082-f-070-vr-009-r001-return-to-work-plan.md",
		"specId": "1082-f-070-vr-009-r001-return-to-work-plan",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Career counseling",
				"Goals"
			],
			"population": [
				"Injured workers"
			]
		},
		"sections": [
			{
				"title": "Practitioner And Worker Roles",
				"body": "The practitioner controls plan structure and final content. The worker can acknowledge the pathway and update assigned responsibilities when the plan is shared."
			},
			{
				"title": "Revision History",
				"body": "Material plan revisions preserve prior milestones and decisions so progress can be monitored over time."
			},
			{
				"title": "Boundary",
				"body": "The plan coordinates agreed return-to-work actions. It does not determine medical suitability, generate employment goals, or replace underlying assessments."
			}
		],
		"faqItems": [
			{
				"question": "Can the worker participate in the plan?",
				"answer": "Yes. The worker can review the pathway, acknowledge responsibilities, and provide simple updates on assigned steps when shared."
			},
			{
				"question": "What happens if the employment goal is missing?",
				"answer": "The plan remains a draft and cannot be considered actionable until the employment goal is defined."
			},
			{
				"question": "Can I omit sections that are not relevant?",
				"answer": "Yes. The practitioner can include only relevant sections for services, accommodations, job search, and constraints."
			}
		]
	},
	{
		"toolType": "trainingPlan",
		"slug": "training-plan",
		"title": "Training Plan | Vocational Rehabilitation Pathway | Qwoach",
		"metaDescription": "Define a training pathway that links documented vocational gaps to a suitable occupation, prerequisites, duration, expected skills, and status.",
		"h1": "Training Plan",
		"intro": "The Training Plan is a vocational rehabilitation tool for practitioners and injured workers when skill development is needed before suitable employment is realistic. Practitioners use it to connect documented vocational gaps to a target occupation, prerequisites, duration, expected skill gains, responsibilities, and milestones.",
		"demoTitle": "Explore the sample training pathway.",
		"demoPrompt": "Interested in using Training Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1083-f-070-vr-010-r001-training-plan.md",
		"specId": "1083-f-070-vr-010-r001-training-plan",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Career counseling"
			],
			"population": [
				"Injured workers"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures the target occupation, training need source, documented gaps, prerequisites, duration, expected skill gains, suitability considerations, responsibilities, and milestone status."
			},
			{
				"title": "Worker Role",
				"body": "The worker can review the pathway, understand why training is needed, acknowledge responsibilities, and provide simple updates on assigned training steps."
			},
			{
				"title": "Boundary",
				"body": "The tool records and tracks a pathway. It does not perform testing, transferable-skills analysis, labor-market review, medical evaluation, course recommendation, or employability prediction."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool recommend courses?",
				"answer": "No. The practitioner defines the training pathway and components; the system organizes the pathway and flags completeness issues."
			},
			{
				"question": "Can the plan be finalized without a target occupation?",
				"answer": "No. Without a target occupation, the plan remains incomplete."
			},
			{
				"question": "What does milestone granularity change?",
				"answer": "Milestone granularity changes the amount of progress tracking detail, not the vocational meaning of the training pathway."
			}
		]
	},
	{
		"toolType": "jobSearchActivityLog",
		"slug": "job-search-activity-log",
		"title": "Job Search Activity Log | Placement Monitoring | Qwoach",
		"metaDescription": "Track job-search contacts, outcomes, interviews, responses, nonresponses, obstacles, and activity patterns during active placement.",
		"h1": "Job Search Activity Log",
		"intro": "The Job Search Activity Log is a ready-to-send vocational rehabilitation tool for workers in active job placement and the practitioners who monitor their search. Practitioners use it to review contacts, outcomes, response patterns, missing activity periods, and obstacles so they can decide the next placement intervention.",
		"demoTitle": "Open the sample activity log.",
		"demoPrompt": "Interested in using Job Search Activity Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1084-f-070-vr-011-r001-job-search-activity-log.md",
		"specId": "1084-f-070-vr-011-r001-job-search-activity-log",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Career counseling",
				"Outcome monitoring"
			],
			"population": [
				"Injured workers"
			]
		},
		"sections": [
			{
				"title": "Minimum Worker Entry",
				"body": "Submitted entries require enough information to understand what happened and when: date, activity/contact, employer or target, activity type, and outcome/status."
			},
			{
				"title": "Review Limits",
				"body": "If no entries are submitted, the result shows no reported activity. It does not infer intent, blame, or noncompliance unless the practitioner interprets the record."
			},
			{
				"title": "Longitudinal Use",
				"body": "Historical entries support trend review across placement periods while preserving original reported activity."
			}
		],
		"faqItems": [
			{
				"question": "Does no submitted activity mean noncompliance?",
				"answer": "No. The result shows no reported activity; practitioner interpretation remains separate."
			},
			{
				"question": "Can outcomes be unknown?",
				"answer": "Yes. Entries can remain valid with unknown status when the worker does not yet know the result."
			},
			{
				"question": "Are draft entries counted?",
				"answer": "No. Partial draft entries save for recovery but are excluded from final counts until minimally complete."
			}
		]
	},
	{
		"toolType": "jobSearchBarrierLog",
		"slug": "job-search-barrier-log",
		"title": "Job Search Barrier Log | Barrier Review | Qwoach",
		"metaDescription": "Identify, prioritize, and track job-search barriers, resolution paths, escalation needs, and resolved or unresolved status.",
		"h1": "Job Search Barrier Log",
		"intro": "The Job Search Barrier Log is a vocational rehabilitation troubleshooting tool for practitioners monitoring a worker's job search. Practitioners use it to identify, prioritize, and track worker, employer, labor-market, medical, logistical, mixed, or uncertain barriers and the status of resolution efforts.",
		"demoTitle": "Review the sample barrier picture.",
		"demoPrompt": "Interested in using Job Search Barrier Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1085-f-070-vr-012-r001-job-search-barrier-log.md",
		"specId": "1085-f-070-vr-012-r001-job-search-barrier-log",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Problem solving",
				"Intervention planning"
			],
			"topic": [
				"Career counseling",
				"Environmental barriers",
				"Problem solving"
			],
			"population": [
				"Injured workers"
			]
		},
		"sections": [
			{
				"title": "Barrier Categories",
				"body": "Supported distinctions are worker, employer, labor-market, medical, logistical, mixed, and other or unspecified when interpretation is uncertain."
			},
			{
				"title": "Reported Versus Interpreted",
				"body": "Worker descriptions can be preserved as reported information while the practitioner controls category, priority, resolution path, escalation need, and final status."
			},
			{
				"title": "Boundary",
				"body": "The log organizes barrier data and resolution status. It does not determine causation independently, assign blame, or create clinical, legal, or compliance findings."
			}
		],
		"faqItems": [
			{
				"question": "Can a worker report barriers without choosing a category?",
				"answer": "Yes. The worker can use plain language; practitioner categorization happens during review."
			},
			{
				"question": "What if a barrier is disputed or uncertain?",
				"answer": "The reported description is preserved and the interpretation can be marked unresolved."
			},
			{
				"question": "Does the tool prove why the job search is stalled?",
				"answer": "No. It organizes barriers and status; causal interpretation remains practitioner-controlled."
			}
		]
	},
	{
		"toolType": "accommodationAssistiveTechnologyPlan",
		"slug": "accommodation-assistive-technology-plan",
		"title": "Accommodation / Assistive Technology Plan | Qwoach",
		"metaDescription": "Plan workplace accommodations, assistive technology, ergonomics, and environmental supports with responsibility, status, and barriers.",
		"h1": "Accommodation / Assistive Technology Plan",
		"intro": "The Accommodation / Assistive Technology Plan is a vocational rehabilitation support-planning tool for practitioners and injured workers. Practitioners use it to tie accommodations, assistive technology, ergonomics, or environmental supports to work demands and functional limitations, assign responsibility, track implementation, and review unresolved barriers.",
		"demoTitle": "Explore the sample support plan.",
		"demoPrompt": "Interested in using Accommodation / Assistive Technology Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1086-f-070-vr-013-r001-accommodation-assistive-technology-plan.md",
		"specId": "1086-f-070-vr-013-r001-accommodation-assistive-technology-plan",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Environmental barriers",
				"Functioning and disability",
				"Occupational participation"
			],
			"population": [
				"Injured workers"
			]
		},
		"sections": [
			{
				"title": "What It Tracks",
				"body": "Each support can include support type, work demand, functional limitation, responsible party, status, barrier, worker feedback, and practitioner viability review."
			},
			{
				"title": "Worker Role",
				"body": "The worker can report whether a support is available, usable, missing, or creating a new barrier, without assigning legal or medical meaning."
			},
			{
				"title": "Boundary",
				"body": "The tool records practitioner-defined support planning. It does not determine medical restrictions, mandate accommodation choices, decide employer obligations, or generate technology recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can I include only assistive technology or only ergonomics?",
				"answer": "Yes. The practitioner chooses the relevant support types for the case."
			},
			{
				"question": "What if implementation status is unknown?",
				"answer": "Unknown status remains unknown and is not treated as pending or implemented."
			},
			{
				"question": "Does the tool decide whether an accommodation is legally required?",
				"answer": "No. The tool tracks support requirements and status; it does not make legal determinations."
			}
		]
	},
	{
		"toolType": "vocationalEvaluationReport",
		"slug": "vocational-evaluation-report",
		"title": "Vocational Evaluation Report | Evidence Review | Qwoach",
		"metaDescription": "Organize medical, vocational, educational, and labor-market factors into findings, implications, recommendations, and decision basis.",
		"h1": "Vocational Evaluation Report",
		"intro": "The Vocational Evaluation Report is a practitioner-only vocational rehabilitation tool for building a comprehensive decision document. Practitioners use it to organize medical, vocational, educational, and labor-market factors, connect strengths and limitations to vocational implications, and link recommendations to supporting findings.",
		"demoTitle": "Explore the sample report outline.",
		"demoPrompt": "Interested in using Vocational Evaluation Report with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1087-f-070-vr-014-r001-vocational-evaluation-report.md",
		"specId": "1087-f-070-vr-014-r001-vocational-evaluation-report",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Assessment",
				"Clinical documentation"
			],
			"topic": [
				"Career counseling",
				"Functioning and disability",
				"Strengths"
			],
			"population": [
				"Injured workers"
			]
		},
		"sections": [
			{
				"title": "Current Template Boundary",
				"body": "The supplied record does not provide exact required report prompts or fields. The demo therefore shows placeholders and supported factor groups without inventing standardized content."
			},
			{
				"title": "Reasoning Trace",
				"body": "Recommendations can be linked to findings so the decision basis is visible for case coordination and review."
			},
			{
				"title": "Versioning",
				"body": "Draft reports remain editable. Once used for decision or review, that version should persist and later evidence should create an amended state."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include all required report sections?",
				"answer": "No. Exact report elements are unresolved from the supplied record, so the demo shows only supported factor groups and placeholder structure."
			},
			{
				"question": "Does the tool write recommendations automatically?",
				"answer": "No. The practitioner enters recommendations and links them to supporting findings."
			},
			{
				"question": "Is there a worker-facing version?",
				"answer": "No. The smallest complete product is practitioner-only; external sharing is a surrounding workflow choice."
			}
		]
	},
	{
		"toolType": "psychoeducationalProfileThirdEditionPep3",
		"slug": "psychoeducational-profile-third-edition-pep-3",
		"title": "PEP-3 Profile Workflow | Developmental Review | Qwoach",
		"metaDescription": "Record authorized PEP-3-derived results as a developmental profile of strengths, needs, emerging skills, and support priorities.",
		"h1": "Psychoeducational Profile - Third Edition (PEP-3)",
		"intro": "The Psychoeducational Profile - Third Edition (PEP-3) workflow is a practitioner-only assessment profile tool for practitioners assessing an autistic child or learner. Practitioners use it to record authorized PEP-3-derived results and review developmental strengths, needs, emerging skills, priority support needs, and practitioner-entered implications for goals or teaching supports.",
		"demoTitle": "Explore the profile shell.",
		"demoPrompt": "Interested in using Psychoeducational Profile - Third Edition (PEP-3) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1088-f-071-teacch-001-r001-psychoeducational-profile-third-edition-pep-3.md",
		"specId": "1088-f-071-teacch-001-r001-psychoeducational-profile-third-edition-pep-3",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Autism",
				"Developmental functioning",
				"Strengths"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Unresolved Assessment Structure",
				"body": "Exact prompts, items, ratings, scoring, domains, worksheets, and report structure are not supplied, so the public demo uses only a profile shell and practitioner-entered summary examples."
			},
			{
				"title": "Practitioner-Only Workflow",
				"body": "The learner may participate in assessment activities outside the product, but no learner-facing digital assessment prompts are part of this smallest configuration."
			},
			{
				"title": "Longitudinal Records",
				"body": "Finalized profiles are dated records; later reassessment creates a new profile rather than overwriting the prior one."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include PEP-3 items or scoring?",
				"answer": "No. Exact PEP-3 prompts, items, scoring, domains, and report structure are unresolved from the supplied record and are not invented."
			},
			{
				"question": "Can the system generate developmental interpretations?",
				"answer": "No. Practitioner interpretation is entered by the practitioner; the system only organizes entered information."
			},
			{
				"question": "Is there a learner-facing assessment form?",
				"answer": "No. The smallest complete product is practitioner-only."
			}
		]
	},
	{
		"toolType": "teacchTransitionAssessmentProfileTtap",
		"slug": "teacch-transition-assessment-profile-ttap",
		"title": "TTAP Profile Workflow | Transition Review | Qwoach",
		"metaDescription": "Record authorized TTAP-derived transition strengths, needs, priority skill areas, support needs, and planning implications.",
		"h1": "TEACCH Transition Assessment Profile (TTAP)",
		"intro": "The TEACCH Transition Assessment Profile (TTAP) workflow is a practitioner-only transition assessment profile tool for practitioners supporting an autistic student moving from school age toward adolescence or adulthood. Practitioners use it to record authorized TTAP-derived strengths, needs, priority skill areas, support priorities, and planning implications for school, home, community, or work contexts.",
		"demoTitle": "Explore the transition profile shell.",
		"demoPrompt": "Interested in using TEACCH Transition Assessment Profile (TTAP) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1089-f-071-teacch-002-r001-teacch-transition-assessment-profile-ttap.md",
		"specId": "1089-f-071-teacch-002-r001-teacch-transition-assessment-profile-ttap",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Autism",
				"Developmental functioning",
				"Transition planning"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Unresolved Assessment Structure",
				"body": "Exact TTAP prompts, fields, ratings, scoring, domains, and report layout are not supplied, so the demo uses only practitioner-entered summary examples and unresolved placeholders."
			},
			{
				"title": "Practitioner-Only Workflow",
				"body": "The student may participate in assessment activities outside the product, but no student-facing TTAP items or rating tasks are part of this smallest configuration."
			},
			{
				"title": "Use In Planning",
				"body": "The profile can inform individualized transition goals and supports, but it is not itself a full service plan."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include TTAP items or ratings?",
				"answer": "No. Exact TTAP content is unresolved from the supplied record and is not invented."
			},
			{
				"question": "Can the tool generate transition goals automatically?",
				"answer": "No. The practitioner records planning implications; the tool does not generate goals automatically."
			},
			{
				"question": "Does the profile predict adult outcomes?",
				"answer": "No. The result organizes entered strengths, needs, priorities, and supports; it does not predict adult outcomes."
			}
		]
	},
	{
		"toolType": "structuredTeachingAssessment",
		"slug": "structured-teaching-assessment",
		"title": "Structured Teaching Assessment | Support Recommendations | Qwoach",
		"metaDescription": "Create individualized recommendations for schedules, work systems, and visual supports tied to observed learner needs and independence goals.",
		"h1": "Structured Teaching Assessment",
		"intro": "The Structured Teaching Assessment is a practitioner-administered support assessment for autistic learners whose schedules, work systems, or visual supports need to be individualized. Practitioners use it to record observations, create recommendations tied to observed needs, specify implementation detail, and target greater independence rather than only adult prompting.",
		"demoTitle": "Explore the recommendation map.",
		"demoPrompt": "Interested in using Structured Teaching Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1090-f-071-teacch-003-r001-structured-teaching-assessment.md",
		"specId": "1090-f-071-teacch-003-r001-structured-teaching-assessment",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Autism",
				"Developmental functioning",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures observed learner needs, schedule needs, work-system needs, visual-support needs, current support performance, recommendation detail, intended independence effect, and adjustment notes."
			},
			{
				"title": "Implementer View",
				"body": "The output can provide clear recommendation detail for people implementing supports without becoming a general visual-support design tool."
			},
			{
				"title": "Unresolved Content Boundary",
				"body": "Exact assessment prompts, rating structures, and worksheet fields are unresolved from the supplied record and should remain placeholders until supplied."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool include a visual schedule builder?",
				"answer": "No. It produces recommendations and implementation notes; it is not a general visual-support design tool."
			},
			{
				"question": "Can recommendations be changed later?",
				"answer": "Yes. Follow-up can record learner performance changes and adjust recommendations while preserving prior support states."
			},
			{
				"question": "Does the learner complete a digital form?",
				"answer": "No. The configured product is practitioner-only; learner performance is observed and entered by the practitioner."
			}
		]
	},
	{
		"toolType": "visualDailySchedule",
		"slug": "visual-daily-schedule",
		"title": "Visual Daily Schedule Demo for Structured Teaching | Qwoach",
		"metaDescription": "Create a visual daily schedule for an autistic learner, show current and next activities, and optionally review completion or prompting over time.",
		"h1": "Visual Daily Schedule for Autistic Learners",
		"intro": "Visual Daily Schedule is a learner-facing structured teaching tool for practitioners supporting autistic learners. It helps practitioners represent the day's activities in an understandable order so the learner can anticipate routines, identify current and next activities, and move through transitions with less reliance on adult prompting.",
		"demoTitle": "Start with a sample school-day schedule, then switch between practitioner setup, learner view, and review.",
		"demoPrompt": "Interested in using Visual Daily Schedule with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1091-f-071-teacch-004-r001-visual-daily-schedule.md",
		"specId": "1091-f-071-teacch-004-r001-visual-daily-schedule",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Autism"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for daily routines where the learner needs an understandable representation of activity order, current activity, and next activity."
			},
			{
				"title": "What It Can Track",
				"body": "If enabled, the tool can record descriptive observations of completion, independence, or prompting. Missed observations remain missing rather than being treated as failed performance."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create diagnostic conclusions, symptom ratings, standardized scores, transition protocols, or reward systems."
			}
		],
		"faqItems": [
			{
				"question": "Does the learner complete a form?",
				"answer": "No. The learner uses the visual schedule directly; the practitioner controls setup and any observation tracking."
			},
			{
				"question": "Can I save a schedule without tracking observations?",
				"answer": "Yes. Tracking is optional; the visual schedule itself can still be saved and used."
			},
			{
				"question": "What happens if the schedule is interrupted?",
				"answer": "The schedule should reopen at the last known current activity or allow the practitioner to reset current position without changing historical observations."
			},
			{
				"question": "Does the tool score independence?",
				"answer": "No. It records descriptive observations only when tracking is enabled."
			}
		]
	},
	{
		"toolType": "individualWorkSystem",
		"slug": "individual-work-system",
		"title": "Individual Work System Demo for Autistic Learners | Qwoach",
		"metaDescription": "Set up a structured work system that shows what work to do, how much to do, when finished, and what comes next for an autistic learner.",
		"h1": "Individual Work System for Structured Work Completion",
		"intro": "Individual Work System is a ready-to-complete-together tool for practitioners supporting autistic learners. It helps the practitioner define what work to do, how much work is expected, how the learner knows it is finished, and what comes next so the learner can participate in work routines with greater independence.",
		"demoTitle": "Set up a sample work routine, then preview the learner-facing work system and practitioner review.",
		"demoPrompt": "Interested in using Individual Work System with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1092-f-071-teacch-005-r001-individual-work-system.md",
		"specId": "1092-f-071-teacch-005-r001-individual-work-system",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Autism",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Required Work-System Elements",
				"body": "A complete setup must show what work, how much work, when the work is finished, and what comes next."
			},
			{
				"title": "Observation Use",
				"body": "Tracking is optional and descriptive. Missing observations are not treated as noncompletion."
			},
			{
				"title": "History Limits",
				"body": "Historical comparison depends on similar task demands and representation; changes to difficulty or setup should remain visible."
			}
		],
		"faqItems": [
			{
				"question": "Is the next-step cue optional?",
				"answer": "No. A next-step cue is required for the work-system meaning and an absent cue makes setup incomplete."
			},
			{
				"question": "Does this tool create task content for me?",
				"answer": "No. The practitioner provides the assigned work, sequence, amount, finish criteria, and next step."
			},
			{
				"question": "Can interrupted work be resumed?",
				"answer": "Yes. Interrupted work should preserve completed tasks or allow the practitioner to reset for the next use."
			},
			{
				"question": "Does the tool score independence?",
				"answer": "No. It can record descriptive completion, independence, and prompting observations without unsupported scales."
			}
		]
	},
	{
		"toolType": "physicalStructurePlan",
		"slug": "physical-structure-plan",
		"title": "Physical Structure Plan Demo for Autistic Learners | Qwoach",
		"metaDescription": "Plan activity areas, boundaries, expectations, and movement paths so an autistic learner's environment supports participation and independence.",
		"h1": "Physical Structure Plan for Structured Teaching Environments",
		"intro": "Physical Structure Plan is a practitioner-only structured teaching tool for practitioners supporting autistic learners. It helps practitioners arrange a learning or activity environment so the learner can understand locations, boundaries, expectations, and movement between areas.",
		"demoTitle": "Explore a sample activity-space plan, then review its areas, boundaries, movement paths, and observation notes.",
		"demoPrompt": "Interested in using Physical Structure Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1093-f-071-teacch-006-r001-physical-structure-plan.md",
		"specId": "1093-f-071-teacch-006-r001-physical-structure-plan",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Autism",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "This tool supports planning and review by the practitioner or support team. It does not require learner data entry."
			},
			{
				"title": "What the Plan Captures",
				"body": "The plan captures the specific space, activity areas, boundaries, expectations, movement paths, intended routines, support needs, and optional observations."
			},
			{
				"title": "Comparison Limits",
				"body": "Environmental changes can make older observations hard to compare. Prior plan states should remain visible when reviewing history."
			}
		],
		"faqItems": [
			{
				"question": "Does the learner use this as a digital activity?",
				"answer": "No. The learner experiences the arranged environment; the digital product is for practitioner planning and review."
			},
			{
				"question": "Do I need an architectural floor plan?",
				"answer": "No. The product should not require architectural precision beyond what is needed to convey the support plan."
			},
			{
				"question": "What makes a plan incomplete?",
				"answer": "A plan without activity areas or boundaries is incomplete for this tool's purpose."
			},
			{
				"question": "Does it decide whether the environment is clinically appropriate?",
				"answer": "No. It organizes reported plan elements and observations; appropriateness remains practitioner interpreted."
			}
		]
	},
	{
		"toolType": "visualTaskOrganization",
		"slug": "visual-task-organization",
		"title": "Visual Task Organization Demo for Autistic Learners | Qwoach",
		"metaDescription": "Organize task materials, sequence, and response cues so an autistic learner can attempt tasks with clearer structure and descriptive review.",
		"h1": "Visual Task Organization for Structured Teaching Tasks",
		"intro": "Visual Task Organization is a ready-to-complete-together tool for practitioners supporting autistic learners. It helps practitioners visually organize task materials, sequence, or response expectations so the learner can attempt the task with greater independence and fewer errors.",
		"demoTitle": "Configure a sample task organization, then compare practitioner setup, learner view, and review.",
		"demoPrompt": "Interested in using Visual Task Organization with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1094-f-071-teacch-007-r001-visual-task-organization.md",
		"specId": "1094-f-071-teacch-007-r001-visual-task-organization",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Autism",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Organizes",
				"body": "The tool can emphasize task materials, sequence, response quality, or a supported combination chosen by the practitioner."
			},
			{
				"title": "What It Observes",
				"body": "Optional observations can describe errors, corrections, independence, and adult clarification. Observations remain descriptive."
			},
			{
				"title": "Version Awareness",
				"body": "Task setup changes should remain visible because changes in materials, sequence, or cues may affect performance comparison."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create a task curriculum?",
				"answer": "No. The practitioner provides the task content; the tool organizes materials, sequence, and cues."
			},
			{
				"question": "Can I track errors?",
				"answer": "Yes, if performance tracking is enabled, errors and corrections can be recorded descriptively."
			},
			{
				"question": "Does it explain why errors happened?",
				"answer": "No. Error causes are not interpreted automatically."
			},
			{
				"question": "What if an attempt is interrupted?",
				"answer": "An interrupted attempt should retain task state if continuation is meaningful or allow restart without treating interruption as an error."
			}
		]
	},
	{
		"toolType": "shoeboxTask",
		"slug": "shoebox-task",
		"title": "Shoebox Task Demo for Structured Teaching | Qwoach",
		"metaDescription": "Prepare a structured hands-on task with a target skill, materials, task demand, clear finish cue, and optional completion or prompting observations.",
		"h1": "Shoebox Task for Structured Hands-On Learning",
		"intro": "Shoebox Task is a ready-to-complete-together structured teaching tool for practitioners supporting autistic learners. It helps practitioners prepare a concrete hands-on task with a targeted skill, organized materials, a clear task demand, and a clear finish cue so the learner can complete the task with appropriate support.",
		"demoTitle": "Build a sample task setup, preview the learner-facing task presentation, and inspect optional observations.",
		"demoPrompt": "Interested in using Shoebox Task with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1095-f-071-teacch-008-r001-shoebox-task.md",
		"specId": "1095-f-071-teacch-008-r001-shoebox-task",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Practice"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Autism",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Clear Finish Is Required",
				"body": "A setup without a clear finish cue is invalid for this tool's purpose."
			},
			{
				"title": "Prompting Can Be Appropriate",
				"body": "Completion with appropriate prompting can still meet the intended use; prompting observations should remain descriptive."
			},
			{
				"title": "No Built-In Task Library",
				"body": "The tool supports practitioner-provided task setup and observation; it does not invent task designs or curriculum content."
			}
		],
		"faqItems": [
			{
				"question": "Does Shoebox Task generate task ideas?",
				"answer": "No. The practitioner provides or separately supplies the task design, materials, and target skill."
			},
			{
				"question": "Can I save a task without observation tracking?",
				"answer": "Yes. The fixed task setup can be saved, and tracking can be off if the practitioner does not want to record observations."
			},
			{
				"question": "Does it determine skill mastery?",
				"answer": "No. It records descriptive performance information and does not make automated mastery conclusions."
			},
			{
				"question": "How are interruptions handled?",
				"answer": "Interrupted attempts should be recorded separately from noncompletion when tracking is used."
			}
		]
	},
	{
		"toolType": "tasksGaloreEarlyEducation",
		"slug": "tasks-galore-early-education",
		"title": "Tasks Galore: Early Education Demo | Qwoach",
		"metaDescription": "Plan early-education structured activities by curriculum area, materials, visual organization, and observations without entering real learner data.",
		"h1": "Tasks Galore: Early Education Activity Planning Support",
		"intro": "Tasks Galore: Early Education is a practitioner-facing activity planning tool for teachers, therapists, parents, and practitioners supporting autistic or otherwise exceptional young learners. It helps practitioners select or adapt visually structured hands-on early-education activities across areas such as fine motor, readiness, language arts, mathematics, reasoning, and play, then observe whether the activity.",
		"demoTitle": "Choose a sample curriculum area, fill the planning container, and review a fictional observation.",
		"demoPrompt": "Interested in using Tasks Galore: Early Education with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1096-f-071-teacch-009-r001-tasks-galore-early-education.md",
		"specId": "1096-f-071-teacch-009-r001-tasks-galore-early-education",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Autism",
				"Developmental functioning",
				"Skills use"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures curriculum area, learner level, skill target, materials, selected or adapted activity reference, visual or multi-modal structure, setting, and optional observations."
			},
			{
				"title": "Activity Content Boundary",
				"body": "The product provides planning containers for practitioner-supplied activity ideas. It does not generate or reproduce exact activity prompts, photographs, pages, or instructions."
			},
			{
				"title": "Repeat Use",
				"body": "Comparable observations can help the practitioner review progress or recurring support needs within the intended early skill area."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include the book's exact activities?",
				"answer": "No. It supports practitioner-selected or adapted activity references and does not reproduce or invent exact book content."
			},
			{
				"question": "Who is this for?",
				"answer": "It is for teachers, therapists, parents, and practitioners planning structured early-education activities for autistic or otherwise exceptional young learners."
			},
			{
				"question": "Can I track learner performance?",
				"answer": "Yes. Optional observations can describe engagement, independence, performance, and adaptation needs."
			},
			{
				"question": "Does it assign developmental scores?",
				"answer": "No. It does not create standardized scores or clinical conclusions."
			}
		]
	},
	{
		"toolType": "tasksGaloreForTheRealWorld",
		"slug": "tasks-galore-for-the-real-world",
		"title": "Tasks Galore: For the Real World Demo | Qwoach",
		"metaDescription": "Plan structured functional routines for home, school, community, workplace, or transition practice with steps, materials, and observations.",
		"h1": "Tasks Galore: For the Real World Functional Routine Planning",
		"intro": "Tasks Galore: For the Real World is a practitioner-facing planning tool for practitioners preparing older children, adolescents, or adults for home, school, community, workplace, or transition participation. It helps practitioners structure functional routines with goals, settings, steps, materials, visual strategies, and descriptive observations of independence, accuracy, or support needs.",
		"demoTitle": "Choose a sample functional routine category, plan the steps, and review a fictional attempt.",
		"demoPrompt": "Interested in using Tasks Galore: For the Real World with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1097-f-071-teacch-009-r002-tasks-galore-for-the-real-world.md",
		"specId": "1097-f-071-teacch-009-r002-tasks-galore-for-the-real-world",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Autism",
				"Transition planning",
				"Occupational participation"
			],
			"population": [
				"Adolescents",
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Supported Contexts",
				"body": "The tool supports planning for home, school, community, workplace, transition, or training contexts."
			},
			{
				"title": "Observation Boundary",
				"body": "Independence, accuracy, and support needs can be observed descriptively. The tool does not produce employability or adult-readiness decisions."
			},
			{
				"title": "Routine Versioning",
				"body": "Changes in setting, steps, materials, or support can affect comparability and should remain visible in review."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide whether someone is ready for work or adult life?",
				"answer": "No. It supports functional routine practice and descriptive observation, not readiness or employment determinations."
			},
			{
				"question": "Can routines be practiced outside the real setting?",
				"answer": "Yes. The practice setting can be a training context or a naturalistic setting, and the setting should remain visible in review."
			},
			{
				"question": "Does the tool provide exact routine instructions from a book?",
				"answer": "No. The practitioner supplies or separately provides the routine content, steps, and materials."
			},
			{
				"question": "What can be tracked?",
				"answer": "Optional tracking can describe independence, accuracy, completed steps, and support needs."
			}
		]
	},
	{
		"toolType": "tasksGaloreMakingGroupsMeaningful",
		"slug": "tasks-galore-making-groups-meaningful",
		"title": "Tasks Galore: Making Groups Meaningful Demo | Qwoach",
		"metaDescription": "Plan structured group activities with themes, flow, roles, individualized supports, and descriptive participation observations for students.",
		"h1": "Tasks Galore: Making Groups Meaningful Group Activity Planning",
		"intro": "Tasks Galore: Making Groups Meaningful is a practitioner-facing planning tool for teachers, therapists, parents, and practitioners designing group-learning activities. It helps practitioners organize themes, activity flow, roles or expectations, and individualized supports so autistic students or students with communication challenges can show observable participation rather than passive presence.",
		"demoTitle": "Set up a sample group activity, add individualized supports, and review fictional participation notes.",
		"demoPrompt": "Interested in using Tasks Galore: Making Groups Meaningful with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1098-f-071-teacch-009-r003-tasks-galore-making-groups-meaningful.md",
		"specId": "1098-f-071-teacch-009-r003-tasks-galore-making-groups-meaningful",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Autism",
				"Interpersonal relationships",
				"Skills use"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Individual Supports Are Central",
				"body": "The plan should show overall group flow and the individualized supports needed for participation."
			},
			{
				"title": "Student Experience",
				"body": "Students participate in the group routine, project, or activity; they are not required to complete a digital form."
			},
			{
				"title": "History Limits",
				"body": "Group composition, context, and support profiles affect comparability across activities and should remain visible."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create group lesson plans?",
				"answer": "No. It structures practitioner-provided group activities and supports; it does not invent curricula or exact activities."
			},
			{
				"question": "Can I include students who do not need individualized supports?",
				"answer": "Yes, but the plan should make explicit when no individualized support is needed for an included student."
			},
			{
				"question": "Does it measure social competence?",
				"answer": "No. Participation observations are descriptive and do not produce unsupported social scores."
			},
			{
				"question": "What happens if a group session is interrupted?",
				"answer": "The session can be marked partial, and observations should remain tied to the activity segments that occurred."
			}
		]
	},
	{
		"toolType": "transitionSkillPlan",
		"slug": "transition-skill-plan",
		"title": "Transition Skill Plan Demo | Qwoach",
		"metaDescription": "Create transition skill goals linked to future environments, participation needs, strengths, support needs, concrete targets, and progress monitoring.",
		"h1": "Transition Skill Plan for Autistic Learners",
		"intro": "Transition Skill Plan is a practitioner-guided planning tool for practitioners supporting autistic learners approaching a transition point. It helps practitioners define transition skill goals connected to future school, work, community, or adult-life environments, identified strengths, support needs, concrete skill targets, and progress monitoring.",
		"demoTitle": "Explore a sample transition goal map and check whether each goal is specific and monitorable.",
		"demoPrompt": "Interested in using Transition Skill Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1099-f-071-teacch-010-r001-transition-skill-plan.md",
		"specId": "1099-f-071-teacch-010-r001-transition-skill-plan",
		"tags": {
			"framework": [
				"TEACCH"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Progress review"
			],
			"topic": [
				"Autism",
				"Transition planning",
				"Goals"
			],
			"population": [
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Goal Traceability",
				"body": "Every goal should connect to a future participation need and to identified strengths or support needs."
			},
			{
				"title": "Progress Monitoring",
				"body": "Progress observations are descriptive and remain tied to stable goal and target wording for comparison."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not administer standardized assessments, determine eligibility, or recommend placement."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool administer TTAP?",
				"answer": "No. It creates a transition skill plan and does not implement standardized TTAP scoring or assessment items."
			},
			{
				"question": "Can the learner participate in planning?",
				"answer": "Yes, when appropriate, but the record does not define exact learner prompts; the workflow remains practitioner-guided."
			},
			{
				"question": "What makes a goal incomplete?",
				"answer": "A goal is incomplete when it lacks a future participation need, concrete skill target, or relevant strengths/support context."
			},
			{
				"question": "Does it predict transition success?",
				"answer": "No. It organizes goals and progress observations without predicting outcomes."
			}
		]
	},
	{
		"toolType": "scertsAssessmentProcessSap",
		"slug": "scerts-assessment-process-sap",
		"title": "SCERTS Assessment Process SAP Demo | Qwoach",
		"metaDescription": "Organize practitioner-entered SAP developmental needs, priority objectives, transactional supports, and progress review areas without scoring.",
		"h1": "SCERTS Assessment Process (SAP) Profile Support",
		"intro": "SCERTS Assessment Process (SAP) is a practitioner-only coordinated assessment and planning tool for practitioners supporting autistic children or learners. It helps practitioners organize practitioner-entered developmental needs, priority objectives, needed transactional supports, and progress review areas so intervention planning can be coordinated around meaningful developmental progress.",
		"demoTitle": "Explore a sample practitioner-authored SAP profile container and review completeness indicators.",
		"demoPrompt": "Interested in using SCERTS Assessment Process (SAP) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1100-f-072-scerts-001-r001-scerts-assessment-process-sap.md",
		"specId": "1100-f-072-scerts-001-r001-scerts-assessment-process-sap",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Autism",
				"Emotion regulation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Practitioner-Only Profile",
				"body": "The product supports practitioner or assessment-team entry and review. It does not require learner self-report or direct product interaction."
			},
			{
				"title": "Completeness Checks",
				"body": "Completeness indicators can identify objectives without linked supports, supports without linked objectives, or progress areas not yet revisited."
			},
			{
				"title": "Content Boundary",
				"body": "The product does not provide SAP manualized forms, items, scoring, objective taxonomy, prompts, or automated recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does this demo include SAP scoring?",
				"answer": "No. The product does not implement SAP scoring, assessment items, forms, or prompt wording not supplied in the record."
			},
			{
				"question": "Is there a learner-facing view?",
				"answer": "No. This is practitioner-only according to the supplied usage mode."
			},
			{
				"question": "What can be saved?",
				"answer": "The tool itself and practitioner-entered profile structure can be saved, including needs, objectives, supports, links, and progress review mode."
			},
			{
				"question": "Does it generate objectives or supports?",
				"answer": "No. Objectives and supports are entered or validated by the practitioner; the system organizes them and checks completeness."
			}
		]
	},
	{
		"toolType": "sapObservationSapO",
		"slug": "sap-observation-sap-o",
		"title": "SAP Observation (SAP-O) Demo | Qwoach",
		"metaDescription": "Explore SAP-O, a practitioner-only SCERTS observation tool for objective-level ratings grounded in direct child behavior observations.",
		"h1": "SAP Observation (SAP-O)",
		"intro": "SAP Observation (SAP-O) is a practitioner-only SCERTS observation tool. Practitioners use it to capture objective-level performance ratings from observed child behavior in social communication, emotional regulation, or support-related objectives.",
		"demoTitle": "Start with a sample observation, choose relevant objectives, record evidence, and review the rated objective table before saving the tool.",
		"demoPrompt": "Interested in using SAP Observation (SAP-O) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1101-f-072-scerts-002-r001-sap-observation-sap-o.md",
		"specId": "1101-f-072-scerts-002-r001-sap-observation-sap-o",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Autism",
				"Emotion regulation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use SAP-O when direct observation is needed to understand a child's performance on relevant social communication, emotional regulation, or support-related objectives."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures observation context, selected objectives, evidence notes, performance ratings, completeness status, and comparable objective-level history when prior SAP-O records exist."
			},
			{
				"title": "Limits",
				"body": "SAP-O organizes observed evidence and ratings. It does not create diagnoses, infer unobserved capabilities, generate goals, or add objective content outside the configured SCERTS objectives."
			}
		],
		"faqItems": [
			{
				"question": "Does SAP-O require client input?",
				"answer": "No. SAP-O is practitioner-only; the child may be observed, but the child does not enter information or complete prompts."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The SAP-O tool and practitioner configuration are saved. Fictional observation notes, sample ratings, and demo child context are not saved as real client data."
			},
			{
				"question": "Can SAP-O compare ratings over time?",
				"answer": "Yes. SAP-O can show objective-level comparison when prior SAP-O results exist for the same comparable objectives."
			},
			{
				"question": "Does SAP-O interpret the ratings for me?",
				"answer": "No. The result organizes ratings, evidence, completeness, and descriptive change without adding unsupported interpretation."
			}
		]
	},
	{
		"toolType": "sapReportInformantDataSapR",
		"slug": "sap-report-informant-data-sap-r",
		"title": "SAP-R Informant Data Tool Demo | Qwoach",
		"metaDescription": "Explore SAP-R, a ready-to-send SCERTS informant-data tool for collecting cross-context reports tied to relevant objectives.",
		"h1": "SAP Report / Informant Data (SAP-R)",
		"intro": "SAP Report / Informant Data (SAP-R) is a ready-to-send SCERTS informant-data tool. Practitioners use it to collect reports about a child's everyday functioning across relevant contexts and partners beyond direct observation.",
		"demoTitle": "Configure sample objectives and contexts, preview the informant entry point, and review how submitted reports are organized.",
		"demoPrompt": "Interested in using SAP Report / Informant Data (SAP-R) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1102-f-072-scerts-003-r001-sap-report-informant-data-sap-r.md",
		"specId": "1102-f-072-scerts-003-r001-sap-report-informant-data-sap-r",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Autism"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use SAP-R when direct observation is not enough to understand how a child functions across everyday settings and interaction partners."
			},
			{
				"title": "Practitioner And Informant Roles",
				"body": "The practitioner defines the objectives and contexts. Informants report what they know from everyday contexts; they are not asked to make clinical interpretations or planning decisions."
			},
			{
				"title": "Limitations",
				"body": "SAP-R organizes informant evidence and coverage. It does not create diagnoses, resolve conflicting reports automatically, or invent prompts beyond the configured SAP-R content."
			}
		],
		"faqItems": [
			{
				"question": "Who completes SAP-R?",
				"answer": "Informants complete the report, while the practitioner configures the objectives, contexts, and review scope."
			},
			{
				"question": "Can SAP-R be used with only one context?",
				"answer": "Yes. Single-context data is allowed, but the review should mark coverage as limited."
			},
			{
				"question": "Does SAP-R compare informant reports with direct observation?",
				"answer": "Yes, when SAP-O data is available, SAP-R can show descriptive alignment or difference with direct observation."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The SAP-R tool and configuration are saved. Fictional informant responses and sample case data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "012ObjectiveRating",
		"slug": "0-1-2-objective-rating",
		"title": "0-1-2 Objective Rating Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only SCERTS 0-1-2 objective rating tool for comparable absent, emerging, or established performance scores.",
		"h1": "0-1-2 Objective Rating",
		"intro": "0-1-2 Objective Rating is a practitioner-only SCERTS scoring configuration. Practitioners use it to assign comparable objective-level ratings that indicate absent, emerging, or established capability over time.",
		"demoTitle": "Choose sample objectives, apply 0, 1, or 2 ratings, and review how the rating set stays comparable.",
		"demoPrompt": "Interested in using 0-1-2 Objective Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1103-f-072-scerts-004-r001-0-1-2-objective-rating.md",
		"specId": "1103-f-072-scerts-004-r001-0-1-2-objective-rating",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Autism",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Stable Rating Scale",
				"body": "The supported values are 0, 1, and 2. The scale remains stable across administrations so repeated objective ratings can be compared."
			},
			{
				"title": "Consensus Use",
				"body": "When consensus mode is used, draft practitioner ratings can be shown separately before a final shared rating is recorded."
			},
			{
				"title": "Limits",
				"body": "The tool stops at objective-level scoring. It does not generate goals, diagnostic interpretations, composites, weights, or score bands beyond 0, 1, and 2."
			}
		],
		"faqItems": [
			{
				"question": "Can I enter a score other than 0, 1, or 2?",
				"answer": "No. The tool accepts only 0, 1, and 2 for objective-level ratings."
			},
			{
				"question": "Does the tool require consensus?",
				"answer": "No. Consensus mode is available, but a single practitioner rating session is also supported."
			},
			{
				"question": "Can scores be compared over time?",
				"answer": "Yes. Repeated ratings can be compared at the same objective level when objectives remain comparable."
			},
			{
				"question": "What is saved when there are no extra scale settings?",
				"answer": "The tool itself is saved as-is, along with selected objectives and mode. Sample demo scores are not saved as real client data."
			}
		]
	},
	{
		"toolType": "socialCommunicationGoalProfile",
		"slug": "social-communication-goal-profile",
		"title": "Social Communication Goal Profile Demo | Qwoach",
		"metaDescription": "Explore a SCERTS planning tool for recording individualized social communication goals linked to a child's current needs.",
		"h1": "Social Communication Goal Profile",
		"intro": "Social Communication Goal Profile is a ready-to-complete-together SCERTS planning tool. Practitioners use it to identify individualized social communication goals matched to a child's current needs and everyday interaction priorities.",
		"demoTitle": "Review sample profile evidence, record sample goals, and see how each goal links to current need and everyday relevance.",
		"demoPrompt": "Interested in using Social Communication Goal Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1104-f-072-scerts-005-r001-social-communication-goal-profile.md",
		"specId": "1104-f-072-scerts-005-r001-social-communication-goal-profile",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Autism",
				"Goals"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this profile when intervention planning needs social communication goals that reflect a child's current profile and everyday interaction priorities."
			},
			{
				"title": "Collaborative Completion",
				"body": "Caregivers or team members may contribute contextual examples, but the practitioner controls the goal profile and planning decisions."
			},
			{
				"title": "Limits",
				"body": "The result is a social communication goal profile, not a generic goal bank, automated recommendation engine, or full intervention plan."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate goals automatically?",
				"answer": "No. The practitioner records selected or drafted goals and links them to current needs; the tool does not auto-generate substantive goal text."
			},
			{
				"question": "Can caregivers participate?",
				"answer": "Yes, when collaborative mode is used, caregivers or team members can contribute everyday examples without using specialist scoring structures."
			},
			{
				"question": "What makes a goal incomplete?",
				"answer": "A goal without a link to current need evidence is flagged as incomplete."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and reusable configuration are saved. Fictional goals, sample evidence, and demo comments are not saved as real client data."
			}
		]
	},
	{
		"toolType": "emotionalRegulationGoalProfile",
		"slug": "emotional-regulation-goal-profile",
		"title": "Emotional Regulation Goal Profile Demo | Qwoach",
		"metaDescription": "Explore a SCERTS planning tool for individualized emotional regulation goals linked to child needs, contexts, and observable monitoring notes.",
		"h1": "Emotional Regulation Goal Profile",
		"intro": "Emotional Regulation Goal Profile is a ready-to-complete-together SCERTS planning tool. Practitioners use it to identify individualized emotional regulation goals matched to a child's current regulation capacities, needs, and everyday contexts.",
		"demoTitle": "Use sample regulation needs, add context-linked goals, and review whether each goal has observable monitoring notes.",
		"demoPrompt": "Interested in using Emotional Regulation Goal Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1105-f-072-scerts-006-r001-emotional-regulation-goal-profile.md",
		"specId": "1105-f-072-scerts-006-r001-emotional-regulation-goal-profile",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation",
				"Goals"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this profile when regulation needs affect a child's engagement, learning, social interaction, or participation and goals need to be individualized."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures goals, linked regulation capacities or challenges, relevant contexts, observable monitoring notes when provided, and review history."
			},
			{
				"title": "Limits",
				"body": "The tool does not add symptom ratings, diagnoses, coping protocols, automated strategies, or unsupported clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool prescribe regulation strategies?",
				"answer": "No. It records individualized emotional regulation goals and related context; it does not prescribe automated strategies or treatment steps."
			},
			{
				"question": "Can caregivers contribute?",
				"answer": "Yes, in collaborative mode, caregivers or team members can contribute everyday context examples without making clinical judgments."
			},
			{
				"question": "What is flagged during review?",
				"answer": "Goals without context linkage or observable indicators are flagged for practitioner review."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool and practitioner configuration are saved. Fictional goals and sample context examples are not saved as real client data."
			}
		]
	},
	{
		"toolType": "transactionalSupportPlan",
		"slug": "transactional-support-plan",
		"title": "Transactional Support Plan Demo | Qwoach",
		"metaDescription": "Explore a SCERTS planning tool for coordinated interpersonal, educational/environmental, and family supports matched to child needs.",
		"h1": "Transactional Support Plan",
		"intro": "Transactional Support Plan is a ready-to-complete-together SCERTS planning tool. Practitioners use it to specify individualized interpersonal, educational/environmental, and family supports needed for a child to function well.",
		"demoTitle": "Select support areas, enter sample priorities, and review the three-area support map before saving the tool.",
		"demoPrompt": "Interested in using Transactional Support Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1106-f-072-scerts-007-r001-transactional-support-plan.md",
		"specId": "1106-f-072-scerts-007-r001-transactional-support-plan",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Autism",
				"Environmental barriers"
			],
			"population": [
				"Children",
				"Families"
			]
		},
		"sections": [
			{
				"title": "Supported Areas",
				"body": "The plan is organized around interpersonal supports, educational/environmental supports, and family supports."
			},
			{
				"title": "Collaborative Use",
				"body": "Family and team members may contribute priorities and feasibility information, while the practitioner maintains one coherent plan."
			},
			{
				"title": "Limitations",
				"body": "The tool does not add unrelated service plans, unsupported treatment protocols, legal placement decisions, or generated support recommendations."
			}
		],
		"faqItems": [
			{
				"question": "What areas does the plan include?",
				"answer": "The supported areas are interpersonal supports, educational/environmental supports, and family supports."
			},
			{
				"question": "Can an area be excluded?",
				"answer": "Yes. Excluded areas are shown as not addressed rather than assumed unnecessary."
			},
			{
				"question": "Who controls the final plan?",
				"answer": "The practitioner creates and maintains the plan, even when family or team members contribute context."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and configuration are saved. Fictional supports, sample family/team comments, and demo case data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "interpersonalSupportProfile",
		"slug": "interpersonal-support-profile",
		"title": "Interpersonal Support Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only SCERTS profile for identifying partner behaviors that support or hinder child communication and regulation.",
		"h1": "Interpersonal Support Profile",
		"intro": "Interpersonal Support Profile is a practitioner-only SCERTS tool. Practitioners use it to identify how interaction partner behaviors support or hinder a child's communication and regulation in actual contexts.",
		"demoTitle": "Choose a sample interaction context, record partner behaviors, link them to child outcomes, and review the support/barrier profile.",
		"demoPrompt": "Interested in using Interpersonal Support Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1107-f-072-scerts-008-r001-interpersonal-support-profile.md",
		"specId": "1107-f-072-scerts-008-r001-interpersonal-support-profile",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Emotion regulation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The profile captures partner behaviors, contexts, linked child communication or regulation outcomes, and support/barrier classification."
			},
			{
				"title": "Planning Use",
				"body": "The profile can inform partner changes or coaching priorities, but the tool itself does not prescribe coaching scripts."
			},
			{
				"title": "Limits",
				"body": "The result is not a global judgment of partner competence and does not make unsupported causal claims."
			}
		],
		"faqItems": [
			{
				"question": "Do partners complete this tool?",
				"answer": "No. The supplied configuration is practitioner-only; partners may be observed or later coached but do not complete the product."
			},
			{
				"question": "Can a behavior be left unclassified?",
				"answer": "Yes. Ambiguous behaviors may remain unclassified with notes rather than being forced into support or barrier."
			},
			{
				"question": "What makes an entry incomplete?",
				"answer": "A partner behavior without a linked child communication or regulation outcome is incomplete."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and partner/context setup are saved. Fictional behavior entries and sample history are not saved as real client data."
			}
		]
	},
	{
		"toolType": "learningEducationalSupportsPlan",
		"slug": "learning-educational-supports-plan",
		"title": "Learning & Educational Supports Plan Demo | Qwoach",
		"metaDescription": "Explore a SCERTS planning tool for mapping learning barriers to visual, organizational, and environmental supports in routines.",
		"h1": "Learning & Educational Supports Plan",
		"intro": "Learning & Educational Supports Plan is a practitioner-only SCERTS planning tool. Practitioners use it to define educational and environmental supports matched to a child's learning needs, including visual, organizational, or environmental adaptations where relevant.",
		"demoTitle": "Choose a sample learning context, link barriers to supports, and review the implementation-ready plan.",
		"demoPrompt": "Interested in using Learning & Educational Supports Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1108-f-072-scerts-009-r001-learning-educational-supports-plan.md",
		"specId": "1108-f-072-scerts-009-r001-learning-educational-supports-plan",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Environmental barriers",
				"Occupational participation"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this plan when a learning environment needs adaptation to support communication, organization, regulation, or participation."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures barriers, matched supports, adaptation grouping, implementation routines, and monitoring or review status."
			},
			{
				"title": "Limits",
				"body": "The tool does not collect academic grades, create curriculum goals, generate supports automatically, or add unrelated classroom-management features."
			}
		],
		"faqItems": [
			{
				"question": "Is this a classroom-management system?",
				"answer": "No. It is a practitioner-only planning tool for educational and environmental supports linked to child learning or participation barriers."
			},
			{
				"question": "What makes a support incomplete?",
				"answer": "A support without a linked barrier or enough implementation detail is flagged for review."
			},
			{
				"question": "Can I monitor supports over time?",
				"answer": "Yes. The plan can preserve monitoring or review status and historical revisions."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool and configuration are saved. Fictional barriers, supports, and sample routine notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "familySupportPlan",
		"slug": "family-support-plan",
		"title": "Family Support Plan Demo | Qwoach",
		"metaDescription": "Explore a SCERTS family support planning tool for linking stated family priorities to feasible educational or emotional supports.",
		"h1": "Family Support Plan",
		"intro": "Family Support Plan is a ready-to-complete-together SCERTS planning tool. Practitioners use it to integrate family priorities, knowledge needs, and emotional support needs into a child's intervention planning.",
		"demoTitle": "Capture sample family priorities, map them to feasible supports, and review the shared coordination plan.",
		"demoPrompt": "Interested in using Family Support Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1109-f-072-scerts-010-r001-family-support-plan.md",
		"specId": "1109-f-072-scerts-010-r001-family-support-plan",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Service preferences"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Practitioner And Family Roles",
				"body": "Family members contribute priorities and context. The practitioner maintains the plan and care-team coordination state."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures family priorities, educational or emotional support needs where relevant, matched supports, feasibility notes, and coordination notes."
			},
			{
				"title": "Limits",
				"body": "The tool does not collect unsupported family functioning ratings, diagnoses, counseling protocols, financial/legal details, or prescribed support steps."
			}
		],
		"faqItems": [
			{
				"question": "Do family members complete this alone?",
				"answer": "No. The tool is designed to be completed together, with the practitioner supporting plain-language priority and context capture."
			},
			{
				"question": "What anchors the plan?",
				"answer": "Family priorities anchor the plan; supports without linked priorities are flagged for review."
			},
			{
				"question": "Can uncertain family input be saved?",
				"answer": "Yes. Sensitive or uncertain input can be recorded as unresolved rather than forced into the plan."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and reusable configuration are saved. Fictional family priorities and sample case content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "behaviorSamplingRecord",
		"slug": "behavior-sampling-record",
		"title": "Behavior Sampling Record Demo | Qwoach",
		"metaDescription": "Explore a SCERTS supplemental evidence tool for objective-linked behavior samples that clarify child functional performance.",
		"h1": "Behavior Sampling Record",
		"intro": "Behavior Sampling Record is a practitioner-only SCERTS supplemental evidence tool. Practitioners use it when observation and informant data are not enough to judge a child's functional performance confidently.",
		"demoTitle": "Select sample objectives, record a fictional behavior sample, and review how the sample confirms, refines, or challenges other evidence.",
		"demoPrompt": "Interested in using Behavior Sampling Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1110-f-072-scerts-011-r001-behavior-sampling-record.md",
		"specId": "1110-f-072-scerts-011-r001-behavior-sampling-record",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Behavior analysis",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this record when SAP-O, SAP-R, or other evidence is not enough to judge functional performance confidently on relevant objectives."
			},
			{
				"title": "What It Captures",
				"body": "The record captures sampling reason, objective links, context, observed behavior evidence, and practitioner-selected relationship to existing evidence."
			},
			{
				"title": "Limits",
				"body": "The tool is not a general behavior log and does not add causal hypotheses, intervention recommendations, diagnostic conclusions, or invented sampling protocols."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general behavior tracker?",
				"answer": "No. Behavior Sampling Record is supplemental assessment evidence tied to relevant objectives, not open-ended behavior tracking."
			},
			{
				"question": "What makes a sample incomplete?",
				"answer": "A sample without objective linkage or sufficient behavior detail remains incomplete or draft."
			},
			{
				"question": "Can conflicting evidence be resolved automatically?",
				"answer": "No. Evidence that conflicts with other data is shown descriptively rather than resolved automatically."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and reusable setup are saved. Fictional behavior samples and demo comparison data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "scertsProgressChart",
		"slug": "scerts-progress-chart",
		"title": "SCERTS Progress Chart Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only SCERTS progress chart for viewing developmental and support change across dated entries, goals, and supports.",
		"h1": "SCERTS Progress Chart",
		"intro": "SCERTS Progress Chart is a practitioner-only longitudinal progress chart for practitioners monitoring a child's developmental and support-related change across repeated points in time. It helps practitioners compare dated entries, connect progress data to prior goals or supports, and identify descriptive gains, plateaus, gaps, or emerging needs.",
		"demoTitle": "Explore the sample chart, adjust the displayed domains and date range, then save the tool for your practice.",
		"demoPrompt": "Interested in using SCERTS Progress Chart with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1111-f-072-scerts-012-r001-scerts-progress-chart.md",
		"specId": "1111-f-072-scerts-012-r001-scerts-progress-chart",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Graph"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Developmental functioning",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during progress review when repeated information is needed to understand a child's trajectory rather than a single status point."
			},
			{
				"title": "What It Shows",
				"body": "The chart shows dated entries, developmental/support domains, comparable prior and current values, missing or non-comparable data, and links to relevant goals or supports."
			},
			{
				"title": "Important Limits",
				"body": "The tool provides descriptive longitudinal organization. It does not diagnose, explain causes of change, create standardized scores, or decide intervention changes for the practitioner."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client-facing form?",
				"answer": "No. SCERTS Progress Chart is practitioner-only in the supplied specification."
			},
			{
				"question": "What happens if there is only one entry?",
				"answer": "The chart shows a baseline only. It must not infer a trajectory from a single point."
			},
			{
				"question": "Can the chart compare entries if domains changed over time?",
				"answer": "Only comparable fields should be compared. If domains change, the chart should show which entries used which domain set and avoid false comparison."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and practitioner configuration are saved. Fictional sample entries and demo case data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "programQualityReview",
		"slug": "program-quality-review",
		"title": "Program Quality Review Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only SCERTS program quality review for capturing implementation evidence, strengths, gaps, priorities, and reassessment history.",
		"h1": "Program Quality Review",
		"intro": "Program Quality Review is a practitioner-only accountability and implementation quality review tool for practitioners evaluating whether a program is being implemented with sufficient quality. It helps capture evidence from actual implementation, identify strengths and gaps, and document improvement priorities for later reassessment.",
		"demoTitle": "Explore a sample quality review, adjust the review structure, and save the tool for your practice.",
		"demoPrompt": "Interested in using Program Quality Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1112-f-072-scerts-013-r001-program-quality-review.md",
		"specId": "1112-f-072-scerts-013-r001-program-quality-review",
		"tags": {
			"framework": [
				"SCERTS"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring",
				"Service monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during program accountability or improvement review when quality evidence should reflect actual implementation rather than intent alone."
			},
			{
				"title": "What It Captures",
				"body": "The review captures implementation evidence, quality-area completion, strengths, gaps, practitioner-selected priorities, and dated reassessment history."
			},
			{
				"title": "Important Limits",
				"body": "The tool organizes evidence descriptively. It does not produce unsupported quality scores, compliance determinations, staff performance judgments, or causal outcome claims."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool evaluate child progress?",
				"answer": "No. Program Quality Review focuses on implementation quality evidence for the program, not child developmental progress."
			},
			{
				"question": "Can it be used without a prior review?",
				"answer": "Yes. With no prior review, the result is a baseline quality review."
			},
			{
				"question": "What happens when evidence is missing?",
				"answer": "Missing evidence is marked as not evidenced or incomplete rather than rated automatically."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool itself and practitioner configuration are saved. Fictional program data and sample review content are not saved as real records."
			}
		]
	},
	{
		"toolType": "functionalEmotionalDevelopmentHomeScreeningTool",
		"slug": "functional-emotional-development-home-screening-tool",
		"title": "Home Functional Emotional Development Screening Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send caregiver home screening for functional emotional developmental capacities, completion status, missing responses, and practitioner review.",
		"h1": "Functional Emotional Development Home Screening Tool",
		"intro": "Functional Emotional Development Home Screening Tool is a ready-to-send caregiver-reported home screening for practitioners who need input on a child's functional emotional developmental capacities in the home context. It helps practitioners organize caregiver observations into a profile that can inform next-step assessment, support, or later comparison.",
		"demoTitle": "Preview the caregiver screening flow, review a sample submitted profile, and save the tool to send later.",
		"demoPrompt": "Interested in using Functional Emotional Development Home Screening Tool with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1113-f-073-dir-001-r001-functional-emotional-development-home-screening-tool.md",
		"specId": "1113-f-073-dir-001-r001-functional-emotional-development-home-screening-tool",
		"tags": {
			"framework": [
				"DIR/Floortime"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Developmental functioning"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during intake, planning, or re-screening when home-based caregiver observations are needed for practitioner review."
			},
			{
				"title": "Practitioner And Caregiver Roles",
				"body": "The practitioner sends and reviews the screening. The caregiver reports home observations and submits responses, but the tool does not ask the caregiver to make clinical decisions."
			},
			{
				"title": "Repeat Use",
				"body": "Later caregiver reports can support comparison only when the same structure is reused or the product qualifies differences between structures."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the screening?",
				"answer": "The caregiver completes the screening, and the practitioner reviews the submitted profile."
			},
			{
				"question": "Does the tool provide a diagnosis?",
				"answer": "No. It organizes caregiver-reported home observations and does not produce diagnoses or age-norm conclusions."
			},
			{
				"question": "Can skipped items be hidden?",
				"answer": "No. Skipped or unanswered items should remain visible as missing responses in the result."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and selected setup are saved. Fictional caregiver responses and sample child data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "functionalEmotionalAssessmentScaleFeas",
		"slug": "functional-emotional-assessment-scale-feas",
		"title": "FEAS Assessment Tool Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only FEAS assessment workspace for age-specific score sheet selection, structured score entry, missing scores, and repeated review.",
		"h1": "Functional Emotional Assessment Scale (FEAS)",
		"intro": "Functional Emotional Assessment Scale (FEAS) is a practitioner-only age-specific assessment tool for practitioners assessing a child's functional emotional development. It helps practitioners select the age-relevant score sheet context, enter FEAS assessment information, and review developmental scores and repeated-score history where supported.",
		"demoTitle": "Explore the sample FEAS assessment workspace, review missing-score handling, and save the tool for your practice.",
		"demoPrompt": "Interested in using Functional Emotional Assessment Scale (FEAS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1114-f-073-dir-002-r001-functional-emotional-assessment-scale-feas.md",
		"specId": "1114-f-073-dir-002-r001-functional-emotional-assessment-scale-feas",
		"tags": {
			"framework": [
				"DIR/Floortime"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Developmental functioning"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when age-specific functional emotional developmental scores are needed for practitioner assessment and later reassessment."
			},
			{
				"title": "What It Records",
				"body": "The workspace records age band or score sheet context, assessment date, structured scores or observations, missing-score status, and repeated assessment history."
			},
			{
				"title": "Important Limits",
				"body": "The tool must not invent FEAS items, calculations, norms, score meanings, diagnoses, or treatment recommendations when those rules are not supplied."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo calculate FEAS scores?",
				"answer": "Only if supported scoring rules are supplied. Without supplied rules, the tool organizes practitioner-entered scores and marks missing information."
			},
			{
				"question": "Is there a client-facing FEAS workflow?",
				"answer": "No. FEAS is practitioner-only in the supplied specification."
			},
			{
				"question": "What happens if the age band changes between assessments?",
				"answer": "The review should show the different score sheet context and avoid implying direct comparison where the structures are not comparable."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and assessment setup are saved. Fictional child data and sample scores are not saved as real client data."
			}
		]
	},
	{
		"toolType": "fedcDevelopmentalProfile",
		"slug": "fedc-developmental-profile",
		"title": "FEDC Developmental Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-led FEDC developmental profile for organizing capacities, needs, interaction context, missing areas, and repeated profile review.",
		"h1": "FEDC Developmental Profile",
		"intro": "FEDC Developmental Profile is a ready-to-complete-together practitioner-led profile for practitioners who need to understand a child's current functional emotional developmental capacities. It helps organize capacities, needs, and meaningful interaction-context notes across developmental levels so planning can align with the child's developmental pathway.",
		"demoTitle": "Complete a sample profile, review the level-by-level result, and save the tool setup.",
		"demoPrompt": "Interested in using FEDC Developmental Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1115-f-073-dir-003-r001-fedc-developmental-profile.md",
		"specId": "1115-f-073-dir-003-r001-fedc-developmental-profile",
		"tags": {
			"framework": [
				"DIR/Floortime"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Developmental functioning"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during planning or review when current functional emotional developmental capacities and needs should be organized across levels."
			},
			{
				"title": "Shared Completion",
				"body": "A caregiver or participant may contribute observations during completion, but practitioner review and planning remain the product focus."
			},
			{
				"title": "Important Limits",
				"body": "The profile is descriptive. It does not create unsupported scores, diagnoses, developmental rankings, or intervention plans."
			}
		],
		"faqItems": [
			{
				"question": "Can caregivers complete this independently?",
				"answer": "No separate self-directed caregiver task is defined. The profile may be completed together under practitioner guidance."
			},
			{
				"question": "Does the profile generate an intervention plan?",
				"answer": "No. It organizes capacities and needs so the practitioner can align planning outside the tool."
			},
			{
				"question": "How are unobserved levels handled?",
				"answer": "Unobserved or incomplete levels should be marked as not observed or incomplete rather than inferred."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and selected profile structure are saved. Fictional sample profile content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "individualDifferencesProfile",
		"slug": "individual-differences-profile",
		"title": "Individual Differences Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-led profile for sensory, processing, and regulation patterns, everyday context, strengths, vulnerabilities, and history review.",
		"h1": "Individual Differences Profile",
		"intro": "Individual Differences Profile is a ready-to-complete-together practitioner-led profile for practitioners considering how a child's sensory, processing, or regulation differences shape engagement and development. It helps organize observed patterns, everyday contexts, strengths, vulnerabilities, and functional links so intervention and interactions can be adapted by the practitioner.",
		"demoTitle": "Create a sample pattern map, review the profile, and save the tool setup.",
		"demoPrompt": "Interested in using Individual Differences Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1116-f-073-dir-004-r001-individual-differences-profile.md",
		"specId": "1116-f-073-dir-004-r001-individual-differences-profile",
		"tags": {
			"framework": [
				"DIR/Floortime"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Sensory integration",
				"Emotion regulation",
				"Developmental functioning"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when individual processing or regulation differences need to be understood in relation to the child's everyday functioning."
			},
			{
				"title": "What It Captures",
				"body": "The profile captures patterns, source/context notes, functional links, strengths, vulnerabilities, missing areas, and dated history."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not diagnose sensory conditions, create standardized scores, infer causes, or prescribe adaptations automatically."
			}
		],
		"faqItems": [
			{
				"question": "Is this a diagnostic sensory assessment?",
				"answer": "No. It is an individualized profile for organizing observed or reported processing and regulation patterns relevant to functioning."
			},
			{
				"question": "Can caregiver observations be included?",
				"answer": "Yes. Caregiver or participant observations may be captured during practitioner-guided completion and should remain source/context-specific."
			},
			{
				"question": "What if observations conflict across contexts?",
				"answer": "Conflicting observations should remain labeled by source and context rather than being merged into one unsupported conclusion."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and selected setup are saved. Fictional sample observations and demo case content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "relationshipInteractionProfile",
		"slug": "relationship-interaction-profile",
		"title": "Relationship / Interaction Profile Demo | Qwoach",
		"metaDescription": "Explore a practitioner-led profile for observable interaction facilitators and barriers, context notes, partner behaviors, goal links, and history review.",
		"h1": "Relationship / Interaction Profile",
		"intro": "Relationship / Interaction Profile is a ready-to-complete-together practitioner-led profile for practitioners reviewing how relationship and interaction patterns affect a child's engagement, communication, thinking, or reasoning. It helps organize observable facilitators and barriers, interaction contexts, partner behaviors, and goal links for practitioner-guided coaching or planning.",
		"demoTitle": "Map sample interaction patterns, review the facilitator/barrier profile, and save the tool setup.",
		"demoPrompt": "Interested in using Relationship / Interaction Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1117-f-073-dir-005-r001-relationship-interaction-profile.md",
		"specId": "1117-f-073-dir-005-r001-relationship-interaction-profile",
		"tags": {
			"framework": [
				"DIR/Floortime"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Developmental functioning"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when observable relationship or interaction patterns need to be organized before caregiver or partner coaching."
			},
			{
				"title": "What It Captures",
				"body": "The profile captures facilitator/barrier classification, observable examples, interaction context, partner behavior or relational condition, optional goal links, and dated history."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not judge caregiver quality, assign blame, infer causal certainty, or create coaching scripts automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create coaching recommendations?",
				"answer": "No. It organizes interaction patterns so the practitioner can choose coaching or goal priorities."
			},
			{
				"question": "Can the same behavior be both a facilitator and a barrier?",
				"answer": "Yes, if it differs by context. The result should preserve context-specific entries rather than merging them."
			},
			{
				"question": "Is there an independent caregiver task?",
				"answer": "No. Caregivers or partners may participate, but the supplied product defines practitioner-guided completion rather than a self-directed client workflow."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and selected setup are saved. Fictional interaction examples and demo case content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "floortimeSessionGoalPlan",
		"slug": "floortime-session-goal-plan",
		"title": "Floortime Session Goal Plan Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only session goal plan for defining a target, rationale, developmental alignment reference, and later review connection.",
		"h1": "Floortime Session Goal Plan",
		"intro": "Floortime Session Goal Plan is a practitioner-only planning tool for practitioners preparing an interaction-based developmental session for a child. It helps create a clear session target and rationale aligned with the child's current functional emotional developmental needs, with an optional link to developmental profile or progress information.",
		"demoTitle": "Create a sample session target, review the compact plan, and save the tool for future sessions.",
		"demoPrompt": "Interested in using Floortime Session Goal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1118-f-073-dir-006-r001-floortime-session-goal-plan.md",
		"specId": "1118-f-073-dir-006-r001-floortime-session-goal-plan",
		"tags": {
			"framework": [
				"DIR/Floortime"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Session preparation",
				"Goal setting"
			],
			"topic": [
				"Goals",
				"Developmental functioning"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before an interaction-based developmental session when the practitioner needs a focused target and rationale."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures target, rationale, session date or instance, optional developmental source reference, and later review linkage."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not generate clinical targets, prescribe steps, score goal quality, or replace a treatment plan."
			}
		],
		"faqItems": [
			{
				"question": "Can the tool create a goal for me?",
				"answer": "No. The practitioner enters or selects the target and rationale; the tool does not generate unsupported goals."
			},
			{
				"question": "Is a developmental profile link required?",
				"answer": "No. A practitioner may create a plan without a linked source, and the result should show that no source is linked."
			},
			{
				"question": "What makes a plan incomplete?",
				"answer": "A plan without both a target and rationale is incomplete, and a plan with no child/session context or no target is invalid."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and setup preference are saved. Fictional session details and sample target text are not saved as real client data."
			}
		]
	},
	{
		"toolType": "fedcProgressReview",
		"slug": "fedc-progress-review",
		"title": "FEDC Progress Review Demo | Qwoach",
		"metaDescription": "Explore a longitudinal FEDC progress review for comparing current and prior developmental capacities, descriptive change, gaps, and review history.",
		"h1": "FEDC Progress Review",
		"intro": "FEDC Progress Review is a ready-to-complete-together longitudinal review for practitioners who need to know whether a child's functional emotional developmental capacities are changing over time. It helps compare current and prior capacity information, show descriptive progress, stagnation, emerging needs, and gaps, and support practitioner decisions about next intervention priorities.",
		"demoTitle": "Review sample capacity changes, adjust the comparison range, and save the tool setup.",
		"demoPrompt": "Interested in using FEDC Progress Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1119-f-073-dir-007-r001-fedc-progress-review.md",
		"specId": "1119-f-073-dir-007-r001-fedc-progress-review",
		"tags": {
			"framework": [
				"DIR/Floortime"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Developmental functioning",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when current developmental-capacity information needs to be compared with prior information to support intervention adjustment."
			},
			{
				"title": "Shared Completion",
				"body": "Caregiver or team observations can be included during guided completion, while practitioner decision-making remains the focus."
			},
			{
				"title": "Important Limits",
				"body": "The review is descriptive. It does not infer causes, invent FEDC scoring, diagnose, or choose intervention priorities automatically."
			}
		],
		"faqItems": [
			{
				"question": "Can the tool show progress with only one review point?",
				"answer": "No. With only one point, the result should show a baseline rather than infer change."
			},
			{
				"question": "How are missing values handled?",
				"answer": "Missing current or prior data should be marked as missing and not treated as stagnation."
			},
			{
				"question": "Can participant observations be included?",
				"answer": "Yes. Participant observations may be captured during guided completion and should remain source-labeled."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and selected setup are saved. Fictional capacity entries and sample review history are not saved as real client data."
			}
		]
	},
	{
		"toolType": "caregiverInteractionReflection",
		"slug": "caregiver-interaction-reflection",
		"title": "Caregiver Interaction Reflection Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send caregiver reflection for home interaction observations, caregiver learning, missing fields, history, and practitioner coaching review.",
		"h1": "Caregiver Interaction Reflection",
		"intro": "Caregiver Interaction Reflection is a ready-to-send reflection tool for practitioners who need insight into caregiver-child interactions at home between sessions. It helps caregivers report actual home interactions, what supported or limited engagement and development, and what they learned so the practitioner can prepare coaching or adjustment.",
		"demoTitle": "Preview the caregiver reflection, review sample submitted insights, and save the tool to send later.",
		"demoPrompt": "Interested in using Caregiver Interaction Reflection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1120-f-073-dir-008-r001-caregiver-interaction-reflection.md",
		"specId": "1120-f-073-dir-008-r001-caregiver-interaction-reflection",
		"tags": {
			"framework": [
				"DIR/Floortime"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Between-session monitoring"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it between sessions when the practitioner needs caregiver-reported information about home interactions and caregiver learning."
			},
			{
				"title": "Practitioner And Caregiver Roles",
				"body": "The practitioner assigns and reviews the reflection. The caregiver reports observations and learning without being asked to make clinical judgments."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated reflections can reveal patterns over time when structure remains comparable or differences are clearly shown."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not score caregiver competence, provide parenting advice automatically, or replace practitioner coaching judgment."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the reflection?",
				"answer": "The caregiver completes the reflection, and the practitioner reviews the submitted information."
			},
			{
				"question": "What if no relevant home interaction happened?",
				"answer": "The caregiver can record that no relevant home interaction occurred rather than inventing content."
			},
			{
				"question": "Does the tool generate coaching advice?",
				"answer": "No. It organizes caregiver-reported insight so the practitioner can decide what to address."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and selected setup are saved. Fictional caregiver responses and sample reflection history are not saved as real client data."
			}
		]
	},
	{
		"toolType": "esdmCurriculumChecklist",
		"slug": "esdm-curriculum-checklist",
		"title": "ESDM Curriculum Checklist Demo | Qwoach",
		"metaDescription": "Explore an ESDM Curriculum Checklist demo for practitioner skill profiling, observed developmental needs, and candidate teaching objectives.",
		"h1": "ESDM Curriculum Checklist",
		"intro": "The ESDM Curriculum Checklist is a practitioner-only early developmental intervention tool for practitioners planning individualized support for a young autistic child. It helps the practitioner record observed skill information across predefined curriculum areas and review a skill-level profile with strengths, gaps, incomplete areas, and candidate teaching objectives.",
		"demoTitle": "Explore a sample checklist profile",
		"demoPrompt": "Interested in using ESDM Curriculum Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1121-f-074-esdm-001-r001-esdm-curriculum-checklist.md",
		"specId": "1121-f-074-esdm-001-r001-esdm-curriculum-checklist",
		"tags": {
			"framework": [
				"Early Start Denver Model"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Autism",
				"Developmental functioning"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before selecting objectives, when current developmental skill information needs to be differentiated enough to identify teachable next steps."
			},
			{
				"title": "What It Keeps Separate",
				"body": "The tool keeps reported checklist entries, organized profile information, incomplete areas, and practitioner interpretation visually distinct."
			},
			{
				"title": "Longitudinal Use",
				"body": "Completed profiles can serve as baseline states for later reassessment and comparison when the same checklist structure is used or version differences are shown."
			}
		],
		"faqItems": [
			{
				"question": "Does the child or caregiver complete this checklist?",
				"answer": "No. The ESDM Curriculum Checklist is practitioner-only; the child may be observed, but the product does not require child or caregiver entry."
			},
			{
				"question": "Does the tool generate teaching objectives automatically?",
				"answer": "No. It can organize entered data and show candidate objective areas where supported, but the practitioner selects candidate teaching objectives."
			},
			{
				"question": "What happens if part of the checklist is incomplete?",
				"answer": "Incomplete areas remain visible as unknown information and are not treated as developmental gaps."
			}
		]
	},
	{
		"toolType": "esdmTeachingObjectiveSet",
		"slug": "esdm-teaching-objective-set",
		"title": "ESDM Teaching Objective Set Demo | Qwoach",
		"metaDescription": "Explore an ESDM Teaching Objective Set demo for linking developmental needs to explicit individualized intervention targets.",
		"h1": "ESDM Teaching Objective Set",
		"intro": "The ESDM Teaching Objective Set is a practitioner-only intervention planning tool for practitioners who have identified a young child's developmental skill profile. It helps the practitioner create explicit individualized teaching targets tied to developmental needs so intervention can be organized around concrete child-specific learning outcomes.",
		"demoTitle": "Build a sample objective set",
		"demoPrompt": "Interested in using ESDM Teaching Objective Set with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1122-f-074-esdm-002-r001-esdm-teaching-objective-set.md",
		"specId": "1122-f-074-esdm-002-r001-esdm-teaching-objective-set",
		"tags": {
			"framework": [
				"Early Start Denver Model"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Goal setting"
			],
			"topic": [
				"Autism",
				"Developmental functioning",
				"Goals"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures target text, the linked developmental need or profile area, and practitioner-entered rationale when needed."
			},
			{
				"title": "Review Focus",
				"body": "Review highlights targets without profile links and selected needs without targets so the practitioner can resolve gaps before finalizing."
			},
			{
				"title": "History",
				"body": "Draft and finalized objective sets persist so revised or retired targets remain distinguishable from active priorities."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool assess the child's developmental level?",
				"answer": "No. It starts from an identified skill profile and helps translate developmental needs into explicit teaching targets."
			},
			{
				"question": "Can the system recommend targets automatically?",
				"answer": "No. The system organizes and checks traceability, but targets are entered or selected by the practitioner from supported information."
			},
			{
				"question": "What makes an objective incomplete?",
				"answer": "An objective is incomplete when it lacks a linked developmental need or profile area, or when a selected need has no target."
			}
		]
	},
	{
		"toolType": "objectiveDataSheet",
		"slug": "objective-data-sheet",
		"title": "Objective Data Sheet Demo | Qwoach",
		"metaDescription": "Explore an Objective Data Sheet demo for repeated ESDM objective-level observations, data history, and descriptive progress review.",
		"h1": "Objective Data Sheet",
		"intro": "The Objective Data Sheet is a practitioner-only repeated skill-acquisition tracking tool for practitioners delivering individualized early developmental teaching. It helps the practitioner record observations for each active objective over time and review whether objective data appear improving, stable, stalled, or insufficient when repeated observations support that view.",
		"demoTitle": "Try sample data entry",
		"demoPrompt": "Interested in using Objective Data Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1123-f-074-esdm-003-r001-objective-data-sheet.md",
		"specId": "1123-f-074-esdm-003-r001-objective-data-sheet",
		"tags": {
			"framework": [
				"Early Start Denver Model"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Autism",
				"Developmental functioning",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Missing Data",
				"body": "Missed opportunities and incomplete entries remain distinct from recorded performance and are not treated as failed attempts."
			},
			{
				"title": "Objective History",
				"body": "Inactive objectives stop receiving new entries but retain their historical data for later review."
			},
			{
				"title": "Review Boundaries",
				"body": "The tool displays repeated data and descriptive patterns; it does not automate mastery conclusions or prescribe instructional changes unless source-supported rules are available."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client-facing form?",
				"answer": "No. The Objective Data Sheet is practitioner-only; the practitioner records observations tied to teaching opportunities."
			},
			{
				"question": "Does a missed opportunity count as unsuccessful performance?",
				"answer": "No. Missed opportunities remain separate from recorded performance data."
			},
			{
				"question": "When does the tool show improving, stable, or stalled patterns?",
				"answer": "It shows those descriptive patterns only when repeated observations are sufficient to support the characterization."
			}
		]
	},
	{
		"toolType": "esdmFidelityRatingSystem",
		"slug": "esdm-fidelity-rating-system",
		"title": "ESDM Fidelity Rating System Demo | Qwoach",
		"metaDescription": "Explore an ESDM Fidelity Rating System demo for structured practitioner ratings, procedure-area profiles, and fidelity review.",
		"h1": "ESDM Fidelity Rating System",
		"intro": "The ESDM Fidelity Rating System is a practitioner-only implementation fidelity assessment tool for practitioners or qualified raters reviewing developmental interactive intervention delivery. It helps them enter ratings for predefined procedure areas and review an implementation fidelity profile showing aligned and weaker areas when supported by the entered ratings.",
		"demoTitle": "Rate a sample observation",
		"demoPrompt": "Interested in using ESDM Fidelity Rating System with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1124-f-074-esdm-004-r001-esdm-fidelity-rating-system.md",
		"specId": "1124-f-074-esdm-004-r001-esdm-fidelity-rating-system",
		"tags": {
			"framework": [
				"Early Start Denver Model"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Incomplete Ratings",
				"body": "Incomplete ratings can be saved as drafts but do not appear as complete fidelity profiles."
			},
			{
				"title": "Score Boundaries",
				"body": "A score or sufficiency indicator appears only when source-supported scoring rules are available."
			},
			{
				"title": "History",
				"body": "Completed fidelity profiles can be preserved for tracking fidelity over time, with form/version differences visible when relevant."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo certify practitioner competence?",
				"answer": "No. The tool displays a fidelity profile from entered ratings and does not make unsupported competence or certification determinations."
			},
			{
				"question": "Can it calculate an overall score?",
				"answer": "Yes, only if source-supported scoring rules are available for the selected fidelity form."
			},
			{
				"question": "What happens when ratings are missing?",
				"answer": "Missing ratings remain incomplete and should not produce a complete fidelity profile."
			}
		]
	},
	{
		"toolType": "esdmSessionActivityPlan",
		"slug": "esdm-session-activity-plan",
		"title": "ESDM Session Activity Plan Demo | Qwoach",
		"metaDescription": "Explore an ESDM Session Activity Plan demo for mapping naturalistic session activities to individualized developmental objectives.",
		"h1": "ESDM Session Activity Plan",
		"intro": "The ESDM Session Activity Plan is a practitioner-only session preparation tool for practitioners planning early developmental intervention. It helps the practitioner connect planned naturalistic activities to individualized objectives so the session structure shows which skills each activity is expected to support.",
		"demoTitle": "Plan a sample session",
		"demoPrompt": "Interested in using ESDM Session Activity Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1125-f-074-esdm-005-r001-esdm-session-activity-plan.md",
		"specId": "1125-f-074-esdm-005-r001-esdm-session-activity-plan",
		"tags": {
			"framework": [
				"Early Start Denver Model"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Session preparation",
				"Intervention planning"
			],
			"topic": [
				"Autism",
				"Developmental functioning",
				"Goals"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Coverage Gaps",
				"body": "Objectives without planned activities are marked uncovered so the practitioner can decide whether to revise the plan."
			},
			{
				"title": "Unmapped Activities",
				"body": "Activities without linked objectives can remain as practitioner context but are shown as unmapped."
			},
			{
				"title": "Plan Versus Outcome",
				"body": "The plan shows intended opportunities and does not record objective progress or judge activity quality."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool prescribe activities?",
				"answer": "No. The practitioner enters planned activities and links them to objectives; the tool does not invent activities or teaching steps."
			},
			{
				"question": "Can one activity support more than one objective?",
				"answer": "Yes. The plan supports many-to-many mapping between activities and objectives."
			},
			{
				"question": "Does this replace objective data collection?",
				"answer": "No. It plans opportunities; actual performance data belongs in follow-up notes or a data sheet."
			}
		]
	},
	{
		"toolType": "jointActivityRoutinePlan",
		"slug": "joint-activity-routine-plan",
		"title": "Joint Activity Routine Plan Demo | Qwoach",
		"metaDescription": "Explore a Joint Activity Routine Plan demo for embedding developmental objectives into feasible shared routines.",
		"h1": "Joint Activity Routine Plan",
		"intro": "The Joint Activity Routine Plan is a practitioner-led planning tool for practitioners shaping an interactive routine with a young child. It helps the practitioner and collaborator, when present, identify a feasible target routine and link embedded objectives that can be addressed through joint engagement.",
		"demoTitle": "Create a sample routine plan",
		"demoPrompt": "Interested in using Joint Activity Routine Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1126-f-074-esdm-006-r001-joint-activity-routine-plan.md",
		"specId": "1126-f-074-esdm-006-r001-joint-activity-routine-plan",
		"tags": {
			"framework": [
				"Early Start Denver Model"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Goal setting"
			],
			"topic": [
				"Autism",
				"Developmental functioning",
				"Interpersonal relationships"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Practitioner And Collaborator Roles",
				"body": "The practitioner controls and finalizes the plan; a collaborator may contribute routine ideas or feasibility information during completion."
			},
			{
				"title": "Unresolved Feasibility",
				"body": "Uncertainty or disagreement remains unresolved rather than being converted into an agreed plan."
			},
			{
				"title": "Reuse",
				"body": "Past routine plans can persist so practitioners can reuse or revise routines as objectives change."
			}
		],
		"faqItems": [
			{
				"question": "Is this an independent caregiver assessment?",
				"answer": "No. A caregiver or collaborator may contribute during planning, but the tool remains practitioner-led."
			},
			{
				"question": "Does the tool provide routine scripts?",
				"answer": "No. It captures the routine, embedded objectives, and opportunity notes entered during planning."
			},
			{
				"question": "What makes a routine plan incomplete?",
				"answer": "A routine plan is incomplete when it has no embedded objectives, unresolved feasibility, or missing routine-objective links needed for finalization."
			}
		]
	},
	{
		"toolType": "parentCoachingGoalPlan",
		"slug": "parent-coaching-goal-plan",
		"title": "Parent Coaching Goal Plan Demo | Qwoach",
		"metaDescription": "Explore a Parent Coaching Goal Plan demo for linking child objectives to feasible caregiver practice goals in everyday routines.",
		"h1": "Parent Coaching Goal Plan",
		"intro": "The Parent Coaching Goal Plan is a practitioner-led caregiver coaching tool for practitioners supporting developmental learning in everyday activities. It helps the practitioner and caregiver define feasible practice goals that connect a child's developmental objectives to clear caregiver actions in real daily routines.",
		"demoTitle": "Build a sample coaching goal",
		"demoPrompt": "Interested in using Parent Coaching Goal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1127-f-074-esdm-007-r001-parent-coaching-goal-plan.md",
		"specId": "1127-f-074-esdm-007-r001-parent-coaching-goal-plan",
		"tags": {
			"framework": [
				"Early Start Denver Model"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Autism",
				"Developmental functioning",
				"Goals"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Practitioner And Caregiver Roles",
				"body": "The practitioner controls and finalizes the plan; the caregiver contributes feasibility information and confirms the practice behavior is understandable."
			},
			{
				"title": "Completeness",
				"body": "Each goal needs a linked child objective, a real routine context, and an observable caregiver action."
			},
			{
				"title": "Revision",
				"body": "Completed goals can be revised as child objectives or routines change, while remaining distinct from later coaching observations or progress data."
			}
		],
		"faqItems": [
			{
				"question": "Is this a parent-training curriculum?",
				"answer": "No. It plans caregiver practice goals tied to child objectives and routines; it does not provide unsupported coaching protocols."
			},
			{
				"question": "Can the caregiver participate?",
				"answer": "Yes. The caregiver can contribute routine feasibility information and confirm that the practice behavior is understandable."
			},
			{
				"question": "Does creating a goal show child progress?",
				"answer": "No. Goal creation does not produce child progress conclusions."
			}
		]
	},
	{
		"toolType": "curriculumReassessmentObjectiveUpdate",
		"slug": "curriculum-reassessment-objective-update",
		"title": "Curriculum Reassessment Demo | Qwoach",
		"metaDescription": "Explore a curriculum reassessment demo for comparing prior and current skill profiles and updating developmental intervention targets.",
		"h1": "Curriculum Reassessment / Objective Update",
		"intro": "Curriculum Reassessment / Objective Update is a practitioner-only longitudinal reassessment tool for practitioners whose child has received individualized developmental intervention over time. It helps the practitioner compare current skill observations with a prior profile and make practitioner-controlled decisions to continue, retire, revise, or add targets.",
		"demoTitle": "Review a sample reassessment",
		"demoPrompt": "Interested in using Curriculum Reassessment / Objective Update with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1128-f-074-esdm-008-r001-curriculum-reassessment-objective-update.md",
		"specId": "1128-f-074-esdm-008-r001-curriculum-reassessment-objective-update",
		"tags": {
			"framework": [
				"Early Start Denver Model"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Autism",
				"Developmental functioning",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "No Prior Profile",
				"body": "If there is no prior profile, the workflow behaves as an initial profile rather than a reassessment."
			},
			{
				"title": "Incomplete Current Data",
				"body": "Incomplete current entries remain visible and are not treated as no change."
			},
			{
				"title": "Downstream Updates",
				"body": "Changing objectives should prompt review of session activity plans and objective data sheets that depend on the target set."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide which objectives should change?",
				"answer": "No. It shows comparison information and candidate areas from entered data, but the practitioner controls target decisions."
			},
			{
				"question": "What happens to retired objectives?",
				"answer": "Retired objectives preserve their historical data and remain distinguishable from active targets."
			},
			{
				"question": "Can incomplete reassessment areas be reviewed?",
				"answer": "Yes. Incomplete areas remain visible so missing information is not confused with no change."
			}
		]
	},
	{
		"toolType": "socialStoryGoal",
		"slug": "social-story-goal",
		"title": "Social Story Goal Demo | Qwoach",
		"metaDescription": "Explore a Social Story Goal demo for defining a narrow, individualized purpose before creating a social learning narrative.",
		"h1": "Social Story Goal",
		"intro": "Social Story Goal is a practitioner-only goal-definition tool for practitioners preparing an individualized social learning narrative. It helps the practitioner define the specific social understanding goal, audience reference, and situation or concept that should anchor later content decisions.",
		"demoTitle": "Draft a sample goal",
		"demoPrompt": "Interested in using Social Story Goal with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1129-f-075-ss-001-r001-social-story-goal.md",
		"specId": "1129-f-075-ss-001-r001-social-story-goal",
		"tags": {
			"framework": [
				"Social Stories"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Session preparation"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Narrowing",
				"body": "A goal that names only a broad domain remains too broad until it identifies the specific situation or concept."
			},
			{
				"title": "Downstream Alignment",
				"body": "If the goal changes after later story work, downstream content should be reviewed against the revised purpose."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool write the story?",
				"answer": "No. It defines the story purpose and does not generate narrative text."
			},
			{
				"question": "Does the audience complete anything?",
				"answer": "No. The tool is practitioner-only and the audience does not interact with it at this stage."
			},
			{
				"question": "What makes a goal incomplete?",
				"answer": "A goal is incomplete if it is too broad, generic, or missing audience-specific information."
			}
		]
	},
	{
		"toolType": "twoStepDiscovery",
		"slug": "two-step-discovery",
		"title": "Two-Step Discovery Demo | Qwoach",
		"metaDescription": "Explore a Two-Step Discovery demo for organizing audience and context evidence before creating an individualized social narrative.",
		"h1": "Two-Step Discovery",
		"intro": "Two-Step Discovery is a practitioner-only structured discovery tool for practitioners preparing an individualized social learning narrative. It helps the practitioner collect and organize audience-specific information and context evidence so later narrative content can be factually grounded rather than assumption-based.",
		"demoTitle": "Try sample discovery",
		"demoPrompt": "Interested in using Two-Step Discovery with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1130-f-075-ss-002-r001-two-step-discovery.md",
		"specId": "1130-f-075-ss-002-r001-two-step-discovery",
		"tags": {
			"framework": [
				"Social Stories"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Session preparation"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Two-Part Evidence",
				"body": "Audience information without context evidence, or context evidence without audience information, remains incomplete."
			},
			{
				"title": "Assumptions",
				"body": "Unresolved assumptions stay visible instead of being filled in by the system."
			},
			{
				"title": "Downstream Use",
				"body": "Completed discovery can support later narrative development or prompt refinement of the narrative goal if new evidence changes the understanding."
			}
		],
		"faqItems": [
			{
				"question": "Does Two-Step Discovery write the narrative?",
				"answer": "No. It organizes discovery evidence and does not generate story text."
			},
			{
				"question": "Can others provide information?",
				"answer": "Yes. The practitioner may gather information from the audience or others, but they do not complete an independent product workflow."
			},
			{
				"question": "What happens when evidence is missing?",
				"answer": "Missing evidence remains visible as incomplete or unresolved rather than being replaced by assumptions."
			}
		]
	},
	{
		"toolType": "audienceProfileFormatPlan",
		"slug": "audience-profile-format-plan",
		"title": "Audience Profile / Format Plan for Social Narrative Delivery | Qwoach",
		"metaDescription": "Plan the audience profile, access needs, constraints, and delivery format for an individualized social learning narrative before use.",
		"h1": "Audience Profile / Format Plan",
		"intro": "Audience Profile / Format Plan is a practitioner-only planning tool for Social Story development. Practitioners use it to capture an intended audience's communication, comprehension, attention, access, and implementation constraints so the delivery format can be tailored before the narrative is prepared or delivered.",
		"demoTitle": "Explore the sample format plan",
		"demoPrompt": "Interested in using Audience Profile / Format Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1131-f-075-ss-003-r001-audience-profile-format-plan.md",
		"specId": "1131-f-075-ss-003-r001-audience-profile-format-plan",
		"tags": {
			"framework": [
				"Social Stories"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Session preparation"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use it before drafting or delivering an individualized social learning narrative when the format must fit the audience's comprehension, communication, attention, access, or delivery context."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not draft the narrative, score the audience, infer clinical meaning, evaluate outcomes, or collect unrelated demographic or symptom information."
			},
			{
				"title": "Partial Plans",
				"body": "If required audience information is unknown, the plan remains usable but visibly partial until the missing information is resolved."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool write the social narrative?",
				"answer": "No. It plans the audience profile and delivery format before drafting; narrative writing belongs in a separate drafting tool."
			},
			{
				"question": "Can I save a plan if some information is unknown?",
				"answer": "Yes. Unknowns can be marked, and the result shows that the plan is partial until required information is resolved."
			},
			{
				"question": "Does the demo require real client information?",
				"answer": "No. The public demo uses fictional sample information and does not require client-identifying or sensitive case details."
			}
		]
	},
	{
		"toolType": "whContextMap",
		"slug": "wh-context-map",
		"title": "WH Context Map for Social Narrative Development | Qwoach",
		"metaDescription": "Map people, place, timing, actions, reasons, and expectations so social learning narratives are based on concrete context.",
		"h1": "WH Context Map",
		"intro": "WH Context Map is a collaborative situational information map for developing a Social Story. Practitioners use it with input from the audience or others to organize people, place, timing, actions, reasons, and expectations so the social situation can be represented accurately and clearly.",
		"demoTitle": "Try the sample WH map",
		"demoPrompt": "Interested in using WH Context Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1132-f-075-ss-004-r001-wh-context-map.md",
		"specId": "1132-f-075-ss-004-r001-wh-context-map",
		"tags": {
			"framework": [
				"Social Stories"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Session preparation",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Collaborator Role",
				"body": "Collaborators may contribute concrete details or corrections. The practitioner remains responsible for reviewing the map and using it in story development."
			},
			{
				"title": "Unknowns And Disagreements",
				"body": "Unknown elements are marked unresolved rather than fabricated. Conflicting details remain visible for practitioner resolution."
			},
			{
				"title": "Boundary",
				"body": "The tool organizes situational context. It does not create the final narrative, score the situation, diagnose, or track outcomes."
			}
		],
		"faqItems": [
			{
				"question": "Are the WH sections configurable?",
				"answer": "No. The supported sections are fixed: people, place, timing, actions, reasons, and expectations."
			},
			{
				"question": "Can a participant complete the map directly?",
				"answer": "Yes, where the surrounding workflow allows, a simple shared completion view can collect concrete details or corrections for practitioner review."
			},
			{
				"question": "Does the result write the story?",
				"answer": "No. The result provides organized context and a descriptive summary for drafting; it does not produce the final social narrative."
			}
		]
	},
	{
		"toolType": "socialStoryDraft",
		"slug": "social-story-draft",
		"title": "Social Story Draft Workspace | Qwoach",
		"metaDescription": "Draft an individualized social narrative with a visible title, introduction, body, conclusion, goal reference, and completion status.",
		"h1": "Social Story Draft",
		"intro": "Social Story Draft is a practitioner-only drafting workspace for creating an individualized social narrative. Practitioners use it to organize a defined social understanding goal and audience context into a title, introduction, body, and conclusion so the support can be reviewed or prepared for delivery.",
		"demoTitle": "Open the sample draft",
		"demoPrompt": "Interested in using Social Story Draft with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1133-f-075-ss-005-r001-social-story-draft.md",
		"specId": "1133-f-075-ss-005-r001-social-story-draft",
		"tags": {
			"framework": [
				"Social Stories"
			],
			"toolType": [
				"Therapeutic document"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Drafting Boundary",
				"body": "This workspace supports the draft's structure and coherence. Sentence mix, voice and vocabulary, caregiver refinement, fidelity, and outcome review are separate steps."
			},
			{
				"title": "Partial Drafts",
				"body": "Blank sections are allowed and clearly marked so the practitioner can save and return without losing the draft structure."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate the story text for me?",
				"answer": "No. The practitioner writes or assembles the narrative text; the system organizes sections and shows descriptive completeness status."
			},
			{
				"question": "What sections does the draft include?",
				"answer": "The draft includes a title, introduction, body, and conclusion."
			},
			{
				"question": "Can I save an incomplete draft?",
				"answer": "Yes. Partial drafts can be saved, and missing required sections remain visible."
			}
		]
	},
	{
		"toolType": "descriptiveVsCoachingSentenceChecker",
		"slug": "descriptive-vs-coaching-sentence-checker",
		"title": "Descriptive vs Coaching Sentence Checker | Qwoach",
		"metaDescription": "Review an individualized social narrative by classifying sentences as descriptive or coaching and checking whether descriptive sentences predominate.",
		"h1": "Descriptive vs Coaching Sentence Checker",
		"intro": "Descriptive vs Coaching Sentence Checker is a practitioner-only quality review tool for an individualized social narrative. Practitioners use it to classify sentences as descriptive or coaching/directive and summarize whether descriptive sentences predominate so revision can focus on the sentence mix.",
		"demoTitle": "Review the sample sentence mix",
		"demoPrompt": "Interested in using Descriptive vs Coaching Sentence Checker with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1134-f-075-ss-006-r001-descriptive-vs-coaching-sentence-checker.md",
		"specId": "1134-f-075-ss-006-r001-descriptive-vs-coaching-sentence-checker",
		"tags": {
			"framework": [
				"Social Stories"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Quality review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Reviewable Automation",
				"body": "Automated labels, if present, remain editable. Practitioner-confirmed labels are distinct from system-derived labels."
			},
			{
				"title": "Version Awareness",
				"body": "If the draft changes, prior classifications should not be silently applied to changed sentences."
			},
			{
				"title": "Boundary",
				"body": "The checker reviews sentence mix only. It does not rewrite the story, certify all quality criteria, or judge outcomes."
			}
		],
		"faqItems": [
			{
				"question": "Does the checker decide final sentence labels automatically?",
				"answer": "No. Automated labels are reviewable, and the practitioner can correct sentence segmentation and classifications."
			},
			{
				"question": "What sentence types are supported?",
				"answer": "The supported distinction is descriptive versus coaching or directive sentences."
			},
			{
				"question": "Does this replace a full fidelity review?",
				"answer": "No. It reviews sentence mix only; broader fidelity review belongs in a separate tool."
			}
		]
	},
	{
		"toolType": "voiceVocabularyChecklist",
		"slug": "voice-vocabulary-checklist",
		"title": "Voice & Vocabulary Checklist for Social Narratives | Qwoach",
		"metaDescription": "Review whether an individualized social narrative's voice and vocabulary fit the intended audience's perspective and comprehension.",
		"h1": "Voice & Vocabulary Checklist",
		"intro": "Voice & Vocabulary Checklist is a practitioner-only language-fit review tool for an individualized social narrative. Practitioners use it to check whether the narrative's voice and vocabulary fit the intended audience's perspective, comprehension, and communication style.",
		"demoTitle": "Try the sample checklist",
		"demoPrompt": "Interested in using Voice & Vocabulary Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1135-f-075-ss-007-r001-voice-vocabulary-checklist.md",
		"specId": "1135-f-075-ss-007-r001-voice-vocabulary-checklist",
		"tags": {
			"framework": [
				"Social Stories"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Quality review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "What It Reviews",
				"body": "The checklist reviews voice and vocabulary fit against the intended audience's perspective, comprehension, and communication style."
			},
			{
				"title": "Unresolved Information",
				"body": "If audience comprehension or communication information is missing, the result remains unresolved rather than making a final fit judgment."
			},
			{
				"title": "Boundary",
				"body": "The tool does not draft the story, complete a full fidelity profile, measure outcomes, or make clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool revise the wording automatically?",
				"answer": "No. It supports review and revision guidance; the practitioner controls final wording and checklist judgments."
			},
			{
				"question": "Can automated vocabulary flags be changed?",
				"answer": "Yes. Any automated vocabulary or tone flags are editable and are not treated as final."
			},
			{
				"question": "What happens if audience information is missing?",
				"answer": "The review can mark that information unresolved, and the result shows that fit cannot be fully judged from the available information."
			}
		]
	},
	{
		"toolType": "socialStory102FidelityChecklist",
		"slug": "social-story-10-2-fidelity-checklist",
		"title": "Social Story 10.2 Fidelity Checklist | Qwoach",
		"metaDescription": "Review an individualized social narrative against fixed criteria and see criterion status, gaps, notes, and readiness for refinement.",
		"h1": "Social Story 10.2 Fidelity Checklist",
		"intro": "Social Story 10.2 Fidelity Checklist is a practitioner-only criteria-based review tool for an individualized social narrative. Practitioners use it to assess required narrative elements and produce a compliance profile showing what is present, unclear, or needs revision.",
		"demoTitle": "Open the sample fidelity review",
		"demoPrompt": "Interested in using Social Story 10.2 Fidelity Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1136-f-075-ss-008-r001-social-story-10-2-fidelity-checklist.md",
		"specId": "1136-f-075-ss-008-r001-social-story-10-2-fidelity-checklist",
		"tags": {
			"framework": [
				"Social Stories"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Quality review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Criterion-Level Review",
				"body": "The checklist keeps criterion responses visible and does not collapse the review into a single opaque score."
			},
			{
				"title": "Partial Reviews",
				"body": "If criteria remain unassessed or unclear, the readiness indication remains provisional rather than definitive."
			},
			{
				"title": "Boundary",
				"body": "The checklist reviews criteria compliance. It does not measure outcomes, create the story from scratch, or replace practitioner judgment."
			}
		],
		"faqItems": [
			{
				"question": "Does the checklist produce a score?",
				"answer": "No. The result is a criterion-level compliance profile, not an opaque score."
			},
			{
				"question": "Can a criterion be unclear?",
				"answer": "Yes. If available information is insufficient, a criterion can be marked unclear and the overall readiness remains provisional."
			},
			{
				"question": "Does the tool measure whether the story worked for the audience?",
				"answer": "No. Outcome review after use belongs in a separate tool."
			}
		]
	},
	{
		"toolType": "caregiverReviewRefinementRecord",
		"slug": "caregiver-review-refinement-record",
		"title": "Caregiver Review / Refinement Record | Qwoach",
		"metaDescription": "Capture caregiver concerns about an individualized social narrative and map them to practitioner revision decisions before use.",
		"h1": "Caregiver Review / Refinement Record",
		"intro": "Caregiver Review / Refinement Record is a practitioner-controlled review record for individualized social narratives. Practitioners use it to capture caregiver concerns about accuracy, appropriateness, and practical fit, then record how those concerns are addressed before the narrative is used.",
		"demoTitle": "Review the sample refinement record",
		"demoPrompt": "Interested in using Caregiver Review / Refinement Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1137-f-075-ss-009-r001-caregiver-review-refinement-record.md",
		"specId": "1137-f-075-ss-009-r001-caregiver-review-refinement-record",
		"tags": {
			"framework": [
				"Social Stories"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Quality review",
				"Intervention planning"
			],
			"topic": [],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Caregiver Role",
				"body": "Caregivers may provide concerns, corrections, and practical-fit feedback. The practitioner controls issue grouping, revision decisions, and final refinement state."
			},
			{
				"title": "Unresolved Or Conflicting Feedback",
				"body": "If caregivers disagree or a concern remains unresolved, the record preserves that information for practitioner resolution."
			},
			{
				"title": "Boundary",
				"body": "The tool records review and refinement. It does not add approval signatures, administrative workflow, or claims that review proves effectiveness."
			}
		],
		"faqItems": [
			{
				"question": "Can caregivers enter feedback directly?",
				"answer": "Yes, where the workflow allows, caregivers may use a simple contribution view for comments and corrections."
			},
			{
				"question": "Who decides how feedback changes the narrative?",
				"answer": "The practitioner decides how caregiver feedback is grouped, addressed, or left unresolved."
			},
			{
				"question": "Does caregiver review show that the narrative is effective?",
				"answer": "No. It records accuracy, appropriateness, and practical-fit feedback before use; effectiveness after use is a separate outcome review."
			}
		]
	},
	{
		"toolType": "storyOutcomeReview",
		"slug": "story-outcome-review",
		"title": "Story Outcome Review for Social Narratives | Qwoach",
		"metaDescription": "Review post-use feedback and observations tied to a social narrative goal, then identify whether refinements are needed.",
		"h1": "Story Outcome Review",
		"intro": "Story Outcome Review is a collaborative outcome and refinement review for an individualized social narrative after it has been used. Practitioners use it to capture feedback and observations tied to the original social understanding goal and identify specific refinements when needed.",
		"demoTitle": "Explore the sample outcome review",
		"demoPrompt": "Interested in using Story Outcome Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1138-f-075-ss-010-r001-story-outcome-review.md",
		"specId": "1138-f-075-ss-010-r001-story-outcome-review",
		"tags": {
			"framework": [
				"Social Stories"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Repeat Use",
				"body": "Repeated reviews can support comparison across review moments when each review is tied to the story version and original goal."
			},
			{
				"title": "Sparse Or Conflicting Information",
				"body": "If information is sparse, the result indicates insufficient information. If feedback conflicts, the review preserves the conflict for practitioner judgment."
			},
			{
				"title": "Boundary",
				"body": "The tool supports practical outcome and refinement review. It does not create unsupported standardized scores, diagnostic conclusions, or formal efficacy claims."
			}
		],
		"faqItems": [
			{
				"question": "Does the review prove the narrative was effective?",
				"answer": "No. It organizes available feedback and observations and avoids claims beyond the recorded information."
			},
			{
				"question": "Can caregivers or the audience contribute feedback?",
				"answer": "Yes, where the workflow allows, a lightweight shared input view may collect concrete feedback related to the original goal."
			},
			{
				"question": "What happens if there is not enough information?",
				"answer": "The review should indicate insufficient information rather than infer that the narrative helped or did not help."
			}
		]
	},
	{
		"toolType": "socialSituationMap",
		"slug": "social-situation-map",
		"title": "Social Situation Map Demo | Qwoach",
		"metaDescription": "Create a shared visual map of a learner's social situation interpretation, response options, and likely effects on self and others.",
		"h1": "Social Situation Map",
		"intro": "Social Situation Map is a shared visual mapping tool for practitioners and learners. Practitioners use it with a learner to make the learner's interpretation of a social situation, possible responses, and likely effects on self and others visible for discussion and teaching.",
		"demoTitle": "Build a sample situation map",
		"demoPrompt": "Interested in using Social Situation Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1139-f-076-st-001-r001-social-situation-map.md",
		"specId": "1139-f-076-st-001-r001-social-situation-map",
		"tags": {
			"framework": [
				"Social Thinking"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Problem solving"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Learner Role",
				"body": "The learner contributes their interpretation, perceived options, and expected outcomes in a shared visual workspace with practitioner support."
			},
			{
				"title": "Practitioner Guidance",
				"body": "Practitioner-supported options or corrections should remain visually distinct from learner-provided entries."
			},
			{
				"title": "Boundary",
				"body": "The tool maps one social situation. It does not score behavior, diagnose, create a generic mind map, or claim one response is universally correct."
			}
		],
		"faqItems": [
			{
				"question": "Is this completed by the practitioner alone?",
				"answer": "No. The supported experience is shared with the learner, although the practitioner creates, facilitates, and controls final review."
			},
			{
				"question": "Can the map show uncertainty?",
				"answer": "Yes. Likely effects can be marked as possibilities rather than facts when they are uncertain."
			},
			{
				"question": "Does the map judge the learner's behavior?",
				"answer": "No. The map makes reasoning visible and connects options to likely effects without diagnostic interpretation or moral judgment."
			}
		]
	},
	{
		"toolType": "10StepSocialSituationMappingProcess",
		"slug": "10-step-social-situation-mapping-process",
		"title": "10-Step Social Situation Mapping Process | Qwoach",
		"metaDescription": "Guide a learner through a stepwise social-reasoning chain from situation cues and people to perspectives, choices, and outcomes.",
		"h1": "10-Step Social Situation Mapping Process",
		"intro": "10-Step Social Situation Mapping Process is a guided workflow for practitioners and learners. Practitioners use it to build a social-reasoning chain that links situation cues, people involved, perspectives, possible behaviors, and resulting outcomes while marking where learner reasoning needs support.",
		"demoTitle": "Explore the guided reasoning chain",
		"demoPrompt": "Interested in using 10-Step Social Situation Mapping Process with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1140-f-076-st-002-r001-10-step-social-situation-mapping-process.md",
		"specId": "1140-f-076-st-002-r001-10-step-social-situation-mapping-process",
		"tags": {
			"framework": [
				"Social Thinking"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"Skill practice",
				"In-session support"
			],
			"topic": [
				"Problem solving"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Step Content Status",
				"body": "The supplied specification supports the stepwise workflow and chain areas but does not provide exact substantive 10-step labels or prompts. The public demo must show unresolved step content rather than invent it."
			},
			{
				"title": "Learner And Practitioner Roles",
				"body": "The learner contributes observations, perspectives, choices, and outcome thinking. The practitioner facilitates, supports, corrects, and controls final review."
			},
			{
				"title": "Partial Chains",
				"body": "If only some steps are completed, the result remains a partial chain and should not present itself as complete."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include the exact 10 step prompts?",
				"answer": "No. The supplied product specification does not provide the exact step labels or prompts, so the demo must mark that content as unresolved rather than invent it."
			},
			{
				"question": "Can the learner revise earlier reasoning?",
				"answer": "Yes. The workflow supports returning to earlier steps as the learner's reasoning changes."
			},
			{
				"question": "Does the process score the learner's reasoning?",
				"answer": "No. It records a reasoning chain, completion state, and support or correction notes without unsupported scoring."
			}
		]
	},
	{
		"toolType": "socialEmotionalChainReactionMap",
		"slug": "social-emotional-chain-reaction-map",
		"title": "Social Emotional Chain Reaction Map for Social Learning | Qwoach",
		"metaDescription": "Build a learner-specific map of actions, reactions, emotions, outcomes, and adaptive choices for a concrete social situation.",
		"h1": "Social Emotional Chain Reaction Map",
		"intro": "The Social Emotional Chain Reaction Map is a shared tool for practitioners and learners. It helps them build an individualized model of how actions, other people's reactions, emotions, outcomes, and possible adaptive choices connect in one specific social situation.",
		"demoTitle": "Explore a sample map",
		"demoPrompt": "Interested in using Social Emotional Chain Reaction Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1141-f-076-st-003-r001-social-emotional-chain-reaction-map.md",
		"specId": "1141-f-076-st-003-r001-social-emotional-chain-reaction-map",
		"tags": {
			"framework": [
				"Social Thinking"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the map during coaching when a learner needs support connecting a concrete social action to reactions, feelings, outcomes, and a more adaptive future choice."
			},
			{
				"title": "Limits of the Result",
				"body": "The map organizes entered information. It does not score social competence, diagnose, or generate prescribed interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide what the learner should have done?",
				"answer": "No. The tool does not choose the correct action automatically; it records the adaptive choice developed by the practitioner and learner."
			},
			{
				"question": "Can a map be saved if some parts are unknown?",
				"answer": "Yes. Partial maps can remain drafts with unresolved items visible."
			},
			{
				"question": "Is this a behavior tracker?",
				"answer": "No. It is a situation-specific cause-and-effect map, not a general behavior tracker or assessment."
			}
		]
	},
	{
		"toolType": "socialObservationChecklist",
		"slug": "social-observation-checklist",
		"title": "Social Observation Checklist for Contextual Data | Qwoach",
		"metaDescription": "Collect context-first social observation data about location, participants, activity, and observable interaction patterns.",
		"h1": "Social Observation Checklist",
		"intro": "The Social Observation Checklist is a ready-to-send tool for practitioners. It helps collect structured observation data about a learner's social functioning by capturing the situation, setting, people involved, activity context, and observable interaction patterns.",
		"demoTitle": "Create a sample observation request",
		"demoPrompt": "Interested in using Social Observation Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1142-f-076-st-004-r001-social-observation-checklist.md",
		"specId": "1142-f-076-st-004-r001-social-observation-checklist",
		"tags": {
			"framework": [
				"Social Thinking"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The checklist captures location, participants, activity or what is happening, and observable social behaviors or interaction patterns."
			},
			{
				"title": "Practitioner and Observer Roles",
				"body": "The practitioner creates the request and reviews the result. The observer completes the checklist and controls their draft until submission."
			},
			{
				"title": "Relevant Limitations",
				"body": "The checklist does not diagnose, score social functioning, or prescribe an intervention."
			}
		],
		"faqItems": [
			{
				"question": "Can someone else complete the checklist?",
				"answer": "Yes. The checklist is ready to send to an appropriate observer, or it can be opened for practitioner entry."
			},
			{
				"question": "What makes an observation complete?",
				"answer": "A complete observation includes minimum context and at least one observable behavior or pattern, with unknowns marked where needed."
			},
			{
				"question": "Does the tool recommend social supports?",
				"answer": "No. It organizes observation data for practitioner review; support planning remains a practitioner decision."
			}
		]
	},
	{
		"toolType": "choiceConsequenceComparison",
		"slug": "choice-consequence-comparison",
		"title": "Choice-Consequence Comparison for Social Decisions | Qwoach",
		"metaDescription": "Compare realistic social choices, likely consequences, learner preferences, and next actions in a specific situation.",
		"h1": "Choice-Consequence Comparison",
		"intro": "Choice-Consequence Comparison is a shared tool for practitioners and learners. It helps compare realistic social choices, likely consequences, effects on the learner and others, and the learner's preference in one specific situation.",
		"demoTitle": "Compare sample choices",
		"demoPrompt": "Interested in using Choice-Consequence Comparison with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1143-f-076-st-005-r001-choice-consequence-comparison.md",
		"specId": "1143-f-076-st-005-r001-choice-consequence-comparison",
		"tags": {
			"framework": [
				"Social Thinking"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Problem solving"
			],
			"topic": [
				"Interpersonal relationships",
				"Problem solving"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during coaching when a learner needs to compare options before selecting a more effective next action."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not rank choices automatically or predict outcomes beyond what the practitioner and learner enter."
			}
		],
		"faqItems": [
			{
				"question": "Does the system choose the best option?",
				"answer": "No. The system only organizes the comparison; the practitioner or learner must mark any selected next action."
			},
			{
				"question": "Can consequences be uncertain?",
				"answer": "Yes. Likely consequences can be marked unsure and preserved as unresolved."
			},
			{
				"question": "Can the comparison be saved without a selected action?",
				"answer": "Yes. It can remain a comparison-only draft or be reviewed without selection when that reflects the session."
			}
		]
	},
	{
		"toolType": "problemSizeSolutionMatchScale",
		"slug": "problem-size-solution-match-scale",
		"title": "Problem Size and Solution Match Planning Tool | Qwoach",
		"metaDescription": "Help a learner appraise problem size and connect it to a proportionate solution or coping response for everyday situations.",
		"h1": "Problem Size / Solution Match Scale",
		"intro": "The Problem Size / Solution Match Scale is a shared tool for practitioners and learners. It helps appraise the seriousness of a problem and pair that appraisal with a proportionate solution or coping response for an everyday situation.",
		"demoTitle": "Try a sample problem",
		"demoPrompt": "Interested in using Problem Size / Solution Match Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1144-f-076-st-006-r001-problem-size-solution-match-scale.md",
		"specId": "1144-f-076-st-006-r001-problem-size-solution-match-scale",
		"tags": {
			"framework": [
				"Social Thinking"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Problem solving",
				"Intervention planning"
			],
			"topic": [
				"Problem solving",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a learner needs support connecting the seriousness of a situation to a workable response or coping plan."
			},
			{
				"title": "Handling Uncertainty",
				"body": "The tool can remain a draft when the learner is unsure, when appraisal is disputed, or when the response plan is missing."
			},
			{
				"title": "Relevant Limitation",
				"body": "The tool is not a risk assessment and does not make clinical determinations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide the correct problem size?",
				"answer": "No. The practitioner and learner enter the appraisal; the system only organizes the appraisal and response plan."
			},
			{
				"question": "Can practitioner and learner views differ?",
				"answer": "Yes. A disputed appraisal can preserve the learner-reported appraisal and a separate practitioner note."
			},
			{
				"question": "What is required before completion?",
				"answer": "Completion requires a situation, an appraisal, and at least one solution or coping response."
			}
		]
	},
	{
		"toolType": "incredible5PointScale",
		"slug": "incredible-5-point-scale",
		"title": "Incredible 5-Point Scale Personalized Map | Qwoach",
		"metaDescription": "Create a five-level intensity/action map linking learner cues, language, situations, and matched supports across relevant settings.",
		"h1": "Incredible 5-Point Scale",
		"intro": "The Incredible 5-Point Scale is a ready-to-send tool for practitioners. It helps create a personalized five-level map that links a learner's emotional intensity, stress, or problem severity to recognizable cues and appropriate actions or supports.",
		"demoTitle": "Personalize a sample scale",
		"demoPrompt": "Interested in using Incredible 5-Point Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1145-f-076-st-007-r001-incredible-5-point-scale.md",
		"specId": "1145-f-076-st-007-r001-incredible-5-point-scale",
		"tags": {
			"framework": [
				"Social Thinking"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Emotion regulation",
				"Stress",
				"Problem solving"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The map captures five ordered levels, personalized cues or signs, learner language or situations, and matched actions or supports."
			},
			{
				"title": "Who Uses It",
				"body": "The practitioner creates and reviews the map with learner input. Support partners may view the reviewed map for consistent use if shared."
			},
			{
				"title": "Version History",
				"body": "Prior reviewed maps should remain viewable when level meanings or supports change over time."
			}
		],
		"faqItems": [
			{
				"question": "Does the scale always have five levels?",
				"answer": "Yes. The tool uses exactly five ordered levels."
			},
			{
				"question": "Can the focus be changed?",
				"answer": "Yes. The supported focus options are emotional intensity, stress, or problem severity."
			},
			{
				"question": "Does the tool prescribe actions for each level?",
				"answer": "No. Actions and supports are entered by the practitioner, learner, or approved workflow; the system does not invent them."
			}
		]
	},
	{
		"toolType": "friendshipPyramidReflection",
		"slug": "friendship-pyramid-reflection",
		"title": "Friendship Pyramid Reflection for Relationship Expectations | Qwoach",
		"metaDescription": "Create a learner-specific profile of peer relationship categories, expectations, boundaries, and possible mismatches.",
		"h1": "Friendship Pyramid Reflection",
		"intro": "Friendship Pyramid Reflection is a shared tool for practitioners and learners. It helps clarify different peer relationship categories, expectations, and boundaries for people or relationship types in the learner's social world.",
		"demoTitle": "Explore a sample profile",
		"demoPrompt": "Interested in using Friendship Pyramid Reflection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1146-f-076-st-008-r001-friendship-pyramid-reflection.md",
		"specId": "1146-f-076-st-008-r001-friendship-pyramid-reflection",
		"tags": {
			"framework": [
				"Social Thinking"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Privacy-Sensitive Use",
				"body": "The tool can use relationship types instead of named people when naming individuals is unnecessary or too sensitive."
			},
			{
				"title": "What It Produces",
				"body": "The result is a differentiated profile of relationship expectations and boundaries, with mismatch notes only when present."
			},
			{
				"title": "Relevant Limitation",
				"body": "The tool does not rate relationship quality or make automated judgments about closeness or safety."
			}
		],
		"faqItems": [
			{
				"question": "Can the learner avoid naming people?",
				"answer": "Yes. The reflection can use anonymized relationship types instead of named people."
			},
			{
				"question": "Is a mismatch required for completion?",
				"answer": "No. A mismatch is recorded only if present; completion can occur when differentiated expectations and boundaries are captured."
			},
			{
				"question": "Does the tool decide whether someone is a friend?",
				"answer": "No. The system organizes entered categories and expectations; it does not make relationship judgments."
			}
		]
	},
	{
		"toolType": "socialThinkingGoalMap",
		"slug": "social-thinking-goal-map",
		"title": "Social Thinking Goal Map for Individualized Goals | Qwoach",
		"metaDescription": "Create individualized social learning goals linked to learner context, needs, priorities, and future progress review.",
		"h1": "Social Thinking Goal Map",
		"intro": "Social Thinking Goal Map is a shared tool for practitioners and learners. It helps align social learning support with a learner's specific social needs, priorities, and growth targets by producing individualized goals that can guide coaching and be revisited over time.",
		"demoTitle": "Draft a sample goal",
		"demoPrompt": "Interested in using Social Thinking Goal Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1147-f-076-st-009-r001-social-thinking-goal-map.md",
		"specId": "1147-f-076-st-009-r001-social-thinking-goal-map",
		"tags": {
			"framework": [
				"Social Thinking"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Goal setting",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Produces",
				"body": "The map produces learner-specific goals linked to the social context, need, priority, or growth target they address."
			},
			{
				"title": "Progress Review",
				"body": "Historical goals remain accessible for later review, but progress is not inferred without entered evidence."
			},
			{
				"title": "Relevant Limitation",
				"body": "The tool does not auto-generate goals or impose fixed goal domains."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write goals automatically?",
				"answer": "No. Goals are drafted and reviewed by the practitioner and learner; the system organizes them."
			},
			{
				"question": "Can goals be revisited later?",
				"answer": "Yes. Historical and active goals can remain accessible for future progress discussion."
			},
			{
				"question": "What makes a goal ready for review?",
				"answer": "A goal is ready when it is specific, understandable to learner and practitioner, linked to context or need, and useful for coaching."
			}
		]
	},
	{
		"toolType": "casel5CompetencyProfile",
		"slug": "casel-5-competency-profile",
		"title": "CASEL 5 Competency Profile for SEL Planning | Qwoach",
		"metaDescription": "Organize student or group SEL strengths and needs across five competency areas using entered evidence and practitioner notes.",
		"h1": "CASEL 5 Competency Profile",
		"intro": "The CASEL 5 Competency Profile is a shared tool for practitioners. It helps organize a student's or group's social-emotional strengths and needs across five recognized competency areas so support can be prioritized from entered evidence and notes.",
		"demoTitle": "Build a sample profile",
		"demoPrompt": "Interested in using CASEL 5 Competency Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1148-f-077-sel-001-r001-casel-5-competency-profile.md",
		"specId": "1148-f-077-sel-001-r001-casel-5-competency-profile",
		"tags": {
			"framework": [
				"CASEL"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Organizes",
				"body": "The profile organizes entered evidence, strengths, and needs across five competency areas rather than producing a single global judgment."
			},
			{
				"title": "Student and Group Contexts",
				"body": "The practitioner chooses whether the profile is for an individual student or a group before review."
			},
			{
				"title": "Relevant Limitation",
				"body": "Exact prompts, ratings, scores, and operationalized assessment content are not supplied by the product spec and should not be invented."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool include a standardized score?",
				"answer": "No. The profile is non-scored unless a supported measurement structure is supplied separately."
			},
			{
				"question": "Can it be used for a group?",
				"answer": "Yes. The profile subject can be student or group, and the result is labeled accordingly."
			},
			{
				"question": "Are the five competency prompts predefined?",
				"answer": "No. The organizing areas are present, but exact operationalized prompts, ratings, and fields are unresolved unless supplied by accepted content."
			}
		]
	},
	{
		"toolType": "selCompetencyAssessmentSelectionMatrix",
		"slug": "sel-competency-assessment-selection-matrix",
		"title": "SEL Assessment Selection Matrix and Rationale | Qwoach",
		"metaDescription": "Compare SEL assessment approaches by purpose, population, competencies, data needs, decisions, constraints, and fit rationale.",
		"h1": "SEL Competency Assessment Selection Matrix",
		"intro": "The SEL Competency Assessment Selection Matrix is a practitioner-only tool. It helps choose an SEL assessment approach by organizing purpose, population, competencies or outcomes, users, data needs, decision context, candidate options, constraints, and fit rationale.",
		"demoTitle": "Compare sample assessment options",
		"demoPrompt": "Interested in using SEL Competency Assessment Selection Matrix with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1149-f-077-sel-002-r001-sel-competency-assessment-selection-matrix.md",
		"specId": "1149-f-077-sel-002-r001-sel-competency-assessment-selection-matrix",
		"tags": {
			"framework": [
				"CASEL"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "This tool is for practitioner decision documentation. Stakeholders may read the rationale if shared, but there is no separate client workflow."
			},
			{
				"title": "What It Compares",
				"body": "The matrix compares candidate approaches by purpose, competencies or outcomes, users, data needs, population, setting, decision context, and constraints."
			},
			{
				"title": "Relevant Limitation",
				"body": "The tool does not provide an assessment catalog, instrument validation, scoring, or unsupported rankings."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend a specific assessment automatically?",
				"answer": "No. The practitioner selects an approach or marks the decision unresolved based on entered fit information."
			},
			{
				"question": "Can the matrix be saved without candidates?",
				"answer": "Yes. It can be saved as a context-only draft with selection unresolved."
			},
			{
				"question": "What blocks a finalized selection?",
				"answer": "A finalized selection should not proceed unless the decision the data will inform is stated or explicitly marked unresolved."
			}
		]
	},
	{
		"toolType": "schoolwideSelImplementationRubric",
		"slug": "schoolwide-sel-implementation-rubric",
		"title": "Schoolwide SEL Implementation Rubric and Gap Profile | Qwoach",
		"metaDescription": "Assess schoolwide SEL implementation strengths and gaps by rubric components, evidence notes, review status, and improvement priorities.",
		"h1": "Schoolwide SEL Implementation Rubric",
		"intro": "The Schoolwide SEL Implementation Rubric is a practitioner-only tool. It helps assess current schoolwide SEL implementation, organize strengths and gaps by supplied rubric components or domains, and mark improvement priorities grounded in entered evidence.",
		"demoTitle": "Start a sample rubric cycle",
		"demoPrompt": "Interested in using Schoolwide SEL Implementation Rubric with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1150-f-077-sel-003-r001-schoolwide-sel-implementation-rubric.md",
		"specId": "1150-f-077-sel-003-r001-schoolwide-sel-implementation-rubric",
		"tags": {
			"framework": [
				"CASEL"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"School climate"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Assesses",
				"body": "The rubric cycle assesses schoolwide SEL implementation practice, not student-level SEL scores or individual staff performance."
			},
			{
				"title": "Evidence and Contributors",
				"body": "Staff contributors may provide evidence if invited, while the practitioner controls final review, judgments, and priorities."
			},
			{
				"title": "Historical Comparison",
				"body": "Historical cycles can support progress tracking only when comparable rubric structure is used."
			},
			{
				"title": "Relevant Limitation",
				"body": "Exact rubric domains, levels, descriptors, and scoring rules are unresolved unless supplied by accepted rubric content."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool include rubric domains by default?",
				"answer": "No. Rubric components, domains, descriptors, and levels must come from supplied rubric content or practitioner-entered structure; the system must not invent them."
			},
			{
				"question": "Can staff contribute evidence?",
				"answer": "Yes. Staff contributors may provide schoolwide evidence or responses if invited, and the practitioner reviews and reconciles input."
			},
			{
				"question": "Does the rubric create an improvement plan automatically?",
				"answer": "No. The tool surfaces strengths, gaps, and priority candidates; the practitioner selects improvement priorities."
			},
			{
				"question": "Can cycles be compared over time?",
				"answer": "Yes, but only when the same or comparable rubric structure is used."
			}
		]
	},
	{
		"toolType": "selImplementationActionPlanner",
		"slug": "sel-implementation-action-planner",
		"title": "SEL Implementation Action Planner Demo | Qwoach",
		"metaDescription": "Plan SEL implementation actions from identified schoolwide gaps with priorities, responsibility, feasibility notes, and trackable progress states.",
		"h1": "SEL Implementation Action Planner",
		"intro": "The SEL Implementation Action Planner is a practitioner-only planning tool for SEL practitioners, school leaders, and implementation teams. It helps convert identified schoolwide SEL needs or gaps into prioritized action steps that can be assigned, reviewed, and tracked over time.",
		"demoTitle": "Explore a sample SEL implementation plan, then save the planner for your practice.",
		"demoPrompt": "Interested in using SEL Implementation Action Planner with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1151-f-077-sel-004-r001-sel-implementation-action-planner.md",
		"specId": "1151-f-077-sel-004-r001-sel-implementation-action-planner",
		"tags": {
			"framework": [
				"CASEL"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Service monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after diagnosis or progress-monitoring work has identified implementation needs. The planner begins where assessment leaves off: converting known gaps into coordinated action."
			},
			{
				"title": "What It Tracks",
				"body": "The plan tracks linked needs, action steps, priority, responsibility, feasibility/context notes, status, and update history. Descriptive counts or groupings may help review progress without adding unsupported scoring."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not assess SEL quality, define rubric content, prescribe interventions, or interpret gaps. Practitioners supply the implementation needs and decide the action direction."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool assess our SEL implementation quality?",
				"answer": "No. It starts from SEL implementation gaps or priorities that have already been identified and helps organize action steps from them."
			},
			{
				"question": "Can I change the progress labels?",
				"answer": "Yes. The supported configuration includes the progress-state set, so local labels can be used while preserving comparability when kept stable."
			},
			{
				"question": "Are sample demo actions saved as real school data?",
				"answer": "No. Sample actions and fictional implementation content are for public exploration and are not saved as real owned implementation data by default."
			},
			{
				"question": "What happens if an action is not linked to a need?",
				"answer": "It should be flagged because the plan is meant to connect every action step to an identified implementation need or gap."
			}
		]
	},
	{
		"toolType": "selSchoolWalkthroughProtocol",
		"slug": "sel-school-walkthrough-protocol",
		"title": "SEL School Walkthrough Protocol Demo | Qwoach",
		"metaDescription": "Collect structured SEL walkthrough observations across school settings and review descriptive patterns, coverage, and variation over time.",
		"h1": "SEL School Walkthrough Protocol",
		"intro": "The SEL School Walkthrough Protocol is a practitioner-only structured observation tool for SEL practitioners, school leaders, and implementation monitors. It helps collect direct observational evidence across school environments, routines, or settings so implementation patterns can be reviewed descriptively.",
		"demoTitle": "Start a sample walkthrough and review coverage across settings.",
		"demoPrompt": "Interested in using SEL School Walkthrough Protocol with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1152-f-077-sel-005-r001-sel-school-walkthrough-protocol.md",
		"specId": "1152-f-077-sel-005-r001-sel-school-walkthrough-protocol",
		"tags": {
			"framework": [
				"CASEL"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Service monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during implementation monitoring when direct observation across school contexts is needed."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures observation instances, settings or routines, supplied protocol responses, descriptive notes, and coverage status."
			},
			{
				"title": "Relevant Limitations",
				"body": "Exact observation prompts, indicators, and ratings must come from adopted protocol content. The tool does not infer causes or assign unsupported ratings."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include official observation indicators?",
				"answer": "No. The product specification leaves exact protocol content unresolved, so demo fields must be treated as supplied sample structure only."
			},
			{
				"question": "Can partial walkthroughs be reviewed?",
				"answer": "Yes. Partial walkthroughs should show incomplete coverage instead of presenting the data as a complete schoolwide pattern."
			},
			{
				"question": "Do students or staff complete this tool?",
				"answer": "No. This is a practitioner-only observation protocol; observed people do not complete the tool."
			},
			{
				"question": "Can walkthroughs be compared over time?",
				"answer": "Yes, when the same protocol structure and scope remain comparable across walkthrough cycles."
			}
		]
	},
	{
		"toolType": "staffFamilyCommunityPartnerSurvey",
		"slug": "staff-family-community-partner-survey",
		"title": "SEL Stakeholder Survey Demo | Qwoach",
		"metaDescription": "Send an SEL implementation survey to staff, families, and community partners, then review descriptive response patterns by stakeholder group.",
		"h1": "Staff, Family & Community Partner Survey",
		"intro": "The Staff, Family & Community Partner Survey is a ready-to-send survey for SEL practitioners, school leaders, and implementation teams. It helps collect perception data from staff, families, and community partners so practitioners can review group-level patterns related to SEL implementation and supports.",
		"demoTitle": "Configure a sample survey cycle and preview the respondent and results views.",
		"demoPrompt": "Interested in using Staff, Family & Community Partner Survey with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1153-f-077-sel-006-r001-staff-family-community-partner-survey.md",
		"specId": "1153-f-077-sel-006-r001-staff-family-community-partner-survey",
		"tags": {
			"framework": [
				"CASEL"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Service monitoring"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Practitioner And Respondent Roles",
				"body": "The practitioner controls setup and review. Staff, family, and community partner respondents provide perception data but do not see practitioner analysis within the defined tool."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures supplied survey responses, stakeholder group labels, response counts, aggregate summaries, and survey-cycle history."
			},
			{
				"title": "Relevant Limitations",
				"body": "The system does not infer causes, diagnose buy-in, create survey items, or apply unsupported benchmarks."
			}
		],
		"faqItems": [
			{
				"question": "Is this a general school satisfaction survey?",
				"answer": "No. It is specifically for perception data related to SEL implementation and supports."
			},
			{
				"question": "Can I compare staff, family, and community partner responses?",
				"answer": "Yes. Group-level comparison is part of the result when response group labels and representation support it."
			},
			{
				"question": "Are the survey questions included in the specification?",
				"answer": "No. Exact survey questions, scales, dimensions, and scoring are unresolved until supplied."
			},
			{
				"question": "Are demo responses saved into my account?",
				"answer": "No. Fictional public-demo responses are not carried over as real owned respondent data by default."
			}
		]
	},
	{
		"toolType": "selNeedsResourcesAssessment",
		"slug": "sel-needs-resources-assessment",
		"title": "SEL Needs and Resources Assessment Demo | Qwoach",
		"metaDescription": "Map SEL needs, existing resources, supports, and priority gaps to create a school-specific implementation baseline for planning.",
		"h1": "SEL Needs & Resources Assessment",
		"intro": "The SEL Needs & Resources Assessment is a practitioner-only planning baseline tool for SEL practitioners, school leaders, and planning teams. It helps organize current SEL needs, existing resources, available supports, and priority gaps so implementation priorities fit the school's starting point.",
		"demoTitle": "Explore a sample baseline map and save the assessment for your planning work.",
		"demoPrompt": "Interested in using SEL Needs & Resources Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1154-f-077-sel-007-r001-sel-needs-resources-assessment.md",
		"specId": "1154-f-077-sel-007-r001-sel-needs-resources-assessment",
		"tags": {
			"framework": [
				"CASEL"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Goal setting"
			],
			"topic": [
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before priority setting, when the planning team needs to understand needs, assets, supports, and gaps in the current SEL implementation context."
			},
			{
				"title": "What It Produces",
				"body": "The result is a baseline map and revisit-ready snapshots, not a final action plan."
			},
			{
				"title": "Relevant Limitations",
				"body": "Exact prompts, categories, ratings, and worksheet structure remain unresolved until supplied. The product does not prescribe priorities or score implementation maturity."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create an SEL action plan?",
				"answer": "No. It creates a baseline picture of needs, resources, supports, and gaps that can later inform action planning."
			},
			{
				"question": "Who selects priority gaps?",
				"answer": "The practitioner or planning team selects priority gaps; the system organizes entries but does not score or determine priority."
			},
			{
				"question": "Can the baseline be revisited later?",
				"answer": "Yes. Prior baseline snapshots should be preserved so later changes do not overwrite the planning history."
			},
			{
				"question": "Are sample baseline entries saved as real school data?",
				"answer": "No. Fictional demo entries are not carried into the account as real owned baseline data by default."
			}
		]
	},
	{
		"toolType": "selStudentGoalReflection",
		"slug": "sel-student-goal-reflection",
		"title": "SEL Student Goal Reflection Demo | Qwoach",
		"metaDescription": "Help students define an SEL goal and build a reflection trail showing progress, barriers, strategy use, and next steps over time.",
		"h1": "SEL Student Goal / Reflection",
		"intro": "The SEL Student Goal / Reflection tool is a ready-to-send goal-setting and reflection activity for practitioners supporting student SEL growth. It helps a student define or co-define a meaningful SEL goal and maintain a reflection trail showing progress, barriers, strategy use, and next steps over time.",
		"demoTitle": "Preview the student reflection flow and practitioner review timeline.",
		"demoPrompt": "Interested in using SEL Student Goal / Reflection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1155-f-077-sel-008-r001-sel-student-goal-reflection.md",
		"specId": "1155-f-077-sel-008-r001-sel-student-goal-reflection",
		"tags": {
			"framework": [
				"CASEL"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting",
				"Progress review"
			],
			"topic": [
				"Goals"
			],
			"population": [
				"Children",
				"Adolescents"
			]
		},
		"sections": [
			{
				"title": "Practitioner And Student Roles",
				"body": "The practitioner initiates and reviews the activity. The student defines or co-defines the goal and contributes reflection entries over time."
			},
			{
				"title": "Repeat Use",
				"body": "The tool is designed for longitudinal reflection, with one active goal as the lowest-load default and goal history preserved when revisions occur."
			},
			{
				"title": "Relevant Limitations",
				"body": "Exact prompts, competency lists, reflection fields, and rating formats are unresolved until supplied. The tool does not score, diagnose, or prescribe interventions."
			}
		],
		"faqItems": [
			{
				"question": "Is this an SEL assessment?",
				"answer": "No. It is a goal-setting and reflection tool, not a tool for scoring or diagnosing student SEL development."
			},
			{
				"question": "Can the practitioner help the student create the goal?",
				"answer": "Yes. Goal creation mode can support student-defined or co-defined goals while preserving student-understandable language."
			},
			{
				"question": "Does the tool support ongoing reflection?",
				"answer": "Yes. It is designed around repeated reflection entries and a chronological history over time."
			},
			{
				"question": "Are demo student reflections saved as real student records?",
				"answer": "No. Fictional public-demo goals and reflections are not carried over as real owned student data by default."
			}
		]
	},
	{
		"toolType": "continuousImprovementDataReview",
		"slug": "continuous-improvement-data-review",
		"title": "SEL Continuous Improvement Data Review Demo | Qwoach",
		"metaDescription": "Review accumulated SEL data, document evidence-linked decisions, and identify what to continue, change, or prioritize next cycle.",
		"h1": "Continuous Improvement Data Review",
		"intro": "Continuous Improvement Data Review is a practitioner-only SEL data review and improvement-cycle decision tool for SEL practitioners, school leaders, and implementation teams. It helps document review questions, evidence patterns, decision rationale, and updated action direction after implementation or outcome data has accumulated.",
		"demoTitle": "Build a sample evidence-to-decision review and preview the cycle record.",
		"demoPrompt": "Interested in using Continuous Improvement Data Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1156-f-077-sel-009-r001-continuous-improvement-data-review.md",
		"specId": "1156-f-077-sel-009-r001-continuous-improvement-data-review",
		"tags": {
			"framework": [
				"CASEL"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Outcome monitoring",
				"Service monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after SEL implementation or outcome data has accumulated and the team needs to decide what to continue, change, or prioritize."
			},
			{
				"title": "What It Captures",
				"body": "The review captures questions, data references, observed patterns, rationale, action updates, revisit notes, and cycle history."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool structures reasoning from available evidence. It does not create data, infer causality, prescribe decisions, or apply unsupported benchmarks."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool recommend what we should do next?",
				"answer": "No. It organizes practitioner-entered evidence, rationale, and action updates but does not decide what is effective or prescribe actions."
			},
			{
				"question": "Can we compare review cycles?",
				"answer": "Yes. Historical cycles persist so prior rationale and action updates can be revisited and compared."
			},
			{
				"question": "What happens if a decision has no evidence?",
				"answer": "It should be flagged as incomplete rationale because finalized decisions should have evidence basis or visible rationale."
			},
			{
				"question": "Are demo review decisions saved as real data?",
				"answer": "No. Fictional demo evidence and decisions are not saved as real owned review data by default."
			}
		]
	},
	{
		"toolType": "aacNeedsParticipationInventory",
		"slug": "aac-needs-participation-inventory",
		"title": "AAC Participation Inventory Demo | Qwoach",
		"metaDescription": "Prioritize an AAC user's communication needs across activities, partners, environments, barriers, and participation contexts.",
		"h1": "AAC Needs / Participation Inventory",
		"intro": "The AAC Needs / Participation Inventory is a ready-to-complete-together AAC assessment tool for SLPs, assistive technology specialists, and AAC teams. It helps identify and prioritize an AAC user's communication needs across activities, partners, and environments so supports can be planned around meaningful participation.",
		"demoTitle": "Complete a sample participation inventory and review the prioritized profile.",
		"demoPrompt": "Interested in using AAC Needs / Participation Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1157-f-078-aac-001-r001-aac-needs-participation-inventory.md",
		"specId": "1157-f-078-aac-001-r001-aac-needs-participation-inventory",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"AAC",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Complete Together",
				"body": "The practitioner can complete the inventory with the AAC user and/or support team, using supported entry, observation-based input, or team contribution where relevant."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures activities, partners, environments, communication needs, barriers/opportunities, priorities, and source/context notes."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not recommend AAC systems, perform full feature matching, or infer device features from the inventory."
			}
		],
		"faqItems": [
			{
				"question": "Is this a device-selection tool?",
				"answer": "No. It identifies and prioritizes communication needs and participation contexts; it does not recommend an AAC system."
			},
			{
				"question": "Can the practitioner enter responses for the AAC user or team?",
				"answer": "Yes. The tool supports practitioner-mediated completion and can document input source or context where useful."
			},
			{
				"question": "What if the AAC user cannot provide direct input?",
				"answer": "Support-team input or observation-based input can be recorded with source context."
			},
			{
				"question": "Are demo AAC user details saved as real client data?",
				"answer": "No. Fictional demo user details and responses are not carried over as real owned client data by default."
			}
		]
	},
	{
		"toolType": "featureMatchingAssessment",
		"slug": "feature-matching-assessment",
		"title": "AAC Feature-Matching Assessment Demo | Qwoach",
		"metaDescription": "Map AAC user needs, access, sensory, motor, and environmental considerations to feature requirements and rationale.",
		"h1": "Feature-Matching Assessment",
		"intro": "Feature-Matching Assessment is a practitioner-only AAC assessment tool for AAC practitioners and assessment teams. It helps determine AAC system-feature requirements that fit a user's documented communication, access, sensory, motor, and environmental needs, with rationale for each requirement.",
		"demoTitle": "Build a sample requirements matrix and review coverage across feature dimensions.",
		"demoPrompt": "Interested in using Feature-Matching Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1158-f-078-aac-002-r001-feature-matching-assessment.md",
		"specId": "1158-f-078-aac-002-r001-feature-matching-assessment",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"AAC"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Produces",
				"body": "The product produces explicit feature requirements with rationale, not a named product recommendation."
			},
			{
				"title": "Coverage Review",
				"body": "Dimension coverage helps practitioners see whether relevant considerations have been addressed without assigning scores or determining clinical necessity."
			},
			{
				"title": "Relevant Limitations",
				"body": "Exact prompts, rating scales, and comparison algorithms are unresolved unless supplied. The tool does not rank products or make funding determinations."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool recommend a specific AAC device?",
				"answer": "No. It produces feature requirements and rationale that can later support comparison or configuration."
			},
			{
				"question": "Is rationale required?",
				"answer": "Yes. A complete result requires feature requirements to be tied to documented user needs, abilities, or contexts with rationale."
			},
			{
				"question": "Can I focus only on one feature dimension?",
				"answer": "You can include applicable dimensions, but the tool should descriptively show when only one dimension has entries and others have not been considered."
			},
			{
				"question": "Are sample requirements saved as client data?",
				"answer": "No. Fictional demo needs, requirements, and rationale are not carried into the account as real client data by default."
			}
		]
	},
	{
		"toolType": "symbolDisplayFeatureProfile",
		"slug": "symbol-display-feature-profile",
		"title": "AAC Symbol Display Profile Demo | Qwoach",
		"metaDescription": "Identify AAC symbol and display requirements linked to user communication, visual, cognitive, access, and participation-context needs.",
		"h1": "Symbol / Display Feature Profile",
		"intro": "The Symbol / Display Feature Profile is a ready-to-complete-together AAC configuration profile for AAC practitioners and teams. It helps identify symbol and display requirements matched to a specific user's communication, visual, cognitive, access, and participation-context needs.",
		"demoTitle": "Complete a sample profile and review linked symbol and display requirements.",
		"demoPrompt": "Interested in using Symbol / Display Feature Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1159-f-078-aac-003-r001-symbol-display-feature-profile.md",
		"specId": "1159-f-078-aac-003-r001-symbol-display-feature-profile",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"AAC"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Focused Scope",
				"body": "The profile stays limited to symbol and display features. Broader AAC feature needs should move to a full feature-matching assessment."
			},
			{
				"title": "Supported Completion",
				"body": "The practitioner may gather user or support-team input through observation, preference input, or supported communication and document the source context."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not prescribe a layout, choose vocabulary, recommend a device, or use unsupported symbol taxonomies."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as a full AAC feature-matching assessment?",
				"answer": "No. It is narrower and focuses only on symbol and display requirements."
			},
			{
				"question": "Can the AAC user participate?",
				"answer": "Yes. The user may participate through supported completion, observation, or preference input documented by the practitioner."
			},
			{
				"question": "Does the tool choose the best display layout?",
				"answer": "No. It organizes requirements and links them to needs and contexts but does not infer the best layout."
			},
			{
				"question": "Are sample profile entries saved as real client data?",
				"answer": "No. Fictional demo requirements and notes are not carried over as real owned client data by default."
			}
		]
	},
	{
		"toolType": "directSelectionChecklistTobiiDynavox",
		"slug": "direct-selection-checklist-tobii-dynavox",
		"title": "AAC Direct Selection Checklist Demo | Qwoach",
		"metaDescription": "Document direct-selection AAC access, body part or movement used, positioning, supports, environments, independence, and setup guidance.",
		"h1": "Direct Selection Checklist (Tobii Dynavox)",
		"intro": "The Direct Selection Checklist (Tobii Dynavox) is a clinician/team-completed AAC access assessment and setup checklist for SLPs, OTs, assistive technology specialists, and school AAC teams. It helps document how an AAC user accesses a speech-generating device through direct selection, including method, body part or movement, setup details, supports, environments, independence, and changes over time.",
		"demoTitle": "Complete a sample checklist and review the setup guidance view.",
		"demoPrompt": "Interested in using Direct Selection Checklist (Tobii Dynavox) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1160-f-078-aac-004-r001-direct-selection-checklist-tobii-dynavox.md",
		"specId": "1160-f-078-aac-004-r001-direct-selection-checklist-tobii-dynavox",
		"tags": {
			"framework": [],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Clinical documentation"
			],
			"topic": [
				"AAC"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during AAC initial assessment, direct-selection setup review, or reassessment when the team needs consistent access setup guidance."
			},
			{
				"title": "What It Captures",
				"body": "The checklist captures direct-selection method, body part or movement, positioning, device supports, environmental considerations, support needs, independence level, setup guidance, assessment episode, and change history."
			},
			{
				"title": "Relevant Limitations",
				"body": "The checklist is direct-selection-specific. It does not assess indirect scanning, recommend a device, or complete a full AAC assessment."
			}
		],
		"faqItems": [
			{
				"question": "Is this checklist for indirect selection or scanning?",
				"answer": "No. It is limited to direct-selection access for speech-generating devices."
			},
			{
				"question": "Does the AAC user complete the checklist independently?",
				"answer": "No. The checklist is completed by the clinician or AAC team while observing interaction and gathering relevant input."
			},
			{
				"question": "Can setup vary by environment?",
				"answer": "Yes. Environment-specific guidance should be recorded when setup or support needs differ across settings."
			},
			{
				"question": "What if the access method is not direct selection?",
				"answer": "The case should be marked out of scope for this checklist rather than forced through direct-selection fields."
			},
			{
				"question": "Are demo access notes saved as real client records?",
				"answer": "No. Fictional demo observations and setup notes are not carried over as real owned client data by default."
			}
		]
	},
	{
		"toolType": "scanningObservationFormTobiiDynavox",
		"slug": "scanning-observation-form-tobii-dynavox",
		"title": "Scanning Observation Form for AAC Teams | Qwoach",
		"metaDescription": "Document AAC scanning access by position, setup conditions, team observations, and implementation recommendations before saving the tool.",
		"h1": "Scanning Observation Form for AAC Scanning Access",
		"intro": "Scanning Observation Form is a structured AAC access observation form for practitioners and AAC teams. It helps SLPs, OTs, assistive technology specialists, educators, and support-team members document scanning-access conditions, team observations, communication positions, and setup recommendations for indirect AAC access.",
		"demoTitle": "Explore a sample scanning observation",
		"demoPrompt": "Interested in using Scanning Observation Form (Tobii Dynavox) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1161-f-078-aac-004-r002-scanning-observation-form-tobii-dynavox.md",
		"specId": "1161-f-078-aac-004-r002-scanning-observation-form-tobii-dynavox",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"AAC"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during indirect-selection AAC assessment when scanning access needs to be observed in one or more communication positions."
			},
			{
				"title": "What It Captures",
				"body": "The form captures position labels, scanning setup conditions, team observations, access-supporting variables, access-interfering variables, and practitioner recommendations."
			},
			{
				"title": "Relevant Limitations",
				"body": "The demo does not add source-specific Tobii Dynavox form fields that are unresolved in the product specification. It does not produce scores, severity labels, diagnostic conclusions, or generic AAC goals."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score scanning ability?",
				"answer": "No. The tool organizes descriptive observations and practitioner-entered recommendations; it does not calculate scores or severity labels."
			},
			{
				"question": "Can the form compare seated and lying positions?",
				"answer": "Yes. In multi-position overview mode, each position has its own observation block and the result can compare setup requirements across positions."
			},
			{
				"question": "Does the AAC user complete a questionnaire?",
				"answer": "No. The AAC user participates in observed scanning-access trials where applicable, while the practitioner or team completes the form."
			},
			{
				"question": "What happens if only one position is observed?",
				"answer": "The result remains useful but is limited to that position and should be marked as such."
			}
		]
	},
	{
		"toolType": "switchAssessmentAndPlanningFrameworkForIndividualsWithPhysicalDisabilities",
		"slug": "switch-assessment-and-planning-framework-for-individuals-with-physical-disabilities",
		"title": "Switch Assessment Planning for AAC Access | Qwoach",
		"metaDescription": "Compare switch movements, placements, positioning, trial notes, and option categories to plan AAC or assistive technology access.",
		"h1": "Switch Assessment and Planning Framework for Physical Disabilities",
		"intro": "Switch Assessment and Planning Framework is a practitioner-facing AAC and assistive technology access-planning tool. It helps AAC teams, OTs, SLPs, assistive technology specialists, and educators record body movements, switch placements, positioning conditions, and trial observations so they can identify viable and unsuitable switch-access options.",
		"demoTitle": "Explore a sample switch access plan",
		"demoPrompt": "Interested in using Switch Assessment and Planning Framework for Individuals with Physical Disabilities with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1162-f-078-aac-004-r003-switch-assessment-and-planning-framework-for-individuals-with-physical-disabilities.md",
		"specId": "1162-f-078-aac-004-r003-switch-assessment-and-planning-framework-for-individuals-with-physical-disabilities",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"AAC",
				"Functioning and disability"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during switch access assessment and planning when the team must determine which body movements, placements, and positioning conditions are viable for AAC or assistive technology access."
			},
			{
				"title": "What It Captures",
				"body": "The workspace captures candidate movements, switch placements, positioning contexts, trial observations, option categories, and practitioner recommendations."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not provide a general motor assessment, device catalog, unsupported scores, or automated judgments about physical ability."
			}
		],
		"faqItems": [
			{
				"question": "Does the framework choose the best switch automatically?",
				"answer": "No. It organizes observed evidence and categories so the practitioner can make and document the final recommendation."
			},
			{
				"question": "Can untested options be included?",
				"answer": "Yes. Untested or insufficiently observed options can be listed, but they should not be recommended as the observed-best option."
			},
			{
				"question": "Are the option categories configurable?",
				"answer": "No. The included access options are configurable, but the planning categories are fixed by the tool purpose."
			},
			{
				"question": "Can classifications be revised later?",
				"answer": "Yes. Practitioners can revise classifications as new observations are added, while preserving historical context."
			}
		]
	},
	{
		"toolType": "aacDeviceSystemTrialLog",
		"slug": "aac-device-system-trial-log",
		"title": "AAC Device Trial Log for System Comparison | Qwoach",
		"metaDescription": "Compare AAC device or system trials across contexts, preferences, evidence gaps, and recommendation status before saving the tool.",
		"h1": "AAC Device/System Trial Log",
		"intro": "AAC Device/System Trial Log is a structured comparison tool for AAC practitioners and teams. It helps practitioners gather trial evidence across contexts, preferences, communication needs, and feature-matching notes so they can compare AAC device or system fit for one user.",
		"demoTitle": "Explore a sample trial log",
		"demoPrompt": "Interested in using AAC Device/System Trial Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1163-f-078-aac-005-r001-aac-device-system-trial-log.md",
		"specId": "1163-f-078-aac-005-r001-aac-device-system-trial-log",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"AAC"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during AAC system selection when multiple options, contexts, or preference inputs need to be compared before a recommendation."
			},
			{
				"title": "What It Captures",
				"body": "The log captures trialed options, relevant contexts, observed communication evidence, feature-matching notes, preference notes, evidence gaps, and recommendation rationale."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not rank devices automatically, generate funding determinations, or supply unresolved feature-matching fields as if they were source-defined."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool rank AAC devices automatically?",
				"answer": "No. It shows recorded evidence side by side and leaves recommendation rationale to the practitioner."
			},
			{
				"question": "Can I use it with only one AAC option?",
				"answer": "Yes. With one option, the result documents evidence of fit rather than a comparative selection."
			},
			{
				"question": "What if an option has missing evidence?",
				"answer": "The log marks the option as unresolved or needing follow-up instead of treating it as ruled out."
			},
			{
				"question": "Can user preference conflict with observed fit?",
				"answer": "Yes. Preference notes and observed fit remain visible separately for practitioner interpretation."
			}
		]
	},
	{
		"toolType": "contextualFacilitatorsBarriersMap",
		"slug": "contextual-facilitators-barriers-map",
		"title": "AAC Contextual Facilitators and Barriers Map | Qwoach",
		"metaDescription": "Map AAC facilitators and barriers by setting or partner, identify actionable environmental targets, and save the configured tool.",
		"h1": "Contextual Facilitators & Barriers Map",
		"intro": "Contextual Facilitators & Barriers Map is an AAC planning tool for practitioners and teams. It helps identify environmental, social, physical, and contextual factors that affect AAC participation, connect them to settings or partners, and prioritize actionable environmental targets.",
		"demoTitle": "Explore a sample context map",
		"demoPrompt": "Interested in using Contextual Facilitators & Barriers Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1164-f-078-aac-006-r001-contextual-facilitators-barriers-map.md",
		"specId": "1164-f-078-aac-006-r001-contextual-facilitators-barriers-map",
		"tags": {
			"framework": [],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"AAC",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when participation issues appear connected to people, places, routines, physical setup, or other contextual factors."
			},
			{
				"title": "What It Captures",
				"body": "The map captures settings, partners, facilitators, barriers, actionability, priority order, and follow-up notes."
			},
			{
				"title": "Relevant Limitations",
				"body": "The map does not diagnose causes, score environments, compare devices, or generate intervention steps automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create AAC goals?",
				"answer": "No. It identifies contextual facilitators, barriers, and environmental targets; it does not create an AAC goal plan."
			},
			{
				"question": "Can the same factor be both a facilitator and a barrier?",
				"answer": "Yes. If it functions differently across settings, it should appear separately in each relevant context."
			},
			{
				"question": "What happens to vague barriers?",
				"answer": "Vague barriers are marked as needing clarification before they become actionable targets."
			},
			{
				"question": "Who controls the priorities?",
				"answer": "The practitioner controls priority ordering, using available team or user input where relevant."
			}
		]
	},
	{
		"toolType": "aacCommunicationPartnerPlan",
		"slug": "aac-communication-partner-plan",
		"title": "AAC Partner Support Planning Tool | Qwoach",
		"metaDescription": "Create partner-specific AAC support plans by setting or routine, review missing strategies, and save the configured planning tool.",
		"h1": "AAC Communication Partner Plan",
		"intro": "AAC Communication Partner Plan is a practitioner-led planning tool for AAC teams. It helps identify relevant communication partners, connect them to settings or routines, and record individualized support roles and strategies that guide everyday AAC interactions.",
		"demoTitle": "Explore a sample partner plan",
		"demoPrompt": "Interested in using AAC Communication Partner Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1165-f-078-aac-007-r001-aac-communication-partner-plan.md",
		"specId": "1165-f-078-aac-007-r001-aac-communication-partner-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"AAC",
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when partner behavior and support routines affect AAC consistency across home, school, community, or other everyday interaction settings."
			},
			{
				"title": "Practitioner And Partner Roles",
				"body": "The practitioner controls the plan and final strategy wording. Partners may contribute contextual details and view the portions relevant to their role."
			},
			{
				"title": "Relevant Limitations",
				"body": "The plan is not a training curriculum, compliance tracker, partner score, or AAC goal plan."
			}
		],
		"faqItems": [
			{
				"question": "Can partners see their own part of the plan?",
				"answer": "Yes. The product supports role-specific views focused on a partner's relevant settings, routines, and strategies."
			},
			{
				"question": "Does the tool score partner performance?",
				"answer": "No. It flags missing or vague strategies but does not score partner competence or quality."
			},
			{
				"question": "Can one partner have different strategies in different settings?",
				"answer": "Yes. Strategies remain separate by partner-context pair so differences across settings are visible."
			},
			{
				"question": "Who writes the final strategies?",
				"answer": "The practitioner controls the final support strategies, with team, partner, or AAC user input where available."
			}
		]
	},
	{
		"toolType": "aacVocabularyMessagePriorities",
		"slug": "aac-vocabulary-message-priorities",
		"title": "AAC Vocabulary and Message Priorities | Qwoach",
		"metaDescription": "Capture priority AAC messages, vocabulary needs, input source, context links, and content-selection notes before saving the tool.",
		"h1": "AAC Vocabulary / Message Priorities",
		"intro": "AAC Vocabulary / Message Priorities is a focused AAC content-planning tool for practitioners and AAC teams. It helps capture the user's priority messages and vocabulary needs, connect them to daily contexts or communication functions when known, and guide AAC content selection or system customization.",
		"demoTitle": "Explore a sample priority list",
		"demoPrompt": "Interested in using AAC Vocabulary / Message Priorities with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1166-f-078-aac-008-r001-aac-vocabulary-message-priorities.md",
		"specId": "1166-f-078-aac-008-r001-aac-vocabulary-message-priorities",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"AAC",
				"Service preferences"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when AAC content needs to reflect user preferences, daily participation needs, and communication purposes."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures priority messages or vocabulary needs, source of input, optional context/function links, practitioner notes, and update history."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not generate vocabulary, prescribe a vocabulary taxonomy, score importance, or program device layouts."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate AAC vocabulary?",
				"answer": "No. It organizes user-provided or team-supported priorities; it does not automatically generate vocabulary lists."
			},
			{
				"question": "Can supporters add priorities when the user cannot provide all input directly?",
				"answer": "Yes. Supporter-entered priorities can be recorded, and their source remains visible."
			},
			{
				"question": "Are communication functions required for every entry?",
				"answer": "No. Context or function links are optional unless the practitioner chooses a scoped collection approach."
			},
			{
				"question": "Can priorities change over time?",
				"answer": "Yes. The tool supports update history so priorities can be revised as preferences, environments, or needs change."
			}
		]
	},
	{
		"toolType": "communicationMatrix",
		"slug": "communication-matrix",
		"title": "Communication Matrix Communication Profile Tool | Qwoach",
		"metaDescription": "Explore the Communication Matrix assessment concept, profile review, skills list, and repeated-assessment tracking with source-defined logic reserved.",
		"h1": "Communication Matrix",
		"intro": "Communication Matrix is an online communication assessment for professionals and families. It helps practitioners supporting communication or AAC intervention capture current communication behaviors and skills, review current and emerging abilities, and compare repeated assessments over time when source-defined assessment logic is available.",
		"demoTitle": "Explore the assessment surfaces",
		"demoPrompt": "Interested in using Communication Matrix with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1167-f-078-aac-009-r001-communication-matrix.md",
		"specId": "1167-f-078-aac-009-r001-communication-matrix",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"AAC",
				"Developmental functioning",
				"Outcome monitoring"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when professional and family stakeholders need a communication profile, skills list, and progress view based on repeated assessments."
			},
			{
				"title": "What Is Reserved",
				"body": "Exact assessment items, skill areas, scoring, and profile generation rules remain source-defined and unresolved in this product specification."
			},
			{
				"title": "Relevant Limitations",
				"body": "The demo must not invent Communication Matrix questions, skill domains, levels, scores, profile algorithms, or progress rules."
			}
		],
		"faqItems": [
			{
				"question": "Does this demo include the actual Communication Matrix questions?",
				"answer": "No. Exact questions and response options are unresolved in the supplied product specification and must remain placeholders unless source-defined content is supplied."
			},
			{
				"question": "Can families contribute observations?",
				"answer": "Yes. Family or support stakeholders may provide observations where the source assessment supports that completion experience."
			},
			{
				"question": "Does the tool generate a profile from partial data?",
				"answer": "Only if source-defined logic allows it. Otherwise, partial assessments should show incomplete status without a full profile."
			},
			{
				"question": "Can repeated assessments be compared?",
				"answer": "Yes, when assessment dates, response sets, and source-defined structure support comparable repeated assessments."
			}
		]
	},
	{
		"toolType": "communicationMatrixProgressTool",
		"slug": "communication-matrix-progress-tool",
		"title": "Communication Matrix Progress Review Tool | Qwoach",
		"metaDescription": "Review sequential Communication Matrix assessments, comparability, trajectory placeholders, and practitioner notes before saving the tool.",
		"h1": "Communication Matrix Progress Tool",
		"intro": "Communication Matrix Progress Tool is a practitioner-only longitudinal review tool for communication and AAC intervention planning. It helps practitioners select sequential Communication Matrix assessments, check whether points are comparable, and review developmental trajectory over time when source-defined outputs support comparison.",
		"demoTitle": "Explore a sample progress review",
		"demoPrompt": "Interested in using Communication Matrix Progress Tool with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1168-f-078-aac-010-r001-communication-matrix-progress-tool.md",
		"specId": "1168-f-078-aac-010-r001-communication-matrix-progress-tool",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"AAC",
				"Developmental functioning",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after multiple Communication Matrix assessments exist and the practitioner needs to review change over time."
			},
			{
				"title": "What It Does Not Do",
				"body": "The progress tool does not collect new assessment responses or create new assessment content."
			},
			{
				"title": "Relevant Limitations",
				"body": "Trajectory views depend on comparable source-defined assessment outputs. Non-comparable assessments must be shown with explicit limitations rather than merged into a misleading trend."
			}
		],
		"faqItems": [
			{
				"question": "Can this tool be used with one assessment?",
				"answer": "Yes, but it cannot show a trajectory with fewer than two comparable assessments; it can only show available snapshot history."
			},
			{
				"question": "Does the tool collect new Communication Matrix responses?",
				"answer": "No. It reviews prior Communication Matrix assessments and does not collect new assessment responses."
			},
			{
				"question": "Can non-comparable assessments be displayed?",
				"answer": "Yes. They can be displayed, but the limitation must be explicit and they should not be merged into a trend."
			},
			{
				"question": "Who uses this tool?",
				"answer": "The practitioner uses this practitioner-only tool for longitudinal intervention review."
			}
		]
	},
	{
		"toolType": "aacGoalPlan",
		"slug": "aac-goal-plan",
		"title": "AAC Functional Communication Goal Plan | Qwoach",
		"metaDescription": "Plan prioritized AAC functional communication targets tied to needs, contexts, preferences, and review history before saving the tool.",
		"h1": "AAC Goal Plan",
		"intro": "AAC Goal Plan is a practitioner planning tool for AAC practitioners and teams. It helps convert assessment findings, user preferences, participation contexts, and daily communication needs into prioritized, observable functional communication targets for intervention planning.",
		"demoTitle": "Explore a sample AAC goal plan",
		"demoPrompt": "Interested in using AAC Goal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1169-f-078-aac-011-r001-aac-goal-plan.md",
		"specId": "1169-f-078-aac-011-r001-aac-goal-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"AAC",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after AAC assessment or participation review when intervention targets need to be meaningful, observable, and tied to daily communication needs."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures targets, priority order, functional-need links, context or preference links, practitioner notes, gap indicators, and review history."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not generate goal-bank language, scoring, formal service-plan wording, or intervention steps."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool write AAC goals automatically?",
				"answer": "No. The practitioner enters and controls final target wording; the tool organizes targets and flags missing links or vague entries."
			},
			{
				"question": "Can a device-operation target be included?",
				"answer": "Yes, but if it is not tied to functional communication, it should be flagged for missing functional link."
			},
			{
				"question": "Can the AAC user contribute priorities?",
				"answer": "Yes. The AAC user may contribute preferences or meaningful communication needs, while the practitioner creates final intervention targets."
			},
			{
				"question": "Can targets be changed later?",
				"answer": "Yes. The plan supports updates and preserves history as needs, abilities, or contexts change."
			}
		]
	},
	{
		"toolType": "aacOutcomeAbandonmentRiskReview",
		"slug": "aac-outcome-abandonment-risk-review",
		"title": "AAC Outcome and Abandonment Risk Review | Qwoach",
		"metaDescription": "Review AAC use, satisfaction, breakdowns, environment fit, and change needs over time before saving the configured tool.",
		"h1": "AAC Outcome / Abandonment Risk Review",
		"intro": "AAC Outcome / Abandonment Risk Review is a follow-up tool for AAC practitioners and teams. It helps review adoption, use, satisfaction, cross-environment fit, and descriptive risk that an AAC approach may be reduced or abandoned, then document recommended changes to sustain use.",
		"demoTitle": "Explore a sample outcome review",
		"demoPrompt": "Interested in using AAC Outcome / Abandonment Risk Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1170-f-078-aac-012-r001-aac-outcome-abandonment-risk-review.md",
		"specId": "1170-f-078-aac-012-r001-aac-outcome-abandonment-risk-review",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"AAC",
				"Service satisfaction",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after an AAC approach is already in use and the team needs to understand adoption, satisfaction, use across environments, or reduced-use risk."
			},
			{
				"title": "What It Captures",
				"body": "The review captures environments, stakeholder perspectives, use patterns, satisfaction concerns, breakdowns, descriptive risk indicators, recommended changes, and review history."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not calculate abandonment-risk scores, assign blame, generate automatic recommendations, or make funding determinations."
			}
		],
		"faqItems": [
			{
				"question": "Does this review calculate an abandonment-risk score?",
				"answer": "No. It identifies risk indicators descriptively and leaves recommended changes to the practitioner."
			},
			{
				"question": "Can the review capture non-use?",
				"answer": "Yes. If the AAC system is not being used in an environment, non-use should be recorded as the use pattern."
			},
			{
				"question": "What if user and stakeholder reports conflict?",
				"answer": "Both reports remain visible with their source so the practitioner can interpret the difference."
			},
			{
				"question": "Can the review be repeated over time?",
				"answer": "Yes. Historical reviews support monitoring whether changes sustain AAC use as contexts or preferences change."
			}
		]
	},
	{
		"toolType": "moreThanWordsSocialCommunicationChecklist",
		"slug": "more-than-words-social-communication-checklist",
		"title": "More Than Words Social Communication Checklist Demo | Qwoach",
		"metaDescription": "Explore a stage and skill profile checklist for child social communication planning, including caregiver completion and pre/post practitioner review.",
		"h1": "More Than Words Social Communication Checklist",
		"intro": "The More Than Words Social Communication Checklist is a ready-to-send stage and skill profile tool for practitioners supporting a child's social communication development. It helps practitioners organize checklist responses into a current profile, identify strengths and gaps, and compare baseline and follow-up administrations.",
		"demoTitle": "Explore a sample checklist",
		"demoPrompt": "Interested in using More Than Words Social Communication Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1171-f-079-hanen-001-r001-more-than-words-social-communication-checklist.md",
		"specId": "1171-f-079-hanen-001-r001-more-than-words-social-communication-checklist",
		"tags": {
			"framework": [],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Social communication",
				"Developmental functioning"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a practitioner needs a baseline or follow-up picture of a child's social communication stage and skills for intervention planning."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures checklist responses or observations required by the source structure and organizes them into a stage/skill profile with completion state, strengths, gaps, and comparison history."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create new checklist items, stage labels, diagnostic conclusions, severity scores, or intervention prescriptions."
			}
		],
		"faqItems": [
			{
				"question": "Can caregivers complete the checklist?",
				"answer": "Yes. The caregiver can complete the assigned checklist or complete it with the practitioner when appropriate."
			},
			{
				"question": "Does the demo show real stage labels or checklist items?",
				"answer": "No. Exact checklist items, response options, stage labels, and scoring rules are unresolved in the supplied specification, so the demo must represent them as source-defined content without inventing them."
			},
			{
				"question": "Can the tool compare baseline and follow-up profiles?",
				"answer": "Yes. When two comparable completed administrations exist, the review can show a side-by-side pre/post comparison using the same profile structure."
			},
			{
				"question": "Does the tool diagnose a child?",
				"answer": "No. It organizes checklist responses into a descriptive stage/skill profile and does not provide diagnostic conclusions."
			}
		]
	},
	{
		"toolType": "communicationStageProfile",
		"slug": "communication-stage-profile",
		"title": "Communication Stage Profile for Child Communication Support | Qwoach",
		"metaDescription": "Explore a communication stage profile for practitioners who identify a child's current stage and record next-step caregiver-mediated targets.",
		"h1": "Communication Stage Profile",
		"intro": "The Communication Stage Profile is a ready-to-complete-together tool for practitioners working with children and caregivers. It helps practitioners organize observations and caregiver examples, identify a current communication stage, and record next-step targets for caregiver-mediated support.",
		"demoTitle": "Open the stage profile demo",
		"demoPrompt": "Interested in using Communication Stage Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1172-f-079-hanen-002-r001-communication-stage-profile.md",
		"specId": "1172-f-079-hanen-002-r001-communication-stage-profile",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Social communication",
				"Developmental functioning"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a practitioner needs to distinguish a child's current communication stage from adjacent stages and choose next targets for caregiver-mediated intervention."
			},
			{
				"title": "Practitioner And Caregiver Roles",
				"body": "Caregivers may contribute everyday examples. The practitioner controls the final stage selection, target wording, and interpretation."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent stage criteria, automatically assign stages when practitioner judgment is required, or generate a broad treatment plan."
			}
		],
		"faqItems": [
			{
				"question": "Does the caregiver choose the child's stage?",
				"answer": "No. The caregiver can contribute examples, but the practitioner finalizes the stage when practitioner judgment is required."
			},
			{
				"question": "Can the profile stay unfinished?",
				"answer": "Yes. Draft profiles can preserve gathered evidence and unresolved questions without presenting the stage as settled."
			},
			{
				"question": "Can prior profiles be compared?",
				"answer": "Yes. A practitioner can select an earlier finalized profile to review stage and target changes over time."
			},
			{
				"question": "Does the tool provide target suggestions?",
				"answer": "No. If exact target menus are not supplied by the source content, the practitioner records selected targets without automated suggestions."
			}
		]
	},
	{
		"toolType": "parentChildInteractionBaselineVideo",
		"slug": "parent-child-interaction-baseline-video",
		"title": "Parent-Child Interaction Baseline Video Tool | Qwoach",
		"metaDescription": "Explore a baseline video workflow for practitioners reviewing natural caregiver-child interaction before communication intervention.",
		"h1": "Parent-Child Interaction Baseline Video",
		"intro": "The Parent-Child Interaction Baseline Video is a video capture and review tool for practitioners beginning caregiver-child communication support. It helps practitioners preserve a natural interaction sample, mark observable moments, and identify communication opportunities, caregiver behaviors, child responses, and support needs.",
		"demoTitle": "Review a sample baseline",
		"demoPrompt": "Interested in using Parent-Child Interaction Baseline Video with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1173-f-079-hanen-003-r001-parent-child-interaction-baseline-video.md",
		"specId": "1173-f-079-hanen-003-r001-parent-child-interaction-baseline-video",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Social communication",
				"Interpersonal relationships"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before intervention or coaching when the practitioner needs an observable baseline rather than relying only on report."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures a video sample, basic session context, timestamped practitioner observations, and coaching-relevant support needs."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not score caregiver behavior, detect emotion, diagnose, or create automated interpretation."
			}
		],
		"faqItems": [
			{
				"question": "Can the video be submitted remotely?",
				"answer": "Yes. The specification supports submitted recording as well as in-session recording."
			},
			{
				"question": "What happens if the video is poor quality?",
				"answer": "The practitioner can mark the capture as unusable or technically limited instead of forcing review conclusions."
			},
			{
				"question": "Does the system score the interaction?",
				"answer": "No. It supports timestamped notes and descriptive review, not automated scoring or behavioral classification."
			},
			{
				"question": "Can later videos be compared with the baseline?",
				"answer": "Yes. A later sample can be selected for descriptive comparison against the baseline."
			}
		]
	},
	{
		"toolType": "videoFeedbackReview",
		"slug": "video-feedback-review",
		"title": "Video Feedback Review for Caregiver Coaching | Qwoach",
		"metaDescription": "Explore a video-anchored feedback tool that helps practitioners review caregiver-child moments and set a specific next target.",
		"h1": "Video Feedback Review",
		"intro": "Video Feedback Review is a practitioner-led video review tool for caregivers learning communication-support strategies. It helps practitioners select observable caregiver-child moments, distinguish an interaction strength from an adjustment, and finalize one specific next target.",
		"demoTitle": "Start a sample video review",
		"demoPrompt": "Interested in using Video Feedback Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1174-f-079-hanen-004-r001-video-feedback-review.md",
		"specId": "1174-f-079-hanen-004-r001-video-feedback-review",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Social communication",
				"Skills use"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during caregiver coaching when feedback needs to refer to moments the caregiver can recognize from their own interaction with the child."
			},
			{
				"title": "What It Produces",
				"body": "The tool produces selected video moments linked to practitioner-authored feedback and one next target for future everyday interactions."
			},
			{
				"title": "Longitudinal Use",
				"body": "Completed reviews persist as coaching history so the practitioner can reinforce, adjust, or move to a new target over time."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate coaching feedback automatically?",
				"answer": "No. Feedback is practitioner-authored and tied to selected observable video moments."
			},
			{
				"question": "Can caregivers see the review?",
				"answer": "Yes. A caregiver-facing shared review can show selected clips and finalized feedback that the practitioner shares for coaching."
			},
			{
				"question": "What makes a review complete?",
				"answer": "A review is complete when the next target is recorded and understandable, with feedback anchored to selected moments."
			},
			{
				"question": "Can a review stay in draft?",
				"answer": "Yes. Draft reviews can contain selected moments without a finalized target."
			}
		]
	},
	{
		"toolType": "sensoryPreferencesChecklist",
		"slug": "sensory-preferences-checklist",
		"title": "Sensory Preferences Checklist for Communication Planning | Qwoach",
		"metaDescription": "Explore a sensory preference checklist that helps practitioners connect child observations to communication-support adaptations.",
		"h1": "Sensory Preferences Checklist",
		"intro": "The Sensory Preferences Checklist is a ready-to-send checklist for practitioners planning communication support for a child. It helps practitioners gather caregiver observations about sensory preferences or sensitivities and connect relevant findings to engagement, interaction, routines, and support adaptations.",
		"demoTitle": "Explore the checklist demo",
		"demoPrompt": "Interested in using Sensory Preferences Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1175-f-079-hanen-005-r001-sensory-preferences-checklist.md",
		"specId": "1175-f-079-hanen-005-r001-sensory-preferences-checklist",
		"tags": {
			"framework": [],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Sensory integration",
				"Social communication"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when sensory preferences or sensitivities may affect communication access, motivation, interaction, or routine participation."
			},
			{
				"title": "What It Captures",
				"body": "The checklist captures caregiver observations and organizes them so the practitioner can connect relevant information to support adaptations."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide diagnostic sensory conclusions, invented domains, severity labels, or automated treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can caregivers complete the checklist?",
				"answer": "Yes. A caregiver-facing checklist experience exists for reporting observations about the child's sensory preferences and responses."
			},
			{
				"question": "Does the tool recommend adaptations automatically?",
				"answer": "No. Adaptations are practitioner-selected or source-supported, not invented by the system."
			},
			{
				"question": "Can preferences vary by context?",
				"answer": "Yes. Context-specific notes should be preserved rather than collapsed into one global trait."
			},
			{
				"question": "Can the profile be updated later?",
				"answer": "Yes. The administration type can be initial profile or update, and update history remains visible."
			}
		]
	},
	{
		"toolType": "childInterestsInventory",
		"slug": "child-interests-inventory",
		"title": "Child Interests Inventory for Communication Planning | Qwoach",
		"metaDescription": "Explore an interests inventory that helps practitioners identify motivating child interests and link them to communication opportunities.",
		"h1": "Child Interests Inventory",
		"intro": "The Child Interests Inventory is a ready-to-send inventory for practitioners building individualized communication support. It helps practitioners gather observations about a child's interests, strengths, and preferences and connect them to natural routines, settings, and interaction opportunities.",
		"demoTitle": "Explore the inventory",
		"demoPrompt": "Interested in using Child Interests Inventory with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1176-f-079-hanen-006-r001-child-interests-inventory.md",
		"specId": "1176-f-079-hanen-006-r001-child-interests-inventory",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Strengths",
				"Social communication"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when planning communication support around interests and activities that naturally sustain a child's engagement."
			},
			{
				"title": "What It Captures",
				"body": "The inventory captures caregiver observations of interests, strengths, and preferences, then supports practitioner links to routines, settings, or interaction opportunities."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not rank motivation, create reward schedules, prescribe activities, or treat adult-selected activities as child preferences without evidence."
			}
		],
		"faqItems": [
			{
				"question": "Who completes the inventory?",
				"answer": "A caregiver-facing inventory exists, and the practitioner reviews the submitted observations for planning."
			},
			{
				"question": "Does the tool recommend activities?",
				"answer": "No. The practitioner uses reported interests to plan communication opportunities; the system does not generate intervention prescriptions."
			},
			{
				"question": "Can interests change over time?",
				"answer": "Yes. The inventory supports initial profiles and updates so changes in interests or settings can be preserved."
			},
			{
				"question": "What if an interest is too broad?",
				"answer": "The practitioner can request or add a more specific example before using it for planning."
			}
		]
	},
	{
		"toolType": "everydayRoutineCommunicationPlan",
		"slug": "everyday-routine-communication-plan",
		"title": "Everyday Routine Communication Plan for Caregiver Coaching | Qwoach",
		"metaDescription": "Explore a routine-based communication plan that helps practitioners map daily routines to opportunities and strategy targets.",
		"h1": "Everyday Routine Communication Plan",
		"intro": "The Everyday Routine Communication Plan is a ready-to-complete-together planning tool for practitioners and caregivers. It helps them choose real everyday routines, identify communication opportunities, and record strategy targets that fit the routine context.",
		"demoTitle": "Build a sample routine plan",
		"demoPrompt": "Interested in using Everyday Routine Communication Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1177-f-079-hanen-007-r001-everyday-routine-communication-plan.md",
		"specId": "1177-f-079-hanen-007-r001-everyday-routine-communication-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Social communication",
				"Skills use"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when caregiver practice needs to carry over into daily routines where the child naturally interacts."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures routine context, communication opportunity, matched strategy target, caregiver feasibility notes, practitioner coaching notes, and status."
			},
			{
				"title": "Repeat Use",
				"body": "Routines can remain active, be paused, or be retired while preserving history for follow-up."
			}
		],
		"faqItems": [
			{
				"question": "Does every daily routine need to be included?",
				"answer": "No. The plan can focus on one or a few routines so it stays usable and repeatable."
			},
			{
				"question": "Does the tool generate strategies?",
				"answer": "No. Strategy targets come from practitioner choice or source-supported material."
			},
			{
				"question": "What makes a routine plan complete?",
				"answer": "Each active routine needs a routine context and a clear communication opportunity or target matched to a strategy target."
			},
			{
				"question": "Can caregivers view the plan?",
				"answer": "Yes. The tool provides a simple caregiver-readable version of the active plan."
			}
		]
	},
	{
		"toolType": "owlFollowTheChildSLeadPracticeLog",
		"slug": "owl-follow-the-child-s-lead-practice-log",
		"title": "OWL Follow-the-Child's-Lead Practice Log | Qwoach",
		"metaDescription": "Explore a responsive interaction practice log for recording caregiver strategy use, child responses, and coaching patterns over time.",
		"h1": "OWL / Follow-the-Child's-Lead Practice Log",
		"intro": "The OWL / Follow-the-Child's-Lead Practice Log is a ready-to-send practice log for practitioners coaching caregivers in everyday interactions. It helps practitioners see whether caregivers are using the active responsive strategy and how the child responds where observable.",
		"demoTitle": "Try the practice log",
		"demoPrompt": "Interested in using OWL / Follow-the-Child's-Lead Practice Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1178-f-079-hanen-008-r001-owl-follow-the-child-s-lead-practice-log.md",
		"specId": "1178-f-079-hanen-008-r001-owl-follow-the-child-s-lead-practice-log",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Social communication",
				"Skills use"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it while caregivers are practicing responsive interaction strategies in everyday moments and need to notice what they tried and what happened next."
			},
			{
				"title": "What It Captures",
				"body": "The log captures real interaction context, caregiver strategy use, child response where observable, entry status, and practitioner coaching notes."
			},
			{
				"title": "Review Limits",
				"body": "Pattern summaries are descriptive. The tool does not create adherence scores, parenting ratings, or automated coaching recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can caregivers save draft entries?",
				"answer": "Yes. Entries can be draft or submitted, allowing quick capture before formal review."
			},
			{
				"question": "What if the child response is unclear?",
				"answer": "The caregiver can mark the response as unknown or not observed instead of inventing one."
			},
			{
				"question": "Does the tool score adherence?",
				"answer": "No. It may show descriptive counts or groupings based on entries, but it does not create an adherence score."
			},
			{
				"question": "Can the practitioner change the strategy focus?",
				"answer": "Yes. The practitioner controls the active strategy focus and can reinforce, adjust, or set a new target after review."
			}
		]
	},
	{
		"toolType": "rOCKRoutinePlan",
		"slug": "r-o-c-k-routine-plan",
		"title": "R.O.C.K. Routine Plan for Communication Opportunities | Qwoach",
		"metaDescription": "Explore a routine-specific strategy plan for structuring predictable routines and reviewing caregiver implementation evidence.",
		"h1": "R.O.C.K. Routine Plan",
		"intro": "The R.O.C.K. Routine Plan is a ready-to-send routine strategy implementation tool for practitioners and caregivers. It helps practitioners define a predictable routine, specify caregiver actions, and review whether repeated communication opportunities and child responses are being recorded over time.",
		"demoTitle": "Explore a sample routine plan",
		"demoPrompt": "Interested in using R.O.C.K. Routine Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1179-f-079-hanen-009-r001-r-o-c-k-routine-plan.md",
		"specId": "1179-f-079-hanen-009-r001-r-o-c-k-routine-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Social communication",
				"Skills use"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a practitioner wants one predictable routine to create repeated opportunities for child participation or communication."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures active routine structure, caregiver actions, repeated opportunities, child responses, barriers, and practitioner review notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not define missing R.O.C.K. content, create unsupported scores, or make automated effectiveness claims."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo define what R.O.C.K. stands for?",
				"answer": "No. The supplied specification does not define the acronym expansion, so the demo must not invent it."
			},
			{
				"question": "Can a routine be paused or retired?",
				"answer": "Yes. Routine plan status can be draft, active, paused, or retired while preserving history."
			},
			{
				"question": "What must be set before logging begins?",
				"answer": "An active plan must have a chosen routine and specific caregiver actions before implementation logging begins."
			},
			{
				"question": "Does the tool judge whether the strategy worked?",
				"answer": "No. It shows descriptive implementation evidence and child responses for practitioner review."
			}
		]
	},
	{
		"toolType": "parentCoachingGoalSheet",
		"slug": "parent-coaching-goal-sheet",
		"title": "Parent Coaching Goal Sheet for Communication Targets | Qwoach",
		"metaDescription": "Explore a collaborative goal sheet for practitioners and parents to set assessment-linked communication-support coaching targets.",
		"h1": "Parent Coaching Goal Sheet",
		"intro": "The Parent Coaching Goal Sheet is a ready-to-complete-together tool for practitioners coaching parents after assessment. It helps practitioners link child communication needs to explicit parent coaching targets, record parent agreement, and keep active targets focused on everyday interactions.",
		"demoTitle": "Draft a sample goal sheet",
		"demoPrompt": "Interested in using Parent Coaching Goal Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1180-f-079-hanen-010-r001-parent-coaching-goal-sheet.md",
		"specId": "1180-f-079-hanen-010-r001-parent-coaching-goal-sheet",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Social communication",
				"Goals"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it after assessment when the practitioner and parent need shared coaching priorities for everyday communication support."
			},
			{
				"title": "What It Captures",
				"body": "The goal sheet captures assessment basis, child communication need, target text, parent role, feasibility input, agreement status, and target history."
			},
			{
				"title": "Completion Rules",
				"body": "A target should not be finalized without child-need basis, parent agreement, specificity, and fit for ordinary interactions or routines."
			}
		],
		"faqItems": [
			{
				"question": "Can a target be finalized without parent agreement?",
				"answer": "No. Parent agreement is required for a finalized shared target."
			},
			{
				"question": "Does the tool generate goals automatically?",
				"answer": "No. Target wording is practitioner- or source-defined; the system does not generate target content."
			},
			{
				"question": "What happens when a target changes?",
				"answer": "Changes create visible target history through revised or retired statuses rather than silently overwriting prior targets."
			},
			{
				"question": "Can parents see the targets?",
				"answer": "Yes. The tool provides a parent-readable view of active shared targets and practical role language."
			}
		]
	},
	{
		"toolType": "focus34",
		"slug": "focus-34",
		"title": "FOCUS-34 Communication Participation Outcome Measure | Qwoach",
		"metaDescription": "Explore FOCUS-34, a ready-to-send communication participation outcome measure for tracking young children across baseline and follow-up.",
		"h1": "FOCUS-34",
		"intro": "FOCUS-34 is a ready-to-send communication-participation outcome measure for practitioners supporting young children with social communication needs. It helps practitioners capture a numerical communication-participation score and compare scores across baseline and follow-up administrations.",
		"demoTitle": "Explore a sample administration and score history.",
		"demoPrompt": "Interested in using FOCUS-34 with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1181-f-079-hanen-011-r001-focus-34.md",
		"specId": "1181-f-079-hanen-011-r001-focus-34",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Social communication",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use FOCUS-34 when communication participation needs to be measured at baseline and repeated later to support treatment review."
			},
			{
				"title": "What It Shows",
				"body": "The review shows completed time points, numerical scores, dates, and descriptive change between available administrations."
			},
			{
				"title": "Limitations",
				"body": "The tool does not add domains, treatment recommendations, diagnostic conclusions, or score-meaning thresholds not defined by FOCUS-34."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo require real child information?",
				"answer": "No. The public demo uses fictional labels and sample data so practitioners can explore the workflow without entering client-identifying information."
			},
			{
				"question": "Can the practitioner customize the FOCUS-34 items?",
				"answer": "No. FOCUS-34 remains the specific measure; configuration is limited to administration context or mode where supported."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The FOCUS-34 tool itself and selected practitioner setup are saved. Sample demo responses and fictional case data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "dailyStutteringSeverityRatingSr",
		"slug": "daily-stuttering-severity-rating-sr",
		"title": "Daily Stuttering Severity Rating Tool | Qwoach",
		"metaDescription": "Explore a daily 0-to-9 stuttering severity rating tool for parent reporting and practitioner review of day-by-day severity trends.",
		"h1": "Daily Stuttering Severity Rating",
		"intro": "Daily Stuttering Severity Rating is a ready-to-send tool for practitioners managing treatment for a child who stutters. It helps practitioners collect parent-reported 0-to-9 daily severity ratings and review a day-by-day severity trend between clinic visits.",
		"demoTitle": "Try the daily rating and trend review.",
		"demoPrompt": "Interested in using Daily Stuttering Severity Rating (SR) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1182-f-080-lid-001-r001-daily-stuttering-severity-rating-sr.md",
		"specId": "1182-f-080-lid-001-r001-daily-stuttering-severity-rating-sr",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Diary card"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Stuttering",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures one daily stuttering severity rating on the fixed 0-to-9 scale."
			},
			{
				"title": "How Missing Days Appear",
				"body": "Missing days are shown as gaps or incomplete dates, not as zero severity."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not collect causes of severity change, caregiver confidence, treatment advice, or alternate severity scales."
			}
		],
		"faqItems": [
			{
				"question": "Does the parent enter more than one rating per day?",
				"answer": "No. The tool captures one stuttering severity rating per date."
			},
			{
				"question": "Can the severity scale be changed?",
				"answer": "No. The daily SR scale is fixed at 0 to 9 for this tool."
			},
			{
				"question": "Are missing days treated as zero severity?",
				"answer": "No. Missing days appear as missing data or gaps, not as severity ratings."
			}
		]
	},
	{
		"toolType": "childStutteringSeverityChart",
		"slug": "child-stuttering-severity-chart",
		"title": "Child Stuttering Severity Chart for Treatment Review | Qwoach",
		"metaDescription": "Explore a practitioner-facing stuttering severity chart that displays home and clinic severity points in chronological treatment order.",
		"h1": "Child Stuttering Severity Chart",
		"intro": "Child Stuttering Severity Chart is a practitioner-facing longitudinal chart for practitioners tracking a child who stutters across treatment. It helps practitioners view repeated severity points in chronological order and recognize progress, plateau, worsening, or possible relapse-risk patterns from the visible trajectory.",
		"demoTitle": "Explore the severity trajectory.",
		"demoPrompt": "Interested in using Child Stuttering Severity Chart with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1183-f-080-lid-002-r001-child-stuttering-severity-chart.md",
		"specId": "1183-f-080-lid-002-r001-child-stuttering-severity-chart",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Graph"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Stuttering",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the chart during treatment review when repeated severity values need to be interpreted in order."
			},
			{
				"title": "Source Labels",
				"body": "Clinic and home ratings are labeled when both are present so mixed-source data is not merged ambiguously."
			},
			{
				"title": "Sparse Data",
				"body": "A single point can be displayed, but it cannot establish a trend."
			}
		],
		"faqItems": [
			{
				"question": "Is there a separate parent view for this chart?",
				"answer": "No. The chart itself is practitioner-facing; parent ratings may feed it from separate SR workflows."
			},
			{
				"question": "Does the chart decide treatment phase changes?",
				"answer": "No. The chart visualizes severity trajectory and leaves treatment decisions to the practitioner."
			},
			{
				"question": "Can clinic and home ratings be distinguished?",
				"answer": "Yes. When both sources exist, the chart should label or visually distinguish them."
			}
		]
	},
	{
		"toolType": "clinicianInClinicSeverityRating",
		"slug": "clinician-in-clinic-severity-rating",
		"title": "Clinician In-Clinic Severity Rating Tool | Qwoach",
		"metaDescription": "Explore a practitioner-only visit rating tool for recording clinician stuttering severity and comparing it with nearby home ratings.",
		"h1": "Clinician In-Clinic Severity Rating",
		"intro": "Clinician In-Clinic Severity Rating is a practitioner-only tool for practitioners seeing a child who stutters in clinic. It helps practitioners record a visit-specific stuttering severity rating from direct observation and compare that reference point with recent caregiver ratings.",
		"demoTitle": "Enter a sample clinic rating.",
		"demoPrompt": "Interested in using Clinician In-Clinic Severity Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1184-f-080-lid-003-r001-clinician-in-clinic-severity-rating.md",
		"specId": "1184-f-080-lid-003-r001-clinician-in-clinic-severity-rating",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Stuttering"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Practitioner Only",
				"body": "The tool is completed by the practitioner based on observed child speech during the visit."
			},
			{
				"title": "Comparison Context",
				"body": "Recent caregiver ratings may be shown for context, but agreement judgments belong to a separate agreement-check tool."
			},
			{
				"title": "Validity Limits",
				"body": "If no speech is observed, no valid in-clinic severity rating should be recorded."
			}
		],
		"faqItems": [
			{
				"question": "Does the child or caregiver complete this tool?",
				"answer": "No. This is a practitioner-only rating based on clinician observation."
			},
			{
				"question": "Can I record more than one rating for the same visit?",
				"answer": "The product is defined around one visit-specific clinician rating; duplicates require correction or clear replacement."
			},
			{
				"question": "Does it determine whether caregiver ratings agree?",
				"answer": "No. It can display nearby caregiver context, but agreement review is handled by the separate agreement-check tool."
			}
		]
	},
	{
		"toolType": "parentClinicianSrAgreementCheck",
		"slug": "parent-clinician-sr-agreement-check",
		"title": "Parent-Clinician Stuttering Rating Agreement Check | Qwoach",
		"metaDescription": "Explore a practitioner-only SR agreement check that compares caregiver and clinician stuttering severity ratings side by side.",
		"h1": "Parent-Clinician SR Agreement Check",
		"intro": "Parent-Clinician SR Agreement Check is a practitioner-only calibration tool for practitioners using caregiver-reported stuttering severity ratings. It helps practitioners compare caregiver and clinician SR values, see the numerical difference, and record whether the comparison supports reliance on home ratings or indicates a calibration need.",
		"demoTitle": "Run a sample agreement check.",
		"demoPrompt": "Interested in using Parent-Clinician SR Agreement Check with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1185-f-080-lid-004-r001-parent-clinician-sr-agreement-check.md",
		"specId": "1185-f-080-lid-004-r001-parent-clinician-sr-agreement-check",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Quality review"
			],
			"topic": [
				"Stuttering",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "What It Compares",
				"body": "The check compares paired caregiver and clinician SR values from the same or closely related observation context."
			},
			{
				"title": "What It Calculates",
				"body": "The system displays the numerical difference between the selected ratings."
			},
			{
				"title": "Interpretation Boundary",
				"body": "Agreement status is practitioner-entered or based only on supported rules; unsupported thresholds are not applied."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool automatically decide whether ratings agree?",
				"answer": "No. It shows the difference and context; agreement status is practitioner-entered unless supported criteria are available."
			},
			{
				"question": "Can unpaired ratings be used?",
				"answer": "No. The tool requires caregiver and clinician ratings selected for a comparable context."
			},
			{
				"question": "Is there a caregiver-facing view?",
				"answer": "No. This is a practitioner-only comparison and calibration review."
			}
		]
	},
	{
		"toolType": "percentSyllablesStutteredSsSample",
		"slug": "percent-syllables-stuttered-ss-sample",
		"title": "%SS Sample Tool for Stuttering Treatment Review | Qwoach",
		"metaDescription": "Explore a practitioner-only %SS tool that calculates percent syllables stuttered from speech-sample counts for treatment review.",
		"h1": "Percent Syllables Stuttered (%SS) Sample",
		"intro": "Percent Syllables Stuttered (%SS) Sample is a practitioner-only speech-frequency measurement tool for practitioners working with a child who stutters. It helps practitioners enter total syllables and stuttered syllables from an actual speech sample and calculate percent syllables stuttered for review.",
		"demoTitle": "Calculate a sample %SS result.",
		"demoPrompt": "Interested in using Percent Syllables Stuttered (%SS) Sample with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1186-f-080-lid-005-r001-percent-syllables-stuttered-ss-sample.md",
		"specId": "1186-f-080-lid-005-r001-percent-syllables-stuttered-ss-sample",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Stuttering"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "What It Calculates",
				"body": "The tool calculates percent syllables stuttered from total syllable count and stuttered syllable count."
			},
			{
				"title": "Validation",
				"body": "Total syllables must be greater than zero, and stuttered syllables cannot exceed total syllables."
			},
			{
				"title": "What It Does Not Require",
				"body": "The tool does not require audio processing or transcript capture as product inputs."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool analyze audio automatically?",
				"answer": "No. The practitioner enters observed counts; automated speech analysis is not part of this product."
			},
			{
				"question": "What happens if stuttered syllables exceed total syllables?",
				"answer": "The entry is invalid, and the tool should not calculate %SS from that count relationship."
			},
			{
				"question": "Is %SS the same as a severity rating?",
				"answer": "No. %SS is a frequency measure derived from counts; severity ratings are a separate construct."
			}
		]
	},
	{
		"toolType": "parentVerbalContingenciesPlan",
		"slug": "parent-verbal-contingencies-plan",
		"title": "Parent Verbal Contingencies Plan for Home Stuttering Treatment | Qwoach",
		"metaDescription": "Explore a joint plan for practitioner-supervised caregiver responses to fluent and stuttered speech during home treatment.",
		"h1": "Parent Verbal Contingencies Plan",
		"intro": "Parent Verbal Contingencies Plan is a ready-to-complete-together treatment procedure plan for practitioners supervising caregiver-delivered stuttering treatment. It helps practitioners and caregivers create a clear home response pattern for fluent speech and stuttered speech during agreed home treatment interactions.",
		"demoTitle": "Draft a sample response plan.",
		"demoPrompt": "Interested in using Parent Verbal Contingencies Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1187-f-080-lid-006-r001-parent-verbal-contingencies-plan.md",
		"specId": "1187-f-080-lid-006-r001-parent-verbal-contingencies-plan",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Stuttering",
				"Behavior change"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Practitioner and Caregiver Roles",
				"body": "The practitioner controls the clinical content; the caregiver participates in joint completion and later views the agreed plan."
			},
			{
				"title": "Completion Rule",
				"body": "A plan missing either fluent-speech or stuttered-speech response content remains incomplete."
			},
			{
				"title": "Revision",
				"body": "The practitioner can revise the plan as supervision continues while keeping the current version clear."
			}
		],
		"faqItems": [
			{
				"question": "Does the system write the verbal contingencies?",
				"answer": "No. The practitioner supplies the substantive response content."
			},
			{
				"question": "Can the caregiver edit the clinical response plan alone?",
				"answer": "No. Caregiver-only edits should not silently change the supervised clinical plan."
			},
			{
				"question": "What makes the plan complete?",
				"answer": "Both fluent-speech and stuttered-speech response categories must be addressed, with the agreed context captured."
			}
		]
	},
	{
		"toolType": "structuredTreatmentPracticePlan",
		"slug": "structured-treatment-practice-plan",
		"title": "Structured Treatment Practice Plan for Home Stuttering Treatment | Qwoach",
		"metaDescription": "Explore a plan for defining specific home contexts, routine fit, and barriers for early caregiver-delivered stuttering treatment.",
		"h1": "Structured Treatment Practice Plan",
		"intro": "Structured Treatment Practice Plan is a ready-to-send planning tool for practitioners beginning caregiver-delivered stuttering treatment. It helps practitioners and caregivers define specific home contexts for focused treatment interactions before support is broadened into everyday conversation.",
		"demoTitle": "Build a sample practice plan.",
		"demoPrompt": "Interested in using Structured Treatment Practice Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1188-f-080-lid-007-r001-structured-treatment-practice-plan.md",
		"specId": "1188-f-080-lid-007-r001-structured-treatment-practice-plan",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Stuttering",
				"Homework"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it early in caregiver-delivered treatment when focused practice needs defined home contexts."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures practice contexts, routine fit, barriers, draft/final state, and practitioner review."
			},
			{
				"title": "Boundary",
				"body": "The tool does not invent dose rules, scripts, reminders, adherence formulas, or automatic expansion decisions."
			}
		],
		"faqItems": [
			{
				"question": "Is this a scheduling tool?",
				"answer": "No. It defines treatment practice contexts; it is not a general calendar or reminder system."
			},
			{
				"question": "Can caregivers propose contexts?",
				"answer": "Yes. Caregivers can provide routine and context information, and the practitioner reviews and finalizes the agreed structure."
			},
			{
				"question": "Does completion automatically move treatment into everyday conversation?",
				"answer": "No. Expansion is not automatic and requires practitioner review."
			}
		]
	},
	{
		"toolType": "everydayConversationGeneralizationPlan",
		"slug": "everyday-conversation-generalization-plan",
		"title": "Everyday Conversation Generalization Plan for Stuttering Treatment | Qwoach",
		"metaDescription": "Explore a joint plan for extending caregiver-supported stuttering treatment into selected everyday conversation contexts.",
		"h1": "Everyday Conversation Generalization Plan",
		"intro": "Everyday Conversation Generalization Plan is a ready-to-complete-together treatment-transition plan for practitioners supporting a child who stutters. It helps practitioners and caregivers select everyday conversation contexts, define the caregiver's role, and reference severity information so extension is aligned with readiness.",
		"demoTitle": "Create a sample generalization plan.",
		"demoPrompt": "Interested in using Everyday Conversation Generalization Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1189-f-080-lid-008-r001-everyday-conversation-generalization-plan.md",
		"specId": "1189-f-080-lid-008-r001-everyday-conversation-generalization-plan",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Stuttering"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when structured treatment response suggests support may extend into selected everyday conversation contexts."
			},
			{
				"title": "Caregiver Role",
				"body": "Each selected context needs an agreed caregiver role before the plan is complete."
			},
			{
				"title": "Readiness Boundary",
				"body": "The tool can display severity information for reference, but readiness remains a practitioner judgment."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool automatically decide readiness?",
				"answer": "No. Readiness is determined by the practitioner, with severity information available as reference when present."
			},
			{
				"question": "Is outcome reporting required immediately?",
				"answer": "No. Outcome reports may be absent initially and should not be treated as failure."
			},
			{
				"question": "What makes a context complete?",
				"answer": "Each selected everyday context needs an agreed caregiver role before finalization."
			}
		]
	},
	{
		"toolType": "stage1ProgressReview",
		"slug": "stage-1-progress-review",
		"title": "Stage 1 Progress Review for Stuttering Treatment | Qwoach",
		"metaDescription": "Explore a joint Stage 1 review workflow for interpreting severity trends, identifying implementation issues, and recording next direction.",
		"h1": "Stage 1 Progress Review",
		"intro": "Stage 1 Progress Review is a ready-to-complete-together recurring decision workflow for practitioners managing active stuttering treatment. It helps practitioners and caregivers interpret recent severity information, identify implementation issues, and record whether to continue, adjust, or prepare for transition.",
		"demoTitle": "Complete a sample progress review.",
		"demoPrompt": "Interested in using Stage 1 Progress Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1190-f-080-lid-009-r001-stage-1-progress-review.md",
		"specId": "1190-f-080-lid-009-r001-stage-1-progress-review",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Stuttering",
				"Outcome monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Decision States",
				"body": "The review records one of three practitioner-selected next directions: continue, adjust, or prepare for transition."
			},
			{
				"title": "Shared Review",
				"body": "The caregiver can participate by discussing implementation issues and sharing an understandable view of current progress and next direction."
			},
			{
				"title": "History",
				"body": "Completed reviews remain historical records and are not overwritten by later reviews."
			},
			{
				"title": "Limits",
				"body": "The tool does not automate transition eligibility or generate treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool choose continue, adjust, or prepare for transition automatically?",
				"answer": "No. The practitioner records the decision state; the system only displays descriptive severity information."
			},
			{
				"question": "What happens if recent SR data is insufficient?",
				"answer": "Insufficient recent SR data should be visible and should limit confidence in trend interpretation."
			},
			{
				"question": "Can caregiver implementation issues be captured?",
				"answer": "Yes. Caregiver implementation issues can be captured when they affect progress."
			},
			{
				"question": "Are prior review decisions overwritten?",
				"answer": "No. Prior review decisions remain historical records when new reviews are completed."
			}
		]
	},
	{
		"toolType": "stage2EntryCriteriaCheck",
		"slug": "stage-2-entry-criteria-check",
		"title": "Stage 2 Entry Criteria Check | Qwoach",
		"metaDescription": "Check whether recent Lidcombe severity ratings support a Stage 2 maintenance transition, with uncertainty kept visible for practitioner review.",
		"h1": "Stage 2 Entry Criteria Check",
		"intro": "Stage 2 Entry Criteria Check is a practitioner-only Lidcombe Program tool for speech-language practitioners. It helps practitioners decide whether a child in active stuttering treatment meets the severity-based readiness threshold for moving into Stage 2 maintenance.",
		"demoTitle": "Explore a sample transition check",
		"demoPrompt": "Interested in using Stage 2 Entry Criteria Check with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1191-f-080-lid-010-r001-stage-2-entry-criteria-check.md",
		"specId": "1191-f-080-lid-010-r001-stage-2-entry-criteria-check",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Stuttering",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the check only at the Stage 1-to-Stage 2 decision point, when low recent severity suggests possible movement from active treatment into maintenance."
			},
			{
				"title": "What It Preserves",
				"body": "The result keeps reported severity ratings, derived threshold status, practitioner judgment, uncertainty, and decision date distinct for later comparison."
			},
			{
				"title": "Important Limitations",
				"body": "The tool does not provide a general stuttering assessment, treatment procedures, prognosis, or explanations for severity change."
			}
		],
		"faqItems": [
			{
				"question": "Is this a client-facing tool?",
				"answer": "No. Stage 2 Entry Criteria Check is practitioner-only and uses severity information already available in the surrounding treatment workflow."
			},
			{
				"question": "What happens if ratings are missing?",
				"answer": "Missing ratings produce an insufficient-evidence state rather than a readiness decision."
			},
			{
				"question": "Can one low severity rating support transition?",
				"answer": "No. The check is based on a longitudinal severity pattern, not a single favorable rating."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The tool itself and selected reusable practitioner settings are saved. Demo case data and sample ratings are not saved as real client data."
			}
		]
	},
	{
		"toolType": "stage2MaintenanceSchedule",
		"slug": "stage-2-maintenance-schedule",
		"title": "Stage 2 Maintenance Schedule | Qwoach",
		"metaDescription": "Create a Lidcombe Stage 2 maintenance timeline with monitoring points, severity entries, caregiver responsibilities, and relapse-signal review.",
		"h1": "Stage 2 Maintenance Schedule",
		"intro": "Stage 2 Maintenance Schedule is a Lidcombe Program maintenance-pathway tool for speech-language practitioners. It helps practitioners set monitoring points, review severity information, and identify relapse or loss-of-gains signals during reduced clinical intensity.",
		"demoTitle": "Explore a sample maintenance timeline",
		"demoPrompt": "Interested in using Stage 2 Maintenance Schedule with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1192-f-080-lid-011-r001-stage-2-maintenance-schedule.md",
		"specId": "1192-f-080-lid-011-r001-stage-2-maintenance-schedule",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Stuttering",
				"Relapse prevention"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the schedule after active-treatment goals have been met and ongoing Stage 2 monitoring is needed."
			},
			{
				"title": "What It Tracks",
				"body": "The tool tracks maintenance start, monitoring points, severity entries, completion status, caregiver responsibilities where defined, relapse-signal status, and practitioner follow-up decisions."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not provide broad care-plan management, active-treatment procedures, or explanations for severity increases."
			}
		],
		"faqItems": [
			{
				"question": "Is this just an appointment scheduler?",
				"answer": "No. The schedule exists to support Stage 2 maintenance monitoring with severity information and relapse-signal visibility."
			},
			{
				"question": "Can caregivers use it?",
				"answer": "Yes, where applicable, caregivers may complete simple maintenance check-ins for required severity information or defined responsibilities."
			},
			{
				"question": "What happens if a monitoring point is missed?",
				"answer": "A missed monitoring point remains visible as unknown or incomplete status, not as evidence that relapse is absent."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself and selected reusable schedule settings are saved. Fictional demo data and sample check-ins do not carry over as real client data."
			}
		]
	},
	{
		"toolType": "lidcombeTreatmentFidelityChecklist",
		"slug": "lidcombe-treatment-fidelity-checklist",
		"title": "Lidcombe Treatment Fidelity Checklist | Qwoach",
		"metaDescription": "Check caregiver-delivered Lidcombe treatment fidelity with component findings, gap notes, unknown states, and comparison over time.",
		"h1": "Lidcombe Treatment Fidelity Checklist",
		"intro": "Lidcombe Treatment Fidelity Checklist is a practitioner-only supervision tool for speech-language practitioners. It helps practitioners verify key treatment procedures, identify implementation gaps, and keep unknown items distinct from adequate fidelity.",
		"demoTitle": "Try a sample fidelity check",
		"demoPrompt": "Interested in using Lidcombe Treatment Fidelity Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1193-f-080-lid-012-r001-lidcombe-treatment-fidelity-checklist.md",
		"specId": "1193-f-080-lid-012-r001-lidcombe-treatment-fidelity-checklist",
		"tags": {
			"framework": [
				"Lidcombe Program"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Quality review"
			],
			"topic": [
				"Stuttering",
				"Fidelity monitoring"
			],
			"population": [
				"Children",
				"Parents"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the checklist when supervising caregiver-delivered treatment and deciding whether implementation problems may explain treatment concerns."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures component responses, gap notes, unknown items, date or review point, and practitioner follow-up judgment."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not score treatment response, judge caregiver motivation, or infer child prognosis."
			}
		],
		"faqItems": [
			{
				"question": "Does the checklist rate treatment outcome?",
				"answer": "No. It verifies implementation fidelity and keeps treatment-response interpretation separate."
			},
			{
				"question": "What if a component was not observed?",
				"answer": "An unobserved component remains unknown rather than being counted as adequate."
			},
			{
				"question": "Can caregivers complete this themselves?",
				"answer": "No. The product is practitioner-only; caregiver behavior or reports may be reviewed as evidence by the practitioner."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The checklist tool itself and selected reusable setup are saved. Demo observations and fictional review content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "aFromProfile",
		"slug": "a-from-profile",
		"title": "A-FROM Profile for Aphasia Care | Qwoach",
		"metaDescription": "Create a shared four-domain A-FROM profile for aphasia, covering life participation, personal factors, communication abilities, and environment.",
		"h1": "A-FROM Profile",
		"intro": "A-FROM Profile is a collaborative aphasia formulation tool for speech-language practitioners and people with aphasia. It helps them discuss meaningful outcomes across life participation, personal factors, impairment or communication abilities, and communication/language environment.",
		"demoTitle": "Build a sample A-FROM profile",
		"demoPrompt": "Interested in using A-FROM Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1194-f-081-lpaa-001-r001-a-from-profile.md",
		"specId": "1194-f-081-lpaa-001-r001-a-from-profile",
		"tags": {
			"framework": [
				"A-FROM"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Aphasia",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Four-Domain Formulation",
				"body": "The profile organizes discussion around life participation, personal factors, impairment or communication abilities, and communication/language environment."
			},
			{
				"title": "Shared Participation Focus",
				"body": "The person’s meaningful outcomes remain visible as reported experience while the practitioner adds synthesis for planning."
			},
			{
				"title": "Relevant Limitations",
				"body": "The profile does not add scores, rankings, diagnostic conclusions, or standardized interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Is this a full aphasia test battery?",
				"answer": "No. A-FROM Profile is a multidomain formulation profile, not a test battery or scoring instrument."
			},
			{
				"question": "Can the person with aphasia participate directly?",
				"answer": "Yes. The tool supports shared completion with practitioner facilitation and low-load interaction."
			},
			{
				"question": "What happens when a domain is empty?",
				"answer": "An empty domain remains unresolved rather than being treated as absent or unimportant."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool itself and selected completion mode are saved. Fictional sample notes and temporary profile content do not become real client data."
			}
		]
	},
	{
		"toolType": "assessmentForLivingWithAphasiaAla",
		"slug": "assessment-for-living-with-aphasia-ala",
		"title": "Assessment for Living with Aphasia | Qwoach",
		"metaDescription": "Send or administer the ALA aphasia self-report and review a broad A-FROM-aligned profile for baseline or follow-up comparison.",
		"h1": "Assessment for Living with Aphasia (ALA)",
		"intro": "Assessment for Living with Aphasia (ALA) is a ready-to-send aphasia self-report tool for speech-language practitioners and people with aphasia. It helps practitioners collect a broad A-FROM-aligned outcome profile based on the person’s own perspective across life-impact domains.",
		"demoTitle": "Preview a sample ALA administration",
		"demoPrompt": "Interested in using Assessment for Living with Aphasia (ALA) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1195-f-081-lpaa-002-r001-assessment-for-living-with-aphasia-ala.md",
		"specId": "1195-f-081-lpaa-002-r001-assessment-for-living-with-aphasia-ala",
		"tags": {
			"framework": [
				"A-FROM"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Aphasia",
				"Outcome monitoring",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Self-Report Source",
				"body": "The result reflects the person’s own responses, with practitioner interpretation kept separate from reported answers and supported profile summaries."
			},
			{
				"title": "Baseline And Follow-Up",
				"body": "Comparable administrations can be reviewed over time when the same instrument structure supports comparison."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not substitute clinician ratings, add custom domains, create goals automatically, or interpret incomplete responses as complete profiles."
			}
		],
		"faqItems": [
			{
				"question": "Is ALA completed by the practitioner?",
				"answer": "No. ALA is a self-report from the person with aphasia, though the practitioner may provide supported administration when needed."
			},
			{
				"question": "Can partial responses produce a profile?",
				"answer": "Only where the instrument supports partial scoring. Otherwise partial responses remain incomplete."
			},
			{
				"question": "Does assistance change the meaning of responses?",
				"answer": "No. Assistance should support access while preserving that the responses are the person’s own self-report."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and selected administration settings are saved. Sample responses and fictional profile results do not carry into real client data."
			}
		]
	},
	{
		"toolType": "wallQuestion",
		"slug": "wall-question",
		"title": "Wall Question Aphasia Rating | Qwoach",
		"metaDescription": "Use the Wall Question to capture a repeatable patient-defined rating of aphasia’s life impact and compare ratings across sessions.",
		"h1": "Wall Question",
		"intro": "Wall Question is a ready-to-send aphasia life-impact rating tool for speech-language practitioners and people with aphasia. It helps practitioners record the person’s own overall rating and compare it across sessions.",
		"demoTitle": "Try a sample Wall Question rating",
		"demoPrompt": "Interested in using Wall Question with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1196-f-081-lpaa-003-r001-wall-question.md",
		"specId": "1196-f-081-lpaa-003-r001-wall-question",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Aphasia",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Repeat Use",
				"body": "The same life-impact construct can be revisited across sessions so the practitioner can see descriptive change over time."
			},
			{
				"title": "Self-Report Source",
				"body": "The rating is the person’s own judgment; assisted completion must preserve that source."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not explain why ratings changed, produce domain scores, or substitute clinician-rated impact."
			}
		],
		"faqItems": [
			{
				"question": "Is this a broad aphasia assessment?",
				"answer": "No. Wall Question is a single repeatable life-impact rating."
			},
			{
				"question": "Who supplies the rating?",
				"answer": "The person with aphasia supplies the rating, with assistance if needed."
			},
			{
				"question": "What if there is no rating?",
				"answer": "A missing rating remains missing or unable to complete; it is not interpreted as no impact."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The tool itself and selected administration settings are saved. Demo ratings and sample history are not saved as real client data."
			}
		]
	},
	{
		"toolType": "lifeInterestsAndValuesCards",
		"slug": "life-interests-and-values-cards",
		"title": "Life Interests and Values Cards | Qwoach",
		"metaDescription": "Use a card-based aphasia planning tool to identify valued life activities, sort participation priorities, and review shared intervention targets.",
		"h1": "Life Interests and Values Cards",
		"intro": "Life Interests and Values Cards is a collaborative aphasia participation-priority tool for speech-language practitioners and people with aphasia. It helps identify and prioritize valued life activities so therapy conversations can focus on personally meaningful participation.",
		"demoTitle": "Sort sample priority cards",
		"demoPrompt": "Interested in using Life Interests and Values Cards with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1197-f-081-lpaa-004-r001-life-interests-and-values-cards.md",
		"specId": "1197-f-081-lpaa-004-r001-life-interests-and-values-cards",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Aphasia",
				"Values",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Client Roles",
				"body": "The practitioner facilitates the card session; the person with aphasia supplies the values and interests that determine priorities."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures selected or prioritized cards, lower-priority or unresolved status where captured, optional notes, and date or session context."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not infer values from nonselection, score priorities, or automatically generate therapy goals."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create therapy goals automatically?",
				"answer": "No. It produces participation priorities that can inform later goal discussion."
			},
			{
				"question": "Who decides which cards matter most?",
				"answer": "The person with aphasia provides the choices and priorities, with practitioner facilitation as needed."
			},
			{
				"question": "What happens to unsorted cards?",
				"answer": "Unsorted cards remain unresolved and should not be treated as unimportant without confirmation."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The tool itself and selected reusable settings are saved. Sample card choices and fictional notes do not become real client data."
			}
		]
	},
	{
		"toolType": "fourcGoalFormulation",
		"slug": "fourc-goal-formulation",
		"title": "FOURC Goal Formulation | Qwoach",
		"metaDescription": "Build a participation-focused aphasia intervention direction by linking needs, goals, supports, context, and expected outcomes.",
		"h1": "FOURC Goal Formulation",
		"intro": "FOURC Goal Formulation is a collaborative aphasia intervention-planning tool for speech-language practitioners and people with aphasia. It helps them connect needs, goals, supports, contextual factors, and expected outcomes into a participation-focused therapy direction.",
		"demoTitle": "Create a sample formulation",
		"demoPrompt": "Interested in using FOURC Goal Formulation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1198-f-081-lpaa-005-r001-fourc-goal-formulation.md",
		"specId": "1198-f-081-lpaa-005-r001-fourc-goal-formulation",
		"tags": {
			"framework": [
				"A-FROM"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Aphasia",
				"Goals",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Connects",
				"body": "The formulation connects meaningful participation outcomes with needs, goals, supports, contextual factors, and expected outcomes."
			},
			{
				"title": "Shared Planning",
				"body": "The person’s priorities and expected outcomes remain visible while the practitioner adds planning synthesis and clinical direction."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not generate goals automatically, score goal quality, prescribe therapy protocols, or add unsupported FOURC fields."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic goal builder?",
				"answer": "No. FOURC Goal Formulation is a specific participation-focused formulation workflow at the level supported by the FOURC materials."
			},
			{
				"question": "Can it start from an A-FROM-aligned profile?",
				"answer": "Yes. The demo can link sample source context where available, while preserving the same FOURC formulation structure."
			},
			{
				"question": "Does the tool write goals automatically?",
				"answer": "No. Goals are formulated by the practitioner and person with aphasia; the system organizes and links entered content."
			},
			{
				"question": "What is saved?",
				"answer": "The tool itself and selected reusable settings are saved. Fictional goals and temporary demo formulation content do not become real client data."
			}
		]
	},
	{
		"toolType": "communicationEnvironmentMap",
		"slug": "communication-environment-map",
		"title": "Communication Environment Map | Qwoach",
		"metaDescription": "Map aphasia communication partners, settings, supports, and barriers to identify environmental targets linked to participation outcomes.",
		"h1": "Communication Environment Map",
		"intro": "Communication Environment Map is a collaborative aphasia intervention-planning tool for speech-language practitioners and people with aphasia. It helps identify communication partners, settings, supports, and barriers so environmental targets can be selected for participation-focused care.",
		"demoTitle": "Map a sample communication environment",
		"demoPrompt": "Interested in using Communication Environment Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1199-f-081-lpaa-006-r001-communication-environment-map.md",
		"specId": "1199-f-081-lpaa-006-r001-communication-environment-map",
		"tags": {
			"framework": [
				"A-FROM"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Aphasia",
				"Environmental barriers",
				"Social communication"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The map captures communication settings, partners, supports, barriers, participation links, target status, unresolved items, and practitioner notes."
			},
			{
				"title": "Shared Roles",
				"body": "The person with aphasia reports lived communication contexts; the practitioner facilitates mapping and selects clinical targets."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not create partner-training protocols, environmental scores, or automatic intervention scripts."
			}
		],
		"faqItems": [
			{
				"question": "Is this a social network map?",
				"answer": "No. It maps the communication environment for aphasia participation planning, including partners, settings, supports, barriers, and targets."
			},
			{
				"question": "Can one person or setting be both a support and a barrier?",
				"answer": "Yes. The tool should allow context-specific notes when a partner or setting functions differently across situations."
			},
			{
				"question": "Does the map rank targets automatically?",
				"answer": "No. It organizes environmental factors and selected targets but does not add unsupported automatic priority rankings."
			},
			{
				"question": "What carries over after saving?",
				"answer": "The tool itself and selected representation mode are saved. Sample partners, settings, and demo targets do not become real client data."
			}
		]
	},
	{
		"toolType": "participationInLifeSituationsMap",
		"slug": "participation-in-life-situations-map",
		"title": "Participation in Life Situations Map | Qwoach",
		"metaDescription": "Map and prioritize meaningful life situations affected by aphasia for baseline planning, goal discussions, and later outcome review.",
		"h1": "Participation in Life Situations Map",
		"intro": "Participation in Life Situations Map is a collaborative aphasia planning and outcome-orientation tool for speech-language practitioners and people with aphasia. It helps identify affected, important, or desired life situations so intervention can focus on meaningful participation outcomes.",
		"demoTitle": "Create a sample participation map",
		"demoPrompt": "Interested in using Participation in Life Situations Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1200-f-081-lpaa-007-r001-participation-in-life-situations-map.md",
		"specId": "1200-f-081-lpaa-007-r001-participation-in-life-situations-map",
		"tags": {
			"framework": [
				"A-FROM"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Aphasia",
				"Occupational participation",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the map for baseline planning, shared goal discussion, or later review of life-participation changes."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures life situations, priority status, restriction or desired-change notes where supported, unresolved items, date/context, and practitioner synthesis."
			},
			{
				"title": "Relevant Limitations",
				"body": "The tool does not invent life-situation categories, assign scores, create impairment ratings, or generate intervention plans automatically."
			}
		],
		"faqItems": [
			{
				"question": "Is this a generic life inventory?",
				"answer": "No. It is a participation-situation mapping tool for aphasia care."
			},
			{
				"question": "Who identifies the important life situations?",
				"answer": "The person with aphasia identifies relevant life situations from their perspective, with practitioner facilitation as needed."
			},
			{
				"question": "Can it be used for follow-up review?",
				"answer": "Yes. Follow-up review can compare comparable profiles over time when life-situation labels remain stable enough."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool itself and selected reusable settings are saved. Fictional life situations, priorities, and sample history do not become real client data."
			}
		]
	},
	{
		"toolType": "personalIdentityAffectReflection",
		"slug": "personal-identity-affect-reflection",
		"title": "Personal Identity / Affect Reflection Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send aphasia reflection that captures identity-related and affective impact information for care planning and later review.",
		"h1": "Personal Identity / Affect Reflection for Aphasia Care Planning",
		"intro": "Personal Identity / Affect Reflection is a ready-to-send reflection for aphasia care practitioners. It helps the practitioner gather a person's self-described identity concerns, emotional responses, personal meaning, and priorities so those reported experiences can inform clinical formulation.",
		"demoTitle": "Preview the reflection and review view with sample responses",
		"demoPrompt": "Interested in using Personal Identity / Affect Reflection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1201-f-081-lpaa-008-r001-personal-identity-affect-reflection.md",
		"specId": "1201-f-081-lpaa-008-r001-personal-identity-affect-reflection",
		"tags": {
			"framework": [
				"A-FROM"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Aphasia"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during aphasia care planning or review when personal meaning, emotional response, and identity-related priorities need to be visible alongside other clinical information."
			},
			{
				"title": "Longitudinal Use",
				"body": "Multiple reflections can be reviewed over time as separate reported states. The tool supports descriptive comparison without creating a numeric trend or clinical interpretation."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not collect impairment scores, assign affective ratings, make diagnostic conclusions, or generate treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Is this a mood screener?",
				"answer": "No. Personal Identity / Affect Reflection is not a mood screener, diagnostic tool, or affective rating scale. It organizes self-described identity and emotional impact information for aphasia care formulation."
			},
			{
				"question": "Does the person have to answer every prompt?",
				"answer": "No. The reflection should support brief, incomplete, skipped, or partial responses so the person can pause, return, or share what they can."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews reported identity-related concerns, emotional responses, personal meaning, priorities, optional practitioner notes, and prior entries for descriptive comparison."
			},
			{
				"question": "Does saving the demo save sample client responses?",
				"answer": "No. Saving preserves the tool and reusable practitioner setup, not fictional demo responses or temporary sample case content."
			}
		]
	},
	{
		"toolType": "collaborativeParticipationGoalPlan",
		"slug": "collaborative-participation-goal-plan",
		"title": "Collaborative Participation Goal Plan Demo | Qwoach",
		"metaDescription": "Explore a collaborative aphasia goal-setting tool for agreeing on a client-centered participation outcome that guides intervention planning.",
		"h1": "Collaborative Participation Goal Plan for Aphasia Therapy",
		"intro": "Collaborative Participation Goal Plan is a ready-to-complete-together tool for practitioners and people with aphasia. It helps them identify a meaningful life participation priority, draft a shared outcome, confirm understanding, and use the agreed participation goal to guide intervention planning.",
		"demoTitle": "Try the together-mode goal workspace",
		"demoPrompt": "Interested in using Collaborative Participation Goal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1202-f-081-lpaa-009-r001-collaborative-participation-goal-plan.md",
		"specId": "1202-f-081-lpaa-009-r001-collaborative-participation-goal-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Aphasia",
				"Goals",
				"Occupational participation"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Draft Versus Agreed",
				"body": "A goal remains a draft until the practitioner confirms that the person and practitioner share the same understanding. Interrupted sessions should remain draft rather than being forced complete."
			},
			{
				"title": "Practitioner And Client Roles",
				"body": "The person contributes the participation priority and confirms whether the outcome matches their intent. The practitioner facilitates, captures, clarifies, and records planning notes."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not auto-generate substantive participation goals, provide a goal library, assign scores, or create impairment targets."
			}
		],
		"faqItems": [
			{
				"question": "Can this be completed by the client alone?",
				"answer": "No. The specified experience is ready-to-complete-together, with the practitioner facilitating goal drafting and confirmation during collaboration."
			},
			{
				"question": "When is a goal considered agreed?",
				"answer": "A goal is agreed only when the practitioner confirms shared understanding with the person. Otherwise it remains a draft."
			},
			{
				"question": "Does the tool generate the participation goal automatically?",
				"answer": "No. The tool may organize entered content, but substantive goal wording must be entered, edited, or confirmed by the practitioner and person."
			},
			{
				"question": "What happens if the person changes their priority later?",
				"answer": "The prior agreed outcome should remain in history, and a revised outcome should be created or clearly shown as changed."
			}
		]
	},
	{
		"toolType": "participationBaselineTask",
		"slug": "participation-baseline-task",
		"title": "Participation Baseline Task Demo | Qwoach",
		"metaDescription": "Explore a goal-linked aphasia baseline task that captures current participation performance before intervention for later comparison.",
		"h1": "Participation Baseline Task for Aphasia Intervention",
		"intro": "Participation Baseline Task is a ready-to-complete-together tool for aphasia practitioners. It helps them link a baseline to an individualized participation goal, record the activity context and observed performance before intervention, and preserve that baseline for later reassessment.",
		"demoTitle": "Try a sample goal-linked baseline",
		"demoPrompt": "Interested in using Participation Baseline Task with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1203-f-081-lpaa-010-r001-participation-baseline-task.md",
		"specId": "1203-f-081-lpaa-010-r001-participation-baseline-task",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Aphasia",
				"Occupational participation",
				"Outcome monitoring"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Goal Link Required",
				"body": "A baseline cannot be finalized without a linked participation goal because its meaning depends on comparison to that specific participation target."
			},
			{
				"title": "Later Comparison",
				"body": "The baseline persists as chronological pre-intervention evidence and can be opened alongside reassessment results later."
			},
			{
				"title": "Important Boundary",
				"body": "The tool captures descriptive current performance. It does not infer clinical significance, define unsupported scoring, or replace practitioner judgment about functional demands."
			}
		],
		"faqItems": [
			{
				"question": "Can I create a baseline without a participation goal?",
				"answer": "No. The baseline must be linked to an individualized participation goal before it can be finalized."
			},
			{
				"question": "Does this tool score performance?",
				"answer": "No. The product specification supports descriptive baseline capture, not unsupported standardized scoring or automatic conclusions."
			},
			{
				"question": "What happens if the task is only partly completed?",
				"answer": "A partial baseline attempt should be retained and marked partial or incomplete rather than discarded or treated as complete."
			},
			{
				"question": "What carries over when I save the demo?",
				"answer": "The tool itself and reusable setup choices carry over. Fictional sample baseline records and temporary demo observations do not become real client data."
			}
		]
	},
	{
		"toolType": "lpaaReassessmentLifeParticipationReview",
		"slug": "lpaa-reassessment-life-participation-review",
		"title": "LPAA Reassessment Review Demo | Qwoach",
		"metaDescription": "Explore a longitudinal aphasia reassessment tool that compares current life participation outcomes with prior priorities and baselines.",
		"h1": "LPAA Reassessment and Life Participation Review",
		"intro": "LPAA Reassessment / Life Participation Review is a ready-to-complete-together tool for aphasia practitioners. It helps them compare current meaningful-life participation information with earlier priorities, goals, and baselines so they can document whether goals should continue, be revised, or be replaced.",
		"demoTitle": "Open a sample longitudinal review",
		"demoPrompt": "Interested in using LPAA Reassessment / Life Participation Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1204-f-081-lpaa-011-r001-lpaa-reassessment-life-participation-review.md",
		"specId": "1204-f-081-lpaa-011-r001-lpaa-reassessment-life-participation-review",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Aphasia",
				"Occupational participation",
				"Outcome monitoring"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Anchored Review",
				"body": "A complete longitudinal comparison depends on prior priorities, goals, or baselines. If anchor information is missing, the current review can be captured but should not be presented as a complete longitudinal comparison."
			},
			{
				"title": "Continue, Revise, Or Replace",
				"body": "The practitioner records whether current goals continue, are revised, or are replaced. This direction remains distinct from client-reported outcomes and descriptive comparison."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not create impairment-only progress summaries, unsupported scores, automated outcome significance, or treatment recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can the tool complete a longitudinal comparison without prior information?",
				"answer": "No. It may capture a current review, but a complete longitudinal comparison requires selected prior priority, goal, or baseline information."
			},
			{
				"question": "Does the tool decide whether a goal should change?",
				"answer": "No. The practitioner records continue, revise, or replace; the system does not automatically decide clinical next steps."
			},
			{
				"question": "What does the client do in this review?",
				"answer": "The client contributes current real-life participation experience during a practitioner-facilitated review, using accessible participation as appropriate."
			},
			{
				"question": "Does saving the demo preserve sample reassessment data?",
				"answer": "No. Saving preserves the tool itself and reusable setup choices, not fictional sample review content or temporary case data."
			}
		]
	},
	{
		"toolType": "supportedConversationForAdultsWithAphasiaSca",
		"slug": "supported-conversation-for-adults-with-aphasia-sca",
		"title": "Supported Conversation for Adults with Aphasia Demo | Qwoach",
		"metaDescription": "Explore a live aphasia conversation support that captures confirmed messages, supports used, and unresolved uncertainty when helpful.",
		"h1": "Supported Conversation for Adults with Aphasia Live Support",
		"intro": "Supported Conversation for Adults with Aphasia (SCA) is a live together-use support for practitioners, communication partners, and adults with aphasia. It helps make conversation accessible, capture confirmed messages or decisions when useful, and keep unresolved meaning visibly separate from practitioner inference.",
		"demoTitle": "Try a sample live conversation support workspace",
		"demoPrompt": "Interested in using Supported Conversation for Adults with Aphasia (SCA) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1205-f-082-sca-001-r001-supported-conversation-for-adults-with-aphasia-sca.md",
		"specId": "1205-f-082-sca-001-r001-supported-conversation-for-adults-with-aphasia-sca",
		"tags": {
			"framework": [],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Aphasia",
				"Social communication"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Live Method, Optional Artifact",
				"body": "The product value occurs during interaction. A persistent artifact is optional and meaningful only when confirmed messages, decisions, or supports should inform future communication."
			},
			{
				"title": "Confirmed Versus Inferred",
				"body": "Confirmed meaning must remain distinct from practitioner inference. Ambiguous responses should stay unresolved."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not teach a full curriculum, certify competence, collect language scores, or overinterpret unclear responses."
			}
		],
		"faqItems": [
			{
				"question": "Is this a form for the client to complete?",
				"answer": "No. The client experience is the supported live conversation, not a standalone form or questionnaire."
			},
			{
				"question": "Does every use create a saved artifact?",
				"answer": "No. No artifact is required when the interaction succeeds without documentation. Captured results are optional when confirmed messages or supports should be retained."
			},
			{
				"question": "Can ambiguous responses be marked confirmed?",
				"answer": "No. Ambiguous responses must remain unresolved until sufficiently clarified through the interaction."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The tool itself and any reusable setup choices are saved. Fictional conversation content and demo interaction notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "writtenKeywordSupport",
		"slug": "written-keyword-support",
		"title": "Written Keyword Support Demo | Qwoach",
		"metaDescription": "Explore a live aphasia conversation support that uses large written keywords to clarify options, choices, and confirmed meaning.",
		"h1": "Written Keyword Support for Aphasia Conversations",
		"intro": "Written Keyword Support is a ready-to-complete-together tool for practitioners, communication partners, and people with aphasia. It helps turn key spoken ideas, options, or decisions into written words so the person can understand the exchange and communicate meaning more accurately.",
		"demoTitle": "Try a live keyword board",
		"demoPrompt": "Interested in using Written Keyword Support with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1206-f-082-sca-002-r001-written-keyword-support.md",
		"specId": "1206-f-082-sca-002-r001-written-keyword-support",
		"tags": {
			"framework": [],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Aphasia",
				"Social communication"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Low-Clutter Display",
				"body": "The active display should show only currently relevant words or options because too many keywords can increase cognitive load."
			},
			{
				"title": "Confirmed Meaning",
				"body": "Keyword supports may reveal choices or meanings, but unclear responses should not be treated as confirmed."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not a reading test, full note-taking tool, or generic worksheet. It supports key concepts and choices during conversation."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool assess reading comprehension?",
				"answer": "No. Written Keyword Support is a conversation support, not a literacy score or reading comprehension assessment."
			},
			{
				"question": "Can the keyword list be edited during conversation?",
				"answer": "Yes. The practitioner should be able to create, edit, narrow, or clear keywords as the exchange unfolds."
			},
			{
				"question": "What happens if the person cannot use written words?",
				"answer": "The exchange should remain unresolved or shift to another support outside this tool rather than forcing a response."
			},
			{
				"question": "Are demo keyword responses saved as client data?",
				"answer": "No. Saving keeps the tool and reusable setup choices, not fictional keyword responses or temporary demo content."
			}
		]
	},
	{
		"toolType": "gestureBodyLanguageSupport",
		"slug": "gesture-body-language-support",
		"title": "Gesture / Body Language Support Demo | Qwoach",
		"metaDescription": "Explore a live-session aphasia communication support for using gesture and body-language cues while keeping ambiguity visible.",
		"h1": "Gesture and Body Language Support for Aphasia Conversations",
		"intro": "Gesture / Body Language Support is a live-session-only tool for practitioners, communication partners, and people with aphasia. It helps the interaction include gesture and body-language cues so meaning, preference, understanding, or breakdown can be conveyed in the moment when speech or writing alone is not enough.",
		"demoTitle": "Preview the live support surface",
		"demoPrompt": "Interested in using Gesture / Body Language Support with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1207-f-082-sca-003-r001-gesture-body-language-support.md",
		"specId": "1207-f-082-sca-003-r001-gesture-body-language-support",
		"tags": {
			"framework": [],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Aphasia",
				"Social communication"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "No Inherent Artifact",
				"body": "The product can be used entirely in live interaction. Documentation is optional and should not be required to complete the interaction."
			},
			{
				"title": "Ambiguity Stays Visible",
				"body": "Ambiguous cues must not be converted into confirmed meaning. No response should not be treated as refusal or lack of preference."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not standardize gesture meanings, assign scores, or require a checklist of gestures."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create a required session record?",
				"answer": "No. Gesture / Body Language Support has no inherent artifact. Optional documentation may be saved only when useful."
			},
			{
				"question": "Is there a separate client form?",
				"answer": "No. The client experience is the live interaction, not a form or product-operated task."
			},
			{
				"question": "Can the tool interpret a gesture automatically?",
				"answer": "No. The tool must not assign universal meanings or interpret ambiguous cues automatically."
			},
			{
				"question": "What is saved for a fixed live-session tool?",
				"answer": "The tool itself is saved as-is. Fictional demo notes and temporary cue examples are not saved as real client data."
			}
		]
	},
	{
		"toolType": "handDrawingSupport",
		"slug": "hand-drawing-support",
		"title": "Hand Drawing Support Demo | Qwoach",
		"metaDescription": "Explore a shared drawing support for aphasia conversations that helps clarify specific messages without inferring meaning automatically.",
		"h1": "Hand Drawing Support for Aphasia Conversations",
		"intro": "Hand Drawing Support is a ready-to-complete-together drawing surface for practitioners, communication partners, and people with aphasia. It helps create a shared visual representation so a message that is difficult to communicate through speech or writing can be confirmed, rejected, elaborated, or left unresolved.",
		"demoTitle": "Open the shared drawing surface",
		"demoPrompt": "Interested in using Hand Drawing Support with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1208-f-082-sca-004-r001-hand-drawing-support.md",
		"specId": "1208-f-082-sca-004-r001-hand-drawing-support",
		"tags": {
			"framework": [],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Aphasia",
				"Social communication"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Simple Canvas",
				"body": "The drawing surface should remain uncluttered with minimal controls such as draw, erase, clear, undo if available, and optional labeling or confirmation."
			},
			{
				"title": "Meaning Requires Confirmation",
				"body": "A saved drawing should not be treated as confirmed meaning unless the person confirms, rejects, or elaborates in a way the practitioner can rely on."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not an art tool, symbol library, generic whiteboard, drawing quality measure, or visual-cognitive assessment."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool interpret the drawing for the practitioner?",
				"answer": "No. The system does not analyze drawings or infer meaning automatically."
			},
			{
				"question": "Does every drawing need to be saved?",
				"answer": "No. The artifact can be saved when it clarifies a relevant message, but saving is optional unless continuity requires it."
			},
			{
				"question": "Can the person with aphasia interact with the drawing?",
				"answer": "Yes. The person may draw, point, confirm, reject, elaborate, or otherwise respond to the visual representation."
			},
			{
				"question": "Are demo drawings saved as real client records?",
				"answer": "No. Saving preserves the tool and reusable setup choices, not fictional demo drawings or temporary sample messages."
			}
		]
	},
	{
		"toolType": "participicsPictographicSupport",
		"slug": "participics-pictographic-support",
		"title": "ParticiPics Pictographic Support Demo | Qwoach",
		"metaDescription": "Explore a pictographic aphasia conversation support for selecting visual options, capturing indicated responses, and preserving uncertainty.",
		"h1": "ParticiPics Pictographic Support for Aphasia Conversations",
		"intro": "ParticiPics Pictographic Support is a ready-to-complete-together tool for practitioners, communication partners, and people with aphasia. It helps the practitioner find relevant pictographic options, present a small visual set, and capture the person's indicated choice, preference, or message when language alone is not enough.",
		"demoTitle": "Try a sample pictographic choice surface",
		"demoPrompt": "Interested in using ParticiPics Pictographic Support with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1209-f-082-sca-005-r001-participics-pictographic-support.md",
		"specId": "1209-f-082-sca-005-r001-participics-pictographic-support",
		"tags": {
			"framework": [],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Aphasia",
				"Social communication"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Option Set Matters",
				"body": "Historical or review value depends on preserving the option set shown, not only the final indicated choice."
			},
			{
				"title": "When Options Do Not Fit",
				"body": "If no suitable pictograph matches the topic closely enough, the interaction should remain unresolved or shift to another support rather than forcing a selection."
			},
			{
				"title": "Important Boundary",
				"body": "The tool is not generic image search or assessment. It supports conversation-specific understanding, choice-making, and message expression."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool infer meaning from an image selection?",
				"answer": "No. The tool records selected options and indicated responses, but unclear selections must remain unconfirmed until verified."
			},
			{
				"question": "Can too many pictographs be shown at once?",
				"answer": "Yes. Too many options may overload the interaction, so the display should support narrowing to a small relevant set."
			},
			{
				"question": "What is preserved in a saved result?",
				"answer": "A saved result should preserve the pictographic option set, the indicated response or message, topic context, and uncertainty when present."
			},
			{
				"question": "Does saving the demo preserve sample image choices as real client data?",
				"answer": "No. Saving keeps the tool and reusable setup choices, not fictional demo selections or temporary conversation content."
			}
		]
	},
	{
		"toolType": "messageVerificationYesNoConfirmation",
		"slug": "message-verification-yes-no-confirmation",
		"title": "Message Verification / Yes-No Confirmation Demo | Qwoach",
		"metaDescription": "Explore an aphasia message verification aid that checks tentative interpretations with accessible yes/no or equivalent responses.",
		"h1": "Message Verification and Yes-No Confirmation for Aphasia",
		"intro": "Message Verification / Yes-No Confirmation is a ready-to-complete-together tool for practitioners, communication partners, and people with aphasia. It helps check a tentative message or decision through an accessible yes/no or equivalent response mode so confirmed meaning stays separate from practitioner inference.",
		"demoTitle": "Try a sample verification flow",
		"demoPrompt": "Interested in using Message Verification / Yes-No Confirmation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1210-f-082-sca-006-r001-message-verification-yes-no-confirmation.md",
		"specId": "1210-f-082-sca-006-r001-message-verification-yes-no-confirmation",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"In-session support",
				"Assessment"
			],
			"topic": [
				"Aphasia",
				"Social communication"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Confirmed Or Unresolved",
				"body": "Verification starts from a tentative interpretation and ends as confirmed or unresolved. Inconsistent responses must prevent confirmation."
			},
			{
				"title": "Response Mode",
				"body": "The response mode should match what the person can access reliably. If the mode does not work, the practitioner can switch modes and keep earlier responses visibly distinct."
			},
			{
				"title": "Important Boundary",
				"body": "The tool does not assign competence labels, create unsupported confidence scores, or confirm decisions that were not checked with the person."
			}
		],
		"faqItems": [
			{
				"question": "Can inconsistent responses be marked as confirmed?",
				"answer": "No. Inconsistent responses must prevent confirmation and leave the verification unresolved."
			},
			{
				"question": "What counts as a response mode?",
				"answer": "A response mode is the accessible way the person answers, such as yes/no, pointing, gesture, tapping, or another equivalent format supported by the implementation."
			},
			{
				"question": "Does the tool decide the person's meaning automatically?",
				"answer": "No. The system organizes the verification record and status, but it does not decide meaning beyond the entered and confirmed exchange."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The tool itself and reusable configuration such as preferred response mode may be saved. Fictional messages and sample response sequences are not saved as real client data."
			}
		]
	},
	{
		"toolType": "communicationAccessTopicSheet",
		"slug": "communication-access-topic-sheet",
		"title": "Communication Access Topic Sheet Demo | Qwoach",
		"metaDescription": "Capture priority topics for accessible aphasia conversations using a reusable sheet with keywords, drawings, or pictograph-supported notes.",
		"h1": "Communication Access Topic Sheet for Aphasia Conversations",
		"intro": "The Communication Access Topic Sheet is a preparation aid for practitioners and communication-support providers working with people with aphasia. It helps capture priority conversation topics and content areas so future interactions can be more accessible, relevant, and person-centered.",
		"demoTitle": "Try a sample topic sheet",
		"demoPrompt": "Interested in using Communication Access Topic Sheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1211-f-082-sca-007-r001-communication-access-topic-sheet.md",
		"specId": "1211-f-082-sca-007-r001-communication-access-topic-sheet",
		"tags": {
			"framework": [
				"SCA"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Session preparation"
			],
			"topic": [
				"Aphasia",
				"Social communication"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the sheet before an upcoming supported conversation or when building general communication access information that partners can revisit."
			},
			{
				"title": "What It Captures",
				"body": "The sheet captures reported topics, specific content notes, accessible keywords or representations, source when known, and completion state."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not assess aphasia severity, infer topic importance, generate unsupported topic categories, or create a communication board."
			}
		],
		"faqItems": [
			{
				"question": "Is this an aphasia assessment?",
				"answer": "No. It is a topic preparation sheet for accessible conversations, not a diagnostic or severity assessment."
			},
			{
				"question": "Can the person with aphasia contribute directly?",
				"answer": "Yes. A person-facing contribution view may be used for simple topic/content entry, with support as needed."
			},
			{
				"question": "What happens to sample demo topics when I save?",
				"answer": "Sample demo topics are not saved as real client data. Saving keeps the tool and reusable setup choices."
			}
		]
	},
	{
		"toolType": "measureOfSkillInSupportedConversationMsc",
		"slug": "measure-of-skill-in-supported-conversation-msc",
		"title": "MSC Supported Conversation Skill Profile Demo | Qwoach",
		"metaDescription": "Evaluate observed communication-partner support skills with an MSC workflow for practitioner scoring, profile review, and change monitoring.",
		"h1": "Measure of Skill in Supported Conversation (MSC)",
		"intro": "The Measure of Skill in Supported Conversation is a practitioner-only observational rating tool for evaluating how effectively a communication partner supports conversation with a person with aphasia. It helps practitioners create a standardized partner-support skill profile for identifying training targets and monitoring change.",
		"demoTitle": "Preview the MSC workflow",
		"demoPrompt": "Interested in using Measure of Skill in Supported Conversation (MSC) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1212-f-082-sca-008-r001-measure-of-skill-in-supported-conversation-msc.md",
		"specId": "1212-f-082-sca-008-r001-measure-of-skill-in-supported-conversation-msc",
		"tags": {
			"framework": [
				"SCA"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Aphasia",
				"Social communication",
				"Outcome monitoring"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "What It Measures",
				"body": "MSC evaluates the communication partner's supported-conversation skill based on observable behavior during a conversation."
			},
			{
				"title": "Longitudinal Use",
				"body": "Repeated comparable administrations can monitor partner skill change after training or practice."
			},
			{
				"title": "Important Limits",
				"body": "The tool must not invent MSC items, anchors, cutoffs, score rules, or training recommendations. Notes alone are not standardized MSC results."
			}
		],
		"faqItems": [
			{
				"question": "Can a partner complete MSC themselves?",
				"answer": "No. The supplied product experience is practitioner-only observational scoring."
			},
			{
				"question": "Can the demo calculate an MSC score?",
				"answer": "No. Standardized scoring requires official MSC item, anchor, and scoring content, which is unresolved in the supplied specification."
			},
			{
				"question": "What is saved if there are no settings?",
				"answer": "The MSC tool itself is saved as-is, even though no practitioner settings are defined."
			}
		]
	},
	{
		"toolType": "measureOfParticipationInConversationMpc",
		"slug": "measure-of-participation-in-conversation-mpc",
		"title": "MPC Conversational Participation Profile Demo | Qwoach",
		"metaDescription": "Preview an MPC workflow for practitioner-only observation, participation profile review, and comparison across time or support conditions.",
		"h1": "Measure of Participation in Conversation (MPC)",
		"intro": "The Measure of Participation in Conversation is a practitioner-only observational tool for evaluating how fully a person with aphasia participates in conversation with a communication partner. It helps practitioners create a standardized participation profile for support planning and comparison over time or across partner-support conditions.",
		"demoTitle": "Preview the MPC workflow",
		"demoPrompt": "Interested in using Measure of Participation in Conversation (MPC) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1213-f-082-sca-009-r001-measure-of-participation-in-conversation-mpc.md",
		"specId": "1213-f-082-sca-009-r001-measure-of-participation-in-conversation-mpc",
		"tags": {
			"framework": [
				"SCA"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Aphasia",
				"Social communication",
				"Outcome monitoring"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "What It Profiles",
				"body": "MPC profiles participation by the person with aphasia in an observed conversation, not the communication partner's skill."
			},
			{
				"title": "Comparison Use",
				"body": "Comparable administrations can be reviewed over time or across partner-support conditions when the same scoring structure is used."
			},
			{
				"title": "Important Limits",
				"body": "The tool must not invent MPC items, anchors, scoring calculations, thresholds, or clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Is MPC the same as MSC?",
				"answer": "No. MPC profiles the person with aphasia's participation; MSC profiles the communication partner's support skill."
			},
			{
				"question": "Can the person with aphasia complete the MPC?",
				"answer": "No. The supplied MPC product experience is practitioner-only observational scoring."
			},
			{
				"question": "Can notes alone create an MPC profile?",
				"answer": "No. Notes without official ratings do not constitute a standardized MPC profile."
			}
		]
	},
	{
		"toolType": "mscMpcConversationSample",
		"slug": "msc-mpc-conversation-sample",
		"title": "MSC/MPC Conversation Sample Demo | Qwoach",
		"metaDescription": "Capture a representative aphasia conversation sample with role labels, context, notes, and readiness for MSC or MPC scoring.",
		"h1": "MSC/MPC Conversation Sample",
		"intro": "The MSC/MPC Conversation Sample is a structured evidence collection tool for practitioners observing a person with aphasia and a communication partner. It helps capture a representative exchange so later MSC and MPC interpretation can consider both partner support and participant involvement.",
		"demoTitle": "Start a sample record",
		"demoPrompt": "Interested in using MSC/MPC Conversation Sample with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1214-f-082-sca-010-r001-msc-mpc-conversation-sample.md",
		"specId": "1214-f-082-sca-010-r001-msc-mpc-conversation-sample",
		"tags": {
			"framework": [
				"SCA"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Aphasia",
				"Social communication"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Sample First, Scoring Later",
				"body": "The conversation sample preserves evidence for later MSC or MPC scoring; it does not replace either measure."
			},
			{
				"title": "What It Captures",
				"body": "The record captures roles, context, capture status, practitioner notes, and readiness for paired scoring."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not prescribe sample length, prompts, topic sequence, scoring items, automated interpretation, or clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score MSC or MPC?",
				"answer": "No. It captures the conversation sample used as evidence; MSC and MPC scoring occur in their own workflows."
			},
			{
				"question": "Do participants complete ratings?",
				"answer": "No. Participants take part in the conversation sample, while the practitioner controls notes and scoring linkage."
			},
			{
				"question": "Can an interrupted sample be saved?",
				"answer": "Yes. Interrupted samples can remain partial and should not be marked ready for paired scoring until enough interaction is captured."
			}
		]
	},
	{
		"toolType": "measureOfSupportedConversationBehaviorChangeMscbc",
		"slug": "measure-of-supported-conversation-behavior-change-mscbc",
		"title": "MSCBC Therapy-Session Skill Profile Demo | Qwoach",
		"metaDescription": "Preview a practitioner-only MSCBC workflow for observing therapist interaction and behavior-change skills in aphasia therapy sessions.",
		"h1": "Measure of Supported Conversation & Behavior Change (MSCBC)",
		"intro": "The Measure of Supported Conversation & Behavior Change is a practitioner-only observational tool for evaluating a therapist's supported-interaction and behavior-change skills during therapy with a person with aphasia. It helps evaluators create a structured skill profile for feedback, coaching, or longitudinal clinician development.",
		"demoTitle": "Preview the MSCBC workflow",
		"demoPrompt": "Interested in using Measure of Supported Conversation & Behavior Change (MSCBC) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1215-f-082-sca-011-r001-measure-of-supported-conversation-behavior-change-mscbc.md",
		"specId": "1215-f-082-sca-011-r001-measure-of-supported-conversation-behavior-change-mscbc",
		"tags": {
			"framework": [
				"SCA"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Aphasia",
				"Social communication",
				"Behavior change"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Therapy-Session Focus",
				"body": "MSCBC focuses on therapist interaction and behavior-change skills in therapy sessions, not communication-partner MSC scoring."
			},
			{
				"title": "Feedback Use",
				"body": "The profile can guide feedback or coaching when based on completed official ratings and observable behavior notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide competency certification, employment judgment, therapy outcome claims, or invented behavior-change categories."
			}
		],
		"faqItems": [
			{
				"question": "Is MSCBC for the therapist to self-rate?",
				"answer": "No. The supplied product experience is practitioner-only observational evaluation."
			},
			{
				"question": "Can the demo generate a complete MSCBC profile?",
				"answer": "No. A complete standardized profile requires official MSCBC items, anchors, and scoring rules."
			},
			{
				"question": "Is MSCBC the same as MSC?",
				"answer": "No. MSCBC is focused on therapist behavior in therapy-session contexts; MSC is for communication partner support skill."
			}
		]
	},
	{
		"toolType": "scaWorkplaceImplementationPlan",
		"slug": "sca-workplace-implementation-plan",
		"title": "SCA Workplace Implementation Plan Demo | Qwoach",
		"metaDescription": "Create a service-level plan for supported communication practices with roles, training needs, implementation steps, and monitoring points.",
		"h1": "SCA Workplace Implementation Plan",
		"intro": "The SCA Workplace Implementation Plan is a practitioner-only planning tool for service leads and implementation leads improving aphasia communication access across a workplace or service setting. It helps organize roles, training needs, implementation steps, and monitoring points so supported communication practices can become part of routine care.",
		"demoTitle": "Build a sample plan",
		"demoPrompt": "Interested in using SCA Workplace Implementation Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1216-f-082-sca-012-r001-sca-workplace-implementation-plan.md",
		"specId": "1216-f-082-sca-012-r001-sca-workplace-implementation-plan",
		"tags": {
			"framework": [
				"SCA"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Aphasia",
				"Service monitoring"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Service-Level Scope",
				"body": "The plan is for workplace or service routines, roles, training needs, and monitoring, not isolated individual-session techniques."
			},
			{
				"title": "Monitoring Over Time",
				"body": "Monitoring points identify intended access changes that can be revisited as the service implements supported communication practices."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not supply a training curriculum, service-quality score, implementation framework, or unsupported service metrics."
			}
		],
		"faqItems": [
			{
				"question": "Is this a project management board?",
				"answer": "No. It is a bounded SCA workplace implementation plan focused on access priorities, roles, training needs, steps, and monitoring points."
			},
			{
				"question": "Does the plan require client input?",
				"answer": "No. The supplied product experience is practitioner-only and service-level."
			},
			{
				"question": "What if the plan only lists individual clinician techniques?",
				"answer": "It should be flagged as not addressing the supported service-level scope."
			}
		]
	},
	{
		"toolType": "conversationPartnerGoalFeedbackPlan",
		"slug": "conversation-partner-goal-feedback-plan",
		"title": "Conversation Partner Feedback Plan Demo | Qwoach",
		"metaDescription": "Create observable partner skill targets and feedback points for supported conversation with a person with aphasia, with progress review.",
		"h1": "Conversation Partner Goal & Feedback Plan",
		"intro": "The Conversation Partner Goal & Feedback Plan is a partner-training tool for practitioners working with communication partners of people with aphasia. It helps define observable partner skill targets and specific feedback points so partners know what to continue or change to better support participation.",
		"demoTitle": "Create a sample feedback plan",
		"demoPrompt": "Interested in using Conversation Partner Goal & Feedback Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1217-f-082-sca-013-r001-conversation-partner-goal-feedback-plan.md",
		"specId": "1217-f-082-sca-013-r001-conversation-partner-goal-feedback-plan",
		"tags": {
			"framework": [
				"SCA"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Progress review"
			],
			"topic": [
				"Aphasia",
				"Social communication",
				"Behavior change"
			],
			"population": [
				"Adults"
			]
		},
		"sections": [
			{
				"title": "Practitioner and Partner Roles",
				"body": "The practitioner defines targets and feedback; the partner reviews the behaviors to continue or change and may add reflection only if supported."
			},
			{
				"title": "Evidence and Progress",
				"body": "Targets can be based on practitioner observation or linked MSC/MPC evidence when available. Progress requires follow-up observation or supported measure data."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not invent partner-skill taxonomies, feedback scripts, practice steps, progress scales, or automatic participation-change interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Can the partner see the plan?",
				"answer": "Yes. A partner-facing view can show targets and feedback points relevant to their behavior."
			},
			{
				"question": "Does the plan require MSC or MPC results?",
				"answer": "No. Targets may come from practitioner observation, with optional MSC/MPC linkage when available."
			},
			{
				"question": "Can progress be inferred automatically?",
				"answer": "No. Progress requires follow-up observation or supported measure data."
			}
		]
	},
	{
		"toolType": "socialFrameworkProfile",
		"slug": "social-framework-profile",
		"title": "SoCIAL Framework Profile Demo | Qwoach",
		"metaDescription": "Map social communication needs across skills, contextual demands, environment, and identity to support assessment interpretation.",
		"h1": "SoCIAL Framework Profile",
		"intro": "The SoCIAL Framework Profile is a collaborative formulation tool for practitioners assessing social communication. It helps organize information about skills, contextual demands, environment, and identity so assessment interpretation and intervention planning can fit the person's real social-communication life.",
		"demoTitle": "Explore a sample profile",
		"demoPrompt": "Interested in using SoCIAL Framework Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1218-f-083-spci-001-r001-social-framework-profile.md",
		"specId": "1218-f-083-spci-001-r001-social-framework-profile",
		"tags": {
			"framework": [
				"SoCIAL framework"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Social communication",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Four-Domain Structure",
				"body": "The profile keeps skills, contextual demands, environment, and identity visible as distinct parts of the formulation."
			},
			{
				"title": "Collaborative Entry",
				"body": "Client contribution can be used for lived-context and identity-related information the person chooses to share, with the option to skip sensitive items."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not provide standardized ratings, severity scores, diagnostic labels, fixed identity categories, or automatic intervention recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the profile force identity labels?",
				"answer": "No. Identity-related information is optional and should reflect what the person chooses to share."
			},
			{
				"question": "Is this a diagnostic instrument?",
				"answer": "No. It is a formulation and mapping tool for assessment interpretation and intervention planning."
			},
			{
				"question": "Can clients contribute information?",
				"answer": "Yes. A collaborative contribution view may gather high-level lived-context information, while the practitioner controls the final formulation."
			}
		]
	},
	{
		"toolType": "contextualCommunicationNeedsMap",
		"slug": "contextual-communication-needs-map",
		"title": "Contextual Communication Needs Map Demo | Qwoach",
		"metaDescription": "Prioritize real-world communication contexts and separate environmental demands from skill considerations for planning.",
		"h1": "Contextual Communication Needs Map",
		"intro": "The Contextual Communication Needs Map is a collaborative mapping tool for practitioners working with social-pragmatic communication needs. It helps identify and prioritize real-world communication contexts, needs within those contexts, and the distinction between contextual or environmental demands and underlying skill considerations.",
		"demoTitle": "Map sample contexts",
		"demoPrompt": "Interested in using Contextual Communication Needs Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1219-f-083-spci-002-r001-contextual-communication-needs-map.md",
		"specId": "1219-f-083-spci-002-r001-contextual-communication-needs-map",
		"tags": {
			"framework": [
				"SoCIAL framework"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Social communication",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Real Contexts First",
				"body": "Entries should name specific environments and routines rather than broad or generic communication categories."
			},
			{
				"title": "Demand Versus Skill",
				"body": "The map distinguishes contextual or environmental demands from underlying communication skill considerations when the practitioner has evidence to support the label."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not include fixed context lists, demand ratings, priority formulas, diagnostic conclusions, or automatic intervention recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the map use a scoring scale?",
				"answer": "No. The supplied product uses manual practitioner prioritization rather than a formal score or priority algorithm."
			},
			{
				"question": "Can the person contribute contexts?",
				"answer": "Yes. A collaborative view may let the person name important communication situations in their own environments and routines."
			},
			{
				"question": "What makes a map incomplete?",
				"answer": "A map is incomplete for planning if contexts lack real environment/routine specificity or have not been prioritized."
			}
		]
	},
	{
		"toolType": "sugarSamplingUtterancesAndGrammaticalAnalysisRevised",
		"slug": "sugar-sampling-utterances-and-grammatical-analysis-revised",
		"title": "SUGAR Language Sample Analysis Demo | Qwoach",
		"metaDescription": "Collect and analyze a 50-utterance child conversational language sample with SUGAR transcription, measures, norms, and target cues.",
		"h1": "SUGAR: Sampling Utterances and Grammatical Analysis Revised",
		"intro": "SUGAR: Sampling Utterances and Grammatical Analysis Revised is a clinician-administered language sample analysis method for speech-language pathologists assessing or reassessing children with possible language impairment. It helps SLPs collect, transcribe, quantitatively analyze, and interpret a 50-utterance conversational sample using SUGAR procedures, norms, and sub-analysis forms.",
		"demoTitle": "Preview a SUGAR analysis",
		"demoPrompt": "Interested in using SUGAR: Sampling Utterances and Grammatical Analysis Revised with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1220-f-083-spci-003-r001-sugar-sampling-utterances-and-grammatical-analysis-revised.md",
		"specId": "1220-f-083-spci-003-r001-sugar-sampling-utterances-and-grammatical-analysis-revised",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Developmental functioning",
				"Social communication"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "50-Utterance Basis",
				"body": "The intended SUGAR profile requires a sufficient 50-utterance conversational sample. Fewer than 50 utterances remains insufficient for the intended profile."
			},
			{
				"title": "Transcript-Driven Analysis",
				"body": "Measures and sub-analysis depend on the transcript and SUGAR scoring inputs. Transcript edits require recalculation."
			},
			{
				"title": "Reassessment",
				"body": "Repeated SUGAR samples can remain separate but comparable when prior transcripts, measures, and reference choices are preserved."
			},
			{
				"title": "Important Limits",
				"body": "The workflow does not replace clinician judgment and must not invent SUGAR procedures, norms, measures, formulas, target rules, or diagnostic thresholds."
			}
		],
		"faqItems": [
			{
				"question": "How many utterances are needed for the intended SUGAR profile?",
				"answer": "A 50-utterance conversational sample is required for the intended SUGAR profile described in the product specification."
			},
			{
				"question": "Does the child complete anything in the product?",
				"answer": "No. The child provides authentic conversational language during sampling, while the SLP administers the workflow."
			},
			{
				"question": "Can the tool compare reassessments?",
				"answer": "Yes. Reassessment comparison is supported when prior transcript, measures, and reference basis are preserved."
			},
			{
				"question": "Are target cues generated without a transcript?",
				"answer": "No. Target cues must be grounded in the child's actual conversational output and supported SUGAR forms."
			}
		]
	},
	{
		"toolType": "pragmaticRatingScaleSchoolAgePrsSa",
		"slug": "pragmatic-rating-scale-school-age-prs-sa",
		"title": "PRS-SA Pragmatic Language Rating Demo | Qwoach",
		"metaDescription": "Explore a PRS-SA demo for trained observer coding of school-age pragmatic language from conversational video samples.",
		"h1": "Pragmatic Rating Scale-School Age (PRS-SA)",
		"intro": "Pragmatic Rating Scale-School Age (PRS-SA) is a trained observer behavioral rating system for speech-language pathology, psychology, autism, and neurodevelopmental assessment practitioners. It helps trained raters code school-age pragmatic-language behaviors from semi-naturalistic conversational videos and review item ratings, domain scores, and a total pragmatic-violation score.",
		"demoTitle": "Open the sample coding record and review how ratings become a domain score profile.",
		"demoPrompt": "Interested in using Pragmatic Rating Scale-School Age (PRS-SA) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1221-f-083-spci-003-r002-pragmatic-rating-scale-school-age-prs-sa.md",
		"specId": "1221-f-083-spci-003-r002-pragmatic-rating-scale-school-age-prs-sa",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Social communication",
				"Autism"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use PRS-SA when a trained rater needs to code pragmatic-language behaviors from a school-age conversational video, especially in autism or neurodevelopmental assessment contexts."
			},
			{
				"title": "What It Shows",
				"body": "The review summarizes observable behavior as item ratings, domain scores, and a total pragmatic-violation score when the supported rating structure is complete."
			},
			{
				"title": "Important Limits",
				"body": "The tool organizes ratings and score profiles. It does not generate diagnostic conclusions, treatment recommendations, new PRS-SA items, or unsupported clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Is PRS-SA a questionnaire for families or children?",
				"answer": "No. PRS-SA is a trained observer rating workflow applied to recorded conversational behavior; no separate child or family questionnaire is defined for this product."
			},
			{
				"question": "Can the demo calculate a final total from partial ratings?",
				"answer": "No. Partial coding shows completed domains and missing ratings; unsupported final summaries are suppressed when required ratings are missing."
			},
			{
				"question": "What is saved if I add the tool to my account?",
				"answer": "The PRS-SA tool and supported practitioner configuration are saved. Fictional demo ratings, video references, notes, and sample scores are not saved as real client data."
			},
			{
				"question": "Does the tool diagnose autism or pragmatic language disorder?",
				"answer": "No. The result is a pragmatic-language rating profile from a recorded sample, not an automated diagnosis or severity category."
			}
		]
	},
	{
		"toolType": "conversationAnalysisProfileForPeopleWithAphasiaCappa",
		"slug": "conversation-analysis-profile-for-people-with-aphasia-cappa",
		"title": "CAPPA Aphasia Conversation Profile Demo | Qwoach",
		"metaDescription": "Explore a CAPPA demo for aphasia conversation assessment using interview information and realistic conversation analysis.",
		"h1": "Conversation Analysis Profile for People with Aphasia (CAPPA)",
		"intro": "Conversation Analysis Profile for People with Aphasia (CAPPA) is an aphasia conversation assessment and therapy-planning profile for speech-language therapists and aphasia rehabilitation practitioners. It helps practitioners combine interview information with analysis of a realistic conversation sample to understand conversational abilities, partner supports, interaction changes, and target-relevant barriers.",
		"demoTitle": "Open the sample CAPPA profile and compare interview information with observed conversation analysis.",
		"demoPrompt": "Interested in using Conversation Analysis Profile for People with Aphasia (CAPPA) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1222-f-083-spci-003-r003-conversation-analysis-profile-for-people-with-aphasia-cappa.md",
		"specId": "1222-f-083-spci-003-r003-conversation-analysis-profile-for-people-with-aphasia-cappa",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Aphasia",
				"Social communication"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Partner Roles",
				"body": "The practitioner controls the profile. The person with aphasia and partner may contribute interview content and conversation behavior through practitioner-led assessment."
			},
			{
				"title": "What It Captures",
				"body": "CAPPA organizes reported perceptions, observed interactional behavior, partner strategies, communication opportunities, and current versus prior interaction style where entered."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent interview text, create aphasia severity scores, diagnose aphasia, or generate therapy programs."
			}
		],
		"faqItems": [
			{
				"question": "Does CAPPA require both the person with aphasia and partner to answer interview questions?",
				"answer": "No. Partial profiles remain usable when one source is unavailable, but missing sources are visible and should not be treated as both perspectives."
			},
			{
				"question": "Is CAPPA only a conversation observation tool?",
				"answer": "No. CAPPA combines interview/perception information with analysis of a realistic conversation sample."
			},
			{
				"question": "What is saved from the public demo?",
				"answer": "The CAPPA tool and selected reusable configuration are saved. Fictional interview answers, observations, conversation references, and target notes are not saved as real client data."
			},
			{
				"question": "Does the result provide an intervention program?",
				"answer": "No. The result organizes evidence and target-relevant areas for practitioner planning; it does not generate a prescribed intervention program."
			}
		]
	},
	{
		"toolType": "socialInteractiveCodingSystemSics",
		"slug": "social-interactive-coding-system-sics",
		"title": "SICS Preschool Social Interaction Coding Demo | Qwoach",
		"metaDescription": "Explore a SICS demo for coding preschool social interaction during play, with initiations, responses, context labels, and progress summaries.",
		"h1": "Social Interactive Coding System (SICS)",
		"intro": "Social Interactive Coding System (SICS) is an observational coding system for speech-language pathologists, child-language clinicians, and clinical researchers. It helps practitioners record preschool social-interaction events such as initiations, responses, conversational turns, partners, and context labels so they can review a measurable baseline and compare repeated observations over time.",
		"demoTitle": "Start the sample observation and try coding a few fictional interaction events.",
		"demoPrompt": "Interested in using Social Interactive Coding System (SICS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1223-f-083-spci-004-r001-social-interactive-coding-system-sics.md",
		"specId": "1223-f-083-spci-004-r001-social-interactive-coding-system-sics",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Social communication",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "SICS is used during live or recorded preschool play and other natural communication contexts when a practitioner needs a rapid baseline or treatment-progress observation."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures coded social-interaction events, context/play labels, communication partners, observation duration, and repeated-observation comparisons."
			},
			{
				"title": "Relevant Limits",
				"body": "SICS summarizes observed events. It does not infer intent, add unsupported codes, diagnose, or generate intervention steps."
			}
		],
		"faqItems": [
			{
				"question": "Can the child use SICS directly?",
				"answer": "No. SICS is practitioner-administered observation coding; the child participates naturally in the observed context."
			},
			{
				"question": "Can SICS compare treatment progress over time?",
				"answer": "Yes. Repeated observations can be compared when context, duration, and coding are comparable and clearly labeled."
			},
			{
				"question": "What happens if an observation is interrupted?",
				"answer": "Interrupted observations preserve coded events and elapsed duration so the practitioner can judge comparability."
			},
			{
				"question": "What is saved when I save the demo?",
				"answer": "The SICS tool and reusable observation configuration are saved. Fictional sample events, counts, notes, and child data are not saved as real client records."
			}
		]
	},
	{
		"toolType": "socialCommunicationCodingSystemSccs",
		"slug": "social-communication-coding-system-sccs",
		"title": "SCCS Classroom Social Communication Demo | Qwoach",
		"metaDescription": "Explore an SCCS demo for classroom social communication coding with frequency, duration, proportion-of-time, and state transitions.",
		"h1": "Social Communication Coding System (SCCS)",
		"intro": "Social Communication Coding System (SCCS) is a classroom social-communication observation coding taxonomy for speech-language pathologists, school clinicians, and clinical researchers. It helps practitioners code mutually exclusive behavioral dimensions during classroom activities and review frequency, duration, proportion-of-time, and average-duration profiles.",
		"demoTitle": "Open the sample classroom observation and try changing the active behavioral state.",
		"demoPrompt": "Interested in using Social Communication Coding System (SCCS) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1224-f-083-spci-004-r002-social-communication-coding-system-sccs.md",
		"specId": "1224-f-083-spci-004-r002-social-communication-coding-system-sccs",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Social communication",
				"Outcome monitoring"
			],
			"population": [
				"Children"
			]
		},
		"sections": [
			{
				"title": "Time-In-State Coding",
				"body": "SCCS depends on mutually exclusive state transitions, so only one supported behavioral dimension is active at a time."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures classroom context, transition timeline, frequency, duration, proportion-of-time, average duration, and repeated-observation comparisons."
			},
			{
				"title": "Relevant Limits",
				"body": "SCCS does not explain why behavior occurred, diagnose, or recommend interventions. Partial observations are labeled so they are not mistaken for full-window records."
			}
		],
		"faqItems": [
			{
				"question": "Can SCCS code two behavioral dimensions at the same time?",
				"answer": "No. SCCS uses mutually exclusive behavioral dimensions, so the coding surface allows one active state at a time."
			},
			{
				"question": "Does SCCS measure both frequency and duration?",
				"answer": "Yes. SCCS derives frequency and duration metrics from coded transitions, with proportion-of-time and average-duration outputs where supported."
			},
			{
				"question": "Can I compare observations across different classroom contexts?",
				"answer": "Yes, but context remains visible so the practitioner can judge whether the observations are comparable."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The SCCS tool and reusable configuration are saved. Fictional timelines, metrics, notes, and sample classroom data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "pragmaticProtocolPruttingKirchner",
		"slug": "pragmatic-protocol-prutting-kirchner",
		"title": "Pragmatic Protocol Conversation Coding Demo | Qwoach",
		"metaDescription": "Explore a Pragmatic Protocol demo for rating 30 pragmatic language parameters from spontaneous or video-recorded conversation.",
		"h1": "Pragmatic Protocol (Prutting & Kirchner)",
		"intro": "Pragmatic Protocol (Prutting & Kirchner) is a conversation-sample pragmatic-language taxonomy for speech-language pathologists, DHH professionals, and clinical researchers. It helps clinicians rate 30 pragmatic parameters from spontaneous or video-recorded interaction as appropriate, inappropriate, or not observed so strengths and weaknesses can be reviewed by behavior area.",
		"demoTitle": "Open the sample protocol and try rating fictional parameters by area.",
		"demoPrompt": "Interested in using Pragmatic Protocol (Prutting & Kirchner) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1225-f-083-spci-004-r003-pragmatic-protocol-prutting-kirchner.md",
		"specId": "1225-f-083-spci-004-r003-pragmatic-protocol-prutting-kirchner",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Social communication"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The protocol organizes ratings across verbal, paralinguistic, and nonverbal pragmatic behavior areas, with examples tied to specific parameters."
			},
			{
				"title": "Why Not Observed Matters",
				"body": "A behavior marked not observed is different from an inappropriate behavior and different from an unrated parameter."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not create new parameters, transform ratings into unsupported scores, diagnose, or generate goals."
			}
		],
		"faqItems": [
			{
				"question": "Is not observed the same as inappropriate?",
				"answer": "No. Not observed means the sample did not provide an opportunity or evidence for that parameter; inappropriate is a rating of observed behavior."
			},
			{
				"question": "Can comments replace ratings?",
				"answer": "No. Comments can support a parameter rating, but they do not substitute for required ratings when a completed profile is needed."
			},
			{
				"question": "Does the demo save sample ratings as client data?",
				"answer": "No. Saving keeps the tool and reusable configuration only; fictional ratings and sample comments are discarded as demo data."
			},
			{
				"question": "Does the Pragmatic Protocol generate a diagnosis?",
				"answer": "No. It creates a structured pragmatic behavior profile from observed conversation and does not generate diagnostic conclusions."
			}
		]
	},
	{
		"toolType": "communicationPartnerRating",
		"slug": "communication-partner-rating",
		"title": "Communication Partner Rating Demo | Qwoach",
		"metaDescription": "Explore a partner-support profile demo for rating how communication partner behaviors support or limit social participation.",
		"h1": "Communication Partner Rating",
		"intro": "Communication Partner Rating is a practitioner-only partner-support profile for practitioners supporting a client's social communication participation. It helps practitioners organize ratings or observations about partner behaviors in a specific context so support and barrier patterns can be reviewed and revisited over time.",
		"demoTitle": "Open the sample partner-support shell and see how scale content is required before completion.",
		"demoPrompt": "Interested in using Communication Partner Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1226-f-083-spci-005-r001-communication-partner-rating.md",
		"specId": "1226-f-083-spci-005-r001-communication-partner-rating",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Social communication",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Configuration Requirement",
				"body": "The tool needs a defined partner-support rating structure before a complete profile can be entered or interpreted."
			},
			{
				"title": "When It Is Used",
				"body": "Use it when partner behavior, context, or communication environment is part of the client's social participation support needs."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent scale anchors, support dimensions, coaching recommendations, partner traits, or intent judgments."
			}
		],
		"faqItems": [
			{
				"question": "Can I complete the Communication Partner Rating without a rating structure?",
				"answer": "No. Without a selected or supplied partner-support rating structure, the product can save setup but cannot produce a complete support profile."
			},
			{
				"question": "Is there a client or partner questionnaire?",
				"answer": "No standalone questionnaire is defined. The practitioner may gather information and enter it in a practitioner-mediated workflow."
			},
			{
				"question": "Can the tool compare partner support over time?",
				"answer": "Yes, when repeated ratings use the same rating structure and the same or clearly comparable partner/context."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and reusable setup are saved. Fictional partner labels, ratings, notes, and support/barrier examples are not saved as real client data."
			}
		]
	},
	{
		"toolType": "socialCommunicationGoalPlan",
		"slug": "social-communication-goal-plan",
		"title": "Social Communication Goal Plan Demo | Qwoach",
		"metaDescription": "Explore a person-centered social communication goal plan demo linking assessment findings, priorities, and contexts to goals.",
		"h1": "Social Communication Goal Plan",
		"intro": "Social Communication Goal Plan is a collaborative person-centered planning tool for practitioners planning social communication intervention. It helps practitioners connect assessment findings, contextual needs, and the person's priorities to explicit social communication goals that can guide intervention decisions.",
		"demoTitle": "Open the sample goal plan and review how each goal links to findings, context, and priorities.",
		"demoPrompt": "Interested in using Social Communication Goal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1227-f-083-spci-006-r001-social-communication-goal-plan.md",
		"specId": "1227-f-083-spci-006-r001-social-communication-goal-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Social communication",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Collaborative Use",
				"body": "The tool supports a shared session view where the client can see plain-language goals and meaningful contexts while the practitioner controls the plan."
			},
			{
				"title": "What Makes A Goal Ready",
				"body": "A ready goal is connected to assessment findings and contextual needs, reflects person priorities where available, and describes a meaningful social communication outcome."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not generate substantive goals, prescribe normative targets, score quality, or supply unsupported templates."
			}
		],
		"faqItems": [
			{
				"question": "Can this be completed with the client?",
				"answer": "Yes. A shared session experience is supported, with plain-language goal statements and contexts visible to the client."
			},
			{
				"question": "Can the tool write goals automatically?",
				"answer": "No. The product organizes practitioner-entered goals and links; it does not generate substantive goal recommendations."
			},
			{
				"question": "What if client priorities are unavailable?",
				"answer": "Unavailable priorities should be marked as unavailable rather than invented, and the goal can remain draft if required links are missing."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and reusable setup are saved. Fictional goals, assessment findings, priorities, contexts, and notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "goalAttainmentScaleForSocialCommunication",
		"slug": "goal-attainment-scale-for-social-communication",
		"title": "Social Communication Goal Attainment Scale Demo | Qwoach",
		"metaDescription": "Explore a social communication Goal Attainment Scale demo with individualized targets, anchors, dated scores, and progress trajectory.",
		"h1": "Goal Attainment Scale for Social Communication",
		"intro": "Goal Attainment Scale for Social Communication is an individualized longitudinal outcome scoring tool for practitioners evaluating social communication intervention progress. It helps practitioners define a target, enter outcome-level anchors, record dated scores, and review whether progress is less than expected, expected, or greater than expected according to the entered anchors.",
		"demoTitle": "Create a sample scale and score fictional review points against visible anchors.",
		"demoPrompt": "Interested in using Goal Attainment Scale for Social Communication with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1228-f-083-spci-007-r001-goal-attainment-scale-for-social-communication.md",
		"specId": "1228-f-083-spci-007-r001-goal-attainment-scale-for-social-communication",
		"tags": {
			"framework": [
				"Goal Attainment Scaling"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Social communication",
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Anchors Are Required",
				"body": "A score is interpretable only when the target and required outcome level anchors are complete."
			},
			{
				"title": "One Target Per Scale",
				"body": "Each scale tracks one individualized social communication target. A changed target requires a new scale."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not generate anchors, infer progress without entered scores, provide normative comparison, or recommend treatment changes automatically."
			}
		],
		"faqItems": [
			{
				"question": "Can the tool score progress without anchors?",
				"answer": "No. Missing anchors prevent valid scoring because each score must be interpreted against the entered target-specific levels."
			},
			{
				"question": "Can one scale track multiple goals?",
				"answer": "No. Each score is tied to one individualized target and its anchors; different goals require separate scales unless a future supported structure says otherwise."
			},
			{
				"question": "Can the client see the scale?",
				"answer": "Yes, a shared review can show the target and plain-language anchors when the practitioner chooses to review them collaboratively."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and reusable setup are saved. Fictional targets, anchors, scores, dates, and notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "socialInteractionStrategyPlan",
		"slug": "social-interaction-strategy-plan",
		"title": "Social Interaction Strategy Plan Demo | Qwoach",
		"metaDescription": "Explore a context-specific social interaction strategy plan demo linking assessment findings, contexts, supports, and review.",
		"h1": "Social Interaction Strategy Plan",
		"intro": "Social Interaction Strategy Plan is a context-specific social communication intervention planning tool for practitioners. It helps practitioners connect assessment-identified barriers or opportunities with a defined social interaction context, relevant demands, partners or environmental supports, and a strategy direction for what to target next.",
		"demoTitle": "Open the sample strategy plan and inspect the context-to-strategy link.",
		"demoPrompt": "Interested in using Social Interaction Strategy Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1229-f-083-spci-008-r001-social-interaction-strategy-plan.md",
		"specId": "1229-f-083-spci-008-r001-social-interaction-strategy-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Social communication",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Context Is Required",
				"body": "A strategy direction is not complete unless it is tied to a defined social interaction context."
			},
			{
				"title": "What It Includes",
				"body": "The plan links assessment evidence, communication demands, partners or environmental supports, strategy direction, and later outcome review status."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not supply intervention techniques, practice steps, strategy taxonomies, or automated recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend a strategy automatically?",
				"answer": "No. The practitioner enters the strategy direction; the tool organizes the link to context and assessment evidence."
			},
			{
				"question": "Can the client participate?",
				"answer": "Yes. A collaborative planning view can show the plain-language context and strategy direction, with practitioner-controlled editing."
			},
			{
				"question": "What if there is no defined context?",
				"answer": "The strategy direction remains incomplete because context is required for the plan to be meaningful."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and reusable setup are saved. Fictional contexts, barriers, strategy text, notes, and review examples are not saved as real client data."
			}
		]
	},
	{
		"toolType": "socialCommunicationProgressSample",
		"slug": "social-communication-progress-sample",
		"title": "Social Communication Progress Sample Demo | Qwoach",
		"metaDescription": "Explore repeated social communication progress sampling with target behaviors, comparable samples, trends, and treatment review.",
		"h1": "Social Communication Progress Sample",
		"intro": "Social Communication Progress Sample is a repeated social communication behavior sampling tool for practitioners monitoring intervention. It helps practitioners define target behaviors, record comparable samples, organize coded evidence, and review direction or magnitude of change to support decisions about continuing, adjusting, or replacing an intervention approach.",
		"demoTitle": "Open the sample timeline and add a fictional progress sample.",
		"demoPrompt": "Interested in using Social Communication Progress Sample with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1230-f-083-spci-009-r001-social-communication-progress-sample.md",
		"specId": "1230-f-083-spci-009-r001-social-communication-progress-sample",
		"tags": {
			"framework": [],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Social communication",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Comparability Matters",
				"body": "Progress review depends on the same or comparable target behavior, context, and measurement method across samples."
			},
			{
				"title": "What It Shows",
				"body": "The timeline shows sample evidence, context, comparability status, trend or change summary, and treatment decision notes."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not invent sampling protocols, infer missing scores, make causal claims, or recommend treatment changes automatically."
			}
		],
		"faqItems": [
			{
				"question": "Can one sample show change over time?",
				"answer": "No. A single sample can show baseline or current evidence, but change requires repeated comparable samples."
			},
			{
				"question": "What happens when a sample is not comparable?",
				"answer": "Non-comparable samples are flagged rather than silently included in the main trend."
			},
			{
				"question": "Can the tool decide whether to change intervention?",
				"answer": "No. The tool organizes progress evidence and captures the practitioner's decision; it does not make automated treatment recommendations."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The tool and reusable setup are saved. Fictional target behaviors, samples, trends, dates, and treatment decision notes are not saved as real client data."
			}
		]
	},
	{
		"toolType": "systemsAnalysisObservationSao",
		"slug": "systems-analysis-observation-sao",
		"title": "Systems Analysis Observation Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only SAO profile for organizing motor speech observations into subsystem strengths and weaknesses for assessment review.",
		"h1": "Systems Analysis Observation for Motor Speech Assessment",
		"intro": "Systems Analysis Observation is a practitioner-only motor speech assessment configuration for clinicians evaluating motor speech. It helps the practitioner organize observed subsystem-level strengths and weaknesses so the profile can inform clinical priorities and later comparison.",
		"demoTitle": "Start with a sample dated SAO profile and review how subsystem observations are organized.",
		"demoPrompt": "Interested in using Systems Analysis Observation (SAO) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1231-f-084-prompt-001-r001-systems-analysis-observation-sao.md",
		"specId": "1231-f-084-prompt-001-r001-systems-analysis-observation-sao",
		"tags": {
			"framework": [
				"PROMPT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Motor speech"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-only assessment capture",
				"body": "The practitioner creates, edits, saves drafts, and finalizes SAO profiles. Clients do not enter data in this product surface."
			},
			{
				"title": "Baseline and follow-up use",
				"body": "A baseline profile can serve as the first dated snapshot. Follow-up profiles can be compared only where equivalent source-defined content exists."
			},
			{
				"title": "Limits of the result",
				"body": "The review shows subsystem strengths and weaknesses entered by the practitioner. It does not provide global severity labels, diagnoses, treatment recommendations, or unsupported scoring."
			}
		],
		"faqItems": [
			{
				"question": "Does the SAO give a global motor speech severity score?",
				"answer": "No. The supported result is a subsystem-level profile of strengths and weaknesses, not a global severity score."
			},
			{
				"question": "Does a client complete the SAO?",
				"answer": "No. The SAO is practitioner-only in the supplied product specification."
			},
			{
				"question": "Can the profile be used later for comparison?",
				"answer": "Yes. Finalized dated profiles can serve as baseline or follow-up snapshots when comparable content exists."
			},
			{
				"question": "Are subsystem names and prompts defined here?",
				"answer": "No. Exact SAO subsystem labels, prompts, scoring anchors, and worksheet structure are unresolved and must come from source-defined implementation content."
			}
		]
	},
	{
		"toolType": "motorSpeechHierarchyMsh",
		"slug": "motor-speech-hierarchy-msh",
		"title": "Motor Speech Hierarchy Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only Motor Speech Hierarchy profile for mapping motor speech observations, breakdown areas, and priorities over time.",
		"h1": "Motor Speech Hierarchy Profile for Treatment-Relevant Assessment",
		"intro": "Motor Speech Hierarchy is a practitioner-only motor speech assessment and treatment-planning configuration for clinicians. It helps the practitioner organize observations into source-defined hierarchy levels, identify breakdown areas, and record priorities that follow from the assessed control pattern.",
		"demoTitle": "Explore a sample hierarchy profile and review how breakdowns and priorities are displayed.",
		"demoPrompt": "Interested in using Motor Speech Hierarchy (MSH) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1232-f-084-prompt-002-r001-motor-speech-hierarchy-msh.md",
		"specId": "1232-f-084-prompt-002-r001-motor-speech-hierarchy-msh",
		"tags": {
			"framework": [
				"PROMPT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Motor speech"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Hierarchy-centered review",
				"body": "The result is organized around the source-defined hierarchy, not a flat checklist or broad goal library."
			},
			{
				"title": "Priority grounding",
				"body": "Priority notes remain practitioner-confirmed and should be traceable to entered assessment evidence."
			},
			{
				"title": "Comparison limits",
				"body": "Historical comparison is limited to matching or mapped hierarchy levels when prior profiles use comparable structure."
			}
		],
		"faqItems": [
			{
				"question": "Does MSH automatically choose treatment priorities?",
				"answer": "No. Priorities are practitioner-confirmed and tied to practitioner-entered assessment evidence."
			},
			{
				"question": "Does a client complete the MSH profile?",
				"answer": "No. The MSH profile is practitioner-only in the supplied usage mode."
			},
			{
				"question": "Can the demo show the exact hierarchy levels?",
				"answer": "Only when source-defined hierarchy content is available. The product specification does not define exact levels or prompts."
			},
			{
				"question": "What happens in a follow-up profile?",
				"answer": "Follow-up context shows prior comparable hierarchy profiles so the practitioner can review change over time."
			}
		]
	},
	{
		"toolType": "motorSpeechHierarchyProbeWordsMshPw",
		"slug": "motor-speech-hierarchy-probe-words-msh-pw",
		"title": "MSH-PW Probe Words Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only probe-word assessment for recording motor speech control results, priorities, and baseline or follow-up comparisons.",
		"h1": "Motor Speech Hierarchy Probe Words Assessment Demo",
		"intro": "Motor Speech Hierarchy Probe Words is a practitioner-only standardized motor speech assessment configuration for clinicians. It helps the practitioner administer supported probe words, record motor-speech control results, identify priorities where supported, and compare baseline with later follow-up evidence.",
		"demoTitle": "Open a sample probe-word assessment and review item completion, results, and comparison state.",
		"demoPrompt": "Interested in using Motor Speech Hierarchy Probe Words (MSH-PW) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1233-f-084-prompt-003-r001-motor-speech-hierarchy-probe-words-msh-pw.md",
		"specId": "1233-f-084-prompt-003-r001-motor-speech-hierarchy-probe-words-msh-pw",
		"tags": {
			"framework": [
				"PROMPT"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Motor speech",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Item completion matters",
				"body": "Not administered, incomplete, and recorded items are separate states so missing data is not treated as low performance."
			},
			{
				"title": "Comparable follow-up evidence",
				"body": "Follow-up review compares time points only when probe content and scoring structure are comparable or mapped."
			},
			{
				"title": "Priority boundaries",
				"body": "Priority summaries are shown only where supported by entered data or source-defined rules; practitioner-confirmed priorities are labeled as such."
			}
		],
		"faqItems": [
			{
				"question": "Does MSH-PW provide probe words in this specification?",
				"answer": "No. The exact probe word set is unresolved and must come from source-defined implementation content."
			},
			{
				"question": "Does the tool score motor speech automatically?",
				"answer": "No. It captures supported item results and descriptive comparisons; unsupported scoring or clinical conclusions are not generated."
			},
			{
				"question": "Can it compare baseline and follow-up results?",
				"answer": "Yes. It supports baseline and follow-up comparison when the evidence is comparable."
			},
			{
				"question": "Does the client complete the assessment online?",
				"answer": "No. The client produces speech during practitioner-administered probing, but the product remains practitioner-only."
			}
		]
	},
	{
		"toolType": "threeTreatmentPriorities",
		"slug": "three-treatment-priorities",
		"title": "Three Treatment Priorities Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only tool for selecting exactly three motor speech treatment priorities grounded in assessment evidence.",
		"h1": "Three Treatment Priorities for Motor Speech Focus",
		"intro": "Three Treatment Priorities is a practitioner-only motor speech treatment-focus tool for clinicians. It helps the practitioner narrow multiple assessed motor speech needs into exactly three actionable priorities linked to assessment evidence and reviewable as the client changes.",
		"demoTitle": "Try the three priority slots with fictional assessment findings.",
		"demoPrompt": "Interested in using Three Treatment Priorities with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1234-f-084-prompt-004-r001-three-treatment-priorities.md",
		"specId": "1234-f-084-prompt-004-r001-three-treatment-priorities",
		"tags": {
			"framework": [
				"PROMPT"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Motor speech"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Exactly three priorities",
				"body": "The product narrows treatment focus to three priorities. More candidate needs may be considered, but only three appear as the priority result."
			},
			{
				"title": "Assessment grounding",
				"body": "Each priority should reference assessed motor speech findings so the treatment focus does not drift away from the client's profile."
			},
			{
				"title": "Appropriateness over time",
				"body": "Later review notes can document whether the priority set remains appropriate as the client changes, without overwriting the original dated set."
			}
		],
		"faqItems": [
			{
				"question": "Can I select more than three priorities?",
				"answer": "No. The supported product result is exactly three treatment priorities."
			},
			{
				"question": "Does the tool generate priorities automatically?",
				"answer": "No. The practitioner selects and documents priorities; the system only checks descriptive completeness such as filled slots and evidence links."
			},
			{
				"question": "Is this a full treatment plan?",
				"answer": "No. It captures treatment focus, not full measurable goals or therapy activities."
			},
			{
				"question": "Can priorities be ordered?",
				"answer": "Only if source practice supports ordered and unordered priority sets. Otherwise, the three slots are fixed product semantics."
			}
		]
	},
	{
		"toolType": "motorSpeechGoalPlan",
		"slug": "motor-speech-goal-plan",
		"title": "Motor Speech Goal Plan Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only goal plan for writing measurable motor speech goals linked to assessment findings and treatment priorities.",
		"h1": "Motor Speech Goal Plan for Measurable Treatment Goals",
		"intro": "Motor Speech Goal Plan is a practitioner-only treatment-planning tool for clinicians working with motor speech needs. It helps the practitioner author measurable goals linked to assessed strengths, weaknesses, and priorities so therapy sessions and review conversations have a clear treatment focus.",
		"demoTitle": "Create a sample goal plan from fictional assessment findings.",
		"demoPrompt": "Interested in using Motor Speech Goal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1235-f-084-prompt-005-r001-motor-speech-goal-plan.md",
		"specId": "1235-f-084-prompt-005-r001-motor-speech-goal-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Motor speech",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-authored goals",
				"body": "The practitioner writes the goal content and measurement details. The system organizes links and status rather than generating clinical goals."
			},
			{
				"title": "Goal lifecycle",
				"body": "Draft, active, revised, and retired states distinguish current goals from historical versions without erasing treatment-planning history."
			},
			{
				"title": "Review-ready summary",
				"body": "A concise review version can show active goals for caregivers or team members while retaining clinical linkage for the practitioner."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write goals automatically?",
				"answer": "No. The practitioner authors the goals and measurement details."
			},
			{
				"question": "Does every goal need an assessment link?",
				"answer": "Yes for this product's purpose. Goals should be linked to assessed motor speech needs or priorities."
			},
			{
				"question": "Is this a progress-monitoring tool?",
				"answer": "No. It supports goal planning and revision history; progress data is not collected unless separately supported."
			},
			{
				"question": "Can caregivers complete the plan?",
				"answer": "No. Caregivers or the care team may review a practitioner-prepared summary, but they do not complete the product."
			}
		]
	},
	{
		"toolType": "prePostProbeWordVideo",
		"slug": "pre-post-probe-word-video",
		"title": "Pre/Post Probe Word Video Demo | Qwoach",
		"metaDescription": "Explore paired pre- and post-treatment probe word videos for practitioner motor speech review, annotations, and caregiver feedback.",
		"h1": "Pre/Post Probe Word Video Review for Motor Speech Change",
		"intro": "Pre/Post Probe Word Video is a practitioner-only audiovisual comparison tool for clinicians reviewing motor speech treatment change. It helps the practitioner pair comparable pre-treatment and post-treatment probe word videos, link them to targeted priorities, and record observations for treatment review or caregiver feedback.",
		"demoTitle": "Review a sample pre/post comparison set with fictional labels and placeholder media.",
		"demoPrompt": "Interested in using Pre/Post Probe Word Video with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1236-f-084-prompt-006-r001-pre-post-probe-word-video.md",
		"specId": "1236-f-084-prompt-006-r001-pre-post-probe-word-video",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Motor speech",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Comparable samples",
				"body": "A complete result requires pre- and post-treatment samples that are comparable enough for practitioner review."
			},
			{
				"title": "Evidence and interpretation stay separate",
				"body": "Videos are stored or referenced as evidence, while change observations remain practitioner-entered notes."
			},
			{
				"title": "Incomplete comparison states",
				"body": "Pre-only, post-only, poor-quality, or non-comparable samples are preserved but not presented as complete change evidence."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide whether the client improved?",
				"answer": "No. The tool does not infer improvement or treatment impact; the practitioner records observations."
			},
			{
				"question": "Can it show video side by side?",
				"answer": "Yes, side-by-side playback is supported if implemented as a playback mode; sequential review may also be available if supported."
			},
			{
				"question": "Are exact probe words included?",
				"answer": "No. Exact probe words and capture protocol are unresolved and must be source-defined."
			},
			{
				"question": "Does the client complete a form?",
				"answer": "No. The client may produce speech for video capture, but the product is practitioner-controlled."
			}
		]
	},
	{
		"toolType": "homeProgrammingPlan",
		"slug": "home-programming-plan",
		"title": "Home Programming Plan Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send motor speech home practice plan with caregiver completion, difficulty feedback, and practitioner review.",
		"h1": "Home Programming Plan for Motor Speech Carryover",
		"intro": "Home Programming Plan is a ready-to-send motor speech carryover tool for practitioners and caregivers. It helps the practitioner align home practice with current treatment targets, lets the caregiver record completion and difficulty, and gives the practitioner feedback to adjust future support.",
		"demoTitle": "Prepare a sample plan, switch to caregiver view, and review sample feedback.",
		"demoPrompt": "Interested in using Home Programming Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1237-f-084-prompt-007-r001-home-programming-plan.md",
		"specId": "1237-f-084-prompt-007-r001-home-programming-plan",
		"tags": {
			"framework": [],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Motor speech",
				"Homework"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Caregiver role",
				"body": "The caregiver can view the active plan and submit completion, difficulty, and relevant comments or questions. The caregiver does not edit practitioner instructions."
			},
			{
				"title": "Feedback boundaries",
				"body": "Feedback is descriptive. Missing feedback is not assumed to mean non-adherence, and high difficulty is surfaced for practitioner review without automatic treatment changes."
			},
			{
				"title": "Plan history",
				"body": "Closed or revised plans remain dated history so the practitioner can see how home support has changed over time."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool create home exercises automatically?",
				"answer": "No. The practitioner writes or selects supported plan content; unsupported exercises are not invented."
			},
			{
				"question": "What does the caregiver submit?",
				"answer": "The caregiver submits whether practice occurred, difficulty, and optional comments or questions."
			},
			{
				"question": "Does missing feedback mean the caregiver did not practice?",
				"answer": "No. Missing feedback is shown as missing, not interpreted as non-adherence."
			},
			{
				"question": "Can the practitioner revise a plan mid-period?",
				"answer": "Yes. The prior plan should be preserved and a revised or next plan created so history is not overwritten."
			}
		]
	},
	{
		"toolType": "caregiverVideoFeedbackReview",
		"slug": "caregiver-video-feedback-review",
		"title": "Caregiver Video Feedback Review Demo | Qwoach",
		"metaDescription": "Explore a guided video review for practitioner and caregiver to discuss motor speech focus, questions, and the next practice target.",
		"h1": "Caregiver Video Feedback Review for Motor Speech Practice",
		"intro": "Caregiver Video Feedback Review is a ready-to-complete-together motor speech review tool for practitioners and caregivers. It helps the practitioner use selected video to explain a relevant motor speech breakdown or treatment focus, capture caregiver questions or feedback, and confirm the next practice target for home support.",
		"demoTitle": "Start a sample shared review with placeholder video and fictional caregiver feedback.",
		"demoPrompt": "Interested in using Caregiver Video Feedback Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1238-f-084-prompt-008-r001-caregiver-video-feedback-review.md",
		"specId": "1238-f-084-prompt-008-r001-caregiver-video-feedback-review",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Motor speech"
			],
			"population": [
				"Parents"
			]
		},
		"sections": [
			{
				"title": "Shared review, not a quiz",
				"body": "The caregiver contributes questions and feedback during practitioner-guided review. The system does not score caregiver understanding."
			},
			{
				"title": "Next target required",
				"body": "A complete review needs a confirmed next practice target. If the target is missing, the review remains incomplete."
			},
			{
				"title": "Unresolved questions",
				"body": "Caregiver uncertainty is captured as unresolved questions so the practitioner can follow up before assuming understanding is sufficient."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool analyze the video automatically?",
				"answer": "No. The practitioner enters the relevant breakdown or treatment focus."
			},
			{
				"question": "Does it score caregiver understanding?",
				"answer": "No. It captures caregiver questions, feedback, and completion state without scoring competence."
			},
			{
				"question": "Can the caregiver use the summary later?",
				"answer": "Yes. The completed summary may be visible as a reminder of the next practice focus if the practitioner chooses to share it."
			},
			{
				"question": "What if no video is available?",
				"answer": "A full review result cannot be completed without a video reference because video-guided review is the core mechanic."
			}
		]
	},
	{
		"toolType": "clientRecoveryHandbook",
		"slug": "client-recovery-handbook",
		"title": "Client Recovery Handbook Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send recovery handbook workflow for assigning client work, reviewing outputs, and supporting continuity across sessions.",
		"h1": "Client Recovery Handbook for Stimulant-Use Treatment Work",
		"intro": "Client Recovery Handbook is a ready-to-send stimulant-use recovery treatment-work handbook for practitioners and clients. It helps the practitioner assign supported handbook material, lets the client complete structured recovery work, and gives the practitioner dated outputs for continuity across sessions.",
		"demoTitle": "Assign a sample section, switch to client view, and review submitted demo work.",
		"demoPrompt": "Interested in using Client Recovery Handbook with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1239-f-085-matrix-001-r001-client-recovery-handbook.md",
		"specId": "1239-f-085-matrix-001-r001-client-recovery-handbook",
		"tags": {
			"framework": [
				"Matrix Model"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice",
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Longitudinal workbook progression",
				"body": "The handbook is designed for repeated work outputs over time, not a one-time form."
			},
			{
				"title": "Client and practitioner roles",
				"body": "The practitioner assigns and reviews. The client completes assigned work and can save drafts until submission."
			},
			{
				"title": "Review boundaries",
				"body": "The system groups outputs by source-defined material and chronology; it does not create scores, clinical conclusions, or automated session recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool include exact handbook prompts in this specification?",
				"answer": "No. Exact chapters, worksheets, prompts, and fields are unresolved and must come from source-defined content."
			},
			{
				"question": "Can clients save work before submitting?",
				"answer": "Yes. Draft work can be saved and resumed until submission."
			},
			{
				"question": "What does the practitioner review?",
				"answer": "The practitioner reviews completed client recovery work outputs, submission history, review status, and practitioner notes."
			},
			{
				"question": "Does the handbook score recovery progress?",
				"answer": "No. The supported result is descriptive workbook output and review status, not scoring or progress grading."
			}
		]
	},
	{
		"toolType": "triggerIdentificationWorksheet",
		"slug": "trigger-identification-worksheet",
		"title": "Trigger Identification Worksheet Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send worksheet for identifying client-specific relapse-risk cues, situations, and states for practitioner review.",
		"h1": "Trigger Identification Worksheet for Stimulant-Use Relapse Prevention",
		"intro": "Trigger Identification Worksheet is a ready-to-send relapse-prevention worksheet for practitioners and clients in stimulant-use treatment. It helps the client record personal cues, situations, or states that increase use risk and helps the practitioner review an individualized trigger profile for later coping or avoidance planning.",
		"demoTitle": "Assign a sample worksheet, enter fictional triggers, and review the trigger profile.",
		"demoPrompt": "Interested in using Trigger Identification Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1240-f-085-matrix-002-r001-trigger-identification-worksheet.md",
		"specId": "1240-f-085-matrix-002-r001-trigger-identification-worksheet",
		"tags": {
			"framework": [
				"Matrix Model"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Individualized profile",
				"body": "The worksheet is for client-specific cues, situations, or states, not generic relapse education alone."
			},
			{
				"title": "Client report and practitioner notes",
				"body": "Trigger entries remain client-reported data until the practitioner reviews and interprets them."
			},
			{
				"title": "Revisiting triggers",
				"body": "New triggers can be added as dated updates so changing risk patterns do not overwrite prior history."
			}
		],
		"faqItems": [
			{
				"question": "Does the worksheet create a coping plan?",
				"answer": "No. It identifies triggers; coping or avoidance planning happens outside or after this tool."
			},
			{
				"question": "Does it score relapse risk?",
				"answer": "No. The tool does not assign severity scores, predictions, or risk ratings unless separately supported by source-defined content."
			},
			{
				"question": "Can clients save partial work?",
				"answer": "Yes. Draft work can be saved before submission."
			},
			{
				"question": "What if a client enters only generic relapse risks?",
				"answer": "Generic entries are preserved but can be flagged for practitioner clarification because the intended result is client-specific triggers."
			}
		]
	},
	{
		"toolType": "triggerThoughtCravingUseChain",
		"slug": "trigger-thought-craving-use-chain",
		"title": "Trigger-Thought-Craving-Use Chain Demo | Qwoach",
		"metaDescription": "Explore a relapse-chain formulation tool for mapping triggers, thoughts, cravings, use risk, and intervention points in early recovery.",
		"h1": "Trigger-Thought-Craving-Use Chain",
		"intro": "Trigger-Thought-Craving-Use Chain is a collaborative relapse-chain formulation tool for substance-use treatment practitioners. It helps practitioners and clients connect a high-risk context, thoughts, cravings or urges, and use or near-use outcomes so intervention points can be discussed.",
		"demoTitle": "Explore a sample chain",
		"demoPrompt": "Interested in using Trigger-Thought-Craving-Use Chain with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1241-f-085-matrix-003-r001-trigger-thought-craving-use-chain.md",
		"specId": "1241-f-085-matrix-003-r001-trigger-thought-craving-use-chain",
		"tags": {
			"framework": [
				"Matrix Model"
			],
			"toolType": [
				"Case formulation"
			],
			"workflow": [
				"Intervention planning",
				"In-session support"
			],
			"topic": [
				"Substance use",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it during relapse-prevention work when a client can discuss a recent use, near-use, or high-risk pathway and the practitioner wants the sequence to guide follow-up."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not calculate relapse risk, assign diagnoses, generate clinical conclusions, or create a full relapse-prevention plan unless those details are entered by the practitioner and client."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool produce a score?",
				"answer": "No. It produces a chain formulation, not a questionnaire score or relapse-risk level."
			},
			{
				"question": "Can a partial chain be saved?",
				"answer": "Yes. Unknown or unresolved links can remain blank and the chain is shown as incomplete."
			},
			{
				"question": "Is there a separate client-only version?",
				"answer": "No separate independent client experience is required. The supported mode is practitioner and client completing the chain together."
			}
		]
	},
	{
		"toolType": "schedulingDailyStructurePlan",
		"slug": "scheduling-daily-structure-plan",
		"title": "Scheduling / Daily Structure Plan Demo | Qwoach",
		"metaDescription": "Explore a recovery daily structure tool for planning treatment commitments, activities, unstructured time, and optional adherence review.",
		"h1": "Scheduling / Daily Structure Plan",
		"intro": "Scheduling / Daily Structure Plan is a recovery routine and adherence planning tool for substance-use treatment practitioners. It helps practitioners send or start a daily timeline so clients can organize treatment commitments, responsibilities, recovery-supportive activities, and unstructured high-risk time.",
		"demoTitle": "Plan a sample day",
		"demoPrompt": "Interested in using Scheduling / Daily Structure Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1242-f-085-matrix-004-r001-scheduling-daily-structure-plan.md",
		"specId": "1242-f-085-matrix-004-r001-scheduling-daily-structure-plan",
		"tags": {
			"framework": [
				"Matrix Model"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Substance use",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The tool captures planned activities, treatment or recovery commitments, responsibilities, unstructured time, optional adherence status, and review notes about routine barriers."
			},
			{
				"title": "History And Comparison",
				"body": "Repeated plans can be reviewed over time to compare routine changes without generating unsupported clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Can this be used as a general calendar?",
				"answer": "No. It is a recovery daily-structure plan, not a general calendar, reminder, or productivity tool."
			},
			{
				"question": "What happens if a client only completes part of the day?",
				"answer": "Partial days can be saved, and missing or unplanned spans remain visible."
			},
			{
				"question": "Does adherence reporting have to be used?",
				"answer": "No. Adherence reporting is a supported setting that can be turned on or off."
			}
		]
	},
	{
		"toolType": "relapsePreventionPlan2",
		"slug": "relapse-prevention-plan-2",
		"title": "Relapse Prevention Plan Demo | Qwoach",
		"metaDescription": "Explore an individualized relapse-prevention planning tool for matching risks, warning signs, coping responses, and support actions.",
		"h1": "Relapse Prevention Plan",
		"intro": "Relapse Prevention Plan is an individualized relapse-readiness planning tool for substance-use recovery practitioners. It helps practitioners and clients identify relapse risks or warning signs, match coping responses to those risks, and define support or recovery actions for moments when self-management is not enough.",
		"demoTitle": "Build a sample plan",
		"demoPrompt": "Interested in using Relapse Prevention Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1243-f-085-matrix-005-r001-relapse-prevention-plan.md",
		"specId": "1243-f-085-matrix-005-r001-relapse-prevention-plan",
		"tags": {
			"framework": [
				"Matrix Model"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Relapse prevention",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Current Plan And Updates",
				"body": "The plan remains individualized and updateable as recovery circumstances change. Prior versions can be useful for review without replacing the current usable plan."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not generate relapse-risk scores, diagnoses, mandated crisis instructions, or risk predictions."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool infer relapse risk severity?",
				"answer": "No. It organizes entered risks, responses, and support actions without generating a severity level."
			},
			{
				"question": "Can a plan be saved with missing responses?",
				"answer": "Yes. A draft can be saved and missing responses are shown as incomplete."
			},
			{
				"question": "Can one risk have more than one response?",
				"answer": "Yes. Multiple coping or support options can be attached to a risk or warning sign."
			}
		]
	},
	{
		"toolType": "cravingUrgeLog",
		"slug": "craving-urge-log",
		"title": "Craving / Urge Log Demo | Qwoach",
		"metaDescription": "Explore a craving and urge episode log for tracking timing, intensity, contexts, triggers, and descriptive patterns over time.",
		"h1": "Craving / Urge Log",
		"intro": "Craving / Urge Log is a longitudinal craving tracking tool for substance-use treatment practitioners. It helps clients record craving or urge episodes so timing, intensity, context, triggers, and change over time are visible for practitioner review.",
		"demoTitle": "Review sample episodes",
		"demoPrompt": "Interested in using Craving / Urge Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1244-f-085-matrix-006-r001-craving-urge-log.md",
		"specId": "1244-f-085-matrix-006-r001-craving-urge-log",
		"tags": {
			"framework": [
				"Matrix Model"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Longitudinal Review",
				"body": "Entries can be reviewed by period so cravings are compared across time instead of relying only on memory or isolated anecdotes."
			},
			{
				"title": "Descriptive Only",
				"body": "The tool does not infer relapse risk, clinical severity, or causes from the log data."
			}
		],
		"faqItems": [
			{
				"question": "Is intensity required?",
				"answer": "Intensity is enabled by default because the tool supports monitoring intensity over time, but the setting can be turned off."
			},
			{
				"question": "What if there are no entries in a review period?",
				"answer": "The review shows no reported episodes for that period without interpreting the absence."
			},
			{
				"question": "Can a client enter approximate times?",
				"answer": "Yes. Approximate times are supported while preserving the chronology of entries."
			}
		]
	},
	{
		"toolType": "recoveryCalendarAbstinenceTracker",
		"slug": "recovery-calendar-abstinence-tracker",
		"title": "Recovery Calendar / Abstinence Tracker Demo | Qwoach",
		"metaDescription": "Explore a recovery calendar for tracking abstinence, lapse/use reports, unknown days, and longitudinal recovery status over time.",
		"h1": "Recovery Calendar / Abstinence Tracker",
		"intro": "Recovery Calendar / Abstinence Tracker is a longitudinal recovery monitoring calendar for substance-use treatment practitioners. It helps practitioners see abstinence continuity, lapse/use reports, unknown days, and recovery progress across a time-structured treatment period.",
		"demoTitle": "Open sample calendar",
		"demoPrompt": "Interested in using Recovery Calendar / Abstinence Tracker with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1245-f-085-matrix-007-r001-recovery-calendar-abstinence-tracker.md",
		"specId": "1245-f-085-matrix-007-r001-recovery-calendar-abstinence-tracker",
		"tags": {
			"framework": [
				"Matrix Model"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Outcome monitoring",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Unknown Days Stay Unknown",
				"body": "Missing entries are displayed as unknown and are not treated as abstinent or lapse/use reports."
			},
			{
				"title": "Historical Review",
				"body": "Historical months remain reviewable so the practitioner can discuss recovery status across treatment contacts without unsupported severity judgments."
			}
		],
		"faqItems": [
			{
				"question": "Does the tracker infer abstinence from nonresponse?",
				"answer": "No. Nonresponse remains unreported or unknown."
			},
			{
				"question": "Can a lapse be recorded without details?",
				"answer": "Yes. A date-level lapse/use report can be recorded without forcing a narrative."
			},
			{
				"question": "Can status categories be customized?",
				"answer": "No. The supported status set is abstinent, lapse/use reported, and unreported/unknown unless a source configuration defines more."
			}
		]
	},
	{
		"toolType": "familyEducationWorksheet",
		"slug": "family-education-worksheet",
		"title": "Family Education Worksheet Demo | Qwoach",
		"metaDescription": "Explore a family recovery education worksheet for gathering family understanding, concerns, support needs, and respondent perspectives.",
		"h1": "Family Education Worksheet",
		"intro": "Family Education Worksheet is a family recovery-education and support-needs worksheet for substance-use treatment practitioners. It helps practitioners gather family or close-support understanding, concerns, misunderstandings, and support needs so education or follow-up can be planned.",
		"demoTitle": "Review a sample worksheet",
		"demoPrompt": "Interested in using Family Education Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1246-f-085-matrix-008-r001-family-education-worksheet.md",
		"specId": "1246-f-085-matrix-008-r001-family-education-worksheet",
		"tags": {
			"framework": [
				"Matrix Model"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Interpersonal relationships"
			],
			"population": [
				"Families"
			]
		},
		"sections": [
			{
				"title": "Multiple Respondents",
				"body": "Responses from multiple family members or close supports stay separate rather than being merged into one viewpoint."
			},
			{
				"title": "Content Boundary",
				"body": "The demo does not invent detailed worksheet prompts; it uses only the supported sections of knowledge, concerns, support needs, misunderstandings or gaps, and possible support role."
			}
		],
		"faqItems": [
			{
				"question": "Does this worksheet rate family functioning?",
				"answer": "No. It gathers descriptive responses and does not generate ratings, diagnoses, or family-functioning scores."
			},
			{
				"question": "Can more than one family member respond?",
				"answer": "Yes. Multiple respondents are supported, and their perspectives remain separate."
			},
			{
				"question": "Are the exact worksheet prompts defined?",
				"answer": "No. Exact substantive prompts are unresolved from the supplied product record and must not be invented."
			}
		]
	},
	{
		"toolType": "socialSupportPlan",
		"slug": "social-support-plan",
		"title": "Social Support Plan Demo | Qwoach",
		"metaDescription": "Explore a recovery social support plan for mapping people, groups, resources, roles, actions, and visible support gaps.",
		"h1": "Social Support Plan",
		"intro": "Social Support Plan is a recovery-support network and action-planning tool for substance-use treatment practitioners. It helps practitioners and clients identify supportive people, groups, and resources, define concrete roles or actions, and make gaps in the support network visible.",
		"demoTitle": "Map sample supports",
		"demoPrompt": "Interested in using Social Support Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1247-f-085-matrix-009-r001-social-support-plan.md",
		"specId": "1247-f-085-matrix-009-r001-social-support-plan",
		"tags": {
			"framework": [
				"Matrix Model"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Interpersonal relationships",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Support Types",
				"body": "The tool supports people, groups, and resources as distinct but comparable entries so the plan is broader than a contact list."
			},
			{
				"title": "Visible Gaps",
				"body": "If no support is identified, the plan can show a gap instead of forcing an entry."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool rate support quality?",
				"answer": "No. It does not score or judge relationship quality."
			},
			{
				"question": "Can a support be listed without an action?",
				"answer": "Yes, but it is flagged as incomplete because the role is not concrete enough to act on."
			},
			{
				"question": "Is this a contact manager?",
				"answer": "No. It captures recovery supports and actions, not contact automation or social-media data."
			}
		]
	},
	{
		"toolType": "treatmentCompletionContinuingCarePlan",
		"slug": "treatment-completion-continuing-care-plan",
		"title": "Treatment Completion / Continuing Care Plan Demo | Qwoach",
		"metaDescription": "Explore a continuing care plan for post-treatment supports, maintenance routines, risk responses, pending items, and follow-up details.",
		"h1": "Treatment Completion / Continuing Care Plan",
		"intro": "Treatment Completion / Continuing Care Plan is a transition and maintenance planning tool for substance-use recovery practitioners. It helps practitioners and clients organize continuing care supports, maintenance routines, known post-treatment risks, risk responses, and follow-up or referral details.",
		"demoTitle": "Review a sample plan",
		"demoPrompt": "Interested in using Treatment Completion / Continuing Care Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1248-f-085-matrix-010-r001-treatment-completion-continuing-care-plan.md",
		"specId": "1248-f-085-matrix-010-r001-treatment-completion-continuing-care-plan",
		"tags": {
			"framework": [
				"Matrix Model"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Transition planning",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Pending Items",
				"body": "Unresolved supports, referrals, or follow-up steps can be marked pending rather than forced into certainty before arrangements are complete."
			},
			{
				"title": "Current Maintenance Plan",
				"body": "The plan is organized as one current maintenance plan, with updates available when follow-up arrangements change."
			}
		],
		"faqItems": [
			{
				"question": "Is this a full discharge-management system?",
				"answer": "No. It captures continuing-care plan elements and does not expand into broad discharge administration."
			},
			{
				"question": "Can unresolved referrals be saved?",
				"answer": "Yes. Pending referral or support items can be saved and shown as unresolved."
			},
			{
				"question": "Does the plan predict sustained recovery?",
				"answer": "No. It organizes supports, routines, risks, responses, and follow-up details without predicting outcomes."
			}
		]
	},
	{
		"toolType": "jellinekAssessmentOfSymptoms",
		"slug": "jellinek-assessment-of-symptoms",
		"title": "Jellinek Assessment of Symptoms Demo | Qwoach",
		"metaDescription": "Explore a practitioner-guided alcohol-problem history assessment shell for capturing structured symptom history and progression.",
		"h1": "Jellinek Assessment of Symptoms",
		"intro": "Jellinek Assessment of Symptoms is a structured alcohol-problem history assessment for practitioners beginning twelve-step-oriented alcohol treatment. It helps practitioners capture a client’s alcohol-related symptom or consequence history and problem progression in a coherent record for early treatment discussion.",
		"demoTitle": "Explore the assessment shell",
		"demoPrompt": "Interested in using Jellinek Assessment of Symptoms with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1249-f-086-tsf-001-r001-jellinek-assessment-of-symptoms.md",
		"specId": "1249-f-086-tsf-001-r001-jellinek-assessment-of-symptoms",
		"tags": {
			"framework": [
				"Twelve Step Facilitation"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Substance use",
				"Clinical history"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Content Boundary",
				"body": "Exact assessment items, prompts, dimensions, response options, and scoring are unresolved from the supplied record and must come from supplied assessment content."
			},
			{
				"title": "Review Boundary",
				"body": "The tool organizes reported history and missing responses but does not generate severity scores, phase assignments, diagnoses, or unsupported clinical interpretations."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include the exact Jellinek assessment items?",
				"answer": "No. Exact items are unresolved in the supplied product specification and are not invented in the demo."
			},
			{
				"question": "Does the tool calculate a score?",
				"answer": "No. No score is calculated unless source assessment rules are supplied."
			},
			{
				"question": "Can an incomplete assessment be saved?",
				"answer": "Yes. Incomplete assessments can be saved and shown with unanswered areas."
			}
		]
	},
	{
		"toolType": "alcoholicsAnonymous12StepParticipationHistory",
		"slug": "alcoholics-anonymous-12-step-participation-history",
		"title": "12-Step Participation History Demo | Qwoach",
		"metaDescription": "Explore a TSF participation history tool for mapping prior 12-step involvement, current engagement, barriers, reservations, and next steps.",
		"h1": "Alcoholics Anonymous / 12-Step Participation History",
		"intro": "Alcoholics Anonymous / 12-Step Participation History is a structured participation and barrier history tool for practitioners using Twelve Step Facilitation. It helps practitioners and clients capture prior exposure, current engagement, attitudes or reservations, obstacles, and a realistic next step toward mutual-help involvement when supported.",
		"demoTitle": "Complete a sample history",
		"demoPrompt": "Interested in using Alcoholics Anonymous / 12-Step Participation History with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1250-f-086-tsf-002-r001-alcoholics-anonymous-12-step-participation-history.md",
		"specId": "1250-f-086-tsf-002-r001-alcoholics-anonymous-12-step-participation-history",
		"tags": {
			"framework": [
				"Twelve Step Facilitation"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Barriers And Reservations",
				"body": "The tool separates facts of participation from obstacles, attitudes, and reservations so barriers can be addressed without turning the result into a readiness score."
			},
			{
				"title": "Not A Directory",
				"body": "The tool does not search meetings, verify attendance, rank mutual-help options, or provide external recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can the client report no prior 12-step participation?",
				"answer": "Yes. A clear none history is supported and the tool can continue to barriers or reservations."
			},
			{
				"question": "Does the tool verify attendance?",
				"answer": "No. It records reported participation history and does not verify attendance."
			},
			{
				"question": "Is a next step required?",
				"answer": "No. The next step can remain unresolved until enough information supports one."
			}
		]
	},
	{
		"toolType": "acceptanceWorksheet",
		"slug": "acceptance-worksheet",
		"title": "Acceptance Worksheet Demo | Qwoach",
		"metaDescription": "Preview a client worksheet that captures acceptance and ambivalence material for early alcohol recovery discussions and practitioner review.",
		"h1": "Acceptance Worksheet for early alcohol recovery discussions",
		"intro": "The Acceptance Worksheet is a ready-to-send client worksheet for practitioners working with early alcohol recovery. It helps the practitioner understand the client's current acceptance, reservations, and ambivalence about loss of control, recovery need, and outside help.",
		"demoTitle": "Preview the worksheet and review sample responses",
		"demoPrompt": "Interested in using Acceptance Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1251-f-086-tsf-003-r001-acceptance-worksheet.md",
		"specId": "1251-f-086-tsf-003-r001-acceptance-worksheet",
		"tags": {
			"framework": [
				"Twelve Step Facilitation"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it early in alcohol recovery when ambivalence about loss of control, recovery need, or outside help is clinically important to discuss."
			},
			{
				"title": "What It Does Not Do",
				"body": "The worksheet does not collect alcohol-use quantities, diagnostic scores, risk ratings, readiness scores, meeting attendance, or sponsor information. It does not label the client's acceptance level."
			},
			{
				"title": "Repeat Use",
				"body": "Repeated worksheet instances can be reviewed chronologically to compare reported acceptance themes over time without calculating change scores."
			}
		],
		"faqItems": [
			{
				"question": "Does the Acceptance Worksheet score acceptance?",
				"answer": "No. The worksheet displays client-reported acceptance and ambivalence material without an acceptance score, readiness stage, or automated conclusion."
			},
			{
				"question": "Can clients save partial responses?",
				"answer": "Yes. Partial responses are preserved as drafts and shown as incomplete until submitted."
			},
			{
				"question": "Are exact worksheet prompts included in the demo?",
				"answer": "No. The product specification does not define exact prompts or fields, so the demo represents the real flow without inventing worksheet wording."
			},
			{
				"question": "What gets saved to my account?",
				"answer": "The fixed Acceptance Worksheet tool is saved. Fictional demo responses and sample assignment data are not saved as real client data."
			}
		]
	},
	{
		"toolType": "surrenderHelpSeekingPlan",
		"slug": "surrender-help-seeking-plan",
		"title": "Surrender / Help-Seeking Plan Demo | Qwoach",
		"metaDescription": "Preview a collaborative plan that helps clients identify outside recovery help, reachable actions, and barriers for practitioner review.",
		"h1": "Surrender / Help-Seeking Plan for outside recovery support",
		"intro": "The Surrender / Help-Seeking Plan is a ready-to-complete-together tool for practitioners and clients working on alcohol recovery support. It helps them identify outside help sources, reachable actions, and barriers so acceptance can turn into active recovery involvement.",
		"demoTitle": "Try the collaborative planning demo",
		"demoPrompt": "Interested in using Surrender / Help-Seeking Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1252-f-086-tsf-004-r001-surrender-help-seeking-plan.md",
		"specId": "1252-f-086-tsf-004-r001-surrender-help-seeking-plan",
		"tags": {
			"framework": [
				"Twelve Step Facilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Collaborative Use",
				"body": "This plan is designed for practitioner and client completion together, especially when the client needs a reachable route to outside recovery help."
			},
			{
				"title": "Incomplete Plans",
				"body": "If no source of help is identified, the plan can remain incomplete or capture a clear next step for finding one."
			},
			{
				"title": "Follow-Up",
				"body": "Later updates can describe attempted contact, barriers, or needed adjustments without scoring adherence or commitment."
			}
		],
		"faqItems": [
			{
				"question": "Is this a broad recovery plan?",
				"answer": "No. It is limited to help-seeking actions that connect recovery need to outside people, groups, or supports."
			},
			{
				"question": "Can the plan be complete without a named support person?",
				"answer": "Yes, if it includes a clear next step toward finding outside recovery help. Without a source or next step, it remains incomplete."
			},
			{
				"question": "Does the tool recommend specific recovery supports?",
				"answer": "No. The tool organizes the pathway the practitioner and client create; it does not prescribe supports or automate recommendations."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The fixed Surrender / Help-Seeking Plan tool is saved. Fictional demo plan content is not saved as real client data."
			}
		]
	},
	{
		"toolType": "meetingAttendancePlan",
		"slug": "meeting-attendance-plan",
		"title": "Meeting Attendance Plan Demo | Qwoach",
		"metaDescription": "Preview a meeting participation plan that captures planned attendance, reported follow-through, barriers, and adjustments over time.",
		"h1": "Meeting Attendance Plan for mutual-help participation",
		"intro": "The Meeting Attendance Plan is a ready-to-send tool for practitioners helping clients build active mutual-help involvement. It helps create a realistic meeting-participation pattern, capture reported follow-through, and identify barriers for adjustment.",
		"demoTitle": "Explore the plan and follow-up demo",
		"demoPrompt": "Interested in using Meeting Attendance Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1253-f-086-tsf-005-r001-meeting-attendance-plan.md",
		"specId": "1253-f-086-tsf-005-r001-meeting-attendance-plan",
		"tags": {
			"framework": [
				"Twelve Step Facilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Between-session monitoring"
			],
			"topic": [
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Plan And Follow-Up Stay Separate",
				"body": "The plan records intended participation; follow-up records what the client reports happened and what got in the way."
			},
			{
				"title": "Barriers Without Failure Scoring",
				"body": "Nonattendance or partial follow-up is captured descriptively so barriers can be discussed without generating failure scores."
			},
			{
				"title": "Longitudinal Review",
				"body": "Repeated cycles create a chronological view of participation patterns, missed follow-up, and adjustments."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool find meetings or manage a calendar?",
				"answer": "No. It is a participation planning and monitoring tool, not a meeting directory, reminder system, or full calendar."
			},
			{
				"question": "Does it score meeting adherence?",
				"answer": "No. It may show descriptive counts or statuses based on reported items, but it does not generate an engagement score."
			},
			{
				"question": "Can a client report that they did not attend?",
				"answer": "Yes. Nonattendance can be recorded with barriers or changed circumstances without treating it as a failure score."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The fixed Meeting Attendance Plan tool is saved. Sample meeting plans and fictional follow-up reports from the public demo are not saved as client data."
			}
		]
	},
	{
		"toolType": "meetingReactionRecord",
		"slug": "meeting-reaction-record",
		"title": "Meeting Reaction Record Demo | Qwoach",
		"metaDescription": "Preview a post-meeting record that captures client reactions, perceived fit, willingness to return, and barriers for practitioner review.",
		"h1": "Meeting Reaction Record for post-meeting reflection",
		"intro": "The Meeting Reaction Record is a ready-to-send client record for practitioners reviewing mutual-help participation. It helps capture the client's emotional and practical reactions, perceived fit, willingness to return, and barriers after attending a recovery meeting.",
		"demoTitle": "Preview a sample reaction record",
		"demoPrompt": "Interested in using Meeting Reaction Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1254-f-086-tsf-006-r001-meeting-reaction-record.md",
		"specId": "1254-f-086-tsf-006-r001-meeting-reaction-record",
		"tags": {
			"framework": [
				"Twelve Step Facilitation"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "After-Meeting Focus",
				"body": "The record is for reactions after meeting attendance. If no meeting was attended, it should remain incomplete or be redirected to planning."
			},
			{
				"title": "Reported Experience, Not Meeting Quality",
				"body": "The tool captures the client's experience and barriers; it does not publish reviews, rate meetings, or score fit."
			},
			{
				"title": "Recurring Themes",
				"body": "Multiple records can be reviewed chronologically to notice repeated barriers or fit themes without scoring them."
			}
		],
		"faqItems": [
			{
				"question": "Is this a meeting rating tool?",
				"answer": "No. It captures a client's reported experience for clinical discussion and does not rate meeting quality."
			},
			{
				"question": "What if the client had a strong negative reaction?",
				"answer": "The reaction is preserved as reported so the practitioner can discuss barriers or expectations without interpreting it as treatment refusal."
			},
			{
				"question": "Can multiple meetings be recorded?",
				"answer": "Yes. Multiple records or separated entries should be stored chronologically so reactions are not conflated."
			},
			{
				"question": "What gets saved from the demo?",
				"answer": "The fixed Meeting Reaction Record tool is saved. Fictional meeting reactions and sample client entries are not saved as real client data."
			}
		]
	},
	{
		"toolType": "sponsorRecoveryContactPlan",
		"slug": "sponsor-recovery-contact-plan",
		"title": "Sponsor / Recovery Contact Plan Demo | Qwoach",
		"metaDescription": "Preview a collaborative plan for sponsor or recovery-contact support, including contact pathways, initiation steps, barriers, and progress updates.",
		"h1": "Sponsor / Recovery Contact Plan for between-session support",
		"intro": "The Sponsor / Recovery Contact Plan is a ready-to-complete-together tool for practitioners and clients in twelve-step facilitation. It helps define who to approach or what step to take next, when and how to initiate contact, and what barriers may affect between-session support.",
		"demoTitle": "Explore the support-pathway demo",
		"demoPrompt": "Interested in using Sponsor / Recovery Contact Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1255-f-086-tsf-007-r001-sponsor-recovery-contact-plan.md",
		"specId": "1255-f-086-tsf-007-r001-sponsor-recovery-contact-plan",
		"tags": {
			"framework": [
				"Twelve Step Facilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Two Valid Pathway States",
				"body": "The plan can show a specific potential contact or a clear next step for finding one. A missing contact does not have to become a dead end."
			},
			{
				"title": "Between-Session Use",
				"body": "The client can view the active pathway between sessions so the next action remains visible."
			},
			{
				"title": "Privacy-Minimizing Detail",
				"body": "The plan should collect only third-party details needed for the client's own pathway."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool match clients with sponsors?",
				"answer": "No. It records a pathway the practitioner and client define; it does not provide sponsor matching."
			},
			{
				"question": "Can the plan be useful before a contact is identified?",
				"answer": "Yes. It can function as a search pathway when the next step for finding recovery contact is clear."
			},
			{
				"question": "Does it rate whether a sponsor or contact is suitable?",
				"answer": "No. The tool does not score contact quality or make automated trust judgments."
			},
			{
				"question": "What is saved after the public demo?",
				"answer": "The fixed Sponsor / Recovery Contact Plan tool is saved. Fictional contact details and sample progress updates are not saved as real client data."
			}
		]
	},
	{
		"toolType": "stepWorkProgressLog",
		"slug": "step-work-progress-log",
		"title": "Step Work Progress Log Demo | Qwoach",
		"metaDescription": "Preview a recurring log for step-related recovery work, broader mutual-help engagement, barriers, gaps, and chronological practitioner review.",
		"h1": "Step Work Progress Log for longitudinal recovery engagement",
		"intro": "The Step Work Progress Log is a ready-to-send recurring log for practitioners monitoring twelve-step recovery involvement. It helps show reported step-related activity, broader mutual-help engagement, stalls, barriers, and gaps over time.",
		"demoTitle": "Explore the sample engagement timeline",
		"demoPrompt": "Interested in using Step Work Progress Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1256-f-086-tsf-008-r001-step-work-progress-log.md",
		"specId": "1256-f-086-tsf-008-r001-step-work-progress-log",
		"tags": {
			"framework": [
				"Twelve Step Facilitation"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Beyond Attendance",
				"body": "The log is for reported step-related activity and broader engagement, not for planning meeting attendance."
			},
			{
				"title": "No Activity Entries",
				"body": "A client can report no activity or barriers without the system interpreting the entry as failure."
			},
			{
				"title": "Descriptive Trends",
				"body": "The review may show recent entries, gaps, or repeated barriers when based directly on log data, without generating progress scores."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool teach the steps?",
				"answer": "No. It logs reported step-related activity and broader engagement; it does not provide step instruction."
			},
			{
				"question": "Does it score step progress?",
				"answer": "No. The log is descriptive and does not rate step quality, commitment, or recovery progress."
			},
			{
				"question": "Can missed periods be shown?",
				"answer": "Yes. Missed periods can be shown descriptively as gaps without interpreting the reason."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed Step Work Progress Log tool is saved. Fictional timeline entries and sample barriers are not saved as real client data."
			}
		]
	},
	{
		"toolType": "12StepFacilitationSessionChecklist",
		"slug": "12-step-facilitation-session-checklist",
		"title": "12-Step Facilitation Session Checklist Demo | Qwoach",
		"metaDescription": "Preview a practitioner-only 12-session checklist for tracking TSF process coverage, missed components, incomplete items, and course-level review.",
		"h1": "12-Step Facilitation Session Checklist for process fidelity",
		"intro": "The 12-Step Facilitation Session Checklist is a practitioner-only tool for clinicians delivering a standardized twelve-step facilitation sequence. It helps verify session process elements, identify missed or incomplete components, and review consistency across the fixed 12-session course.",
		"demoTitle": "Preview the session checklist matrix",
		"demoPrompt": "Interested in using 12-Step Facilitation Session Checklist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1257-f-086-tsf-009-r001-12-step-facilitation-session-checklist.md",
		"specId": "1257-f-086-tsf-009-r001-12-step-facilitation-session-checklist",
		"tags": {
			"framework": [
				"Twelve Step Facilitation"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Quality review"
			],
			"topic": [
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "The checklist has no client-facing experience and collects no client self-report."
			},
			{
				"title": "Fixed Sequence",
				"body": "The sequence length is fixed at 12 sessions for this configuration and should not be exposed as a setting."
			},
			{
				"title": "Descriptive Gap Review",
				"body": "The tool surfaces incomplete or missed process components once checklist content is defined, without creating fidelity thresholds or competence scores."
			}
		],
		"faqItems": [
			{
				"question": "Does this checklist include client worksheets?",
				"answer": "No. This is a practitioner-only process checklist with no client-facing surface."
			},
			{
				"question": "Can I change the number of sessions?",
				"answer": "No. The supplied configuration is a fixed 12-session sequence and does not expose sequence length as a setting."
			},
			{
				"question": "Are exact checklist items shown in the demo?",
				"answer": "No. Exact items are unresolved, so the demo shows the sequence and status behavior without inventing fidelity elements."
			},
			{
				"question": "What gets saved to my account?",
				"answer": "The fixed 12-Step Facilitation Session Checklist tool is saved. Fictional course statuses and demo checklist marks are not saved as real data."
			}
		]
	},
	{
		"toolType": "costBenefitAnalysisCba",
		"slug": "cost-benefit-analysis-cba",
		"title": "Cost-Benefit Analysis Demo | Qwoach",
		"metaDescription": "Preview a CBA worksheet that captures client-perceived benefits and costs of continuing versus changing an addictive behavior.",
		"h1": "Cost-Benefit Analysis (CBA) for behavior-change ambivalence",
		"intro": "Cost-Benefit Analysis (CBA) is a ready-to-send worksheet for practitioners helping clients with substance-use or addictive behavior change. It helps the client list perceived benefits and costs of continuing the behavior and changing it so ambivalence can be discussed clearly.",
		"demoTitle": "Try the CBA worksheet demo",
		"demoPrompt": "Interested in using Cost-Benefit Analysis (CBA) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1258-f-087-smart-001-r001-cost-benefit-analysis-cba.md",
		"specId": "1258-f-087-smart-001-r001-cost-benefit-analysis-cba",
		"tags": {
			"framework": [
				"SMART Recovery"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Substance use",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Comparison Structure",
				"body": "The CBA is organized around continuing versus changing and benefits versus costs. The comparison is the core product experience."
			},
			{
				"title": "Uneven Responses Are Allowed",
				"body": "Ambivalence may not appear evenly across all areas. Empty or one-sided cells are shown as reported, not interpreted."
			},
			{
				"title": "Repeated Use",
				"body": "Multiple CBAs can be stored chronologically for qualitative comparison of reported tradeoffs over time."
			}
		],
		"faqItems": [
			{
				"question": "Does the CBA calculate a score?",
				"answer": "No. The CBA organizes client-perceived tradeoffs and does not calculate a net score or readiness classification."
			},
			{
				"question": "Can a client leave one area blank?",
				"answer": "Yes. Blank areas can be shown as unanswered when intentional or incomplete when the submission is not finished."
			},
			{
				"question": "Is this a change plan?",
				"answer": "No. It clarifies tradeoffs and ambivalence; it does not create a behavior-change plan."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The fixed CBA tool is saved. Fictional tradeoffs and sample target behavior data from the demo are not saved as client data."
			}
		]
	},
	{
		"toolType": "changePlanWorksheet2",
		"slug": "change-plan-worksheet-2",
		"title": "Change Plan Worksheet Demo | Qwoach",
		"metaDescription": "Preview a worksheet that helps clients turn behavior-change intention into target change, reasons, supports, steps, and obstacles.",
		"h1": "Change Plan Worksheet for recovery behavior change",
		"intro": "The Change Plan Worksheet is a ready-to-send worksheet for practitioners helping clients change a substance-use or addictive behavior. It helps the client define the target change, reasons, supports, practical steps, and obstacles so intention becomes an actionable plan.",
		"demoTitle": "Build a sample change plan",
		"demoPrompt": "Interested in using Change Plan Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1259-f-087-smart-002-r001-change-plan-worksheet.md",
		"specId": "1259-f-087-smart-002-r001-change-plan-worksheet",
		"tags": {
			"framework": [
				"SMART Recovery"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Behavior change",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Action-Oriented Elements",
				"body": "The plan centers on target change, reasons, supports, steps, and obstacles."
			},
			{
				"title": "Incomplete Planning Areas",
				"body": "Vague targets or missing steps and supports remain visible so the practitioner can refine the plan with the client."
			},
			{
				"title": "Revisions",
				"body": "If a plan changes, prior versions or dated instances should remain distinguishable rather than silently overwritten."
			}
		],
		"faqItems": [
			{
				"question": "Is this a progress tracker?",
				"answer": "No. It creates a change pathway; it is not a progress tracker unless later follow-up fields are supplied."
			},
			{
				"question": "What does completion require?",
				"answer": "Completion should require at least a specific target change and one practical step or support, with exact validation depending on final fields."
			},
			{
				"question": "Can one worksheet cover several behaviors?",
				"answer": "No. Separate plan instances should be used for multiple target behaviors to keep pathways clear."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The fixed Change Plan Worksheet tool is saved. Fictional sample goals, supports, and steps from the demo are not saved as real client data."
			}
		]
	},
	{
		"toolType": "abcExercise",
		"slug": "abc-exercise",
		"title": "ABC Exercise Demo | Qwoach",
		"metaDescription": "Preview an ABC Exercise that maps activating situations, beliefs or interpretations, and consequences for substance-use recovery work.",
		"h1": "ABC Exercise for cognitive-behavioral formulation",
		"intro": "The ABC Exercise is a ready-to-send worksheet for practitioners working with substance-use or recovery-related behavior. It helps the client separate an activating situation, beliefs or interpretations, and emotional or behavioral consequences so the practitioner can identify a cognitive target for discussion.",
		"demoTitle": "Try the ABC mapping demo",
		"demoPrompt": "Interested in using ABC Exercise with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1260-f-087-smart-003-r001-abc-exercise.md",
		"specId": "1260-f-087-smart-003-r001-abc-exercise",
		"tags": {
			"framework": [
				"SMART Recovery"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Substance use",
				"Cognitive restructuring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "ABC Structure",
				"body": "The exercise separates activating event or situation, beliefs or interpretations, and consequences."
			},
			{
				"title": "Missing Or Conflated Components",
				"body": "If a component is missing or a belief is entered like an event, the product preserves the entry and keeps field separation visible for review."
			},
			{
				"title": "Repeated Use",
				"body": "Multiple ABC exercises can be reviewed chronologically to notice recurring situations or beliefs without scoring them."
			}
		],
		"faqItems": [
			{
				"question": "Does the ABC Exercise dispute beliefs automatically?",
				"answer": "No. It maps the situation, belief or interpretation, and consequence; it does not generate disputation or replacement beliefs."
			},
			{
				"question": "Can the belief field be incomplete?",
				"answer": "Yes. Missing components are shown as incomplete rather than inferred by the system."
			},
			{
				"question": "Is this a general diary or trigger log?",
				"answer": "No. It is a cognitive-behavioral ABC formulation exercise, not a general diary or broad trigger log."
			},
			{
				"question": "What gets saved after the demo?",
				"answer": "The fixed ABC Exercise tool is saved. Fictional sample ABC entries and demo target behavior content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "disputingIrrationalBeliefsDibs",
		"slug": "disputing-irrational-beliefs-dibs",
		"title": "Disputing Irrational Beliefs Worksheet | Qwoach",
		"metaDescription": "Explore a ready-to-send addiction recovery worksheet for capturing a belief, its challenge, and a recovery-oriented replacement belief.",
		"h1": "Disputing Irrational Beliefs (DIBs)",
		"intro": "Disputing Irrational Beliefs (DIBs) is a ready-to-send addiction recovery worksheet for practitioners. It helps a practitioner see a client's triggering belief, how the belief was challenged, and the replacement belief that may support recovery-oriented choices.",
		"demoTitle": "Try the worksheet with sample belief, challenge, and replacement-belief content.",
		"demoPrompt": "Interested in using Disputing Irrational Beliefs (DIBs) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1261-f-087-smart-004-r001-disputing-irrational-beliefs-dibs.md",
		"specId": "1261-f-087-smart-004-r001-disputing-irrational-beliefs-dibs",
		"tags": {
			"framework": [
				"SMART Recovery"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Substance use",
				"Cognitive restructuring",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a client needs to make one recovery-relevant belief visible enough to challenge and replace."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not diagnose irrationality, score belief quality, generate clinical interpretations, or classify beliefs into unsupported categories."
			}
		],
		"faqItems": [
			{
				"question": "Can the worksheet handle more than one belief?",
				"answer": "One belief should anchor each worksheet instance. If multiple beliefs come up, they should be separated into distinct worksheet instances to preserve specificity."
			},
			{
				"question": "Does the tool decide whether a belief is irrational?",
				"answer": "No. The tool organizes the reported belief, challenge, and replacement belief; interpretation remains practitioner-led."
			},
			{
				"question": "Can a client save a partial worksheet?",
				"answer": "Yes. Partial or draft states can be preserved and show which of the belief, challenge, or replacement belief fields are missing."
			}
		]
	},
	{
		"toolType": "urgeCravingCopingPlan",
		"slug": "urge-craving-coping-plan",
		"title": "Urge and Craving Coping Plan | Qwoach",
		"metaDescription": "Explore a ready-to-send addiction recovery plan for mapping likely urge situations to coping responses, supports, and review points.",
		"h1": "Urge / Craving Coping Plan",
		"intro": "Urge / Craving Coping Plan is a ready-to-send addiction recovery planning tool for practitioners and clients. It helps practitioners support clients by mapping likely urge or craving situations to specific coping responses, available supports, and real-world fit.",
		"demoTitle": "Create a sample urge situation and add coping responses.",
		"demoPrompt": "Interested in using Urge / Craving Coping Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1262-f-087-smart-005-r001-urge-craving-coping-plan.md",
		"specId": "1262-f-087-smart-005-r001-urge-craving-coping-plan",
		"tags": {
			"framework": [
				"SMART Recovery"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Coping",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before or between high-risk moments so the client has a concrete plan to try when urges or cravings arise."
			},
			{
				"title": "Repeat Use",
				"body": "Plans can be updated over time, with prior versions remaining reviewable enough to compare what changed."
			}
		],
		"faqItems": [
			{
				"question": "Does the plan score craving severity?",
				"answer": "No. The plan organizes situations, coping responses, and supports; it does not score craving severity or predict relapse risk."
			},
			{
				"question": "Can a plan be incomplete?",
				"answer": "Yes. Partial plans remain usable but are clearly marked when a situation does not yet have a coping response."
			},
			{
				"question": "Can the practitioner complete it with the client?",
				"answer": "Yes. The plan can be sent to the client or completed collaboratively while preserving client-reported content and practitioner notes separately."
			}
		]
	},
	{
		"toolType": "urgeLog",
		"slug": "urge-log",
		"title": "Urge Log for Addiction Recovery | Qwoach",
		"metaDescription": "Explore a ready-to-send urge tracking tool for recording recurring urges and reviewing descriptive timing, context, and change patterns.",
		"h1": "Urge Log",
		"intro": "Urge Log is a ready-to-send addiction recovery tracking tool for practitioners. It helps practitioners collect repeated client urge entries and review descriptive patterns in timing, context, frequency, and intensity where those details are reported.",
		"demoTitle": "Explore a sample logging window and add fictional urge entries.",
		"demoPrompt": "Interested in using Urge Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1263-f-087-smart-006-r001-urge-log.md",
		"specId": "1263-f-087-smart-006-r001-urge-log",
		"tags": {
			"framework": [
				"SMART Recovery"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Relapse prevention",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Missing Data",
				"body": "Missed days are not treated as no urges unless explicitly reported. Sparse data is shown descriptively."
			},
			{
				"title": "History",
				"body": "Continuing with the same logging structure preserves comparability across review windows."
			}
		],
		"faqItems": [
			{
				"question": "Does the Urge Log predict relapse risk?",
				"answer": "No. It records and descriptively summarizes reported urge entries; it does not generate relapse-risk predictions."
			},
			{
				"question": "What happens if the client misses entries?",
				"answer": "Missed periods are shown as missing or sparse data, not as proof that urges did not occur."
			},
			{
				"question": "Can the practitioner change the logging window?",
				"answer": "Yes. The logging period or frequency expectation is a real setting that defines the review window and supports comparable follow-up."
			}
		]
	},
	{
		"toolType": "problemSolvingWorksheet3",
		"slug": "problem-solving-worksheet-3",
		"title": "Problem-Solving Worksheet for Recovery | Qwoach",
		"metaDescription": "Explore a ready-to-send addiction recovery worksheet for defining one concrete problem and linking it to realistic next steps.",
		"h1": "Problem-Solving Worksheet",
		"intro": "Problem-Solving Worksheet is a ready-to-send addiction recovery worksheet for practitioners and clients. It helps define a concrete problem that is interfering with self-management or progress and connect it to realistic next steps for practitioner review.",
		"demoTitle": "Try a sample problem statement and add next steps.",
		"demoPrompt": "Interested in using Problem-Solving Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1264-f-087-smart-007-r001-problem-solving-worksheet.md",
		"specId": "1264-f-087-smart-007-r001-problem-solving-worksheet",
		"tags": {
			"framework": [
				"SMART Recovery"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Problem solving"
			],
			"topic": [
				"Substance use",
				"Problem solving"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One Problem At A Time",
				"body": "The worksheet works best when one concrete problem anchors the action path. Multiple problems should be separated or clearly split."
			},
			{
				"title": "Follow-Up",
				"body": "Prior problem/action worksheets can support later review of whether a chosen step reduced the problem's impact."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend solutions?",
				"answer": "No. The tool captures the client's problem and next steps; it does not generate recommendations."
			},
			{
				"question": "Can the worksheet be completed together?",
				"answer": "Yes. It can be sent to the client or completed collaboratively while preserving client-reported content and practitioner notes separately."
			},
			{
				"question": "What if the problem is too broad?",
				"answer": "The worksheet can show that the problem needs more specificity without supplying the content for the client."
			}
		]
	},
	{
		"toolType": "lifestyleBalanceValuesPlan",
		"slug": "lifestyle-balance-values-plan",
		"title": "Lifestyle Balance and Values Plan | Qwoach",
		"metaDescription": "Explore a recovery planning tool for capturing client-defined values, life-balance direction, recovery-supporting choices, and follow-up cues.",
		"h1": "Lifestyle Balance / Values Plan",
		"intro": "Lifestyle Balance / Values Plan is a ready-to-send addiction recovery planning tool for practitioners and clients. It helps capture client-defined values or priorities, desired life balance, and recovery-supporting choices that can guide follow-up goals.",
		"demoTitle": "Explore a sample values and lifestyle-direction plan.",
		"demoPrompt": "Interested in using Lifestyle Balance / Values Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1265-f-087-smart-008-r001-lifestyle-balance-values-plan.md",
		"specId": "1265-f-087-smart-008-r001-lifestyle-balance-values-plan",
		"tags": {
			"framework": [
				"SMART Recovery"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Values",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client-Defined Values",
				"body": "Values and priorities remain client-defined. The tool does not suggest what the client's values should be."
			},
			{
				"title": "Plan History",
				"body": "Prior versions can support longitudinal review when lifestyle direction changes over time."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool rate life balance?",
				"answer": "No. Balance is represented descriptively through client-defined priorities and recovery-supporting choices."
			},
			{
				"question": "Are domains fixed?",
				"answer": "No. Exact domains are unresolved, so the demo uses flexible life areas or priorities rather than a fixed taxonomy."
			},
			{
				"question": "Can the plan be drafted over time?",
				"answer": "Yes. Partial drafting and revision are supported because values-oriented content may take reflection."
			}
		]
	},
	{
		"toolType": "6QuestionsWorksheet",
		"slug": "6-questions-worksheet",
		"title": "6 Questions Worksheet for Recovery | Qwoach",
		"metaDescription": "Explore a fixed six-response recovery worksheet for capturing client reasoning around one decision, belief, or issue for practitioner review.",
		"h1": "6 Questions Worksheet",
		"intro": "6 Questions Worksheet is a ready-to-send addiction recovery reasoning worksheet for practitioners. It helps a practitioner review a client's reasoning about one decision, belief, or issue through six ordered responses, while keeping interpretation practitioner-led.",
		"demoTitle": "Explore the six-response worksheet with sample reasoning content.",
		"demoPrompt": "Interested in using 6 Questions Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1266-f-087-smart-009-r001-6-questions-worksheet.md",
		"specId": "1266-f-087-smart-009-r001-6-questions-worksheet",
		"tags": {
			"framework": [
				"SMART Recovery"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Structure",
				"body": "The worksheet has six ordered response areas. The number of questions is not configurable."
			},
			{
				"title": "Unresolved Prompt Text",
				"body": "Exact six-question wording is not defined in the supplied specification, so public demo prompts must remain placeholders until supplied."
			}
		],
		"faqItems": [
			{
				"question": "Are the exact six questions included?",
				"answer": "No. The exact question wording is unresolved, so the demo preserves six ordered response areas without inventing substantive prompts."
			},
			{
				"question": "Can the practitioner change it to five or seven questions?",
				"answer": "No. Six ordered questions define the worksheet identity."
			},
			{
				"question": "Does the worksheet recommend a decision?",
				"answer": "No. It organizes reasoning for practitioner-led discussion and does not produce recommendations or scores."
			}
		]
	},
	{
		"toolType": "smartRecoveryProgressReview",
		"slug": "smart-recovery-progress-review",
		"title": "SMART Recovery Progress Review Tool | Qwoach",
		"metaDescription": "Explore a joint recovery progress review tool for comparing multi-area self-management strengths, gaps, and changes over time.",
		"h1": "SMART Recovery Progress Review",
		"intro": "SMART Recovery Progress Review is a ready-to-complete-together review tool for addiction recovery practitioners. It helps practitioners and clients review multiple recovery self-management areas over time and identify strengths, gaps, and changes for ongoing support.",
		"demoTitle": "Compare a sample current review with a prior review baseline.",
		"demoPrompt": "Interested in using SMART Recovery Progress Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1267-f-087-smart-010-r001-smart-recovery-progress-review.md",
		"specId": "1267-f-087-smart-010-r001-smart-recovery-progress-review",
		"tags": {
			"framework": [
				"SMART Recovery"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Outcome monitoring",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "First Review",
				"body": "The first review has no historical comparison and should appear as a baseline state."
			},
			{
				"title": "Comparability",
				"body": "Future reviews should reuse the same structure where possible so descriptive change remains understandable."
			}
		],
		"faqItems": [
			{
				"question": "Is this a standalone client assignment?",
				"answer": "No. The specified default is a ready-to-complete-together joint review experience."
			},
			{
				"question": "Does the review generate a recovery stage?",
				"answer": "No. It shows descriptive strengths, gaps, and changes; it does not assign stages or automated recommendations."
			},
			{
				"question": "What if there is no prior review?",
				"answer": "The first review is shown as a baseline state without historical comparison."
			}
		]
	},
	{
		"toolType": "harmReductionGoalsForm",
		"slug": "harm-reduction-goals-form",
		"title": "Harm Reduction Goals Form | Qwoach",
		"metaDescription": "Explore a collaborative harm reduction form for capturing client-defined risk-reduction goals, context, readiness, and progress review notes.",
		"h1": "Harm Reduction Goals Form",
		"intro": "Harm Reduction Goals Form is a ready-to-complete-together planning form for practitioners and clients. It helps capture client-defined substance-related risk-reduction goals that fit the client's priorities, readiness, and context.",
		"demoTitle": "Create sample client-defined goals and review their clarity.",
		"demoPrompt": "Interested in using Harm Reduction Goals Form with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1268-f-088-hr-001-r001-harm-reduction-goals-form.md",
		"specId": "1268-f-088-hr-001-r001-harm-reduction-goals-form",
		"tags": {
			"framework": [
				"Harm reduction"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Substance use",
				"Behavior change",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Client Autonomy",
				"body": "Goals are recorded as client-defined. Practitioner-imposed goals should not be presented as client-defined content."
			},
			{
				"title": "Progress Review",
				"body": "Goals remain available for later review as priorities, readiness, or context change."
			}
		],
		"faqItems": [
			{
				"question": "Does the form require abstinence as the endpoint?",
				"answer": "No. The form supports client-defined risk-reduction goals and does not impose a single abstinence endpoint."
			},
			{
				"question": "Can a client decline to set a goal?",
				"answer": "Yes. The state should reflect no goal set rather than forcing completion."
			},
			{
				"question": "Does the tool rank goals clinically?",
				"answer": "No. It organizes goals and review readiness; it does not automatically rank or prioritize goals."
			}
		]
	},
	{
		"toolType": "substanceUseRiskContextMap",
		"slug": "substance-use-risk-context-map",
		"title": "Substance Use Risk Context Map | Qwoach",
		"metaDescription": "Explore a harm reduction mapping tool for organizing substance-use contexts, risk factors, protective factors, and safer conditions.",
		"h1": "Substance Use Risk Context Map",
		"intro": "Substance Use Risk Context Map is a ready-to-complete-together harm reduction mapping tool for practitioners and clients. It helps practitioners understand substance-use contexts, specific risk factors, protective or safer conditions, and areas needing risk-reduction attention.",
		"demoTitle": "Build a sample context map with risk and safety factors.",
		"demoPrompt": "Interested in using Substance Use Risk Context Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1269-f-088-hr-002-r001-substance-use-risk-context-map.md",
		"specId": "1269-f-088-hr-002-r001-substance-use-risk-context-map",
		"tags": {
			"framework": [
				"Harm reduction"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Behavior analysis"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Context First",
				"body": "The organizing unit is the use context. General substance-use descriptions are insufficient until connected to specific conditions."
			},
			{
				"title": "Unknowns",
				"body": "Unknown or omitted information remains unknown and is not treated as absence of risk."
			}
		],
		"faqItems": [
			{
				"question": "Does the map calculate a risk score?",
				"answer": "No. The map organizes reported risk and safety factors descriptively and does not calculate risk scores."
			},
			{
				"question": "Are context categories fixed?",
				"answer": "No. Exact context categories are unresolved, so the tool supports flexible context entry rather than mandatory categories."
			},
			{
				"question": "Can profiles be compared over time?",
				"answer": "Yes. History can compare context profiles over time when the same structure is preserved."
			}
		]
	},
	{
		"toolType": "overdoseRiskReview",
		"slug": "overdose-risk-review",
		"title": "Overdose Risk Review Tool | Qwoach",
		"metaDescription": "Explore a collaborative harm reduction review tool for organizing overdose risk factors, protective factors, and prevention targets.",
		"h1": "Overdose Risk Review",
		"intro": "Overdose Risk Review is a ready-to-complete-together harm reduction review tool for practitioners and clients. It helps practitioners organize client-specific overdose risk factors, reducing or protective factors, and practitioner-marked prevention or intervention targets.",
		"demoTitle": "Explore a sample review scope and mark fictional prevention targets.",
		"demoPrompt": "Interested in using Overdose Risk Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1270-f-088-hr-003-r001-overdose-risk-review.md",
		"specId": "1270-f-088-hr-003-r001-overdose-risk-review",
		"tags": {
			"framework": [
				"Harm reduction"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Crisis response"
			],
			"population": []
		},
		"sections": [
			{
				"title": "High-Stakes Incompleteness",
				"body": "Incomplete or unknown information is visibly marked and is not treated as low risk."
			},
			{
				"title": "Practitioner-Led Targets",
				"body": "Urgency and prevention targets are marked by the practitioner; the system does not generate automated clinical judgments."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool calculate overdose risk?",
				"answer": "No. The tool organizes reported factors and practitioner-marked targets; it does not compute an overdose risk score."
			},
			{
				"question": "Does it provide emergency instructions?",
				"answer": "No. Emergency protocols and automated escalation workflows are outside the supplied product specification."
			},
			{
				"question": "What happens when information is unknown?",
				"answer": "Unknown or not-yet-reviewed information remains visibly unknown and is not treated as low risk or absent risk."
			}
		]
	},
	{
		"toolType": "saferUsePlan",
		"slug": "safer-use-plan",
		"title": "Safer Use Plan for Harm-Reduction Practice | Qwoach",
		"metaDescription": "Explore a ready-to-send Safer Use Plan that helps practitioners organize client-reported risks, safer-use actions, barriers, and updates.",
		"h1": "Safer Use Plan",
		"intro": "The Safer Use Plan is a ready-to-send harm-reduction planning tool for practitioners working with clients who use substances. It helps the practitioner and client organize reported risks, practical safer-use actions, barriers, and follow-up updates without requiring abstinence as the only success condition.",
		"demoTitle": "Explore a sample Safer Use Plan",
		"demoPrompt": "Interested in using Safer Use Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1271-f-088-hr-004-r001-safer-use-plan.md",
		"specId": "1271-f-088-hr-004-r001-safer-use-plan",
		"tags": {
			"framework": [
				"Harm reduction"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when substance use is continuing and the immediate work is to reduce preventable harm in the client's real circumstances."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures reported risks, practical safer-use actions, barriers or needs if provided, and updates over time. It does not collect diagnostic interpretations or unsupported safety predictions."
			},
			{
				"title": "Review Over Time",
				"body": "Prior versions remain visible so the practitioner can compare what changed and discuss safety outcomes over time."
			}
		],
		"faqItems": [
			{
				"question": "Is the Safer Use Plan an abstinence plan?",
				"answer": "No. The Safer Use Plan is for practical harm reduction and does not require abstinence as the only success condition."
			},
			{
				"question": "Does the tool score client risk?",
				"answer": "No. The tool organizes reported risk context and safer-use actions but does not calculate unsupported scores or infer clinical risk levels."
			},
			{
				"question": "Can a client skip sensitive questions?",
				"answer": "Yes. The client can leave items unanswered, and partial plans remain visible as incomplete drafts."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The fixed Safer Use Plan tool is saved as-is. Fictional demo entries and sample client content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "naloxoneAccessOverdoseResponsePlan",
		"slug": "naloxone-access-overdose-response-plan",
		"title": "Naloxone Access and Overdose Response Plan | Qwoach",
		"metaDescription": "Explore a co-completed overdose response readiness plan for naloxone access, gaps, likely risk settings, supports, and review updates.",
		"h1": "Naloxone Access / Overdose Response Plan",
		"intro": "The Naloxone Access / Overdose Response Plan is a ready-to-complete-together tool for practitioners and clients when overdose risk is present. It helps clarify reported naloxone access, access gaps, likely overdose-risk settings, relevant supports or bystanders, and the intended response pathway.",
		"demoTitle": "Try the co-completion demo",
		"demoPrompt": "Interested in using Naloxone Access / Overdose Response Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1272-f-088-hr-005-r001-naloxone-access-overdose-response-plan.md",
		"specId": "1272-f-088-hr-005-r001-naloxone-access-overdose-response-plan",
		"tags": {
			"framework": [
				"Harm reduction"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Substance use",
				"Crisis response"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Maps",
				"body": "The plan maps reported naloxone access, access gaps, likely overdose-risk settings, support people or bystanders where applicable, and the intended response pathway."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not generate emergency medical instructions, guarantee reversal, calculate overdose-risk scores, or invent local protocol content."
			},
			{
				"title": "Follow-Up Use",
				"body": "Prior plans remain available so changes in naloxone access, risk settings, and support availability can be reviewed over time."
			}
		],
		"faqItems": [
			{
				"question": "Is this a naloxone training module?",
				"answer": "No. It is an overdose response readiness plan, not a training module or source of medical instructions."
			},
			{
				"question": "Can the plan show unknown naloxone access?",
				"answer": "Yes. Unknown access is shown as an unresolved gap rather than forced into a yes or no conclusion."
			},
			{
				"question": "Does the tool require support people?",
				"answer": "No. Support people or bystanders are considered where applicable, but the plan can reflect that no supports are identified."
			},
			{
				"question": "What gets saved?",
				"answer": "The fixed tool is saved into the practitioner's account. Fictional demo access details, risk settings, and support names are not saved as real client data."
			}
		]
	},
	{
		"toolType": "syringeEquipmentAccessPlan",
		"slug": "syringe-equipment-access-plan",
		"title": "Syringe and Equipment Access Plan Demo | Qwoach",
		"metaDescription": "Explore a co-completed access plan for safer-use supplies, reported risks, barriers, reachable resources, and ongoing follow-up status.",
		"h1": "Syringe / Equipment Access Plan",
		"intro": "The Syringe / Equipment Access Plan is a ready-to-complete-together tool for practitioners and clients when safer-use supplies are needed but access is uncertain. It helps organize reported risk context, relevant supplies or equipment, access barriers, reachable resources, and whether the pathway supports ongoing access.",
		"demoTitle": "Explore the access pathway demo",
		"demoPrompt": "Interested in using Syringe / Equipment Access Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1273-f-088-hr-006-r001-syringe-equipment-access-plan.md",
		"specId": "1273-f-088-hr-006-r001-syringe-equipment-access-plan",
		"tags": {
			"framework": [
				"Harm reduction"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures reported supply needs, the risks those needs relate to, access barriers, reachable resources, and whether the pathway supports ongoing access."
			},
			{
				"title": "Resource Uncertainty",
				"body": "Resource availability is recorded as reported or unresolved. The tool does not verify availability or invent service locations."
			},
			{
				"title": "Follow-Up Value",
				"body": "History helps the practitioner review whether access became more reliable or whether barriers remain."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool recommend specific supplies?",
				"answer": "No. It organizes supplies or equipment reported as relevant by the client and practitioner; it does not invent a supply list."
			},
			{
				"question": "Does it include a resource directory?",
				"answer": "No. The supplied specification does not support a built-in directory or verified resource availability."
			},
			{
				"question": "Can unresolved access barriers be saved in a plan?",
				"answer": "Yes. Unresolved needs and barriers remain visible for follow-up."
			},
			{
				"question": "What happens when I save the demo?",
				"answer": "The fixed tool is saved into your account. Fictional sample resources, barriers, and client content do not become real client data."
			}
		]
	},
	{
		"toolType": "healthSocialServiceLinkageMap",
		"slug": "health-social-service-linkage-map",
		"title": "Health and Social Service Linkage Map | Qwoach",
		"metaDescription": "Explore a co-created linkage map for client-recognized needs, priorities, supports, realistic next steps, barriers, and follow-up status.",
		"h1": "Health & Social Service Linkage Map",
		"intro": "The Health & Social Service Linkage Map is a ready-to-complete-together tool for practitioners and clients when health, social, or recovery needs extend beyond the immediate service. It helps organize client-recognized needs, priorities, readiness, selected supports, barriers, and a realistic next step.",
		"demoTitle": "Explore a sample linkage map",
		"demoPrompt": "Interested in using Health & Social Service Linkage Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1274-f-088-hr-007-r001-health-social-service-linkage-map.md",
		"specId": "1274-f-088-hr-007-r001-health-social-service-linkage-map",
		"tags": {
			"framework": [
				"Harm reduction"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Environmental barriers",
				"Service preferences"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Person-Directed Linkage",
				"body": "The map centers needs the client recognizes, readiness, priorities, and realistic next steps rather than imposing unsupported priorities."
			},
			{
				"title": "Follow-Up Status",
				"body": "The result can show reported pathway states such as planned, attempted, linked, or barrier remains when those states are entered."
			},
			{
				"title": "Limits",
				"body": "The tool does not determine eligibility, verify service availability, or provide broad directory functionality."
			}
		],
		"faqItems": [
			{
				"question": "Is this a referral directory?",
				"answer": "No. It is a person-directed linkage map, not a broad service directory."
			},
			{
				"question": "Can practitioner concerns be recorded?",
				"answer": "Yes, but client-recognized needs must remain distinct from practitioner concerns."
			},
			{
				"question": "What if there is no realistic next step yet?",
				"answer": "The map can preserve the barrier and unresolved state for follow-up."
			},
			{
				"question": "What is saved after the demo?",
				"answer": "The fixed linkage map tool is saved into the practitioner's account. Fictional demo needs, support options, and barriers are not saved as real client data."
			}
		]
	},
	{
		"toolType": "harmReductionProgressReview",
		"slug": "harm-reduction-progress-review",
		"title": "Harm Reduction Progress Review Tool | Qwoach",
		"metaDescription": "Explore a ready-to-send review for person-defined harm-reduction priorities, progress, setbacks, practical changes, and support needs.",
		"h1": "Harm Reduction Progress Review",
		"intro": "The Harm Reduction Progress Review is a ready-to-send tool for practitioners who need a longitudinal picture of person-defined harm-reduction outcomes. It helps capture current priorities, progress, setbacks, practical safety or well-being changes, and what support should continue or change next.",
		"demoTitle": "Explore a sample progress review",
		"demoPrompt": "Interested in using Harm Reduction Progress Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1275-f-088-hr-008-r001-harm-reduction-progress-review.md",
		"specId": "1275-f-088-hr-008-r001-harm-reduction-progress-review",
		"tags": {
			"framework": [
				"Harm reduction"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Substance use",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Person-Defined Outcomes",
				"body": "The review centers the client's own priorities and practical safety or well-being changes rather than fixed outcome domains."
			},
			{
				"title": "Setbacks Over Time",
				"body": "Setbacks are included as part of longitudinal review and are not treated as failure."
			},
			{
				"title": "First Review State",
				"body": "A first review creates a baseline and should not display unsupported trend claims."
			}
		],
		"faqItems": [
			{
				"question": "Is abstinence the only progress measure?",
				"answer": "No. The review captures practical harm-reduction changes that matter to the client, not only abstinence status."
			},
			{
				"question": "Does the tool score outcomes?",
				"answer": "No. The supplied specification does not support outcome scores or standardized measures."
			},
			{
				"question": "Can priorities change over time?",
				"answer": "Yes. Prior priorities are preserved while the current review can keep, revise, or mark them no longer relevant."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed review tool is saved. Fictional priorities, setbacks, and sample history are not saved as real client data."
			}
		]
	},
	{
		"toolType": "programHarmReductionPrinciplesReview",
		"slug": "program-harm-reduction-principles-review",
		"title": "Program Harm Reduction Principles Review | Qwoach",
		"metaDescription": "Explore a practitioner-only review for organizing harm-reduction program implementation strengths, gaps, improvement notes, and change over time.",
		"h1": "Program Harm Reduction Principles Review",
		"intro": "The Program Harm Reduction Principles Review is a practitioner-only tool for practitioners or program leads evaluating whether a program is implementing harm reduction in line with stated principles and practice areas. It helps organize implementation strengths, gaps, improvement notes, unresolved review areas, and changes across reviews.",
		"demoTitle": "Explore a sample program review",
		"demoPrompt": "Interested in using Program Harm Reduction Principles Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1276-f-088-hr-009-r001-program-harm-reduction-principles-review.md",
		"specId": "1276-f-088-hr-009-r001-program-harm-reduction-principles-review",
		"tags": {
			"framework": [
				"Harm reduction"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Quality review",
				"Progress review"
			],
			"topic": [
				"Service monitoring",
				"Fidelity monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "This tool is for program implementation review and does not include a client-facing experience."
			},
			{
				"title": "Strengths and Gaps",
				"body": "The review keeps strengths and gaps separate so improvement areas remain clear."
			},
			{
				"title": "No Scoring",
				"body": "The supplied specification does not support scores, benchmarks, or ratings."
			}
		],
		"faqItems": [
			{
				"question": "Is this used with clients?",
				"answer": "No. This is a practitioner-only program implementation review tool."
			},
			{
				"question": "Does the tool calculate a program score?",
				"answer": "No. It organizes strengths and gaps but does not calculate unsupported ratings or scores."
			},
			{
				"question": "Can reviews be compared over time?",
				"answer": "Yes. Historical reviews persist so implementation changes can be reviewed descriptively."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The fixed review tool is saved. Fictional demo observations and sample program content do not become real program data."
			}
		]
	},
	{
		"toolType": "seekingSafetySessionFormatWorksheet",
		"slug": "seeking-safety-session-format-worksheet",
		"title": "Seeking Safety Session Format Worksheet | Qwoach",
		"metaDescription": "Explore a practitioner-only worksheet shell for session process capture, departures from intended structure, notes, and cross-session comparison.",
		"h1": "Seeking Safety Session Format Worksheet",
		"intro": "The Seeking Safety Session Format Worksheet is a practitioner-only worksheet for practitioners delivering structured treatment sessions for co-occurring trauma and substance-use concerns. It helps record source-supported process elements when available, identify departures from the intended structure, add supervision or self-correction notes, and compare sessions over time.",
		"demoTitle": "Explore the worksheet shell",
		"demoPrompt": "Interested in using Seeking Safety Session Format Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1277-f-089-ssafe-001-r001-seeking-safety-session-format-worksheet.md",
		"specId": "1277-f-089-ssafe-001-r001-seeking-safety-session-format-worksheet",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Quality review",
				"Clinical documentation"
			],
			"topic": [
				"Fidelity monitoring",
				"Trauma",
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Unresolved Worksheet Structure",
				"body": "The demo uses placeholders for unresolved process elements and does not invent exact worksheet fields, sequence, or scoring."
			},
			{
				"title": "Practitioner-Only Use",
				"body": "The worksheet is used by the practitioner during or after a session and has no client-facing surface."
			},
			{
				"title": "Comparison Over Time",
				"body": "Historical worksheets can support comparison across sessions when the same fields are used."
			}
		],
		"faqItems": [
			{
				"question": "Does the demo include the full worksheet fields?",
				"answer": "No. Exact worksheet fields and process elements are unresolved, so the demo shows a worksheet shell without fabricated model content."
			},
			{
				"question": "Does the worksheet calculate fidelity scores?",
				"answer": "No. This worksheet records process information and departures; unsupported fidelity scores are not calculated."
			},
			{
				"question": "Is there a client view?",
				"answer": "No. The worksheet is practitioner-only."
			},
			{
				"question": "What is saved?",
				"answer": "The fixed worksheet tool is saved. Fictional session context, departure notes, and sample entries from the demo are not saved as real session data."
			}
		]
	},
	{
		"toolType": "seekingSafetyFidelityScale",
		"slug": "seeking-safety-fidelity-scale",
		"title": "Seeking Safety Fidelity Scale Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only fidelity scale shell for adherence evaluation, corrective notes, unresolved scoring, and later comparable reviews.",
		"h1": "Seeking Safety Fidelity Scale",
		"intro": "The Seeking Safety Fidelity Scale is a practitioner-only fidelity/adherence evaluation tool for practitioners reviewing structured treatment delivery for co-occurring trauma and substance-use concerns. It is intended to produce a fidelity profile from source-supported scale items and scoring rules; because exact items, forms, scoring, and interpretation are unresolved, the demo shows the interaction shell without.",
		"demoTitle": "Explore the fidelity scale shell",
		"demoPrompt": "Interested in using Seeking Safety Fidelity Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1278-f-089-ssafe-002-r001-seeking-safety-fidelity-scale.md",
		"specId": "1278-f-089-ssafe-002-r001-seeking-safety-fidelity-scale",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Quality review"
			],
			"topic": [
				"Fidelity monitoring",
				"Trauma",
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Unresolved Scale Content",
				"body": "The demo does not show fabricated items, response options, profile dimensions, thresholds, or scores."
			},
			{
				"title": "Form Comparability",
				"body": "If brief and long forms are supplied, comparisons should use the same form or clearly indicate form differences."
			},
			{
				"title": "Corrective-Action Notes",
				"body": "Practitioner notes can sit near the scale result but remain separate from ratings and system-derived profiles."
			}
		],
		"faqItems": [
			{
				"question": "Can the demo calculate a fidelity score?",
				"answer": "No. Scores are suppressed because exact items and scoring rules are not supplied."
			},
			{
				"question": "Are brief and long forms available in the demo?",
				"answer": "No. The record states that brief and long scales exist, but the exact forms are unresolved, so form selection cannot be completed in the demo."
			},
			{
				"question": "Is there a client-facing version?",
				"answer": "No. The fidelity scale is practitioner-only."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The fidelity scale tool itself is saved. Supported form configuration would be preserved when available, but fictional demo observations and notes are not saved as real fidelity data."
			}
		]
	},
	{
		"toolType": "safetyPlan2",
		"slug": "safety-plan-2",
		"title": "Safety Plan for Seeking Safety Context | Qwoach",
		"metaDescription": "Explore a co-completed Safety Plan for situation-specific risks, concrete protective steps, supports or resources, and review updates.",
		"h1": "Safety Plan",
		"intro": "The Safety Plan is a ready-to-complete-together tool for practitioners and clients addressing trauma and substance-use-related safety risks. It helps organize situation-specific risks, concrete protective steps, relevant supports or resources, and updates as risk circumstances change.",
		"demoTitle": "Explore a sample Safety Plan",
		"demoPrompt": "Interested in using Safety Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1279-f-089-ssafe-003-r001-safety-plan.md",
		"specId": "1279-f-089-ssafe-003-r001-safety-plan",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Trauma",
				"Substance use",
				"Crisis response"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Designed for High-Risk Usability",
				"body": "The result should stay concise enough to review during distress or relapse vulnerability."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures situation-specific risks, protective steps, supports or resources where relevant, unresolved areas, and updates over time."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not score risk, diagnose the client, guarantee safety, or invent crisis protocol content."
			}
		],
		"faqItems": [
			{
				"question": "Is this a crisis protocol?",
				"answer": "No. It is an individualized safety preparation plan and does not generate unsupported crisis protocol steps."
			},
			{
				"question": "Can the plan be incomplete?",
				"answer": "Yes. Partial plans preserve entries and clearly mark missing protective steps or supports."
			},
			{
				"question": "Can risks change over time?",
				"answer": "Yes. The plan can be updated while prior versions remain available for review."
			},
			{
				"question": "What is saved from the demo?",
				"answer": "The fixed Safety Plan tool is saved. Fictional risks, protective steps, supports, and sample plan content are not saved as real client data."
			}
		]
	},
	{
		"toolType": "groundingPlan",
		"slug": "grounding-plan",
		"title": "Grounding Plan for Present-Moment Stability | Qwoach",
		"metaDescription": "Explore a ready-to-send Grounding Plan for likely distress states, concrete client-identified strategies, real-use feedback, and updates.",
		"h1": "Grounding Plan",
		"intro": "The Grounding Plan is a ready-to-send tool for practitioners supporting clients with trauma and substance-use concerns who become overwhelmed, dissociated, triggered, or emotionally dysregulated outside session. It helps the client identify likely distress states, concrete grounding strategies they believe they can use, and later feedback on what worked in real situations.",
		"demoTitle": "Explore a sample Grounding Plan",
		"demoPrompt": "Interested in using Grounding Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1280-f-089-ssafe-004-r001-grounding-plan.md",
		"specId": "1280-f-089-ssafe-004-r001-grounding-plan",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Coping",
				"Trauma",
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Individualized Repertoire",
				"body": "The plan organizes strategies the client identifies as usable for their own likely distress states."
			},
			{
				"title": "Present-Moment Focus",
				"body": "The plan supports present-moment stabilization and does not prompt deeper trauma processing."
			},
			{
				"title": "Review in Real Situations",
				"body": "Later review can record whether strategies were used, helped, did not help, or need revision when the client reports that feedback."
			}
		],
		"faqItems": [
			{
				"question": "Does the Grounding Plan provide a technique library?",
				"answer": "No. The supplied specification supports an individualized repertoire, not a fixed library of grounding techniques."
			},
			{
				"question": "Does it ask for trauma narratives?",
				"answer": "No. The plan focuses on present-moment stabilization and does not collect deeper trauma-processing content."
			},
			{
				"question": "Can a vague strategy be revised?",
				"answer": "Yes. Strategies that are too vague or not usable can be marked for revision while history is preserved."
			},
			{
				"question": "What is saved into my account?",
				"answer": "The fixed Grounding Plan tool is saved. Fictional distress states, sample strategies, and demo feedback are not saved as real client data."
			}
		]
	},
	{
		"toolType": "redAndGreenFlags",
		"slug": "red-and-green-flags",
		"title": "Red and Green Flags Tool Demo | Qwoach",
		"metaDescription": "Explore a safety-focused Red and Green Flags profile for identifying client warning signs and protective factors in recovery treatment.",
		"h1": "Red and Green Flags",
		"intro": "Red and Green Flags is a ready-to-send tool for practitioners in safety-focused recovery treatment. It helps a practitioner and client identify client-specific conditions that increase danger and conditions that support safer recovery.",
		"demoTitle": "Explore the profile with sample red and green flag entries, then save the tool for use with clients.",
		"demoPrompt": "Interested in using Red and Green Flags with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1281-f-089-ssafe-005-r001-red-and-green-flags.md",
		"specId": "1281-f-089-ssafe-005-r001-red-and-green-flags",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when treatment needs a clear, revisitable distinction between personal warning signs and protective factors in a safety-focused recovery context."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures client-entered red flags, client-entered green flags, optional item context if provided, and practitioner notes kept separate from reported content."
			},
			{
				"title": "Limits",
				"body": "The tool does not produce a risk score, severity rating, automated interpretation, clinical conclusion, or predictive safety determination."
			}
		],
		"faqItems": [
			{
				"question": "Does Red and Green Flags score a client’s risk?",
				"answer": "No. Red and Green Flags organizes reported warning signs and protective factors; it does not score risk, predict danger, or assign severity levels."
			},
			{
				"question": "Can a client submit only red flags or only green flags?",
				"answer": "Yes. One-sided work can be saved and reviewed as incomplete, with the missing contrast clearly shown."
			},
			{
				"question": "Can the practitioner change the categories?",
				"answer": "No. The product specification supports the fixed Red Flags and Green Flags contrast, not additional categories or renamed labels."
			},
			{
				"question": "Is sample demo content saved to the practitioner’s account?",
				"answer": "No. Saving keeps the tool itself, while fictional demo entries and temporary sample history are not saved as real client data."
			}
		]
	},
	{
		"toolType": "copingWithTriggersPlan",
		"slug": "coping-with-triggers-plan",
		"title": "Coping with Triggers Plan Demo | Qwoach",
		"metaDescription": "Explore a trigger-to-coping plan that helps practitioners and clients map likely triggers to realistic coping responses for recovery support.",
		"h1": "Coping with Triggers Plan",
		"intro": "Coping with Triggers Plan is a ready-to-send tool for practitioners in safety-focused recovery treatment. It helps a practitioner and client identify destabilizing situations, cues, or internal states and link them to realistic coping responses.",
		"demoTitle": "Try a sample trigger-to-response map, then save the tool for your practice.",
		"demoPrompt": "Interested in using Coping with Triggers Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1282-f-089-ssafe-006-r001-coping-with-triggers-plan.md",
		"specId": "1282-f-089-ssafe-006-r001-coping-with-triggers-plan",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Coping",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this plan when predictable triggers may destabilize recovery and the client needs concrete coping options prepared in advance."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures client-specific triggers, linked coping responses, relevant context when provided, and practitioner review notes kept separate."
			},
			{
				"title": "Limits",
				"body": "The tool does not score trigger severity, rank clinical risk, recommend which coping response is best, or generate coping strategies on its own."
			}
		],
		"faqItems": [
			{
				"question": "Can one trigger have more than one coping response?",
				"answer": "Yes. The plan supports one or more coping responses for each trigger when multiple realistic options are useful."
			},
			{
				"question": "What happens if a trigger has no coping response yet?",
				"answer": "The trigger is saved as incomplete and remains visible as a follow-up need during review."
			},
			{
				"question": "Does the tool recommend coping strategies?",
				"answer": "No. Coping responses are entered by the client, practitioner, or collaboratively; the system does not generate unsupported coping prescriptions."
			},
			{
				"question": "Is demo trigger content saved to my account?",
				"answer": "No. Saving stores the tool itself, while fictional demo triggers and responses are not saved as client data."
			}
		]
	},
	{
		"toolType": "askingForHelpPlan",
		"slug": "asking-for-help-plan",
		"title": "Asking for Help Plan Demo | Qwoach",
		"metaDescription": "Explore a help-seeking plan that helps practitioners and clients identify who to contact, when to ask, and how to request support.",
		"h1": "Asking for Help Plan",
		"intro": "Asking for Help Plan is a ready-to-send tool for practitioners in safety-focused recovery treatment. It helps a practitioner and client identify specific supports, situations that warrant asking for help, and language or steps for making the request.",
		"demoTitle": "Explore sample help-seeking pathways, then save the tool for client use.",
		"demoPrompt": "Interested in using Asking for Help Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1283-f-089-ssafe-007-r001-asking-for-help-plan.md",
		"specId": "1283-f-089-ssafe-007-r001-asking-for-help-plan",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this plan when a client needs support but may not know who to ask, when to ask, or what to say or do."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures specific supports, situations that warrant contact, request language or steps, incomplete pathway cues, and practitioner review notes."
			},
			{
				"title": "Limits",
				"body": "The tool does not verify contacts, evaluate relationship quality, provide emergency protocols, or make automated recommendations about which supports are appropriate."
			}
		],
		"faqItems": [
			{
				"question": "Does Asking for Help Plan verify whether a support is available?",
				"answer": "No. The tool records help-seeking pathways entered by the client or practitioner; it does not verify availability or contact details."
			},
			{
				"question": "Can a pathway be saved before all parts are complete?",
				"answer": "Yes. Incomplete pathways remain visible with missing support, situation, or request-step cues."
			},
			{
				"question": "Can one situation have multiple support options?",
				"answer": "Yes. Multiple supports for one situation are supported when practical help options vary."
			},
			{
				"question": "Will sample support names from the demo be saved?",
				"answer": "No. Saving stores the fixed tool, not fictional demo pathways or sample support names."
			}
		]
	},
	{
		"toolType": "settingBoundariesPlan",
		"slug": "setting-boundaries-plan",
		"title": "Setting Boundaries Plan Demo | Qwoach",
		"metaDescription": "Explore a relationship-boundary plan that helps practitioners and clients map high-risk situations to boundaries, cues, and responses.",
		"h1": "Setting Boundaries Plan",
		"intro": "Setting Boundaries Plan is a ready-to-send tool for practitioners in safety-focused recovery treatment. It helps a practitioner and client identify high-risk relationship situations, define specific boundaries, recognize crossed-boundary cues, and name intended responses.",
		"demoTitle": "Try a sample boundary map, then save the tool for use with clients.",
		"demoPrompt": "Interested in using Setting Boundaries Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1284-f-089-ssafe-008-r001-setting-boundaries-plan.md",
		"specId": "1284-f-089-ssafe-008-r001-setting-boundaries-plan",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this plan when relationship situations may affect recovery and the client needs clearer boundaries and responses."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures situations, boundaries, crossed-boundary cues, intended responses, missing-element cues, and practitioner review notes."
			},
			{
				"title": "Limits",
				"body": "The tool does not assess relationship diagnoses, label people as safe or unsafe, provide legal advice, or decide whether a relationship should continue."
			}
		],
		"faqItems": [
			{
				"question": "Does Setting Boundaries Plan decide whether a relationship is safe?",
				"answer": "No. The tool organizes client- and practitioner-entered boundary planning content; it does not classify relationships automatically."
			},
			{
				"question": "Can sensitive relationship details be entered without real names?",
				"answer": "Yes. The product supports neutral labels or client-chosen wording for sensitive relationship content."
			},
			{
				"question": "Can incomplete boundary entries be saved?",
				"answer": "Yes. Incomplete entries are saved and marked with missing boundary, cue, or response parts for review."
			},
			{
				"question": "Is demo relationship content saved into my account?",
				"answer": "No. Saving stores the fixed tool, while fictional demo situations and sample notes are discarded."
			}
		]
	},
	{
		"toolType": "takingGoodCareOfYourselfPlan",
		"slug": "taking-good-care-of-yourself-plan",
		"title": "Taking Good Care of Yourself Plan Demo | Qwoach",
		"metaDescription": "Explore a self-care commitment plan that helps practitioners and clients define realistic commitments for recovery stability and follow-up.",
		"h1": "Taking Good Care of Yourself Plan",
		"intro": "Taking Good Care of Yourself Plan is a ready-to-send tool for practitioners in safety-focused recovery treatment. It helps a practitioner and client define specific self-care commitments that support emotional, physical, and recovery-related safety.",
		"demoTitle": "Explore sample self-care commitments, then save the tool for your practice.",
		"demoPrompt": "Interested in using Taking Good Care of Yourself Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1285-f-089-ssafe-009-r001-taking-good-care-of-yourself-plan.md",
		"specId": "1285-f-089-ssafe-009-r001-taking-good-care-of-yourself-plan",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this plan when daily self-care needs to become more concrete and observable in support of recovery stability."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures self-care commitments, optional gap or context notes, revisitability cues, practitioner review notes, and dated commitment history."
			},
			{
				"title": "Limits",
				"body": "The tool does not score wellness, define a universal self-care program, prescribe routines, or measure clinical outcomes."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool include self-care categories or ratings?",
				"answer": "No. The supplied product specification does not support fixed self-care domains, ratings, or scores."
			},
			{
				"question": "Can a vague self-care commitment be saved?",
				"answer": "Yes. Vague commitments can be saved and marked as needing clarification for review."
			},
			{
				"question": "Can commitments be revisited later?",
				"answer": "Yes. The tool supports dated commitments so they can be continued, revised, retired, or discussed during follow-up."
			},
			{
				"question": "Are demo commitments saved as client records?",
				"answer": "No. Saving stores the fixed tool, not fictional sample commitments or temporary demo history."
			}
		]
	},
	{
		"toolType": "recoveryThinkingWorksheet",
		"slug": "recovery-thinking-worksheet",
		"title": "Recovery Thinking Worksheet Demo | Qwoach",
		"metaDescription": "Explore a cognitive coping worksheet that links real situations, recovery-interfering thoughts, and recovery-supporting alternatives.",
		"h1": "Recovery Thinking Worksheet",
		"intro": "Recovery Thinking Worksheet is a ready-to-send tool for practitioners in recovery-oriented care. It helps a practitioner and client identify real situations, recovery-interfering thoughts or beliefs, and recovery-supporting alternative interpretations or responses.",
		"demoTitle": "Try sample situation-thought-alternative entries, then save the worksheet for client use.",
		"demoPrompt": "Interested in using Recovery Thinking Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1286-f-089-ssafe-010-r001-recovery-thinking-worksheet.md",
		"specId": "1286-f-089-ssafe-010-r001-recovery-thinking-worksheet",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Skill practice"
			],
			"topic": [
				"Cognitive restructuring",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this worksheet when recovery work needs a clearer view of situations and thoughts that may weaken coping or safety."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures actual situations, recovery-interfering thoughts or beliefs, recovery-supporting alternatives, missing-element cues, and practitioner notes."
			},
			{
				"title": "Limits",
				"body": "The worksheet does not assign cognitive distortion labels, score beliefs, generate reframes, or produce clinical conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does Recovery Thinking Worksheet generate alternative thoughts?",
				"answer": "No. Recovery-supporting alternatives are entered or approved by the client and practitioner; the system does not generate substantive reframes."
			},
			{
				"question": "Can a thought be saved without a situation?",
				"answer": "Yes. It can be saved as incomplete and marked for context during review."
			},
			{
				"question": "Does the worksheet use cognitive distortion labels?",
				"answer": "No. The supplied product specification does not support cognitive distortion taxonomies or labels."
			},
			{
				"question": "Will demo thoughts be saved as client data?",
				"answer": "No. Saving stores the fixed worksheet, not fictional demo thoughts, alternatives, or notes."
			}
		]
	},
	{
		"toolType": "commitmentPlan",
		"slug": "commitment-plan",
		"title": "Commitment Plan Demo | Qwoach",
		"metaDescription": "Explore a behavioral commitment plan that helps practitioners and clients turn recovery intentions into specific, revisitable action.",
		"h1": "Commitment Plan",
		"intro": "Commitment Plan is a ready-to-send tool for practitioners in safety-focused recovery treatment. It helps a practitioner and client form an explicit, personally meaningful behavioral commitment that supports safer recovery and can be revisited later.",
		"demoTitle": "Explore a sample commitment draft, then save the plan for use with clients.",
		"demoPrompt": "Interested in using Commitment Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1287-f-089-ssafe-011-r001-commitment-plan.md",
		"specId": "1287-f-089-ssafe-011-r001-commitment-plan",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Progress review"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this plan when a client’s recovery intention needs to become a concrete behavioral commitment that can guide action."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the commitment, optional alignment or realism context, completion cues, practitioner notes, and dated follow-up status."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide motivation scores, compliance scores, penalties, reminders, or a broad goal-management system."
			}
		],
		"faqItems": [
			{
				"question": "Is Commitment Plan a goal tracker?",
				"answer": "No. Commitment Plan is a bounded behavioral commitment tool, not a generic goal-management or task-tracking system."
			},
			{
				"question": "Can more than one commitment be entered?",
				"answer": "Yes, if each commitment remains explicit and manageable; the tool should not become a broad task list."
			},
			{
				"question": "Does the tool judge whether a commitment is realistic?",
				"answer": "No. Realism is reviewed by the practitioner and client; the system does not automatically reject commitments."
			},
			{
				"question": "Does saving keep the sample commitment?",
				"answer": "No. Saving keeps the fixed tool, while fictional demo commitments and notes are discarded."
			}
		]
	},
	{
		"toolType": "communityResourcesMap",
		"slug": "community-resources-map",
		"title": "Community Resources Map Demo | Qwoach",
		"metaDescription": "Explore a collaborative resource map for practitioners and clients to record relevant supports, roles, access steps, and practical notes.",
		"h1": "Community Resources Map",
		"intro": "Community Resources Map is a ready-to-complete-together tool for practitioners in safety-focused recovery treatment. It helps a practitioner and client identify relevant community supports, clarify each support’s role, and record practical access pathways for use outside the session.",
		"demoTitle": "Build a sample resource map, then save the tool for collaborative use.",
		"demoPrompt": "Interested in using Community Resources Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1288-f-089-ssafe-012-r001-community-resources-map.md",
		"specId": "1288-f-089-ssafe-012-r001-community-resources-map",
		"tags": {
			"framework": [
				"Seeking Safety"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this map when a client needs external supports for safety, recovery, or stabilization and needs practical access information."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures resource name, associated need, role, access or contact pathway, practical notes, missing-detail cues, and dated updates."
			},
			{
				"title": "Limits",
				"body": "The tool does not require an external resource database, infer eligibility, guarantee availability, or invent local resources."
			}
		],
		"faqItems": [
			{
				"question": "Does Community Resources Map find local resources automatically?",
				"answer": "No. The map organizes resources entered by the practitioner and client; it does not generate or verify local resources."
			},
			{
				"question": "Can resource details be marked uncertain?",
				"answer": "Yes. Uncertainty can be recorded as a practitioner/client note without claiming verification."
			},
			{
				"question": "Is this meant for clients to complete alone?",
				"answer": "No. The specified mode is ready-to-complete-together, with practitioner-guided collaborative entry and a client-visible result."
			},
			{
				"question": "Are demo resource names saved into my account?",
				"answer": "No. Saving stores the fixed tool, while fictional demo resources and temporary notes are discarded."
			}
		]
	},
	{
		"toolType": "recoveryStrategiesGoalWorksheet",
		"slug": "recovery-strategies-goal-worksheet",
		"title": "Recovery Strategies Goal Worksheet Demo | Qwoach",
		"metaDescription": "Explore an IMR recovery goal worksheet that helps practitioners and clients connect meaningful goals to concrete action steps.",
		"h1": "Recovery Strategies Goal Worksheet",
		"intro": "Recovery Strategies Goal Worksheet is a ready-to-send IMR tool for practitioners beginning illness management and recovery work. It helps a practitioner and client establish a personally meaningful recovery goal and a concrete action path for moving toward it.",
		"demoTitle": "Explore a sample goal-action plan, then save the worksheet for client use.",
		"demoPrompt": "Interested in using Recovery Strategies Goal Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1289-f-090-imr-001-r001-recovery-strategies-goal-worksheet.md",
		"specId": "1289-f-090-imr-001-r001-recovery-strategies-goal-worksheet",
		"tags": {
			"framework": [
				"Illness Management and Recovery"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Mental health conditions"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this worksheet near the beginning of IMR work to establish a recovery direction and practical next steps."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures a personally meaningful recovery goal, linked action steps, feasibility context if entered, progress notes, and dated history."
			},
			{
				"title": "Limits",
				"body": "The worksheet does not score goals, assign unsupported domains, generate treatment plans, or operate as a broad task manager."
			}
		],
		"faqItems": [
			{
				"question": "Does the worksheet score the quality of a recovery goal?",
				"answer": "No. The worksheet organizes the goal and action steps; it does not produce a goal score."
			},
			{
				"question": "Can a goal be saved before action steps are added?",
				"answer": "Yes. A goal without steps can be saved as a draft and marked as having an incomplete action path."
			},
			{
				"question": "Can more than one goal be entered?",
				"answer": "Yes, if each goal has its own action path and the result remains understandable."
			},
			{
				"question": "Will sample demo goals be saved to my account?",
				"answer": "No. Saving stores the fixed worksheet, while fictional demo goals and steps are discarded."
			}
		]
	},
	{
		"toolType": "knowledgeAboutMentalIllnessReview",
		"slug": "knowledge-about-mental-illness-review",
		"title": "Knowledge About Mental Illness Review Demo | Qwoach",
		"metaDescription": "Explore an IMR knowledge review that helps practitioners identify client knowledge gaps, concerns, and topics for psychoeducation.",
		"h1": "Knowledge About Mental Illness Review",
		"intro": "Knowledge About Mental Illness Review is a ready-to-send IMR tool for practitioners supporting illness management. It helps a practitioner understand what a client does and does not yet understand about mental illness, including concerns or possible misconceptions, so psychoeducation can be targeted.",
		"demoTitle": "Explore a sample knowledge review, then save the tool for use with clients.",
		"demoPrompt": "Interested in using Knowledge About Mental Illness Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1290-f-090-imr-002-r001-knowledge-about-mental-illness-review.md",
		"specId": "1290-f-090-imr-002-r001-knowledge-about-mental-illness-review",
		"tags": {
			"framework": [
				"Illness Management and Recovery"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Mental health conditions"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this review when psychoeducation should be guided by the client’s actual understanding, concerns, and illness-management needs."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures client-entered understanding, areas of confusion, concerns or worries, possible misconceptions when reported, and practitioner follow-up notes."
			},
			{
				"title": "Limits",
				"body": "The tool does not grade answers, determine correctness automatically, diagnose, score knowledge, or generate psychoeducation content."
			}
		],
		"faqItems": [
			{
				"question": "Is Knowledge About Mental Illness Review a test?",
				"answer": "No. It is a low-pressure review of understanding, gaps, concerns, and possible misconceptions, not a graded test."
			},
			{
				"question": "Does the tool choose diagnosis-specific questions?",
				"answer": "No. The supplied product specification does not support diagnosis-specific prompts or question banks."
			},
			{
				"question": "Can sparse responses be submitted?",
				"answer": "Yes. Sparse responses can be submitted and shown as limited detail for practitioner review."
			},
			{
				"question": "Are sample review answers saved as client data?",
				"answer": "No. Saving stores the fixed review tool, while fictional demo responses and notes are discarded."
			}
		]
	},
	{
		"toolType": "stressVulnerabilityModelMap",
		"slug": "stress-vulnerability-model-map",
		"title": "Stress-Vulnerability Model Map for IMR Work | Qwoach",
		"metaDescription": "Map client-specific stressors, vulnerabilities, treatment strategies, and wellness supports into a shared relapse and stability formulation.",
		"h1": "Stress-Vulnerability Model Map",
		"intro": "The Stress-Vulnerability Model Map is a collaborative formulation tool for mental health practitioners and clients managing mental illness. It helps them organize client-specific stressors, vulnerabilities, treatment strategies, and wellness factors into a shared explanation of relapse risk and stability supports.",
		"demoTitle": "Explore a sample map",
		"demoPrompt": "Interested in using Stress-Vulnerability Model Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1291-f-090-imr-003-r001-stress-vulnerability-model-map.md",
		"specId": "1291-f-090-imr-003-r001-stress-vulnerability-model-map",
		"tags": {
			"framework": [
				"Illness Management and Recovery"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Stress"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the map when stress, vulnerability, treatment strategies, and wellness supports need to be connected into a client-specific relapse/wellness formulation."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not diagnose, score vulnerability, calculate relapse probability, or infer clinical meaning beyond entered relationships."
			},
			{
				"title": "History Over Time",
				"body": "Reviewed maps can be retained so later updates show changed factors and formulation text descriptively, without implying quantitative change."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool predict relapse?",
				"answer": "No. It organizes reported stressors, vulnerabilities, supports, treatment strategies, and practitioner-entered formulation links; it does not calculate relapse probability."
			},
			{
				"question": "Can the client use it directly?",
				"answer": "Yes. The product includes a client-facing collaborative view, but the minimum product does not require a separate solo client workflow."
			},
			{
				"question": "What is saved to my account?",
				"answer": "The fixed Stress-Vulnerability Model Map tool is saved. Demo sample items and fictional formulation content are not saved as client data."
			}
		]
	},
	{
		"toolType": "socialSupportMap",
		"slug": "social-support-map",
		"title": "Social Support Map for Recovery Planning | Qwoach",
		"metaDescription": "Create a client social support profile showing existing supports, missing or weak supports, and recovery-relevant relationship priorities.",
		"h1": "Social Support Map",
		"intro": "The Social Support Map is a ready-to-send tool for mental health practitioners and clients managing mental illness. It helps identify existing supports, missing or weak supports, and which relationships or support sources matter for recovery and self-management.",
		"demoTitle": "Try the support map",
		"demoPrompt": "Interested in using Social Support Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1292-f-090-imr-004-r001-social-support-map.md",
		"specId": "1292-f-090-imr-004-r001-social-support-map",
		"tags": {
			"framework": [
				"Illness Management and Recovery"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The map captures support sources, whether support is available, missing, or weak, and how each support relates to recovery or self-management."
			},
			{
				"title": "Practitioner And Client Roles",
				"body": "The client can complete or update entries; the practitioner reviews, clarifies, and adds notes where appropriate."
			},
			{
				"title": "Repeat Use",
				"body": "Reviewed profiles can persist so changes in supports, gaps, or priorities are visible descriptively over time."
			}
		],
		"faqItems": [
			{
				"question": "Does the Social Support Map rate relationship quality?",
				"answer": "No. It groups client-reported support information by availability, gaps, weak points, and recovery relevance without unsupported ratings."
			},
			{
				"question": "Can the tool be completed in session?",
				"answer": "Yes. Although it is ready to send, practitioner-facilitated completion still preserves the purpose of creating a support profile."
			},
			{
				"question": "What information should be entered about other people?",
				"answer": "Only enough identifying detail for the client and practitioner to understand the support source should be entered."
			}
		]
	},
	{
		"toolType": "medicationDecisionEffectReview",
		"slug": "medication-decision-effect-review",
		"title": "Medication Experience and Barrier Review Tool | Qwoach",
		"metaDescription": "Review client-reported medication benefits, drawbacks, preferences, concerns, and barriers for collaborative treatment discussion.",
		"h1": "Medication Decision / Effect Review",
		"intro": "Medication Decision / Effect Review is a collaborative tool for mental health practitioners and clients managing mental illness. It helps organize the client's perceived medication effects, decisions, preferences, concerns, and barriers so they can support informed treatment discussion.",
		"demoTitle": "Review a sample medication discussion",
		"demoPrompt": "Interested in using Medication Decision / Effect Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1293-f-090-imr-005-r001-medication-decision-effect-review.md",
		"specId": "1293-f-090-imr-005-r001-medication-decision-effect-review",
		"tags": {
			"framework": [
				"Illness Management and Recovery"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Medication adherence"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Boundaries",
				"body": "The review captures reported experience and barriers. It does not recommend starting, stopping, changing, or dosing medication."
			},
			{
				"title": "Balanced Representation",
				"body": "Benefits and drawbacks can coexist, and client concerns or preferences remain visible in the summary."
			},
			{
				"title": "Longitudinal Use",
				"body": "Reviewed summaries can be compared descriptively over time to see changing experiences, barriers, or concerns."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool give medication advice?",
				"answer": "No. It organizes reported medication-use experience and barriers; follow-up or coordination decisions occur outside the tool."
			},
			{
				"question": "Can a client use it if they are not currently taking medication?",
				"answer": "Yes. The review can capture decisions, concerns, or barriers relevant to medication discussion without forcing active-use fields."
			},
			{
				"question": "Does it score adherence or effectiveness?",
				"answer": "No. It does not produce adherence scores, efficacy ratings, or causality determinations."
			}
		]
	},
	{
		"toolType": "substanceUseImpactReview",
		"slug": "substance-use-impact-review",
		"title": "Substance Use Impact Review for Recovery Work | Qwoach",
		"metaDescription": "Map how client-reported drug or alcohol patterns relate to symptoms, functioning, recovery stability, risks, and barriers.",
		"h1": "Substance Use Impact Review",
		"intro": "Substance Use Impact Review is a ready-to-send tool for mental health practitioners and clients managing mental illness. It helps clarify how drug or alcohol use relates to symptoms, functioning, recovery stability, risks, and barriers.",
		"demoTitle": "Explore the impact review",
		"demoPrompt": "Interested in using Substance Use Impact Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1294-f-090-imr-006-r001-substance-use-impact-review.md",
		"specId": "1294-f-090-imr-006-r001-substance-use-impact-review",
		"tags": {
			"framework": [
				"Illness Management and Recovery"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Substance use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The review captures recovery-relevant substance-use patterns, perceived effects on symptoms or functioning, and client-specific risks or barriers."
			},
			{
				"title": "Sensitive Content Handling",
				"body": "Sensitive or high-risk content is presented as reported information for practitioner follow-up, not as automated advice."
			},
			{
				"title": "Comparison Over Time",
				"body": "Reviewed results can be compared by changed patterns, impacts, or barriers, not by numeric trend."
			}
		],
		"faqItems": [
			{
				"question": "Does this review diagnose substance use disorder?",
				"answer": "No. It maps reported substance-use patterns to recovery impact and does not create diagnoses or severity scores."
			},
			{
				"question": "Can it be used if the client reports past use rather than current use?",
				"answer": "Yes. Past or affected-by-drugs/alcohol content can be captured when it is relevant to recovery."
			},
			{
				"question": "What happens if a pattern is entered without an impact?",
				"answer": "The entry is marked as needing clarification before final review, while the draft content is preserved."
			}
		]
	},
	{
		"toolType": "relapsePreventionPlan3",
		"slug": "relapse-prevention-plan-3",
		"title": "Relapse Prevention Plan for Early Warning Signs | Qwoach",
		"metaDescription": "Build a client-specific relapse prevention plan with warning signs, high-risk situations, early-response steps, and supports.",
		"h1": "Relapse Prevention Plan",
		"intro": "Relapse Prevention Plan is a ready-to-send planning tool for mental health practitioners and clients managing mental illness. It helps create a client-specific approach for recognizing relapse warning signs, identifying high-risk situations, and activating early responses and supports.",
		"demoTitle": "Build a sample plan",
		"demoPrompt": "Interested in using Relapse Prevention Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1295-f-090-imr-007-r001-relapse-prevention-plan.md",
		"specId": "1295-f-090-imr-007-r001-relapse-prevention-plan",
		"tags": {
			"framework": [
				"Illness Management and Recovery"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Completeness",
				"body": "A complete plan requires at least one warning sign or risk pattern and at least one response or support."
			},
			{
				"title": "Current And Prior Plans",
				"body": "Reviewed plans can be retained as dated current or prior plans so updates are clear over time."
			},
			{
				"title": "Scope",
				"body": "The tool remains a relapse prevention plan and does not expand into a generic safety plan, symptom tracker, or crisis workflow unless those exact elements are entered by the client and practitioner."
			}
		],
		"faqItems": [
			{
				"question": "Does the plan predict relapse?",
				"answer": "No. It organizes warning signs, risks, responses, and supports; it does not calculate relapse probability."
			},
			{
				"question": "Can a partial plan be saved?",
				"answer": "Yes. Partial entries are preserved as a draft and visibly marked incomplete until reviewed."
			},
			{
				"question": "Who finalizes the plan?",
				"answer": "The practitioner reviews the client draft with the client and can mark the plan as reviewed and current."
			}
		]
	},
	{
		"toolType": "stressManagementPlan",
		"slug": "stress-management-plan",
		"title": "Stress Management Plan for Recovery-Relevant Stress | Qwoach",
		"metaDescription": "Create an individualized coping plan by matching client priority stressors to realistic responses and feasibility notes.",
		"h1": "Stress Management Plan",
		"intro": "Stress Management Plan is a ready-to-send tool for mental health practitioners and clients managing mental illness. It helps identify priority stressors and match them with realistic coping responses that fit the client's abilities and context.",
		"demoTitle": "Try the coping plan",
		"demoPrompt": "Interested in using Stress Management Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1296-f-090-imr-008-r001-stress-management-plan.md",
		"specId": "1296-f-090-imr-008-r001-stress-management-plan",
		"tags": {
			"framework": [
				"Illness Management and Recovery"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Stress",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures priority stressors, coping responses, matches between them, and feasibility or context notes."
			},
			{
				"title": "Review Focus",
				"body": "Practitioner review focuses on whether responses are realistic and sufficiently matched to the client's situation."
			},
			{
				"title": "Revision Over Time",
				"body": "Reviewed plans can be compared by changed stressors, changed responses, or follow-up notes."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool provide coping skills instruction?",
				"answer": "No. It organizes client-entered stressors and coping responses; it does not add unsupported coping-skill content."
			},
			{
				"question": "Can a stressor be left unmatched?",
				"answer": "Yes. Unmatched stressors can remain in draft state and be flagged for practitioner follow-up."
			},
			{
				"question": "Does the plan score stress severity?",
				"answer": "No. The tool does not use stress scores or standardized coping ratings."
			}
		]
	},
	{
		"toolType": "persistentSymptomCopingPlan",
		"slug": "persistent-symptom-coping-plan",
		"title": "Persistent Symptom Coping Plan Tool | Qwoach",
		"metaDescription": "Create a symptom-specific self-management plan by matching persistent symptoms or recurring problems to feasible strategies.",
		"h1": "Persistent Symptom Coping Plan",
		"intro": "Persistent Symptom Coping Plan is a ready-to-send tool for mental health practitioners and clients managing mental illness. It helps identify persistent symptoms or recurring problems and match them with feasible self-management strategies and observable signs of improvement or relief.",
		"demoTitle": "Try a sample symptom plan",
		"demoPrompt": "Interested in using Persistent Symptom Coping Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1297-f-090-imr-009-r001-persistent-symptom-coping-plan.md",
		"specId": "1297-f-090-imr-009-r001-persistent-symptom-coping-plan",
		"tags": {
			"framework": [
				"Illness Management and Recovery"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Coping",
				"Mental health conditions"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Expected Signs",
				"body": "Expected signs of improvement or relief are descriptive cues entered by the client and practitioner, not automated outcome measurements."
			},
			{
				"title": "Flexible Matching",
				"body": "One strategy can be linked to multiple symptoms or problems when appropriate."
			},
			{
				"title": "Draft States",
				"body": "Symptoms without strategies or entries without clear expected signs can remain drafts for practitioner discussion."
			}
		],
		"faqItems": [
			{
				"question": "Does this plan diagnose symptoms?",
				"answer": "No. It captures symptoms or recurring problems as reported and organizes self-management strategies around them."
			},
			{
				"question": "Does it measure improvement automatically?",
				"answer": "No. Improvement or relief is represented through expected signs and follow-up observations, not automated evaluation."
			},
			{
				"question": "Can one strategy apply to more than one symptom?",
				"answer": "Yes. The tool can link one strategy to multiple symptoms or recurring problems when appropriate."
			}
		]
	},
	{
		"toolType": "mentalHealthSystemNeedsPlan",
		"slug": "mental-health-system-needs-plan",
		"title": "Mental Health System Needs and Advocacy Plan | Qwoach",
		"metaDescription": "Clarify unmet service needs, desired mental health system supports, advocacy steps, and contact paths in a practical plan.",
		"h1": "Mental Health System Needs Plan",
		"intro": "Mental Health System Needs Plan is a collaborative tool for mental health practitioners and clients managing mental illness. It helps clarify unmet service needs, desired supports or system responses, and realistic steps for raising those needs.",
		"demoTitle": "Plan a sample service need",
		"demoPrompt": "Interested in using Mental Health System Needs Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1298-f-090-imr-010-r001-mental-health-system-needs-plan.md",
		"specId": "1298-f-090-imr-010-r001-mental-health-system-needs-plan",
		"tags": {
			"framework": [
				"Illness Management and Recovery"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Problem solving",
				"Intervention planning"
			],
			"topic": [
				"Service preferences",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Captures",
				"body": "The plan captures unmet service needs, desired supports or responses, advocacy steps, barriers, and who to contact or how to raise the need."
			},
			{
				"title": "Unresolved Details",
				"body": "A need without a known contact path can remain draft and be marked unresolved for follow-up."
			},
			{
				"title": "Plan History",
				"body": "Reviewed plans can persist so continuing, resolved, or changed needs are visible descriptively over time."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool decide whether a client is eligible for services?",
				"answer": "No. It organizes needs and advocacy steps; it does not make eligibility or authorization decisions."
			},
			{
				"question": "Can a plan be created if the contact person is unknown?",
				"answer": "Yes. The contact path can be marked unresolved and the plan can remain draft for follow-up."
			},
			{
				"question": "Does the tool create referrals automatically?",
				"answer": "No. It creates a service-needs and self-advocacy plan, not an automated referral workflow."
			}
		]
	},
	{
		"toolType": "imrProgressReview",
		"slug": "imr-progress-review",
		"title": "IMR Progress Review for Longitudinal Recovery Work | Qwoach",
		"metaDescription": "Review recovery goals, self-management, functioning, strengths, and barriers over time with descriptive progress snapshots.",
		"h1": "IMR Progress Review",
		"intro": "IMR Progress Review is a collaborative tool for mental health practitioners and clients in ongoing illness management and recovery work. It helps capture dated snapshots of recovery goals, self-management, functioning, strengths, and barriers so ongoing care can be adjusted.",
		"demoTitle": "Compare sample snapshots",
		"demoPrompt": "Interested in using IMR Progress Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1299-f-090-imr-011-r001-imr-progress-review.md",
		"specId": "1299-f-090-imr-011-r001-imr-progress-review",
		"tags": {
			"framework": [
				"Illness Management and Recovery"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Goals",
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "First Review",
				"body": "The first real review appears as a baseline or current snapshot with no comparison until another reviewed snapshot exists."
			},
			{
				"title": "Comparisons",
				"body": "Comparisons are descriptive and limited to content areas present in reviewed snapshots; sparse information does not produce change summaries."
			},
			{
				"title": "History Integrity",
				"body": "Prior reviewed snapshots remain stable, with later updates added as new snapshots or clearly marked corrections."
			}
		],
		"faqItems": [
			{
				"question": "Does IMR Progress Review create a progress score?",
				"answer": "No. It compares recovery and self-management information descriptively and does not calculate global progress scores."
			},
			{
				"question": "What happens during the first review?",
				"answer": "The first review is saved as a baseline or current snapshot, with no prior comparison shown."
			},
			{
				"question": "Can prior reviewed snapshots be changed?",
				"answer": "Reviewed snapshots should remain stable; corrections or later updates should be clearly marked rather than silently overwriting history."
			}
		]
	},
	{
		"toolType": "rehabilitationReadinessAssessment",
		"slug": "rehabilitation-readiness-assessment",
		"title": "Rehabilitation Readiness Assessment Tool | Qwoach",
		"metaDescription": "Assess willingness, preparedness, practical capacity, and barriers for a rehabilitation goal with a reviewed readiness profile.",
		"h1": "Rehabilitation Readiness Assessment",
		"intro": "Rehabilitation Readiness Assessment is a collaborative tool for psychiatric rehabilitation practitioners and people considering a rehabilitation goal. It helps organize willingness, preparedness, practical capacity, and barriers into a readiness profile used to decide whether to proceed, pause, or develop readiness further.",
		"demoTitle": "Explore a readiness profile",
		"demoPrompt": "Interested in using Rehabilitation Readiness Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1300-f-091-psyr-001-r001-rehabilitation-readiness-assessment.md",
		"specId": "1300-f-091-psyr-001-r001-rehabilitation-readiness-assessment",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Readiness Domains",
				"body": "The assessment organizes willingness, preparedness, practical capacity, and barriers into a descriptive profile."
			},
			{
				"title": "Mixed Readiness",
				"body": "Willingness, preparedness, and barriers can point in different directions without forcing a single automated conclusion."
			},
			{
				"title": "Reassessment",
				"body": "Reviewed readiness profiles can be retained so changes in willingness, preparedness, or barriers are visible descriptively over time."
			}
		],
		"faqItems": [
			{
				"question": "Does this assessment score readiness?",
				"answer": "No. It creates a descriptive readiness profile and does not produce numeric readiness scores without a supplied scoring method."
			},
			{
				"question": "Can it be used before a specific rehabilitation goal is named?",
				"answer": "Yes, but the profile should remain draft or incomplete for goal-specific planning until the goal context is clear."
			},
			{
				"question": "Who decides whether to proceed, pause, or develop readiness?",
				"answer": "The planning direction is practitioner-entered or jointly reviewed; it is not automatically inferred by the system."
			}
		]
	},
	{
		"toolType": "readinessDevelopmentPlan",
		"slug": "readiness-development-plan",
		"title": "Readiness Development Plan Demo | Qwoach",
		"metaDescription": "Explore a psychiatric rehabilitation readiness plan that helps practitioners and people define concrete next steps before goal setting.",
		"h1": "Readiness Development Plan for Psychiatric Rehabilitation",
		"intro": "The Readiness Development Plan is a collaborative psychiatric rehabilitation tool for practitioners and people preparing for rehabilitation. It helps identify concrete readiness-development priorities and next steps tied to self-awareness, alternative-environment awareness, and support development.",
		"demoTitle": "Explore the shared plan with sample readiness areas",
		"demoPrompt": "Interested in using Readiness Development Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1301-f-091-psyr-002-r001-readiness-development-plan.md",
		"specId": "1301-f-091-psyr-002-r001-readiness-development-plan",
		"tags": {
			"framework": [
				"Psychiatric rehabilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before rehabilitation goal setting when readiness needs should be developed first."
			},
			{
				"title": "What It Produces",
				"body": "The result is a grouped readiness-development action plan, not a readiness score or diagnosis."
			},
			{
				"title": "Limitations",
				"body": "The tool is limited to self-awareness, alternative-environment awareness, and support development. It does not generate clinical conclusions or unsupported readiness scales."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score readiness?",
				"answer": "No. It produces readiness-development priorities and actions, not a readiness score."
			},
			{
				"question": "Can the person complete it alone?",
				"answer": "No. The specified experience is collaborative and practitioner-guided."
			},
			{
				"question": "What happens if a need has no action yet?",
				"answer": "It remains visible as unresolved instead of being hidden."
			},
			{
				"question": "Can I choose only one readiness area?",
				"answer": "Yes. The practitioner can select any relevant combination of the supported readiness areas."
			}
		]
	},
	{
		"toolType": "overallRehabilitationGoalOrg",
		"slug": "overall-rehabilitation-goal-org",
		"title": "Overall Rehabilitation Goal Demo | Qwoach",
		"metaDescription": "Explore an ORG tool for defining a self-determined 6- to 24-month psychiatric rehabilitation goal as a role in an environment.",
		"h1": "Overall Rehabilitation Goal (ORG) Tool",
		"intro": "The Overall Rehabilitation Goal (ORG) is a collaborative psychiatric rehabilitation tool for practitioners and people choosing a long-term direction. It helps define a self-determined 6- to 24-month destination as a desired role in a specific environment.",
		"demoTitle": "Build a sample ORG statement",
		"demoPrompt": "Interested in using Overall Rehabilitation Goal (ORG) with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1302-f-091-psyr-003-r001-overall-rehabilitation-goal-org.md",
		"specId": "1302-f-091-psyr-003-r001-overall-rehabilitation-goal-org",
		"tags": {
			"framework": [
				"Psychiatric rehabilitation"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What The ORG Includes",
				"body": "An ORG includes desired role, specific environment, and a 6- to 24-month horizon."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not generate the person's goal, infer preference from practitioner notes, assess skills, or prescribe supports."
			},
			{
				"title": "History",
				"body": "Prior ORG statements are preserved when goals change because later plans depend on which goal was active."
			}
		],
		"faqItems": [
			{
				"question": "Is the ORG generated by the system?",
				"answer": "No. The person supplies the preference content, and the system only structures and checks completeness."
			},
			{
				"question": "What timeframe is supported?",
				"answer": "The ORG uses a 6- to 24-month horizon."
			},
			{
				"question": "Are role and environment both required?",
				"answer": "Yes. The ORG is incomplete without both desired role and specific environment."
			},
			{
				"question": "Can domains like living or working be hidden?",
				"answer": "Yes. Domain prompts can be shown broadly or focused, but the goal still requires role, environment, and timeframe."
			}
		]
	},
	{
		"toolType": "criticalSkillsList",
		"slug": "critical-skills-list",
		"title": "Critical Skills List Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only tool for listing environment-specific critical skills before psychiatric rehabilitation functional assessment.",
		"h1": "Critical Skills List for Psychiatric Rehabilitation",
		"intro": "The Critical Skills List is a practitioner-only psychiatric rehabilitation tool for practitioners preparing functional assessment. It helps identify environment-specific skills a person must be able to use in a selected role and distinguish critical skills from nice-to-have abilities.",
		"demoTitle": "Create a sample critical skills list",
		"demoPrompt": "Interested in using Critical Skills List with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1303-f-091-psyr-004-r001-critical-skills-list.md",
		"specId": "1303-f-091-psyr-004-r001-critical-skills-list",
		"tags": {
			"framework": [
				"Psychiatric rehabilitation"
			],
			"toolType": [
				"Checklist"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Functioning and disability",
				"Occupational participation"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "This configuration is built for practitioner list creation. A practitioner may discuss the list outside the product, but no separate client workflow is defined."
			},
			{
				"title": "Required Context",
				"body": "Environment and role context are required because skills must be evaluated as environment-specific."
			},
			{
				"title": "Limitations",
				"body": "The tool does not rate the person's performance, infer critical skills automatically, or add unsupported skill taxonomies."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool evaluate the person's current skill use?",
				"answer": "No. It lists environment-specific skill requirements; evaluation belongs to a later tool."
			},
			{
				"question": "Can I keep nice-to-have skills?",
				"answer": "Yes. The setting can include non-critical candidate skills while keeping critical skills primary."
			},
			{
				"question": "What if a skill is too vague?",
				"answer": "It is marked needs clarification so it can be made observable before later evaluation."
			},
			{
				"question": "Is there a client view?",
				"answer": "No. The specified configuration is practitioner-only."
			}
		]
	},
	{
		"toolType": "skillUseDescription",
		"slug": "skill-use-description",
		"title": "Skill Use Description Demo | Qwoach",
		"metaDescription": "Explore a collaborative tool for defining observable criteria for one critical rehabilitation skill in a chosen environment.",
		"h1": "Skill Use Description for Psychiatric Rehabilitation",
		"intro": "The Skill Use Description is a collaborative psychiatric rehabilitation tool for practitioners and people clarifying an identified critical skill. It helps define operational criteria for successful use of that skill in a chosen environment.",
		"demoTitle": "Describe a sample critical skill",
		"demoPrompt": "Interested in using Skill Use Description with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1304-f-091-psyr-005-r001-skill-use-description.md",
		"specId": "1304-f-091-psyr-005-r001-skill-use-description",
		"tags": {
			"framework": [
				"Psychiatric rehabilitation"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Functioning and disability",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One Skill At A Time",
				"body": "The unit of work is one identified critical skill in one role/environment context."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures observable criteria, examples if entered, unresolved wording, and confirmation of shared understanding."
			},
			{
				"title": "Limitations",
				"body": "It does not score current functioning, infer criteria, create skill-teaching steps, or generate adequacy thresholds."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool assess whether the person can perform the skill?",
				"answer": "No. It defines criteria for successful use; performance evaluation is separate."
			},
			{
				"question": "Can it connect to a Critical Skills List?",
				"answer": "Yes. The practitioner can link to a prior Critical Skills List or create a standalone description."
			},
			{
				"question": "What if the criteria are not observable?",
				"answer": "The description remains incomplete or marked for clarification until observable criteria are entered."
			},
			{
				"question": "Can the person contribute wording?",
				"answer": "Yes. The specified experience is collaborative, and the person can contribute examples and confirm shared understanding."
			}
		]
	},
	{
		"toolType": "skillFunctioningEvaluation",
		"slug": "skill-functioning-evaluation",
		"title": "Skill Functioning Evaluation Demo | Qwoach",
		"metaDescription": "Explore a psychiatric rehabilitation tool for classifying required skills as spontaneous, prompted, not yet adequate, or unresolved.",
		"h1": "Skill Functioning Evaluation for Psychiatric Rehabilitation",
		"intro": "The Skill Functioning Evaluation is a collaborative psychiatric rehabilitation tool for practitioners and people reviewing required skills. It helps classify each skill as spontaneous use, prompted use, not yet adequate, or unresolved so the practitioner can see current capabilities and development needs.",
		"demoTitle": "Evaluate sample required skills",
		"demoPrompt": "Interested in using Skill Functioning Evaluation with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1305-f-091-psyr-006-r001-skill-functioning-evaluation.md",
		"specId": "1305-f-091-psyr-006-r001-skill-functioning-evaluation",
		"tags": {
			"framework": [
				"Psychiatric rehabilitation"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Functioning and disability",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Classifications",
				"body": "The native classifications are spontaneous use, prompted use, not yet adequate, and unresolved."
			},
			{
				"title": "Longitudinal Review",
				"body": "History can compare classifications over time while preserving the environment and criteria version used."
			},
			{
				"title": "Limitations",
				"body": "The tool does not add scores, automatically classify skills, generate clinical conclusions, or recommend interventions."
			}
		],
		"faqItems": [
			{
				"question": "Are classification counts scores?",
				"answer": "No. Counts and groupings are descriptive and are not treated as scores."
			},
			{
				"question": "Can skills be imported?",
				"answer": "Yes. Skills can be imported from a prior Critical Skills List or entered directly."
			},
			{
				"question": "What if a skill cannot be evaluated?",
				"answer": "It remains unresolved instead of being forced into a category."
			},
			{
				"question": "Does the tool recommend treatment?",
				"answer": "No. It produces a descriptive gap profile that can inform practitioner planning."
			}
		]
	},
	{
		"toolType": "supportNeedsAssessment",
		"slug": "support-needs-assessment",
		"title": "Support Needs Assessment Demo | Qwoach",
		"metaDescription": "Explore a collaborative psychiatric rehabilitation tool for identifying support needs and intervention targets tied to a chosen role or environment.",
		"h1": "Support Needs Assessment for Psychiatric Rehabilitation",
		"intro": "The Support Needs Assessment is a collaborative psychiatric rehabilitation tool for practitioners and people working with a chosen role or environment. It helps identify support needs and intervention targets linked to barriers, current supports, and the selected setting.",
		"demoTitle": "Map sample support needs",
		"demoPrompt": "Interested in using Support Needs Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1306-f-091-psyr-007-r001-support-needs-assessment.md",
		"specId": "1306-f-091-psyr-007-r001-support-needs-assessment",
		"tags": {
			"framework": [
				"Psychiatric rehabilitation"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Environmental barriers",
				"Service preferences"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Support Versus Skill",
				"body": "The tool can record distinctions between support needs and skill deficits when entered, and can preserve uncertainty when the distinction is unclear."
			},
			{
				"title": "Role And Environment Link",
				"body": "Support needs must be tied to the selected role or environment to keep the assessment concrete."
			},
			{
				"title": "Limitations",
				"body": "The tool does not prescribe resources, determine eligibility, score support adequacy, or infer support-versus-skill distinctions automatically."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool recommend specific resources?",
				"answer": "No. It identifies support needs and intervention targets but does not prescribe resources automatically."
			},
			{
				"question": "Can I start from prior skill gaps?",
				"answer": "Yes. The starting context can use prior skill gaps or begin from direct support discussion."
			},
			{
				"question": "What if a need may be both a skill deficit and a support need?",
				"answer": "It can be marked uncertain rather than forced into one category."
			},
			{
				"question": "Is client participation supported?",
				"answer": "Yes. The specified experience is collaborative and includes the person's barriers, preferences, and support perspective."
			}
		]
	},
	{
		"toolType": "skillDevelopmentPlan",
		"slug": "skill-development-plan",
		"title": "Skill Development Plan Demo | Qwoach",
		"metaDescription": "Explore a psychiatric rehabilitation tool for turning environment-specific skill gaps into actionable development steps and progress status.",
		"h1": "Skill Development Plan for Psychiatric Rehabilitation",
		"intro": "The Skill Development Plan is a collaborative psychiatric rehabilitation tool for practitioners and people working on skills required for a chosen environment. It helps select target skills from current gaps and define actionable development steps tied to use in context.",
		"demoTitle": "Plan sample skill-development steps",
		"demoPrompt": "Interested in using Skill Development Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1307-f-091-psyr-008-r001-skill-development-plan.md",
		"specId": "1307-f-091-psyr-008-r001-skill-development-plan",
		"tags": {
			"framework": [
				"Psychiatric rehabilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Skills use",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Plans",
				"body": "The plan focuses on skill acquisition steps for target skills tied to the chosen environment."
			},
			{
				"title": "Progress",
				"body": "Progress is tracked descriptively through status, notes, and later skill-use evidence, not unsupported scores."
			},
			{
				"title": "Limitations",
				"body": "The tool does not invent teaching content, prescribe practice methods, infer priorities automatically, or replace support planning."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate skill-teaching steps?",
				"answer": "No. Action steps are entered by the practitioner and person."
			},
			{
				"question": "Can it use a prior skill evaluation?",
				"answer": "Yes. The plan can build from a prior Skill Functioning Evaluation or be created manually."
			},
			{
				"question": "What if a target skill has no action step?",
				"answer": "It remains unresolved until at least one actionable step is added or the unresolved status is kept."
			},
			{
				"question": "Does the plan include environmental supports?",
				"answer": "No. It may reference context, but support planning is a separate workflow."
			}
		]
	},
	{
		"toolType": "environmentalSupportPlan",
		"slug": "environmental-support-plan",
		"title": "Environmental Support Plan Demo | Qwoach",
		"metaDescription": "Explore a psychiatric rehabilitation tool for matching environmental support strategies to barriers, support needs, and chosen settings.",
		"h1": "Environmental Support Plan for Psychiatric Rehabilitation",
		"intro": "The Environmental Support Plan is a collaborative psychiatric rehabilitation tool for practitioners and people planning supports for a chosen role or setting. It helps define a support strategy matched to specific barriers, support needs, sources or responsibilities, and the relationship to skill development.",
		"demoTitle": "Build a sample support strategy",
		"demoPrompt": "Interested in using Environmental Support Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1308-f-091-psyr-009-r001-environmental-support-plan.md",
		"specId": "1308-f-091-psyr-009-r001-environmental-support-plan",
		"tags": {
			"framework": [
				"Psychiatric rehabilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Strategy, Not Assessment",
				"body": "This tool turns identified barriers or support needs into support strategies. Assessment of needs is a separate workflow unless imported as context."
			},
			{
				"title": "Unknown Sources",
				"body": "If a support source or responsibility is not yet known, the strategy remains visible as unresolved."
			},
			{
				"title": "Limitations",
				"body": "The tool does not recommend resources automatically, infer responsibilities, determine eligibility, or create skill-teaching plans."
			}
		],
		"faqItems": [
			{
				"question": "Can the plan start from a Support Needs Assessment?",
				"answer": "Yes. It can import support needs from a prior assessment or be created standalone."
			},
			{
				"question": "Does the tool recommend providers or resources?",
				"answer": "No. Planned supports and responsibilities are entered by the practitioner and person."
			},
			{
				"question": "What if the support source is unknown?",
				"answer": "The support remains unresolved but visible for follow-up."
			},
			{
				"question": "How does it relate to skill development?",
				"answer": "The strategy should complement needed skill development and can record that relationship when entered."
			}
		]
	},
	{
		"toolType": "selfDirectedPsychiatricRehabilitationWorkbook",
		"slug": "self-directed-psychiatric-rehabilitation-workbook",
		"title": "Self-Directed Rehabilitation Workbook Demo | Qwoach",
		"metaDescription": "Explore a ready-to-send psychiatric rehabilitation workbook for person-driven goals, readiness, skills, supports, and priorities.",
		"h1": "Self-Directed Psychiatric Rehabilitation Workbook",
		"intro": "The Self-Directed Psychiatric Rehabilitation Workbook is a ready-to-send workbook for psychiatric rehabilitation practitioners and people working independently or between contacts. It helps the person organize their own goals, readiness, skills, supports, and priorities so the practitioner can review person-driven information.",
		"demoTitle": "Preview and configure workbook areas",
		"demoPrompt": "Interested in using Self-Directed Psychiatric Rehabilitation Workbook with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1309-f-091-psyr-010-r001-self-directed-psychiatric-rehabilitation-workbook.md",
		"specId": "1309-f-091-psyr-010-r001-self-directed-psychiatric-rehabilitation-workbook",
		"tags": {
			"framework": [
				"Psychiatric rehabilitation"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Between-session monitoring",
				"Assessment"
			],
			"topic": [
				"Goals",
				"Skills use"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Supported Areas",
				"body": "The workbook may include goals, readiness, skills, supports, priorities, or a supported subset."
			},
			{
				"title": "Self-Paced Completion",
				"body": "The person can save and resume, skip areas, mark unresolved areas, and review before sharing."
			},
			{
				"title": "Limitations",
				"body": "The public page must not invent worksheet prompts, ratings, scoring, substantive practice steps, or generated conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Can the practitioner choose which areas to include?",
				"answer": "Yes. The practitioner can include goals, readiness, skills, supports, priorities, or a supported subset."
			},
			{
				"question": "Does the demo show exact worksheet questions?",
				"answer": "No. Exact worksheet prompts and fields are unresolved, so the demo shows only supported area-level behavior."
			},
			{
				"question": "Can the person save and resume?",
				"answer": "Yes. The specified experience supports self-paced completion with save/resume behavior."
			},
			{
				"question": "Does the workbook score responses?",
				"answer": "No. It organizes person-entered information and completion status without scoring or interpretation."
			}
		]
	},
	{
		"toolType": "rehabilitationProgressReview",
		"slug": "rehabilitation-progress-review",
		"title": "Rehabilitation Progress Review Demo | Qwoach",
		"metaDescription": "Explore a recurring psychiatric rehabilitation review for progress, success or satisfaction, barriers, and descriptive comparison over time.",
		"h1": "Rehabilitation Progress Review for Psychiatric Rehabilitation",
		"intro": "The Rehabilitation Progress Review is a collaborative psychiatric rehabilitation tool for practitioners and people reviewing progress over time. It helps capture the current picture of progress, success or satisfaction, and remaining barriers in relation to the selected goal and environment.",
		"demoTitle": "Review sample progress over time",
		"demoPrompt": "Interested in using Rehabilitation Progress Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1310-f-091-psyr-011-r001-rehabilitation-progress-review.md",
		"specId": "1310-f-091-psyr-011-r001-rehabilitation-progress-review",
		"tags": {
			"framework": [
				"Psychiatric rehabilitation"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Goals",
				"Environmental barriers"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Recurring Review",
				"body": "Prior reviews remain available so current reviews can be compared over time within the same goal/environment context."
			},
			{
				"title": "Baseline Choice",
				"body": "The practitioner can compare with the last review, initial goal state, or another selected prior review."
			},
			{
				"title": "Limitations",
				"body": "The tool does not create the original goal, generate outcome scores, make causal claims, or decide whether support should continue, adjust, or redirect."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool decide whether to continue, adjust, or redirect support?",
				"answer": "No. It provides decision context; the practitioner makes the next-step decision."
			},
			{
				"question": "What if there is no prior review?",
				"answer": "The first review becomes a baseline and cannot show change yet."
			},
			{
				"question": "Can barriers remain uncategorized?",
				"answer": "Yes. Barriers that are not categorized as skill or support remain uncategorized rather than being forced."
			},
			{
				"question": "Does the review use standardized scores?",
				"answer": "No. It captures descriptive progress, success or satisfaction changes, and barriers without unsupported scoring."
			}
		]
	},
	{
		"toolType": "ipsCareerProfile",
		"slug": "ips-career-profile",
		"title": "IPS Career Profile Demo for Employment and Education Support | Qwoach",
		"metaDescription": "Explore an IPS Career Profile for organizing goals, strengths, experience, preferences, circumstances, and support needs for planning.",
		"h1": "IPS Career Profile",
		"intro": "The IPS Career Profile is a collaborative employment and education planning tool for practitioners supporting individualized services. It helps practitioners organize a person's goals, strengths, experience, preferences, circumstances, and support needs into a current profile for job or education matching decisions.",
		"demoTitle": "Explore a sample profile",
		"demoPrompt": "Interested in using IPS Career Profile with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1311-f-092-ips-001-r001-ips-career-profile.md",
		"specId": "1311-f-092-ips-001-r001-ips-career-profile",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a person is receiving individualized employment or education support and the practitioner needs enough person-specific information to guide planning."
			},
			{
				"title": "What It Captures",
				"body": "The profile organizes goals, strengths, experience, preferences, circumstances, and support needs. It does not collect unsupported ratings, scores, clinical conclusions, or automated job recommendations."
			},
			{
				"title": "History",
				"body": "Profiles can be partial or updated over time. Prior versions remain useful because preferences and circumstances may change."
			}
		],
		"faqItems": [
			{
				"question": "Does the IPS Career Profile recommend jobs?",
				"answer": "No. It organizes reported vocational information so the practitioner can use judgment in employment or education planning."
			},
			{
				"question": "Can the person complete it with the practitioner?",
				"answer": "Yes. The supplied configuration supports collaborative completion with plain-language prompts and the ability to skip unknown items."
			},
			{
				"question": "Are there configurable settings?",
				"answer": "No. The supplied record supports the fixed IPS Career Profile tool, not practitioner-defined settings."
			},
			{
				"question": "What happens to sample demo content when I save?",
				"answer": "Sample content is not saved as real client data. Saving adds the tool itself to the practitioner account."
			}
		]
	},
	{
		"toolType": "jobSearchPlan",
		"slug": "job-search-plan",
		"title": "Job Search Plan Demo for IPS Employment Support | Qwoach",
		"metaDescription": "Explore an IPS Job Search Plan that turns employment goals into target roles, target employers, and concrete next steps.",
		"h1": "Job Search Plan",
		"intro": "The Job Search Plan is a collaborative IPS employment planning tool for practitioners supporting people pursuing competitive employment. It helps turn a person's goals and preferences into target roles, target employers, and concrete next steps for active job search.",
		"demoTitle": "Explore a sample job search plan",
		"demoPrompt": "Interested in using Job Search Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1312-f-092-ips-002-r001-job-search-plan.md",
		"specId": "1312-f-092-ips-002-r001-job-search-plan",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Goal setting"
			],
			"topic": [
				"Career counseling",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when preference information needs to become an active search direction for competitive employment."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures employment goals, target roles, target employers, and concrete next steps. It does not provide employer scoring, labor-market predictions, or automated suitability rankings."
			},
			{
				"title": "Repeat Use",
				"body": "Plans can be revised as search learning occurs, while prior plan states remain useful for understanding how the direction changed."
			}
		],
		"faqItems": [
			{
				"question": "Does the Job Search Plan find employers automatically?",
				"answer": "No. The practitioner and person enter target roles, target employers, and next steps; the tool does not automate matching or ranking."
			},
			{
				"question": "Can the person participate in the plan?",
				"answer": "Yes. The person can confirm, reject, or refine targets and actions in the shared planning experience."
			},
			{
				"question": "What makes a plan ready for action?",
				"answer": "A plan is ready when targets and next steps are specific enough to guide practitioner and client action."
			}
		]
	},
	{
		"toolType": "employerContactLog",
		"slug": "employer-contact-log",
		"title": "Employer Contact Log Demo for IPS Job Development | Qwoach",
		"metaDescription": "Explore an IPS Employer Contact Log for recording employer outreach, contact purpose, outcomes, and activity patterns over time.",
		"h1": "Employer Contact Log",
		"intro": "The Employer Contact Log is a practitioner-only IPS job-development tracking tool for practitioners who contact employers. It helps record which employers were contacted, why the contact occurred, and what resulted so outreach patterns and follow-up needs are visible.",
		"demoTitle": "Explore a sample contact log",
		"demoPrompt": "Interested in using Employer Contact Log with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1313-f-092-ips-003-r001-employer-contact-log.md",
		"specId": "1313-f-092-ips-003-r001-employer-contact-log",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Service monitoring",
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it soon after employer contacts so purpose and outcome information stays accurate."
			},
			{
				"title": "What It Captures",
				"body": "The log captures employer contact activity, purpose or participant need, outcome, and follow-up-relevant notes at the level supported by the source form."
			},
			{
				"title": "Limitations",
				"body": "The log does not rate employers, automate outreach, or infer job-match quality."
			}
		],
		"faqItems": [
			{
				"question": "Is there a client-facing version of the Employer Contact Log?",
				"answer": "No. The supplied configuration is practitioner-only."
			},
			{
				"question": "Does the log score outreach quality?",
				"answer": "No. It records and descriptively groups activity; it does not create quality scores."
			},
			{
				"question": "Can incomplete contacts be saved?",
				"answer": "Yes. Contacts with unknown outcomes can be saved as incomplete and reviewed later."
			}
		]
	},
	{
		"toolType": "disclosureWorksheet",
		"slug": "disclosure-worksheet",
		"title": "Disclosure Worksheet Demo for Employment Support | Qwoach",
		"metaDescription": "Explore a Disclosure Worksheet for weighing pros and cons and documenting an employment disclosure choice and practical plan.",
		"h1": "Disclosure Worksheet",
		"intro": "The Disclosure Worksheet is a collaborative employment support tool for practitioners and people deciding whether, what, and how to disclose disability or service involvement to an employer. It helps weigh advantages and disadvantages and document the person's choice and practical approach.",
		"demoTitle": "Explore a sample disclosure worksheet",
		"demoPrompt": "Interested in using Disclosure Worksheet with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1314-f-092-ips-004-r001-disclosure-worksheet.md",
		"specId": "1314-f-092-ips-004-r001-disclosure-worksheet",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Career counseling",
				"Disclosure"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before employer contact, job start, or workplace support when disclosure choices could affect privacy, accommodations, or support."
			},
			{
				"title": "What It Captures",
				"body": "The worksheet captures advantages and disadvantages, the person's preference or unresolved status, what information may be shared, with whom, and the employment need or privacy concern involved."
			},
			{
				"title": "Limitations",
				"body": "The worksheet does not tell the person what to choose, score risk or benefit, or provide legal conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Does the Disclosure Worksheet recommend disclosure?",
				"answer": "No. It supports weighing advantages and disadvantages and documenting the person’s own preference."
			},
			{
				"question": "Can the decision remain unresolved?",
				"answer": "Yes. The worksheet can show an unresolved decision when the person is not ready to choose."
			},
			{
				"question": "Can the person revise their choice?",
				"answer": "Yes. The product supports revisiting the worksheet when employment context or preferences change."
			}
		]
	},
	{
		"toolType": "benefitsPlanningRecord",
		"slug": "benefits-planning-record",
		"title": "Benefits Planning Record Demo for IPS Employment Planning | Qwoach",
		"metaDescription": "Explore a Benefits Planning Record for documenting benefits concerns, offered planning, key decisions, and next steps before job start.",
		"h1": "Benefits Planning Record",
		"intro": "The Benefits Planning Record is a collaborative IPS documentation tool for practitioners supporting people considering or approaching work. It helps identify benefits-related concerns, document whether planning was offered before job start, and clarify decisions or next steps.",
		"demoTitle": "Explore a sample benefits planning record",
		"demoPrompt": "Interested in using Benefits Planning Record with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1315-f-092-ips-005-r001-benefits-planning-record.md",
		"specId": "1315-f-092-ips-005-r001-benefits-planning-record",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Clinical documentation"
			],
			"topic": [
				"Benefits planning",
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a person is considering or approaching work and benefits-related uncertainty could affect employment planning."
			},
			{
				"title": "What It Captures",
				"body": "The record captures benefits concerns, planning-offered status, key decisions, next steps, and unresolved items."
			},
			{
				"title": "Limitations",
				"body": "The record does not calculate benefit impacts, determine eligibility, or provide substantive benefits rules."
			}
		],
		"faqItems": [
			{
				"question": "Does the Benefits Planning Record calculate benefit changes?",
				"answer": "No. It documents concerns, planning status, decisions, and next steps; it does not calculate financial or eligibility outcomes."
			},
			{
				"question": "Can concerns remain unresolved?",
				"answer": "Yes. Unresolved concerns can be recorded and revisited later."
			},
			{
				"question": "Is there a shared client experience?",
				"answer": "Yes. The person can state concerns and review planning status and next steps with the practitioner."
			}
		]
	},
	{
		"toolType": "jobStartReport",
		"slug": "job-start-report",
		"title": "Job Start Report Demo for IPS Employment Outcomes | Qwoach",
		"metaDescription": "Explore a Job Start Report for recording role, employer, start details, and follow-up information for IPS outcome tracking.",
		"h1": "Job Start Report",
		"intro": "The Job Start Report is a practitioner-only IPS outcome capture tool for practitioners tracking when a person begins work. It helps record role, employer, start details, and support-relevant information needed for follow-up and program tracking.",
		"demoTitle": "Explore a sample job start report",
		"demoPrompt": "Interested in using Job Start Report with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1316-f-092-ips-006-r001-job-start-report.md",
		"specId": "1316-f-092-ips-006-r001-job-start-report",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a person begins a job and the employment outcome needs to be captured consistently."
			},
			{
				"title": "What It Captures",
				"body": "The report captures role, employer, start details, and immediate support-relevant information at the level supported by the source form."
			},
			{
				"title": "Limitations",
				"body": "The report does not manage onboarding, score job quality, or predict retention risk."
			}
		],
		"faqItems": [
			{
				"question": "Is the Job Start Report completed by the client?",
				"answer": "No. The supplied configuration is practitioner-only."
			},
			{
				"question": "Does it replace a Job Support Plan?",
				"answer": "No. It records the job start outcome and may inform early support coordination, but it is not the support plan."
			},
			{
				"question": "Can incomplete reports be saved?",
				"answer": "Yes. Incomplete reports can show missing outcome details for later completion."
			}
		]
	},
	{
		"toolType": "jobEndReport",
		"slug": "job-end-report",
		"title": "Job End Report Demo for IPS Employment Outcomes | Qwoach",
		"metaDescription": "Explore a Job End Report for recording duration, reason or circumstances, and next support implications after a job ends.",
		"h1": "Job End Report",
		"intro": "The Job End Report is a practitioner-only IPS outcome tool for practitioners tracking when a person's job ends. It helps record duration, reason or circumstances, and implications for future support or job matching.",
		"demoTitle": "Explore a sample job end report",
		"demoPrompt": "Interested in using Job End Report with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1317-f-092-ips-007-r001-job-end-report.md",
		"specId": "1317-f-092-ips-007-r001-job-end-report",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Clinical documentation",
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a job has ended and the practitioner needs a consistent outcome record for learning and tracking."
			},
			{
				"title": "What It Captures",
				"body": "The report captures job identity, duration when available, reason or circumstances, and implications for future support or job matching."
			},
			{
				"title": "Limitations",
				"body": "The report does not assign blame, evaluate performance, rate employers, or infer clinical meaning."
			}
		],
		"faqItems": [
			{
				"question": "Does the Job End Report determine why a job ended?",
				"answer": "No. It records the reason or circumstances available to the practitioner; it does not investigate or assign blame."
			},
			{
				"question": "Can the reason be unknown or disputed?",
				"answer": "Yes. Unknown or disputed reasons should remain visible rather than being forced into unsupported certainty."
			},
			{
				"question": "Is there a client-facing version?",
				"answer": "No. The supplied configuration is practitioner-only."
			}
		]
	},
	{
		"toolType": "jobSupportPlan",
		"slug": "job-support-plan",
		"title": "Job Support Plan Demo for IPS Retention Support | Qwoach",
		"metaDescription": "Explore a Job Support Plan for mapping job context, support preferences, retention risks or needs, and support responses.",
		"h1": "Job Support Plan",
		"intro": "The Job Support Plan is a collaborative IPS retention-support tool for practitioners helping a person who has obtained employment or is about to start work. It helps define support tied to the actual job, workplace demands, preferences, risks to retention, and support needs.",
		"demoTitle": "Explore a sample job support plan",
		"demoPrompt": "Interested in using Job Support Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1318-f-092-ips-008-r001-job-support-plan.md",
		"specId": "1318-f-092-ips-008-r001-job-support-plan",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Career counseling",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it before or after job start when ongoing support needs should be tied to the actual job and workplace."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures job context, workplace demands, support preferences, needs or risks, and support responses."
			},
			{
				"title": "Repeat Use",
				"body": "The active plan can be updated as workplace demands, preferences, or support needs change, while meaningful history is preserved."
			}
		],
		"faqItems": [
			{
				"question": "Does the Job Support Plan predict retention risk?",
				"answer": "No. It records risks or needs identified by the practitioner and person and maps them to support responses."
			},
			{
				"question": "Can the person choose limited practitioner involvement?",
				"answer": "Yes. The plan should reflect the person’s preferences about practitioner involvement and workplace support."
			},
			{
				"question": "Is workplace sharing automatic?",
				"answer": "No. Workplace sharing is not a default product behavior unless separately decided as part of the support approach."
			}
		]
	},
	{
		"toolType": "transitionPlan",
		"slug": "transition-plan",
		"title": "Transition Plan Demo for IPS Continuity Support | Qwoach",
		"metaDescription": "Explore a Transition Plan for preserving employment or education support across services, providers, or support phases.",
		"h1": "Transition Plan",
		"intro": "The Transition Plan is a collaborative IPS continuity tool for practitioners supporting people moving between services, providers, or phases of support. It helps preserve employment or education support by mapping the transition context, ongoing goal, responsibilities, supports to hand off, and practical next step.",
		"demoTitle": "Explore a sample transition plan",
		"demoPrompt": "Interested in using Transition Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1319-f-092-ips-009-r001-transition-plan.md",
		"specId": "1319-f-092-ips-009-r001-transition-plan",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Transition planning",
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it when a change in service, provider, or support phase could interrupt employment or education support."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures transition context, ongoing goal, responsibilities, supports to preserve or hand off, unresolved gaps, and a practical next step."
			},
			{
				"title": "Limitations",
				"body": "The tool stays bounded to vocational support continuity and does not replace discharge planning, scheduling, or referral management."
			}
		],
		"faqItems": [
			{
				"question": "Is the Transition Plan a discharge plan?",
				"answer": "No. It is limited to preserving employment or education support through a transition."
			},
			{
				"question": "Can responsibilities remain unresolved?",
				"answer": "Yes. Unresolved responsibility gaps can remain visible until they are clarified."
			},
			{
				"question": "Does the person see the plan?",
				"answer": "Yes. The shared experience shows the transition path, continued goal, support responsibilities, and next step in plain terms."
			}
		]
	},
	{
		"toolType": "ipsFidelityScale",
		"slug": "ips-fidelity-scale",
		"title": "IPS Fidelity Scale Demo for Program Quality Review | Qwoach",
		"metaDescription": "Explore an IPS Fidelity Scale workflow for program review, completion tracking, fidelity profile review, and comparison over time.",
		"h1": "IPS Fidelity Scale",
		"intro": "The IPS Fidelity Scale is a practitioner-only program assessment tool for reviewers, practitioners, and program leads responsible for IPS quality improvement. It helps assess how closely a program is operating according to the IPS model and produce a fidelity profile showing implementation strengths and gaps.",
		"demoTitle": "Explore a sample fidelity review",
		"demoPrompt": "Interested in using IPS Fidelity Scale with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1320-f-092-ips-010-r001-ips-fidelity-scale.md",
		"specId": "1320-f-092-ips-010-r001-ips-fidelity-scale",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Quality review"
			],
			"topic": [
				"Fidelity monitoring",
				"Service monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use it for periodic program-level review when a practitioner, reviewer, or program lead needs to understand IPS implementation strengths and gaps."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures source-defined fidelity item responses or ratings, evidence notes if supported, review context, scale version, and resulting profile information."
			},
			{
				"title": "Comparison",
				"body": "Completed reviews can be compared over time or across reviews when scale versions and review methods are comparable."
			},
			{
				"title": "Limitations",
				"body": "The tool does not invent fidelity items, scoring anchors, dimensions, or improvement recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Can I customize the fidelity items?",
				"answer": "No. Items, scoring anchors, domains, totals, and thresholds must come from the selected source scale."
			},
			{
				"question": "Can a partial review produce a final profile?",
				"answer": "No. Partial reviews show incomplete items and cannot be treated as final fidelity profiles."
			},
			{
				"question": "Is there a client-facing view?",
				"answer": "No. The supplied configuration is practitioner-only and program-level."
			},
			{
				"question": "What is saved if I choose a scale version?",
				"answer": "The tool and selected source-supported scale version are saved; fictional demo ratings and sample observations are not saved as real program data."
			}
		]
	},
	{
		"toolType": "ipsFidelityActionPlan",
		"slug": "ips-fidelity-action-plan",
		"title": "IPS Fidelity Action Plan for Implementation Improvement | Qwoach",
		"metaDescription": "Turn IPS fidelity findings or implementation gaps into prioritized improvement targets, owner accountability, next steps, and follow-up expectations.",
		"h1": "IPS Fidelity Action Plan",
		"intro": "The IPS Fidelity Action Plan is a practitioner-only implementation improvement tool for practitioners responsible for improving evidence-based employment programs. It helps them convert IPS fidelity findings or implementation gaps into prioritized targets, concrete next steps, owners or team roles, and follow-up expectations.",
		"demoTitle": "Explore a sample action plan and save the tool for your practice.",
		"demoPrompt": "Interested in using IPS Fidelity Action Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1321-f-092-ips-011-r001-ips-fidelity-action-plan.md",
		"specId": "1321-f-092-ips-011-r001-ips-fidelity-action-plan",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Fidelity monitoring",
				"Service monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the plan when fidelity findings or implementation gaps show that supported employment practice is not yet where it needs to be."
			},
			{
				"title": "What It Tracks",
				"body": "The plan tracks the concern, priority, urgency or development distinction, improvement target, next step, owner or team role, follow-up expectation, and progress review state."
			},
			{
				"title": "Important Limits",
				"body": "The tool organizes practitioner-supplied improvement planning. It does not calculate fidelity scores, interpret clinical outcomes, prescribe IPS practice changes, or make outcome-causality claims."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score IPS fidelity?",
				"answer": "No. The tool organizes action planning after fidelity findings or implementation gaps are known; it does not calculate or interpret fidelity scores."
			},
			{
				"question": "Can staff members be assigned work in the plan?",
				"answer": "Yes. The practitioner can name an accountable owner or team role, but the product remains practitioner-controlled and does not create a separate staff workflow."
			},
			{
				"question": "Can partial action plans be saved?",
				"answer": "Yes. Concerns can be saved before every planning field is complete, with missing targets, owners, next steps, or follow-up expectations clearly marked."
			}
		]
	},
	{
		"toolType": "supervisorDataTable",
		"slug": "supervisor-data-table",
		"title": "Supervisor Data Table for IPS Program Tracking | Qwoach",
		"metaDescription": "Review IPS program indicators, staff or caseload patterns, outcome data, missing entries, follow-up areas, and longitudinal changes in one table.",
		"h1": "Supervisor Data Table",
		"intro": "The Supervisor Data Table is a practitioner-only operational program dashboard for employment-support program supervisors. It helps supervisors review program indicators, caseload movement, outcome data, staff or team patterns, bottlenecks, missing data, and follow-up needs over time.",
		"demoTitle": "Explore the sample supervisor table and save it for your program.",
		"demoPrompt": "Interested in using Supervisor Data Table with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1322-f-092-ips-012-r001-supervisor-data-table.md",
		"specId": "1322-f-092-ips-012-r001-supervisor-data-table",
		"tags": {
			"framework": [
				"Vocational rehabilitation"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Service monitoring",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the table during supervision, program management review, and periodic longitudinal review of the same operational indicators."
			},
			{
				"title": "What It Captures",
				"body": "The table captures program or supervisor-level indicators, staff/team or caseload grouping when present, outcome data used by the program, reporting period, missing-data status, and practitioner-marked follow-up areas."
			},
			{
				"title": "Important Limits",
				"body": "The table does not invent indicators, determine staff quality, explain causality, or make employment-outcome claims beyond recorded operational data."
			}
		],
		"faqItems": [
			{
				"question": "Can this table compare data over time?",
				"answer": "Yes. The table supports longitudinal review when indicator definitions remain comparable across reporting periods."
			},
			{
				"question": "Does the system decide which patterns need supervision?",
				"answer": "No. The system may highlight descriptive differences or missing data, but the supervisor decides what requires follow-up."
			},
			{
				"question": "Does it require staff-level data?",
				"answer": "No. Staff/team or caseload grouping can be used when data exists, but the table must still function at program level."
			}
		]
	},
	{
		"toolType": "wellnessToolbox",
		"slug": "wellness-toolbox",
		"title": "Wellness Toolbox for Self-Directed Recovery Planning | Qwoach",
		"metaDescription": "Help a person create a personal inventory of wellness resources, supports, and strategies they can reuse in later recovery and wellness planning.",
		"h1": "Wellness Toolbox",
		"intro": "The Wellness Toolbox is a ready-to-send self-directed recovery and wellness inventory for practitioners supporting a person in recovery planning. It helps the person identify their own wellness resources, supports, and strategies so those items can be reused in later planning.",
		"demoTitle": "Preview the activity, add sample supports, and save the tool.",
		"demoPrompt": "Interested in using Wellness Toolbox with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1323-f-093-wrap-001-r001-wellness-toolbox.md",
		"specId": "1323-f-093-wrap-001-r001-wellness-toolbox",
		"tags": {
			"framework": [
				"WRAP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Coping",
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this before or alongside later recovery planning when the person needs a practical inventory of what supports their wellbeing."
			},
			{
				"title": "Practitioner And Person Roles",
				"body": "The practitioner initiates and reviews. The person authors and revises the inventory in their own language."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not score, rank, prescribe strategies, or add unsupported worksheet categories."
			}
		],
		"faqItems": [
			{
				"question": "Does the Wellness Toolbox recommend coping strategies?",
				"answer": "No. It organizes the person's own resources, supports, and strategies; it is not a recommendation engine."
			},
			{
				"question": "Can the person revise the inventory later?",
				"answer": "Yes. The inventory can be updated over time as the person learns what is useful or practical."
			},
			{
				"question": "Is there a separate practitioner configuration?",
				"answer": "No. The tool is fixed and ready to send; saving still saves the tool itself."
			}
		]
	},
	{
		"toolType": "dailyPlan",
		"slug": "daily-plan",
		"title": "Daily Plan for Baseline Wellness and Daily Maintenance | Qwoach",
		"metaDescription": "Help a person describe ordinary wellness and daily supports or routines so future recovery check-ins can reference a shared baseline.",
		"h1": "Daily Plan",
		"intro": "The Daily Plan is a ready-to-send self-directed recovery planning tool for practitioners supporting a person in wellness planning. It helps the person describe what being well ordinarily looks like and which daily supports or routines help maintain that state.",
		"demoTitle": "Preview the Daily Plan and save it for later use.",
		"demoPrompt": "Interested in using Daily Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1324-f-093-wrap-002-r001-daily-plan.md",
		"specId": "1324-f-093-wrap-002-r001-daily-plan",
		"tags": {
			"framework": [
				"WRAP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the Daily Plan when a shared baseline is needed for future recovery check-ins and daily maintenance planning."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures the person's ordinary wellness description, daily supports or routines, and optional notes about when additional support may be needed."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create symptom scores, diagnostic interpretations, habit streaks, or automated monitoring conclusions."
			}
		],
		"faqItems": [
			{
				"question": "Is the Daily Plan a habit tracker?",
				"answer": "No. It captures a baseline wellness picture and daily maintenance supports or routines; it does not track streaks or generic habits."
			},
			{
				"question": "What is required for completion?",
				"answer": "A completed Daily Plan requires a baseline wellness description and at least one daily support or routine."
			},
			{
				"question": "Can partial work be saved?",
				"answer": "Yes. Either the baseline or routine section can be saved while the missing part remains clearly marked."
			}
		]
	},
	{
		"toolType": "stressorsActionPlan",
		"slug": "stressors-action-plan",
		"title": "Stressors & Action Plan for Self-Directed Recovery | Qwoach",
		"metaDescription": "Help a person identify personal stressors and match each one to preferred responses, supports, or actions they can use before stress escalates.",
		"h1": "Stressors & Action Plan",
		"intro": "The Stressors & Action Plan is a ready-to-send self-directed recovery tool for practitioners helping a person understand stress-related setbacks. It helps the person identify stressors in their own context and match each stressor to preferred responses, supports, or actions.",
		"demoTitle": "Try the stressor-response map and save the tool.",
		"demoPrompt": "Interested in using Stressors & Action Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1325-f-093-wrap-003-r001-stressors-action-plan.md",
		"specId": "1325-f-093-wrap-003-r001-stressors-action-plan",
		"tags": {
			"framework": [
				"WRAP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Stress",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this when a person can identify situations or contexts that tend to disrupt wellness and wants practical responses connected to those stressors."
			},
			{
				"title": "What It Captures",
				"body": "The profile captures stressors, matched responses, and optional cues for recognizing when a stressor is present."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not rate stress severity, diagnose risk, interpret effectiveness, or provide generic coping recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does every stressor need a response?",
				"answer": "Yes for completion. Drafts can include stressors without responses, but those entries are marked incomplete."
			},
			{
				"question": "Can one stressor have multiple responses?",
				"answer": "Yes. The person can add more than one preferred response for a stressor."
			},
			{
				"question": "Does the tool score stress?",
				"answer": "No. It organizes person-authored stressors and responses without severity scores or clinical interpretation."
			}
		]
	},
	{
		"toolType": "earlyWarningSignsActionPlan",
		"slug": "early-warning-signs-action-plan",
		"title": "Early Warning Signs & Action Plan for Prevention Planning | Qwoach",
		"metaDescription": "Help a person identify early warning signs and link each sign to feasible responses before problems intensify or crisis-level support is needed.",
		"h1": "Early Warning Signs & Action Plan",
		"intro": "The Early Warning Signs & Action Plan is a ready-to-send prevention and self-directed recovery tool for practitioners helping a person preserve stability. It helps the person identify personally recognizable early warning signs and connect each sign to feasible, acceptable responses before problems intensify.",
		"demoTitle": "Preview the early-warning map and save the tool.",
		"demoPrompt": "Interested in using Early Warning Signs & Action Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1326-f-093-wrap-004-r001-early-warning-signs-action-plan.md",
		"specId": "1326-f-093-wrap-004-r001-early-warning-signs-action-plan",
		"tags": {
			"framework": [
				"WRAP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Coping"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this when wellness may be starting to shift but the situation has not reached a more severe escalation or crisis state."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures early warning signs, linked responses, optional feasibility or acceptability notes, and boundary notes for items that may need practitioner discussion."
			},
			{
				"title": "Important Limits",
				"body": "The system does not infer severity, predict relapse, score symptoms, or replace a crisis plan."
			}
		],
		"faqItems": [
			{
				"question": "Is this a crisis plan?",
				"answer": "No. It focuses on early warning signs and responses before problems intensify; crisis preferences belong in a separate crisis plan."
			},
			{
				"question": "What makes an entry complete?",
				"answer": "A completed entry has an early warning sign and at least one linked response."
			},
			{
				"question": "Can uncertain items be handled?",
				"answer": "Yes. Items that may be more severe than early warning can be flagged for practitioner discussion instead of forced into a category."
			}
		]
	},
	{
		"toolType": "whenThingsAreBreakingDownPlan",
		"slug": "when-things-are-breaking-down-plan",
		"title": "When Things Are Breaking Down Plan for Escalation Support | Qwoach",
		"metaDescription": "Help a person define escalation signs, preferred responses, support needs, and boundaries for periods when coping is no longer enough.",
		"h1": "When Things Are Breaking Down Plan",
		"intro": "The When Things Are Breaking Down Plan is a ready-to-send escalation planning tool for practitioners supporting a person during marked deterioration. It helps the person identify escalation signs, preferred responses, support needs, and boundaries for periods when usual coping may no longer be enough.",
		"demoTitle": "Preview the escalation plan and save the tool.",
		"demoPrompt": "Interested in using When Things Are Breaking Down Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1327-f-093-wrap-005-r001-when-things-are-breaking-down-plan.md",
		"specId": "1327-f-093-wrap-005-r001-when-things-are-breaking-down-plan",
		"tags": {
			"framework": [
				"WRAP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Risk review"
			],
			"topic": [
				"Crisis response",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this for marked deterioration when usual coping may no longer be enough but before crisis-level support is the focus."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures escalation signs, preferred responses, support needs, boundaries, and discussion flags for unclear items."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not infer crisis status, create emergency directives, score risk, or replace a separate Crisis Plan."
			}
		],
		"faqItems": [
			{
				"question": "Is this the same as an Early Warning Signs plan?",
				"answer": "No. This plan is for a more serious breaking-down state, distinct from ordinary stressors or early warning signs."
			},
			{
				"question": "Is this a Crisis Plan?",
				"answer": "No. It supports proportionate action before crisis and does not substitute for a separate crisis preference plan."
			},
			{
				"question": "Can boundaries be unresolved?",
				"answer": "Yes. Support boundaries can be marked for practitioner discussion while the partial plan is preserved."
			}
		]
	},
	{
		"toolType": "crisisPlan",
		"slug": "crisis-plan",
		"title": "Crisis Plan for Advance Support Preferences | Qwoach",
		"metaDescription": "Help a person document crisis support preferences, contacts, roles, decision points, values, and safety needs before acute crisis occurs.",
		"h1": "Crisis Plan",
		"intro": "The Crisis Plan is a ready-to-send advance support preference tool for practitioners helping a person prepare for acute crisis periods. It helps the person document preferred and unwanted supports, key contacts, roles, decision points, values, and safety needs for times when they may have reduced capacity to advocate for themselves.",
		"demoTitle": "Preview the Crisis Plan and save it for your practice.",
		"demoPrompt": "Interested in using Crisis Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1328-f-093-wrap-006-r001-crisis-plan.md",
		"specId": "1328-f-093-wrap-006-r001-crisis-plan",
		"tags": {
			"framework": [
				"WRAP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Risk review",
				"Intervention planning"
			],
			"topic": [
				"Crisis response",
				"Service preferences"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this before crisis occurs so preferences and support information are available if the person has reduced capacity to advocate for themselves."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures preferred supports, unwanted supports, key contacts, supporter or provider roles, decision points, values, and safety needs."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not score risk, determine decision-making authority, invent emergency-service instructions, or add unsupported crisis protocol fields."
			}
		],
		"faqItems": [
			{
				"question": "Does this Crisis Plan make clinical risk decisions?",
				"answer": "No. It organizes person-provided advance preferences and readiness cues; it does not score risk or determine required interventions."
			},
			{
				"question": "Can sensitive sections be left unresolved?",
				"answer": "Yes. Sensitive or unresolved sections can be saved and flagged for practitioner discussion."
			},
			{
				"question": "How is the plan used during crisis?",
				"answer": "The plan can be shown in a clear read-only reference mode so supporters or providers can review documented preferences."
			}
		]
	},
	{
		"toolType": "postCrisisPlan",
		"slug": "post-crisis-plan",
		"title": "Post-Crisis Plan for Transition and Learning | Qwoach",
		"metaDescription": "Help a person emerging from crisis clarify recovery needs, pacing for return to routines, lessons learned, next supports, and support signals.",
		"h1": "Post-Crisis Plan",
		"intro": "The Post-Crisis Plan is a ready-to-send transition and learning tool for practitioners supporting a person emerging from crisis. It helps the person clarify immediate recovery needs, pacing for returning to everyday roles or routines, lessons learned, next supports, and signals that additional support is still needed.",
		"demoTitle": "Preview the Post-Crisis Plan and save the tool.",
		"demoPrompt": "Interested in using Post-Crisis Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1329-f-093-wrap-007-r001-post-crisis-plan.md",
		"specId": "1329-f-093-wrap-007-r001-post-crisis-plan",
		"tags": {
			"framework": [
				"WRAP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Progress review"
			],
			"topic": [
				"Crisis response",
				"Relapse prevention"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this after a crisis, as the person is emerging from acute crisis and returning toward everyday life."
			},
			{
				"title": "What It Captures",
				"body": "The plan captures immediate recovery needs, transition pacing or readiness, lessons learned, next supports, and shared signals that additional support is still needed."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not assign blame, score risk, impose discharge workflows, infer causality, or automatically alter related plans."
			}
		],
		"faqItems": [
			{
				"question": "Can the person complete this gradually?",
				"answer": "Yes. The tool is designed to save partial work because post-crisis completion may need to happen in manageable parts."
			},
			{
				"question": "Does it update other plans automatically?",
				"answer": "No. Lessons can suggest reviewing related plans, but the tool does not automatically modify them."
			},
			{
				"question": "Is this an incident report?",
				"answer": "No. It focuses on transition needs and learning, not blame, fault, or administrative incident analysis."
			}
		]
	},
	{
		"toolType": "wrapApp",
		"slug": "wrap-app",
		"title": "WRAP App for Longitudinal Self-Management Review | Qwoach",
		"metaDescription": "Review self-management information across toolbox, daily plan, stressors, warning signs, crisis, and post-crisis plan areas over time.",
		"h1": "WRAP App",
		"intro": "The WRAP App is a ready-to-send longitudinal self-management product for practitioners supporting ongoing self-directed recovery. It helps a person build and update information across Wellness Toolbox, Daily Plan, Stressors & Action Plan, Early Warning Signs & Action Plan, Crisis Plan, and Post-Crisis Plan areas so the practitioner can review strategies, risks, preferences, and changes over time.",
		"demoTitle": "Explore the multi-area dashboard and save the app.",
		"demoPrompt": "Interested in using WRAP App with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1330-f-093-wrap-008-r001-wrap-app.md",
		"specId": "1330-f-093-wrap-008-r001-wrap-app",
		"tags": {
			"framework": [
				"WRAP"
			],
			"toolType": [
				"Delivery capability"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [
				"Relapse prevention",
				"Crisis response",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Included Plan Areas",
				"body": "The app-level scope includes Wellness Toolbox, Daily Plan, Stressors & Action Plan, Early Warning Signs & Action Plan, Crisis Plan, and Post-Crisis Plan."
			},
			{
				"title": "Repeat Use",
				"body": "The app is intended for longitudinal review, so changes in stressors, warning signs, supports, preferences, and post-crisis learning can remain visible over time."
			},
			{
				"title": "Important Limits",
				"body": "The app does not add unsupported prompts, ratings, clinical conclusions, generic modules, or real-time emergency triage."
			}
		],
		"faqItems": [
			{
				"question": "Can practitioners choose different modules for the app?",
				"answer": "No. The included plan areas are fixed to the supplied app scope and should not become a generic module builder."
			},
			{
				"question": "Does the app interpret clinical risk?",
				"answer": "No. It shows current information, changes, incomplete areas, and currency cues without clinical interpretation or risk scoring."
			},
			{
				"question": "Can a person complete only some areas?",
				"answer": "Yes. Partial completion across areas is expected, and incomplete areas remain visible."
			},
			{
				"question": "What is saved if there are no configurable modules?",
				"answer": "The fixed WRAP App tool itself is saved as-is, including the supported plan-area scope."
			}
		]
	},
	{
		"toolType": "connectionReflection",
		"slug": "connection-reflection",
		"title": "Connection Reflection Demo for IPS Practitioners | Qwoach",
		"metaDescription": "Explore a co-completed IPS reflection tool for reviewing connection, trust, engagement, and relational learning from both perspectives.",
		"h1": "Connection Reflection for Intentional Peer Support",
		"intro": "Connection Reflection is a co-completed Intentional Peer Support tool for peer-support practitioners and participants. It helps both people examine the quality of connection, including what supports or hinders trust, engagement, and learning in the relationship.",
		"demoTitle": "Open the sample reflection",
		"demoPrompt": "Interested in using Connection Reflection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1331-f-094-ips-001-r001-connection-reflection.md",
		"specId": "1331-f-094-ips-001-r001-connection-reflection",
		"tags": {
			"framework": [
				"Intentional Peer Support"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use Connection Reflection when a peer-support relationship needs shared attention to connection, trust, engagement, or what both people are learning through the relationship."
			},
			{
				"title": "What It Does Not Do",
				"body": "The tool does not produce scores, satisfaction ratings, clinical interpretations, practitioner performance ratings, or conclusions about relationship success or failure."
			}
		],
		"faqItems": [
			{
				"question": "Is Connection Reflection a survey?",
				"answer": "No. Connection Reflection is a shared relational reflection, not a questionnaire, satisfaction survey, score, or one-sided evaluation."
			},
			{
				"question": "Can it be completed with only the practitioner perspective?",
				"answer": "It can be saved as partial, but it cannot be presented as shared insight unless both perspectives are represented."
			},
			{
				"question": "Does the system resolve disagreements?",
				"answer": "No. Differences are preserved descriptively so they can be discussed rather than forced into agreement."
			}
		]
	},
	{
		"toolType": "worldviewExploration",
		"slug": "worldview-exploration",
		"title": "Worldview Exploration Demo for IPS Practitioners | Qwoach",
		"metaDescription": "Explore an IPS conversation tool for mapping each person's meaning, assumptions, and context without forcing agreement or correction.",
		"h1": "Worldview Exploration for Peer-Support Conversations",
		"intro": "Worldview Exploration is a co-completed Intentional Peer Support tool for peer-support practitioners and participants. It helps both people articulate the meanings, assumptions, and life contexts they bring to a conversation so the next conversation can honor different worldviews.",
		"demoTitle": "Explore the sample worldview map",
		"demoPrompt": "Interested in using Worldview Exploration with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1332-f-094-ips-002-r001-worldview-exploration.md",
		"specId": "1332-f-094-ips-002-r001-worldview-exploration",
		"tags": {
			"framework": [
				"Intentional Peer Support"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use Worldview Exploration when different meanings, assumptions, or life contexts may be shaping a peer-support conversation."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not diagnose, validate beliefs, rate cultural competence, judge correctness, or create forced consensus statements."
			}
		],
		"faqItems": [
			{
				"question": "Does Worldview Exploration decide whose interpretation is correct?",
				"answer": "No. It records and organizes reported meanings and contexts without judging accuracy."
			},
			{
				"question": "Can one person's worldview be enough to complete it?",
				"answer": "No. A one-sided entry can be saved as partial, but completion requires meaning and context from both people."
			},
			{
				"question": "Can differences remain in the result?",
				"answer": "Yes. Differences are part of the result and do not need to be resolved by the system."
			}
		]
	},
	{
		"toolType": "mutualityCheck",
		"slug": "mutuality-check",
		"title": "Mutuality Check Demo for IPS Practitioners | Qwoach",
		"metaDescription": "Explore an IPS reflection tool for noticing reciprocity, imbalance, learning, needs, contributions, and possible co-learning adjustments.",
		"h1": "Mutuality Check for Peer-Support Relationships",
		"intro": "Mutuality Check is an Intentional Peer Support reflection tool for peer-support practitioners and participants. It helps both people identify indicators of reciprocity and imbalance so the relationship can stay grounded in co-learning and shared growth.",
		"demoTitle": "Open the sample mutuality check",
		"demoPrompt": "Interested in using Mutuality Check with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1333-f-094-ips-003-r001-mutuality-check.md",
		"specId": "1333-f-094-ips-003-r001-mutuality-check",
		"tags": {
			"framework": [
				"Intentional Peer Support"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"In-session support",
				"Intervention planning"
			],
			"topic": [
				"Interpersonal relationships"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use Mutuality Check when a peer-support interaction may feel one-sided, expert-driven, or disconnected from shared growth."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not create compliance ratings, dependency judgments, practitioner competence scores, diagnoses, blame assignments, or satisfaction measures."
			}
		],
		"faqItems": [
			{
				"question": "Does Mutuality Check score the relationship?",
				"answer": "No. It organizes descriptive indicators and possible adjustments without calculating a mutuality score."
			},
			{
				"question": "Can imbalance be named by only one person?",
				"answer": "Yes. If one person names imbalance and the other does not, the difference is preserved rather than resolved by the system."
			},
			{
				"question": "Is this client feedback about the practitioner?",
				"answer": "No. The tool is framed as shared reflection on relational dynamics, not feedback about the practitioner or assessment of the participant."
			}
		]
	},
	{
		"toolType": "movingTowardsPlan",
		"slug": "moving-towards-plan",
		"title": "Moving Towards Plan Demo for IPS Practitioners | Qwoach",
		"metaDescription": "Explore an IPS planning tool for shifting from unwanted concerns toward personally meaningful direction and concrete near-term actions.",
		"h1": "Moving Towards Plan for Intentional Peer Support",
		"intro": "Moving Towards Plan is a co-completed Intentional Peer Support planning tool for peer-support practitioners and participants. It helps the person name what they want to move toward, why it matters, and which near-term actions feel personally meaningful.",
		"demoTitle": "Build a sample moving-towards plan",
		"demoPrompt": "Interested in using Moving Towards Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1334-f-094-ips-004-r001-moving-towards-plan.md",
		"specId": "1334-f-094-ips-004-r001-moving-towards-plan",
		"tags": {
			"framework": [
				"Intentional Peer Support"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals",
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use Moving Towards Plan when the conversation is centered on what someone wants to escape and needs to orient toward what they want instead."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not impose goals, require compliance, create risk scores, rate motivation, or generate external success criteria."
			}
		],
		"faqItems": [
			{
				"question": "Does the practitioner choose the person's goal?",
				"answer": "No. The participant controls the desired direction and acceptable actions; practitioner-suggested actions must be confirmed as personally meaningful."
			},
			{
				"question": "Can the plan be complete with only an unwanted concern?",
				"answer": "No. If only away-from language is captured, the plan remains incomplete because the toward direction is unresolved."
			},
			{
				"question": "Does the tool include reminders or due dates?",
				"answer": "No. Due dates, reminders, labels, and goal categories are not supported tool settings in the supplied specification."
			}
		]
	},
	{
		"toolType": "ipsCompetencySelfAssessment",
		"slug": "ips-competency-self-assessment",
		"title": "IPS Competency Self-Assessment Demo | Qwoach",
		"metaDescription": "Explore a practitioner-only IPS self-assessment tool for creating a competency profile of strengths and development needs over time.",
		"h1": "IPS Competency Self-Assessment for Practitioner Development",
		"intro": "IPS Competency Self-Assessment is a practitioner-only self-assessment tool for Intentional Peer Support practitioners. It helps a practitioner create a competency profile that distinguishes practice strengths from specific development needs for professional growth.",
		"demoTitle": "Preview the self-assessment flow",
		"demoPrompt": "Interested in using IPS Competency Self-Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1335-f-094-ips-005-r001-ips-competency-self-assessment.md",
		"specId": "1335-f-094-ips-005-r001-ips-competency-self-assessment",
		"tags": {
			"framework": [
				"Intentional Peer Support"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "This tool is for the practitioner's own self-assessment. It does not ask clients or peers to provide information."
			},
			{
				"title": "Content Dependency",
				"body": "The product requires source-defined competency items, response values, and profile logic. Without them, a complete substantive assessment cannot be produced."
			}
		],
		"faqItems": [
			{
				"question": "Can the public demo include invented competency items?",
				"answer": "No. Exact competencies, rating scales, prompts, and profile rules are unresolved and must not be invented."
			},
			{
				"question": "Is there a client or peer view?",
				"answer": "No. The supplied configuration is practitioner-only and collects no client/user input."
			},
			{
				"question": "Does the profile determine certification or employment readiness?",
				"answer": "No. The result is a practitioner self-assessment profile, not a certification judgment, employment decision, or external evaluation."
			}
		]
	},
	{
		"toolType": "coReflectionGuide",
		"slug": "co-reflection-guide",
		"title": "Co-Reflection Guide Demo for IPS Practitioners | Qwoach",
		"metaDescription": "Explore a practitioner-only IPS reflection tool for connecting practice experiences to learning and specific future adjustments.",
		"h1": "Co-Reflection Guide for IPS Practice Learning",
		"intro": "Co-Reflection Guide is a practitioner-only Intentional Peer Support reflective learning tool. It helps peer-support practitioners connect recent practice experiences to learning and identify specific adjustments for future relationships.",
		"demoTitle": "Preview the reflection guide",
		"demoPrompt": "Interested in using Co-Reflection Guide with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1336-f-094-ips-006-r001-co-reflection-guide.md",
		"specId": "1336-f-094-ips-006-r001-co-reflection-guide",
		"tags": {
			"framework": [
				"Intentional Peer Support"
			],
			"toolType": [
				"Guide"
			],
			"workflow": [
				"Progress review",
				"Intervention planning"
			],
			"topic": [],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner-Only Use",
				"body": "This tool supports the practitioner's reflective learning. It does not collect client/user responses."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool does not produce competence judgments, client interpretations, scores, or generic recommendations."
			}
		],
		"faqItems": [
			{
				"question": "Does Co-Reflection Guide include a client view?",
				"answer": "No. The supplied configuration is practitioner-only."
			},
			{
				"question": "Can the demo invent the guide prompts?",
				"answer": "No. Exact guide prompts, fields, and sequence are unresolved and must not be fabricated."
			},
			{
				"question": "What does the result contain?",
				"answer": "The result contains a reflective learning record linking concrete practice patterns, learning, and possible future adjustments."
			}
		]
	},
	{
		"toolType": "growCoachingMap",
		"slug": "grow-coaching-map",
		"title": "GROW Coaching Map Demo for Coaches | Qwoach",
		"metaDescription": "Explore a co-completed coaching map for organizing Goal, Reality, Options, and Way Forward into a coherent action picture.",
		"h1": "GROW Coaching Map for Structured Coaching Conversations",
		"intro": "GROW Coaching Map is a co-completed coaching workflow tool for coaches and coached people. It helps them connect a meaningful goal, current reality, possible options, and a chosen way forward into one coherent action picture.",
		"demoTitle": "Explore the four-stage map",
		"demoPrompt": "Interested in using GROW Coaching Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1337-f-095-grow-001-r001-grow-coaching-map.md",
		"specId": "1337-f-095-grow-001-r001-grow-coaching-map",
		"tags": {
			"framework": [
				"GROW coaching"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Goal setting",
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use GROW Coaching Map when a coaching conversation needs a coherent structure from desired goal through current reality, options, and commitment."
			},
			{
				"title": "Relevant Limits",
				"body": "The tool organizes the coaching conversation but does not diagnose, score motivation, predict success, impose goals, or select the best option."
			}
		],
		"faqItems": [
			{
				"question": "Are the four stages configurable?",
				"answer": "No. Goal, Reality, Options, and Will/Way Forward are fixed for this product."
			},
			{
				"question": "Can a map be saved before all stages are complete?",
				"answer": "Yes. Partial maps can be saved and resumed, but the review must show which stage is missing or underdeveloped."
			},
			{
				"question": "Does the system choose the best option?",
				"answer": "No. The system organizes options and tradeoffs but does not choose for the person."
			}
		]
	},
	{
		"toolType": "goalDefinition",
		"slug": "goal-definition",
		"title": "Goal Definition Demo for Coaches | Qwoach",
		"metaDescription": "Explore a focused coaching tool for turning a broad topic into an explicit, personally relevant goal that can anchor later work.",
		"h1": "Goal Definition for Coaching Conversations",
		"intro": "Goal Definition is a focused coaching tool for coaches and coached people. It helps the person turn a broad topic or aspiration into an explicit, personally relevant coaching goal that can anchor current reality and options work.",
		"demoTitle": "Try the sample goal definition",
		"demoPrompt": "Interested in using Goal Definition with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1338-f-095-grow-002-r001-goal-definition.md",
		"specId": "1338-f-095-grow-002-r001-goal-definition",
		"tags": {
			"framework": [
				"GROW coaching"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use Goal Definition when a coaching engagement is beginning or needs refocusing and the desired outcome is still vague."
			},
			{
				"title": "Scope Boundary",
				"body": "This tool defines the goal only. It does not produce a current-state profile, option set, action commitment, or full coaching map."
			}
		],
		"faqItems": [
			{
				"question": "Does Goal Definition create a full coaching plan?",
				"answer": "No. It is limited to defining an explicit coaching goal."
			},
			{
				"question": "Can the practitioner write the goal for the person?",
				"answer": "The practitioner can help clarify, but a practitioner-entered goal requires the person's confirmation that it is personally relevant."
			},
			{
				"question": "What happens if the entry is only a topic?",
				"answer": "It remains a draft or incomplete goal until it is refined into a desired outcome."
			}
		]
	},
	{
		"toolType": "realityAssessment",
		"slug": "reality-assessment",
		"title": "Reality Assessment Demo for Coaches | Qwoach",
		"metaDescription": "Explore a focused coaching tool for mapping current reality, facts, constraints, resources, and starting point connected to a goal.",
		"h1": "Reality Assessment for Goal-Linked Coaching",
		"intro": "Reality Assessment is a focused coaching tool for coaches and coached people. It helps the person map their current situation, constraints, resources, and starting point in relation to a coaching goal before exploring solutions.",
		"demoTitle": "Explore the sample reality profile",
		"demoPrompt": "Interested in using Reality Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1339-f-095-grow-003-r001-reality-assessment.md",
		"specId": "1339-f-095-grow-003-r001-reality-assessment",
		"tags": {
			"framework": [
				"GROW coaching"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use Reality Assessment after a coaching goal exists and before generating options, so possible paths can fit the person's actual situation."
			},
			{
				"title": "Scope Boundary",
				"body": "This tool maps current reality only. It does not diagnose, recommend options, create action commitments, or score readiness."
			}
		],
		"faqItems": [
			{
				"question": "Can Reality Assessment be complete without a goal?",
				"answer": "No. It can be drafted, but it cannot be complete as a Reality-stage result unless it connects to a goal."
			},
			{
				"question": "Does the tool decide which facts are true?",
				"answer": "No. It helps separate reported facts from assumptions or wishes without judging truth."
			},
			{
				"question": "Does Reality Assessment generate solutions?",
				"answer": "No. It produces a current-state profile that can inform later options work."
			}
		]
	},
	{
		"toolType": "optionsGenerator",
		"slug": "options-generator",
		"title": "Options Generator Demo for Coaches | Qwoach",
		"metaDescription": "Explore a focused coaching tool for generating multiple options, connecting them to goal and reality, and comparing tradeoffs.",
		"h1": "Options Generator for Coaching Choices",
		"intro": "Options Generator is a focused coaching tool for coaches and coached people. It helps the person identify multiple viable ways forward, connect them to the goal and current reality, and compare benefits, risks, or tradeoffs before commitment.",
		"demoTitle": "Compare sample options",
		"demoPrompt": "Interested in using Options Generator with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1340-f-095-grow-004-r001-options-generator.md",
		"specId": "1340-f-095-grow-004-r001-options-generator",
		"tags": {
			"framework": [
				"GROW coaching"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Problem solving"
			],
			"topic": [
				"Goals",
				"Problem solving"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use Options Generator when the person understands the goal and current reality but needs to identify and compare possible ways forward."
			},
			{
				"title": "Scope Boundary",
				"body": "This tool supports option generation and tradeoff comparison. It does not produce a final action commitment, automated ranking, or best-option recommendation."
			}
		],
		"faqItems": [
			{
				"question": "Does Options Generator choose the best option?",
				"answer": "No. It organizes options and tradeoffs but does not rank or choose automatically."
			},
			{
				"question": "Can it be complete with only one option?",
				"answer": "No. A single option can be saved as a limited or incomplete state, but complete option generation requires more than one plausible option."
			},
			{
				"question": "Does it replace a Way Forward step?",
				"answer": "No. It can identify a candidate next-step option, but final commitment belongs in a later Way Forward conversation."
			}
		]
	},
	{
		"toolType": "willWayForwardPlan",
		"slug": "will-way-forward-plan",
		"title": "Will / Way Forward Plan for Coaching Commitments | Qwoach",
		"metaDescription": "Capture a client-owned next action, timing, and follow-through clarity at the Will stage of a GROW-based coaching conversation.",
		"h1": "Will / Way Forward Plan",
		"intro": "Will / Way Forward Plan is a coaching action-commitment planner for practitioners using the Will / Way Forward stage after goal, reality, and options have already been explored. It helps the practitioner capture a specific client-owned next action with enough timing or follow-through clarity to support accountability between sessions.",
		"demoTitle": "Explore the commitment capture with sample context, then save the tool for your practice.",
		"demoPrompt": "Interested in using Will / Way Forward Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1341-f-095-grow-005-r001-will-way-forward-plan.md",
		"specId": "1341-f-095-grow-005-r001-will-way-forward-plan",
		"tags": {
			"framework": [
				"GROW coaching"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When To Use It",
				"body": "Use it at the end of a coaching conversation when the client has explored a goal, current reality, and options and now needs to choose a next action."
			},
			{
				"title": "What It Does Not Do",
				"body": "It does not generate options, score readiness, assign actions for the practitioner, provide reminders, or replace a full GROW workflow."
			},
			{
				"title": "Follow-Up Value",
				"body": "The completed commitment persists as the action to revisit between sessions. Later changes should be handled as revisions so the follow-up record stays understandable."
			}
		],
		"faqItems": [
			{
				"question": "Does this replace the full GROW model?",
				"answer": "No. It only supports the Will / Way Forward commitment step after goal, reality, and options have already been explored."
			},
			{
				"question": "Can the practitioner fill it out with the client?",
				"answer": "Yes. The tool supports collaborative completion in session as well as sending the commitment capture to the client."
			},
			{
				"question": "What makes a plan complete?",
				"answer": "A complete plan includes a stated next action and enough timing or follow-through detail to support accountability."
			},
			{
				"question": "Does the system decide whether the action is good?",
				"answer": "No. The system can show missing clarity and organize the commitment, but it does not judge the action or invent interpretation."
			}
		]
	},
	{
		"toolType": "commitmentRating",
		"slug": "commitment-rating",
		"title": "Commitment Rating for Coaching Action Readiness | Qwoach",
		"metaDescription": "Check a client’s 1–10 commitment to a planned action and capture relevant barriers before treating the plan as viable.",
		"h1": "Commitment Rating",
		"intro": "Commitment Rating is a coaching readiness and barrier check for practitioners working with a client who has identified a possible course of action. It helps the practitioner capture a 1–10 commitment rating and any remaining barriers so the action plan can be strengthened or adjusted before the conversation ends.",
		"demoTitle": "Try a sample action, rating, and barrier capture, then save the tool for your practice.",
		"demoPrompt": "Interested in using Commitment Rating with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1342-f-095-grow-006-r001-commitment-rating.md",
		"specId": "1342-f-095-grow-006-r001-commitment-rating",
		"tags": {
			"framework": [
				"GROW coaching"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Intervention planning"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Action-Specific By Design",
				"body": "The rating is meaningful only when it is attached to a specific planned action. If the action changes, the prior rating should not automatically apply."
			},
			{
				"title": "What It Does Not Infer",
				"body": "The tool does not diagnose motivation, predict follow-through, or explain why the client is committed or not committed. Barriers remain client-reported information for discussion."
			}
		],
		"faqItems": [
			{
				"question": "Is the rating always required?",
				"answer": "Yes. A completed check requires a 1–10 commitment rating tied to a specific planned action."
			},
			{
				"question": "Can barrier capture be optional?",
				"answer": "Yes. The practitioner can configure barrier capture to always appear, appear below a chosen rating, or remain optional."
			},
			{
				"question": "Does a low rating automatically mean the action is wrong?",
				"answer": "No. A low or uncertain rating is shown as a signal for discussion; the practitioner and client decide whether to strengthen or revise the plan."
			},
			{
				"question": "Can the tool compare repeated ratings?",
				"answer": "Repeated ratings for the same action can be compared descriptively if captured over time, but longitudinal interpretation is not required for the smallest complete product."
			}
		]
	},
	{
		"toolType": "growProgressReview",
		"slug": "grow-progress-review",
		"title": "GROW Progress Review for Ongoing Coaching | Qwoach",
		"metaDescription": "Review prior goals, changed reality, and next coaching focus in an ongoing GROW-based coaching engagement.",
		"h1": "GROW Progress Review",
		"intro": "GROW Progress Review is a collaborative coaching review tool for practitioners working in an ongoing GROW-based engagement. It helps practitioner and client compare prior coaching context with current progress, changed reality, and the next coaching focus as new experience emerges over time.",
		"demoTitle": "Explore a sample progress review, then save the tool for ongoing coaching work.",
		"demoPrompt": "Interested in using GROW Progress Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1343-f-095-grow-007-r001-grow-progress-review.md",
		"specId": "1343-f-095-grow-007-r001-grow-progress-review",
		"tags": {
			"framework": [
				"GROW coaching"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Designed For Ongoing Work",
				"body": "The review is most useful when prior coaching context exists and new client experience has emerged since the last goal-setting or action-planning conversation."
			},
			{
				"title": "History And Comparability",
				"body": "Completed reviews persist in chronological order. Edits after completion should preserve historical clarity so longitudinal changes remain understandable."
			},
			{
				"title": "Limits",
				"body": "The tool does not score coaching effectiveness, assign causes, or recommend the next coaching direction automatically."
			}
		],
		"faqItems": [
			{
				"question": "Can this be used without prior coaching context?",
				"answer": "Yes, it can capture current reality, but it cannot show progress against a previous goal or action without prior context."
			},
			{
				"question": "Is there a separate client solo workflow?",
				"answer": "No. The client experience is collaborative in-session participation in the practitioner-led review."
			},
			{
				"question": "What makes a review complete?",
				"answer": "A complete review needs prior context, current progress or changed-reality information, and a next coaching focus."
			},
			{
				"question": "Does the system decide why progress changed?",
				"answer": "No. It organizes reported information and descriptive comparison but does not infer causes or judge success."
			}
		]
	},
	{
		"toolType": "wheelOfLifeAssessment",
		"slug": "wheel-of-life-assessment",
		"title": "Wheel of Life Assessment for Coaching | Qwoach",
		"metaDescription": "Create a multi-domain current-state profile so coaching clients and practitioners can see relative strengths and lower-rated life areas.",
		"h1": "Wheel of Life Assessment",
		"intro": "Wheel of Life Assessment is a ready-to-send coaching self-assessment for practitioners who want a broad current-state view across important life areas. It helps the practitioner collect client ratings or equivalent signals by domain and review a profile that makes relative strengths and lower-rated areas visible for a coaching conversation.",
		"demoTitle": "Configure sample domains, try the client rating view, then save the assessment for your practice.",
		"demoPrompt": "Interested in using Wheel of Life Assessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1344-f-096-wol-001-r001-wheel-of-life-assessment.md",
		"specId": "1344-f-096-wol-001-r001-wheel-of-life-assessment",
		"tags": {
			"framework": [
				"Wheel of Life"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Life domains"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Domain Setup",
				"body": "The practitioner can use a default, practitioner-selected, or personalized domain set. Domain choices affect profile labels and whether later profiles can be compared directly."
			},
			{
				"title": "Partial Profiles",
				"body": "If a client skips a represented domain, the result remains partial and visibly incomplete rather than being treated as a finished profile."
			},
			{
				"title": "Limits",
				"body": "The tool does not provide importance-current gaps, clinical conclusions, automatic priorities, or action plans."
			}
		],
		"faqItems": [
			{
				"question": "What does the client complete?",
				"answer": "The client provides a current-state rating or equivalent signal for each represented life domain."
			},
			{
				"question": "Can domains be customized?",
				"answer": "Yes. The practitioner can use default, practitioner-selected, or personalized domains where supported by setup."
			},
			{
				"question": "Does the tool choose the coaching priority?",
				"answer": "No. It shows relative strengths and lower-rated areas, but priority selection remains part of the coaching conversation."
			},
			{
				"question": "What happens if a domain is skipped?",
				"answer": "The profile is shown as partial and the missing domain is identified."
			}
		]
	},
	{
		"toolType": "customLifeDomainBuilder",
		"slug": "custom-life-domain-builder",
		"title": "Custom Life-Domain Builder for Wheel Coaching | Qwoach",
		"metaDescription": "Build a personalized set of life or work domains for Wheel of Life assessment, reflection, and progress review.",
		"h1": "Custom Life-Domain Builder",
		"intro": "Custom Life-Domain Builder is a collaborative Wheel of Life personalization tool for practitioners and clients when generic life-balance categories do not fit. It helps them create a reusable personalized domain set for later assessment, reflection, or progress review.",
		"demoTitle": "Create a sample domain set, check it for blanks or duplicates, then save the builder for your practice.",
		"demoPrompt": "Interested in using Custom Life-Domain Builder with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1345-f-096-wol-002-r001-custom-life-domain-builder.md",
		"specId": "1345-f-096-wol-002-r001-custom-life-domain-builder",
		"tags": {
			"framework": [
				"Wheel of Life"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Session preparation"
			],
			"topic": [
				"Life domains"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What It Produces",
				"body": "The result is a personalized domain set that can be reused across Wheel-related assessment, reflection, and progress review."
			},
			{
				"title": "What It Excludes",
				"body": "The builder does not collect ratings, importance scores, goals, or interpretation. Those belong to other supported tools."
			},
			{
				"title": "Historical Clarity",
				"body": "Once a domain set has been used in an assessment, later changes should create a revised set rather than silently altering past assessment meaning."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool rate the domains?",
				"answer": "No. It only creates, edits, and saves the domain labels used by later Wheel workflows."
			},
			{
				"question": "Can the client help name the domains?",
				"answer": "Yes. The intended experience is collaborative domain naming and confirmation with the practitioner."
			},
			{
				"question": "What makes a domain set usable?",
				"answer": "A usable set requires multiple non-empty domains and should avoid duplicate labels; exact count bounds require configuration and validation."
			},
			{
				"question": "Can generic categories still be used?",
				"answer": "Yes. Generic categories can remain if the client recognizes them as meaningful."
			}
		]
	},
	{
		"toolType": "importanceVsCurrentStateGap",
		"slug": "importance-vs-current-state-gap",
		"title": "Importance vs Current-State Gap for Wheel Coaching | Qwoach",
		"metaDescription": "Compare current-state and importance ratings by life domain to reveal which Wheel of Life gaps matter most for coaching focus.",
		"h1": "Importance vs Current-State Gap",
		"intro": "Importance vs Current-State Gap is a Wheel of Life prioritization profile for practitioners and clients who need more than current-state ratings. It helps compare each life domain’s current state with its personal importance so high-importance gaps are visible for coaching focus discussion.",
		"demoTitle": "Try a sample domain gap profile, then save the tool for your practice.",
		"demoPrompt": "Interested in using Importance vs Current-State Gap with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1346-f-096-wol-003-r001-importance-vs-current-state-gap.md",
		"specId": "1346-f-096-wol-003-r001-importance-vs-current-state-gap",
		"tags": {
			"framework": [
				"Wheel of Life"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Goal setting"
			],
			"topic": [
				"Life domains"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Why Importance Matters",
				"body": "A low current-state rating is not automatically a high-priority coaching focus. Pairing it with importance helps distinguish high-importance gaps from lower-priority dissatisfaction."
			},
			{
				"title": "Comparable Inputs",
				"body": "Numeric gap calculation is valid only when current-state and importance inputs use comparable scales. Otherwise, the tool should present paired values descriptively."
			},
			{
				"title": "Limits",
				"body": "The tool does not identify causes, prescribe goals, or hide lower-priority domains."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool require both current-state and importance values?",
				"answer": "Yes. Each domain needs both signals for a complete prioritized profile."
			},
			{
				"question": "Can current-state ratings be reused from a prior Wheel assessment?",
				"answer": "Yes. The practitioner may reuse prior current-state ratings where available, or ask the client to provide new ones."
			},
			{
				"question": "Does the largest gap have to become the coaching goal?",
				"answer": "No. The gap profile informs discussion; it does not prescribe the goal."
			},
			{
				"question": "What happens if the scales are different?",
				"answer": "The tool should show paired values descriptively rather than calculating a misleading numeric gap."
			}
		]
	},
	{
		"toolType": "wheelReflection",
		"slug": "wheel-reflection",
		"title": "Wheel Reflection for Client Priorities | Qwoach",
		"metaDescription": "Attach reflection to a completed Wheel profile so clients explain what stands out, what it means, and which priorities matter now.",
		"h1": "Wheel Reflection",
		"intro": "Wheel Reflection is a ready-to-send reflection flow for practitioners with a completed Wheel of Life profile. It helps the client explain what stands out, connect ratings to lived experience, and name priority areas or themes for the next coaching conversation.",
		"demoTitle": "Review a sample profile, add a reflection, then save the tool for your practice.",
		"demoPrompt": "Interested in using Wheel Reflection with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1347-f-096-wol-004-r001-wheel-reflection.md",
		"specId": "1347-f-096-wol-004-r001-wheel-reflection",
		"tags": {
			"framework": [
				"Wheel of Life"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"In-session support"
			],
			"topic": [
				"Life domains"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Requires A Wheel Profile",
				"body": "The reflection is anchored to a completed Wheel profile. Without a profile, the core mechanic is missing."
			},
			{
				"title": "Client Interpretation Comes First",
				"body": "The tool organizes what the client reports but does not infer hidden meaning from ratings or override client-stated priorities."
			},
			{
				"title": "Natural Next Step",
				"body": "After review, practitioner and client may discuss whether one or more named priorities should become coaching goals using an appropriate goal-planning tool."
			}
		],
		"faqItems": [
			{
				"question": "Can this be used before a Wheel profile exists?",
				"answer": "No. The reflection needs a completed Wheel profile to reflect on."
			},
			{
				"question": "Does the system interpret the scores?",
				"answer": "No. The system keeps the profile visible and organizes client-authored reflection, but it does not generate meaning from the ratings."
			},
			{
				"question": "Can the client name priorities that do not match the lowest scores?",
				"answer": "Yes. The tool preserves the client’s interpretation even when priorities do not simply match low ratings."
			},
			{
				"question": "Does this create goals or action steps?",
				"answer": "No. It stops at client-stated interpretation and priorities unless another supported goal-planning tool is used."
			}
		]
	},
	{
		"toolType": "wheelPriorityGoalPlan",
		"slug": "wheel-priority-goal-plan",
		"title": "Wheel Priority Goal Plan for Domain-Linked Goals | Qwoach",
		"metaDescription": "Turn priority Wheel of Life domains or gaps into concrete coaching goals linked to the areas the client wants to address.",
		"h1": "Wheel Priority Goal Plan",
		"intro": "Wheel Priority Goal Plan is a collaborative goal-planning tool for practitioners and clients after priority life-domain gaps have been identified. It helps them create concrete coaching goals linked to the Wheel domains that matter for the client’s desired life balance or satisfaction.",
		"demoTitle": "Draft a sample domain-linked goal plan, then save the tool for your practice.",
		"demoPrompt": "Interested in using Wheel Priority Goal Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1348-f-096-wol-005-r001-wheel-priority-goal-plan.md",
		"specId": "1348-f-096-wol-005-r001-wheel-priority-goal-plan",
		"tags": {
			"framework": [
				"Wheel of Life"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Life domains",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Requires Priority Context",
				"body": "The tool is designed to follow identified priority domains or gaps. Without prior priority context, it cannot preserve its native domain-linked goal mechanic."
			},
			{
				"title": "Bridge, Not Action Tracker",
				"body": "The result is a set of domain-linked goals that can guide later action planning. It does not create detailed steps, reminders, or accountability logs."
			},
			{
				"title": "Traceability",
				"body": "The priority source remains visible so each goal can be traced back to the client’s Wheel-based assessment or reflection context."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool identify the priority domains?",
				"answer": "No. It uses priority domains already identified through a Wheel profile, reflection, gap profile, or practitioner/client selection."
			},
			{
				"question": "What makes a goal complete?",
				"answer": "A complete goal is linked to a priority domain and has enough concrete text to guide later action planning."
			},
			{
				"question": "Does the system write goals for the client?",
				"answer": "No. Goal content is authored by the client and practitioner; the system only organizes links and completeness checks."
			},
			{
				"question": "Can a goal be tied to a non-priority domain?",
				"answer": "Yes, only if the practitioner and client explicitly reclassify it as meaningful and preserve the source context."
			}
		]
	},
	{
		"toolType": "repeatedWheelProgressOverlay",
		"slug": "repeated-wheel-progress-overlay",
		"title": "Repeated Wheel Progress Overlay for Coaching | Qwoach",
		"metaDescription": "Compare current Wheel of Life ratings with prior check-ins to show domain-level improvement, decline, or stability over time.",
		"h1": "Repeated Wheel / Progress Overlay",
		"intro": "Repeated Wheel / Progress Overlay is a longitudinal Wheel of Life comparison tool for practitioners and clients in periodic coaching check-ins. It helps collect current ratings for the same domains and compare them with earlier ratings so improvement, decline, or stability is visible by domain.",
		"demoTitle": "Compare a sample baseline with current ratings, then save the tool for repeated check-ins.",
		"demoPrompt": "Interested in using Repeated Wheel / Progress Overlay with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1349-f-096-wol-006-r001-repeated-wheel-progress-overlay.md",
		"specId": "1349-f-096-wol-006-r001-repeated-wheel-progress-overlay",
		"tags": {
			"framework": [
				"Wheel of Life"
			],
			"toolType": [
				"Graph"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Life domains",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Requires Prior Comparable Ratings",
				"body": "The overlay mechanic requires a prior Wheel profile with comparable domains and rating structure. Without prior ratings, use a standard Wheel assessment first."
			},
			{
				"title": "Change Is Descriptive",
				"body": "The tool can show improvement, decline, or stability by domain where comparable, but it does not infer causes or coaching effectiveness."
			},
			{
				"title": "Baseline Matters",
				"body": "The chosen baseline is explicit because comparing against the first profile, most recent profile, or another prior profile changes the meaning of the result."
			}
		],
		"faqItems": [
			{
				"question": "Can this be used for a first Wheel assessment?",
				"answer": "No. The overlay requires a prior comparable Wheel profile; first-time use belongs in a standard Wheel assessment."
			},
			{
				"question": "What happens if domains changed?",
				"answer": "The tool should compare only matching domains or clearly mark non-comparable domains according to the configured policy."
			},
			{
				"question": "Does the overlay explain why a rating changed?",
				"answer": "No. It shows descriptive change and leaves causes to the coaching discussion."
			},
			{
				"question": "Can multiple prior profiles exist?",
				"answer": "Yes. When multiple prior profiles exist, the selected baseline must be explicit in the result."
			}
		]
	},
	{
		"toolType": "writtenWoop",
		"slug": "written-woop",
		"title": "Written WOOP for Goal Pursuit Planning | Qwoach",
		"metaDescription": "Guide clients through Wish, Outcome, Obstacle, and Plan to create a written if-then response plan for a meaningful goal.",
		"h1": "Written WOOP",
		"intro": "Written WOOP is a ready-to-send self-regulation and goal-pursuit planning tool for practitioners supporting clients with meaningful goals. It helps the client write a Wish, desired Outcome, internal Obstacle, and if-then Plan so aspiration is connected to realistic self-directed follow-through.",
		"demoTitle": "Try the four-step written sequence, then save the tool for your practice.",
		"demoPrompt": "Interested in using Written WOOP with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1350-f-097-woop-001-r001-written-woop.md",
		"specId": "1350-f-097-woop-001-r001-written-woop",
		"tags": {
			"framework": [
				"WOOP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Skill practice"
			],
			"topic": [
				"Goals",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Four Required Parts",
				"body": "A completed Written WOOP includes Wish, Outcome, Obstacle, and Plan. Missing steps are shown as incomplete."
			},
			{
				"title": "Internal Obstacle",
				"body": "The obstacle is internal according to the supplied success criteria. If only an external obstacle is entered, the tool should prompt for an internal obstacle without inventing one."
			},
			{
				"title": "One Wish Per Sequence",
				"body": "The smallest complete product supports one WOOP sequence per wish. Additional wishes should create separate WOOP entries."
			}
		],
		"faqItems": [
			{
				"question": "What does the client write?",
				"answer": "The client writes a meaningful Wish, desired Outcome, internal Obstacle, and if-then Plan."
			},
			{
				"question": "Is every step required?",
				"answer": "Yes. A complete Written WOOP requires entries for all four parts."
			},
			{
				"question": "Does the tool score the WOOP?",
				"answer": "No. It checks structure and completeness but does not score quality, predict success, or interpret psychology."
			},
			{
				"question": "Can a client use multiple wishes in one WOOP?",
				"answer": "No. The smallest complete product keeps one WOOP sequence per wish; additional wishes create separate entries."
			}
		]
	},
	{
		"toolType": "wishDefinition",
		"slug": "wish-definition",
		"title": "Wish Definition Tool for Client Goal Clarification | Qwoach",
		"metaDescription": "Explore a ready-to-send Wish Definition tool that helps practitioners capture a client's personally meaningful goal for later planning work.",
		"h1": "Wish Definition",
		"intro": "Wish Definition is a ready-to-send tool for practitioners working with clients whose goal is vague, externally driven, or not yet personally meaningful. It helps the client state a personally meaningful wish or goal that can support later motivation and planning work.",
		"demoTitle": "Try the client view with sample wish wording, then review the submitted goal as the practitioner.",
		"demoPrompt": "Interested in using Wish Definition with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1351-f-097-woop-002-r001-wish-definition.md",
		"specId": "1351-f-097-woop-002-r001-wish-definition",
		"tags": {
			"framework": [
				"WOOP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals",
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When to use it",
				"body": "Use it before deeper motivation or planning work when the client needs to name a goal that reflects their own priorities."
			},
			{
				"title": "What it does not do",
				"body": "It does not capture outcomes, obstacles, plans, ratings, diagnoses, recommendations, or longitudinal progress."
			}
		],
		"faqItems": [
			{
				"question": "Does Wish Definition score the quality of a client's goal?",
				"answer": "No. Wish Definition captures and organizes the client's reported goal without scoring or interpreting goal quality."
			},
			{
				"question": "Can the client submit a broad or externally driven goal?",
				"answer": "Yes. The tool preserves the client's wording and leaves follow-up or clarification to practitioner review."
			},
			{
				"question": "Is this the full WOOP process?",
				"answer": "No. This tool covers only the Wish step and does not include Outcome, Obstacle, Plan, or Review steps."
			}
		]
	},
	{
		"toolType": "bestOutcomeImagery",
		"slug": "best-outcome-imagery",
		"title": "Best Outcome Imagery Tool for Goal Motivation | Qwoach",
		"metaDescription": "Explore a client outcome-imagery tool that helps practitioners capture the positive outcome linked to a specific client goal.",
		"h1": "Best Outcome Imagery",
		"intro": "Best Outcome Imagery is a ready-to-send tool for practitioners working with clients who already have a meaningful goal. It helps the client describe the best desired outcome and the motivational meaning connected to that specific goal.",
		"demoTitle": "Choose a sample goal context, write a sample outcome, and review the goal-outcome result.",
		"demoPrompt": "Interested in using Best Outcome Imagery with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1352-f-097-woop-003-r001-best-outcome-imagery.md",
		"specId": "1352-f-097-woop-003-r001-best-outcome-imagery",
		"tags": {
			"framework": [
				"WOOP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals",
				"Values"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When to use it",
				"body": "Use it after a meaningful goal is available and before identifying obstacles or creating a plan."
			},
			{
				"title": "What it does not do",
				"body": "It does not define the original wish, identify obstacles, create if-then plans, rate motivation, or interpret the outcome."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool generate outcome imagery for the client?",
				"answer": "No. The client supplies the outcome content; the system only organizes and displays it."
			},
			{
				"question": "Is a goal required?",
				"answer": "Yes. The outcome must be linked to a specific goal context before the tool can preserve its meaning."
			},
			{
				"question": "Does the result include obstacle planning?",
				"answer": "No. The result is limited to the goal, best outcome, and client-reported motivational meaning."
			}
		]
	},
	{
		"toolType": "internalObstacleIdentification",
		"slug": "internal-obstacle-identification",
		"title": "Internal Obstacle Identification Tool for Goal Planning | Qwoach",
		"metaDescription": "Explore a ready-to-send tool that helps practitioners capture the internal obstacle most likely to interfere with a client's goal pursuit.",
		"h1": "Internal Obstacle Identification",
		"intro": "Internal Obstacle Identification is a ready-to-send tool for practitioners working with clients who have a goal and desired outcome. It helps the client name the internal thought, feeling, impulse, or habit most likely to interfere with goal pursuit.",
		"demoTitle": "Set a sample goal and outcome, then try the client obstacle entry and practitioner review.",
		"demoPrompt": "Interested in using Internal Obstacle Identification with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1353-f-097-woop-004-r001-internal-obstacle-identification.md",
		"specId": "1353-f-097-woop-004-r001-internal-obstacle-identification",
		"tags": {
			"framework": [
				"WOOP"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Internal obstacle focus",
				"body": "The tool keeps attention on client-reported thoughts, feelings, impulses, or habits rather than external circumstances as the primary result."
			},
			{
				"title": "Single-barrier result",
				"body": "The primary result is one key obstacle so later planning can stay clear."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool reject external obstacles?",
				"answer": "No. It preserves the client's report and leaves the internal-obstacle fit for practitioner review."
			},
			{
				"question": "Can it capture more than one obstacle?",
				"answer": "The tool is designed around one key obstacle as the primary result; separate obstacles should become separate instances if needed."
			},
			{
				"question": "Does it create a plan?",
				"answer": "No. It identifies the obstacle only and does not generate if-then plans or suggested responses."
			}
		]
	},
	{
		"toolType": "ifThenPlan",
		"slug": "if-then-plan",
		"title": "If-Then Plan Tool for Client Implementation Intentions | Qwoach",
		"metaDescription": "Explore a ready-to-send if-then planning tool that helps practitioners capture a client's trigger, response, and formatted contingency plan.",
		"h1": "If-Then Plan",
		"intro": "If-Then Plan is a ready-to-send tool for practitioners working with clients who know the internal obstacle that may interfere with a goal. It helps the client define a recognizable trigger and a concrete response, then formats them into one if-then plan.",
		"demoTitle": "Set sample goal and obstacle context, then build and review a sample if-then plan.",
		"demoPrompt": "Interested in using If-Then Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1354-f-097-woop-005-r001-if-then-plan.md",
		"specId": "1354-f-097-woop-005-r001-if-then-plan",
		"tags": {
			"framework": [
				"WOOP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One plan per completion",
				"body": "The tool keeps one primary if-then plan per completion so the contingency remains memorable and reviewable."
			},
			{
				"title": "Client visibility",
				"body": "The final plan remains visible to the client so it can be recalled when the obstacle appears."
			}
		],
		"faqItems": [
			{
				"question": "Does If-Then Plan suggest the response?",
				"answer": "No. The response is supplied by the client or practitioner context; the system only formats the if-then statement."
			},
			{
				"question": "Are both fields required?",
				"answer": "Yes. Completion requires both a trigger and a response."
			},
			{
				"question": "Does the tool include reminders or progress tracking?",
				"answer": "No. Reminders, tracking, adherence logs, and progress scores are outside this tool."
			}
		]
	},
	{
		"toolType": "planRefinementOvercomePreventOpportunity",
		"slug": "plan-refinement-overcome-prevent-opportunity",
		"title": "Plan Refinement Tool for Overcome, Prevent, and Opportunity Plans | Qwoach",
		"metaDescription": "Explore a plan refinement tool that helps practitioners match a client's trigger-response logic to overcome, prevent, or opportunity situations.",
		"h1": "Plan Refinement: Overcome / Prevent / Opportunity",
		"intro": "Plan Refinement: Overcome / Prevent / Opportunity is a ready-to-send tool for practitioners refining an existing goal response. It helps the client or practitioner select whether the plan is for overcoming, preventing, or using an opportunity, then clarifies the trigger-response action logic.",
		"demoTitle": "Choose a sample plan type, refine the trigger and response, and review the labeled action logic.",
		"demoPrompt": "Interested in using Plan Refinement: Overcome / Prevent / Opportunity with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1355-f-097-woop-006-r001-plan-refinement-overcome-prevent-opportunity.md",
		"specId": "1355-f-097-woop-006-r001-plan-refinement-overcome-prevent-opportunity",
		"tags": {
			"framework": [
				"WOOP"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning",
				"Problem solving"
			],
			"topic": [
				"Behavior change",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Supported plan types",
				"body": "The tool supports exactly three plan types: Overcome, Prevent, and Opportunity."
			},
			{
				"title": "Revision history",
				"body": "If the type changes after completion, the revised state should remain distinguishable from the earlier version for review."
			}
		],
		"faqItems": [
			{
				"question": "Can the system decide the correct plan type automatically?",
				"answer": "No. The selected type is a client or practitioner decision, not a system interpretation."
			},
			{
				"question": "Can one refinement include multiple situations?",
				"answer": "No. One primary situation is used per refinement; separate situations should use separate refinements."
			},
			{
				"question": "Does the tool create new action ideas?",
				"answer": "No. It refines supplied trigger-response logic and does not generate substantive action content."
			}
		]
	},
	{
		"toolType": "woopReview",
		"slug": "woop-review",
		"title": "WOOP Review Tool for Goal Plan Progress and Fit | Qwoach",
		"metaDescription": "Explore a WOOP Review tool that helps practitioners compare a prior goal plan with current progress, obstacle changes, and plan usefulness.",
		"h1": "WOOP Review",
		"intro": "WOOP Review is a recurring review tool for practitioners whose clients have been using a goal pursuit plan. It helps compare the prior goal, obstacle, and plan with the client's current progress, obstacle experience, plan usefulness, and decision to continue, revise, or replace.",
		"demoTitle": "Open a sample prior plan, complete a fictional review, and inspect the practitioner comparison view.",
		"demoPrompt": "Interested in using WOOP Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1356-f-097-woop-007-r001-woop-review.md",
		"specId": "1356-f-097-woop-007-r001-woop-review",
		"tags": {
			"framework": [
				"WOOP"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Requires an existing plan",
				"body": "WOOP Review cannot run as designed without a prior goal, obstacle, and plan target."
			},
			{
				"title": "History over time",
				"body": "Completed reviews persist as dated points tied to the plan instance so progress and fit decisions remain visible."
			}
		],
		"faqItems": [
			{
				"question": "Can WOOP Review create the original plan?",
				"answer": "No. WOOP Review requires an existing goal, obstacle, and plan to review."
			},
			{
				"question": "Does the tool recommend whether to continue, revise, or replace?",
				"answer": "No. Continue, revise, or replace is a practitioner decision state, not an automated recommendation."
			},
			{
				"question": "Does it score progress?",
				"answer": "No. It captures descriptive progress and fit information without clinical scores or adherence grades."
			}
		]
	},
	{
		"toolType": "woopAppTimeline",
		"slug": "woop-app-timeline",
		"title": "WOOP Timeline Tool for Goal and Plan History | Qwoach",
		"metaDescription": "Explore a WOOP-style timeline that helps practitioners review client goals, obstacles, plans, and progress across sessions.",
		"h1": "WOOP App / Timeline",
		"intro": "WOOP App / Timeline is a longitudinal tool for practitioners supporting clients with goal pursuit over time. It helps organize current and past WOOP-style goals, obstacles, plans, and progress updates so coaching can continue from a shared record.",
		"demoTitle": "Explore a sample timeline, open current and past entries, and review how progress and fit changes are preserved.",
		"demoPrompt": "Interested in using WOOP App / Timeline with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1357-f-097-woop-008-r001-woop-app-timeline.md",
		"specId": "1357-f-097-woop-008-r001-woop-app-timeline",
		"tags": {
			"framework": [
				"WOOP"
			],
			"toolType": [
				"Log"
			],
			"workflow": [
				"Between-session monitoring",
				"Progress review"
			],
			"topic": [
				"Goals",
				"Outcome monitoring"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Not a generic tracker",
				"body": "The timeline is specifically for WOOP-style goals, obstacles, plans, and progress history."
			},
			{
				"title": "Pattern visibility",
				"body": "Recurring reported obstacles can be displayed descriptively without inferring causes or producing automated interpretations."
			},
			{
				"title": "Drafts and revisions",
				"body": "Incomplete entries are marked as drafts, and revisions remain visible when historical comparison matters."
			}
		],
		"faqItems": [
			{
				"question": "Can the timeline include multiple current goals?",
				"answer": "Yes. Multiple current entries can be maintained intentionally, with each entry kept separate."
			},
			{
				"question": "Does the timeline provide analytics or success scores?",
				"answer": "No. It organizes reported history without productivity metrics, scores, or automated coaching conclusions."
			},
			{
				"question": "What happens to archived entries?",
				"answer": "Archived entries remain available as past history while current entries guide the next coaching focus."
			}
		]
	},
	{
		"toolType": "5DAppreciativeInquiryCycle",
		"slug": "5-d-appreciative-inquiry-cycle",
		"title": "5-D Appreciative Inquiry Cycle Tool for Strengths-Based Change | Qwoach",
		"metaDescription": "Explore a staged Appreciative Inquiry cycle that helps practitioners facilitate strengths, aspirations, design ideas, and commitments.",
		"h1": "5-D Appreciative Inquiry Cycle",
		"intro": "The 5-D Appreciative Inquiry Cycle is a ready-to-complete-together tool for practitioners facilitating change with a client or group. It helps connect existing strengths, future aspirations, design choices, and commitments into a coherent strengths-based direction.",
		"demoTitle": "Move through a sample facilitated cycle and review the staged summary.",
		"demoPrompt": "Interested in using 5-D Appreciative Inquiry Cycle with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1358-f-098-ai-001-r001-5-d-appreciative-inquiry-cycle.md",
		"specId": "1358-f-098-ai-001-r001-5-d-appreciative-inquiry-cycle",
		"tags": {
			"framework": [
				"Appreciative Inquiry"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Strengths",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Designed for completion together",
				"body": "The tool supports facilitated work with an individual or group rather than requiring an independent client self-serve flow."
			},
			{
				"title": "Partial cycles",
				"body": "Incomplete cycles preserve completed stage outputs and mark remaining stages incomplete."
			},
			{
				"title": "Participant voice and synthesis",
				"body": "Participant-reported material remains distinct from practitioner synthesis."
			}
		],
		"faqItems": [
			{
				"question": "Is this a survey?",
				"answer": "No. It is a staged facilitation workflow, not a questionnaire or assessment."
			},
			{
				"question": "Can it be used with a group?",
				"answer": "Yes. The same staged mechanic supports individual and group participation where the practitioner facilitates the cycle."
			},
			{
				"question": "Does it include scores or rankings?",
				"answer": "No. It organizes stage outputs and completion status without scoring, ranking, or diagnosis."
			}
		]
	},
	{
		"toolType": "affirmativeTopicDefinition",
		"slug": "affirmative-topic-definition",
		"title": "Affirmative Topic Definition Tool for Appreciative Inquiry | Qwoach",
		"metaDescription": "Explore a focus-setting tool that helps practitioners and groups define an affirmative topic for strengths-based inquiry.",
		"h1": "Affirmative Topic Definition",
		"intro": "Affirmative Topic Definition is a ready-to-complete-together tool for practitioners starting a strengths-based inquiry with a client or group. It helps define a meaningful affirmative topic that names what the client or group wants to learn about and grow.",
		"demoTitle": "Draft a sample inquiry topic, refine it affirmatively, and review the final focus.",
		"demoPrompt": "Interested in using Affirmative Topic Definition with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1359-f-098-ai-002-r001-affirmative-topic-definition.md",
		"specId": "1359-f-098-ai-002-r001-affirmative-topic-definition",
		"tags": {
			"framework": [
				"Appreciative Inquiry"
			],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "One primary topic",
				"body": "Each inquiry instance should identify one primary affirmative topic; separate topics should become separate instances."
			},
			{
				"title": "Draft and revision states",
				"body": "Candidate wording, unresolved drafts, and deliberate later revisions can be preserved so later inquiry outputs remain understandable."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool run the full Appreciative Inquiry cycle?",
				"answer": "No. It only defines the affirmative inquiry focus."
			},
			{
				"question": "Can it preserve deficit-framed starting language?",
				"answer": "Yes. Initial wording can be preserved where useful while the final result is an affirmative topic."
			},
			{
				"question": "Does the system recommend a topic?",
				"answer": "No. The topic is collaboratively drafted by the practitioner and client or group, not automatically generated."
			}
		]
	},
	{
		"toolType": "peakExperienceBestOfWhatIsInterview",
		"slug": "peak-experience-best-of-what-is-interview",
		"title": "Peak Experience Interview Tool for Appreciative Inquiry Discovery | Qwoach",
		"metaDescription": "Explore a discovery interview tool that helps practitioners capture peak experiences, strengths, and enabling conditions for change work.",
		"h1": "Peak Experience / Best-of-What-Is Interview",
		"intro": "Peak Experience / Best-of-What-Is Interview is a ready-to-complete-together tool for practitioners working with a client or group. It helps capture high-functioning experiences, identify strengths, and make enabling conditions explicit so future change work can build from demonstrated sources of capability and energy.",
		"demoTitle": "Set a sample inquiry focus, capture a fictional peak experience, and review the strengths discovery map.",
		"demoPrompt": "Interested in using Peak Experience / Best-of-What-Is Interview with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1360-f-098-ai-003-r001-peak-experience-best-of-what-is-interview.md",
		"specId": "1360-f-098-ai-003-r001-peak-experience-best-of-what-is-interview",
		"tags": {
			"framework": [
				"Appreciative Inquiry"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Multiple voices",
				"body": "The tool can preserve multiple examples and participant voices without forcing a single synthesis."
			},
			{
				"title": "Partial discovery",
				"body": "An interview can remain partial when experiences are captured but strengths or enabling conditions are still unresolved."
			},
			{
				"title": "Focus-linked insights",
				"body": "Discovery outputs remain tied to the inquiry focus used at the time of capture."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool provide interview questions?",
				"answer": "No. Exact interview prompts are unresolved by the product specification and should not be invented in the demo."
			},
			{
				"question": "Can the tool rank strengths?",
				"answer": "No. It captures strengths and enabling conditions without ranking, scoring, or diagnosing them."
			},
			{
				"question": "Is this a full Appreciative Inquiry cycle?",
				"answer": "No. It is a Discover-style interview and does not define the topic, design changes, or capture commitments."
			}
		]
	},
	{
		"toolType": "strengthsLifeGivingForcesMap",
		"slug": "strengths-life-giving-forces-map",
		"title": "Strengths / Life-Giving Forces Map Demo | Qwoach",
		"metaDescription": "Explore a strengths map for appreciative inquiry discovery. Capture successes, shared assets, and enabling conditions before change design.",
		"h1": "Strengths / Life-Giving Forces Map",
		"intro": "The Strengths / Life-Giving Forces Map is a collaborative discovery tool for practitioners working with a client, team, or system. It helps identify shared strengths, past successes, life-giving assets, and the conditions that made those successes possible before future changes are defined.",
		"demoTitle": "Open the sample map",
		"demoPrompt": "Interested in using Strengths / Life-Giving Forces Map with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1361-f-098-ai-004-r001-strengths-life-giving-forces-map.md",
		"specId": "1361-f-098-ai-004-r001-strengths-life-giving-forces-map",
		"tags": {
			"framework": [
				"Appreciative Inquiry"
			],
			"toolType": [
				"Map"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the map at the beginning of a strengths-based change effort, before defining the future state or action commitments."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures success examples, strengths/assets, and enabling conditions as distinct information types so the shared map remains traceable to participant-provided material."
			},
			{
				"title": "Important Limits",
				"body": "The map does not score people, diagnose systems, define the preferred future, create design commitments, or build an action plan."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool score strengths?",
				"answer": "No. The tool organizes strengths, successes, assets, and enabling conditions descriptively; it does not score, rank, or diagnose them."
			},
			{
				"question": "Can participants contribute to the map?",
				"answer": "Yes. A client, team, or system can contribute positive examples, strengths noticed, and enabling conditions during a facilitated session."
			},
			{
				"question": "Can a draft map be saved before it is confirmed?",
				"answer": "Yes. Partial maps remain usable as working notes and should be marked incomplete until the practitioner confirms the shared map with participants."
			},
			{
				"question": "What is required before a map can be finalized?",
				"answer": "At least one success or asset must be captured before the result can be finalized."
			}
		]
	},
	{
		"toolType": "preferredFutureDreamStatement",
		"slug": "preferred-future-dream-statement",
		"title": "Preferred Future / Dream Statement Demo | Qwoach",
		"metaDescription": "Explore a Dream statement tool for appreciative inquiry. Build a shared future-state aspiration grounded in strengths and prior successes.",
		"h1": "Preferred Future / Dream Statement",
		"intro": "The Preferred Future / Dream Statement is a collaboration tool for practitioners working with a client, team, or system after strengths have been identified. It helps articulate a clear desired future that reflects participant values and builds on positive experiences and strengths.",
		"demoTitle": "Draft a sample Dream statement",
		"demoPrompt": "Interested in using Preferred Future / Dream Statement with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1362-f-098-ai-005-r001-preferred-future-dream-statement.md",
		"specId": "1362-f-098-ai-005-r001-preferred-future-dream-statement",
		"tags": {
			"framework": [
				"Appreciative Inquiry"
			],
			"toolType": [
				"Therapeutic document"
			],
			"workflow": [
				"Goal setting"
			],
			"topic": [
				"Goals",
				"Values",
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool after strengths and positive experiences have been identified and before design commitments are created."
			},
			{
				"title": "What It Produces",
				"body": "The result is a desired-future statement with visible grounding in strengths and prior successes, plus any unresolved wording alternatives."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create action plans, assign owners, score aspirations, evaluate feasibility, or generate the future-state content on behalf of participants."
			}
		],
		"faqItems": [
			{
				"question": "Does the tool write the Dream statement automatically?",
				"answer": "No. Participants and the practitioner supply the future-state language; the system organizes drafts and structural checks."
			},
			{
				"question": "Can the tool be used without prior strengths?",
				"answer": "Yes. Drafting can begin without prior strengths, but the result should show that grounding in identified strengths is unresolved."
			},
			{
				"question": "Can there be multiple versions of the aspiration?",
				"answer": "Yes. Candidate wording can remain as alternatives until the practitioner consolidates or confirms one shared version."
			},
			{
				"question": "Is the result an action plan?",
				"answer": "No. The result is an aspirational future-state statement for later design work, not a task list or implementation plan."
			}
		]
	},
	{
		"toolType": "provocativePropositionDesignStatement",
		"slug": "provocative-proposition-design-statement",
		"title": "Design Statement Tool Demo | Qwoach",
		"metaDescription": "Explore a design statement tool for appreciative inquiry. Create affirmative commitments grounded in strengths and a preferred future.",
		"h1": "Provocative Proposition / Design Statement",
		"intro": "The Provocative Proposition / Design Statement is a collaborative tool for practitioners working with a client, team, or system. It helps create affirmative design commitments that connect what already works with the preferred future participants want to make true.",
		"demoTitle": "Draft sample design commitments",
		"demoPrompt": "Interested in using Provocative Proposition / Design Statement with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1363-f-098-ai-006-r001-provocative-proposition-design-statement.md",
		"specId": "1363-f-098-ai-006-r001-provocative-proposition-design-statement",
		"tags": {
			"framework": [
				"Appreciative Inquiry"
			],
			"toolType": [
				"Therapeutic document"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Goals",
				"Strengths"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the tool after a strengths map and preferred future statement exist, when the group needs commitments that can guide decisions and action planning."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures commitment text, links to strengths and aspirations, draft or confirmed status, unresolved wording, and consolidation of related drafts."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not manage tasks, assign responsibilities, rank commitments, score alignment, or judge whether a commitment is substantively correct."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool create the commitments for the group?",
				"answer": "No. Commitment wording is supplied by participants and the practitioner; the system organizes grounding and structural review."
			},
			{
				"question": "Can a commitment be drafted without source material?",
				"answer": "Yes. Drafting can continue, but the commitment should be marked as having unresolved grounding until linked to a strength or aspiration when available."
			},
			{
				"question": "Can there be more than one design commitment?",
				"answer": "Yes. The tool supports one or more affirmative design commitments."
			},
			{
				"question": "Is this an action plan?",
				"answer": "No. The tool creates guiding design commitments; implementation responsibilities and next steps belong in a separate action-planning workflow."
			}
		]
	},
	{
		"toolType": "destinyActionPlan",
		"slug": "destiny-action-plan",
		"title": "Destiny / Action Plan Demo | Qwoach",
		"metaDescription": "Explore an appreciative inquiry action plan for implementation commitments, responsibilities, desired-change links, and follow-up reference.",
		"h1": "Destiny / Action Plan",
		"intro": "The Destiny / Action Plan is a collaborative planning tool for practitioners working with a client, team, or system. It helps record implementation commitments, responsible people or groups, links to the desired change, and a basis for follow-up on sustained change.",
		"demoTitle": "Build a sample action plan",
		"demoPrompt": "Interested in using Destiny / Action Plan with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1364-f-098-ai-007-r001-destiny-action-plan.md",
		"specId": "1364-f-098-ai-007-r001-destiny-action-plan",
		"tags": {
			"framework": [
				"Appreciative Inquiry"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Behavior change",
				"Goals"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool after a preferred future or design commitment has been agreed and participants need implementation commitments that can be followed up."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the commitment, responsible person or group, connection to the desired change, and follow-up note where known."
			},
			{
				"title": "Important Limits",
				"body": "The tool is not a full project manager, scheduling system, productivity dashboard, or generic to-do list."
			}
		],
		"faqItems": [
			{
				"question": "Does every finalized commitment need an owner?",
				"answer": "Yes. A finalized follow-upable commitment needs a responsible person or group."
			},
			{
				"question": "Can the action plan include generic tasks?",
				"answer": "No. Tasks should be tied to the desired change; isolated tasks are flagged rather than treated as complete implementation commitments."
			},
			{
				"question": "Does the tool track progress ratings?",
				"answer": "No. The supplied product defines implementation commitments and follow-up basis, not progress scores or ratings."
			},
			{
				"question": "Can commitments be revised later?",
				"answer": "Yes. Confirmed commitments can be updated, but the original commitment should remain visible for follow-up comparison."
			}
		]
	},
	{
		"toolType": "appreciativeInquiryProgressReview",
		"slug": "appreciative-inquiry-progress-review",
		"title": "Appreciative Inquiry Progress Review Demo | Qwoach",
		"metaDescription": "Explore a progress review for strengths-based change. Track dated evidence, learning, what is working, and adjustment needs over time.",
		"h1": "Appreciative Inquiry Progress Review",
		"intro": "The Appreciative Inquiry Progress Review is a longitudinal review tool for practitioners supporting a strengths-based change effort. It helps connect progress evidence, what is working, learning, and adjustment needs to the original aspirations or commitments over time.",
		"demoTitle": "Start a sample progress review",
		"demoPrompt": "Interested in using Appreciative Inquiry Progress Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1365-f-098-ai-008-r001-appreciative-inquiry-progress-review.md",
		"specId": "1365-f-098-ai-008-r001-appreciative-inquiry-progress-review",
		"tags": {
			"framework": [
				"Appreciative Inquiry"
			],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Progress review"
			],
			"topic": [
				"Outcome monitoring",
				"Behavior change"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the review while a strengths-based change effort is underway, especially when prior commitments or aspirations need to be revisited over time."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures dated review entries, progress evidence, what is working, learning, adjustment needs, and links to original reference artifacts."
			},
			{
				"title": "Longitudinal Behavior",
				"body": "Draft reviews are separate from completed review points. Completed entries stay time-ordered so the practitioner can compare change-learning across reviews."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not score implementation success, diagnose failure, prescribe interventions, or replace the original action plan."
			}
		],
		"faqItems": [
			{
				"question": "Can the first review show comparison over time?",
				"answer": "No. The first review can show baseline reference artifacts, but there is no prior review point for comparison yet."
			},
			{
				"question": "Can a review be completed without a reference aspiration or commitment?",
				"answer": "No. Notes can be drafted, but connected longitudinal review requires at least one aspiration or commitment reference."
			},
			{
				"question": "Are draft reviews included in the timeline comparison?",
				"answer": "No. Drafts are saved separately and excluded from longitudinal comparison until marked complete."
			},
			{
				"question": "Does the review decide whether the change succeeded?",
				"answer": "No. The review organizes evidence, learning, and adjustment needs; it does not make a definitive success or failure judgment."
			}
		]
	},
	{
		"toolType": "oNetInterestProfiler2",
		"slug": "o-net-interest-profiler-2",
		"title": "O*NET Interest Profiler Demo | Qwoach",
		"metaDescription": "Explore a six-domain vocational interest profiler for career guidance. Review RIASEC domain results and relative interest patterns.",
		"h1": "O*NET Interest Profiler",
		"intro": "The O*NET Interest Profiler is a vocational interest assessment for career practitioners supporting clients in career exploration. It produces a six-domain RIASEC interest profile that helps clarify relative interest patterns for a guidance conversation.",
		"demoTitle": "Preview the profiler experience",
		"demoPrompt": "Interested in using O*NET Interest Profiler with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1366-f-099-riasec-001-r001-o-net-interest-profiler.md",
		"specId": "1366-f-099-riasec-001-r001-o-net-interest-profiler",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Fixed Domains",
				"body": "The profile always represents Realistic, Investigative, Artistic, Social, Enterprising, and Conventional interests."
			},
			{
				"title": "Client Completion",
				"body": "The client completes required profiler responses before a final profile is produced. Partial assessments show progress but no final scores."
			},
			{
				"title": "Result Use",
				"body": "The result is used for career guidance conversation and exploration of occupational environments, not as a final career decision."
			},
			{
				"title": "Known Validation Needs",
				"body": "Exact item wording, response scale, scoring rules, and client-facing result visibility must be validated from the represented profiler definition."
			}
		],
		"faqItems": [
			{
				"question": "Can practitioners change the six interest domains?",
				"answer": "No. The six RIASEC domains are fixed for this represented tool."
			},
			{
				"question": "Are results produced from incomplete responses?",
				"answer": "No. Final scoring is withheld until required responses are complete."
			},
			{
				"question": "Does the profile choose a career for the client?",
				"answer": "No. The profile clarifies vocational interest patterns for discussion; it does not decide a career or guarantee fit."
			},
			{
				"question": "Can a client retake the profiler?",
				"answer": "Yes. A retake should create a separate dated result so prior results remain stable."
			}
		]
	},
	{
		"toolType": "miniIp30ItemInterestProfiler",
		"slug": "mini-ip-30-item-interest-profiler",
		"title": "Mini-IP 30-Item Interest Profiler Demo | Qwoach",
		"metaDescription": "Explore a brief 30-item vocational interest profiler. Review six RIASEC scores for a focused career exploration conversation.",
		"h1": "Mini-IP 30-Item Interest Profiler",
		"intro": "The Mini-IP 30-Item Interest Profiler is a brief vocational interest assessment for career practitioners. It helps produce usable scores across Realistic, Investigative, Artistic, Social, Enterprising, and Conventional domains without a lengthy assessment process.",
		"demoTitle": "Preview the 30-item profiler",
		"demoPrompt": "Interested in using Mini-IP 30-Item Interest Profiler with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1367-f-099-riasec-002-r001-mini-ip-30-item-interest-profiler.md",
		"specId": "1367-f-099-riasec-002-r001-mini-ip-30-item-interest-profiler",
		"tags": {
			"framework": [],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Brief Use Case",
				"body": "Use the Mini-IP when a structured interest snapshot is enough to orient the next career exploration conversation."
			},
			{
				"title": "Fixed Structure",
				"body": "The tool remains a 30-item profiler with scores across Realistic, Investigative, Artistic, Social, Enterprising, and Conventional domains."
			},
			{
				"title": "Result Scope",
				"body": "The result is a six-score snapshot. It does not include an occupation match list, ability inference, or extended narrative report."
			},
			{
				"title": "Known Validation Needs",
				"body": "Exact item wording, response options, scoring rules, score display format, and client result visibility must be validated."
			}
		],
		"faqItems": [
			{
				"question": "Is the Mini-IP configurable?",
				"answer": "No. The represented tool has a fixed 30-item format and six RIASEC domains."
			},
			{
				"question": "Can scores be produced before all items are answered?",
				"answer": "No. Final scores are not produced from incomplete required responses."
			},
			{
				"question": "Does the tool ask clients for written explanations?",
				"answer": "No. Narrative justification should not be added unless the represented Mini-IP definition requires it, which is not supported by the supplied record."
			},
			{
				"question": "Is this a full career assessment history?",
				"answer": "No. The result is a brief six-domain snapshot for initial career exploration."
			}
		]
	},
	{
		"toolType": "riasecCodeTopInterests",
		"slug": "riasec-code-top-interests",
		"title": "RIASEC Code / Top Interests Demo | Qwoach",
		"metaDescription": "Explore a tool that condenses six-domain interest data into a RIASEC code and ordered top-interest themes for career discussion.",
		"h1": "RIASEC Code / Top Interests",
		"intro": "The RIASEC Code / Top Interests tool is for career practitioners who already have a client’s vocational interest data. It derives an interpretable code and ordered top-interest themes so the practitioner can focus career discussion and exploration.",
		"demoTitle": "Derive a sample RIASEC code",
		"demoPrompt": "Interested in using RIASEC Code / Top Interests with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1368-f-099-riasec-003-r001-riasec-code-top-interests.md",
		"specId": "1368-f-099-riasec-003-r001-riasec-code-top-interests",
		"tags": {
			"framework": [],
			"toolType": [
				"Report"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Required Source Data",
				"body": "The tool needs existing six-domain RIASEC interest data. If a required domain score is missing, a final code is unavailable or marked provisional."
			},
			{
				"title": "What It Shows",
				"body": "The result shows the condensed code, ordered leading themes, supporting domain scores, source profile/date, and tie or close-score notes."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not administer a profiler, manually override the derived code, infer abilities, or produce occupation matches by itself."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool administer an interest assessment?",
				"answer": "No. It derives a code from existing six-domain interest data."
			},
			{
				"question": "Can the practitioner manually change the code?",
				"answer": "No. The derived code should change only when source data or supported derivation rules change; practitioner notes can be separate."
			},
			{
				"question": "What happens if a domain score is missing?",
				"answer": "A final code should not be generated when required domain data are missing."
			},
			{
				"question": "Does the code recommend occupations?",
				"answer": "No. The code supports focused career discussion; occupation matching requires a separate supported tool."
			}
		]
	},
	{
		"toolType": "occupationMatchExplorer",
		"slug": "occupation-match-explorer",
		"title": "Occupation Match Explorer Demo | Qwoach",
		"metaDescription": "Explore occupation candidates connected to a client interest pattern. Capture preferences and narrow next career exploration steps.",
		"h1": "Occupation Match Explorer",
		"intro": "The Occupation Match Explorer is a career exploration tool for practitioners and clients. It connects a measured or stated vocational interest pattern to candidate occupations and captures simple client preference signals so the next exploration steps are easier to narrow.",
		"demoTitle": "Explore sample occupation matches",
		"demoPrompt": "Interested in using Occupation Match Explorer with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1369-f-099-riasec-004-r001-occupation-match-explorer.md",
		"specId": "1369-f-099-riasec-004-r001-occupation-match-explorer",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "Practitioner And Client Roles",
				"body": "The practitioner supplies or selects interest data. The client reviews candidate occupations and records preference signals. The practitioner reviews the narrowed set."
			},
			{
				"title": "Preference Signals",
				"body": "Preference signals are exploratory and remain distinct from match logic; liking an occupation does not change why it appeared in the candidate set."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not guarantee fit, decide a career, assess qualifications, verify credentials, estimate hiring likelihood, or invent occupation data."
			},
			{
				"title": "Known Validation Needs",
				"body": "Occupation data source, matching method, initial candidate set size, allowed preference labels, and whether clients can add occupations require validation."
			}
		],
		"faqItems": [
			{
				"question": "Does this tool choose a career for the client?",
				"answer": "No. It presents occupations worth considering and captures preferences for further exploration."
			},
			{
				"question": "What input is required to generate candidates?",
				"answer": "A supported vocational interest pattern is required; without it, the tool cannot generate a supported candidate set."
			},
			{
				"question": "Can the client reject every option?",
				"answer": "Yes. The tool preserves that preference data and supports revisiting the interest pattern or exploration criteria."
			},
			{
				"question": "Are client preferences the same as match scores?",
				"answer": "No. Preference signals are separate from the interest-pattern basis used to surface candidate occupations."
			}
		]
	},
	{
		"toolType": "interestOccupationFitReview",
		"slug": "interest-occupation-fit-review",
		"title": "Interest–Occupation Fit Review Demo | Qwoach",
		"metaDescription": "Explore a career fit review that links client interest themes to selected occupations, visible mismatches, and next exploration steps.",
		"h1": "Interest–Occupation Fit Review",
		"intro": "The Interest–Occupation Fit Review is a collaborative career guidance tool for practitioners and clients considering specific occupations. It helps link interest themes to occupational environments or demands, identify fit and mismatch points, and record implications for continuing, narrowing, or revising exploration.",
		"demoTitle": "Review sample occupations",
		"demoPrompt": "Interested in using Interest–Occupation Fit Review with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1370-f-099-riasec-005-r001-interest-occupation-fit-review.md",
		"specId": "1370-f-099-riasec-005-r001-interest-occupation-fit-review",
		"tags": {
			"framework": [],
			"toolType": [
				"Worksheet"
			],
			"workflow": [
				"Intervention planning",
				"Problem solving"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use the review after a client has specific occupations under consideration and available vocational interest themes."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures fit points, mismatch points, occupation-specific reasoning, unresolved questions, and implications for continuing, narrowing, or revising exploration."
			},
			{
				"title": "Comparison Behavior",
				"body": "Multiple occupations can be compared side by side without automatically ranking them."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not administer an interest assessment, generate broad occupation lists, evaluate qualifications, or make final career decisions."
			}
		],
		"faqItems": [
			{
				"question": "Can the review be completed without interest data?",
				"answer": "No. An interest-based fit review requires client vocational interest themes or results."
			},
			{
				"question": "What if no mismatch is identified for an occupation?",
				"answer": "That can be recorded only as a practitioner-confirmed state, because important mismatches should not be ignored."
			},
			{
				"question": "Does the tool rank occupations automatically?",
				"answer": "No. The review compares fit and mismatch reasoning without forcing an unsupported ranking."
			},
			{
				"question": "Can the client contribute reactions?",
				"answer": "Yes. When completed together, client reactions can inform the discussion, while the practitioner controls the formal review."
			}
		]
	},
	{
		"toolType": "careerExplorationShortlist",
		"slug": "career-exploration-shortlist",
		"title": "Career Exploration Shortlist for Practitioners | Qwoach",
		"metaDescription": "Demo a career guidance tool that helps practitioners turn vocational interest patterns into a manageable shortlist of exploration targets.",
		"h1": "Career Exploration Shortlist",
		"intro": "Career Exploration Shortlist is a ready-to-send career guidance tool for practitioners working with clients who have vocational interest information. It helps the practitioner and client narrow interest-grounded candidate targets into a manageable set of careers or occupations the client can investigate next.",
		"demoTitle": "Explore the sample setup, try client preference selections, and save the tool for your practice.",
		"demoPrompt": "Interested in using Career Exploration Shortlist with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1371-f-099-riasec-006-r001-career-exploration-shortlist.md",
		"specId": "1371-f-099-riasec-006-r001-career-exploration-shortlist",
		"tags": {
			"framework": [
				"RIASEC"
			],
			"toolType": [
				"Plan"
			],
			"workflow": [
				"Intervention planning"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool after vocational interest information already exists and the client needs a manageable set of specific career or occupation targets to explore next."
			},
			{
				"title": "What It Captures",
				"body": "The tool captures the interest pattern or source result, candidate exploration targets, client selection states, and the resulting shortlist. It keeps reported interest information, client preference, system organization, and practitioner interpretation distinct."
			},
			{
				"title": "Repeat Use and History",
				"body": "Prior shortlists remain viewable so the practitioner can see which targets were selected at a point in time and compare later exploration direction without recalculating old results from changed inputs."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not create a full career assessment, rank careers, predict fit or success, provide labor-market facts, or explain occupation meanings unless that information is supplied from a supported source or practitioner-provided content."
			}
		],
		"faqItems": [
			{
				"question": "Is Career Exploration Shortlist a career assessment?",
				"answer": "No. Career Exploration Shortlist uses existing vocational interest information to narrow candidate targets; it does not create a new assessment score or interpret career fit."
			},
			{
				"question": "What does the client do in this tool?",
				"answer": "The client marks interest-grounded candidate targets as included, not included, or undecided so the final shortlist reflects their preferences."
			},
			{
				"question": "Can the practitioner control how many targets appear in the shortlist?",
				"answer": "Yes. The practitioner can set a shortlist size or size range when they want to define what counts as manageable for this use."
			},
			{
				"question": "What happens if the client selects too many targets?",
				"answer": "The result shows that the shortlist is not yet manageable and prompts further narrowing or practitioner review."
			},
			{
				"question": "Does the tool recommend the best career?",
				"answer": "No. The tool produces exploration targets to investigate next, not rankings, fit scores, or predictions of career success."
			}
		]
	},
	{
		"toolType": "riasecReassessment",
		"slug": "riasec-reassessment",
		"title": "RIASEC Reassessment for Career Guidance | Qwoach",
		"metaDescription": "Demo a career guidance reassessment tool that compares prior and current vocational interest patterns to show descriptive stability or change.",
		"h1": "RIASEC Reassessment",
		"intro": "RIASEC Reassessment is a ready-to-send career guidance tool for practitioners who have prior vocational interest information for a client. It helps them update the client’s interest picture and compare current and earlier patterns so career guidance can reflect stability or change.",
		"demoTitle": "Review the sample comparison, inspect the reassessment flow, and save the tool for occasional use.",
		"demoPrompt": "Interested in using RIASEC Reassessment with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/1372-f-099-riasec-007-r001-riasec-reassessment.md",
		"specId": "1372-f-099-riasec-007-r001-riasec-reassessment",
		"tags": {
			"framework": [
				"RIASEC"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment",
				"Progress review"
			],
			"topic": [
				"Career counseling"
			],
			"population": []
		},
		"sections": [
			{
				"title": "When It Is Used",
				"body": "Use this tool when a client has earlier vocational interest information and there is a specific reason to check whether current interests remain similar or have shifted."
			},
			{
				"title": "What It Compares",
				"body": "The tool compares a selected prior vocational interest result with current reassessment information. It preserves source identity, order, completion state, and whether the data are comparable."
			},
			{
				"title": "Occasional Use",
				"body": "RIASEC Reassessment is framed as an occasional update at meaningful decision points, not as daily, weekly, or routine progress tracking."
			},
			{
				"title": "Important Limits",
				"body": "The tool does not invent reassessment prompts, scoring methods, change thresholds, causes of change, diagnoses, aptitude conclusions, or career outcome predictions."
			}
		],
		"faqItems": [
			{
				"question": "Is RIASEC Reassessment for first-time career interest assessment?",
				"answer": "No. RIASEC Reassessment is for clients who already have prior vocational interest information to compare with a current update."
			},
			{
				"question": "Does the tool track progress over time?",
				"answer": "No. The tool supports occasional reassessment at meaningful decision points; it is not a frequent progress tracker."
			},
			{
				"question": "What must the practitioner choose before reassessment?",
				"answer": "The practitioner must select the earlier vocational interest result that will serve as the comparison baseline."
			},
			{
				"question": "What happens if the prior and current data are not comparable?",
				"answer": "The tool shows both data states but marks the comparison as limited or unavailable instead of forcing a change or stability conclusion."
			},
			{
				"question": "Does the result explain why the client’s interests changed?",
				"answer": "No. The result can describe observed differences when supported by comparable data, but it does not infer causes."
			}
		]
	},
	{
		"toolType": "wheelOfLife",
		"slug": "wheel-of-life",
		"title": "Interactive Wheel of Life Assessment | Qwoach",
		"metaDescription": "Try a Wheel of Life demo for reviewing balance, satisfaction, and coaching priorities across key life areas.",
		"h1": "Interactive Wheel of Life Assessment",
		"intro": "The Wheel of Life helps clients rate satisfaction across life areas and turn the pattern into practical coaching priorities.",
		"demoTitle": "Try the Wheel of Life demo",
		"demoPrompt": "Interested in using Wheel of Life with clients? Request access now.",
		"ctaText": "Request access",
		"isStaticPlaceholder": true,
		"sourceSpecPath": "data/tools-expansion/active/tool-specs/wheel-of-life.md",
		"specId": "wheel-of-life",
		"tags": {
			"framework": [
				"Wheel of Life"
			],
			"toolType": [
				"Assessment"
			],
			"workflow": [
				"Assessment"
			],
			"topic": [
				"Life domains"
			],
			"population": []
		},
		"sections": [
			{
				"title": "What this tool helps with",
				"body": "Make life balance visible across health, relationships, work, growth, recreation, and environment."
			},
			{
				"title": "How practitioners use it",
				"body": "Adjust life areas, collect client ratings, and discuss the resulting wheel together."
			},
			{
				"title": "When not to use it",
				"body": "Do not treat the wheel as a validated clinical measurement or a replacement for a structured assessment."
			}
		],
		"faqItems": [
			{
				"question": "What is the Wheel of Life?",
				"answer": "It is a coaching reflection tool that maps satisfaction or balance across multiple life areas."
			},
			{
				"question": "Can the areas be changed?",
				"answer": "Yes. Practitioners can customize the areas in the Wheel of Life settings."
			}
		]
	}
]

exports.generatedToolDemoPageDefinitions = generatedToolDemoPageDefinitions
